'use strict';

var _toConsumableArray2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/regenerator/index.js");

var _assertThisInitialized3 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

var _classCallCheck2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _slicedToArray2 = require("/codebuild/output/src902923440/src/wacoWebsite/node_modules/@babel/runtime/helpers/slicedToArray.js");

function _createForOfIteratorHelper2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct2(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn2(this, result); }; }

function _isNativeReflectConstruct2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/esnext.global-this.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.math.hypot.js");

require("core-js/modules/es.promise.finally.js");

require("core-js/modules/esnext.string.match-all.js");

require("core-js/modules/es.string.trim-end.js");

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/esnext.string.replace-all.js");

var lodash = require('lodash');

var React = require('react');

var styled = require('styled-components');

var crypto = require('crypto');

var http = require('http');

var https = require('https');

var url = require('url');

var require$$0 = require('stream');

var assert = require('assert');

var tty = require('tty');

var util = require('util');

var os = require('os');

var zlib = require('zlib');

var ReactDOM = require('react-dom');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__default$1 = /*#__PURE__*/_interopDefaultLegacy(React);

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

var http__default = /*#__PURE__*/_interopDefaultLegacy(http);

var https__default = /*#__PURE__*/_interopDefaultLegacy(https);

var url__default = /*#__PURE__*/_interopDefaultLegacy(url);

var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);

var assert__default = /*#__PURE__*/_interopDefaultLegacy(assert);

var tty__default = /*#__PURE__*/_interopDefaultLegacy(tty);

var util__default = /*#__PURE__*/_interopDefaultLegacy(util);

var os__default = /*#__PURE__*/_interopDefaultLegacy(os);

var zlib__default = /*#__PURE__*/_interopDefaultLegacy(zlib);

var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get SecondaryText() {
    return SecondaryText;
  },

  get PrimaryText() {
    return PrimaryText;
  },

  get Button() {
    return Button$2;
  },

  get CalloutData() {
    return CalloutData;
  },

  get CalloutWithGradient() {
    return CalloutWithGradient$1;
  },

  get CalloutWithGradientAndPadding() {
    return CalloutWithGradientAndPadding$1;
  },

  get CalloutMobileApps() {
    return CalloutMobileApps;
  },

  get CalloutText() {
    return CalloutText;
  },

  get CalloutMobileAppsGradients() {
    return CalloutMobileAppsGradientsDark$1;
  },

  get ContactSimple() {
    return ContactSimple;
  },

  get ContainerGradient() {
    return ContainerGradient$1;
  },

  get ContentBox() {
    return ContentBox$1;
  },

  get CompressedContent() {
    return CompressedContent;
  },

  get DividerDynamicComponent() {
    return DividerDynamicComponent;
  },

  get FeatureV2Image() {
    return FeatureV2Image;
  },

  get FeatureV4Image() {
    return FeatureV4Image;
  },

  get GradientWithoutImageContainer() {
    return GradientWithoutImageContainer;
  },

  get H3() {
    return H3$6;
  },

  get HeroCard() {
    return HeroCard;
  },

  get HorizontalDivider() {
    return HorizontalDivider;
  },

  get Icon() {
    return Icon;
  },

  get Iframe() {
    return Iframe$1;
  },

  get Links() {
    return Links$2;
  },

  get List() {
    return List;
  },

  get MediaQuery() {
    return MediaQuery;
  },

  get Message404() {
    return Message404;
  },

  get Modal() {
    return Modal;
  },

  get OfficeHourBox() {
    return OfficeHourBox;
  },

  get PageTitle() {
    return PageTitle;
  },

  get AutoLink() {
    return AutoLink$2;
  },

  get PageHeaderGradient() {
    return PageHeaderGradient;
  },

  get PageHeaderGradientContainer() {
    return PageHeaderGradientContainer;
  },

  get PageHeaderGradients() {
    return PageHeaderGradients;
  },

  get PageHeaderSubTitle() {
    return PageHeaderSubTitle;
  },

  get PageHeaderTitle() {
    return Title$v;
  },

  get Place() {
    return Place;
  },

  get RatesList() {
    return RatesList;
  },

  get RatesTabs() {
    return RatesTabs;
  },

  get Rectangle() {
    return Rectangle$3;
  },

  get RichTextContainer() {
    return RichTextContainer;
  },

  get ScrollStyle() {
    return ScrollStyle;
  },

  get TableContentItemLine() {
    return TableContentItemLine;
  },

  get TextBody() {
    return TextBody;
  },

  get TextSimple() {
    return TextSimple;
  },

  get Title() {
    return Title$t;
  },

  get TitleWithGradients() {
    return TitleWithGradient;
  },

  get VerticalDivider() {
    return VerticalDivider;
  },

  get CalloutMobileAppsGradientsLight() {
    return CalloutMobileAppsGradientsLight;
  },

  get CalloutMobileAppsGradientsDark() {
    return CalloutMobileAppsGradientsDark;
  },

  get Widget() {
    return Widget;
  },

  get ImagesGaleryRichText() {
    return ImagesGaleryRichText;
  },

  get ImagesGalery() {
    return ImagesGalery$1;
  },

  get Video() {
    return Video;
  },

  get VideoList() {
    return VideoList;
  },

  get Toast() {
    return Toast$1;
  },

  get Input() {
    return Input;
  },

  get MemberFeedback() {
    return MemberFeedbackForm;
  },

  get FormTemplate() {
    return FormTemplate;
  },

  get OptInForm() {
    return OptInForm;
  },

  get Table() {
    return Table$1;
  },

  get TabContent() {
    return TabContent;
  },

  get TeamMembers() {
    return TeamMembers;
  },

  get BodyText() {
    return BodyText$1;
  },

  get Branch() {
    return Branch$1;
  },

  get BranchExpandedComponent() {
    return BranchExpandedComponent;
  },

  get ButtonVariant() {
    return ButtonVariant;
  },

  get Callout() {
    return Callout$2;
  },

  get CalloutButtonWithDividers() {
    return CalloutButtonWithDividers;
  },

  get CalloutDataWithDividers() {
    return CalloutDataWithDividers;
  },

  get CalloutMobileAppsWithDividers() {
    return CalloutMobileAppsWithDividers;
  },

  get CalloutTextWithDividers() {
    return CalloutTextWithDividers;
  },

  get ConfirmationModal() {
    return ConfirmationModal;
  },

  get Contact() {
    return Contact$1;
  },

  get CustomButtons() {
    return CustomButtons;
  },

  get CustomPageFeature() {
    return CustomPageFeature;
  },

  get CustomPageGeneric() {
    return CustomPageGeneric;
  },

  get DefaultFallbackComponent() {
    return DefaultFallbackComponent;
  },

  get Dividers() {
    return Dividers;
  },

  get DividerImage() {
    return DividerImage;
  },

  get DynamicZonePage() {
    return DynamicZonePage;
  },

  get DynamicZonesPage() {
    return DynamicZonesPage;
  },

  get Feature() {
    return Feature;
  },

  get FeatureWithDiversV1() {
    return FeatureWithDividerV1;
  },

  get FeatureWithDiversV2() {
    return FeatureWithDividerV2;
  },

  get FeatureWithDiversV3() {
    return FeatureWithDividerV3;
  },

  get FeatureWithDividers() {
    return FeatureWithDividers;
  },

  get FeatureFullBg() {
    return FeatureFullBg;
  },

  get FeatureFullBackground() {
    return FeatureFullBackground;
  },

  get FeatureCollapseContent() {
    return FeatureCollapseContent;
  },

  get GoogleMap() {
    return BlossomGoogleMap;
  },

  get HeaderGradient() {
    return HeaderGradient;
  },

  get HeaderGradients() {
    return HeaderGradients;
  },

  get Hero() {
    return Hero$1;
  },

  get HeroWithDividers() {
    return HeroWithDividers;
  },

  get IconSelector() {
    return IconSelector;
  },

  get IframeWithDividers() {
    return IframeWithDividers;
  },

  get MainContact() {
    return MainContact;
  },

  get MainContactBox() {
    return MainContactBox;
  },

  get MainOffice() {
    return MainOffice;
  },

  get Message() {
    return Message;
  },

  get Product() {
    return Product;
  },

  get Products() {
    return Products;
  },

  get ProductsWithDividers() {
    return ProductsWithDividers;
  },

  get ProductsRates() {
    return ProductsRates;
  },

  get RenderDynamicZoneComponent() {
    return RenderDynamicZoneComponent;
  },

  get Slider() {
    return Slider;
  },

  get Search() {
    return Search;
  },

  get SpeedBump() {
    return SpeedBump;
  },

  get Tab() {
    return Tab;
  },

  get Tabs() {
    return Tabs;
  },

  get TableComponent() {
    return TableComponent;
  },

  get TableContentItem() {
    return TableContentItem;
  },

  get Text() {
    return Text$1;
  },

  get TextsLists() {
    return TextsLists;
  },

  get RichText() {
    return RichText;
  },

  get Reports() {
    return Reports;
  },

  get DescriptionAndLinks() {
    return DescriptionAndLinks;
  },

  get PopUpGaleryCommon() {
    return PopUpGaleryCommon;
  },

  get PopUpGalery() {
    return PopUpGalery$1;
  }

});
var templates = /*#__PURE__*/Object.freeze({
  __proto__: null,

  get AboutUsTemplateV1() {
    return AboutUsTemplateV1;
  },

  get AboutUsTemplateV2() {
    return AboutUsTemplateV2;
  },

  get AboutUsTemplateV7() {
    return AboutUsTemplateV7;
  },

  get AboutUsTemplateV8() {
    return AboutUsTemplateV8;
  },

  get DynamicTemplateV1() {
    return DynamicTemplateV1;
  },

  get DynamicTemplateV2() {
    return DynamicTemplateV2;
  },

  get DynamicTemplateV3() {
    return DynamicTemplateV3;
  },

  get DynamicTemplateV4() {
    return DynamicTemplateV4;
  },

  get DynamicTemplateV5() {
    return DynamicTemplateV5;
  },

  get DynamicTemplateV6() {
    return DynamicTemplateV6;
  },

  get DynamicTemplateV7() {
    return DynamicTemplateV7;
  },

  get DynamicTemplateV8() {
    return DynamicTemplateV8;
  },

  get DynamicTemplateV9() {
    return DynamicTemplateV9;
  },

  get HomeTemplateV1() {
    return HomeTemplateV1;
  },

  get HomeTemplateV2() {
    return HomeTemplateV2;
  },

  get HomeTemplateV3() {
    return HomeTemplateV3;
  },

  get HomeTemplateV4() {
    return HomeTemplateV4;
  },

  get HomeTemplateV5() {
    return HomeTemplateV5;
  },

  get HomeTemplateV6() {
    return HomeTemplateV6;
  },

  get HomeTemplateV7() {
    return HomeTemplateV7;
  },

  get HomeTemplateV8() {
    return HomeTemplateV8;
  },

  get HomeTemplateV9() {
    return HomeTemplateV9;
  },

  get ContactUsTemplateV1() {
    return ContactUsTemplateV1;
  },

  get ContactUsTemplateV2() {
    return ContactUsTemplateV2;
  },

  get ContactUsTemplateV3() {
    return ContactUsTemplateV3;
  },

  get ContactUsTemplateV5() {
    return ContactUsTemplateV5;
  },

  get ContactUsTemplateV6() {
    return ContactUsTemplateV6;
  },

  get ContactUsTemplateV7() {
    return ContactUsTemplateV7;
  },

  get ContactUsTemplateV8() {
    return ContactUsTemplateV8;
  },

  get ContactUsTemplateV9() {
    return ContactUsTemplateV9;
  },

  get ContactUsTemplateV10() {
    return ContactUsTemplateV10;
  }

});
var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var a = Object.defineProperty({}, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function get() {
        return n[k];
      }
    });
  });
  return a;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}

var check = function check(it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global$1 = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1) || // eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();

var fails = function fails(exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
}; // Detect IE8's incomplete defineProperty implementation


var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1] != 7;
});
var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {
    /* empty */
  }.bind(); // eslint-disable-next-line no-prototype-builtins -- safe


  return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var call$2 = Function.prototype.call;
var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
  return call$2.apply(call$2, arguments);
};
var $propertyIsEnumerable$2 = {}.propertyIsEnumerable; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$c = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG = getOwnPropertyDescriptor$c && !$propertyIsEnumerable$2.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

var f$9 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$c(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;
var objectPropertyIsEnumerable = {
  f: f$9
};

var createPropertyDescriptor = function createPropertyDescriptor(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$4 = Function.prototype;
var call$1 = FunctionPrototype$4.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype$4.bind.bind(call$1, call$1);

var functionUncurryThisRaw = function functionUncurryThisRaw(fn) {
  return functionBindNative ? uncurryThisWithBind(fn) : function () {
    return call$1.apply(fn, arguments);
  };
};

var toString$4 = functionUncurryThisRaw({}.toString);
var stringSlice$h = functionUncurryThisRaw(''.slice);

var classofRaw = function classofRaw(it) {
  return stringSlice$h(toString$4(it), 8, -1);
};

var functionUncurryThis = function functionUncurryThis(fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThisRaw(fn);
};

var $Object$6 = Object;
var split$3 = functionUncurryThis(''.split); // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$6('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split$3(it, '') : $Object$6(it);
} : $Object$6; // we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec

var isNullOrUndefined = function isNullOrUndefined(it) {
  return it === null || it === undefined;
};

var $TypeError$A = TypeError; // `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible

var requireObjectCoercible = function requireObjectCoercible(it) {
  if (isNullOrUndefined(it)) throw $TypeError$A("Can't call method on " + it);
  return it;
}; // toObject with fallback for non-array-like ES3 strings


var toIndexedObject = function toIndexedObject(it) {
  return indexedObject(requireObjectCoercible(it));
};

var documentAll$2 = typeof document == 'object' && document.all; // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot

var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;
var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};
var documentAll$1 = documentAll_1.all; // `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable

var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};
var documentAll = documentAll_1.all;
var isObject$6 = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function aFunction(argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function getBuiltIn(namespace, method) {
  return arguments.length < 2 ? aFunction(global$1[namespace]) : global$1[namespace] && global$1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);
var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';
var process$5 = global$1.process;
var Deno$1 = global$1.Deno;
var versions = process$5 && process$5.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match$3, version$2;

if (v8) {
  match$3 = v8.split('.'); // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us

  version$2 = match$3[0] > 0 && match$3[0] < 4 ? 1 : +(match$3[0] + match$3[1]);
} // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0


if (!version$2 && engineUserAgent) {
  match$3 = engineUserAgent.match(/Edge\/(\d+)/);

  if (!match$3 || match$3[1] >= 74) {
    match$3 = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match$3) version$2 = +match$3[1];
  }
}

var engineV8Version = version$2;
/* eslint-disable es/no-symbol -- required for testing */
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing

var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol(); // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances

  return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && engineV8Version && engineV8Version < 41;
});
/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $Object$5 = Object;
var isSymbol$1 = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$5(it));
};
var $String$5 = String;

var tryToString = function tryToString(argument) {
  try {
    return $String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$z = TypeError; // `Assert: IsCallable(argument) is true`

var aCallable = function aCallable(argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError$z(tryToString(argument) + ' is not a function');
}; // `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod


var getMethod = function getMethod(V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$y = TypeError; // `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive

var ordinaryToPrimitive = function ordinaryToPrimitive(input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject$6(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject$6(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject$6(val = functionCall(fn, input))) return val;
  throw $TypeError$y("Can't convert object to primitive value");
};

var isPure = false; // eslint-disable-next-line es/no-object-defineproperty -- safe

var defineProperty$i = Object.defineProperty;

var defineGlobalProperty = function defineGlobalProperty(key, value) {
  try {
    defineProperty$i(global$1, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global$1[key] = value;
  }

  return value;
};

var SHARED = '__core-js_shared__';
var store$3 = global$1[SHARED] || defineGlobalProperty(SHARED, {});
var sharedStore = store$3;
var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.25.5',
    mode: 'global',
    copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
    license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
    source: 'https://github.com/zloirock/core-js'
  });
});
var $Object$4 = Object; // `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject

var toObject$1 = function toObject$1(argument) {
  return $Object$4(requireObjectCoercible(argument));
};

var hasOwnProperty$c = functionUncurryThis({}.hasOwnProperty); // `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe

var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$c(toObject$1(it), key);
};

var id$1 = 0;
var postfix = Math.random();
var toString$3 = functionUncurryThis(1.0.toString);

var uid = function uid(key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$3(++id$1 + postfix, 36);
};

var WellKnownSymbolsStore$1 = shared('wks');
var Symbol$5 = global$1.Symbol;
var symbolFor = Symbol$5 && Symbol$5['for'];
var createWellKnownSymbol = useSymbolAsUid ? Symbol$5 : Symbol$5 && Symbol$5.withoutSetter || uid;

var wellKnownSymbol = function wellKnownSymbol(name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore$1, name) || !(symbolConstructorDetection || typeof WellKnownSymbolsStore$1[name] == 'string')) {
    var description = 'Symbol.' + name;

    if (symbolConstructorDetection && hasOwnProperty_1(Symbol$5, name)) {
      WellKnownSymbolsStore$1[name] = Symbol$5[name];
    } else if (useSymbolAsUid && symbolFor) {
      WellKnownSymbolsStore$1[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore$1[name] = createWellKnownSymbol(description);
    }
  }

  return WellKnownSymbolsStore$1[name];
};

var $TypeError$x = TypeError;
var TO_PRIMITIVE$1 = wellKnownSymbol('toPrimitive'); // `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive

var toPrimitive = function toPrimitive(input, pref) {
  if (!isObject$6(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE$1);
  var result;

  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject$6(result) || isSymbol$1(result)) return result;
    throw $TypeError$x("Can't convert object to primitive value");
  }

  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
}; // `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey


var toPropertyKey = function toPropertyKey(argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol$1(key) ? key : key + '';
};

var document$3 = global$1.document; // typeof document.createElement is 'object' in old IE

var EXISTS$1 = isObject$6(document$3) && isObject$6(document$3.createElement);

var documentCreateElement = function documentCreateElement(it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
}; // Thanks to IE8 for its funny defineProperty


var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
}); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

var f$8 = descriptors ? $getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$2(O, P);
  } catch (error) {
    /* empty */
  }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$8
}; // V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334

var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {
    /* empty */
  }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});
var $String$4 = String;
var $TypeError$w = TypeError; // `Assert: Type(argument) is Object`

var anObject = function anObject(argument) {
  if (isObject$6(argument)) return argument;
  throw $TypeError$w($String$4(argument) + ' is not an object');
};

var $TypeError$v = TypeError; // eslint-disable-next-line es/no-object-defineproperty -- safe

var $defineProperty$1 = Object.defineProperty; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable'; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty

var f$7 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);

  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);

    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }

  return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$v('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f$7
};
var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};
var FunctionPrototype$3 = Function.prototype; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwnProperty_1(FunctionPrototype$3, 'name'); // additional protection from minified / mangled / dropped function names

var PROPER = EXISTS && function something() {
  /* empty */
}.name === 'something';

var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$3, 'name').configurable);
var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};
var functionToString$1 = functionUncurryThis(Function.toString); // this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper

if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString$1(it);
  };
}

var inspectSource = sharedStore.inspectSource;
var WeakMap$6 = global$1.WeakMap;
var weakMapBasicDetection = isCallable(WeakMap$6) && /native code/.test(String(WeakMap$6));
var keys$4 = shared('keys');

var sharedKey = function sharedKey(key) {
  return keys$4[key] || (keys$4[key] = uid(key));
};

var hiddenKeys$1 = {};
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$8 = global$1.TypeError;
var WeakMap$5 = global$1.WeakMap;
var set$3, get$2, has$3;

var enforce = function enforce(it) {
  return has$3(it) ? get$2(it) : set$3(it, {});
};

var getterFor$2 = function getterFor$2(TYPE) {
  return function (it) {
    var state;

    if (!isObject$6(it) || (state = get$2(it)).type !== TYPE) {
      throw TypeError$8('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store$2 = sharedStore.state || (sharedStore.state = new WeakMap$5());
  /* eslint-disable no-self-assign -- prototype methods protection */

  store$2.get = store$2.get;
  store$2.has = store$2.has;
  store$2.set = store$2.set;
  /* eslint-enable no-self-assign -- prototype methods protection */

  set$3 = function set$3(it, metadata) {
    if (store$2.has(it)) throw TypeError$8(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$2.set(it, metadata);
    return metadata;
  };

  get$2 = function get$2(it) {
    return store$2.get(it) || {};
  };

  has$3 = function has$3(it) {
    return store$2.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$1[STATE] = true;

  set$3 = function set$3(it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw TypeError$8(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };

  get$2 = function get$2(it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };

  has$3 = function has$3(it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set$3,
  get: get$2,
  has: has$3,
  enforce: enforce,
  getterFor: getterFor$2
};
var makeBuiltIn_1 = createCommonjsModule(function (module) {
  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
  var enforceInternalState = internalState.enforce;
  var getInternalState = internalState.get; // eslint-disable-next-line es/no-object-defineproperty -- safe

  var defineProperty = Object.defineProperty;
  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
    return defineProperty(function () {
      /* empty */
    }, 'length', {
      value: 8
    }).length !== 8;
  });
  var TEMPLATE = String(String).split('String');

  var makeBuiltIn = module.exports = function (value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }

    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;

    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
      if (descriptors) defineProperty(value, 'name', {
        value: name,
        configurable: true
      });else value.name = name;
    }

    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
      defineProperty(value, 'length', {
        value: options.arity
      });
    }

    try {
      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
        if (descriptors) defineProperty(value, 'prototype', {
          writable: false
        }); // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
      } else if (value.prototype) value.prototype = undefined;
    } catch (error) {
      /* empty */
    }

    var state = enforceInternalState(value);

    if (!hasOwnProperty_1(state, 'source')) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }

    return value;
  }; // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  // eslint-disable-next-line no-extend-native -- required


  Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
  }, 'toString');
});

var defineBuiltIn = function defineBuiltIn(O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);

  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {
      /* empty */
    }

    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }

  return O;
};

var ceil$1 = Math.ceil;
var floor$a = Math.floor; // `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe

var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$a : ceil$1)(n);
}; // `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity


var toIntegerOrInfinity = function toIntegerOrInfinity(argument) {
  var number = +argument; // eslint-disable-next-line no-self-compare -- NaN check

  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max$9 = Math.max;
var min$c = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex = function toAbsoluteIndex(index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max$9(integer + length, 0) : min$c(integer, length);
};

var min$b = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength = function toLength(argument) {
  return argument > 0 ? min$b(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
}; // `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike


var lengthOfArrayLike = function lengthOfArrayLike(obj) {
  return toLength(obj.length);
}; // `Array.prototype.{ indexOf, includes }` methods implementation


var createMethod$8 = function createMethod$8(IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$8(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$8(false)
};
var indexOf$2 = arrayIncludes.indexOf;
var push$m = functionUncurryThis([].push);

var objectKeysInternal = function objectKeysInternal(object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$m(result, key);
  } // Don't enum bug & hidden keys


  while (names.length > i) {
    if (hasOwnProperty_1(O, key = names[i++])) {
      ~indexOf$2(result, key) || push$m(result, key);
    }
  }

  return result;
}; // IE8- don't enum bug keys


var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
var hiddenKeys = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe

var f$6 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys);
};

var objectGetOwnPropertyNames = {
  f: f$6
}; // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe

var f$5 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$5
};
var concat$4 = functionUncurryThis([].concat); // all object keys, includes non-enumerable and symbols

var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat$4(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function copyConstructorProperties(target, source, exceptions) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function isForced(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;
var getOwnPropertyDescriptor$b = objectGetOwnPropertyDescriptor.f;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/

var _export = function _export(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$b(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }

    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var TO_STRING_TAG$9 = wellKnownSymbol('toStringTag');
var test$2 = {};
test$2[TO_STRING_TAG$9] = 'z';
var toStringTagSupport = String(test$2) === '[object z]';
var TO_STRING_TAG$8 = wellKnownSymbol('toStringTag');
var $Object$3 = Object; // ES3 wrong here

var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (error) {
    /* empty */
  }
}; // getting tag from ES6+ `Object.prototype.toString`


var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (tag = tryGet(O = $Object$3(it), TO_STRING_TAG$8)) == 'string' ? tag // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
  : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};
var $String$3 = String;

var toString$2 = function toString$2(argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$3(argument);
}; // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe


var objectKeys$1 = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
}; // `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe


var f$4 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;

  while (length > index) {
    objectDefineProperty.f(O, key = keys[index++], props[key]);
  }

  return O;
};
var objectDefineProperties = {
  f: f$4
};
var html$1 = getBuiltIn('document', 'documentElement');
/* global ActiveXObject -- old IE, WSH */

var GT = '>';
var LT = '<';
var PROTOTYPE$2 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey('IE_PROTO');

var EmptyConstructor = function EmptyConstructor() {
  /* empty */
};

var scriptTag = function scriptTag(content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
}; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak

  return temp;
}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
}; // Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug


var activeXDocument;

var _NullProtoObject = function NullProtoObject() {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {
    /* ignore */
  }

  _NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH

  var length = enumBugKeys.length;

  while (length--) {
    delete _NullProtoObject[PROTOTYPE$2][enumBugKeys[length]];
  }

  return _NullProtoObject();
};

hiddenKeys$1[IE_PROTO$1] = true; // `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe

var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    EmptyConstructor[PROTOTYPE$2] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$2] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO$1] = O;
  } else result = _NullProtoObject();

  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var createProperty = function createProperty(object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};

var $Array$a = Array;
var max$8 = Math.max;

var arraySliceSimple = function arraySliceSimple(O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array$a(max$8(fin - k, 0));

  for (var n = 0; k < fin; k++, n++) {
    createProperty(result, n, O[k]);
  }

  result.length = n;
  return result;
};
/* eslint-disable es/no-object-getownpropertynames -- safe */


var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return arraySliceSimple(windowNames);
  }
}; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


var f$3 = function getOwnPropertyNames(it) {
  return windowNames && classofRaw(it) == 'Window' ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
  f: f$3
};
var f$2 = wellKnownSymbol;
var wellKnownSymbolWrapped = {
  f: f$2
};
var path = global$1;
var defineProperty$h = objectDefineProperty.f;

var wellKnownSymbolDefine = function wellKnownSymbolDefine(NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwnProperty_1(Symbol, NAME)) defineProperty$h(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};

var symbolDefineToPrimitive = function symbolDefineToPrimitive() {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return functionCall(valueOf, this);
    }, {
      arity: 1
    });
  }
};

var defineProperty$g = objectDefineProperty.f;
var TO_STRING_TAG$7 = wellKnownSymbol('toStringTag');

var setToStringTag = function setToStringTag(target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;

  if (target && !hasOwnProperty_1(target, TO_STRING_TAG$7)) {
    defineProperty$g(target, TO_STRING_TAG$7, {
      configurable: true,
      value: TAG
    });
  }
};

var bind$2 = functionUncurryThis(functionUncurryThis.bind); // optional / simple context binding

var functionBindContext = function functionBindContext(fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind$2(fn, that) : function
    /* ...args */
  () {
    return fn.apply(that, arguments);
  };
}; // `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe


var isArray$4 = Array.isArray || function isArray(argument) {
  return classofRaw(argument) == 'Array';
};

var noop$4 = function noop$4() {
  /* empty */
};

var empty = [];
var construct$1 = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$b = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING$2 = !constructorRegExp.exec(noop$4);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;

  try {
    construct$1(noop$4, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;

  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
  }

  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING$2 || !!exec$b(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true; // `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor

var isConstructor = !construct$1 || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var SPECIES$6 = wellKnownSymbol('species');
var $Array$9 = Array; // a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate

var arraySpeciesConstructor = function arraySpeciesConstructor(originalArray) {
  var C;

  if (isArray$4(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (isConstructor(C) && (C === $Array$9 || isArray$4(C.prototype))) C = undefined;else if (isObject$6(C)) {
      C = C[SPECIES$6];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? $Array$9 : C;
}; // `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate


var arraySpeciesCreate = function arraySpeciesCreate(originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var push$l = functionUncurryThis([].push); // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation

var createMethod$7 = function createMethod$7(TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$1($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;

    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        value = self[index];
        result = boundFunction(value, index, O);

        if (TYPE) {
          if (IS_MAP) target[index] = result; // map
          else if (result) switch (TYPE) {
            case 3:
              return true;
            // some

            case 5:
              return value;
            // find

            case 6:
              return index;
            // findIndex

            case 2:
              push$l(target, value);
            // filter
          } else switch (TYPE) {
            case 4:
              return false;
            // every

            case 7:
              push$l(target, value);
            // filterReject
          }
        }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$7(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$7(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$7(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$7(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$7(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$7(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$7(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$7(7)
};
var $forEach$3 = arrayIteration.forEach;
var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var setInternalState$i = internalState.set;
var getInternalState$e = internalState.getterFor(SYMBOL);
var ObjectPrototype$5 = Object[PROTOTYPE$1];
var $Symbol = global$1.Symbol;
var SymbolPrototype$1 = $Symbol && $Symbol[PROTOTYPE$1];
var TypeError$7 = global$1.TypeError;
var QObject = global$1.QObject;
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
var push$k = functionUncurryThis([].push);
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks'); // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate$1(nativeDefineProperty({}, 'a', {
    get: function get() {
      return nativeDefineProperty(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype$5, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$5[P];
  nativeDefineProperty(O, P, Attributes);

  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$5) {
    nativeDefineProperty(ObjectPrototype$5, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap$2 = function wrap$2(tag, description) {
  var symbol = AllSymbols[tag] = objectCreate$1(SymbolPrototype$1);
  setInternalState$i(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$5) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);

  if (hasOwnProperty_1(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwnProperty_1(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwnProperty_1(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate$1(Attributes, {
        enumerable: createPropertyDescriptor(0, false)
      });
    }

    return setSymbolDescriptor(O, key, Attributes);
  }

  return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys$1(properties).concat($getOwnPropertySymbols(properties));
  $forEach$3(keys, function (key) {
    if (!descriptors || functionCall($propertyIsEnumerable$1, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate$1(O) : $defineProperties(objectCreate$1(O), Properties);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = functionCall(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$5 && hasOwnProperty_1(AllSymbols, P) && !hasOwnProperty_1(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwnProperty_1(this, P) || !hasOwnProperty_1(AllSymbols, P) || hasOwnProperty_1(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype$5 && hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);

  if (descriptor && hasOwnProperty_1(AllSymbols, key) && !(hasOwnProperty_1(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }

  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach$3(names, function (key) {
    if (!hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(hiddenKeys$1, key)) push$k(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function $getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$5;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach$3(names, function (key) {
    if (hasOwnProperty_1(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwnProperty_1(ObjectPrototype$5, key))) {
      push$k(result, AllSymbols[key]);
    }
  });
  return result;
}; // `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor


if (!symbolConstructorDetection) {
  $Symbol = function Symbol() {
    if (objectIsPrototypeOf(SymbolPrototype$1, this)) throw TypeError$7('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : toString$2(arguments[0]);
    var tag = uid(description);

    var setter = function setter(value) {
      if (this === ObjectPrototype$5) functionCall(setter, ObjectPrototypeSymbols, value);
      if (hasOwnProperty_1(this, HIDDEN) && hasOwnProperty_1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };

    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype$5, tag, {
      configurable: true,
      set: setter
    });
    return wrap$2(tag, description);
  };

  SymbolPrototype$1 = $Symbol[PROTOTYPE$1];
  defineBuiltIn(SymbolPrototype$1, 'toString', function toString() {
    return getInternalState$e(this).tag;
  });
  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap$2(uid(description), description);
  });
  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
  objectDefineProperty.f = $defineProperty;
  objectDefineProperties.f = $defineProperties;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  wellKnownSymbolWrapped.f = function (name) {
    return wrap$2(wellKnownSymbol(name), name);
  };

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype$1, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$e(this).description;
      }
    });
    {
      defineBuiltIn(ObjectPrototype$5, 'propertyIsEnumerable', $propertyIsEnumerable$1, {
        unsafe: true
      });
    }
  }
}

_export({
  global: true,
  constructor: true,
  wrap: true,
  forced: !symbolConstructorDetection,
  sham: !symbolConstructorDetection
}, {
  Symbol: $Symbol
});

$forEach$3(objectKeys$1(WellKnownSymbolsStore), function (name) {
  wellKnownSymbolDefine(name);
});

_export({
  target: SYMBOL,
  stat: true,
  forced: !symbolConstructorDetection
}, {
  useSetter: function useSetter() {
    USE_SETTER = true;
  },
  useSimple: function useSimple() {
    USE_SETTER = false;
  }
});

_export({
  target: 'Object',
  stat: true,
  forced: !symbolConstructorDetection,
  sham: !descriptors
}, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

_export({
  target: 'Object',
  stat: true,
  forced: !symbolConstructorDetection
}, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
}); // `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive


symbolDefineToPrimitive(); // `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag

setToStringTag($Symbol, SYMBOL);
hiddenKeys$1[HIDDEN] = true;
/* eslint-disable es/no-symbol -- safe */

var symbolRegistryDetection = symbolConstructorDetection && !!Symbol['for'] && !!Symbol.keyFor;
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry$1 = shared('symbol-to-string-registry'); // `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for

_export({
  target: 'Symbol',
  stat: true,
  forced: !symbolRegistryDetection
}, {
  'for': function _for(key) {
    var string = toString$2(key);
    if (hasOwnProperty_1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry$1[symbol] = string;
    return symbol;
  }
});

var SymbolToStringRegistry = shared('symbol-to-string-registry'); // `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor

_export({
  target: 'Symbol',
  stat: true,
  forced: !symbolRegistryDetection
}, {
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwnProperty_1(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});

var FunctionPrototype$2 = Function.prototype;
var apply = FunctionPrototype$2.apply;
var call = FunctionPrototype$2.call; // eslint-disable-next-line es/no-reflect -- safe

var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});
var arraySlice$1 = functionUncurryThis([].slice);
var $stringify = getBuiltIn('JSON', 'stringify');
var exec$a = functionUncurryThis(/./.exec);
var charAt$h = functionUncurryThis(''.charAt);
var charCodeAt$5 = functionUncurryThis(''.charCodeAt);
var replace$c = functionUncurryThis(''.replace);
var numberToString$3 = functionUncurryThis(1.0.toString);
var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
  var symbol = getBuiltIn('Symbol')(); // MS Edge converts symbol values to JSON as {}

  return $stringify([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
  || $stringify({
    a: symbol
  }) != '{}' // V8 throws on boxed symbols
  || $stringify(Object(symbol)) != '{}';
}); // https://github.com/tc39/proposal-well-formed-stringify

var ILL_FORMED_UNICODE = fails(function () {
  return $stringify("\uDF06\uD834") !== "\"\\udf06\\ud834\"" || $stringify("\uDEAD") !== "\"\\udead\"";
});

var stringifyWithSymbolsFix = function stringifyWithSymbolsFix(it, replacer) {
  var args = arraySlice$1(arguments);
  var $replacer = replacer;
  if (!isObject$6(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined

  if (!isArray$4(replacer)) replacer = function replacer(key, value) {
    if (isCallable($replacer)) value = functionCall($replacer, this, key, value);
    if (!isSymbol$1(value)) return value;
  };
  args[1] = replacer;
  return functionApply($stringify, null, args);
};

var fixIllFormed = function fixIllFormed(match, offset, string) {
  var prev = charAt$h(string, offset - 1);
  var next = charAt$h(string, offset + 1);

  if (exec$a(low, match) && !exec$a(hi, next) || exec$a(hi, match) && !exec$a(low, prev)) {
    return "\\u" + numberToString$3(charCodeAt$5(match, 0), 16);
  }

  return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  _export({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$1(arguments);
      var result = functionApply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$c(result, tester, fixIllFormed) : result;
    }
  });
} // V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443


var FORCED$n = !symbolConstructorDetection || fails(function () {
  objectGetOwnPropertySymbols.f(1);
}); // `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols

_export({
  target: 'Object',
  stat: true,
  forced: FORCED$n
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject$1(it)) : [];
  }
});

var defineProperty$f = objectDefineProperty.f;
var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (descriptors && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) || // Safari 12 bug
NativeSymbol().description !== undefined)) {
  var EmptyStringDescriptionStore = {}; // wrap Symbol constructor for correct work with undefined description

  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$2(arguments[0]);
    var result = objectIsPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
    : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;
  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = functionUncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = functionUncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$b = functionUncurryThis(''.replace);
  var stringSlice$g = functionUncurryThis(''.slice);
  defineProperty$f(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwnProperty_1(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$g(string, 7, -1) : replace$b(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({
    global: true,
    constructor: true,
    forced: true
  }, {
    Symbol: SymbolWrapper
  });
} // `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator


wellKnownSymbolDefine('asyncIterator'); // `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance

wellKnownSymbolDefine('hasInstance'); // `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable

wellKnownSymbolDefine('isConcatSpreadable'); // `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator

wellKnownSymbolDefine('iterator'); // `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match

wellKnownSymbolDefine('match'); // `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall

wellKnownSymbolDefine('matchAll'); // `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace

wellKnownSymbolDefine('replace'); // `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search

wellKnownSymbolDefine('search'); // `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species

wellKnownSymbolDefine('species'); // `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split

wellKnownSymbolDefine('split'); // `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive

wellKnownSymbolDefine('toPrimitive'); // `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive

symbolDefineToPrimitive(); // `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag

wellKnownSymbolDefine('toStringTag'); // `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag

setToStringTag(getBuiltIn('Symbol'), 'Symbol'); // `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables

wellKnownSymbolDefine('unscopables');
var $String$2 = String;
var $TypeError$u = TypeError;

var aPossiblePrototype = function aPossiblePrototype(argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError$u("Can't set " + $String$2(argument) + ' as a prototype');
};
/* eslint-disable no-proto -- safe */
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe


var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;

  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
    /* empty */
  }

  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
var defineProperty$e = objectDefineProperty.f;

var proxyAccessor = function proxyAccessor(Target, Source, key) {
  key in Target || defineProperty$e(Target, key, {
    configurable: true,
    get: function get() {
      return Source[key];
    },
    set: function set(it) {
      Source[key] = it;
    }
  });
}; // makes subclassing work correct for wrapped built-ins


var inheritIfRequired = function inheritIfRequired($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if ( // it can work only with native `setPrototypeOf`
  objectSetPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
  isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject$6(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var normalizeStringArgument = function normalizeStringArgument(argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$2(argument);
}; // `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause


var installErrorCause = function installErrorCause(O, options) {
  if (isObject$6(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

var $Error$1 = Error;
var replace$a = functionUncurryThis(''.replace);

var TEST = function (arg) {
  return String($Error$1(arg).stack);
}('zxcasd');

var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function errorStackClear(stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error$1.prepareStackTrace) {
    while (dropEntries--) {
      stack = replace$a(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
    }
  }

  return stack;
};

var errorStackInstallable = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true; // eslint-disable-next-line es/no-object-defineproperty -- safe

  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

var wrapErrorConstructorWithCause = function wrapErrorConstructorWithCause(FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);
  if (!OriginalError) return;
  var OriginalErrorPrototype = OriginalError.prototype; // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006

  if (hasOwnProperty_1(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;
  if (!FORCED) return OriginalError;
  var BaseError = getBuiltIn('Error');
  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (errorStackInstallable) createNonEnumerableProperty(result, 'stack', errorStackClear(result.stack, 2));
    if (this && objectIsPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });
  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (objectSetPrototypeOf) objectSetPrototypeOf(WrappedError, BaseError);else copyConstructorProperties(WrappedError, BaseError, {
      name: true
    });
  } else if (descriptors && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }

    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) {
    /* empty */
  }

  return WrappedError;
};
/* eslint-disable no-unused-vars -- required for functions `.length` */


var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly$1 = global$1[WEB_ASSEMBLY];
var FORCED$m = Error('e', {
  cause: 7
}).cause !== 7;

var exportGlobalErrorCauseWrapper = function exportGlobalErrorCauseWrapper(ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$m);

  _export({
    global: true,
    constructor: true,
    arity: 1,
    forced: FORCED$m
  }, O);
};

var exportWebAssemblyErrorCauseWrapper = function exportWebAssemblyErrorCauseWrapper(ERROR_NAME, wrapper) {
  if (WebAssembly$1 && WebAssembly$1[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$m);

    _export({
      target: WEB_ASSEMBLY,
      stat: true,
      constructor: true,
      arity: 1,
      forced: FORCED$m
    }, O);
  }
}; // https://github.com/tc39/proposal-error-cause


exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) {
    return functionApply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) {
    return functionApply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) {
    return functionApply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) {
    return functionApply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) {
    return functionApply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) {
    return functionApply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) {
    return functionApply(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) {
    return functionApply(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) {
    return functionApply(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) {
    return functionApply(init, this, arguments);
  };
});
var nativeErrorToString = Error.prototype.toString;
var INCORRECT_TO_STRING$1 = fails(function () {
  if (descriptors) {
    // Chrome 32- incorrectly call accessor
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var object = objectCreate$1(Object.defineProperty({}, 'name', {
      get: function get() {
        return this === object;
      }
    }));
    if (nativeErrorToString.call(object) !== 'true') return true;
  } // FF10- does not properly handle non-strings


  return nativeErrorToString.call({
    message: 1,
    name: 2
  }) !== '2: 1' // IE8 does not properly handle defaults
  || nativeErrorToString.call({}) !== 'Error';
});
var errorToString = INCORRECT_TO_STRING$1 ? function toString() {
  var O = anObject(this);
  var name = normalizeStringArgument(O.name, 'Error');
  var message = normalizeStringArgument(O.message);
  return !name ? message : !message ? name : name + ': ' + message;
} : nativeErrorToString;
var ErrorPrototype$1 = Error.prototype; // `Error.prototype.toString` method fix
// https://tc39.es/ecma262/#sec-error.prototype.tostring

if (ErrorPrototype$1.toString !== errorToString) {
  defineBuiltIn(ErrorPrototype$1, 'toString', errorToString);
}

var correctPrototypeGetter = !fails(function () {
  function F() {
    /* empty */
  }

  F.prototype.constructor = null; // eslint-disable-next-line es/no-object-getprototypeof -- required for testing

  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var IE_PROTO = sharedKey('IE_PROTO');
var $Object$2 = Object;
var ObjectPrototype$4 = $Object$2.prototype; // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe

var objectGetPrototypeOf = correctPrototypeGetter ? $Object$2.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwnProperty_1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;

  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }

  return object instanceof $Object$2 ? ObjectPrototype$4 : null;
};
var iterators = {};
var ITERATOR$a = wellKnownSymbol('iterator');
var ArrayPrototype$2 = Array.prototype; // check on default Array iterator

var isArrayIteratorMethod = function isArrayIteratorMethod(it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$2[ITERATOR$a] === it);
};

var ITERATOR$9 = wellKnownSymbol('iterator');

var getIteratorMethod = function getIteratorMethod(it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$9) || getMethod(it, '@@iterator') || iterators[classof(it)];
};

var $TypeError$t = TypeError;

var getIterator = function getIterator(argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw $TypeError$t(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function iteratorClose(iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);

  try {
    innerResult = getMethod(iterator, 'return');

    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }

    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }

  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$s = TypeError;

var Result = function Result(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate = function iterate(iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function stop(condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function callFn(value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }

    return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError$s(tryToString(iterable) + ' is not iterable'); // optimisation for array iterators

    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      }

      return new Result(false);
    }

    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;

  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }

    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  }

  return new Result(false);
};

var TO_STRING_TAG$6 = wellKnownSymbol('toStringTag');
var $Error = Error;
var push$j = [].push;

var $AggregateError$1 = function AggregateError(errors, message
/* , options */
) {
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var isInstance = objectIsPrototypeOf(AggregateErrorPrototype, this);
  var that;

  if (objectSetPrototypeOf) {
    that = objectSetPrototypeOf($Error(), isInstance ? objectGetPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : objectCreate$1(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG$6, 'Error');
  }

  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  if (errorStackInstallable) createNonEnumerableProperty(that, 'stack', errorStackClear(that.stack, 1));
  installErrorCause(that, options);
  var errorsArray = [];
  iterate(errors, push$j, {
    that: errorsArray
  });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (objectSetPrototypeOf) objectSetPrototypeOf($AggregateError$1, $Error);else copyConstructorProperties($AggregateError$1, $Error, {
  name: true
});
var AggregateErrorPrototype = $AggregateError$1.prototype = objectCreate$1($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError$1),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
}); // `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor

_export({
  global: true,
  constructor: true,
  arity: 2
}, {
  AggregateError: $AggregateError$1
});

var AGGREGATE_ERROR = 'AggregateError';
var $AggregateError = getBuiltIn(AGGREGATE_ERROR);
var FORCED$l = !fails(function () {
  return $AggregateError([1]).errors[0] !== 1;
}) && fails(function () {
  return $AggregateError([1], AGGREGATE_ERROR, {
    cause: 7
  }).cause !== 7;
}); // https://github.com/tc39/proposal-error-cause

_export({
  global: true,
  constructor: true,
  arity: 2,
  forced: FORCED$l
}, {
  AggregateError: wrapErrorConstructorWithCause(AGGREGATE_ERROR, function (init) {
    // eslint-disable-next-line no-unused-vars -- required for functions `.length`
    return function AggregateError(errors, message) {
      return functionApply(init, this, arguments);
    };
  }, FORCED$l, true)
});

var defineProperty$d = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype$1 = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$d(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: objectCreate$1(null)
  });
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables = function addToUnscopables(key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
}; // `Array.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method


_export({
  target: 'Array',
  proto: true
}, {
  at: function at(index) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : O[k];
  }
});

addToUnscopables('at');
var $TypeError$r = TypeError;
var MAX_SAFE_INTEGER$2 = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function doesNotExceedSafeInteger(it) {
  if (it > MAX_SAFE_INTEGER$2) throw $TypeError$r('Maximum allowed index exceeded');
  return it;
};

var SPECIES$5 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function arrayMethodHasSpeciesSupport(METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES$5] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable'); // We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679

var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function isConcatSpreadable(O) {
  if (!isObject$6(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$4(O);
};

var FORCED$k = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species

_export({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$k
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$1(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;

    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];

      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);

        for (k = 0; k < len; k++, n++) {
          if (k in E) createProperty(A, n, E[k]);
        }
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }

    A.length = n;
    return A;
  }
});

var $TypeError$q = TypeError;

var deletePropertyOrThrow = function deletePropertyOrThrow(O, P) {
  if (!delete O[P]) throw $TypeError$q('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var min$a = Math.min; // `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe

var arrayCopyWithin = [].copyWithin || function copyWithin(target
/* = 0 */
, start
/* = 0, end = @length */
) {
  var O = toObject$1(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min$a((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;

  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }

  while (count-- > 0) {
    if (from in O) O[to] = O[from];else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  }

  return O;
}; // `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin


_export({
  target: 'Array',
  proto: true
}, {
  copyWithin: arrayCopyWithin
}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


addToUnscopables('copyWithin');

var arrayMethodIsStrict = function arrayMethodIsStrict(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () {
      return 1;
    }, 1);
  });
};

var $every$2 = arrayIteration.every;
var STRICT_METHOD$8 = arrayMethodIsStrict('every'); // `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD$8
}, {
  every: function every(callbackfn
  /* , thisArg */
  ) {
    return $every$2(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill


var arrayFill = function fill(value
/* , start = 0, end = @length */
) {
  var O = toObject$1(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

  while (endPos > index) {
    O[index++] = value;
  }

  return O;
}; // `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill


_export({
  target: 'Array',
  proto: true
}, {
  fill: arrayFill
}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


addToUnscopables('fill');
var $filter$1 = arrayIteration.filter;
var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('filter'); // `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$3
}, {
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $find$2 = arrayIteration.find;
var FIND = 'find';
var SKIPS_HOLES$1 = true; // Shouldn't skip holes

if (FIND in []) Array(1)[FIND](function () {
  SKIPS_HOLES$1 = false;
}); // `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find

_export({
  target: 'Array',
  proto: true,
  forced: SKIPS_HOLES$1
}, {
  find: function find(callbackfn
  /* , that = undefined */
  ) {
    return $find$2(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


addToUnscopables(FIND);
var $findIndex$1 = arrayIteration.findIndex;
var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true; // Shouldn't skip holes

if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () {
  SKIPS_HOLES = false;
}); // `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex

_export({
  target: 'Array',
  proto: true,
  forced: SKIPS_HOLES
}, {
  findIndex: function findIndex(callbackfn
  /* , that = undefined */
  ) {
    return $findIndex$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


addToUnscopables(FIND_INDEX); // `Array.prototype.{ findLast, findLastIndex }` methods implementation

var createMethod$6 = function createMethod$6(TYPE) {
  var IS_FIND_LAST_INDEX = TYPE == 1;
  return function ($this, callbackfn, that) {
    var O = toObject$1($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;

    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0:
          return value;
        // findLast

        case 1:
          return index;
        // findLastIndex
      }
    }

    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

var arrayIterationFromLast = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod$6(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod$6(1)
};
var $findLast$1 = arrayIterationFromLast.findLast; // `Array.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last

_export({
  target: 'Array',
  proto: true
}, {
  findLast: function findLast(callbackfn
  /* , that = undefined */
  ) {
    return $findLast$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLast');
var $findLastIndex$1 = arrayIterationFromLast.findLastIndex; // `Array.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last

_export({
  target: 'Array',
  proto: true
}, {
  findLastIndex: function findLastIndex(callbackfn
  /* , that = undefined */
  ) {
    return $findLastIndex$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLastIndex'); // `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

var flattenIntoArray = function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? functionBindContext(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$4(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }

    sourceIndex++;
  }

  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray; // `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat

_export({
  target: 'Array',
  proto: true
}, {
  flat: function
    /* depthArg = 1 */
  flat() {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$1(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
}); // `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap


_export({
  target: 'Array',
  proto: true
}, {
  flatMap: function flatMap(callbackfn
  /* , thisArg */
  ) {
    var O = toObject$1(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

var $forEach$2 = arrayIteration.forEach;
var STRICT_METHOD$7 = arrayMethodIsStrict('forEach'); // `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach

var arrayForEach = !STRICT_METHOD$7 ? function forEach(callbackfn
/* , thisArg */
) {
  return $forEach$2(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined); // eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach; // `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe

_export({
  target: 'Array',
  proto: true,
  forced: [].forEach != arrayForEach
}, {
  forEach: arrayForEach
}); // call something on iterator step with safe closing on error


var callWithSafeIterationClosing = function callWithSafeIterationClosing(iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var $Array$8 = Array; // `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from

var arrayFrom = function from(arrayLike
/* , mapfn = undefined, thisArg = undefined */
) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value; // if the target is not iterable or it's an array with the default iterator - use a simple case

  if (iteratorMethod && !(this === $Array$8 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];

    for (; !(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$8(length);

    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }

  result.length = index;
  return result;
};

var ITERATOR$8 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function next() {
      return {
        done: !!called++
      };
    },
    'return': function _return() {
      SAFE_CLOSING = true;
    }
  };

  iteratorWithReturn[ITERATOR$8] = function () {
    return this;
  }; // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing


  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {
  /* empty */
}

var checkCorrectnessOfIteration = function checkCorrectnessOfIteration(exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;

  try {
    var object = {};

    object[ITERATOR$8] = function () {
      return {
        next: function next() {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };

    exec(object);
  } catch (error) {
    /* empty */
  }

  return ITERATION_SUPPORT;
};

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
}); // `Array.from` method
// https://tc39.es/ecma262/#sec-array.from

_export({
  target: 'Array',
  stat: true,
  forced: INCORRECT_ITERATION
}, {
  from: arrayFrom
});

var $includes$1 = arrayIncludes.includes; // FF99+ bug

var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
}); // `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes

_export({
  target: 'Array',
  proto: true,
  forced: BROKEN_ON_SPARSE
}, {
  includes: function includes(el
  /* , fromIndex = 0 */
  ) {
    return $includes$1(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


addToUnscopables('includes');
/* eslint-disable es/no-array-prototype-indexof -- required for testing */

var $indexOf$1 = arrayIncludes.indexOf;
var nativeIndexOf = functionUncurryThis([].indexOf);
var NEGATIVE_ZERO$1 = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var STRICT_METHOD$6 = arrayMethodIsStrict('indexOf'); // `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof

_export({
  target: 'Array',
  proto: true,
  forced: NEGATIVE_ZERO$1 || !STRICT_METHOD$6
}, {
  indexOf: function indexOf(searchElement
  /* , fromIndex = 0 */
  ) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO$1 // convert -0 to +0
    ? nativeIndexOf(this, searchElement, fromIndex) || 0 : $indexOf$1(this, searchElement, fromIndex);
  }
}); // `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray


_export({
  target: 'Array',
  stat: true
}, {
  isArray: isArray$4
});

var ITERATOR$7 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false; // `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object

var IteratorPrototype$5, PrototypeOfArrayIteratorPrototype, arrayIterator$1;
/* eslint-disable es/no-array-prototype-keys -- safe */

if ([].keys) {
  arrayIterator$1 = [].keys(); // Safari 8 has buggy iterators w/o `next`

  if (!('next' in arrayIterator$1)) BUGGY_SAFARI_ITERATORS$1 = true;else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator$1));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$5 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$6(IteratorPrototype$5) || fails(function () {
  var test = {}; // FF44- legacy iterators case

  return IteratorPrototype$5[ITERATOR$7].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$5 = {}; // `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator

if (!isCallable(IteratorPrototype$5[ITERATOR$7])) {
  defineBuiltIn(IteratorPrototype$5, ITERATOR$7, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$5,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var IteratorPrototype$4 = iteratorsCore.IteratorPrototype;

var returnThis$1 = function returnThis$1() {
  return this;
};

var iteratorCreateConstructor = function iteratorCreateConstructor(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate$1(IteratorPrototype$4, {
    next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var PROPER_FUNCTION_NAME$3 = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function returnThis() {
  return this;
};

var iteratorDefine = function iteratorDefine(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function getIterationMethod(KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };

      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };

      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }

    return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY; // fix native

  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));

    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$3) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$3);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$6])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      } // Set @@toStringTag to native iterators


      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  } // fix Array.prototype.{ values, @@iterator }.name in V8 / FF


  if (PROPER_FUNCTION_NAME$3 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;

      defaultIterator = function values() {
        return functionCall(nativeIterator, this);
      };
    }
  } // export additional methods


  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
    }, methods);
  } // define iterator


  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$6, defaultIterator, {
      name: DEFAULT
    });
  }

  iterators[NAME] = defaultIterator;
  return methods;
}; // `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject


var createIterResultObject = function createIterResultObject(value, done) {
  return {
    value: value,
    done: done
  };
};

var defineProperty$c = objectDefineProperty.f;
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$h = internalState.set;
var getInternalState$d = internalState.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator

var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState$h(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind

  }); // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$d(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;

  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }

  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject

var values = iterators.Arguments = iterators.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries'); // V8 ~ Chrome 45- bug

if (descriptors && values.name !== 'values') try {
  defineProperty$c(values, 'name', {
    value: 'values'
  });
} catch (error) {
  /* empty */
}
var nativeJoin = functionUncurryThis([].join);
var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD$5 = arrayMethodIsStrict('join', ','); // `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join

_export({
  target: 'Array',
  proto: true,
  forced: ES3_STRINGS || !STRICT_METHOD$5
}, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});
/* eslint-disable es/no-array-prototype-lastindexof -- safe */


var min$9 = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD$4 = arrayMethodIsStrict('lastIndexOf');
var FORCED$j = NEGATIVE_ZERO || !STRICT_METHOD$4; // `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof

var arrayLastIndexOf = FORCED$j ? function lastIndexOf(searchElement
/* , fromIndex = @[*-1] */
) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return functionApply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min$9(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;

  for (; index >= 0; index--) {
    if (index in O && O[index] === searchElement) return index || 0;
  }

  return -1;
} : $lastIndexOf; // `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing

_export({
  target: 'Array',
  proto: true,
  forced: arrayLastIndexOf !== [].lastIndexOf
}, {
  lastIndexOf: arrayLastIndexOf
});

var $map$1 = arrayIteration.map;
var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('map'); // `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$2
}, {
  map: function map(callbackfn
  /* , thisArg */
  ) {
    return $map$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $Array$7 = Array;
var ISNT_GENERIC = fails(function () {
  function F() {
    /* empty */
  } // eslint-disable-next-line es/no-array-of -- safe


  return !($Array$7.of.call(F) instanceof F);
}); // `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic

_export({
  target: 'Array',
  stat: true,
  forced: ISNT_GENERIC
}, {
  of: function
    /* ...args */
  of() {
    var index = 0;
    var argumentsLength = arguments.length;
    var result = new (isConstructor(this) ? this : $Array$7)(argumentsLength);

    while (argumentsLength > index) {
      createProperty(result, index, arguments[index++]);
    }

    result.length = argumentsLength;
    return result;
  }
});

var $TypeError$p = TypeError; // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$a = Object.getOwnPropertyDescriptor; // Safari < 13 does not throw an error in this case

var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;

  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray$4(O) && !getOwnPropertyDescriptor$a(O, 'length').writable) {
    throw $TypeError$p('Cannot set read only .length');
  }

  return O.length = length;
} : function (O, length) {
  return O.length = length;
};
var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({
    length: 0x100000000
  }, 1) !== 4294967297;
}); // V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681

var SILENT_ON_NON_WRITABLE_LENGTH$1 = !function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
}(); // `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push

_export({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: INCORRECT_TO_LENGTH || SILENT_ON_NON_WRITABLE_LENGTH$1
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);

    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }

    arraySetLength(O, len);
    return len;
  }
});

var $TypeError$o = TypeError; // `Array.prototype.{ reduce, reduceRight }` methods implementation

var createMethod$5 = function createMethod$5(IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject$1(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }

      index += i;

      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$o('Reduce of empty array with no initial value');
      }
    }

    for (; IS_RIGHT ? index >= 0 : length > index; index += i) {
      if (index in self) {
        memo = callbackfn(memo, self[index], index, O);
      }
    }

    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$5(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$5(true)
};
var engineIsNode = classofRaw(global$1.process) == 'process';
var $reduce$1 = arrayReduce.left;
var STRICT_METHOD$3 = arrayMethodIsStrict('reduce'); // Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

var CHROME_BUG$1 = !engineIsNode && engineV8Version > 79 && engineV8Version < 83; // `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD$3 || CHROME_BUG$1
}, {
  reduce: function reduce(callbackfn
  /* , initialValue */
  ) {
    var length = arguments.length;
    return $reduce$1(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var $reduceRight$1 = arrayReduce.right;
var STRICT_METHOD$2 = arrayMethodIsStrict('reduceRight'); // Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83; // `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD$2 || CHROME_BUG
}, {
  reduceRight: function reduceRight(callbackfn
  /* , initialValue */
  ) {
    return $reduceRight$1(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var nativeReverse = functionUncurryThis([].reverse);
var test$1 = [1, 2]; // `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794

_export({
  target: 'Array',
  proto: true,
  forced: String(test$1) === String(test$1.reverse())
}, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray$4(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('slice');
var SPECIES$4 = wellKnownSymbol('species');
var $Array$6 = Array;
var max$7 = Math.max; // `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$1
}, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

    var Constructor, result, n;

    if (isArray$4(O)) {
      Constructor = O.constructor; // cross-realm fallback

      if (isConstructor(Constructor) && (Constructor === $Array$6 || isArray$4(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$6(Constructor)) {
        Constructor = Constructor[SPECIES$4];
        if (Constructor === null) Constructor = undefined;
      }

      if (Constructor === $Array$6 || Constructor === undefined) {
        return arraySlice$1(O, k, fin);
      }
    }

    result = new (Constructor === undefined ? $Array$6 : Constructor)(max$7(fin - k, 0));

    for (n = 0; k < fin; k++, n++) {
      if (k in O) createProperty(result, n, O[k]);
    }

    result.length = n;
    return result;
  }
});

var $some$2 = arrayIteration.some;
var STRICT_METHOD$1 = arrayMethodIsStrict('some'); // `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some

_export({
  target: 'Array',
  proto: true,
  forced: !STRICT_METHOD$1
}, {
  some: function some(callbackfn
  /* , thisArg */
  ) {
    return $some$2(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var floor$9 = Math.floor;

var mergeSort = function mergeSort(array, comparefn) {
  var length = array.length;
  var middle = floor$9(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge$1(array, mergeSort(arraySliceSimple(array, 0, middle), comparefn), mergeSort(arraySliceSimple(array, middle), comparefn), comparefn);
};

var insertionSort = function insertionSort(array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];

    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }

    if (j !== i++) array[j] = element;
  }

  return array;
};

var merge$1 = function merge$1(array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
  }

  return array;
};

var arraySort = mergeSort;
var firefox = engineUserAgent.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];
var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);
var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];
var test = [];
var nativeSort$1 = functionUncurryThis(test.sort);
var push$i = functionUncurryThis(test.push); // IE8-

var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
}); // V8 bug

var FAILS_ON_NULL = fails(function () {
  test.sort(null);
}); // Old WebKit

var STRICT_METHOD = arrayMethodIsStrict('sort');
var STABLE_SORT$1 = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;
  var result = '';
  var code, chr, value, index; // generate an array with more 512 elements (Chakra and old V8 fails only in this case)

  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66:
      case 69:
      case 70:
      case 72:
        value = 3;
        break;

      case 68:
      case 71:
        value = 4;
        break;

      default:
        value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({
        k: chr + index,
        v: value
      });
    }
  }

  test.sort(function (a, b) {
    return b.v - a.v;
  });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});
var FORCED$i = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT$1;

var getSortCompare$1 = function getSortCompare$1(comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$2(x) > toString$2(y) ? 1 : -1;
  };
}; // `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort


_export({
  target: 'Array',
  proto: true,
  forced: FORCED$i
}, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);
    var array = toObject$1(this);
    if (STABLE_SORT$1) return comparefn === undefined ? nativeSort$1(array) : nativeSort$1(array, comparefn);
    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$i(items, array[index]);
    }

    arraySort(items, getSortCompare$1(comparefn));
    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) {
      array[index] = items[index++];
    }

    while (index < arrayLength) {
      deletePropertyOrThrow(array, index++);
    }

    return array;
  }
});

var SPECIES$3 = wellKnownSymbol('species');

var setSpecies = function setSpecies(CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function get() {
        return this;
      }
    });
  }
}; // `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species


setSpecies('Array');
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var max$6 = Math.max;
var min$8 = Math.min; // `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species

_export({
  target: 'Array',
  proto: true,
  forced: !HAS_SPECIES_SUPPORT
}, {
  splice: function splice(start, deleteCount
  /* , ...items */
  ) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;

    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$8(max$6(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }

    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);

    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }

    A.length = actualDeleteCount;

    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];else deletePropertyOrThrow(O, to);
      }

      for (k = len; k > len - actualDeleteCount + insertCount; k--) {
        deletePropertyOrThrow(O, k - 1);
      }
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];else deletePropertyOrThrow(O, to);
      }
    }

    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }

    arraySetLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
}); // this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables


addToUnscopables('flat'); // this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('flatMap'); // IE8-

var INCORRECT_RESULT = [].unshift(0) !== 1; // V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError

var SILENT_ON_NON_WRITABLE_LENGTH = !function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
}(); // `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift

_export({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: INCORRECT_RESULT || SILENT_ON_NON_WRITABLE_LENGTH
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;

    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;

      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];else deletePropertyOrThrow(O, to);
      }

      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    }

    return arraySetLength(O, len + argCount);
  }
}); // eslint-disable-next-line es/no-typed-arrays -- safe


var arrayBufferBasicDetection = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var defineBuiltIns = function defineBuiltIns(target, src, options) {
  for (var key in src) {
    defineBuiltIn(target, key, src[key], options);
  }

  return target;
};

var $TypeError$n = TypeError;

var anInstance = function anInstance(it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw $TypeError$n('Incorrect invocation');
};

var $RangeError$c = RangeError; // `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex

var toIndex = function toIndex(it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError$c('Wrong length or index');
  return length;
}; // IEEE754 conversions based on https://github.com/feross/ieee754


var $Array$5 = Array;
var abs$8 = Math.abs;
var pow$5 = Math.pow;
var floor$8 = Math.floor;
var log$8 = Math.log;
var LN2$2 = Math.LN2;

var pack = function pack(number, mantissaLength, bytes) {
  var buffer = $Array$5(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow$5(2, -24) - pow$5(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs$8(number); // eslint-disable-next-line no-self-compare -- NaN check

  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$8(log$8(number) / LN2$2);
    c = pow$5(2, -exponent);

    if (number * c < 1) {
      exponent--;
      c *= 2;
    }

    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow$5(2, 1 - eBias);
    }

    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }

    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow$5(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow$5(2, eBias - 1) * pow$5(2, mantissaLength);
      exponent = 0;
    }
  }

  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }

  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;

  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }

  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function unpack(buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;

  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }

  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;

  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }

  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow$5(2, mantissaLength);
    exponent = exponent - eBias;
  }

  return (sign ? -1 : 1) * mantissa * pow$5(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};
var getOwnPropertyNames$4 = objectGetOwnPropertyNames.f;
var defineProperty$b = objectDefineProperty.f;
var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var getInternalState$c = internalState.get;
var setInternalState$g = internalState.set;
var ARRAY_BUFFER$1 = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer$1 = global$1[ARRAY_BUFFER$1];
var $ArrayBuffer = NativeArrayBuffer$1;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$1[DATA_VIEW];
var DataViewPrototype$1 = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype$3 = Object.prototype;
var Array$2 = global$1.Array;
var RangeError$3 = global$1.RangeError;
var fill = functionUncurryThis(arrayFill);
var reverse = functionUncurryThis([].reverse);
var packIEEE754 = ieee754.pack;
var unpackIEEE754 = ieee754.unpack;

var packInt8 = function packInt8(number) {
  return [number & 0xFF];
};

var packInt16 = function packInt16(number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function packInt32(number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function unpackInt32(buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function packFloat32(number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function packFloat64(number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function addGetter(Constructor, key) {
  defineProperty$b(Constructor[PROTOTYPE], key, {
    get: function get() {
      return getInternalState$c(this)[key];
    }
  });
};

var get$1 = function get$1(view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState$c(view);
  if (intIndex + count > store.byteLength) throw RangeError$3(WRONG_INDEX);
  var bytes = getInternalState$c(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySliceSimple(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set$2 = function set$2(view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState$c(view);
  if (intIndex + count > store.byteLength) throw RangeError$3(WRONG_INDEX);
  var bytes = getInternalState$c(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);

  for (var i = 0; i < count; i++) {
    bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
  }
};

if (!arrayBufferBasicDetection) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState$g(this, {
      bytes: fill(Array$2(byteLength), 0),
      byteLength: byteLength
    });
    if (!descriptors) this.byteLength = byteLength;
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype$1);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferLength = getInternalState$c(buffer).byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError$3('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError$3(WRONG_LENGTH);
    setInternalState$g(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });

    if (!descriptors) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype$1 = $DataView[PROTOTYPE];

  if (descriptors) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  defineBuiltIns(DataViewPrototype$1, {
    getInt8: function getInt8(byteOffset) {
      return get$1(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get$1(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset
    /* , littleEndian */
    ) {
      var bytes = get$1(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset
    /* , littleEndian */
    ) {
      var bytes = get$1(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset
    /* , littleEndian */
    ) {
      return unpackInt32(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset
    /* , littleEndian */
    ) {
      return unpackInt32(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset
    /* , littleEndian */
    ) {
      return unpackIEEE754(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset
    /* , littleEndian */
    ) {
      return unpackIEEE754(get$1(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set$2(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set$2(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value
    /* , littleEndian */
    ) {
      set$2(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value
    /* , littleEndian */
    ) {
      set$2(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value
    /* , littleEndian */
    ) {
      set$2(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value
    /* , littleEndian */
    ) {
      set$2(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value
    /* , littleEndian */
    ) {
      set$2(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value
    /* , littleEndian */
    ) {
      set$2(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME$2 && NativeArrayBuffer$1.name !== ARRAY_BUFFER$1;
  /* eslint-disable no-new -- required for testing */

  if (!fails(function () {
    NativeArrayBuffer$1(1);
  }) || !fails(function () {
    new NativeArrayBuffer$1(-1);
  }) || fails(function () {
    new NativeArrayBuffer$1();
    new NativeArrayBuffer$1(1.5);
    new NativeArrayBuffer$1(NaN);
    return NativeArrayBuffer$1.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer$1(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys$3 = getOwnPropertyNames$4(NativeArrayBuffer$1), j$1 = 0, key$3; keys$3.length > j$1;) {
      if (!((key$3 = keys$3[j$1++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key$3, NativeArrayBuffer$1[key$3]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer$1, 'name', ARRAY_BUFFER$1);
  } // WebKit bug - the same parent prototype for typed arrays and data view


  if (objectSetPrototypeOf && objectGetPrototypeOf(DataViewPrototype$1) !== ObjectPrototype$3) {
    objectSetPrototypeOf(DataViewPrototype$1, ObjectPrototype$3);
  } // iOS Safari 7.x bug


  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = functionUncurryThis(DataViewPrototype$1.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype$1, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, {
    unsafe: true
  });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER$1);
setToStringTag($DataView, DATA_VIEW);
var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};
var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer$3 = arrayBuffer[ARRAY_BUFFER];
var NativeArrayBuffer = global$1[ARRAY_BUFFER]; // `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor

_export({
  global: true,
  constructor: true,
  forced: NativeArrayBuffer !== ArrayBuffer$3
}, {
  ArrayBuffer: ArrayBuffer$3
});

setSpecies(ARRAY_BUFFER);
var defineProperty$a = objectDefineProperty.f;
var enforceInternalState$2 = internalState.enforce;
var getInternalState$b = internalState.get;
var Int8Array$4 = global$1.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global$1.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray = Int8Array$4 && objectGetPrototypeOf(Int8Array$4);
var TypedArrayPrototype$1 = Int8ArrayPrototype$1 && objectGetPrototypeOf(Int8ArrayPrototype$1);
var ObjectPrototype$2 = Object.prototype;
var TypeError$6 = global$1.TypeError;
var TO_STRING_TAG$5 = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor'; // Fixing native typed arrays in Opera Presto crashes the browser, see #595

var NATIVE_ARRAY_BUFFER_VIEWS$2 = arrayBufferBasicDetection && !!objectSetPrototypeOf && classof(global$1.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME$1, Constructor, Prototype;
var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};
var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject$6(it)) return false;
  var klass = classof(it);
  return klass === 'DataView' || hasOwnProperty_1(TypedArrayConstructorsList, klass) || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor$5 = function getTypedArrayConstructor$5(it) {
  var proto = objectGetPrototypeOf(it);
  if (!isObject$6(proto)) return;
  var state = getInternalState$b(proto);
  return state && hasOwnProperty_1(state, TYPED_ARRAY_CONSTRUCTOR) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor$5(proto);
};

var isTypedArray$2 = function isTypedArray$2(it) {
  if (!isObject$6(it)) return false;
  var klass = classof(it);
  return hasOwnProperty_1(TypedArrayConstructorsList, klass) || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var aTypedArray$x = function aTypedArray$x(it) {
  if (isTypedArray$2(it)) return it;
  throw TypeError$6('Target is not a typed array');
};

var aTypedArrayConstructor$4 = function aTypedArrayConstructor$4(C) {
  if (isCallable(C) && (!objectSetPrototypeOf || objectIsPrototypeOf(TypedArray, C))) return C;
  throw TypeError$6(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod$y = function exportTypedArrayMethod$y(KEY, property, forced, options) {
  if (!descriptors) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global$1[ARRAY];
    if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) {
        /* empty */
      }
    }
  }

  if (!TypedArrayPrototype$1[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype$1, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod$3 = function exportTypedArrayStaticMethod$3(KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!descriptors) return;

  if (objectSetPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global$1[ARRAY];
      if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) {
        /* empty */
      }
    }

    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && TypedArray[KEY] || property);
      } catch (error) {
        /* empty */
      }
    } else return;
  }

  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$1[ARRAY];

    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME$1 in TypedArrayConstructorsList) {
  Constructor = global$1[NAME$1];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$2(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;else NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}

for (NAME$1 in BigIntArrayConstructorsList) {
  Constructor = global$1[NAME$1];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$2(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
} // WebKit bug - typed arrays constructors prototype is Object.prototype


if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError$6('Incorrect invocation');
  };

  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME$1 in TypedArrayConstructorsList) {
    if (global$1[NAME$1]) objectSetPrototypeOf(global$1[NAME$1], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !TypedArrayPrototype$1 || TypedArrayPrototype$1 === ObjectPrototype$2) {
  TypedArrayPrototype$1 = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME$1 in TypedArrayConstructorsList) {
    if (global$1[NAME$1]) objectSetPrototypeOf(global$1[NAME$1].prototype, TypedArrayPrototype$1);
  }
} // WebKit bug - one more object in Uint8ClampedArray prototype chain


if (NATIVE_ARRAY_BUFFER_VIEWS$2 && objectGetPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$1) {
  objectSetPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype$1);
}

if (descriptors && !hasOwnProperty_1(TypedArrayPrototype$1, TO_STRING_TAG$5)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty$a(TypedArrayPrototype$1, TO_STRING_TAG$5, {
    get: function get() {
      return isObject$6(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });

  for (NAME$1 in TypedArrayConstructorsList) {
    if (global$1[NAME$1]) {
      createNonEnumerableProperty(global$1[NAME$1], TYPED_ARRAY_TAG, NAME$1);
    }
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$2,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray$x,
  aTypedArrayConstructor: aTypedArrayConstructor$4,
  exportTypedArrayMethod: exportTypedArrayMethod$y,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod$3,
  getTypedArrayConstructor: getTypedArrayConstructor$5,
  isView: isView,
  isTypedArray: isTypedArray$2,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype$1
};
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS; // `ArrayBuffer.isView` method
// https://tc39.es/ecma262/#sec-arraybuffer.isview

_export({
  target: 'ArrayBuffer',
  stat: true,
  forced: !NATIVE_ARRAY_BUFFER_VIEWS$1
}, {
  isView: arrayBufferViewCore.isView
});

var $TypeError$m = TypeError; // `Assert: IsConstructor(argument) is true`

var aConstructor = function aConstructor(argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$m(tryToString(argument) + ' is not a constructor');
};

var SPECIES$2 = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor

var speciesConstructor = function speciesConstructor(O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var ArrayBuffer$2 = arrayBuffer.ArrayBuffer;
var DataView$3 = arrayBuffer.DataView;
var DataViewPrototype = DataView$3.prototype;
var nativeArrayBufferSlice = functionUncurryThis(ArrayBuffer$2.prototype.slice);
var getUint8 = functionUncurryThis(DataViewPrototype.getUint8);
var setUint8 = functionUncurryThis(DataViewPrototype.setUint8);
var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer$2(2).slice(1, undefined).byteLength;
}); // `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice

_export({
  target: 'ArrayBuffer',
  proto: true,
  unsafe: true,
  forced: INCORRECT_SLICE
}, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }

    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer$2))(toLength(fin - first));
    var viewSource = new DataView$3(this);
    var viewTarget = new DataView$3(result);
    var index = 0;

    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    }

    return result;
  }
}); // `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor


_export({
  global: true,
  constructor: true,
  forced: !arrayBufferBasicDetection
}, {
  DataView: arrayBuffer.DataView
});

var FORCED$h = fails(function () {
  return new Date(16e11).getYear() !== 120;
});
var getFullYear = functionUncurryThis(Date.prototype.getFullYear); // `Date.prototype.getYear` method
// https://tc39.es/ecma262/#sec-date.prototype.getyear

_export({
  target: 'Date',
  proto: true,
  forced: FORCED$h
}, {
  getYear: function getYear() {
    return getFullYear(this) - 1900;
  }
}); // TODO: Remove from `core-js@4`


var $Date = Date;
var thisTimeValue$4 = functionUncurryThis($Date.prototype.getTime); // `Date.now` method
// https://tc39.es/ecma262/#sec-date.now

_export({
  target: 'Date',
  stat: true
}, {
  now: function now() {
    return thisTimeValue$4(new $Date());
  }
});

var DatePrototype$3 = Date.prototype;
var thisTimeValue$3 = functionUncurryThis(DatePrototype$3.getTime);
var setFullYear = functionUncurryThis(DatePrototype$3.setFullYear); // `Date.prototype.setYear` method
// https://tc39.es/ecma262/#sec-date.prototype.setyear

_export({
  target: 'Date',
  proto: true
}, {
  setYear: function setYear(year) {
    // validate
    thisTimeValue$3(this);
    var yi = toIntegerOrInfinity(year);
    var yyyy = 0 <= yi && yi <= 99 ? yi + 1900 : yi;
    return setFullYear(this, yyyy);
  }
}); // `Date.prototype.toGMTString` method
// https://tc39.es/ecma262/#sec-date.prototype.togmtstring


_export({
  target: 'Date',
  proto: true
}, {
  toGMTString: Date.prototype.toUTCString
});

var $RangeError$b = RangeError; // `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat

var stringRepeat = function repeat(count) {
  var str = toString$2(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw $RangeError$b('Wrong number of repetitions');

  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) result += str;
  }

  return result;
}; // https://github.com/tc39/proposal-string-pad-start-end


var repeat$2 = functionUncurryThis(stringRepeat);
var stringSlice$f = functionUncurryThis(''.slice);
var ceil = Math.ceil; // `String.prototype.{ padStart, padEnd }` methods implementation

var createMethod$4 = function createMethod$4(IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString$2(requireObjectCoercible($this));
    var intMaxLength = toLength(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString$2(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat$2(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice$f(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod$4(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod$4(true)
};
var padStart = stringPad.start;
var $RangeError$a = RangeError;
var $isFinite$1 = isFinite;
var abs$7 = Math.abs;
var DatePrototype$2 = Date.prototype;
var nativeDateToISOString = DatePrototype$2.toISOString;
var thisTimeValue$2 = functionUncurryThis(DatePrototype$2.getTime);
var getUTCDate = functionUncurryThis(DatePrototype$2.getUTCDate);
var getUTCFullYear = functionUncurryThis(DatePrototype$2.getUTCFullYear);
var getUTCHours = functionUncurryThis(DatePrototype$2.getUTCHours);
var getUTCMilliseconds = functionUncurryThis(DatePrototype$2.getUTCMilliseconds);
var getUTCMinutes = functionUncurryThis(DatePrototype$2.getUTCMinutes);
var getUTCMonth = functionUncurryThis(DatePrototype$2.getUTCMonth);
var getUTCSeconds = functionUncurryThis(DatePrototype$2.getUTCSeconds); // `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:

var dateToIsoString = fails(function () {
  return nativeDateToISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  nativeDateToISOString.call(new Date(NaN));
}) ? function toISOString() {
  if (!$isFinite$1(thisTimeValue$2(this))) throw $RangeError$a('Invalid time value');
  var date = this;
  var year = getUTCFullYear(date);
  var milliseconds = getUTCMilliseconds(date);
  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
  return sign + padStart(abs$7(year), sign ? 6 : 4, 0) + '-' + padStart(getUTCMonth(date) + 1, 2, 0) + '-' + padStart(getUTCDate(date), 2, 0) + 'T' + padStart(getUTCHours(date), 2, 0) + ':' + padStart(getUTCMinutes(date), 2, 0) + ':' + padStart(getUTCSeconds(date), 2, 0) + '.' + padStart(milliseconds, 3, 0) + 'Z';
} : nativeDateToISOString; // `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations

_export({
  target: 'Date',
  proto: true,
  forced: Date.prototype.toISOString !== dateToIsoString
}, {
  toISOString: dateToIsoString
});

var FORCED$g = fails(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
    toISOString: function toISOString() {
      return 1;
    }
  }) !== 1;
}); // `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson

_export({
  target: 'Date',
  proto: true,
  arity: 1,
  forced: FORCED$g
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject$1(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

var $TypeError$l = TypeError; // `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive

var dateToPrimitive = function dateToPrimitive(hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';else if (hint !== 'number') throw $TypeError$l('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype$1 = Date.prototype; // `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive

if (!hasOwnProperty_1(DatePrototype$1, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype$1, TO_PRIMITIVE, dateToPrimitive);
} // TODO: Remove from `core-js@4`


var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var nativeDateToString = functionUncurryThis(DatePrototype[TO_STRING$1]);
var thisTimeValue$1 = functionUncurryThis(DatePrototype.getTime); // `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring

if (String(new Date(NaN)) != INVALID_DATE) {
  defineBuiltIn(DatePrototype, TO_STRING$1, function toString() {
    var value = thisTimeValue$1(this); // eslint-disable-next-line no-self-compare -- NaN check

    return value === value ? nativeDateToString(this) : INVALID_DATE;
  });
}

var charAt$g = functionUncurryThis(''.charAt);
var charCodeAt$4 = functionUncurryThis(''.charCodeAt);
var exec$9 = functionUncurryThis(/./.exec);
var numberToString$2 = functionUncurryThis(1.0.toString);
var toUpperCase = functionUncurryThis(''.toUpperCase);
var raw = /[\w*+\-./@]/;

var hex$1 = function hex$1(code, length) {
  var result = numberToString$2(code, 16);

  while (result.length < length) {
    result = '0' + result;
  }

  return result;
}; // `escape` method
// https://tc39.es/ecma262/#sec-escape-string


_export({
  global: true
}, {
  escape: function escape(string) {
    var str = toString$2(string);
    var result = '';
    var length = str.length;
    var index = 0;
    var chr, code;

    while (index < length) {
      chr = charAt$g(str, index++);

      if (exec$9(raw, chr)) {
        result += chr;
      } else {
        code = charCodeAt$4(chr, 0);

        if (code < 256) {
          result += '%' + hex$1(code, 2);
        } else {
          result += '%u' + toUpperCase(hex$1(code, 4));
        }
      }
    }

    return result;
  }
});

var $Function = Function;
var concat$3 = functionUncurryThis([].concat);
var join$7 = functionUncurryThis([].join);
var factories = {};

var construct = function construct(C, argsLength, args) {
  if (!hasOwnProperty_1(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) {
      list[i] = 'a[' + i + ']';
    }

    factories[argsLength] = $Function('C,a', 'return new C(' + join$7(list, ',') + ')');
  }

  return factories[argsLength](C, args);
}; // `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind


var functionBind = functionBindNative ? $Function.bind : function bind(that
/* , ...args */
) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice$1(arguments, 1);

  var boundFunction = function
    /* args... */
  bound() {
    var args = concat$3(partArgs, arraySlice$1(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };

  if (isObject$6(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
}; // TODO: Remove from `core-js@4`
// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind

_export({
  target: 'Function',
  proto: true,
  forced: Function.bind !== functionBind
}, {
  bind: functionBind
});

var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype$1 = Function.prototype; // `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance

if (!(HAS_INSTANCE in FunctionPrototype$1)) {
  objectDefineProperty.f(FunctionPrototype$1, HAS_INSTANCE, {
    value: makeBuiltIn_1(function (O) {
      if (!isCallable(this) || !isObject$6(O)) return false;
      var P = this.prototype;
      if (!isObject$6(P)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

      while (O = objectGetPrototypeOf(O)) {
        if (P === O) return true;
      }

      return false;
    }, HAS_INSTANCE)
  });
}

var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var defineProperty$9 = objectDefineProperty.f;
var FunctionPrototype = Function.prototype;
var functionToString = functionUncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = functionUncurryThis(nameRE.exec);
var NAME = 'name'; // Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name

if (descriptors && !FUNCTION_NAME_EXISTS) {
  defineProperty$9(FunctionPrototype, NAME, {
    configurable: true,
    get: function get() {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
} // `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis


_export({
  global: true,
  forced: global$1.globalThis !== global$1
}, {
  globalThis: global$1
}); // JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag


setToStringTag(global$1.JSON, 'JSON', true); // FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

var arrayBufferNonExtensible = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8); // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe

    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
      value: 8
    });
  }
}); // eslint-disable-next-line es/no-object-isextensible -- safe

var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES$9 = fails(function () {
  $isExtensible(1);
}); // `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible

var objectIsExtensible = FAILS_ON_PRIMITIVES$9 || arrayBufferNonExtensible ? function isExtensible(it) {
  if (!isObject$6(it)) return false;
  if (arrayBufferNonExtensible && classofRaw(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;
var freezing = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});
var internalMetadata = createCommonjsModule(function (module) {
  var defineProperty = objectDefineProperty.f;
  var REQUIRED = false;
  var METADATA = uid('meta');
  var id = 0;

  var setMetadata = function setMetadata(it) {
    defineProperty(it, METADATA, {
      value: {
        objectID: 'O' + id++,
        // object ID
        weakData: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!isObject$6(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!hasOwnProperty_1(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!objectIsExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMetadata(it); // return object ID
    }

    return it[METADATA].objectID;
  };

  var getWeakData = function getWeakData(it, create) {
    if (!hasOwnProperty_1(it, METADATA)) {
      // can't set metadata to uncaught frozen object
      if (!objectIsExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMetadata(it); // return the store of weak collections IDs
    }

    return it[METADATA].weakData;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (freezing && REQUIRED && objectIsExtensible(it) && !hasOwnProperty_1(it, METADATA)) setMetadata(it);
    return it;
  };

  var enable = function enable() {
    meta.enable = function () {
      /* empty */
    };

    REQUIRED = true;
    var getOwnPropertyNames = objectGetOwnPropertyNames.f;
    var splice = functionUncurryThis([].splice);
    var test = {};
    test[METADATA] = 1; // prevent exposing of metadata key

    if (getOwnPropertyNames(test).length) {
      objectGetOwnPropertyNames.f = function (it) {
        var result = getOwnPropertyNames(it);

        for (var i = 0, length = result.length; i < length; i++) {
          if (result[i] === METADATA) {
            splice(result, i, 1);
            break;
          }
        }

        return result;
      };

      _export({
        target: 'Object',
        stat: true,
        forced: true
      }, {
        getOwnPropertyNames: objectGetOwnPropertyNamesExternal.f
      });
    }
  };

  var meta = module.exports = {
    enable: enable,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
  };
  hiddenKeys$1[METADATA] = true;
});

var collection = function collection(CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global$1[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function fixMethod(KEY) {
    var uncurriedNativeMethod = functionUncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY, KEY == 'add' ? function add(value) {
      uncurriedNativeMethod(this, value === 0 ? 0 : value);
      return this;
    } : KEY == 'delete' ? function (key) {
      return IS_WEAK && !isObject$6(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : KEY == 'get' ? function get(key) {
      return IS_WEAK && !isObject$6(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : KEY == 'has' ? function has(key) {
      return IS_WEAK && !isObject$6(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : function set(key, value) {
      uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
      return this;
    });
  };

  var REPLACE = isForced_1(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })));

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    internalMetadata.enable();
  } else if (isForced_1(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor(); // early implementations not supports chaining

    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false

    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    }); // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing

    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) {
      new NativeConstructor(iterable);
    }); // for early implementations -0 and +0 not the same

    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;

      while (index--) {
        $instance[ADDER](index, index);
      }

      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
          that: that,
          AS_ENTRIES: IS_MAP
        });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;

  _export({
    global: true,
    constructor: true,
    forced: Constructor != NativeConstructor
  }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);
  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
  return Constructor;
};

var defineProperty$8 = objectDefineProperty.f;
var fastKey = internalMetadata.fastKey;
var setInternalState$f = internalState.set;
var internalStateGetterFor$1 = internalState.getterFor;
var collectionStrong = {
  getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState$f(that, {
        type: CONSTRUCTOR_NAME,
        index: objectCreate$1(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!descriptors) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
        that: that,
        AS_ENTRIES: IS_MAP
      });
    });
    var Prototype = Constructor.prototype;
    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

    var define = function define(that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index; // change existing entry

      if (entry) {
        entry.value = value; // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (descriptors) state.size++;else that.size++; // add to index

        if (index !== 'F') state.index[index] = entry;
      }

      return that;
    };

    var getEntry = function getEntry(that, key) {
      var state = getInternalState(that); // fast case

      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index]; // frozen object case

      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;

        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }

        state.first = state.last = undefined;
        if (descriptors) state.size = 0;else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function _delete(key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);

        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (descriptors) state.size--;else that.size--;
        }

        return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn
      /* , that = undefined */
      ) {
        var state = getInternalState(this);
        var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;

        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this); // revert to the last existing entry

          while (entry && entry.removed) {
            entry = entry.previous;
          }
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });
    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (descriptors) defineProperty$8(Prototype, 'size', {
      get: function get() {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME); // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator

    iteratorDefine(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$f(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last; // revert to the last existing entry

      while (entry && entry.removed) {
        entry = entry.previous;
      } // get next entry


      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      } // return step by kind


      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species

    setSpecies(CONSTRUCTOR_NAME);
  }
}; // `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects

collection('Map', function (init) {
  return function Map() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);
var log$7 = Math.log; // `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe

var mathLog1p = Math.log1p || function log1p(x) {
  var n = +x;
  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log$7(1 + n);
}; // eslint-disable-next-line es/no-math-acosh -- required for testing


var $acosh = Math.acosh;
var log$6 = Math.log;
var sqrt$2 = Math.sqrt;
var LN2$1 = Math.LN2;
var FORCED$f = !$acosh // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
|| Math.floor($acosh(Number.MAX_VALUE)) != 710 // Tor Browser bug: Math.acosh(Infinity) -> NaN
|| $acosh(Infinity) != Infinity; // `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh

_export({
  target: 'Math',
  stat: true,
  forced: FORCED$f
}, {
  acosh: function acosh(x) {
    var n = +x;
    return n < 1 ? NaN : n > 94906265.62425156 ? log$6(n) + LN2$1 : mathLog1p(n - 1 + sqrt$2(n - 1) * sqrt$2(n + 1));
  }
}); // eslint-disable-next-line es/no-math-asinh -- required for testing


var $asinh = Math.asinh;
var log$5 = Math.log;
var sqrt$1 = Math.sqrt;

function asinh(x) {
  var n = +x;
  return !isFinite(n) || n == 0 ? n : n < 0 ? -asinh(-n) : log$5(n + sqrt$1(n * n + 1));
} // `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0


_export({
  target: 'Math',
  stat: true,
  forced: !($asinh && 1 / $asinh(0) > 0)
}, {
  asinh: asinh
}); // eslint-disable-next-line es/no-math-atanh -- required for testing


var $atanh = Math.atanh;
var log$4 = Math.log; // `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0

_export({
  target: 'Math',
  stat: true,
  forced: !($atanh && 1 / $atanh(-0) < 0)
}, {
  atanh: function atanh(x) {
    var n = +x;
    return n == 0 ? n : log$4((1 + n) / (1 - n)) / 2;
  }
}); // `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe


var mathSign = Math.sign || function sign(x) {
  var n = +x; // eslint-disable-next-line no-self-compare -- NaN check

  return n == 0 || n != n ? n : n < 0 ? -1 : 1;
};

var abs$6 = Math.abs;
var pow$4 = Math.pow; // `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt

_export({
  target: 'Math',
  stat: true
}, {
  cbrt: function cbrt(x) {
    var n = +x;
    return mathSign(n) * pow$4(abs$6(n), 1 / 3);
  }
});

var floor$7 = Math.floor;
var log$3 = Math.log;
var LOG2E = Math.LOG2E; // `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32

_export({
  target: 'Math',
  stat: true
}, {
  clz32: function clz32(x) {
    var n = x >>> 0;
    return n ? 31 - floor$7(log$3(n + 0.5) * LOG2E) : 32;
  }
}); // eslint-disable-next-line es/no-math-expm1 -- safe


var $expm1 = Math.expm1;
var exp$2 = Math.exp; // `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1

var mathExpm1 = !$expm1 // Old FF bug
|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 // Tor Browser bug
|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
  var n = +x;
  return n == 0 ? n : n > -1e-6 && n < 1e-6 ? n + n * n / 2 : exp$2(n) - 1;
} : $expm1; // eslint-disable-next-line es/no-math-cosh -- required for testing

var $cosh = Math.cosh;
var abs$5 = Math.abs;
var E$1 = Math.E; // `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh

_export({
  target: 'Math',
  stat: true,
  forced: !$cosh || $cosh(710) === Infinity
}, {
  cosh: function cosh(x) {
    var t = mathExpm1(abs$5(x) - 1) + 1;
    return (t + 1 / (t * E$1 * E$1)) * (E$1 / 2);
  }
}); // `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing


_export({
  target: 'Math',
  stat: true,
  forced: mathExpm1 != Math.expm1
}, {
  expm1: mathExpm1
});

var abs$4 = Math.abs;
var pow$3 = Math.pow;
var EPSILON = pow$3(2, -52);
var EPSILON32 = pow$3(2, -23);
var MAX32 = pow$3(2, 127) * (2 - EPSILON32);
var MIN32 = pow$3(2, -126);

var roundTiesToEven = function roundTiesToEven(n) {
  return n + 1 / EPSILON - 1 / EPSILON;
}; // `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe


var mathFround = Math.fround || function fround(x) {
  var n = +x;
  var $abs = abs$4(n);
  var $sign = mathSign(n);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs); // eslint-disable-next-line no-self-compare -- NaN check

  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
}; // `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround


_export({
  target: 'Math',
  stat: true
}, {
  fround: mathFround
}); // eslint-disable-next-line es/no-math-hypot -- required for testing


var $hypot = Math.hypot;
var abs$3 = Math.abs;
var sqrt = Math.sqrt; // Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546

var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity; // `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot

_export({
  target: 'Math',
  stat: true,
  arity: 2,
  forced: BUGGY
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  hypot: function hypot(value1, value2) {
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;

    while (i < aLen) {
      arg = abs$3(arguments[i++]);

      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }

    return larg === Infinity ? Infinity : larg * sqrt(sum);
  }
}); // eslint-disable-next-line es/no-math-imul -- required for testing


var $imul = Math.imul;
var FORCED$e = fails(function () {
  return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
}); // `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity

_export({
  target: 'Math',
  stat: true,
  forced: FORCED$e
}, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

var log$2 = Math.log;
var LOG10E = Math.LOG10E; // eslint-disable-next-line es/no-math-log10 -- safe

var mathLog10 = Math.log10 || function log10(x) {
  return log$2(x) * LOG10E;
}; // `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10


_export({
  target: 'Math',
  stat: true
}, {
  log10: mathLog10
}); // `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p


_export({
  target: 'Math',
  stat: true
}, {
  log1p: mathLog1p
});

var log$1 = Math.log;
var LN2 = Math.LN2; // `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2

_export({
  target: 'Math',
  stat: true
}, {
  log2: function log2(x) {
    return log$1(x) / LN2;
  }
}); // `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign


_export({
  target: 'Math',
  stat: true
}, {
  sign: mathSign
});

var abs$2 = Math.abs;
var exp$1 = Math.exp;
var E = Math.E;
var FORCED$d = fails(function () {
  // eslint-disable-next-line es/no-math-sinh -- required for testing
  return Math.sinh(-2e-17) != -2e-17;
}); // `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers

_export({
  target: 'Math',
  stat: true,
  forced: FORCED$d
}, {
  sinh: function sinh(x) {
    var n = +x;
    return abs$2(n) < 1 ? (mathExpm1(n) - mathExpm1(-n)) / 2 : (exp$1(n - 1) - exp$1(-n - 1)) * (E / 2);
  }
});

var exp = Math.exp; // `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh

_export({
  target: 'Math',
  stat: true
}, {
  tanh: function tanh(x) {
    var n = +x;
    var a = mathExpm1(n);
    var b = mathExpm1(-n);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
  }
}); // Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag


setToStringTag(Math, 'Math', true); // `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc

_export({
  target: 'Math',
  stat: true
}, {
  trunc: mathTrunc
}); // `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue


var thisNumberValue$1 = functionUncurryThis(1.0.valueOf); // a string of all valid unicode whitespaces

var whitespaces$1 = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002" + "\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var replace$9 = functionUncurryThis(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

var createMethod$3 = function createMethod$3(TYPE) {
  return function ($this) {
    var string = toString$2(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$9(string, ltrim, '');
    if (TYPE & 2) string = replace$9(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};
var getOwnPropertyNames$3 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$9 = objectGetOwnPropertyDescriptor.f;
var defineProperty$7 = objectDefineProperty.f;
var trim$3 = stringTrim.trim;
var NUMBER = 'Number';
var NativeNumber = global$1[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$5 = global$1.TypeError;
var arraySlice = functionUncurryThis(''.slice);
var charCodeAt$3 = functionUncurryThis(''.charCodeAt); // `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric

var toNumeric = function toNumeric(value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
}; // `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber


var toNumber = function toNumber(argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol$1(it)) throw TypeError$5('Cannot convert a Symbol value to a number');

  if (typeof it == 'string' && it.length > 2) {
    it = trim$3(it);
    first = charCodeAt$3(it, 0);

    if (first === 43 || first === 45) {
      third = charCodeAt$3(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt$3(it, 1)) {
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0b[01]+$/i

        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        // fast equal of /^0o[0-7]+$/i

        default:
          return +it;
      }

      digits = arraySlice(it, 2);
      length = digits.length;

      for (index = 0; index < length; index++) {
        code = charCodeAt$3(digits, index); // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols

        if (code < 48 || code > maxCode) return NaN;
      }

      return parseInt(digits, radix);
    }
  }

  return +it;
}; // `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor


if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this; // check on 1..constructor(foo) case

    return objectIsPrototypeOf(NumberPrototype, dummy) && fails(function () {
      thisNumberValue$1(dummy);
    }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };

  for (var keys$2 = descriptors ? getOwnPropertyNames$3(NativeNumber) : ( // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
  'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' + // ESNext
  'fromString,range').split(','), j = 0, key$2; keys$2.length > j; j++) {
    if (hasOwnProperty_1(NativeNumber, key$2 = keys$2[j]) && !hasOwnProperty_1(NumberWrapper, key$2)) {
      defineProperty$7(NumberWrapper, key$2, getOwnPropertyDescriptor$9(NativeNumber, key$2));
    }
  }

  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  defineBuiltIn(global$1, NUMBER, NumberWrapper, {
    constructor: true
  });
} // `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon


_export({
  target: 'Number',
  stat: true,
  nonConfigurable: true,
  nonWritable: true
}, {
  EPSILON: Math.pow(2, -52)
});

var globalIsFinite = global$1.isFinite; // `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe

var numberIsFinite = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
}; // `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite


_export({
  target: 'Number',
  stat: true
}, {
  isFinite: numberIsFinite
});

var floor$6 = Math.floor; // `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe

var isIntegralNumber = Number.isInteger || function isInteger(it) {
  return !isObject$6(it) && isFinite(it) && floor$6(it) === it;
}; // `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger


_export({
  target: 'Number',
  stat: true
}, {
  isInteger: isIntegralNumber
}); // `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan


_export({
  target: 'Number',
  stat: true
}, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});

var abs$1 = Math.abs; // `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger

_export({
  target: 'Number',
  stat: true
}, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber(number) && abs$1(number) <= 0x1FFFFFFFFFFFFF;
  }
}); // `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer


_export({
  target: 'Number',
  stat: true,
  nonConfigurable: true,
  nonWritable: true
}, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
}); // `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer


_export({
  target: 'Number',
  stat: true,
  nonConfigurable: true,
  nonWritable: true
}, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});

var trim$2 = stringTrim.trim;
var charAt$f = functionUncurryThis(''.charAt);
var $parseFloat = global$1.parseFloat;
var Symbol$4 = global$1.Symbol;
var ITERATOR$5 = Symbol$4 && Symbol$4.iterator;
var FORCED$c = 1 / $parseFloat(whitespaces$1 + '-0') !== -Infinity // MS Edge 18- broken with boxed symbols
|| ITERATOR$5 && !fails(function () {
  $parseFloat(Object(ITERATOR$5));
}); // `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string

var numberParseFloat = FORCED$c ? function parseFloat(string) {
  var trimmedString = trim$2(toString$2(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && charAt$f(trimmedString, 0) == '-' ? -0 : result;
} : $parseFloat; // `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing

_export({
  target: 'Number',
  stat: true,
  forced: Number.parseFloat != numberParseFloat
}, {
  parseFloat: numberParseFloat
});

var trim$1 = stringTrim.trim;
var $parseInt = global$1.parseInt;
var Symbol$3 = global$1.Symbol;
var ITERATOR$4 = Symbol$3 && Symbol$3.iterator;
var hex = /^[+-]?0x/i;
var exec$8 = functionUncurryThis(hex.exec);
var FORCED$b = $parseInt(whitespaces$1 + '08') !== 8 || $parseInt(whitespaces$1 + '0x16') !== 22 // MS Edge 18- broken with boxed symbols
|| ITERATOR$4 && !fails(function () {
  $parseInt(Object(ITERATOR$4));
}); // `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix

var numberParseInt = FORCED$b ? function parseInt(string, radix) {
  var S = trim$1(toString$2(string));
  return $parseInt(S, radix >>> 0 || (exec$8(hex, S) ? 16 : 10));
} : $parseInt; // `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing

_export({
  target: 'Number',
  stat: true,
  forced: Number.parseInt != numberParseInt
}, {
  parseInt: numberParseInt
});

var $RangeError$9 = RangeError;
var $String$1 = String;
var $isFinite = isFinite;
var abs = Math.abs;
var floor$5 = Math.floor;
var pow$2 = Math.pow;
var round = Math.round;
var nativeToExponential = functionUncurryThis(1.0.toExponential);
var repeat$1 = functionUncurryThis(stringRepeat);
var stringSlice$e = functionUncurryThis(''.slice); // Edge 17-

var ROUNDS_PROPERLY = nativeToExponential(-6.9e-11, 4) === '-6.9000e-11' // IE11- && Edge 14-
&& nativeToExponential(1.255, 2) === '1.25e+0' // FF86-, V8 ~ Chrome 49-50
&& nativeToExponential(12345, 3) === '1.235e+4' // FF86-, V8 ~ Chrome 49-50
&& nativeToExponential(25, 0) === '3e+1'; // IE8-

var THROWS_ON_INFINITY_FRACTION = fails(function () {
  nativeToExponential(1, Infinity);
}) && fails(function () {
  nativeToExponential(1, -Infinity);
}); // Safari <11 && FF <50

var PROPER_NON_FINITE_THIS_CHECK = !fails(function () {
  nativeToExponential(Infinity, Infinity);
}) && !fails(function () {
  nativeToExponential(NaN, Infinity);
});
var FORCED$a = !ROUNDS_PROPERLY || !THROWS_ON_INFINITY_FRACTION || !PROPER_NON_FINITE_THIS_CHECK; // `Number.prototype.toExponential` method
// https://tc39.es/ecma262/#sec-number.prototype.toexponential

_export({
  target: 'Number',
  proto: true,
  forced: FORCED$a
}, {
  toExponential: function toExponential(fractionDigits) {
    var x = thisNumberValue$1(this);
    if (fractionDigits === undefined) return nativeToExponential(x);
    var f = toIntegerOrInfinity(fractionDigits);
    if (!$isFinite(x)) return String(x); // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation

    if (f < 0 || f > 20) throw $RangeError$9('Incorrect fraction digits');
    if (ROUNDS_PROPERLY) return nativeToExponential(x, f);
    var s = '';
    var m = '';
    var e = 0;
    var c = '';
    var d = '';

    if (x < 0) {
      s = '-';
      x = -x;
    }

    if (x === 0) {
      e = 0;
      m = repeat$1('0', f + 1);
    } else {
      // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
      // TODO: improve accuracy with big fraction digits
      var l = mathLog10(x);
      e = floor$5(l);
      var n = 0;
      var w = pow$2(10, e - f);
      n = round(x / w);

      if (2 * x >= (2 * n + 1) * w) {
        n += 1;
      }

      if (n >= pow$2(10, f + 1)) {
        n /= 10;
        e += 1;
      }

      m = $String$1(n);
    }

    if (f !== 0) {
      m = stringSlice$e(m, 0, 1) + '.' + stringSlice$e(m, 1);
    }

    if (e === 0) {
      c = '+';
      d = '0';
    } else {
      c = e > 0 ? '+' : '-';
      d = $String$1(abs(e));
    }

    m += 'e' + c + d;
    return s + m;
  }
});

var $RangeError$8 = RangeError;
var $String = String;
var floor$4 = Math.floor;
var repeat = functionUncurryThis(stringRepeat);
var stringSlice$d = functionUncurryThis(''.slice);
var nativeToFixed = functionUncurryThis(1.0.toFixed);

var pow$1 = function pow$1(x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log = function log(x) {
  var n = 0;
  var x2 = x;

  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }

  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }

  return n;
};

var multiply = function multiply(data, n, c) {
  var index = -1;
  var c2 = c;

  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$4(c2 / 1e7);
  }
};

var divide = function divide(data, n) {
  var index = 6;
  var c = 0;

  while (--index >= 0) {
    c += data[index];
    data[index] = floor$4(c / n);
    c = c % n * 1e7;
  }
};

var dataToString = function dataToString(data) {
  var index = 6;
  var s = '';

  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  }

  return s;
};

var FORCED$9 = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' || nativeToFixed(0.9, 0) !== '1' || nativeToFixed(1.255, 2) !== '1.25' || nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
}); // `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed

_export({
  target: 'Number',
  proto: true,
  forced: FORCED$9
}, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue$1(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k; // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation

    if (fractDigits < 0 || fractDigits > 20) throw $RangeError$8('Incorrect fraction digits'); // eslint-disable-next-line no-self-compare -- NaN check

    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);

    if (number < 0) {
      sign = '-';
      number = -number;
    }

    if (number > 1e-21) {
      e = log(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;

      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;

        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }

        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;

        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }

        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }

    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits ? '0.' + repeat('0', fractDigits - k) + result : stringSlice$d(result, 0, k - fractDigits) + '.' + stringSlice$d(result, k - fractDigits));
    } else {
      result = sign + result;
    }

    return result;
  }
});

var nativeToPrecision = functionUncurryThis(1.0.toPrecision);
var FORCED$8 = fails(function () {
  // IE7-
  return nativeToPrecision(1, undefined) !== '1';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToPrecision({});
}); // `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision

_export({
  target: 'Number',
  proto: true,
  forced: FORCED$8
}, {
  toPrecision: function toPrecision(precision) {
    return precision === undefined ? nativeToPrecision(thisNumberValue$1(this)) : nativeToPrecision(thisNumberValue$1(this), precision);
  }
}); // eslint-disable-next-line es/no-object-assign -- safe


var $assign = Object.assign; // eslint-disable-next-line es/no-object-defineproperty -- required for testing

var defineProperty$6 = Object.defineProperty;
var concat$2 = functionUncurryThis([].concat); // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign

var objectAssign$1 = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({
    b: 1
  }, $assign(defineProperty$6({}, 'a', {
    enumerable: true,
    get: function get() {
      defineProperty$6(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

  var A = {};
  var B = {}; // eslint-disable-next-line es/no-symbol -- safe

  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;

  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$2(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign; // `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing

_export({
  target: 'Object',
  stat: true,
  arity: 2,
  forced: Object.assign !== objectAssign$1
}, {
  assign: objectAssign$1
}); // TODO: Remove from `core-js@4`
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create


_export({
  target: 'Object',
  stat: true,
  sham: !descriptors
}, {
  create: objectCreate$1
}); // Forced replacement object prototype accessors methods


var objectPrototypeAccessorsForced = !fails(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (engineWebkitVersion && engineWebkitVersion < 535) return;
  var key = Math.random(); // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing

  __defineSetter__.call(null, key, function () {
    /* empty */
  });

  delete global$1[key];
}); // `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__

if (descriptors) {
  _export({
    target: 'Object',
    proto: true,
    forced: objectPrototypeAccessorsForced
  }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      objectDefineProperty.f(toObject$1(this), P, {
        get: aCallable(getter),
        enumerable: true,
        configurable: true
      });
    }
  });
}

var defineProperties$1 = objectDefineProperties.f; // `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe

_export({
  target: 'Object',
  stat: true,
  forced: Object.defineProperties !== defineProperties$1,
  sham: !descriptors
}, {
  defineProperties: defineProperties$1
});

var defineProperty$5 = objectDefineProperty.f; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe

_export({
  target: 'Object',
  stat: true,
  forced: Object.defineProperty !== defineProperty$5,
  sham: !descriptors
}, {
  defineProperty: defineProperty$5
}); // `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__


if (descriptors) {
  _export({
    target: 'Object',
    proto: true,
    forced: objectPrototypeAccessorsForced
  }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      objectDefineProperty.f(toObject$1(this), P, {
        set: aCallable(setter),
        enumerable: true,
        configurable: true
      });
    }
  });
}

var $propertyIsEnumerable = objectPropertyIsEnumerable.f;
var propertyIsEnumerable$2 = functionUncurryThis($propertyIsEnumerable);
var push$h = functionUncurryThis([].push); // `Object.{ entries, values }` methods implementation

var createMethod$2 = function createMethod$2(TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys$1(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;

    while (length > i) {
      key = keys[i++];

      if (!descriptors || propertyIsEnumerable$2(O, key)) {
        push$h(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }

    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$2(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$2(false)
};
var $entries = objectToArray.entries; // `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries

_export({
  target: 'Object',
  stat: true
}, {
  entries: function entries(O) {
    return $entries(O);
  }
});

var onFreeze$2 = internalMetadata.onFreeze; // eslint-disable-next-line es/no-object-freeze -- safe

var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES$8 = fails(function () {
  $freeze(1);
}); // `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$8,
  sham: !freezing
}, {
  freeze: function freeze(it) {
    return $freeze && isObject$6(it) ? $freeze(onFreeze$2(it)) : it;
  }
}); // `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries


_export({
  target: 'Object',
  stat: true
}, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, {
      AS_ENTRIES: true
    });
    return obj;
  }
});

var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var FAILS_ON_PRIMITIVES$7 = fails(function () {
  nativeGetOwnPropertyDescriptor(1);
});
var FORCED$7 = !descriptors || FAILS_ON_PRIMITIVES$7; // `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

_export({
  target: 'Object',
  stat: true,
  forced: FORCED$7,
  sham: !descriptors
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
}); // `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors


_export({
  target: 'Object',
  stat: true,
  sham: !descriptors
}, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var keys = ownKeys$1(O);
    var result = {};
    var index = 0;
    var key, descriptor;

    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }

    return result;
  }
});

var getOwnPropertyNames$2 = objectGetOwnPropertyNamesExternal.f; // eslint-disable-next-line es/no-object-getownpropertynames -- required for testing

var FAILS_ON_PRIMITIVES$6 = fails(function () {
  return !Object.getOwnPropertyNames(1);
}); // `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$6
}, {
  getOwnPropertyNames: getOwnPropertyNames$2
});

var FAILS_ON_PRIMITIVES$5 = fails(function () {
  objectGetPrototypeOf(1);
}); // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$5,
  sham: !correctPrototypeGetter
}, {
  getPrototypeOf: function getPrototypeOf(it) {
    return objectGetPrototypeOf(toObject$1(it));
  }
}); // `Object.hasOwn` method
// https://github.com/tc39/proposal-accessible-object-hasownproperty


_export({
  target: 'Object',
  stat: true
}, {
  hasOwn: hasOwnProperty_1
}); // `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe


var sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
}; // `Object.is` method
// https://tc39.es/ecma262/#sec-object.is


_export({
  target: 'Object',
  stat: true
}, {
  is: sameValue
}); // `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe


_export({
  target: 'Object',
  stat: true,
  forced: Object.isExtensible !== objectIsExtensible
}, {
  isExtensible: objectIsExtensible
}); // eslint-disable-next-line es/no-object-isfrozen -- safe


var $isFrozen = Object.isFrozen;
var FAILS_ON_PRIMITIVES$4 = fails(function () {
  $isFrozen(1);
}); // `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$4 || arrayBufferNonExtensible
}, {
  isFrozen: function isFrozen(it) {
    if (!isObject$6(it)) return true;
    if (arrayBufferNonExtensible && classofRaw(it) == 'ArrayBuffer') return true;
    return $isFrozen ? $isFrozen(it) : false;
  }
}); // eslint-disable-next-line es/no-object-issealed -- safe


var $isSealed = Object.isSealed;
var FAILS_ON_PRIMITIVES$3 = fails(function () {
  $isSealed(1);
}); // `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$3 || arrayBufferNonExtensible
}, {
  isSealed: function isSealed(it) {
    if (!isObject$6(it)) return true;
    if (arrayBufferNonExtensible && classofRaw(it) == 'ArrayBuffer') return true;
    return $isSealed ? $isSealed(it) : false;
  }
});

var FAILS_ON_PRIMITIVES$2 = fails(function () {
  objectKeys$1(1);
}); // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$2
}, {
  keys: function keys(it) {
    return objectKeys$1(toObject$1(it));
  }
});

var getOwnPropertyDescriptor$8 = objectGetOwnPropertyDescriptor.f; // `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__

if (descriptors) {
  _export({
    target: 'Object',
    proto: true,
    forced: objectPrototypeAccessorsForced
  }, {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject$1(this);
      var key = toPropertyKey(P);
      var desc;

      do {
        if (desc = getOwnPropertyDescriptor$8(O, key)) return desc.get;
      } while (O = objectGetPrototypeOf(O));
    }
  });
}

var getOwnPropertyDescriptor$7 = objectGetOwnPropertyDescriptor.f; // `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__

if (descriptors) {
  _export({
    target: 'Object',
    proto: true,
    forced: objectPrototypeAccessorsForced
  }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject$1(this);
      var key = toPropertyKey(P);
      var desc;

      do {
        if (desc = getOwnPropertyDescriptor$7(O, key)) return desc.set;
      } while (O = objectGetPrototypeOf(O));
    }
  });
}

var onFreeze$1 = internalMetadata.onFreeze; // eslint-disable-next-line es/no-object-preventextensions -- safe

var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES$1 = fails(function () {
  $preventExtensions(1);
}); // `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES$1,
  sham: !freezing
}, {
  preventExtensions: function preventExtensions(it) {
    return $preventExtensions && isObject$6(it) ? $preventExtensions(onFreeze$1(it)) : it;
  }
});

var defineBuiltInAccessor = function defineBuiltInAccessor(target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
    setter: true
  });
  return objectDefineProperty.f(target, name, descriptor);
}; // eslint-disable-next-line es/no-object-getprototypeof -- safe


var getPrototypeOf$1 = Object.getPrototypeOf; // eslint-disable-next-line es/no-object-setprototypeof -- safe

var setPrototypeOf$1 = Object.setPrototypeOf;
var ObjectPrototype$1 = Object.prototype;
var PROTO = '__proto__'; // `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__

if (descriptors && getPrototypeOf$1 && setPrototypeOf$1 && !(PROTO in ObjectPrototype$1)) try {
  defineBuiltInAccessor(ObjectPrototype$1, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf$1(toObject$1(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (!isObject$6(proto) && proto !== null || !isObject$6(O)) return;
      setPrototypeOf$1(O, proto);
    }
  });
} catch (error) {
  /* empty */
}
var onFreeze = internalMetadata.onFreeze; // eslint-disable-next-line es/no-object-seal -- safe

var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function () {
  $seal(1);
}); // `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal

_export({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES,
  sham: !freezing
}, {
  seal: function seal(it) {
    return $seal && isObject$6(it) ? $seal(onFreeze(it)) : it;
  }
}); // `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof


_export({
  target: 'Object',
  stat: true
}, {
  setPrototypeOf: objectSetPrototypeOf
}); // `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring


var objectToString$1 = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
}; // `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring

if (!toStringTagSupport) {
  defineBuiltIn(Object.prototype, 'toString', objectToString$1, {
    unsafe: true
  });
}

var $values = objectToArray.values; // `Object.values` method
// https://tc39.es/ecma262/#sec-object.values

_export({
  target: 'Object',
  stat: true
}, {
  values: function values(O) {
    return $values(O);
  }
}); // `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string


_export({
  global: true,
  forced: parseFloat != numberParseFloat
}, {
  parseFloat: numberParseFloat
}); // `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix


_export({
  global: true,
  forced: parseInt != numberParseInt
}, {
  parseInt: numberParseInt
});

var $TypeError$k = TypeError;

var validateArgumentsLength = function validateArgumentsLength(passed, required) {
  if (passed < required) throw $TypeError$k('Not enough arguments');
  return passed;
};

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);
var set$1 = global$1.setImmediate;
var clear = global$1.clearImmediate;
var process$4 = global$1.process;
var Dispatch = global$1.Dispatch;
var Function$2 = global$1.Function;
var MessageChannel = global$1.MessageChannel;
var String$1 = global$1.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$1.location;
} catch (error) {
  /* empty */
}

var run = function run(id) {
  if (hasOwnProperty_1(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function runner(id) {
  return function () {
    run(id);
  };
};

var listener = function listener(event) {
  run(event.data);
};

var post = function post(id) {
  // old engines have not location.origin
  global$1.postMessage(String$1(id), $location.protocol + '//' + $location.host);
}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$2(handler);
    var args = arraySlice$1(arguments, 1);

    queue$2[++counter] = function () {
      functionApply(fn, undefined, args);
    };

    defer(counter);
    return counter;
  };

  clear = function clearImmediate(id) {
    delete queue$2[id];
  }; // Node.js 0.8-


  if (engineIsNode) {
    defer = function defer(id) {
      process$4.nextTick(runner(id));
    }; // Sphere (JS game engine) Dispatch API

  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(runner(id));
    }; // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624

  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = functionBindContext(port.postMessage, port); // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global$1.addEventListener && isCallable(global$1.postMessage) && !global$1.importScripts && $location && $location.protocol !== 'file:' && !fails(post)) {
    defer = post;
    global$1.addEventListener('message', listener, false); // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function defer(id) {
      html$1.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    }; // Rest old browsers

  } else {
    defer = function defer(id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set$1,
  clear: clear
};
var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && global$1.Pebble !== undefined;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);
var getOwnPropertyDescriptor$6 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var MutationObserver$1 = global$1.MutationObserver || global$1.WebKitMutationObserver;
var document$2 = global$1.document;
var process$3 = global$1.process;
var Promise$6 = global$1.Promise; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

var queueMicrotaskDescriptor = getOwnPropertyDescriptor$6(global$1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var flush, head, last, notify$1, toggle, node$1, promise, then; // modern engines have queueMicrotask method

if (!queueMicrotask) {
  flush = function flush() {
    var parent, fn;
    if (engineIsNode && (parent = process$3.domain)) parent.exit();

    while (head) {
      fn = head.fn;
      head = head.next;

      try {
        fn();
      } catch (error) {
        if (head) notify$1();else last = undefined;
        throw error;
      }
    }

    last = undefined;
    if (parent) parent.enter();
  }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898


  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver$1 && document$2) {
    toggle = true;
    node$1 = document$2.createTextNode('');
    new MutationObserver$1(flush).observe(node$1, {
      characterData: true
    });

    notify$1 = function notify$1() {
      node$1.data = toggle = !toggle;
    }; // environments with maybe non-completely correct, but existent Promise

  } else if (!engineIsIosPebble && Promise$6 && Promise$6.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$6.resolve(undefined); // workaround of WebKit ~ iOS Safari 10.1 bug

    promise.constructor = Promise$6;
    then = functionBindContext(promise.then, promise);

    notify$1 = function notify$1() {
      then(flush);
    }; // Node.js without promises

  } else if (engineIsNode) {
    notify$1 = function notify$1() {
      process$3.nextTick(flush);
    }; // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessage
    // - onreadystatechange
    // - setTimeout

  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = functionBindContext(macrotask, global$1);

    notify$1 = function notify$1() {
      macrotask(flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = {
    fn: fn,
    next: undefined
  };
  if (last) last.next = task;

  if (!head) {
    head = task;
    notify$1();
  }

  last = task;
};

var hostReportErrors = function hostReportErrors(a, b) {
  var console = global$1.console;

  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function perform(exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};

var Queue = function Queue() {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function add(item) {
    var entry = {
      item: item,
      next: null
    };
    if (this.head) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
  },
  get: function get() {
    var entry = this.head;

    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};
var queue$1 = Queue;
var promiseNativeConstructor = global$1.Promise;
/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';
var engineIsBrowser = !engineIsDeno && !engineIsNode && typeof window == 'object' && typeof document == 'object';
promiseNativeConstructor && promiseNativeConstructor.prototype;
var SPECIES$1 = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable(global$1.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$5 = isForced_1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor); // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions

  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true; // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679

  if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor(function (resolve) {
      resolve(1);
    });

    var FakePromise = function FakePromise(exec) {
      exec(function () {
        /* empty */
      }, function () {
        /* empty */
      });
    };

    var constructor = promise.constructor = {};
    constructor[SPECIES$1] = FakePromise;
    SUBCLASSING = promise.then(function () {
      /* empty */
    }) instanceof FakePromise;
    if (!SUBCLASSING) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  }

  return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});
var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};
var $TypeError$j = TypeError;

var PromiseCapability = function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError$j('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
}; // `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability


var f$1 = function f$1(C) {
  return new PromiseCapability(C);
};

var newPromiseCapability$1 = {
  f: f$1
};
var task = task$1.set;
var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = promiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = promiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var setInternalState$e = internalState.set;
var NativePromisePrototype$2 = promiseNativeConstructor && promiseNativeConstructor.prototype;
var PromiseConstructor = promiseNativeConstructor;
var PromisePrototype = NativePromisePrototype$2;
var TypeError$4 = global$1.TypeError;
var document$1 = global$1.document;
var process$2 = global$1.process;
var newPromiseCapability = newPromiseCapability$1.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen; // helpers

var isThenable = function isThenable(it) {
  var then;
  return isObject$6(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function callReaction(reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;

  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }

      if (handler === true) result = value;else {
        if (domain) domain.enter();
        result = handler(value); // can throw

        if (domain) {
          domain.exit();
          exited = true;
        }
      }

      if (result === reaction.promise) {
        reject(TypeError$4('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        functionCall(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function notify(state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;

    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }

    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function dispatchEvent(name, promise, reason) {
  var event, handler;

  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$1.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };

  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$1['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function onUnhandled(state) {
  functionCall(task, global$1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;

    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$2.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function isUnhandled(state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function onHandleUnhandled(state) {
  functionCall(task, global$1, function () {
    var promise = state.facade;

    if (engineIsNode) {
      process$2.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function bind$1(fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function internalReject(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function internalResolve(state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;

  try {
    if (state.facade === value) throw TypeError$4("Promise can't be resolved itself");
    var then = isThenable(value);

    if (then) {
      microtask(function () {
        var wrapper = {
          done: false
        };

        try {
          functionCall(then, value, bind$1(internalResolve, wrapper, state), bind$1(internalReject, wrapper, state));
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({
      done: false
    }, error, state);
  }
}; // constructor polyfill


if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    functionCall(Internal, this);
    var state = getInternalPromiseState(this);

    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype; // eslint-disable-next-line no-unused-vars -- required for `.length`

  Internal = function Promise(executor) {
    setInternalState$e(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  }; // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then


  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = engineIsNode ? process$2.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapability$1.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };

  if (isCallable(promiseNativeConstructor) && NativePromisePrototype$2 !== Object.prototype) {
    nativeThen = NativePromisePrototype$2.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype$2, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          functionCall(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected); // https://github.com/zloirock/core-js/issues/640
      }, {
        unsafe: true
      });
    } // make `.constructor === Promise` work for native promise-based APIs


    try {
      delete NativePromisePrototype$2.constructor;
    } catch (error) {
      /* empty */
    } // make `instanceof Promise` work for native promise-based APIs


    if (objectSetPrototypeOf) {
      objectSetPrototypeOf(NativePromisePrototype$2, PromisePrototype);
    }
  }
}

_export({
  global: true,
  constructor: true,
  wrap: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$4
}, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  promiseNativeConstructor.all(iterable).then(undefined, function () {
    /* empty */
  });
}); // `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all

_export({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype; // `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch

_export({
  target: 'Promise',
  proto: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$2,
  real: true
}, {
  'catch': function _catch(onRejected) {
    return this.then(undefined, onRejected);
  }
}); // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`


if (isCallable(promiseNativeConstructor)) {
  var method$1 = getBuiltIn('Promise').prototype['catch'];

  if (NativePromisePrototype$1['catch'] !== method$1) {
    defineBuiltIn(NativePromisePrototype$1, 'catch', method$1, {
      unsafe: true
    });
  }
} // `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race


_export({
  target: 'Promise',
  stat: true,
  forced: promiseStaticsIncorrectIteration
}, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR; // `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject

_export({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$1
}, {
  reject: function reject(r) {
    var capability = newPromiseCapability$1.f(this);
    functionCall(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve = function promiseResolve(C, x) {
  anObject(C);
  if (isObject$6(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
getBuiltIn('Promise'); // `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve

_export({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR
}, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
}); // `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled


_export({
  target: 'Promise',
  stat: true
}, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapability$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = {
            status: 'fulfilled',
            value: value
          };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = {
            status: 'rejected',
            reason: error
          };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var PROMISE_ANY_ERROR = 'No one promise resolved'; // `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any

_export({
  target: 'Promise',
  stat: true
}, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapability$1.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        functionCall(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype; // Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829

var NON_GENERIC = !!promiseNativeConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({
    then: function then() {
      /* empty */
    }
  }, function () {
    /* empty */
  });
}); // `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally

_export({
  target: 'Promise',
  proto: true,
  real: true,
  forced: NON_GENERIC
}, {
  'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
}); // makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`


if (isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];

  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, {
      unsafe: true
    });
  }
} // MS Edge argumentsList argument is optional


var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () {
    /* empty */
  });
}); // `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply

_export({
  target: 'Reflect',
  stat: true,
  forced: OPTIONAL_ARGUMENTS_LIST
}, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push$g = [].push; // `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it

var NEW_TARGET_BUG = fails(function () {
  function F() {
    /* empty */
  }

  return !(nativeConstruct(function () {
    /* empty */
  }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () {
    /* empty */
  });
});
var FORCED$6 = NEW_TARGET_BUG || ARGS_BUG;

_export({
  target: 'Reflect',
  stat: true,
  forced: FORCED$6,
  sham: FORCED$6
}, {
  construct: function construct(Target, args
  /* , newTarget */
  ) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);

    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0:
          return new Target();

        case 1:
          return new Target(args[0]);

        case 2:
          return new Target(args[0], args[1]);

        case 3:
          return new Target(args[0], args[1], args[2]);

        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      } // w/o altered newTarget, lot of arguments case


      var $args = [null];
      functionApply(push$g, $args, args);
      return new (functionApply(functionBind, Target, $args))();
    } // with altered newTarget, not support built-in constructors


    var proto = newTarget.prototype;
    var instance = objectCreate$1(isObject$6(proto) ? proto : ObjectPrototype);
    var result = functionApply(Target, instance, args);
    return isObject$6(result) ? result : instance;
  }
}); // MS Edge has broken Reflect.defineProperty - throwing instead of returning false


var ERROR_INSTEAD_OF_FALSE = fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.defineProperty(objectDefineProperty.f({}, 1, {
    value: 1
  }), 1, {
    value: 2
  });
}); // `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty

_export({
  target: 'Reflect',
  stat: true,
  forced: ERROR_INSTEAD_OF_FALSE,
  sham: !descriptors
}, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPropertyKey(propertyKey);
    anObject(attributes);

    try {
      objectDefineProperty.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});

var getOwnPropertyDescriptor$5 = objectGetOwnPropertyDescriptor.f; // `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty

_export({
  target: 'Reflect',
  stat: true
}, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor$5(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});

var isDataDescriptor = function isDataDescriptor(descriptor) {
  return descriptor !== undefined && (hasOwnProperty_1(descriptor, 'value') || hasOwnProperty_1(descriptor, 'writable'));
}; // `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get


function get(target, propertyKey
/* , receiver */
) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = objectGetOwnPropertyDescriptor.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : functionCall(descriptor.get, receiver);
  if (isObject$6(prototype = objectGetPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

_export({
  target: 'Reflect',
  stat: true
}, {
  get: get
}); // `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor


_export({
  target: 'Reflect',
  stat: true,
  sham: !descriptors
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return objectGetOwnPropertyDescriptor.f(anObject(target), propertyKey);
  }
}); // `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof


_export({
  target: 'Reflect',
  stat: true,
  sham: !correctPrototypeGetter
}, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
}); // `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has


_export({
  target: 'Reflect',
  stat: true
}, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
}); // `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible


_export({
  target: 'Reflect',
  stat: true
}, {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return objectIsExtensible(target);
  }
}); // `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys


_export({
  target: 'Reflect',
  stat: true
}, {
  ownKeys: ownKeys$1
}); // `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions


_export({
  target: 'Reflect',
  stat: true,
  sham: !freezing
}, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);

    try {
      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
}); // `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set


function set(target, propertyKey, V
/* , receiver */
) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = objectGetOwnPropertyDescriptor.f(anObject(target), propertyKey);
  var existingDescriptor, prototype, setter;

  if (!ownDescriptor) {
    if (isObject$6(prototype = objectGetPrototypeOf(target))) {
      return set(prototype, propertyKey, V, receiver);
    }

    ownDescriptor = createPropertyDescriptor(0);
  }

  if (isDataDescriptor(ownDescriptor)) {
    if (ownDescriptor.writable === false || !isObject$6(receiver)) return false;

    if (existingDescriptor = objectGetOwnPropertyDescriptor.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      objectDefineProperty.f(receiver, propertyKey, existingDescriptor);
    } else objectDefineProperty.f(receiver, propertyKey, createPropertyDescriptor(0, V));
  } else {
    setter = ownDescriptor.set;
    if (setter === undefined) return false;
    functionCall(setter, receiver, V);
  }

  return true;
} // MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype


var MS_EDGE_BUG = fails(function () {
  var Constructor = function Constructor() {
    /* empty */
  };

  var object = objectDefineProperty.f(new Constructor(), 'a', {
    configurable: true
  }); // eslint-disable-next-line es/no-reflect -- required for testing

  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});

_export({
  target: 'Reflect',
  stat: true,
  forced: MS_EDGE_BUG
}, {
  set: set
}); // `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof


if (objectSetPrototypeOf) _export({
  target: 'Reflect',
  stat: true
}, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject(target);
    aPossiblePrototype(proto);

    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});

_export({
  global: true
}, {
  Reflect: {}
}); // Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag


setToStringTag(global$1.Reflect, 'Reflect', true);
var MATCH$2 = wellKnownSymbol('match'); // `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp

var isRegexp = function isRegexp(it) {
  var isRegExp;
  return isObject$6(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
}; // `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags


var regexpFlags = function regexpFlags() {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var RegExpPrototype$7 = RegExp.prototype;

var regexpGetFlags = function regexpGetFlags(R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$7) && !hasOwnProperty_1(R, 'flags') && objectIsPrototypeOf(RegExpPrototype$7, R) ? functionCall(regexpFlags, R) : flags;
}; // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError


var $RegExp$2 = global$1.RegExp;
var UNSUPPORTED_Y$3 = fails(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
}); // UC Browser bug
// https://github.com/zloirock/core-js/issues/1008

var MISSED_STICKY$2 = UNSUPPORTED_Y$3 || fails(function () {
  return !$RegExp$2('a', 'y').sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y$3 || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});
var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$2,
  UNSUPPORTED_Y: UNSUPPORTED_Y$3
}; // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError

var $RegExp$1 = global$1.RegExp;
var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
}); // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError

var $RegExp = global$1.RegExp;
var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var enforceInternalState$1 = internalState.enforce;
var MATCH$1 = wellKnownSymbol('match');
var NativeRegExp = global$1.RegExp;
var RegExpPrototype$6 = NativeRegExp.prototype;
var SyntaxError$2 = global$1.SyntaxError;
var exec$7 = functionUncurryThis(RegExpPrototype$6.exec);
var charAt$e = functionUncurryThis(''.charAt);
var replace$8 = functionUncurryThis(''.replace);
var stringIndexOf$4 = functionUncurryThis(''.indexOf);
var stringSlice$c = functionUncurryThis(''.slice); // TODO: Use only proper RegExpIdentifierName

var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g; // "new" should create a new object, old webkit bug

var CORRECT_NEW = new NativeRegExp(re1) !== re1;
var MISSED_STICKY$1 = regexpStickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;
var BASE_FORCED = descriptors && (!CORRECT_NEW || MISSED_STICKY$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg || fails(function () {
  re2[MATCH$1] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
}));

var handleDotAll = function handleDotAll(string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;

  for (; index <= length; index++) {
    chr = charAt$e(string, index);

    if (chr === '\\') {
      result += chr + charAt$e(string, ++index);
      continue;
    }

    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      }

      result += chr;
    }
  }

  return result;
};

var handleNCG = function handleNCG(string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;

  for (; index <= length; index++) {
    chr = charAt$e(string, index);

    if (chr === '\\') {
      chr = chr + charAt$e(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;

      case chr === '(':
        if (exec$7(IS_NCG, stringSlice$c(string, index + 1))) {
          index += 2;
          ncg = true;
        }

        result += chr;
        groupid++;
        continue;

      case chr === '>' && ncg:
        if (groupname === '' || hasOwnProperty_1(names, groupname)) {
          throw new SyntaxError$2('Invalid capture group name');
        }

        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }

    if (ncg) groupname += chr;else result += chr;
  }

  return [result, named];
}; // `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor


if (isForced_1('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = objectIsPrototypeOf(RegExpPrototype$6, this);
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || objectIsPrototypeOf(RegExpPrototype$6, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = regexpGetFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$2(pattern);
    flags = flags === undefined ? '' : toString$2(flags);
    rawPattern = pattern;

    if (regexpUnsupportedDotAll && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$4(flags, 's') > -1;
      if (dotAll) flags = replace$8(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY$1 && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$4(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$2) flags = replace$8(flags, /y/g, '');
    }

    if (regexpUnsupportedNcg) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$6, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState$1(result);

      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }

      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) {
      /* empty */
    }
    return result;
  };

  for (var keys$1 = getOwnPropertyNames$1(NativeRegExp), index$3 = 0; keys$1.length > index$3;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$1[index$3++]);
  }

  RegExpPrototype$6.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$6;
  defineBuiltIn(global$1, 'RegExp', RegExpWrapper, {
    constructor: true
  });
} // https://tc39.es/ecma262/#sec-get-regexp-@@species


setSpecies('RegExp');
var getInternalState$a = internalState.get;
var RegExpPrototype$5 = RegExp.prototype;
var $TypeError$i = TypeError; // `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall

if (descriptors && regexpUnsupportedDotAll) {
  defineBuiltInAccessor(RegExpPrototype$5, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype$5) return undefined; // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.

      if (classofRaw(this) === 'RegExp') {
        return !!getInternalState$a(this).dotAll;
      }

      throw $TypeError$i('Incompatible receiver, RegExp required');
    }
  });
}
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */

/* eslint-disable regexp/no-useless-quantifier -- testing */


var getInternalState$9 = internalState.get;
var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$d = functionUncurryThis(''.charAt);
var indexOf$1 = functionUncurryThis(''.indexOf);
var replace$7 = functionUncurryThis(''.replace);
var stringSlice$b = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET; // nonparticipating capturing group, copied from es5-shim's String#split patch.

var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$9(re);
    var str = toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$7(flags, 'y', '');

      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$b(str, re.lastIndex); // Support anchored sticky behavior.

      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$d(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      } // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.


      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }

    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$b(match.input, charsAdded);
        match[0] = stringSlice$b(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }

    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate$1(null);

      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec; // `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec

_export({
  target: 'RegExp',
  proto: true,
  forced: /./.exec !== regexpExec
}, {
  exec: regexpExec
}); // babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError


var RegExp$2 = global$1.RegExp;
var RegExpPrototype$4 = RegExp$2.prototype;
var FORCED$5 = descriptors && fails(function () {
  var INDICES_SUPPORT = true;

  try {
    RegExp$2('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {}; // modern V8 bug

  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function addGetter(key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, {
      get: function get() {
        calls += chr;
        return true;
      }
    });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };
  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) {
    addGetter(key, pairs[key]);
  } // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe


  var result = Object.getOwnPropertyDescriptor(RegExpPrototype$4, 'flags').get.call(O);
  return result !== expected || calls !== expected;
}); // `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags

if (FORCED$5) defineBuiltInAccessor(RegExpPrototype$4, 'flags', {
  configurable: true,
  get: regexpFlags
});
var MISSED_STICKY = regexpStickyHelpers.MISSED_STICKY;
var getInternalState$8 = internalState.get;
var RegExpPrototype$3 = RegExp.prototype;
var $TypeError$h = TypeError; // `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky

if (descriptors && MISSED_STICKY) {
  defineBuiltInAccessor(RegExpPrototype$3, 'sticky', {
    configurable: true,
    get: function sticky() {
      if (this === RegExpPrototype$3) return undefined; // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.

      if (classofRaw(this) === 'RegExp') {
        return !!getInternalState$8(this).sticky;
      }

      throw $TypeError$h('Incompatible receiver, RegExp required');
    }
  });
} // TODO: Remove from `core-js@4` since it's moved to entry points


var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;

  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };

  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test; // `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test

_export({
  target: 'RegExp',
  proto: true,
  forced: !DELEGATES_TO_EXEC
}, {
  test: function test(S) {
    var R = anObject(this);
    var string = toString$2(S);
    var exec = R.exec;
    if (!isCallable(exec)) return functionCall(nativeTest, R, string);
    var result = functionCall(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var TO_STRING = 'toString';
var RegExpPrototype$2 = RegExp.prototype;
var nativeToString = RegExpPrototype$2[TO_STRING];
var NOT_GENERIC = fails(function () {
  return nativeToString.call({
    source: 'a',
    flags: 'b'
  }) != '/a/b';
}); // FF44- RegExp#toString has a wrong name

var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name != TO_STRING; // `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring

if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = toString$2(R.source);
    var flags = toString$2(regexpGetFlags(R));
    return '/' + pattern + '/' + flags;
  }, {
    unsafe: true
  });
} // `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects


collection('Set', function (init) {
  return function Set() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);
var charAt$c = functionUncurryThis(''.charAt);
var FORCED$4 = fails(function () {
  // eslint-disable-next-line es/no-array-string-prototype-at -- safe
  return '𠮷'.at(-2) !== "\uD842";
}); // `String.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method

_export({
  target: 'String',
  proto: true,
  forced: FORCED$4
}, {
  at: function at(index) {
    var S = toString$2(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : charAt$c(S, k);
  }
});

var charAt$b = functionUncurryThis(''.charAt);
var charCodeAt$2 = functionUncurryThis(''.charCodeAt);
var stringSlice$a = functionUncurryThis(''.slice);

var createMethod$1 = function createMethod$1(CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$2(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$2(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$2(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$b(S, position) : first : CONVERT_TO_STRING ? stringSlice$a(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};
var codeAt$2 = stringMultibyte.codeAt; // `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat

_export({
  target: 'String',
  proto: true
}, {
  codePointAt: function codePointAt(pos) {
    return codeAt$2(this, pos);
  }
});

var $TypeError$g = TypeError;

var notARegexp = function notARegexp(it) {
  if (isRegexp(it)) {
    throw $TypeError$g("The method doesn't accept regular expressions");
  }

  return it;
};

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function correctIsRegexpLogic(METHOD_NAME) {
  var regexp = /./;

  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) {
      /* empty */
    }
  }

  return false;
};

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f; // eslint-disable-next-line es/no-string-prototype-endswith -- safe

var nativeEndsWith = functionUncurryThis(''.endsWith);
var slice$2 = functionUncurryThis(''.slice);
var min$7 = Math.min;
var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegexpLogic('endsWith'); // https://github.com/zloirock/core-js/pull/702

var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$4(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}(); // `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith

_export({
  target: 'String',
  proto: true,
  forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1
}, {
  endsWith: function endsWith(searchString
  /* , endPosition = @length */
  ) {
    var that = toString$2(requireObjectCoercible(this));
    notARegexp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min$7(toLength(endPosition), len);
    var search = toString$2(searchString);
    return nativeEndsWith ? nativeEndsWith(that, search, end) : slice$2(that, end - search.length, end) === search;
  }
});

var $RangeError$7 = RangeError;
var fromCharCode$3 = String.fromCharCode; // eslint-disable-next-line es/no-string-fromcodepoint -- required for testing

var $fromCodePoint = String.fromCodePoint;
var join$6 = functionUncurryThis([].join); // length should be 1, old FF problem

var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1; // `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint

_export({
  target: 'String',
  stat: true,
  arity: 1,
  forced: INCORRECT_LENGTH
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;

    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw $RangeError$7(code + ' is not a valid code point');
      elements[i] = code < 0x10000 ? fromCharCode$3(code) : fromCharCode$3(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    }

    return join$6(elements, '');
  }
});

var stringIndexOf$3 = functionUncurryThis(''.indexOf); // `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes

_export({
  target: 'String',
  proto: true,
  forced: !correctIsRegexpLogic('includes')
}, {
  includes: function includes(searchString
  /* , position = 0 */
  ) {
    return !!~stringIndexOf$3(toString$2(requireObjectCoercible(this)), toString$2(notARegexp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var charAt$a = stringMultibyte.charAt;
var STRING_ITERATOR$1 = 'String Iterator';
var setInternalState$d = internalState.set;
var getInternalState$7 = internalState.getterFor(STRING_ITERATOR$1); // `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator

iteratorDefine(String, 'String', function (iterated) {
  setInternalState$d(this, {
    type: STRING_ITERATOR$1,
    string: toString$2(iterated),
    index: 0
  }); // `%StringIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$7(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt$a(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
}); // TODO: Remove from `core-js@4` since it's moved to entry points

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype$1 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function fixRegexpWellKnownSymbolLogic(KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);
  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};

    O[SYMBOL] = function () {
      return 7;
    };

    return ''[KEY](O) != 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.

      re.constructor = {};

      re.constructor[SPECIES] = function () {
        return re;
      };

      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
    var uncurriedNativeRegExpMethod = functionUncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThis(nativeMethod);
      var $exec = regexp.exec;

      if ($exec === regexpExec || $exec === RegExpPrototype$1.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: uncurriedNativeRegExpMethod(regexp, str, arg2)
          };
        }

        return {
          done: true,
          value: uncurriedNativeMethod(str, regexp, arg2)
        };
      }

      return {
        done: false
      };
    });
    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype$1, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype$1[SYMBOL], 'sham', true);
};

var charAt$9 = stringMultibyte.charAt; // `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex

var advanceStringIndex = function advanceStringIndex(S, index, unicode) {
  return index + (unicode ? charAt$9(S, index).length : 1);
};

var $TypeError$f = TypeError; // `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec

var regexpExecAbstract = function regexpExecAbstract(R, S) {
  var exec = R.exec;

  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }

  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw $TypeError$f('RegExp#exec called on incompatible receiver');
}; // @@match logic


fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [// `String.prototype.match` method
  // https://tc39.es/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = requireObjectCoercible(this);
    var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
    return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$2(O));
  }, // `RegExp.prototype[@@match]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
  function (string) {
    var rx = anObject(this);
    var S = toString$2(string);
    var res = maybeCallNative(nativeMatch, rx, S);
    if (res.done) return res.value;
    if (!rx.global) return regexpExecAbstract(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;

    while ((result = regexpExecAbstract(rx, S)) !== null) {
      var matchStr = toString$2(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      n++;
    }

    return n === 0 ? null : A;
  }];
});
/* eslint-disable es/no-string-prototype-matchall -- safe */

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState$c = internalState.set;
var getInternalState$6 = internalState.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var $TypeError$e = TypeError;
var stringIndexOf$2 = functionUncurryThis(''.indexOf);
var nativeMatchAll = functionUncurryThis(''.matchAll);
var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  nativeMatchAll('a', /./);
});
var $RegExpStringIterator = iteratorCreateConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
  setInternalState$c(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: $global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState$6(this);
  if (state.done) return createIterResultObject(undefined, true);
  var R = state.regexp;
  var S = state.string;
  var match = regexpExecAbstract(R, S);

  if (match === null) {
    state.done = true;
    return createIterResultObject(undefined, true);
  }

  if (state.global) {
    if (toString$2(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return createIterResultObject(match, false);
  }

  state.done = true;
  return createIterResultObject(match, false);
});

var $matchAll = function $matchAll(string) {
  var R = anObject(this);
  var S = toString$2(string);
  var C = speciesConstructor(R, RegExp);
  var flags = toString$2(regexpGetFlags(R));
  var matcher, $global, fullUnicode;
  matcher = new C(C === RegExp ? R.source : R, flags);
  $global = !!~stringIndexOf$2(flags, 'g');
  fullUnicode = !!~stringIndexOf$2(flags, 'u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
}; // `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall


_export({
  target: 'String',
  proto: true,
  forced: WORKS_WITH_NON_GLOBAL_REGEX
}, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;

    if (!isNullOrUndefined(regexp)) {
      if (isRegexp(regexp)) {
        flags = toString$2(requireObjectCoercible(regexpGetFlags(regexp)));
        if (!~stringIndexOf$2(flags, 'g')) throw $TypeError$e('`.matchAll` does not allow non-global regexes');
      }

      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && isPure && classofRaw(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher) return functionCall(matcher, regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);

    S = toString$2(O);
    rx = new RegExp(regexp, 'g');
    return rx[MATCH_ALL](S);
  }
});

MATCH_ALL in RegExpPrototype || defineBuiltIn(RegExpPrototype, MATCH_ALL, $matchAll); // https://github.com/zloirock/core-js/issues/280

var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(engineUserAgent);
var $padEnd = stringPad.end; // `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend

_export({
  target: 'String',
  proto: true,
  forced: stringPadWebkitBug
}, {
  padEnd: function padEnd(maxLength
  /* , fillString = ' ' */
  ) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $padStart = stringPad.start; // `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart

_export({
  target: 'String',
  proto: true,
  forced: stringPadWebkitBug
}, {
  padStart: function padStart(maxLength
  /* , fillString = ' ' */
  ) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var push$f = functionUncurryThis([].push);
var join$5 = functionUncurryThis([].join); // `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw

_export({
  target: 'String',
  stat: true
}, {
  raw: function raw(template) {
    var rawTemplate = toIndexedObject(toObject$1(template).raw);
    var literalSegments = lengthOfArrayLike(rawTemplate);
    var argumentsLength = arguments.length;
    var elements = [];
    var i = 0;

    while (literalSegments > i) {
      push$f(elements, toString$2(rawTemplate[i++]));
      if (i === literalSegments) return join$5(elements, '');
      if (i < argumentsLength) push$f(elements, toString$2(arguments[i]));
    }
  }
}); // `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat


_export({
  target: 'String',
  proto: true
}, {
  repeat: stringRepeat
});

var floor$3 = Math.floor;
var charAt$8 = functionUncurryThis(''.charAt);
var replace$6 = functionUncurryThis(''.replace);
var stringSlice$9 = functionUncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g; // `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution

var getSubstitution = function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }

  return replace$6(replacement, symbols, function (match, ch) {
    var capture;

    switch (charAt$8(ch, 0)) {
      case '$':
        return '$';

      case '&':
        return matched;

      case '`':
        return stringSlice$9(str, 0, position);

      case "'":
        return stringSlice$9(str, tailPos);

      case '<':
        capture = namedCaptures[stringSlice$9(ch, 1, -1)];
        break;

      default:
        // \d\d?
        var n = +ch;
        if (n === 0) return match;

        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$8(ch, 1) : captures[f - 1] + charAt$8(ch, 1);
          return match;
        }

        capture = captures[n - 1];
    }

    return capture === undefined ? '' : capture;
  });
};

var REPLACE$1 = wellKnownSymbol('replace');
var max$5 = Math.max;
var min$6 = Math.min;
var concat$1 = functionUncurryThis([].concat);
var push$e = functionUncurryThis([].push);
var stringIndexOf$1 = functionUncurryThis(''.indexOf);
var stringSlice$8 = functionUncurryThis(''.slice);

var maybeToString = function maybeToString(it) {
  return it === undefined ? it : String(it);
}; // IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0


var REPLACE_KEEPS_$0 = function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
}(); // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string


var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
  if (/./[REPLACE$1]) {
    return /./[REPLACE$1]('a', '$0') === '';
  }

  return false;
}();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;

  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  }; // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive


  return ''.replace(re, '$<a>') !== '7';
}); // @@replace logic

fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
  return [// `String.prototype.replace` method
  // https://tc39.es/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE$1);
    return replacer ? functionCall(replacer, searchValue, O, replaceValue) : functionCall(nativeReplace, toString$2(O), searchValue, replaceValue);
  }, // `RegExp.prototype[@@replace]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
  function (string, replaceValue) {
    var rx = anObject(this);
    var S = toString$2(string);

    if (typeof replaceValue == 'string' && stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf$1(replaceValue, '$<') === -1) {
      var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
      if (res.done) return res.value;
    }

    var functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString$2(replaceValue);
    var global = rx.global;

    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }

    var results = [];

    while (true) {
      var result = regexpExecAbstract(rx, S);
      if (result === null) break;
      push$e(results, result);
      if (!global) break;
      var matchStr = toString$2(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }

    var accumulatedResult = '';
    var nextSourcePosition = 0;

    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = toString$2(result[0]);
      var position = max$5(min$6(toIntegerOrInfinity(result.index), S.length), 0);
      var captures = []; // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

      for (var j = 1; j < result.length; j++) {
        push$e(captures, maybeToString(result[j]));
      }

      var namedCaptures = result.groups;

      if (functionalReplace) {
        var replacerArgs = concat$1([matched], captures, position, S);
        if (namedCaptures !== undefined) push$e(replacerArgs, namedCaptures);
        var replacement = toString$2(functionApply(replaceValue, undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }

      if (position >= nextSourcePosition) {
        accumulatedResult += stringSlice$8(S, nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }

    return accumulatedResult + stringSlice$8(S, nextSourcePosition);
  }];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
var REPLACE = wellKnownSymbol('replace');
var $TypeError$d = TypeError;
var indexOf = functionUncurryThis(''.indexOf);
functionUncurryThis(''.replace);
var stringSlice$7 = functionUncurryThis(''.slice);
var max$4 = Math.max;

var stringIndexOf = function stringIndexOf(string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
}; // `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall


_export({
  target: 'String',
  proto: true
}, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';

    if (!isNullOrUndefined(searchValue)) {
      IS_REG_EXP = isRegexp(searchValue);

      if (IS_REG_EXP) {
        flags = toString$2(requireObjectCoercible(regexpGetFlags(searchValue)));
        if (!~indexOf(flags, 'g')) throw $TypeError$d('`.replaceAll` does not allow non-global regexes');
      }

      replacer = getMethod(searchValue, REPLACE);

      if (replacer) {
        return functionCall(replacer, searchValue, O, replaceValue);
      }
    }

    string = toString$2(O);
    searchString = toString$2(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString$2(replaceValue);
    searchLength = searchString.length;
    advanceBy = max$4(1, searchLength);
    position = stringIndexOf(string, searchString, 0);

    while (position !== -1) {
      replacement = functionalReplace ? toString$2(replaceValue(searchString, position, string)) : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice$7(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }

    if (endOfLastMatch < string.length) {
      result += stringSlice$7(string, endOfLastMatch);
    }

    return result;
  }
}); // @@search logic


fixRegexpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [// `String.prototype.search` method
  // https://tc39.es/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = requireObjectCoercible(this);
    var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
    return searcher ? functionCall(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$2(O));
  }, // `RegExp.prototype[@@search]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
  function (string) {
    var rx = anObject(this);
    var S = toString$2(string);
    var res = maybeCallNative(nativeSearch, rx, S);
    if (res.done) return res.value;
    var previousLastIndex = rx.lastIndex;
    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
    var result = regexpExecAbstract(rx, S);
    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
});
var UNSUPPORTED_Y = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$5 = Math.min;
var $push = [].push;
var exec$6 = functionUncurryThis(/./.exec);
var push$d = functionUncurryThis($push);
var stringSlice$6 = functionUncurryThis(''.slice); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;

  re.exec = function () {
    return originalExec.apply(this, arguments);
  };

  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
}); // @@split logic

fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;

  if ('abbc'.split(/(b)*/)[1] == 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
      var string = toString$2(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

      if (!isRegexp(separator)) {
        return functionCall(nativeSplit, string, separator, lim);
      }

      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;

      while (match = functionCall(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;

        if (lastIndex > lastLastIndex) {
          push$d(output, stringSlice$6(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply($push, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }

        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }

      if (lastLastIndex === string.length) {
        if (lastLength || !exec$6(separatorCopy, '')) push$d(output, '');
      } else push$d(output, stringSlice$6(string, lastLastIndex));

      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    }; // Chakra, V8

  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function internalSplit(separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [// `String.prototype.split` method
  // https://tc39.es/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = requireObjectCoercible(this);
    var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
    return splitter ? functionCall(splitter, separator, O, limit) : functionCall(internalSplit, toString$2(O), separator, limit);
  }, // `RegExp.prototype[@@split]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (string, limit) {
    var rx = anObject(this);
    var S = toString$2(string);
    var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
    if (res.done) return res.value;
    var C = speciesConstructor(rx, RegExp);
    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y'); // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.

    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];

    while (q < S.length) {
      splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
      var z = regexpExecAbstract(splitter, UNSUPPORTED_Y ? stringSlice$6(S, q) : S);
      var e;

      if (z === null || (e = min$5(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        push$d(A, stringSlice$6(S, p, q));
        if (A.length === lim) return A;

        for (var i = 1; i <= z.length - 1; i++) {
          push$d(A, z[i]);
          if (A.length === lim) return A;
        }

        q = p = e;
      }
    }

    push$d(A, stringSlice$6(S, p));
    return A;
  }];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f; // eslint-disable-next-line es/no-string-prototype-startswith -- safe

var nativeStartsWith = functionUncurryThis(''.startsWith);
var stringSlice$5 = functionUncurryThis(''.slice);
var min$4 = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith'); // https://github.com/zloirock/core-js/pull/702

var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$3(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}(); // `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith

_export({
  target: 'String',
  proto: true,
  forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
  startsWith: function startsWith(searchString
  /* , position = 0 */
  ) {
    var that = toString$2(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$4(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$2(searchString);
    return nativeStartsWith ? nativeStartsWith(that, search, index) : stringSlice$5(that, index, index + search.length) === search;
  }
});

var stringSlice$4 = functionUncurryThis(''.slice);
var max$3 = Math.max;
var min$3 = Math.min; // eslint-disable-next-line unicorn/prefer-string-slice, es/no-string-prototype-substr -- required for testing

var FORCED$3 = !''.substr || 'ab'.substr(-1) !== 'b'; // `String.prototype.substr` method
// https://tc39.es/ecma262/#sec-string.prototype.substr

_export({
  target: 'String',
  proto: true,
  forced: FORCED$3
}, {
  substr: function substr(start, length) {
    var that = toString$2(requireObjectCoercible(this));
    var size = that.length;
    var intStart = toIntegerOrInfinity(start);
    var intLength, intEnd;
    if (intStart === Infinity) intStart = 0;
    if (intStart < 0) intStart = max$3(size + intStart, 0);
    intLength = length === undefined ? size : toIntegerOrInfinity(length);
    if (intLength <= 0 || intLength === Infinity) return '';
    intEnd = min$3(intStart + intLength, size);
    return intStart >= intEnd ? '' : stringSlice$4(that, intStart, intEnd);
  }
});

var PROPER_FUNCTION_NAME = functionName.PROPER;
var non = "\u200B\x85\u180E"; // check that a method works with the correct list
// of whitespaces and has a correct name

var stringTrimForced = function stringTrimForced(METHOD_NAME) {
  return fails(function () {
    return !!whitespaces$1[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces$1[METHOD_NAME].name !== METHOD_NAME;
  });
};

var $trim = stringTrim.trim; // `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim

_export({
  target: 'String',
  proto: true,
  forced: stringTrimForced('trim')
}, {
  trim: function trim() {
    return $trim(this);
  }
});

var $trimEnd = stringTrim.end; // `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright

var stringTrimEnd = stringTrimForced('trimEnd') ? function trimEnd() {
  return $trimEnd(this); // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd; // `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe

_export({
  target: 'String',
  proto: true,
  name: 'trimEnd',
  forced: ''.trimRight !== stringTrimEnd
}, {
  trimRight: stringTrimEnd
}); // TODO: Remove this line from `core-js@4`
// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe


_export({
  target: 'String',
  proto: true,
  name: 'trimEnd',
  forced: ''.trimEnd !== stringTrimEnd
}, {
  trimEnd: stringTrimEnd
});

var $trimStart = stringTrim.start; // `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft

var stringTrimStart = stringTrimForced('trimStart') ? function trimStart() {
  return $trimStart(this); // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart; // `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe

_export({
  target: 'String',
  proto: true,
  name: 'trimStart',
  forced: ''.trimLeft !== stringTrimStart
}, {
  trimLeft: stringTrimStart
}); // TODO: Remove this line from `core-js@4`
// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe


_export({
  target: 'String',
  proto: true,
  name: 'trimStart',
  forced: ''.trimStart !== stringTrimStart
}, {
  trimStart: stringTrimStart
});

var quot = /"/g;
var replace$5 = functionUncurryThis(''.replace); // `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml

var createHtml = function createHtml(string, tag, attribute, value) {
  var S = toString$2(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace$5(toString$2(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
}; // check the existence of a method, lowercase
// of a tag and escaping quotes in arguments


var stringHtmlForced = function stringHtmlForced(METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
}; // `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('anchor')
}, {
  anchor: function anchor(name) {
    return createHtml(this, 'a', 'name', name);
  }
}); // `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('big')
}, {
  big: function big() {
    return createHtml(this, 'big', '', '');
  }
}); // `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('blink')
}, {
  blink: function blink() {
    return createHtml(this, 'blink', '', '');
  }
}); // `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('bold')
}, {
  bold: function bold() {
    return createHtml(this, 'b', '', '');
  }
}); // `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('fixed')
}, {
  fixed: function fixed() {
    return createHtml(this, 'tt', '', '');
  }
}); // `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('fontcolor')
}, {
  fontcolor: function fontcolor(color) {
    return createHtml(this, 'font', 'color', color);
  }
}); // `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('fontsize')
}, {
  fontsize: function fontsize(size) {
    return createHtml(this, 'font', 'size', size);
  }
}); // `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('italics')
}, {
  italics: function italics() {
    return createHtml(this, 'i', '', '');
  }
}); // `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('link')
}, {
  link: function link(url) {
    return createHtml(this, 'a', 'href', url);
  }
}); // `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('small')
}, {
  small: function small() {
    return createHtml(this, 'small', '', '');
  }
}); // `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('strike')
}, {
  strike: function strike() {
    return createHtml(this, 'strike', '', '');
  }
}); // `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('sub')
}, {
  sub: function sub() {
    return createHtml(this, 'sub', '', '');
  }
}); // `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup


_export({
  target: 'String',
  proto: true,
  forced: stringHtmlForced('sup')
}, {
  sup: function sup() {
    return createHtml(this, 'sup', '', '');
  }
});
/* eslint-disable no-new -- required for testing */


var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var ArrayBuffer$1 = global$1.ArrayBuffer;
var Int8Array$3 = global$1.Int8Array;
var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array$3(1);
}) || !fails(function () {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$3(new ArrayBuffer$1(2), 1, undefined).length !== 1;
});
var $RangeError$6 = RangeError;

var toPositiveInteger = function toPositiveInteger(it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError$6("The argument can't be less than 0");
  return result;
};

var $RangeError$5 = RangeError;

var toOffset = function toOffset(it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError$5('Wrong offset');
  return offset;
};

var slice$1 = functionUncurryThis(''.slice);

var isBigIntArray = function isBigIntArray(it) {
  return slice$1(classof(it), 0, 3) === 'Big';
};

var $TypeError$c = TypeError; // `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint

var toBigInt = function toBigInt(argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError$c("Can't convert number to bigint"); // eslint-disable-next-line es/no-bigint -- safe

  return BigInt(prim);
};

var aTypedArrayConstructor$3 = arrayBufferViewCore.aTypedArrayConstructor;

var typedArrayFrom = function from(source
/* , mapfn, thisArg */
) {
  var C = aConstructor(this);
  var O = toObject$1(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;

  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];

    while (!(step = functionCall(next, iterator)).done) {
      O.push(step.value);
    }
  }

  if (mapping && argumentsLength > 2) {
    mapfn = functionBindContext(mapfn, arguments[2]);
  }

  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor$3(C))(length);
  thisIsBigIntArray = isBigIntArray(result);

  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i]; // FF30- typed arrays doesn't properly convert objects to typed array values

    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }

  return result;
};

var typedArrayConstructor = createCommonjsModule(function (module) {
  var getOwnPropertyNames = objectGetOwnPropertyNames.f;
  var forEach = arrayIteration.forEach;
  var getInternalState = internalState.get;
  var setInternalState = internalState.set;
  var enforceInternalState = internalState.enforce;
  var nativeDefineProperty = objectDefineProperty.f;
  var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  var round = Math.round;
  var RangeError = global$1.RangeError;
  var ArrayBuffer = arrayBuffer.ArrayBuffer;
  var ArrayBufferPrototype = ArrayBuffer.prototype;
  var DataView = arrayBuffer.DataView;
  var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
  var TYPED_ARRAY_TAG = arrayBufferViewCore.TYPED_ARRAY_TAG;
  var TypedArray = arrayBufferViewCore.TypedArray;
  var TypedArrayPrototype = arrayBufferViewCore.TypedArrayPrototype;
  var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
  var isTypedArray = arrayBufferViewCore.isTypedArray;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var WRONG_LENGTH = 'Wrong length';

  var fromList = function fromList(C, list) {
    aTypedArrayConstructor(C);
    var index = 0;
    var length = list.length;
    var result = new C(length);

    while (length > index) {
      result[index] = list[index++];
    }

    return result;
  };

  var addGetter = function addGetter(it, key) {
    nativeDefineProperty(it, key, {
      get: function get() {
        return getInternalState(this)[key];
      }
    });
  };

  var isArrayBuffer = function isArrayBuffer(it) {
    var klass;
    return objectIsPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
  };

  var isTypedArrayIndex = function isTypedArrayIndex(target, key) {
    return isTypedArray(target) && !isSymbol$1(key) && key in target && isIntegralNumber(+key) && key >= 0;
  };

  var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = toPropertyKey(key);
    return isTypedArrayIndex(target, key) ? createPropertyDescriptor(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
  };

  var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = toPropertyKey(key);

    if (isTypedArrayIndex(target, key) && isObject$6(descriptor) && hasOwnProperty_1(descriptor, 'value') && !hasOwnProperty_1(descriptor, 'get') && !hasOwnProperty_1(descriptor, 'set') // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable && (!hasOwnProperty_1(descriptor, 'writable') || descriptor.writable) && (!hasOwnProperty_1(descriptor, 'enumerable') || descriptor.enumerable)) {
      target[key] = descriptor.value;
      return target;
    }

    return nativeDefineProperty(target, key, descriptor);
  };

  if (descriptors) {
    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      objectGetOwnPropertyDescriptor.f = wrappedGetOwnPropertyDescriptor;
      objectDefineProperty.f = wrappedDefineProperty;
      addGetter(TypedArrayPrototype, 'buffer');
      addGetter(TypedArrayPrototype, 'byteOffset');
      addGetter(TypedArrayPrototype, 'byteLength');
      addGetter(TypedArrayPrototype, 'length');
    }

    _export({
      target: 'Object',
      stat: true,
      forced: !NATIVE_ARRAY_BUFFER_VIEWS
    }, {
      getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
      defineProperty: wrappedDefineProperty
    });

    module.exports = function (TYPE, wrapper, CLAMPED) {
      var BYTES = TYPE.match(/\d+$/)[0] / 8;
      var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
      var GETTER = 'get' + TYPE;
      var SETTER = 'set' + TYPE;
      var NativeTypedArrayConstructor = global$1[CONSTRUCTOR_NAME];
      var TypedArrayConstructor = NativeTypedArrayConstructor;
      var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
      var exported = {};

      var getter = function getter(that, index) {
        var data = getInternalState(that);
        return data.view[GETTER](index * BYTES + data.byteOffset, true);
      };

      var setter = function setter(that, index, value) {
        var data = getInternalState(that);
        if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
        data.view[SETTER](index * BYTES + data.byteOffset, value, true);
      };

      var addElement = function addElement(that, index) {
        nativeDefineProperty(that, index, {
          get: function get() {
            return getter(this, index);
          },
          set: function set(value) {
            return setter(this, index, value);
          },
          enumerable: true
        });
      };

      if (!NATIVE_ARRAY_BUFFER_VIEWS) {
        TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
          anInstance(that, TypedArrayConstructorPrototype);
          var index = 0;
          var byteOffset = 0;
          var buffer, byteLength, length;

          if (!isObject$6(data)) {
            length = toIndex(data);
            byteLength = length * BYTES;
            buffer = new ArrayBuffer(byteLength);
          } else if (isArrayBuffer(data)) {
            buffer = data;
            byteOffset = toOffset(offset, BYTES);
            var $len = data.byteLength;

            if ($length === undefined) {
              if ($len % BYTES) throw RangeError(WRONG_LENGTH);
              byteLength = $len - byteOffset;
              if (byteLength < 0) throw RangeError(WRONG_LENGTH);
            } else {
              byteLength = toLength($length) * BYTES;
              if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
            }

            length = byteLength / BYTES;
          } else if (isTypedArray(data)) {
            return fromList(TypedArrayConstructor, data);
          } else {
            return functionCall(typedArrayFrom, TypedArrayConstructor, data);
          }

          setInternalState(that, {
            buffer: buffer,
            byteOffset: byteOffset,
            byteLength: byteLength,
            length: length,
            view: new DataView(buffer)
          });

          while (index < length) {
            addElement(that, index++);
          }
        });
        if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
        TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = objectCreate$1(TypedArrayPrototype);
      } else if (typedArrayConstructorsRequireWrappers) {
        TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
          anInstance(dummy, TypedArrayConstructorPrototype);
          return inheritIfRequired(function () {
            if (!isObject$6(data)) return new NativeTypedArrayConstructor(toIndex(data));
            if (isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
            if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
            return functionCall(typedArrayFrom, TypedArrayConstructor, data);
          }(), dummy, TypedArrayConstructor);
        });
        if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
        forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
          if (!(key in TypedArrayConstructor)) {
            createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
          }
        });
        TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
      }

      if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
        createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
      }

      enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

      if (TYPED_ARRAY_TAG) {
        createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
      }

      var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;
      exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

      _export({
        global: true,
        constructor: true,
        forced: FORCED,
        sham: !NATIVE_ARRAY_BUFFER_VIEWS
      }, exported);

      if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
        createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
      }

      if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
        createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
      }

      setSpecies(CONSTRUCTOR_NAME);
    };
  } else module.exports = function () {
    /* empty */
  };
}); // `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Float64', function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true); // `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}); // `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects

typedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});
var aTypedArray$w = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$x = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method

exportTypedArrayMethod$x('at', function at(index) {
  var O = aTypedArray$w(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return k < 0 || k >= len ? undefined : O[k];
});
var u$ArrayCopyWithin = functionUncurryThis(arrayCopyWithin);
var aTypedArray$v = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$w = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin

exportTypedArrayMethod$w('copyWithin', function copyWithin(target, start
/* , end */
) {
  return u$ArrayCopyWithin(aTypedArray$v(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});
var $every$1 = arrayIteration.every;
var aTypedArray$u = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$v = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every

exportTypedArrayMethod$v('every', function every(callbackfn
/* , thisArg */
) {
  return $every$1(aTypedArray$u(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});
var aTypedArray$t = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$u = arrayBufferViewCore.exportTypedArrayMethod;
var slice = functionUncurryThis(''.slice); // V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18

var CONVERSION_BUG = fails(function () {
  var count = 0; // eslint-disable-next-line es/no-typed-arrays -- safe

  new Int8Array(2).fill({
    valueOf: function valueOf() {
      return count++;
    }
  });
  return count !== 1;
}); // `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill

exportTypedArrayMethod$u('fill', function fill(value
/* , start, end */
) {
  var length = arguments.length;
  aTypedArray$t(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return functionCall(arrayFill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

var arrayFromConstructorAndList = function arrayFromConstructorAndList(Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);

  while (length > index) {
    result[index] = list[index++];
  }

  return result;
};

var aTypedArrayConstructor$2 = arrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor$4 = arrayBufferViewCore.getTypedArrayConstructor; // a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create

var typedArraySpeciesConstructor = function typedArraySpeciesConstructor(originalArray) {
  return aTypedArrayConstructor$2(speciesConstructor(originalArray, getTypedArrayConstructor$4(originalArray)));
};

var typedArrayFromSpeciesAndList = function typedArrayFromSpeciesAndList(instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};

var $filter = arrayIteration.filter;
var aTypedArray$s = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$t = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter

exportTypedArrayMethod$t('filter', function filter(callbackfn
/* , thisArg */
) {
  var list = $filter(aTypedArray$s(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return typedArrayFromSpeciesAndList(this, list);
});
var $find$1 = arrayIteration.find;
var aTypedArray$r = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$s = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find

exportTypedArrayMethod$s('find', function find(predicate
/* , thisArg */
) {
  return $find$1(aTypedArray$r(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});
var $findIndex = arrayIteration.findIndex;
var aTypedArray$q = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$r = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex

exportTypedArrayMethod$r('findIndex', function findIndex(predicate
/* , thisArg */
) {
  return $findIndex(aTypedArray$q(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});
var $findLast = arrayIterationFromLast.findLast;
var aTypedArray$p = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$q = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last

exportTypedArrayMethod$q('findLast', function findLast(predicate
/* , thisArg */
) {
  return $findLast(aTypedArray$p(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});
var $findLastIndex = arrayIterationFromLast.findLastIndex;
var aTypedArray$o = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$p = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last

exportTypedArrayMethod$p('findLastIndex', function findLastIndex(predicate
/* , thisArg */
) {
  return $findLastIndex(aTypedArray$o(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});
var $forEach$1 = arrayIteration.forEach;
var aTypedArray$n = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$o = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach

exportTypedArrayMethod$o('forEach', function forEach(callbackfn
/* , thisArg */
) {
  $forEach$1(aTypedArray$n(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});
var exportTypedArrayStaticMethod$2 = arrayBufferViewCore.exportTypedArrayStaticMethod; // `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from

exportTypedArrayStaticMethod$2('from', typedArrayFrom, typedArrayConstructorsRequireWrappers);
var $includes = arrayIncludes.includes;
var aTypedArray$m = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$n = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes

exportTypedArrayMethod$n('includes', function includes(searchElement
/* , fromIndex */
) {
  return $includes(aTypedArray$m(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});
var $indexOf = arrayIncludes.indexOf;
var aTypedArray$l = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$m = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof

exportTypedArrayMethod$m('indexOf', function indexOf(searchElement
/* , fromIndex */
) {
  return $indexOf(aTypedArray$l(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});
var ITERATOR$3 = wellKnownSymbol('iterator');
var Uint8Array$4 = global$1.Uint8Array;
var arrayValues = functionUncurryThis(es_array_iterator.values);
var arrayKeys = functionUncurryThis(es_array_iterator.keys);
var arrayEntries = functionUncurryThis(es_array_iterator.entries);
var aTypedArray$k = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$l = arrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array$4 && Uint8Array$4.prototype;
var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR$3].call([1]);
});
var ITERATOR_IS_VALUES = !!TypedArrayPrototype && TypedArrayPrototype.values && TypedArrayPrototype[ITERATOR$3] === TypedArrayPrototype.values && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray$k(this));
}; // `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries


exportTypedArrayMethod$l('entries', function entries() {
  return arrayEntries(aTypedArray$k(this));
}, GENERIC); // `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys

exportTypedArrayMethod$l('keys', function keys() {
  return arrayKeys(aTypedArray$k(this));
}, GENERIC); // `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values

exportTypedArrayMethod$l('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
  name: 'values'
}); // `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator

exportTypedArrayMethod$l(ITERATOR$3, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
  name: 'values'
});
var aTypedArray$j = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$k = arrayBufferViewCore.exportTypedArrayMethod;
var $join = functionUncurryThis([].join); // `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join

exportTypedArrayMethod$k('join', function join(separator) {
  return $join(aTypedArray$j(this), separator);
});
var aTypedArray$i = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$j = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof

exportTypedArrayMethod$j('lastIndexOf', function lastIndexOf(searchElement
/* , fromIndex */
) {
  var length = arguments.length;
  return functionApply(arrayLastIndexOf, aTypedArray$i(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});
var $map = arrayIteration.map;
var aTypedArray$h = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$i = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map

exportTypedArrayMethod$i('map', function map(mapfn
/* , thisArg */
) {
  return $map(aTypedArray$h(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});
var aTypedArrayConstructor$1 = arrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod$1 = arrayBufferViewCore.exportTypedArrayStaticMethod; // `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of

exportTypedArrayStaticMethod$1('of', function
  /* ...items */
of() {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor$1(this))(length);

  while (length > index) {
    result[index] = arguments[index++];
  }

  return result;
}, typedArrayConstructorsRequireWrappers);
var $reduce = arrayReduce.left;
var aTypedArray$g = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$h = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce

exportTypedArrayMethod$h('reduce', function reduce(callbackfn
/* , initialValue */
) {
  var length = arguments.length;
  return $reduce(aTypedArray$g(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});
var $reduceRight = arrayReduce.right;
var aTypedArray$f = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$g = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright

exportTypedArrayMethod$g('reduceRight', function reduceRight(callbackfn
/* , initialValue */
) {
  var length = arguments.length;
  return $reduceRight(aTypedArray$f(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});
var aTypedArray$e = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$f = arrayBufferViewCore.exportTypedArrayMethod;
var floor$2 = Math.floor; // `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse

exportTypedArrayMethod$f('reverse', function reverse() {
  var that = this;
  var length = aTypedArray$e(that).length;
  var middle = floor$2(length / 2);
  var index = 0;
  var value;

  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  }

  return that;
});
var RangeError$2 = global$1.RangeError;
var Int8Array$2 = global$1.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$d = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$e = arrayBufferViewCore.exportTypedArrayMethod;
var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  functionCall($set, array, {
    length: 1,
    0: 3
  }, 1);
  return array[1] !== 3;
}); // https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other

var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array$2(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
}); // `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set

exportTypedArrayMethod$e('set', function set(arrayLike
/* , offset */
) {
  aTypedArray$d(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toObject$1(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return functionCall($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError$2('Wrong length');

  while (index < len) {
    this[offset + index] = src[index++];
  }
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);
var aTypedArray$c = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$d = arrayBufferViewCore.exportTypedArrayMethod;
var FORCED$2 = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
}); // `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice

exportTypedArrayMethod$d('slice', function slice(start, end) {
  var list = arraySlice$1(aTypedArray$c(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);

  while (length > index) {
    result[index] = list[index++];
  }

  return result;
}, FORCED$2);
var $some$1 = arrayIteration.some;
var aTypedArray$b = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$c = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some

exportTypedArrayMethod$c('some', function some(callbackfn
/* , thisArg */
) {
  return $some$1(aTypedArray$b(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});
var aTypedArray$a = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$b = arrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array$1 = global$1.Uint16Array;
var nativeSort = Uint16Array$1 && functionUncurryThis(Uint16Array$1.prototype.sort); // WebKit

var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array$1(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array$1(2), {});
}));
var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 74;
  if (engineFfVersion) return engineFfVersion < 67;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 602;
  var array = new Uint16Array$1(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function getSortCompare(comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0; // eslint-disable-next-line no-self-compare -- NaN check

    if (y !== y) return -1; // eslint-disable-next-line no-self-compare -- NaN check

    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
}; // `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort


exportTypedArrayMethod$b('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);
  return arraySort(aTypedArray$a(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
var aTypedArray$9 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$a = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray

exportTypedArrayMethod$a('subarray', function subarray(begin, end) {
  var O = aTypedArray$9(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex));
});
var Int8Array$1 = global$1.Int8Array;
var aTypedArray$8 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$9 = arrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString; // iOS Safari 6.x fails here

var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails(function () {
  $toLocaleString.call(new Int8Array$1(1));
});
var FORCED$1 = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array$1([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
}); // `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring

exportTypedArrayMethod$9('toLocaleString', function toLocaleString() {
  return functionApply($toLocaleString, TO_LOCALE_STRING_BUG ? arraySlice$1(aTypedArray$8(this)) : aTypedArray$8(this), arraySlice$1(arguments));
}, FORCED$1);
var exportTypedArrayMethod$8 = arrayBufferViewCore.exportTypedArrayMethod;
var Uint8Array$3 = global$1.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$3 && Uint8Array$3.prototype || {};
var arrayToString = [].toString;
var join$4 = functionUncurryThis([].join);

if (fails(function () {
  arrayToString.call({});
})) {
  arrayToString = function toString() {
    return join$4(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString; // `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring

exportTypedArrayMethod$8('toString', arrayToString, IS_NOT_ARRAY_METHOD);
var fromCharCode$2 = String.fromCharCode;
var charAt$7 = functionUncurryThis(''.charAt);
var exec$5 = functionUncurryThis(/./.exec);
var stringSlice$3 = functionUncurryThis(''.slice);
var hex2 = /^[\da-f]{2}$/i;
var hex4 = /^[\da-f]{4}$/i; // `unescape` method
// https://tc39.es/ecma262/#sec-unescape-string

_export({
  global: true
}, {
  unescape: function unescape(string) {
    var str = toString$2(string);
    var result = '';
    var length = str.length;
    var index = 0;
    var chr, part;

    while (index < length) {
      chr = charAt$7(str, index++);

      if (chr === '%') {
        if (charAt$7(str, index) === 'u') {
          part = stringSlice$3(str, index + 1, index + 5);

          if (exec$5(hex4, part)) {
            result += fromCharCode$2(parseInt(part, 16));
            index += 5;
            continue;
          }
        } else {
          part = stringSlice$3(str, index, index + 2);

          if (exec$5(hex2, part)) {
            result += fromCharCode$2(parseInt(part, 16));
            index += 2;
            continue;
          }
        }
      }

      result += chr;
    }

    return result;
  }
});

var getWeakData = internalMetadata.getWeakData;
var setInternalState$b = internalState.set;
var internalStateGetterFor = internalState.getterFor;
var find$2 = arrayIteration.find;
var findIndex$1 = arrayIteration.findIndex;
var splice$2 = functionUncurryThis([].splice);
var id = 0; // fallback for uncaught frozen keys

var uncaughtFrozenStore = function uncaughtFrozenStore(store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.entries = [];
};

var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return find$2(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.entries.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = findIndex$1(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice$2(this.entries, index, 1);
    return !!~index;
  }
};
var collectionWeak = {
  getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState$b(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
        that: that,
        AS_ENTRIES: IS_MAP
      });
    });
    var Prototype = Constructor.prototype;
    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function define(that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function _delete(key) {
        var state = getInternalState(this);
        if (!isObject$6(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwnProperty_1(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject$6(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwnProperty_1(data, state.id);
      }
    });
    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);

        if (isObject$6(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });
    return Constructor;
  }
};
var enforceInternalState = internalState.enforce;
var IS_IE11 = !global$1.ActiveXObject && 'ActiveXObject' in global$1;
var InternalWeakMap;

var wrapper = function wrapper(init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}; // `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor


var $WeakMap = collection('WeakMap', wrapper, collectionWeak); // IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485

if (weakMapBasicDetection && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  internalMetadata.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = functionUncurryThis(WeakMapPrototype['delete']);
  var nativeHas = functionUncurryThis(WeakMapPrototype.has);
  var nativeGet = functionUncurryThis(WeakMapPrototype.get);
  var nativeSet = functionUncurryThis(WeakMapPrototype.set);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function _delete(key) {
      if (isObject$6(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      }

      return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject$6(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      }

      return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject$6(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      }

      return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject$6(key) && !objectIsExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);

      return this;
    }
  });
} // `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor


collection('WeakSet', function (init) {
  return function WeakSet() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionWeak);
var USE_FUNCTION_CONSTRUCTOR = 'USE_FUNCTION_CONSTRUCTOR';
var ASYNC_ITERATOR$3 = wellKnownSymbol('asyncIterator');
var AsyncIterator = global$1.AsyncIterator;
var PassedAsyncIteratorPrototype = sharedStore.AsyncIteratorPrototype;
var AsyncIteratorPrototype, prototype;

if (PassedAsyncIteratorPrototype) {
  AsyncIteratorPrototype = PassedAsyncIteratorPrototype;
} else if (isCallable(AsyncIterator)) {
  AsyncIteratorPrototype = AsyncIterator.prototype;
} else if (sharedStore[USE_FUNCTION_CONSTRUCTOR] || global$1[USE_FUNCTION_CONSTRUCTOR]) {
  try {
    // eslint-disable-next-line no-new-func -- we have no alternatives without usage of modern syntax
    prototype = objectGetPrototypeOf(objectGetPrototypeOf(objectGetPrototypeOf(Function('return async function*(){}()')())));
    if (objectGetPrototypeOf(prototype) === Object.prototype) AsyncIteratorPrototype = prototype;
  } catch (error) {
    /* empty */
  }
}

if (!AsyncIteratorPrototype) AsyncIteratorPrototype = {};

if (!isCallable(AsyncIteratorPrototype[ASYNC_ITERATOR$3])) {
  defineBuiltIn(AsyncIteratorPrototype, ASYNC_ITERATOR$3, function () {
    return this;
  });
}

var asyncIteratorPrototype = AsyncIteratorPrototype;
var Promise$5 = getBuiltIn('Promise');
var ASYNC_FROM_SYNC_ITERATOR = 'AsyncFromSyncIterator';
var setInternalState$a = internalState.set;
var getInternalState$5 = internalState.getterFor(ASYNC_FROM_SYNC_ITERATOR);

var asyncFromSyncIteratorContinuation = function asyncFromSyncIteratorContinuation(result, resolve, reject) {
  var done = result.done;
  Promise$5.resolve(result.value).then(function (value) {
    resolve(createIterResultObject(value, done));
  }, reject);
};

var AsyncFromSyncIterator = function AsyncIterator(iterator) {
  setInternalState$a(this, {
    type: ASYNC_FROM_SYNC_ITERATOR,
    iterator: anObject(iterator),
    next: iterator.next
  });
};

AsyncFromSyncIterator.prototype = defineBuiltIns(objectCreate$1(asyncIteratorPrototype), {
  next: function next() {
    var state = getInternalState$5(this);
    return new Promise$5(function (resolve, reject) {
      var result = anObject(functionCall(state.next, state.iterator));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  },
  'return': function _return() {
    var iterator = getInternalState$5(this).iterator;
    return new Promise$5(function (resolve, reject) {
      var $return = getMethod(iterator, 'return');
      if ($return === undefined) return resolve(createIterResultObject(undefined, true));
      var result = anObject(functionCall($return, iterator));
      asyncFromSyncIteratorContinuation(result, resolve, reject);
    });
  }
});
var asyncFromSyncIterator = AsyncFromSyncIterator;
var ASYNC_ITERATOR$2 = wellKnownSymbol('asyncIterator');

var getAsyncIterator = function getAsyncIterator(it, usingIterator) {
  var method = arguments.length < 2 ? getMethod(it, ASYNC_ITERATOR$2) : usingIterator;
  return method ? anObject(functionCall(method, it)) : new asyncFromSyncIterator(getIterator(it));
};

var entryVirtual = function entryVirtual(CONSTRUCTOR) {
  return global$1[CONSTRUCTOR].prototype;
};

var getIteratorDirect = function getIteratorDirect(obj) {
  return {
    iterator: obj,
    next: aCallable(anObject(obj).next)
  };
};

var asyncIteratorClose = function asyncIteratorClose(iterator, method, argument, reject) {
  try {
    var returnMethod = getMethod(iterator, 'return');

    if (returnMethod) {
      return getBuiltIn('Promise').resolve(functionCall(returnMethod, iterator)).then(function () {
        method(argument);
      }, function (error) {
        reject(error);
      });
    }
  } catch (error2) {
    return reject(error2);
  }

  method(argument);
}; // https://github.com/tc39/proposal-iterator-helpers
// https://github.com/tc39/proposal-array-from-async


var createMethod = function createMethod(TYPE) {
  var IS_TO_ARRAY = TYPE == 0;
  var IS_FOR_EACH = TYPE == 1;
  var IS_EVERY = TYPE == 2;
  var IS_SOME = TYPE == 3;
  return function (object, fn, target) {
    var record = getIteratorDirect(object);
    var Promise = getBuiltIn('Promise');
    var iterator = record.iterator;
    var next = record.next;
    var index = 0;
    var MAPPING = fn !== undefined;
    if (MAPPING || !IS_TO_ARRAY) aCallable(fn);
    return new Promise(function (resolve, reject) {
      var ifAbruptCloseAsyncIterator = function ifAbruptCloseAsyncIterator(error) {
        asyncIteratorClose(iterator, reject, error, reject);
      };

      var loop = function loop() {
        try {
          if (IS_TO_ARRAY && MAPPING) try {
            doesNotExceedSafeInteger(index);
          } catch (error5) {
            ifAbruptCloseAsyncIterator(error5);
          }
          Promise.resolve(anObject(functionCall(next, iterator))).then(function (step) {
            try {
              if (anObject(step).done) {
                if (IS_TO_ARRAY) {
                  target.length = index;
                  resolve(target);
                } else resolve(IS_SOME ? false : IS_EVERY || undefined);
              } else {
                var value = step.value;

                try {
                  if (MAPPING) {
                    Promise.resolve(IS_TO_ARRAY ? fn(value, index) : fn(value)).then(function (result) {
                      if (IS_FOR_EACH) {
                        loop();
                      } else if (IS_EVERY) {
                        result ? loop() : asyncIteratorClose(iterator, resolve, false, reject);
                      } else if (IS_TO_ARRAY) {
                        try {
                          target[index++] = result;
                          loop();
                        } catch (error4) {
                          ifAbruptCloseAsyncIterator(error4);
                        }
                      } else {
                        result ? asyncIteratorClose(iterator, resolve, IS_SOME || value, reject) : loop();
                      }
                    }, ifAbruptCloseAsyncIterator);
                  } else {
                    target[index++] = value;
                    loop();
                  }
                } catch (error3) {
                  ifAbruptCloseAsyncIterator(error3);
                }
              }
            } catch (error2) {
              reject(error2);
            }
          }, reject);
        } catch (error) {
          reject(error);
        }
      };

      loop();
    });
  };
};

var asyncIteratorIteration = {
  toArray: createMethod(0),
  forEach: createMethod(1),
  every: createMethod(2),
  some: createMethod(3),
  find: createMethod(4)
};
var toArray = asyncIteratorIteration.toArray;
var ASYNC_ITERATOR$1 = wellKnownSymbol('asyncIterator');
var arrayIterator = entryVirtual('Array').values; // `Array.fromAsync` method implementation
// https://github.com/tc39/proposal-array-from-async

var arrayFromAsync = function fromAsync(asyncItems
/* , mapfn = undefined, thisArg = undefined */
) {
  var C = this;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var thisArg = argumentsLength > 2 ? arguments[2] : undefined;
  return new (getBuiltIn('Promise'))(function (resolve) {
    var O = toObject$1(asyncItems);
    if (mapfn !== undefined) mapfn = functionBindContext(mapfn, thisArg);
    var usingAsyncIterator = getMethod(O, ASYNC_ITERATOR$1);
    var usingSyncIterator = usingAsyncIterator ? undefined : getIteratorMethod(O) || arrayIterator;
    var A = isConstructor(C) ? new C() : [];
    var iterator = usingAsyncIterator ? getAsyncIterator(O, usingAsyncIterator) : new asyncFromSyncIterator(getIterator(O, usingSyncIterator));
    resolve(toArray(iterator, mapfn, A));
  });
}; // `Array.fromAsync` method
// https://github.com/tc39/proposal-array-from-async


_export({
  target: 'Array',
  stat: true,
  forced: true
}, {
  fromAsync: arrayFromAsync
}); // TODO: remove from `core-js@4`


var $filterReject$3 = arrayIteration.filterReject; // `Array.prototype.filterOut` method
// https://github.com/tc39/proposal-array-filtering

_export({
  target: 'Array',
  proto: true,
  forced: true
}, {
  filterOut: function filterOut(callbackfn
  /* , thisArg */
  ) {
    return $filterReject$3(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('filterOut');
var $filterReject$2 = arrayIteration.filterReject; // `Array.prototype.filterReject` method
// https://github.com/tc39/proposal-array-filtering

_export({
  target: 'Array',
  proto: true,
  forced: true
}, {
  filterReject: function filterReject(callbackfn
  /* , thisArg */
  ) {
    return $filterReject$2(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('filterReject');
var $Array$4 = Array;
var push$c = functionUncurryThis([].push);

var arrayGroup = function arrayGroup($this, callbackfn, that, specificConstructor) {
  var O = toObject$1($this);
  var self = indexedObject(O);
  var boundFunction = functionBindContext(callbackfn, that);
  var target = objectCreate$1(null);
  var length = lengthOfArrayLike(self);
  var index = 0;
  var Constructor, key, value;

  for (; length > index; index++) {
    value = self[index];
    key = toPropertyKey(boundFunction(value, index, O)); // in some IE10 builds, `hasOwnProperty` returns incorrect result on integer keys
    // but since it's a `null` prototype object, we can safely use `in`

    if (key in target) push$c(target[key], value);else target[key] = [value];
  } // TODO: Remove this block from `core-js@4`


  if (specificConstructor) {
    Constructor = specificConstructor(O);

    if (Constructor !== $Array$4) {
      for (key in target) {
        target[key] = arrayFromConstructorAndList(Constructor, target[key]);
      }
    }
  }

  return target;
}; // `Array.prototype.group` method
// https://github.com/tc39/proposal-array-grouping


_export({
  target: 'Array',
  proto: true
}, {
  group: function group(callbackfn
  /* , thisArg */
  ) {
    var thisArg = arguments.length > 1 ? arguments[1] : undefined;
    return arrayGroup(this, callbackfn, thisArg);
  }
});

addToUnscopables('group'); // TODO: Remove from `core-js@4`
// `Array.prototype.groupBy` method
// https://github.com/tc39/proposal-array-grouping
// https://bugs.webkit.org/show_bug.cgi?id=236541

_export({
  target: 'Array',
  proto: true,
  forced: !arrayMethodIsStrict('groupBy')
}, {
  groupBy: function groupBy(callbackfn
  /* , thisArg */
  ) {
    var thisArg = arguments.length > 1 ? arguments[1] : undefined;
    return arrayGroup(this, callbackfn, thisArg);
  }
});

addToUnscopables('groupBy');
var Map$8 = getBuiltIn('Map');
var MapPrototype$2 = Map$8.prototype;
var mapGet$1 = functionUncurryThis(MapPrototype$2.get);
var mapHas$2 = functionUncurryThis(MapPrototype$2.has);
var mapSet$2 = functionUncurryThis(MapPrototype$2.set);
var push$b = functionUncurryThis([].push); // `Array.prototype.groupToMap` method
// https://github.com/tc39/proposal-array-grouping

var arrayGroupToMap = function groupToMap(callbackfn
/* , thisArg */
) {
  var O = toObject$1(this);
  var self = indexedObject(O);
  var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  var map = new Map$8();
  var length = lengthOfArrayLike(self);
  var index = 0;
  var key, value;

  for (; length > index; index++) {
    value = self[index];
    key = boundFunction(value, index, O);
    if (mapHas$2(map, key)) push$b(mapGet$1(map, key), value);else mapSet$2(map, key, [value]);
  }

  return map;
}; // TODO: Remove from `core-js@4`
// `Array.prototype.groupByToMap` method
// https://github.com/tc39/proposal-array-grouping
// https://bugs.webkit.org/show_bug.cgi?id=236541


_export({
  target: 'Array',
  proto: true,
  name: 'groupToMap',
  forced: !arrayMethodIsStrict('groupByToMap')
}, {
  groupByToMap: arrayGroupToMap
});

addToUnscopables('groupByToMap'); // `Array.prototype.groupToMap` method
// https://github.com/tc39/proposal-array-grouping

_export({
  target: 'Array',
  proto: true,
  forced: isPure
}, {
  groupToMap: arrayGroupToMap
});

addToUnscopables('groupToMap'); // eslint-disable-next-line es/no-object-isfrozen -- safe

var isFrozen = Object.isFrozen;

var isFrozenStringArray = function isFrozenStringArray(array, allowUndefined) {
  if (!isFrozen || !isArray$4(array) || !isFrozen(array)) return false;
  var index = 0;
  var length = array.length;
  var element;

  while (index < length) {
    element = array[index++];

    if (!(typeof element == 'string' || allowUndefined && element === undefined)) {
      return false;
    }
  }

  return length !== 0;
}; // `Array.isTemplateObject` method
// https://github.com/tc39/proposal-array-is-template-object


_export({
  target: 'Array',
  stat: true,
  sham: true,
  forced: true
}, {
  isTemplateObject: function isTemplateObject(value) {
    if (!isFrozenStringArray(value, true)) return false;
    var raw = value.raw;
    return raw.length === value.length && isFrozenStringArray(raw, false);
  }
}); // TODO: Remove from `core-js@4`
// `Array.prototype.lastIndex` getter
// https://github.com/keithamus/proposal-array-last


if (descriptors) {
  defineBuiltInAccessor(Array.prototype, 'lastIndex', {
    configurable: true,
    get: function lastIndex() {
      var O = toObject$1(this);
      var len = lengthOfArrayLike(O);
      return len == 0 ? 0 : len - 1;
    }
  });
  addToUnscopables('lastIndex');
} // TODO: Remove from `core-js@4`
// `Array.prototype.lastIndex` accessor
// https://github.com/keithamus/proposal-array-last


if (descriptors) {
  defineBuiltInAccessor(Array.prototype, 'lastItem', {
    configurable: true,
    get: function lastItem() {
      var O = toObject$1(this);
      var len = lengthOfArrayLike(O);
      return len == 0 ? undefined : O[len - 1];
    },
    set: function lastItem(value) {
      var O = toObject$1(this);
      var len = lengthOfArrayLike(O);
      return O[len == 0 ? 0 : len - 1] = value;
    }
  });
  addToUnscopables('lastItem');
} // https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed


var arrayToReversed = function arrayToReversed(O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;

  for (; k < len; k++) {
    A[k] = O[len - k - 1];
  }

  return A;
};

var $Array$3 = Array; // `Array.prototype.toReversed` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed

_export({
  target: 'Array',
  proto: true
}, {
  toReversed: function toReversed() {
    return arrayToReversed(toIndexedObject(this), $Array$3);
  }
});

addToUnscopables('toReversed');
var $Array$2 = Array;
var sort$1 = functionUncurryThis(entryVirtual('Array').sort); // `Array.prototype.toSorted` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toSorted

_export({
  target: 'Array',
  proto: true
}, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== undefined) aCallable(compareFn);
    var O = toIndexedObject(this);
    var A = arrayFromConstructorAndList($Array$2, O);
    return sort$1(A, compareFn);
  }
});

addToUnscopables('toSorted');
var $Array$1 = Array;
var max$2 = Math.max;
var min$2 = Math.min; // `Array.prototype.toSpliced` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toSpliced

_export({
  target: 'Array',
  proto: true
}, {
  toSpliced: function toSpliced(start, deleteCount
  /* , ...items */
  ) {
    var O = toIndexedObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var k = 0;
    var insertCount, actualDeleteCount, newLen, A;

    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$2(max$2(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }

    newLen = doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = $Array$1(newLen);

    for (; k < actualStart; k++) {
      A[k] = O[k];
    }

    for (; k < actualStart + insertCount; k++) {
      A[k] = arguments[k - actualStart + 2];
    }

    for (; k < newLen; k++) {
      A[k] = O[k + actualDeleteCount - insertCount];
    }

    return A;
  }
});

addToUnscopables('toSpliced');
var Map$7 = getBuiltIn('Map');
var MapPrototype$1 = Map$7.prototype;
var mapForEach = functionUncurryThis(MapPrototype$1.forEach);
var mapHas$1 = functionUncurryThis(MapPrototype$1.has);
var mapSet$1 = functionUncurryThis(MapPrototype$1.set);
var push$a = functionUncurryThis([].push); // `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique

var arrayUniqueBy$2 = function uniqueBy(resolver) {
  var that = toObject$1(this);
  var length = lengthOfArrayLike(that);
  var result = arraySpeciesCreate(that, 0);
  var map = new Map$7();
  var resolverFunction = !isNullOrUndefined(resolver) ? aCallable(resolver) : function (value) {
    return value;
  };
  var index, item, key;

  for (index = 0; index < length; index++) {
    item = that[index];
    key = resolverFunction(item);
    if (!mapHas$1(map, key)) mapSet$1(map, key, item);
  }

  mapForEach(map, function (value) {
    push$a(result, value);
  });
  return result;
}; // `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique


_export({
  target: 'Array',
  proto: true,
  forced: true
}, {
  uniqueBy: arrayUniqueBy$2
});

addToUnscopables('uniqueBy');
var $RangeError$4 = RangeError; // https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with

var arrayWith = function arrayWith(O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw $RangeError$4('Incorrect index');
  var A = new C(len);
  var k = 0;

  for (; k < len; k++) {
    A[k] = k === actualIndex ? value : O[k];
  }

  return A;
};

var $Array = Array; // `Array.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with

_export({
  target: 'Array',
  proto: true
}, {
  'with': function _with(index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var TO_STRING_TAG$4 = wellKnownSymbol('toStringTag');

var AsyncIteratorConstructor = function AsyncIterator() {
  anInstance(this, asyncIteratorPrototype);
};

AsyncIteratorConstructor.prototype = asyncIteratorPrototype;

if (!hasOwnProperty_1(asyncIteratorPrototype, TO_STRING_TAG$4)) {
  createNonEnumerableProperty(asyncIteratorPrototype, TO_STRING_TAG$4, 'AsyncIterator');
}

if (!hasOwnProperty_1(asyncIteratorPrototype, 'constructor') || asyncIteratorPrototype.constructor === Object) {
  createNonEnumerableProperty(asyncIteratorPrototype, 'constructor', AsyncIteratorConstructor);
}

_export({
  global: true,
  constructor: true,
  forced: isPure
}, {
  AsyncIterator: AsyncIteratorConstructor
});

var Promise$4 = getBuiltIn('Promise');
var ASYNC_ITERATOR_HELPER = 'AsyncIteratorHelper';
var WRAP_FOR_VALID_ASYNC_ITERATOR = 'WrapForValidAsyncIterator';
var setInternalState$9 = internalState.set;
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');

var createAsyncIteratorProxyPrototype = function createAsyncIteratorProxyPrototype(IS_ITERATOR) {
  var IS_GENERATOR = !IS_ITERATOR;
  var ASYNC_ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ASYNC_ITERATOR : ASYNC_ITERATOR_HELPER;
  var getInternalState = internalState.getterFor(ASYNC_ITERATOR_PROXY);

  var getStateOrEarlyExit = function getStateOrEarlyExit(that) {
    var stateCompletion = perform(function () {
      return getInternalState(that);
    });
    var stateError = stateCompletion.error;
    var state = stateCompletion.value;

    if (stateError || IS_GENERATOR && state.done) {
      return {
        exit: true,
        value: stateError ? Promise$4.reject(state) : Promise$4.resolve(createIterResultObject(undefined, true))
      };
    }

    return {
      exit: false,
      value: state
    };
  };

  var enqueue = function enqueue(state, handler) {
    var task = function task() {
      var promise = handler();

      if (IS_GENERATOR) {
        state.awaiting = promise;

        var clean = function clean() {
          if (state.awaiting === promise) state.awaiting = null;
        };

        promise.then(clean, clean);
      }

      return promise;
    };

    return state.awaiting ? state.awaiting = state.awaiting.then(task, task) : task();
  };

  var AsyncIteratorProxyPrototype = defineBuiltIns(objectCreate$1(asyncIteratorPrototype), {
    next: function next() {
      var stateCompletion = getStateOrEarlyExit(this);
      var exit = stateCompletion.exit;
      var state = stateCompletion.value;
      return exit ? state : enqueue(state, function () {
        var handlerCompletion = perform(function () {
          return anObject(state.nextHandler(Promise$4));
        });
        var handlerError = handlerCompletion.error;
        var value = handlerCompletion.value;
        if (handlerError) state.done = true;
        return handlerError ? Promise$4.reject(value) : Promise$4.resolve(value);
      });
    },
    'return': function _return() {
      var stateCompletion = getStateOrEarlyExit(this);
      var exit = stateCompletion.exit;
      var state = stateCompletion.value;
      return exit ? state : enqueue(state, function () {
        state.done = true;
        var iterator = state.iterator;
        var innerIterator = state.innerIterator;
        var returnMethod, result;
        var completion = perform(function () {
          if (innerIterator) try {
            iteratorClose(innerIterator, 'return');
          } catch (error) {
            return iteratorClose(iterator, 'throw', error);
          }
          return getMethod(iterator, 'return');
        });
        returnMethod = result = completion.value;
        if (completion.error) return Promise$4.reject(result);
        if (returnMethod === undefined) return Promise$4.resolve(createIterResultObject(undefined, true));
        completion = perform(function () {
          return functionCall(returnMethod, iterator);
        });
        result = completion.value;
        if (completion.error) return Promise$4.reject(result);
        return IS_ITERATOR ? Promise$4.resolve(result) : Promise$4.resolve(result).then(function (resolved) {
          anObject(resolved);
          return createIterResultObject(undefined, true);
        });
      });
    }
  });

  if (IS_GENERATOR) {
    createNonEnumerableProperty(AsyncIteratorProxyPrototype, TO_STRING_TAG$3, 'Async Iterator Helper');
  }

  return AsyncIteratorProxyPrototype;
};

var AsyncIteratorHelperPrototype = createAsyncIteratorProxyPrototype(false);
var WrapForValidAsyncIteratorPrototype = createAsyncIteratorProxyPrototype(true);

var asyncIteratorCreateProxy = function asyncIteratorCreateProxy(nextHandler, IS_ITERATOR) {
  var ASYNC_ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ASYNC_ITERATOR : ASYNC_ITERATOR_HELPER;

  var AsyncIteratorProxy = function AsyncIterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;

    state.type = ASYNC_ITERATOR_PROXY;
    state.nextHandler = nextHandler;
    state.done = false;
    state.awaiting = null;
    setInternalState$9(this, state);
  };

  AsyncIteratorProxy.prototype = IS_ITERATOR ? WrapForValidAsyncIteratorPrototype : AsyncIteratorHelperPrototype;
  return AsyncIteratorProxy;
}; // https://github.com/tc39/proposal-iterator-helpers


var AsyncIteratorProxy$5 = asyncIteratorCreateProxy(function (Promise) {
  var state = this;
  var iterator = state.iterator;
  return Promise.resolve(anObject(functionCall(state.next, iterator))).then(function (step) {
    if (anObject(step).done) {
      state.done = true;
      return createIterResultObject(undefined, true);
    }

    return createIterResultObject([state.index++, step.value], false);
  }).then(null, function (error) {
    state.done = true;
    throw error;
  });
});

var asyncIteratorIndexed = function indexed() {
  return new AsyncIteratorProxy$5(getIteratorDirect(this), {
    index: 0
  });
}; // TODO: Remove from `core-js@4`
// https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'AsyncIterator',
  name: 'indexed',
  proto: true,
  real: true,
  forced: true
}, {
  asIndexedPairs: asyncIteratorIndexed
});

var $RangeError$3 = RangeError;

var notANan = function notANan(it) {
  // eslint-disable-next-line no-self-compare -- NaN check
  if (it === it) return it;
  throw $RangeError$3('NaN is not allowed');
}; // https://github.com/tc39/proposal-iterator-helpers


var AsyncIteratorProxy$4 = asyncIteratorCreateProxy(function (Promise) {
  var state = this;
  return new Promise(function (resolve, reject) {
    var doneAndReject = function doneAndReject(error) {
      state.done = true;
      reject(error);
    };

    var loop = function loop() {
      try {
        Promise.resolve(anObject(functionCall(state.next, state.iterator))).then(function (step) {
          try {
            if (anObject(step).done) {
              state.done = true;
              resolve(createIterResultObject(undefined, true));
            } else if (state.remaining) {
              state.remaining--;
              loop();
            } else resolve(createIterResultObject(step.value, false));
          } catch (err) {
            doneAndReject(err);
          }
        }, doneAndReject);
      } catch (error) {
        doneAndReject(error);
      }
    };

    loop();
  });
});

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  drop: function drop(limit) {
    return new AsyncIteratorProxy$4(getIteratorDirect(this), {
      remaining: toPositiveInteger(notANan(+limit))
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $every = asyncIteratorIteration.every;

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  every: function every(fn) {
    return $every(this, fn);
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var AsyncIteratorProxy$3 = asyncIteratorCreateProxy(function (Promise) {
  var state = this;
  var iterator = state.iterator;
  var filterer = state.filterer;
  return new Promise(function (resolve, reject) {
    var doneAndReject = function doneAndReject(error) {
      state.done = true;
      reject(error);
    };

    var ifAbruptCloseAsyncIterator = function ifAbruptCloseAsyncIterator(error) {
      asyncIteratorClose(iterator, doneAndReject, error, doneAndReject);
    };

    var loop = function loop() {
      try {
        Promise.resolve(anObject(functionCall(state.next, iterator))).then(function (step) {
          try {
            if (anObject(step).done) {
              state.done = true;
              resolve(createIterResultObject(undefined, true));
            } else {
              var value = step.value;

              try {
                Promise.resolve(filterer(value)).then(function (selected) {
                  selected ? resolve(createIterResultObject(value, false)) : loop();
                }, ifAbruptCloseAsyncIterator);
              } catch (error3) {
                ifAbruptCloseAsyncIterator(error3);
              }
            }
          } catch (error2) {
            doneAndReject(error2);
          }
        }, doneAndReject);
      } catch (error) {
        doneAndReject(error);
      }
    };

    loop();
  });
});

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  filter: function filter(filterer) {
    return new AsyncIteratorProxy$3(getIteratorDirect(this), {
      filterer: aCallable(filterer)
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $find = asyncIteratorIteration.find;

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  find: function find(fn) {
    return $find(this, fn);
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var AsyncIteratorProxy$2 = asyncIteratorCreateProxy(function (Promise) {
  var state = this;
  var iterator = state.iterator;
  var mapper = state.mapper;
  var innerIterator;
  return new Promise(function (resolve, reject) {
    var doneAndReject = function doneAndReject(error) {
      state.done = true;
      reject(error);
    };

    var ifAbruptCloseAsyncIterator = function ifAbruptCloseAsyncIterator(error) {
      asyncIteratorClose(iterator, doneAndReject, error, doneAndReject);
    };

    var outerLoop = function outerLoop() {
      try {
        Promise.resolve(anObject(functionCall(state.next, iterator))).then(function (step) {
          try {
            if (anObject(step).done) {
              state.done = true;
              resolve(createIterResultObject(undefined, true));
            } else {
              var value = step.value;

              try {
                Promise.resolve(mapper(value)).then(function (mapped) {
                  try {
                    state.innerIterator = innerIterator = getAsyncIterator(mapped);
                    state.innerNext = aCallable(innerIterator.next);
                    innerLoop();
                  } catch (error4) {
                    ifAbruptCloseAsyncIterator(error4);
                  }
                }, ifAbruptCloseAsyncIterator);
              } catch (error3) {
                ifAbruptCloseAsyncIterator(error3);
              }
            }
          } catch (error2) {
            doneAndReject(error2);
          }
        }, doneAndReject);
      } catch (error) {
        doneAndReject(error);
      }
    };

    var innerLoop = function innerLoop() {
      if (innerIterator = state.innerIterator) {
        try {
          Promise.resolve(anObject(functionCall(state.innerNext, innerIterator))).then(function (result) {
            try {
              if (anObject(result).done) {
                state.innerIterator = state.innerNext = null;
                outerLoop();
              } else resolve(createIterResultObject(result.value, false));
            } catch (error1) {
              ifAbruptCloseAsyncIterator(error1);
            }
          }, ifAbruptCloseAsyncIterator);
        } catch (error) {
          ifAbruptCloseAsyncIterator(error);
        }
      } else outerLoop();
    };

    innerLoop();
  });
});

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  flatMap: function flatMap(mapper) {
    return new AsyncIteratorProxy$2(getIteratorDirect(this), {
      mapper: aCallable(mapper),
      innerIterator: null,
      innerNext: null
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $forEach = asyncIteratorIteration.forEach;

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  forEach: function forEach(fn) {
    return $forEach(this, fn);
  }
});

var asyncIteratorWrap = asyncIteratorCreateProxy(function () {
  return functionCall(this.next, this.iterator);
}, true); // https://github.com/tc39/proposal-iterator-helpers

var ASYNC_ITERATOR = wellKnownSymbol('asyncIterator');

_export({
  target: 'AsyncIterator',
  stat: true,
  forced: true
}, {
  from: function from(O) {
    var object = toObject$1(O);
    var usingIterator = getMethod(object, ASYNC_ITERATOR);
    var iterator;

    if (usingIterator) {
      iterator = getAsyncIterator(object, usingIterator);
      if (objectIsPrototypeOf(asyncIteratorPrototype, iterator)) return iterator;
    }

    if (iterator === undefined) {
      usingIterator = getIteratorMethod(object);
      if (usingIterator) iterator = new asyncFromSyncIterator(getIterator(object, usingIterator));
    }

    return new asyncIteratorWrap(getIteratorDirect(iterator !== undefined ? iterator : object));
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  indexed: asyncIteratorIndexed
}); // https://github.com/tc39/proposal-iterator-helpers


var AsyncIteratorProxy$1 = asyncIteratorCreateProxy(function (Promise) {
  var state = this;
  var iterator = state.iterator;
  var mapper = state.mapper;
  return new Promise(function (resolve, reject) {
    var doneAndReject = function doneAndReject(error) {
      state.done = true;
      reject(error);
    };

    var ifAbruptCloseAsyncIterator = function ifAbruptCloseAsyncIterator(error) {
      asyncIteratorClose(iterator, doneAndReject, error, doneAndReject);
    };

    Promise.resolve(anObject(functionCall(state.next, iterator))).then(function (step) {
      try {
        if (anObject(step).done) {
          state.done = true;
          resolve(createIterResultObject(undefined, true));
        } else {
          var value = step.value;

          try {
            Promise.resolve(mapper(value)).then(function (mapped) {
              resolve(createIterResultObject(mapped, false));
            }, ifAbruptCloseAsyncIterator);
          } catch (error2) {
            ifAbruptCloseAsyncIterator(error2);
          }
        }
      } catch (error) {
        doneAndReject(error);
      }
    }, doneAndReject);
  });
});

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  map: function map(mapper) {
    return new AsyncIteratorProxy$1(getIteratorDirect(this), {
      mapper: aCallable(mapper)
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var Promise$3 = getBuiltIn('Promise');
var $TypeError$b = TypeError;

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  reduce: function reduce(reducer
  /* , initialValue */
  ) {
    var record = getIteratorDirect(this);
    var iterator = record.iterator;
    var next = record.next;
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aCallable(reducer);
    return new Promise$3(function (resolve, reject) {
      var ifAbruptCloseAsyncIterator = function ifAbruptCloseAsyncIterator(error) {
        asyncIteratorClose(iterator, reject, error, reject);
      };

      var loop = function loop() {
        try {
          Promise$3.resolve(anObject(functionCall(next, iterator))).then(function (step) {
            try {
              if (anObject(step).done) {
                noInitial ? reject($TypeError$b('Reduce of empty iterator with no initial value')) : resolve(accumulator);
              } else {
                var value = step.value;

                if (noInitial) {
                  noInitial = false;
                  accumulator = value;
                  loop();
                } else try {
                  Promise$3.resolve(reducer(accumulator, value)).then(function (result) {
                    accumulator = result;
                    loop();
                  }, ifAbruptCloseAsyncIterator);
                } catch (error3) {
                  ifAbruptCloseAsyncIterator(error3);
                }
              }
            } catch (error2) {
              reject(error2);
            }
          }, reject);
        } catch (error) {
          reject(error);
        }
      };

      loop();
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $some = asyncIteratorIteration.some;

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  some: function some(fn) {
    return $some(this, fn);
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var AsyncIteratorProxy = asyncIteratorCreateProxy(function (Promise) {
  var state = this;
  var iterator = state.iterator;
  var returnMethod;

  if (!state.remaining--) {
    var resultDone = createIterResultObject(undefined, true);
    state.done = true;
    returnMethod = iterator['return'];

    if (returnMethod !== undefined) {
      return Promise.resolve(functionCall(returnMethod, iterator, undefined)).then(function () {
        return resultDone;
      });
    }

    return resultDone;
  }

  return Promise.resolve(functionCall(state.next, iterator)).then(function (step) {
    if (anObject(step).done) {
      state.done = true;
      return createIterResultObject(undefined, true);
    }

    return createIterResultObject(step.value, false);
  }).then(null, function (error) {
    state.done = true;
    throw error;
  });
});

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  take: function take(limit) {
    return new AsyncIteratorProxy(getIteratorDirect(this), {
      remaining: toPositiveInteger(notANan(+limit))
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $toArray = asyncIteratorIteration.toArray;

_export({
  target: 'AsyncIterator',
  proto: true,
  real: true,
  forced: true
}, {
  toArray: function toArray() {
    return $toArray(this, undefined, []);
  }
});

var defineProperties = objectDefineProperties.f;
var INCORRECT_RANGE = 'Incorrect Number.range arguments';
var NUMERIC_RANGE_ITERATOR = 'NumericRangeIterator';
var setInternalState$8 = internalState.set;
var getInternalState$4 = internalState.getterFor(NUMERIC_RANGE_ITERATOR);
var $RangeError$2 = RangeError;
var $TypeError$a = TypeError;
var $RangeIterator = iteratorCreateConstructor(function NumericRangeIterator(start, end, option, type, zero, one) {
  if (typeof start != type || end !== Infinity && end !== -Infinity && typeof end != type) {
    throw $TypeError$a(INCORRECT_RANGE);
  }

  if (start === Infinity || start === -Infinity) {
    throw $RangeError$2(INCORRECT_RANGE);
  }

  var ifIncrease = end > start;
  var inclusiveEnd = false;
  var step;

  if (option === undefined) {
    step = undefined;
  } else if (isObject$6(option)) {
    step = option.step;
    inclusiveEnd = !!option.inclusive;
  } else if (typeof option == type) {
    step = option;
  } else {
    throw $TypeError$a(INCORRECT_RANGE);
  }

  if (isNullOrUndefined(step)) {
    step = ifIncrease ? one : -one;
  }

  if (typeof step != type) {
    throw $TypeError$a(INCORRECT_RANGE);
  }

  if (step === Infinity || step === -Infinity || step === zero && start !== end) {
    throw $RangeError$2(INCORRECT_RANGE);
  } // eslint-disable-next-line no-self-compare -- NaN check


  var hitsEnd = start != start || end != end || step != step || end > start !== step > zero;
  setInternalState$8(this, {
    type: NUMERIC_RANGE_ITERATOR,
    start: start,
    end: end,
    step: step,
    inclusiveEnd: inclusiveEnd,
    hitsEnd: hitsEnd,
    currentCount: zero,
    zero: zero
  });

  if (!descriptors) {
    this.start = start;
    this.end = end;
    this.step = step;
    this.inclusive = inclusiveEnd;
  }
}, NUMERIC_RANGE_ITERATOR, function next() {
  var state = getInternalState$4(this);
  if (state.hitsEnd) return createIterResultObject(undefined, true);
  var start = state.start;
  var end = state.end;
  var step = state.step;
  var currentYieldingValue = start + step * state.currentCount++;
  if (currentYieldingValue === end) state.hitsEnd = true;
  var inclusiveEnd = state.inclusiveEnd;
  var endCondition;

  if (end > start) {
    endCondition = inclusiveEnd ? currentYieldingValue > end : currentYieldingValue >= end;
  } else {
    endCondition = inclusiveEnd ? end > currentYieldingValue : end >= currentYieldingValue;
  }

  if (endCondition) {
    state.hitsEnd = true;
    return createIterResultObject(undefined, true);
  }

  return createIterResultObject(currentYieldingValue, false);
});

var getter = function getter(fn) {
  return {
    get: fn,
    set: function set() {
      /* empty */
    },
    configurable: true,
    enumerable: false
  };
};

if (descriptors) {
  defineProperties($RangeIterator.prototype, {
    start: getter(function () {
      return getInternalState$4(this).start;
    }),
    end: getter(function () {
      return getInternalState$4(this).end;
    }),
    inclusive: getter(function () {
      return getInternalState$4(this).inclusiveEnd;
    }),
    step: getter(function () {
      return getInternalState$4(this).step;
    })
  });
}

var numericRangeIterator = $RangeIterator;
/* eslint-disable es/no-bigint -- safe */
// `BigInt.range` method
// https://github.com/tc39/proposal-Number.range

if (typeof BigInt == 'function') {
  _export({
    target: 'BigInt',
    stat: true,
    forced: true
  }, {
    range: function range(start, end, option) {
      return new numericRangeIterator(start, end, option, 'bigint', BigInt(0), BigInt(1));
    }
  });
} // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`


var $Object$1 = Object;
var $TypeError$9 = TypeError;
var Map$6 = getBuiltIn('Map');
var WeakMap$4 = getBuiltIn('WeakMap');

var Node = function Node() {
  // keys
  this.object = null;
  this.symbol = null; // child nodes

  this.primitives = null;
  this.objectsByIndex = objectCreate$1(null);
};

Node.prototype.get = function (key, initializer) {
  return this[key] || (this[key] = initializer());
};

Node.prototype.next = function (i, it, IS_OBJECT) {
  var store = IS_OBJECT ? this.objectsByIndex[i] || (this.objectsByIndex[i] = new WeakMap$4()) : this.primitives || (this.primitives = new Map$6());
  var entry = store.get(it);
  if (!entry) store.set(it, entry = new Node());
  return entry;
};

var root$2 = new Node();

var compositeKey = function compositeKey() {
  var active = root$2;
  var length = arguments.length;
  var i, it; // for prevent leaking, start from objects

  for (i = 0; i < length; i++) {
    if (isObject$6(it = arguments[i])) active = active.next(i, it, true);
  }

  if (this === $Object$1 && active === root$2) throw $TypeError$9('Composite keys must contain a non-primitive component');

  for (i = 0; i < length; i++) {
    if (!isObject$6(it = arguments[i])) active = active.next(i, it, false);
  }

  return active;
};

var $Object = Object;

var initializer = function initializer() {
  var freeze = getBuiltIn('Object', 'freeze');
  return freeze ? freeze(objectCreate$1(null)) : objectCreate$1(null);
}; // https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey


_export({
  global: true,
  forced: true
}, {
  compositeKey: function compositeKey$1() {
    return functionApply(compositeKey, $Object, arguments).get('object', initializer);
  }
}); // https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey


_export({
  global: true,
  forced: true
}, {
  compositeSymbol: function compositeSymbol() {
    if (arguments.length == 1 && typeof arguments[0] == 'string') return getBuiltIn('Symbol')['for'](arguments[0]);
    return functionApply(compositeKey, null, arguments).get('symbol', getBuiltIn('Symbol'));
  }
}); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe


var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
var classRegExp = /^\s*class\b/;
var exec$4 = functionUncurryThis(classRegExp.exec);

var isClassConstructor = function isClassConstructor(argument) {
  try {
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    if (!descriptors || !exec$4(classRegExp, inspectSource(argument))) return false;
  } catch (error) {
    /* empty */
  }

  var prototype = getOwnPropertyDescriptor$2(argument, 'prototype');
  return !!prototype && hasOwnProperty_1(prototype, 'writable') && !prototype.writable;
}; // `Function.isCallable` method
// https://github.com/caitp/TC39-Proposals/blob/trunk/tc39-reflect-isconstructor-iscallable.md


_export({
  target: 'Function',
  stat: true,
  sham: true,
  forced: true
}, {
  isCallable: function isCallable$1(argument) {
    return isCallable(argument) && !isClassConstructor(argument);
  }
}); // `Function.isConstructor` method
// https://github.com/caitp/TC39-Proposals/blob/trunk/tc39-reflect-isconstructor-iscallable.md


_export({
  target: 'Function',
  stat: true,
  forced: true
}, {
  isConstructor: isConstructor
}); // `Function.prototype.unThis` method
// https://github.com/js-choi/proposal-function-un-this


_export({
  target: 'Function',
  proto: true,
  forced: true
}, {
  unThis: function unThis() {
    return functionUncurryThisRaw(aCallable(this));
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var NativeIterator = global$1.Iterator; // FF56- have non-standard global helper `Iterator`

var FORCED = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$2 // FF44- non-standard `Iterator` passes previous tests
|| !fails(function () {
  NativeIterator({});
});

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype$2);
};

if (!hasOwnProperty_1(IteratorPrototype$2, TO_STRING_TAG$2)) {
  createNonEnumerableProperty(IteratorPrototype$2, TO_STRING_TAG$2, 'Iterator');
}

if (FORCED || !hasOwnProperty_1(IteratorPrototype$2, 'constructor') || IteratorPrototype$2.constructor === Object) {
  createNonEnumerableProperty(IteratorPrototype$2, 'constructor', IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype$2;

_export({
  global: true,
  constructor: true,
  forced: FORCED
}, {
  Iterator: IteratorConstructor
});

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState$7 = internalState.set;
var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');

var createIteratorProxyPrototype = function createIteratorProxyPrototype(IS_ITERATOR) {
  var ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
  var getInternalState = internalState.getterFor(ITERATOR_PROXY);
  var IteratorProxyPrototype = defineBuiltIns(objectCreate$1(IteratorPrototype$1), {
    next: function next() {
      var state = getInternalState(this); // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value

      if (IS_ITERATOR) return state.nextHandler();

      try {
        var result = state.done ? undefined : state.nextHandler();
        return createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function _return() {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;

      if (IS_ITERATOR) {
        var returnMethod = getMethod(iterator, 'return');
        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
      }

      var innerIterator = state.innerIterator;
      if (innerIterator) try {
        iteratorClose(innerIterator, 'return');
      } catch (error) {
        return iteratorClose(iterator, 'throw', error);
      }
      iteratorClose(iterator, 'return');
      return createIterResultObject(undefined, true);
    }
  });

  if (!IS_ITERATOR) {
    createNonEnumerableProperty(IteratorProxyPrototype, TO_STRING_TAG$1, 'Iterator Helper');
  }

  return IteratorProxyPrototype;
};

var IteratorHelperPrototype = createIteratorProxyPrototype(false);
var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);

var iteratorCreateProxy = function iteratorCreateProxy(nextHandler, IS_ITERATOR) {
  var ITERATOR_PROXY = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;

  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;

    state.type = ITERATOR_PROXY;
    state.nextHandler = nextHandler;
    state.done = false;
    setInternalState$7(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
  return IteratorProxy;
}; // https://github.com/tc39/proposal-iterator-helpers


var IteratorProxy$6 = iteratorCreateProxy(function () {
  var result = anObject(functionCall(this.next, this.iterator));
  var done = this.done = !!result.done;
  if (!done) return [this.index++, result.value];
});

var iteratorIndexed = function indexed() {
  return new IteratorProxy$6(getIteratorDirect(this), {
    index: 0
  });
}; // TODO: Remove from `core-js@4`
// https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  name: 'indexed',
  proto: true,
  real: true,
  forced: true
}, {
  asIndexedPairs: iteratorIndexed
}); // https://github.com/tc39/proposal-iterator-helpers


var IteratorProxy$5 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var next = this.next;
  var result, done;

  while (this.remaining) {
    this.remaining--;
    result = anObject(functionCall(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
  }

  result = anObject(functionCall(next, iterator));
  done = this.done = !!result.done;
  if (!done) return result.value;
});

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  drop: function drop(limit) {
    return new IteratorProxy$5(getIteratorDirect(this), {
      remaining: toPositiveInteger(notANan(+limit))
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  every: function every(fn) {
    var record = getIteratorDirect(this);
    aCallable(fn);
    return !iterate(record, function (value, stop) {
      if (!fn(value)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var IteratorProxy$4 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var filterer = this.filterer;
  var next = this.next;
  var result, done, value;

  while (true) {
    result = anObject(functionCall(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, filterer, value)) return value;
  }
});

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  filter: function filter(filterer) {
    return new IteratorProxy$4(getIteratorDirect(this), {
      filterer: aCallable(filterer)
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  find: function find(fn) {
    var record = getIteratorDirect(this);
    aCallable(fn);
    return iterate(record, function (value, stop) {
      if (fn(value)) return stop(value);
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).result;
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $TypeError$8 = TypeError;
var IteratorProxy$3 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var mapper = this.mapper;
  var result, mapped, iteratorMethod, innerIterator;

  while (true) {
    if (innerIterator = this.innerIterator) try {
      result = anObject(functionCall(this.innerNext, innerIterator));
      if (!result.done) return result.value;
      this.innerIterator = this.innerNext = null;
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    result = anObject(functionCall(this.next, iterator));
    if (this.done = !!result.done) return;

    try {
      mapped = mapper(result.value);
      iteratorMethod = getIteratorMethod(mapped);

      if (!iteratorMethod) {
        throw $TypeError$8('.flatMap callback should return an iterable object');
      }

      this.innerIterator = innerIterator = anObject(functionCall(iteratorMethod, mapped));
      this.innerNext = aCallable(innerIterator.next);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
  }
});

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  flatMap: function flatMap(mapper) {
    return new IteratorProxy$3(getIteratorDirect(this), {
      mapper: aCallable(mapper),
      innerIterator: null,
      innerNext: null
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  forEach: function forEach(fn) {
    iterate(getIteratorDirect(this), fn, {
      IS_RECORD: true
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var IteratorPrototype = iteratorsCore.IteratorPrototype;
var IteratorProxy$2 = iteratorCreateProxy(function () {
  return functionCall(this.next, this.iterator);
}, true);

_export({
  target: 'Iterator',
  stat: true,
  forced: true
}, {
  from: function from(O) {
    var object = toObject$1(O);
    var usingIterator = getIteratorMethod(object);
    var iterator;

    if (usingIterator) {
      iterator = getIterator(object, usingIterator);
      if (objectIsPrototypeOf(IteratorPrototype, iterator)) return iterator;
    } else {
      iterator = object;
    }

    return new IteratorProxy$2(getIteratorDirect(iterator));
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  indexed: iteratorIndexed
}); // https://github.com/tc39/proposal-iterator-helpers


var IteratorProxy$1 = iteratorCreateProxy(function () {
  var iterator = this.iterator;
  var result = anObject(functionCall(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, result.value);
});

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  map: function map(mapper) {
    return new IteratorProxy$1(getIteratorDirect(this), {
      mapper: aCallable(mapper)
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var $TypeError$7 = TypeError;

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  reduce: function reduce(reducer
  /* , initialValue */
  ) {
    var record = getIteratorDirect(this);
    aCallable(reducer);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    iterate(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value);
      }
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw $TypeError$7('Reduce of empty iterator with no initial value');
    return accumulator;
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  some: function some(fn) {
    var record = getIteratorDirect(this);
    aCallable(fn);
    return iterate(record, function (value, stop) {
      if (fn(value)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var IteratorProxy = iteratorCreateProxy(function () {
  var iterator = this.iterator;

  if (!this.remaining--) {
    this.done = true;
    return iteratorClose(iterator, 'normal', undefined);
  }

  var result = anObject(functionCall(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return result.value;
});

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  take: function take(limit) {
    return new IteratorProxy(getIteratorDirect(this), {
      remaining: toPositiveInteger(notANan(+limit))
    });
  }
}); // https://github.com/tc39/proposal-iterator-helpers


var push$9 = [].push;

_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  toArray: function toArray() {
    var result = [];
    iterate(getIteratorDirect(this), push$9, {
      that: result,
      IS_RECORD: true
    });
    return result;
  }
}); // https://github.com/tc39/proposal-iterator-helpers


_export({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: true
}, {
  toAsync: function toAsync() {
    return new asyncIteratorWrap(getIteratorDirect(new asyncFromSyncIterator(this)));
  }
}); // https://github.com/tc39/collection-methods


var collectionDeleteAll = function
  /* ...elements */
deleteAll() {
  var collection = anObject(this);
  var remover = aCallable(collection['delete']);
  var allDeleted = true;
  var wasDeleted;

  for (var k = 0, len = arguments.length; k < len; k++) {
    wasDeleted = functionCall(remover, collection, arguments[k]);
    allDeleted = allDeleted && wasDeleted;
  }

  return !!allDeleted;
}; // `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  deleteAll: collectionDeleteAll
}); // `Map.prototype.emplace` method
// https://github.com/thumbsupep/proposal-upsert


var mapEmplace = function emplace(key, handler) {
  var map = anObject(this);
  var get = aCallable(map.get);
  var has = aCallable(map.has);
  var set = aCallable(map.set);
  var value, inserted;

  if (functionCall(has, map, key)) {
    value = functionCall(get, map, key);

    if ('update' in handler) {
      value = handler.update(value, key, map);
      functionCall(set, map, key, value);
    }

    return value;
  }

  inserted = handler.insert(key, map);
  functionCall(set, map, key, inserted);
  return inserted;
}; // `Map.prototype.emplace` method
// https://github.com/thumbsupep/proposal-upsert


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  emplace: mapEmplace
});

var getMapIterator = function getMapIterator(it) {
  // eslint-disable-next-line es/no-map -- safe
  return functionCall(Map.prototype.entries, it);
}; // `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  every: function every(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return !iterate(iterator, function (key, value, stop) {
      if (!boundFunction(value, key, map)) return stop();
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aCallable(newMap.set);
    iterate(iterator, function (key, value) {
      if (boundFunction(value, key, map)) functionCall(setter, newMap, key, value);
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true
    });
    return newMap;
  }
}); // `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  find: function find(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(iterator, function (key, value, stop) {
      if (boundFunction(value, key, map)) return stop(value);
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).result;
  }
}); // `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  findKey: function findKey(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(iterator, function (key, value, stop) {
      if (boundFunction(value, key, map)) return stop(key);
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).result;
  }
}); // https://tc39.github.io/proposal-setmap-offrom/


var push$8 = [].push;

var collectionFrom = function from(source
/* , mapFn, thisArg */
) {
  var length = arguments.length;
  var mapFn = length > 1 ? arguments[1] : undefined;
  var mapping, array, n, boundFunction;
  aConstructor(this);
  mapping = mapFn !== undefined;
  if (mapping) aCallable(mapFn);
  if (isNullOrUndefined(source)) return new this();
  array = [];

  if (mapping) {
    n = 0;
    boundFunction = functionBindContext(mapFn, length > 2 ? arguments[2] : undefined);
    iterate(source, function (nextItem) {
      functionCall(push$8, array, boundFunction(nextItem, n++));
    });
  } else {
    iterate(source, push$8, {
      that: array
    });
  }

  return new this(array);
}; // `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from


_export({
  target: 'Map',
  stat: true,
  forced: true
}, {
  from: collectionFrom
});

var push$7 = functionUncurryThis([].push); // `Map.groupBy` method
// https://github.com/tc39/proposal-collection-methods

_export({
  target: 'Map',
  stat: true,
  forced: true
}, {
  groupBy: function groupBy(iterable, keyDerivative) {
    aCallable(keyDerivative);
    var iterator = getIterator(iterable);
    var newMap = new this();
    var has = aCallable(newMap.has);
    var get = aCallable(newMap.get);
    var set = aCallable(newMap.set);
    iterate(iterator, function (element) {
      var derivedKey = keyDerivative(element);
      if (!functionCall(has, newMap, derivedKey)) functionCall(set, newMap, derivedKey, [element]);else push$7(functionCall(get, newMap, derivedKey), element);
    }, {
      IS_ITERATOR: true
    });
    return newMap;
  }
}); // `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero


var sameValueZero = function sameValueZero(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y || x != x && y != y;
}; // `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  includes: function includes(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value, stop) {
      if (sameValueZero(value, searchElement)) return stop();
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  stat: true,
  forced: true
}, {
  keyBy: function keyBy(iterable, keyDerivative) {
    var newMap = new this();
    aCallable(keyDerivative);
    var setter = aCallable(newMap.set);
    iterate(iterable, function (element) {
      functionCall(setter, newMap, keyDerivative(element), element);
    });
    return newMap;
  }
}); // `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  keyOf: function keyOf(searchElement) {
    return iterate(getMapIterator(anObject(this)), function (key, value, stop) {
      if (value === searchElement) return stop(key);
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).result;
  }
}); // `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  mapKeys: function mapKeys(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aCallable(newMap.set);
    iterate(iterator, function (key, value) {
      functionCall(setter, newMap, boundFunction(value, key, map), value);
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true
    });
    return newMap;
  }
}); // `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  mapValues: function mapValues(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newMap = new (speciesConstructor(map, getBuiltIn('Map')))();
    var setter = aCallable(newMap.set);
    iterate(iterator, function (key, value) {
      functionCall(setter, newMap, key, boundFunction(value, key, map));
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true
    });
    return newMap;
  }
}); // `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  arity: 1,
  forced: true
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  merge: function merge(iterable
  /* ...iterables */
  ) {
    var map = anObject(this);
    var setter = aCallable(map.set);
    var argumentsLength = arguments.length;
    var i = 0;

    while (i < argumentsLength) {
      iterate(arguments[i++], setter, {
        that: map,
        AS_ENTRIES: true
      });
    }

    return map;
  }
}); // https://tc39.github.io/proposal-setmap-offrom/


var collectionOf = function of() {
  return new this(arraySlice$1(arguments));
}; // `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of


_export({
  target: 'Map',
  stat: true,
  forced: true
}, {
  of: collectionOf
});

var $TypeError$6 = TypeError; // `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods

_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  reduce: function reduce(callbackfn
  /* , initialValue */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aCallable(callbackfn);
    iterate(iterator, function (key, value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, key, map);
      }
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true
    });
    if (noInitial) throw $TypeError$6('Reduce of empty map with no initial value');
    return accumulator;
  }
}); // `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  some: function some(callbackfn
  /* , thisArg */
  ) {
    var map = anObject(this);
    var iterator = getMapIterator(map);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(iterator, function (key, value, stop) {
      if (boundFunction(value, key, map)) return stop();
    }, {
      AS_ENTRIES: true,
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
});

var $TypeError$5 = TypeError; // `Set.prototype.update` method
// https://github.com/tc39/proposal-collection-methods

_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  update: function update(key, callback
  /* , thunk */
  ) {
    var map = anObject(this);
    var get = aCallable(map.get);
    var has = aCallable(map.has);
    var set = aCallable(map.set);
    var length = arguments.length;
    aCallable(callback);
    var isPresentInMap = functionCall(has, map, key);

    if (!isPresentInMap && length < 3) {
      throw $TypeError$5('Updating absent value');
    }

    var value = isPresentInMap ? functionCall(get, map, key) : aCallable(length > 2 ? arguments[2] : undefined)(key, map);
    functionCall(set, map, key, callback(value, key, map));
    return map;
  }
});

var $TypeError$4 = TypeError; // `Map.prototype.upsert` method
// https://github.com/thumbsupep/proposal-upsert

var mapUpsert = function upsert(key, updateFn
/* , insertFn */
) {
  var map = anObject(this);
  var get = aCallable(map.get);
  var has = aCallable(map.has);
  var set = aCallable(map.set);
  var insertFn = arguments.length > 2 ? arguments[2] : undefined;
  var value;

  if (!isCallable(updateFn) && !isCallable(insertFn)) {
    throw $TypeError$4('At least one callback required');
  }

  if (functionCall(has, map, key)) {
    value = functionCall(get, map, key);

    if (isCallable(updateFn)) {
      value = updateFn(value);
      functionCall(set, map, key, value);
    }
  } else if (isCallable(insertFn)) {
    value = insertFn();
    functionCall(set, map, key, value);
  }

  return value;
}; // TODO: remove from `core-js@4`
// `Map.prototype.updateOrInsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert


_export({
  target: 'Map',
  proto: true,
  real: true,
  name: 'upsert',
  forced: true
}, {
  updateOrInsert: mapUpsert
}); // TODO: remove from `core-js@4`
// `Map.prototype.upsert` method (replaced by `Map.prototype.emplace`)
// https://github.com/thumbsupep/proposal-upsert


_export({
  target: 'Map',
  proto: true,
  real: true,
  forced: true
}, {
  upsert: mapUpsert
});

var min$1 = Math.min;
var max$1 = Math.max; // `Math.clamp` method
// https://rwaldron.github.io/proposal-math-extensions/

_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  clamp: function clamp(x, lower, upper) {
    return min$1(upper, max$1(lower, x));
  }
}); // `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/


_export({
  target: 'Math',
  stat: true,
  nonConfigurable: true,
  nonWritable: true
}, {
  DEG_PER_RAD: Math.PI / 180
});

var RAD_PER_DEG = 180 / Math.PI; // `Math.degrees` method
// https://rwaldron.github.io/proposal-math-extensions/

_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
}); // `Math.scale` method implementation
// https://rwaldron.github.io/proposal-math-extensions/


var mathScale = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  var nx = +x;
  var nInLow = +inLow;
  var nInHigh = +inHigh;
  var nOutLow = +outLow;
  var nOutHigh = +outHigh; // eslint-disable-next-line no-self-compare -- NaN check

  if (nx != nx || nInLow != nInLow || nInHigh != nInHigh || nOutLow != nOutLow || nOutHigh != nOutHigh) return NaN;
  if (nx === Infinity || nx === -Infinity) return nx;
  return (nx - nInLow) * (nOutHigh - nOutLow) / (nInHigh - nInLow) + nOutLow;
}; // `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return mathFround(mathScale(x, inLow, inHigh, outLow, outHigh));
  }
}); // `Math.iaddh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
}); // `Math.imulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  imulh: function imulh(u, v) {
    var UINT16 = 0xFFFF;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
}); // `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
}); // `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/


_export({
  target: 'Math',
  stat: true,
  nonConfigurable: true,
  nonWritable: true
}, {
  RAD_PER_DEG: 180 / Math.PI
});

var DEG_PER_RAD = Math.PI / 180; // `Math.radians` method
// https://rwaldron.github.io/proposal-math-extensions/

_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
}); // `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  scale: mathScale
});

var SEEDED_RANDOM = 'Seeded Random';
var SEEDED_RANDOM_GENERATOR = SEEDED_RANDOM + ' Generator';
var SEED_TYPE_ERROR = 'Math.seededPRNG() argument should have a "seed" field with a finite value.';
var setInternalState$6 = internalState.set;
var getInternalState$3 = internalState.getterFor(SEEDED_RANDOM_GENERATOR);
var $TypeError$3 = TypeError;
var $SeededRandomGenerator = iteratorCreateConstructor(function SeededRandomGenerator(seed) {
  setInternalState$6(this, {
    type: SEEDED_RANDOM_GENERATOR,
    seed: seed % 2147483647
  });
}, SEEDED_RANDOM, function next() {
  var state = getInternalState$3(this);
  var seed = state.seed = (state.seed * 1103515245 + 12345) % 2147483647;
  return createIterResultObject((seed & 1073741823) / 1073741823, false);
}); // `Math.seededPRNG` method
// https://github.com/tc39/proposal-seeded-random
// based on https://github.com/tc39/proposal-seeded-random/blob/78b8258835b57fc2100d076151ab506bc3202ae6/demo.html

_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  seededPRNG: function seededPRNG(it) {
    var seed = anObject(it).seed;
    if (!numberIsFinite(seed)) throw $TypeError$3(SEED_TYPE_ERROR);
    return new $SeededRandomGenerator(seed);
  }
}); // `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  signbit: function signbit(x) {
    var n = +x; // eslint-disable-next-line no-self-compare -- NaN check

    return n == n && n == 0 ? 1 / n == -Infinity : n < 0;
  }
}); // `Math.umulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`


_export({
  target: 'Math',
  stat: true,
  forced: true
}, {
  umulh: function umulh(u, v) {
    var UINT16 = 0xFFFF;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

var INVALID_NUMBER_REPRESENTATION = 'Invalid number representation';
var INVALID_RADIX = 'Invalid radix';
var $RangeError$1 = RangeError;
var $SyntaxError = SyntaxError;
var $TypeError$2 = TypeError;
var valid = /^[\da-z]+$/;
var charAt$6 = functionUncurryThis(''.charAt);
var exec$3 = functionUncurryThis(valid.exec);
var numberToString$1 = functionUncurryThis(1.0.toString);
var stringSlice$2 = functionUncurryThis(''.slice); // `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring

_export({
  target: 'Number',
  stat: true,
  forced: true
}, {
  fromString: function fromString(string, radix) {
    var sign = 1;
    var R, mathNum;
    if (typeof string != 'string') throw $TypeError$2(INVALID_NUMBER_REPRESENTATION);
    if (!string.length) throw $SyntaxError(INVALID_NUMBER_REPRESENTATION);

    if (charAt$6(string, 0) == '-') {
      sign = -1;
      string = stringSlice$2(string, 1);
      if (!string.length) throw $SyntaxError(INVALID_NUMBER_REPRESENTATION);
    }

    R = radix === undefined ? 10 : toIntegerOrInfinity(radix);
    if (R < 2 || R > 36) throw $RangeError$1(INVALID_RADIX);

    if (!exec$3(valid, string) || numberToString$1(mathNum = numberParseInt(string, R), R) !== string) {
      throw $SyntaxError(INVALID_NUMBER_REPRESENTATION);
    }

    return sign * mathNum;
  }
}); // `Number.range` method
// https://github.com/tc39/proposal-Number.range


_export({
  target: 'Number',
  stat: true,
  forced: true
}, {
  range: function range(start, end, option) {
    return new numericRangeIterator(start, end, option, 'number', 0, 1);
  }
});

var OBJECT_ITERATOR = 'Object Iterator';
var setInternalState$5 = internalState.set;
var getInternalState$2 = internalState.getterFor(OBJECT_ITERATOR);
var objectIterator = iteratorCreateConstructor(function ObjectIterator(source, mode) {
  var object = toObject$1(source);
  setInternalState$5(this, {
    type: OBJECT_ITERATOR,
    mode: mode,
    object: object,
    keys: objectKeys$1(object),
    index: 0
  });
}, 'Object', function next() {
  var state = getInternalState$2(this);
  var keys = state.keys;

  while (true) {
    if (keys === null || state.index >= keys.length) {
      state.object = state.keys = null;
      return createIterResultObject(undefined, true);
    }

    var key = keys[state.index++];
    var object = state.object;
    if (!hasOwnProperty_1(object, key)) continue;

    switch (state.mode) {
      case 'keys':
        return createIterResultObject(key, false);

      case 'values':
        return createIterResultObject(object[key], false);
    }
    /* entries */


    return createIterResultObject([key, object[key]], false);
  }
}); // TODO: Remove from `core-js@4`
// `Object.iterateEntries` method
// https://github.com/tc39/proposal-object-iteration

_export({
  target: 'Object',
  stat: true,
  forced: true
}, {
  iterateEntries: function iterateEntries(object) {
    return new objectIterator(object, 'entries');
  }
}); // TODO: Remove from `core-js@4`
// `Object.iterateKeys` method
// https://github.com/tc39/proposal-object-iteration


_export({
  target: 'Object',
  stat: true,
  forced: true
}, {
  iterateKeys: function iterateKeys(object) {
    return new objectIterator(object, 'keys');
  }
}); // TODO: Remove from `core-js@4`
// `Object.iterateValues` method
// https://github.com/tc39/proposal-object-iteration


_export({
  target: 'Object',
  stat: true,
  forced: true
}, {
  iterateValues: function iterateValues(object) {
    return new objectIterator(object, 'values');
  }
});

var $$OBSERVABLE$2 = wellKnownSymbol('observable');
var NativeObservable = global$1.Observable;
var NativeObservablePrototype = NativeObservable && NativeObservable.prototype;
var observableForced = !isCallable(NativeObservable) || !isCallable(NativeObservable.from) || !isCallable(NativeObservable.of) || !isCallable(NativeObservablePrototype.subscribe) || !isCallable(NativeObservablePrototype[$$OBSERVABLE$2]); // https://github.com/tc39/proposal-observable

var $$OBSERVABLE$1 = wellKnownSymbol('observable');
var OBSERVABLE = 'Observable';
var SUBSCRIPTION = 'Subscription';
var SUBSCRIPTION_OBSERVER = 'SubscriptionObserver';
var getterFor$1 = internalState.getterFor;
var setInternalState$4 = internalState.set;
var getObservableInternalState = getterFor$1(OBSERVABLE);
var getSubscriptionInternalState = getterFor$1(SUBSCRIPTION);
var getSubscriptionObserverInternalState = getterFor$1(SUBSCRIPTION_OBSERVER);

var SubscriptionState = function SubscriptionState(observer) {
  this.observer = anObject(observer);
  this.cleanup = undefined;
  this.subscriptionObserver = undefined;
};

SubscriptionState.prototype = {
  type: SUBSCRIPTION,
  clean: function clean() {
    var cleanup = this.cleanup;

    if (cleanup) {
      this.cleanup = undefined;

      try {
        cleanup();
      } catch (error) {
        hostReportErrors(error);
      }
    }
  },
  close: function close() {
    if (!descriptors) {
      var subscription = this.facade;
      var subscriptionObserver = this.subscriptionObserver;
      subscription.closed = true;
      if (subscriptionObserver) subscriptionObserver.closed = true;
    }

    this.observer = undefined;
  },
  isClosed: function isClosed() {
    return this.observer === undefined;
  }
};

var Subscription = function Subscription(observer, subscriber) {
  var subscriptionState = setInternalState$4(this, new SubscriptionState(observer));
  var start;
  if (!descriptors) this.closed = false;

  try {
    if (start = getMethod(observer, 'start')) functionCall(start, observer, this);
  } catch (error) {
    hostReportErrors(error);
  }

  if (subscriptionState.isClosed()) return;
  var subscriptionObserver = subscriptionState.subscriptionObserver = new SubscriptionObserver(subscriptionState);

  try {
    var cleanup = subscriber(subscriptionObserver);
    var subscription = cleanup;
    if (!isNullOrUndefined(cleanup)) subscriptionState.cleanup = isCallable(cleanup.unsubscribe) ? function () {
      subscription.unsubscribe();
    } : aCallable(cleanup);
  } catch (error) {
    subscriptionObserver.error(error);
    return;
  }

  if (subscriptionState.isClosed()) subscriptionState.clean();
};

Subscription.prototype = defineBuiltIns({}, {
  unsubscribe: function unsubscribe() {
    var subscriptionState = getSubscriptionInternalState(this);

    if (!subscriptionState.isClosed()) {
      subscriptionState.close();
      subscriptionState.clean();
    }
  }
});
if (descriptors) defineBuiltInAccessor(Subscription.prototype, 'closed', {
  configurable: true,
  get: function closed() {
    return getSubscriptionInternalState(this).isClosed();
  }
});

var SubscriptionObserver = function SubscriptionObserver(subscriptionState) {
  setInternalState$4(this, {
    type: SUBSCRIPTION_OBSERVER,
    subscriptionState: subscriptionState
  });
  if (!descriptors) this.closed = false;
};

SubscriptionObserver.prototype = defineBuiltIns({}, {
  next: function next(value) {
    var subscriptionState = getSubscriptionObserverInternalState(this).subscriptionState;

    if (!subscriptionState.isClosed()) {
      var observer = subscriptionState.observer;

      try {
        var nextMethod = getMethod(observer, 'next');
        if (nextMethod) functionCall(nextMethod, observer, value);
      } catch (error) {
        hostReportErrors(error);
      }
    }
  },
  error: function error(value) {
    var subscriptionState = getSubscriptionObserverInternalState(this).subscriptionState;

    if (!subscriptionState.isClosed()) {
      var observer = subscriptionState.observer;
      subscriptionState.close();

      try {
        var errorMethod = getMethod(observer, 'error');
        if (errorMethod) functionCall(errorMethod, observer, value);else hostReportErrors(value);
      } catch (err) {
        hostReportErrors(err);
      }

      subscriptionState.clean();
    }
  },
  complete: function complete() {
    var subscriptionState = getSubscriptionObserverInternalState(this).subscriptionState;

    if (!subscriptionState.isClosed()) {
      var observer = subscriptionState.observer;
      subscriptionState.close();

      try {
        var completeMethod = getMethod(observer, 'complete');
        if (completeMethod) functionCall(completeMethod, observer);
      } catch (error) {
        hostReportErrors(error);
      }

      subscriptionState.clean();
    }
  }
});
if (descriptors) defineBuiltInAccessor(SubscriptionObserver.prototype, 'closed', {
  configurable: true,
  get: function closed() {
    return getSubscriptionObserverInternalState(this).subscriptionState.isClosed();
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, ObservablePrototype);
  setInternalState$4(this, {
    type: OBSERVABLE,
    subscriber: aCallable(subscriber)
  });
};

var ObservablePrototype = $Observable.prototype;
defineBuiltIns(ObservablePrototype, {
  subscribe: function subscribe(observer) {
    var length = arguments.length;
    return new Subscription(isCallable(observer) ? {
      next: observer,
      error: length > 1 ? arguments[1] : undefined,
      complete: length > 2 ? arguments[2] : undefined
    } : isObject$6(observer) ? observer : {}, getObservableInternalState(this).subscriber);
  }
});
defineBuiltIn(ObservablePrototype, $$OBSERVABLE$1, function () {
  return this;
});

_export({
  global: true,
  constructor: true,
  forced: observableForced
}, {
  Observable: $Observable
});

setSpecies(OBSERVABLE);
var $$OBSERVABLE = wellKnownSymbol('observable'); // `Observable.from` method
// https://github.com/tc39/proposal-observable

_export({
  target: 'Observable',
  stat: true,
  forced: observableForced
}, {
  from: function from(x) {
    var C = isConstructor(this) ? this : getBuiltIn('Observable');
    var observableMethod = getMethod(anObject(x), $$OBSERVABLE);

    if (observableMethod) {
      var observable = anObject(functionCall(observableMethod, x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    var iterator = getIterator(x);
    return new C(function (observer) {
      iterate(iterator, function (it, stop) {
        observer.next(it);
        if (observer.closed) return stop();
      }, {
        IS_ITERATOR: true,
        INTERRUPTED: true
      });
      observer.complete();
    });
  }
});

var Array$1 = getBuiltIn('Array'); // `Observable.of` method
// https://github.com/tc39/proposal-observable

_export({
  target: 'Observable',
  stat: true,
  forced: observableForced
}, {
  of: function of() {
    var C = isConstructor(this) ? this : getBuiltIn('Observable');
    var length = arguments.length;
    var items = Array$1(length);
    var index = 0;

    while (index < length) {
      items[index] = arguments[index++];
    }

    return new C(function (observer) {
      for (var i = 0; i < length; i++) {
        observer.next(items[i]);
        if (observer.closed) return;
      }

      observer.complete();
    });
  }
}); // TODO: Remove from `core-js@4`
// `Promise.try` method
// https://github.com/tc39/proposal-promise-try


_export({
  target: 'Promise',
  stat: true,
  forced: true
}, {
  'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability$1.f(this);
    var result = perform(callbackfn);
    (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
    return promiseCapability.promise;
  }
}); // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`


var Map$5 = getBuiltIn('Map');
var WeakMap$3 = getBuiltIn('WeakMap');
var push$6 = functionUncurryThis([].push);
var metadata = shared('metadata');
var store$1 = metadata.store || (metadata.store = new WeakMap$3());

var getOrCreateMetadataMap$1 = function getOrCreateMetadataMap$1(target, targetKey, create) {
  var targetMetadata = store$1.get(target);

  if (!targetMetadata) {
    if (!create) return;
    store$1.set(target, targetMetadata = new Map$5());
  }

  var keyMetadata = targetMetadata.get(targetKey);

  if (!keyMetadata) {
    if (!create) return;
    targetMetadata.set(targetKey, keyMetadata = new Map$5());
  }

  return keyMetadata;
};

var ordinaryHasOwnMetadata$3 = function ordinaryHasOwnMetadata$3(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap$1(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};

var ordinaryGetOwnMetadata$2 = function ordinaryGetOwnMetadata$2(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap$1(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};

var ordinaryDefineOwnMetadata$2 = function ordinaryDefineOwnMetadata$2(MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap$1(O, P, true).set(MetadataKey, MetadataValue);
};

var ordinaryOwnMetadataKeys$2 = function ordinaryOwnMetadataKeys$2(target, targetKey) {
  var metadataMap = getOrCreateMetadataMap$1(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) {
    push$6(keys, key);
  });
  return keys;
};

var toMetadataKey$9 = function toMetadataKey$9(it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};

var reflectMetadata = {
  store: store$1,
  getMap: getOrCreateMetadataMap$1,
  has: ordinaryHasOwnMetadata$3,
  get: ordinaryGetOwnMetadata$2,
  set: ordinaryDefineOwnMetadata$2,
  keys: ordinaryOwnMetadataKeys$2,
  toKey: toMetadataKey$9
}; // TODO: Remove from `core-js@4`

var toMetadataKey$8 = reflectMetadata.toKey;
var ordinaryDefineOwnMetadata$1 = reflectMetadata.set; // `Reflect.defineMetadata` method
// https://github.com/rbuckton/reflect-metadata

_export({
  target: 'Reflect',
  stat: true
}, {
  defineMetadata: function defineMetadata(metadataKey, metadataValue, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 4 ? undefined : toMetadataKey$8(arguments[3]);
    ordinaryDefineOwnMetadata$1(metadataKey, metadataValue, anObject(target), targetKey);
  }
});

var toMetadataKey$7 = reflectMetadata.toKey;
var getOrCreateMetadataMap = reflectMetadata.getMap;
var store = reflectMetadata.store; // `Reflect.deleteMetadata` method
// https://github.com/rbuckton/reflect-metadata

_export({
  target: 'Reflect',
  stat: true
}, {
  deleteMetadata: function deleteMetadata(metadataKey, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 3 ? undefined : toMetadataKey$7(arguments[2]);
    var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
    if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
    if (metadataMap.size) return true;
    var targetMetadata = store.get(target);
    targetMetadata['delete'](targetKey);
    return !!targetMetadata.size || store['delete'](target);
  }
}); // TODO: Remove from `core-js@4`


var ordinaryHasOwnMetadata$2 = reflectMetadata.has;
var ordinaryGetOwnMetadata$1 = reflectMetadata.get;
var toMetadataKey$6 = reflectMetadata.toKey;

var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata$2(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata$1(MetadataKey, O, P);
  var parent = objectGetPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
}; // `Reflect.getMetadata` method
// https://github.com/rbuckton/reflect-metadata


_export({
  target: 'Reflect',
  stat: true
}, {
  getMetadata: function getMetadata(metadataKey, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 3 ? undefined : toMetadataKey$6(arguments[2]);
    return ordinaryGetMetadata(metadataKey, anObject(target), targetKey);
  }
}); // TODO: Remove from `core-js@4`


var arrayUniqueBy$1 = functionUncurryThis(arrayUniqueBy$2);
var concat = functionUncurryThis([].concat);
var ordinaryOwnMetadataKeys$1 = reflectMetadata.keys;
var toMetadataKey$5 = reflectMetadata.toKey;

var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
  var oKeys = ordinaryOwnMetadataKeys$1(O, P);
  var parent = objectGetPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? arrayUniqueBy$1(concat(oKeys, pKeys)) : pKeys : oKeys;
}; // `Reflect.getMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata


_export({
  target: 'Reflect',
  stat: true
}, {
  getMetadataKeys: function getMetadataKeys(target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 2 ? undefined : toMetadataKey$5(arguments[1]);
    return ordinaryMetadataKeys(anObject(target), targetKey);
  }
}); // TODO: Remove from `core-js@4`


var ordinaryGetOwnMetadata = reflectMetadata.get;
var toMetadataKey$4 = reflectMetadata.toKey; // `Reflect.getOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata

_export({
  target: 'Reflect',
  stat: true
}, {
  getOwnMetadata: function getOwnMetadata(metadataKey, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 3 ? undefined : toMetadataKey$4(arguments[2]);
    return ordinaryGetOwnMetadata(metadataKey, anObject(target), targetKey);
  }
}); // TODO: Remove from `core-js@4`


var ordinaryOwnMetadataKeys = reflectMetadata.keys;
var toMetadataKey$3 = reflectMetadata.toKey; // `Reflect.getOwnMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata

_export({
  target: 'Reflect',
  stat: true
}, {
  getOwnMetadataKeys: function getOwnMetadataKeys(target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 2 ? undefined : toMetadataKey$3(arguments[1]);
    return ordinaryOwnMetadataKeys(anObject(target), targetKey);
  }
}); // TODO: Remove from `core-js@4`


var ordinaryHasOwnMetadata$1 = reflectMetadata.has;
var toMetadataKey$2 = reflectMetadata.toKey;

var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata$1(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = objectGetPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
}; // `Reflect.hasMetadata` method
// https://github.com/rbuckton/reflect-metadata


_export({
  target: 'Reflect',
  stat: true
}, {
  hasMetadata: function hasMetadata(metadataKey, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 3 ? undefined : toMetadataKey$2(arguments[2]);
    return ordinaryHasMetadata(metadataKey, anObject(target), targetKey);
  }
}); // TODO: Remove from `core-js@4`


var ordinaryHasOwnMetadata = reflectMetadata.has;
var toMetadataKey$1 = reflectMetadata.toKey; // `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata

_export({
  target: 'Reflect',
  stat: true
}, {
  hasOwnMetadata: function hasOwnMetadata(metadataKey, target
  /* , targetKey */
  ) {
    var targetKey = arguments.length < 3 ? undefined : toMetadataKey$1(arguments[2]);
    return ordinaryHasOwnMetadata(metadataKey, anObject(target), targetKey);
  }
});

var toMetadataKey = reflectMetadata.toKey;
var ordinaryDefineOwnMetadata = reflectMetadata.set; // `Reflect.metadata` method
// https://github.com/rbuckton/reflect-metadata

_export({
  target: 'Reflect',
  stat: true
}, {
  metadata: function metadata(metadataKey, metadataValue) {
    return function decorator(target, key) {
      ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetadataKey(key));
    };
  }
}); // https://github.com/tc39/collection-methods


var collectionAddAll = function
  /* ...elements */
addAll() {
  var set = anObject(this);
  var adder = aCallable(set.add);

  for (var k = 0, len = arguments.length; k < len; k++) {
    functionCall(adder, set, arguments[k]);
  }

  return set;
}; // `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  addAll: collectionAddAll
}); // `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  deleteAll: collectionDeleteAll
}); // `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  difference: function difference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aCallable(newSet['delete']);
    iterate(iterable, function (value) {
      functionCall(remover, newSet, value);
    });
    return newSet;
  }
});

var getSetIterator = function getSetIterator(it) {
  // eslint-disable-next-line es/no-set -- safe
  return functionCall(Set.prototype.values, it);
}; // `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  every: function every(callbackfn
  /* , thisArg */
  ) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return !iterate(iterator, function (value, stop) {
      if (!boundFunction(value, value, set)) return stop();
    }, {
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  filter: function filter(callbackfn
  /* , thisArg */
  ) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var adder = aCallable(newSet.add);
    iterate(iterator, function (value) {
      if (boundFunction(value, value, set)) functionCall(adder, newSet, value);
    }, {
      IS_ITERATOR: true
    });
    return newSet;
  }
}); // `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  find: function find(callbackfn
  /* , thisArg */
  ) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(iterator, function (value, stop) {
      if (boundFunction(value, value, set)) return stop(value);
    }, {
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).result;
  }
}); // `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from


_export({
  target: 'Set',
  stat: true,
  forced: true
}, {
  from: collectionFrom
}); // `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  intersection: function intersection(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var hasCheck = aCallable(set.has);
    var adder = aCallable(newSet.add);
    iterate(iterable, function (value) {
      if (functionCall(hasCheck, set, value)) functionCall(adder, newSet, value);
    });
    return newSet;
  }
}); // `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  isDisjointFrom: function isDisjointFrom(iterable) {
    var set = anObject(this);
    var hasCheck = aCallable(set.has);
    return !iterate(iterable, function (value, stop) {
      if (functionCall(hasCheck, set, value) === true) return stop();
    }, {
      INTERRUPTED: true
    }).stopped;
  }
}); // `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  isSubsetOf: function isSubsetOf(iterable) {
    var iterator = getIterator(this);
    var otherSet = anObject(iterable);
    var hasCheck = otherSet.has;

    if (!isCallable(hasCheck)) {
      otherSet = new (getBuiltIn('Set'))(iterable);
      hasCheck = aCallable(otherSet.has);
    }

    return !iterate(iterator, function (value, stop) {
      if (functionCall(hasCheck, otherSet, value) === false) return stop();
    }, {
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  isSupersetOf: function isSupersetOf(iterable) {
    var set = anObject(this);
    var hasCheck = aCallable(set.has);
    return !iterate(iterable, function (value, stop) {
      if (functionCall(hasCheck, set, value) === false) return stop();
    }, {
      INTERRUPTED: true
    }).stopped;
  }
});

var arrayJoin = functionUncurryThis([].join);
var push$5 = [].push; // `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods

_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  join: function join(separator) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var sep = separator === undefined ? ',' : toString$2(separator);
    var result = [];
    iterate(iterator, push$5, {
      that: result,
      IS_ITERATOR: true
    });
    return arrayJoin(result, sep);
  }
}); // `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  map: function map(callbackfn
  /* , thisArg */
  ) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))();
    var adder = aCallable(newSet.add);
    iterate(iterator, function (value) {
      functionCall(adder, newSet, boundFunction(value, value, set));
    }, {
      IS_ITERATOR: true
    });
    return newSet;
  }
}); // `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of


_export({
  target: 'Set',
  stat: true,
  forced: true
}, {
  of: collectionOf
});

var $TypeError$1 = TypeError; // `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods

_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  reduce: function reduce(callbackfn
  /* , initialValue */
  ) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    aCallable(callbackfn);
    iterate(iterator, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = callbackfn(accumulator, value, value, set);
      }
    }, {
      IS_ITERATOR: true
    });
    if (noInitial) throw $TypeError$1('Reduce of empty set with no initial value');
    return accumulator;
  }
}); // `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  some: function some(callbackfn
  /* , thisArg */
  ) {
    var set = anObject(this);
    var iterator = getSetIterator(set);
    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return iterate(iterator, function (value, stop) {
      if (boundFunction(value, value, set)) return stop();
    }, {
      IS_ITERATOR: true,
      INTERRUPTED: true
    }).stopped;
  }
}); // `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  symmetricDifference: function symmetricDifference(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    var remover = aCallable(newSet['delete']);
    var adder = aCallable(newSet.add);
    iterate(iterable, function (value) {
      functionCall(remover, newSet, value) || functionCall(adder, newSet, value);
    });
    return newSet;
  }
}); // `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods


_export({
  target: 'Set',
  proto: true,
  real: true,
  forced: true
}, {
  union: function union(iterable) {
    var set = anObject(this);
    var newSet = new (speciesConstructor(set, getBuiltIn('Set')))(set);
    iterate(iterable, aCallable(newSet.add), {
      that: newSet
    });
    return newSet;
  }
}); // TODO: Remove from `core-js@4`


var charAt$5 = stringMultibyte.charAt; // `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at

_export({
  target: 'String',
  proto: true,
  forced: true
}, {
  at: function at(index) {
    var S = toString$2(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : charAt$5(S, k);
  }
});

var $TypeError = TypeError;
var ArrayPrototype = Array.prototype;
var push$4 = functionUncurryThis(ArrayPrototype.push);
var join$3 = functionUncurryThis(ArrayPrototype.join); // `String.cooked` method
// https://github.com/tc39/proposal-string-cooked

_export({
  target: 'String',
  stat: true,
  forced: true
}, {
  cooked: function cooked(template
  /* , ...substitutions */
  ) {
    var cookedTemplate = toIndexedObject(template);
    var literalSegments = lengthOfArrayLike(cookedTemplate);
    var argumentsLength = arguments.length;
    var elements = [];
    var i = 0;

    while (literalSegments > i) {
      var nextVal = cookedTemplate[i++];
      if (nextVal === undefined) throw $TypeError('Incorrect template');
      push$4(elements, toString$2(nextVal));
      if (i === literalSegments) return join$3(elements, '');
      if (i < argumentsLength) push$4(elements, toString$2(arguments[i]));
    }
  }
});

var codeAt$1 = stringMultibyte.codeAt;
var charAt$4 = stringMultibyte.charAt;
var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR); // TODO: unify with String#@@iterator

var $StringIterator = iteratorCreateConstructor(function StringIterator(string) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: string,
    index: 0
  });
}, 'String', function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt$4(string, index);
  state.index += point.length;
  return createIterResultObject({
    codePoint: codeAt$1(point, 0),
    position: index
  }, false);
}); // `String.prototype.codePoints` method
// https://github.com/tc39/proposal-string-prototype-codepoints

_export({
  target: 'String',
  proto: true,
  forced: true
}, {
  codePoints: function codePoints() {
    return new $StringIterator(toString$2(requireObjectCoercible(this)));
  }
}); // `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement


wellKnownSymbolDefine('asyncDispose'); // `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement

wellKnownSymbolDefine('dispose'); // `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching

wellKnownSymbolDefine('matcher'); // TODO: Remove from `core-js@4`
// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators

wellKnownSymbolDefine('metadata'); // `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata

wellKnownSymbolDefine('metadataKey'); // `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable

wellKnownSymbolDefine('observable'); // TODO: remove from `core-js@4`
// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching

wellKnownSymbolDefine('patternMatch'); // TODO: remove from `core-js@4`

wellKnownSymbolDefine('replaceAll'); // TODO: Remove from `core-js@4`

var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = arrayBufferViewCore.exportTypedArrayStaticMethod; // `%TypedArray%.fromAsync` method
// https://github.com/tc39/proposal-array-from-async

exportTypedArrayStaticMethod('fromAsync', function fromAsync(asyncItems
/* , mapfn = undefined, thisArg = undefined */
) {
  var C = this;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var thisArg = argumentsLength > 2 ? arguments[2] : undefined;
  return new (getBuiltIn('Promise'))(function (resolve) {
    aConstructor(C);
    resolve(arrayFromAsync(asyncItems, mapfn, thisArg));
  }).then(function (list) {
    return arrayFromConstructorAndList(aTypedArrayConstructor(C), list);
  });
}, true); // TODO: Remove from `core-js@4`

var $filterReject$1 = arrayIteration.filterReject;
var aTypedArray$7 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$7 = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.filterOut` method
// https://github.com/tc39/proposal-array-filtering

exportTypedArrayMethod$7('filterOut', function filterOut(callbackfn
/* , thisArg */
) {
  var list = $filterReject$1(aTypedArray$7(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return typedArrayFromSpeciesAndList(this, list);
}, true);
var $filterReject = arrayIteration.filterReject;
var aTypedArray$6 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$6 = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.filterReject` method
// https://github.com/tc39/proposal-array-filtering

exportTypedArrayMethod$6('filterReject', function filterReject(callbackfn
/* , thisArg */
) {
  var list = $filterReject(aTypedArray$6(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return typedArrayFromSpeciesAndList(this, list);
}, true); // TODO: Remove from `core-js@4`

var aTypedArray$5 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$5 = arrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.groupBy` method
// https://github.com/tc39/proposal-array-grouping

exportTypedArrayMethod$5('groupBy', function groupBy(callbackfn
/* , thisArg */
) {
  var thisArg = arguments.length > 1 ? arguments[1] : undefined;
  return arrayGroup(aTypedArray$5(this), callbackfn, thisArg, typedArraySpeciesConstructor);
}, true);
var aTypedArray$4 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$4 = arrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor$3 = arrayBufferViewCore.getTypedArrayConstructor; // `%TypedArray%.prototype.toReversed` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed

exportTypedArrayMethod$4('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray$4(this), getTypedArrayConstructor$3(this));
});
var aTypedArray$3 = arrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor$2 = arrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod$3 = arrayBufferViewCore.exportTypedArrayMethod;
var sort = functionUncurryThis(arrayBufferViewCore.TypedArrayPrototype.sort); // `%TypedArray%.prototype.toSorted` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toSorted

exportTypedArrayMethod$3('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray$3(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor$2(O), O);
  return sort(A, compareFn);
}); // TODO: Remove from `core-js@4`

var aTypedArray$2 = arrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor$1 = arrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod$2 = arrayBufferViewCore.exportTypedArrayMethod;
var max = Math.max;
var min = Math.min; // some early implementations, like WebKit, does not follow the final semantic

var PROPER_ORDER$1 = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Int8Array([1]);
  var spliced = array.toSpliced(1, 0, {
    valueOf: function valueOf() {
      array[0] = 2;
      return 3;
    }
  });
  return spliced[0] !== 2 || spliced[1] !== 3;
}); // `%TypedArray%.prototype.toSpliced` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toSpliced

exportTypedArrayMethod$2('toSpliced', function toSpliced(start, deleteCount
/* , ...items */
) {
  var O = aTypedArray$2(this);
  var C = getTypedArrayConstructor$1(O);
  var len = lengthOfArrayLike(O);
  var actualStart = toAbsoluteIndex(start, len);
  var argumentsLength = arguments.length;
  var k = 0;
  var insertCount, actualDeleteCount, thisIsBigIntArray, convertedItems, value, newLen, A;

  if (argumentsLength === 0) {
    insertCount = actualDeleteCount = 0;
  } else if (argumentsLength === 1) {
    insertCount = 0;
    actualDeleteCount = len - actualStart;
  } else {
    actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    insertCount = argumentsLength - 2;

    if (insertCount) {
      convertedItems = new C(insertCount);
      thisIsBigIntArray = isBigIntArray(convertedItems);

      for (var i = 2; i < argumentsLength; i++) {
        value = arguments[i]; // FF30- typed arrays doesn't properly convert objects to typed array values

        convertedItems[i - 2] = thisIsBigIntArray ? toBigInt(value) : +value;
      }
    }
  }

  newLen = len + insertCount - actualDeleteCount;
  A = new C(newLen);

  for (; k < actualStart; k++) {
    A[k] = O[k];
  }

  for (; k < actualStart + insertCount; k++) {
    A[k] = convertedItems[k - actualStart];
  }

  for (; k < newLen; k++) {
    A[k] = O[k + actualDeleteCount - insertCount];
  }

  return A;
}, !PROPER_ORDER$1);
var aTypedArray$1 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;
var arrayUniqueBy = functionUncurryThis(arrayUniqueBy$2); // `%TypedArray%.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique

exportTypedArrayMethod$1('uniqueBy', function uniqueBy(resolver) {
  return typedArrayFromSpeciesAndList(this, arrayUniqueBy(aTypedArray$1(this), resolver));
}, true);
var aTypedArray = arrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = arrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = arrayBufferViewCore.exportTypedArrayMethod;
var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays -- required for testing
    new Int8Array(1)['with'](2, {
      valueOf: function valueOf() {
        throw 8;
      }
    });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}(); // `%TypedArray%.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with

exportTypedArrayMethod('with', {
  'with': function _with(index, value) {
    var O = aTypedArray(this);
    var relativeIndex = toIntegerOrInfinity(index);
    var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
    return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
  }
}['with'], !PROPER_ORDER); // `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods

_export({
  target: 'WeakMap',
  proto: true,
  real: true,
  forced: true
}, {
  deleteAll: collectionDeleteAll
}); // `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from


_export({
  target: 'WeakMap',
  stat: true,
  forced: true
}, {
  from: collectionFrom
}); // `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of


_export({
  target: 'WeakMap',
  stat: true,
  forced: true
}, {
  of: collectionOf
}); // `WeakMap.prototype.emplace` method
// https://github.com/tc39/proposal-upsert


_export({
  target: 'WeakMap',
  proto: true,
  real: true,
  forced: true
}, {
  emplace: mapEmplace
}); // TODO: remove from `core-js@4`
// `WeakMap.prototype.upsert` method (replaced by `WeakMap.prototype.emplace`)
// https://github.com/tc39/proposal-upsert


_export({
  target: 'WeakMap',
  proto: true,
  real: true,
  forced: true
}, {
  upsert: mapUpsert
}); // `WeakSet.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'WeakSet',
  proto: true,
  real: true,
  forced: true
}, {
  addAll: collectionAddAll
}); // `WeakSet.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods


_export({
  target: 'WeakSet',
  proto: true,
  real: true,
  forced: true
}, {
  deleteAll: collectionDeleteAll
}); // `WeakSet.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from


_export({
  target: 'WeakSet',
  stat: true,
  forced: true
}, {
  from: collectionFrom
}); // `WeakSet.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of


_export({
  target: 'WeakSet',
  stat: true,
  forced: true
}, {
  of: collectionOf
});

var itoc$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
var ctoi$1 = {};

for (var index$2 = 0; index$2 < 66; index$2++) {
  ctoi$1[itoc$1.charAt(index$2)] = index$2;
}

var base64Map = {
  itoc: itoc$1,
  ctoi: ctoi$1
};
var ctoi = base64Map.ctoi;
var disallowed = /[^\d+/a-z]/i;
var whitespaces = /[\t\n\f\r ]+/g;
var finalEq = /[=]+$/;
var $atob = getBuiltIn('atob');
var fromCharCode$1 = String.fromCharCode;
var charAt$3 = functionUncurryThis(''.charAt);
var replace$4 = functionUncurryThis(''.replace);
var exec$2 = functionUncurryThis(disallowed.exec);
var NO_SPACES_IGNORE = fails(function () {
  return $atob(' ') !== '';
});
var NO_ENCODING_CHECK = !fails(function () {
  $atob('a');
});
var NO_ARG_RECEIVING_CHECK$1 = !NO_SPACES_IGNORE && !NO_ENCODING_CHECK && !fails(function () {
  $atob();
});
var WRONG_ARITY$1 = !NO_SPACES_IGNORE && !NO_ENCODING_CHECK && $atob.length !== 1; // `atob` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-atob

_export({
  global: true,
  enumerable: true,
  forced: NO_SPACES_IGNORE || NO_ENCODING_CHECK || NO_ARG_RECEIVING_CHECK$1 || WRONG_ARITY$1
}, {
  atob: function atob(data) {
    validateArgumentsLength(arguments.length, 1);
    if (NO_ARG_RECEIVING_CHECK$1 || WRONG_ARITY$1) return $atob(data);
    var string = replace$4(toString$2(data), whitespaces, '');
    var output = '';
    var position = 0;
    var bc = 0;
    var chr, bs;

    if (string.length % 4 == 0) {
      string = replace$4(string, finalEq, '');
    }

    if (string.length % 4 == 1 || exec$2(disallowed, string)) {
      throw new (getBuiltIn('DOMException'))('The string is not correctly encoded', 'InvalidCharacterError');
    }

    while (chr = charAt$3(string, position++)) {
      if (hasOwnProperty_1(ctoi, chr)) {
        bs = bc % 4 ? bs * 64 + ctoi[chr] : ctoi[chr];
        if (bc++ % 4) output += fromCharCode$1(255 & bs >> (-2 * bc & 6));
      }
    }

    return output;
  }
});

var itoc = base64Map.itoc;
var $btoa = getBuiltIn('btoa');
var charAt$2 = functionUncurryThis(''.charAt);
var charCodeAt$1 = functionUncurryThis(''.charCodeAt);
var NO_ARG_RECEIVING_CHECK = !!$btoa && !fails(function () {
  $btoa();
});
var WRONG_ARG_CONVERSION = !!$btoa && fails(function () {
  return $btoa(null) !== 'bnVsbA==';
});
var WRONG_ARITY = !!$btoa && $btoa.length !== 1; // `btoa` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa

_export({
  global: true,
  enumerable: true,
  forced: NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY
}, {
  btoa: function btoa(data) {
    validateArgumentsLength(arguments.length, 1);
    if (NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY) return $btoa(toString$2(data));
    var string = toString$2(data);
    var output = '';
    var position = 0;
    var map = itoc;
    var block, charCode;

    while (charAt$2(string, position) || (map = '=', position % 1)) {
      charCode = charCodeAt$1(string, position += 3 / 4);

      if (charCode > 0xFF) {
        throw new (getBuiltIn('DOMException'))('The string contains characters outside of the Latin1 range', 'InvalidCharacterError');
      }

      block = block << 8 | charCode;
      output += charAt$2(map, 63 & block >> 8 - position % 1 * 8);
    }

    return output;
  }
}); // iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods


var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}; // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var handlePrototype$1 = function handlePrototype$1(CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
};

for (var COLLECTION_NAME$1 in domIterables) {
  if (domIterables[COLLECTION_NAME$1]) {
    handlePrototype$1(global$1[COLLECTION_NAME$1] && global$1[COLLECTION_NAME$1].prototype);
  }
}

handlePrototype$1(domTokenListPrototype);
var ITERATOR$2 = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

var handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }

    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }

    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in domIterables) {
  handlePrototype(global$1[COLLECTION_NAME] && global$1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(domTokenListPrototype, 'DOMTokenList');

var tryNodeRequire = function tryNodeRequire(name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (engineIsNode) return Function('return require("' + name + '")')();
  } catch (error) {
    /* empty */
  }
};

var domExceptionConstants = {
  IndexSizeError: {
    s: 'INDEX_SIZE_ERR',
    c: 1,
    m: 1
  },
  DOMStringSizeError: {
    s: 'DOMSTRING_SIZE_ERR',
    c: 2,
    m: 0
  },
  HierarchyRequestError: {
    s: 'HIERARCHY_REQUEST_ERR',
    c: 3,
    m: 1
  },
  WrongDocumentError: {
    s: 'WRONG_DOCUMENT_ERR',
    c: 4,
    m: 1
  },
  InvalidCharacterError: {
    s: 'INVALID_CHARACTER_ERR',
    c: 5,
    m: 1
  },
  NoDataAllowedError: {
    s: 'NO_DATA_ALLOWED_ERR',
    c: 6,
    m: 0
  },
  NoModificationAllowedError: {
    s: 'NO_MODIFICATION_ALLOWED_ERR',
    c: 7,
    m: 1
  },
  NotFoundError: {
    s: 'NOT_FOUND_ERR',
    c: 8,
    m: 1
  },
  NotSupportedError: {
    s: 'NOT_SUPPORTED_ERR',
    c: 9,
    m: 1
  },
  InUseAttributeError: {
    s: 'INUSE_ATTRIBUTE_ERR',
    c: 10,
    m: 1
  },
  InvalidStateError: {
    s: 'INVALID_STATE_ERR',
    c: 11,
    m: 1
  },
  SyntaxError: {
    s: 'SYNTAX_ERR',
    c: 12,
    m: 1
  },
  InvalidModificationError: {
    s: 'INVALID_MODIFICATION_ERR',
    c: 13,
    m: 1
  },
  NamespaceError: {
    s: 'NAMESPACE_ERR',
    c: 14,
    m: 1
  },
  InvalidAccessError: {
    s: 'INVALID_ACCESS_ERR',
    c: 15,
    m: 1
  },
  ValidationError: {
    s: 'VALIDATION_ERR',
    c: 16,
    m: 0
  },
  TypeMismatchError: {
    s: 'TYPE_MISMATCH_ERR',
    c: 17,
    m: 1
  },
  SecurityError: {
    s: 'SECURITY_ERR',
    c: 18,
    m: 1
  },
  NetworkError: {
    s: 'NETWORK_ERR',
    c: 19,
    m: 1
  },
  AbortError: {
    s: 'ABORT_ERR',
    c: 20,
    m: 1
  },
  URLMismatchError: {
    s: 'URL_MISMATCH_ERR',
    c: 21,
    m: 1
  },
  QuotaExceededError: {
    s: 'QUOTA_EXCEEDED_ERR',
    c: 22,
    m: 1
  },
  TimeoutError: {
    s: 'TIMEOUT_ERR',
    c: 23,
    m: 1
  },
  InvalidNodeTypeError: {
    s: 'INVALID_NODE_TYPE_ERR',
    c: 24,
    m: 1
  },
  DataCloneError: {
    s: 'DATA_CLONE_ERR',
    c: 25,
    m: 1
  }
};
var defineProperty$4 = objectDefineProperty.f;
var DOM_EXCEPTION$2 = 'DOMException';
var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
var Error$4 = getBuiltIn('Error'); // NodeJS < 17.0 does not expose `DOMException` to global

var NativeDOMException$1 = getBuiltIn(DOM_EXCEPTION$2) || function () {
  try {
    // NodeJS < 15.0 does not expose `MessageChannel` to global
    var MessageChannel = getBuiltIn('MessageChannel') || tryNodeRequire('worker_threads').MessageChannel; // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe

    new MessageChannel().port1.postMessage(new WeakMap());
  } catch (error) {
    if (error.name == DATA_CLONE_ERR && error.code == 25) return error.constructor;
  }
}();

var NativeDOMExceptionPrototype = NativeDOMException$1 && NativeDOMException$1.prototype;
var ErrorPrototype = Error$4.prototype;
var setInternalState$2 = internalState.set;
var getInternalState = internalState.getterFor(DOM_EXCEPTION$2);
var HAS_STACK = ('stack' in Error$4(DOM_EXCEPTION$2));

var codeFor = function codeFor(name) {
  return hasOwnProperty_1(domExceptionConstants, name) && domExceptionConstants[name].m ? domExceptionConstants[name].c : 0;
};

var $DOMException$1 = function DOMException() {
  anInstance(this, DOMExceptionPrototype$1);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var code = codeFor(name);
  setInternalState$2(this, {
    type: DOM_EXCEPTION$2,
    name: name,
    message: message,
    code: code
  });

  if (!descriptors) {
    this.name = name;
    this.message = message;
    this.code = code;
  }

  if (HAS_STACK) {
    var error = Error$4(message);
    error.name = DOM_EXCEPTION$2;
    defineProperty$4(this, 'stack', createPropertyDescriptor(1, errorStackClear(error.stack, 1)));
  }
};

var DOMExceptionPrototype$1 = $DOMException$1.prototype = objectCreate$1(ErrorPrototype);

var createGetterDescriptor = function createGetterDescriptor(get) {
  return {
    enumerable: true,
    configurable: true,
    get: get
  };
};

var getterFor = function getterFor(key) {
  return createGetterDescriptor(function () {
    return getInternalState(this)[key];
  });
};

if (descriptors) {
  defineBuiltInAccessor(DOMExceptionPrototype$1, 'code', getterFor('code'));
  defineBuiltInAccessor(DOMExceptionPrototype$1, 'message', getterFor('message'));
  defineBuiltInAccessor(DOMExceptionPrototype$1, 'name', getterFor('name'));
}

defineProperty$4(DOMExceptionPrototype$1, 'constructor', createPropertyDescriptor(1, $DOMException$1)); // FF36- DOMException is a function, but can't be constructed

var INCORRECT_CONSTRUCTOR = fails(function () {
  return !(new NativeDOMException$1() instanceof Error$4);
}); // Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs

var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException$1(1, 2)) !== '2: 1';
}); // Deno 1.6.3- DOMException.prototype.code just missed

var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
  return new NativeDOMException$1(1, 'DataCloneError').code !== 25;
}); // Deno 1.6.3- DOMException constants just missed

INCORRECT_CONSTRUCTOR || NativeDOMException$1[DATA_CLONE_ERR] !== 25 || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;
var FORCED_CONSTRUCTOR$1 = INCORRECT_CONSTRUCTOR; // `DOMException` constructor
// https://webidl.spec.whatwg.org/#idl-DOMException

_export({
  global: true,
  constructor: true,
  forced: FORCED_CONSTRUCTOR$1
}, {
  DOMException: FORCED_CONSTRUCTOR$1 ? $DOMException$1 : NativeDOMException$1
});

var PolyfilledDOMException$1 = getBuiltIn(DOM_EXCEPTION$2);
var PolyfilledDOMExceptionPrototype$1 = PolyfilledDOMException$1.prototype;

if (INCORRECT_TO_STRING && NativeDOMException$1 === PolyfilledDOMException$1) {
  defineBuiltIn(PolyfilledDOMExceptionPrototype$1, 'toString', errorToString);
}

if (INCORRECT_CODE && descriptors && NativeDOMException$1 === PolyfilledDOMException$1) {
  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype$1, 'code', createGetterDescriptor(function () {
    return codeFor(anObject(this).name);
  }));
}

for (var key$1 in domExceptionConstants) {
  if (hasOwnProperty_1(domExceptionConstants, key$1)) {
    var constant$1 = domExceptionConstants[key$1];
    var constantName$1 = constant$1.s;
    var descriptor$1 = createPropertyDescriptor(6, constant$1.c);

    if (!hasOwnProperty_1(PolyfilledDOMException$1, constantName$1)) {
      defineProperty$4(PolyfilledDOMException$1, constantName$1, descriptor$1);
    }

    if (!hasOwnProperty_1(PolyfilledDOMExceptionPrototype$1, constantName$1)) {
      defineProperty$4(PolyfilledDOMExceptionPrototype$1, constantName$1, descriptor$1);
    }
  }
}

var defineProperty$3 = objectDefineProperty.f;
var DOM_EXCEPTION$1 = 'DOMException';
var Error$3 = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION$1);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error$3(message);
  error.name = DOM_EXCEPTION$1;
  defineProperty$3(that, 'stack', createPropertyDescriptor(1, errorStackClear(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
var ERROR_HAS_STACK = ('stack' in Error$3(DOM_EXCEPTION$1));
var DOM_EXCEPTION_HAS_STACK = ('stack' in new NativeDOMException(1, 2)); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var descriptor = NativeDOMException && descriptors && Object.getOwnPropertyDescriptor(global$1, DOM_EXCEPTION$1); // Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399

var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);
var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK; // `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness

_export({
  global: true,
  constructor: true,
  forced: FORCED_CONSTRUCTOR
}, {
  // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION$1);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  {
    defineProperty$3(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in domExceptionConstants) {
    if (hasOwnProperty_1(domExceptionConstants, key)) {
      var constant = domExceptionConstants[key];
      var constantName = constant.s;

      if (!hasOwnProperty_1(PolyfilledDOMException, constantName)) {
        defineProperty$3(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
      }
    }
  }
}

var DOM_EXCEPTION = 'DOMException';
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);
var clearImmediate = task$1.clear; // `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate

_export({
  global: true,
  bind: true,
  enumerable: true,
  forced: global$1.clearImmediate !== clearImmediate
}, {
  clearImmediate: clearImmediate
});

var setImmediate = task$1.set; // `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate

_export({
  global: true,
  bind: true,
  enumerable: true,
  forced: global$1.setImmediate !== setImmediate
}, {
  setImmediate: setImmediate
});

var process$1 = global$1.process; // `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask

_export({
  global: true,
  enumerable: true,
  dontCallGetSet: true
}, {
  queueMicrotask: function queueMicrotask(fn) {
    validateArgumentsLength(arguments.length, 1);
    aCallable(fn);
    var domain = engineIsNode && process$1.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

var Object$1 = global$1.Object;
var Date$1 = global$1.Date;
var Error$2 = global$1.Error;
var EvalError = global$1.EvalError;
var RangeError$1 = global$1.RangeError;
var ReferenceError$1 = global$1.ReferenceError;
var SyntaxError$1 = global$1.SyntaxError;
var TypeError$3 = global$1.TypeError;
var URIError = global$1.URIError;
var PerformanceMark = global$1.PerformanceMark;
var WebAssembly = global$1.WebAssembly;
var CompileError = WebAssembly && WebAssembly.CompileError || Error$2;
var LinkError = WebAssembly && WebAssembly.LinkError || Error$2;
var RuntimeError = WebAssembly && WebAssembly.RuntimeError || Error$2;
var DOMException = getBuiltIn('DOMException');
var Set$3 = getBuiltIn('Set');
var Map$4 = getBuiltIn('Map');
var MapPrototype = Map$4.prototype;
var mapHas = functionUncurryThis(MapPrototype.has);
var mapGet = functionUncurryThis(MapPrototype.get);
var mapSet = functionUncurryThis(MapPrototype.set);
var setAdd = functionUncurryThis(Set$3.prototype.add);
var objectKeys = getBuiltIn('Object', 'keys');
var push$3 = functionUncurryThis([].push);
var thisBooleanValue = functionUncurryThis(true.valueOf);
var thisNumberValue = functionUncurryThis(1.0.valueOf);
var thisStringValue = functionUncurryThis(''.valueOf);
var thisTimeValue = functionUncurryThis(Date$1.prototype.getTime);
var PERFORMANCE_MARK = uid('structuredClone');
var DATA_CLONE_ERROR = 'DataCloneError';
var TRANSFERRING = 'Transferring';

var checkBasicSemantic = function checkBasicSemantic(structuredCloneImplementation) {
  return !fails(function () {
    var set1 = new global$1.Set([7]);
    var set2 = structuredCloneImplementation(set1);
    var number = structuredCloneImplementation(Object$1(7));
    return set2 == set1 || !set2.has(7) || typeof number != 'object' || number != 7;
  }) && structuredCloneImplementation;
};

var checkErrorsCloning = function checkErrorsCloning(structuredCloneImplementation, $Error) {
  return !fails(function () {
    var error = new $Error();
    var test = structuredCloneImplementation({
      a: error,
      b: error
    });
    return !(test && test.a === test.b && test.a instanceof $Error && test.a.stack === error.stack);
  });
}; // https://github.com/whatwg/html/pull/5749


var checkNewErrorsCloningSemantic = function checkNewErrorsCloningSemantic(structuredCloneImplementation) {
  return !fails(function () {
    var test = structuredCloneImplementation(new global$1.AggregateError([1], PERFORMANCE_MARK, {
      cause: 3
    }));
    return test.name != 'AggregateError' || test.errors[0] != 1 || test.message != PERFORMANCE_MARK || test.cause != 3;
  });
}; // FF94+, Safari 15.4+, Chrome 98+, NodeJS 17.0+, Deno 1.13+
// FF<103 and Safari implementations can't clone errors
// https://bugzilla.mozilla.org/show_bug.cgi?id=1556604
// FF103 can clone errors, but `.stack` of clone is an empty string
// https://bugzilla.mozilla.org/show_bug.cgi?id=1778762
// FF104+ fixed it on usual errors, but not on DOMExceptions
// https://bugzilla.mozilla.org/show_bug.cgi?id=1777321
// Chrome <102 returns `null` if cloned object contains multiple references to one error
// https://bugs.chromium.org/p/v8/issues/detail?id=12542
// NodeJS implementation can't clone DOMExceptions
// https://github.com/nodejs/node/issues/41038
// only FF103+ supports new (html/5749) error cloning semantic


var nativeStructuredClone = global$1.structuredClone;
var FORCED_REPLACEMENT = !checkErrorsCloning(nativeStructuredClone, Error$2) || !checkErrorsCloning(nativeStructuredClone, DOMException) || !checkNewErrorsCloningSemantic(nativeStructuredClone); // Chrome 82+, Safari 14.1+, Deno 1.11+
// Chrome 78-81 implementation swaps `.name` and `.message` of cloned `DOMException`
// Chrome returns `null` if cloned object contains multiple references to one error
// Safari 14.1 implementation doesn't clone some `RegExp` flags, so requires a workaround
// Safari implementation can't clone errors
// Deno 1.2-1.10 implementations too naive
// NodeJS 16.0+ does not have `PerformanceMark` constructor
// NodeJS <17.2 structured cloning implementation from `performance.mark` is too naive
// and can't clone, for example, `RegExp` or some boxed primitives
// https://github.com/nodejs/node/issues/40840
// no one of those implementations supports new (html/5749) error cloning semantic

var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
  return new PerformanceMark(PERFORMANCE_MARK, {
    detail: value
  }).detail;
});
var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;

var throwUncloneable = function throwUncloneable(type) {
  throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
};

var throwUnpolyfillable = function throwUnpolyfillable(type, action) {
  throw new DOMException((action || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
};

var createDataTransfer = function createDataTransfer() {
  var dataTransfer;

  try {
    dataTransfer = new global$1.DataTransfer();
  } catch (error) {
    try {
      dataTransfer = new global$1.ClipboardEvent('').clipboardData;
    } catch (error2) {
      /* empty */
    }
  }

  return dataTransfer && dataTransfer.items && dataTransfer.files ? dataTransfer : null;
};

var structuredCloneInternal = function structuredCloneInternal(value, map) {
  if (isSymbol$1(value)) throwUncloneable('Symbol');
  if (!isObject$6(value)) return value; // effectively preserves circular references

  if (map) {
    if (mapHas(map, value)) return mapGet(map, value);
  } else map = new Map$4();

  var type = classof(value);
  var deep = false;
  var C, name, cloned, dataTransfer, i, length, keys, key, source, target;

  switch (type) {
    case 'Array':
      cloned = [];
      deep = true;
      break;

    case 'Object':
      cloned = {};
      deep = true;
      break;

    case 'Map':
      cloned = new Map$4();
      deep = true;
      break;

    case 'Set':
      cloned = new Set$3();
      deep = true;
      break;

    case 'RegExp':
      // in this block because of a Safari 14.1 bug
      // old FF does not clone regexes passed to the constructor, so get the source and flags directly
      cloned = new RegExp(value.source, regexpGetFlags(value));
      break;

    case 'Error':
      name = value.name;

      switch (name) {
        case 'AggregateError':
          cloned = getBuiltIn('AggregateError')([]);
          break;

        case 'EvalError':
          cloned = EvalError();
          break;

        case 'RangeError':
          cloned = RangeError$1();
          break;

        case 'ReferenceError':
          cloned = ReferenceError$1();
          break;

        case 'SyntaxError':
          cloned = SyntaxError$1();
          break;

        case 'TypeError':
          cloned = TypeError$3();
          break;

        case 'URIError':
          cloned = URIError();
          break;

        case 'CompileError':
          cloned = CompileError();
          break;

        case 'LinkError':
          cloned = LinkError();
          break;

        case 'RuntimeError':
          cloned = RuntimeError();
          break;

        default:
          cloned = Error$2();
      }

      deep = true;
      break;

    case 'DOMException':
      cloned = new DOMException(value.message, value.name);
      deep = true;
      break;

    case 'DataView':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'BigInt64Array':
    case 'BigUint64Array':
      C = global$1[type]; // in some old engines like Safari 9, typeof C is 'object'
      // on Uint8ClampedArray or some other constructors

      if (!isObject$6(C)) throwUnpolyfillable(type);
      cloned = new C( // this is safe, since arraybuffer cannot have circular references
      structuredCloneInternal(value.buffer, map), value.byteOffset, type === 'DataView' ? value.byteLength : value.length);
      break;

    case 'DOMQuad':
      try {
        cloned = new DOMQuad(structuredCloneInternal(value.p1, map), structuredCloneInternal(value.p2, map), structuredCloneInternal(value.p3, map), structuredCloneInternal(value.p4, map));
      } catch (error) {
        if (nativeRestrictedStructuredClone) {
          cloned = nativeRestrictedStructuredClone(value);
        } else throwUnpolyfillable(type);
      }

      break;

    case 'FileList':
      dataTransfer = createDataTransfer();

      if (dataTransfer) {
        for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
          dataTransfer.items.add(structuredCloneInternal(value[i], map));
        }

        cloned = dataTransfer.files;
      } else if (nativeRestrictedStructuredClone) {
        cloned = nativeRestrictedStructuredClone(value);
      } else throwUnpolyfillable(type);

      break;

    case 'ImageData':
      // Safari 9 ImageData is a constructor, but typeof ImageData is 'object'
      try {
        cloned = new ImageData(structuredCloneInternal(value.data, map), value.width, value.height, {
          colorSpace: value.colorSpace
        });
      } catch (error) {
        if (nativeRestrictedStructuredClone) {
          cloned = nativeRestrictedStructuredClone(value);
        } else throwUnpolyfillable(type);
      }

      break;

    default:
      if (nativeRestrictedStructuredClone) {
        cloned = nativeRestrictedStructuredClone(value);
      } else switch (type) {
        case 'BigInt':
          // can be a 3rd party polyfill
          cloned = Object$1(value.valueOf());
          break;

        case 'Boolean':
          cloned = Object$1(thisBooleanValue(value));
          break;

        case 'Number':
          cloned = Object$1(thisNumberValue(value));
          break;

        case 'String':
          cloned = Object$1(thisStringValue(value));
          break;

        case 'Date':
          cloned = new Date$1(thisTimeValue(value));
          break;

        case 'ArrayBuffer':
          C = global$1.DataView; // `ArrayBuffer#slice` is not available in IE10
          // `ArrayBuffer#slice` and `DataView` are not available in old FF

          if (!C && typeof value.slice != 'function') throwUnpolyfillable(type); // detached buffers throws in `DataView` and `.slice`

          try {
            if (typeof value.slice == 'function') {
              cloned = value.slice(0);
            } else {
              length = value.byteLength;
              cloned = new ArrayBuffer(length);
              source = new C(value);
              target = new C(cloned);

              for (i = 0; i < length; i++) {
                target.setUint8(i, source.getUint8(i));
              }
            }
          } catch (error) {
            throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
          }

          break;

        case 'SharedArrayBuffer':
          // SharedArrayBuffer should use shared memory, we can't polyfill it, so return the original
          cloned = value;
          break;

        case 'Blob':
          try {
            cloned = value.slice(0, value.size, value.type);
          } catch (error) {
            throwUnpolyfillable(type);
          }

          break;

        case 'DOMPoint':
        case 'DOMPointReadOnly':
          C = global$1[type];

          try {
            cloned = C.fromPoint ? C.fromPoint(value) : new C(value.x, value.y, value.z, value.w);
          } catch (error) {
            throwUnpolyfillable(type);
          }

          break;

        case 'DOMRect':
        case 'DOMRectReadOnly':
          C = global$1[type];

          try {
            cloned = C.fromRect ? C.fromRect(value) : new C(value.x, value.y, value.width, value.height);
          } catch (error) {
            throwUnpolyfillable(type);
          }

          break;

        case 'DOMMatrix':
        case 'DOMMatrixReadOnly':
          C = global$1[type];

          try {
            cloned = C.fromMatrix ? C.fromMatrix(value) : new C(value);
          } catch (error) {
            throwUnpolyfillable(type);
          }

          break;

        case 'AudioData':
        case 'VideoFrame':
          if (!isCallable(value.clone)) throwUnpolyfillable(type);

          try {
            cloned = value.clone();
          } catch (error) {
            throwUncloneable(type);
          }

          break;

        case 'File':
          try {
            cloned = new File([value], value.name, value);
          } catch (error) {
            throwUnpolyfillable(type);
          }

          break;

        case 'CropTarget':
        case 'CryptoKey':
        case 'FileSystemDirectoryHandle':
        case 'FileSystemFileHandle':
        case 'FileSystemHandle':
        case 'GPUCompilationInfo':
        case 'GPUCompilationMessage':
        case 'ImageBitmap':
        case 'RTCCertificate':
        case 'WebAssembly.Module':
          throwUnpolyfillable(type);
        // break omitted

        default:
          throwUncloneable(type);
      }

  }

  mapSet(map, value, cloned);
  if (deep) switch (type) {
    case 'Array':
    case 'Object':
      keys = objectKeys(value);

      for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
        key = keys[i];
        createProperty(cloned, key, structuredCloneInternal(value[key], map));
      }

      break;

    case 'Map':
      value.forEach(function (v, k) {
        mapSet(cloned, structuredCloneInternal(k, map), structuredCloneInternal(v, map));
      });
      break;

    case 'Set':
      value.forEach(function (v) {
        setAdd(cloned, structuredCloneInternal(v, map));
      });
      break;

    case 'Error':
      createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map));

      if (hasOwnProperty_1(value, 'cause')) {
        createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map));
      }

      if (name == 'AggregateError') {
        cloned.errors = structuredCloneInternal(value.errors, map);
      }

    // break omitted

    case 'DOMException':
      if (errorStackInstallable) {
        createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map));
      }

  }
  return cloned;
};

var PROPER_TRANSFER = nativeStructuredClone && !fails(function () {
  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (engineIsDeno && engineV8Version > 92 || engineIsNode && engineV8Version > 94 || engineIsBrowser && engineV8Version > 97) return false;
  var buffer = new ArrayBuffer(8);
  var clone = nativeStructuredClone(buffer, {
    transfer: [buffer]
  });
  return buffer.byteLength != 0 || clone.byteLength != 8;
});

var tryToTransfer = function tryToTransfer(rawTransfer, map) {
  if (!isObject$6(rawTransfer)) throw TypeError$3('Transfer option cannot be converted to a sequence');
  var transfer = [];
  iterate(rawTransfer, function (value) {
    push$3(transfer, anObject(value));
  });
  var i = 0;
  var length = lengthOfArrayLike(transfer);
  var value, type, C, transferredArray, transferred, canvas, context;

  if (PROPER_TRANSFER) {
    transferredArray = nativeStructuredClone(transfer, {
      transfer: transfer
    });

    while (i < length) {
      mapSet(map, transfer[i], transferredArray[i++]);
    }
  } else while (i < length) {
    value = transfer[i++];
    if (mapHas(map, value)) throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
    type = classof(value);

    switch (type) {
      case 'ImageBitmap':
        C = global$1.OffscreenCanvas;
        if (!isConstructor(C)) throwUnpolyfillable(type, TRANSFERRING);

        try {
          canvas = new C(value.width, value.height);
          context = canvas.getContext('bitmaprenderer');
          context.transferFromImageBitmap(value);
          transferred = canvas.transferToImageBitmap();
        } catch (error) {
          /* empty */
        }

        break;

      case 'AudioData':
      case 'VideoFrame':
        if (!isCallable(value.clone) || !isCallable(value.close)) throwUnpolyfillable(type, TRANSFERRING);

        try {
          transferred = value.clone();
          value.close();
        } catch (error) {
          /* empty */
        }

        break;

      case 'ArrayBuffer':
      case 'MediaSourceHandle':
      case 'MessagePort':
      case 'OffscreenCanvas':
      case 'ReadableStream':
      case 'TransformStream':
      case 'WritableStream':
        throwUnpolyfillable(type, TRANSFERRING);
    }

    if (transferred === undefined) throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);
    mapSet(map, value, transferred);
  }
}; // `structuredClone` method
// https://html.spec.whatwg.org/multipage/structured-data.html#dom-structuredclone


_export({
  global: true,
  enumerable: true,
  sham: !PROPER_TRANSFER,
  forced: FORCED_REPLACEMENT
}, {
  structuredClone: function structuredClone(value
  /* , { transfer } */
  ) {
    var options = validateArgumentsLength(arguments.length, 1) > 1 && !isNullOrUndefined(arguments[1]) ? anObject(arguments[1]) : undefined;
    var transfer = options ? options.transfer : undefined;
    var map;

    if (transfer !== undefined) {
      map = new Map$4();
      tryToTransfer(transfer, map);
    }

    return structuredCloneInternal(value, map);
  }
});

var MSIE = /MSIE .\./.test(engineUserAgent); // <- dirty ie9- check

var Function$1 = global$1.Function;

var wrap$1 = function wrap$1(scheduler) {
  return MSIE ? function (handler, timeout
  /* , ...arguments */
  ) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > 2;
    var fn = isCallable(handler) ? handler : Function$1(handler);
    var args = boundArgs ? arraySlice$1(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      functionApply(fn, this, args);
    } : fn, timeout);
  } : scheduler;
}; // ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers


var schedulersFix = {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap$1(global$1.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap$1(global$1.setInterval)
};
var setInterval$1 = schedulersFix.setInterval; // ie9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval

_export({
  global: true,
  bind: true,
  forced: global$1.setInterval !== setInterval$1
}, {
  setInterval: setInterval$1
});

var setTimeout$1 = schedulersFix.setTimeout; // ie9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout

_export({
  global: true,
  bind: true,
  forced: global$1.setTimeout !== setTimeout$1
}, {
  setTimeout: setTimeout$1
});

var ITERATOR$1 = wellKnownSymbol('iterator');
var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return isPure && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR$1] // throws in Edge
  || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' // not punycoded in Edge
  || new URL('http://тест').host !== 'xn--e1aybc' // not escaped in Chrome 62-
  || new URL('http://a#б').hash !== '#%D0%B1' // fails in Chrome 66-
  || result !== 'a1c3' // throws in Safari
  || new URL('http://x', undefined).host !== 'x';
}); // based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80

var delimiter = '-'; // '\x2D'

var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars

var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var $RangeError = RangeError;
var exec$1 = functionUncurryThis(regexSeparators.exec);
var floor$1 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = functionUncurryThis(''.charCodeAt);
var join$2 = functionUncurryThis([].join);
var push$2 = functionUncurryThis([].push);
var replace$3 = functionUncurryThis(''.replace);
var split$2 = functionUncurryThis(''.split);
var toLowerCase$1 = functionUncurryThis(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */

var ucs2decode = function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length = string.length;

  while (counter < length) {
    var value = charCodeAt(string, counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // Low surrogate.
        push$2(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$2(output, value);
        counter--;
      }
    } else {
      push$2(output, value);
    }
  }

  return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */


var digitToBasic = function digitToBasic(digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */


var adapt = function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$1(delta / damp) : delta >> 1;
  delta += floor$1(delta / numPoints);

  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$1(delta / baseMinusTMin);
    k += base;
  }

  return floor$1(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */


var encode$1 = function encode$1(input) {
  var output = []; // Convert the input in UCS-2 to an array of Unicode code points.

  input = ucs2decode(input); // Cache the length.

  var inputLength = input.length; // Initialize the state.

  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue; // Handle the basic code points.

  for (i = 0; i < input.length; i++) {
    currentValue = input[i];

    if (currentValue < 0x80) {
      push$2(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.

  var handledCPCount = basicLength; // number of code points that have been handled;
  // Finish the basic string with a delimiter unless it's empty.

  if (basicLength) {
    push$2(output, delimiter);
  } // Main encoding loop:


  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.


    var handledCPCountPlusOne = handledCPCount + 1;

    if (m - n > floor$1((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];

      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;

        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$2(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$1(qMinusT / baseMinusT);
          k += base;
        }

        push$2(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }

  return join$2(output, '');
};

var stringPunycodeToAscii = function stringPunycodeToAscii(input) {
  var encoded = [];
  var labels = split$2(replace$3(toLowerCase$1(input), regexSeparators, "."), '.');
  var i, label;

  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$2(encoded, exec$1(regexNonASCII, label) ? 'xn--' + encode$1(label) : label);
  }

  return join$2(encoded, '.');
}; // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`


var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = internalState.set;
var getInternalParamsState = internalState.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR); // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe

var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor; // Avoid NodeJS experimental warning

var safeGetBuiltIn = function safeGetBuiltIn(name) {
  if (!descriptors) return global$1[name];
  var descriptor = getOwnPropertyDescriptor$1(global$1, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$1.RegExp;
var TypeError$2 = global$1.TypeError;
var decodeURIComponent$1 = global$1.decodeURIComponent;
var encodeURIComponent$1 = global$1.encodeURIComponent;
var charAt$1 = functionUncurryThis(''.charAt);
var join$1 = functionUncurryThis([].join);
var push$1 = functionUncurryThis([].push);
var replace$2 = functionUncurryThis(''.replace);
var shift$1 = functionUncurryThis([].shift);
var splice$1 = functionUncurryThis([].splice);
var split$1 = functionUncurryThis(''.split);
var stringSlice$1 = functionUncurryThis(''.slice);
var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function percentSequence(bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function percentDecode(sequence) {
  try {
    return decodeURIComponent$1(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function deserialize(it) {
  var result = replace$2(it, plus, ' ');
  var bytes = 4;

  try {
    return decodeURIComponent$1(result);
  } catch (error) {
    while (bytes) {
      result = replace$2(result, percentSequence(bytes--), percentDecode);
    }

    return result;
  }
};

var find$1 = /[!'()~]|%20/g;
var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function replacer(match) {
  return replacements[match];
};

var _serialize = function serialize(it) {
  return replace$2(encodeURIComponent$1(it), find$1, replacer);
};

var URLSearchParamsIterator = iteratorCreateConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;

  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  }

  return step;
}, true);

var URLSearchParamsState = function URLSearchParamsState(init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$6(init)) this.parseObject(init);else this.parseQuery(typeof init == 'string' ? charAt$1(init, 0) === '?' ? stringSlice$1(init, 1) : init : toString$2(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function bindURL(url) {
    this.url = url;
    this.update();
  },
  parseObject: function parseObject(object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;

      while (!(step = functionCall(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if ((first = functionCall(entryNext, entryIterator)).done || (second = functionCall(entryNext, entryIterator)).done || !functionCall(entryNext, entryIterator).done) throw TypeError$2('Expected sequence with length 2');
        push$1(this.entries, {
          key: toString$2(first.value),
          value: toString$2(second.value)
        });
      }
    } else for (var key in object) {
      if (hasOwnProperty_1(object, key)) {
        push$1(this.entries, {
          key: key,
          value: toString$2(object[key])
        });
      }
    }
  },
  parseQuery: function parseQuery(query) {
    if (query) {
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;

      while (index < attributes.length) {
        attribute = attributes[index++];

        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$1(this.entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function serialize() {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      push$1(result, _serialize(entry.key) + '=' + _serialize(entry.value));
    }

    return join$1(result, '&');
  },
  update: function update() {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function updateURL() {
    if (this.url) this.url.update();
  }
}; // `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams

var URLSearchParamsConstructor = function
  /* init */
URLSearchParams() {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$1(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$1(state.entries, {
      key: toString$2(name),
      value: toString$2(value)
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function _delete(name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = toString$2(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index].key === key) splice$1(entries, index, 1);else index++;
    }

    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString$2(name);
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }

    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString$2(name);
    var result = [];
    var index = 0;

    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$1(result, entries[index].value);
    }

    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = toString$2(name);
    var index = 0;

    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }

    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = toString$2(name);
    var val = toString$2(value);
    var index = 0;
    var entry;

    for (; index < entries.length; index++) {
      entry = entries[index];

      if (entry.key === key) {
        if (found) splice$1(entries, index--, 1);else {
          found = true;
          entry.value = val;
        }
      }
    }

    if (!found) push$1(entries, {
      key: key,
      value: val
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback
  /* , thisArg */
  ) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = functionBindContext(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;

    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, {
  enumerable: true
}); // `URLSearchParams.prototype[@@iterator]` method

defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, {
  name: 'entries'
}); // `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior

defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, {
  enumerable: true
});
setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

_export({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection
}, {
  URLSearchParams: URLSearchParamsConstructor
}); // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`


if (!urlConstructorDetection && isCallable(Headers)) {
  var headersHas = functionUncurryThis(HeadersPrototype.has);
  var headersSet = functionUncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function wrapRequestOptions(init) {
    if (isObject$6(init)) {
      var body = init.body;
      var headers;

      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();

        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }

        return objectCreate$1(init, {
          body: createPropertyDescriptor(0, toString$2(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    }

    return init;
  };

  if (isCallable(nativeFetch)) {
    _export({
      global: true,
      enumerable: true,
      dontCallGetSet: true,
      forced: true
    }, {
      fetch: function fetch(input
      /* , init */
      ) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input
    /* , init */
    ) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    _export({
      global: true,
      constructor: true,
      dontCallGetSet: true,
      forced: true
    }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
}; // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var codeAt = stringMultibyte.codeAt;
var setInternalState = internalState.set;
var getInternalURLState = internalState.getterFor('URL');
var URLSearchParams$1 = web_urlSearchParams_constructor.URLSearchParams;
var getInternalSearchParamsState = web_urlSearchParams_constructor.getState;
var NativeURL = global$1.URL;
var TypeError$1 = global$1.TypeError;
var parseInt$1 = global$1.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = functionUncurryThis(''.charAt);
var exec = functionUncurryThis(/./.exec);
var join = functionUncurryThis([].join);
var numberToString = functionUncurryThis(1.0.toString);
var pop = functionUncurryThis([].pop);
var push = functionUncurryThis([].push);
var replace$1 = functionUncurryThis(''.replace);
var shift = functionUncurryThis([].shift);
var split = functionUncurryThis(''.split);
var stringSlice = functionUncurryThis(''.slice);
var toLowerCase = functionUncurryThis(''.toLowerCase);
var unshift = functionUncurryThis([].unshift);
var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';
var ALPHA = /[a-z]/i; // eslint-disable-next-line regexp/no-obscure-range -- safe

var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */

var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */

var EOF; // https://url.spec.whatwg.org/#ipv4-number-parser

var parseIPv4 = function parseIPv4(input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;

  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }

  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];

  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;

    if (part.length > 1 && charAt(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix == 8 ? 1 : 2);
    }

    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }

    push(numbers, number);
  }

  for (index = 0; index < partsLength; index++) {
    number = numbers[index];

    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }

  ipv4 = pop(numbers);

  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }

  return ipv4;
}; // https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO


var parseIPv6 = function parseIPv6(input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function chr() {
    return charAt(input, pointer);
  };

  if (chr() == ':') {
    if (charAt(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }

  while (chr()) {
    if (pieceIndex == 8) return;

    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }

    value = length = 0;

    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }

    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;

      while (chr()) {
        ipv4Piece = null;

        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;else return;
        }

        if (!exec(DIGIT, chr())) return;

        while (exec(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;else if (ipv4Piece == 0) return;else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }

        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }

      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;

    address[pieceIndex++] = value;
  }

  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;

    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;

  return address;
};

var findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;

  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }

      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }

  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }

  return maxIndex;
}; // https://url.spec.whatwg.org/#host-serializing


var serializeHost = function serializeHost(host) {
  var result, index, compress, ignore0; // ipv4

  if (typeof host == 'number') {
    result = [];

    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    }

    return join(result, '.'); // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);

    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;

      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }

    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = objectAssign$1({}, C0ControlPercentEncodeSet, {
  ' ': 1,
  '"': 1,
  '<': 1,
  '>': 1,
  '`': 1
});
var pathPercentEncodeSet = objectAssign$1({}, fragmentPercentEncodeSet, {
  '#': 1,
  '?': 1,
  '{': 1,
  '}': 1
});
var userinfoPercentEncodeSet = objectAssign$1({}, pathPercentEncodeSet, {
  '/': 1,
  ':': 1,
  ';': 1,
  '=': 1,
  '@': 1,
  '[': 1,
  '\\': 1,
  ']': 1,
  '^': 1,
  '|': 1
});

var percentEncode = function percentEncode(chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1(set, chr) ? chr : encodeURIComponent(chr);
}; // https://url.spec.whatwg.org/#special-scheme


var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}; // https://url.spec.whatwg.org/#windows-drive-letter

var isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA, charAt(string, 0)) && ((second = charAt(string, 1)) == ':' || !normalized && second == '|');
}; // https://url.spec.whatwg.org/#start-with-a-windows-drive-letter


var startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (string.length == 2 || (third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
}; // https://url.spec.whatwg.org/#single-dot-path-segment


var isSingleDot = function isSingleDot(segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
}; // https://url.spec.whatwg.org/#double-dot-path-segment


var isDoubleDot = function isDoubleDot(segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
}; // States:


var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function URLState(url, isBase, base) {
  var urlString = toString$2(url);
  var baseState, failure, searchParams;

  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function parse(input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;
    input = toString$2(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$1(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace$1(input, TAB_AND_NEW_LINE, '');
    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];

      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;

          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (url.isSpecial() != hasOwnProperty_1(specialSchemes, buffer) || buffer == 'file' && (url.includesCredentials() || url.port !== null) || url.scheme == 'file' && !url.host)) return;
            url.scheme = buffer;

            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }

            buffer = '';

            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;

          break;

        case NO_SCHEME:
          if (!base || base.cannotBeABaseURL && chr != '#') return INVALID_SCHEME;

          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }

          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          }

          break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;

          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
          } else if (chr == '/' || chr == '\\' && url.isSpecial()) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.path.length--;
            state = PATH;
            continue;
          }

          break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          }

          break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          }

          break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);

            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];

              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }

              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;else url.username += encodedCodePoints;
            }

            buffer = '';
          } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;

          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial()) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;else if (chr == ']') seenBracket = false;
            buffer += chr;
          }

          break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (chr == EOF || chr == '/' || chr == '?' || chr == '#' || chr == '\\' && url.isSpecial() || stateOverride) {
            if (buffer != '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = url.isSpecial() && port === specialSchemes[url.scheme] ? null : port;
              buffer = '';
            }

            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;

          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySliceSimple(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySliceSimple(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySliceSimple(base.path);
                url.shortenPath();
              }

              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          }
          break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }

          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySliceSimple(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);else url.host = base.host;
          }

          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            }

            continue;
          } else buffer += chr;

          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          }

          break;

        case PATH:
          if (chr == EOF || chr == '/' || chr == '\\' && url.isSpecial() || !stateOverride && (chr == '?' || chr == '#')) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();

              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }

              push(url.path, buffer);
            }

            buffer = '';

            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }

            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          }

          break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          }

          break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';else if (chr == '#') url.query += '%23';else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          }

          break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function parseHost(input) {
    var result, codePoints, index;

    if (charAt(input, 0) == '[') {
      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result; // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);

      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }

      this.host = result;
    } else {
      input = stringPunycodeToAscii(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function includesCredentials() {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function isSpecial() {
    return hasOwnProperty_1(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function shortenPath() {
    var path = this.path;
    var pathSize = path.length;

    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function serialize() {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';

    if (host !== null) {
      output += '//';

      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }

      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';

    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function setHref(href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function getOrigin() {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function getProtocol() {
    return this.scheme + ':';
  },
  setProtocol: function setProtocol(protocol) {
    this.parse(toString$2(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function getUsername() {
    return this.username;
  },
  setUsername: function setUsername(username) {
    var codePoints = arrayFrom(toString$2(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function getPassword() {
    return this.password;
  },
  setPassword: function setPassword(password) {
    var codePoints = arrayFrom(toString$2(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';

    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function getHost() {
    var host = this.host;
    var port = this.port;
    return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port;
  },
  setHost: function setHost(host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function getHostname() {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function setHostname(hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function getPort() {
    var port = this.port;
    return port === null ? '' : toString$2(port);
  },
  setPort: function setPort(port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString$2(port);
    if (port == '') this.port = null;else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function getPathname() {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function setPathname(pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function getSearch() {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function setSearch(search) {
    search = toString$2(search);

    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }

    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function getSearchParams() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function getHash() {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function setHash(hash) {
    hash = toString$2(hash);

    if (hash == '') {
      this.fragment = null;
      return;
    }

    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function update() {
    this.query = this.searchParams.serialize() || null;
  }
}; // `URL` constructor
// https://url.spec.whatwg.org/#url-class

var URLConstructor = function URL(url
/* , base */
) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));

  if (!descriptors) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function accessorDescriptor(getter, setter) {
  return {
    get: function get() {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref')); // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin

  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin')); // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol

  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol')); // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username

  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername')); // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password

  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword')); // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host

  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost')); // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname

  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname')); // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port

  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort')); // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname

  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname')); // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search

  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch')); // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams

  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams')); // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash

  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
} // `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson


defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, {
  enumerable: true
}); // `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior

defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, {
  enumerable: true
});

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL; // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL

  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', functionBindContext(nativeCreateObjectURL, NativeURL)); // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL

  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', functionBindContext(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

_export({
  global: true,
  constructor: true,
  forced: !urlConstructorDetection,
  sham: !descriptors
}, {
  URL: URLConstructor
}); // `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson


_export({
  target: 'URL',
  proto: true,
  enumerable: true
}, {
  toJSON: function toJSON() {
    return functionCall(URL.prototype.toString, this);
  }
});

var name$1 = "@hellobuild/blossom-websites-core-package";
var description$1 = "Blossom Static Websites library";
var version$1 = "1.5.35";
var author$1 = "@hellobuild";
var source = "src/index.js";
var main$1 = "dist/index.cjs.js";
var keywords$1 = [];
var repository$1 = "git://github.com/hellobuild/BlossomWebsitesCorePackage.git";
var publishConfig = {
  registry: "https://npm.pkg.github.com"
};
var files = ["dist/*.js", "dist/*.css", "package.json", "README.md"];
var scripts$1 = {
  build: "rollup -c",
  "build-watch": "rollup -c -w",
  format: "prettier --write \"src/**/*.{js,jsx,json}\"",
  lint: "eslint --fix \"src/**/*.{js,jsx}\" --ignore-pattern \"src/forms/*\"",
  storybook: "start-storybook -p 6006",
  "build-storybook": "build-storybook"
};
var dependencies$1 = {
  "@react-google-maps/api": "^2.12.1",
  axios: "^0.21.1",
  classnames: "^2.2.6",
  "core-js": "^3.11.1",
  "date-fns": "^2.17.0",
  formik: "^2.2.6",
  "gatsby-link": "^3.14.0",
  "google-map-react": "^2.1.9",
  "hoist-non-react-statics": "^3.3.2",
  "json-stable-stringify": "^1.0.1",
  nanoid: "^3.1.22",
  "node-fetch": "^2.6.1",
  postcss: "^8.2.1",
  "prop-types": "^15.7.2",
  "react-error-boundary": "^3.1.0",
  "react-google-recaptcha": "^2.1.0",
  "react-helmet": "^6.1.0",
  "react-player": "^2.9.0",
  "react-query": "3.9.8",
  "react-slideshow-image": "^3.4.3",
  "react-toastify": "^7.0.3",
  "styled-components": "^5.2.1",
  swiper: "^6.5.9"
};
var peerDependencies = {
  gatsby: "^2.26.1",
  lodash: "^4.17.20",
  react: "^16.12.0",
  "react-dom": "^16.12.0",
  "styled-components": "^5.2.1"
};
var devDependencies$1 = {
  "@babel/cli": "^7.13.10",
  "@babel/core": "^7.13.16",
  "@babel/preset-env": "^7.13.10",
  "@babel/preset-react": "^7.12.13",
  "@etchteam/storybook-addon-css-variables-theme": "^1.0.2",
  "@gatsbyjs/reach-router": "^1.3.6",
  "@rollup/plugin-babel": "^5.3.0",
  "@rollup/plugin-commonjs": "^17.1.0",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-node-resolve": "^11.2.0",
  "@storybook/addon-actions": "^6.3.8",
  "@storybook/addon-essentials": "^6.3.8",
  "@storybook/addon-links": "^6.3.8",
  "@storybook/react": "^6.3.8",
  "@types/swiper": "^5.4.2",
  "babel-eslint": "^10.1.0",
  "babel-loader": "^8.2.2",
  dotenv: "^8.2.0",
  eslint: "^7.24.0",
  "eslint-config-airbnb": "^18.2.1",
  "eslint-config-prettier": "^7.2.0",
  "eslint-plugin-import": "^2.22.1",
  "eslint-plugin-jsx-a11y": "^6.4.1",
  "eslint-plugin-prettier": "^3.3.1",
  "eslint-plugin-react": "^7.22.0",
  "eslint-plugin-react-hooks": "^4.2.0",
  husky: "^4.3.8",
  "lint-staged": "^10.5.3",
  "npm-run-all": "^4.1.5",
  prettier: "^2.3.0",
  react: "16.12.0",
  "react-dom": "16.12.0",
  rollup: "^2.41.1",
  "rollup-plugin-alias": "^2.2.0",
  "rollup-plugin-css-only": "^3.1.0",
  "rollup-plugin-delete": "^2.0.0",
  "rollup-plugin-hot-css": "^0.4.0",
  "rollup-plugin-includepaths": "^0.2.4",
  "rollup-plugin-peer-deps-external": "^2.2.4",
  sass: "^1.32.7"
};
var husky = {
  hooks: {
    "pre-commit": "lint-staged"
  }
};
var pkg$1 = {
  name: name$1,
  "private": false,
  description: description$1,
  version: version$1,
  author: author$1,
  source: source,
  main: main$1,
  keywords: keywords$1,
  repository: repository$1,
  publishConfig: publishConfig,
  files: files,
  scripts: scripts$1,
  dependencies: dependencies$1,
  peerDependencies: peerDependencies,
  devDependencies: devDependencies$1,
  husky: husky,
  "lint-staged": {
    "src/**/*.{js,jsx}": ["prettier --write", "eslint --fix", "git add"],
    "src/**/*.{json}": ["prettier --write", "git add"]
  }
};
var contactFormTemplate = {
  data: {
    "contact-information": {
      title: "",
      description: "",
      cols: 2,
      inputs: [{
        label: "Your Full Name",
        type: "text",
        name: "fullName",
        required: true,
        minLength: 2,
        maxLength: 40
      }, {
        label: "Your Phone Number",
        type: "text",
        name: "phoneNumber",
        required: true,
        minLength: 7,
        maxLength: 15,
        regex: [{
          labelError: "The value entered is not a number.",
          rule: "^\\d{7,15}$"
        }]
      }, {
        label: "Your Email",
        type: "text",
        name: "email",
        required: true,
        theme: {
          fullWidth: true
        },
        regex: [{
          labelError: "The value entered is not a email.",
          rule: ""
        }]
      }, {
        label: "Your Message",
        type: "textarea",
        name: "message",
        required: true,
        minLength: 2,
        maxLength: 500,
        theme: {
          fullWidth: true
        }
      }, {
        label: "ReCAPTCHA",
        type: "reCaptcha",
        name: "reCaptcha",
        required: true,
        theme: {
          fullWidth: true
        }
      }]
    }
  },
  options: {}
};
var bodyTextVariantsTypes = {
  DECORATION_NONE: "DECORATION_NONE",
  DECORATION_DOTTEN: "DECORATION_DOTTEN",
  NONE: "NONE"
};
var branchVariantsTypes = {
  EXPANDED: "EXPANDED",
  NONE: "NONE",
  VERTICAL_LINE: "VERTICAL_LINE"
};
var buttonFillTypes = {
  FILLED: "FILLED",
  OUTLINE_DARK: "OUTLINE_DARK",
  NONE: "NONE"
};
var buttonStyleTypes = {
  STANDARD: "STANDARD",
  PILL: "PILL",
  NONE: "NONE"
};
var buttonVariantsTypes = {
  SELECT: "SELECT",
  CALLOUT: "CALLOUT",
  NONE: "NONE"
};
var customPageFeatureVariantsTypes = {
  PAGE_HEADER_GRADIENT: "PageHeaderGradient",
  FEATURES_V2: "FeaturesV2",
  TABLES: "Tables",
  NONE: "NONE"
};
var dividersVariantsTypes = {
  CALLOUT: "CALLOUT",
  IFRAME: "IFRAME",
  FEATURE: "FEATURE",
  PRODUCTS: "PRODUCTS",
  DIVIDER: "DIVIDER",
  HERO: "HERO",
  NONE: "NONE"
};
var dividerVariantsTypes = {
  VERTICAL: "VERTICAL",
  HORIZONTAL: "HORIZONTAL",
  NONE: "NONE"
};
var customPageGenericVariantsTypes = {
  PAGE_HEADER_GRADIENTS: "PageHeaderGradients",
  TEXTS_LISTS: "TextsLists",
  TABLES: "Tables",
  NONE: "NONE"
};
var calloutVariantsTypes = {
  BUTTON: "BUTTON",
  MOBILE_APPS: "MOBILE_APPS",
  MOBILE_APPS_GRADIENTS_LIGHT: "GRADIENT_BACKGROUND_LIGHT",
  MOBILE_APPS_GRADIENTS_DARK: "GRADIENT_BACKGROUND_DARK",
  MOBILE_APPS_CENTERED_NO_BACKGROUND: "CENTERED_NO_BACKGROUND",
  DATA: "DATA",
  TEXT: "TEXT",
  NONE: "NONE",
  IMAGE_WITH_GRADIENT: "IMAGE_WITH_GRADIENT",
  IMAGE_WITH_GRADIENT_AND_PADDING: "IMAGE_WITH_GRADIENT_AND_PADDING"
};
var dynamicPagesVariantsTypes = {
  CUSTOM_PAGE_FEATURE: "CustomPageFeature",
  CUSTOM_PAGE_GENERIC: "CustomPageGeneric",
  DYNAMIC_ZONES_PAGE: "DynamicZonesPage"
};
var dynamicsComponentsVariantsTypes = {
  "all.iframe-component": "Iframe",
  "all.page-header-gradients": "HeaderGradients",
  "all.page-header-gradient": "HeaderGradient",
  "all.feature-v1": "FeatureWithDiversV1",
  "all.feature-v2": "FeatureWithDiversV2",
  "all.feature-v3": "FeatureWithDiversV3",
  "all.feature-full-background": "FeatureFullBackground",
  "all.feature-colapse-content": "FeatureCollapseContent",
  "all.table": "TableComponent",
  "all.team-component": "TeamMembers",
  "all.texts-list": "TextsLists",
  "all.heros-list": "HeroWithDividers",
  "all.divider-image": "DividerImage",
  "all.hero": "HeroWithDividers",
  "all.products-list": "ProductsWithDividers",
  "all.callouts": "CalloutTextWithDividers",
  "all.callout-button": "CalloutButtonWithDividers",
  "all.callout-data": "CalloutDataWithDividers",
  "all.callout-mobile-apps": "CalloutMobileAppsWithDividers",
  "all.callout-with-image-and-gradient": "CalloutWithGradient",
  "all.rich-text": "RichText",
  "all.pop-up-galery": "PopUpGaleryCommon",
  "all.compressed-content-list": "CompressedContent",
  "all.title-with-gradients": "TitleWithGradients",
  "all.title": "PageTitle",
  "all.autolink": "AutoLink",
  "all.divider": "DividerDynamicComponent",
  "all.multiple-tabs-component": "Tabs",
  "all.widget": "Widget",
  "all.rates-list": "RatesList",
  "all.contact": "Contact",
  "all.branch-expanded": "BranchExpandedComponent",
  "all.member-feedback": "MemberFeedback",
  "all.form-template": "FormTemplate",
  "all.search": "Search",
  "all.opt-in-form": "OptInForm",
  "all.reports": "Reports",
  "all.video-list": "VideoList",
  "all.video": "Video",
  "all.description-and-links": "DescriptionAndLinks",
  "all.rectangle": "Rectangle",
  "all.images-galery-rich-text": "ImagesGaleryRichText",
  "all.images-galery": "ImagesGalery",
  "all.custom-buttons": "CustomButtons",
  "all.products-rates": "ProductsRates",
  "all.rates-tabs": "RatesTabs",
  "all.404-message": "Message404"
};
var dynamicPageRendereableComponentsTypes = {
  FEATURES_V2: "all.feature-v2",
  FEATURES_V1: "all.feature-v1",
  FEATURES_V3: "all.feature-v3",
  PAGE_HEADER_GRADIENT: "all.page-header-gradient",
  PAGE_HEADER_GRADIENTS: "all.page-header-gradients",
  TABLE: "all.table",
  SAVES: "all.save",
  TEXTS_LISTS: "all.texts-list",
  HERO: "all.heros-list",
  DIVIDER_IMAGEN: "all.divider-image",
  TEXT_BODY_A: "all.text-body-a",
  PRODUCTS: "all.products-list",
  CALLOUT_BUTTON: "all.callouts",
  CALLOUT_DATA: "all.callout-data",
  TABS: "all.multiple-tabs-component",
  WIDGET: "all.widget",
  MEMBER_FEEDBACK: "all.member-feedback",
  VIDEO_LIST: "all.video-list",
  DESCRIPTION_AND_LINKS: "all.description-and-links",
  RECTANGLE: "all.rectangle",
  IMAGES_GALERY: "all.images-galery",
  IMAGES_GALERY_RICHTEXT: "all.images-galery-rich-text",
  POP_UP_GALERY: "all.pop-up-galery",
  CALLOUT_MOBILE_APPS: "",
  CUSTOM_BUTTONS: "all.custom-buttons",
  PRODUCTS_RATES: "all.products-rates",
  NONE: "none"
};
var featureVariantsTypes = {
  V1: "V1",
  V2: "V2",
  V3: "V3",
  V4: "V4",
  V5: "V5",
  V6: "V6",
  FEATURE_COLLAPSE_CONTENT: "FEATURE_COLLAPSE_CONTENT",
  NONE: "NONE"
};
var heroVariantsTypes = {
  CENTRAL: "CENTRAL",
  FULL: "FULL",
  CAROUSEL: "CAROUSEL",
  CAROUSEL_CENTRAL: "CAROUSEL_CENTRAL",
  CAROUSEL_CENTRAL_FADE: "CAROUSEL_CENTRAL_FADE",
  DINAMIC: "DINAMIC",
  NONE: "NONE"
};
var iconSelectorTypes = {
  EMAIL: "email",
  TELEPHONE_NUMBER: "telephoneNumber",
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  LINKEDIN: "linkedin",
  NONE: "NONE"
};
var iconVariantsTypes = {
  LINKEDIN: "/images/icons/linkedin.svg",
  YOUTUBE: "/images/icons/youtube.svg",
  SEARCH: "/images/icons/search.svg",
  ENVELOPE: "/images/icons/envelope.svg",
  PHONE: "/images/icons/phone.svg",
  FACEBOOK_SIMPLE: "/images/icons/facebook.svg",
  INSTAGRAM: "/images/icons/instagram.svg",
  FACEBOOK: "/images/icons/facebook.svg",
  PIN: "/images/icons/pin.svg",
  ANDROID: "/images/icons/android.svg",
  APPLE: "/images/icons/apple.svg",
  TWITTER: "/images/icons/twitter.svg",
  NAVIGATION_MENU: "/images/icons/navigation-menu.svg",
  REMOVE: "/images/icons/remove.svg",
  ARROW_DOWN_1: "/images/icons/arrow-down-1.svg",
  ARROW_UP_1: "/images/icons/arrow-up-1.svg",
  NONE: "NONE"
};
var pageGenericVariantsTypes = {
  PAGE_HEADER_GRADIENTS: "PageHeaderGradients",
  TEXTS_LISTS: "TextsLists",
  TABLES: "Tables",
  NONE: "NONE"
};
var pageFeatureVariantsTypes = {
  PAGE_HEADER_GRADIENT: "PageHeaderGradient",
  FEATURES_V2: "FeaturesV2",
  TABLES: "Tables",
  NONE: "NONE"
};
var pageHeaderColorVariantsTypes = {
  PRIMARY: "PRIMARY",
  GRAYSCALE: "GRAYSCALE",
  NONE: "NONE"
};
var pageHeaderVariantsTypes = {
  GRADIENT: "GRADIENT",
  GRADIENTS: "GRADIENTS",
  NONE: "NONE"
};
var pageVariantsTypes = {
  FUTURE: "FUTURE",
  FUTURE_NODE: "FUTURE_NODE",
  FUTURE_TABLE: "FUTURE_TABLE",
  GENERIC: "GENERIC",
  NONE: "NONE"
};
var textVariantsTypes = {
  SIMPLE: "SIMPLE",
  H2: "H2",
  DESCRIPTION: "DESCRIPTION",
  NONE: "NONE"
};
var linkVariantTypes = {
  PAGE_LINKS: "pageLinks",
  URL: "url",
  PDF: "pdf",
  SEARCH: "search"
};
var iconTypes = {
  LINKEDIN: "LINKEDIN",
  YOUTUBE: "YOUTUBE",
  SEARCH: "SEARCH",
  ENVELOPE: "ENVELOPE",
  PHONE: "PHONE",
  FACEBOOK_SIMPLE: "FACEBOOK_SIMPLE",
  INSTAGRAM: "INSTAGRAM",
  FACEBOOK: "FACEBOOK",
  PIN: "PIN",
  ANDROID: "ANDROID",
  APPLE: "APPLE",
  TWITTER: "TWITTER",
  NAVIGATION_MENU: "NAVIGATION_MENU",
  REMOVE: "REMOVE",
  ARROW_DOWN_1: "ARROW_DOWN_1",
  ARROW_UP_1: "ARROW_UP_1",
  NONE: "NONE"
};
var productVariantsTypes = {
  OUTLINE: "OUTLINE",
  GRADIENT: "GRADIENT",
  DIVIDED_BY_GRADIENT: "DIVIDED_BY_GRADIENT",
  PRODUCT_WITHOUT_BORDER: "PRODUCT_WITHOUT_BORDER",
  IMAGE_AND_TITLE: "IMAGE_AND_TITLE",
  NONE: "NONE"
};
var productsVariantsTypes = {
  HORIZONTAL_COLLECTION: "HORIZONTAL_COLLECTION",
  LIST: "LIST",
  NONE: "NONE"
};
var themeVariantsTypes = {
  Default: "Default"
};
var contactVariantsTypes = {
  REGULAR: "REGULAR",
  BACKGROUND: "BACKGROUND"
};
var tabVariantsTypes = {
  STANDARD: "STANDARD",
  NONE: "NONE"
};
var tabsVariantsTypes = {
  VERTICAL: "VERTICAL",
  HORIZONTAL: "HORIZONTAL",
  NONE: "NONE"
};
var dynamicTemplatesVersionVariantsTypes = {
  DYNAMIC_TEMPLATE_V1: "DynamicTemplateV1",
  DYNAMIC_TEMPLATE_V2: "DynamicTemplateV2",
  DYNAMIC_TEMPLATE_V3: "DynamicTemplateV3",
  DYNAMIC_TEMPLATE_V4: "DynamicTemplateV4",
  DYNAMIC_TEMPLATE_V5: "DynamicTemplateV5",
  DYNAMIC_TEMPLATE_V6: "DynamicTemplateV6",
  DYNAMIC_TEMPLATE_V7: "DynamicTemplateV7",
  DYNAMIC_TEMPLATE_V8: "DynamicTemplateV8",
  DYNAMIC_TEMPLATE_V9: "DynamicTemplateV9",
  NONE: "NONE"
};
var homeTemplatesVersionVariantTypes = {
  HOME_TEMPLATE_V1: "HomeTemplateV1",
  HOME_TEMPLATE_V2: "HomeTemplateV2",
  HOME_TEMPLATE_V3: "HomeTemplateV3",
  HOME_TEMPLATE_V4: "HomeTemplateV4",
  HOME_TEMPLATE_V5: "HomeTemplateV5",
  HOME_TEMPLATE_V6: "HomeTemplateV6",
  HOME_TEMPLATE_V7: "HomeTemplateV7",
  HOME_TEMPLATE_V8: "HomeTemplateV8",
  HOME_TEMPLATE_V9: "HomeTemplateV9",
  NONE: "NONE"
};
var contactUsTemplatesVersionVariantsTypes = {
  CONTACT_US_TEMPLATE_V1: "ContactUsTemplateV1",
  CONTACT_US_TEMPLATE_V2: "ContactUsTemplateV2",
  CONTACT_US_TEMPLATE_V3: "ContactUsTemplateV3",
  CONTACT_US_TEMPLATE_V4: "ContactUsTemplateV4",
  CONTACT_US_TEMPLATE_V5: "ContactUsTemplateV5",
  CONTACT_US_TEMPLATE_V6: "ContactUsTemplateV6",
  CONTACT_US_TEMPLATE_V7: "ContactUsTemplateV7",
  CONTACT_US_TEMPLATE_V8: "ContactUsTemplateV8",
  CONTACT_US_TEMPLATE_V9: "ContactUsTemplateV9",
  CONTACT_US_TEMPLATE_V10: "ContactUsTemplateV10",
  NONE: "NONE"
};
var aboutUsTemplatesVersionVariantsTypes = {
  ABOUT_US_TEMPLATE_V1: "AboutUsTemplateV1",
  ABOUT_US_TEMPLATE_V2: "AboutUsTemplateV2",
  ABOUT_US_TEMPLATE_V3: "AboutUsTemplateV3",
  ABOUT_US_TEMPLATE_V5: "AboutUsTemplateV5",
  ABOUT_US_TEMPLATE_V6: "AboutUsTemplateV6",
  ABOUT_US_TEMPLATE_V7: "AboutUsTemplateV7",
  ABOUT_US_TEMPLATE_V8: "AboutUsTemplateV8",
  NONE: "NONE"
};
var colorsTypes = {
  SECONDARY: "var(--secondary-color)",
  VERY_ULTRA_LIGHT: "var(--grayscale-6-color)",
  WHITE: "var(--grayscale-0-color)",
  BLACK: "var(--grayscale-100-color)",
  ULTRA_DARK: "var(--grayscale-80-color)",
  DARK: "var(--grayscale-70-color)",
  SEMI_DARK: "var(--grayscale-50-color)",
  ULTRA_LIGHT: "var(--grayscale-20-color)",
  LIGHT: "var(--grayscale-30-color)",
  PRIMARY_VERY_ULTRA_LIGHT: "var(--primary-6-color)",
  PRIMARY_ULTRA_LIGHT: "var(--primary-50-color)",
  PRIMARY_LIGHT: "var(--primary-80-color)",
  PRIMARY: "var(--primary-color)",
  PRIMARY_LIGHT_SEMI_DARK: "var(--primary-100-color)",
  PRIMARY_SEMI_DARK: "var(--primary-110-color)",
  HIGHT_LIGHT_PRIMARY: "var(--primary-30-color)",
  PRIMARY_DARK: "var(--primary-150-color)",
  PRIMARY_ULTRA_DARK: "var(--primary-180-color)",
  TRANSPARENT: "transparent",
  UI_ALERT: "var(--ui-alert-color)",
  UI_ALERT_FADED: "var(--ui-alert-faded-color)",
  NONE: undefined
};
var colorsVariantsTypes = {
  SECONDARY: "SECONDARY",
  WHITE: "WHITE",
  BLACK: "BLACK",
  ULTRA_DARK: "ULTRA_DARK",
  SEMI_DARK: "SEMI_DARK",
  DARK: "DARK",
  VERY_ULTRA_LIGHT: "VERY_ULTRA_LIGHT",
  ULTRA_LIGHT: "ULTRA_LIGHT",
  LIGHT: "LIGHT",
  PRIMARY_VERY_ULTRA_LIGHT: "PRIMARY_VERY_ULTRA_LIGHT",
  PRIMARY_ULTRA_LIGHT: "PRIMARY_ULTRA_LIGHT",
  PRIMARY_LIGHT: "PRIMARY_LIGHT",
  PRIMARY: "PRIMARY",
  HIGHT_LIGHT_PRIMARY: "HIGHT_LIGHT_PRIMARY",
  PRIMARY_SEMI_DARK: "PRIMARY_SEMI_DARK",
  PRIMARY_DARK: "PRIMARY_DARK",
  PRIMARY_ULTRA_DARK: "PRIMARY_ULTRA_DARK",
  TRANSPARENT: "TRANSPARENT",
  UI_ALERT: "UI_ALERT",
  UI_ALERT_FADED: "UI_ALERT_FADED",
  NONE: "NONE"
};
var textSizesTypes = {
  ULTRA_SMALL: "12px",
  VERY_SMALL: "14px",
  SMALL: "16px",
  NORMAL: "18px",
  LARGE: "20px",
  VERY_LARGE: "22px",
  BIG: "24px",
  VERY_BIG: "26px",
  HEADER_1: "40px",
  HEADER_1_H2: "42px",
  HEADER_2: "44px",
  HEADER_3: "50px",
  HEADER_4: "54px",
  HEADER_5: "60px",
  HEADER_6: "63px",
  NONE: undefined
};
var textSizesVariantsTypes = {
  ULTRA_SMALL: "ULTRA_SMALL",
  VERY_SMALL: "VERY_SMALL",
  SMALL: "SMALL",
  NORMAL: "NORMAL",
  LARGE: "LARGE",
  VERY_LARGE: "VERY_LARGE",
  BIG: "BIG",
  VERY_BIG: "VERY_BIG",
  HEADER_1: "HEADER_1",
  HEADER_1_H2: "HEADER_1_H2",
  HEADER_2: "HEADER_2",
  HEADER_3: "HEADER_3",
  HEADER_4: "HEADER_4",
  HEADER_5: "HEADER_5",
  HEADER_6: "HEADER_6",
  NONE: "NONE"
};
var fontsFamiliesTypes = {
  PRIMARY: "var(--primary-family)",
  SECONDARY: "var(--secondary-family)"
};
var fontsFamiliesVariantsTypes = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY"
};
var headerDesktopVariantTypes = {
  STANDARD: "STANDARD",
  DESKTOP_DOUBLE: "DESKTOP_DOUBLE",
  CONTAINED: "CONTAINED",
  BANNER: "BANNER",
  NONE: "NONE"
};
var headerCompressedVariantTypes = {
  STANDARD: "STANDARD",
  NONE: "NONE"
};
var headerMobileVariantTypes = {
  STANDARD: "STANDARD",
  DOUBLE: "DOUBLE",
  NONE: "NONE"
};
var headerMobileCompressedVariantTypes = {
  STANDARD: "STANDARD",
  DESKTOP_DOUBLE: "DESKTOP_DOUBLE",
  CONTAINED: "CONTAINED",
  NONE: "NONE"
};
var loginVariantTypes = {
  DIRECT: "DIRECT",
  FORM: "FORM",
  POST: "POST",
  NO_MODAL: "NO_MODAL"
};
var inputVariantTypes = {
  TEXT: "TEXT",
  TEXTAREA: "TEXTAREA",
  SELECT: "SELECT",
  CHECK: "CHECK",
  NONE: "NONE"
};
var videoVariantTypes = {
  SIMPLE: "SIMPLE",
  NONE: "NONE"
};
var videoListVariantTypes = {
  VERTICAL: "VERTICAL",
  NONE: "NONE"
};
var imagesGaleryVariantsTypes = {
  RICHTEXT: "RICHTEXT",
  NONE: "NONE"
};
var optInFormTemplate = {
  data: {
    "opt-in-form-for-atm-and-debit-card": {
      title: "Opt-In Form for ATM & Debit Card",
      description: "",
      cols: 2,
      inputs: [{
        label: "Member name",
        type: "text",
        name: "memberName",
        required: true,
        minLength: 2,
        maxLength: 40,
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }, {
        label: "Account Number",
        type: "text",
        name: "accountNumber",
        required: false,
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        },
        regex: [{
          labelError: "The value entered is not a number.",
          rule: "^\\d+$"
        }]
      }, {
        label: "Phone Number",
        type: "text",
        name: "phoneNumber",
        required: false,
        minLength: 7,
        maxLength: 14,
        regex: [{
          labelError: "The value entered is not a number.",
          rule: "^\\d+$"
        }],
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }, {
        label: "Last 4 of SSN",
        type: "text",
        name: "ssn",
        required: true,
        minLength: 4,
        maxLength: 4,
        regex: [{
          labelError: "The value entered is not a number.",
          rule: "^\\d+$"
        }],
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }, {
        label: "Email",
        type: "email",
        name: "email",
        required: false,
        minLength: 2,
        maxLength: 40,
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        },
        theme: {
          fullWidth: true
        }
      }]
    }
  },
  options: {}
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$3(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$g() {
  _extends$g = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$g.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$6(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e3) {
          throw _e3;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e4) {
      didErr = true;
      err = _e4;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var memberFeedbackTemplate = function memberFeedbackTemplate() {
  var _data;

  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    website: "",
    commentTitle: "",
    tellUs: ""
  };
  return {
    data: (_data = {}, _defineProperty$1(_data, lodash.kebabCase(data === null || data === void 0 ? void 0 : data.website) || "web-sites", {
      title: data === null || data === void 0 ? void 0 : data.website,
      description: "",
      cols: 1,
      inputs: [{
        label: "Web Sites",
        type: "select",
        name: "websites",
        required: true,
        theme: {
          fullWidth: true
        },
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }]
    }), _defineProperty$1(_data, lodash.kebabCase(data === null || data === void 0 ? void 0 : data.commentTitle) || "comments", {
      title: data === null || data === void 0 ? void 0 : data.commentTitle,
      description: "",
      cols: 1,
      inputs: [{
        label: "Comments",
        type: "textarea",
        name: "message",
        required: true,
        minLength: 2,
        maxLength: 255,
        theme: {
          fullWidth: true
        },
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }]
    }), _defineProperty$1(_data, lodash.kebabCase(data === null || data === void 0 ? void 0 : data.tellUs) || "tell-us", {
      title: data === null || data === void 0 ? void 0 : data.tellUs,
      description: "",
      cols: 2,
      inputs: [{
        label: "Name",
        type: "text",
        name: "name",
        required: true,
        minLength: 2,
        maxLength: 40,
        theme: {
          fullWidth: true
        },
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }, {
        label: "Email",
        type: "email",
        name: "email",
        required: false,
        minLength: 2,
        maxLength: 40,
        theme: {
          fullWidth: true
        },
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }, {
        label: "Phone",
        type: "number",
        name: "phone",
        required: false,
        minLength: 8,
        maxLength: 14,
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        }
      }, {
        label: "Fax",
        type: "number",
        name: "fax",
        required: false,
        minLength: 7,
        maxLength: 15,
        props: {
          styles: {
            widthBorder: false,
            backgroundColor: colorsTypes.WHITE
          }
        },
        regex: [// {
          //   labelError: "The value entered is not a number.",
          //   rule: "^\\d{7,15}$",
          // },
        ]
      }]
    }), _data),
    options: {
      websites: [{
        value: "WS",
        label: "Web Site"
      }]
    }
  };
};
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

/* eslint-disable no-param-reassign */


function isObject$5(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}

function extend$5(target, src) {
  if (target === void 0) {
    target = {};
  }

  if (src === void 0) {
    src = {};
  }

  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$5(src[key]) && isObject$5(target[key]) && Object.keys(src[key]).length > 0) {
      extend$5(target[key], src[key]);
    }
  });
}

var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};

function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend$5(doc, ssrDocument);
  return doc;
}

var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }

    return setTimeout(callback, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }

    clearTimeout(id);
  }
};

function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend$5(win, ssrWindow);
  return win;
}
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */


function _inheritsLoose$5(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/* eslint-disable no-proto */


function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose$5(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized$2(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}

function arrayFilter$1(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}

function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter$1(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  var window = getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter$1(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index$1() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq$1(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition$1,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd$1,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index$1,
  eq: eq$1,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle$1(el) {
  var window = getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$4(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$4() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$4(to[nextKey]) && isObject$4(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$4(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$4(to[nextKey]) && isObject$4(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$4(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject$4(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = getDocument();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}

var support;

function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}

var browser$2;

function calcBrowser() {
  var window = getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser$2) {
    browser$2 = calcBrowser();
  }

  return browser$2;
}

var supportsResizeObserver = function supportsResizeObserver() {
  var window = getWindow();
  return typeof window.ResizeObserver !== 'undefined';
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    extend$4(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = getWindow();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = getWindow();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = getWindow();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      observer: _extends$f({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
};
var modular = {
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        extend$4(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
};
/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  extend$4(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  extend$4(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  extend$4(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  extend$4(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */


function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = $(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  extend$4(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      extend$4(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events$1 = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$4(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  extend$4(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints$1 = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};
var defaults$1 = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var prototypes = {
  modular: modular,
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events$1,
  breakpoints: breakpoints$1,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper$1 = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = extend$4({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$4({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = extend$4({}, defaults$1);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = extend$4({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$4({}, swiper.params);
    swiper.passedParams = extend$4({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    extend$4(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = getDocument();
      var wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    extend$4(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    extend$4(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults$1;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer$1]);
var SwiperCore = Swiper$1;

function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$e.apply(this, arguments);
}

var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = $(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = $(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    extend$4(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      navigation: _extends$e({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    extend$4(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
};
var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      pagination: _extends$d({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = nextTick(function () {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
        swiper.autoplay.run();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
      });
    }
  },
  onVisibilityChange: function onVisibilityChange() {
    var swiper = this;
    var document = getDocument();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      swiper.autoplay.run();
      swiper.autoplay.paused = false;
    }
  },
  onTransitionEnd: function onTransitionEnd(e) {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.run();
    }
  },
  onMouseEnter: function onMouseEnter() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
  },
  onMouseLeave: function onMouseLeave() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    swiper.autoplay.run();
  },
  attachMouseEvents: function attachMouseEvents() {
    var swiper = this;

    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
    }
  },
  detachMouseEvents: function detachMouseEvents() {
    var swiper = this;
    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
  }
};
var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      autoplay: _extends$c({}, Autoplay, {
        running: false,
        paused: false
      })
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        var document = getDocument();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        swiper.autoplay.attachMouseEvents();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove(swiper) {
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd(swiper) {
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy(swiper) {
      swiper.autoplay.detachMouseEvents();

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      var document = getDocument();
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
};

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset = $slideEl[0].swiperSlideOffset;
      var tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration);

    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};
var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      fadeEffect: _extends$b({}, Fade)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + "fade");
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      extend$4(swiper.params, overwriteParams);
      extend$4(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate(swiper) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
};

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

var Thumbs = {
  init: function init() {
    var swiper = this;
    var thumbsParams = swiper.params.thumbs;
    if (swiper.thumbs.initialized) return false;
    swiper.thumbs.initialized = true;
    var SwiperClass = swiper.constructor;

    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      extend$4(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      extend$4(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (isObject$4(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass(extend$4({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false
      }));
      swiper.thumbs.swiperCreated = true;
    }

    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    return true;
  },
  onThumbClick: function onThumbClick() {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex;

    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }

    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;

      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }

      var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }

    swiper.slideTo(slideToIndex);
  },
  update: function update(initial) {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex;
      var direction;

      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix(); // eslint-disable-next-line

          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        } // Find actual thumbs index to slide to


        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();

        if (typeof prevThumbsIndex === 'undefined') {
          newThumbsIndex = nextThumbsIndex;
        } else if (typeof nextThumbsIndex === 'undefined') {
          newThumbsIndex = prevThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
          newThumbsIndex = nextThumbsIndex;
        } else {
          newThumbsIndex = prevThumbsIndex;
        }

        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }

      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }

      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;

        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    } // Activate thumbs


    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }

    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.removeClass(thumbActiveClass);

    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
      }
    } else {
      for (var _i = 0; _i < thumbsToActivate; _i += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i).addClass(thumbActiveClass);
      }
    }
  }
};
var Thumbs$1 = {
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      thumbs: _extends$a({
        swiper: null,
        initialized: false
      }, Thumbs)
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      var thumbs = swiper.params.thumbs;
      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange: function slideChange(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update: function update(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize: function resize(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate: function observerUpdate(swiper) {
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition: function setTransition(swiper, duration) {
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy: function beforeDestroy(swiper) {
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;

      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    }
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            classes.push(arg.toString());
            continue;
          }

          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d$1 = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h$1 = b ? Symbol.for("react.provider") : 60109,
    k$1 = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m$1 = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r$1 = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w$1 = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y$1 = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m$1:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n:
              case t:
              case r$1:
              case h$1:
                return a;

              default:
                return u;
            }

        }

      case d$1:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m$1;
}

var AsyncMode = l;
var ConcurrentMode = m$1;
var ContextConsumer = k$1;
var ContextProvider = h$1;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r$1;
var Portal = d$1;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k$1;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h$1;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r$1;
};

var isPortal = function isPortal(a) {
  return z(a) === d$1;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m$1 || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n || a.$$typeof === w$1 || a.$$typeof === x || a.$$typeof === y$1 || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$b = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty$b.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;
var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has$1 = has$2;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {
      /**/
    }
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;
var checkPropTypes = checkPropTypes_1;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);

        if (checkerResult == null) {
          return null;
        }

        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }

      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;
var require$$2$1 = factoryWithThrowingShims;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = require$$2$1();
  }
});
var PropTypes = propTypes;
var breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
};

function createButtonStyles(type, fill, disabled) {
  var GENERAL_STYLES = "login-button-Style tw-transition-all tw-inline-block tw-font-medium bl-text-xs focus:tw-outline-none tw-cursor-pointer";
  var TYPE_STYLES = {
    STANDARD: "login-button-Style tw-px-8 tw-py-3 tw-rounded-lg",
    PILL: "login-button-Style tw-px-5 tw-py-1 tw-rounded-full"
  };
  var FILL_STYLES = {
    FILLED: "login-button-Style bl-bg-primary bl-text-grayscale-0 hover:bl-bg-primary-80 tw-border-2 bl-border-primary hover:bl-border-primary-80",
    OUTLINE_DARK: "login-button-Style tw-border-solid tw-border-black tw-border-2 hover:bl-text-grayscale-70 hover:bl-border-grayscale-70"
  };
  return "".concat(GENERAL_STYLES, " ").concat(TYPE_STYLES[type] || "", " ").concat(FILL_STYLES[fill] || "", " ").concat(disabled ? "tw-opacity-75 tw-cursor-not-allowed" : "").trim();
}

var _templateObject$2U;

var GlobalStyleComponent = styled.createGlobalStyle(_templateObject$2U || (_templateObject$2U = _taggedTemplateLiteral(["\n  // Variables (DOC): http://www.sass-lang.com/documentation/variables\n  // Styled Components (DOC): https://styled-components.com/docs/basics\n\n  // \u2728 (START) \u2728 Theme: Dynamic CSS/SASS Variable\n  ", "\n    // \u2728 (END) \u2728 Theme: Dynamic CSS/SASS Variable\n  *,\n  *::after,\n  *::before {\n    box-sizing: border-box;\n    font-family: var(--primary-family);\n  }\n\n  body {\n    height: 100vh;\n    margin: 0;\n    padding: 0;\n\n    transition: all 0.25s linear;\n\n    * {\n      transition: all linear 100ms;\n    }\n  }\n\n\n  .tw-custom-container .tw-container {\n    padding: 0 ", ";\n  }\n\n  .tw-x-container {\n    max-width: 100%;\n    padding-right: ", ";\n    padding-left: ", ";\n  } \n\n  .bl-padding-right{\n    padding-right: ", ";\n  }\n\n  .bl-padding-left{\n    padding-left: ", ";\n  }\n\n  .tw-fixed-width-container{\n    max-width: 1280px;\n  }\n  @media only screen and (min-width: ", "px){\n    .tw-custom-container .tw-container {\n      padding: 0 ", ";\n    }\n\n    .tw-x-container,\n    .LAYOUT_MAIN_HOME > .FOOTER > .tw-x-container {\n      max-width: 100%;\n      padding-right: ", ";\n      padding-left: ", ";\n    }\n\n    .LAYOUT_MAIN_HOME > .tw-custom-container\n    > .CALLOUT_MOBILE_APPS_GRADIENTS_DARK\n    > .CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTAINER {\n      margin-right: 100px !important;\n      margin-left: 100px !important;\n    }\n\n    .DYNAMIC_ZONES_PAGE ~ footer .tw-x-container, \n    .LAYOUT_MAIN_CONTACT_US  footer .tw-x-container {\n      padding-right: 9%;\n      padding-left: 9%;\n    }\n\n    .tw-fixed-width-container{\n      max-width: 1280px;\n    }\n  }\n\n  @media only screen and (max-width: ", "px){\n    .tw-custom-container .tw-container {\n      padding: 0 ", ";\n    }\n\n    .tw-x-container {\n      max-width: 100%;\n      padding-right: ", ";\n      padding-left: ", ";\n    }\n\n    LAYOUT_MAIN_HOME > .tw-custom-container\n    > .CALLOUT_MOBILE_APPS_GRADIENTS_DARK\n    > .CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTAINER {\n      margin-right: 100px !important;\n      margin-left: 100px !important;\n    }\n  }\n\n  @media only screen and (min-width: ", "px){\n    .tw-x-container.max-width-container {\n      padding-right: ", " !important;\n      padding-left: ", " !important;\n    }\n\n  }\n\n  @media only screen and (min-width: ", "px){\n    .max-width-container {\n      padding: 0 !important;\n      max-width: 1280px !important;\n    }\n\n    .tw-x-container.max-width-container {\n      padding-right: ", " !important;\n      padding-left: ", " !important;\n      margin-left: auto !important;\n      margin-right: auto !important;\n      max-width: 1280px !important;\n    }\n\n  }\n\n\n  @media only screen and (max-width: ", "px){\n    .tw-custom-container .tw-container {\n      padding: 0 ", ";\n    }\n\n    .tw-x-container {\n      max-width: 100%;\n      padding-right: ", ";\n      padding-left: ", ";\n    }\n\n    LAYOUT_MAIN_HOME > .tw-custom-container\n    > .CALLOUT_MOBILE_APPS_GRADIENTS_DARK\n    > .CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTAINER {\n      margin-right: 100px !important;\n      margin-left: 100px !important;\n    }\n\n    .tw-fixed-width-container{\n      max-width: 640px;\n      padding-right: 2rem;\n      padding-left: 2rem;\n    }\n  }\n\n  @media only screen and (max-width: ", "px){\n    .tw-custom-container .tw-container {\n      padding: 0 ", ";\n    }\n\n    .tw-x-container {\n      max-width: 100%;\n      padding-right: ", ";\n      padding-left: ", ";\n    }\n\n    .tw-fixed-width-container{\n      max-width: 768px;\n    }\n  }\n\n  .tw-fixed-width-container{\n    margin: auto;\n  }\n  ;\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme;

  var cssFormatThemeColors = function cssFormatThemeColors(_ref2) {
    var _ref3 = _slicedToArray$1(_ref2, 2),
        themeName = _ref3[0],
        themeValue = _ref3[1];

    if (themeName === "breakpoints") {
      var breakpoints = Object.entries(themeValue).map(function (_ref4) {
        var _ref5 = _slicedToArray$1(_ref4, 2),
            breakpointName = _ref5[0],
            breakpointValue = _ref5[1];

        return "--".concat(lodash.kebabCase(themeName), "-").concat(lodash.kebabCase(breakpointName), ": ").concat(breakpointValue, "px;").replace(/,/gi, "");
      });
      return breakpoints.join(" ");
    }

    return "--".concat(lodash.kebabCase(themeValue.name), "-color: ").concat(themeValue.value, ";").replace(/,/gi, "");
  };

  var sassFormatThemeColors = function sassFormatThemeColors(_ref6) {
    var _ref7 = _slicedToArray$1(_ref6, 2),
        themeName = _ref7[0],
        themeValue = _ref7[1];

    if (themeName === "breakpoints") {
      var breakpoints = Object.entries(themeValue).map(function (_ref8) {
        var _ref9 = _slicedToArray$1(_ref8, 2),
            breakpointName = _ref9[0],
            breakpointValue = _ref9[1];

        return "$global-".concat(lodash.kebabCase(themeName).replace(/,/gi, ""), "-").concat(lodash.kebabCase(breakpointName), ": ").concat(breakpointValue, "px;");
      });
      return breakpoints.join(" ");
    }

    return "$global-".concat(lodash.kebabCase(themeValue.name).replace(/,/gi, ""), "-color: global ").concat(themeValue.value, ";");
  };

  var cssThemeColorsCasted = Object.entries((theme === null || theme === void 0 ? void 0 : theme.colors) || {}).map(cssFormatThemeColors).join(" ");
  var sassThemeColorsCasted = Object.entries((theme === null || theme === void 0 ? void 0 : theme.colors) || {}).map(sassFormatThemeColors).join(" ");
  var cssBreakpoints = Object.entries((theme === null || theme === void 0 ? void 0 : theme.breakpoints) || {}).map(function (_ref10) {
    var _ref11 = _slicedToArray$1(_ref10, 2),
        breakpointName = _ref11[0],
        breakpointValue = _ref11[1];

    return "--breakpoints-".concat(breakpointName, ": ").concat(breakpointValue, "px;");
  }).join(" ");
  var sassBreakpoints = Object.entries((theme === null || theme === void 0 ? void 0 : theme.breakpoints) || {}).map(function (_ref12) {
    var _ref13 = _slicedToArray$1(_ref12, 2),
        breakpointName = _ref13[0],
        breakpointValue = _ref13[1];

    return "$global-breakpoints-".concat(breakpointName, ": global ").concat(breakpointValue, "px;");
  }).join(" ");
  var cssPadding = "";
  var sassPadding = "";
  var cssPrimaryFont = ["", ""];
  var cssSecondaryFont = ["", ""];
  var sassPrimaryFont = "";
  var sassSecondaryFont = "";

  if (theme) {
    if (theme.fonts && theme.fonts.families) {
      var _theme$fonts$families = theme.fonts.families,
          _theme$fonts$families2 = _theme$fonts$families.primaryUrl,
          primaryUrl = _theme$fonts$families2 === void 0 ? "" : _theme$fonts$families2,
          _theme$fonts$families3 = _theme$fonts$families.primaryFamily,
          primaryFamily = _theme$fonts$families3 === void 0 ? "" : _theme$fonts$families3,
          _theme$fonts$families4 = _theme$fonts$families.secondaryFamily,
          secondaryFamily = _theme$fonts$families4 === void 0 ? "" : _theme$fonts$families4,
          _theme$fonts$families5 = _theme$fonts$families.secondaryUrl,
          secondaryUrl = _theme$fonts$families5 === void 0 ? "" : _theme$fonts$families5;

      if (primaryFamily && primaryUrl) {
        cssPrimaryFont = ["@import url('".concat(primaryUrl, "');"), "--primary-family: ".concat(primaryFamily, ";")];
        sassPrimaryFont = lodash.trim(lodash.unescape("$global-primary-family: global ".concat(primaryFamily, ";")));
      }

      if (secondaryFamily && secondaryUrl) {
        cssSecondaryFont = ["@import url('".concat(secondaryUrl, "');"), "--secondary-family: ".concat(secondaryFamily, ";")];
        sassSecondaryFont = lodash.trim(lodash.unescape("$global-secondary-family: global ".concat(secondaryFamily, ";")));
      }
    }

    if (theme.spacing) {
      if (theme.spacing.padding) {
        var _theme$spacing$paddin = theme.spacing.padding,
            defaultPadding = _theme$spacing$paddin["default"],
            smPadding = _theme$spacing$paddin.sm,
            lgPadding = _theme$spacing$paddin.lg,
            xlPadding = _theme$spacing$paddin.xl;

        if (defaultPadding) {
          cssPadding = "".concat(cssPadding, "\n                --padding-default: ").concat(defaultPadding, ";");
          sassPadding = "".concat(sassPadding, "\n                $global-padding-default: global ").concat(defaultPadding, ";");
        }

        if (smPadding) {
          cssPadding = "".concat(cssPadding, "\n                --padding-sm: ").concat(smPadding, ";");
          sassPadding = "".concat(sassPadding, "\n                $global-padding-sm: global ").concat(smPadding, ";");
        }

        if (lgPadding) {
          cssPadding = "".concat(cssPadding, "\n                --padding-lg: ").concat(lgPadding, ";");
          sassPadding = "".concat(sassPadding, "\n                $global-padding-lg: global ").concat(lgPadding, ";");
        }

        if (xlPadding) {
          cssPadding = "".concat(cssPadding, "\n                --padding-xl: ").concat(xlPadding, ";");
          sassPadding = "".concat(sassPadding, "\n                $global-padding-xl: global ").concat(xlPadding, ";");
        }
      }
    }
  }

  return "\n      ".concat(sassBreakpoints, "\n      ").concat(sassThemeColorsCasted, "\n      ").concat(sassPadding, "\n\n      ").concat(sassPrimaryFont, "\n      ").concat(sassSecondaryFont, "\n\n      ").concat(cssPrimaryFont[0] ? cssPrimaryFont[0] : "", "\n      ").concat(cssSecondaryFont[0] ? cssSecondaryFont[0] : "", "\n\n      :root {\n        ").concat(cssPrimaryFont[1] ? cssPrimaryFont[1] : "", "\n        ").concat(cssSecondaryFont[1] ? cssSecondaryFont[1] : "", "\n        ").concat(cssBreakpoints, "\n        ").concat(cssThemeColorsCasted, "\n        ").concat(cssPadding, "\n      }\n    ");
}, function (_ref14) {
  var _theme$spacing, _theme$spacing$paddin2;

  var _ref14$theme = _ref14.theme,
      theme = _ref14$theme === void 0 ? {} : _ref14$theme;
  return (_theme$spacing = theme.spacing) === null || _theme$spacing === void 0 ? void 0 : (_theme$spacing$paddin2 = _theme$spacing.padding) === null || _theme$spacing$paddin2 === void 0 ? void 0 : _theme$spacing$paddin2["default"];
}, function (_ref15) {
  var _theme$spacing2, _theme$spacing2$paddi;

  var _ref15$theme = _ref15.theme,
      theme = _ref15$theme === void 0 ? {} : _ref15$theme;
  return (_theme$spacing2 = theme.spacing) === null || _theme$spacing2 === void 0 ? void 0 : (_theme$spacing2$paddi = _theme$spacing2.padding) === null || _theme$spacing2$paddi === void 0 ? void 0 : _theme$spacing2$paddi["default"];
}, function (_ref16) {
  var _theme$spacing3, _theme$spacing3$paddi;

  var _ref16$theme = _ref16.theme,
      theme = _ref16$theme === void 0 ? {} : _ref16$theme;
  return (_theme$spacing3 = theme.spacing) === null || _theme$spacing3 === void 0 ? void 0 : (_theme$spacing3$paddi = _theme$spacing3.padding) === null || _theme$spacing3$paddi === void 0 ? void 0 : _theme$spacing3$paddi["default"];
}, function (_ref17) {
  var _theme$spacing4, _theme$spacing4$paddi;

  var _ref17$theme = _ref17.theme,
      theme = _ref17$theme === void 0 ? {} : _ref17$theme;
  return (_theme$spacing4 = theme.spacing) === null || _theme$spacing4 === void 0 ? void 0 : (_theme$spacing4$paddi = _theme$spacing4.padding) === null || _theme$spacing4$paddi === void 0 ? void 0 : _theme$spacing4$paddi["default"];
}, function (_ref18) {
  var _theme$spacing5, _theme$spacing5$paddi;

  var _ref18$theme = _ref18.theme,
      theme = _ref18$theme === void 0 ? {} : _ref18$theme;
  return (_theme$spacing5 = theme.spacing) === null || _theme$spacing5 === void 0 ? void 0 : (_theme$spacing5$paddi = _theme$spacing5.padding) === null || _theme$spacing5$paddi === void 0 ? void 0 : _theme$spacing5$paddi["default"];
}, breakpoints.lg, function (_ref19) {
  var _theme$spacing6, _theme$spacing6$paddi;

  var _ref19$theme = _ref19.theme,
      theme = _ref19$theme === void 0 ? {} : _ref19$theme;
  return (_theme$spacing6 = theme.spacing) === null || _theme$spacing6 === void 0 ? void 0 : (_theme$spacing6$paddi = _theme$spacing6.padding) === null || _theme$spacing6$paddi === void 0 ? void 0 : _theme$spacing6$paddi.xl;
}, function (_ref20) {
  var _theme$spacing7, _theme$spacing7$paddi;

  var _ref20$theme = _ref20.theme,
      theme = _ref20$theme === void 0 ? {} : _ref20$theme;
  return (_theme$spacing7 = theme.spacing) === null || _theme$spacing7 === void 0 ? void 0 : (_theme$spacing7$paddi = _theme$spacing7.padding) === null || _theme$spacing7$paddi === void 0 ? void 0 : _theme$spacing7$paddi.xl;
}, function (_ref21) {
  var _theme$spacing8, _theme$spacing8$paddi;

  var _ref21$theme = _ref21.theme,
      theme = _ref21$theme === void 0 ? {} : _ref21$theme;
  return (_theme$spacing8 = theme.spacing) === null || _theme$spacing8 === void 0 ? void 0 : (_theme$spacing8$paddi = _theme$spacing8.padding) === null || _theme$spacing8$paddi === void 0 ? void 0 : _theme$spacing8$paddi.xl;
}, breakpoints.lg, function (_ref22) {
  var _theme$spacing9, _theme$spacing9$paddi;

  var _ref22$theme = _ref22.theme,
      theme = _ref22$theme === void 0 ? {} : _ref22$theme;
  return (_theme$spacing9 = theme.spacing) === null || _theme$spacing9 === void 0 ? void 0 : (_theme$spacing9$paddi = _theme$spacing9.padding) === null || _theme$spacing9$paddi === void 0 ? void 0 : _theme$spacing9$paddi.lg;
}, function (_ref23) {
  var _theme$spacing10, _theme$spacing10$padd;

  var _ref23$theme = _ref23.theme,
      theme = _ref23$theme === void 0 ? {} : _ref23$theme;
  return (_theme$spacing10 = theme.spacing) === null || _theme$spacing10 === void 0 ? void 0 : (_theme$spacing10$padd = _theme$spacing10.padding) === null || _theme$spacing10$padd === void 0 ? void 0 : _theme$spacing10$padd.lg;
}, function (_ref24) {
  var _theme$spacing11, _theme$spacing11$padd;

  var _ref24$theme = _ref24.theme,
      theme = _ref24$theme === void 0 ? {} : _ref24$theme;
  return (_theme$spacing11 = theme.spacing) === null || _theme$spacing11 === void 0 ? void 0 : (_theme$spacing11$padd = _theme$spacing11.padding) === null || _theme$spacing11$padd === void 0 ? void 0 : _theme$spacing11$padd.lg;
}, breakpoints.lg, function (_ref25) {
  var _theme$spacing12, _theme$spacing12$padd;

  var _ref25$theme = _ref25.theme,
      theme = _ref25$theme === void 0 ? {} : _ref25$theme;
  return (_theme$spacing12 = theme.spacing) === null || _theme$spacing12 === void 0 ? void 0 : (_theme$spacing12$padd = _theme$spacing12.padding) === null || _theme$spacing12$padd === void 0 ? void 0 : _theme$spacing12$padd.lg;
}, function (_ref26) {
  var _theme$spacing13, _theme$spacing13$padd;

  var _ref26$theme = _ref26.theme,
      theme = _ref26$theme === void 0 ? {} : _ref26$theme;
  return (_theme$spacing13 = theme.spacing) === null || _theme$spacing13 === void 0 ? void 0 : (_theme$spacing13$padd = _theme$spacing13.padding) === null || _theme$spacing13$padd === void 0 ? void 0 : _theme$spacing13$padd.lg;
}, breakpoints.xl, function (_ref27) {
  var _theme$spacing14, _theme$spacing14$padd;

  var _ref27$theme = _ref27.theme,
      theme = _ref27$theme === void 0 ? {} : _ref27$theme;
  return (_theme$spacing14 = theme.spacing) === null || _theme$spacing14 === void 0 ? void 0 : (_theme$spacing14$padd = _theme$spacing14.padding) === null || _theme$spacing14$padd === void 0 ? void 0 : _theme$spacing14$padd.xl;
}, function (_ref28) {
  var _theme$spacing15, _theme$spacing15$padd;

  var _ref28$theme = _ref28.theme,
      theme = _ref28$theme === void 0 ? {} : _ref28$theme;
  return (_theme$spacing15 = theme.spacing) === null || _theme$spacing15 === void 0 ? void 0 : (_theme$spacing15$padd = _theme$spacing15.padding) === null || _theme$spacing15$padd === void 0 ? void 0 : _theme$spacing15$padd.xl;
}, breakpoints.md, function (_ref29) {
  var _theme$spacing16, _theme$spacing16$padd;

  var _ref29$theme = _ref29.theme,
      theme = _ref29$theme === void 0 ? {} : _ref29$theme;
  return (_theme$spacing16 = theme.spacing) === null || _theme$spacing16 === void 0 ? void 0 : (_theme$spacing16$padd = _theme$spacing16.padding) === null || _theme$spacing16$padd === void 0 ? void 0 : _theme$spacing16$padd.md;
}, function (_ref30) {
  var _theme$spacing17, _theme$spacing17$padd;

  var _ref30$theme = _ref30.theme,
      theme = _ref30$theme === void 0 ? {} : _ref30$theme;
  return (_theme$spacing17 = theme.spacing) === null || _theme$spacing17 === void 0 ? void 0 : (_theme$spacing17$padd = _theme$spacing17.padding) === null || _theme$spacing17$padd === void 0 ? void 0 : _theme$spacing17$padd.md;
}, function (_ref31) {
  var _theme$spacing18, _theme$spacing18$padd;

  var _ref31$theme = _ref31.theme,
      theme = _ref31$theme === void 0 ? {} : _ref31$theme;
  return (_theme$spacing18 = theme.spacing) === null || _theme$spacing18 === void 0 ? void 0 : (_theme$spacing18$padd = _theme$spacing18.padding) === null || _theme$spacing18$padd === void 0 ? void 0 : _theme$spacing18$padd.md;
}, breakpoints.sm, function (_ref32) {
  var _theme$spacing19, _theme$spacing19$padd;

  var _ref32$theme = _ref32.theme,
      theme = _ref32$theme === void 0 ? {} : _ref32$theme;
  return (_theme$spacing19 = theme.spacing) === null || _theme$spacing19 === void 0 ? void 0 : (_theme$spacing19$padd = _theme$spacing19.padding) === null || _theme$spacing19$padd === void 0 ? void 0 : _theme$spacing19$padd.sm;
}, function (_ref33) {
  var _theme$spacing20, _theme$spacing20$padd;

  var _ref33$theme = _ref33.theme,
      theme = _ref33$theme === void 0 ? {} : _ref33$theme;
  return (_theme$spacing20 = theme.spacing) === null || _theme$spacing20 === void 0 ? void 0 : (_theme$spacing20$padd = _theme$spacing20.padding) === null || _theme$spacing20$padd === void 0 ? void 0 : _theme$spacing20$padd.sm;
}, function (_ref34) {
  var _theme$spacing21, _theme$spacing21$padd;

  var _ref34$theme = _ref34.theme,
      theme = _ref34$theme === void 0 ? {} : _ref34$theme;
  return (_theme$spacing21 = theme.spacing) === null || _theme$spacing21 === void 0 ? void 0 : (_theme$spacing21$padd = _theme$spacing21.padding) === null || _theme$spacing21$padd === void 0 ? void 0 : _theme$spacing21$padd.sm;
});

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose$4(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$9.apply(this, arguments);
} // TYPES
// UTILS


var isServer = typeof window === 'undefined';

function noop$3() {
  return undefined;
}

function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}

function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}

function ensureArray(value) {
  return Array.isArray(value) ? value : [value];
}

function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}

function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return _extends$9({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return _extends$9({}, arg2, {
    queryKey: arg1
  });
}

function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [_extends$9({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}

function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var isActive;

  if (inactive === false || active && !inactive) {
    isActive = true;
  } else if (active === false || inactive && !active) {
    isActive = false;
  }

  if (typeof isActive === 'boolean' && query.isActive() !== isActive) {
    return false;
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}

function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */


function hashQueryKey(queryKey) {
  var asArray = Array.isArray(queryKey) ? queryKey : [queryKey];
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */


function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject$2(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */


function partialMatchKey(a, b) {
  return partialDeepEqual(ensureArray(a), ensureArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */


function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */


function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject$2(a) && isPlainObject$2(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */


function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object


function isPlainObject$2(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}

function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */


function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}

var FocusManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$4(FocusManager, _Subscribable);

  function FocusManager() {
    return _Subscribable.apply(this, arguments) || this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.removeEventListener) {
      this.setDefaultEventListener();
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this = this;

    if (this.removeEventListener) {
      this.removeEventListener();
    }

    this.removeEventListener = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this.setFocused(focused);
      } else {
        _this.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  _proto.setDefaultEventListener = function setDefaultEventListener() {
    var _window;

    if (!isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
      this.setEventListener(function (onFocus) {
        // Listen to visibillitychange and focus
        window.addEventListener('visibilitychange', onFocus, false);
        window.addEventListener('focus', onFocus, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', onFocus);
          window.removeEventListener('focus', onFocus);
        };
      });
    }
  };

  return FocusManager;
}(Subscribable);

var focusManager = new FocusManager();

var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$4(OnlineManager, _Subscribable);

  function OnlineManager() {
    return _Subscribable.apply(this, arguments) || this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.removeEventListener) {
      this.setDefaultEventListener();
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this = this;

    if (this.removeEventListener) {
      this.removeEventListener();
    }

    this.removeEventListener = setup(function (online) {
      if (typeof online === 'boolean') {
        _this.setOnline(online);
      } else {
        _this.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  _proto.setDefaultEventListener = function setDefaultEventListener() {
    var _window;

    if (!isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
      this.setEventListener(function (onOnline) {
        // Listen to online
        window.addEventListener('online', onOnline, false);
        window.addEventListener('offline', onOnline, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', onOnline);
          window.removeEventListener('offline', onOnline);
        };
      });
    }
  };

  return OnlineManager;
}(Subscribable);

var onlineManager = new OnlineManager();

function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}

var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};

function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS


var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions)); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay; // Stop if the fetch is already resolved


      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = functionalUpdate(retryDelay, _this.failureCount) || 0;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      sleep(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!focusManager.isFocused() || !onlineManager.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
}; // CLASS


var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    this.transactions++;
    var result = callback();
    this.transactions--;

    if (!this.transactions) {
      this.flush();
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      scheduleMicrotask(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      scheduleMicrotask(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON


var notifyManager = new NotifyManager(); // FUNCTIONS

var logger = console || {
  error: noop$3,
  warn: noop$3,
  log: noop$3
};

function getLogger() {
  return logger;
} // CLASS


var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = _extends$9({}, this.defaultOptions, options); // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if (isValidTimeout(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length && !this.state.isFetching) {
      this.cache.remove(this);
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = functionalUpdate(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = replaceEqualDeep(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(noop$3).catch(noop$3) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify(this);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify(this);
    }
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        // Return current promise if we are already fetching
        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    } // Create query function context


    var queryKey = ensureArray(this.queryKey);
    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined
    }; // Create fetch function

    var fetchFn = function fetchFn() {
      return _this2.options.queryFn ? _this2.options.queryFn(queryFnContext) : Promise.reject('Missing queryFn');
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new Retryer({
      fn: context.fetchFn,
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!isCancelledError(error)) {
          // Notify cache callback
          if (_this2.cache.config.onError) {
            _this2.cache.config.onError(error, _this2);
          } // Log error


          getLogger().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify(_this3);
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return _extends$9({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return _extends$9({}, state, {
          isPaused: true
        });

      case 'continue':
        return _extends$9({}, state, {
          isPaused: false
        });

      case 'fetch':
        return _extends$9({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false,
          status: !state.dataUpdatedAt ? 'loading' : state.status
        });

      case 'success':
        return _extends$9({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if (isCancelledError(error) && error.revert && this.revertState) {
          return _extends$9({}, this.revertState);
        }

        return _extends$9({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return _extends$9({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return _extends$9({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}(); // CLASS


var QueryCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$4(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify(query);
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify(query);
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return matchQuery(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return filters ? this.queries.filter(function (query) {
      return matchQuery(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(query) {
    var _this3 = this;

    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(query);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(Subscribable); // CLASS


var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = _extends$9({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(noop$3).catch(noop$3);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result;
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      if (_this.mutationCache.config.onError) {
        _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this);
      } // Log error


      getLogger().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new Retryer({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer$1(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();

function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer$1(state, action) {
  switch (action.type) {
    case 'failed':
      return _extends$9({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return _extends$9({}, state, {
        isPaused: true
      });

    case 'continue':
      return _extends$9({}, state, {
        isPaused: false
      });

    case 'loading':
      return _extends$9({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return _extends$9({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return _extends$9({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return _extends$9({}, state, action.state);

    default:
      return state;
  }
} // CLASS


var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$4(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(noop$3);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(Subscribable);

function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$state$data, _context$state$data2;

        var fetchMore = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
            return previous ? [page].concat(pages) : [].concat(pages, [page]);
          });

          if (isCancelable(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          var manual = typeof pageParam !== 'undefined';
          var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          var _manual = typeof pageParam !== 'undefined';

          var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

          promise = fetchPage(oldPages, _manual, _param, true);
        } // Refetch pages
        else {
          (function () {
            newPageParams = [];
            var manual = typeof context.options.getNextPageParam === 'undefined'; // Fetch first page

            promise = fetchPage([], manual, oldPageParams[0]); // Fetch remaining pages

            var _loop = function _loop(i) {
              promise = promise.then(function (pages) {
                var param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              });
            };

            for (var i = 1; i < oldPages.length; i++) {
              _loop(i);
            }
          })();
        }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;

          if (isCancelable(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}

function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}

function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
} // CLASS


var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = parseQueryArgs(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this2 = this;

    var _parseFilterArgs3 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = _extends$9({}, filters, {
      active: true
    });

    return notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this2.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs4 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager.batch(function () {
      return _this3.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(noop$3).catch(noop$3);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _filters$refetchActiv,
        _filters$refetchInact,
        _this4 = this;

    var _parseFilterArgs5 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = _extends$9({}, filters, {
      active: (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager.batch(function () {
      _this4.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this4.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this5 = this;

    var _parseFilterArgs6 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager.batch(function () {
      return _this5.queryCache.findAll(filters).map(function (query) {
        return query.fetch();
      });
    });
    var promise = Promise.all(promises).then(noop$3);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(noop$3);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(noop$3).catch(noop$3);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop$3).catch(noop$3);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this6 = this;

    var promises = notifyManager.batch(function () {
      return _this6.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(noop$3).catch(noop$3);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return hashQueryKey(queryKey) === hashQueryKey(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return partialMatchKey(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return partialMatchKey(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = _extends$9({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return _extends$9({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$4(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return _shouldFetchOnReconnect(this.currentQuery, this.options);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return _shouldFetchOnWindowFocus(this.currentQuery, this.options);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    } // Update refetch interval if needed


    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.refetchInterval !== prevOptions.refetchInterval)) {
      this.updateRefetchInterval();
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result) {
    var _this2 = this;

    var trackedResult = {};
    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          var typedKey = key;

          if (!_this2.trackedProps.includes(typedKey)) {
            _this2.trackedProps.push(typedKey);
          }

          return result[typedKey];
        }
      });
    });
    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch(options);
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(noop$3);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime)) {
      return;
    }

    var time = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.updateRefetchInterval = function updateRefetchInterval() {
    var _this7 = this;

    this.clearRefetchInterval();

    if (isServer || this.options.enabled === false || !isValidTimeout(this.options.refetchInterval)) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager.isFocused()) {
        _this7.executeFetch();
      }
    }, this.options.refetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval();
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (prevResultOptions == null ? void 0 : prevResultOptions.select)) {
        data = prevResult.data;
      } else {
        try {
          data = options.select(state.data);

          if (options.structuralSharing !== false) {
            data = replaceEqualDeep(prevResult == null ? void 0 : prevResult.data, data);
          }
        } catch (selectError) {
          getLogger().error(selectError);
          error = selectError;
          errorUpdatedAt = Date.now();
          status = 'error';
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    if (result === prevResult) {
      return false;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if (shallowEqualObjects(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify(_extends$9({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify(_this8.currentQuery);
      }
    });
  };

  return QueryObserver;
}(Subscribable);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldRefetchOnMount(query, options) {
  return options.enabled !== false && query.state.dataUpdatedAt > 0 && (options.refetchOnMount === 'always' || options.refetchOnMount !== false && isStale(query, options));
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || shouldRefetchOnMount(query, options);
}

function _shouldFetchOnReconnect(query, options) {
  return options.enabled !== false && (options.refetchOnReconnect === 'always' || options.refetchOnReconnect !== false && isStale(query, options));
}

function _shouldFetchOnWindowFocus(query, options) {
  return options.enabled !== false && (options.refetchOnWindowFocus === 'always' || options.refetchOnWindowFocus !== false && isStale(query, options));
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}

var defaultContext = /*#__PURE__*/React__default$1["default"].createContext(undefined); // We share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext() {
  // @ts-ignore (for global)
  if (typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = React__default$1["default"].useContext(getQueryClientContext());

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};

var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      children = _ref.children;
  React__default$1["default"].useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext();
  return /*#__PURE__*/React__default$1["default"].createElement(Context.Provider, {
    value: client
  }, children);
};

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/React__default$1["default"].createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return React__default$1["default"].useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT


function useBaseQuery(options, Observer) {
  var mountedRef = React__default$1["default"].useRef(false);

  var _React$useState = React__default$1["default"].useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var obsRef = React__default$1["default"].useRef();

  if (!obsRef.current) {
    obsRef.current = new Observer(queryClient, defaultedOptions);
  }

  var result = obsRef.current.getOptimisticResult(defaultedOptions);
  React__default$1["default"].useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = obsRef.current.subscribe(notifyManager.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    obsRef.current.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary]);
  React__default$1["default"].useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    obsRef.current.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw obsRef.current.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if ((defaultedOptions.suspense || defaultedOptions.useErrorBoundary) && result.isError) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = obsRef.current.trackResult(result);
  }

  return result;
}

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}

var useFetch = function useFetch(key, callback) {
  var _useQuery = useQuery(key, callback),
      isLoading = _useQuery.isLoading,
      isError = _useQuery.isError,
      data = _useQuery.data,
      error = _useQuery.error;

  return {
    isLoading: isLoading,
    isError: isError,
    data: data,
    error: error
  };
};

function useClickOut(initialIsVisible) {
  var _useState = React.useState(initialIsVisible),
      _useState2 = _slicedToArray$1(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var ref = React.useRef(null);

  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  React.useEffect(function () {
    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return {
    ref: ref,
    isVisible: isVisible,
    setIsVisible: setIsVisible
  };
}

function useModal() {
  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isModalVisible = _useState2[0],
      setIsModalVisible = _useState2[1];

  function closeModal() {
    setIsModalVisible(false);
  }

  function showModal() {
    setIsModalVisible(true);
  }

  return {
    isModalVisible: isModalVisible,
    closeModal: closeModal,
    showModal: showModal
  };
}

function useTheme(_ref) {
  var _ref$themes = _ref.themes,
      rootThemes = _ref$themes === void 0 ? [] : _ref$themes;

  var _useState = React.useState(rootThemes),
      _useState2 = _slicedToArray$1(_useState, 2),
      themes = _useState2[0],
      setThemes = _useState2[1];

  var _useState3 = React.useState(rootThemes.length ? rootThemes[0] : {
    data: {}
  }),
      _useState4 = _slicedToArray$1(_useState3, 2),
      theme = _useState4[0],
      setTheme = _useState4[1];

  var doChangeTheme = function doChangeTheme() {
    var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeVariantsTypes.Default;

    var _theme = themes.find(function (_ref2) {
      var _ref2$name = _ref2.name,
          name = _ref2$name === void 0 ? "" : _ref2$name;
      return new RegExp(name).test(themeName);
    });

    if (lodash.isEmpty(_theme)) return null;
    setTheme(_theme);
    return null;
  };

  React.useEffect(function () {
    if (Array.isArray(themes) && !!themes.length) {
      setTheme(themes[0]);
    }
  }, [themes]);
  return {
    theme: theme,
    doChangeTheme: doChangeTheme,
    doChangeThemes: setThemes
  };
}

function useWindowDimensions() {
  var _useState = React.useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      windowDimensions = _useState2[0],
      setWindowDimensions = _useState2[1];

  React.useEffect(function () {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowDimensions;
} // --- Utils ---


function getWindowDimensions() {
  var _window = window,
      width = _window.innerWidth,
      height = _window.innerHeight;
  return {
    width: width,
    height: height
  };
}

function useForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$inputs = _ref.inputs,
      $initialInputs = _ref$inputs === void 0 ? {} : _ref$inputs,
      _ref$onValidate = _ref.onValidate,
      onValidate = _ref$onValidate === void 0 ? function () {
    return false;
  } : _ref$onValidate;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      $inputs = _useState2[0],
      $setInputs = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      $isValid = _useState4[0],
      $setIsValid = _useState4[1];

  var _useState5 = React.useState({}),
      _useState6 = _slicedToArray$1(_useState5, 2),
      $fields = _useState6[0],
      $setFields = _useState6[1];

  function setField(_ref2) {
    var _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? "" : _ref2$name,
        _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? "" : _ref2$value,
        _ref2$error = _ref2.error,
        error = _ref2$error === void 0 ? "" : _ref2$error,
        _ref2$isValid = _ref2.isValid,
        isValid = _ref2$isValid === void 0 ? true : _ref2$isValid;

    var inputData = _objectSpread2(_objectSpread2({}, $fields[name]), {}, {
      value: value,
      error: error,
      isValid: isValid
    });

    $setFields(_objectSpread2(_objectSpread2({}, $fields), {}, _defineProperty$1({}, name, inputData)));
    return undefined;
  }

  function onInputTextChange(_ref3, _ref4) {
    var target = _ref3.target;
    var isValid = _ref4.isValid,
        error = _ref4.error;
    setField({
      name: target.name,
      value: target.value,
      error: error,
      isValid: isValid
    });
  }

  function getField() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var field = $fields[name];

    if (!field) {
      setField({
        name: name,
        value: "",
        error: "",
        isValid: true
      });
    }

    return $fields[name];
  }

  function cleanFields() {
    var $newFields = _objectSpread2({}, $fields);

    inputsLikeArray.forEach(function (input) {
      var $field = _objectSpread2(_objectSpread2({}, $fields[input.name]), {}, {
        value: ""
      });

      $newFields = _objectSpread2(_objectSpread2({}, $newFields), {}, _defineProperty$1({}, input.name, $field));
    });
    var Reset = new Promise(function (resolve) {
      var _iterator = _createForOfIteratorHelper(inputsLikeArray),
          _step;

      try {
        var _loop = function _loop() {
          var $input = _step.value;
          setTimeout(function () {
            var inputDOM = document.getElementById($input.id);
            if (inputDOM) inputDOM.value = "";
          }, 1000 / inputsLikeArray.length);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      resolve();
    });
    Reset.then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))).then(function () {
      $setFields($newFields);
      $setInputs({});
      $setIsValid(false);
    }).then(function () {
      formatInputs($initialInputs);
    });
  }

  function formatInputs() {
    var inputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $initialInputs;
    var fieldsFormatted = Object.values(inputs).reduce(function (inputAcc, input) {
      var inputFormatted = input.reduce(function (fieldAcc, field) {
        var fieldData = getField(field.name) || {};
        return _objectSpread2(_objectSpread2({}, fieldAcc), {}, _defineProperty$1({}, field.name, fieldData.value || ""));
      }, {});
      return _objectSpread2(_objectSpread2({}, inputAcc), inputFormatted);
    }, {});
    $setInputs(inputs);
    $setFields(fieldsFormatted);
  }

  var inputsLikeArray = !lodash.isEmpty($inputs) ? Object.values($inputs).reduce(function (acc, input) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(input.map(function (field) {
      var fieldData = getField(field.name) || {};
      return _objectSpread2(_objectSpread2({}, fieldData), field);
    })));
  }, []) : [];
  var isValidFormData = inputsLikeArray.map(function (_ref6) {
    var _ref6$value = _ref6.value,
        value = _ref6$value === void 0 ? "" : _ref6$value,
        _ref6$isRequired = _ref6.isRequired,
        isRequired = _ref6$isRequired === void 0 ? false : _ref6$isRequired,
        _ref6$validations = _ref6.validations,
        validations = _ref6$validations === void 0 ? [] : _ref6$validations,
        _ref6$type = _ref6.type,
        type = _ref6$type === void 0 ? "" : _ref6$type;
    if (/select/gi.test(type)) return !!value || !value && !isRequired;
    var $validations = lodash.isEmpty(validations) || validations.map(function (_ref7) {
      var _ref7$regexp = _ref7.regexp,
          regexp = _ref7$regexp === void 0 ? "" : _ref7$regexp,
          _ref7$regExpoConfig = _ref7.regExpoConfig,
          regExpoConfig = _ref7$regExpoConfig === void 0 ? "" : _ref7$regExpoConfig;
      return new RegExp(regexp, regExpoConfig).test(value);
    }).every(Boolean);
    return isRequired && $validations || !isRequired;
  }).every(Boolean);
  React.useEffect(function () {
    if (lodash.isEmpty($fields) && onValidate) {
      var validation = Object.values($fields).map(onValidate).every(Boolean);
      $setIsValid(validation);
    }
  }, [$fields]);
  return {
    getField: getField,
    setField: setField,
    onInputTextChange: onInputTextChange,
    cleanFields: cleanFields,
    isValidFormData: isValidFormData,
    inputsLikeArray: inputsLikeArray,
    isValid: $isValid,
    fields: $fields,
    setFields: $setFields,
    inputs: $inputs,
    setInputs: formatInputs
  };
}

var useScript = function useScript(props) {
  React.useEffect(function () {
    var script = document.createElement("script"); // src, async, onload

    Object.assign(script, props);
    var _props$parent = props.parent,
        parent = _props$parent === void 0 ? "body" : _props$parent;
    var parentNode = document.querySelector(parent);
    parentNode.appendChild(script);
    return function () {
      parentNode.removeChild(script);
    };
  });
  return null; // Return null is necessary for the moment.
};

var _excluded$1k = ["isCachedPage"];
/*
  - pageId(string): This prop is only useful for avista pages or for home, about-us and contact-us collection types
  - pageData(object): This prop avoids fetch data from strapi. You are passing the data object instead
  - isDynamicPage(bool): If it is true, this function will try to fetch data from CustomPages collection types
  - isCachedPage(bool): Related to react-query and cache system
*/

function fetchCMSPage(_x) {
  return _fetchCMSPage.apply(this, arguments);
}

function _fetchCMSPage() {
  _fetchCMSPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var isCachedPage, rest, _yield$fetchData, _yield$fetchData2, header, footer, page, theme;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isCachedPage = _ref.isCachedPage, rest = _objectWithoutProperties$1(_ref, _excluded$1k);
            _context.prev = 1;
            _context.next = 4;
            return fetchData(rest);

          case 4:
            _yield$fetchData = _context.sent;
            _yield$fetchData2 = _slicedToArray$1(_yield$fetchData, 4);
            header = _yield$fetchData2[0];
            footer = _yield$fetchData2[1];
            page = _yield$fetchData2[2];
            theme = _yield$fetchData2[3];
            return _context.abrupt("return", {
              fallback: false,
              layout: {
                Header: header,
                Footer: footer
              },
              page: page,
              theme: theme || {}
            });

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);

            if (!isCachedPage) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", Promise.reject(_context.t0));

          case 17:
            return _context.abrupt("return", {
              fallback: true,
              layout: {
                Header: {
                  loginButtonText: "Login",
                  NavBarItems: []
                },
                Footer: undefined
              },
              page: undefined
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return _fetchCMSPage.apply(this, arguments);
}

function fetchData(_ref2) {
  var pageId = _ref2.pageId,
      pageData = _ref2.pageData,
      isDynamicPage = _ref2.isDynamicPage;

  if (pageData) {
    var dataCollection = [];

    if (pageData) {
      var layout = pageData.layout,
          page = pageData.page;
      if (page) dataCollection.push(page);

      if (layout) {
        var Header = layout.Header,
            Footer = layout.Footer;
        if (Header) dataCollection.push(Header);
        if (Footer) dataCollection.push(Footer);
      }
    }

    return dataCollection;
  }

  var CREDIT_UNION = lodash.snakeCase(process.env.GATSBY_CU_NAME);
  return Promise.all([fetchCollectionType({
    collectionTypeName: "cu-headers",
    CREDIT_UNION: CREDIT_UNION
  }), fetchCollectionType({
    collectionTypeName: "cu-footers",
    CREDIT_UNION: CREDIT_UNION
  }), fetchCollectionType({
    collectionTypeName: pageId,
    isDynamicPage: isDynamicPage,
    CREDIT_UNION: CREDIT_UNION
  }), fetchGeneral({
    collectionTypeName: "themes",
    CREDIT_UNION: CREDIT_UNION
  }) // fetches the theme for that specific credit union
  ]);
}

function fetchCollectionType(_x2) {
  return _fetchCollectionType.apply(this, arguments);
}

function _fetchCollectionType() {
  _fetchCollectionType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
    var collectionTypeName, isDynamicPage, CREDIT_UNION, ban, AuxdynamicZonesPage, DYNAMIC_PAGES_TYPES, _yield$Promise$all, _yield$Promise$all2, genericPage, featurePage, dynamicZonesPage;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            collectionTypeName = _ref3.collectionTypeName, isDynamicPage = _ref3.isDynamicPage, CREDIT_UNION = _ref3.CREDIT_UNION;
            ban = 0;

            if (!(collectionTypeName === "cu-home-pages")) {
              _context2.next = 7;
              break;
            }

            _context2.next = 5;
            return Promise.resolve(fetchDynamicPage({
              collectionTypeName: collectionTypeName,
              urlRoute: "",
              dynamicPageType: "DYNAMIC_ZONES_PAGE",
              CREDIT_UNION: CREDIT_UNION
            }));

          case 5:
            AuxdynamicZonesPage = _context2.sent;

            if (AuxdynamicZonesPage) {
              ban = 1;
              collectionTypeName = "";
            }

          case 7:
            if (!(isDynamicPage || ban)) {
              _context2.next = 19;
              break;
            }

            DYNAMIC_PAGES_TYPES = {
              CUSTOM_PAGE_FEATURE: "CUSTOM_PAGE_FEATURE",
              CUSTOM_PAGE_GENERIC: "CUSTOM_PAGE_GENERIC",
              DYNAMIC_ZONES_PAGE: "DYNAMIC_ZONES_PAGE"
            };
            _context2.next = 11;
            return Promise.all([fetchDynamicPage({
              collectionTypeName: "custom-page-ones",
              urlRoute: collectionTypeName,
              dynamicPageType: DYNAMIC_PAGES_TYPES.CUSTOM_PAGE_GENERIC,
              CREDIT_UNION: CREDIT_UNION
            }), fetchDynamicPage({
              collectionTypeName: "custom-page-twos",
              urlRoute: collectionTypeName,
              dynamicPageType: DYNAMIC_PAGES_TYPES.CUSTOM_PAGE_FEATURE,
              CREDIT_UNION: CREDIT_UNION
            }), fetchDynamicPage({
              collectionTypeName: "cu-dynamics",
              urlRoute: collectionTypeName,
              dynamicPageType: DYNAMIC_PAGES_TYPES.DYNAMIC_ZONES_PAGE,
              CREDIT_UNION: CREDIT_UNION
            })]);

          case 11:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray$1(_yield$Promise$all, 3);
            genericPage = _yield$Promise$all2[0];
            featurePage = _yield$Promise$all2[1];
            dynamicZonesPage = _yield$Promise$all2[2];

            if (!(!genericPage && !featurePage && !dynamicZonesPage)) {
              _context2.next = 18;
              break;
            }

            throw new Error("Page \"".concat(collectionTypeName, "\" not found"));

          case 18:
            return _context2.abrupt("return", _objectSpread2(_objectSpread2({}, genericPage || featurePage || dynamicZonesPage), {}, {
              DYNAMIC_PAGES_TYPES: DYNAMIC_PAGES_TYPES
            }));

          case 19:
            return _context2.abrupt("return", fetch("".concat(process.env.GATSBY_CMS_URL, "/").concat(collectionTypeName, "?CreditUnion.CREDIT_UNION=").concat(CREDIT_UNION), {
              method: "GET"
            }).then(function (r) {
              if (!r.ok) throw new Error(r.statusText);
              return r.json();
            }).then(function (r) {
              if (r.length === 0) {
                throw new Error("Page \"".concat(collectionTypeName, "\" not found"));
              }

              return r[0];
            }));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchCollectionType.apply(this, arguments);
}

function fetchDynamicPage(_x3) {
  return _fetchDynamicPage.apply(this, arguments);
}

function _fetchDynamicPage() {
  _fetchDynamicPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref4) {
    var collectionTypeName, urlRoute, dynamicPageType, CREDIT_UNION, dynamicPage, parsedDynamicPage;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            collectionTypeName = _ref4.collectionTypeName, urlRoute = _ref4.urlRoute, dynamicPageType = _ref4.dynamicPageType, CREDIT_UNION = _ref4.CREDIT_UNION;
            dynamicPage = [];
            _context3.next = 4;
            return fetch("".concat(process.env.GATSBY_CMS_URL, "/").concat(collectionTypeName === "cu-home-pages" ? "cu-dynamics" : collectionTypeName, "?CreditUnion.CREDIT_UNION=").concat(CREDIT_UNION, "&urlRoute=/").concat(urlRoute), {
              method: "GET"
            });

          case 4:
            dynamicPage = _context3.sent;
            parsedDynamicPage = [];

            if (dynamicPage.ok) {
              _context3.next = 8;
              break;
            }

            throw new Error(dynamicPage.statusText);

          case 8:
            _context3.next = 10;
            return dynamicPage.json();

          case 10:
            parsedDynamicPage = _context3.sent;

            if (!(parsedDynamicPage.length === 0)) {
              _context3.next = 22;
              break;
            }

            if (!(collectionTypeName === "cu-dynamics")) {
              _context3.next = 21;
              break;
            }

            _context3.next = 15;
            return fetch("".concat(process.env.GATSBY_CMS_URL, "/").concat(collectionTypeName, "?CreditUnion.CREDIT_UNION=").concat(CREDIT_UNION, "&urlRoute=/404"), {
              method: "GET"
            });

          case 15:
            dynamicPage = _context3.sent;
            _context3.next = 18;
            return dynamicPage.json();

          case 18:
            parsedDynamicPage = _context3.sent;
            _context3.next = 22;
            break;

          case 21:
            return _context3.abrupt("return", undefined);

          case 22:
            return _context3.abrupt("return", _objectSpread2(_objectSpread2({}, parsedDynamicPage[0]), {}, {
              dynamicPageType: dynamicPageType
            }));

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchDynamicPage.apply(this, arguments);
}

function fetchGeneral(_ref5) {
  var collectionTypeName = _ref5.collectionTypeName,
      CREDIT_UNION = _ref5.CREDIT_UNION;
  return fetch("".concat(process.env.GATSBY_CMS_URL, "/").concat(collectionTypeName, "?credit_unions.CREDIT_UNION=").concat(CREDIT_UNION), {
    method: "GET"
  }).then(function (r) {
    if (!r.ok) throw new Error(r.statusText);
    return r.json();
  }).then(function (r) {
    if (r.length === 0) return undefined;
    return _objectSpread2({}, r[0]);
  });
}

function getListStyles() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bodyTextVariantsTypes.NONE;

  if (variant === bodyTextVariantsTypes.DECORATION_DOTTEN) {
    return "tw-ml-6 tw-list-disc";
  }

  return "";
} // eslint-disable-next-line import/prefer-default-export


function isExternalURL(url) {
  if (!url) return false;
  var currentDomain = "".concat(window.location.protocol, "//").concat(window.location.host);
  var links = url.match(/(https?:\/\/[\w\d.-]+)/gi) || [];
  var regex = new RegExp("^".concat(currentDomain), "gi");
  var result = false;
  links.forEach(function (link) {
    if (link.match(regex) === null) result = true;
  });
  return result;
}

function screenOverflowHidden(isHidden) {
  document.body.style.overflow = isHidden ? "hidden" : "auto";
  return null;
}

function addClassHeaderOnScroll(_ref) {
  var _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$classTag = _ref.classTag,
      classTag = _ref$classTag === void 0 ? "HEADER" : _ref$classTag,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent;

  if (!!_float && !!transparent && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return "".concat(classTag, "__BEFORE__BREAKPOINT__SCROLL");
  }

  return null;
}

function selectTag() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (link) return {
    Tag: "a",
    props: {
      href: link
    },
    className: "hover:tw-opacity-50"
  };
  return {
    Tag: "p",
    props: {},
    className: ""
  };
}

var withProps = function withProps() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var elementProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (lodash.isEmpty(children) || children === null || children === undefined) return null;
  var elements = React.Children.toArray(children);
  var element = elements[0];
  if (lodash.isEmpty(elements) || elements === null || elements === undefined) return null;
  if (elements.length === 0) elements = null;
  if (elements.length === 1) elements = element ? /*#__PURE__*/React.cloneElement(element, elementProps) : null;
  if (elements.length > 1) elements = elements.map(function (node) {
    return /*#__PURE__*/React.cloneElement(node, elementProps);
  });
  return elements;
};

function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? [] : _ref$themes;

  var _useTheme = useTheme({
    themes: themes
  }),
      theme = _useTheme.theme,
      doChangeTheme = _useTheme.doChangeTheme,
      doChangeThemes = _useTheme.doChangeThemes;

  var elementProps = {
    theme: theme,
    doChangeTheme: doChangeTheme,
    doChangeThemes: doChangeThemes
  };
  var elements = withProps(children, elementProps);
  return /*#__PURE__*/React__default$1["default"].createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(GlobalStyleComponent, null), elements));
}

var getColors = function getColors() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : colorsVariantsTypes.NONE;

  switch (color) {
    case colorsVariantsTypes.SECONDARY:
      return colorsTypes.SECONDARY;

    case colorsVariantsTypes.WHITE:
      return colorsTypes.WHITE;

    case colorsVariantsTypes.BLACK:
      return colorsTypes.BLACK;

    case colorsVariantsTypes.ULTRA_DARK:
      return colorsTypes.ULTRA_DARK;

    case colorsVariantsTypes.DARK:
      return colorsTypes.DARK;

    case colorsVariantsTypes.SEMI_DARK:
      return colorsTypes.SEMI_DARK;

    case colorsVariantsTypes.VERY_ULTRA_LIGHT:
      return colorsTypes.VERY_ULTRA_LIGHT;

    case colorsVariantsTypes.ULTRA_LIGHT:
      return colorsTypes.ULTRA_LIGHT;

    case colorsVariantsTypes.LIGHT:
      return colorsTypes.LIGHT;

    case colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT:
      return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT;

    case colorsVariantsTypes.PRIMARY_ULTRA_LIGHT:
      return colorsTypes.PRIMARY_ULTRA_LIGHT;

    case colorsVariantsTypes.PRIMARY_LIGHT:
      return colorsTypes.PRIMARY_LIGHT;

    case colorsVariantsTypes.PRIMARY:
      return colorsTypes.PRIMARY;

    case colorsVariantsTypes.PRIMARY_DARK:
      return colorsTypes.PRIMARY_DARK;

    case colorsVariantsTypes.PRIMARY_SEMI_DARK:
      return colorsTypes.PRIMARY_SEMI_DARK;

    case colorsVariantsTypes.PRIMARY_ULTRA_DARK:
      return colorsTypes.PRIMARY_ULTRA_DARK;

    case colorsVariantsTypes.HIGHT_LIGHT_PRIMARY:
      return colorsTypes.HIGHT_LIGHT_PRIMARY;

    case colorsVariantsTypes.TRANSPARENT:
      return colorsTypes.TRANSPARENT;

    default:
      return colorsTypes.PRIMARY;
  }
};

var getTextSize = function getTextSize() {
  var sizeVariant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : textSizesVariantsTypes.NONE;

  switch (sizeVariant) {
    case textSizesVariantsTypes.ULTRA_SMALL:
      return textSizesTypes.ULTRA_SMALL;

    case textSizesVariantsTypes.VERY_SMALL:
      return textSizesTypes.VERY_SMALL;

    case textSizesVariantsTypes.SMALL:
      return textSizesTypes.SMALL;

    case textSizesVariantsTypes.NORMAL:
      return textSizesTypes.NORMAL;

    case textSizesVariantsTypes.LARGE:
      return textSizesTypes.LARGE;

    case textSizesVariantsTypes.VERY_LARGE:
      return textSizesTypes.VERY_LARGE;

    case textSizesVariantsTypes.BIG:
      return textSizesTypes.BIG;

    case textSizesVariantsTypes.VERY_BIG:
      return textSizesTypes.VERY_BIG;

    case textSizesVariantsTypes.HEADER_1:
      return textSizesTypes.HEADER_1;

    case textSizesVariantsTypes.HEADER_1_H2:
      return textSizesTypes.HEADER_1_H2;

    case textSizesVariantsTypes.HEADER_2:
      return textSizesTypes.HEADER_2;

    case textSizesVariantsTypes.HEADER_3:
      return textSizesTypes.HEADER_3;

    case textSizesVariantsTypes.HEADER_4:
      return textSizesTypes.HEADER_4;

    case textSizesVariantsTypes.HEADER_5:
      return textSizesTypes.HEADER_5;

    case textSizesVariantsTypes.HEADER_6:
      return textSizesTypes.HEADER_6;

    default:
      return textSizesTypes.NONE;
  }
};

var getFontFamily = function getFontFamily() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fontsFamiliesVariantsTypes.PRIMARY;

  switch (color) {
    case fontsFamiliesVariantsTypes.PRIMARY:
      return fontsFamiliesTypes.PRIMARY;

    case fontsFamiliesVariantsTypes.SECONDARY:
      return fontsFamiliesTypes.SECONDARY;

    default:
      return fontsFamiliesTypes.PRIMARY;
  }
};

var _templateObject$2T;

var _excluded$1j = ["is", "styleType", "fill", "type", "className", "children", "variant", "isAuxHref"];

function ButtonBase(_ref) {
  var _ref$is = _ref.is,
      Tag = _ref$is === void 0 ? "button" : _ref$is,
      _ref$styleType = _ref.styleType,
      styleType = _ref$styleType === void 0 ? buttonStyleTypes.STANDARD : _ref$styleType,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? buttonFillTypes.FILLED : _ref$fill,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      className = _ref.className,
      children = _ref.children,
      variant = _ref.variant,
      _ref$isAuxHref = _ref.isAuxHref,
      isAuxHref = _ref$isAuxHref === void 0 ? true : _ref$isAuxHref,
      rest = _objectWithoutProperties$1(_ref, _excluded$1j);

  if (!children) return null;
  var auxHref = {};

  if (variant === "NO_MODAL" || process.env.GATSBY_CU_NAME === "field_stone" || process.env.GATSBY_CU_NAME === "field-stone") {
    Tag = "a";
    auxHref = {
      href: isAuxHref ? process.env.GATSBY_LOGIN_URL : rest.href
    };
  }

  return /*#__PURE__*/React__default$1["default"].createElement(Tag, _extends$g({
    className: classnames(createButtonStyles(styleType, fill, rest.disabled), className, "BUTTON_TAG")
  }, Tag === "button" && {
    type: type
  }, rest, auxHref), variant === "NO_MODAL" && /*#__PURE__*/React__default$1["default"].createElement("span", null, children), variant !== "NO_MODAL" && children);
}

ButtonBase.propTypes = {
  withoutBorderRadius: PropTypes.bool,
  transparent: PropTypes.bool,
  grayscale: PropTypes.bool,
  dark: PropTypes.bool,
  outline: PropTypes.bool,
  marginButton: PropTypes.bool,
  fill: PropTypes.string,
  styleType: PropTypes.string,
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  transparentBackgroundColor: PropTypes.string,
  grayscaleAndOutlineOrPillBackgroundColor: PropTypes.string,
  darkGrayscaleAndFilledBackgroundColor: PropTypes.string,
  grayscaleAndFilledBackgroundColor: PropTypes.string,
  defaultGrayscaleBackgroundColor: PropTypes.string,
  outlineOrPillBackgroundColor: PropTypes.string,
  darkFilledBackgroundColor: PropTypes.string,
  filledBackgroundColor: PropTypes.string,
  defaultBackgroundColor: PropTypes.string,
  darkGrayscaleAndOutlineBorderColor: PropTypes.string,
  grayscaleAndOutlineBorderColor: PropTypes.string,
  darkGrayscaleBorderColor: PropTypes.string,
  grayscaleBorderColor: PropTypes.string,
  darkOutlineOrPillBorderColor: PropTypes.string,
  outlineOrPillBorderColor: PropTypes.string,
  filledBorderColor: PropTypes.string,
  defaultBorderColor: PropTypes.string,
  grayscaleAndOutlineTextColor: PropTypes.string,
  darkGrayscaleAndOFilledTextColor: PropTypes.string,
  grayscaleAndOFilledTextColor: PropTypes.string,
  darkGrayscaleTextColor: PropTypes.string,
  grayscaleTextColor: PropTypes.string,
  darkOutlineTextColor: PropTypes.string,
  outlineTextColor: PropTypes.string,
  darkFilledTextColor: PropTypes.string,
  filledTextColor: PropTypes.string,
  darkPillTextColor: PropTypes.string,
  pillTextColor: PropTypes.string,
  darkTextColor: PropTypes.string,
  textColor: PropTypes.string,
  padding: PropTypes.string,
  hoverDefaultBackgroundColor: PropTypes.string,
  hoverBackgroundColor: PropTypes.string,
  hoverBackgroundTransparentColor: PropTypes.string,
  hoverGrayscaleFillBackgroundColor: PropTypes.string,
  hoverDarkGrayscaleFillBackgroundColor: PropTypes.string,
  hoverGrayscaleOutlineOrPillBackgroundColor: PropTypes.string,
  hoverGrayscaleBackgroundColor: PropTypes.string,
  hoverOutlineOrPillBackgroundColor: PropTypes.string,
  hoverDarkIsNotOutlineAndFilledBackgroundColor: PropTypes.string,
  hoverDefaultBorderColor: PropTypes.string,
  hoverDarkOutlineAndColorBorderColor: PropTypes.string,
  hoverOutlineAndColorBorderColor: PropTypes.string,
  hoverFilledBorderColor: PropTypes.string,
  hoverDarkGrayscaleBorderColor: PropTypes.string,
  hoverGrayscaleBorderColor: PropTypes.string,
  hoverDefaultTextColor: PropTypes.string,
  hoverAndNotOutlineTextColor: PropTypes.string,
  hoverDarkGrayscaleTextColor: PropTypes.string,
  hoverDarkGrayscaleFilledTextColor: PropTypes.string,
  hoverGrayscaleFilledTextColor: PropTypes.string,
  hoverDarkGrayscaleFilledAndOutlineTextColor: PropTypes.string,
  hoverGrayscaleFilledAndOutlineTextColor: PropTypes.string,
  hoverDarkOutlineTextColor: PropTypes.string,
  hoverOutlineTextColor: PropTypes.string,
  hoverDarkFilledTextColor: PropTypes.string,
  hoverFilledTextColor: PropTypes.string,
  hoverDarkTextColor: PropTypes.string,
  hoverTextColor: PropTypes.string
};
var Button$2 = styled__default["default"](ButtonBase)(_templateObject$2T || (_templateObject$2T = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  height: ", ";\n\n  position: ", ";\n\n  margin-top: ", ";\n\n  text-align: ", ";\n  grid-row: ", ";\n  grid-column: ", ";\n  margin: ", ";\n\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  padding: ", ";\n\n  border-style: solid;\n  border-width: ", "px;\n  border-radius: ", ";\n\n  background: ", ";\n\n  border-color: ", ";\n\n  color: ", ";\n\n  &:hover {\n    border-width: ", "px;\n\n    background: ", ";\n\n    border-color: ", ";\n\n    color: ", ";\n  }\n"])), function (_ref2) {
  var _ref2$fontSize = _ref2.fontSize,
      fontSize = _ref2$fontSize === void 0 ? textSizesVariantsTypes.SMALL : _ref2$fontSize;
  return getTextSize(fontSize);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var height = _ref4.height;
  return height && lodash.isNumber(height) ? "".concat(height, "px") : height;
}, function (_ref5) {
  var _ref5$marginButton = _ref5.marginButton,
      marginButton = _ref5$marginButton === void 0 ? false : _ref5$marginButton;
  if (marginButton) return "absolute";
  return "";
}, function (_ref6) {
  var _ref6$marginButton = _ref6.marginButton,
      marginButton = _ref6$marginButton === void 0 ? false : _ref6$marginButton;
  if (marginButton) return "-18px";
  return "";
}, function (_ref7) {
  var _ref7$textAlign = _ref7.textAlign,
      textAlign = _ref7$textAlign === void 0 ? "center" : _ref7$textAlign;
  return textAlign;
}, function (_ref8) {
  var row = _ref8.row;
  return row;
}, function (_ref9) {
  var col = _ref9.col;
  return col;
}, function (_ref10) {
  var margin = _ref10.margin;
  return margin;
}, function (_ref11) {
  var width = _ref11.width;
  return width && lodash.isNumber(width) ? "".concat(width, "px") : width;
}, function (_ref12) {
  var maxWidth = _ref12.maxWidth;
  return maxWidth && lodash.isNumber(maxWidth) ? "".concat(maxWidth, "px") : maxWidth;
}, function (_ref13) {
  var minWidth = _ref13.minWidth;
  return minWidth && lodash.isNumber(minWidth) ? "".concat(minWidth, "px") : minWidth;
}, function (_ref14) {
  var padding = _ref14.padding;
  return padding;
}, function (_ref15) {
  var _ref15$borderWidth = _ref15.borderWidth,
      borderWidth = _ref15$borderWidth === void 0 ? 1 : _ref15$borderWidth;
  return borderWidth;
}, function (_ref16) {
  var _ref16$withoutBorderR = _ref16.withoutBorderRadius,
      withoutBorderRadius = _ref16$withoutBorderR === void 0 ? false : _ref16$withoutBorderR,
      _ref16$radius = _ref16.radius,
      radius = _ref16$radius === void 0 ? ".5rem" : _ref16$radius;
  return withoutBorderRadius ? "0px " : "".concat(radius && lodash.isNumber(radius) ? "".concat(radius, "px") : radius);
}, function (_ref17) {
  var _ref17$transparent = _ref17.transparent,
      transparent = _ref17$transparent === void 0 ? false : _ref17$transparent,
      _ref17$grayscale = _ref17.grayscale,
      grayscale = _ref17$grayscale === void 0 ? false : _ref17$grayscale,
      _ref17$dark = _ref17.dark,
      dark = _ref17$dark === void 0 ? false : _ref17$dark,
      _ref17$outline = _ref17.outline,
      outline = _ref17$outline === void 0 ? false : _ref17$outline,
      _ref17$fill = _ref17.fill,
      fill = _ref17$fill === void 0 ? buttonFillTypes.NONE : _ref17$fill,
      _ref17$styleType = _ref17.styleType,
      styleType = _ref17$styleType === void 0 ? buttonStyleTypes.NONE : _ref17$styleType,
      _ref17$transparentBac = _ref17.transparentBackgroundColor,
      transparentBackgroundColor = _ref17$transparentBac === void 0 ? colorsTypes.TRANSPARENT : _ref17$transparentBac,
      _ref17$grayscaleAndOu = _ref17.grayscaleAndOutlineOrPillBackgroundColor,
      grayscaleAndOutlineOrPillBackgroundColor = _ref17$grayscaleAndOu === void 0 ? colorsTypes.WHITE : _ref17$grayscaleAndOu,
      _ref17$darkGrayscaleA = _ref17.darkGrayscaleAndFilledBackgroundColor,
      darkGrayscaleAndFilledBackgroundColor = _ref17$darkGrayscaleA === void 0 ? colorsTypes.LIGHT : _ref17$darkGrayscaleA,
      _ref17$grayscaleAndFi = _ref17.grayscaleAndFilledBackgroundColor,
      grayscaleAndFilledBackgroundColor = _ref17$grayscaleAndFi === void 0 ? colorsTypes.WHITE : _ref17$grayscaleAndFi,
      _ref17$defaultGraysca = _ref17.defaultGrayscaleBackgroundColor,
      defaultGrayscaleBackgroundColor = _ref17$defaultGraysca === void 0 ? colorsTypes.WHITE : _ref17$defaultGraysca,
      _ref17$outlineOrPillB = _ref17.outlineOrPillBackgroundColor,
      outlineOrPillBackgroundColor = _ref17$outlineOrPillB === void 0 ? colorsTypes.TRANSPARENT : _ref17$outlineOrPillB,
      _ref17$darkFilledBack = _ref17.darkFilledBackgroundColor,
      darkFilledBackgroundColor = _ref17$darkFilledBack === void 0 ? colorsTypes.PRIMARY_DARK : _ref17$darkFilledBack,
      _ref17$filledBackgrou = _ref17.filledBackgroundColor,
      filledBackgroundColor = _ref17$filledBackgrou === void 0 ? colorsTypes.PRIMARY : _ref17$filledBackgrou,
      _ref17$defaultBackgro = _ref17.defaultBackgroundColor,
      defaultBackgroundColor = _ref17$defaultBackgro === void 0 ? colorsTypes.PRIMARY_DARK : _ref17$defaultBackgro,
      _ref17$darkFilledOutl = _ref17.darkFilledOutlineBackgroundColor,
      darkFilledOutlineBackgroundColor = _ref17$darkFilledOutl === void 0 ? colorsTypes.TRANSPARENT : _ref17$darkFilledOutl,
      _ref17$darkGrayscaleA2 = _ref17.darkGrayscaleAndOutlineDarkBackgroundColor,
      darkGrayscaleAndOutlineDarkBackgroundColor = _ref17$darkGrayscaleA2 === void 0 ? colorsTypes.TRANSPARENT : _ref17$darkGrayscaleA2,
      _ref17$grayscaleAndOu2 = _ref17.grayscaleAndOutlineDarkBackgroundColor,
      grayscaleAndOutlineDarkBackgroundColor = _ref17$grayscaleAndOu2 === void 0 ? colorsTypes.WHITE : _ref17$grayscaleAndOu2;
  if (transparent) return transparentBackgroundColor;

  if (grayscale) {
    if (outline || styleType === buttonStyleTypes.PILL) return grayscaleAndOutlineOrPillBackgroundColor;

    if (fill === buttonFillTypes.FILLED) {
      if (dark) return darkGrayscaleAndFilledBackgroundColor;
      return grayscaleAndFilledBackgroundColor;
    }

    if (fill === buttonFillTypes.OUTLINE_DARK) {
      if (dark) return darkGrayscaleAndOutlineDarkBackgroundColor;
      return grayscaleAndOutlineDarkBackgroundColor;
    }

    return defaultGrayscaleBackgroundColor;
  }

  if (outline || styleType === buttonStyleTypes.PILL) return outlineOrPillBackgroundColor;
  if (fill === buttonFillTypes.OUTLINE_DARK) return darkFilledOutlineBackgroundColor;

  if (fill === buttonFillTypes.FILLED) {
    if (dark) return darkFilledBackgroundColor;
    return filledBackgroundColor;
  }

  return defaultBackgroundColor;
}, function (_ref18) {
  var _ref18$grayscale = _ref18.grayscale,
      grayscale = _ref18$grayscale === void 0 ? false : _ref18$grayscale,
      _ref18$outline = _ref18.outline,
      outline = _ref18$outline === void 0 ? false : _ref18$outline,
      _ref18$dark = _ref18.dark,
      dark = _ref18$dark === void 0 ? false : _ref18$dark,
      _ref18$fill = _ref18.fill,
      fill = _ref18$fill === void 0 ? buttonFillTypes.NONE : _ref18$fill,
      _ref18$styleType = _ref18.styleType,
      styleType = _ref18$styleType === void 0 ? buttonStyleTypes.NONE : _ref18$styleType,
      _ref18$darkGrayscaleA = _ref18.darkGrayscaleAndOutlineBorderColor,
      darkGrayscaleAndOutlineBorderColor = _ref18$darkGrayscaleA === void 0 ? colorsTypes.BLACK : _ref18$darkGrayscaleA,
      _ref18$grayscaleAndOu = _ref18.grayscaleAndOutlineBorderColor,
      grayscaleAndOutlineBorderColor = _ref18$grayscaleAndOu === void 0 ? colorsTypes.ULTRA_DARK : _ref18$grayscaleAndOu,
      _ref18$darkGrayscaleB = _ref18.darkGrayscaleBorderColor,
      darkGrayscaleBorderColor = _ref18$darkGrayscaleB === void 0 ? colorsTypes.BLACK : _ref18$darkGrayscaleB,
      _ref18$grayscaleBorde = _ref18.grayscaleBorderColor,
      grayscaleBorderColor = _ref18$grayscaleBorde === void 0 ? colorsTypes.TRANSPARENT : _ref18$grayscaleBorde,
      _ref18$darkOutlineOrP = _ref18.darkOutlineOrPillBorderColor,
      darkOutlineOrPillBorderColor = _ref18$darkOutlineOrP === void 0 ? colorsTypes.PRIMARY_DARK : _ref18$darkOutlineOrP,
      _ref18$outlineOrPillB = _ref18.outlineOrPillBorderColor,
      outlineOrPillBorderColor = _ref18$outlineOrPillB === void 0 ? colorsTypes.PRIMARY : _ref18$outlineOrPillB,
      _ref18$filledBorderCo = _ref18.filledBorderColor,
      filledBorderColor = _ref18$filledBorderCo === void 0 ? colorsTypes.TRANSPARENT : _ref18$filledBorderCo,
      _ref18$defaultBorderC = _ref18.defaultBorderColor,
      defaultBorderColor = _ref18$defaultBorderC === void 0 ? colorsTypes.PRIMARY : _ref18$defaultBorderC,
      _ref18$filledOutlineD = _ref18.filledOutlineDarkBorderColor,
      filledOutlineDarkBorderColor = _ref18$filledOutlineD === void 0 ? colorsTypes.PRIMARY_DARK : _ref18$filledOutlineD,
      _ref18$filledOutlineB = _ref18.filledOutlineBorderColor,
      filledOutlineBorderColor = _ref18$filledOutlineB === void 0 ? colorsTypes.PRIMARY : _ref18$filledOutlineB,
      _ref18$darkGrayscaleO = _ref18.darkGrayscaleOutlineDarkBorderColor,
      darkGrayscaleOutlineDarkBorderColor = _ref18$darkGrayscaleO === void 0 ? colorsTypes.BLACK : _ref18$darkGrayscaleO,
      _ref18$grayscaleOutli = _ref18.grayscaleOutlineDarkBorderColor,
      grayscaleOutlineDarkBorderColor = _ref18$grayscaleOutli === void 0 ? colorsTypes.WHITE : _ref18$grayscaleOutli;

  if (grayscale) {
    if (fill === buttonFillTypes.OUTLINE_DARK) {
      if (dark) return darkGrayscaleOutlineDarkBorderColor;
      return grayscaleOutlineDarkBorderColor;
    }

    if (outline || styleType === buttonStyleTypes.PILL) {
      if (dark) return darkGrayscaleAndOutlineBorderColor;
      return grayscaleAndOutlineBorderColor;
    }

    if (dark) return darkGrayscaleBorderColor;
    return grayscaleBorderColor;
  }

  if (outline || styleType === buttonStyleTypes.PILL) {
    if (dark) return darkOutlineOrPillBorderColor;
    return outlineOrPillBorderColor;
  }

  if (fill === buttonFillTypes.OUTLINE_DARK) {
    if (dark) return filledOutlineDarkBorderColor;
    return filledOutlineBorderColor;
  }

  if (fill === buttonFillTypes.FILLED) return filledBorderColor;
  return defaultBorderColor;
}, function (_ref19) {
  var _ref19$outline = _ref19.outline,
      outline = _ref19$outline === void 0 ? false : _ref19$outline,
      _ref19$grayscale = _ref19.grayscale,
      grayscale = _ref19$grayscale === void 0 ? false : _ref19$grayscale,
      _ref19$dark = _ref19.dark,
      dark = _ref19$dark === void 0 ? false : _ref19$dark,
      _ref19$fill = _ref19.fill,
      fill = _ref19$fill === void 0 ? buttonFillTypes.NONE : _ref19$fill,
      _ref19$styleType = _ref19.styleType,
      styleType = _ref19$styleType === void 0 ? buttonStyleTypes.NONE : _ref19$styleType,
      _ref19$grayscaleAndOu = _ref19.grayscaleAndOutlineTextColor,
      grayscaleAndOutlineTextColor = _ref19$grayscaleAndOu === void 0 ? colorsTypes.BLACK : _ref19$grayscaleAndOu,
      _ref19$darkGrayscaleA = _ref19.darkGrayscaleAndOFilledTextColor,
      darkGrayscaleAndOFilledTextColor = _ref19$darkGrayscaleA === void 0 ? colorsTypes.BLACK : _ref19$darkGrayscaleA,
      _ref19$grayscaleAndOu2 = _ref19.grayscaleAndOutlineDarkTextColor,
      grayscaleAndOutlineDarkTextColor = _ref19$grayscaleAndOu2 === void 0 ? colorsTypes.WHITE : _ref19$grayscaleAndOu2,
      _ref19$darkGrayscaleA2 = _ref19.darkGrayscaleAndOutlineDarkTextColor,
      darkGrayscaleAndOutlineDarkTextColor = _ref19$darkGrayscaleA2 === void 0 ? colorsTypes.ULTRA_DARK : _ref19$darkGrayscaleA2,
      _ref19$grayscaleAndOF = _ref19.grayscaleAndOFilledTextColor,
      grayscaleAndOFilledTextColor = _ref19$grayscaleAndOF === void 0 ? colorsTypes.ULTRA_DARK : _ref19$grayscaleAndOF,
      _ref19$darkGrayscaleT = _ref19.darkGrayscaleTextColor,
      darkGrayscaleTextColor = _ref19$darkGrayscaleT === void 0 ? colorsTypes.BLACK : _ref19$darkGrayscaleT,
      _ref19$grayscaleTextC = _ref19.grayscaleTextColor,
      grayscaleTextColor = _ref19$grayscaleTextC === void 0 ? colorsTypes.WHITE : _ref19$grayscaleTextC,
      _ref19$darkOutlineTex = _ref19.darkOutlineTextColor,
      darkOutlineTextColor = _ref19$darkOutlineTex === void 0 ? colorsTypes.PRIMARY_DARK : _ref19$darkOutlineTex,
      _ref19$outlineTextCol = _ref19.outlineTextColor,
      outlineTextColor = _ref19$outlineTextCol === void 0 ? colorsTypes.PRIMARY : _ref19$outlineTextCol,
      _ref19$darkFilledText = _ref19.darkFilledTextColor,
      darkFilledTextColor = _ref19$darkFilledText === void 0 ? colorsTypes.BLACK : _ref19$darkFilledText,
      _ref19$filledTextColo = _ref19.filledTextColor,
      filledTextColor = _ref19$filledTextColo === void 0 ? colorsTypes.WHITE : _ref19$filledTextColo,
      _ref19$filledTextOutl = _ref19.filledTextOutlineColor,
      filledTextOutlineColor = _ref19$filledTextOutl === void 0 ? colorsTypes.PRIMARY : _ref19$filledTextOutl,
      _ref19$filledTextOutl2 = _ref19.filledTextOutlineDarkColor,
      filledTextOutlineDarkColor = _ref19$filledTextOutl2 === void 0 ? colorsTypes.PRIMARY_DARK : _ref19$filledTextOutl2,
      _ref19$darkPillTextCo = _ref19.darkPillTextColor,
      darkPillTextColor = _ref19$darkPillTextCo === void 0 ? colorsTypes.PRIMARY_DARK : _ref19$darkPillTextCo,
      _ref19$pillTextColor = _ref19.pillTextColor,
      pillTextColor = _ref19$pillTextColor === void 0 ? colorsTypes.PRIMARY : _ref19$pillTextColor,
      _ref19$darkTextColor = _ref19.darkTextColor,
      darkTextColor = _ref19$darkTextColor === void 0 ? colorsTypes.PRIMARY : _ref19$darkTextColor,
      _ref19$textColor = _ref19.textColor,
      textColor = _ref19$textColor === void 0 ? colorsTypes.PRIMARY : _ref19$textColor;

  if (grayscale) {
    if (outline) return grayscaleAndOutlineTextColor;

    if (fill === buttonFillTypes.OUTLINE_DARK) {
      if (dark) return darkGrayscaleAndOutlineDarkTextColor;
      return grayscaleAndOutlineDarkTextColor;
    }

    if (fill === buttonFillTypes.FILLED) {
      if (dark) return darkGrayscaleAndOFilledTextColor;
      return grayscaleAndOFilledTextColor;
    }

    if (dark) return darkGrayscaleTextColor;
    return grayscaleTextColor;
  }

  if (outline) {
    if (dark) return darkOutlineTextColor;
    return outlineTextColor;
  }

  if (fill === buttonFillTypes.FILLED || fill === buttonFillTypes.NONE) {
    if (dark) return darkFilledTextColor;
    return filledTextColor;
  }

  if (fill === buttonFillTypes.OUTLINE_DARK) {
    if (dark) return filledTextOutlineDarkColor;
    return filledTextOutlineColor;
  }

  if (styleType === buttonStyleTypes.PILL) {
    if (dark) return darkPillTextColor;
    return pillTextColor;
  }

  if (styleType === buttonStyleTypes.STANDARD) {
    if (dark) return darkPillTextColor;
    return pillTextColor;
  }

  if (dark) return darkTextColor;
  return textColor;
}, function (_ref20) {
  var _ref20$outline = _ref20.outline,
      outline = _ref20$outline === void 0 ? false : _ref20$outline,
      _ref20$hoverBorderWid = _ref20.hoverBorderWidth,
      hoverBorderWidth = _ref20$hoverBorderWid === void 0 ? 1 : _ref20$hoverBorderWid,
      _ref20$fill = _ref20.fill,
      fill = _ref20$fill === void 0 ? buttonFillTypes.NONE : _ref20$fill,
      _ref20$styleType = _ref20.styleType,
      styleType = _ref20$styleType === void 0 ? buttonStyleTypes.NONE : _ref20$styleType;

  if (!outline || fill !== buttonFillTypes.OUTLINE_DARK || styleType !== buttonStyleTypes.PILL) {
    return hoverBorderWidth;
  }

  return 0;
}, function (_ref21) {
  var _ref21$hoverTranspare = _ref21.hoverTransparent,
      hoverTransparent = _ref21$hoverTranspare === void 0 ? false : _ref21$hoverTranspare,
      _ref21$grayscale = _ref21.grayscale,
      grayscale = _ref21$grayscale === void 0 ? false : _ref21$grayscale,
      _ref21$dark = _ref21.dark,
      dark = _ref21$dark === void 0 ? false : _ref21$dark,
      _ref21$hoverColor = _ref21.hoverColor,
      hoverColor = _ref21$hoverColor === void 0 ? false : _ref21$hoverColor,
      _ref21$hoverOutline = _ref21.hoverOutline,
      hoverOutline = _ref21$hoverOutline === void 0 ? false : _ref21$hoverOutline,
      _ref21$fill = _ref21.fill,
      fill = _ref21$fill === void 0 ? buttonFillTypes.NONE : _ref21$fill,
      _ref21$styleType = _ref21.styleType,
      styleType = _ref21$styleType === void 0 ? buttonStyleTypes.NONE : _ref21$styleType,
      _ref21$hoverDefaultBa = _ref21.hoverDefaultBackgroundColor,
      hoverDefaultBackgroundColor = _ref21$hoverDefaultBa === void 0 ? colorsTypes.PRIMARY : _ref21$hoverDefaultBa,
      _ref21$hoverBackgroun = _ref21.hoverBackgroundColor,
      hoverBackgroundColor = _ref21$hoverBackgroun === void 0 ? colorsTypes.TRANSPARENT : _ref21$hoverBackgroun,
      _ref21$hoverBackgroun2 = _ref21.hoverBackgroundTransparentColor,
      hoverBackgroundTransparentColor = _ref21$hoverBackgroun2 === void 0 ? colorsTypes.TRANSPARENT : _ref21$hoverBackgroun2,
      _ref21$hoverGrayscale = _ref21.hoverGrayscaleFillBackgroundColor,
      hoverGrayscaleFillBackgroundColor = _ref21$hoverGrayscale === void 0 ? colorsTypes.TRANSPARENT : _ref21$hoverGrayscale,
      _ref21$hoverDarkGrays = _ref21.hoverDarkGrayscaleFillBackgroundColor,
      hoverDarkGrayscaleFillBackgroundColor = _ref21$hoverDarkGrays === void 0 ? colorsTypes.TRANSPARENT : _ref21$hoverDarkGrays,
      _ref21$hoverGrayscale2 = _ref21.hoverGrayscaleOutlineOrPillBackgroundColor,
      hoverGrayscaleOutlineOrPillBackgroundColor = _ref21$hoverGrayscale2 === void 0 ? colorsTypes.WHITE : _ref21$hoverGrayscale2,
      _ref21$hoverGrayscale3 = _ref21.hoverGrayscaleOutlineDarkBackgroundColor,
      hoverGrayscaleOutlineDarkBackgroundColor = _ref21$hoverGrayscale3 === void 0 ? colorsTypes.ULTRA_DARK : _ref21$hoverGrayscale3,
      _ref21$hoverGrayscale4 = _ref21.hoverGrayscaleOutlineBackgroundColor,
      hoverGrayscaleOutlineBackgroundColor = _ref21$hoverGrayscale4 === void 0 ? colorsTypes.WHITE : _ref21$hoverGrayscale4,
      _ref21$hoverGrayscale5 = _ref21.hoverGrayscaleBackgroundColor,
      hoverGrayscaleBackgroundColor = _ref21$hoverGrayscale5 === void 0 ? colorsTypes.WHITE : _ref21$hoverGrayscale5,
      _ref21$hoverOutlineOr = _ref21.hoverOutlineOrPillBackgroundColor,
      hoverOutlineOrPillBackgroundColor = _ref21$hoverOutlineOr === void 0 ? colorsTypes.PRIMARY : _ref21$hoverOutlineOr,
      _ref21$hoverOutlineOr2 = _ref21.hoverOutlineOrPillDarkBackgroundColor,
      hoverOutlineOrPillDarkBackgroundColor = _ref21$hoverOutlineOr2 === void 0 ? colorsTypes.PRIMARY_DARK : _ref21$hoverOutlineOr2,
      _ref21$hoverDarkIsNot = _ref21.hoverDarkIsNotOutlineAndFilledBackgroundColor,
      hoverDarkIsNotOutlineAndFilledBackgroundColor = _ref21$hoverDarkIsNot === void 0 ? colorsTypes.TRANSPARENT : _ref21$hoverDarkIsNot,
      _ref21$hoverFilledOut = _ref21.hoverFilledOutlineDarkBackgroundColor,
      hoverFilledOutlineDarkBackgroundColor = _ref21$hoverFilledOut === void 0 ? colorsTypes.PRIMARY : _ref21$hoverFilledOut,
      _ref21$hoverDarkFille = _ref21.hoverDarkFilledOutlineDarkBackgroundColor,
      hoverDarkFilledOutlineDarkBackgroundColor = _ref21$hoverDarkFille === void 0 ? colorsTypes.PRIMARY_DARK : _ref21$hoverDarkFille,
      _ref21$hoverFilledBac = _ref21.hoverFilledBackgroundColor,
      hoverFilledBackgroundColor = _ref21$hoverFilledBac === void 0 ? colorsTypes.PRIMARY : _ref21$hoverFilledBac,
      _ref21$hoverDarkFille2 = _ref21.hoverDarkFilledBackgroundColor,
      hoverDarkFilledBackgroundColor = _ref21$hoverDarkFille2 === void 0 ? colorsTypes.PRIMARY_DARK : _ref21$hoverDarkFille2;
  if (hoverTransparent) return hoverBackgroundTransparentColor;

  if (grayscale) {
    if (hoverOutline || styleType === buttonStyleTypes.PILL) return hoverGrayscaleOutlineOrPillBackgroundColor;

    if (fill === buttonFillTypes.OUTLINE_DARK) {
      if (dark) return hoverGrayscaleOutlineDarkBackgroundColor;
      return hoverGrayscaleOutlineBackgroundColor;
    }

    if (fill === buttonFillTypes.FILLED) {
      if (dark) return hoverDarkGrayscaleFillBackgroundColor;
      return hoverGrayscaleFillBackgroundColor;
    }

    return hoverGrayscaleBackgroundColor;
  }

  if (hoverOutline || styleType === buttonStyleTypes.PILL) {
    if (dark) return hoverOutlineOrPillDarkBackgroundColor;
    return hoverOutlineOrPillBackgroundColor;
  }

  if (fill === buttonFillTypes.OUTLINE_DARK) {
    if (dark) return hoverDarkFilledOutlineDarkBackgroundColor;
    return hoverFilledOutlineDarkBackgroundColor;
  }

  if (fill === buttonFillTypes.FILLED) {
    if (dark) return hoverDarkFilledBackgroundColor;
    return hoverFilledBackgroundColor;
  }

  if (!hoverOutline && hoverColor) {
    if (dark) return hoverDarkIsNotOutlineAndFilledBackgroundColor;
    return hoverBackgroundColor;
  }

  return hoverDefaultBackgroundColor;
}, function (_ref22) {
  var _ref22$hoverColor = _ref22.hoverColor,
      hoverColor = _ref22$hoverColor === void 0 ? false : _ref22$hoverColor,
      _ref22$hoverOutline = _ref22.hoverOutline,
      hoverOutline = _ref22$hoverOutline === void 0 ? false : _ref22$hoverOutline,
      _ref22$grayscale = _ref22.grayscale,
      grayscale = _ref22$grayscale === void 0 ? false : _ref22$grayscale,
      _ref22$dark = _ref22.dark,
      dark = _ref22$dark === void 0 ? false : _ref22$dark,
      _ref22$fill = _ref22.fill,
      fill = _ref22$fill === void 0 ? buttonFillTypes.NONE : _ref22$fill,
      _ref22$hoverDefaultBo = _ref22.hoverDefaultBorderColor,
      hoverDefaultBorderColor = _ref22$hoverDefaultBo === void 0 ? colorsTypes.PRIMARY : _ref22$hoverDefaultBo,
      _ref22$hoverDarkOutli = _ref22.hoverDarkOutlineAndColorBorderColor,
      hoverDarkOutlineAndColorBorderColor = _ref22$hoverDarkOutli === void 0 ? colorsTypes.PRIMARY : _ref22$hoverDarkOutli,
      _ref22$hoverOutlineAn = _ref22.hoverOutlineAndColorBorderColor,
      hoverOutlineAndColorBorderColor = _ref22$hoverOutlineAn === void 0 ? colorsTypes.PRIMARY_DARK : _ref22$hoverOutlineAn,
      _ref22$hoverFilledBor = _ref22.hoverFilledBorderColor,
      hoverFilledBorderColor = _ref22$hoverFilledBor === void 0 ? colorsTypes.PRIMARY : _ref22$hoverFilledBor,
      _ref22$hoverDarkGrays = _ref22.hoverDarkGrayscaleBorderColor,
      hoverDarkGrayscaleBorderColor = _ref22$hoverDarkGrays === void 0 ? colorsTypes.ULTRA_DARK : _ref22$hoverDarkGrays,
      _ref22$hoverGrayscale = _ref22.hoverGrayscaleBorderColor,
      hoverGrayscaleBorderColor = _ref22$hoverGrayscale === void 0 ? colorsTypes.WHITE : _ref22$hoverGrayscale,
      _ref22$hoverGrayscale2 = _ref22.hoverGrayscaleOutlineDarkBorderColor,
      hoverGrayscaleOutlineDarkBorderColor = _ref22$hoverGrayscale2 === void 0 ? colorsTypes.ULTRA_DARK : _ref22$hoverGrayscale2,
      _ref22$hoverGrayscale3 = _ref22.hoverGrayscaleOutlineBorderColor,
      hoverGrayscaleOutlineBorderColor = _ref22$hoverGrayscale3 === void 0 ? colorsTypes.WHITE : _ref22$hoverGrayscale3,
      _ref22$hoverFilledOut = _ref22.hoverFilledOutlineDarkBorderColor,
      hoverFilledOutlineDarkBorderColor = _ref22$hoverFilledOut === void 0 ? colorsTypes.PRIMARY_DARK : _ref22$hoverFilledOut,
      _ref22$hoverFilledOut2 = _ref22.hoverFilledOutlineBorderColor,
      hoverFilledOutlineBorderColor = _ref22$hoverFilledOut2 === void 0 ? colorsTypes.PRIMARY : _ref22$hoverFilledOut2;

  if (grayscale) {
    if (fill === buttonFillTypes.OUTLINE_DARK) {
      if (dark) return hoverGrayscaleOutlineDarkBorderColor;
      return hoverGrayscaleOutlineBorderColor;
    }

    if (dark) return hoverDarkGrayscaleBorderColor;
    return hoverGrayscaleBorderColor;
  }

  if (hoverOutline || hoverColor) {
    if (dark) return hoverDarkOutlineAndColorBorderColor;
    return hoverOutlineAndColorBorderColor;
  }

  if (fill === buttonFillTypes.OUTLINE_DARK) {
    if (dark) return hoverFilledOutlineDarkBorderColor;
    return hoverFilledOutlineBorderColor;
  }

  if (fill === buttonFillTypes.FILLED) return hoverFilledBorderColor;
  return hoverDefaultBorderColor;
}, function (_ref23) {
  var _ref23$hoverColor = _ref23.hoverColor,
      hoverColor = _ref23$hoverColor === void 0 ? false : _ref23$hoverColor,
      _ref23$hoverOutline = _ref23.hoverOutline,
      hoverOutline = _ref23$hoverOutline === void 0 ? false : _ref23$hoverOutline,
      _ref23$grayscale = _ref23.grayscale,
      grayscale = _ref23$grayscale === void 0 ? false : _ref23$grayscale,
      _ref23$dark = _ref23.dark,
      dark = _ref23$dark === void 0 ? false : _ref23$dark,
      _ref23$fill = _ref23.fill,
      fill = _ref23$fill === void 0 ? buttonFillTypes.NONE : _ref23$fill,
      _ref23$styleType = _ref23.styleType,
      styleType = _ref23$styleType === void 0 ? buttonStyleTypes.NONE : _ref23$styleType,
      _ref23$hoverDefaultTe = _ref23.hoverDefaultTextColor,
      hoverDefaultTextColor = _ref23$hoverDefaultTe === void 0 ? colorsTypes.WHITE : _ref23$hoverDefaultTe,
      _ref23$hoverAndNotOut = _ref23.hoverAndNotOutlineTextColor,
      hoverAndNotOutlineTextColor = _ref23$hoverAndNotOut === void 0 ? colorsTypes.WHITE : _ref23$hoverAndNotOut,
      _ref23$hoverDarkGrays = _ref23.hoverDarkGrayscaleTextColor,
      hoverDarkGrayscaleTextColor = _ref23$hoverDarkGrays === void 0 ? colorsTypes.BLACK : _ref23$hoverDarkGrays,
      _ref23$hoverDarkGrays2 = _ref23.hoverDarkGrayscaleFilledTextColor,
      hoverDarkGrayscaleFilledTextColor = _ref23$hoverDarkGrays2 === void 0 ? colorsTypes.BLACK : _ref23$hoverDarkGrays2,
      _ref23$hoverGrayscale = _ref23.hoverGrayscaleFilledTextColor,
      hoverGrayscaleFilledTextColor = _ref23$hoverGrayscale === void 0 ? colorsTypes.WHITE : _ref23$hoverGrayscale,
      _ref23$hoverDarkGrays3 = _ref23.hoverDarkGrayscaleFilledAndOutlineTextColor,
      hoverDarkGrayscaleFilledAndOutlineTextColor = _ref23$hoverDarkGrays3 === void 0 ? colorsTypes.BLACK : _ref23$hoverDarkGrays3,
      _ref23$hoverGrayscale2 = _ref23.hoverGrayscaleFilledAndOutlineTextColor,
      hoverGrayscaleFilledAndOutlineTextColor = _ref23$hoverGrayscale2 === void 0 ? colorsTypes.ULTRA_DARK : _ref23$hoverGrayscale2,
      _ref23$hoverDarkGrays4 = _ref23.hoverDarkGrayscaleOutlineDarkTextColor,
      hoverDarkGrayscaleOutlineDarkTextColor = _ref23$hoverDarkGrays4 === void 0 ? colorsTypes.BLACK : _ref23$hoverDarkGrays4,
      _ref23$hoverGrayscale3 = _ref23.hoverGrayscaleOutlineDarkTextColor,
      hoverGrayscaleOutlineDarkTextColor = _ref23$hoverGrayscale3 === void 0 ? colorsTypes.ULTRA_DARK : _ref23$hoverGrayscale3,
      _ref23$hoverDarkOutli = _ref23.hoverDarkOutlineTextColor,
      hoverDarkOutlineTextColor = _ref23$hoverDarkOutli === void 0 ? colorsTypes.PRIMARY : _ref23$hoverDarkOutli,
      _ref23$hoverOutlineTe = _ref23.hoverOutlineTextColor,
      hoverOutlineTextColor = _ref23$hoverOutlineTe === void 0 ? colorsTypes.PRIMARY : _ref23$hoverOutlineTe,
      _ref23$hoverDarkFille = _ref23.hoverDarkFilledTextColor,
      hoverDarkFilledTextColor = _ref23$hoverDarkFille === void 0 ? colorsTypes.PRIMARY_DARK : _ref23$hoverDarkFille,
      _ref23$hoverFilledTex = _ref23.hoverFilledTextColor,
      hoverFilledTextColor = _ref23$hoverFilledTex === void 0 ? colorsTypes.WHITE : _ref23$hoverFilledTex,
      _ref23$hoverDarkTextC = _ref23.hoverDarkTextColor,
      hoverDarkTextColor = _ref23$hoverDarkTextC === void 0 ? colorsTypes.HIGHT_LIGHT_PRIMARY : _ref23$hoverDarkTextC,
      _ref23$hoverDarkPillT = _ref23.hoverDarkPillTextColor,
      hoverDarkPillTextColor = _ref23$hoverDarkPillT === void 0 ? colorsTypes.PRIMARY : _ref23$hoverDarkPillT,
      _ref23$hoverPillTextC = _ref23.hoverPillTextColor,
      hoverPillTextColor = _ref23$hoverPillTextC === void 0 ? colorsTypes.PRIMARY : _ref23$hoverPillTextC,
      _ref23$hoverDarkFille2 = _ref23.hoverDarkFilledOutlineDarkTextColor,
      hoverDarkFilledOutlineDarkTextColor = _ref23$hoverDarkFille2 === void 0 ? colorsTypes.HIGHT_LIGHT_PRIMARY : _ref23$hoverDarkFille2,
      _ref23$hoverFilledOut = _ref23.hoverFilledOutlineDarkTextColor,
      hoverFilledOutlineDarkTextColor = _ref23$hoverFilledOut === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref23$hoverFilledOut,
      _ref23$hoverTextColor = _ref23.hoverTextColor,
      hoverTextColor = _ref23$hoverTextColor === void 0 ? colorsTypes.PRIMARY : _ref23$hoverTextColor;
  if (hoverColor && !hoverOutline) return hoverAndNotOutlineTextColor;

  if (grayscale) {
    if (fill === buttonFillTypes.OUTLINE_DARK) {
      if (dark) return hoverDarkGrayscaleOutlineDarkTextColor;
      return hoverGrayscaleOutlineDarkTextColor;
    }

    if (fill === buttonFillTypes.FILLED) {
      if (hoverOutline) {
        if (dark) return hoverDarkGrayscaleFilledAndOutlineTextColor;
        return hoverGrayscaleFilledAndOutlineTextColor;
      }

      if (dark) return hoverDarkGrayscaleFilledTextColor;
      return hoverGrayscaleFilledTextColor;
    }

    if (dark) return hoverDarkGrayscaleTextColor;
    return hoverDefaultTextColor;
  }

  if (hoverOutline) {
    if (dark) return hoverDarkOutlineTextColor;
    return hoverOutlineTextColor;
  }

  if (styleType === buttonStyleTypes.PILL) {
    if (dark) return hoverDarkPillTextColor;
    return hoverPillTextColor;
  }

  if (fill === buttonFillTypes.OUTLINE_DARK) {
    if (dark) return hoverDarkFilledOutlineDarkTextColor;
    return hoverFilledOutlineDarkTextColor;
  }

  if (fill === buttonFillTypes.FILLED) {
    if (dark) return hoverDarkFilledTextColor;
    return hoverFilledTextColor;
  }

  if (dark) return hoverDarkTextColor;
  return hoverTextColor;
});

var _templateObject$2S, _templateObject2$1n, _templateObject3$16, _templateObject4$O, _templateObject5$F;

var Container$n = styled__default["default"].div(_templateObject$2S || (_templateObject$2S = _taggedTemplateLiteral(["\n  background: ", ";\n"])), function (_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$backgroundColor;
  return getColors(backgroundColor);
});
var Title$A = styled__default["default"].h3(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.ULTRA_DARK : _ref2$color;
  return getColors(color);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(size);
});
var Description$e = styled__default["default"].p(_templateObject3$16 || (_templateObject3$16 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.BLACK : _ref5$color;
  return getColors(color);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? textSizesVariantsTypes.LARGE : _ref7$size;
  return getTextSize(size);
});
var ItemTitle = styled__default["default"].span(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteral(["\n  font-weight: bold;\n\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref8$color;
  return getColors(color);
}, function (_ref9) {
  var _ref9$fontFamily = _ref9.fontFamily,
      fontFamily = _ref9$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref9$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref10) {
  var _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? textSizesVariantsTypes.SMALL : _ref10$size;
  return getTextSize(size);
});
var ItemSubTitle = styled__default["default"].span(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref11) {
  var _ref11$color = _ref11.color,
      color = _ref11$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref11$color;
  return getColors(color);
}, function (_ref12) {
  var _ref12$fontFamily = _ref12.fontFamily,
      fontFamily = _ref12$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref12$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref13) {
  var _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? textSizesVariantsTypes.SMALL : _ref13$size;
  return getTextSize(size);
});

function CalloutData(_ref14) {
  var data = _ref14.data;
  if (!data) return null;
  var _data$backgroundColor = data.backgroundColor,
      backgroundColor = _data$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _data$backgroundColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont,
      _data$itemTitleColor = data.itemTitleColor,
      itemTitleColor = _data$itemTitleColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$itemTitleColor,
      _data$itemTitleSize = data.itemTitleSize,
      itemTitleSize = _data$itemTitleSize === void 0 ? textSizesVariantsTypes.SMALL : _data$itemTitleSize,
      _data$itemTitleFontFa = data.itemTitleFontFamily,
      itemTitleFontFamily = _data$itemTitleFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$itemTitleFontFa,
      _data$itemSubtitleCol = data.itemSubtitleColor,
      itemSubtitleColor = _data$itemSubtitleCol === void 0 ? colorsVariantsTypes.PRIMARY : _data$itemSubtitleCol,
      _data$itemSubtitleSiz = data.itemSubtitleSize,
      itemSubtitleSize = _data$itemSubtitleSiz === void 0 ? textSizesVariantsTypes.SMALL : _data$itemSubtitleSiz,
      _data$itemSubtitleFon = data.itemSubtitleFontFamily,
      itemSubtitleFontFamily = _data$itemSubtitleFon === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$itemSubtitleFon;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$n, {
    className: "CALLOUT_DATA tw-text-center md:tw-text-left tw-rounded-lg",
    backgroundColor: colorsVariantsTypes[backgroundColor || colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT]
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_DATA__CONTAINER tw-card lg:tw-flex sm:tw-justify-between tw-flex-wrap tw-px-8 xl:tw-px-24 tw-py-10"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_DATA__CONTAINER__HEADER lg:tw-w-7/12 tw-self-center"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_DATA__CONTAINER__HEADER__CONTAINER sm:tw-w-full md:tw-w-full sm:tw-text-center md:tw-text-left"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$A, {
    className: "CALLOUT_DATA__CONTAINER__HEADER__TITLE CalloutData__title tw-font-bold bl-text-xl tw-pb-3",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_DATA__CONTAINER__HEADER__PRIMARY_TEXT"
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(Description$e, {
    className: "CALLOUT_DATA__CONTAINER__HEADER__DESCRIPTION bl-text-md tw-mb-8",
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.BLACK],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.LARGE]
  }, data.description))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_DATA__CONTAINER__LIST_CONTAINER lg:tw-w-4/12 tw-self-center tw-px-2 tw-py-2"
  }, /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "CALLOUT_DATA__CONTAINER__LIST"
  }, (data.items || []).map(function (item, i) {
    return /*#__PURE__*/React__default$1["default"].createElement("li", {
      key: "CalloutData-item-".concat(i),
      className: "CALLOUT_DATA__CONTAINER__LIST__ITEM"
    }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
      className: "CALLOUT_DATA__CONTAINER__LIST__ITEM__PRIMARY_TEXT"
    }, /*#__PURE__*/React__default$1["default"].createElement(ItemTitle, {
      className: "CALLOUT_DATA__CONTAINER__LIST__ITEM__TITLE CalloutData__subtitle tw-pr-3 tw-font-black",
      fontFamily: fontsFamiliesVariantsTypes[itemTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
      color: colorsVariantsTypes[itemTitleColor || colorsVariantsTypes.PRIMARY],
      size: textSizesVariantsTypes[itemTitleSize || textSizesVariantsTypes.SMALL]
    }, item.name)), /*#__PURE__*/React__default$1["default"].createElement(ItemSubTitle, {
      className: "CALLOUT_DATA__CONTAINER__LIST__ITEM__SUB_TITLE",
      fontFamily: fontsFamiliesVariantsTypes[itemSubtitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
      color: colorsVariantsTypes[itemSubtitleColor || colorsVariantsTypes.PRIMARY],
      size: textSizesVariantsTypes[itemSubtitleSize || textSizesVariantsTypes.SMALL]
    }, item.content));
  })))));
}

var _templateObject$2R, _templateObject2$1m, _templateObject3$15, _templateObject4$N, _templateObject5$E;

var Title$z = styled__default["default"].h3(_templateObject$2R || (_templateObject$2R = _taggedTemplateLiteral(["\n  font-weight: 600;\n  line-height: 70px;\n  text-align: center;\n\n  font-size: ", ";\n\n  color: ", ";\n\n  font-family: ", ";\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref$size;
  return getTextSize(size);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.BLACK : _ref2$color;
  return getColors(color);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
});
var Description$d = styled__default["default"].p(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  color: ", ";\n\n  font-family: ", ";\n"])), function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(size);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.BLACK : _ref5$color;
  return getColors(color);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
});
var CustomButton$f = styled__default["default"](Button$2)(_templateObject3$15 || (_templateObject3$15 = _taggedTemplateLiteral([""])));
var CallogutWithGradientContainer = styled__default["default"].div(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteral(["\n  background-color: #000;\n  background: transparent;\n"])));

function CalloutWithGradient(_ref7) {
  var _config$speedBump, _customComponentStyle, _config$speedBump2, _customComponentStyle2;

  var _ref7$customComponent = _ref7.customComponentStyles,
      customComponentStyles = _ref7$customComponent === void 0 ? {} : _ref7$customComponent,
      _ref7$applyMaxWidthCo = _ref7.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref7$applyMaxWidthCo === void 0 ? false : _ref7$applyMaxWidthCo,
      _ref7$config = _ref7.config,
      config = _ref7$config === void 0 ? {} : _ref7$config,
      data = _ref7.data,
      _ref7$ultraLight = _ref7.ultraLight,
      ultraLight = _ref7$ultraLight === void 0 ? false : _ref7$ultraLight,
      _ref7$withoutOpacity = _ref7.withoutOpacity,
      withoutOpacity = _ref7$withoutOpacity === void 0 ? false : _ref7$withoutOpacity,
      _ref7$radial = _ref7.radial,
      radial = _ref7$radial === void 0 ? false : _ref7$radial,
      _ref7$darkButton = _ref7.darkButton,
      dark = _ref7$darkButton === void 0 ? false : _ref7$darkButton,
      _ref7$buttonGrayscale = _ref7.buttonGrayscale,
      grayscale = _ref7$buttonGrayscale === void 0 ? false : _ref7$buttonGrayscale,
      _ref7$noGradient = _ref7.noGradient,
      noGradient = _ref7$noGradient === void 0 ? false : _ref7$noGradient,
      _ref7$buttonStylesPro = _ref7.buttonStylesProps,
      buttonStylesProps = _ref7$buttonStylesPro === void 0 ? {
    hoverBackgroundColor: colorsTypes.PRIMARY,
    hoverFilledBackgroundColor: colorsTypes.PRIMARY_DARK,
    hoverColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    hoverBorderColor: colorsTypes.PRIMARY,
    defaultBorderColor: colorsTypes.TRANSPARENT,
    defaultTextColor: colorsTypes.PRIMARY_DARK,
    defaultBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    transparent: false
  } : _ref7$buttonStylesPro;
  if (!data) return null;
  var _data$cssBackgroundGr = data.cssBackgroundGradient,
      gradient = _data$cssBackgroundGr === void 0 ? "" : _data$cssBackgroundGr,
      _data$buttonGrayscale = data.buttonGrayscale,
      buttonGrayscale = _data$buttonGrayscale === void 0 ? false : _data$buttonGrayscale,
      _data$withGradient = data.withGradient,
      withGradient = _data$withGradient === void 0 ? true : _data$withGradient,
      _data$image = data.image,
      image = _data$image === void 0 ? {} : _data$image,
      _data$title = data.title,
      title = _data$title === void 0 ? "" : _data$title,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.BLACK : _data$titleColor,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$buttonFilled = data.buttonFilled,
      buttonFilled = _data$buttonFilled === void 0 ? buttonFillTypes.FILLED : _data$buttonFilled,
      _data$description = data.description,
      description = _data$description === void 0 ? "" : _data$description,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _data$titleSize,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont,
      _data$buttonText = data.buttonText,
      buttonText = _data$buttonText === void 0 ? "" : _data$buttonText,
      _data$buttonUrl = data.buttonUrl,
      buttonUrl = _data$buttonUrl === void 0 ? "" : _data$buttonUrl;

  var _noGradient = noGradient || !withGradient;

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: applyMaxWidthContainer && "tw-x-container max-width-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(CallogutWithGradientContainer, {
    className: "CALLOUT_WITH_GRADIENT tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("CALLOUT_WITH_GRADIENT__CONTENT tw-absolute tw-w-full tw-inset-0 tw-flex tw-flex-col tw-justify-center tw-z-40 tw-my-10", !applyMaxWidthContainer && "tw-container")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER tw-text-center"
  }, title && /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER__PRIMARY_TEXT"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$z, {
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER__PRIMARY_TEXT__TITLE FeatureV2__title FeatureV2__title FeatureV2__title-callout-with-gradient",
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.BLACK],
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.HEADER_6]
  }, title)), description && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER__DESCRIPTION_CONTAINER tw-mt-20 tw-mb-20"
  }, /*#__PURE__*/React__default$1["default"].createElement(Description$d, {
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.BLACK],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.VERY_BIG],
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER__DESCRIPTION_TEXT md:bl-text-lg tw-leading-snug sm:bl-text-base"
  }, description)), buttonText && buttonUrl && !image ? /*#__PURE__*/React__default$1["default"].createElement(CustomButton$f, _extends$g({
    is: "a",
    fill: buttonFilled,
    href: buttonUrl,
    grayscale: buttonGrayscale || grayscale,
    dark: dark,
    withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious) || false,
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER__BUTTON"
  }, buttonStylesProps, (_customComponentStyle = customComponentStyles.calloutWithGradient) === null || _customComponentStyle === void 0 ? void 0 : _customComponentStyle.buttonStylesProps), buttonText) : /*#__PURE__*/React__default$1["default"].createElement(CustomButton$f, _extends$g({
    is: "a",
    fill: buttonFilled,
    href: buttonUrl,
    grayscale: buttonGrayscale || grayscale,
    dark: dark,
    withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious) || false,
    className: "CALLOUT_WITH_GRADIENT__CONTENT__HEADER__BUTTON"
  }, buttonStylesProps, (_customComponentStyle2 = customComponentStyles.calloutWithGradient) === null || _customComponentStyle2 === void 0 ? void 0 : _customComponentStyle2.buttonStylesProps), buttonText))), !!image && !!image.url ? /*#__PURE__*/React__default$1["default"].createElement(ContainerGradient$1, {
    gradient: gradient,
    className: "CALLOUT_WITH_GRADIENT__GRADIENT tw-w-full",
    gradientType: "BackgroundImageColor",
    image: process.env.GATSBY_CU_NAME === "bayou" ? "https://d1w2egu22dd0ex.cloudfront.net/".concat(image.url.split("/").pop()) : image.url,
    style: {
      height: "90vh"
    },
    noGradient: _noGradient,
    radial: radial,
    withoutOpacity: withoutOpacity
  }) : /*#__PURE__*/React__default$1["default"].createElement(GradientWithoutImageContainer, {
    gradient: gradient,
    ultraLight: ultraLight,
    style: {
      minHeight: "640px"
    },
    noGradient: _noGradient,
    radial: radial,
    withoutOpacity: withoutOpacity,
    className: "CALLOUT_WITH_GRADIENT__GRADIENT CALLOUT_WITH_GRADIENT__CONTAINER"
  })));
}

var CalloutWithGradient$1 = styled__default["default"](CalloutWithGradient)(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteral(["\n  h3 {\n    color: var(--primary-color);\n  }\n\n  a {\n    width: 30%;\n    color: var(--grayscale-0-color);\n  }\n\n  @media only screen and (max-width: ", "px) {\n    a {\n      width: auto;\n    }\n  }\n"])), breakpoints.sm);

var _templateObject$2Q, _templateObject2$1l, _templateObject3$14, _templateObject4$M;

var Title$y = styled__default["default"].h3(_templateObject$2Q || (_templateObject$2Q = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n\n  @media only screen and (max-width: ", "px) {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? false : _ref$primary;

  if (grayscale && primary === false) {
    if (dark) return getColors(colorsVariantsTypes.BLACK);
    return getColors(colorsVariantsTypes.WHITE);
  }

  if (dark) return getColors(colorsVariantsTypes.PRIMARY_DARK);
  return getColors(colorsVariantsTypes.PRIMARY);
}, function (_ref2) {
  var _ref2$titleFontFamily = _ref2.titleFontFamily,
      titleFontFamily = _ref2$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$titleFontFamily;
  return getFontFamily(titleFontFamily);
}, function (_ref3) {
  var _ref3$titleSize = _ref3.titleSize,
      titleSize = _ref3$titleSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref3$titleSize;
  return getTextSize(titleSize);
}, breakpoints.md - 1, getTextSize(textSizesVariantsTypes.HEADER_1_H2));
var Description$c = styled__default["default"].p(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  font-size: ", ";\n\n  @media only screen and (max-width: ", "px) {\n    font-size: ", ";\n  }\n"])), function (_ref4) {
  var _ref4$grayscale = _ref4.grayscale,
      grayscale = _ref4$grayscale === void 0 ? false : _ref4$grayscale,
      _ref4$dark = _ref4.dark,
      dark = _ref4$dark === void 0 ? false : _ref4$dark;

  if (grayscale) {
    if (dark) return getColors(colorsVariantsTypes.BLACK);
    return getColors(colorsVariantsTypes.WHITE);
  }

  if (dark) return getColors(colorsVariantsTypes.PRIMARY_DARK);
  return getColors(colorsVariantsTypes.PRIMARY);
}, function (_ref5) {
  var _ref5$descriptionFont = _ref5.descriptionFontFamily,
      descriptionFontFamily = _ref5$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref5$descriptionFont;
  return getFontFamily(descriptionFontFamily);
}, function (_ref6) {
  var _ref6$descriptionSize = _ref6.descriptionSize,
      descriptionSize = _ref6$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref6$descriptionSize;
  return getTextSize(descriptionSize);
}, breakpoints.md - 1, getTextSize(textSizesVariantsTypes.SMALL));
var CustomButton$e = styled__default["default"](Button$2)(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n\n  &:hover {\n    color: var(--primary-110-color);\n  }\n"])), function (_ref7) {
  var _ref7$withoutBorderRa = _ref7.withoutBorderRadius,
      withoutBorderRadius = _ref7$withoutBorderRa === void 0 ? false : _ref7$withoutBorderRa;
  if (withoutBorderRadius) return 0;
  return 5;
});

function CalloutWithGradientAndPadding(_ref8) {
  var data = _ref8.data,
      _ref8$ultraLight = _ref8.ultraLight,
      ultraLight = _ref8$ultraLight === void 0 ? false : _ref8$ultraLight,
      _ref8$darkTitle = _ref8.darkTitle,
      darkTitle = _ref8$darkTitle === void 0 ? false : _ref8$darkTitle,
      _ref8$primaryTitle = _ref8.primaryTitle,
      primaryTitle = _ref8$primaryTitle === void 0 ? false : _ref8$primaryTitle,
      _ref8$darkDescription = _ref8.darkDescription,
      darkDescription = _ref8$darkDescription === void 0 ? false : _ref8$darkDescription,
      _ref8$grayscaleTitle = _ref8.grayscaleTitle,
      grayscaleTitle = _ref8$grayscaleTitle === void 0 ? false : _ref8$grayscaleTitle,
      _ref8$grayscaleDescri = _ref8.grayscaleDescription,
      grayscaleDescription = _ref8$grayscaleDescri === void 0 ? false : _ref8$grayscaleDescri,
      _ref8$darkButton = _ref8.darkButton,
      dark = _ref8$darkButton === void 0 ? false : _ref8$darkButton,
      _ref8$buttonOutline = _ref8.buttonOutline,
      buttonOutline = _ref8$buttonOutline === void 0 ? false : _ref8$buttonOutline,
      _ref8$buttonHoverColo = _ref8.buttonHoverColor,
      buttonHoverColor = _ref8$buttonHoverColo === void 0 ? false : _ref8$buttonHoverColo,
      _ref8$darkButton2 = _ref8.darkButton,
      darkButton = _ref8$darkButton2 === void 0 ? false : _ref8$darkButton2,
      _ref8$noGradient = _ref8.noGradient,
      noGradient = _ref8$noGradient === void 0 ? false : _ref8$noGradient,
      _ref8$buttonStylesPro = _ref8.buttonStylesProps,
      buttonStylesProps = _ref8$buttonStylesPro === void 0 ? {
    padding: "10px 20px",
    minWidth: "none",
    filledBackgroundColor: colorsTypes.PRIMARY_ULTRA_LIGHT,
    filledBorderColor: colorsTypes.PRIMARY_ULTRA_LIGHT,
    filledTextColor: colorsTypes.PRIMARY_ULTRA_LIGHT,
    hoverBackgroundColor: colorsTypes.TRANSPARENT,
    hoverFilledTextColor: colorsTypes.PRIMARY_ULTRA_LIGHT,
    hoverDefaultBorderColor: colorsTypes.PRIMARY_ULTRA_LIGHT,
    hoverFilledBorderColor: colorsTypes.PRIMARY_ULTRA_LIGHT
  } : _ref8$buttonStylesPro;
  if (!data) return null;
  var _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _data$titleSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING tw-relative tw-m-8 xl:tw-m-32"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER tw-absolute tw-w-full tw-inset-0 tw-flex tw-flex-col tw-justify-center tw-z-40 tw-my-10 tw-px-4 lg:tw-px-16"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__BOX tw-text-center"
  }, data.title && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__TITLE_BOX"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$y, {
    dark: darkTitle,
    grayscale: grayscaleTitle,
    primary: primaryTitle,
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.HEADER_1_H2],
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__TITLE_TEXT FeatureV2__title FeatureV2__title-callout-with-gradient-and-padding tw-font-bold tw-mb-5 tw-leading-snug"
  }, data.title)), data.description && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__DESCRIPTION_BOX tw-mt-20 tw-mb-20"
  }, /*#__PURE__*/React__default$1["default"].createElement(Description$c, {
    dark: darkDescription,
    grayscale: grayscaleDescription,
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.VERY_LARGE],
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__DESCRIPTION_TEXT tw-leading-snug"
  }, data.description)), data.buttonText && data.buttonUrl && !data.image ? /*#__PURE__*/React__default$1["default"].createElement(CustomButton$e, _extends$g({
    is: "a",
    href: data.buttonUrl,
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.STANDARD,
    withoutBorderRadius: false,
    outline: buttonOutline,
    hoverColor: buttonHoverColor,
    dark: darkButton,
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__BUTTON"
  }, buttonStylesProps), data.buttonText) : /*#__PURE__*/React__default$1["default"].createElement(CustomButton$e, {
    is: "a",
    fill: buttonFillTypes.FILLED,
    hoverBackgroundColor: colorsTypes.PRIMARY,
    hoverFilledBackgroundColor: colorsTypes.PRIMARY_DARK,
    hoverColor: colorsTypes.WHITE,
    hoverBorderColor: colorsTypes.PRIMARY,
    defaultTextColor: colorsTypes.PRIMARY_DARK,
    defaultBackgroundColor: colorsTypes.WHITE,
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__CONTAINER__BUTTON",
    href: data.buttonUrl,
    grayscale: true,
    dark: dark
  }, data.buttonText))), data.image ? /*#__PURE__*/React__default$1["default"].createElement(ContainerGradient$1, {
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__GRADIENT tw-w-full",
    gradientType: "BackgroundImageColor",
    image: data.image.url,
    style: {
      height: "90vh"
    }
  }) : /*#__PURE__*/React__default$1["default"].createElement(GradientWithoutImageContainer, {
    ultraLight: ultraLight,
    noGradient: noGradient,
    style: {
      minHeight: "640px"
    },
    className: "CALLOUT_WITH_GRADIENT_AND_PADDING__GRADIENT"
  }));
}

var CalloutWithGradientAndPadding$1 = styled__default["default"](CalloutWithGradientAndPadding)(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteral(["\n  h3 {\n    color: var(--primary-color);\n  }\n  a {\n    width: 30%;\n  }\n  @media only screen and (max-width: ", "px) {\n    a {\n      width: auto;\n    }\n  }\n"])), breakpoints.sm);

var _templateObject$2P, _templateObject2$1k, _templateObject3$13;

var Container$m = styled__default["default"].div(_templateObject$2P || (_templateObject$2P = _taggedTemplateLiteral(["\n  //background: var(--primary-6-color);\n  background: ", ";\n"])), function (_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$backgroundColor;
  return getColors(backgroundColor);
});
var Title$x = styled__default["default"].h3(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteral(["\n  //color: var(--primary-color);\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref2$color;
  return getColors(color);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(size);
});
var Description$b = styled__default["default"].p(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteral(["\n  //color: var(--grayscale-100-color);\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.BLACK : _ref5$color;
  return getColors(color);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? textSizesVariantsTypes.SMALL : _ref7$size;
  return getTextSize(size);
});

function CalloutMobileApps(_ref8) {
  var _data$mobileAppImageA, _data$mobileAppImageA2, _data$mobileAppImageA3, _data$mobileAppImageB, _data$mobileAppImageB2;

  var data = _ref8.data;
  if (!data || !data.mobileAppImageA && !data.mobileAppImageB) return null;
  var _data$backgroundColor = data.backgroundColor,
      backgroundColor = _data$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _data$backgroundColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.SMALL : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$m, {
    className: "CALLOUT_MOBILE_APPS__CONTAINER tw-rounded-lg bl-bg-primary-6 tw-flex tw-flex-wrap tw-justify-center md:tw-justify-between tw-items-center tw-p-16 lg:tw-p-20",
    backgroundColor: colorsVariantsTypes[backgroundColor || colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT]
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS__HEADER_CONTAINER tw-w-64 tw-text-center md:tw-text-left"
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_MOBILE_APPS__HEADER__TITLE_PRIMARY"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$x, {
    className: "CALLOUT_MOBILE_APPS__HEADER__TITLE CalloutMobileApps__title tw-font-bold bl-text-xl tw-mb-3",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.PRIMARY],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(Description$b, {
    className: "CALLOUT_MOBILE_APPS__HEADER__DESCRIPTION",
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.BLACK],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.SMALL]
  }, data.description)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS__CONTENT tw-flex tw-w-64 lg:tw-w-72 tw-justify-center tw-mt-8"
  }, ((_data$mobileAppImageA = data.mobileAppImageA) === null || _data$mobileAppImageA === void 0 ? void 0 : _data$mobileAppImageA.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS__CONTENT__LINK tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    className: "tw-absolute tw-w-full tw-h-full",
    href: data.mobileAppLinkA,
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "CALLOUT_MOBILE_APPS__CONTENT__LINK__IMAGE tw-w-auto tw-h-6 sm:tw-h-10 tw-object-cover tw-rounded-md",
    src: data.mobileAppImageA.url,
    alt: (data === null || data === void 0 ? void 0 : (_data$mobileAppImageA2 = data.mobileAppImageA) === null || _data$mobileAppImageA2 === void 0 ? void 0 : _data$mobileAppImageA2.alternativeText) || (data === null || data === void 0 ? void 0 : (_data$mobileAppImageA3 = data.mobileAppImageA) === null || _data$mobileAppImageA3 === void 0 ? void 0 : _data$mobileAppImageA3.hash) || ""
  })), ((_data$mobileAppImageB = data.mobileAppImageB) === null || _data$mobileAppImageB === void 0 ? void 0 : _data$mobileAppImageB.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS__CONTENT__LINK tw-ml-2 lg:tw-ml-8 tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    className: "tw-absolute tw-w-full tw-h-full",
    href: data.mobileAppLinkB,
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: data.mobileAppImageB.url,
    className: "CALLOUT_MOBILE_APPS__CONTENT__LINK__IMAGE tw-w-auto tw-h-6 sm:tw-h-10 tw-object-cover tw-rounded-md",
    alt: ((_data$mobileAppImageB2 = data.mobileAppImageB) === null || _data$mobileAppImageB2 === void 0 ? void 0 : _data$mobileAppImageB2.alternativeText) || data.mobileAppImageB.hash
  }))));
}

var _templateObject$2O, _templateObject2$1j, _templateObject3$12, _templateObject4$L;

var LineDecoration = styled__default["default"].div(_templateObject$2O || (_templateObject$2O = _taggedTemplateLiteral(["\n  border-left: ", ";\n"])), function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref$borderColor;
  return "solid 4px ".concat(getColors(borderColor));
});
var Title$w = styled__default["default"].h4(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteral(["\n  font-weight: bold;\n  //color: var(--primary-color);\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref2$color;
  return getColors(color);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(size);
});
var List$1 = styled__default["default"].ul(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteral([""])));
var ListItem = styled__default["default"].li(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteral(["\n  //color: var(--primary-color);\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref5$color;
  return getColors(color);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref7$size;
  return getTextSize(size);
});

function CalloutText(_ref8) {
  var data = _ref8.data;
  if (!data) return null;
  var _data$lineColor = data.lineColor,
      lineColor = _data$lineColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$lineColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$itemColor = data.itemColor,
      itemColor = _data$itemColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$itemColor,
      _data$itemSize = data.itemSize,
      itemSize = _data$itemSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$itemSize,
      _data$itemFontFamily = data.itemFontFamily,
      itemFontFamily = _data$itemFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$itemFontFamily;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_TEXT tw-flex tw-items-stretch"
  }, /*#__PURE__*/React__default$1["default"].createElement(LineDecoration, {
    className: "CALLOUT_TEXT__DIVIDER tw-w-1 tw-my-2 tw-mr-4 md:tw-mr-10",
    borderColor: colorsVariantsTypes[lineColor || colorsVariantsTypes.PRIMARY]
  }), /*#__PURE__*/React__default$1["default"].createElement("div", null, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, null, /*#__PURE__*/React__default$1["default"].createElement(Title$w, {
    className: "CALLOUT_TEXT__TITLE CalloutText__title bl-text-xl tw-leading-tight tw-mb-6",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.PRIMARY],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(List$1, {
    className: "CALLOUT_TEXT__LIST bl-text-lg"
  }, data.list.map(function (text, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(ListItem, {
      key: "CalloutText-text-".concat(index),
      className: "CALLOUT_TEXT__LIST__ITEM tw-mt-2",
      fontFamily: fontsFamiliesVariantsTypes[itemFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
      color: colorsVariantsTypes[itemColor || colorsVariantsTypes.PRIMARY],
      size: textSizesVariantsTypes[itemSize || textSizesVariantsTypes.VERY_LARGE]
    }, text.item);
  }))));
}

var _templateObject$2N, _templateObject2$1i, _templateObject3$11;

function CalloutMobileAppsGradientsDark$1(_ref) {
  var _data$mobileAppImageA, _data$mobileAppImageA2, _data$mobileAppImageB, _data$mobileAppImageB2;

  var data = _ref.data;
  if (!data || !data.mobileAppImageA && !data.mobileAppImageB) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(GradientContainer$3, {
    className: "CALLOUT_MOBILE_APPS_GRADIENT tw-py-16"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__BOX tw-x-container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-center md:tw-justify-between tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__TITLE tw-border-l-2 tw-pl-6 tw-border-gray-50 tw-w-64 tw-text-center md:tw-text-left"
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__PRIMARY_TEXT"
  }, /*#__PURE__*/React__default$1["default"].createElement(H3$7, {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__H3 CalloutMobileApps__title tw-font-bold bl-text-xl tw-mb-3"
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(P$8, {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__TEXT bl-text-grayscale-100"
  }, data.description)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__MOBILE__ICON__CONTAINER tw-flex tw-w-64 lg:tw-w-72 tw-justify-center tw-my-auto"
  }, ((_data$mobileAppImageA = data.mobileAppImageA) === null || _data$mobileAppImageA === void 0 ? void 0 : _data$mobileAppImageA.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    className: "tw-absolute tw-w-full tw-h-full",
    href: data.mobileAppLinkA,
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "CALLOUT_MOBILE_APPS_GRADIENT__MOBILE__ICON_A tw-w-auto tw-h-6 sm:tw-h-10 tw-object-cover tw-rounded-md",
    src: data.mobileAppImageA.url,
    alt: ((_data$mobileAppImageA2 = data.mobileAppImageA) === null || _data$mobileAppImageA2 === void 0 ? void 0 : _data$mobileAppImageA2.alternativeText) || data.mobileAppImageA.hash
  })), ((_data$mobileAppImageB = data.mobileAppImageB) === null || _data$mobileAppImageB === void 0 ? void 0 : _data$mobileAppImageB.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-relative tw-ml-2 lg:tw-ml-8"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    className: "tw-absolute tw-w-full tw-h-full",
    href: data.mobileAppLinkB,
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: data.mobileAppImageB.url,
    className: "tw-w-auto tw-h-6 sm:tw-h-10 tw-object-cover tw-rounded-md CALLOUT_MOBILE_APPS_GRADIENT__MOBILE__ICON_B",
    alt: ((_data$mobileAppImageB2 = data.mobileAppImageB) === null || _data$mobileAppImageB2 === void 0 ? void 0 : _data$mobileAppImageB2.alternativeText) || data.mobileAppImageB.hash
  })))));
} // Gradient Container


var GradientContainer$3 = styled__default["default"].div(_templateObject$2N || (_templateObject$2N = _taggedTemplateLiteral(["\n  background-image: linear-gradient(to right, var(--primary-100-color), var(--primary-150-color));\n"])));
var H3$7 = styled__default["default"].h3(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteral(["\n  color: var(--grayscale-6-color);\n"])));
var P$8 = styled__default["default"].div(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteral(["\n  color: var(--grayscale-6-color);\n"])));

var _templateObject$2M, _templateObject2$1h;

var Wrapper = styled__default["default"].div(_templateObject$2M || (_templateObject$2M = _taggedTemplateLiteral(["\n  h5 {\n    ", "\n  }\n\n  p {\n    ", "\n  }\n"])), function (_ref) {
  var _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref$titleColor,
      _ref$titleSize = _ref.titleSize,
      titleSize = _ref$titleSize === void 0 ? textSizesVariantsTypes.SMALL : _ref$titleSize,
      _ref$titleFontFamily = _ref.titleFontFamily,
      titleFontFamily = _ref$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$titleFontFamily;
  return "\n      color: ".concat(getColors(colorsVariantsTypes[titleColor]), ";\n      font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[titleFontFamily]), ";\n      font-size: ").concat(getTextSize(textSizesVariantsTypes[titleSize]), "\n    ");
}, function (_ref2) {
  var _ref2$infoColor = _ref2.infoColor,
      infoColor = _ref2$infoColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref2$infoColor,
      _ref2$infoSize = _ref2.infoSize,
      infoSize = _ref2$infoSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref2$infoSize,
      _ref2$infoFontFamily = _ref2.infoFontFamily,
      infoFontFamily = _ref2$infoFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref2$infoFontFamily;
  return "\n      color: ".concat(getColors(colorsVariantsTypes[infoColor]), ";\n      font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[infoFontFamily]), ";\n      font-size: ").concat(getTextSize(textSizesVariantsTypes[infoSize]), "\n    ");
});
var ContactText = styled__default["default"].p(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$contactColor = _ref3.contactColor,
      contactColor = _ref3$contactColor === void 0 ? colorsVariantsTypes.LIGHT : _ref3$contactColor,
      _ref3$contactSize = _ref3.contactSize,
      contactSize = _ref3$contactSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref3$contactSize,
      _ref3$contactFontFami = _ref3.contactFontFamily,
      contactFontFamily = _ref3$contactFontFami === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$contactFontFami;
  return "\n      color: ".concat(getColors(colorsVariantsTypes[contactColor]), ";\n      font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[contactFontFamily]), ";\n      font-size: ").concat(getTextSize(textSizesVariantsTypes[contactSize]), "\n    ");
});

function ContactSimple(_ref4) {
  var title = _ref4.title,
      info = _ref4.info,
      contact = _ref4.contact,
      _ref4$contactSimpleSt = _ref4.contactSimpleStyles,
      contactSimpleStyles = _ref4$contactSimpleSt === void 0 ? {} : _ref4$contactSimpleSt,
      contactSimpleTitleSize = _ref4.contactSimpleTitleSize,
      contactSimpleTitleFontFamily = _ref4.contactSimpleTitleFontFamily,
      contactSimpleTitleColor = _ref4.contactSimpleTitleColor,
      contactSimpleInfoSize = _ref4.contactSimpleInfoSize,
      contactSimpleInfoFontFamily = _ref4.contactSimpleInfoFontFamily,
      contactSimpleInfoColor = _ref4.contactSimpleInfoColor,
      contactSimpleContactSize = _ref4.contactSimpleContactSize,
      contactSimpleContactFontFamily = _ref4.contactSimpleContactFontFamily,
      contactSimpleContactColor = _ref4.contactSimpleContactColor;
  return /*#__PURE__*/React__default$1["default"].createElement(Wrapper, _extends$g({}, contactSimpleStyles, {
    titleSize: contactSimpleTitleSize,
    titleFontFamily: contactSimpleTitleFontFamily,
    titleColor: contactSimpleTitleColor,
    infoSize: contactSimpleInfoSize,
    infoFontFamily: contactSimpleInfoFontFamily,
    infoColor: contactSimpleInfoColor
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_SIMPLE tw-mt-6"
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, null, /*#__PURE__*/React__default$1["default"].createElement("h5", {
    className: "CONTACT_SIMPLE__TITLE tw-mb-6 ContactSimple__title tw-leading-none tw-font-bold"
  }, title)), /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "CONTACT_SIMPLE__TEXT tw-my-1 tw-leading-none tw-font-medium bl-text-xs bl-text-grayscale-50 tw-italic"
  }, info), /*#__PURE__*/React__default$1["default"].createElement(ContactText, {
    last: {
      color: "var(--primary-180-color)"
    },
    className: "CONTACT_SIMPLE__CONTACT_TEXT tw-leading-4 tw-whitespace-pre-line",
    contactSize: contactSimpleContactSize,
    contactFontFamily: contactSimpleContactFontFamily,
    contactColor: contactSimpleContactColor
  }, contact)));
}

var _templateObject$2L;

var BackgroundStyleSelector = function BackgroundStyleSelector(_ref) {
  var _ref$gradientType = _ref.gradientType,
      gradientType = _ref$gradientType === void 0 ? "solid gray" : _ref$gradientType,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? "" : _ref$image,
      _ref$cssBackgroundGra = _ref.cssBackgroundGradient,
      cssBackgroundGradient = _ref$cssBackgroundGra === void 0 ? "" : _ref$cssBackgroundGra,
      _ref$noGradient = _ref.noGradient,
      noGradient = _ref$noGradient === void 0 ? false : _ref$noGradient,
      _ref$gradient = _ref.gradient,
      gradient = _ref$gradient === void 0 ? "" : _ref$gradient;

  if (cssBackgroundGradient) {
    return "".concat(cssBackgroundGradient, ", url(").concat(image, ")");
  }

  if (gradientType === "Left") {
    if (!noGradient) {
      var defaultGradient = "linear-gradient(to left, rgba(255, 255, 255, 0) 21%, rgba(255, 255, 255, 0.9) 73%)";
      return "".concat(gradient || defaultGradient, "\n       ").concat(image ? ", url(\"".concat(image, "\")") : "");
    }

    if (image) return "url(\"".concat(image, "\")");
    return "";
  }

  if (gradientType === "solid gray") {
    if (!noGradient) {
      var _defaultGradient = "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%)";
      return "".concat(gradient || _defaultGradient).concat(image ? ", url(\"".concat(image, "\")") : "");
    }

    if (image) return "url(\"".concat(image, "\")");
    return "";
  }

  if (gradientType === "BackgroundImageColor") {
    if (!noGradient) {
      var _defaultGradient2 = "linear-gradient(180deg, var(--primary-150-color) 0%, rgba(0,0,0, 0.05) 200%)";
      return "".concat(gradient || _defaultGradient2).concat(image ? ", url(\"".concat(image, "\")") : "");
    }

    if (image) return "url(\"".concat(image, "\")");
    return "";
  }

  if (!noGradient) {
    var _defaultGradient3 = "radial-gradient(\n      circle at 50% 71%,\n      ".concat(colorsTypes.BLACK, ",\n      rgba(255, 255, 255, 0) 25%),\n      radial-gradient(circle at 50% 14%, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.93) 85%),\n      linear-gradient(\n        to bottom,\n        rgba(255, 255, 255, 0) 29%,\n        rgba(255, 255, 255, 0.11) 53%,\n        rgba(255, 255, 255, 0.98) 96%,\n        ").concat(colorsTypes.BLACK, " 96%\n      )");

    return "".concat(gradient || _defaultGradient3).concat(image ? ", url(\"".concat(image, "\")") : "");
  }

  if (image) return "url(\"".concat(image, "\")");
  return "";
};

var ContainerGradient$1 = styled__default["default"].div(_templateObject$2L || (_templateObject$2L = _taggedTemplateLiteral(["\n  background-color: #000;\n  background-image: ", ";\n  opacity: 0.9;\n  background-position: center top;\n  background-repeat: no-repeat;\n  background-size: cover;\n"])), BackgroundStyleSelector);

var changedArray = function changedArray(a, b) {
  if (a === void 0) {
    a = [];
  }

  if (b === void 0) {
    b = [];
  }

  return a.length !== b.length || a.some(function (item, index) {
    return !Object.is(item, b[index]);
  });
};

var initialState = {
  error: null
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$4(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.state = initialState;

    _this.resetErrorBoundary = function () {
      var _this$props;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

      _this.reset();
    };

    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      error: error
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.reset = function reset() {
    this.setState(initialState);
  };

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;

    (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var error = this.state.error;
    var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
    // happens to *also* be in the resetKeys array, we'd end up resetting
    // the error boundary immediately. This would likely trigger a second
    // error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call
    // of cDU after the error is set

    if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
      var _this$props$onResetKe, _this$props3;

      (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
      this.reset();
    }
  };

  _proto.render = function render() {
    var error = this.state.error;
    var _this$props4 = this.props,
        fallbackRender = _this$props4.fallbackRender,
        FallbackComponent = _this$props4.FallbackComponent,
        fallback = _this$props4.fallback;

    if (error !== null) {
      var _props = {
        error: error,
        resetErrorBoundary: this.resetErrorBoundary
      };

      if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
        return fallback;
      } else if (typeof fallbackRender === 'function') {
        return fallbackRender(_props);
      } else if (FallbackComponent) {
        return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
      } else {
        throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
      }
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(React__namespace.Component);

function withErrorBoundary$1(Component, errorBoundaryProps) {
  var Wrapped = function Wrapped(props) {
    return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
  }; // Format for display in DevTools


  var name = Component.displayName || Component.name || 'Unknown';
  Wrapped.displayName = "withErrorBoundary(" + name + ")";
  return Wrapped;
}
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$2 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$2(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function withErrorBoundary(Component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      FallbackComponent = _ref.FallbackComponent;

  var WithErrorBoundaryBuilder = function WithErrorBoundaryBuilder(props) {
    var ComponentWithBoundary = withErrorBoundary$1(Component, {
      FallbackComponent: FallbackComponent || DefaultFallbackComponent,
      onError: function onError() {}
    });
    return /*#__PURE__*/React__default$1["default"].createElement(ComponentWithBoundary, props);
  };

  WithErrorBoundaryBuilder.displayName = "withErrorBoundary(".concat(Component.displayName || Component.name, ")");
  return hoistNonReactStatics_cjs(WithErrorBoundaryBuilder, Component);
}

var _templateObject$2K;

function ContentBox(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React__default$1["default"].createElement("section", {
    className: "CONTENT_BOX"
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CONTENT_BOX__TITLE"
  }, /*#__PURE__*/React__default$1["default"].createElement("h3", {
    className: "CONTENT_BOX__TITLE__TEXT bl-font-medium bl-text-grayscale bl-text-xl tw-my-8"
  }, title)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTENT_BOX__DIVIDER bl-text-grayscale bl-text-lg"
  }, children));
}

var ContentBox$1 = styled__default["default"](withErrorBoundary(ContentBox))(_templateObject$2K || (_templateObject$2K = _taggedTemplateLiteral(["\n  h3 {\n    color: var(--grayscale-0-color);\n  }\n"])));

var _templateObject$2J;

var FeatureV2Image = styled__default["default"].img(_templateObject$2J || (_templateObject$2J = _taggedTemplateLiteral(["\n  height: 343px;\n  width: 343px;\n\n  @media (min-width: ", ") {\n    height: 400px;\n    width: 400px;\n  }\n"])), function (props) {
  return "".concat(props.theme.breakpoints.md, "px");
});

var _templateObject$2I;

var FeatureV4Image = styled__default["default"].img(_templateObject$2I || (_templateObject$2I = _taggedTemplateLiteral(["\n  ", "\n  min-height: 100%;\n  height: auto;\n  width: 50%;\n  min-width: 50%;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--primary-color);\n    opacity: 0.2;\n    z-index: -1;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n  }\n"])), function (_ref) {
  var padding = _ref.padding,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? null : _ref$borderRadius;
  return "\n  padding: ".concat(padding || null, ";\n  border-radius: ").concat(borderRadius, ";\n");
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.breakpoints.lg, "px");
});

var _templateObject$2H;

var GradientWithoutImageContainer = styled__default["default"].div(_templateObject$2H || (_templateObject$2H = _taggedTemplateLiteral(["\n  background-color: #000;\n  background: ", ";\n  opacity: ", ";\n"])), function (_ref) {
  var _ref$gradient = _ref.gradient,
      gradient = _ref$gradient === void 0 ? "" : _ref$gradient,
      _ref$radial = _ref.radial,
      radial = _ref$radial === void 0 ? false : _ref$radial,
      _ref$ultraLight = _ref.ultraLight,
      ultraLight = _ref$ultraLight === void 0 ? false : _ref$ultraLight,
      _ref$noGradient = _ref.noGradient,
      noGradient = _ref$noGradient === void 0 ? false : _ref$noGradient,
      _ref$angle = _ref.angle,
      angle = _ref$angle === void 0 ? "180deg" : _ref$angle,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? -16.8 : _ref$divider,
      _ref$from = _ref.from,
      from = _ref$from === void 0 ? "91.25% 91.25% at" : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? "50% 50%" : _ref$to,
      _ref$linearUltraLight = _ref.linearUltraLightFirstColor,
      linearUltraLightFirstColor = _ref$linearUltraLight === void 0 ? colorsTypes.PRIMARY_ULTRA_LIGHT : _ref$linearUltraLight,
      _ref$linearUltraLight2 = _ref.linearUltraLightSecondColor,
      linearUltraLightSecondColor = _ref$linearUltraLight2 === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$linearUltraLight2,
      _ref$linearLightFirst = _ref.linearLightFirstColor,
      linearLightFirstColor = _ref$linearLightFirst === void 0 ? colorsTypes.PRIMARY : _ref$linearLightFirst,
      _ref$linearLightSecon = _ref.linearLightSecondColor,
      linearLightSecondColor = _ref$linearLightSecon === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$linearLightSecon,
      _ref$radialUltraLight = _ref.radialUltraLightFirstColor,
      radialUltraLightFirstColor = _ref$radialUltraLight === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$radialUltraLight,
      _ref$radialUltraLight2 = _ref.radialUltraLightSecondColor,
      radialUltraLightSecondColor = _ref$radialUltraLight2 === void 0 ? colorsTypes.PRIMARY_ULTRA_LIGHT : _ref$radialUltraLight2,
      _ref$radialLightFirst = _ref.radialLightFirstColor,
      radialLightFirstColor = _ref$radialLightFirst === void 0 ? colorsTypes.PRIMARY_ULTRA_LIGHT : _ref$radialLightFirst,
      _ref$radialLightSecon = _ref.radialLightSecondColor,
      radialLightSecondColor = _ref$radialLightSecon === void 0 ? colorsTypes.PRIMARY : _ref$radialLightSecon;
  if (noGradient) return undefined;
  if (gradient) return gradient;

  if (radial) {
    if (ultraLight) {
      return "radial-gradient(".concat(from, " ").concat(to, " , ").concat(radialUltraLightFirstColor, " 0%, ").concat(radialUltraLightSecondColor, " 100%)");
    }

    return "radial-gradient(".concat(from, " ").concat(to, " , ").concat(radialLightFirstColor, " 0%, ").concat(radialLightSecondColor, " 100%)");
  }

  if (ultraLight) {
    return "linear-gradient(".concat(angle, ", ").concat(linearUltraLightFirstColor, " ").concat(divider, "%, ").concat(linearUltraLightSecondColor, " 110.7%)");
  }

  return "linear-gradient(".concat(angle, ", ").concat(linearLightFirstColor, " ").concat(divider, "%, ").concat(linearLightSecondColor, " 110.7%)");
}, function (_ref2) {
  var _ref2$withoutOpacity = _ref2.withoutOpacity,
      withoutOpacity = _ref2$withoutOpacity === void 0 ? false : _ref2$withoutOpacity;
  return withoutOpacity ? undefined : 0.3;
});

var _templateObject$2G;

function H3$5(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default$1["default"].createElement("h3", {
    className: "H3 bl-grey-600 tw-weight-900 bl-text-5xl ".concat(className)
  }, children);
}

var H3$6 = styled__default["default"](H3$5)(_templateObject$2G || (_templateObject$2G = _taggedTemplateLiteral(["\n  color: var(--bl-color-grayscale-6);\n"])));

function HeroCard(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "tw-items-end" : _ref$className;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("HERO_CARD tw-mx-w tw-mx-h tw-relative tw-flex tw-justify-center sm:tw-justify-start tw-pb-10", className)
  }, children);
}

function HorizontalDivider(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default$1["default"].createElement("hr", {
    className: classnames("HORIZONTAL_DIVIDER tw-border-0 tw-h-px", className)
  });
}

var _excluded$1i = ["icon", "size", "className", "customIconsAlt"];

var _templateObject$2F;

var IconImg = styled__default["default"].img(_templateObject$2F || (_templateObject$2F = _taggedTemplateLiteral(["\n  filter: ", ";\n\n  @media all and (max-width: ", "px) {\n    filter: ", ";\n  }\n"])), function (_ref) {
  var _ref$isScrollChangeCo = _ref.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref$isScrollChangeCo === void 0 ? false : _ref$isScrollChangeCo,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$menuActive = _ref.menuActive,
      menuActive = _ref$menuActive === void 0 ? false : _ref$menuActive,
      _ref$noFilter = _ref.noFilter,
      noFilter = _ref$noFilter === void 0 ? false : _ref$noFilter,
      _ref$forceFilter = _ref.forceFilter,
      forceFilter = _ref$forceFilter === void 0 ? false : _ref$forceFilter,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$filterEffect = _ref.filterEffect,
      filterEffect = _ref$filterEffect === void 0 ? [] : _ref$filterEffect,
      _ref$filterEffectAfte = _ref.filterEffectAfterScroll,
      filterEffectAfterScroll = _ref$filterEffectAfte === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$filterEffectAfte,
      _ref$activeFilterEffe = _ref.activeFilterEffectAfterScroll,
      activeFilterEffectAfterScroll = _ref$activeFilterEffe === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$activeFilterEffe;

  if (noFilter) return "none";

  if (!!_float && scrollY >= backgroundBreakpoint && isScrollChangeColorButton || forceFilter || menuActive) {
    if (menuActive) return activeFilterEffectAfterScroll.join(" ");
    return filterEffectAfterScroll.join(" ");
  }

  return filterEffect.join(" ");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (_ref3) {
  var _ref3$isScrollChangeC = _ref3.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref3$isScrollChangeC === void 0 ? false : _ref3$isScrollChangeC,
      _ref3$float = _ref3["float"],
      _float2 = _ref3$float === void 0 ? false : _ref3$float,
      _ref3$menuActive = _ref3.menuActive,
      menuActive = _ref3$menuActive === void 0 ? false : _ref3$menuActive,
      _ref3$noFilter = _ref3.noFilter,
      noFilter = _ref3$noFilter === void 0 ? false : _ref3$noFilter,
      _ref3$forceFilter = _ref3.forceFilter,
      forceFilter = _ref3$forceFilter === void 0 ? false : _ref3$forceFilter,
      _ref3$scrollY = _ref3.scrollY,
      scrollY = _ref3$scrollY === void 0 ? 0 : _ref3$scrollY,
      _ref3$backgroundBreak = _ref3.backgroundBreakpoint,
      backgroundBreakpoint = _ref3$backgroundBreak === void 0 ? 20 : _ref3$backgroundBreak,
      _ref3$mobileFilterEff = _ref3.mobileFilterEffect,
      mobileFilterEffect = _ref3$mobileFilterEff === void 0 ? [] : _ref3$mobileFilterEff,
      _ref3$mobileFilterEff2 = _ref3.mobileFilterEffectAfterScroll,
      mobileFilterEffectAfterScroll = _ref3$mobileFilterEff2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref3$mobileFilterEff2,
      _ref3$mobileActiveFil = _ref3.mobileActiveFilterEffectAfterScroll,
      mobileActiveFilterEffectAfterScroll = _ref3$mobileActiveFil === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref3$mobileActiveFil;

  if (noFilter) return "none";

  if (!!_float2 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton || forceFilter || menuActive) {
    if (menuActive) return mobileActiveFilterEffectAfterScroll.join(" ");
    return mobileFilterEffectAfterScroll.join(" ");
  }

  return mobileFilterEffect.join(" ");
}); // function iconToLowerCase(icon) {
//   if (typeof icon === "string" && icon.length > 1) {
//     const newIconString = icon.replace(/\s+/g, "-");
//     return `${newIconString.toLowerCase()} icon`;
//   }
//   return "icon";
// }

function Icon(_ref4) {
  var _ref4$icon = _ref4.icon,
      icon = _ref4$icon === void 0 ? iconTypes.NONE : _ref4$icon,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 24 : _ref4$size,
      className = _ref4.className,
      customIconsAlt = _ref4.customIconsAlt,
      otherProps = _objectWithoutProperties$1(_ref4, _excluded$1i);

  return /*#__PURE__*/React__default$1["default"].createElement(IconImg, _extends$g({
    src: iconVariantsTypes[icon],
    width: size,
    alt: "".concat(customIconsAlt || ""),
    className: classnames("ICON tw-inline-block", className)
  }, otherProps));
}

var _templateObject$2E, _templateObject2$1g;

var VerticalDividerContainer = styled__default["default"].div(_templateObject$2E || (_templateObject$2E = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: ", ";\n"])), function (_ref) {
  var _ref$verticalSpacing = _ref.verticalSpacing,
      verticalSpacing = _ref$verticalSpacing === void 0 ? "0px" : _ref$verticalSpacing;
  return verticalSpacing;
});
var LineDivider$6 = styled__default["default"].div(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteral(["\n  height: 2px;\n  background: ", ";\n"])), function (_ref2) {
  var _ref2$lineDivider = _ref2.lineDivider,
      lineDivider = _ref2$lineDivider === void 0 ? false : _ref2$lineDivider;

  if (lineDivider) {
    return colorsTypes.HIGHT_LIGHT_PRIMARY;
  }

  return "transparent";
});

function DividerDynamicComponent(_ref3) {
  var _ref3$applyMaxWidthCo = _ref3.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref3$applyMaxWidthCo === void 0 ? false : _ref3$applyMaxWidthCo,
      _ref3$data = _ref3.data,
      data = _ref3$data === void 0 ? {} : _ref3$data;
  var _data$lineDivider = data.lineDivider,
      lineDivider = _data$lineDivider === void 0 ? false : _data$lineDivider,
      _data$verticalSpacing = data.verticalSpacing,
      verticalSpacing = _data$verticalSpacing === void 0 ? "0px" : _data$verticalSpacing;
  return /*#__PURE__*/React__default$1["default"].createElement(VerticalDividerContainer, {
    className: classnames("VERTICAL_DIVIDER_CONTAINER", lineDivider && "VERTICAL_DIVIDER_CONTAINER_ACTIVE"),
    verticalSpacing: verticalSpacing
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("LINE_DIVIDER__CONTAINER tw-x-container", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement(LineDivider$6, {
    className: classnames("LINE_DIVIDER ", lineDivider ? "LINE_DIVIDER__ON" : "LINE_DIVIDER__OFF"),
    lineDivider: lineDivider
  })));
}

function Iframe$1(_ref) {
  var data = _ref.data,
      _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("IFRAME tw-w-full tw-x-container tw-flex sm:tw-justify-center", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-w-full tw-h-full IFRAME_CONTAINER tw-overflow-x-auto",
    dangerouslySetInnerHTML: {
      __html: data.insertIframe
    }
  }));
}

var _templateObject$2D;

function Links$1(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "LINKS_LIST bl-text-md tw-mt-4"
  }, links.map(function (item, index) {
    return /*#__PURE__*/React__default$1["default"].createElement("li", {
      key: "Links-item-".concat(index),
      className: "LINK_CONTAINER tw-py-2"
    }, /*#__PURE__*/React__default$1["default"].createElement("a", {
      href: item.url,
      className: "LINK_TEXT"
    }, item.item));
  }));
}

var Links$2 = styled__default["default"](Links$1)(_templateObject$2D || (_templateObject$2D = _taggedTemplateLiteral(["\n  a {\n    color: var(--primary-color);\n  }\n"])));

function List(_ref) {
  var list = _ref.list,
      variant = _ref.variant;
  var listStyles = getListStyles(variant);
  return /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "LIST bl-text-md"
  }, list.map(function (item, index) {
    var text = item.item || item.text;
    return /*#__PURE__*/React__default$1["default"].createElement("li", {
      key: "List-item-".concat(index),
      className: classnames("LIST__ITEM tw-py-2", listStyles)
    }, text);
  }));
}

var _templateObject$2C;

var MediaQuery = styled.css(_templateObject$2C || (_templateObject$2C = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 var(--padding-default);\n\n  @media (min-width: ", "px) {\n    max-width: ", "px;\n    padding: 0 var(--padding-sm);\n  }\n  @media (min-width: ", "px) {\n    max-width: ", "px;\n    padding: 0px var(--padding-lg);\n  }\n  @media (min-width: ", "px) {\n    max-width: ", "px;\n    padding: 0px var(--padding-lg);\n  }\n  @media (min-width: ", "px) {\n    max-width: ", "px;\n    padding: 0px var(--padding-xl);\n  }\n"])), breakpoints.sm, breakpoints.sm, breakpoints.md, breakpoints.md, breakpoints.lg, breakpoints.lg, breakpoints.xl, breakpoints.xl);

var _templateObject$2B;

var ScrollStyle = styled.css(_templateObject$2B || (_templateObject$2B = _taggedTemplateLiteral(["\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 12px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: rgb(0, 0, 0, 0.05);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: rgb(0, 0, 0, 0.15);\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: rgb(0, 0, 0, 0.25);\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background-color: rgb(0, 0, 0, 0.35);\n  }\n"])));

var _templateObject$2A, _templateObject2$1f;

var Container$l = styled__default["default"].div(_templateObject$2A || (_templateObject$2A = _taggedTemplateLiteral(["\n  background: var(--grayscale-0-color);\n  overflow-y: auto;\n\n  ", "\n"])), ScrollStyle);
var Line = styled__default["default"].div(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteral(["\n  background: var(--grayscale-100-color);\n"])));

function Modal(_ref) {
  var show = _ref.show,
      closeModal = _ref.closeModal,
      children = _ref.children,
      borderWithRadius = _ref.borderWithRadius;
  var backdropRef = React.useRef(null);
  React.useEffect(function () {
    var mounted = true;
    if (mounted) screenOverflowHidden(show);
    return function cleanup() {
      mounted = false;
    };
  }, [show]);

  function handleBackdropClick(event) {
    if (backdropRef && backdropRef.current === event.target) {
      closeModal();
    }
  }

  if (!show) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MODAL tw-flex tw-justify-center tw-items-center tw-fixed tw-inset-0 tw-z-50 tw-p-6",
    role: "button",
    onClick: handleBackdropClick,
    onKeyPress: handleBackdropClick,
    tabIndex: 0,
    ref: backdropRef
  }, /*#__PURE__*/React__default$1["default"].createElement(Container$l, {
    className: classnames("MODAL__CONTAINER tw-mx-auto tw-shadow-lg tw-relative bl-bg-grayscale-0 tw-cursor-default tw-max-w-full tw-relative tw-max-h-full md:tw-h-auto tw-overscroll-y-contain", borderWithRadius && " tw-rounded-lg")
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "MODAL__BUTTON tw-absolute tw-top-11 tw-right-8 hover:tw-opacity-75",
    onClick: function onClick() {
      return closeModal();
    }
  }, /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    icon: iconTypes.REMOVE
  })), children)), /*#__PURE__*/React__default$1["default"].createElement(Line, {
    className: "MODAL__LINE tw-opacity-25 tw-fixed tw-inset-0 tw-z-40 bl-bg-grayscale-100"
  }));
}

function Error$1(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "ERROR_CONTAINER bl-bg-grayscale-6 tw-min-h-screen tw-flex tw-flex-col tw-justify-center tw-p-4"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "ERROR_CONTAINER_BOX tw-p-4 tw-max-w-md tw-mx-auto bl-bg-grayscale-0 tw-shadow-lg tw-text-center tw-rounded-lg"
  }, /*#__PURE__*/React__default$1["default"].createElement("h1", {
    className: "ERROR_TITLE bl-text-2xl tw-font-bold tw-mb-6"
  }, title), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "ERROR_CONTENT"
  }, children || /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("span", {
    className: "ERROR_DESCRIPTION"
  }, "We could not find the page you are looking for."), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "ERROR_GO_BACK_CONTAINER"
  }, "Go back to our home page by", " ", /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "ERROR_GO_BACK_BUTTON tw-font-bold tw-underline",
    onClick: function onClick() {
      window.location.href = "/";
    }
  }, "clicking here"))))));
}

function Message404() {
  return /*#__PURE__*/React__default$1["default"].createElement(Error$1, {
    title: "Oops, could not find the page"
  });
}

var _templateObject$2z, _templateObject2$1e, _templateObject3$10;

var First = styled__default["default"].p(_templateObject$2z || (_templateObject$2z = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsVariantsTypes.BLACK : _ref$color,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref$size;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[textSizesVariantsTypes[size]]), ";\n    font-weight: 500;\n  ");
});
var Second = styled__default["default"].p(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.BLACK : _ref2$color,
      _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref2$fontFamily,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? textSizesVariantsTypes.SMALL : _ref2$size;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[textSizesVariantsTypes[size]]), ";\n  ");
});
var Third = styled__default["default"].p(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.SEMI_DARK : _ref3$color,
      _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref3$size;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[textSizesVariantsTypes[size]]), ";\n  ");
});

function OfficeHourBox(_ref4) {
  var days = _ref4.days,
      hours = _ref4.hours,
      info = _ref4.info,
      _ref4$officeHourBoxSt = _ref4.officeHourBoxStyles,
      officeHourBoxStyles = _ref4$officeHourBoxSt === void 0 ? {} : _ref4$officeHourBoxSt,
      daysSize = _ref4.daysSize,
      daysFontFamily = _ref4.daysFontFamily,
      daysColor = _ref4.daysColor,
      hoursSize = _ref4.hoursSize,
      hoursFontFamily = _ref4.hoursFontFamily,
      hoursColor = _ref4.hoursColor,
      infoSize = _ref4.infoSize,
      infoFontFamily = _ref4.infoFontFamily,
      infoColor = _ref4.infoColor;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "OFFICE_HOUR_BOX tw-w-48 tw-mb-5"
  }, /*#__PURE__*/React__default$1["default"].createElement(First, _extends$g({}, officeHourBoxStyles.first, {
    className: "OFFICE_HOUR_BOX__FIRST",
    size: daysSize,
    fontFamily: daysFontFamily,
    color: daysColor
  }), days), /*#__PURE__*/React__default$1["default"].createElement(Second, _extends$g({}, officeHourBoxStyles.second, {
    className: "OFFICE_HOUR_BOX__SECOND tw-leading-none",
    size: hoursSize,
    fontFamily: hoursFontFamily,
    color: hoursColor
  }), hours), /*#__PURE__*/React__default$1["default"].createElement(Third, _extends$g({}, officeHourBoxStyles.third, {
    className: "OFFICE_HOUR_BOX__THIRD tw-mt-1 tw-leading-none tw-italic",
    size: infoSize,
    fontFamily: infoFontFamily,
    color: infoColor
  }), info));
}

function PageHeaderGradient(_ref) {
  var color = _ref.color,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  var _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PAGE_HEADER_GRADIENT tw-relative tw-pb-6"
  }, !lodash.isEmpty(data.image) && /*#__PURE__*/React__default$1["default"].createElement(ContainerGradient$1, {
    className: "PAGE_HEADER_GRADIENT__CONTAINER tw-h-96",
    image: data.image.url
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PAGE_HEADER_GRADIENT__TEXT__CONTAINER tw-absolute tw-w-full tw-bottom-0 tw-mb-20"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$v, {
    className: "PAGE_HEADER_GRADIENT__TITLE",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.HEADER_6,
    color: color
  }, data.title), data.subtitle && data.subtitle.length > 0 && /*#__PURE__*/React__default$1["default"].createElement(PageHeaderSubTitle, {
    className: "PAGE_HEADER_GRADIENT__SUBTITLE",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: descriptionSize || textSizesVariantsTypes.VERY_BIG
  }, data.subtitle)));
}

var _templateObject$2y;

var PageHeaderGradientContainer = styled__default["default"].div(_templateObject$2y || (_templateObject$2y = _taggedTemplateLiteral(["\n  background-image: linear-gradient(\n      to bottom,\n      rgba(255, 255, 255, 0) 6%,\n      var(--grayscale-0-color) 95%\n    ),\n    linear-gradient(to bottom, var(--primary-color), var(--primary-color));\n  opacity: 0.06;\n"])));

function PageHeaderGradients(_ref) {
  var color = _ref.color,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  var _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PAGE_HEADER_GRADIENTS tw-relative tw-h-80 lg:tw-h-56"
  }, /*#__PURE__*/React__default$1["default"].createElement(PageHeaderGradientContainer, {
    className: "PAGE_HEADER_GRADIENTS__CONTAINER tw-h-80 lg:tw-h-56"
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PAGE_HEADER_GRADIENTS__TITLE__CONTAINER tw-absolute tw-w-full tw-bottom-0 tw-py-6"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$v, {
    className: "PAGE_HEADER_GRADIENTS__TITLE",
    color: color,
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.HEADER_6
  }, data.title || "")));
}

var _templateObject$2x;

var H3$4 = styled__default["default"].h3(_templateObject$2x || (_templateObject$2x = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  font-size: ", ";\n\n  color: ", ";\n\n  @media (min-width: 768px) {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref2$size;
  return getTextSize(size);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "" : _ref3$color;
  return color === pageHeaderColorVariantsTypes.PRIMARY ? getColors(colorsVariantsTypes.PRIMARY) : getColors(colorsVariantsTypes.LIGHT);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(textSizesVariantsTypes[size]);
});

function PageHeaderSubTitle(_ref5) {
  var children = _ref5.children,
      fontFamily = _ref5.fontFamily,
      size = _ref5.size,
      _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? pageHeaderColorVariantsTypes.PRIMARY : _ref5$color;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PAGE_HEADER__SUBTITLE tw-container page-header-subtitle-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(H3$4, {
    color: color,
    fontFamily: fontFamily,
    size: size,
    className: "PAGE_HEADER__SUBTITLE__TEXT page-header-subtitle-h3 tw-leading-tight md:tw-leading-normal"
  }, children));
}

var _templateObject$2w;

var H1$2 = styled__default["default"].h1(_templateObject$2w || (_templateObject$2w = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  font-size: ", ";\n\n  color: ", ";\n\n  @media (min-width: 768px) {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? textSizesVariantsTypes.HEADER_5 : _ref2$size;
  return getTextSize(size);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "" : _ref3$color;
  return color === pageHeaderColorVariantsTypes.PRIMARY ? getColors(colorsVariantsTypes.PRIMARY) : getColors(colorsVariantsTypes.WHITE);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref4$size;
  return getTextSize(textSizesVariantsTypes[size]);
});

function Title$v(_ref5) {
  var children = _ref5.children,
      _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? pageHeaderColorVariantsTypes.PRIMARY : _ref5$color,
      fontFamily = _ref5.fontFamily,
      size = _ref5.size;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PAGE_HEADER__TITLE tw-container page-header-title-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(H1$2, {
    color: color,
    fontFamily: fontFamily,
    size: size,
    className: "PAGE_HEADER__TITLE__TEXT bl-font-secondary tw-font-bold tw-leading-tight page-header-title-h1"
  }, children));
}

var _templateObject$2v, _templateObject2$1d;

var Container$k = styled__default["default"].div(_templateObject$2v || (_templateObject$2v = _taggedTemplateLiteral(["\n  background: var(--primary-color);\n"])));
var Content$a = styled__default["default"].div(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteral(["\n  background: var(--primary-180-color);\n"])));

function Place() {
  return /*#__PURE__*/React__default$1["default"].createElement(Container$k, {
    style: {
      transform: "translate(-50%, -50%)"
    },
    className: "PLACE place-container tw-w-12 tw-h-12 tw-rounded-full bl-bg-primary-50 tw-flex tw-items-center tw-justify-center tw-opacity-75"
  }, /*#__PURE__*/React__default$1["default"].createElement(Content$a, {
    className: "PLACE__CONTENT palce-content tw-w-4 tw-h-4 tw-rounded-full bl-bg-primary"
  }));
}

var _templateObject$2u;

var RichTextContainer = styled__default["default"].div(_templateObject$2u || (_templateObject$2u = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n\n  background-color: ", ";\n\n  figure {\n    width: 100%;\n    overflow-x: auto;\n    float: none;\n\n    ", "\n  }\n  div {\n    scroll-margin-top: 100px;\n  }\n  a {\n    color: hsl(210, 75%, 60%);\n  }\n\n  h1 {\n    font-size: 42px;\n  }\n\n  h2 {\n    font-size: 26px;\n  }\n\n  h3 {\n    font-size: 20px;\n  }\n\n  h4 {\n    font-size: 16px;\n  }\n\n  p {\n    font-size: 22px;\n  }\n\n  ol {\n    display: block;\n    list-style-type: decimal;\n    padding: 0 0 0 20px;\n  }\n\n  ul {\n    display: block;\n    list-style-type: disc;\n    padding: 0 0 0 20px;\n\n    &,\n    .todo-list {\n      /* list-style: none; */\n\n      span {\n        vertical-align: top;\n        margin-left: 0.4rem;\n      }\n\n      input {\n        &:disabled {\n          -webkit-appearance: none;\n          background-color: var(--grayscale-0-color);\n          border: 1px solid var(--grayscale-30-color);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);\n          padding: 9px;\n          border-radius: 3px;\n          display: inline-block;\n          position: relative;\n        }\n\n        &:checked {\n          background-color: #008d1398;\n          border: 1px solid var(--grayscale-30-color);\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),\n            inset 15px 10px -12px rgba(255, 255, 255, 0.1);\n          color: var(--grayscale-0-color);\n        }\n\n        &:checked:after {\n          content: \"\u2714\";\n          font-size: 14px;\n          position: absolute;\n          top: 0px;\n          left: 3px;\n          color: white;\n        }\n      }\n    }\n  }\n\n  table {\n    width: 100%;\n\n    p {\n      text-align: left;\n      padding: 0;\n    }\n\n    ul {\n      display: block;\n      list-style-type: disc;\n      padding: 0 0 0 20px;\n    }\n\n    td,\n    th {\n      min-width: 275px;\n      padding: 20px 20px 20px 0;\n      text-align: left;\n\n      @media (min-width: 768px) {\n        min-width: auto;\n      }\n    }\n\n    thead {\n      color: var(--bl-color-primary-110);\n      font-weight: bold;\n      border-bottom: 3px solid var(--bl-color-primary-110);\n    }\n  }\n\n  blockquote {\n    quotes: \"\u201C\" \"\u201D\" \"\u2018\" \"\u2019\";\n\n    p {\n      font-style: italic;\n      background: var(--grayscale-6-color);\n      border-left: 10px solid var(--grayscale-20-color);\n      padding-left: 20px;\n    }\n  }\n"])), function (_ref) {
  var _ref$tags = _ref.tags,
      tags = _ref$tags === void 0 ? [".custom-container"] : _ref$tags;
  return tags.join(",");
}, MediaQuery, function (_ref2) {
  var _ref2$backgroundConta = _ref2.backgroundContainer,
      backgroundContainer = _ref2$backgroundConta === void 0 ? colorsTypes.TRANSPARENT : _ref2$backgroundConta;
  return backgroundContainer;
}, ScrollStyle);

var _templateObject$2t, _templateObject2$1c, _templateObject3$$, _templateObject4$K, _templateObject5$D, _templateObject6$s, _templateObject7$g, _templateObject8$c, _templateObject9$6, _templateObject10$3, _templateObject11$3, _templateObject12$3;

var BackgroundContainer = styled__default["default"].div(_templateObject$2t || (_templateObject$2t = _taggedTemplateLiteral(["\n  width: 100%;\n  background: ", ";\n\n  @media only screen and (max-width: ", "px) {\n    margin-bottom: 24px;\n  }\n"])), function (_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.VERY_ULTRA_LIGHT : _ref$background;
  return background;
}, breakpoints.sm - 1);
var Container$j = styled__default["default"].div(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteral([""])));
var ItemContainer$1 = styled__default["default"].div(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 36px 0px;\n\n  @media only screen and (max-width: ", "px) {\n    padding: 52px 0px;\n  }\n"])), breakpoints.sm - 1);
var LeftContainer = styled__default["default"].div(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteral(["\n  width: 48%;\n  @media only screen and (max-width: ", "px) {\n    width: 100%;\n  }\n"])), breakpoints.sm - 1);
var Title$u = styled__default["default"].h3(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref2$color,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref2$size;
  return "\n  font-family: ".concat(getFontFamily(fontFamily), ";\n  font-weight: 600;\n  margin-bottom: 14px;\n  color: ").concat(getColors(color), ";\n  font-size: ").concat(getTextSize(size), ";\n  line-height: 40px;\n  ");
});
var Subtitle = styled__default["default"].p(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: 14px;\n"])), function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? colorsVariantsTypes.ULTRA_LIGHT : _ref4$color;
  return getColors(color);
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref5$size;
  return getTextSize(size);
});
var Rate$1 = styled__default["default"].h2(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: 600;\n  color: ", ";\n  font-size: ", ";\n  line-height: 50px;\n"])), function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref7) {
  var _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref7$color;
  return getColors(color);
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? textSizesVariantsTypes.HEADER_2 : _ref8$size;
  return getTextSize(size);
});
var RightContainer = styled__default["default"].div(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteral(["\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 48%;\n\n  @media only screen and (max-width: ", "px) {\n    text-align: left;\n    width: 100%;\n  }\n"])), breakpoints.sm - 1);
var RightTitle = styled__default["default"].p(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: 40px;\n"])), function (_ref9) {
  var _ref9$fontFamily = _ref9.fontFamily,
      fontFamily = _ref9$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref9$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref10) {
  var _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsVariantsTypes.BLACK : _ref10$color;
  return getColors(color);
}, function (_ref11) {
  var _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? textSizesVariantsTypes.SMALL : _ref11$size;
  return getTextSize(size);
});
var RightSubtitle = styled__default["default"].h6(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref12) {
  var _ref12$fontFamily = _ref12.fontFamily,
      fontFamily = _ref12$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref12$fontFamily,
      _ref12$color = _ref12.color,
      color = _ref12$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref12$color,
      _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref12$size;
  return "\n  font-weight: 600;\n  font-family: ".concat(getFontFamily(fontFamily), ";\n  color: ").concat(getColors(color), ";\n  font-size: ").concat(getTextSize(size), ";\n  line-height: 20px;\n  ");
});
var RightText = styled__default["default"].p(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: 20px;\n  margin-bottom: 5px;\n"])), function (_ref13) {
  var _ref13$fontFamily = _ref13.fontFamily,
      fontFamily = _ref13$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref13$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref14) {
  var _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? colorsVariantsTypes.BLACK : _ref14$color;
  return getColors(color);
}, function (_ref15) {
  var _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? textSizesVariantsTypes.SMALL : _ref15$size;
  return getTextSize(size);
});
var LineSeparator = styled__default["default"].div(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 2px;\n  background: ", ";\n  display: ", ";\n\n  @media only screen and (max-width: ", "px) {\n    margin: 18px 0px;\n    width: 120px;\n    display: ", ";\n  }\n"])), function (_ref16) {
  var _ref16$background = _ref16.background,
      background = _ref16$background === void 0 ? colorsTypes.SECONDARY : _ref16$background;

  if (background) {
    return background;
  }

  return "linear-gradient(264.35deg, ".concat(colorsTypes.SECONDARY, " 2.57%, ").concat(colorsTypes.SECONDARY, " 95.51%)");
}, function (_ref17) {
  var _ref17$isMobileScreen = _ref17.isMobileScreen,
      isMobileScreen = _ref17$isMobileScreen === void 0 ? false : _ref17$isMobileScreen;
  return isMobileScreen ? "none" : "block";
}, breakpoints.sm - 1, function (_ref18) {
  var _ref18$isMobileScreen = _ref18.isMobileScreen,
      isMobileScreen = _ref18$isMobileScreen === void 0 ? false : _ref18$isMobileScreen;
  return isMobileScreen ? "block" : "none";
});

function RatesList(_ref19) {
  var data = _ref19.data,
      _ref19$customComponen = _ref19.customComponentStyles.ratesList,
      ratesList = _ref19$customComponen === void 0 ? {} : _ref19$customComponen;

  if (!data) {
    return null;
  }

  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _data$titleColor,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$subtitleColor = data.subtitleColor,
      subtitleColor = _data$subtitleColor === void 0 ? colorsVariantsTypes.ULTRA_LIGHT : _data$subtitleColor,
      _data$subtitleFontFam = data.subtitleFontFamily,
      subtitleFontFamily = _data$subtitleFontFam === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$subtitleFontFam,
      _data$subtitleSize = data.subtitleSize,
      subtitleSize = _data$subtitleSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$subtitleSize,
      _data$rateColor = data.rateColor,
      rateColor = _data$rateColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _data$rateColor,
      _data$rateFontFamily = data.rateFontFamily,
      rateFontFamily = _data$rateFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$rateFontFamily,
      _data$rateSize = data.rateSize,
      rateSize = _data$rateSize === void 0 ? textSizesVariantsTypes.HEADER_2 : _data$rateSize,
      _data$rightTitleColor = data.rightTitleColor,
      rightTitleColor = _data$rightTitleColor === void 0 ? colorsVariantsTypes.BLACK : _data$rightTitleColor,
      _data$rightTitleFontF = data.rightTitleFontFamily,
      rightTitleFontFamily = _data$rightTitleFontF === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$rightTitleFontF,
      _data$rightTitleSize = data.rightTitleSize,
      rightTitleSize = _data$rightTitleSize === void 0 ? textSizesVariantsTypes.SMALL : _data$rightTitleSize,
      _data$rightSubtitleCo = data.rightSubtitleColor,
      rightSubtitleColor = _data$rightSubtitleCo === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _data$rightSubtitleCo,
      _data$rightSubtitleFo = data.rightSubtitleFontFamily,
      rightSubtitleFontFamily = _data$rightSubtitleFo === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$rightSubtitleFo,
      _data$rightSubtitleSi = data.rightSubtitleSize,
      rightSubtitleSize = _data$rightSubtitleSi === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$rightSubtitleSi,
      _data$rightTextColor = data.rightTextColor,
      rightTextColor = _data$rightTextColor === void 0 ? colorsVariantsTypes.BLACK : _data$rightTextColor,
      _data$rightTextFontFa = data.rightTextFontFamily,
      rightTextFontFamily = _data$rightTextFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$rightTextFontFa,
      _data$rightTextSize = data.rightTextSize,
      rightTextSize = _data$rightTextSize === void 0 ? textSizesVariantsTypes.SMALL : _data$rightTextSize;
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, data === null || data === void 0 ? void 0 : data.rate.map(function (element, key) {
    return /*#__PURE__*/React__default$1["default"].createElement(BackgroundContainer, {
      className: "RATE_LIST__BACKGROUND_CONTAINER rate-list-background-container",
      background: (data === null || data === void 0 ? void 0 : data.gradient) || "var(--primary-6-color)",
      key: "Rate-item_".concat(key)
    }, /*#__PURE__*/React__default$1["default"].createElement(Container$j, {
      className: "RATE_LIST__CONTAINER tw-x-container rate-list-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(ItemContainer$1, {
      container: "RATE_LIST__CONTAINER__ITEM_CONTAINER rate-list-item-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(LeftContainer, {
      className: "RATE_LIST__LEFT_CONTAINER rate-list-left-container"
    }, element.title.search(/([A-z]|[A-z].[A-z].)\w+/) !== -1 && /*#__PURE__*/React__default$1["default"].createElement(Title$u, _extends$g({}, ratesList.title, {
      className: "RATE_LIST__TITLE rate-list-title",
      fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY],
      color: colorsVariantsTypes[titleColor || colorsVariantsTypes.PRIMARY_DARK],
      size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
    }), "".concat(element.title)), /*#__PURE__*/React__default$1["default"].createElement(Subtitle, {
      className: "RATE_LIST__SUBTITLE rate-list-subtitle",
      fontFamily: fontsFamiliesVariantsTypes[subtitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
      color: colorsVariantsTypes[subtitleColor || colorsVariantsTypes.ULTRA_LIGHT],
      size: textSizesVariantsTypes[subtitleSize || textSizesVariantsTypes.VERY_SMALL]
    }, element.subtitle), /*#__PURE__*/React__default$1["default"].createElement(Rate$1, {
      className: "RATE_LIST__RATE rate-list-rate",
      fontFamily: fontsFamiliesVariantsTypes[rateFontFamily || fontsFamiliesVariantsTypes.SECONDARY],
      color: colorsVariantsTypes[rateColor || colorsVariantsTypes.PRIMARY_DARK],
      size: textSizesVariantsTypes[rateSize || textSizesVariantsTypes.HEADER_2]
    }, element.rate), /*#__PURE__*/React__default$1["default"].createElement(LineSeparator, {
      background: data === null || data === void 0 ? void 0 : data.lineDividerColor,
      className: "RATE_LIST__SEPARATOR rate-list-line-separator",
      isMobileScreen: true
    })), /*#__PURE__*/React__default$1["default"].createElement(RightContainer, {
      className: "RATE_LIST__RIGHT_CONTAINER rate-list-right-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(RightTitle, {
      className: "RATE_LIST__RIGHT_TITLE rate-list-right-title",
      fontFamily: fontsFamiliesVariantsTypes[rightTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
      color: colorsVariantsTypes[rightTitleColor || colorsVariantsTypes.BLACK],
      size: textSizesVariantsTypes[rightTitleSize || textSizesVariantsTypes.SMALL]
    }, element.rateDescription), /*#__PURE__*/React__default$1["default"].createElement("div", null, /*#__PURE__*/React__default$1["default"].createElement(RightSubtitle, _extends$g({}, ratesList.rightSubtitle, {
      className: "RATE_LIST__RIGHT_SUBTITLE rate-list-right-subtitle",
      fontFamily: fontsFamiliesVariantsTypes[rightSubtitleFontFamily || fontsFamiliesVariantsTypes.SECONDARY],
      color: colorsVariantsTypes[rightSubtitleColor || colorsVariantsTypes.PRIMARY_DARK],
      size: textSizesVariantsTypes[rightSubtitleSize || textSizesVariantsTypes.VERY_SMALL]
    }), element.titleText), /*#__PURE__*/React__default$1["default"].createElement(RightText, {
      className: "RATE_LIST__RIGHT_TEXT rate-list-right-text",
      fontFamily: fontsFamiliesVariantsTypes[rightTextFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
      color: colorsVariantsTypes[rightTextColor || colorsVariantsTypes.BLACK],
      size: textSizesVariantsTypes[rightTextSize || textSizesVariantsTypes.SMALL]
    }, element.text))), /*#__PURE__*/React__default$1["default"].createElement(LineSeparator, {
      background: data === null || data === void 0 ? void 0 : data.lineDividerColor,
      className: "RATE_LIST__SEPARATOR rate-list-line-separator"
    }))));
  }));
}

var _templateObject$2s;

var TD = styled__default["default"].td(_templateObject$2s || (_templateObject$2s = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsVariantsTypes.BLACK : _ref$color,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return "\n  color: ".concat(getColors(colorsVariantsTypes[color]), ";\n  font-size: ").concat(getTextSize(textSizesVariantsTypes[size]), ";\n  font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), "\n");
});

function TableContentItemLine(_ref2) {
  var children = _ref2.children,
      key = _ref2.key,
      className = _ref2.className,
      width = _ref2.width,
      color = _ref2.color,
      size = _ref2.size,
      fontFamily = _ref2.fontFamily;
  return /*#__PURE__*/React__default$1["default"].createElement(TD, {
    key: "TableContentItem-key-".concat(key),
    className: classnames("tw-px-6 tw-py-6 tw-whitespace-no-wrap tw-border-b bl-border-grayscale tw-leading-5", width, className),
    color: color,
    size: size,
    fontFamily: fontFamily
  }, children);
}

var _templateObject$2r;

var P$7 = styled__default["default"].p(_templateObject$2r || (_templateObject$2r = _taggedTemplateLiteral([""])));

function TextBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "TEXT_BODY tw-w-full primitive-text-body-container"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "TEXT_BODY__CONTAINER text-body-p-container tw-rounded-xl bl-text-lg ".concat(className)
  }, /*#__PURE__*/React__default$1["default"].createElement(P$7, {
    className: "TEXT_BODY__CONTAINER__CONTENT text-body-p"
  }, children)));
}

var _templateObject$2q;

var P$6 = styled__default["default"].p(_templateObject$2q || (_templateObject$2q = _taggedTemplateLiteral([""])));

function TextSimple(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "TEXT_SIMPLE tw-w-full"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "TEXT_SIMPLE__CONTAINER tw-rounded-xl bl-text-lg ".concat(className)
  }, /*#__PURE__*/React__default$1["default"].createElement(P$6, {
    className: "TEXT_SIMPLE__CONTAINER__CONTENT"
  }, children)));
}

var _templateObject$2p;

var H4$1 = styled__default["default"].h4(_templateObject$2p || (_templateObject$2p = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n"])));

function Title$t(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default$1["default"].createElement(H4$1, {
    className: "TITLE tw-font-bold bl-text-xl sm:bl-text-xl lg:bl-text-xl tw-leading-tight tw-mb-6"
  }, children);
}

var _templateObject$2o, _templateObject2$1b, _templateObject3$_;

var H2 = styled__default["default"].h2(_templateObject$2o || (_templateObject$2o = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref) {
  var _ref$textFontSize = _ref.textFontSize,
      textFontSize = _ref$textFontSize === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$textFontSize;
  return getFontFamily(textFontSize);
}, function (_ref2) {
  var _ref2$textSize = _ref2.textSize,
      textSize = _ref2$textSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref2$textSize;
  return getTextSize(textSize);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$color,
      _ref3$light = _ref3.light,
      light = _ref3$light === void 0 ? false : _ref3$light;
  return light ? getColors(color) : getColors(colorsVariantsTypes.PRIMARY_DARK);
}); // Gradient Container

var GradientContainer$2 = styled__default["default"].div(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteral(["\n  background-color: #000;\n  background-image: ", ";\n"])), function (_ref4) {
  var _ref4$withGradient = _ref4.withGradient,
      withGradient = _ref4$withGradient === void 0 ? true : _ref4$withGradient,
      _ref4$light = _ref4.light,
      light = _ref4$light === void 0 ? false : _ref4$light,
      _ref4$from = _ref4.from,
      from = _ref4$from === void 0 ? "to" : _ref4$from,
      _ref4$to = _ref4.to,
      to = _ref4$to === void 0 ? "right " : _ref4$to,
      _ref4$firstColor = _ref4.firstColor,
      firstColor = _ref4$firstColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref4$firstColor,
      _ref4$firstLightColor = _ref4.firstLightColor,
      firstLightColor = _ref4$firstLightColor === void 0 ? colorsTypes.PRIMARY_ULTRA_LIGHT : _ref4$firstLightColor,
      _ref4$secondColor = _ref4.secondColor,
      secondColor = _ref4$secondColor === void 0 ? colorsTypes.PRIMARY_DARK : _ref4$secondColor,
      _ref4$secondLightColo = _ref4.secondLightColor,
      secondLightColor = _ref4$secondLightColo === void 0 ? colorsTypes.PRIMARY_LIGHT : _ref4$secondLightColo;
  if (!withGradient) return light ? firstLightColor : firstColor;
  return "linear-gradient(".concat(from, " ").concat(to, ", ").concat(light ? firstLightColor : firstColor, ", ").concat(light ? secondLightColor : secondColor, ")");
});
var Container$i = styled__default["default"].div(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteral([""])));

function TitleWithGradient(_ref5) {
  var _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? {} : _ref5$data,
      _ref5$customComponent = _ref5.customComponentStyles.titleWithGradients,
      titleWithGradients = _ref5$customComponent === void 0 ? {} : _ref5$customComponent;
  var _data$light = data.light,
      light = _data$light === void 0 ? false : _data$light,
      _data$withGradient = data.withGradient,
      withGradient = _data$withGradient === void 0 ? true : _data$withGradient,
      _data$text = data.text,
      text = _data$text === void 0 ? "" : _data$text,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _data$titleColor,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize;
  return /*#__PURE__*/React__default$1["default"].createElement(GradientContainer$2, _extends$g({
    className: "CALLOUT_WITH_GRADIENT__CONTAINER callout-with-gradient-gradient-container",
    light: light,
    withGradient: withGradient
  }, titleWithGradients.gradients), /*#__PURE__*/React__default$1["default"].createElement(Container$i, {
    className: "CALLOUT_WITH_GRADIENT__CONTAINER__BOX tw-x-container callout-with-gradient-gradient-container-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(H2, _extends$g({
    className: "CALLOUT_WITH_GRADIENT__H2 callout-with-gradient-gradient-title-h2 tw-font-bold bl-text-md tw-py-6",
    textFontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT],
    textColor: colorsVariantsTypes[titleColor || fontsFamiliesVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT],
    textSize: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, titleWithGradients, {
    light: !light
  }), text)));
}

var _excluded$1h = ["className"];

function VerticalDivider(_ref) {
  var className = _ref.className,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$1h);

  return /*#__PURE__*/React__default$1["default"].createElement("hr", _extends$g({
    className: classnames("VERTICAL_DIVIDER tw-w-px", className)
  }, otherProps));
}

var _templateObject$2n, _templateObject2$1a, _templateObject3$Z; // const Container = styled.div`
//   ${MediaQuery}
// `;


function PageTitle(_ref) {
  var _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      data = _ref.data,
      pageTitleProps = _ref.pageTitleProps;
  if (!data) return null;
  var Title = styled__default["default"].h4(_templateObject$2n || (_templateObject$2n = _taggedTemplateLiteral(["\n    font-family: var(--secondary-family);\n    font-weight: 600;\n    color: ", ";\n  "])), pageTitleProps !== null && pageTitleProps !== void 0 && pageTitleProps.titleColor ? pageTitleProps === null || pageTitleProps === void 0 ? void 0 : pageTitleProps.titleColor : "var(--primary-150-color)");
  var Rectangle = styled__default["default"].div(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteral(["\n    width: 200px;\n    height: 4px;\n    background: var(--secondary-color);\n    color: ", ";\n  "])), pageTitleProps !== null && pageTitleProps !== void 0 && pageTitleProps.RectangleColor ? pageTitleProps === null || pageTitleProps === void 0 ? void 0 : pageTitleProps.RectangleColor : colorsTypes.SECONDARY);
  var SubTitle = styled__default["default"].h5(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteral(["\n    font-family: var(--primary-family);\n    font-weight: 600;\n    opacity: 60%;\n    color: ", ";\n  "])), pageTitleProps !== null && pageTitleProps !== void 0 && pageTitleProps.subtitleColor ? pageTitleProps === null || pageTitleProps === void 0 ? void 0 : pageTitleProps.subtitleColor : colorsTypes.PRIMARY_ULTRA_LIGHT); // const Tag = isTwContainer ? "div" : Container;

  var Tag = "div";
  return /*#__PURE__*/React__default$1["default"].createElement(Tag, {
    className: classnames("PAGE_TITLE tw-mt-10 page-title-container-tag", !applyMaxWidthContainer && "tw-x-container")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: applyMaxWidthContainer && "tw-x-container max-width-container"
  }, data.Title && /*#__PURE__*/React__default$1["default"].createElement(Title, {
    className: "PAGE_TITLE__TITLE page-title-title tw-font-bold bl-text-2xl tw-leading-tight tw-mb-2"
  }, data.Title), data.SubTitle && /*#__PURE__*/React__default$1["default"].createElement(SubTitle, {
    className: "PAGE_TITLE__SUBTITLE tw-font-bold bl-text-base tw-leading-tight tw-mb-6"
  }, data.SubTitle)), /*#__PURE__*/React__default$1["default"].createElement(Rectangle, {
    className: "PAGE_TITLE__RECTANGLE page-title-rectangle"
  }));
}

function AutoLink$2(_ref) {
  var data = _ref.data;
  if (!data) return null;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IFRAME"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IFRAME_CONTAINER"
  }), /*#__PURE__*/React__default$1["default"].createElement(useScript, {
    async: false,
    type: "text/javascript",
    src: data === null || data === void 0 ? void 0 : data.Autolink
  }));
}

function isObject$3(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend$3(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$3(src[key]) && isObject$3(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend$3(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}
/* underscore in name -> watch for changes */


var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom']; // eslint-disable-next-line

function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend$3(params, SwiperCore.defaults);
  extend$3(params, SwiperCore.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject$3(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend$3(params[key], obj[key]);
        extend$3(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
} // eslint-disable-next-line


function initSwiper(swiperParams) {
  return new SwiperCore(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = SwiperCore.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React__default$1["default"].cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default$1["default"].cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React__default$1["default"].createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject$3(swiperParams[key]) && isObject$3(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function processChildren(c) {
  var slides = [];
  React__default$1["default"].Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default$1["default"].Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}

function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (isObject$3(currentParams[key]) && isObject$3(passedParams[key])) {
      extend$3(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React__default$1["default"].cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}

function useIsomorphicLayoutEffect$1(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return React.useEffect(callback, deps);
  return React.useLayoutEffect(callback, deps);
}

var _excluded$1g = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Swiper = /*#__PURE__*/React.forwardRef(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose$5(_ref, _excluded$1g);

  var eventsAssigned = false;

  var _useState = React.useState('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = React.useState(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = React.useState(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = React.useRef(false);
  var swiperElRef = React.useRef(null);
  var swiperRef = React.useRef(null);
  var oldPassedParamsRef = React.useRef(null);
  var oldSlides = React.useRef(null);
  var nextElRef = React.useRef(null);
  var prevElRef = React.useRef(null);
  var paginationElRef = React.useRef(null);
  var scrollbarElRef = React.useRef(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend$3(swiperRef.current.params.virtual, extendWith);
      extend$3(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  React.useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  React.useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect$1(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect$1(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect$1(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React__default$1["default"].cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default$1["default"].createElement(Tag, _extends$8({
    ref: swiperElRef,
    className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/React__default$1["default"].createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper.displayName = 'Swiper';
var _excluded$1f = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SwiperSlide = /*#__PURE__*/React.forwardRef(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose$4(_ref, _excluded$1f);

  var slideElRef = React.useRef(null);

  var _useState = React.useState('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect$1(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect$1(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default$1["default"].createElement(Tag, _extends$7({
    ref: slideElRef,
    className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';
var urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
var POOL_SIZE_MULTIPLIER = 128;
var pool, poolOffset;

var fillPool = function fillPool(bytes) {
  if (!pool || pool.length < bytes) {
    pool = Buffer.allocUnsafe(bytes * POOL_SIZE_MULTIPLIER);
    crypto__default["default"].randomFillSync(pool);
    poolOffset = 0;
  } else if (poolOffset + bytes > pool.length) {
    crypto__default["default"].randomFillSync(pool);
    poolOffset = 0;
  }

  poolOffset += bytes;
};

var nanoid = function nanoid() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;
  fillPool(size -= 0);
  var id = '';

  for (var i = poolOffset - size; i < poolOffset; i++) {
    id += urlAlphabet[pool[i] & 63];
  }

  return id;
};

var _templateObject$2m, _templateObject2$19, _templateObject3$Y, _templateObject4$J, _templateObject5$C, _templateObject6$r, _templateObject7$f;

var ContainerGradient = styled__default["default"].div(_templateObject$2m || (_templateObject$2m = _taggedTemplateLiteral(["\n  &::before {\n    background-image: url(", ");\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    filter: grayscale(100%);\n    background-position: center top;\n    background-repeat: no-repeat;\n    background-size: cover;\n    transition: all 0.9s ease;\n  }\n\n  &:hover::before {\n    filter: grayscale(0);\n  }\n\n  &:hover .box-content .title-to-hide {\n    visibility: hidden;\n    height: 0;\n    bottom: 0;\n  }\n\n  &:hover .description-box {\n    visibility: visible;\n    height: min-content;\n    bottom: 0;\n    text-align: center;\n    opacity: 1;\n  }\n\n  &:hover .box-content-on-hover {\n    display: block;\n  }\n"])), function (_ref) {
  var _ref$image = _ref.image,
      image = _ref$image === void 0 ? "" : _ref$image;
  return image;
});
var DesktopContainer = styled__default["default"].div(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteral([""])));
var Title$s = styled__default["default"].h3(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteral(["\n  color: var(--primary-color);\n  font-weight: 700;\n  size: 26px;\n  line-height: 39px;\n"])));
var TransparentContainer = styled__default["default"].div(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteral(["\n  height: auto;\n"])));
var Text$3 = styled__default["default"].p(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-weight: 400;\n  size: 14px;\n  line-height: 16px;\n"])));
var Button$1 = styled__default["default"].a(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteral(["\n  color: var(--primary-110-color);\n  border: solid 1px var(--primary-110-color);\n  font-weight: 500;\n  size: 14px;\n  line-height: 16px;\n  padding: 7px 20px;\n\n  &:hover {\n    color: var(--grayscale-0-color);\n    background-color: var(--primary-color);\n  }\n"])));
var desktopSettings = {
  pagination: false,
  loop: true,
  navigation: false,
  spaceBetween: 0
};

function DesktopCompressedContent(_ref2) {
  var data = _ref2.data,
      _ref2$buttonCustomSty = _ref2.buttonCustomStyles,
      buttonCustomStyles = _ref2$buttonCustomSty === void 0 ? {} : _ref2$buttonCustomSty;
  if (!data) return null;
  var desktopData = data.CompressedContent;
  var result = desktopData.reduce(function (resultArray, item, index) {
    var chunkIndex = Math.floor(index / 3);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [];
    }

    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement(DesktopContainer, {
    className: "COMPRESSED_COMPONENT tw-hidden lg:tw-block "
  }, /*#__PURE__*/React__default$1["default"].createElement(Swiper, _extends$g({}, desktopSettings, {
    className: "mySwiper COMPRESSED_COMPONENT_MYSWIPER"
  }), result.map(function (section) {
    return /*#__PURE__*/React__default$1["default"].createElement(SwiperSlide, {
      key: nanoid()
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "COMPRESSED_COMPONENT__CONTAINER tw-grid tw-grid-cols-3 "
    }, section === null || section === void 0 ? void 0 : section.map(function (box, index) {
      var Wrapper = styled__default["default"].div(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteral(["\n                  background-color: rgba(255, 255, 255, 0.5);\n                  &:hover #boxAnimation-", " {\n                    visibility: visible;\n                  }\n\n                  & {\n                    height: 500px;\n                  }\n\n                  & .box-content {\n                    position: absolute;\n                    width: 100%;\n                    bottom: 0;\n                    visibility: hidden;\n                  }\n\n                  & .description-box {\n                    height: 0;\n                    opacity: 0;\n                    -webkit-transition: opacity 0.3s ease-in-out;\n                    -moz-transition: opacity 0.3s ease-in-out;\n                    -ms-transition: opacity 0.3s ease-in-out;\n                    -o-transition: opacity 0.3s ease-in-out;\n                  }\n\n                  & *:not(.description-box) {\n                    transition: none;\n                  }\n\n                  & .box-content .title-to-hide {\n                    -webkit-transition: opacity 0.3s ease-in-out;\n                    -moz-transition: opacity 0.3s ease-in-out;\n                    -ms-transition: opacity 0.3s ease-in-out;\n                    -o-transition: opacity 0.3s ease-in-out;\n                  }\n\n                  & .swiper-button-next {\n                    display: none;\n                  }\n                "])), index);
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "box-".concat(index),
        id: "box-".concat(index),
        className: "COMPRESSED_COMPONENT__CONTAINER__BOX tw-relative"
      }, box.image && /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "COMPRESSED_COMPONENT__BOX tw-text-center tw-h-full"
      }, /*#__PURE__*/React__default$1["default"].createElement(ContainerGradient, {
        className: "COMPRESSED_COMPONENT__CONTAINER__GRADIENT",
        gradientType: box.gradient,
        image: box.image.url
      }, /*#__PURE__*/React__default$1["default"].createElement(Wrapper, {
        className: "COMPRESSED_COMPONENT__WRAPPER wrapper-grayscale tw-bg-opacity-50 hover:tw-bg-opacity-0"
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "box-content COMPRESSED_COMPONENT_WRAPPER_CONTENT"
      }, box.title && /*#__PURE__*/React__default$1["default"].createElement("div", {
        id: "boxNoAnimation-".concat(index),
        className: "COMPRESSED_COMPONENT__TITLE_CONTAINER tw-visible title-to-hide tw-bg-opacity-95 tw-bg-white"
      }, /*#__PURE__*/React__default$1["default"].createElement(Title$s, {
        className: "COMPRESSED_COMPONENT__TITLE tw-py-6 tw-px-8"
      }, /*#__PURE__*/React__default$1["default"].createElement(SecondaryText, {
        className: "COMPRESSED_COMPONENT__TITLE__SECONDARY_TEXT"
      }, box.title))), /*#__PURE__*/React__default$1["default"].createElement(TransparentContainer, {
        className: "COMPRESSED_COMPONENT__TRANSPARENT__CONTAINER description-box tw-bg-opacity-95 tw-bg-white"
      }, box.title && /*#__PURE__*/React__default$1["default"].createElement("div", {
        id: "boxNoAnimation-".concat(index + 1),
        className: "COMPRESSED_COMPONENT__TRANSPARENT__TITLE__CONTAINER tw-visible"
      }, /*#__PURE__*/React__default$1["default"].createElement(Title$s, {
        className: "COMPRESSED_COMPONENT__TRANSPARENT_TITLE tw-py-6 tw-px-8"
      }, /*#__PURE__*/React__default$1["default"].createElement(SecondaryText, {
        className: "COMPRESSED_COMPONENT__TRANSPARENT_TITLE__SECONDARY_TEXT"
      }, box.title))), box.description && /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "COMPRESSED_COMPONENT__TRANSPARENT__DESCRIPTION__CONTAINER tw-px-8"
      }, /*#__PURE__*/React__default$1["default"].createElement(Text$3, {
        className: "COMPRESSED_COMPONENT__TRANSPARENT__DESCRIPTION"
      }, box.description)), box.buttonText && box.buttonUrl && /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "COMPRESSED_COMPONENT__TRANSPARENT__BUTTON__CONTAINER bl-text-xs tw-py-6 tw-px-8"
      }, /*#__PURE__*/React__default$1["default"].createElement(Button$1, _extends$g({
        className: "COMPRESSED_COMPONENT__TRANSPARENT__BUTTON tw-inline-block focus:tw-outline-none tw-cursor-pointer",
        href: box.buttonUrl
      }, buttonCustomStyles), box.buttonText))))))));
    })));
  })));
}

var _templateObject$2l, _templateObject2$18, _templateObject3$X, _templateObject4$I, _templateObject5$B, _templateObject6$q, _templateObject7$e;

var SwiperContainer$3 = styled__default["default"].div(_templateObject$2l || (_templateObject$2l = _taggedTemplateLiteral(["\n  .swiper-button-prev,\n  .swiper-button-next {\n    opacity: 0;\n    height: 65px;\n    top: 64.8%;\n    color: var(--grayscale-150-color);\n    cursor: pointer;\n  }\n\n  /* .swipter-button-prev::after {\n    display: none;\n  } */\n  .swiper-button-prev:after {\n    display: inline-block;\n    padding-left: 12px;\n    font-size: 25px;\n  }\n  .swiper-button-next:after {\n    display: inline-block;\n    padding-right: 12px;\n    font-size: 25px;\n  }\n\n  /* @media (min-width: 500px) {\n    .swiper-button-prev,\n    .swiper-button-next {\n      top: 74%;\n    }\n  } */\n"])));
var ArrowTitleContainer = styled__default["default"].div(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var Arrow$1 = styled__default["default"].i(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteral(["\n  //visibility: hidden;\n  border: solid var(--primary-150-color);\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 8px;\n  border-radius: 0px 1px 1px 0px;\n\n  &.left {\n    transform: rotate(135deg);\n    -webkit-transform: rotate(135deg);\n  }\n\n  &.right {\n    transform: rotate(-45deg);\n    -webkit-transform: rotate(-45deg);\n  }\n"])));
var Title$r = styled__default["default"].h3(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteral(["\n  color: var(--primary-color);\n  font-weight: 700;\n  font-size: 26px;\n  line-height: 39px;\n  padding: 0px 5px;\n"])));
var Text$2 = styled__default["default"].p(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n"])));
var Button = styled__default["default"].a(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteral(["\n  color: var(--primary-150-color);\n  border: solid 1px var(--primary-150-color);\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  padding: 7px 20px;\n\n  &:hover {\n    color: var(--grayscale-0-color);\n    background-color: var(--primary-color);\n  }\n"]))); // install Swiper modules

SwiperCore.use([Navigation$1]);
var defaultSettings$3 = {
  pagination: false,
  loop: true,
  navigation: true,
  spaceBetween: 0
};

function MobileCompressedContent(_ref) {
  var _data$CompressedConte;

  var data = _ref.data;
  if (!data) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(SwiperContainer$3, {
    className: "COMPRESS_COMPONENT_MOBILE tw-block lg:tw-hidden tw-h-full"
  }, /*#__PURE__*/React__default$1["default"].createElement(Swiper, _extends$g({}, defaultSettings$3, {
    className: "mySwiper COMPRESS_COMPONENT_MOBILE__MYSWIPER"
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-absolute COMPRESS_COMPONENT_MOBILE__CONTAINER"
  }, (_data$CompressedConte = data.CompressedContent) === null || _data$CompressedConte === void 0 ? void 0 : _data$CompressedConte.map(function (box, index) {
    var _box$image;

    var Wrapper = styled__default["default"].div(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteral(["\n              width: 100%;\n            "])));
    return /*#__PURE__*/React__default$1["default"].createElement(SwiperSlide, {
      style: {
        height: "auto"
      }
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "box-".concat(index),
      className: "COMPRESS_COMPONENT_MOBILE__CONTAINER__SLIDE tw-h-full"
    }, box.image && /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "COMPRESS_COMPONENT_MOBILE__BOX tw-text-center tw-w-full tw-h-full tw-object-fill tw-flex tw-flex-col"
    }, /*#__PURE__*/React__default$1["default"].createElement("img", {
      src: box.image.url,
      alt: (box === null || box === void 0 ? void 0 : (_box$image = box.image) === null || _box$image === void 0 ? void 0 : _box$image.alternativeText) || "",
      className: "COMPRESS_COMPONENT_MOBILE__IMG tw-w-full tw-h-80 tw-object-cover tw-object-top"
    }), /*#__PURE__*/React__default$1["default"].createElement(Wrapper, {
      className: "COMPRESS_COMPONENT_MOBILE__WRAPPER tw-bg-gray-100 tw-bg-opacity-0 tw-flex-grow"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      id: "boxAnimation-".concat(index),
      className: "COMPRESS_COMPONENT_MOBILE__TITLE_CONTAINER tw-bg-gray-100 tw-bg-opacity-75 tw-block tw-h-full tw-flex tw-flex-col tw-justify-evenly"
    }, box.title && /*#__PURE__*/React__default$1["default"].createElement(ArrowTitleContainer, {
      className: "tw-p-6 COMPRESS_COMPONENT_MOBILE__ARROWS_CONTAINER"
    }, /*#__PURE__*/React__default$1["default"].createElement(Arrow$1, {
      className: "left COMPRESS_COMPONENT_MOBILE__ARROW__LEFT"
    }), /*#__PURE__*/React__default$1["default"].createElement(SecondaryText, null, /*#__PURE__*/React__default$1["default"].createElement(Title$r, {
      className: "COMPRESS_COMPONENT_MOBILE_TITLE tw-p-6"
    }, box.title)), /*#__PURE__*/React__default$1["default"].createElement(Arrow$1, {
      className: "right COMPRESS_COMPONENT_MOBILE__RIGHT"
    })), box.description && /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "COMPRESS_COMPONENT_MOBILE__DESCRIPTION_CONTAINER tw-bg-gray-100 tw-px-6 tw-bg-opacity-75"
    }, /*#__PURE__*/React__default$1["default"].createElement(Text$2, {
      className: "COMPRESS_COMPONENT_MOBILE__DESCRIPTION"
    }, box.description)), box.buttonText && box.buttonUrl && /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "COMPRESS_COMPONENT_MOBILE_BUTTON__CONTAINER bl-text-xs tw-bg-gray-100 tw-bg-opacity-75 tw-p-6"
    }, /*#__PURE__*/React__default$1["default"].createElement(Button, {
      className: "COMPRESS_COMPONENT_MOBILE__BUTTON tw-inline-block focus:tw-outline-none tw-cursor-pointer",
      href: box.buttonUrl
    }, box.buttonText)))))));
  }))));
}

var _excluded$1e = ["data"];

function CompressedContent(_ref) {
  var data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$1e);

  return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-hidden lg:tw-block"
  }, /*#__PURE__*/React__default$1["default"].createElement(DesktopCompressedContent, _extends$g({
    data: data
  }, otherProps))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-block lg:tw-hidden tw-h-full"
  }, /*#__PURE__*/React__default$1["default"].createElement(MobileCompressedContent, _extends$g({
    data: data
  }, otherProps))));
}

var _templateObject$2k, _templateObject2$17, _templateObject3$W, _templateObject4$H, _templateObject5$A; // Gradient Container


var GradientContainer$1 = styled__default["default"].div(_templateObject$2k || (_templateObject$2k = _taggedTemplateLiteral(["\n  background-image: linear-gradient(to right, var(--primary-30-color), var(--primary-6-color));\n"])));
var LineDecorationDesktop$2 = styled__default["default"].div(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteral(["\n  @media (min-width: ", "px) {\n    border-left: ", ";\n  }\n"])), breakpoints.md, function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _ref$borderColor;
  return "solid 2px ".concat(getColors(borderColor));
});
var LineDecorationMobile$2 = styled__default["default"].div(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteral(["\n  @media (max-width: ", "px) {\n    background: ", ";\n  }\n"])), breakpoints.md - 1, function (_ref2) {
  var _ref2$borderColor = _ref2.borderColor,
      borderColor = _ref2$borderColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _ref2$borderColor;
  return getColors(borderColor);
});
var H3$3 = styled__default["default"].h3(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref3$color;
  return getColors(color);
}, function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref5$size;
  return getTextSize(size);
});
var P$5 = styled__default["default"].div(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsVariantsTypes.BLACK : _ref6$color;
  return getColors(color);
}, function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref7$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref8$size;
  return getTextSize(size);
}); // const H3 = styled.h3`
//   color: var(--primary-150-color);
// `;
// const P = styled.div`
//   color: var(--grayscale-100-color);
// `;

function CalloutMobileAppsGradientsLight(_ref9) {
  var _data$mobileAppImageA, _data$mobileAppImageA2, _data$mobileAppImageB, _data$mobileAppImageB2;

  var data = _ref9.data,
      _ref9$buttonStylesPro = _ref9.buttonStylesProps,
      buttonStylesProps = _ref9$buttonStylesPro === void 0 ? {} : _ref9$buttonStylesPro;
  if (!data || !data.mobileAppImageA && !data.mobileAppImageB) return null;
  var _data$lineColor = data.lineColor,
      lineColor = _data$lineColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _data$lineColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.SMALL : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  var buttonHoverBackgroundColor = buttonStylesProps.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = buttonStylesProps.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = buttonStylesProps.buttonHoverOutlineAndColorBorderColor,
      _buttonStylesProps$bu = buttonStylesProps.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _buttonStylesProps$bu === void 0 ? false : _buttonStylesProps$bu,
      _buttonStylesProps$bu2 = buttonStylesProps.buttonHoverColor,
      buttonHoverColor = _buttonStylesProps$bu2 === void 0 ? false : _buttonStylesProps$bu2,
      _buttonStylesProps$bu3 = buttonStylesProps.buttonGrayscale,
      buttonGrayscale = _buttonStylesProps$bu3 === void 0 ? false : _buttonStylesProps$bu3,
      _buttonStylesProps$da = buttonStylesProps.darkButton,
      darkButton = _buttonStylesProps$da === void 0 ? false : _buttonStylesProps$da,
      _buttonStylesProps$bu4 = buttonStylesProps.buttonFill,
      buttonFill = _buttonStylesProps$bu4 === void 0 ? buttonFillTypes.NONE : _buttonStylesProps$bu4,
      buttonTextColor = buttonStylesProps.buttonTextColor,
      _buttonStylesProps$bu5 = buttonStylesProps.buttonStyleType,
      buttonStyleType = _buttonStylesProps$bu5 === void 0 ? buttonStyleTypes.STANDARD : _buttonStylesProps$bu5;
  return /*#__PURE__*/React__default$1["default"].createElement(GradientContainer$1, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT tw-py-16"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER tw-x-container tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(LineDecorationDesktop$2, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__HEADER md:tw-pl-6 tw-w-80 tw-mr-2 sm:tw-mr-0",
    borderColor: colorsVariantsTypes[lineColor || colorsVariantsTypes.PRIMARY_ULTRA_LIGHT]
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__HEADER__TITLE"
  }, /*#__PURE__*/React__default$1["default"].createElement(H3$3, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__HEADER__TITLE__TEXT CalloutMobileApps__title tw-font-bold bl-text-xl",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.PRIMARY_DARK],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(LineDecorationMobile$2, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__DIVIDER bl-bg-primary-50 tw-w-36 tw-my-4 md:tw-hidden",
    borderColor: colorsVariantsTypes[lineColor || colorsVariantsTypes.VERY_ULTRA_LIGHT],
    style: {
      height: "2px"
    }
  }), /*#__PURE__*/React__default$1["default"].createElement(P$5, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__DESCRIPTION bl-text-grayscale-100 tw-mt-3",
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.BLACK],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.SMALL]
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    className: "FEATURE_V1__BUTTON CALLOUT_MOBILE_APPS_BUTTON",
    withoutBorderRadius: buttonWithoutBorderRadius,
    fill: buttonFill,
    styleType: buttonStyleType,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    is: "a",
    href: data.mobileAppsButtonUrl,
    dark: darkButton,
    hoverBackgroundColor: buttonHoverBackgroundColor,
    hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
    hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
    textColor: buttonTextColor
  }, data.mobileAppsButton)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__CONTENT tw-flex tw-w-full md:tw-w-80 lg:tw-w-96 md:tw-justify-end tw-my-10 md:tw-my-auto sm:tw-mr-0"
  }, ((_data$mobileAppImageA = data.mobileAppImageA) === null || _data$mobileAppImageA === void 0 ? void 0 : _data$mobileAppImageA.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__CONTENT__LINK tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    className: "tw-w-full tw-h-full tw-absolute",
    href: data.mobileAppLinkA,
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__CONTENT__LINK__IMAGE tw-w-auto tw-h-12 tw-object-cover tw-rounded-md",
    src: data.mobileAppImageA.url,
    alt: ((_data$mobileAppImageA2 = data.mobileAppImageA) === null || _data$mobileAppImageA2 === void 0 ? void 0 : _data$mobileAppImageA2.alternativeText) || data.mobileAppImageA.hash
  })), ((_data$mobileAppImageB = data.mobileAppImageB) === null || _data$mobileAppImageB === void 0 ? void 0 : _data$mobileAppImageB.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__CONTENT__LINK tw-relative tw-ml-6 lg:tw-ml-8"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: data.mobileAppLinkB,
    target: "_blank",
    rel: "noreferrer",
    className: "tw-w-full tw-h-full tw-absolute"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: data.mobileAppImageB.url,
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_LIGHT__CONTAINER__CONTENT__LINK__IMAGE tw-w-auto tw-h-12 tw-object-cover tw-rounded-md",
    alt: ((_data$mobileAppImageB2 = data.mobileAppImageB) === null || _data$mobileAppImageB2 === void 0 ? void 0 : _data$mobileAppImageB2.alternativeText) || data.mobileAppImageB.hash
  })))));
}

var _templateObject$2j, _templateObject2$16, _templateObject3$V, _templateObject4$G, _templateObject5$z; // Gradient Container


var GradientContainer = styled__default["default"].div(_templateObject$2j || (_templateObject$2j = _taggedTemplateLiteral(["\n  background-color: #000;\n  background-image: linear-gradient(to right, var(--primary-color), var(--primary-150-color));\n"])));
var LineDecorationDesktop$1 = styled__default["default"].div(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteral(["\n  @media (min-width: ", "px) {\n    border-left: ", ";\n  }\n"])), breakpoints.md, function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref$borderColor;
  return "solid 2px ".concat(getColors(borderColor));
});
var LineDecorationMobile$1 = styled__default["default"].div(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteral(["\n  @media (max-width: ", "px) {\n    background: ", ";\n  }\n"])), breakpoints.md - 1, function (_ref2) {
  var _ref2$borderColor = _ref2.borderColor,
      borderColor = _ref2$borderColor === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref2$borderColor;
  return getColors(borderColor);
});
var H3$2 = styled__default["default"].h3(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref3$color;
  return getColors(color);
}, function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref5$size;
  return getTextSize(size);
});
var P$4 = styled__default["default"].div(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _ref6$color;
  return getColors(color);
}, function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref7$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref8$size;
  return getTextSize(size);
});

function CalloutMobileAppsGradientsDark(_ref9) {
  var _data$mobileAppImageA, _data$mobileAppImageA2, _data$mobileAppImageB, _data$mobileAppImageB2;

  var data = _ref9.data;
  if (!data || !data.mobileAppImageA && !data.mobileAppImageB) return null;
  var _data$lineColor = data.lineColor,
      lineColor = _data$lineColor === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _data$lineColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.VERY_ULTRA_LIGHT : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.SMALL : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(GradientContainer, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK tw-x-container md:tw-py-16"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTAINER tw-rounded-lg tw-flex tw-flex-wrap tw-justify-between tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(LineDecorationDesktop$1, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__HEADER tw-w-80 md:tw-pl-6  tw-mr-2 sm:tw-mr-0",
    borderColor: colorsVariantsTypes[lineColor || colorsVariantsTypes.VERY_ULTRA_LIGHT]
  }, /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__HEADER__TITLE"
  }, /*#__PURE__*/React__default$1["default"].createElement(H3$2, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__HEADER__TITLE__TEXT CalloutMobileApps__title tw-font-bold bl-text-xl tw-mb-3",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.VERY_ULTRA_LIGHT],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(LineDecorationMobile$1, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__DIVIDER tw-w-36 tw-my-4 md:tw-hidden",
    borderColor: colorsVariantsTypes[lineColor || colorsVariantsTypes.VERY_ULTRA_LIGHT],
    style: {
      height: "2px"
    }
  }), /*#__PURE__*/React__default$1["default"].createElement(P$4, {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__DESCRIPTION bl-text-grayscale-100",
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.VERY_ULTRA_LIGHT],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.SMALL]
  }, data.description)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTENT tw-flex tw-w-full md:tw-w-80 lg:tw-w-96 md:tw-justify-end tw-my-10 md:tw-my-auto sm:tw-mr-0"
  }, ((_data$mobileAppImageA = data.mobileAppImageA) === null || _data$mobileAppImageA === void 0 ? void 0 : _data$mobileAppImageA.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTENT__LINK tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: data.mobileAppLinkA,
    target: "_blank",
    rel: "noreferrer",
    className: "tw-w-full tw-h-full tw-absolute"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTENT__LINK__IMAGE tw-w-auto tw-h-12 tw-object-cover tw-rounded-md",
    src: data.mobileAppImageA.url,
    alt: ((_data$mobileAppImageA2 = data.mobileAppImageA) === null || _data$mobileAppImageA2 === void 0 ? void 0 : _data$mobileAppImageA2.alternativeText) || data.mobileAppImageA.hash
  })), ((_data$mobileAppImageB = data.mobileAppImageB) === null || _data$mobileAppImageB === void 0 ? void 0 : _data$mobileAppImageB.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTENT__LINK tw-ml-6 lg:tw-ml-8 tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: data.mobileAppLinkB,
    target: "_blank",
    rel: "noreferrer",
    className: "tw-w-full tw-h-full tw-absolute"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: data.mobileAppImageB.url,
    className: "CALLOUT_MOBILE_APPS_GRADIENTS_DARK__CONTENT__LINK__IMAGE tw-w-auto tw-h-12 tw-object-cover tw-rounded-md",
    alt: ((_data$mobileAppImageB2 = data.mobileAppImageB) === null || _data$mobileAppImageB2 === void 0 ? void 0 : _data$mobileAppImageB2.alternativeText) || data.mobileAppImageB.hash
  })))));
}

function Widget(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;

  function checkScriptsAndInsert() {
    var counter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var maxCalls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300; // if (window && document && data.customScript) {

    if (window && document) {
      var script = document.createElement("script");
      script.src = data.customScript;
      script.async = false;
      document.body.querySelector("#WIDGET").appendChild(script);
      var iframe = document.querySelector("iframe");

      if (iframe) {
        iframe.style.position = "relative";
      }
    } else {
      return checkScriptsAndInsert();
    }

    var iframeExists = document.querySelector("iframe");

    if (iframeExists) {
      return true;
    }

    if (!iframeExists && counter < maxCalls) {
      setTimeout(function () {
        return checkScriptsAndInsert(counter + 1);
      }, 3000);
    } else {
      return false;
    }

    return false;
  }

  React.useEffect(function () {
    checkScriptsAndInsert();
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement(RichTextContainer, {
    id: "WIDGET",
    className: "WIDGET WIDGET_RICH_TEXT_MAIN",
    dangerouslySetInnerHTML: {
      __html: data.iframe
    }
  });
}

var _excluded$1d = ["children"];

var _templateObject$2i, _templateObject2$15;

var PrimaryTextFontFamily = styled.css(_templateObject$2i || (_templateObject$2i = _taggedTemplateLiteral(["\n  * {\n    font-family: var(--primary-family);\n  }\n"])));
var PrimaryTextContainer = styled__default["default"].div(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteral(["\n  ", "\n"])), PrimaryTextFontFamily);

var PrimaryText = function PrimaryText(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$1d);

  return /*#__PURE__*/React__default$1["default"].createElement(PrimaryTextContainer, otherProps, children);
};

var _excluded$1c = ["children"];

var _templateObject$2h, _templateObject2$14;

var SecondaryTextFontFamily = styled.css(_templateObject$2h || (_templateObject$2h = _taggedTemplateLiteral(["\n  * {\n    font-family: var(--secondary-family);\n  }\n"])));
var SecondaryTextContainer = styled__default["default"].div(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteral(["\n  ", "\n"])), SecondaryTextFontFamily);

var SecondaryText = function SecondaryText(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$1c);

  return /*#__PURE__*/React__default$1["default"].createElement(SecondaryTextContainer, otherProps, children);
};

var _templateObject$2g, _templateObject2$13, _templateObject3$U; // components


var Title$q = styled__default["default"].h3(_templateObject$2g || (_templateObject$2g = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.2rem" : _ref$fontSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "var(--grayscale-100-color)" : _ref$color,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "" : _ref$margin,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? "var(--primary-family)" : _ref$fontFamily;
  return "\n\tfont-family: ".concat(fontFamily, ";\n\tcolor: ").concat(color, ";\n\tfont-weight: 500;\n\tfont-size: ").concat(fontSize, ";\n  margin: ").concat(margin, ";\n");
});
var RectangleContainer = styled__default["default"].div(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n"])));
var RectangleItem = styled__default["default"].div(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? "#fff" : _ref2$background,
      _ref2$fontSize = _ref2.fontSize,
      fontSize = _ref2$fontSize === void 0 ? "36px" : _ref2$fontSize,
      _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? "Roboto" : _ref2$fontFamily,
      _ref2$fontWeight = _ref2.fontWeight,
      fontWeight = _ref2$fontWeight === void 0 ? 500 : _ref2$fontWeight,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "var(--grayscale-100-color)" : _ref2$color,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  return "\n        background: ".concat(background, ";\n        fontFamily: ").concat(fontFamily, ";\n        font-weight: ").concat(fontWeight, ";\n        line-height: 42px;\n        padding: 20px;\n        width: 50%;\n        text-align: center;\n\n        &, & *{\n            color: ").concat(color, ";\n            font-size: ").concat(fontSize, ";\n            text-transform: uppercase;\n        }\n\n        @media (max-width: ").concat(theme.breakpoints.sm, "px){\n          &{\n            width: 100%;\n            *{\n              font-size: 30px;\n            }\n          }\n        }\n    ");
});
var colors = [{
  background: "var(--primary-color)",
  color: "var(--grayscale-0-color)"
}, {
  background: "var(--complimentary-color)",
  color: "var(--grayscale-0-color)"
}];

function Rectangle$3(_ref3) {
  var data = _ref3.data;
  var rectangleItems = data.RectangleItem;
  return /*#__PURE__*/React__default$1["default"].createElement(RectangleContainer, {
    className: "RECTANGLE__CONTAINER"
  }, (rectangleItems || []).map(function (el, idx) {
    return /*#__PURE__*/React__default$1["default"].createElement(RectangleItem, {
      className: "RECTANGLE__CONTAINER_ITEM",
      background: colors[idx].background,
      color: colors[idx].color
    }, /*#__PURE__*/React__default$1["default"].createElement("a", {
      href: el.link
    }, /*#__PURE__*/React__default$1["default"].createElement(Title$q, null, el.text)));
  }));
}

var _templateObject$2f, _templateObject2$12, _templateObject3$T;

var Container$h = styled__default["default"].div(_templateObject$2f || (_templateObject$2f = _taggedTemplateLiteral(["\n  display: none;\n  @media only screen and (min-width: ", "px) {\n    display: flex;\n  }\n"])), breakpoints.md + 1);
var RateTabs = styled__default["default"].div(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  box-shadow: 0px 4px 6px 1px rgba(0, 0, 0, 0.25);\n"])));
var RateTab = styled__default["default"].a(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteral(["\n  padding: 13px 0px 13px 0px;\n  border-right: ", ";\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n  background: ", ";\n  line-height: 24px;\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  &:hover {\n    color: ", ";\n    background: ", ";\n  }\n"])), function (_ref) {
  var applyRightBorder = _ref.applyRightBorder;
  return applyRightBorder && "1px solid ".concat(getColors(colorsVariantsTypes.ULTRA_LIGHT));
}, function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref3$color;
  return getColors(color);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.LARGE : _ref4$size;
  return getTextSize(size);
}, function (_ref5) {
  var _ref5$background = _ref5.background,
      background = _ref5$background === void 0 ? colorsVariantsTypes.WHITE : _ref5$background;
  return getColors(background);
}, function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsVariantsTypes.WHITE : _ref6$color;
  return getColors(color);
}, function (_ref7) {
  var _ref7$background = _ref7.background,
      background = _ref7$background === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref7$background;
  return getColors(background);
});

function RatesTabs(_ref8) {
  var data = _ref8.data;

  if (!data) {
    return null;
  }

  var ratesTabs = data.ratesTabs;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$h, {
    className: "RATE_TABS_CONTAINER rate-tabs-container tw-x-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(RateTabs, {
    className: "RATE_TABS rate-tabs"
  }, ratesTabs.map(function (_ref9, i) {
    var id = _ref9.id,
        name = _ref9.name,
        tableRef = _ref9.tableRef;
    return /*#__PURE__*/React__default$1["default"].createElement(RateTab, {
      className: "RATE_TAB rate-tab",
      href: "#".concat(tableRef),
      applyRightBorder: i < ratesTabs.length - 1,
      key: id
    }, name);
  })));
}

function BodyText(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? bodyTextVariantsTypes.DECORATION_NONE : _ref$variant,
      data = _ref.data,
      _ref$buttonStylesProp = _ref.buttonStylesProps,
      buttonStylesProps = _ref$buttonStylesProp === void 0 ? {} : _ref$buttonStylesProp;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BODY_TEXT_CONTAINER tw-w-full"
  }, data.title && /*#__PURE__*/React__default$1["default"].createElement(Title$t, {
    className: "BODY_TEXT_TITLE"
  }, data.title), data.list && /*#__PURE__*/React__default$1["default"].createElement(List, {
    list: data.list,
    variant: variant
  }), data.linksList && /*#__PURE__*/React__default$1["default"].createElement(Links$2, {
    className: "BODY_TEXT_LINKS",
    links: data.linksList
  }), data.buttonName && /*#__PURE__*/React__default$1["default"].createElement(ButtonVariant, {
    className: "BODY_TEXT_BUTTON",
    variant: variant,
    data: data,
    buttonStylesProps: buttonStylesProps
  }));
}

var BodyText$1 = withErrorBoundary(BodyText);
var _excluded$1b = ["mainOfficeStyles"];

var _templateObject$2e, _templateObject2$11, _templateObject3$S, _templateObject4$F;

var H3$1 = styled__default["default"].h3(_templateObject$2e || (_templateObject$2e = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  font-weight: 600;\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Pre$1 = styled__default["default"].p(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.BLACK : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.SMALL : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
});

function Expanded(_ref7) {
  var _props$data$imageLoca, _props$data$imageLoca2;

  var _ref7$mainOfficeStyle = _ref7.mainOfficeStyles,
      mainOfficeStyles = _ref7$mainOfficeStyle === void 0 ? {} : _ref7$mainOfficeStyle,
      props = _objectWithoutProperties$1(_ref7, _excluded$1b);

  var _props$data = props === null || props === void 0 ? void 0 : props.data,
      _props$data$titleFont = _props$data.titleFontFamily,
      titleFontFamily = _props$data$titleFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _props$data$titleFont,
      _props$data$titleColo = _props$data.titleColor,
      titleColor = _props$data$titleColo === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _props$data$titleColo,
      _props$data$titleSize = _props$data.titleSize,
      titleSize = _props$data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _props$data$titleSize,
      _props$data$direction = _props$data.directionFontFamily,
      directionFontFamily = _props$data$direction === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _props$data$direction,
      _props$data$direction2 = _props$data.directionColor,
      directionColor = _props$data$direction2 === void 0 ? colorsVariantsTypes.BLACK : _props$data$direction2,
      _props$data$direction3 = _props$data.directionSize,
      directionSize = _props$data$direction3 === void 0 ? textSizesVariantsTypes.SMALL : _props$data$direction3;

  var BranchContainer = styled__default["default"].div(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteral(["\n    height: 100%;\n\n    ", "\n  "])), props.design === branchVariantsTypes.VERTICAL_LINE && styled.css(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteral(["\n      border-left: ", ";\n      padding-left: 8%;\n    "])), function (_ref8) {
    var _ref8$borderColor = _ref8.borderColor,
        borderColor = _ref8$borderColor === void 0 ? colorsTypes.SECONDARY : _ref8$borderColor;
    return "2px solid ".concat(borderColor);
  }));
  var initialMarginLeft = props.design === branchVariantsTypes.VERTICAL_LINE ? "" : "tw-ml-10";
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    id: props.data.branch_id,
    className: "BRANCH_EXPANDED tw-relative ".concat(initialMarginLeft, " tw-flex tw-flex-col tw-mt-16")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__CONTAINER tw-flex tw-flex-wrap tw-justify-between"
  }, /*#__PURE__*/React__default$1["default"].createElement(H3$1, {
    className: "BRANCH_EXPANDED__TITLE tw-mr-5",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.VERY_BIG,
    color: titleColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK
  }, props.data.title), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__CONTAINER__BOX__PRE tw-flex tw-items-center sm:tw-flex-row sm:tw-text-right"
  }, /*#__PURE__*/React__default$1["default"].createElement(Pre$1, {
    className: "BRANCH_EXPANDED_PRE  tw-leading-none tw-mr-2 tw-whitespace-pre-line",
    fontFamily: directionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: directionSize || textSizesVariantsTypes.SMALL,
    color: directionColor || colorsVariantsTypes.BLACK
  }, props.data.direction), /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    className: "BRANCH_EXPANDED__ICON",
    icon: iconTypes.PIN
  }))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__BEFORE_MAIN_OFFICE__CONTAINER tw-flex tw-flex-wrap tw-justify-between tw-mt-10"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__BEFORE_MAIN_OFFICE__CONTAINER__BOX sm:tw-w-5/12 tw-pr-6 tw-mb-10 md:tw-mb-0"
  }, /*#__PURE__*/React__default$1["default"].createElement(BranchContainer, {
    className: "BRANCH_EXPANDED__BEFORE_MAIN_OFFICE__CONTAINER__BOX__2",
    borderColor: mainOfficeStyles === null || mainOfficeStyles === void 0 ? void 0 : mainOfficeStyles.borderColor
  }, /*#__PURE__*/React__default$1["default"].createElement(MainOffice, {
    data: props.data,
    mainOfficeStyles: mainOfficeStyles
  }))), (_props$data$imageLoca = props.data.imageLocation) !== null && _props$data$imageLoca !== void 0 && _props$data$imageLoca.url ? /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__CONTAINER_MAP_AND_IMAGE  tw-overflow-hidden tw-rounded-xl"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__CONTAINER_GOOGLE_MAP"
  }, /*#__PURE__*/React__default$1["default"].createElement(BlossomGoogleMap, {
    lat: props.data.latitudeMap,
    lng: props.data.longitudeMap
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__CONTAINER_IMAGE_LOCATION"
  }, /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: props.data.imageLocation.url,
    className: "BRANCH_EXPANDED__IMAGE__LOCATION tw-object-cover tw-rounded-xl",
    alt: ((_props$data$imageLoca2 = props.data.imageLocation) === null || _props$data$imageLoca2 === void 0 ? void 0 : _props$data$imageLoca2.alternativeText) || props.data.imageLocation.hash
  })))) : /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED__CONTAINER_MAP tw-w-full sm:tw-w-7/12 tw-rounded-xl tw-overflow-hidden"
  }, /*#__PURE__*/React__default$1["default"].createElement(BlossomGoogleMap, {
    lat: props.data.latitudeMap,
    lng: props.data.longitudeMap
  }))));
}

var _excluded$1a = ["variant"];

function Branch(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? branchVariantsTypes.EXPANDED : _ref$variant,
      props = _objectWithoutProperties$1(_ref, _excluded$1a);

  if (!props.data) return null;

  switch (variant) {
    case branchVariantsTypes.EXPANDED:
      return /*#__PURE__*/React__default$1["default"].createElement(Expanded, props);

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

var Branch$1 = withErrorBoundary(Branch);

function BranchExpandedComponent(_ref) {
  var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "BRANCH_EXPANDED_COMPONENT tw-x-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
    data: data,
    design: branchVariantsTypes.VERTICAL_LINE
  }, branchProps, {
    mainOfficeStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
      title: _objectSpread2({
        color: colorsTypes.SECONDARY
      }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
      // for documentation pourposes:
      officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
        first: _objectSpread2({
          color: colorsTypes.BLACK
        }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.first) || {})
      }),
      contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
        title: _objectSpread2({
          color: colorsTypes.SECONDARY
        }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {})
      })
    })
  })));
}

function Section(_ref) {
  var buttonName = _ref.buttonName,
      buttonUrl = _ref.buttonUrl,
      _ref$buttonStylesProp = _ref.buttonStylesProps,
      buttonStylesProps = _ref$buttonStylesProp === void 0 ? {} : _ref$buttonStylesProp;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_SECTION tw-pt-8"
  }, /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    className: "CALLOUT_SECTION__BUTTON"
  }, buttonStylesProps, {
    is: "a",
    href: buttonUrl
  }), buttonName));
}

var _templateObject$2d, _templateObject2$10, _templateObject3$R;

var Container$g = styled__default["default"].div(_templateObject$2d || (_templateObject$2d = _taggedTemplateLiteral(["\n  background: ", ";\n"])), function (_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$backgroundColor;
  return getColors(backgroundColor);
});
var H3 = styled__default["default"].h3(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.WHITE : _ref2$color;
  return getColors(color);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(size);
});
var Pre = styled__default["default"].p(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref5$color;
  return getColors(color);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref7$size;
  return getTextSize(size);
});

function Callout$3(_ref8) {
  var data = _ref8.data;
  if (!data) return null;
  var _data$backgroundColor = data.backgroundColor,
      backgroundColor = _data$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _data$backgroundColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.WHITE : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.PRIMARY : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$g, {
    className: "CALLOUT_BUTTON tw-p-10 tw-rounded-xl",
    backgroundColor: colorsVariantsTypes[backgroundColor || colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT]
  }, /*#__PURE__*/React__default$1["default"].createElement(H3, {
    className: "CALLOUT_BUTTON__TITLE CalloutButton__title bl-text-grayscale bl-text-xl tw-mb-5",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.WHITE],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, data.title), /*#__PURE__*/React__default$1["default"].createElement(Pre, {
    className: "CALLOUT_BUTTON__DESCRIPTION tw-whitespace-pre-line tw-break-all bl-font-primary tw-mb-8 sm:bl-text-lg",
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.PRIMARY],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.VERY_LARGE]
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    is: "a",
    className: "CALLOUT_BUTTON__BUTTON",
    href: data.href
  }, data.button));
}

var _excluded$19 = ["data", "variant"];

function ButtonVariant(_ref) {
  var data = _ref.data,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? bodyTextVariantsTypes.DECORATION_NONE : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$19);

  switch (variant) {
    case bodyTextVariantsTypes.DECORATION_NONE:
      return /*#__PURE__*/React__default$1["default"].createElement(Section, _extends$g({}, otherProps, {
        buttonName: data.buttonName,
        buttonUrl: data.buttonUrl
      }));

    case bodyTextVariantsTypes.DECORATION_DOTTEN:
      return /*#__PURE__*/React__default$1["default"].createElement(Callout$3, _extends$g({
        data: data
      }, otherProps));

    case buttonVariantsTypes.CALLOUT:
      return /*#__PURE__*/React__default$1["default"].createElement(Callout$3, _extends$g({
        data: data
      }, otherProps));

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

var _templateObject$2c, _templateObject2$$, _templateObject3$Q, _templateObject4$E, _templateObject5$y; // Gradient Container


var Container$f = styled__default["default"].div(_templateObject$2c || (_templateObject$2c = _taggedTemplateLiteral([""])));
var LineDecorationDesktop = styled__default["default"].div(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteral(["\n  @media (min-width: ", "px) {\n    border-left: ", ";\n  }\n"])), breakpoints.md, function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _ref$borderColor;
  return "solid 2px ".concat(getColors(borderColor));
});
var LineDecorationMobile = styled__default["default"].div(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteral(["\n  @media (max-width: ", "px) {\n    background: ", ";\n  }\n"])), breakpoints.md - 1, function (_ref2) {
  var _ref2$borderColor = _ref2.borderColor,
      borderColor = _ref2$borderColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _ref2$borderColor;
  return getColors(borderColor);
});
var H4 = styled__default["default"].h3(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref3$color;
  return getColors(color);
}, function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref4$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref5$size;
  return getTextSize(size);
});
var P$3 = styled__default["default"].div(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  size: ", ";\n"])), function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsVariantsTypes.BLACK : _ref6$color;
  return getColors(color);
}, function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref7$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref8$size;
  return getTextSize(size);
}); // const H3 = styled.h3`
//   color: var(--primary-150-color);
// `;
// const P = styled.div`
//   color: var(--grayscale-100-color);
// `;

function CalloutMobileAppsCenteredNoBackground(_ref9) {
  var _data$mobileAppImageA, _data$mobileAppImageA2, _data$mobileAppImageB, _data$mobileAppImageB2;

  var data = _ref9.data;
  if (!data || !data.mobileAppImageA && !data.mobileAppImageB) return null;
  var _data$lineColor = data.lineColor,
      lineColor = _data$lineColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _data$lineColor,
      _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.SMALL : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$f, {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND tw-py-16 tw-text-center"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER tw-items-center tw-text-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(LineDecorationDesktop, {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__HEADER md:tw-pl-6 tw-mr-2 sm:tw-mr-0",
    borderColor: colorsVariantsTypes.TRANSPARENT
  }, data.title !== null && /*#__PURE__*/React__default$1["default"].createElement(PrimaryText, {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__HEADER__TITLE"
  }, /*#__PURE__*/React__default$1["default"].createElement(H4, {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__HEADER__TITLE__TEXT CalloutMobileApps__title tw-font-bold bl-text-xl tw-py-2",
    fontFamily: fontsFamiliesVariantsTypes[titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY],
    color: colorsVariantsTypes[titleColor || colorsVariantsTypes.PRIMARY_DARK],
    size: textSizesVariantsTypes[titleSize || textSizesVariantsTypes.VERY_BIG]
  }, data.title)), /*#__PURE__*/React__default$1["default"].createElement(LineDecorationMobile, {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__DIVIDER bl-bg-primary-50 tw-my-4 md:tw-hidden",
    borderColor: colorsVariantsTypes[lineColor || colorsVariantsTypes.VERY_ULTRA_LIGHT],
    style: {
      height: "2px"
    }
  }), /*#__PURE__*/React__default$1["default"].createElement(P$3, {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__DESCRIPTION bl-text-grayscale-100",
    fontFamily: fontsFamiliesVariantsTypes[descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY],
    color: colorsVariantsTypes[descriptionColor || colorsVariantsTypes.BLACK],
    size: textSizesVariantsTypes[descriptionSize || textSizesVariantsTypes.SMALL]
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__CONTENT tw-flex tw-w-full md:tw-my-auto tw-py-4 tw-justify-center"
  }, ((_data$mobileAppImageA = data.mobileAppImageA) === null || _data$mobileAppImageA === void 0 ? void 0 : _data$mobileAppImageA.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__CONTENT__LINK tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    style: {
      top: 0,
      left: 0
    },
    className: "tw-w-full tw-h-full tw-absolute",
    href: data.mobileAppLinkA,
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__CONTENT__LINK__IMAGE tw-w-auto tw-h-12 tw-object-cover tw-rounded-md",
    src: data.mobileAppImageA.url,
    alt: ((_data$mobileAppImageA2 = data.mobileAppImageA) === null || _data$mobileAppImageA2 === void 0 ? void 0 : _data$mobileAppImageA2.alternativeText) || data.mobileAppImageA.hash
  })), ((_data$mobileAppImageB = data.mobileAppImageB) === null || _data$mobileAppImageB === void 0 ? void 0 : _data$mobileAppImageB.url) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__CONTENT__LINK tw-relative tw-ml-6 lg:tw-ml-8"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    style: {
      top: 0,
      left: 0
    },
    href: data.mobileAppLinkB,
    target: "_blank",
    rel: "noreferrer",
    className: "tw-w-full tw-h-full tw-absolute"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: data.mobileAppImageB.url,
    className: "CALLOUT_MOBILE_APPS_CENTERED_NO_BACKGROUND__CONTAINER__CONTENT__LINK__IMAGE tw-w-auto tw-h-12 tw-object-cover tw-rounded-md",
    alt: ((_data$mobileAppImageB2 = data.mobileAppImageB) === null || _data$mobileAppImageB2 === void 0 ? void 0 : _data$mobileAppImageB2.alternativeText) || data.mobileAppImageB.hash
  }))))));
}

var _excluded$18 = ["variant"];

function Callout$1(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties$1(_ref, _excluded$18);

  switch (variant) {
    case calloutVariantsTypes.MOBILE_APPS:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutMobileApps, props);

    case calloutVariantsTypes.BUTTON:
      return /*#__PURE__*/React__default$1["default"].createElement(ButtonVariant, _extends$g({
        variant: buttonVariantsTypes.CALLOUT
      }, props));

    case calloutVariantsTypes.DATA:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutData, props);

    case calloutVariantsTypes.TEXT:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutText, props);

    case calloutVariantsTypes.MOBILE_APPS_GRADIENTS_DARK:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutMobileAppsGradientsDark, props);

    case calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutMobileAppsGradientsLight, props);

    case calloutVariantsTypes.IMAGE_WITH_GRADIENT:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutWithGradient$1, props);

    case calloutVariantsTypes.IMAGE_WITH_GRADIENT_AND_PADDING:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutWithGradientAndPadding$1, props);

    case calloutVariantsTypes.MOBILE_APPS_CENTERED_NO_BACKGROUND:
      return /*#__PURE__*/React__default$1["default"].createElement(CalloutMobileAppsCenteredNoBackground, props);

    default:
      throw new Error("Invalid Callout variant: ".concat(variant));
  }
}

var Callout$2 = withErrorBoundary(Callout$1);
var _excluded$17 = ["data"];

function CalloutButtonWithDividers(_ref) {
  var data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$17);

  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
    className: "CALLOUT_BUTTON_WITH_DIVIDERS_MAIN",
    variant: dividersVariantsTypes.CALLOUT,
    childrenVariant: calloutVariantsTypes.BUTTON,
    data: data
  }, otherProps));
}

var _excluded$16 = ["data"];

function CalloutDataWithDividers(_ref) {
  var data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$16);

  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
    className: "CALLOUT_DATA_WITH_DIVIDERS_MAIN",
    variant: dividersVariantsTypes.CALLOUT,
    childrenVariant: calloutVariantsTypes.DATA,
    data: data
  }, otherProps));
}

function CalloutMobileAppsWithDividers(_ref) {
  var data = _ref.data,
      _ref$buttonStylesProp = _ref.buttonStylesProps,
      buttonStylesProps = _ref$buttonStylesProp === void 0 ? {} : _ref$buttonStylesProp;

  switch (data.Type) {
    case calloutVariantsTypes.MOBILE_APPS_GRADIENTS_DARK:
      return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.CALLOUT,
        childrenVariant: calloutVariantsTypes.MOBILE_APPS_GRADIENTS_DARK // if Gradients wanted, use MOBILE_APPS_GRADIENTS
        ,
        data: data,
        buttonStylesProps: buttonStylesProps
      });

    case calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT:
      return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.CALLOUT,
        childrenVariant: calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT // if Gradients wanted, use MOBILE_APPS_GRADIENTS
        ,
        data: data,
        buttonStylesProps: buttonStylesProps
      });

    case calloutVariantsTypes.MOBILE_APPS_CENTERED_NO_BACKGROUND:
      return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.CALLOUT,
        childrenVariant: calloutVariantsTypes.MOBILE_APPS_CENTERED_NO_BACKGROUND // if Gradients wanted, use MOBILE_APPS_GRADIENTS
        ,
        data: data,
        buttonStylesProps: buttonStylesProps
      });

    default:
      return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.CALLOUT,
        childrenVariant: calloutVariantsTypes.MOBILE_APPS // if Gradients wanted, use MOBILE_APPS_GRADIENTS
        ,
        data: data,
        buttonStylesProps: buttonStylesProps
      });
  }
}

function CalloutTextWithDividers(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.CALLOUT,
    childrenVariant: calloutVariantsTypes.TEXT,
    data: data
  });
}

var _templateObject$2b;

var ConfirmModalText = styled__default["default"].p(_templateObject$2b || (_templateObject$2b = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.BLACK : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.LARGE : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});

function ConfirmationModal(_ref4) {
  var _ref4$speedBumpStyles = _ref4.speedBumpStyles,
      speedBumpStyles = _ref4$speedBumpStyles === void 0 ? {
    acceptButton: {
      withoutBorderRadius: true,
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      fontSize: textSizesVariantsTypes.NORMAL,
      filledBackgroundColor: colorsTypes.PRIMARY_DARK,
      filledOutlineBorderColor: colorsTypes.PRIMARY_DARK,
      filledTextColor: colorsTypes.WHITE,
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
      hoverFilledTextColor: colorsTypes.PRIMARY_DARK
    },
    cancelButton: {
      withoutBorderRadius: true,
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      fontSize: textSizesVariantsTypes.NORMAL,
      filledBackgroundColor: colorsTypes.PRIMARY_DARK,
      filledOutlineBorderColor: colorsTypes.PRIMARY_DARK,
      filledTextColor: colorsTypes.WHITE,
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
      hoverFilledTextColor: colorsTypes.PRIMARY_DARK
    }
  } : _ref4$speedBumpStyles,
      color = _ref4.color,
      size = _ref4.size,
      fontFamily = _ref4.fontFamily,
      _ref4$message = _ref4.message,
      message = _ref4$message === void 0 ? "" : _ref4$message,
      _ref4$cancelBtnText = _ref4.cancelBtnText,
      cancelBtnText = _ref4$cancelBtnText === void 0 ? "Cancel" : _ref4$cancelBtnText,
      _ref4$acceptBtnText = _ref4.acceptBtnText,
      acceptBtnText = _ref4$acceptBtnText === void 0 ? "Accept" : _ref4$acceptBtnText,
      _ref4$borderWithRadiu = _ref4.borderWithRadius,
      borderWithRadius = _ref4$borderWithRadiu === void 0 ? true : _ref4$borderWithRadiu,
      _ref4$isModalVisible = _ref4.isModalVisible,
      isModalVisible = _ref4$isModalVisible === void 0 ? function () {
    return null;
  } : _ref4$isModalVisible,
      _ref4$closeModal = _ref4.closeModal,
      closeModal = _ref4$closeModal === void 0 ? function () {
    return null;
  } : _ref4$closeModal,
      _ref4$onAccept = _ref4.onAccept,
      onAccept = _ref4$onAccept === void 0 ? function () {
    return null;
  } : _ref4$onAccept;
  return /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    show: isModalVisible,
    closeModal: closeModal,
    borderWithRadius: borderWithRadius
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONFIRMATION_MODAL tw-max-w-md tw-relative tw-p-6 tw-flex-auto tw-mt-20 tw-pt-0 tw-whitespace-pre-line"
  }, /*#__PURE__*/React__default$1["default"].createElement(ConfirmModalText, {
    className: "CONFIRMATION_MODAL__TEXT",
    color: color,
    size: size,
    fontFamily: fontFamily
  }, message)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONFIRMATION_MODAL__BUTTON__CONTAINER tw-flex tw-items-center tw-justify-between tw-p-4"
  }, /*#__PURE__*/React__default$1["default"].createElement(Button$2 // withoutBorderRadius={!borderWithRadius}
  // styleType={buttonStyleTypes.STANDARD}
  , _extends$g({
    className: "CONFIRMATION_MODAL__CANCEL_BUTTON tw-mr-2 tw-flex-1",
    onClick: function onClick() {
      return closeModal();
    } // outline
    // transparent
    // dark

  }, speedBumpStyles.cancelButton), cancelBtnText), /*#__PURE__*/React__default$1["default"].createElement(Button$2 // withoutBorderRadius={!borderWithRadius}
  // styleType={buttonStyleTypes.STANDARD}
  , _extends$g({
    className: "CONFIRMATION_MODAL__ACCEPT__BUTTON tw-ml-2 tw-flex-1" // fill={buttonFillTypes.FILLED}
    ,
    onClick: function onClick() {
      return onAccept();
    } // hoverColor
    // hoverBackgroundColor="var(--primary-80-color)"

  }, speedBumpStyles.acceptButton), acceptBtnText)));
}

function Contact$3(_ref) {
  var data = _ref.data,
      inputStyles = _ref.inputStyles,
      _ref$buttonCustomStyl = _ref.buttonCustomStyles,
      buttonCustomStyles = _ref$buttonCustomStyl === void 0 ? {} : _ref$buttonCustomStyl,
      _ref$formContainerSty = _ref.formContainerStyles,
      formContainerStyles = _ref$formContainerSty === void 0 ? {} : _ref$formContainerSty,
      _ref$noGap = _ref.noGap,
      noGap = _ref$noGap === void 0 ? false : _ref$noGap;
  if (!data) return null;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_REGULAR tw-flex tw-flex-wrap tw-justify-between"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_REGULAR__MESSAGE__CONTAINER md:tw-w-6/12 lg:tw-w-7/12"
  }, /*#__PURE__*/React__default$1["default"].createElement(Message, {
    noGap: noGap,
    inputStyles: inputStyles,
    buttonCustomStyles: buttonCustomStyles,
    data: data,
    formTemplateJson: contactFormTemplate,
    formContainerStyles: formContainerStyles
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_REGULAR__MAIN_CONTACT__CONTAINER md:tw-w-5/12 lg:tw-w-4/12"
  }, /*#__PURE__*/React__default$1["default"].createElement(MainContact, {
    data: data
  })));
}

var ContactRegular = withErrorBoundary(Contact$3);

var _templateObject$2a;

var Container$e = styled__default["default"].div(_templateObject$2a || (_templateObject$2a = _taggedTemplateLiteral(["\n  background-color: var(--primary-6-color);\n"])));

function Contact$2(_ref) {
  var _customComponentStyle;

  var data = _ref.data,
      inputStyles = _ref.inputStyles,
      _ref$noGap = _ref.noGap,
      noGap = _ref$noGap === void 0 ? false : _ref$noGap,
      _ref$buttonCustomStyl = _ref.buttonCustomStyles,
      buttonCustomStyles = _ref$buttonCustomStyl === void 0 ? {} : _ref$buttonCustomStyl,
      _ref$formContainerSty = _ref.formContainerStyles,
      formContainerStyles = _ref$formContainerSty === void 0 ? {} : _ref$formContainerSty,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Submit Message" : _ref$buttonText,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS,
      _ref$customIconsAlt = _ref.customIconsAlt,
      customIconsAlt = _ref$customIconsAlt === void 0 ? "" : _ref$customIconsAlt,
      _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon;
  if (!data) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$e, {
    className: "CONTACT_BACKGROUND__COLOR"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("CONTACT_BACKGROUND tw-flex tw-flex-wrap tw-justify-between tw-x-container tw-pt-10", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_BACKGROUND__MESSAGE__CONTAINER md:tw-w-6/12 lg:tw-w-7/12"
  }, /*#__PURE__*/React__default$1["default"].createElement(Message, {
    noGap: noGap,
    buttonText: buttonText,
    inputStyles: (customComponentStyles === null || customComponentStyles === void 0 ? void 0 : (_customComponentStyle = customComponentStyles.contact) === null || _customComponentStyle === void 0 ? void 0 : _customComponentStyle.inputStyles) || inputStyles,
    buttonCustomStyles: buttonCustomStyles,
    data: data,
    formTemplateJson: contactFormTemplate,
    formContainerStyles: formContainerStyles
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_BACKGROUND__MAIN_CONTACT__CONTAINER md:tw-w-5/12 lg:tw-w-4/12 tw-pt-16"
  }, /*#__PURE__*/React__default$1["default"].createElement(MainContact, {
    data: data,
    customIconsAlt: customIconsAlt,
    rectangle: true
  }))));
}

var ContactBackground = withErrorBoundary(Contact$2);
var _excluded$15 = ["variant"];

function Contact(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties$1(_ref, _excluded$15);

  var externalVariant = props.data.variant;
  if (!props.data) return null;

  switch (externalVariant || variant) {
    case contactVariantsTypes.REGULAR:
      return /*#__PURE__*/React__default$1["default"].createElement(ContactRegular, props);

    case contactVariantsTypes.BACKGROUND:
      return /*#__PURE__*/React__default$1["default"].createElement(ContactBackground, props);

    case undefined:
      return /*#__PURE__*/React__default$1["default"].createElement(ContactBackground, props);

    default:
      throw new Error("Invalid Contact variant: ".concat(variant));
  }
}

var Contact$1 = withErrorBoundary(Contact);

var _templateObject$29, _templateObject2$_, _templateObject3$P, _templateObject4$D, _templateObject5$x;

var CustomButtonsBox = styled__default["default"].div(_templateObject$29 || (_templateObject$29 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n"])), function (_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? "left" : _ref$position;

  switch (position) {
    case "center":
      return "center";

    case "right":
      return "end";

    default:
      return "start";
  }
});
var CustomButton$d = styled__default["default"](Button$2)(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: ", ";\n\n  margin-right: ", ";\n"])), function (_ref2) {
  var _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? "left" : _ref2$position;

  switch (position) {
    case "center":
      return "auto";

    case "right":
      return "10px";

    default:
      return "0px";
  }
}, function (_ref3) {
  var _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? "left" : _ref3$position;

  switch (position) {
    case "center":
      return "auto";

    case "right":
      return "0px";

    default:
      return "10px";
  }
});
var ModalContainer = styled__default["default"].div(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  max-width: 600px;\n  min-width: 250px;\n  min-height: 300px;\n  padding: 100px 30px 30px 40px;\n"])));
var ModalTitle = styled__default["default"].h5(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 39px;\n  color: var(--grayscale-100-color);\n  margin-bottom: 10px;\n"])));
var ModalMessage = styled__default["default"].p(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  white-space: pre-line;\n  font-size: 22px;\n  margin-bottom: 10px;\n"])));

function CustomButtons(_ref4) {
  var _ref4$data = _ref4.data,
      data = _ref4$data === void 0 ? {} : _ref4$data;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      dataModal = _useState2[0],
      setDataModal = _useState2[1];

  function getClassStyle() {
    var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "primary";

    switch (style) {
      case "secondary":
        return "CUSTOM_BUTTON__SECONDARY";

      case "tertiary":
        return "CUSTOM_BUTTON__TERTIARY";

      default:
        return "CUSTOM_BUTTON_PRIMARY";
    }
  } // leftButtonLink = "",
  //   leftButtonName = "",
  //   message = "",
  //   rightButtonLink = "",
  //   rightButtonName = "",
  //   title = "",


  function openModal(item) {
    setDataModal(item);
    showModal();
  }

  var _data$Position = data.Position,
      Position = _data$Position === void 0 ? "left" : _data$Position,
      _data$buttons = data.buttons,
      buttons = _data$buttons === void 0 ? [] : _data$buttons,
      _data$buttonWithModal = data.buttonWithModal,
      buttonWithModal = _data$buttonWithModal === void 0 ? [] : _data$buttonWithModal;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CUSTOM_BUTTONS__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(CustomButtonsBox, {
    className: "tw-x-container CUSTOM_BUTTONS__BOX",
    position: Position
  }, buttons.length > 0 && buttons.map(function (item) {
    return /*#__PURE__*/React__default$1["default"].createElement(CustomButton$d, {
      is: "a",
      position: Position,
      key: nanoid(),
      href: item === null || item === void 0 ? void 0 : item.link,
      className: classnames("CUSTOM_BUTTON", getClassStyle(item === null || item === void 0 ? void 0 : item.styles))
    }, item === null || item === void 0 ? void 0 : item.buttonName);
  })), /*#__PURE__*/React__default$1["default"].createElement(CustomButtonsBox, {
    className: "tw-x-container CUSTOM_BUTTONS__BOX",
    position: Position
  }, buttonWithModal.length > 0 && buttonWithModal.map(function (item) {
    return /*#__PURE__*/React__default$1["default"].createElement(CustomButton$d, {
      is: "button",
      type: "button",
      position: Position,
      key: nanoid(),
      className: classnames("CUSTOM_BUTTON", getClassStyle(item === null || item === void 0 ? void 0 : item.styles)),
      onClick: function onClick() {
        return openModal(item);
      }
    }, item === null || item === void 0 ? void 0 : item.modalButtonText);
  })), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(ModalContainer, {
    className: "tw-p-20"
  }, /*#__PURE__*/React__default$1["default"].createElement(ModalTitle, {
    className: "MODAL_TITLE"
  }, dataModal === null || dataModal === void 0 ? void 0 : dataModal.title), /*#__PURE__*/React__default$1["default"].createElement(ModalMessage, null, dataModal === null || dataModal === void 0 ? void 0 : dataModal.message), /*#__PURE__*/React__default$1["default"].createElement("div", null, /*#__PURE__*/React__default$1["default"].createElement(CustomButton$d, {
    is: "a",
    position: Position,
    key: nanoid(),
    href: dataModal === null || dataModal === void 0 ? void 0 : dataModal.leftButtonLink,
    className: "CUSTOM_BUTTON CUSTOM_BUTTON__LEFT__BUTTON"
  }, dataModal === null || dataModal === void 0 ? void 0 : dataModal.leftButtonName), /*#__PURE__*/React__default$1["default"].createElement(CustomButton$d, {
    is: "a",
    position: Position,
    key: nanoid(),
    href: dataModal === null || dataModal === void 0 ? void 0 : dataModal.rightButtonLink,
    className: "CUSTOM_BUTTON CUSTOM_BUTTON__RIGHT__BUTTON"
  }, dataModal === null || dataModal === void 0 ? void 0 : dataModal.rightButtonName)))));
}

function CustomPageFeature(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  var keys = Object.keys(data);
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, keys.map(function (key) {
    var _data$FeaturesV, _data$Tables;

    switch (key) {
      case customPageFeatureVariantsTypes.PAGE_HEADER_GRADIENT:
        return /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, {
          key: "PageHeader-key-".concat(key),
          variant: pageHeaderVariantsTypes.GRADIENTS,
          color: pageHeaderColorVariantsTypes.PRIMARY,
          data: data.PageHeaderGradient[0]
        });

      case customPageFeatureVariantsTypes.FEATURES_V2:
        return /*#__PURE__*/React__default$1["default"].createElement("div", {
          key: "Feature-key-".concat(key),
          className: "CUSTOM_PAGE_FEATURE tw-container"
        }, (_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
          return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
            className: "CUSTOM_PAGE_FEATURE_FRAGMENT",
            key: "FeatureV2-".concat(index)
          }, data.FeaturesV2 && /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
            variant: dividersVariantsTypes.DIVIDER,
            className: "tw-mb-20 md:tw-mb-48"
          }), /*#__PURE__*/React__default$1["default"].createElement(Feature, {
            className: "CUSTOM_PAGE_FEATURE_FEATURE",
            variant: featureVariantsTypes.V2,
            data: feature
          }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
            variant: dividersVariantsTypes.DIVIDER,
            className: "CUSTOM_PAGE_FEATURE__DIVIDER tw-mb-20 md:tw-mb-48"
          }));
        }));

      case customPageFeatureVariantsTypes.TABLES:
        return /*#__PURE__*/React__default$1["default"].createElement("div", {
          key: "Table-key-".concat(key),
          className: "CUSTOM_PAGE_FEATURE tw-container"
        }, (_data$Tables = data.Tables) === null || _data$Tables === void 0 ? void 0 : _data$Tables.map(function (table, index) {
          return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
            key: "TableContent-".concat(index)
          }, /*#__PURE__*/React__default$1["default"].createElement(Table$1, {
            title: table.title,
            description: table.description,
            HeadTitles: table.HeadTitles,
            TableItems: table.TableItems
          }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
            variant: dividersVariantsTypes.DIVIDER,
            className: "CUSTOM_PAGE_FEATURE__DIVIDER tw-my-6"
          }));
        }));

      default:
        return null;
    }
  }));
}

function CustomPageGeneric(_ref) {
  var data = _ref.data;
  var keys = Object.keys(data);
  return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, keys.map(function (key) {
    var _data$TextsLists, _data$Tables;

    switch (key) {
      case customPageGenericVariantsTypes.PAGE_HEADER_GRADIENTS:
        return /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, {
          key: "PageHeader-key-".concat(key),
          variant: pageHeaderVariantsTypes.GRADIENTS,
          color: pageHeaderColorVariantsTypes.PRIMARY,
          data: data.PageHeaderGradients
        });

      case customPageGenericVariantsTypes.TEXTS_LISTS:
        return /*#__PURE__*/React__default$1["default"].createElement("div", {
          key: "BodyText-key-".concat(key),
          className: "CUSTOM_PAGE_GENERIC tw-container"
        }, (_data$TextsLists = data.TextsLists) === null || _data$TextsLists === void 0 ? void 0 : _data$TextsLists.map(function (item, index) {
          var isListDotten = item.listDecoration === "none";
          return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
            key: "TextsList-".concat(index)
          }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
            variant: dividersVariantsTypes.DIVIDER,
            className: "CUSTOM_PAGE_GENERIC__DIVIDER tw-my-7"
          }), /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, {
            buttonStylesProps: {
              textColor: colorsTypes.WHITE,
              dark: true,
              buttonFill: buttonFillTypes.FILLED,
              buttonHoverColor: true,
              buttonWithoutBorderRadius: false,
              buttonHoverBackgroundColor: colorsTypes.ULTRA_DARK,
              buttonHoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
              buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK
            },
            data: item,
            variant: isListDotten ? bodyTextVariantsTypes.DECORATION_NONE : bodyTextVariantsTypes.DECORATION_DOTTEN
          }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
            variant: dividersVariantsTypes.DIVIDER,
            className: "CUSTOM_PAGE_GENERIC__DIVIDER tw-my-7"
          }));
        }));

      case customPageGenericVariantsTypes.TABLES:
        return /*#__PURE__*/React__default$1["default"].createElement("div", {
          key: "Table-key-".concat(key),
          className: "CUSTOM_PAGE_GENERIC tw-container"
        }, (_data$Tables = data.Tables) === null || _data$Tables === void 0 ? void 0 : _data$Tables.map(function (table, index) {
          return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
            key: "TableContent-".concat(index)
          }, /*#__PURE__*/React__default$1["default"].createElement(Table$1, {
            title: table.title,
            description: table.description,
            HeadTitles: table.HeadTitles,
            TableItems: table.TableItems
          }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
            variant: dividersVariantsTypes.DIVIDER,
            className: "CUSTOM_PAGE_GENERIC__DIVIDER tw-my-6"
          }));
        }));

      default:
        return null;
    }
  }));
}

function DefaultFallbackComponent() {
  // TODO: Launch some error alert using something like Rollup
  return null;
}

var _excluded$14 = ["variant", "data", "buttonStylesProps", "applyMaxWidthContainer"];

function Callout(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? calloutVariantsTypes.NONE : _ref$variant,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$buttonStylesProp = _ref.buttonStylesProps,
      buttonStylesProps = _ref$buttonStylesProp === void 0 ? {} : _ref$buttonStylesProp,
      _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$14);

  var dataFormat = data;

  var WidthContainer = function WidthContainer() {
    if (variant === calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT || variant === calloutVariantsTypes.MOBILE_APPS_GRADIENTS_DARK) return null;
    if (applyMaxWidthContainer) return "tw-x-container max-width-container";
    return "tw-x-container";
  };

  if (variant === calloutVariantsTypes.TEXT) {
    dataFormat = {
      title: data === null || data === void 0 ? void 0 : data.title,
      list: [{
        item: data === null || data === void 0 ? void 0 : data.description
      }]
    }; // workaround, when you add the "Callout Text" component in cms, modify this component
  }

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: WidthContainer()
  }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "tw-my-7 DIVIDER__CALLOUT__1"
  }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
    variant: variant,
    data: dataFormat,
    buttonStylesProps: buttonStylesProps
  }, otherProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "tw-my-7 DIVIDER__CALLOUT__2"
  }));
}

var _excluded$13 = ["variant", "data", "applyMaxWidthContainer"];

var _templateObject$28;

var Container$d = styled__default["default"].div(_templateObject$28 || (_templateObject$28 = _taggedTemplateLiteral([""])));

function FeatureWithDividerV1$1(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? featureVariantsTypes.V1 : _ref$variant,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$13);

  switch (variant) {
    case featureVariantsTypes.V6:
      return /*#__PURE__*/React__default$1["default"].createElement(Container$d, null, /*#__PURE__*/React__default$1["default"].createElement(Feature, {
        variant: variant,
        data: data
      }));

    default:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: classnames("FEATURE_WITH_DIVIDERS_MAIN tw-x-container", applyMaxWidthContainer && "max-width-container")
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
        variant: dividersVariantsTypes.DIVIDER
      }, otherProps, {
        className: "DIVIDER__FEATURE__1 tw-mb-20 md:tw-mb-48"
      })), /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        variant: variant,
        data: data
      }, otherProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
        variant: dividersVariantsTypes.DIVIDER
      }, otherProps, {
        className: "DIVIDER__FEATURE__2 tw-mb-20 md:tw-mb-48"
      })));
  }
}

var _excluded$12 = ["data", "variant", "typeOfItems"];

function Products$1(_ref) {
  var data = _ref.data,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? productsVariantsTypes.LIST : _ref$variant,
      _ref$typeOfItems = _ref.typeOfItems,
      typeOfItems = _ref$typeOfItems === void 0 ? productVariantsTypes.OUTLINE : _ref$typeOfItems,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$12);

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "DIVIDER__PRODUCT__1 tw-my-7"
  }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
    data: data,
    variant: variant,
    typeOfItems: typeOfItems
  }, otherProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "DIVIDER__PRODUCT__2 tw-my-7"
  }));
}

function Divider(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dividerVariantsTypes.HORIZONTAL : _ref$variant,
      className = _ref.className;

  switch (variant) {
    case dividerVariantsTypes.VERTICAL:
      return /*#__PURE__*/React__default$1["default"].createElement(VerticalDivider, {
        className: className
      });

    default:
      return /*#__PURE__*/React__default$1["default"].createElement(HorizontalDivider, {
        className: className
      });
  }
}

var _excluded$11 = ["variant", "data", "customComponentStyles"];

function Hero$2(_ref) {
  var _data$;

  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? heroVariantsTypes.NONE : _ref$variant,
      data = _ref.data,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$11);

  var spacer = false;

  if (variant === "DINAMIC" && (_data$ = data[0]) !== null && _data$ !== void 0 && _data$.addSpaces) {
    spacer = true;
  }

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, spacer && /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "DIVIDER__HERO__1 tw-my-7"
  }), /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
    className: "hero-component",
    variant: variant,
    data: data,
    customComponentStyles: customComponentStyles
  }, otherProps)), spacer && /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "DIVIDER__HERO__2 tw-my-7"
  }));
}

function Iframe(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "DIVIDER__IFRAME__1 tw-my-2"
  }), /*#__PURE__*/React__default$1["default"].createElement(Iframe$1, {
    data: data
  }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "DIVIDER__IFRAME__2 tw-my-2"
  }));
}

var _excluded$10 = ["data", "className", "variant", "itemVariant", "subItemVariant", "childrenVariant", "buttonStylesProps", "customComponentStyles"];
var variantDefaultValue = dividersVariantsTypes.NONE;
var childrenVariantDefaultValue = calloutVariantsTypes.NONE || featureVariantsTypes.NONE || dividerVariantsTypes.NONE || heroVariantsTypes.NONE;

function Dividers(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? variantDefaultValue : _ref$variant,
      itemVariant = _ref.itemVariant,
      subItemVariant = _ref.subItemVariant,
      _ref$childrenVariant = _ref.childrenVariant,
      childrenVariant = _ref$childrenVariant === void 0 ? childrenVariantDefaultValue : _ref$childrenVariant,
      buttonStylesProps = _ref.buttonStylesProps,
      customComponentStyles = _ref.customComponentStyles,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$10);

  switch (variant) {
    case dividersVariantsTypes.CALLOUT:
      return /*#__PURE__*/React__default$1["default"].createElement(Callout, _extends$g({
        variant: childrenVariant,
        data: data,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    case dividersVariantsTypes.FEATURE:
      return /*#__PURE__*/React__default$1["default"].createElement(FeatureWithDividerV1$1, _extends$g({
        className: "DIVIDERS_INDEX_FEATURE_OPTION",
        variant: childrenVariant,
        data: data,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    case dividersVariantsTypes.PRODUCTS:
      return /*#__PURE__*/React__default$1["default"].createElement(Products$1, _extends$g({
        data: data,
        variant: itemVariant || productsVariantsTypes.LIST,
        typeOfItems: subItemVariant || productVariantsTypes.OUTLINE,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    case dividersVariantsTypes.IFRAME:
      return /*#__PURE__*/React__default$1["default"].createElement(Iframe, _extends$g({
        data: data,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    case dividersVariantsTypes.DIVIDER:
      return /*#__PURE__*/React__default$1["default"].createElement(Divider, _extends$g({
        variant: childrenVariant,
        className: className,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    case dividersVariantsTypes.HERO:
      return /*#__PURE__*/React__default$1["default"].createElement(Hero$2, _extends$g({
        variant: childrenVariant,
        data: data,
        buttonStylesProps: buttonStylesProps,
        customComponentStyles: customComponentStyles
      }, otherProps));

    default:
      throw new Error("Invalid Divider variant: ".concat(variant));
  }
}

var _templateObject$27, _templateObject2$Z, _templateObject3$O, _templateObject4$C;

function DividerImage(_ref) {
  var _data$backgroundImage;

  var data = _ref.data;
  var DividirImage = styled__default["default"].div(_templateObject$27 || (_templateObject$27 = _taggedTemplateLiteral(["\n    background-image: url(", ");\n    background-size: cover;\n    background-repeat: no-repeat;\n    height: ", ";\n  "])), data === null || data === void 0 ? void 0 : (_data$backgroundImage = data.backgroundImage) === null || _data$backgroundImage === void 0 ? void 0 : _data$backgroundImage.url, data === null || data === void 0 ? void 0 : data.verticalSpacing);
  var divider = /*#__PURE__*/React__default$1["default"].createElement(DividirImage, {
    className: "DIVIDER__IMAGE"
  });

  if (data !== null && data !== void 0 && data.pageFooter) {
    var _data$backgroundImage2;

    var PageFooter = styled__default["default"].h3(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteral(["\n      font-family: ", ";\n      font-size: ", ";\n      color: ", ";\n      float: right;\n    "])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), getTextSize(textSizesVariantsTypes.VERY_SMALL), getColors(colorsVariantsTypes.SEMI_DARK));
    var DividirImageFooter = styled__default["default"].div(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteral(["\n      background-image: url(", ");\n      background-size: cover;\n      background-repeat: no-repeat;\n      height: ", ";\n      max-height: 393px;\n      @media (min-width: ", "px) {\n        max-height: 500px;\n      }\n    "])), data === null || data === void 0 ? void 0 : (_data$backgroundImage2 = data.backgroundImage) === null || _data$backgroundImage2 === void 0 ? void 0 : _data$backgroundImage2.url, (data === null || data === void 0 ? void 0 : data.verticalSpacing) || "", function (theme) {
      var _theme$breakpoints;

      return (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.md) || breakpoints.md;
    });
    var Line = styled__default["default"].hr(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteral(["\n      position: relative;\n      height: 1px;\n      border: 1px solid ", ";\n      width: 100%;\n      margin-top: 4rem;\n      margin-top: 4.5rem;\n      opacity: 0.06;\n      margin-bottom: 1rem;\n      @media (max-width: ", "px) {\n        display: none;\n      }\n    "])), getColors(colorsVariantsTypes.BLACK), function (theme) {
      var _theme$breakpoints2;

      return (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.sm) || breakpoints.sm;
    });
    divider = /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: classnames("DIVIDER__IMAGE__CONTAINER", !data.fullWidth && " tw-x-container")
    }, /*#__PURE__*/React__default$1["default"].createElement(DividirImageFooter, {
      className: "DIVIDER__IMAGE"
    }), /*#__PURE__*/React__default$1["default"].createElement(PageFooter, {
      className: "DIVIDER_IMAGE_PAGE_FOOTER"
    }, data === null || data === void 0 ? void 0 : data.pageFooter), /*#__PURE__*/React__default$1["default"].createElement(Line, {
      className: "DIVIDER__IMAGE__LINE"
    }));
  }

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, divider);
}

function DynamicZonePage(component, keyName) {
  var customComponentStyles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$stylesProps = options.stylesProps,
      stylesProps = _options$stylesProps === void 0 ? {
    buttonStylesProps: {
      withoutBorderRadius: true
    }
  } : _options$stylesProps;
  if (!component) return null;
  var componentName = component.__component;
  return /*#__PURE__*/React__default$1["default"].createElement(RenderDynamicZoneComponent, {
    key: "".concat(componentName.replace("all.", ""), "-").concat(keyName),
    componentName: componentName,
    data: component,
    stylesProps: stylesProps,
    config: options,
    customComponentStyles: customComponentStyles
  });
}

var _excluded$$ = ["data"],
    _excluded2$1 = ["data", "stylesProps", "config", "customComponentStyles", "customContainerClass"],
    _excluded3 = ["data", "stylesProps", "config", "customComponentStyles", "customContainerClass"];
var CONTAINER_EXCLUDED_COMPONENTS = {
  HEROS_LIST: "all.heros-list"
};

function DynamicZonesPage(props) {
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(ValidatorComponent, props));
}

function ValidatorComponent(_ref) {
  var data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$$);

  if (data.Components !== undefined && data.Components[0].__component === CONTAINER_EXCLUDED_COMPONENTS.HEROS_LIST) {
    return /*#__PURE__*/React__default$1["default"].createElement(MainViewExcludeFirstElementFromContainer, _extends$g({
      data: data
    }, otherProps));
  }

  return /*#__PURE__*/React__default$1["default"].createElement(MainView, _extends$g({
    data: data
  }, otherProps));
}

function MainViewExcludeFirstElementFromContainer(_ref2) {
  var data = _ref2.data,
      _ref2$stylesProps = _ref2.stylesProps,
      stylesProps = _ref2$stylesProps === void 0 ? {} : _ref2$stylesProps,
      config = _ref2.config,
      _ref2$customComponent = _ref2.customComponentStyles,
      customComponentStyles = _ref2$customComponent === void 0 ? {} : _ref2$customComponent,
      _ref2$customContainer = _ref2.customContainerClass,
      customContainerClass = _ref2$customContainer === void 0 ? "" : _ref2$customContainer,
      otherProps = _objectWithoutProperties$1(_ref2, _excluded2$1);

  var _stylesProps$buttonSt = stylesProps.buttonStylesProps,
      buttonStylesProps = _stylesProps$buttonSt === void 0 ? {
    withoutBorderRadius: true
  } : _stylesProps$buttonSt;
  var firstComponentName = data.Components[0].__component;
  var FirstComponent = components[dynamicsComponentsVariantsTypes[firstComponentName]];
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "DYNAMIC_ZONES_PAGE"
  }, /*#__PURE__*/React__default$1["default"].createElement(FirstComponent, _extends$g({
    key: "component_".concat(firstComponentName),
    data: data.Components[0],
    buttonStylesProps: buttonStylesProps,
    config: config,
    customComponentStyles: customComponentStyles
  }, otherProps)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: customContainerClass || "tw-custom-container"
  }, data.Components !== undefined && data.Components.map(function (component, i) {
    if (!component || i < 1) return null; // eslint-disable-next-line no-underscore-dangle

    var componentName = component.__component;
    var Component = components[dynamicsComponentsVariantsTypes[componentName]];
    if (!Component) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(Component, _extends$g({
      key: "component_".concat(i),
      data: component,
      buttonStylesProps: buttonStylesProps,
      config: config,
      customComponentStyles: customComponentStyles
    }, otherProps));
  })));
}

function MainView(_ref3) {
  var data = _ref3.data,
      _ref3$stylesProps = _ref3.stylesProps,
      stylesProps = _ref3$stylesProps === void 0 ? {} : _ref3$stylesProps,
      config = _ref3.config,
      _ref3$customComponent = _ref3.customComponentStyles,
      customComponentStyles = _ref3$customComponent === void 0 ? {} : _ref3$customComponent,
      _ref3$customContainer = _ref3.customContainerClass,
      customContainerClass = _ref3$customContainer === void 0 ? "" : _ref3$customContainer,
      otherProps = _objectWithoutProperties$1(_ref3, _excluded3);

  var _stylesProps$buttonSt2 = stylesProps.buttonStylesProps,
      buttonStylesProps = _stylesProps$buttonSt2 === void 0 ? {
    withoutBorderRadius: true
  } : _stylesProps$buttonSt2;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "DYNAMIC_ZONES_PAGE ".concat(!customContainerClass ? "tw-custom-container" : customContainerClass)
  }, data.Components !== undefined && data.Components.map(function (component, i) {
    if (!component) return null; // eslint-disable-next-line no-underscore-dangle

    var componentName = component.__component;
    var Component = components[dynamicsComponentsVariantsTypes[componentName]];
    if (!Component) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(Component, _extends$g({
      key: "component_".concat(i),
      data: component,
      buttonStylesProps: buttonStylesProps,
      config: config,
      customComponentStyles: customComponentStyles
    }, otherProps));
  }));
}

var _templateObject$26, _templateObject2$Y, _templateObject3$N, _templateObject4$B, _templateObject5$w, _templateObject6$p, _templateObject7$d, _templateObject8$b, _templateObject9$5, _templateObject10$2, _templateObject11$2, _templateObject12$2;

var FeatureCollapse = styled__default["default"].div(_templateObject$26 || (_templateObject$26 = _taggedTemplateLiteral(["\nbackground: ", ";\n  \nbackground-image: ", "\n  background-size: cover;\n  background-repeat: no-repeat;\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.BLACK : _ref$color;
  return color;
}, function (_ref2) {
  var _ref2$url = _ref2.url,
      url = _ref2$url === void 0 ? "" : _ref2$url;
  return "url(".concat(url, ");");
});
var Container$c = styled__default["default"].div(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteral(["\n  display:flex;\n  padding:8rem;\n  background: ", "\n  \n  min-height:600px;\n  justify-content:space-between;\n  @media (max-width: ", "px) {\n    padding:4rem 1.5rem 3rem 1.5rem;\n    min-height: calc(100vh - 100px);\n    flex-direction:column;\n  }\n"])), function (_ref3) {
  var _ref3$gradient = _ref3.gradient,
      gradient = _ref3$gradient === void 0 ? "linear-gradient(90deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%)" : _ref3$gradient;
  return "".concat(gradient, ";");
}, breakpoints.md);
var TitleContainer$1 = styled__default["default"].div(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteral(["\n  width: 50%;\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), breakpoints.md);
var Title$p = styled__default["default"].h2(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteral(["\n  max-width: 470px;\n  font-family: ", ";\n\n  color: ", ";\n  font-size: 62px;\n  font-weight: 600;\n  line-height: 70px;\n  @media (max-width: ", "px) {\n    font-size: 42px;\n    line-height: 50px;\n  }\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.WHITE : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, breakpoints.md);
var LineDivider$5 = styled__default["default"].div(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteral(["\n  width: 80%;\n  margin-top: 2rem;\n  background: var(--grayscale-0-color);\n  height: 1px;\n  border: 2px;\n  @media (max-width: ", "px) {\n    width: 100%;\n  }\n"])), breakpoints.md);
var ItemsContainer = styled__default["default"].div(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteral(["\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  @media (max-width: ", "px) {\n    width: 100%;\n    margin-top: 10rem;\n  }\n"])), breakpoints.md);
var ItemContainer = styled__default["default"].div(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteral(["\n  max-width: 490px;\n  padding-bottom: 1rem;\n  width: 100%;\n"])));
var ItemButton = styled__default["default"].button(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 80px;\n  font-size: 26px;\n  line-height: 39px;\n  font-weight: 600;\n  background: var(--grayscale-0-color);\n  padding: 1.2rem;\n  font-family: ", ";\n  cursor: pointer;\n  border: none;\n"])), function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref6$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
});
var ButtonArrow = styled__default["default"].div(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid black;\n  transform: ", ";\n"])), function (_ref7) {
  var _ref7$open = _ref7.open,
      open = _ref7$open === void 0 ? false : _ref7$open;
  return open ? "rotate(0deg)" : "rotate(180deg)";
});
var ItemContentContainer = styled__default["default"].div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n  max-height: ", ";\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 400;\n  font-family: ", ";\n  color: var(--grayscale-0-color);\n  background-color: rgba(0, 0, 0, 0.8);\n"])), function (_ref8) {
  var _ref8$open = _ref8.open,
      open = _ref8$open === void 0 ? false : _ref8$open;
  return open ? "450px" : "0px";
}, function (_ref9) {
  var _ref9$fontFamily = _ref9.fontFamily,
      fontFamily = _ref9$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref9$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
});
var ItemContent = styled__default["default"].div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n  padding: 1rem;\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 400;\n  font-family: ", ";\n  color: var(--grayscale-0-color);\n"])), function (_ref10) {
  var _ref10$fontFamily = _ref10.fontFamily,
      fontFamily = _ref10$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref10$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
});
var ContentButton = styled__default["default"].a(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  align-items: center;\n  justify-content: center;\n  height: 44px;\n  font-weight: 500;\n  padding: 0.75rem 20px;\n  margin: 0 0 1rem 1rem;\n  font-size: 14px;\n  line-height: 16px;\n  background: white;\n  text-align: center;\n  border-color: white;\n  border-width: 1.5px;\n  color: var(--primary-150-color);\n  &:hover {\n    background: transparent;\n    border-color: var(--grayscale-0-color);\n    color: var(--grayscale-0-color);\n  }\n"])));

function FeatureCollapseContent(_ref11) {
  var data = _ref11.data;
  var _data$featureId = data.featureId,
      featureId = _data$featureId === void 0 ? "" : _data$featureId,
      _data$title = data.title,
      title = _data$title === void 0 ? "Title" : _data$title,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _data$titleSize,
      _data$lineDivideColor = data.lineDivideColor,
      lineDivideColor = _data$lineDivideColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$lineDivideColor,
      ContentList = data.ContentList;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var handleClickItem = function handleClickItem(panel) {
    return function () {
      setExpanded(expanded === panel ? false : panel);
    };
  };

  return /*#__PURE__*/React__default$1["default"].createElement(FeatureCollapse, {
    className: "FEATURE_COLLAPSE",
    url: data.backgroundImage.url
  }, /*#__PURE__*/React__default$1["default"].createElement(Container$c, {
    id: featureId,
    className: "FEATURE_COLLAPSE_CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(TitleContainer$1, {
    className: "FEATURE_COLLAPSE_CONTAINER__TITLE"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$p, {
    className: "FEATURE_COLLAPSE_TITLE",
    size: titleSize || textSizesVariantsTypes.HEADER_6
  }, title), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$5, {
    color: lineDivideColor,
    className: "FEATURE_COLLAPSE_LINE_DIVIDER"
  })), /*#__PURE__*/React__default$1["default"].createElement(ItemsContainer, {
    className: "FEATURE_COLLAPSE_CONTAINER__ITEMS"
  }, ContentList.map(function (item) {
    return /*#__PURE__*/React__default$1["default"].createElement(ItemContainer, {
      className: "FEATURE_COLLAPSE_CONTAINER__ITEM",
      key: item.id
    }, /*#__PURE__*/React__default$1["default"].createElement(ItemButton, {
      onClick: handleClickItem(item.id),
      className: "FEATURE_COLLAPSE_ITEM__BUTTON"
    }, item.itemTitle, /*#__PURE__*/React__default$1["default"].createElement(ButtonArrow, {
      className: "FEATURE_COLLAPSE_ITEM_BUTTON__ARROW",
      open: expanded === item.id
    })), /*#__PURE__*/React__default$1["default"].createElement(ItemContentContainer, {
      className: "FEATURE_COLLAPSE_ITEM_CONTENT__CONTAINER",
      open: expanded === item.id
    }, /*#__PURE__*/React__default$1["default"].createElement(ItemContent, {
      className: "FEATURE_COLLAPSE_ITEM__CONTENT"
    }, item.ItemContent), item.buttonText && /*#__PURE__*/React__default$1["default"].createElement(ContentButton, {
      className: "FEATURE_COLLAPSE_ITEM_CONTENT__BUTTON",
      href: item.buttonUrl
    }, item.buttonText)));
  }))));
}

var _templateObject$25, _templateObject2$X, _templateObject3$M;

var Title$o = styled__default["default"].h2(_templateObject$25 || (_templateObject$25 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  @media (min-width: ", "px) {\n    font-size: ", ";\n  }\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, breakpoints.lg, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Description$a = styled__default["default"].p(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Container$b = styled__default["default"].div(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteral(["\n  background: var(--primary-6-color);\n"])));

function V1(_ref7) {
  var data = _ref7.data,
      _ref7$buttonStylesPro = _ref7.buttonStylesProps,
      buttonStylesProps = _ref7$buttonStylesPro === void 0 ? {} : _ref7$buttonStylesPro;
  var buttonHoverBackgroundColor = buttonStylesProps.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = buttonStylesProps.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = buttonStylesProps.buttonHoverOutlineAndColorBorderColor,
      _buttonStylesProps$bu = buttonStylesProps.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _buttonStylesProps$bu === void 0 ? false : _buttonStylesProps$bu,
      _buttonStylesProps$bu2 = buttonStylesProps.buttonHoverColor,
      buttonHoverColor = _buttonStylesProps$bu2 === void 0 ? false : _buttonStylesProps$bu2,
      _buttonStylesProps$bu3 = buttonStylesProps.buttonGrayscale,
      buttonGrayscale = _buttonStylesProps$bu3 === void 0 ? false : _buttonStylesProps$bu3,
      _buttonStylesProps$da = buttonStylesProps.darkButton,
      darkButton = _buttonStylesProps$da === void 0 ? false : _buttonStylesProps$da,
      _buttonStylesProps$bu4 = buttonStylesProps.buttonFill,
      buttonFill = _buttonStylesProps$bu4 === void 0 ? buttonFillTypes.NONE : _buttonStylesProps$bu4,
      buttonTextColor = buttonStylesProps.buttonTextColor,
      _buttonStylesProps$bu5 = buttonStylesProps.buttonStyleType,
      buttonStyleType = _buttonStylesProps$bu5 === void 0 ? buttonStyleTypes.STANDARD : _buttonStylesProps$bu5;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.PRIMARY : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$b, {
    className: "FEATURE_V1 tw-pt-24 tw-pb-24 bl-bg-primary-6 tw-rounded-xl"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FEATURE_V1__CONTAINER tw-mx-auto tw-text-center tw-w-10/12 lg:tw-w-8/12"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$o, {
    className: "FEATURE_V1__TITLE tw-font-bold bl-text-2xl tw-leading-tight",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: titleColor || colorsVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.HEADER_6
  }, data.title), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FEATURE_V1__DESCRIPTION__CONTAINER tw-mt-8 tw-mb-12 lg:tw-my-12 tw-pb-2 bl-text-grayscale bl-text-lg"
  }, /*#__PURE__*/React__default$1["default"].createElement(Description$a, {
    className: "FEATURE_V1__DESCRIPTION__TEXT tw-leading-tight",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: descriptionColor || colorsVariantsTypes.PRIMARY,
    size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
  }, data.description)), /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    className: "FEATURE_V1__BUTTON",
    withoutBorderRadius: buttonWithoutBorderRadius,
    fill: buttonFill,
    styleType: buttonStyleType,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    is: "a",
    href: data.buttonUrl,
    dark: darkButton,
    hoverBackgroundColor: buttonHoverBackgroundColor,
    hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
    hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
    textColor: buttonTextColor
  }, data.buttonText)));
}

var _templateObject$24, _templateObject2$W, _templateObject3$L, _templateObject4$A, _templateObject5$v;

var Title$n = styled__default["default"].h2(_templateObject$24 || (_templateObject$24 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Description$9 = styled__default["default"].p(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.DARK : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Caption = styled__default["default"].p(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref7$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.ULTRA_DARK : _ref8$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref9$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var DescriptionItem = styled__default["default"].li(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteral(["\n  margin-bottom: 25px;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), function (_ref10) {
  var _ref10$fontFamily = _ref10.fontFamily,
      fontFamily = _ref10$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref10$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref11) {
  var _ref11$color = _ref11.color,
      color = _ref11$color === void 0 ? colorsVariantsTypes.BLACK : _ref11$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref12) {
  var _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref12$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var CustomButton$c = styled__default["default"](Button$2)(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteral(["\n  margin-top: 25px;\n\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), getColors(colorsVariantsTypes.WHITE), getColors(colorsVariantsTypes.ULTRA_DARK));

function V2(_ref13) {
  var _data$image, _data$descriptions, _data$descriptions$;

  var data = _ref13.data,
      _ref13$buttonStylesPr = _ref13.buttonStylesProps,
      buttonStylesProps = _ref13$buttonStylesPr === void 0 ? {} : _ref13$buttonStylesPr;
  var buttonHoverBackgroundColor = buttonStylesProps.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = buttonStylesProps.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = buttonStylesProps.buttonHoverOutlineAndColorBorderColor,
      _buttonStylesProps$bu = buttonStylesProps.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _buttonStylesProps$bu === void 0 ? false : _buttonStylesProps$bu,
      _buttonStylesProps$bu2 = buttonStylesProps.buttonHoverColor,
      buttonHoverColor = _buttonStylesProps$bu2 === void 0 ? false : _buttonStylesProps$bu2,
      _buttonStylesProps$bu3 = buttonStylesProps.buttonGrayscale,
      buttonGrayscale = _buttonStylesProps$bu3 === void 0 ? false : _buttonStylesProps$bu3,
      _buttonStylesProps$da = buttonStylesProps.darkButton,
      darkButton = _buttonStylesProps$da === void 0 ? false : _buttonStylesProps$da,
      _buttonStylesProps$bu4 = buttonStylesProps.buttonFill,
      buttonFill = _buttonStylesProps$bu4 === void 0 ? buttonFillTypes.NONE : _buttonStylesProps$bu4,
      buttonTextColor = buttonStylesProps.buttonTextColor,
      _buttonStylesProps$bu5 = buttonStylesProps.buttonStyleType,
      buttonStyleType = _buttonStylesProps$bu5 === void 0 ? buttonStyleTypes.STANDARD : _buttonStylesProps$bu5;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.DARK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont,
      _data$descriptionItem = data.descriptionItemColor,
      descriptionItemColor = _data$descriptionItem === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionItem,
      _data$descriptionItem2 = data.descriptionItemSize,
      descriptionItemSize = _data$descriptionItem2 === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionItem2,
      _data$descriptionItem3 = data.descriptionItemFontFamily,
      descriptionItemFontFamily = _data$descriptionItem3 === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionItem3,
      _data$captionColor = data.captionColor,
      captionColor = _data$captionColor === void 0 ? colorsVariantsTypes.ULTRA_DARK : _data$captionColor,
      _data$captionSize = data.captionSize,
      captionSize = _data$captionSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$captionSize,
      _data$captionFontFami = data.captionFontFamily,
      captionFontFamily = _data$captionFontFami === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$captionFontFami;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("FEATURE_V2 tw-x-container lg:tw-flex lg:tw-flex-row lg:tw-justify-between lg:tw-flex-no-wrap max-width-container", data.imgAlign !== "left" && "lg:tw-flex-row-reverse")
  }, data.image && /*#__PURE__*/React__default$1["default"].createElement(FeatureV2Image, {
    src: data.image.url,
    alt: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.alternativeText) || "",
    className: classnames("FEATURE_V2__IMAGE tw-rounded-lg md:tw-mx-auto tw-max-w-full tw-max-h-full tw-object-cover", data.imgAlign !== "left" ? "lg:tw-ml-8 lg:tw-mr-0" : "lg:tw-mr-8 lg:tw-ml-0")
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FEATURE_V2__CONTAINER tw-mt-6 lg:tw-mt-0 lg:tw-w-6/12 md:tw-text-center lg:tw-text-left tw-relative"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$n, {
    className: "FEATURE_V2__TITLE tw-font-bold tw-mb-5 tw-leading-snug",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: titleColor || colorsVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.HEADER_1_H2
  }, lodash.unescape(data.title)), /*#__PURE__*/React__default$1["default"].createElement(Description$9, {
    className: "FEATURE_V2__DESCRIPTION tw-leading-snug",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: descriptionColor || colorsVariantsTypes.DARK,
    size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
  }, lodash.unescape(data.description)), data.descriptions && /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "FEATURE_V2__ITEM_DESCRIPTION_UL"
  }, data.descriptions.map(function (description, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(DescriptionItem, {
      key: "FeatureV2-description-".concat(index),
      className: "FEATURE_V2__ITEM__DESCRIPTION_LI",
      fontFamily: descriptionItemFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      color: descriptionItemColor || colorsVariantsTypes.BLACK,
      size: descriptionItemSize || textSizesVariantsTypes.VERY_LARGE
    }, lodash.unescape(description.text));
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("FEATURE_V2__BUTTON__CONTAINER__BUTTON tw-mt-12 lg:tw-mt-0 tw-bottom-0 tw-mb-7", (((_data$descriptions = data.descriptions) === null || _data$descriptions === void 0 ? void 0 : _data$descriptions.length) < 1 || ((_data$descriptions$ = data.descriptions[0]) === null || _data$descriptions$ === void 0 ? void 0 : _data$descriptions$.length) < 128) && "lg:tw-absolute")
  }, data.caption && /*#__PURE__*/React__default$1["default"].createElement(Caption, {
    className: "FEATURE_V2__CAPTION tw-italic tw-my-5",
    fontFamily: captionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: captionColor || colorsVariantsTypes.ULTRA_DARK,
    size: captionSize || textSizesVariantsTypes.VERY_SMALL
  }, lodash.unescape(data.caption)), data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$c, {
    className: "FEATURE_V2__BUTTON",
    is: "a",
    withoutBorderRadius: buttonWithoutBorderRadius,
    fill: buttonFill,
    styleType: buttonStyleType,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    href: data.buttonUrl,
    dark: darkButton,
    hoverBackgroundColor: buttonHoverBackgroundColor,
    hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
    hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
    textColor: buttonTextColor
  }, lodash.unescape(data.buttonText)))));
}

var _templateObject$23, _templateObject2$V, _templateObject3$K, _templateObject4$z, _templateObject5$u, _templateObject6$o;

var Title$m = styled__default["default"].h4(_templateObject$23 || (_templateObject$23 = _taggedTemplateLiteral(["\n  font-weight: 600;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.WHITE : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Description$8 = styled__default["default"].p(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.WHITE : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var LineDivider$4 = styled__default["default"].div(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteral(["\n  background: var(--grayscale-0-color);\n  height: 1px;\n  border: none;\n"])));
var Content$9 = styled__default["default"].div(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteral(["\n  position: relative;\n  height: auto;\n  margin: 0;\n  min-height: 366px;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  box-sizing: border-box;\n  /*padding: 7% 8%;*/\n  background-color: #000;\n  background: transparent;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: white;\n    opacity: 0.1;\n    z-index: -1;\n  }\n\n  @media (min-width: ", "px) {\n    width: 50%;\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.lg;
});
/*
@media (max-width: 768px) {
  .featutureFullBg-blur-content1 {
    display: none;
  }
  .featutureFullBg-clean-col {
    #min-height: 366px;
  }

  .featutureFullBg-blur-content-mobil {
    min-height: 366px;
  }
}
*/

var Container$a = styled__default["default"].div(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteral([""])));
var CustomButton$b = styled__default["default"](Button$2)(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteral(["\n  width: auto;\n  font-weight: bold;\n  margin: 25px 0 77px 0;\n"])));

function V3(_ref8) {
  var _data$image;

  var data = _ref8.data,
      lineDivideColor = _ref8.lineDivideColor,
      _ref8$buttonWithoutBo = _ref8.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref8$buttonWithoutBo === void 0 ? false : _ref8$buttonWithoutBo,
      _ref8$buttonGrayscale = _ref8.buttonGrayscale,
      buttonGrayscale = _ref8$buttonGrayscale === void 0 ? false : _ref8$buttonGrayscale,
      _ref8$buttonOutline = _ref8.buttonOutline,
      buttonOutline = _ref8$buttonOutline === void 0 ? false : _ref8$buttonOutline,
      _ref8$darkButton = _ref8.darkButton,
      darkButton = _ref8$darkButton === void 0 ? false : _ref8$darkButton,
      _ref8$buttonFill = _ref8.buttonFill,
      buttonFill = _ref8$buttonFill === void 0 ? buttonFillTypes.NONE : _ref8$buttonFill,
      _ref8$buttonStyleType = _ref8.buttonStyleType,
      buttonStyleType = _ref8$buttonStyleType === void 0 ? buttonStyleTypes.NONE : _ref8$buttonStyleType,
      _ref8$buttonStylesPro = _ref8.buttonStylesProps,
      buttonStylesProps = _ref8$buttonStylesPro === void 0 ? {} : _ref8$buttonStylesPro;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.WHITE : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.WHITE : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  var styleFeature = {
    backgroundImage: "url(".concat(data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.url, ")"),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
  };
  var blurBg = {
    backgroundImage: "linear-gradient(to top, rgba(79, 0, 23, 0.4), rgba(0, 0, 0, 1))"
  };
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Container$a, {
    id: data.feature_id,
    style: styleFeature,
    className: classnames("FEATURE_V3__DESKTOP bl-bg-primary-6 lg:tw-flex lg:tw-flex-row lg:tw-justify-between lg:tw-flex-no-wrap", data.contentAlign !== "right" && "lg:tw-flex-row-reverse")
  }, /*#__PURE__*/React__default$1["default"].createElement(Content$9, {
    className: "FEATURE_V3__DESKTOP__CLEAN_COL tw_flex featutureFullBg-clean-col"
  }), /*#__PURE__*/React__default$1["default"].createElement(Content$9, {
    className: "FEATURE_V3__DESKTOP__CONTAINER  tw-x-container tw-hidden md:tw-block featutureFullBg-blur-content1",
    style: blurBg
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$m, {
    className: "FEATURE_V3__DESKTOP__TITLE tw-font-semibold text-3xl tw-my-5 tw-leading-snug",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY,
    color: titleColor || colorsVariantsTypes.WHITE,
    size: titleSize || textSizesVariantsTypes.HEADER_1_H2
  }, data.ffbTitle), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$4, {
    color: lineDivideColor,
    className: "FEATURE_V3__DESKTOP__LINE_DIVIDER tw-my-8 tw-border-2"
  }), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$8, {
    className: "FEATURE_V3__DESKTOP__DESCRIPTION bl-text-grayscale-70 bl-text-lg tw-leading-snug",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: descriptionColor || colorsVariantsTypes.WHITE,
    size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FEATURE_V3__DESKTOP__CONTAINER__BUTTON bl-text-xs tw-mt-2 lg:tw-mt-2 tw-mb-4"
  }, data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$b, _extends$g({
    className: "FEATURE_V3__DESKTOP__BUTTON",
    is: "a",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    grayscale: buttonGrayscale,
    dark: darkButton
  }, buttonStylesProps), data.buttonText)))), /*#__PURE__*/React__default$1["default"].createElement(Container$a, {
    className: "FEATURE_V3__MOBILE md:tw-hidden"
  }, /*#__PURE__*/React__default$1["default"].createElement(Content$9, {
    key: "conte_2",
    className: "FEATURE_V3__MOBILE_CONTAINER tw-x-container featutureFullBg-blur-content-mobil",
    style: blurBg
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$m, {
    className: "FEATURE_V3__MOBILE__TITLE FeatureFullBg__title tw-pt-12 tw-font-semibold text-3xl tw-leading-snug"
  }, data.ffbTitle), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$4, {
    color: lineDivideColor,
    className: "FEATURE_V3__MOBILE__LINE_DIVIDER tw-my-8 tw-border-2"
  }), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$8, {
    className: "FEATURE_V3__MOBILE__DESCRIPTION bl-text-grayscale-70 bl-text-lg tw-leading-snug"
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FEATURE_V3__MOBILE__CONTAINER__BUTTON bl-text-xs tw-mt-2 lg:tw-mt-2 mb:tw-mb-8"
  }, data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$b, _extends$g({
    className: "FEATURE_V3__MOBILE__BUTTON",
    is: "a",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    grayscale: buttonGrayscale,
    dark: darkButton
  }, buttonStylesProps), data.buttonText)))));
}

var _templateObject$22, _templateObject2$U, _templateObject3$J, _templateObject4$y, _templateObject5$t, _templateObject6$n, _templateObject7$c, _templateObject8$a, _templateObject9$4;

var Title$l = styled__default["default"].h3(_templateObject$22 || (_templateObject$22 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  padding: 0 13%;\n  font-weight: 600;\n  line-height: 50px;\n  margin: 0;\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Description$7 = styled__default["default"].p(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteral(["\n  padding: 0 13%;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  flex: 1 1;\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var DescriptionLI$2 = styled__default["default"].li(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref7$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref8$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref9$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var LineDivider$3 = styled__default["default"].div(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteral(["\n  background: ", ";\n\n  height: ", ";\n\n  width: ", ";\n\n  margin: ", ";\n\n  opacity: ", ";\n"])), function (_ref10) {
  var _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsTypes.SECONDARY : _ref10$color;
  return color;
}, function (_ref11) {
  var _ref11$height = _ref11.height,
      height = _ref11$height === void 0 ? 4 : _ref11$height;
  return lodash.isNumber(height) ? "".concat(height, "px") : height;
}, function (_ref12) {
  var _ref12$width = _ref12.width,
      width = _ref12$width === void 0 ? "80%" : _ref12$width;
  return lodash.isNumber(width) ? "".concat(width, "px") : width;
}, function (_ref13) {
  var _ref13$margin = _ref13.margin,
      margin = _ref13$margin === void 0 ? "2.5rem 0 2.5rem 13%" : _ref13$margin;
  return lodash.isNumber(margin) ? "".concat(margin, "px") : margin;
}, function (_ref14) {
  var _ref14$opacity = _ref14.opacity,
      opacity = _ref14$opacity === void 0 ? 1 : _ref14$opacity;
  return opacity;
});
var Content$8 = styled__default["default"].div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteral(["\n  position: relative;\n  height: auto;\n  width: 50%;\n  margin: 0;\n  padding: 5% 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  box-sizing: border-box;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--primary-color);\n    opacity: 0.1;\n    z-index: -1;\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    padding: 3rem var(--padding-default);\n  }\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.lg;
});
var Spacer$2 = styled__default["default"].div(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteral(["\n  flex: 1 1;\n"])));
var Container$9 = styled__default["default"].div(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteral([""])));
var MetaContainer$1 = styled__default["default"].div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteral(["\n  margin: 8rem 13% 0 13%;\n"])));
var CustomButton$a = styled__default["default"](Button$2)(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n  width: auto;\n  font-weight: bold;\n  margin: 0;\n"])));

function V4(_ref16) {
  var _data$image;

  var data = _ref16.data,
      lineDivideColor = _ref16.lineDivideColor,
      _ref16$buttonWithoutB = _ref16.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref16$buttonWithoutB === void 0 ? false : _ref16$buttonWithoutB,
      _ref16$buttonHoverCol = _ref16.buttonHoverColor,
      buttonHoverColor = _ref16$buttonHoverCol === void 0 ? false : _ref16$buttonHoverCol,
      _ref16$buttonGrayscal = _ref16.buttonGrayscale,
      buttonGrayscale = _ref16$buttonGrayscal === void 0 ? false : _ref16$buttonGrayscal,
      _ref16$buttonOutline = _ref16.buttonOutline,
      buttonOutline = _ref16$buttonOutline === void 0 ? false : _ref16$buttonOutline,
      _ref16$darkButton = _ref16.darkButton,
      darkButton = _ref16$darkButton === void 0 ? false : _ref16$darkButton,
      _ref16$buttonFill = _ref16.buttonFill,
      buttonFill = _ref16$buttonFill === void 0 ? buttonFillTypes.NONE : _ref16$buttonFill,
      _ref16$buttonStyleTyp = _ref16.buttonStyleType,
      buttonStyleType = _ref16$buttonStyleTyp === void 0 ? buttonStyleTypes.STANDARD : _ref16$buttonStyleTyp,
      _ref16$buttonStylesPr = _ref16.buttonStylesProps,
      buttonStylesProps = _ref16$buttonStylesPr === void 0 ? {} : _ref16$buttonStylesPr;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$9, {
    className: classnames("FEATURE_V4 bl-bg-primary-6 lg:tw-flex lg:tw-flex-row lg:tw-justify-between lg:tw-flex-no-wrap", data.imgAlign !== "left" && "lg:tw-flex-row-reverse")
  }, data.image && /*#__PURE__*/React__default$1["default"].createElement(FeatureV4Image, {
    src: process.env.GATSBY_CU_NAME === "bayou" ? "https://d1w2egu22dd0ex.cloudfront.net/".concat(data.image.url.split("/").pop()) : data.image.url,
    alt: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.alternativeText) || "",
    className: classnames("FEATURE_V4__IMAGE tw-max-h-full tw-object-cover")
  }), /*#__PURE__*/React__default$1["default"].createElement(Content$8, {
    className: "FEATURE_V4__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$l, {
    className: "FEATURE_V4__TITLE",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY,
    color: titleColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
    size: titleSize || textSizesVariantsTypes.HEADER_1_H2
  }, data.title), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$3, {
    className: "FEATURE_V4__LINE_DIVIDER",
    color: lineDivideColor
  }), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$7, {
    className: "FEATURE_V4__DESCRIPTION tw-leading-snug",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: descriptionColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
    size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
  }, data.description), data.descriptions && /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "FEATURE_V4__DESCRIPTION_UL bl-text-lg"
  }, data.descriptions.map(function (description, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(DescriptionLI$2, {
      key: "FeatureV4-description-".concat(index),
      className: "FEATURE_V4__LI",
      fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      color: descriptionColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
      size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
    }, description.text);
  })), /*#__PURE__*/React__default$1["default"].createElement(Spacer$2, null), /*#__PURE__*/React__default$1["default"].createElement(MetaContainer$1, null, data.caption && /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "FEATURE_V3__META_CONTAINER bl-text-xs tw-italic bl-text-grayscale-80 tw-my-5"
  }, data.caption), data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$a, _extends$g({
    is: "a",
    className: "FEATURE_V3__BUTTON",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    dark: darkButton
  }, buttonStylesProps), data.buttonText))));
}

var _templateObject$21, _templateObject2$T, _templateObject3$I, _templateObject4$x, _templateObject5$s, _templateObject6$m, _templateObject7$b, _templateObject8$9;

var FeatureV5ImageContainer = styled__default["default"].div(_templateObject$21 || (_templateObject$21 = _taggedTemplateLiteral(["\n  border-radius: 10px;\n  min-height: 400px;\n  height: auto;\n  width: 400px;\n  overflow: auto;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: var(--primary-color);\n    opacity: 0.2;\n    z-index: -1;\n  }\n\n  @media (max-width: ", ") {\n    width: 100%;\n    height: 340px;\n    min-height: 0px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.breakpoints.lg - 1, "px");
});
var FeatureV5Image = styled__default["default"].img(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
var Title$k = styled__default["default"].h3(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteral(["\n  font-weight: 600;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.BLACK : _ref3$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _ref4$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Description$6 = styled__default["default"].p(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteral(["\n  padding: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  flex: 1 1;\n"])), function (_ref5) {
  var _ref5$padding = _ref5.padding,
      padding = _ref5$padding === void 0 ? "3.5rem" : _ref5$padding;
  return padding;
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref7) {
  var _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? colorsVariantsTypes.BLACK : _ref7$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref8$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var DescriptionLI$1 = styled__default["default"].li(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref9) {
  var _ref9$fontFamily = _ref9.fontFamily,
      fontFamily = _ref9$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref9$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref10) {
  var _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref10$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref11) {
  var _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref11$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Content$7 = styled__default["default"].div(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteral(["\n  padding: ", ";\n\n  position: relative;\n  height: auto;\n  width: 50%;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  box-sizing: border-box;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.1;\n    z-index: -1;\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    padding: 25px 0px;\n  }\n"])), function (_ref12) {
  var _ref12$paddingLeft = _ref12.paddingLeft,
      paddingLeft = _ref12$paddingLeft === void 0 ? "0px" : _ref12$paddingLeft,
      _ref12$paddingRight = _ref12.paddingRight,
      paddingRight = _ref12$paddingRight === void 0 ? "0px" : _ref12$paddingRight;
  return "25px ".concat(paddingRight, " 25px ").concat(paddingLeft);
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.lg - 1;
});
var Container$8 = styled__default["default"].div(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral([""])));
var CustomButton$9 = styled__default["default"](Button$2)(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteral(["\n  width: auto;\n  font-weight: bold;\n  margin: 25px 0 0 0;\n"])));

function V5(_ref14) {
  var _data$image;

  var data = _ref14.data,
      _ref14$buttonWithoutB = _ref14.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref14$buttonWithoutB === void 0 ? false : _ref14$buttonWithoutB,
      _ref14$buttonHoverCol = _ref14.buttonHoverColor,
      buttonHoverColor = _ref14$buttonHoverCol === void 0 ? false : _ref14$buttonHoverCol,
      _ref14$buttonGrayscal = _ref14.buttonGrayscale,
      buttonGrayscale = _ref14$buttonGrayscal === void 0 ? false : _ref14$buttonGrayscal,
      _ref14$buttonOutline = _ref14.buttonOutline,
      buttonOutline = _ref14$buttonOutline === void 0 ? false : _ref14$buttonOutline,
      _ref14$darkButton = _ref14.darkButton,
      darkButton = _ref14$darkButton === void 0 ? false : _ref14$darkButton,
      _ref14$buttonFill = _ref14.buttonFill,
      buttonFill = _ref14$buttonFill === void 0 ? buttonFillTypes.NONE : _ref14$buttonFill,
      _ref14$buttonStyleTyp = _ref14.buttonStyleType,
      buttonStyleType = _ref14$buttonStyleTyp === void 0 ? buttonStyleTypes.STANDARD : _ref14$buttonStyleTyp,
      _ref14$buttonStylesPr = _ref14.buttonStylesProps,
      buttonStylesProps = _ref14$buttonStylesPr === void 0 ? {} : _ref14$buttonStylesPr,
      _ref14$imgStyles = _ref14.imgStyles,
      imgStyles = _ref14$imgStyles === void 0 ? {} : _ref14$imgStyles,
      _ref14$contentStyles = _ref14.contentStyles,
      contentStyles = _ref14$contentStyles === void 0 ? {} : _ref14$contentStyles,
      _ref14$descriptionSty = _ref14.descriptionStyles,
      descriptionStyles = _ref14$descriptionSty === void 0 ? {} : _ref14$descriptionSty;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.BLACK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$8, {
    className: classnames("FEATURE_V5 lg:tw-flex lg:tw-flex-row lg:tw-justify-center lg:tw-flex-no-wrap tw-px-8", data.imgAlign !== "left" && "lg:tw-flex-row-reverse")
  }, /*#__PURE__*/React__default$1["default"].createElement(FeatureV5ImageContainer, _extends$g({}, imgStyles, {
    className: classnames("FEATURE_V5__IMG__CONTAINER tw-max-h-full", imgStyles.padding ? "" : "")
  }), data.image && /*#__PURE__*/React__default$1["default"].createElement(FeatureV5Image, {
    src: data.image.url,
    alt: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.alternativeText) || "",
    className: "FEATURE_V5__IMG tw-max-h-full"
  })), /*#__PURE__*/React__default$1["default"].createElement(Content$7, _extends$g({}, contentStyles, {
    className: "FEATURE_V5__CONTENT",
    paddingLeft: data.imgAlign === "left" ? "100px" : "0px",
    paddingRight: data.imgAlign !== "left" ? "100px" : "0px"
  }), /*#__PURE__*/React__default$1["default"].createElement(Title$k, {
    className: "FEATURE_V5__TITLE tw-leading-snug",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY,
    color: titleColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
    size: titleSize || textSizesVariantsTypes.HEADER_1_H2
  }, data.title), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$6, _extends$g({
    className: "FEATURE_V5__DESCRIPTION tw-leading-snug",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: descriptionColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
    size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
  }, descriptionStyles), data.description), data.descriptions && /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "FEATURE_V5__DESCRIPTION_ITEM__UL"
  }, data.descriptions.map(function (description, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(DescriptionLI$1, {
      key: "FeatureV2-description-".concat(index),
      fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      color: descriptionColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
      size: descriptionSize || textSizesVariantsTypes.VERY_LARGE,
      className: "FEATURE_V5__DESCRIPTION_ITEM__LI"
    }, description.text);
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "bl-text-xs FEATURE_V5__BUTTON_CONTAINER"
  }, data.caption && /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "FEATURE_V5__CAPTION tw-italic bl-text-grayscale-80 "
  }, data.caption), data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$9, _extends$g({
    is: "a",
    className: "FEATURE_V5__BUTTON",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    dark: darkButton
  }, buttonStylesProps), data.buttonText))));
}

var _templateObject$20, _templateObject2$S, _templateObject3$H, _templateObject4$w, _templateObject5$r, _templateObject6$l, _templateObject7$a, _templateObject8$8;

var Title$j = styled__default["default"].h3(_templateObject$20 || (_templateObject$20 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  padding: 0;\n  font-weight: 600;\n  line-height: 50px;\n  margin: 0;\n  margin-bottom: 10px;\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var Description$5 = styled__default["default"].p(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteral(["\n  padding: 1rem 0;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  // flex: 1 1;\n"])), function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref4$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var DescriptionLI = styled__default["default"].li(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref7$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref8$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref9$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var LineDivider$2 = styled__default["default"].div(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteral(["\n  background: ", ";\n\n  height: ", ";\n\n  width: ", ";\n\n  margin: ", ";\n\n  opacity: ", ";\n  display: none;\n  @media (max-width: ", "px) {\n    & {\n      display: block;\n    }\n  }\n"])), function (_ref10) {
  var _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsTypes.SECONDARY : _ref10$color;
  return color;
}, function (_ref11) {
  var _ref11$height = _ref11.height,
      height = _ref11$height === void 0 ? 4 : _ref11$height;
  return lodash.isNumber(height) ? "".concat(height, "px") : height;
}, function (_ref12) {
  var _ref12$width = _ref12.width,
      width = _ref12$width === void 0 ? "80%" : _ref12$width;
  return lodash.isNumber(width) ? "".concat(width, "px") : width;
}, function (_ref13) {
  var _ref13$margin = _ref13.margin,
      margin = _ref13$margin === void 0 ? "2.5rem 0 2.5rem 0" : _ref13$margin;
  return lodash.isNumber(margin) ? "".concat(margin, "px") : margin;
}, function (_ref14) {
  var _ref14$opacity = _ref14.opacity,
      opacity = _ref14$opacity === void 0 ? 1 : _ref14$opacity;
  return opacity;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.lg;
});
var Content$6 = styled__default["default"].div(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteral(["\n  position: relative;\n  height: auto;\n  width: 50%;\n  margin: auto auto;\n  padding: 5% 3%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  box-sizing: border-box;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.1;\n    z-index: -1;\n  }\n\n  @media (max-width: ", "px) {\n    width: 100%;\n    padding: 3rem 1rem;\n    &.bl-padding-left {\n      padding-left: 1rem !important;\n    }\n  }\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.breakpoints.lg;
});
var Container$7 = styled__default["default"].div(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref17) {
  var _ref17$background = _ref17.background,
      background = _ref17$background === void 0 ? "var(--primary-6-color)" : _ref17$background;
  return "\n  background: ".concat(background, ";\n");
});
var MetaContainer = styled__default["default"].div(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral(["\n  margin: 8rem 13% 0 13%;\n"])));
var CustomButton$8 = styled__default["default"](Button$2)(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteral(["\n  width: auto;\n  font-weight: bold;\n  margin: 0;\n"])));

function V6(_ref18) {
  var _data$image;

  var data = _ref18.data,
      _ref18$buttonWithoutB = _ref18.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref18$buttonWithoutB === void 0 ? true : _ref18$buttonWithoutB,
      _ref18$buttonHoverCol = _ref18.buttonHoverColor,
      buttonHoverColor = _ref18$buttonHoverCol === void 0 ? false : _ref18$buttonHoverCol,
      _ref18$buttonGrayscal = _ref18.buttonGrayscale,
      buttonGrayscale = _ref18$buttonGrayscal === void 0 ? false : _ref18$buttonGrayscal,
      _ref18$buttonOutline = _ref18.buttonOutline,
      buttonOutline = _ref18$buttonOutline === void 0 ? false : _ref18$buttonOutline,
      _ref18$darkButton = _ref18.darkButton,
      darkButton = _ref18$darkButton === void 0 ? false : _ref18$darkButton,
      _ref18$buttonFill = _ref18.buttonFill,
      buttonFill = _ref18$buttonFill === void 0 ? buttonFillTypes.NONE : _ref18$buttonFill,
      _ref18$buttonStyleTyp = _ref18.buttonStyleType,
      buttonStyleType = _ref18$buttonStyleTyp === void 0 ? buttonStyleTypes.STANDARD : _ref18$buttonStyleTyp,
      _ref18$buttonStylesPr = _ref18.buttonStylesProps,
      buttonStylesProps = _ref18$buttonStylesPr === void 0 ? {} : _ref18$buttonStylesPr;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.HEADER_1_H2 : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$7, {
    background: data.background,
    className: classnames("FEATURE_V6 lg:tw-flex lg:tw-flex-row lg:tw-justify-between lg:tw-flex-no-wrap", data.imgAlign !== "left" && "lg:tw-flex-row-reverse")
  }, data.image && /*#__PURE__*/React__default$1["default"].createElement(FeatureV4Image, {
    src: data.image.url,
    alt: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.alternativeText) || "",
    className: classnames("FEATURE_V4__IMAGE tw-max-h-full tw-object-cover")
  }), /*#__PURE__*/React__default$1["default"].createElement(Content$6, {
    className: classnames("FEATURE_V4__CONTAINER", data.imgAlign === "left" ? "bl-padding-right" : "bl-padding-left")
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$j, {
    className: "FEATURE_V6__TITLE",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY,
    color: titleColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
    size: titleSize || textSizesVariantsTypes.HEADER_1_H2
  }, data.title), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$2, {
    className: "FEATURE_V4__LINE_DIVIDER",
    color: "transparent"
  }), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$5, {
    className: "FEATURE_V4__DESCRIPTION tw-leading-snug",
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    color: descriptionColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
    size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
  }, data.description), data.descriptions && /*#__PURE__*/React__default$1["default"].createElement("ul", {
    className: "FEATURE_V4__DESCRIPTION_UL bl-text-lg"
  }, data.descriptions.map(function (description, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(DescriptionLI, {
      key: "FeatureV4-description-".concat(index),
      className: "FEATURE_V4__LI",
      fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      color: descriptionColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK,
      size: descriptionSize || textSizesVariantsTypes.VERY_LARGE
    }, description.text);
  })), /*#__PURE__*/React__default$1["default"].createElement(MetaContainer, null, data.caption && /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "FEATURE_V3__META_CONTAINER bl-text-xs tw-italic bl-text-grayscale-80 tw-my-5"
  }, data.caption), data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$8, _extends$g({
    is: "a",
    className: "FEATURE_V6__BUTTON",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    dark: darkButton
  }, buttonStylesProps), data.buttonText))));
}

var _excluded$_ = ["variant", "data"];

function Feature(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? featureVariantsTypes.NONE : _ref$variant,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$_);

  switch (variant) {
    case featureVariantsTypes.FEATURE_COLLAPSE_CONTENT:
      return /*#__PURE__*/React__default$1["default"].createElement(FeatureCollapseContent, _extends$g({
        data: data
      }, otherProps));

    case featureVariantsTypes.V1:
      return /*#__PURE__*/React__default$1["default"].createElement(V1, _extends$g({
        data: data
      }, otherProps));

    case featureVariantsTypes.V2:
      return /*#__PURE__*/React__default$1["default"].createElement(V2, _extends$g({
        data: data
      }, otherProps));

    case featureVariantsTypes.V3:
      return /*#__PURE__*/React__default$1["default"].createElement(V3, _extends$g({
        data: data
      }, otherProps));

    case featureVariantsTypes.V4:
      return /*#__PURE__*/React__default$1["default"].createElement(V4, _extends$g({
        data: data
      }, otherProps));

    case featureVariantsTypes.V5:
      return /*#__PURE__*/React__default$1["default"].createElement(V5, _extends$g({
        data: data
      }, otherProps));

    case featureVariantsTypes.V6:
      return /*#__PURE__*/React__default$1["default"].createElement(V6, _extends$g({
        data: data
      }, otherProps));

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

var _excluded$Z = ["data"];

function FeatureWithDividerV1(_ref) {
  var data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$Z);

  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
    className: "FEATURE_WITH_DIVIDERS_V1_DIVIDERS",
    variant: dividersVariantsTypes.FEATURE,
    childrenVariant: featureVariantsTypes.V1,
    data: data
  }, otherProps));
}

var _excluded$Y = ["featureProps", "data"];

function FeatureWithDividerV2(_ref) {
  var _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {
    variant: {}
  } : _ref$featureProps,
      data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$Y);

  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
    variant: dividersVariantsTypes.FEATURE,
    childrenVariant: featureProps.variant || featureVariantsTypes.V2,
    data: data
  }, otherProps));
}

function FeatureWithDividerV3(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.FEATURE,
    childrenVariant: featureVariantsTypes.V3,
    data: data
  });
}

function FeatureWithDividers(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? featureVariantsTypes.V1 : _ref$variant,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.FEATURE,
    childrenVariant: variant,
    data: data
  });
}

var _templateObject$1$, _templateObject2$R, _templateObject3$G, _templateObject4$v, _templateObject5$q, _templateObject6$k;

var Title$i = styled__default["default"].h4(_templateObject$1$ || (_templateObject$1$ = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  color: var(--primary-color);\n  font-weight: 400;\n  font-size: 2rem;\n"])));
var Description$4 = styled__default["default"].p(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteral(["\n  color: var(--primary-color);\n"])));
var LineDivider$1 = styled__default["default"].div(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteral(["\n  border-color: var(--primary-color);\n"])));
var Content$5 = styled__default["default"].div(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteral(["\n  position: relative;\n  height: auto;\n  margin: 0;\n  min-height: 366px;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  box-sizing: border-box;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: white;\n    opacity: 0.1;\n    z-index: -1;\n  }\n\n  @media (min-width: ", "px) {\n    padding: 7% 8%;\n    width: 100%;\n  }\n  @media (max-width: ", "px) {\n    padding: 0 8%;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.sm;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
});
var Container$6 = styled__default["default"].div(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteral([""])));
var CustomButton$7 = styled__default["default"](Button$2)(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteral(["\n  width: auto;\n  font-weight: bold;\n  margin: 25px 0 0 0;\n"])));

function FeatureFullBg(_ref3) {
  var _data$image;

  var data = _ref3.data,
      lineDivideColor = _ref3.lineDivideColor,
      _ref3$buttonWithoutBo = _ref3.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref3$buttonWithoutBo === void 0 ? false : _ref3$buttonWithoutBo,
      _ref3$buttonHoverColo = _ref3.buttonHoverColor,
      buttonHoverColor = _ref3$buttonHoverColo === void 0 ? false : _ref3$buttonHoverColo,
      _ref3$buttonGrayscale = _ref3.buttonGrayscale,
      buttonGrayscale = _ref3$buttonGrayscale === void 0 ? false : _ref3$buttonGrayscale,
      _ref3$buttonOutline = _ref3.buttonOutline,
      buttonOutline = _ref3$buttonOutline === void 0 ? false : _ref3$buttonOutline,
      _ref3$darkButton = _ref3.darkButton,
      darkButton = _ref3$darkButton === void 0 ? false : _ref3$darkButton,
      _ref3$buttonFill = _ref3.buttonFill,
      buttonFill = _ref3$buttonFill === void 0 ? buttonFillTypes.NONE : _ref3$buttonFill,
      _ref3$buttonStyleType = _ref3.buttonStyleType,
      buttonStyleType = _ref3$buttonStyleType === void 0 ? buttonStyleTypes.STANDARD : _ref3$buttonStyleType,
      _ref3$buttonStylesPro = _ref3.buttonStylesProps,
      buttonStylesProps = _ref3$buttonStylesPro === void 0 ? {} : _ref3$buttonStylesPro;
  var styleFeature = {
    backgroundImage: "url(".concat(data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.url, ")"),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
  };
  var blurBg = {
    backgroundImage: "linear-gradient(to top, rgba(79, 0, 23, 0.4), rgba(0, 0, 0, 1))"
  };
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Container$6, {
    style: styleFeature,
    className: classnames("ANT_FEATURE_FULL bl-bg-primary-6 lg:tw-flex lg:tw-flex-row lg:tw-justify-between lg:tw-flex-no-wrap", data.imgAlign !== "left" && "lg:tw-flex-row-reverse")
  }, /*#__PURE__*/React__default$1["default"].createElement(Content$5, {
    className: "tw_flex featuture ANT_FEATURE_FULL__DIVIDER FullBg-clean-col"
  }), /*#__PURE__*/React__default$1["default"].createElement(Content$5, {
    className: "ANT_FEATURE_FULL__DIVIDER__CONTAINER tw-hidden md:tw-block featutureFullBg-blur-content1",
    style: blurBg
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$i, {
    className: "ANT_FEATURE_FULL__DIVIDER__CONTAINER__TITLE tw-font-semibold text-3xl tw-my-5 tw-leading-snug"
  }, data.ffbTitle), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$1, {
    color: lineDivideColor,
    className: "ANT_FEATURE_FULL__DIVIDER__CONTAINER__DIVIDER tw-my-8 tw-border-2"
  }), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$4, {
    className: "ANT_FEATURE_FULL__DIVIDER__CONTAINER__DESCRIPTION bl-text-grayscale-70 bl-text-lg tw-leading-snug"
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "ANT_FEATURE_FULL__DIVIDER__CONTAINER__BUTTONS bl-text-xs tw-mt-2 lg:tw-mt-2 tw-mb-4"
  }, data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$7, _extends$g({
    is: "a",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    dark: darkButton,
    className: "ANT_FEATURE_FULL__DIVIDER__CONTAINER__BUTTONS__BUTTON"
  }, buttonStylesProps), data.buttonText)))), /*#__PURE__*/React__default$1["default"].createElement(Container$6, {
    className: "ANT_FEATURE_FULL_MOBILE md:tw-hidden"
  }, /*#__PURE__*/React__default$1["default"].createElement(Content$5, {
    key: nanoid(),
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER featutureFullBg-blur-content-mobil",
    style: blurBg
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$i, {
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER__TITLE FeatureFullBg__title tw-pt-12 tw-font-semibold text-3xl tw-leading-snug"
  }, data.ffbTitle), /*#__PURE__*/React__default$1["default"].createElement(LineDivider$1, {
    color: lineDivideColor,
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER__DIVIDER tw-my-8 tw-border-2"
  }), !!data.description && /*#__PURE__*/React__default$1["default"].createElement(Description$4, {
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER__DESCRIPTION bl-text-grayscale-70 bl-text-lg tw-leading-snug"
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER__BUTTONS bl-text-xs tw-mt-2 lg:tw-mt-2 tw-mb-4"
  }, data.buttonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$7, _extends$g({
    is: "a",
    href: data.buttonUrl,
    fill: buttonFill,
    styleType: buttonStyleType,
    withoutBorderRadius: buttonWithoutBorderRadius,
    outline: buttonOutline,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    dark: darkButton,
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER__BUTTONS__BUTTON"
  }, buttonStylesProps), data.buttonText)))));
}

function FeatureFullBackground(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? featureVariantsTypes.V1 : _ref$variant,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  variant = featureVariantsTypes.V3;
  return /*#__PURE__*/React__default$1["default"].createElement(Feature, {
    variant: variant,
    data: data
  });
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default$1["default"],
      k = Symbol.for("react.element"),
      l = Symbol.for("react.fragment"),
      m = Object.prototype.hasOwnProperty,
      n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function q(c, a, g) {
    var b,
        d = {},
        e = null,
        h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);

    for (b in a) {
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    }

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
      void 0 === d[b] && (d[b] = a[b]);
    }
    return {
      $$typeof: k,
      type: c,
      key: e,
      ref: h,
      props: d,
      _owner: n.current
    };
  }

  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var React = React__default$1["default"]; // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.

      var REACT_ELEMENT_TYPE = Symbol.for('react.element');
      var REACT_PORTAL_TYPE = Symbol.for('react.portal');
      var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
      var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
      var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
      var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
      var REACT_CONTEXT_TYPE = Symbol.for('react.context');
      var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
      var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
      var REACT_MEMO_TYPE = Symbol.for('react.memo');
      var REACT_LAZY_TYPE = Symbol.for('react.lazy');
      var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            printWarning('error', format, args);
          }
        }
      }

      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          } // eslint-disable-next-line react-internal/safe-string-coercion


          var argsWithFormat = args.map(function (item) {
            return String(item);
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      } // -----------------------------------------------------------------------------


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      var enableCacheElement = false;
      var enableTransitionTracing = false; // No known bugs, but needs performance testing

      var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
      }

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;

        if (displayName) {
          return displayName;
        }

        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
      } // Keep in sync with react-reconciler/getComponentNameFromFiber


      function getContextName(type) {
        return type.displayName || 'Context';
      } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


      function getComponentNameFromType(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;

              if (outerName !== null) {
                return outerName;
              }

              return getComponentNameFromType(type.type) || 'Memo';

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentNameFromType(init(payload));
                } catch (x) {
                  return null;
                }
              }
            // eslint-disable-next-line no-fallthrough
          }
        }

        return null;
      }

      var assign = Object.assign; // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.

      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.


          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function Fake() {
              throw Error();
            }; // $FlowFixMe


            Object.defineProperty(Fake.prototype, 'props', {
              set: function set() {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                      // but we have a user-provided "displayName"
                      // splice it in to make the stack more readable.


                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName);
                      }

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.


        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  // eslint-disable-next-line react-internal/prod-error-codes
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a);
      }
      /*
       * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
       * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
       *
       * The functions in this module will throw an easier-to-understand,
       * easier-to-debug exception with a clear errors message message explaining the
       * problem. (Instead of a confusing exception thrown inside the implementation
       * of the `value` object).
       */
      // $FlowFixMe only called in DEV, so void return is not possible.


      function typeName(value) {
        {
          // toStringTag is needed for namespaced types like Temporal.Instant
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
          return type;
        }
      } // $FlowFixMe only called in DEV, so void return is not possible.


      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }

      function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
      }

      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */


      var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */


      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = '' + maybeKey;
          }

          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = '' + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object


          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props


          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }

          return '';
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
          }

          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */


      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */


      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */


      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }

          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */


      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }

          var propTypes;

          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }

          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentNameFromType(type);

            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }

          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */


      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';

            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = 'null';
            } else if (isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }

            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)


          if (validType) {
            var children = props.children;

            if (children !== undefined) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.


      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }

  return reactJsxRuntime_development;
}

(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = requireReactJsxRuntime_production_min();
  } else {
    module.exports = requireReactJsxRuntime_development();
  }
})(jsxRuntime);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */


var NODE_ENV$1 = process.env.NODE_ENV;

var invariant$1 = function invariant$1(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV$1 !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1$1 = invariant$1;
var MapContext = React.createContext(null);

function useGoogleMap() {
  invariant_1$1(!!React.useContext, 'useGoogleMap is React hook and requires React version 16.8+');
  var map = React.useContext(MapContext);
  invariant_1$1(!!map, 'useGoogleMap needs a GoogleMap available up in the tree');
  return map;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function reduce(obj, fn, acc) {
  return Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key);
  }, acc);
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function forEach$1(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}
/* global google */


function applyUpdaterToNextProps( // eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap, // eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var map = {}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var iter = function iter(fn, key) {
    var nextValue = nextProps[key];

    if (nextValue !== prevProps[key]) {
      map[key] = nextValue;
      fn(instance, nextValue);
    }
  };

  forEach$1(updaterMap, iter);
  return map;
}

function registerEvents( // eslint-disable-next-line @typescript-eslint/no-explicit-any
props, // eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
  var registeredList = reduce(eventMap, function reducer(acc, googleEventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEventName) {
    if (typeof props[onEventName] === 'function') {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }

    return acc;
  }, []);
  return registeredList;
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}

function unregisterEvents() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  events.forEach(unregisterEvent);
}

function applyUpdatersToPropsAndRegisterEvents(_ref35) {
  var updaterMap = _ref35.updaterMap,
      eventMap = _ref35.eventMap,
      prevProps = _ref35.prevProps,
      nextProps = _ref35.nextProps,
      instance = _ref35.instance;
  var registeredEvents = registerEvents(nextProps, instance, eventMap);
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
  return registeredEvents;
}

var eventMap$i = {
  onDblClick: 'dblclick',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMapTypeIdChanged: 'maptypeid_changed',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseDown: 'mousedown',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onTilesLoaded: 'tilesloaded',
  onBoundsChanged: 'bounds_changed',
  onCenterChanged: 'center_changed',
  onClick: 'click',
  onDrag: 'drag',
  onHeadingChanged: 'heading_changed',
  onIdle: 'idle',
  onProjectionChanged: 'projection_changed',
  onResize: 'resize',
  onTiltChanged: 'tilt_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$i = {
  extraMapTypes: function extraMapTypes(map, extra) {
    extra.forEach(function forEachExtra(it, i) {
      map.mapTypes.set(String(i), it);
    });
  },
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  clickableIcons: function clickableIcons(map, clickable) {
    map.setClickableIcons(clickable);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options3) {
    map.setOptions(_options3);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
}; // TODO: unfinished!

function GoogleMapFunctional(_ref36) {
  var children = _ref36.children,
      options = _ref36.options,
      id = _ref36.id,
      mapContainerStyle = _ref36.mapContainerStyle,
      mapContainerClassName = _ref36.mapContainerClassName,
      center = _ref36.center,
      onClick = _ref36.onClick,
      onDblClick = _ref36.onDblClick,
      onDrag = _ref36.onDrag,
      onDragEnd = _ref36.onDragEnd,
      onDragStart = _ref36.onDragStart,
      onMouseMove = _ref36.onMouseMove,
      onMouseOut = _ref36.onMouseOut,
      onMouseOver = _ref36.onMouseOver,
      onMouseDown = _ref36.onMouseDown,
      onMouseUp = _ref36.onMouseUp,
      onRightClick = _ref36.onRightClick,
      onCenterChanged = _ref36.onCenterChanged,
      onLoad = _ref36.onLoad,
      onUnmount = _ref36.onUnmount;

  var _React$useState2 = React.useState(null),
      _React$useState3 = _slicedToArray2(_React$useState2, 2),
      map = _React$useState3[0],
      setMap = _React$useState3[1];

  var ref = React.useRef(null); // const [extraMapTypesListener, setExtraMapTypesListener] = useState<google.maps.MapsEventListener | null>(null)

  var _React$useState4 = React.useState(null),
      _React$useState5 = _slicedToArray2(_React$useState4, 2),
      centerChangedListener = _React$useState5[0],
      setCenterChangedListener = _React$useState5[1];

  var _React$useState6 = React.useState(null),
      _React$useState7 = _slicedToArray2(_React$useState6, 2),
      dblclickListener = _React$useState7[0],
      setDblclickListener = _React$useState7[1];

  var _React$useState8 = React.useState(null),
      _React$useState9 = _slicedToArray2(_React$useState8, 2),
      dragendListener = _React$useState9[0],
      setDragendListener = _React$useState9[1];

  var _React$useState10 = React.useState(null),
      _React$useState11 = _slicedToArray2(_React$useState10, 2),
      dragstartListener = _React$useState11[0],
      setDragstartListener = _React$useState11[1];

  var _React$useState12 = React.useState(null),
      _React$useState13 = _slicedToArray2(_React$useState12, 2),
      mousedownListener = _React$useState13[0],
      setMousedownListener = _React$useState13[1];

  var _React$useState14 = React.useState(null),
      _React$useState15 = _slicedToArray2(_React$useState14, 2),
      mousemoveListener = _React$useState15[0],
      setMousemoveListener = _React$useState15[1];

  var _React$useState16 = React.useState(null),
      _React$useState17 = _slicedToArray2(_React$useState16, 2),
      mouseoutListener = _React$useState17[0],
      setMouseoutListener = _React$useState17[1];

  var _React$useState18 = React.useState(null),
      _React$useState19 = _slicedToArray2(_React$useState18, 2),
      mouseoverListener = _React$useState19[0],
      setMouseoverListener = _React$useState19[1];

  var _React$useState20 = React.useState(null),
      _React$useState21 = _slicedToArray2(_React$useState20, 2),
      mouseupListener = _React$useState21[0],
      setMouseupListener = _React$useState21[1];

  var _React$useState22 = React.useState(null),
      _React$useState23 = _slicedToArray2(_React$useState22, 2),
      rightclickListener = _React$useState23[0],
      setRightclickListener = _React$useState23[1];

  var _React$useState24 = React.useState(null),
      _React$useState25 = _slicedToArray2(_React$useState24, 2),
      clickListener = _React$useState25[0],
      setClickListener = _React$useState25[1];

  var _React$useState26 = React.useState(null),
      _React$useState27 = _slicedToArray2(_React$useState26, 2),
      dragListener = _React$useState27[0],
      setDragListener = _React$useState27[1]; // Order does matter


  React.useEffect(function () {
    if (options && map !== null) {
      map.setOptions(options);
    }
  }, [map, options]);
  React.useEffect(function () {
    if (map !== null && typeof center !== 'undefined') {
      map.setCenter(center);
    }
  }, [map, center]);
  React.useEffect(function () {
    if (map && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(map, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (map && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(map, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (map && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(map, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (map && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(map, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (map && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(map, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (map && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(map, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (map && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(map, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (map && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(map, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (map && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(map, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (map && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(map, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (map && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(map, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (map && onCenterChanged) {
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }

      setCenterChangedListener(google.maps.event.addListener(map, 'center_changed', onCenterChanged));
    }
  }, [onClick]);
  React.useEffect(function () {
    var map = ref.current === null ? null : new google.maps.Map(ref.current, options);
    setMap(map);

    if (map !== null && onLoad) {
      onLoad(map);
    }

    return function () {
      if (map !== null) {
        if (onUnmount) {
          onUnmount(map);
        }
      }
    };
  }, []);
  return jsxRuntime.exports.jsx("div", Object.assign({
    id: id,
    ref: ref,
    style: mapContainerStyle,
    className: mapContainerClassName
  }, {
    children: jsxRuntime.exports.jsx(MapContext.Provider, Object.assign({
      value: map
    }, {
      children: map !== null ? children : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {})
    }))
  }));
}

React.memo(GoogleMapFunctional);

var GoogleMap = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits2(GoogleMap, _React$PureComponent2);

  var _super2 = _createSuper2(GoogleMap);

  function GoogleMap() {
    var _this9;

    _classCallCheck2(this, GoogleMap);

    _this9 = _super2.apply(this, arguments);
    _this9.state = {
      map: null
    };
    _this9.registeredEvents = [];
    _this9.mapRef = null;

    _this9.getInstance = function () {
      if (_this9.mapRef === null) {
        return null;
      }

      return new google.maps.Map(_this9.mapRef, _this9.props.options);
    };

    _this9.panTo = function (latLng) {
      var map = _this9.getInstance();

      if (map) {
        map.panTo(latLng);
      }
    };

    _this9.setMapCallback = function () {
      if (_this9.state.map !== null) {
        if (_this9.props.onLoad) {
          _this9.props.onLoad(_this9.state.map);
        }
      }
    };

    _this9.getRef = function (ref) {
      _this9.mapRef = ref;
    };

    return _this9;
  }

  _createClass2(GoogleMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var map = this.getInstance();
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$i,
        eventMap: eventMap$i,
        prevProps: {},
        nextProps: this.props,
        instance: map
      });
      this.setState(function setMap() {
        return {
          map: map
        };
      }, this.setMapCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.map !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$i,
          eventMap: eventMap$i,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.map
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.map !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.map);
        }

        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        id: this.props.id,
        ref: this.getRef,
        style: this.props.mapContainerStyle,
        className: this.props.mapContainerClassName
      }, {
        children: jsxRuntime.exports.jsx(MapContext.Provider, Object.assign({
          value: this.state.map
        }, {
          children: this.state.map !== null ? this.props.children : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {})
        }))
      }));
    }
  }]);

  return GoogleMap;
}(React.PureComponent);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest$1(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var isBrowser = typeof document !== 'undefined';

function injectScript(_ref37) {
  var url = _ref37.url,
      id = _ref37.id,
      nonce = _ref37.nonce;

  if (!isBrowser) {
    return Promise.reject(new Error('document is undefined'));
  }

  return new Promise(function injectScriptCallback(resolve, reject) {
    var existingScript = document.getElementById(id);
    var windowWithGoogleMap = window;

    if (existingScript) {
      // Same script id/url: keep same script
      var dataStateAttribute = existingScript.getAttribute('data-state');

      if (existingScript.src === url && dataStateAttribute !== 'error') {
        if (dataStateAttribute === 'ready') {
          return resolve(id);
        } else {
          var originalInitMap = windowWithGoogleMap.initMap;
          var originalErrorCallback = existingScript.onerror;

          windowWithGoogleMap.initMap = function initMap() {
            if (originalInitMap) {
              originalInitMap();
            }

            resolve(id);
          };

          existingScript.onerror = function (err) {
            if (originalErrorCallback) {
              originalErrorCallback(err);
            }

            reject(err);
          };

          return;
        }
      } // Same script id, but either
      // 1. requested URL is different
      // 2. script failed to load
      else {
        existingScript.remove();
      }
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.async = true;
    script.nonce = nonce;

    script.onerror = function onerror(err) {
      script.setAttribute('data-state', 'error');
      reject(err);
    };

    windowWithGoogleMap.initMap = function onload() {
      script.setAttribute('data-state', 'ready');
      resolve(id);
    };

    document.head.appendChild(script);
  }).catch(function (err) {
    console.error('injectScript error: ', err);
    throw err;
  });
}

function isGoogleFontStyle(element) {
  // 'Roboto' or 'Google Sans Text' font download
  var href = element.href;

  if (href && (href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0 || href.indexOf('https://fonts.googleapis.com/css?family=Google+Sans+Text') === 0)) {
    return true;
  } // font style elements


  if (element.tagName.toLowerCase() === 'style' && // @ts-ignore
  element.styleSheet && // @ts-ignore
  element.styleSheet.cssText && // @ts-ignore
  element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // @ts-ignore
    element.styleSheet.cssText = '';
    return true;
  } // font style elements for other browsers


  if (element.tagName.toLowerCase() === 'style' && element.innerHTML && element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
    element.innerHTML = '';
    return true;
  } // when google tries to add empty style


  if (element.tagName.toLowerCase() === 'style' && // @ts-ignore
  !element.styleSheet && !element.innerHTML) {
    return true;
  }

  return false;
} // Preventing the Google Maps library from downloading an extra font


function preventGoogleFonts() {
  // we override these methods only for one particular head element
  // default methods for other elements are not affected
  var head = document.getElementsByTagName('head')[0];
  var trueInsertBefore = head.insertBefore.bind(head); // TODO: adding return before reflect solves the TS issue
  // @ts-ignore

  head.insertBefore = function insertBefore(newElement, referenceElement) {
    if (!isGoogleFontStyle(newElement)) {
      Reflect.apply(trueInsertBefore, head, [newElement, referenceElement]);
    }
  };

  var trueAppend = head.appendChild.bind(head); // TODO: adding return before reflect solves the TS issue
  // @ts-ignore

  head.appendChild = function appendChild(textNode) {
    if (!isGoogleFontStyle(textNode)) {
      Reflect.apply(trueAppend, head, [textNode]);
    }
  };
}

function makeLoadScriptUrl(_ref38) {
  var googleMapsApiKey = _ref38.googleMapsApiKey,
      googleMapsClientId = _ref38.googleMapsClientId,
      _ref38$version = _ref38.version,
      version = _ref38$version === void 0 ? 'weekly' : _ref38$version,
      language = _ref38.language,
      region = _ref38.region,
      libraries = _ref38.libraries,
      channel = _ref38.channel,
      mapIds = _ref38.mapIds,
      authReferrerPolicy = _ref38.authReferrerPolicy;
  var params = [];
  invariant_1$1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.');

  if (googleMapsApiKey) {
    params.push("key=".concat(googleMapsApiKey));
  } else if (googleMapsClientId) {
    params.push("client=".concat(googleMapsClientId));
  }

  if (version) {
    params.push("v=".concat(version));
  }

  if (language) {
    params.push("language=".concat(language));
  }

  if (region) {
    params.push("region=".concat(region));
  }

  if (libraries && libraries.length) {
    params.push("libraries=".concat(libraries.sort().join(',')));
  }

  if (channel) {
    params.push("channel=".concat(channel));
  }

  if (mapIds && mapIds.length) {
    params.push("map_ids=".concat(mapIds.join(',')));
  }

  if (authReferrerPolicy) {
    params.push("auth_referrer_policy=".concat(authReferrerPolicy));
  }

  params.push('callback=initMap');
  return "https://maps.googleapis.com/maps/api/js?".concat(params.join('&'));
}

var cleaningUp = false;

function DefaultLoadingElement() {
  return jsxRuntime.exports.jsx("div", {
    children: "Loading..."
  });
}

var defaultLoadScriptProps = {
  id: 'script-loader',
  version: 'weekly'
};

var LoadScript = /*#__PURE__*/function (_React$PureComponent3) {
  _inherits2(LoadScript, _React$PureComponent3);

  var _super3 = _createSuper2(LoadScript);

  function LoadScript() {
    var _this10;

    _classCallCheck2(this, LoadScript);

    _this10 = _super3.apply(this, arguments);
    _this10.check = React.createRef();
    _this10.state = {
      loaded: false
    };

    _this10.cleanupCallback = function () {
      // @ts-ignore
      delete window.google.maps;

      _this10.injectScript();
    };

    _this10.isCleaningUp = function () {
      return __awaiter(_assertThisInitialized3(_this10), void 0, void 0, /*#__PURE__*/_regeneratorRuntime2.mark(function _callee5() {
        var promiseCallback;
        return _regeneratorRuntime2.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                promiseCallback = function _promiseCallback(resolve) {
                  if (!cleaningUp) {
                    resolve();
                  } else {
                    if (isBrowser) {
                      var timer = window.setInterval(function interval() {
                        if (!cleaningUp) {
                          window.clearInterval(timer);
                          resolve();
                        }
                      }, 1);
                    }
                  }

                  return;
                };

                return _context5.abrupt("return", new Promise(promiseCallback));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    };

    _this10.cleanup = function () {
      cleaningUp = true;
      var script = document.getElementById(_this10.props.id);

      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }

      Array.prototype.slice.call(document.getElementsByTagName('script')).filter(function filter(script) {
        return typeof script.src === 'string' && script.src.includes('maps.googleapis');
      }).forEach(function forEach(script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('link')).filter(function filter(link) {
        return link.href === 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans';
      }).forEach(function forEach(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('style')).filter(function filter(style) {
        return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes('.gm-');
      }).forEach(function forEach(style) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    };

    _this10.injectScript = function () {
      if (_this10.props.preventGoogleFontsLoading) {
        preventGoogleFonts();
      }

      invariant_1$1(!!_this10.props.id, 'LoadScript requires "id" prop to be a string: %s', _this10.props.id);
      var injectScriptOptions = {
        id: _this10.props.id,
        nonce: _this10.props.nonce,
        url: makeLoadScriptUrl(_this10.props)
      };
      injectScript(injectScriptOptions).then(function () {
        if (_this10.props.onLoad) {
          _this10.props.onLoad();
        }

        _this10.setState(function setLoaded() {
          return {
            loaded: true
          };
        });

        return;
      }).catch(function (err) {
        if (_this10.props.onError) {
          _this10.props.onError(err);
        }

        console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this10.props.googleMapsApiKey || '-', ") or Client ID (").concat(_this10.props.googleMapsClientId || '-', ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
      });
    };

    return _this10;
  }

  _createClass2(LoadScript, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isBrowser) {
        if (window.google && window.google.maps && !cleaningUp) {
          console.error('google api is already presented');
          return;
        }

        this.isCleaningUp().then(this.injectScript).catch(function error(err) {
          console.error('Error at injecting script after cleaning up: ', err);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.libraries !== prevProps.libraries) {
        console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
      }

      if (isBrowser && prevProps.language !== this.props.language) {
        this.cleanup(); // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
        // eslint-disable-next-line react/no-did-update-set-state

        this.setState(function setLoaded() {
          return {
            loaded: false
          };
        }, this.cleanupCallback);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this11 = this;

      if (isBrowser) {
        this.cleanup();

        var timeoutCallback = function timeoutCallback() {
          if (!_this11.check.current) {
            // @ts-ignore
            delete window.google;
            cleaningUp = false;
          }
        };

        window.setTimeout(timeoutCallback, 1);

        if (this.props.onUnmount) {
          this.props.onUnmount();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, {
        children: [jsxRuntime.exports.jsx("div", {
          ref: this.check
        }), this.state.loaded ? this.props.children : this.props.loadingElement || jsxRuntime.exports.jsx(DefaultLoadingElement, {})]
      });
    }
  }]);

  return LoadScript;
}(React.PureComponent);

LoadScript.defaultProps = defaultLoadScriptProps;
/* eslint-disable filenames/match-regex */

var previouslyLoadedUrl;

function useLoadScript(_ref39) {
  var _ref39$id = _ref39.id,
      id = _ref39$id === void 0 ? defaultLoadScriptProps.id : _ref39$id,
      _ref39$version = _ref39.version,
      version = _ref39$version === void 0 ? defaultLoadScriptProps.version : _ref39$version,
      nonce = _ref39.nonce,
      googleMapsApiKey = _ref39.googleMapsApiKey,
      googleMapsClientId = _ref39.googleMapsClientId,
      language = _ref39.language,
      region = _ref39.region,
      libraries = _ref39.libraries,
      preventGoogleFontsLoading = _ref39.preventGoogleFontsLoading,
      channel = _ref39.channel,
      mapIds = _ref39.mapIds,
      authReferrerPolicy = _ref39.authReferrerPolicy;
  var isMounted = React.useRef(false);

  var _React$useState28 = React.useState(false),
      _React$useState29 = _slicedToArray2(_React$useState28, 2),
      isLoaded = _React$useState29[0],
      setLoaded = _React$useState29[1];

  var _React$useState30 = React.useState(undefined),
      _React$useState31 = _slicedToArray2(_React$useState30, 2),
      loadError = _React$useState31[0],
      setLoadError = _React$useState31[1];

  React.useEffect(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  React.useEffect(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  React.useEffect(function validateLoadedState() {
    if (isLoaded) {
      invariant_1$1(!!window.google, 'useLoadScript was marked as loaded, but window.google is not present. Something went wrong.');
    }
  }, [isLoaded]);
  var url = makeLoadScriptUrl({
    version: version,
    googleMapsApiKey: googleMapsApiKey,
    googleMapsClientId: googleMapsClientId,
    language: language,
    region: region,
    libraries: libraries,
    channel: channel,
    mapIds: mapIds,
    authReferrerPolicy: authReferrerPolicy
  });
  React.useEffect(function loadScriptAndModifyLoadedState() {
    if (!isBrowser) {
      return;
    }

    function setLoadedIfMounted() {
      if (isMounted.current) {
        setLoaded(true);
        previouslyLoadedUrl = url;
      }
    }

    if (window.google && window.google.maps && previouslyLoadedUrl === url) {
      setLoadedIfMounted();
      return;
    }

    injectScript({
      id: id,
      url: url,
      nonce: nonce
    }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
      if (isMounted.current) {
        setLoadError(err);
      }

      console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || '-', ") or Client ID (").concat(googleMapsClientId || '-', ")\n        Otherwise it is a Network issue.\n      "));
      console.error(err);
    });
  }, [id, url, nonce]);
  var prevLibraries = React.useRef();
  React.useEffect(function checkPerformance() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }

    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError,
    url: url
  };
}

var defaultLoadingElement = jsxRuntime.exports.jsx(DefaultLoadingElement, {});

function LoadScriptNext(_a) {
  var loadingElement = _a.loadingElement,
      onLoad = _a.onLoad,
      onError = _a.onError,
      onUnmount = _a.onUnmount,
      children = _a.children,
      hookOptions = __rest$1(_a, ["loadingElement", "onLoad", "onError", "onUnmount", "children"]);

  var _useLoadScript2 = useLoadScript(hookOptions),
      isLoaded = _useLoadScript2.isLoaded,
      loadError = _useLoadScript2.loadError;

  React.useEffect(function handleOnLoad() {
    if (isLoaded && typeof onLoad === 'function') {
      onLoad();
    }
  }, [isLoaded, onLoad]);
  React.useEffect(function handleOnError() {
    if (loadError && typeof onError === 'function') {
      onError(loadError);
    }
  }, [loadError, onError]);
  React.useEffect(function handleOnUnmount() {
    return function () {
      if (onUnmount) {
        onUnmount();
      }
    };
  }, [onUnmount]);
  return isLoaded ? children : loadingElement || defaultLoadingElement;
}

React.memo(LoadScriptNext);
/**
 * The status of the [[Loader]].
 */

var LoaderStatus;

(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
  LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
  LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
  LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));

var eventMap$h = {};
var updaterMap$h = {
  options: function options(instance, _options4) {
    instance.setOptions(_options4);
  }
};

function TrafficLayerFunctional(_ref40) {
  var options = _ref40.options,
      onLoad = _ref40.onLoad,
      onUnmount = _ref40.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState32 = React.useState(null),
      _React$useState33 = _slicedToArray2(_React$useState32, 2),
      instance = _React$useState33[0],
      setInstance = _React$useState33[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    var trafficLayer = new google.maps.TrafficLayer(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));
    setInstance(trafficLayer);

    if (onLoad) {
      onLoad(trafficLayer);
    }

    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        }

        instance.setMap(null);
      }
    };
  }, []);
  return null;
}

React.memo(TrafficLayerFunctional);

var TrafficLayer = /*#__PURE__*/function (_React$PureComponent4) {
  _inherits2(TrafficLayer, _React$PureComponent4);

  var _super4 = _createSuper2(TrafficLayer);

  function TrafficLayer() {
    var _this12;

    _classCallCheck2(this, TrafficLayer);

    _this12 = _super4.apply(this, arguments);
    _this12.state = {
      trafficLayer: null
    };

    _this12.setTrafficLayerCallback = function () {
      if (_this12.state.trafficLayer !== null && _this12.props.onLoad) {
        _this12.props.onLoad(_this12.state.trafficLayer);
      }
    };

    _this12.registeredEvents = [];
    return _this12;
  }

  _createClass2(TrafficLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var trafficLayer = new google.maps.TrafficLayer(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$h,
        eventMap: eventMap$h,
        prevProps: {},
        nextProps: this.props,
        instance: trafficLayer
      });
      this.setState(function setTrafficLayer() {
        return {
          trafficLayer: trafficLayer
        };
      }, this.setTrafficLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.trafficLayer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$h,
          eventMap: eventMap$h,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.trafficLayer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.trafficLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.trafficLayer);
        }

        unregisterEvents(this.registeredEvents); // @ts-ignore

        this.state.trafficLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TrafficLayer;
}(React.PureComponent);

TrafficLayer.contextType = MapContext;

function BicyclingLayerFunctional(_ref41) {
  var onLoad = _ref41.onLoad,
      onUnmount = _ref41.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState34 = React.useState(null),
      _React$useState35 = _slicedToArray2(_React$useState34, 2),
      instance = _React$useState35[0],
      setInstance = _React$useState35[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    var bicyclingLayer = new google.maps.BicyclingLayer();
    setInstance(bicyclingLayer);
    bicyclingLayer.setMap(map);

    if (onLoad) {
      onLoad(bicyclingLayer);
    }

    return function () {
      if (bicyclingLayer !== null) {
        if (onUnmount) {
          onUnmount(bicyclingLayer);
        }

        bicyclingLayer.setMap(null);
      }
    };
  }, []);
  return null;
}

React.memo(BicyclingLayerFunctional);

var BicyclingLayer = /*#__PURE__*/function (_React$PureComponent5) {
  _inherits2(BicyclingLayer, _React$PureComponent5);

  var _super5 = _createSuper2(BicyclingLayer);

  function BicyclingLayer() {
    var _this13;

    _classCallCheck2(this, BicyclingLayer);

    _this13 = _super5.apply(this, arguments);
    _this13.state = {
      bicyclingLayer: null
    };

    _this13.setBicyclingLayerCallback = function () {
      if (_this13.state.bicyclingLayer !== null) {
        _this13.state.bicyclingLayer.setMap(_this13.context);

        if (_this13.props.onLoad) {
          _this13.props.onLoad(_this13.state.bicyclingLayer);
        }
      }
    };

    return _this13;
  }

  _createClass2(BicyclingLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var bicyclingLayer = new google.maps.BicyclingLayer();
      this.setState(function () {
        return {
          bicyclingLayer: bicyclingLayer
        };
      }, this.setBicyclingLayerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.bicyclingLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.bicyclingLayer);
        }

        this.state.bicyclingLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return BicyclingLayer;
}(React.PureComponent);

BicyclingLayer.contextType = MapContext;

function TransitLayerFunctional(_ref42) {
  var _this14 = this;

  var onLoad = _ref42.onLoad,
      onUnmount = _ref42.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState36 = React.useState(null),
      _React$useState37 = _slicedToArray2(_React$useState36, 2),
      instance = _React$useState37[0],
      setInstance = _React$useState37[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    var transitLayer = new google.maps.TransitLayer();
    setInstance(transitLayer);
    transitLayer.setMap(map);

    if (onLoad) {
      onLoad(transitLayer);
    }

    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        } // @ts-ignore


        _this14.state.transitLayer.setMap(null);
      }
    };
  }, []);
  return null;
}

React.memo(TransitLayerFunctional);

var TransitLayer = /*#__PURE__*/function (_React$PureComponent6) {
  _inherits2(TransitLayer, _React$PureComponent6);

  var _super6 = _createSuper2(TransitLayer);

  function TransitLayer() {
    var _this15;

    _classCallCheck2(this, TransitLayer);

    _this15 = _super6.apply(this, arguments);
    _this15.state = {
      transitLayer: null
    };

    _this15.setTransitLayerCallback = function () {
      if (_this15.state.transitLayer !== null) {
        // @ts-ignore
        _this15.state.transitLayer.setMap(_this15.context);

        if (_this15.props.onLoad) {
          // @ts-ignore
          _this15.props.onLoad(_this15.state.transitLayer);
        }
      }
    };

    return _this15;
  }

  _createClass2(TransitLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var transitLayer = new google.maps.TransitLayer();
      this.setState(function setTransitLayer() {
        return {
          transitLayer: transitLayer
        };
      }, this.setTransitLayerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.transitLayer !== null) {
        if (this.props.onUnmount) {
          // @ts-ignore
          this.props.onUnmount(this.state.transitLayer);
        } // @ts-ignore


        this.state.transitLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return TransitLayer;
}(React.PureComponent);

TransitLayer.contextType = MapContext;
/* globals google */

var eventMap$g = {
  onCircleComplete: 'circlecomplete',
  onMarkerComplete: 'markercomplete',
  onOverlayComplete: 'overlaycomplete',
  onPolygonComplete: 'polygoncomplete',
  onPolylineComplete: 'polylinecomplete',
  onRectangleComplete: 'rectanglecomplete'
};
var updaterMap$g = {
  drawingMode: function drawingMode(instance, _drawingMode) {
    instance.setDrawingMode(_drawingMode);
  },
  options: function options(instance, _options5) {
    instance.setOptions(_options5);
  }
};

function DrawingManagerFunctional(_ref43) {
  var options = _ref43.options,
      drawingMode = _ref43.drawingMode,
      onCircleComplete = _ref43.onCircleComplete,
      onMarkerComplete = _ref43.onMarkerComplete,
      onOverlayComplete = _ref43.onOverlayComplete,
      onPolygonComplete = _ref43.onPolygonComplete,
      onPolylineComplete = _ref43.onPolylineComplete,
      onRectangleComplete = _ref43.onRectangleComplete,
      onLoad = _ref43.onLoad,
      onUnmount = _ref43.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState38 = React.useState(null),
      _React$useState39 = _slicedToArray2(_React$useState38, 2),
      instance = _React$useState39[0],
      setInstance = _React$useState39[1];

  var _React$useState40 = React.useState(null),
      _React$useState41 = _slicedToArray2(_React$useState40, 2),
      circlecompleteListener = _React$useState41[0],
      setCircleCompleteListener = _React$useState41[1];

  var _React$useState42 = React.useState(null),
      _React$useState43 = _slicedToArray2(_React$useState42, 2),
      markercompleteListener = _React$useState43[0],
      setMarkerCompleteListener = _React$useState43[1];

  var _React$useState44 = React.useState(null),
      _React$useState45 = _slicedToArray2(_React$useState44, 2),
      overlaycompleteListener = _React$useState45[0],
      setOverlayCompleteListener = _React$useState45[1];

  var _React$useState46 = React.useState(null),
      _React$useState47 = _slicedToArray2(_React$useState46, 2),
      polygoncompleteListener = _React$useState47[0],
      setPolygonCompleteListener = _React$useState47[1];

  var _React$useState48 = React.useState(null),
      _React$useState49 = _slicedToArray2(_React$useState48, 2),
      polylinecompleteListener = _React$useState49[0],
      setPolylineCompleteListener = _React$useState49[1];

  var _React$useState50 = React.useState(null),
      _React$useState51 = _slicedToArray2(_React$useState50, 2),
      rectanglecompleteListener = _React$useState51[0],
      setRectangleCompleteListener = _React$useState51[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (drawingMode && instance !== null) {
      instance.setDrawingMode(drawingMode);
    }
  }, [instance, drawingMode]);
  React.useEffect(function () {
    if (instance && onCircleComplete) {
      if (circlecompleteListener !== null) {
        google.maps.event.removeListener(circlecompleteListener);
      }

      setCircleCompleteListener(google.maps.event.addListener(instance, 'circlecomplete', onCircleComplete));
    }
  }, [instance, onCircleComplete]);
  React.useEffect(function () {
    if (instance && onMarkerComplete) {
      if (markercompleteListener !== null) {
        google.maps.event.removeListener(markercompleteListener);
      }

      setMarkerCompleteListener(google.maps.event.addListener(instance, 'markercomplete', onMarkerComplete));
    }
  }, [instance, onMarkerComplete]);
  React.useEffect(function () {
    if (instance && onOverlayComplete) {
      if (overlaycompleteListener !== null) {
        google.maps.event.removeListener(overlaycompleteListener);
      }

      setOverlayCompleteListener(google.maps.event.addListener(instance, 'overlaycomplete', onOverlayComplete));
    }
  }, [instance, onOverlayComplete]);
  React.useEffect(function () {
    if (instance && onPolygonComplete) {
      if (polygoncompleteListener !== null) {
        google.maps.event.removeListener(polygoncompleteListener);
      }

      setPolygonCompleteListener(google.maps.event.addListener(instance, 'polygoncomplete', onPolygonComplete));
    }
  }, [instance, onPolygonComplete]);
  React.useEffect(function () {
    if (instance && onPolylineComplete) {
      if (polylinecompleteListener !== null) {
        google.maps.event.removeListener(polylinecompleteListener);
      }

      setPolylineCompleteListener(google.maps.event.addListener(instance, 'polylinecomplete', onPolylineComplete));
    }
  }, [instance, onPolylineComplete]);
  React.useEffect(function () {
    if (instance && onRectangleComplete) {
      if (rectanglecompleteListener !== null) {
        google.maps.event.removeListener(rectanglecompleteListener);
      }

      setRectangleCompleteListener(google.maps.event.addListener(instance, 'rectanglecomplete', onRectangleComplete));
    }
  }, [instance, onRectangleComplete]);
  React.useEffect(function () {
    invariant_1$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    var drawingManager = new google.maps.drawing.DrawingManager(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));

    if (drawingMode) {
      drawingManager.setDrawingMode(drawingMode);
    }

    if (onCircleComplete) {
      setCircleCompleteListener(google.maps.event.addListener(drawingManager, 'circlecomplete', onCircleComplete));
    }

    if (onMarkerComplete) {
      setMarkerCompleteListener(google.maps.event.addListener(drawingManager, 'markercomplete', onMarkerComplete));
    }

    if (onOverlayComplete) {
      setOverlayCompleteListener(google.maps.event.addListener(drawingManager, 'overlaycomplete', onOverlayComplete));
    }

    if (onPolygonComplete) {
      setPolygonCompleteListener(google.maps.event.addListener(drawingManager, 'polygoncomplete', onPolygonComplete));
    }

    if (onPolylineComplete) {
      setPolylineCompleteListener(google.maps.event.addListener(drawingManager, 'polylinecomplete', onPolylineComplete));
    }

    if (onRectangleComplete) {
      setRectangleCompleteListener(google.maps.event.addListener(drawingManager, 'rectanglecomplete', onRectangleComplete));
    }

    setInstance(drawingManager);

    if (onLoad) {
      onLoad(drawingManager);
    }

    return function () {
      if (instance !== null) {
        if (circlecompleteListener) {
          google.maps.event.removeListener(circlecompleteListener);
        }

        if (markercompleteListener) {
          google.maps.event.removeListener(markercompleteListener);
        }

        if (overlaycompleteListener) {
          google.maps.event.removeListener(overlaycompleteListener);
        }

        if (polygoncompleteListener) {
          google.maps.event.removeListener(polygoncompleteListener);
        }

        if (polylinecompleteListener) {
          google.maps.event.removeListener(polylinecompleteListener);
        }

        if (rectanglecompleteListener) {
          google.maps.event.removeListener(rectanglecompleteListener);
        }

        if (onUnmount) {
          onUnmount(instance);
        }

        instance.setMap(null);
      }
    };
  }, []);
  return null;
}

React.memo(DrawingManagerFunctional);

var DrawingManager = /*#__PURE__*/function (_React$PureComponent7) {
  _inherits2(DrawingManager, _React$PureComponent7);

  var _super7 = _createSuper2(DrawingManager);

  function DrawingManager(props) {
    var _this16;

    _classCallCheck2(this, DrawingManager);

    _this16 = _super7.call(this, props);
    _this16.registeredEvents = [];
    _this16.state = {
      drawingManager: null
    };

    _this16.setDrawingManagerCallback = function () {
      if (_this16.state.drawingManager !== null && _this16.props.onLoad) {
        _this16.props.onLoad(_this16.state.drawingManager);
      }
    };

    invariant_1$1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    return _this16;
  }

  _createClass2(DrawingManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var drawingManager = new google.maps.drawing.DrawingManager(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$g,
        eventMap: eventMap$g,
        prevProps: {},
        nextProps: this.props,
        instance: drawingManager
      });
      this.setState(function setDrawingManager() {
        return {
          drawingManager: drawingManager
        };
      }, this.setDrawingManagerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.drawingManager !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$g,
          eventMap: eventMap$g,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.drawingManager
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.drawingManager !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.drawingManager);
        }

        unregisterEvents(this.registeredEvents);
        this.state.drawingManager.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DrawingManager;
}(React.PureComponent);

DrawingManager.contextType = MapContext;
var eventMap$f = {
  onAnimationChanged: 'animation_changed',
  onClick: 'click',
  onClickableChanged: 'clickable_changed',
  onCursorChanged: 'cursor_changed',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDraggableChanged: 'draggable_changed',
  onDragStart: 'dragstart',
  onFlatChanged: 'flat_changed',
  onIconChanged: 'icon_changed',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onPositionChanged: 'position_changed',
  onRightClick: 'rightclick',
  onShapeChanged: 'shape_changed',
  onTitleChanged: 'title_changed',
  onVisibleChanged: 'visible_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$f = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation);
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable);
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon);
  },
  label: function label(instance, _label) {
    instance.setLabel(_label);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity);
  },
  options: function options(instance, _options6) {
    instance.setOptions(_options6);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape);
  },
  title: function title(instance, _title) {
    instance.setTitle(_title);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var defaultOptions$4 = {};

function MarkerFunctional(_ref44) {
  var position = _ref44.position,
      options = _ref44.options,
      clusterer = _ref44.clusterer,
      noClustererRedraw = _ref44.noClustererRedraw,
      children = _ref44.children,
      draggable = _ref44.draggable,
      visible = _ref44.visible,
      animation = _ref44.animation,
      clickable = _ref44.clickable,
      cursor = _ref44.cursor,
      icon = _ref44.icon,
      label = _ref44.label,
      opacity = _ref44.opacity,
      shape = _ref44.shape,
      title = _ref44.title,
      zIndex = _ref44.zIndex,
      onClick = _ref44.onClick,
      onDblClick = _ref44.onDblClick,
      onDrag = _ref44.onDrag,
      onDragEnd = _ref44.onDragEnd,
      onDragStart = _ref44.onDragStart,
      onMouseOut = _ref44.onMouseOut,
      onMouseOver = _ref44.onMouseOver,
      onMouseUp = _ref44.onMouseUp,
      onMouseDown = _ref44.onMouseDown,
      onRightClick = _ref44.onRightClick,
      onClickableChanged = _ref44.onClickableChanged,
      onCursorChanged = _ref44.onCursorChanged,
      onAnimationChanged = _ref44.onAnimationChanged,
      onDraggableChanged = _ref44.onDraggableChanged,
      onFlatChanged = _ref44.onFlatChanged,
      onIconChanged = _ref44.onIconChanged,
      onPositionChanged = _ref44.onPositionChanged,
      onShapeChanged = _ref44.onShapeChanged,
      onTitleChanged = _ref44.onTitleChanged,
      onVisibleChanged = _ref44.onVisibleChanged,
      onZindexChanged = _ref44.onZindexChanged,
      onLoad = _ref44.onLoad,
      onUnmount = _ref44.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState52 = React.useState(null),
      _React$useState53 = _slicedToArray2(_React$useState52, 2),
      instance = _React$useState53[0],
      setInstance = _React$useState53[1];

  var _React$useState54 = React.useState(null),
      _React$useState55 = _slicedToArray2(_React$useState54, 2),
      dblclickListener = _React$useState55[0],
      setDblclickListener = _React$useState55[1];

  var _React$useState56 = React.useState(null),
      _React$useState57 = _slicedToArray2(_React$useState56, 2),
      dragendListener = _React$useState57[0],
      setDragendListener = _React$useState57[1];

  var _React$useState58 = React.useState(null),
      _React$useState59 = _slicedToArray2(_React$useState58, 2),
      dragstartListener = _React$useState59[0],
      setDragstartListener = _React$useState59[1];

  var _React$useState60 = React.useState(null),
      _React$useState61 = _slicedToArray2(_React$useState60, 2),
      mousedownListener = _React$useState61[0],
      setMousedownListener = _React$useState61[1];

  var _React$useState62 = React.useState(null),
      _React$useState63 = _slicedToArray2(_React$useState62, 2),
      mouseoutListener = _React$useState63[0],
      setMouseoutListener = _React$useState63[1];

  var _React$useState64 = React.useState(null),
      _React$useState65 = _slicedToArray2(_React$useState64, 2),
      mouseoverListener = _React$useState65[0],
      setMouseoverListener = _React$useState65[1];

  var _React$useState66 = React.useState(null),
      _React$useState67 = _slicedToArray2(_React$useState66, 2),
      mouseupListener = _React$useState67[0],
      setMouseupListener = _React$useState67[1];

  var _React$useState68 = React.useState(null),
      _React$useState69 = _slicedToArray2(_React$useState68, 2),
      rightclickListener = _React$useState69[0],
      setRightclickListener = _React$useState69[1];

  var _React$useState70 = React.useState(null),
      _React$useState71 = _slicedToArray2(_React$useState70, 2),
      clickListener = _React$useState71[0],
      setClickListener = _React$useState71[1];

  var _React$useState72 = React.useState(null),
      _React$useState73 = _slicedToArray2(_React$useState72, 2),
      dragListener = _React$useState73[0],
      setDragListener = _React$useState73[1];

  var _React$useState74 = React.useState(null),
      _React$useState75 = _slicedToArray2(_React$useState74, 2),
      clickableChangedListener = _React$useState75[0],
      setClickableChangedListener = _React$useState75[1];

  var _React$useState76 = React.useState(null),
      _React$useState77 = _slicedToArray2(_React$useState76, 2),
      cursorChangedListener = _React$useState77[0],
      setCursorChangedListener = _React$useState77[1];

  var _React$useState78 = React.useState(null),
      _React$useState79 = _slicedToArray2(_React$useState78, 2),
      animationChangedListener = _React$useState79[0],
      setAnimationChangedListener = _React$useState79[1];

  var _React$useState80 = React.useState(null),
      _React$useState81 = _slicedToArray2(_React$useState80, 2),
      draggableChangedListener = _React$useState81[0],
      setDraggableChangedListener = _React$useState81[1];

  var _React$useState82 = React.useState(null),
      _React$useState83 = _slicedToArray2(_React$useState82, 2),
      flatChangedListener = _React$useState83[0],
      setFlatChangedListener = _React$useState83[1];

  var _React$useState84 = React.useState(null),
      _React$useState85 = _slicedToArray2(_React$useState84, 2),
      iconChangedListener = _React$useState85[0],
      setIconChangedListener = _React$useState85[1];

  var _React$useState86 = React.useState(null),
      _React$useState87 = _slicedToArray2(_React$useState86, 2),
      positionChangedListener = _React$useState87[0],
      setPositionChangedListener = _React$useState87[1];

  var _React$useState88 = React.useState(null),
      _React$useState89 = _slicedToArray2(_React$useState88, 2),
      shapeChangedListener = _React$useState89[0],
      setShapeChangedListener = _React$useState89[1];

  var _React$useState90 = React.useState(null),
      _React$useState91 = _slicedToArray2(_React$useState90, 2),
      titleChangedListener = _React$useState91[0],
      setTitleChangedListener = _React$useState91[1];

  var _React$useState92 = React.useState(null),
      _React$useState93 = _slicedToArray2(_React$useState92, 2),
      visibleChangedListener = _React$useState93[0],
      setVisibleChangedListener = _React$useState93[1];

  var _React$useState94 = React.useState(null),
      _React$useState95 = _slicedToArray2(_React$useState94, 2),
      zIndexChangedListener = _React$useState95[0],
      setZindexChangedListener = _React$useState95[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (position && instance !== null) {
      instance.setPosition(position);
    }
  }, [instance, position]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (animation && instance !== null) {
      instance.setAnimation(animation);
    }
  }, [instance, animation]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (instance && onClickableChanged) {
      if (clickableChangedListener !== null) {
        google.maps.event.removeListener(clickableChangedListener);
      }

      setClickableChangedListener(google.maps.event.addListener(instance, 'clickable_changed', onClickableChanged));
    }
  }, [onClickableChanged]);
  React.useEffect(function () {
    if (instance && onCursorChanged) {
      if (cursorChangedListener !== null) {
        google.maps.event.removeListener(cursorChangedListener);
      }

      setCursorChangedListener(google.maps.event.addListener(instance, 'cursor_changed', onCursorChanged));
    }
  }, [onCursorChanged]);
  React.useEffect(function () {
    if (instance && onAnimationChanged) {
      if (animationChangedListener !== null) {
        google.maps.event.removeListener(animationChangedListener);
      }

      setAnimationChangedListener(google.maps.event.addListener(instance, 'animation_changed', onAnimationChanged));
    }
  }, [onAnimationChanged]);
  React.useEffect(function () {
    if (instance && onDraggableChanged) {
      if (draggableChangedListener !== null) {
        google.maps.event.removeListener(draggableChangedListener);
      }

      setDraggableChangedListener(google.maps.event.addListener(instance, 'draggable_changed', onDraggableChanged));
    }
  }, [onDraggableChanged]);
  React.useEffect(function () {
    if (instance && onFlatChanged) {
      if (flatChangedListener !== null) {
        google.maps.event.removeListener(flatChangedListener);
      }

      setFlatChangedListener(google.maps.event.addListener(instance, 'flat_changed', onFlatChanged));
    }
  }, [onFlatChanged]);
  React.useEffect(function () {
    if (instance && onIconChanged) {
      if (iconChangedListener !== null) {
        google.maps.event.removeListener(iconChangedListener);
      }

      setIconChangedListener(google.maps.event.addListener(instance, 'icon_changed', onIconChanged));
    }
  }, [onIconChanged]);
  React.useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionChangedListener !== null) {
        google.maps.event.removeListener(positionChangedListener);
      }

      setPositionChangedListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  React.useEffect(function () {
    if (instance && onShapeChanged) {
      if (shapeChangedListener !== null) {
        google.maps.event.removeListener(shapeChangedListener);
      }

      setShapeChangedListener(google.maps.event.addListener(instance, 'shape_changed', onShapeChanged));
    }
  }, [onShapeChanged]);
  React.useEffect(function () {
    if (instance && onTitleChanged) {
      if (titleChangedListener !== null) {
        google.maps.event.removeListener(titleChangedListener);
      }

      setTitleChangedListener(google.maps.event.addListener(instance, 'title_changed', onTitleChanged));
    }
  }, [onTitleChanged]);
  React.useEffect(function () {
    if (instance && onVisibleChanged) {
      if (visibleChangedListener !== null) {
        google.maps.event.removeListener(visibleChangedListener);
      }

      setVisibleChangedListener(google.maps.event.addListener(instance, 'visible_changed', onVisibleChanged));
    }
  }, [onVisibleChanged]);
  React.useEffect(function () {
    if (instance && onZindexChanged) {
      if (zIndexChangedListener !== null) {
        google.maps.event.removeListener(zIndexChangedListener);
      }

      setZindexChangedListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  React.useEffect(function () {
    var markerOptions = Object.assign(Object.assign(Object.assign({}, options || defaultOptions$4), clusterer ? defaultOptions$4 : {
      map: map
    }), {
      position: position
    });
    var marker = new google.maps.Marker(markerOptions);

    if (clusterer) {
      clusterer.addMarker(marker, !!noClustererRedraw);
    } else {
      marker.setMap(map);
    }

    if (position) {
      marker.setPosition(position);
    }

    if (typeof visible !== 'undefined') {
      marker.setVisible(visible);
    }

    if (typeof draggable !== 'undefined') {
      marker.setDraggable(draggable);
    }

    if (typeof clickable !== 'undefined') {
      marker.setClickable(clickable);
    }

    if (typeof cursor === 'string') {
      marker.setCursor(cursor);
    }

    if (icon) {
      marker.setIcon(icon);
    }

    if (typeof label !== 'undefined') {
      marker.setLabel(label);
    }

    if (typeof opacity !== 'undefined') {
      marker.setOpacity(opacity);
    }

    if (shape) {
      marker.setShape(shape);
    }

    if (typeof title === 'string') {
      marker.setTitle(title);
    }

    if (typeof zIndex === 'number') {
      marker.setZIndex(zIndex);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(marker, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(marker, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(marker, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(marker, 'mousedown', onMouseDown));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(marker, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(marker, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(marker, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(marker, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(marker, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(marker, 'drag', onDrag));
    }

    if (onClickableChanged) {
      setClickableChangedListener(google.maps.event.addListener(marker, 'clickable_changed', onClickableChanged));
    }

    if (onCursorChanged) {
      setCursorChangedListener(google.maps.event.addListener(marker, 'cursor_changed', onCursorChanged));
    }

    if (onAnimationChanged) {
      setAnimationChangedListener(google.maps.event.addListener(marker, 'animation_changed', onAnimationChanged));
    }

    if (onDraggableChanged) {
      setDraggableChangedListener(google.maps.event.addListener(marker, 'draggable_changed', onDraggableChanged));
    }

    if (onFlatChanged) {
      setFlatChangedListener(google.maps.event.addListener(marker, 'flat_changed', onFlatChanged));
    }

    if (onIconChanged) {
      setIconChangedListener(google.maps.event.addListener(marker, 'icon_changed', onIconChanged));
    }

    if (onPositionChanged) {
      setPositionChangedListener(google.maps.event.addListener(marker, 'position_changed', onPositionChanged));
    }

    if (onShapeChanged) {
      setShapeChangedListener(google.maps.event.addListener(marker, 'shape_changed', onShapeChanged));
    }

    if (onTitleChanged) {
      setTitleChangedListener(google.maps.event.addListener(marker, 'title_changed', onTitleChanged));
    }

    if (onVisibleChanged) {
      setVisibleChangedListener(google.maps.event.addListener(marker, 'visible_changed', onVisibleChanged));
    }

    if (onZindexChanged) {
      setZindexChangedListener(google.maps.event.addListener(marker, 'zindex_changed', onZindexChanged));
    }

    setInstance(marker);

    if (onLoad) {
      onLoad(marker);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (clickableChangedListener !== null) {
        google.maps.event.removeListener(clickableChangedListener);
      }

      if (cursorChangedListener !== null) {
        google.maps.event.removeListener(cursorChangedListener);
      }

      if (animationChangedListener !== null) {
        google.maps.event.removeListener(animationChangedListener);
      }

      if (draggableChangedListener !== null) {
        google.maps.event.removeListener(draggableChangedListener);
      }

      if (flatChangedListener !== null) {
        google.maps.event.removeListener(flatChangedListener);
      }

      if (iconChangedListener !== null) {
        google.maps.event.removeListener(iconChangedListener);
      }

      if (positionChangedListener !== null) {
        google.maps.event.removeListener(positionChangedListener);
      }

      if (titleChangedListener !== null) {
        google.maps.event.removeListener(titleChangedListener);
      }

      if (visibleChangedListener !== null) {
        google.maps.event.removeListener(visibleChangedListener);
      }

      if (zIndexChangedListener !== null) {
        google.maps.event.removeListener(zIndexChangedListener);
      }

      if (onUnmount) {
        onUnmount(marker);
      }

      if (clusterer) {
        clusterer.removeMarker(marker, !!noClustererRedraw);
      } else if (marker) {
        marker.setMap(null);
      }
    };
  }, []);
  var chx = React.useMemo(function () {
    return children ? React.Children.map(children, function (child) {
      if (!React.isValidElement(child)) {
        return child;
      }

      var elementChild = child;
      return React.cloneElement(elementChild, {
        anchor: instance
      });
    }) : null;
  }, [children, instance]);
  return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {
    children: chx
  }) || null;
}

React.memo(MarkerFunctional);

var Marker = /*#__PURE__*/function (_React$PureComponent8) {
  _inherits2(Marker, _React$PureComponent8);

  var _super8 = _createSuper2(Marker);

  function Marker() {
    var _this17;

    _classCallCheck2(this, Marker);

    _this17 = _super8.apply(this, arguments);
    _this17.registeredEvents = [];
    return _this17;
  }

  _createClass2(Marker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var markerOptions = Object.assign(Object.assign(Object.assign({}, this.props.options || defaultOptions$4), this.props.clusterer ? defaultOptions$4 : {
        map: this.context
      }), {
        position: this.props.position
      }); // Unfortunately we can't just do this in the contstructor, because the
      // `MapContext` might not be filled in yet.

      this.marker = new google.maps.Marker(markerOptions);

      if (this.props.clusterer) {
        this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
      } else {
        this.marker.setMap(this.context);
      }

      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$f,
        eventMap: eventMap$f,
        prevProps: {},
        nextProps: this.props,
        instance: this.marker
      });

      if (this.props.onLoad) {
        this.props.onLoad(this.marker);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.marker) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$f,
          eventMap: eventMap$f,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.marker
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.marker) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.marker);
        }

        unregisterEvents(this.registeredEvents);

        if (this.props.clusterer) {
          this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
        } else {
          this.marker && this.marker.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this18 = this;

      var children = null;

      if (this.props.children) {
        children = React.Children.map(this.props.children, function (child) {
          if (!React.isValidElement(child)) {
            return child;
          }

          var elementChild = child;
          return React.cloneElement(elementChild, {
            anchor: _this18.marker
          });
        });
      }

      return children || null;
    }
  }]);

  return Marker;
}(React.PureComponent);

Marker.contextType = MapContext;

var ClusterIcon =
/** @class */
function () {
  function ClusterIcon(cluster, styles) {
    cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.cluster = cluster;
    this.clusterClassName = this.cluster.getClusterer().getClusterClass();
    this.className = this.clusterClassName;
    this.styles = styles;
    this.center = undefined;
    this.div = null;
    this.sums = null;
    this.visible = false;
    this.boundsChangedListener = null;
    this.url = '';
    this.height = 0;
    this.width = 0;
    this.anchorText = [0, 0];
    this.anchorIcon = [0, 0];
    this.textColor = 'black';
    this.textSize = 11;
    this.textDecoration = 'none';
    this.fontWeight = 'bold';
    this.fontStyle = 'normal';
    this.fontFamily = 'Arial,sans-serif';
    this.backgroundPosition = '0 0';
    this.cMouseDownInCluster = null;
    this.cDraggingMapByCluster = null;
    this.timeOut = null;
    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called

    this.onBoundsChanged = this.onBoundsChanged.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.draw = this.draw.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.useStyle = this.useStyle.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
  }

  ClusterIcon.prototype.onBoundsChanged = function () {
    this.cDraggingMapByCluster = this.cMouseDownInCluster;
  };

  ClusterIcon.prototype.onMouseDown = function () {
    this.cMouseDownInCluster = true;
    this.cDraggingMapByCluster = false;
  };

  ClusterIcon.prototype.onClick = function (event) {
    this.cMouseDownInCluster = false;

    if (!this.cDraggingMapByCluster) {
      var markerClusterer_1 = this.cluster.getClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */

      google.maps.event.trigger(markerClusterer_1, 'click', this.cluster);
      google.maps.event.trigger(markerClusterer_1, 'clusterclick', this.cluster); // deprecated name
      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.

      if (markerClusterer_1.getZoomOnClick()) {
        // Zoom into the cluster.
        var maxZoom_1 = markerClusterer_1.getMaxZoom();
        var bounds_1 = this.cluster.getBounds();
        var map = markerClusterer_1.getMap();

        if (map !== null && 'fitBounds' in map) {
          map.fitBounds(bounds_1);
        } // There is a fix for Issue 170 here:


        this.timeOut = window.setTimeout(function () {
          var map = markerClusterer_1.getMap();

          if (map !== null) {
            if ('fitBounds' in map) {
              map.fitBounds(bounds_1);
            }

            var zoom = map.getZoom() || 0; // Don't zoom beyond the max zoom level

            if (maxZoom_1 !== null && zoom > maxZoom_1) {
              map.setZoom(maxZoom_1 + 1);
            }
          }
        }, 100);
      } // Prevent event propagation to the map:


      event.cancelBubble = true;

      if (event.stopPropagation) {
        event.stopPropagation();
      }
    }
  };

  ClusterIcon.prototype.onMouseOver = function () {
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseover', this.cluster);
  };

  ClusterIcon.prototype.onMouseOut = function () {
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseout', this.cluster);
  };

  ClusterIcon.prototype.onAdd = function () {
    var _a;

    this.div = document.createElement('div');
    this.div.className = this.className;

    if (this.visible) {
      this.show();
    }

    (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a.overlayMouseTarget.appendChild(this.div);
    var map = this.getMap();

    if (map !== null) {
      // Fix for Issue 157
      this.boundsChangedListener = google.maps.event.addListener(map, 'bounds_changed', this.onBoundsChanged);
      this.div.addEventListener('mousedown', this.onMouseDown);
      this.div.addEventListener('click', this.onClick);
      this.div.addEventListener('mouseover', this.onMouseOver);
      this.div.addEventListener('mouseout', this.onMouseOut);
    }
  };

  ClusterIcon.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.hide();

      if (this.boundsChangedListener !== null) {
        google.maps.event.removeListener(this.boundsChangedListener);
      }

      this.div.removeEventListener('mousedown', this.onMouseDown);
      this.div.removeEventListener('click', this.onClick);
      this.div.removeEventListener('mouseover', this.onMouseOver);
      this.div.removeEventListener('mouseout', this.onMouseOut);
      this.div.parentNode.removeChild(this.div);

      if (this.timeOut !== null) {
        window.clearTimeout(this.timeOut);
        this.timeOut = null;
      }

      this.div = null;
    }
  };

  ClusterIcon.prototype.draw = function () {
    if (this.visible && this.div !== null && this.center) {
      var pos = this.getPosFromLatLng(this.center);
      this.div.style.top = pos !== null ? "".concat(pos.y, "px") : '0';
      this.div.style.left = pos !== null ? "".concat(pos.x, "px") : '0';
    }
  };

  ClusterIcon.prototype.hide = function () {
    if (this.div) {
      this.div.style.display = 'none';
    }

    this.visible = false;
  };

  ClusterIcon.prototype.show = function () {
    var _a;

    if (this.div && this.center) {
      var divTitle = ''; // NOTE: values must be specified in px units

      var bp = this.backgroundPosition.split(' ');
      var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ''), 10);
      var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ''), 10);
      var pos = this.getPosFromLatLng(this.center);

      if (this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '') {
        divTitle = this.cluster.getClusterer().getTitle();
      } else {
        divTitle = this.sums.title;
      }

      this.div.className = this.className;
      this.div.style.cursor = 'pointer';
      this.div.style.position = 'absolute';
      this.div.style.top = pos !== null ? "".concat(pos.y, "px") : '0';
      this.div.style.left = pos !== null ? "".concat(pos.x, "px") : '0';
      this.div.style.width = "".concat(this.width, "px");
      this.div.style.height = "".concat(this.height, "px");
      var img = document.createElement('img');
      img.alt = divTitle;
      img.src = this.url;
      img.width = this.width;
      img.height = this.height;
      img.style.position = 'absolute';
      img.style.top = "".concat(spriteV, "px");
      img.style.left = "".concat(spriteH, "px");

      if (!this.cluster.getClusterer().enableRetinaIcons) {
        img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
      }

      var textElm = document.createElement('div');
      textElm.style.position = 'absolute';
      textElm.style.top = "".concat(this.anchorText[0], "px");
      textElm.style.left = "".concat(this.anchorText[1], "px");
      textElm.style.color = this.textColor;
      textElm.style.fontSize = "".concat(this.textSize, "px");
      textElm.style.fontFamily = this.fontFamily;
      textElm.style.fontWeight = this.fontWeight;
      textElm.style.fontStyle = this.fontStyle;
      textElm.style.textDecoration = this.textDecoration;
      textElm.style.textAlign = 'center';
      textElm.style.width = "".concat(this.width, "px");
      textElm.style.lineHeight = "".concat(this.height, "px");
      textElm.innerText = "".concat((_a = this.sums) === null || _a === void 0 ? void 0 : _a.text);
      this.div.innerHTML = '';
      this.div.appendChild(img);
      this.div.appendChild(textElm);
      this.div.title = divTitle;
      this.div.style.display = '';
    }

    this.visible = true;
  };

  ClusterIcon.prototype.useStyle = function (sums) {
    this.sums = sums;
    var styles = this.cluster.getClusterer().getStyles();
    var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
    this.url = style.url;
    this.height = style.height;
    this.width = style.width;
    if (style.className) this.className = "".concat(this.clusterClassName, " ").concat(style.className);
    this.anchorText = style.anchorText || [0, 0];
    this.anchorIcon = style.anchorIcon || [this.height / 2, this.width / 2];
    this.textColor = style.textColor || 'black';
    this.textSize = style.textSize || 11;
    this.textDecoration = style.textDecoration || 'none';
    this.fontWeight = style.fontWeight || 'bold';
    this.fontStyle = style.fontStyle || 'normal';
    this.fontFamily = style.fontFamily || 'Arial,sans-serif';
    this.backgroundPosition = style.backgroundPosition || '0 0';
  };

  ClusterIcon.prototype.setCenter = function (center) {
    this.center = center;
  };

  ClusterIcon.prototype.getPosFromLatLng = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);

    if (pos !== null) {
      pos.x -= this.anchorIcon[1];
      pos.y -= this.anchorIcon[0];
    }

    return pos;
  };

  return ClusterIcon;
}();

var Cluster$1 =
/** @class */
function () {
  function Cluster(markerClusterer) {
    this.markerClusterer = markerClusterer;
    this.map = this.markerClusterer.getMap();
    this.gridSize = this.markerClusterer.getGridSize();
    this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
    this.averageCenter = this.markerClusterer.getAverageCenter();
    this.markers = [];
    this.center = undefined;
    this.bounds = null;
    this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
    this.getSize = this.getSize.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.getMap = this.getMap.bind(this);
    this.getClusterer = this.getClusterer.bind(this);
    this.getBounds = this.getBounds.bind(this);
    this.remove = this.remove.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
    this.calculateBounds = this.calculateBounds.bind(this);
    this.updateIcon = this.updateIcon.bind(this);
    this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
  }

  Cluster.prototype.getSize = function () {
    return this.markers.length;
  };

  Cluster.prototype.getMarkers = function () {
    return this.markers;
  };

  Cluster.prototype.getCenter = function () {
    return this.center;
  };

  Cluster.prototype.getMap = function () {
    return this.map;
  };

  Cluster.prototype.getClusterer = function () {
    return this.markerClusterer;
  };

  Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center, this.center);
    var markers = this.getMarkers();

    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();

      if (position) {
        bounds.extend(position);
      }
    }

    return bounds;
  };

  Cluster.prototype.remove = function () {
    this.clusterIcon.setMap(null);
    this.markers = []; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    delete this.markers;
  };

  Cluster.prototype.addMarker = function (marker) {
    var _a;

    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }

    if (!this.center) {
      var position = marker.getPosition();

      if (position) {
        this.center = position;
        this.calculateBounds();
      }
    } else {
      if (this.averageCenter) {
        var position = marker.getPosition();

        if (position) {
          var length_1 = this.markers.length + 1;
          this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
          this.calculateBounds();
        }
      }
    }

    marker.isAdded = true;
    this.markers.push(marker);
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();

    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      // Zoomed in past max zoom, so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount < this.minClusterSize) {
      // Min cluster size not reached so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount === this.minClusterSize) {
      // Hide the markers that were showing.
      for (var i = 0; i < mCount; i++) {
        this.markers[i].setMap(null);
      }
    } else {
      marker.setMap(null);
    }

    return true;
  };

  Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    if (this.bounds !== null) {
      var position = marker.getPosition();

      if (position) {
        return this.bounds.contains(position);
      }
    }

    return false;
  };

  Cluster.prototype.calculateBounds = function () {
    this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
  };

  Cluster.prototype.updateIcon = function () {
    var _a;

    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();

    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      this.clusterIcon.hide();
      return;
    }

    if (mCount < this.minClusterSize) {
      // Min cluster size not yet reached.
      this.clusterIcon.hide();
      return;
    }

    if (this.center) {
      this.clusterIcon.setCenter(this.center);
    }

    this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
    this.clusterIcon.show();
  };

  Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers.includes) {
      return this.markers.includes(marker);
    }

    for (var i = 0; i < this.markers.length; i++) {
      if (marker === this.markers[i]) {
        return true;
      }
    }

    return false;
  };

  return Cluster;
}();
/* global google */

/**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */


function CALCULATOR(markers, numStyles) {
  var count = markers.length;
  var numberOfDigits = count.toString().length;
  var index = Math.min(numberOfDigits, numStyles);
  return {
    text: count.toString(),
    index: index,
    title: ''
  };
}

var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var IMAGE_EXTENSION = 'png';
var IMAGE_SIZES = [53, 56, 66, 78, 90];
var CLUSTERER_CLASS = 'cluster';

var Clusterer =
/** @class */
function () {
  function Clusterer(map, optMarkers, optOptions) {
    if (optMarkers === void 0) {
      optMarkers = [];
    }

    if (optOptions === void 0) {
      optOptions = {};
    }

    this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
    this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
    this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
    this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
    this.addToClosestCluster = this.addToClosestCluster.bind(this);
    this.getImageExtension = this.getImageExtension.bind(this);
    this.setImageExtension = this.setImageExtension.bind(this);
    this.getExtendedBounds = this.getExtendedBounds.bind(this);
    this.getAverageCenter = this.getAverageCenter.bind(this);
    this.setAverageCenter = this.setAverageCenter.bind(this);
    this.getTotalClusters = this.getTotalClusters.bind(this);
    this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
    this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
    this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
    this.getClusterClass = this.getClusterClass.bind(this);
    this.setClusterClass = this.setClusterClass.bind(this);
    this.getTotalMarkers = this.getTotalMarkers.bind(this);
    this.getZoomOnClick = this.getZoomOnClick.bind(this);
    this.setZoomOnClick = this.setZoomOnClick.bind(this);
    this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
    this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
    this.createClusters = this.createClusters.bind(this);
    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.getImageSizes = this.getImageSizes.bind(this);
    this.setImageSizes = this.setImageSizes.bind(this);
    this.getCalculator = this.getCalculator.bind(this);
    this.setCalculator = this.setCalculator.bind(this);
    this.removeMarkers = this.removeMarkers.bind(this);
    this.resetViewport = this.resetViewport.bind(this);
    this.getImagePath = this.getImagePath.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.pushMarkerTo = this.pushMarkerTo.bind(this);
    this.removeMarker = this.removeMarker.bind(this);
    this.clearMarkers = this.clearMarkers.bind(this);
    this.setupStyles = this.setupStyles.bind(this);
    this.getGridSize = this.getGridSize.bind(this);
    this.setGridSize = this.setGridSize.bind(this);
    this.getClusters = this.getClusters.bind(this);
    this.getMaxZoom = this.getMaxZoom.bind(this);
    this.setMaxZoom = this.setMaxZoom.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.addMarkers = this.addMarkers.bind(this);
    this.getStyles = this.getStyles.bind(this);
    this.setStyles = this.setStyles.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.repaint = this.repaint.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.redraw = this.redraw.bind(this);
    this.extend = this.extend.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.draw = this.draw.bind(this);
    this.extend(Clusterer, google.maps.OverlayView);
    this.markers = [];
    this.clusters = [];
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
    this.gridSize = optOptions.gridSize || 60;
    this.minClusterSize = optOptions.minimumClusterSize || 2;
    this.maxZoom = optOptions.maxZoom || null;
    this.styles = optOptions.styles || [];
    this.title = optOptions.title || '';
    this.zoomOnClick = true;

    if (optOptions.zoomOnClick !== undefined) {
      this.zoomOnClick = optOptions.zoomOnClick;
    }

    this.averageCenter = false;

    if (optOptions.averageCenter !== undefined) {
      this.averageCenter = optOptions.averageCenter;
    }

    this.ignoreHidden = false;

    if (optOptions.ignoreHidden !== undefined) {
      this.ignoreHidden = optOptions.ignoreHidden;
    }

    this.enableRetinaIcons = false;

    if (optOptions.enableRetinaIcons !== undefined) {
      this.enableRetinaIcons = optOptions.enableRetinaIcons;
    }

    this.imagePath = optOptions.imagePath || IMAGE_PATH;
    this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
    this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
    this.calculator = optOptions.calculator || CALCULATOR;
    this.batchSize = optOptions.batchSize || BATCH_SIZE;
    this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
    this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;

    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      // Try to avoid IE timeout when processing a huge number of markers:
      this.batchSize = this.batchSizeIE;
    }

    this.timerRefStatic = null;
    this.setupStyles();
    this.addMarkers(optMarkers, true);
    this.setMap(map); // Note: this causes onAdd to be called
  }

  Clusterer.prototype.onZoomChanged = function () {
    var _a, _b;

    this.resetViewport(false); // Workaround for this Google bug: when map is at level 0 and "-" of
    // zoom slider is clicked, a "zoom_changed" event is fired even though
    // the map doesn't zoom out any further. In this situation, no "idle"
    // event is triggered so the cluster markers that have been removed
    // do not get redrawn. Same goes for a zoom in at maxZoom.

    if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get('minZoom') || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get('maxZoom')) {
      google.maps.event.trigger(this, 'idle');
    }
  };

  Clusterer.prototype.onIdle = function () {
    this.redraw();
  };

  Clusterer.prototype.onAdd = function () {
    var map = this.getMap();
    this.activeMap = map;
    this.ready = true;
    this.repaint();

    if (map !== null) {
      // Add the map event listeners
      this.listeners = [google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged), google.maps.event.addListener(map, 'idle', this.onIdle)];
    }
  };

  Clusterer.prototype.onRemove = function () {
    // Put all the managed markers back on the map:
    for (var i = 0; i < this.markers.length; i++) {
      if (this.markers[i].getMap() !== this.activeMap) {
        this.markers[i].setMap(this.activeMap);
      }
    } // Remove all clusters:


    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }

    this.clusters = []; // Remove map event listeners:

    for (var i = 0; i < this.listeners.length; i++) {
      google.maps.event.removeListener(this.listeners[i]);
    }

    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
  };

  Clusterer.prototype.draw = function () {
    return;
  };

  Clusterer.prototype.setupStyles = function () {
    if (this.styles.length > 0) {
      return;
    }

    for (var i = 0; i < this.imageSizes.length; i++) {
      this.styles.push({
        url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
        height: this.imageSizes[i],
        width: this.imageSizes[i]
      });
    }
  };

  Clusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();

      if (position) {
        bounds.extend(position);
      }
    }

    var map = this.getMap();

    if (map !== null && 'fitBounds' in map) {
      map.fitBounds(bounds);
    }
  };

  Clusterer.prototype.getGridSize = function () {
    return this.gridSize;
  };

  Clusterer.prototype.setGridSize = function (gridSize) {
    this.gridSize = gridSize;
  };

  Clusterer.prototype.getMinimumClusterSize = function () {
    return this.minClusterSize;
  };

  Clusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
    this.minClusterSize = minimumClusterSize;
  };

  Clusterer.prototype.getMaxZoom = function () {
    return this.maxZoom;
  };

  Clusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom = maxZoom;
  };

  Clusterer.prototype.getStyles = function () {
    return this.styles;
  };

  Clusterer.prototype.setStyles = function (styles) {
    this.styles = styles;
  };

  Clusterer.prototype.getTitle = function () {
    return this.title;
  };

  Clusterer.prototype.setTitle = function (title) {
    this.title = title;
  };

  Clusterer.prototype.getZoomOnClick = function () {
    return this.zoomOnClick;
  };

  Clusterer.prototype.setZoomOnClick = function (zoomOnClick) {
    this.zoomOnClick = zoomOnClick;
  };

  Clusterer.prototype.getAverageCenter = function () {
    return this.averageCenter;
  };

  Clusterer.prototype.setAverageCenter = function (averageCenter) {
    this.averageCenter = averageCenter;
  };

  Clusterer.prototype.getIgnoreHidden = function () {
    return this.ignoreHidden;
  };

  Clusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
    this.ignoreHidden = ignoreHidden;
  };

  Clusterer.prototype.getEnableRetinaIcons = function () {
    return this.enableRetinaIcons;
  };

  Clusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
    this.enableRetinaIcons = enableRetinaIcons;
  };

  Clusterer.prototype.getImageExtension = function () {
    return this.imageExtension;
  };

  Clusterer.prototype.setImageExtension = function (imageExtension) {
    this.imageExtension = imageExtension;
  };

  Clusterer.prototype.getImagePath = function () {
    return this.imagePath;
  };

  Clusterer.prototype.setImagePath = function (imagePath) {
    this.imagePath = imagePath;
  };

  Clusterer.prototype.getImageSizes = function () {
    return this.imageSizes;
  };

  Clusterer.prototype.setImageSizes = function (imageSizes) {
    this.imageSizes = imageSizes;
  };

  Clusterer.prototype.getCalculator = function () {
    return this.calculator;
  };

  Clusterer.prototype.setCalculator = function (calculator) {
    this.calculator = calculator;
  };

  Clusterer.prototype.getBatchSizeIE = function () {
    return this.batchSizeIE;
  };

  Clusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
    this.batchSizeIE = batchSizeIE;
  };

  Clusterer.prototype.getClusterClass = function () {
    return this.clusterClass;
  };

  Clusterer.prototype.setClusterClass = function (clusterClass) {
    this.clusterClass = clusterClass;
  };

  Clusterer.prototype.getMarkers = function () {
    return this.markers;
  };

  Clusterer.prototype.getTotalMarkers = function () {
    return this.markers.length;
  };

  Clusterer.prototype.getClusters = function () {
    return this.clusters;
  };

  Clusterer.prototype.getTotalClusters = function () {
    return this.clusters.length;
  };

  Clusterer.prototype.addMarker = function (marker, optNoDraw) {
    this.pushMarkerTo(marker);

    if (!optNoDraw) {
      this.redraw();
    }
  };

  Clusterer.prototype.addMarkers = function (markers, optNoDraw) {
    for (var key in markers) {
      if (Object.prototype.hasOwnProperty.call(markers, key)) {
        this.pushMarkerTo(markers[key]);
      }
    }

    if (!optNoDraw) {
      this.redraw();
    }
  };

  Clusterer.prototype.pushMarkerTo = function (marker) {
    var _this = this; // If the marker is draggable add a listener so we can update the clusters on the dragend:


    if (marker.getDraggable()) {
      google.maps.event.addListener(marker, 'dragend', function () {
        if (_this.ready) {
          marker.isAdded = false;

          _this.repaint();
        }
      });
    }

    marker.isAdded = false;
    this.markers.push(marker);
  };

  Clusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;

    if (this.markers.indexOf) {
      index = this.markers.indexOf(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          index = i;
          break;
        }
      }
    }

    if (index === -1) {
      // Marker is not in our list of markers, so do nothing:
      return false;
    }

    marker.setMap(null);
    this.markers.splice(index, 1); // Remove the marker from the list of managed markers

    return true;
  };

  Clusterer.prototype.removeMarker = function (marker, optNoDraw) {
    var removed = this.removeMarker_(marker);

    if (!optNoDraw && removed) {
      this.repaint();
    }

    return removed;
  };

  Clusterer.prototype.removeMarkers = function (markers, optNoDraw) {
    var removed = false;

    for (var i = 0; i < markers.length; i++) {
      removed = removed || this.removeMarker_(markers[i]);
    }

    if (!optNoDraw && removed) {
      this.repaint();
    }

    return removed;
  };

  Clusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);
    this.markers = [];
  };

  Clusterer.prototype.repaint = function () {
    var oldClusters = this.clusters.slice();
    this.clusters = [];
    this.resetViewport(false);
    this.redraw(); // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.

    setTimeout(function timeout() {
      for (var i = 0; i < oldClusters.length; i++) {
        oldClusters[i].remove();
      }
    }, 0);
  };

  Clusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection(); // Convert the points to pixels and the extend out by the grid size.

    var trPix = projection.fromLatLngToDivPixel( // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));

    if (trPix !== null) {
      trPix.x += this.gridSize;
      trPix.y -= this.gridSize;
    }

    var blPix = projection.fromLatLngToDivPixel( // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));

    if (blPix !== null) {
      blPix.x -= this.gridSize;
      blPix.y += this.gridSize;
    } // Extend the bounds to contain the new bounds.


    if (trPix !== null) {
      // Convert the pixel points back to LatLng nw
      var point1 = projection.fromDivPixelToLatLng(trPix);

      if (point1 !== null) {
        bounds.extend(point1);
      }
    }

    if (blPix !== null) {
      // Convert the pixel points back to LatLng sw
      var point2 = projection.fromDivPixelToLatLng(blPix);

      if (point2 !== null) {
        bounds.extend(point2);
      }
    }

    return bounds;
  };

  Clusterer.prototype.redraw = function () {
    // Redraws all the clusters.
    this.createClusters(0);
  };

  Clusterer.prototype.resetViewport = function (optHide) {
    // Remove all the clusters
    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }

    this.clusters = []; // Reset the markers to not be added and to be removed from the map.

    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      marker.isAdded = false;

      if (optHide) {
        marker.setMap(null);
      }
    }
  };

  Clusterer.prototype.distanceBetweenPoints = function (p1, p2) {
    var R = 6371; // Radius of the Earth in km

    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  Clusterer.prototype.isMarkerInBounds = function (marker, bounds) {
    var position = marker.getPosition();

    if (position) {
      return bounds.contains(position);
    }

    return false;
  };

  Clusterer.prototype.addToClosestCluster = function (marker) {
    var cluster;
    var distance = 40000; // Some large number

    var clusterToAddTo = null;

    for (var i = 0; i < this.clusters.length; i++) {
      cluster = this.clusters[i];
      var center = cluster.getCenter();
      var position = marker.getPosition();

      if (center && position) {
        var d = this.distanceBetweenPoints(center, position);

        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }

    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      cluster = new Cluster$1(this);
      cluster.addMarker(marker);
      this.clusters.push(cluster);
    }
  };

  Clusterer.prototype.createClusters = function (iFirst) {
    var _this = this;

    if (!this.ready) {
      return;
    } // Cancel previous batch processing if we're working on the first batch:


    if (iFirst === 0) {
      /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringbegin', this);

      if (this.timerRefStatic !== null) {
        window.clearTimeout(this.timerRefStatic); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        delete this.timerRefStatic;
      }
    }

    var map = this.getMap();
    var bounds = map !== null && 'getBounds' in map ? map.getBounds() : null;
    var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0; // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:

    var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var extendedMapBounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize, this.markers.length);

    for (var i = iFirst; i < iLast; i++) {
      var marker = this.markers[i];

      if (!marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) {
        this.addToClosestCluster(marker);
      }
    }

    if (iLast < this.markers.length) {
      this.timerRefStatic = window.setTimeout(function () {
        _this.createClusters(iLast);
      }, 0);
    } else {
      this.timerRefStatic = null;
      /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */

      google.maps.event.trigger(this, 'clusteringend', this);

      for (var i = 0; i < this.clusters.length; i++) {
        this.clusters[i].updateIcon();
      }
    }
  };

  Clusterer.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        // @ts-ignore
        this.prototype[property] = object.prototype[property];
      }

      return this;
    }.apply(obj1, [obj2]);
  };

  return Clusterer;
}();

var eventMap$e = {
  onClick: 'click',
  onClusteringBegin: 'clusteringbegin',
  onClusteringEnd: 'clusteringend',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover'
};
var updaterMap$e = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter);
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE);
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator);
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass);
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons);
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize);
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden);
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension);
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath);
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes);
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom);
  },
  minimumClusterSize: function minimumClusterSize(instance, _minimumClusterSize) {
    instance.setMinimumClusterSize(_minimumClusterSize);
  },
  styles: function styles(instance, _styles3) {
    instance.setStyles(_styles3);
  },
  title: function title(instance, _title2) {
    instance.setTitle(_title2);
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick);
  }
};

function MarkerClustererFunctional(_ref45) {
  var children = _ref45.children;

  var _React$useState96 = React.useState(null),
      _React$useState97 = _slicedToArray2(_React$useState96, 1),
      instance
  /* setInstance */
  = _React$useState97[0]; // TODO!


  return instance !== null ? children(instance) || null : null;
}

React.memo(MarkerClustererFunctional);

var ClustererComponent = /*#__PURE__*/function (_React$PureComponent9) {
  _inherits2(ClustererComponent, _React$PureComponent9);

  var _super9 = _createSuper2(ClustererComponent);

  function ClustererComponent() {
    var _this19;

    _classCallCheck2(this, ClustererComponent);

    _this19 = _super9.apply(this, arguments);
    _this19.registeredEvents = [];
    _this19.state = {
      markerClusterer: null
    };

    _this19.setClustererCallback = function () {
      if (_this19.state.markerClusterer !== null && _this19.props.onLoad) {
        _this19.props.onLoad(_this19.state.markerClusterer);
      }
    };

    return _this19;
  }

  _createClass2(ClustererComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context) {
        var markerClusterer = new Clusterer(this.context, [], this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$e,
          eventMap: eventMap$e,
          prevProps: {},
          nextProps: this.props,
          instance: markerClusterer
        });
        this.setState(function () {
          return {
            markerClusterer: markerClusterer
          };
        }, this.setClustererCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.markerClusterer) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$e,
          eventMap: eventMap$e,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.markerClusterer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.markerClusterer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.markerClusterer);
        }

        unregisterEvents(this.registeredEvents); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        this.state.markerClusterer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
    }
  }]);

  return ClustererComponent;
}(React.PureComponent);

ClustererComponent.contextType = MapContext; // This handler prevents an event in the InfoBox from being passed on to the map.

function cancelHandler(event) {
  event.cancelBubble = true;

  if (event.stopPropagation) {
    event.stopPropagation();
  }
}

var InfoBox =
/** @class */
function () {
  function InfoBox(options) {
    if (options === void 0) {
      options = {};
    }

    this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
    this.closeClickHandler = this.closeClickHandler.bind(this);
    this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
    this.addClickHandler = this.addClickHandler.bind(this);
    this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
    this.getBoxWidths = this.getBoxWidths.bind(this);
    this.setBoxStyle = this.setBoxStyle.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.setOptions = this.setOptions.bind(this);
    this.setContent = this.setContent.bind(this);
    this.setVisible = this.setVisible.bind(this);
    this.getContent = this.getContent.bind(this);
    this.getVisible = this.getVisible.bind(this);
    this.setZIndex = this.setZIndex.bind(this);
    this.getZIndex = this.getZIndex.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.panBox = this.panBox.bind(this);
    this.extend = this.extend.bind(this);
    this.close = this.close.bind(this);
    this.draw = this.draw.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.open = this.open.bind(this);
    this.extend(InfoBox, google.maps.OverlayView); // Standard options (in common with google.maps.InfoWindow):

    this.content = options.content || '';
    this.disableAutoPan = options.disableAutoPan || false;
    this.maxWidth = options.maxWidth || 0;
    this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
    this.position = options.position || new google.maps.LatLng(0, 0);
    this.zIndex = options.zIndex || null; // Additional options (unique to InfoBox):

    this.boxClass = options.boxClass || 'infoBox';
    this.boxStyle = options.boxStyle || {};
    this.closeBoxMargin = options.closeBoxMargin || '2px';
    this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';

    if (options.closeBoxURL === '') {
      this.closeBoxURL = '';
    }

    this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);

    if (typeof options.visible === 'undefined') {
      if (typeof options.isHidden === 'undefined') {
        options.visible = true;
      } else {
        options.visible = !options.isHidden;
      }
    }

    this.isHidden = !options.visible;
    this.alignBottom = options.alignBottom || false;
    this.pane = options.pane || 'floatPane';
    this.enableEventPropagation = options.enableEventPropagation || false;
    this.div = null;
    this.closeListener = null;
    this.moveListener = null;
    this.mapListener = null;
    this.contextListener = null;
    this.eventListeners = null;
    this.fixedWidthSet = null;
  }

  InfoBox.prototype.createInfoBoxDiv = function () {
    var _this = this; // This handler ignores the current event in the InfoBox and conditionally prevents
    // the event from being passed on to the map. It is used for the contextmenu event.


    var ignoreHandler = function ignoreHandler(event) {
      event.returnValue = false;

      if (event.preventDefault) {
        event.preventDefault();
      }

      if (!_this.enableEventPropagation) {
        cancelHandler(event);
      }
    };

    if (!this.div) {
      this.div = document.createElement('div');
      this.setBoxStyle();

      if (typeof this.content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + this.content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(this.content);
      }

      var panes = this.getPanes();

      if (panes !== null) {
        panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
      }

      this.addClickHandler();

      if (this.div.style.width) {
        this.fixedWidthSet = true;
      } else {
        if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
          this.div.style.width = this.maxWidth + 'px';
          this.fixedWidthSet = true;
        } else {
          // The following code is needed to overcome problems with MSIE
          var bw = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
          this.fixedWidthSet = false;
        }
      }

      this.panBox(this.disableAutoPan);

      if (!this.enableEventPropagation) {
        this.eventListeners = []; // Cancel event propagation.
        // Note: mousemove not included (to resolve Issue 152)

        var events = ['mousedown', 'mouseover', 'mouseout', 'mouseup', 'click', 'dblclick', 'touchstart', 'touchend', 'touchmove'];

        for (var i = 0; i < events.length; i++) {
          this.eventListeners.push(google.maps.event.addListener(this.div, events[i], cancelHandler));
        } // Workaround for Google bug that causes the cursor to change to a pointer
        // when the mouse moves over a marker underneath InfoBox.


        this.eventListeners.push(google.maps.event.addListener(this.div, 'mouseover', function () {
          if (_this.div) {
            _this.div.style.cursor = 'default';
          }
        }));
      }

      this.contextListener = google.maps.event.addListener(this.div, 'contextmenu', ignoreHandler);
      /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */

      google.maps.event.trigger(this, 'domready');
    }
  };

  InfoBox.prototype.getCloseBoxImg = function () {
    var img = '';

    if (this.closeBoxURL !== '') {
      img = '<img alt=""';
      img += ' aria-hidden="true"';
      img += " src='" + this.closeBoxURL + "'";
      img += ' align=right'; // Do this because Opera chokes on style='float: right;'

      img += " style='";
      img += ' position: relative;'; // Required by MSIE

      img += ' cursor: pointer;';
      img += ' margin: ' + this.closeBoxMargin + ';';
      img += "'>";
    }

    return img;
  };

  InfoBox.prototype.addClickHandler = function () {
    this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== '' ? google.maps.event.addListener(this.div.firstChild, 'click', this.getCloseClickHandler()) : null;
  };

  InfoBox.prototype.closeClickHandler = function (event) {
    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    event.cancelBubble = true;

    if (event.stopPropagation) {
      event.stopPropagation();
    }
    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */


    google.maps.event.trigger(this, 'closeclick');
    this.close();
  };

  InfoBox.prototype.getCloseClickHandler = function () {
    return this.closeClickHandler;
  };

  InfoBox.prototype.panBox = function (disablePan) {
    if (this.div && !disablePan) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var map = this.getMap(); // Only pan if attached to map, not panorama

      if (map instanceof google.maps.Map) {
        var xOffset = 0;
        var yOffset = 0;
        var bounds = map.getBounds();

        if (bounds && !bounds.contains(this.position)) {
          // Marker not in visible area of map, so set center
          // of map to the marker position first.
          map.setCenter(this.position);
        }

        var mapDiv = map.getDiv(); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        var mapWidth = mapDiv.offsetWidth; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        var mapHeight = mapDiv.offsetHeight;
        var iwOffsetX = this.pixelOffset.width;
        var iwOffsetY = this.pixelOffset.height;
        var iwWidth = this.div.offsetWidth;
        var iwHeight = this.div.offsetHeight;
        var padX = this.infoBoxClearance.width;
        var padY = this.infoBoxClearance.height; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        var projection = this.getProjection();
        var pixPosition = projection.fromLatLngToContainerPixel(this.position);

        if (pixPosition !== null) {
          if (pixPosition.x < -iwOffsetX + padX) {
            xOffset = pixPosition.x + iwOffsetX - padX;
          } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
            xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
          }

          if (this.alignBottom) {
            if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
              yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
            } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
            }
          } else {
            if (pixPosition.y < -iwOffsetY + padY) {
              yOffset = pixPosition.y + iwOffsetY - padY;
            } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
            }
          }
        }

        if (!(xOffset === 0 && yOffset === 0)) {
          // Move the map to the shifted center.
          map.panBy(xOffset, yOffset);
        }
      }
    }
  };

  InfoBox.prototype.setBoxStyle = function () {
    if (this.div) {
      // Apply style values from the style sheet defined in the boxClass parameter:
      this.div.className = this.boxClass; // Clear existing inline style values:

      this.div.style.cssText = ''; // Apply style values defined in the boxStyle parameter:

      var boxStyle = this.boxStyle;

      for (var i in boxStyle) {
        if (Object.prototype.hasOwnProperty.call(boxStyle, i)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.div.style[i] = boxStyle[i];
        }
      } // Fix for iOS disappearing InfoBox problem
      // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad


      this.div.style.webkitTransform = 'translateZ(0)'; // Fix up opacity style for benefit of MSIE

      if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
        // See http://www.quirksmode.org/css/opacity.html
        var opacity = parseFloat(this.div.style.opacity || ''); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
        this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
      } // Apply required styles


      this.div.style.position = 'absolute';
      this.div.style.visibility = 'hidden';

      if (this.zIndex !== null) {
        this.div.style.zIndex = this.zIndex + '';
      }

      if (!this.div.style.overflow) {
        this.div.style.overflow = 'auto';
      }
    }
  };

  InfoBox.prototype.getBoxWidths = function () {
    var bw = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };

    if (!this.div) {
      return bw;
    }

    if (document.defaultView) {
      var ownerDocument = this.div.ownerDocument;
      var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;

      if (computedStyle) {
        // The computed styles are always in pixel units (good!)
        bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
      }
    } else if ( // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.documentElement.currentStyle // MSIE
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var currentStyle = this.div.currentStyle;

      if (currentStyle) {
        // The current styles may not be in pixel units, but assume they are (bad!)
        bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
      }
    }

    return bw;
  };

  InfoBox.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  InfoBox.prototype.draw = function () {
    this.createInfoBoxDiv();

    if (this.div) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var projection = this.getProjection();
      var pixPosition = projection.fromLatLngToDivPixel(this.position);

      if (pixPosition !== null) {
        this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';

        if (this.alignBottom) {
          this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
        } else {
          this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
        }
      }

      if (this.isHidden) {
        this.div.style.visibility = 'hidden';
      } else {
        this.div.style.visibility = 'visible';
      }
    }
  };

  InfoBox.prototype.setOptions = function (options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof options.boxClass !== 'undefined') {
      // Must be first
      this.boxClass = options.boxClass;
      this.setBoxStyle();
    }

    if (typeof options.boxStyle !== 'undefined') {
      // Must be second
      this.boxStyle = options.boxStyle;
      this.setBoxStyle();
    }

    if (typeof options.content !== 'undefined') {
      this.setContent(options.content);
    }

    if (typeof options.disableAutoPan !== 'undefined') {
      this.disableAutoPan = options.disableAutoPan;
    }

    if (typeof options.maxWidth !== 'undefined') {
      this.maxWidth = options.maxWidth;
    }

    if (typeof options.pixelOffset !== 'undefined') {
      this.pixelOffset = options.pixelOffset;
    }

    if (typeof options.alignBottom !== 'undefined') {
      this.alignBottom = options.alignBottom;
    }

    if (typeof options.position !== 'undefined') {
      this.setPosition(options.position);
    }

    if (typeof options.zIndex !== 'undefined') {
      this.setZIndex(options.zIndex);
    }

    if (typeof options.closeBoxMargin !== 'undefined') {
      this.closeBoxMargin = options.closeBoxMargin;
    }

    if (typeof options.closeBoxURL !== 'undefined') {
      this.closeBoxURL = options.closeBoxURL;
    }

    if (typeof options.infoBoxClearance !== 'undefined') {
      this.infoBoxClearance = options.infoBoxClearance;
    }

    if (typeof options.isHidden !== 'undefined') {
      this.isHidden = options.isHidden;
    }

    if (typeof options.visible !== 'undefined') {
      this.isHidden = !options.visible;
    }

    if (typeof options.enableEventPropagation !== 'undefined') {
      this.enableEventPropagation = options.enableEventPropagation;
    }

    if (this.div) {
      this.draw();
    }
  };

  InfoBox.prototype.setContent = function (content) {
    this.content = content;

    if (this.div) {
      if (this.closeListener) {
        google.maps.event.removeListener(this.closeListener);
        this.closeListener = null;
      } // Odd code required to make things work with MSIE.


      if (!this.fixedWidthSet) {
        this.div.style.width = '';
      }

      if (typeof content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(content);
      } // Perverse code required to make things work with MSIE.
      // (Ensures the close box does, in fact, float to the right.)


      if (!this.fixedWidthSet) {
        this.div.style.width = this.div.offsetWidth + 'px';

        if (typeof content === 'string') {
          this.div.innerHTML = this.getCloseBoxImg() + content;
        } else {
          this.div.innerHTML = this.getCloseBoxImg();
          this.div.appendChild(content);
        }
      }

      this.addClickHandler();
    }
    /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */


    google.maps.event.trigger(this, 'content_changed');
  };

  InfoBox.prototype.setPosition = function (latLng) {
    this.position = latLng;

    if (this.div) {
      this.draw();
    }
    /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */


    google.maps.event.trigger(this, 'position_changed');
  };

  InfoBox.prototype.setVisible = function (isVisible) {
    this.isHidden = !isVisible;

    if (this.div) {
      this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    }
  };

  InfoBox.prototype.setZIndex = function (index) {
    this.zIndex = index;

    if (this.div) {
      this.div.style.zIndex = index + '';
    }
    /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */


    google.maps.event.trigger(this, 'zindex_changed');
  };

  InfoBox.prototype.getContent = function () {
    return this.content;
  };

  InfoBox.prototype.getPosition = function () {
    return this.position;
  };

  InfoBox.prototype.getZIndex = function () {
    return this.zIndex;
  };

  InfoBox.prototype.getVisible = function () {
    var map = this.getMap();
    return typeof map === 'undefined' || map === null ? false : !this.isHidden;
  };

  InfoBox.prototype.show = function () {
    this.isHidden = false;

    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };

  InfoBox.prototype.hide = function () {
    this.isHidden = true;

    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };

  InfoBox.prototype.open = function (map, anchor) {
    var _this = this;

    if (anchor) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.position = anchor.getPosition();
      this.moveListener = google.maps.event.addListener(anchor, 'position_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var position = anchor.getPosition();

        _this.setPosition(position);
      });
      this.mapListener = google.maps.event.addListener(anchor, 'map_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _this.setMap(anchor.map);
      });
    }

    this.setMap(map);

    if (this.div) {
      this.panBox();
    }
  };

  InfoBox.prototype.close = function () {
    if (this.closeListener) {
      google.maps.event.removeListener(this.closeListener);
      this.closeListener = null;
    }

    if (this.eventListeners) {
      for (var i = 0; i < this.eventListeners.length; i++) {
        google.maps.event.removeListener(this.eventListeners[i]);
      }

      this.eventListeners = null;
    }

    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }

    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }

    if (this.contextListener) {
      google.maps.event.removeListener(this.contextListener);
      this.contextListener = null;
    } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore


    this.setMap(null);
  };

  InfoBox.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        if (!Object.prototype.hasOwnProperty.call(this, property)) {
          // @ts-ignore
          this.prototype[property] = object.prototype[property];
        }
      }

      return this;
    }.apply(obj1, [obj2]);
  };

  return InfoBox;
}();

var eventMap$d = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$d = {
  options: function options(instance, _options7) {
    instance.setOptions(_options7);
  },
  position: function position(instance, _position2) {
    if (_position2 instanceof google.maps.LatLng) {
      instance.setPosition(_position2);
    } else {
      instance.setPosition(new google.maps.LatLng(_position2.lat, _position2.lng));
    }
  },
  visible: function visible(instance, _visible2) {
    instance.setVisible(_visible2);
  },
  zIndex: function zIndex(instance, _zIndex2) {
    instance.setZIndex(_zIndex2);
  }
};
var defaultOptions$3 = {};

function InfoBoxFunctional(_ref46) {
  var children = _ref46.children,
      anchor = _ref46.anchor,
      options = _ref46.options,
      position = _ref46.position,
      zIndex = _ref46.zIndex,
      onCloseClick = _ref46.onCloseClick,
      onDomReady = _ref46.onDomReady,
      onContentChanged = _ref46.onContentChanged,
      onPositionChanged = _ref46.onPositionChanged,
      onZindexChanged = _ref46.onZindexChanged,
      onLoad = _ref46.onLoad,
      onUnmount = _ref46.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState98 = React.useState(null),
      _React$useState99 = _slicedToArray2(_React$useState98, 2),
      instance = _React$useState99[0],
      setInstance = _React$useState99[1];

  var _React$useState100 = React.useState(null),
      _React$useState101 = _slicedToArray2(_React$useState100, 2),
      closeclickListener = _React$useState101[0],
      setCloseClickListener = _React$useState101[1];

  var _React$useState102 = React.useState(null),
      _React$useState103 = _slicedToArray2(_React$useState102, 2),
      domreadyclickListener = _React$useState103[0],
      setDomReadyClickListener = _React$useState103[1];

  var _React$useState104 = React.useState(null),
      _React$useState105 = _slicedToArray2(_React$useState104, 2),
      contentchangedclickListener = _React$useState105[0],
      setContentChangedClickListener = _React$useState105[1];

  var _React$useState106 = React.useState(null),
      _React$useState107 = _slicedToArray2(_React$useState106, 2),
      positionchangedclickListener = _React$useState107[0],
      setPositionChangedClickListener = _React$useState107[1];

  var _React$useState108 = React.useState(null),
      _React$useState109 = _slicedToArray2(_React$useState108, 2),
      zindexchangedclickListener = _React$useState109[0],
      setZindexChangedClickListener = _React$useState109[1];

  var containerElementRef = React.useRef(null); // Order does matter

  React.useEffect(function () {
    if (map && instance !== null) {
      instance.close();

      if (anchor) {
        instance.open(map, anchor);
      } else if (instance.getPosition()) {
        instance.open(map);
      }
    }
  }, [map, instance, anchor]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (position && instance !== null) {
      var positionLatLng = position instanceof google.maps.LatLng ? position // @ts-ignore
      : new google.maps.LatLng(position.lat, position.lng);
      instance.setPosition(positionLatLng);
    }
  }, [position]);
  React.useEffect(function () {
    if (typeof zIndex === 'number' && instance !== null) {
      instance.setZIndex(zIndex);
    }
  }, [zIndex]);
  React.useEffect(function () {
    if (instance && onCloseClick) {
      if (closeclickListener !== null) {
        google.maps.event.removeListener(closeclickListener);
      }

      setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
    }
  }, [onCloseClick]);
  React.useEffect(function () {
    if (instance && onDomReady) {
      if (domreadyclickListener !== null) {
        google.maps.event.removeListener(domreadyclickListener);
      }

      setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
    }
  }, [onDomReady]);
  React.useEffect(function () {
    if (instance && onContentChanged) {
      if (contentchangedclickListener !== null) {
        google.maps.event.removeListener(contentchangedclickListener);
      }

      setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
    }
  }, [onContentChanged]);
  React.useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionchangedclickListener !== null) {
        google.maps.event.removeListener(positionchangedclickListener);
      }

      setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  React.useEffect(function () {
    if (instance && onZindexChanged) {
      if (zindexchangedclickListener !== null) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }

      setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  React.useEffect(function () {
    if (map) {
      var _a = options || defaultOptions$3,
          _position3 = _a.position,
          infoBoxOptions = __rest$1(_a, ["position"]);

      var positionLatLng;

      if (_position3 && !(_position3 instanceof google.maps.LatLng)) {
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(_position3.lat, _position3.lng);
      }

      var infoBox = new InfoBox(Object.assign(Object.assign({}, infoBoxOptions), positionLatLng ? {
        position: positionLatLng
      } : {}));
      containerElementRef.current = document.createElement('div');
      setInstance(infoBox);

      if (onCloseClick) {
        setCloseClickListener(google.maps.event.addListener(infoBox, 'closeclick', onCloseClick));
      }

      if (onDomReady) {
        setDomReadyClickListener(google.maps.event.addListener(infoBox, 'domready', onDomReady));
      }

      if (onContentChanged) {
        setContentChangedClickListener(google.maps.event.addListener(infoBox, 'content_changed', onContentChanged));
      }

      if (onPositionChanged) {
        setPositionChangedClickListener(google.maps.event.addListener(infoBox, 'position_changed', onPositionChanged));
      }

      if (onZindexChanged) {
        setZindexChangedClickListener(google.maps.event.addListener(infoBox, 'zindex_changed', onZindexChanged));
      }

      infoBox.setContent(containerElementRef.current);

      if (anchor) {
        infoBox.open(map, anchor);
      } else if (infoBox.getPosition()) {
        infoBox.open(map);
      } else {
        invariant_1$1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }

      if (onLoad) {
        onLoad(infoBox);
      }
    }

    return function () {
      if (instance !== null) {
        if (closeclickListener) {
          google.maps.event.removeListener(closeclickListener);
        }

        if (contentchangedclickListener) {
          google.maps.event.removeListener(contentchangedclickListener);
        }

        if (domreadyclickListener) {
          google.maps.event.removeListener(domreadyclickListener);
        }

        if (positionchangedclickListener) {
          google.maps.event.removeListener(positionchangedclickListener);
        }

        if (zindexchangedclickListener) {
          google.maps.event.removeListener(zindexchangedclickListener);
        }

        if (onUnmount) {
          onUnmount(instance);
        }

        instance.close();
      }
    };
  }, []);
  return containerElementRef.current ? ReactDOM.createPortal(React.Children.only(children), containerElementRef.current) : null;
}

React.memo(InfoBoxFunctional);

var InfoBoxComponent = /*#__PURE__*/function (_React$PureComponent10) {
  _inherits2(InfoBoxComponent, _React$PureComponent10);

  var _super10 = _createSuper2(InfoBoxComponent);

  function InfoBoxComponent() {
    var _this20;

    _classCallCheck2(this, InfoBoxComponent);

    _this20 = _super10.apply(this, arguments);
    _this20.registeredEvents = [];
    _this20.containerElement = null;
    _this20.state = {
      infoBox: null
    };

    _this20.open = function (infoBox, anchor) {
      if (anchor) {
        // @ts-ignore
        infoBox.open(_this20.context, anchor);
      } else if (infoBox.getPosition()) {
        // @ts-ignore
        infoBox.open(_this20.context);
      } else {
        invariant_1$1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }
    };

    _this20.setInfoBoxCallback = function () {
      if (_this20.state.infoBox !== null && _this20.containerElement !== null) {
        _this20.state.infoBox.setContent(_this20.containerElement);

        _this20.open(_this20.state.infoBox, _this20.props.anchor);

        if (_this20.props.onLoad) {
          _this20.props.onLoad(_this20.state.infoBox);
        }
      }
    };

    return _this20;
  }

  _createClass2(InfoBoxComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a = this.props.options || {},
          position = _a.position,
          infoBoxOptions = __rest$1(_a, ["position"]);

      var positionLatLng;

      if (position && !(position instanceof google.maps.LatLng)) {
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(position.lat, position.lng);
      }

      var infoBox = new InfoBox(Object.assign(Object.assign({}, infoBoxOptions), positionLatLng ? {
        position: positionLatLng
      } : {}));
      this.containerElement = document.createElement('div');
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$d,
        eventMap: eventMap$d,
        prevProps: {},
        nextProps: this.props,
        instance: infoBox
      });
      this.setState({
        infoBox: infoBox
      }, this.setInfoBoxCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var infoBox = this.state.infoBox;

      if (infoBox !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$d,
          eventMap: eventMap$d,
          prevProps: prevProps,
          nextProps: this.props,
          instance: infoBox
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;
      var infoBox = this.state.infoBox;

      if (infoBox !== null) {
        if (onUnmount) {
          onUnmount(infoBox);
        }

        unregisterEvents(this.registeredEvents);
        infoBox.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.containerElement ? ReactDOM.createPortal(React.Children.only(this.props.children), this.containerElement) : null;
    }
  }]);

  return InfoBoxComponent;
}(React.PureComponent);

InfoBoxComponent.contextType = MapContext; // do not edit .js files directly - edit src/index.jst

var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  } // true if both NaN, false otherwise


  return a !== a && b !== b;
};

var kdbush = {
  exports: {}
};

(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    function sortKD(ids, coords, nodeSize, left, right, depth) {
      if (right - left <= nodeSize) {
        return;
      }

      var m = left + right >> 1;
      select(ids, coords, m, left, right, depth % 2);
      sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
      sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
    }

    function select(ids, coords, k, left, right, inc) {
      while (right > left) {
        if (right - left > 600) {
          var n = right - left + 1;
          var m = k - left + 1;
          var z = Math.log(n);
          var s = 0.5 * Math.exp(2 * z / 3);
          var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
          var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
          var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
          select(ids, coords, k, newLeft, newRight, inc);
        }

        var t = coords[2 * k + inc];
        var i = left;
        var j = right;
        swapItem(ids, coords, left, k);

        if (coords[2 * right + inc] > t) {
          swapItem(ids, coords, left, right);
        }

        while (i < j) {
          swapItem(ids, coords, i, j);
          i++;
          j--;

          while (coords[2 * i + inc] < t) {
            i++;
          }

          while (coords[2 * j + inc] > t) {
            j--;
          }
        }

        if (coords[2 * left + inc] === t) {
          swapItem(ids, coords, left, j);
        } else {
          j++;
          swapItem(ids, coords, j, right);
        }

        if (j <= k) {
          left = j + 1;
        }

        if (k <= j) {
          right = j - 1;
        }
      }
    }

    function swapItem(ids, coords, i, j) {
      swap(ids, i, j);
      swap(coords, 2 * i, 2 * j);
      swap(coords, 2 * i + 1, 2 * j + 1);
    }

    function swap(arr, i, j) {
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }

    function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
      var stack = [0, ids.length - 1, 0];
      var result = [];
      var x, y;

      while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();

        if (right - left <= nodeSize) {
          for (var i = left; i <= right; i++) {
            x = coords[2 * i];
            y = coords[2 * i + 1];

            if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
              result.push(ids[i]);
            }
          }

          continue;
        }

        var m = Math.floor((left + right) / 2);
        x = coords[2 * m];
        y = coords[2 * m + 1];

        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
          result.push(ids[m]);
        }

        var nextAxis = (axis + 1) % 2;

        if (axis === 0 ? minX <= x : minY <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(nextAxis);
        }

        if (axis === 0 ? maxX >= x : maxY >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(nextAxis);
        }
      }

      return result;
    }

    function within(ids, coords, qx, qy, r, nodeSize) {
      var stack = [0, ids.length - 1, 0];
      var result = [];
      var r2 = r * r;

      while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();

        if (right - left <= nodeSize) {
          for (var i = left; i <= right; i++) {
            if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) {
              result.push(ids[i]);
            }
          }

          continue;
        }

        var m = Math.floor((left + right) / 2);
        var x = coords[2 * m];
        var y = coords[2 * m + 1];

        if (sqDist(x, y, qx, qy) <= r2) {
          result.push(ids[m]);
        }

        var nextAxis = (axis + 1) % 2;

        if (axis === 0 ? qx - r <= x : qy - r <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(nextAxis);
        }

        if (axis === 0 ? qx + r >= x : qy + r >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(nextAxis);
        }
      }

      return result;
    }

    function sqDist(ax, ay, bx, by) {
      var dx = ax - bx;
      var dy = ay - by;
      return dx * dx + dy * dy;
    }

    var defaultGetX = function defaultGetX(p) {
      return p[0];
    };

    var defaultGetY = function defaultGetY(p) {
      return p[1];
    };

    var KDBush = function KDBush(points, getX, getY, nodeSize, ArrayType) {
      if (getX === void 0) getX = defaultGetX;
      if (getY === void 0) getY = defaultGetY;
      if (nodeSize === void 0) nodeSize = 64;
      if (ArrayType === void 0) ArrayType = Float64Array;
      this.nodeSize = nodeSize;
      this.points = points;
      var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
      var ids = this.ids = new IndexArrayType(points.length);
      var coords = this.coords = new ArrayType(points.length * 2);

      for (var i = 0; i < points.length; i++) {
        ids[i] = i;
        coords[2 * i] = getX(points[i]);
        coords[2 * i + 1] = getY(points[i]);
      }

      sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
    };

    KDBush.prototype.range = function range$1(minX, minY, maxX, maxY) {
      return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    };

    KDBush.prototype.within = function within$1(x, y, r) {
      return within(this.ids, this.coords, x, y, r, this.nodeSize);
    };

    return KDBush;
  });
})(kdbush);

var KDBush = kdbush.exports;
var defaultOptions$2 = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: false,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: false,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: function map(props) {
    return props;
  } // props => ({sum: props.my_value})

};

var fround = Math.fround || function (tmp) {
  return function (x) {
    tmp[0] = +x;
    return tmp[0];
  };
}(new Float32Array(1));

var Supercluster = /*#__PURE__*/function () {
  function Supercluster(options) {
    _classCallCheck2(this, Supercluster);

    this.options = extend$1(Object.create(defaultOptions$2), options);
    this.trees = new Array(this.options.maxZoom + 1);
  }

  _createClass2(Supercluster, [{
    key: "load",
    value: function load(points) {
      var _this$options2 = this.options,
          log = _this$options2.log,
          minZoom = _this$options2.minZoom,
          maxZoom = _this$options2.maxZoom,
          nodeSize = _this$options2.nodeSize;
      if (log) console.time('total time');
      var timerId = "prepare ".concat(points.length, " points");
      if (log) console.time(timerId);
      this.points = points; // generate a cluster object for each point and index input points into a KD-tree

      var clusters = [];

      for (var i = 0; i < points.length; i++) {
        if (!points[i].geometry) continue;
        clusters.push(createPointCluster(points[i], i));
      }

      this.trees[maxZoom + 1] = new KDBush(clusters, getX$1, getY$1, nodeSize, Float32Array);
      if (log) console.timeEnd(timerId); // cluster points on max zoom, then cluster the results on previous zoom, etc.;
      // results in a cluster hierarchy across zoom levels

      for (var _z = maxZoom; _z >= minZoom; _z--) {
        var _now = +Date.now(); // create a new set of clusters for the zoom and index them with a KD-tree


        clusters = this._cluster(clusters, _z);
        this.trees[_z] = new KDBush(clusters, getX$1, getY$1, nodeSize, Float32Array);
        if (log) console.log('z%d: %d clusters in %dms', _z, clusters.length, +Date.now() - _now);
      }

      if (log) console.timeEnd('total time');
      return this;
    }
  }, {
    key: "getClusters",
    value: function getClusters(bbox, zoom) {
      var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
      var minLat = Math.max(-90, Math.min(90, bbox[1]));
      var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
      var maxLat = Math.max(-90, Math.min(90, bbox[3]));

      if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
      } else if (minLng > maxLng) {
        var easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
        var westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
        return easternHem.concat(westernHem);
      }

      var tree = this.trees[this._limitZoom(zoom)];

      var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
      var clusters = [];

      var _iterator2 = _createForOfIteratorHelper2(ids),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _id2 = _step2.value;
          var _c = tree.points[_id2];
          clusters.push(_c.numPoints ? getClusterJSON(_c) : this.points[_c.index]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return clusters;
    }
  }, {
    key: "getChildren",
    value: function getChildren(clusterId) {
      var originId = this._getOriginId(clusterId);

      var originZoom = this._getOriginZoom(clusterId);

      var errorMsg = 'No cluster with the specified id.';
      var index = this.trees[originZoom];
      if (!index) throw new Error(errorMsg);
      var origin = index.points[originId];
      if (!origin) throw new Error(errorMsg);
      var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
      var ids = index.within(origin.x, origin.y, r);
      var children = [];

      var _iterator3 = _createForOfIteratorHelper2(ids),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _id3 = _step3.value;
          var _c2 = index.points[_id3];

          if (_c2.parentId === clusterId) {
            children.push(_c2.numPoints ? getClusterJSON(_c2) : this.points[_c2.index]);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (children.length === 0) throw new Error(errorMsg);
      return children;
    }
  }, {
    key: "getLeaves",
    value: function getLeaves(clusterId, limit, offset) {
      limit = limit || 10;
      offset = offset || 0;
      var leaves = [];

      this._appendLeaves(leaves, clusterId, limit, offset, 0);

      return leaves;
    }
  }, {
    key: "getTile",
    value: function getTile(z, x, y) {
      var tree = this.trees[this._limitZoom(z)];

      var z2 = Math.pow(2, z);
      var _this$options3 = this.options,
          extent = _this$options3.extent,
          radius = _this$options3.radius;
      var p = radius / extent;
      var top = (y - p) / z2;
      var bottom = (y + 1 + p) / z2;
      var tile = {
        features: []
      };

      this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.points, x, y, z2, tile);

      if (x === 0) {
        this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.points, z2, y, z2, tile);
      }

      if (x === z2 - 1) {
        this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.points, -1, y, z2, tile);
      }

      return tile.features.length ? tile : null;
    }
  }, {
    key: "getClusterExpansionZoom",
    value: function getClusterExpansionZoom(clusterId) {
      var expansionZoom = this._getOriginZoom(clusterId) - 1;

      while (expansionZoom <= this.options.maxZoom) {
        var _children = this.getChildren(clusterId);

        expansionZoom++;
        if (_children.length !== 1) break;
        clusterId = _children[0].properties.cluster_id;
      }

      return expansionZoom;
    }
  }, {
    key: "_appendLeaves",
    value: function _appendLeaves(result, clusterId, limit, offset, skipped) {
      var children = this.getChildren(clusterId);

      var _iterator4 = _createForOfIteratorHelper2(children),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          var _props5 = child.properties;

          if (_props5 && _props5.cluster) {
            if (skipped + _props5.point_count <= offset) {
              // skip the whole cluster
              skipped += _props5.point_count;
            } else {
              // enter the cluster
              skipped = this._appendLeaves(result, _props5.cluster_id, limit, offset, skipped); // exit the cluster
            }
          } else if (skipped < offset) {
            // skip a single point
            skipped++;
          } else {
            // add a single point
            result.push(child);
          }

          if (result.length === limit) break;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return skipped;
    }
  }, {
    key: "_addTileFeatures",
    value: function _addTileFeatures(ids, points, x, y, z2, tile) {
      var _iterator5 = _createForOfIteratorHelper2(ids),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var i = _step5.value;
          var _c3 = points[i];
          var isCluster = _c3.numPoints;
          var tags = void 0,
              px = void 0,
              py = void 0;

          if (isCluster) {
            tags = getClusterProperties(_c3);
            px = _c3.x;
            py = _c3.y;
          } else {
            var _p = this.points[_c3.index];
            tags = _p.properties;
            px = lngX(_p.geometry.coordinates[0]);
            py = latY(_p.geometry.coordinates[1]);
          }

          var _f = {
            type: 1,
            geometry: [[Math.round(this.options.extent * (px * z2 - x)), Math.round(this.options.extent * (py * z2 - y))]],
            tags: tags
          }; // assign id

          var _id4 = void 0;

          if (isCluster) {
            _id4 = _c3.id;
          } else if (this.options.generateId) {
            // optionally generate id
            _id4 = _c3.index;
          } else if (this.points[_c3.index].id) {
            // keep id if already assigned
            _id4 = this.points[_c3.index].id;
          }

          if (_id4 !== undefined) _f.id = _id4;
          tile.features.push(_f);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "_limitZoom",
    value: function _limitZoom(z) {
      return Math.max(this.options.minZoom, Math.min(+z, this.options.maxZoom + 1));
    }
  }, {
    key: "_cluster",
    value: function _cluster(points, zoom) {
      var clusters = [];
      var _this$options4 = this.options,
          radius = _this$options4.radius,
          extent = _this$options4.extent,
          reduce = _this$options4.reduce,
          minPoints = _this$options4.minPoints;
      var r = radius / (extent * Math.pow(2, zoom)); // loop through each point

      for (var i = 0; i < points.length; i++) {
        var _p2 = points[i]; // if we've already visited the point at this zoom level, skip it

        if (_p2.zoom <= zoom) continue;
        _p2.zoom = zoom; // find all nearby points

        var tree = this.trees[zoom + 1];
        var neighborIds = tree.within(_p2.x, _p2.y, r);
        var numPointsOrigin = _p2.numPoints || 1;
        var numPoints = numPointsOrigin; // count the number of points in a potential cluster

        var _iterator6 = _createForOfIteratorHelper2(neighborIds),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _neighborId2 = _step6.value;
            var _b4 = tree.points[_neighborId2]; // filter out neighbors that are already processed

            if (_b4.zoom > zoom) numPoints += _b4.numPoints || 1;
          } // if there were neighbors to merge, and there are enough points to form a cluster

        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        if (numPoints > numPointsOrigin && numPoints >= minPoints) {
          var wx = _p2.x * numPointsOrigin;
          var wy = _p2.y * numPointsOrigin;
          var clusterProperties = reduce && numPointsOrigin > 1 ? this._map(_p2, true) : null; // encode both zoom and point index on which the cluster originated -- offset by total length of features

          var _id5 = (i << 5) + (zoom + 1) + this.points.length;

          var _iterator7 = _createForOfIteratorHelper2(neighborIds),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var neighborId = _step7.value;
              var _b2 = tree.points[neighborId];
              if (_b2.zoom <= zoom) continue;
              _b2.zoom = zoom; // save the zoom (so it doesn't get processed twice)

              var numPoints2 = _b2.numPoints || 1;
              wx += _b2.x * numPoints2; // accumulate coordinates for calculating weighted center

              wy += _b2.y * numPoints2;
              _b2.parentId = _id5;

              if (reduce) {
                if (!clusterProperties) clusterProperties = this._map(_p2, true);
                reduce(clusterProperties, this._map(_b2));
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          _p2.parentId = _id5;
          clusters.push(createCluster(wx / numPoints, wy / numPoints, _id5, numPoints, clusterProperties));
        } else {
          // left points as unclustered
          clusters.push(_p2);

          if (numPoints > 1) {
            var _iterator8 = _createForOfIteratorHelper2(neighborIds),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _neighborId = _step8.value;
                var _b3 = tree.points[_neighborId];
                if (_b3.zoom <= zoom) continue;
                _b3.zoom = zoom;
                clusters.push(_b3);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        }
      }

      return clusters;
    } // get index of the point from which the cluster originated

  }, {
    key: "_getOriginId",
    value: function _getOriginId(clusterId) {
      return clusterId - this.points.length >> 5;
    } // get zoom of the point from which the cluster originated

  }, {
    key: "_getOriginZoom",
    value: function _getOriginZoom(clusterId) {
      return (clusterId - this.points.length) % 32;
    }
  }, {
    key: "_map",
    value: function _map(point, clone) {
      if (point.numPoints) {
        return clone ? extend$1({}, point.properties) : point.properties;
      }

      var original = this.points[point.index].properties;
      var result = this.options.map(original);
      return clone && result === original ? extend$1({}, result) : result;
    }
  }]);

  return Supercluster;
}();

function createCluster(x, y, id, numPoints, properties) {
  return {
    x: fround(x),
    // weighted cluster center; round for consistency with Float32Array index
    y: fround(y),
    zoom: Infinity,
    // the last zoom the cluster was processed at
    id: id,
    // encodes index of the first child of the cluster and its zoom level
    parentId: -1,
    // parent cluster id
    numPoints: numPoints,
    properties: properties
  };
}

function createPointCluster(p, id) {
  var _p$geometry$coordinat = _slicedToArray2(p.geometry.coordinates, 2),
      x = _p$geometry$coordinat[0],
      y = _p$geometry$coordinat[1];

  return {
    x: fround(lngX(x)),
    // projected point coordinates
    y: fround(latY(y)),
    zoom: Infinity,
    // the last zoom the point was processed at
    index: id,
    // index of the source feature in the original input array,
    parentId: -1 // parent cluster id

  };
}

function getClusterJSON(cluster) {
  return {
    type: 'Feature',
    id: cluster.id,
    properties: getClusterProperties(cluster),
    geometry: {
      type: 'Point',
      coordinates: [xLng(cluster.x), yLat(cluster.y)]
    }
  };
}

function getClusterProperties(cluster) {
  var count = cluster.numPoints;
  var abbrev = count >= 10000 ? "".concat(Math.round(count / 1000), "k") : count >= 1000 ? "".concat(Math.round(count / 100) / 10, "k") : count;
  return extend$1(extend$1({}, cluster.properties), {
    cluster: true,
    cluster_id: cluster.id,
    point_count: count,
    point_count_abbreviated: abbrev
  });
} // longitude/latitude to spherical mercator in [0..1] range


function lngX(lng) {
  return lng / 360 + 0.5;
}

function latY(lat) {
  var sin = Math.sin(lat * Math.PI / 180);
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
  return y < 0 ? 0 : y > 1 ? 1 : y;
} // spherical mercator to longitude/latitude


function xLng(x) {
  return (x - 0.5) * 360;
}

function yLat(y) {
  var y2 = (180 - y * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

function extend$1(dest, src) {
  for (var _id6 in src) {
    dest[_id6] = src[_id6];
  }

  return dest;
}

function getX$1(p) {
  return p.x;
}

function getY$1(p) {
  return p.y;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var Cluster = /*#__PURE__*/function () {
  function Cluster(_ref47) {
    var markers = _ref47.markers,
        position = _ref47.position;

    _classCallCheck2(this, Cluster);

    this.markers = markers;

    if (position) {
      if (position instanceof google.maps.LatLng) {
        this._position = position;
      } else {
        this._position = new google.maps.LatLng(position);
      }
    }
  }

  _createClass2(Cluster, [{
    key: "bounds",
    get: function get() {
      if (this.markers.length === 0 && !this._position) {
        return undefined;
      }

      return this.markers.reduce(function (bounds, marker) {
        return bounds.extend(marker.getPosition());
      }, new google.maps.LatLngBounds(this._position, this._position));
    }
  }, {
    key: "position",
    get: function get() {
      return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */

  }, {
    key: "count",
    get: function get() {
      return this.markers.filter(function (m) {
        return m.getVisible();
      }).length;
    }
    /**
     * Add a marker to the cluster.
     */

  }, {
    key: "push",
    value: function push(marker) {
      this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */

  }, {
    key: "delete",
    value: function _delete() {
      if (this.marker) {
        this.marker.setMap(null);
        delete this.marker;
      }

      this.markers.length = 0;
    }
  }]);

  return Cluster;
}();
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @hidden
 */


var AbstractAlgorithm = /*#__PURE__*/function () {
  function AbstractAlgorithm(_ref48) {
    var _ref48$maxZoom = _ref48.maxZoom,
        maxZoom = _ref48$maxZoom === void 0 ? 16 : _ref48$maxZoom;

    _classCallCheck2(this, AbstractAlgorithm);

    this.maxZoom = maxZoom;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers, map})
   *    }
   * }
   * ```
   */


  _createClass2(AbstractAlgorithm, [{
    key: "noop",
    value: function noop(_ref49) {
      var markers = _ref49.markers;
      return noop$1(markers);
    }
  }]);

  return AbstractAlgorithm;
}();
/**
 * @hidden
 */


var noop$1 = function noop$1(markers) {
  var clusters = markers.map(function (marker) {
    return new Cluster({
      position: marker.getPosition(),
      markers: [marker]
    });
  });
  return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */


var SuperClusterAlgorithm = /*#__PURE__*/function (_AbstractAlgorithm) {
  _inherits2(SuperClusterAlgorithm, _AbstractAlgorithm);

  var _super11 = _createSuper2(SuperClusterAlgorithm);

  function SuperClusterAlgorithm(_a) {
    var _this21;

    _classCallCheck2(this, SuperClusterAlgorithm);

    var maxZoom = _a.maxZoom,
        _a$radius = _a.radius,
        radius = _a$radius === void 0 ? 60 : _a$radius,
        options = __rest(_a, ["maxZoom", "radius"]);

    _this21 = _super11.call(this, {
      maxZoom: maxZoom
    });
    _this21.superCluster = new Supercluster(Object.assign({
      maxZoom: _this21.maxZoom,
      radius: radius
    }, options));
    _this21.state = {
      zoom: null
    };
    return _this21;
  }

  _createClass2(SuperClusterAlgorithm, [{
    key: "calculate",
    value: function calculate(input) {
      var changed = false;

      if (!fastDeepEqual(input.markers, this.markers)) {
        changed = true; // TODO use proxy to avoid copy?

        this.markers = _toConsumableArray2(input.markers);
        var points = this.markers.map(function (marker) {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [marker.getPosition().lng(), marker.getPosition().lat()]
            },
            properties: {
              marker: marker
            }
          };
        });
        this.superCluster.load(points);
      }

      var state = {
        zoom: input.map.getZoom()
      };

      if (!changed) {
        if (this.state.zoom > this.maxZoom && state.zoom > this.maxZoom) ;else {
          changed = changed || !fastDeepEqual(this.state, state);
        }
      }

      this.state = state;

      if (changed) {
        this.clusters = this.cluster(input);
      }

      return {
        clusters: this.clusters,
        changed: changed
      };
    }
  }, {
    key: "cluster",
    value: function cluster(_ref50) {
      var map = _ref50.map;
      return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(map.getZoom())).map(this.transformCluster.bind(this));
    }
  }, {
    key: "transformCluster",
    value: function transformCluster(_ref51) {
      var _ref51$geometry$coord = _slicedToArray2(_ref51.geometry.coordinates, 2),
          lng = _ref51$geometry$coord[0],
          lat = _ref51$geometry$coord[1],
          properties = _ref51.properties;

      if (properties.cluster) {
        return new Cluster({
          markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map(function (leaf) {
            return leaf.properties.marker;
          }),
          position: new google.maps.LatLng({
            lat: lat,
            lng: lng
          })
        });
      } else {
        var marker = properties.marker;
        return new Cluster({
          markers: [marker],
          position: marker.getPosition()
        });
      }
    }
  }]);

  return SuperClusterAlgorithm;
}(AbstractAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */


var ClusterStats = /*#__PURE__*/_createClass2(function ClusterStats(markers, clusters) {
  _classCallCheck2(this, ClusterStats);

  this.markers = {
    sum: markers.length
  };
  var clusterMarkerCounts = clusters.map(function (a) {
    return a.count;
  });
  var clusterMarkerSum = clusterMarkerCounts.reduce(function (a, b) {
    return a + b;
  }, 0);
  this.clusters = {
    count: clusters.length,
    markers: {
      mean: clusterMarkerSum / clusters.length,
      sum: clusterMarkerSum,
      min: Math.min.apply(Math, _toConsumableArray2(clusterMarkerCounts)),
      max: Math.max.apply(Math, _toConsumableArray2(clusterMarkerCounts))
    }
  };
});

var DefaultRenderer = /*#__PURE__*/function () {
  function DefaultRenderer() {
    _classCallCheck2(this, DefaultRenderer);
  }

  _createClass2(DefaultRenderer, [{
    key: "render",
    value:
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    function render(_ref52, stats) {
      var count = _ref52.count,
          position = _ref52.position;
      // change color if this cluster has more markers than the mean cluster
      var color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff"; // create svg url with fill color

      var svg = window.btoa("\n  <svg fill=\"".concat(color, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\">\n    <circle cx=\"120\" cy=\"120\" opacity=\".6\" r=\"70\" />\n    <circle cx=\"120\" cy=\"120\" opacity=\".3\" r=\"90\" />\n    <circle cx=\"120\" cy=\"120\" opacity=\".2\" r=\"110\" />\n  </svg>")); // create marker using svg icon

      return new google.maps.Marker({
        position: position,
        icon: {
          url: "data:image/svg+xml;base64,".concat(svg),
          scaledSize: new google.maps.Size(45, 45)
        },
        label: {
          text: String(count),
          color: "rgba(255,255,255,0.9)",
          fontSize: "12px"
        },
        title: "Cluster of ".concat(count, " markers"),
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
      });
    }
  }]);

  return DefaultRenderer;
}();
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


function extend$2(type1, type2) {
  /* istanbul ignore next */
  // eslint-disable-next-line prefer-const
  for (var property in type2.prototype) {
    type1.prototype[property] = type2.prototype[property];
  }
}
/**
 * @ignore
 */


var OverlayViewSafe = /*#__PURE__*/_createClass2(function OverlayViewSafe() {
  _classCallCheck2(this, OverlayViewSafe);

  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  extend$2(OverlayViewSafe, google.maps.OverlayView);
});
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var MarkerClustererEvents;

(function (MarkerClustererEvents) {
  MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
  MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
  MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));

var defaultOnClusterClickHandler = function defaultOnClusterClickHandler(_, cluster, map) {
  map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */


var MarkerClusterer = /*#__PURE__*/function (_OverlayViewSafe) {
  _inherits2(MarkerClusterer, _OverlayViewSafe);

  var _super12 = _createSuper2(MarkerClusterer);

  function MarkerClusterer(_ref53) {
    var _this22;

    var map = _ref53.map,
        _ref53$markers = _ref53.markers,
        markers = _ref53$markers === void 0 ? [] : _ref53$markers,
        _ref53$algorithm = _ref53.algorithm,
        algorithm = _ref53$algorithm === void 0 ? new SuperClusterAlgorithm({}) : _ref53$algorithm,
        _ref53$renderer = _ref53.renderer,
        renderer = _ref53$renderer === void 0 ? new DefaultRenderer() : _ref53$renderer,
        _ref53$onClusterClick = _ref53.onClusterClick,
        onClusterClick = _ref53$onClusterClick === void 0 ? defaultOnClusterClickHandler : _ref53$onClusterClick;

    _classCallCheck2(this, MarkerClusterer);

    _this22 = _super12.call(this);
    _this22.markers = _toConsumableArray2(markers);
    _this22.clusters = [];
    _this22.algorithm = algorithm;
    _this22.renderer = renderer;
    _this22.onClusterClick = onClusterClick;

    if (map) {
      _this22.setMap(map);
    }

    return _this22;
  }

  _createClass2(MarkerClusterer, [{
    key: "addMarker",
    value: function addMarker(marker, noDraw) {
      if (this.markers.includes(marker)) {
        return;
      }

      this.markers.push(marker);

      if (!noDraw) {
        this.render();
      }
    }
  }, {
    key: "addMarkers",
    value: function addMarkers(markers, noDraw) {
      var _this23 = this;

      markers.forEach(function (marker) {
        _this23.addMarker(marker, true);
      });

      if (!noDraw) {
        this.render();
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(marker, noDraw) {
      var index = this.markers.indexOf(marker);

      if (index === -1) {
        // Marker is not in our list of markers, so do nothing:
        return false;
      }

      marker.setMap(null);
      this.markers.splice(index, 1); // Remove the marker from the list of managed markers

      if (!noDraw) {
        this.render();
      }

      return true;
    }
  }, {
    key: "removeMarkers",
    value: function removeMarkers(markers, noDraw) {
      var _this24 = this;

      var removed = false;
      markers.forEach(function (marker) {
        removed = _this24.removeMarker(marker, true) || removed;
      });

      if (removed && !noDraw) {
        this.render();
      }

      return removed;
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers(noDraw) {
      this.markers.length = 0;

      if (!noDraw) {
        this.render();
      }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */

  }, {
    key: "render",
    value: function render() {
      var map = this.getMap();

      if (map instanceof google.maps.Map && this.getProjection()) {
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);

        var _this$algorithm$calcu = this.algorithm.calculate({
          markers: this.markers,
          map: map,
          mapCanvasProjection: this.getProjection()
        }),
            clusters = _this$algorithm$calcu.clusters,
            changed = _this$algorithm$calcu.changed; // allow algorithms to return flag on whether the clusters/markers have changed


        if (changed || changed == undefined) {
          // reset visibility of markers and clusters
          this.reset(); // store new clusters

          this.clusters = clusters;
          this.renderClusters();
        }

        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
      }
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
      this.render();
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      google.maps.event.removeListener(this.idleListener);
      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.markers.forEach(function (marker) {
        return marker.setMap(null);
      });
      this.clusters.forEach(function (cluster) {
        return cluster.delete();
      });
      this.clusters = [];
    }
  }, {
    key: "renderClusters",
    value: function renderClusters() {
      var _this25 = this;

      // generate stats to pass to renderers
      var stats = new ClusterStats(this.markers, this.clusters);
      var map = this.getMap();
      this.clusters.forEach(function (cluster) {
        if (cluster.markers.length === 1) {
          cluster.marker = cluster.markers[0];
        } else {
          cluster.marker = _this25.renderer.render(cluster, stats);

          if (_this25.onClusterClick) {
            cluster.marker.addListener("click",
            /* istanbul ignore next */
            function (event) {
              google.maps.event.trigger(_this25, MarkerClustererEvents.CLUSTER_CLICK, cluster);

              _this25.onClusterClick(event, cluster, map);
            });
          }
        }

        cluster.marker.setMap(map);
      });
    }
  }]);

  return MarkerClusterer;
}(OverlayViewSafe);

function useGoogleMarkerClusterer(options) {
  var map = useGoogleMap();

  var _React$useState110 = React.useState(null),
      _React$useState111 = _slicedToArray2(_React$useState110, 2),
      markerClusterer = _React$useState111[0],
      setMarkerClusterer = _React$useState111[1];

  React.useEffect(function () {
    if (map && markerClusterer === null) {
      var markerCluster = new MarkerClusterer(Object.assign(Object.assign({}, options), {
        map: map
      }));
      setMarkerClusterer(markerCluster);
    }
  }, [map]);
  return markerClusterer;
}
/** Wrapper around [@googlemaps/markerclusterer](https://github.com/googlemaps/js-markerclusterer)
 *
 * Accepts {@link  MarkerClustererOptionsSubset} which is a subset of  {@link MarkerClustererOptions}
 */


function GoogleMarkerClusterer(_ref54) {
  var children = _ref54.children,
      options = _ref54.options;
  var markerClusterer = useGoogleMarkerClusterer(options);
  return markerClusterer !== null ? children(markerClusterer) : null;
}

React.memo(GoogleMarkerClusterer);
/* global google */

var eventMap$c = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$c = {
  options: function options(instance, _options8) {
    instance.setOptions(_options8);
  },
  position: function position(instance, _position4) {
    instance.setPosition(_position4);
  },
  zIndex: function zIndex(instance, _zIndex3) {
    instance.setZIndex(_zIndex3);
  }
};

function InfoWindowFunctional(_ref55) {
  var children = _ref55.children,
      anchor = _ref55.anchor,
      options = _ref55.options,
      position = _ref55.position,
      zIndex = _ref55.zIndex,
      onCloseClick = _ref55.onCloseClick,
      onDomReady = _ref55.onDomReady,
      onContentChanged = _ref55.onContentChanged,
      onPositionChanged = _ref55.onPositionChanged,
      onZindexChanged = _ref55.onZindexChanged,
      onLoad = _ref55.onLoad,
      onUnmount = _ref55.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState112 = React.useState(null),
      _React$useState113 = _slicedToArray2(_React$useState112, 2),
      instance = _React$useState113[0],
      setInstance = _React$useState113[1];

  var _React$useState114 = React.useState(null),
      _React$useState115 = _slicedToArray2(_React$useState114, 2),
      closeclickListener = _React$useState115[0],
      setCloseClickListener = _React$useState115[1];

  var _React$useState116 = React.useState(null),
      _React$useState117 = _slicedToArray2(_React$useState116, 2),
      domreadyclickListener = _React$useState117[0],
      setDomReadyClickListener = _React$useState117[1];

  var _React$useState118 = React.useState(null),
      _React$useState119 = _slicedToArray2(_React$useState118, 2),
      contentchangedclickListener = _React$useState119[0],
      setContentChangedClickListener = _React$useState119[1];

  var _React$useState120 = React.useState(null),
      _React$useState121 = _slicedToArray2(_React$useState120, 2),
      positionchangedclickListener = _React$useState121[0],
      setPositionChangedClickListener = _React$useState121[1];

  var _React$useState122 = React.useState(null),
      _React$useState123 = _slicedToArray2(_React$useState122, 2),
      zindexchangedclickListener = _React$useState123[0],
      setZindexChangedClickListener = _React$useState123[1];

  var containerElementRef = React.useRef(null); // Order does matter

  React.useEffect(function () {
    if (instance !== null) {
      instance.close();

      if (anchor) {
        instance.open(map, anchor);
      } else if (instance.getPosition()) {
        instance.open(map);
      }
    }
  }, [map, instance, anchor]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (position && instance !== null) {
      instance.setPosition(position);
    }
  }, [position]);
  React.useEffect(function () {
    if (typeof zIndex === 'number' && instance !== null) {
      instance.setZIndex(zIndex);
    }
  }, [zIndex]);
  React.useEffect(function () {
    if (instance && onCloseClick) {
      if (closeclickListener !== null) {
        google.maps.event.removeListener(closeclickListener);
      }

      setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
    }
  }, [onCloseClick]);
  React.useEffect(function () {
    if (instance && onDomReady) {
      if (domreadyclickListener !== null) {
        google.maps.event.removeListener(domreadyclickListener);
      }

      setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
    }
  }, [onDomReady]);
  React.useEffect(function () {
    if (instance && onContentChanged) {
      if (contentchangedclickListener !== null) {
        google.maps.event.removeListener(contentchangedclickListener);
      }

      setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
    }
  }, [onContentChanged]);
  React.useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionchangedclickListener !== null) {
        google.maps.event.removeListener(positionchangedclickListener);
      }

      setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  React.useEffect(function () {
    if (instance && onZindexChanged) {
      if (zindexchangedclickListener !== null) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }

      setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  React.useEffect(function () {
    var infoWindow = new google.maps.InfoWindow(Object.assign({}, options || {}));
    setInstance(infoWindow);
    containerElementRef.current = document.createElement('div');

    if (onCloseClick) {
      setCloseClickListener(google.maps.event.addListener(infoWindow, 'closeclick', onCloseClick));
    }

    if (onDomReady) {
      setDomReadyClickListener(google.maps.event.addListener(infoWindow, 'domready', onDomReady));
    }

    if (onContentChanged) {
      setContentChangedClickListener(google.maps.event.addListener(infoWindow, 'content_changed', onContentChanged));
    }

    if (onPositionChanged) {
      setPositionChangedClickListener(google.maps.event.addListener(infoWindow, 'position_changed', onPositionChanged));
    }

    if (onZindexChanged) {
      setZindexChangedClickListener(google.maps.event.addListener(infoWindow, 'zindex_changed', onZindexChanged));
    }

    infoWindow.setContent(containerElementRef.current);

    if (position) {
      infoWindow.setPosition(position);
    }

    if (zIndex) {
      infoWindow.setZIndex(zIndex);
    }

    if (anchor) {
      infoWindow.open(map, anchor);
    } else if (infoWindow.getPosition()) {
      infoWindow.open(map);
    } else {
      invariant_1$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
    }

    if (onLoad) {
      onLoad(infoWindow);
    }

    return function () {
      if (closeclickListener) {
        google.maps.event.removeListener(closeclickListener);
      }

      if (contentchangedclickListener) {
        google.maps.event.removeListener(contentchangedclickListener);
      }

      if (domreadyclickListener) {
        google.maps.event.removeListener(domreadyclickListener);
      }

      if (positionchangedclickListener) {
        google.maps.event.removeListener(positionchangedclickListener);
      }

      if (zindexchangedclickListener) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }

      if (onUnmount) {
        onUnmount(infoWindow);
      }

      infoWindow.close();
    };
  }, []);
  return containerElementRef.current ? ReactDOM.createPortal(React.Children.only(children), containerElementRef.current) : null;
}

React.memo(InfoWindowFunctional);

var InfoWindow = /*#__PURE__*/function (_React$PureComponent11) {
  _inherits2(InfoWindow, _React$PureComponent11);

  var _super13 = _createSuper2(InfoWindow);

  function InfoWindow() {
    var _this26;

    _classCallCheck2(this, InfoWindow);

    _this26 = _super13.apply(this, arguments);
    _this26.registeredEvents = [];
    _this26.containerElement = null;
    _this26.state = {
      infoWindow: null
    };

    _this26.open = function (infoWindow, anchor) {
      if (anchor) {
        infoWindow.open(_this26.context, anchor);
      } else if (infoWindow.getPosition()) {
        // @ts-ignore
        infoWindow.open(_this26.context);
      } else {
        invariant_1$1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
      }
    };

    _this26.setInfoWindowCallback = function () {
      if (_this26.state.infoWindow !== null && _this26.containerElement !== null) {
        _this26.state.infoWindow.setContent(_this26.containerElement);

        _this26.open(_this26.state.infoWindow, _this26.props.anchor);

        if (_this26.props.onLoad) {
          _this26.props.onLoad(_this26.state.infoWindow);
        }
      }
    };

    return _this26;
  }

  _createClass2(InfoWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var infoWindow = new google.maps.InfoWindow(Object.assign({}, this.props.options || {}));
      this.containerElement = document.createElement('div');
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$c,
        eventMap: eventMap$c,
        prevProps: {},
        nextProps: this.props,
        instance: infoWindow
      });
      this.setState(function () {
        return {
          infoWindow: infoWindow
        };
      }, this.setInfoWindowCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.infoWindow !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$c,
          eventMap: eventMap$c,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.infoWindow
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.infoWindow !== null) {
        unregisterEvents(this.registeredEvents);

        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.infoWindow);
        }

        this.state.infoWindow.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.containerElement ? ReactDOM.createPortal(React.Children.only(this.props.children), this.containerElement) : null;
    }
  }]);

  return InfoWindow;
}(React.PureComponent);

InfoWindow.contextType = MapContext;
var eventMap$b = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$b = {
  draggable: function draggable(instance, _draggable2) {
    instance.setDraggable(_draggable2);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map2) {
    instance.setMap(_map2);
  },
  options: function options(instance, _options9) {
    instance.setOptions(_options9);
  },
  path: function path(instance, _path) {
    instance.setPath(_path);
  },
  visible: function visible(instance, _visible3) {
    instance.setVisible(_visible3);
  }
};
var defaultOptions$1 = {};

function PolylineFunctional(_ref56) {
  var options = _ref56.options,
      draggable = _ref56.draggable,
      editable = _ref56.editable,
      visible = _ref56.visible,
      path = _ref56.path,
      onDblClick = _ref56.onDblClick,
      onDragEnd = _ref56.onDragEnd,
      onDragStart = _ref56.onDragStart,
      onMouseDown = _ref56.onMouseDown,
      onMouseMove = _ref56.onMouseMove,
      onMouseOut = _ref56.onMouseOut,
      onMouseOver = _ref56.onMouseOver,
      onMouseUp = _ref56.onMouseUp,
      onRightClick = _ref56.onRightClick,
      onClick = _ref56.onClick,
      onDrag = _ref56.onDrag,
      onLoad = _ref56.onLoad,
      onUnmount = _ref56.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState124 = React.useState(null),
      _React$useState125 = _slicedToArray2(_React$useState124, 2),
      instance = _React$useState125[0],
      setInstance = _React$useState125[1];

  var _React$useState126 = React.useState(null),
      _React$useState127 = _slicedToArray2(_React$useState126, 2),
      dblclickListener = _React$useState127[0],
      setDblclickListener = _React$useState127[1];

  var _React$useState128 = React.useState(null),
      _React$useState129 = _slicedToArray2(_React$useState128, 2),
      dragendListener = _React$useState129[0],
      setDragendListener = _React$useState129[1];

  var _React$useState130 = React.useState(null),
      _React$useState131 = _slicedToArray2(_React$useState130, 2),
      dragstartListener = _React$useState131[0],
      setDragstartListener = _React$useState131[1];

  var _React$useState132 = React.useState(null),
      _React$useState133 = _slicedToArray2(_React$useState132, 2),
      mousedownListener = _React$useState133[0],
      setMousedownListener = _React$useState133[1];

  var _React$useState134 = React.useState(null),
      _React$useState135 = _slicedToArray2(_React$useState134, 2),
      mousemoveListener = _React$useState135[0],
      setMousemoveListener = _React$useState135[1];

  var _React$useState136 = React.useState(null),
      _React$useState137 = _slicedToArray2(_React$useState136, 2),
      mouseoutListener = _React$useState137[0],
      setMouseoutListener = _React$useState137[1];

  var _React$useState138 = React.useState(null),
      _React$useState139 = _slicedToArray2(_React$useState138, 2),
      mouseoverListener = _React$useState139[0],
      setMouseoverListener = _React$useState139[1];

  var _React$useState140 = React.useState(null),
      _React$useState141 = _slicedToArray2(_React$useState140, 2),
      mouseupListener = _React$useState141[0],
      setMouseupListener = _React$useState141[1];

  var _React$useState142 = React.useState(null),
      _React$useState143 = _slicedToArray2(_React$useState142, 2),
      rightclickListener = _React$useState143[0],
      setRightclickListener = _React$useState143[1];

  var _React$useState144 = React.useState(null),
      _React$useState145 = _slicedToArray2(_React$useState144, 2),
      clickListener = _React$useState145[0],
      setClickListener = _React$useState145[1];

  var _React$useState146 = React.useState(null),
      _React$useState147 = _slicedToArray2(_React$useState146, 2),
      dragListener = _React$useState147[0],
      setDragListener = _React$useState147[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof path !== 'undefined' && instance !== null) {
      instance.setPath(path);
    }
  }, [instance, path]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    var polyline = new google.maps.Polyline(Object.assign(Object.assign({}, options || defaultOptions$1), {
      map: map
    }));

    if (path) {
      polyline.setPath(path);
    }

    if (typeof visible !== 'undefined') {
      polyline.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      polyline.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      polyline.setDraggable(draggable);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(polyline, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(polyline, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(polyline, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(polyline, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(polyline, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(polyline, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(polyline, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(polyline, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(polyline, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(polyline, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(polyline, 'drag', onDrag));
    }

    setInstance(polyline);

    if (onLoad) {
      onLoad(polyline);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (onUnmount) {
        onUnmount(polyline);
      }

      polyline.setMap(null);
    };
  }, []);
  return null;
}

React.memo(PolylineFunctional);

var Polyline = /*#__PURE__*/function (_React$PureComponent12) {
  _inherits2(Polyline, _React$PureComponent12);

  var _super14 = _createSuper2(Polyline);

  function Polyline() {
    var _this27;

    _classCallCheck2(this, Polyline);

    _this27 = _super14.apply(this, arguments);
    _this27.registeredEvents = [];
    _this27.state = {
      polyline: null
    };

    _this27.setPolylineCallback = function () {
      if (_this27.state.polyline !== null && _this27.props.onLoad) {
        _this27.props.onLoad(_this27.state.polyline);
      }
    };

    return _this27;
  }

  _createClass2(Polyline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var polyline = new google.maps.Polyline(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$b,
        eventMap: eventMap$b,
        prevProps: {},
        nextProps: this.props,
        instance: polyline
      });
      this.setState(function setPolyline() {
        return {
          polyline: polyline
        };
      }, this.setPolylineCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.polyline !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$b,
          eventMap: eventMap$b,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.polyline
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.polyline !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.polyline);
        }

        unregisterEvents(this.registeredEvents);
        this.state.polyline.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Polyline;
}(React.PureComponent);

Polyline.contextType = MapContext;
/* global google */

var eventMap$a = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$a = {
  draggable: function draggable(instance, _draggable3) {
    instance.setDraggable(_draggable3);
  },
  editable: function editable(instance, _editable2) {
    instance.setEditable(_editable2);
  },
  map: function map(instance, _map3) {
    instance.setMap(_map3);
  },
  options: function options(instance, _options10) {
    instance.setOptions(_options10);
  },
  path: function path(instance, _path2) {
    instance.setPath(_path2);
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths);
  },
  visible: function visible(instance, _visible4) {
    instance.setVisible(_visible4);
  }
};

function PolygonFunctional(_ref57) {
  var options = _ref57.options,
      draggable = _ref57.draggable,
      editable = _ref57.editable,
      visible = _ref57.visible,
      path = _ref57.path,
      onDblClick = _ref57.onDblClick,
      onDragEnd = _ref57.onDragEnd,
      onDragStart = _ref57.onDragStart,
      onMouseDown = _ref57.onMouseDown,
      onMouseMove = _ref57.onMouseMove,
      onMouseOut = _ref57.onMouseOut,
      onMouseOver = _ref57.onMouseOver,
      onMouseUp = _ref57.onMouseUp,
      onRightClick = _ref57.onRightClick,
      onClick = _ref57.onClick,
      onDrag = _ref57.onDrag,
      onLoad = _ref57.onLoad,
      onUnmount = _ref57.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState148 = React.useState(null),
      _React$useState149 = _slicedToArray2(_React$useState148, 2),
      instance = _React$useState149[0],
      setInstance = _React$useState149[1];

  var _React$useState150 = React.useState(null),
      _React$useState151 = _slicedToArray2(_React$useState150, 2),
      dblclickListener = _React$useState151[0],
      setDblclickListener = _React$useState151[1];

  var _React$useState152 = React.useState(null),
      _React$useState153 = _slicedToArray2(_React$useState152, 2),
      dragendListener = _React$useState153[0],
      setDragendListener = _React$useState153[1];

  var _React$useState154 = React.useState(null),
      _React$useState155 = _slicedToArray2(_React$useState154, 2),
      dragstartListener = _React$useState155[0],
      setDragstartListener = _React$useState155[1];

  var _React$useState156 = React.useState(null),
      _React$useState157 = _slicedToArray2(_React$useState156, 2),
      mousedownListener = _React$useState157[0],
      setMousedownListener = _React$useState157[1];

  var _React$useState158 = React.useState(null),
      _React$useState159 = _slicedToArray2(_React$useState158, 2),
      mousemoveListener = _React$useState159[0],
      setMousemoveListener = _React$useState159[1];

  var _React$useState160 = React.useState(null),
      _React$useState161 = _slicedToArray2(_React$useState160, 2),
      mouseoutListener = _React$useState161[0],
      setMouseoutListener = _React$useState161[1];

  var _React$useState162 = React.useState(null),
      _React$useState163 = _slicedToArray2(_React$useState162, 2),
      mouseoverListener = _React$useState163[0],
      setMouseoverListener = _React$useState163[1];

  var _React$useState164 = React.useState(null),
      _React$useState165 = _slicedToArray2(_React$useState164, 2),
      mouseupListener = _React$useState165[0],
      setMouseupListener = _React$useState165[1];

  var _React$useState166 = React.useState(null),
      _React$useState167 = _slicedToArray2(_React$useState166, 2),
      rightclickListener = _React$useState167[0],
      setRightclickListener = _React$useState167[1];

  var _React$useState168 = React.useState(null),
      _React$useState169 = _slicedToArray2(_React$useState168, 2),
      clickListener = _React$useState169[0],
      setClickListener = _React$useState169[1];

  var _React$useState170 = React.useState(null),
      _React$useState171 = _slicedToArray2(_React$useState170, 2),
      dragListener = _React$useState171[0],
      setDragListener = _React$useState171[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof path !== 'undefined' && instance !== null) {
      instance.setPath(path);
    }
  }, [instance, path]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    var polygon = new google.maps.Polygon(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));

    if (path) {
      polygon.setPath(path);
    }

    if (typeof visible !== 'undefined') {
      polygon.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      polygon.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      polygon.setDraggable(draggable);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(polygon, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(polygon, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(polygon, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(polygon, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(polygon, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(polygon, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(polygon, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(polygon, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(polygon, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(polygon, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(polygon, 'drag', onDrag));
    }

    setInstance(polygon);

    if (onLoad) {
      onLoad(polygon);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (onUnmount) {
        onUnmount(polygon);
      }

      polygon.setMap(null);
    };
  }, []);
  return null;
}

React.memo(PolygonFunctional);

var Polygon = /*#__PURE__*/function (_React$PureComponent13) {
  _inherits2(Polygon, _React$PureComponent13);

  var _super15 = _createSuper2(Polygon);

  function Polygon() {
    var _this28;

    _classCallCheck2(this, Polygon);

    _this28 = _super15.apply(this, arguments);
    _this28.registeredEvents = [];
    _this28.state = {
      polygon: null
    };

    _this28.setPolygonCallback = function () {
      if (_this28.state.polygon !== null && _this28.props.onLoad) {
        _this28.props.onLoad(_this28.state.polygon);
      }
    };

    return _this28;
  }

  _createClass2(Polygon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var polygon = new google.maps.Polygon(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$a,
        eventMap: eventMap$a,
        prevProps: {},
        nextProps: this.props,
        instance: polygon
      });
      this.setState(function setPolygon() {
        return {
          polygon: polygon
        };
      }, this.setPolygonCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.polygon !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$a,
          eventMap: eventMap$a,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.polygon
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.polygon !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.polygon);
        }

        unregisterEvents(this.registeredEvents);
        this.state.polygon && this.state.polygon.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Polygon;
}(React.PureComponent);

Polygon.contextType = MapContext;
var eventMap$9 = {
  onBoundsChanged: 'bounds_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$9 = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
  draggable: function draggable(instance, _draggable4) {
    instance.setDraggable(_draggable4);
  },
  editable: function editable(instance, _editable3) {
    instance.setEditable(_editable3);
  },
  map: function map(instance, _map4) {
    instance.setMap(_map4);
  },
  options: function options(instance, _options11) {
    instance.setOptions(_options11);
  },
  visible: function visible(instance, _visible5) {
    instance.setVisible(_visible5);
  }
};

function RectangleFunctional(_ref58) {
  var options = _ref58.options,
      bounds = _ref58.bounds,
      draggable = _ref58.draggable,
      editable = _ref58.editable,
      visible = _ref58.visible,
      onDblClick = _ref58.onDblClick,
      onDragEnd = _ref58.onDragEnd,
      onDragStart = _ref58.onDragStart,
      onMouseDown = _ref58.onMouseDown,
      onMouseMove = _ref58.onMouseMove,
      onMouseOut = _ref58.onMouseOut,
      onMouseOver = _ref58.onMouseOver,
      onMouseUp = _ref58.onMouseUp,
      onRightClick = _ref58.onRightClick,
      onClick = _ref58.onClick,
      onDrag = _ref58.onDrag,
      onBoundsChanged = _ref58.onBoundsChanged,
      onLoad = _ref58.onLoad,
      onUnmount = _ref58.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState172 = React.useState(null),
      _React$useState173 = _slicedToArray2(_React$useState172, 2),
      instance = _React$useState173[0],
      setInstance = _React$useState173[1];

  var _React$useState174 = React.useState(null),
      _React$useState175 = _slicedToArray2(_React$useState174, 2),
      dblclickListener = _React$useState175[0],
      setDblclickListener = _React$useState175[1];

  var _React$useState176 = React.useState(null),
      _React$useState177 = _slicedToArray2(_React$useState176, 2),
      dragendListener = _React$useState177[0],
      setDragendListener = _React$useState177[1];

  var _React$useState178 = React.useState(null),
      _React$useState179 = _slicedToArray2(_React$useState178, 2),
      dragstartListener = _React$useState179[0],
      setDragstartListener = _React$useState179[1];

  var _React$useState180 = React.useState(null),
      _React$useState181 = _slicedToArray2(_React$useState180, 2),
      mousedownListener = _React$useState181[0],
      setMousedownListener = _React$useState181[1];

  var _React$useState182 = React.useState(null),
      _React$useState183 = _slicedToArray2(_React$useState182, 2),
      mousemoveListener = _React$useState183[0],
      setMousemoveListener = _React$useState183[1];

  var _React$useState184 = React.useState(null),
      _React$useState185 = _slicedToArray2(_React$useState184, 2),
      mouseoutListener = _React$useState185[0],
      setMouseoutListener = _React$useState185[1];

  var _React$useState186 = React.useState(null),
      _React$useState187 = _slicedToArray2(_React$useState186, 2),
      mouseoverListener = _React$useState187[0],
      setMouseoverListener = _React$useState187[1];

  var _React$useState188 = React.useState(null),
      _React$useState189 = _slicedToArray2(_React$useState188, 2),
      mouseupListener = _React$useState189[0],
      setMouseupListener = _React$useState189[1];

  var _React$useState190 = React.useState(null),
      _React$useState191 = _slicedToArray2(_React$useState190, 2),
      rightclickListener = _React$useState191[0],
      setRightclickListener = _React$useState191[1];

  var _React$useState192 = React.useState(null),
      _React$useState193 = _slicedToArray2(_React$useState192, 2),
      clickListener = _React$useState193[0],
      setClickListener = _React$useState193[1];

  var _React$useState194 = React.useState(null),
      _React$useState195 = _slicedToArray2(_React$useState194, 2),
      dragListener = _React$useState195[0],
      setDragListener = _React$useState195[1];

  var _React$useState196 = React.useState(null),
      _React$useState197 = _slicedToArray2(_React$useState196, 2),
      boundsChangedListener = _React$useState197[0],
      setBoundsChangedListener = _React$useState197[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof bounds !== 'undefined' && instance !== null) {
      instance.setBounds(bounds);
    }
  }, [instance, bounds]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (instance && onBoundsChanged) {
      if (boundsChangedListener !== null) {
        google.maps.event.removeListener(boundsChangedListener);
      }

      setBoundsChangedListener(google.maps.event.addListener(instance, 'bounds_changed', onBoundsChanged));
    }
  }, [onBoundsChanged]);
  React.useEffect(function () {
    var rectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));

    if (typeof visible !== 'undefined') {
      rectangle.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      rectangle.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      rectangle.setDraggable(draggable);
    }

    if (typeof bounds !== 'undefined') {
      rectangle.setBounds(bounds);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(rectangle, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(rectangle, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(rectangle, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(rectangle, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(rectangle, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(rectangle, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(rectangle, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(rectangle, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(rectangle, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(rectangle, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(rectangle, 'drag', onDrag));
    }

    if (onBoundsChanged) {
      setBoundsChangedListener(google.maps.event.addListener(rectangle, 'bounds_changed', onBoundsChanged));
    }

    setInstance(rectangle);

    if (onLoad) {
      onLoad(rectangle);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      if (boundsChangedListener !== null) {
        google.maps.event.removeListener(boundsChangedListener);
      }

      if (onUnmount) {
        onUnmount(rectangle);
      }

      rectangle.setMap(null);
    };
  }, []);
  return null;
}

React.memo(RectangleFunctional);

var Rectangle$2 = /*#__PURE__*/function (_React$PureComponent14) {
  _inherits2(Rectangle$2, _React$PureComponent14);

  var _super16 = _createSuper2(Rectangle$2);

  function Rectangle$2() {
    var _this29;

    _classCallCheck2(this, Rectangle$2);

    _this29 = _super16.apply(this, arguments);
    _this29.registeredEvents = [];
    _this29.state = {
      rectangle: null
    };

    _this29.setRectangleCallback = function () {
      if (_this29.state.rectangle !== null && _this29.props.onLoad) {
        _this29.props.onLoad(_this29.state.rectangle);
      }
    };

    return _this29;
  }

  _createClass2(Rectangle$2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$9,
        eventMap: eventMap$9,
        prevProps: {},
        nextProps: this.props,
        instance: rectangle
      });
      this.setState(function setRectangle() {
        return {
          rectangle: rectangle
        };
      }, this.setRectangleCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.rectangle !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$9,
          eventMap: eventMap$9,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.rectangle
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.rectangle !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.rectangle);
        }

        unregisterEvents(this.registeredEvents);
        this.state.rectangle.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Rectangle$2;
}(React.PureComponent);

Rectangle$2.contextType = MapContext;
var eventMap$8 = {
  onCenterChanged: 'center_changed',
  onRadiusChanged: 'radius_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$8 = {
  center: function center(instance, _center2) {
    instance.setCenter(_center2);
  },
  draggable: function draggable(instance, _draggable5) {
    instance.setDraggable(_draggable5);
  },
  editable: function editable(instance, _editable4) {
    instance.setEditable(_editable4);
  },
  map: function map(instance, _map5) {
    instance.setMap(_map5);
  },
  options: function options(instance, _options12) {
    instance.setOptions(_options12);
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius);
  },
  visible: function visible(instance, _visible6) {
    instance.setVisible(_visible6);
  }
};
var defaultOptions$5 = {};

function CircleFunctional(_ref59) {
  var options = _ref59.options,
      center = _ref59.center,
      radius = _ref59.radius,
      draggable = _ref59.draggable,
      editable = _ref59.editable,
      visible = _ref59.visible,
      onDblClick = _ref59.onDblClick,
      onDragEnd = _ref59.onDragEnd,
      onDragStart = _ref59.onDragStart,
      onMouseDown = _ref59.onMouseDown,
      onMouseMove = _ref59.onMouseMove,
      onMouseOut = _ref59.onMouseOut,
      onMouseOver = _ref59.onMouseOver,
      onMouseUp = _ref59.onMouseUp,
      onRightClick = _ref59.onRightClick,
      onClick = _ref59.onClick,
      onDrag = _ref59.onDrag,
      onCenterChanged = _ref59.onCenterChanged,
      onRadiusChanged = _ref59.onRadiusChanged,
      onLoad = _ref59.onLoad,
      onUnmount = _ref59.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState198 = React.useState(null),
      _React$useState199 = _slicedToArray2(_React$useState198, 2),
      instance = _React$useState199[0],
      setInstance = _React$useState199[1];

  var _React$useState200 = React.useState(null),
      _React$useState201 = _slicedToArray2(_React$useState200, 2),
      dblclickListener = _React$useState201[0],
      setDblclickListener = _React$useState201[1];

  var _React$useState202 = React.useState(null),
      _React$useState203 = _slicedToArray2(_React$useState202, 2),
      dragendListener = _React$useState203[0],
      setDragendListener = _React$useState203[1];

  var _React$useState204 = React.useState(null),
      _React$useState205 = _slicedToArray2(_React$useState204, 2),
      dragstartListener = _React$useState205[0],
      setDragstartListener = _React$useState205[1];

  var _React$useState206 = React.useState(null),
      _React$useState207 = _slicedToArray2(_React$useState206, 2),
      mousedownListener = _React$useState207[0],
      setMousedownListener = _React$useState207[1];

  var _React$useState208 = React.useState(null),
      _React$useState209 = _slicedToArray2(_React$useState208, 2),
      mousemoveListener = _React$useState209[0],
      setMousemoveListener = _React$useState209[1];

  var _React$useState210 = React.useState(null),
      _React$useState211 = _slicedToArray2(_React$useState210, 2),
      mouseoutListener = _React$useState211[0],
      setMouseoutListener = _React$useState211[1];

  var _React$useState212 = React.useState(null),
      _React$useState213 = _slicedToArray2(_React$useState212, 2),
      mouseoverListener = _React$useState213[0],
      setMouseoverListener = _React$useState213[1];

  var _React$useState214 = React.useState(null),
      _React$useState215 = _slicedToArray2(_React$useState214, 2),
      mouseupListener = _React$useState215[0],
      setMouseupListener = _React$useState215[1];

  var _React$useState216 = React.useState(null),
      _React$useState217 = _slicedToArray2(_React$useState216, 2),
      rightclickListener = _React$useState217[0],
      setRightclickListener = _React$useState217[1];

  var _React$useState218 = React.useState(null),
      _React$useState219 = _slicedToArray2(_React$useState218, 2),
      clickListener = _React$useState219[0],
      setClickListener = _React$useState219[1];

  var _React$useState220 = React.useState(null),
      _React$useState221 = _slicedToArray2(_React$useState220, 2),
      dragListener = _React$useState221[0],
      setDragListener = _React$useState221[1];

  var _React$useState222 = React.useState(null),
      _React$useState223 = _slicedToArray2(_React$useState222, 2),
      centerChangedListener = _React$useState223[0],
      setCenterChangedListener = _React$useState223[1];

  var _React$useState224 = React.useState(null),
      _React$useState225 = _slicedToArray2(_React$useState224, 2),
      radiusChangedListener = _React$useState225[0],
      setRadiusChangedListener = _React$useState225[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof radius === 'number' && instance !== null) {
      instance.setRadius(radius);
    }
  }, [instance, radius]);
  React.useEffect(function () {
    if (typeof center !== 'undefined' && instance !== null) {
      instance.setCenter(center);
    }
  }, [instance, center]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }

      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (instance && onCenterChanged) {
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }

      setCenterChangedListener(google.maps.event.addListener(instance, 'center_changed', onCenterChanged));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onRadiusChanged) {
      if (radiusChangedListener !== null) {
        google.maps.event.removeListener(radiusChangedListener);
      }

      setRadiusChangedListener(google.maps.event.addListener(instance, 'radius_changed', onRadiusChanged));
    }
  }, [onRadiusChanged]);
  React.useEffect(function () {
    var circle = new google.maps.Circle(Object.assign(Object.assign({}, options || defaultOptions$5), {
      map: map
    }));

    if (typeof radius === 'number') {
      circle.setRadius(radius);
    }

    if (typeof center !== 'undefined') {
      circle.setCenter(center);
    }

    if (typeof radius === 'number') {
      circle.setRadius(radius);
    }

    if (typeof visible !== 'undefined') {
      circle.setVisible(visible);
    }

    if (typeof editable !== 'undefined') {
      circle.setEditable(editable);
    }

    if (typeof draggable !== 'undefined') {
      circle.setDraggable(draggable);
    }

    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(circle, 'dblclick', onDblClick));
    }

    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(circle, 'dragend', onDragEnd));
    }

    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(circle, 'dragstart', onDragStart));
    }

    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(circle, 'mousedown', onMouseDown));
    }

    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(circle, 'mousemove', onMouseMove));
    }

    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(circle, 'mouseout', onMouseOut));
    }

    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(circle, 'mouseover', onMouseOver));
    }

    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(circle, 'mouseup', onMouseUp));
    }

    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(circle, 'rightclick', onRightClick));
    }

    if (onClick) {
      setClickListener(google.maps.event.addListener(circle, 'click', onClick));
    }

    if (onDrag) {
      setDragListener(google.maps.event.addListener(circle, 'drag', onDrag));
    }

    if (onCenterChanged) {
      setCenterChangedListener(google.maps.event.addListener(circle, 'center_changed', onCenterChanged));
    }

    if (onRadiusChanged) {
      setRadiusChangedListener(google.maps.event.addListener(circle, 'radius_changed', onRadiusChanged));
    }

    setInstance(circle);

    if (onLoad) {
      onLoad(circle);
    }

    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }

      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }

      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }

      if (radiusChangedListener !== null) {
        google.maps.event.removeListener(radiusChangedListener);
      }

      if (onUnmount) {
        onUnmount(circle);
      }

      circle.setMap(null);
    };
  }, []);
  return null;
}

React.memo(CircleFunctional);

var Circle = /*#__PURE__*/function (_React$PureComponent15) {
  _inherits2(Circle, _React$PureComponent15);

  var _super17 = _createSuper2(Circle);

  function Circle() {
    var _this30;

    _classCallCheck2(this, Circle);

    _this30 = _super17.apply(this, arguments);
    _this30.registeredEvents = [];
    _this30.state = {
      circle: null
    };

    _this30.setCircleCallback = function () {
      if (_this30.state.circle !== null && _this30.props.onLoad) {
        _this30.props.onLoad(_this30.state.circle);
      }
    };

    return _this30;
  }

  _createClass2(Circle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var circle = new google.maps.Circle(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$8,
        eventMap: eventMap$8,
        prevProps: {},
        nextProps: this.props,
        instance: circle
      });
      this.setState(function setCircle() {
        return {
          circle: circle
        };
      }, this.setCircleCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.circle !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$8,
          eventMap: eventMap$8,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.circle
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.circle !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.circle);
        }

        unregisterEvents(this.registeredEvents);
        this.state.circle && this.state.circle.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Circle;
}(React.PureComponent);

Circle.contextType = MapContext;
var eventMap$7 = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onAddFeature: 'addfeature',
  onRemoveFeature: 'removefeature',
  onRemoveProperty: 'removeproperty',
  onSetGeometry: 'setgeometry',
  onSetProperty: 'setproperty'
};
var updaterMap$7 = {
  add: function add(instance, feature) {
    instance.add(feature);
  },
  addgeojson: function addgeojson(instance, geojson, options) {
    instance.addGeoJson(geojson, options);
  },
  contains: function contains(instance, feature) {
    instance.contains(feature);
  },
  foreach: function foreach(instance, callback) {
    instance.forEach(callback);
  },
  loadgeojson: function loadgeojson(instance, url, options, callback) {
    instance.loadGeoJson(url, options, callback);
  },
  overridestyle: function overridestyle(instance, feature, style) {
    instance.overrideStyle(feature, style);
  },
  remove: function remove(instance, feature) {
    instance.remove(feature);
  },
  revertstyle: function revertstyle(instance, feature) {
    instance.revertStyle(feature);
  },
  controlposition: function controlposition(instance, controlPosition) {
    instance.setControlPosition(controlPosition);
  },
  controls: function controls(instance, _controls) {
    instance.setControls(_controls);
  },
  drawingmode: function drawingmode(instance, mode) {
    instance.setDrawingMode(mode);
  },
  map: function map(instance, _map6) {
    instance.setMap(_map6);
  },
  style: function style(instance, _style) {
    instance.setStyle(_style);
  },
  togeojson: function togeojson(instance, callback) {
    instance.toGeoJson(callback);
  }
};

function DataFunctional(_ref60) {
  var options = _ref60.options,
      onClick = _ref60.onClick,
      onDblClick = _ref60.onDblClick,
      onMouseDown = _ref60.onMouseDown,
      onMouseMove = _ref60.onMouseMove,
      onMouseOut = _ref60.onMouseOut,
      onMouseOver = _ref60.onMouseOver,
      onMouseUp = _ref60.onMouseUp,
      onRightClick = _ref60.onRightClick,
      onAddFeature = _ref60.onAddFeature,
      onRemoveFeature = _ref60.onRemoveFeature,
      onRemoveProperty = _ref60.onRemoveProperty,
      onSetGeometry = _ref60.onSetGeometry,
      onSetProperty = _ref60.onSetProperty,
      onLoad = _ref60.onLoad,
      onUnmount = _ref60.onUnmount;
  var map = React.useContext(MapContext);

  var _React$useState226 = React.useState(null),
      _React$useState227 = _slicedToArray2(_React$useState226, 2),
      instance = _React$useState227[0],
      setInstance = _React$useState227[1];

  var _React$useState228 = React.useState(null),
      _React$useState229 = _slicedToArray2(_React$useState228, 2),
      dblclickListener = _React$useState229[0],
      setDblclickListener = _React$useState229[1];

  var _React$useState230 = React.useState(null),
      _React$useState231 = _slicedToArray2(_React$useState230, 2),
      mousedownListener = _React$useState231[0],
      setMousedownListener = _React$useState231[1];

  var _React$useState232 = React.useState(null),
      _React$useState233 = _slicedToArray2(_React$useState232, 2),
      mousemoveListener = _React$useState233[0],
      setMousemoveListener = _React$useState233[1];

  var _React$useState234 = React.useState(null),
      _React$useState235 = _slicedToArray2(_React$useState234, 2),
      mouseoutListener = _React$useState235[0],
      setMouseoutListener = _React$useState235[1];

  var _React$useState236 = React.useState(null),
      _React$useState237 = _slicedToArray2(_React$useState236, 2),
      mouseoverListener = _React$useState237[0],
      setMouseoverListener = _React$useState237[1];

  var _React$useState238 = React.useState(null),
      _React$useState239 = _slicedToArray2(_React$useState238, 2),
      mouseupListener = _React$useState239[0],
      setMouseupListener = _React$useState239[1];

  var _React$useState240 = React.useState(null),
      _React$useState241 = _slicedToArray2(_React$useState240, 2),
      rightclickListener = _React$useState241[0],
      setRightclickListener = _React$useState241[1];

  var _React$useState242 = React.useState(null),
      _React$useState243 = _slicedToArray2(_React$useState242, 2),
      clickListener = _React$useState243[0],
      setClickListener = _React$useState243[1];

  var _React$useState244 = React.useState(null),
      _React$useState245 = _slicedToArray2(_React$useState244, 2),
      addFeatureListener = _React$useState245[0],
      setAddFeatureListener = _React$useState245[1];

  var _React$useState246 = React.useState(null),
      _React$useState247 = _slicedToArray2(_React$useState246, 2),
      removeFeatureListener = _React$useState247[0],
      setRemoveFeatureListener = _React$useState247[1];

  var _React$useState248 = React.useState(null),
      _React$useState249 = _slicedToArray2(_React$useState248, 2),
      removePropertyListener = _React$useState249[0],
      setRemovePropertyListener = _React$useState249[1];

  var _React$useState250 = React.useState(null),
      _React$useState251 = _slicedToArray2(_React$useState250, 2),
      setGeometryListener = _React$useState251[0],
      setSetGeometryListener = _React$useState251[1];

  var _React$useState252 = React.useState(null),
      _React$useState253 = _slicedToArray2(_React$useState252, 2),
      setPropertyListener = _React$useState253[0],
      setSetPropertyListener = _React$useState253[1]; // Order does matter


  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }

      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }

      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }

      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }

      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }

      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }

      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }

      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }

      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onAddFeature) {
      if (addFeatureListener !== null) {
        google.maps.event.removeListener(addFeatureListener);
      }

      setAddFeatureListener(google.maps.event.addListener(instance, 'addfeature', onAddFeature));
    }
  }, [onAddFeature]);
  React.useEffect(function () {
    if (instance && onRemoveFeature) {
      if (removeFeatureListener !== null) {
        google.maps.event.removeListener(removeFeatureListener);
      }

      setRemoveFeatureListener(google.maps.event.addListener(instance, 'removefeature', onRemoveFeature));
    }
  }, [onRemoveFeature]);
  React.useEffect(function () {
    if (instance && onRemoveProperty) {
      if (removePropertyListener !== null) {
        google.maps.event.removeListener(removePropertyListener);
      }

      setRemovePropertyListener(google.maps.event.addListener(instance, 'removeproperty', onRemoveProperty));
    }
  }, [onRemoveProperty]);
  React.useEffect(function () {
    if (instance && onSetGeometry) {
      if (setGeometryListener !== null) {
        google.maps.event.removeListener(setGeometryListener);
      }

      setSetGeometryListener(google.maps.event.addListener(instance, 'setgeometry', onSetGeometry));
    }
  }, [onSetGeometry]);
  React.useEffect(function () {
    if (instance && onSetProperty) {
      if (setPropertyListener !== null) {
        google.maps.event.removeListener(setPropertyListener);
      }

      setSetPropertyListener(google.maps.event.addListener(instance, 'setproperty', onSetProperty));
    }
  }, [onSetProperty]);
  React.useEffect(function () {
    if (map !== null) {
      var _data8 = new google.maps.Data(Object.assign(Object.assign({}, options || {}), {
        map: map
      }));

      if (onDblClick) {
        setDblclickListener(google.maps.event.addListener(_data8, 'dblclick', onDblClick));
      }

      if (onMouseDown) {
        setMousedownListener(google.maps.event.addListener(_data8, 'mousedown', onMouseDown));
      }

      if (onMouseMove) {
        setMousemoveListener(google.maps.event.addListener(_data8, 'mousemove', onMouseMove));
      }

      if (onMouseOut) {
        setMouseoutListener(google.maps.event.addListener(_data8, 'mouseout', onMouseOut));
      }

      if (onMouseOver) {
        setMouseoverListener(google.maps.event.addListener(_data8, 'mouseover', onMouseOver));
      }

      if (onMouseUp) {
        setMouseupListener(google.maps.event.addListener(_data8, 'mouseup', onMouseUp));
      }

      if (onRightClick) {
        setRightclickListener(google.maps.event.addListener(_data8, 'rightclick', onRightClick));
      }

      if (onClick) {
        setClickListener(google.maps.event.addListener(_data8, 'click', onClick));
      }

      if (onAddFeature) {
        setAddFeatureListener(google.maps.event.addListener(_data8, 'addfeature', onAddFeature));
      }

      if (onRemoveFeature) {
        setRemoveFeatureListener(google.maps.event.addListener(_data8, 'removefeature', onRemoveFeature));
      }

      if (onRemoveProperty) {
        setRemovePropertyListener(google.maps.event.addListener(_data8, 'removeproperty', onRemoveProperty));
      }

      if (onSetGeometry) {
        setSetGeometryListener(google.maps.event.addListener(_data8, 'setgeometry', onSetGeometry));
      }

      if (onSetProperty) {
        setSetPropertyListener(google.maps.event.addListener(_data8, 'setproperty', onSetProperty));
      }

      setInstance(_data8);

      if (onLoad) {
        onLoad(_data8);
      }
    }

    return function () {
      if (instance) {
        if (dblclickListener !== null) {
          google.maps.event.removeListener(dblclickListener);
        }

        if (mousedownListener !== null) {
          google.maps.event.removeListener(mousedownListener);
        }

        if (mousemoveListener !== null) {
          google.maps.event.removeListener(mousemoveListener);
        }

        if (mouseoutListener !== null) {
          google.maps.event.removeListener(mouseoutListener);
        }

        if (mouseoverListener !== null) {
          google.maps.event.removeListener(mouseoverListener);
        }

        if (mouseupListener !== null) {
          google.maps.event.removeListener(mouseupListener);
        }

        if (rightclickListener !== null) {
          google.maps.event.removeListener(rightclickListener);
        }

        if (clickListener !== null) {
          google.maps.event.removeListener(clickListener);
        }

        if (addFeatureListener !== null) {
          google.maps.event.removeListener(addFeatureListener);
        }

        if (removeFeatureListener !== null) {
          google.maps.event.removeListener(removeFeatureListener);
        }

        if (removePropertyListener !== null) {
          google.maps.event.removeListener(removePropertyListener);
        }

        if (setGeometryListener !== null) {
          google.maps.event.removeListener(setGeometryListener);
        }

        if (setPropertyListener !== null) {
          google.maps.event.removeListener(setPropertyListener);
        }

        if (onUnmount) {
          onUnmount(instance);
        }

        instance.setMap(null);
      }
    };
  }, []);
  return null;
}

React.memo(DataFunctional);

var Data = /*#__PURE__*/function (_React$PureComponent16) {
  _inherits2(Data, _React$PureComponent16);

  var _super18 = _createSuper2(Data);

  function Data() {
    var _this31;

    _classCallCheck2(this, Data);

    _this31 = _super18.apply(this, arguments);
    _this31.registeredEvents = [];
    _this31.state = {
      data: null
    };

    _this31.setDataCallback = function () {
      if (_this31.state.data !== null && _this31.props.onLoad) {
        _this31.props.onLoad(_this31.state.data);
      }
    };

    return _this31;
  }

  _createClass2(Data, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context !== null) {
        var _data9 = new google.maps.Data(Object.assign(Object.assign({}, this.props.options || {}), {
          map: this.context
        }));

        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: {},
          nextProps: this.props,
          instance: _data9
        });
        this.setState(function () {
          return {
            data: _data9
          };
        }, this.setDataCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.data !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.data
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.data !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.data);
        }

        unregisterEvents(this.registeredEvents);

        if (this.state.data) {
          this.state.data.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Data;
}(React.PureComponent);

Data.contextType = MapContext;
var eventMap$6 = {
  onClick: 'click',
  onDefaultViewportChanged: 'defaultviewport_changed',
  onStatusChanged: 'status_changed'
};
var updaterMap$6 = {
  options: function options(instance, _options13) {
    instance.setOptions(_options13);
  },
  url: function url(instance, _url) {
    instance.setUrl(_url);
  },
  zIndex: function zIndex(instance, _zIndex4) {
    instance.setZIndex(_zIndex4);
  }
};

var KmlLayer = /*#__PURE__*/function (_React$PureComponent17) {
  _inherits2(KmlLayer, _React$PureComponent17);

  var _super19 = _createSuper2(KmlLayer);

  function KmlLayer() {
    var _this32;

    _classCallCheck2(this, KmlLayer);

    _this32 = _super19.apply(this, arguments);
    _this32.registeredEvents = [];
    _this32.state = {
      kmlLayer: null
    };

    _this32.setKmlLayerCallback = function () {
      if (_this32.state.kmlLayer !== null && _this32.props.onLoad) {
        _this32.props.onLoad(_this32.state.kmlLayer);
      }
    };

    return _this32;
  }

  _createClass2(KmlLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var kmlLayer = new google.maps.KmlLayer(Object.assign(Object.assign({}, this.props.options), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$6,
        eventMap: eventMap$6,
        prevProps: {},
        nextProps: this.props,
        instance: kmlLayer
      });
      this.setState(function setLmlLayer() {
        return {
          kmlLayer: kmlLayer
        };
      }, this.setKmlLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.kmlLayer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$6,
          eventMap: eventMap$6,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.kmlLayer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.kmlLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.kmlLayer);
        }

        unregisterEvents(this.registeredEvents);
        this.state.kmlLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return KmlLayer;
}(React.PureComponent);

KmlLayer.contextType = MapContext;

function getOffsetOverride(containerElement, getPixelPositionOffset) {
  return typeof getPixelPositionOffset === 'function' ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
    x: 0,
    y: 0
  };
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


function ensureOfType(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
}

function ensureOfTypeBounds(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());

  if (ne && sw) {
    return {
      left: "".concat(sw.x + offset.x, "px"),
      top: "".concat(ne.y + offset.y, "px"),
      width: "".concat(ne.x - sw.x - offset.x, "px"),
      height: "".concat(sw.y - ne.y - offset.y, "px")
    };
  }

  return {
    left: '-9999px',
    top: '-9999px'
  };
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);

  if (point) {
    var _x4 = point.x,
        _y = point.y;
    return {
      left: "".concat(_x4 + offset.x, "px"),
      top: "".concat(_y + offset.y, "px")
    };
  }

  return {
    left: '-9999px',
    top: '-9999px'
  };
}

function getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
  return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfTypeBounds(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
}

function arePositionsEqual(currentPosition, previousPosition) {
  return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}

function createOverlay(container, pane, position, getPixelPositionOffset) {
  var Overlay = /*#__PURE__*/function (_google$maps$OverlayV) {
    _inherits2(Overlay, _google$maps$OverlayV);

    var _super20 = _createSuper2(Overlay);

    function Overlay(container, pane, position) {
      var _this33;

      _classCallCheck2(this, Overlay);

      _this33 = _super20.call(this);
      _this33.container = container;
      _this33.pane = pane;
      _this33.position = position;
      return _this33;
    }

    _createClass2(Overlay, [{
      key: "onAdd",
      value: function onAdd() {
        var _a;

        var pane = (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a[this.pane];
        pane === null || pane === void 0 ? void 0 : pane.appendChild(this.container);
      }
    }, {
      key: "draw",
      value: function draw() {
        var projection = this.getProjection();
        var point = projection.fromLatLngToDivPixel(this.position);
        var offset = Object.assign({}, this.container ? getOffsetOverride(this.container, getPixelPositionOffset) : {
          x: 0,
          y: 0
        });

        if (point === null) {
          return;
        }

        this.container.style.transform = "translate(".concat(point.x + offset.x, "px, ").concat(point.y + offset.y, "px)");
      }
    }, {
      key: "onRemove",
      value: function onRemove() {
        if (this.container.parentNode !== null) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }]);

    return Overlay;
  }(google.maps.OverlayView);

  return new Overlay(container, pane, position);
}

function convertToLatLngString(latLngLike) {
  if (!latLngLike) {
    return '';
  }

  var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
  return latLng + '';
}

function convertToLatLngBoundsString(latLngBoundsLike) {
  if (!latLngBoundsLike) {
    return '';
  }

  var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
  return latLngBounds + '';
}

function OverlayViewFunctional(_ref61) {
  var position = _ref61.position,
      mapPaneName = _ref61.mapPaneName,
      zIndex = _ref61.zIndex,
      onLoad = _ref61.onLoad,
      onUnmount = _ref61.onUnmount,
      getPixelPositionOffset = _ref61.getPixelPositionOffset,
      children = _ref61.children;
  var map = React.useContext(MapContext);
  var container = React.useMemo(function () {
    var div = document.createElement('div');
    div.style.position = 'absolute';
    return div;
  }, []);
  var overlay = React.useMemo(function () {
    return createOverlay(container, mapPaneName, position, getPixelPositionOffset);
  }, [container, mapPaneName, position]);
  React.useEffect(function () {
    onLoad === null || onLoad === void 0 ? void 0 : onLoad(overlay);
    overlay === null || overlay === void 0 ? void 0 : overlay.setMap(map);
    return function () {
      onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount(overlay);
      overlay === null || overlay === void 0 ? void 0 : overlay.setMap(null);
    };
  }, [map, overlay]); // to move the container to the foreground and background

  React.useEffect(function () {
    container.style.zIndex = "".concat(zIndex);
  }, [zIndex, container]);
  return ReactDOM__namespace.createPortal(children, container);
}

React.memo(OverlayViewFunctional);

var OverlayView = /*#__PURE__*/function (_React$PureComponent18) {
  _inherits2(OverlayView, _React$PureComponent18);

  var _super21 = _createSuper2(OverlayView);

  function OverlayView(props) {
    var _this34;

    _classCallCheck2(this, OverlayView);

    _this34 = _super21.call(this, props);
    _this34.state = {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: 'absolute'
      }
    };

    _this34.updatePane = function () {
      var mapPaneName = _this34.props.mapPaneName; // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes

      var mapPanes = _this34.overlayView.getPanes();

      invariant_1$1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);

      if (mapPanes) {
        _this34.setState({
          paneEl: mapPanes[mapPaneName]
        });
      } else {
        _this34.setState({
          paneEl: null
        });
      }
    };

    _this34.onAdd = function () {
      var _a, _b;

      _this34.updatePane();

      (_b = (_a = _this34.props).onLoad) === null || _b === void 0 ? void 0 : _b.call(_a, _this34.overlayView);
    };

    _this34.onPositionElement = function () {
      var mapCanvasProjection = _this34.overlayView.getProjection();

      var offset = Object.assign({
        x: 0,
        y: 0
      }, _this34.containerRef.current ? getOffsetOverride(_this34.containerRef.current, _this34.props.getPixelPositionOffset) : {});
      var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this34.props.bounds, _this34.props.position);
      var _this34$state$contain = _this34.state.containerStyle,
          left = _this34$state$contain.left,
          top = _this34$state$contain.top,
          width = _this34$state$contain.width,
          height = _this34$state$contain.height;

      if (!arePositionsEqual(layoutStyles, {
        left: left,
        top: top,
        width: width,
        height: height
      })) {
        _this34.setState({
          containerStyle: Object.assign(Object.assign({}, layoutStyles), {
            position: 'absolute'
          })
        });
      }
    };

    _this34.draw = function () {
      _this34.onPositionElement();
    };

    _this34.onRemove = function () {
      var _a, _b;

      _this34.setState(function () {
        return {
          paneEl: null
        };
      }); // this.mapPaneEl = null


      (_b = (_a = _this34.props).onUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, _this34.overlayView);
    };

    _this34.containerRef = React.createRef(); // You must implement three methods: onAdd(), draw(), and onRemove().

    var overlayView = new google.maps.OverlayView();
    overlayView.onAdd = _this34.onAdd;
    overlayView.draw = _this34.draw;
    overlayView.onRemove = _this34.onRemove;
    _this34.overlayView = overlayView;
    return _this34;
  }

  _createClass2(OverlayView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // You must call setMap() with a valid Map object to trigger the call to
      // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.overlayView.setMap(this.context);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevPositionString = convertToLatLngString(prevProps.position);
      var positionString = convertToLatLngString(this.props.position);
      var prevBoundsString = convertToLatLngBoundsString(prevProps.bounds);
      var boundsString = convertToLatLngBoundsString(this.props.bounds);

      if (prevPositionString !== positionString || prevBoundsString !== boundsString) {
        this.overlayView.draw();
      }

      if (prevProps.mapPaneName !== this.props.mapPaneName) {
        this.updatePane();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.overlayView.setMap(null);
    }
  }, {
    key: "render",
    value: function render() {
      var paneEl = this.state.paneEl;

      if (paneEl) {
        return ReactDOM__namespace.createPortal(jsxRuntime.exports.jsx("div", Object.assign({
          ref: this.containerRef,
          style: this.state.containerStyle
        }, {
          children: React.Children.only(this.props.children)
        })), paneEl);
      } else {
        return null;
      }
    }
  }]);

  return OverlayView;
}(React.PureComponent);

OverlayView.FLOAT_PANE = "floatPane";
OverlayView.MAP_PANE = "mapPane";
OverlayView.MARKER_LAYER = "markerLayer";
OverlayView.OVERLAY_LAYER = "overlayLayer";
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
OverlayView.contextType = MapContext;

function noop$2() {
  return;
}

var eventMap$5 = {
  onDblClick: 'dblclick',
  onClick: 'click'
};
var updaterMap$5 = {
  opacity: function opacity(instance, _opacity2) {
    instance.setOpacity(_opacity2);
  }
};

var GroundOverlay = /*#__PURE__*/function (_React$PureComponent19) {
  _inherits2(GroundOverlay, _React$PureComponent19);

  var _super22 = _createSuper2(GroundOverlay);

  function GroundOverlay() {
    var _this35;

    _classCallCheck2(this, GroundOverlay);

    _this35 = _super22.apply(this, arguments);
    _this35.registeredEvents = [];
    _this35.state = {
      groundOverlay: null
    };

    _this35.setGroundOverlayCallback = function () {
      if (_this35.state.groundOverlay !== null && _this35.props.onLoad) {
        _this35.props.onLoad(_this35.state.groundOverlay);
      }
    };

    return _this35;
  }

  _createClass2(GroundOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1$1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
      var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, Object.assign(Object.assign({}, this.props.options), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$5,
        eventMap: eventMap$5,
        prevProps: {},
        nextProps: this.props,
        instance: groundOverlay
      });
      this.setState(function setGroundOverlay() {
        return {
          groundOverlay: groundOverlay
        };
      }, this.setGroundOverlayCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.groundOverlay !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$5,
          eventMap: eventMap$5,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.groundOverlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.groundOverlay) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.groundOverlay);
        }

        this.state.groundOverlay.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return GroundOverlay;
}(React.PureComponent);

GroundOverlay.defaultProps = {
  onLoad: noop$2
};
GroundOverlay.contextType = MapContext;
var eventMap$4 = {};
var updaterMap$4 = {
  data: function data(instance, _data10) {
    instance.setData(_data10);
  },
  map: function map(instance, _map7) {
    instance.setMap(_map7);
  },
  options: function options(instance, _options14) {
    instance.setOptions(_options14);
  }
};

var HeatmapLayer = /*#__PURE__*/function (_React$PureComponent20) {
  _inherits2(HeatmapLayer, _React$PureComponent20);

  var _super23 = _createSuper2(HeatmapLayer);

  function HeatmapLayer() {
    var _this36;

    _classCallCheck2(this, HeatmapLayer);

    _this36 = _super23.apply(this, arguments);
    _this36.registeredEvents = [];
    _this36.state = {
      heatmapLayer: null
    };

    _this36.setHeatmapLayerCallback = function () {
      if (_this36.state.heatmapLayer !== null && _this36.props.onLoad) {
        _this36.props.onLoad(_this36.state.heatmapLayer);
      }
    };

    return _this36;
  }

  _createClass2(HeatmapLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1$1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
      invariant_1$1(!!this.props.data, 'data property is required in HeatmapLayer %s', this.props.data);
      var heatmapLayer = new google.maps.visualization.HeatmapLayer(Object.assign(Object.assign({}, this.props.options || {}), {
        data: this.props.data,
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: {},
        nextProps: this.props,
        instance: heatmapLayer
      });
      this.setState(function setHeatmapLayer() {
        return {
          heatmapLayer: heatmapLayer
        };
      }, this.setHeatmapLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.heatmapLayer
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.heatmapLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.heatmapLayer);
        }

        unregisterEvents(this.registeredEvents);
        this.state.heatmapLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return HeatmapLayer;
}(React.PureComponent);

HeatmapLayer.contextType = MapContext;
var eventMap$3 = {
  onCloseClick: 'closeclick',
  onPanoChanged: 'pano_changed',
  onPositionChanged: 'position_changed',
  onPovChanged: 'pov_changed',
  onResize: 'resize',
  onStatusChanged: 'status_changed',
  onVisibleChanged: 'visible_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$3 = {
  register: function register(instance, provider, options) {
    instance.registerPanoProvider(provider, options);
  },
  links: function links(instance, _links) {
    instance.setLinks(_links);
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking);
  },
  options: function options(instance, _options15) {
    instance.setOptions(_options15);
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano);
  },
  position: function position(instance, _position5) {
    instance.setPosition(_position5);
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov);
  },
  visible: function visible(instance, _visible7) {
    instance.setVisible(_visible7);
  },
  zoom: function zoom(instance, _zoom2) {
    instance.setZoom(_zoom2);
  }
};

var StreetViewPanorama = /*#__PURE__*/function (_React$PureComponent21) {
  _inherits2(StreetViewPanorama, _React$PureComponent21);

  var _super24 = _createSuper2(StreetViewPanorama);

  function StreetViewPanorama() {
    var _this37;

    _classCallCheck2(this, StreetViewPanorama);

    _this37 = _super24.apply(this, arguments);
    _this37.registeredEvents = [];
    _this37.state = {
      streetViewPanorama: null
    };

    _this37.setStreetViewPanoramaCallback = function () {
      if (_this37.state.streetViewPanorama !== null && _this37.props.onLoad) {
        _this37.props.onLoad(_this37.state.streetViewPanorama);
      }
    };

    return _this37;
  }

  _createClass2(StreetViewPanorama, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // @ts-ignore
      var streetViewPanorama = this.context.getStreetView();
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$3,
        eventMap: eventMap$3,
        prevProps: {},
        nextProps: this.props,
        instance: streetViewPanorama
      });
      this.setState(function () {
        return {
          streetViewPanorama: streetViewPanorama
        };
      }, this.setStreetViewPanoramaCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.streetViewPanorama !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$3,
          eventMap: eventMap$3,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.streetViewPanorama
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.streetViewPanorama !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.streetViewPanorama);
        }

        unregisterEvents(this.registeredEvents);
        this.state.streetViewPanorama.setVisible(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return StreetViewPanorama;
}(React.PureComponent);

StreetViewPanorama.contextType = MapContext;

var StreetViewService = /*#__PURE__*/function (_React$PureComponent22) {
  _inherits2(StreetViewService, _React$PureComponent22);

  var _super25 = _createSuper2(StreetViewService);

  function StreetViewService() {
    var _this38;

    _classCallCheck2(this, StreetViewService);

    _this38 = _super25.apply(this, arguments);
    _this38.state = {
      streetViewService: null
    };

    _this38.setStreetViewServiceCallback = function () {
      if (_this38.state.streetViewService !== null && _this38.props.onLoad) {
        _this38.props.onLoad(_this38.state.streetViewService);
      }
    };

    return _this38;
  }

  _createClass2(StreetViewService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var streetViewService = new google.maps.StreetViewService();
      this.setState(function setStreetViewService() {
        return {
          streetViewService: streetViewService
        };
      }, this.setStreetViewServiceCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.streetViewService !== null && this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewService);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return StreetViewService;
}(React.PureComponent);

StreetViewService.contextType = MapContext;
var eventMap$2 = {
  onDirectionsChanged: 'directions_changed'
};
var updaterMap$2 = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions);
  },
  map: function map(instance, _map8) {
    instance.setMap(_map8);
  },
  options: function options(instance, _options16) {
    instance.setOptions(_options16);
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel);
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex);
  }
};

var DirectionsRenderer = /*#__PURE__*/function (_React$PureComponent23) {
  _inherits2(DirectionsRenderer, _React$PureComponent23);

  var _super26 = _createSuper2(DirectionsRenderer);

  function DirectionsRenderer() {
    var _this39;

    _classCallCheck2(this, DirectionsRenderer);

    _this39 = _super26.apply(this, arguments);
    _this39.registeredEvents = [];
    _this39.state = {
      directionsRenderer: null
    };

    _this39.setDirectionsRendererCallback = function () {
      if (_this39.state.directionsRenderer !== null) {
        // @ts-ignore
        _this39.state.directionsRenderer.setMap(_this39.context);

        if (_this39.props.onLoad) {
          _this39.props.onLoad(_this39.state.directionsRenderer);
        }
      }
    };

    return _this39;
  }

  _createClass2(DirectionsRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$2,
        eventMap: eventMap$2,
        prevProps: {},
        nextProps: this.props,
        instance: directionsRenderer
      });
      this.setState(function setDirectionsRenderer() {
        return {
          directionsRenderer: directionsRenderer
        };
      }, this.setDirectionsRendererCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.directionsRenderer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$2,
          eventMap: eventMap$2,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.directionsRenderer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.directionsRenderer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.directionsRenderer);
        }

        unregisterEvents(this.registeredEvents);

        if (this.state.directionsRenderer) {
          this.state.directionsRenderer.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {});
    }
  }]);

  return DirectionsRenderer;
}(React.PureComponent);

DirectionsRenderer.contextType = MapContext;
var eventMap$1 = {
  onPlacesChanged: 'places_changed'
};
var updaterMap$1 = {
  bounds: function bounds(instance, _bounds2) {
    instance.setBounds(_bounds2);
  }
};

var StandaloneSearchBox = /*#__PURE__*/function (_React$PureComponent24) {
  _inherits2(StandaloneSearchBox, _React$PureComponent24);

  var _super27 = _createSuper2(StandaloneSearchBox);

  function StandaloneSearchBox() {
    var _this40;

    _classCallCheck2(this, StandaloneSearchBox);

    _this40 = _super27.apply(this, arguments);
    _this40.registeredEvents = [];
    _this40.containerElement = React.createRef();
    _this40.state = {
      searchBox: null
    };

    _this40.setSearchBoxCallback = function () {
      if (_this40.state.searchBox !== null && _this40.props.onLoad) {
        _this40.props.onLoad(_this40.state.searchBox);
      }
    };

    return _this40;
  }

  _createClass2(StandaloneSearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);

      if (this.containerElement !== null && this.containerElement.current !== null) {
        var input = this.containerElement.current.querySelector('input');

        if (input !== null) {
          var searchBox = new google.maps.places.SearchBox(input, this.props.options);
          this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$1,
            eventMap: eventMap$1,
            prevProps: {},
            nextProps: this.props,
            instance: searchBox
          });
          this.setState(function setSearchBox() {
            return {
              searchBox: searchBox
            };
          }, this.setSearchBoxCallback);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.searchBox !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$1,
          eventMap: eventMap$1,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.searchBox
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.searchBox !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.searchBox);
        }

        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        ref: this.containerElement
      }, {
        children: React.Children.only(this.props.children)
      }));
    }
  }]);

  return StandaloneSearchBox;
}(React.PureComponent);

StandaloneSearchBox.contextType = MapContext;
var eventMap = {
  onPlaceChanged: 'place_changed'
};
var updaterMap = {
  bounds: function bounds(instance, _bounds3) {
    instance.setBounds(_bounds3);
  },
  restrictions: function restrictions(instance, _restrictions) {
    instance.setComponentRestrictions(_restrictions);
  },
  fields: function fields(instance, _fields) {
    instance.setFields(_fields);
  },
  options: function options(instance, _options17) {
    instance.setOptions(_options17);
  },
  types: function types(instance, _types) {
    instance.setTypes(_types);
  }
};

var Autocomplete = /*#__PURE__*/function (_React$PureComponent25) {
  _inherits2(Autocomplete, _React$PureComponent25);

  var _super28 = _createSuper2(Autocomplete);

  function Autocomplete() {
    var _this41;

    _classCallCheck2(this, Autocomplete);

    _this41 = _super28.apply(this, arguments);
    _this41.registeredEvents = [];
    _this41.containerElement = React.createRef();
    _this41.state = {
      autocomplete: null
    };

    _this41.setAutocompleteCallback = function () {
      if (_this41.state.autocomplete !== null && _this41.props.onLoad) {
        _this41.props.onLoad(_this41.state.autocomplete);
      }
    };

    return _this41;
  }

  _createClass2(Autocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1$1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places); // TODO: why current could be equal null?
      // @ts-ignore

      var input = this.containerElement.current.querySelector('input');

      if (input) {
        var autocomplete = new google.maps.places.Autocomplete(input, this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap,
          eventMap: eventMap,
          prevProps: {},
          nextProps: this.props,
          instance: autocomplete
        });
        this.setState(function () {
          return {
            autocomplete: autocomplete
          };
        }, this.setAutocompleteCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap,
        eventMap: eventMap,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.autocomplete
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.autocomplete !== null) {
        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        ref: this.containerElement,
        className: this.props.className
      }, {
        children: React.Children.only(this.props.children)
      }));
    }
  }]);

  return Autocomplete;
}(React.PureComponent);

Autocomplete.defaultProps = {
  className: ''
};
Autocomplete.contextType = MapContext;

var BlossomGoogleMap = function BlossomGoogleMap(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng;
  var defaultProps = {
    center: {
      lat: lat,
      lng: lng
    },
    zoom: 17
  };

  var _useLoadScript = useLoadScript({
    googleMapsApiKey: process.env.GATSBY_GOOGLE_MAPS_API_KEY
  }),
      isLoaded = _useLoadScript.isLoaded;

  if (!isLoaded) return /*#__PURE__*/React__default$1["default"].createElement("div", null, "Loading...");
  return /*#__PURE__*/React__default$1["default"].createElement(Map$3, {
    defaultProps: defaultProps
  });
};

var Map$3 = function Map(_ref2) {
  var defaultProps = _ref2.defaultProps;
  var center = React.useMemo(function () {
    return defaultProps.center;
  }, []);
  var zoom = defaultProps.zoom;
  return /*#__PURE__*/React__default$1["default"].createElement(GoogleMap, {
    zoom: zoom,
    center: center,
    mapContainerClassName: "GOOGLE_MAP"
  }, /*#__PURE__*/React__default$1["default"].createElement(Marker, {
    position: center
  }));
};

function HeaderGradient(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_GRADIENT tw-pt-28"
  }, /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, {
    variant: pageHeaderVariantsTypes.GRADIENT,
    color: pageHeaderColorVariantsTypes.PRIMARY,
    data: data
  }));
}

function HeaderGradients(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_GRADIENTS"
  }, /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, {
    variant: pageHeaderVariantsTypes.GRADIENTS,
    color: pageHeaderColorVariantsTypes.PRIMARY,
    data: data
  }));
}

var _templateObject$1_, _templateObject2$Q;

var H1$1 = styled__default["default"].h1(_templateObject$1_ || (_templateObject$1_ = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref$size;
  return getTextSize(size);
}, function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref3$color;
  return getColors(color);
});
var P$2 = styled__default["default"].p(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.BIG : _ref4$size;
  return getTextSize(size);
}, function (_ref5) {
  var _ref5$fontFamily = _ref5.fontFamily,
      fontFamily = _ref5$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref5$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsVariantsTypes.WHITE : _ref6$color;
  return getColors(color);
});

function HeroCentral(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === void 0 ? [] : _ref7$data;
  return /*#__PURE__*/React__default$1["default"].createElement(Slider, {
    className: "HERO_CENTRAL_SLIDER"
  }, (data && data.id ? [data] : data || []).map(function () {
    var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _content$buttonFilled = content.buttonFilled,
        buttonFilled = _content$buttonFilled === void 0 ? buttonFillTypes.FILLED : _content$buttonFilled,
        _content$buttonGraysc = content.buttonGrayscale,
        buttonGrayscale = _content$buttonGraysc === void 0 ? false : _content$buttonGraysc,
        _content$buttonText = content.buttonText,
        buttonText = _content$buttonText === void 0 ? "" : _content$buttonText,
        _content$buttonTextFo = content.buttonTextFontFamily,
        buttonTextFontFamily = _content$buttonTextFo === void 0 ? fontsFamiliesTypes.PRIMARY : _content$buttonTextFo,
        _content$buttonTextSi = content.buttonTextSize,
        buttonTextSize = _content$buttonTextSi === void 0 ? textSizesVariantsTypes.HEADER_6 : _content$buttonTextSi,
        _content$buttonUrl = content.buttonUrl,
        buttonUrl = _content$buttonUrl === void 0 ? "" : _content$buttonUrl,
        _content$cssBackgroun = content.cssBackgroundGradient,
        cssBackgroundGradient = _content$cssBackgroun === void 0 ? "" : _content$cssBackgroun,
        _content$gradientType = content.gradientType,
        gradientType = _content$gradientType === void 0 ? "Bottom" : _content$gradientType,
        _content$id = content.id,
        id = _content$id === void 0 ? 4 : _content$id,
        _content$image = content.image,
        image = _content$image === void 0 ? {
      alternativeText: "",
      caption: "",
      created_at: "",
      created_by: 1,
      ext: ".jpg",
      formats: {
        thumbnail: {},
        medium: {},
        small: {}
      },
      hash: "",
      height: 980,
      id: 0,
      mime: "",
      name: "",
      previewUrl: null,
      provider: "aws-s3",
      provider_metadata: null,
      size: 62.7,
      updated_at: "",
      updated_by: 0,
      url: "",
      width: 980
    } : _content$image,
        _content$subText = content.subText,
        subText = _content$subText === void 0 ? "" : _content$subText,
        _content$subTextColor = content.subTextColor,
        subTextColor = _content$subTextColor === void 0 ? colorsVariantsTypes.PRIMARY : _content$subTextColor,
        _content$subTextFontF = content.subTextFontFamily,
        subTextFontFamily = _content$subTextFontF === void 0 ? fontsFamiliesTypes.SECONDARY : _content$subTextFontF,
        _content$subTextSize = content.subTextSize,
        subTextSize = _content$subTextSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _content$subTextSize,
        _content$text = content.text,
        text = _content$text === void 0 ? "" : _content$text,
        _content$textColor = content.textColor,
        textColor = _content$textColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _content$textColor,
        _content$textFontFami = content.textFontFamily,
        textFontFamily = _content$textFontFami === void 0 ? fontsFamiliesTypes.PRIMARY : _content$textFontFami,
        _content$textSize = content.textSize,
        textSize = _content$textSize === void 0 ? textSizesVariantsTypes.BIG : _content$textSize;
    return /*#__PURE__*/React__default$1["default"].createElement(HeroCard, {
      key: "HeroCard-".concat(id, "-").concat(nanoid())
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HERO_CARD__CONTAINER tw-flex tw-justify-center tw-text-center tw-absolute tw-w-full tw-z-50"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HERO_CARD__CONTAINER_BOX tw-w-64 sm:tw-w-160 tw-z-40 tw-mb-16"
    }, /*#__PURE__*/React__default$1["default"].createElement(H1$1, {
      className: "HERO_CENTRAL__TITLE Hero__title tw-font-bold tw-px-2 tw-leading-tight sm:tw-leading-none tw-mb-6 sm:tw-px-0 sm:bl-text-3xl",
      size: textSize,
      fontFamily: textFontFamily,
      color: textColor
    }, text), /*#__PURE__*/React__default$1["default"].createElement(P$2, {
      className: "HERO_CENTRAL__SUB_TITLE Hero__subtitle tw-mb-8",
      color: subTextColor,
      fontFamily: subTextFontFamily,
      size: subTextSize
    }, subText), content.buttonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
      is: "a",
      fill: buttonFilled,
      href: buttonUrl,
      grayscale: buttonGrayscale,
      size: buttonTextSize,
      fontFamily: buttonTextFontFamily,
      className: "HERO_CENTRAL__BUTTON"
    }, buttonText))), !!image && !!image.url && gradientType && /*#__PURE__*/React__default$1["default"].createElement(ContainerGradient$1, {
      className: "HERO_CENTRAL__GRADIENT tw-w-full tw-min-h-screen sm:tw-min-h-0",
      gradientType: gradientType,
      cssBackgroundGradient: cssBackgroundGradient,
      image: image.url,
      style: {
        height: "70vh"
      }
    }));
  }));
}

var _templateObject$1Z, _templateObject2$P;

var H1 = styled__default["default"].h1(_templateObject$1Z || (_templateObject$1Z = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref$size;
  return getTextSize(size);
}, function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref3$color;
  return getColors(color);
});
var P$1 = styled__default["default"].p(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.BIG : _ref4$size;
  return getTextSize(size);
}, function (_ref5) {
  var _ref5$fontFamily = _ref5.fontFamily,
      fontFamily = _ref5$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref5$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsTypes.WHITE : _ref6$color;
  return color;
});

function HeroFull(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === void 0 ? [] : _ref7$data,
      buttonHoverBackgroundColor = _ref7.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = _ref7.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = _ref7.buttonHoverOutlineAndColorBorderColor,
      _ref7$buttonWithoutBo = _ref7.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref7$buttonWithoutBo === void 0 ? false : _ref7$buttonWithoutBo,
      _ref7$buttonHoverColo = _ref7.buttonHoverColor,
      buttonHoverColor = _ref7$buttonHoverColo === void 0 ? false : _ref7$buttonHoverColo,
      _ref7$buttonGrayscale = _ref7.buttonGrayscale,
      componentButtonGrayscale = _ref7$buttonGrayscale === void 0 ? false : _ref7$buttonGrayscale,
      _ref7$darkButton = _ref7.darkButton,
      darkButton = _ref7$darkButton === void 0 ? false : _ref7$darkButton,
      _ref7$buttonFill = _ref7.buttonFill,
      buttonFill = _ref7$buttonFill === void 0 ? buttonFillTypes.NONE : _ref7$buttonFill,
      buttonTextColor = _ref7.buttonTextColor,
      _ref7$descriptionColo = _ref7.descriptionColor,
      descriptionColor = _ref7$descriptionColo === void 0 ? colorsTypes.NONE : _ref7$descriptionColo,
      _ref7$buttonStyleType = _ref7.buttonStyleType,
      buttonStyleType = _ref7$buttonStyleType === void 0 ? buttonStyleTypes.STANDARD : _ref7$buttonStyleType;
  return /*#__PURE__*/React__default$1["default"].createElement(Slider, null, (data && data.id ? [data] : data || []).map(function (content) {
    var _content$buttonFilled = content.buttonFilled,
        buttonFilled = _content$buttonFilled === void 0 ? buttonFillTypes.FILLED : _content$buttonFilled,
        _content$buttonGraysc = content.buttonGrayscale,
        buttonGrayscale = _content$buttonGraysc === void 0 ? false : _content$buttonGraysc,
        _content$buttonText = content.buttonText,
        buttonText = _content$buttonText === void 0 ? "" : _content$buttonText,
        _content$buttonTextFo = content.buttonTextFontFamily,
        buttonTextFontFamily = _content$buttonTextFo === void 0 ? fontsFamiliesTypes.PRIMARY : _content$buttonTextFo,
        _content$buttonTextSi = content.buttonTextSize,
        buttonTextSize = _content$buttonTextSi === void 0 ? textSizesVariantsTypes.HEADER_6 : _content$buttonTextSi,
        _content$id = content.id,
        id = _content$id === void 0 ? 4 : _content$id,
        _content$image = content.image,
        image = _content$image === void 0 ? {
      alternativeText: "",
      caption: "",
      created_at: "",
      created_by: 1,
      ext: ".jpg",
      formats: {
        thumbnail: {},
        medium: {},
        small: {}
      },
      hash: "",
      height: 980,
      id: 0,
      mime: "",
      name: "",
      previewUrl: null,
      provider: "aws-s3",
      provider_metadata: null,
      size: 62.7,
      updated_at: "",
      updated_by: 0,
      url: "",
      width: 980
    } : _content$image,
        _content$subText = content.subText,
        subText = _content$subText === void 0 ? "" : _content$subText,
        _content$subTextColor = content.subTextColor,
        subTextColor = _content$subTextColor === void 0 ? colorsVariantsTypes.PRIMARY : _content$subTextColor,
        _content$subTextFontF = content.subTextFontFamily,
        subTextFontFamily = _content$subTextFontF === void 0 ? fontsFamiliesTypes.SECONDARY : _content$subTextFontF,
        _content$subTextSize = content.subTextSize,
        subTextSize = _content$subTextSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _content$subTextSize,
        _content$text = content.text,
        text = _content$text === void 0 ? "" : _content$text,
        _content$textColor = content.textColor,
        textColor = _content$textColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _content$textColor,
        _content$textFontFami = content.textFontFamily,
        textFontFamily = _content$textFontFami === void 0 ? fontsFamiliesTypes.PRIMARY : _content$textFontFami,
        _content$textSize = content.textSize,
        textSize = _content$textSize === void 0 ? textSizesVariantsTypes.BIG : _content$textSize,
        _content$cssBackgroun = content.cssBackgroundGradient,
        gradient = _content$cssBackgroun === void 0 ? "" : _content$cssBackgroun;
    return /*#__PURE__*/React__default$1["default"].createElement(HeroCard, {
      key: "HeroCard-".concat(id, "-").concat(nanoid()),
      className: "HERO_FULL tw-items-end sm:tw-items-center"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HERO_FULL__CONTENT tw-z-40 tw-absolute md:tw-w-160 lg:tw-w-6/12 sm:tw-ml-10 lg:tw-ml-24 tw-px-5 md:tw-px-0 tw-text-center sm:tw-text-left tw-mb-12 sm:tw-mb-0"
    }, /*#__PURE__*/React__default$1["default"].createElement(H1, {
      className: "HERO_FULL__CONTENT__TITLE Hero__title tw-font-bold tw-leading-tight sm:tw-leading-none tw-mb-6 sm:bl-text-3xl",
      size: textSize,
      fontFamily: textFontFamily,
      color: textColor
    }, text), /*#__PURE__*/React__default$1["default"].createElement(P$1, {
      color: descriptionColor || getColors(subTextColor),
      fontFamily: subTextFontFamily,
      size: subTextSize,
      className: "HERO_FULL__CONTENT__SUB_TITLE Hero__subtitle bl-text-lg tw-mb-8"
    }, subText), content.buttonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
      is: "a",
      href: content.buttonUrl,
      withoutBorderRadius: buttonWithoutBorderRadius,
      styleType: buttonStyleType,
      hoverColor: buttonHoverColor,
      dark: darkButton,
      hoverBackgroundColor: buttonHoverBackgroundColor,
      hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
      hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
      textColor: buttonTextColor,
      fill: buttonFilled || buttonFill,
      grayscale: buttonGrayscale || componentButtonGrayscale,
      size: buttonTextSize,
      fontFamily: buttonTextFontFamily,
      className: "HERO_FULL__CONTENT__BUTTON"
    }, buttonText)), image && image.url && /*#__PURE__*/React__default$1["default"].createElement(ContainerGradient$1 // gradient={gradient}
    , {
      gradient: gradient,
      className: "HERO_FULL__GRADIENT tw-w-full tw-min-h-screen sm:tw-min-h-0",
      gradientType: content.gradientType,
      image: image.url,
      style: {
        height: "70vh"
      }
    }));
  }));
}

var _templateObject$1Y, _templateObject2$O, _templateObject3$F, _templateObject4$u, _templateObject5$p, _templateObject6$j;

var Title$h = styled__default["default"].h3(_templateObject$1Y || (_templateObject$1Y = _taggedTemplateLiteral(["\n  margin: 3rem 0;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 70px;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n\n  @media (max-width: ", "px) {\n    padding: 0;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 42px;\n    line-height: 50px;\n\n    text-align: center;\n  }\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref$size;
  return getTextSize(size);
}, function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref3$color;
  return getColors(color);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm;
});
var Description$3 = styled__default["default"].p(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteral(["\n  margin: 0 0 4rem 0;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 28px;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? textSizesVariantsTypes.BIG : _ref5$size;
  return getTextSize(size);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref7) {
  var _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? colorsVariantsTypes.WHITE : _ref7$color;
  return getColors(color);
});
var Cover$2 = styled__default["default"].div(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  position: relative;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 15;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n  }\n"])), function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsTypes.BLACK : _ref8$color;
  return color;
}, function (_ref9) {
  var _ref9$image = _ref9.image,
      image = _ref9$image === void 0 ? "" : _ref9$image,
      _ref9$gradientType = _ref9.gradientType,
      gradientType = _ref9$gradientType === void 0 ? "" : _ref9$gradientType,
      _ref9$gradient = _ref9.gradient,
      gradient = _ref9$gradient === void 0 ? "" : _ref9$gradient;
  if (gradient) return gradient;
  return BackgroundStyleSelector({
    gradientType: gradientType,
    image: image
  });
});
var Image$3 = styled__default["default"].img(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteral(["\n  min-height: calc(100vh - ", "px);\n  width: 100%;\n  object-fit: cover;\n"])), function (_ref10) {
  var _ref10$fullScreen = _ref10.fullScreen,
      fullScreen = _ref10$fullScreen === void 0 ? false : _ref10$fullScreen;
  return fullScreen ? 0 : 75;
});

var defaultSettings$2 = function defaultSettings(data) {
  var dataHasItems = Array.isArray(data) && !!data.length;
  return {
    spaceBetween: 0,
    navigation: dataHasItems,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false
    },
    pagination: {
      clickable: true,
      dynamicBullets: true
    },
    loop: dataHasItems
  };
};

var Content$4 = styled__default["default"].div(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  display: flex;\n  align-items: center;\n  z-index: 20;\n  justify-content: ", ";\n  top: 50%;\n  bottom: 50%;\n  transform: translateY(-50%);\n  opacity: ", ";\n\n  @media (max-width: ", "px) {\n    padding: 0 45px;\n  }\n"])), function (_ref11) {
  var _ref11$position = _ref11.position,
      position = _ref11$position === void 0 ? "Left" : _ref11$position;
  if (/left/gi.test(position)) return "flex-start";
  if (/right/gi.test(position)) return "flex-end";
  if (/center/gi.test(position)) return "center";
  return "center";
}, function (_ref12) {
  var _ref12$animate = _ref12.animate,
      animate = _ref12$animate === void 0 ? false : _ref12$animate;
  return animate ? 0 : 1;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.sm;
});
var SwiperContainer$2 = styled__default["default"](Swiper)(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteral(["\n  height: calc(100vh - ", "px);\n\n  @media (max-width: 1024px) {\n    height: calc(100vh - ", "px);\n\n    .swiper-pagination.swiper-pagination-bullets {\n      bottom: 25px;\n    }\n  }\n\n  .swiper-pagination-bullet-active {\n    background: var(--primary-110-color);\n  }\n\n  ", " {\n    animation: ", ";\n  }\n\n  .swiper-slide {\n    ", " {\n      display: none;\n    }\n  }\n\n  .swiper-slide-active {\n    ", " {\n      display: flex;\n    }\n  }\n\n  @keyframes slide-in-up {\n    from {\n      top: inherit;\n      bottom: -50%;\n      transform: inherit;\n      opacity: 0;\n    }\n    to {\n      top: 50%;\n      bottom: 50%;\n      transform: translateY(-50%);\n      opacity: 1;\n    }\n  }\n"])), function (_ref14) {
  var _ref14$fullScreen = _ref14.fullScreen,
      fullScreen = _ref14$fullScreen === void 0 ? false : _ref14$fullScreen;
  return fullScreen ? 0 : 77;
}, function (_ref15) {
  var _ref15$fullScreen = _ref15.fullScreen,
      fullScreen = _ref15$fullScreen === void 0 ? false : _ref15$fullScreen;
  return fullScreen ? 0 : 43;
}, Content$4, function (_ref16) {
  var _ref16$animate = _ref16.animate,
      animate = _ref16$animate === void 0 ? false : _ref16$animate;
  return animate ? "slide-in-up 625ms linear forwards" : undefined;
}, Content$4, Content$4);

function HeroCarousel$1(_ref17) {
  var _ref17$gradient = _ref17.gradient,
      componentGradient = _ref17$gradient === void 0 ? "" : _ref17$gradient,
      _ref17$data = _ref17.data,
      data = _ref17$data === void 0 ? [] : _ref17$data,
      buttonHoverBackgroundColor = _ref17.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = _ref17.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = _ref17.buttonHoverOutlineAndColorBorderColor,
      _ref17$buttonWithoutB = _ref17.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref17$buttonWithoutB === void 0 ? false : _ref17$buttonWithoutB,
      _ref17$buttonHoverCol = _ref17.buttonHoverColor,
      buttonHoverColor = _ref17$buttonHoverCol === void 0 ? false : _ref17$buttonHoverCol,
      _ref17$fullScreen = _ref17.fullScreen,
      fullScreen = _ref17$fullScreen === void 0 ? false : _ref17$fullScreen,
      _ref17$titleColor = _ref17.titleColor,
      componentTitleColor = _ref17$titleColor === void 0 ? colorsVariantsTypes.WHITE : _ref17$titleColor,
      _ref17$darkDescriptio = _ref17.darkDescription,
      darkDescription = _ref17$darkDescriptio === void 0 ? false : _ref17$darkDescriptio,
      _ref17$buttonGrayscal = _ref17.buttonGrayscale,
      componentButtonGrayscale = _ref17$buttonGrayscal === void 0 ? false : _ref17$buttonGrayscal,
      _ref17$darkButton = _ref17.darkButton,
      darkButton = _ref17$darkButton === void 0 ? false : _ref17$darkButton,
      _ref17$animate = _ref17.animate,
      animate = _ref17$animate === void 0 ? false : _ref17$animate,
      _ref17$settings = _ref17.settings,
      settings = _ref17$settings === void 0 ? {} : _ref17$settings,
      _ref17$buttonFill = _ref17.buttonFill,
      buttonFill = _ref17$buttonFill === void 0 ? buttonFillTypes.FILLED : _ref17$buttonFill,
      _ref17$buttonStyleTyp = _ref17.buttonStyleType,
      buttonStyleType = _ref17$buttonStyleTyp === void 0 ? buttonStyleTypes.STANDARD : _ref17$buttonStyleTyp,
      _ref17$transparent = _ref17.transparent,
      transparent = _ref17$transparent === void 0 ? false : _ref17$transparent,
      _ref17$outline = _ref17.outline,
      outline = _ref17$outline === void 0 ? false : _ref17$outline,
      _ref17$darkGrayscaleA = _ref17.darkGrayscaleAndOutlineBorderColor,
      darkGrayscaleAndOutlineBorderColor = _ref17$darkGrayscaleA === void 0 ? false : _ref17$darkGrayscaleA,
      _ref17$buttonStylesPr = _ref17.buttonStylesProps,
      buttonStylesProps = _ref17$buttonStylesPr === void 0 ? {} : _ref17$buttonStylesPr;

  var swiperSettings = _objectSpread2(_objectSpread2({}, defaultSettings$2(data)), settings);

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  return /*#__PURE__*/React__default$1["default"].createElement("div", null, /*#__PURE__*/React__default$1["default"].createElement(SwiperContainer$2, _extends$g({
    animate: animate,
    fullScreen: fullScreen,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false
    },
    pagination: {
      clickable: true,
      dynamicBullets: true
    },
    loop: Array.isArray(data) && !!data.length,
    id: data[0].heroId,
    className: "HERO_CAROUSEL__SWIPER"
  }, swiperSettings), (data && data.id ? [data] : data || []).map(function (_ref18) {
    var _data$image;

    var _ref18$image = _ref18.image,
        image = _ref18$image === void 0 ? {} : _ref18$image,
        _ref18$mobileImg = _ref18.mobileImg,
        mobileImg = _ref18$mobileImg === void 0 ? "" : _ref18$mobileImg,
        _ref18$buttonText = _ref18.buttonText,
        buttonText = _ref18$buttonText === void 0 ? "" : _ref18$buttonText,
        _ref18$buttonUrl = _ref18.buttonUrl,
        buttonUrl = _ref18$buttonUrl === void 0 ? "" : _ref18$buttonUrl,
        _ref18$buttonGrayscal = _ref18.buttonGrayscale,
        buttonGrayscale = _ref18$buttonGrayscal === void 0 ? true : _ref18$buttonGrayscal,
        _ref18$buttonTextFont = _ref18.buttonTextFontFamily,
        buttonTextFontFamily = _ref18$buttonTextFont === void 0 ? fontsFamiliesTypes.PRIMARY : _ref18$buttonTextFont,
        _ref18$buttonTextSize = _ref18.buttonTextSize,
        buttonTextSize = _ref18$buttonTextSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref18$buttonTextSize,
        _ref18$buttonFilled = _ref18.buttonFilled,
        buttonFilled = _ref18$buttonFilled === void 0 ? buttonFillTypes.FILLED : _ref18$buttonFilled,
        _ref18$subText = _ref18.subText,
        subText = _ref18$subText === void 0 ? "" : _ref18$subText,
        _ref18$subTextColor = _ref18.subTextColor,
        subTextColor = _ref18$subTextColor === void 0 ? colorsVariantsTypes.WHITE : _ref18$subTextColor,
        _ref18$subTextFontFam = _ref18.subTextFontFamily,
        subTextFontFamily = _ref18$subTextFontFam === void 0 ? fontsFamiliesTypes.PRIMARY : _ref18$subTextFontFam,
        _ref18$subTextSize = _ref18.subTextSize,
        subTextSize = _ref18$subTextSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref18$subTextSize,
        _ref18$text = _ref18.text,
        text = _ref18$text === void 0 ? "" : _ref18$text,
        _ref18$textColor = _ref18.textColor,
        textColor = _ref18$textColor === void 0 ? colorsVariantsTypes.WHITE : _ref18$textColor,
        _ref18$textFontFamily = _ref18.textFontFamily,
        textFontFamily = _ref18$textFontFamily === void 0 ? fontsFamiliesTypes.SECONDARY : _ref18$textFontFamily,
        _ref18$textSize = _ref18.textSize,
        textSize = _ref18$textSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref18$textSize,
        _ref18$cssBackgroundG = _ref18.cssBackgroundGradient,
        gradient = _ref18$cssBackgroundG === void 0 ? "" : _ref18$cssBackgroundG,
        _ref18$gradientType = _ref18.gradientType,
        gradientType = _ref18$gradientType === void 0 ? "Center" : _ref18$gradientType;
    return /*#__PURE__*/React__default$1["default"].createElement(SwiperSlide, {
      key: nanoid(),
      className: "HERO_CAROUSEL__SLIDE"
    }, /*#__PURE__*/React__default$1["default"].createElement(Cover$2, {
      image: mobileImg !== "" && width <= breakpoints.sm ? mobileImg : image,
      gradientType: gradientType,
      gradient: gradient || componentGradient || undefined,
      className: "HERO_CAROUSEL__COVER"
    }, /*#__PURE__*/React__default$1["default"].createElement(Image$3, {
      fullScreen: true,
      src: mobileImg !== "" && width <= breakpoints.sm ? process.env.GATSBY_CU_NAME === "bayou" ? "https://d1w2egu22dd0ex.cloudfront.net/".concat(mobileImg.url.split("/").pop()) : mobileImg.url : process.env.GATSBY_CU_NAME === "bayou" ? "https://d1w2egu22dd0ex.cloudfront.net/".concat(image.url.split("/").pop()) : image.url,
      alt: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.alternativeText) || "",
      className: "HERO_CAROUSEL__COVER__IMAGE"
    }), /*#__PURE__*/React__default$1["default"].createElement(Content$4, {
      position: gradientType,
      className: "HERO_CAROUSEL__COVER__CONTENT"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HERO_CAROUSEL__COVER__CONTENT_BOX tw-w-full tw-text-center tw-x-container tw-z-40"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HERO_CAROUSEL__COVER__CONTENT_BOX__SUB_BOX sm:tw-text-left"
    }, /*#__PURE__*/React__default$1["default"].createElement(Title$h, {
      size: textSize || textSizesVariantsTypes.HEADER_6,
      fontFamily: textFontFamily || fontsFamiliesTypes.SECONDARY,
      color: textColor || componentTitleColor || colorsVariantsTypes.WHITE,
      className: "HERO_CAROUSEL__TITLE Hero__title bl-text-primary tw-px-0 tw-font-bold tw-mb-16 sm:tw-mb-10 bl-text-2xl sm:bl-text-3xl"
    }, text), /*#__PURE__*/React__default$1["default"].createElement(Description$3, {
      size: subTextSize || textSizesVariantsTypes.VERY_LARGE,
      fontFamily: subTextFontFamily || fontsFamiliesTypes.PRIMARY,
      color: subTextColor || colorsVariantsTypes.WHITE,
      dark: darkDescription,
      className: "HERO_CAROUSEL__SUB_TITLE Hero__subtitle bl-text-lg tw-mb-16 sm:tw-mb-10"
    }, subText), buttonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
      size: buttonTextSize || textSizesVariantsTypes.VERY_SMALL,
      fontFamily: buttonTextFontFamily || fontsFamiliesTypes.PRIMARY,
      withoutBorderRadius: buttonWithoutBorderRadius,
      fill: buttonFilled || buttonFill,
      styleType: buttonStyleType,
      hoverColor: buttonHoverColor,
      grayscale: buttonGrayscale || componentButtonGrayscale,
      is: "a",
      href: buttonUrl,
      dark: darkButton,
      hoverBackgroundColor: buttonHoverBackgroundColor,
      hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
      hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
      transparent: transparent,
      outline: outline,
      darkGrayscaleAndOutlineBorderColor: darkGrayscaleAndOutlineBorderColor,
      className: "HERO_CAROUSEL__BUTTON"
    }, buttonStylesProps), buttonText))))));
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HERO__ARROW",
    style: {
      position: "absolute",
      width: "20px",
      height: "50px",
      zIndex: "50",
      top: "calc(100vh - 100px",
      left: "calc(100vw - 60px",
      display: "none"
    }
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    style: {
      color: "red"
    },
    type: "button",
    onClick: function onClick() {
      // if(!window) return null
      window.scrollBy(0, 750); // return nul
    }
  }, /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "HERO__ARROW_IMAGE",
    src: "/images/icons/hero-arrow.png",
    alt: "hero-arrow"
  }))));
}

HeroCarousel$1.defaultProps = {
  dark: false
};
HeroCarousel$1.propTypes = {
  data: PropTypes.array.isRequired,
  dark: PropTypes.bool
};

var _templateObject$1X, _templateObject2$N, _templateObject3$E, _templateObject4$t, _templateObject5$o, _templateObject6$i;

var SwiperContainer$1 = styled__default["default"](Swiper)(_templateObject$1X || (_templateObject$1X = _taggedTemplateLiteral(["\n  height: calc(100vh - ", "px);\n\n  @media (max-width: 1024px) {\n    height: calc(100vh - ", "px);\n    .swiper-pagination.swiper-pagination-bullets {\n      bottom: 25px;\n    }\n  }\n\n  .swiper-pagination-bullet-active {\n    background: var(--primary-110-color);\n  }\n"])), function (_ref) {
  var _ref$fullScreen = _ref.fullScreen,
      fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen;
  return fullScreen ? 0 : 77;
}, function (_ref2) {
  var _ref2$fullScreen = _ref2.fullScreen,
      fullScreen = _ref2$fullScreen === void 0 ? false : _ref2$fullScreen;
  return fullScreen ? 0 : 43;
});
var Title$g = styled__default["default"].h3(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 62px;\n  line-height: 70px;\n  margin: 3rem 0 0 0;\n  ", ";\n\n  @media (max-width: ", "px) {\n    padding: 0;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 42px;\n    line-height: 50px;\n    text-align: center;\n  }\n"])), function (_ref3) {
  var _ref3$dark = _ref3.dark,
      dark = _ref3$dark === void 0 ? false : _ref3$dark,
      _ref3$titleColor = _ref3.titleColor,
      titleColor = _ref3$titleColor === void 0 ? null : _ref3$titleColor;
  if (!dark) return "color: ".concat(titleColor);
  return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm;
});
var Description$2 = styled__default["default"].p(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 22px;\n  line-height: 28px;\n  ", "\n"])), function (_ref5) {
  var subTextColor = _ref5.subTextColor;
  return "color: ".concat(subTextColor, ";"); // if (!dark) {
  //   return `
  //     color: ${subTextColor};
  //   `
  // } else {
  //   return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
  // }
});
var Cover$1 = styled__default["default"].div(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  position: relative;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 5;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n  }\n"])), function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsTypes.BLACK : _ref6$color;
  return color;
}, function (_ref7) {
  var _ref7$image = _ref7.image,
      image = _ref7$image === void 0 ? "" : _ref7$image,
      _ref7$gradientType = _ref7.gradientType,
      gradientType = _ref7$gradientType === void 0 ? "" : _ref7$gradientType,
      _ref7$gradient = _ref7.gradient,
      gradient = _ref7$gradient === void 0 ? "" : _ref7$gradient;
  if (gradient) return gradient;
  return BackgroundStyleSelector({
    gradientType: gradientType,
    image: image
  });
});
var Image$2 = styled__default["default"].img(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteral(["\n  min-height: calc(100vh - ", "px);\n  width: 100%;\n  object-fit: cover;\n"])), function (_ref8) {
  var _ref8$fullScreen = _ref8.fullScreen,
      fullScreen = _ref8$fullScreen === void 0 ? false : _ref8$fullScreen;
  return fullScreen ? 0 : 75;
});

var defaultSettings$1 = function defaultSettings(data) {
  var dataHasItems = Array.isArray(data) && !!data.length;
  return {
    spaceBetween: 0,
    navigation: false,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    pagination: {
      clickable: true,
      dynamicBullets: true
    },
    loop: dataHasItems
  };
};

var Content$3 = styled__default["default"].div(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 0 135px;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100%;\n  display: flex;\n\n  justify-content: ", ";\n\n  align-items: center;\n  z-index: 15;\n\n  @media (max-width: ", "px) {\n    padding: 0 45px;\n  }\n"])), function (_ref9) {
  var _ref9$position = _ref9.position,
      position = _ref9$position === void 0 ? "Left" : _ref9$position;
  if (/left/gi.test(position)) return "flex-start";
  if (/right/gi.test(position)) return "flex-end";
  if (/center/gi.test(position)) return "center";
  return "center";
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.sm;
});

function HeroCarousel(_ref11) {
  var _ref11$gradient = _ref11.gradient,
      componentGradient = _ref11$gradient === void 0 ? "" : _ref11$gradient,
      _ref11$applyMaxWidthC = _ref11.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref11$applyMaxWidthC === void 0 ? false : _ref11$applyMaxWidthC,
      _ref11$data = _ref11.data,
      data = _ref11$data === void 0 ? [] : _ref11$data,
      buttonHoverBackgroundColor = _ref11.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = _ref11.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = _ref11.buttonHoverOutlineAndColorBorderColor,
      grayscaleAndOutlineBorderColor = _ref11.grayscaleAndOutlineBorderColor,
      grayscaleAndOutlineTextColor = _ref11.grayscaleAndOutlineTextColor,
      grayscaleAndFilledBackgroundColor = _ref11.grayscaleAndFilledBackgroundColor,
      hoverGrayscaleFilledTextColor = _ref11.hoverGrayscaleFilledTextColor,
      hoverAndNotOutlineTextColor = _ref11.hoverAndNotOutlineTextColor,
      hoverColor = _ref11.hoverColor,
      hoverGrayscaleFillBackgroundColor = _ref11.hoverGrayscaleFillBackgroundColor,
      hoverGrayscaleBorderColor = _ref11.hoverGrayscaleBorderColor,
      _ref11$buttonWithoutB = _ref11.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref11$buttonWithoutB === void 0 ? false : _ref11$buttonWithoutB,
      _ref11$fullScreen = _ref11.fullScreen,
      fullScreen = _ref11$fullScreen === void 0 ? false : _ref11$fullScreen,
      _ref11$darkDescriptio = _ref11.darkDescription,
      darkDescription = _ref11$darkDescriptio === void 0 ? false : _ref11$darkDescriptio,
      _ref11$buttonGrayscal = _ref11.buttonGrayscale,
      componentButtonGrayscale = _ref11$buttonGrayscal === void 0 ? false : _ref11$buttonGrayscal,
      _ref11$darkButton = _ref11.darkButton,
      darkButton = _ref11$darkButton === void 0 ? false : _ref11$darkButton,
      _ref11$settings = _ref11.settings,
      settings = _ref11$settings === void 0 ? defaultSettings$1(data) : _ref11$settings,
      _ref11$buttonFill = _ref11.buttonFill,
      buttonFill = _ref11$buttonFill === void 0 ? buttonFillTypes.NONE : _ref11$buttonFill,
      _ref11$buttonStyleTyp = _ref11.buttonStyleType,
      buttonStyleType = _ref11$buttonStyleTyp === void 0 ? buttonStyleTypes.STANDARD : _ref11$buttonStyleTyp,
      _ref11$transparent = _ref11.transparent,
      transparent = _ref11$transparent === void 0 ? false : _ref11$transparent,
      _ref11$outline = _ref11.outline,
      outline = _ref11$outline === void 0 ? false : _ref11$outline,
      _ref11$darkGrayscaleA = _ref11.darkGrayscaleAndOutlineBorderColor,
      darkGrayscaleAndOutlineBorderColor = _ref11$darkGrayscaleA === void 0 ? false : _ref11$darkGrayscaleA,
      _ref11$titleColor = _ref11.titleColor,
      componentTitleColor = _ref11$titleColor === void 0 ? colorsVariantsTypes.WHITE : _ref11$titleColor,
      _ref11$grayscaleAndOF = _ref11.grayscaleAndOFilledTextColor,
      grayscaleAndOFilledTextColor = _ref11$grayscaleAndOF === void 0 ? colorsTypes.WHITE : _ref11$grayscaleAndOF,
      _ref11$buttonStylesPr = _ref11.buttonStylesProps,
      buttonStylesProps = _ref11$buttonStylesPr === void 0 ? {} : _ref11$buttonStylesPr;

  var swiperSettings = _objectSpread2(_objectSpread2({}, defaultSettings$1(data)), settings);

  return /*#__PURE__*/React__default$1["default"].createElement(SwiperContainer$1, _extends$g({
    fullScreen: fullScreen,
    navigation: Array.isArray(data) && !!data.length,
    pagination: {
      clickable: true,
      dynamicBullets: true
    },
    loop: Array.isArray(data) && !!data.length,
    className: "HERO_CAROUSEL_CENTRAL_CONTENT__SWIPER"
  }, swiperSettings), (data && data.id ? [data] : data || []).map(function (_ref12) {
    var _ref12$image = _ref12.image,
        image = _ref12$image === void 0 ? {} : _ref12$image,
        _ref12$buttonText = _ref12.buttonText,
        buttonText = _ref12$buttonText === void 0 ? "" : _ref12$buttonText,
        _ref12$buttonUrl = _ref12.buttonUrl,
        buttonUrl = _ref12$buttonUrl === void 0 ? "" : _ref12$buttonUrl,
        _ref12$buttonGrayscal = _ref12.buttonGrayscale,
        buttonGrayscale = _ref12$buttonGrayscal === void 0 ? true : _ref12$buttonGrayscal,
        _ref12$buttonTextFont = _ref12.buttonTextFontFamily,
        buttonTextFontFamily = _ref12$buttonTextFont === void 0 ? fontsFamiliesTypes.PRIMARY : _ref12$buttonTextFont,
        _ref12$buttonTextSize = _ref12.buttonTextSize,
        buttonTextSize = _ref12$buttonTextSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref12$buttonTextSize,
        _ref12$buttonFilled = _ref12.buttonFilled,
        buttonFilled = _ref12$buttonFilled === void 0 ? buttonFillTypes.FILLED : _ref12$buttonFilled,
        _ref12$subText = _ref12.subText,
        subText = _ref12$subText === void 0 ? "" : _ref12$subText,
        _ref12$subTextColor = _ref12.subTextColor,
        subTextColor = _ref12$subTextColor === void 0 ? colorsVariantsTypes.WHITE : _ref12$subTextColor,
        _ref12$subTextFontFam = _ref12.subTextFontFamily,
        subTextFontFamily = _ref12$subTextFontFam === void 0 ? fontsFamiliesTypes.PRIMARY : _ref12$subTextFontFam,
        _ref12$subTextSize = _ref12.subTextSize,
        subTextSize = _ref12$subTextSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref12$subTextSize,
        _ref12$text = _ref12.text,
        text = _ref12$text === void 0 ? "" : _ref12$text,
        _ref12$textColor = _ref12.textColor,
        textColor = _ref12$textColor === void 0 ? colorsVariantsTypes.WHITE : _ref12$textColor,
        _ref12$textFontFamily = _ref12.textFontFamily,
        textFontFamily = _ref12$textFontFamily === void 0 ? fontsFamiliesTypes.SECONDARY : _ref12$textFontFamily,
        _ref12$textSize = _ref12.textSize,
        textSize = _ref12$textSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref12$textSize,
        _ref12$cssBackgroundG = _ref12.cssBackgroundGradient,
        gradient = _ref12$cssBackgroundG === void 0 ? "" : _ref12$cssBackgroundG,
        _ref12$gradientType = _ref12.gradientType,
        gradientType = _ref12$gradientType === void 0 ? "Center" : _ref12$gradientType;
    return /*#__PURE__*/React__default$1["default"].createElement(SwiperSlide, {
      key: nanoid(),
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__SWIPER__SLIDE"
    }, /*#__PURE__*/React__default$1["default"].createElement(Cover$1, {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER",
      image: image,
      gradientType: gradientType,
      gradient: gradient || componentGradient || undefined
    }, /*#__PURE__*/React__default$1["default"].createElement(Image$2, {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__IMAGE",
      fullScreen: true,
      src: image.url,
      alt: (image === null || image === void 0 ? void 0 : image.alternativeText) || ""
    }), /*#__PURE__*/React__default$1["default"].createElement(Content$3, {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT",
      position: gradientType
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: classnames("HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__TITLE_BOX tw-w-full tw-text-center sm:tw-px-12 tw-z-40", applyMaxWidthContainer ? "tw-x-container max-width-container" : "sm:tw-container")
    }, /*#__PURE__*/React__default$1["default"].createElement(Title$g, {
      size: textSize || textSizesVariantsTypes.HEADER_6,
      fontFamily: textFontFamily || fontsFamiliesTypes.SECONDARY,
      color: textColor || componentTitleColor || colorsVariantsTypes.WHITE // {...data[index]}
      ,
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__TITLE Hero__title bl-text-primary bl-font-secondary tw-px-0 tw-font-bold tw-mb-16 sm:tw-mb-10 bl-text-2xl sm:bl-text-3xl"
    }, text), /*#__PURE__*/React__default$1["default"].createElement(Description$2, {
      subTextColor: subTextColor,
      size: subTextSize || textSizesVariantsTypes.VERY_LARGE,
      fontFamily: subTextFontFamily || fontsFamiliesTypes.PRIMARY,
      color: subTextColor || colorsVariantsTypes.WHITE,
      dark: darkDescription // {...data[index]}
      ,
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__DESCRIPTION Hero__subtitle bl-text-lg bl-text-grayscale tw-mb-16 sm:tw-mb-10"
    }, subText), buttonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
      size: buttonTextSize || textSizesVariantsTypes.VERY_SMALL,
      fontFamily: buttonTextFontFamily || fontsFamiliesTypes.PRIMARY,
      fill: buttonFilled || buttonFill,
      grayscale: buttonGrayscale || componentButtonGrayscale,
      grayscaleAndFilledBackgroundColor: grayscaleAndFilledBackgroundColor,
      hoverGrayscaleFillBackgroundColor: hoverGrayscaleFillBackgroundColor,
      hoverGrayscaleBorderColor: hoverGrayscaleBorderColor,
      hoverBorderColor: true,
      withoutBorderRadius: buttonWithoutBorderRadius,
      styleType: buttonStyleType,
      is: "a",
      href: buttonUrl,
      dark: darkButton,
      hoverBackgroundColor: buttonHoverBackgroundColor,
      hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
      hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
      transparent: transparent,
      outline: outline,
      darkGrayscaleAndOutlineBorderColor: darkGrayscaleAndOutlineBorderColor,
      grayscaleAndOutlineBorderColor: grayscaleAndOutlineBorderColor,
      grayscaleAndOutlineTextColor: grayscaleAndOutlineTextColor,
      hoverGrayscaleFilledTextColor: hoverGrayscaleFilledTextColor,
      hoverAndNotOutlineTextColor: hoverAndNotOutlineTextColor,
      hoverColor: hoverColor,
      grayscaleAndOFilledTextColor: grayscaleAndOFilledTextColor,
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__BUTTON"
    }, buttonStylesProps), buttonText)))));
  }));
}

HeroCarousel.defaultProps = {
  dark: false
};
HeroCarousel.propTypes = {
  data: PropTypes.array.isRequired,
  dark: PropTypes.bool
};

var _templateObject$1W, _templateObject2$M, _templateObject3$D;

var Title$f = styled__default["default"].h3(_templateObject$1W || (_templateObject$1W = _taggedTemplateLiteral(["\n  ", ";\n\n  @media (max-width: ", "px) {\n    padding-top: 1rem;\n    font-size: ", ";\n    color: ", ";\n  }\n"])), function (_ref) {
  var fontSize = _ref.fontSize,
      fontFamily = _ref.fontFamily,
      fontColor = _ref.fontColor;
  return "\n      font-size: ".concat(fontSize || getTextSize(textSizesVariantsTypes.HEADER_6), ";\n      font-family: ").concat(fontFamily || getFontFamily(fontsFamiliesVariantsTypes.SECONDARY), ";\n      color: ").concat(fontColor || getColors(colorsVariantsTypes.WHITE), ";\n    ");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.sm;
}, getTextSize(textSizesVariantsTypes.HEADER_1_H2), getColors(colorsVariantsTypes.PRIMARY_DARK));
var SubTitle$1 = styled__default["default"].div(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$fontColor = _ref3.fontColor,
      fontColor = _ref3$fontColor === void 0 ? undefined : _ref3$fontColor,
      _ref3$fontSize = _ref3.fontSize,
      fontSize = _ref3$fontSize === void 0 ? undefined : _ref3$fontSize,
      _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? undefined : _ref3$fontFamily;
  return "\n      font-family: ".concat(fontFamily || getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), ";\n      font-size: ").concat(fontSize || getTextSize(textSizesVariantsTypes.BIG), ";\n      color: ").concat(fontColor || getColors(colorsVariantsTypes.WHITE), ";\n    ");
});
var LineDivider = styled__default["default"].div(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteral(["\n  border-color: ", ";\n  background: ", ";\n\n  @media (max-width: ", "px) {\n    height: 5px;\n    border-color: transparent;\n    background: linear-gradient(\n      264.35deg,\n      ", " 2.57%,\n      ", " 95.51%\n    );\n  }\n"])), getColors(colorsVariantsTypes.WHITE), getColors(colorsVariantsTypes.WHITE), function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm;
}, getColors(colorsVariantsTypes.PRIMARY_DARK), getColors(colorsVariantsTypes.PRIMARY_SEMI_DARK));

function HeroDinamic(_ref5) {
  var _ref5$applyMaxWidthCo = _ref5.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref5$applyMaxWidthCo === void 0 ? false : _ref5$applyMaxWidthCo,
      _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? {} : _ref5$data,
      _ref5$subTitle = _ref5.subTitle,
      subTitle = _ref5$subTitle === void 0 ? {} : _ref5$subTitle,
      _ref5$title = _ref5.title,
      title = _ref5$title === void 0 ? {} : _ref5$title;
  if (!data.id) data = data[0];
  var _data = data,
      _data$addSpaces = _data.addSpaces,
      addSpaces = _data$addSpaces === void 0 ? false : _data$addSpaces,
      _data$gradientType = _data.gradientType,
      gradientType = _data$gradientType === void 0 ? "Bottom" : _data$gradientType,
      _data$image = _data.image,
      image = _data$image === void 0 ? {
    alternativeText: "",
    caption: "",
    created_at: "",
    created_by: 1,
    ext: ".jpg",
    formats: {
      thumbnail: {},
      medium: {},
      small: {}
    },
    hash: "",
    height: 980,
    id: 0,
    mime: "",
    name: "",
    previewUrl: null,
    provider: "aws-s3",
    provider_metadata: null,
    size: 62.7,
    updated_at: "",
    updated_by: 0,
    url: "",
    width: 980
  } : _data$image,
      _data$subText = _data.subText,
      subText = _data$subText === void 0 ? "" : _data$subText,
      _data$subTextColor = _data.subTextColor,
      subTextColor = _data$subTextColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$subTextColor,
      _data$subTextFontFami = _data.subTextFontFamily,
      subTextFontFamily = _data$subTextFontFami === void 0 ? fontsFamiliesTypes.SECONDARY : _data$subTextFontFami,
      _data$subTextSize = _data.subTextSize,
      subTextSize = _data$subTextSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$subTextSize,
      _data$mobileTextColor = _data.mobileTextColor,
      mobileTextColor = _data$mobileTextColor === void 0 ? colorsVariantsTypes.PRIMARY : _data$mobileTextColor,
      _data$mobileTextFontF = _data.mobileTextFontFamily,
      mobileTextFontFamily = _data$mobileTextFontF === void 0 ? fontsFamiliesTypes.SECONDARY : _data$mobileTextFontF,
      _data$mobileTextSize = _data.mobileTextSize,
      mobileTextSize = _data$mobileTextSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$mobileTextSize,
      _data$text = _data.text,
      text = _data$text === void 0 ? "" : _data$text,
      _data$textColor = _data.textColor,
      textColor = _data$textColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _data$textColor,
      _data$textFontFamily = _data.textFontFamily,
      textFontFamily = _data$textFontFamily === void 0 ? fontsFamiliesTypes.PRIMARY : _data$textFontFamily,
      _data$textSize = _data.textSize,
      textSize = _data$textSize === void 0 ? textSizesVariantsTypes.BIG : _data$textSize,
      _data$cssBackgroundGr = _data.cssBackgroundGradient,
      gradient = _data$cssBackgroundGr === void 0 ? "linear-gradient(to top, rgba(79, 0, 23, 0.4), rgba(0, 0, 0, 1))" : _data$cssBackgroundGr;
  var spacer = "auto";
  var titleSpacer = {
    marginTop: "auto"
  };

  if (addSpaces) {
    spacer = "auto";
  } else {
    spacer = "-5rem";
    titleSpacer = {
      marginTop: "3rem"
    };
  }

  var styleFeature = {
    backgroundColor: "#000",
    backgroundImage: "url(".concat(image === null || image === void 0 ? void 0 : image.url, ")"),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    // marginLeft: "-5%",
    // marginRight: "-5%",
    marginTop: "".concat(spacer)
  };
  var blurBg = {
    minHeight: "500px"
  };

  if (gradientType) {
    blurBg = _objectSpread2(_objectSpread2({}, blurBg), {}, {
      backgroundImage: gradient
    });
  }

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    style: styleFeature,
    className: "HERO_DYNAMIC_DESKTOP hero-dinamic-container tw-hidden md:tw-block"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    style: blurBg,
    className: "HERO_DYNAMIC_DESKTOP__CONTAINER "
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("HERO_DYNAMIC_DESKTOP__CONTAINER__BOX tw-x-container tw-pt-32 tw-w-full", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$f, _extends$g({
    style: titleSpacer,
    className: "HERO_DYNAMIC_DESKTOP__CONTAINER__BOX__TITLE tw-font-bold sm:bl-text-3xl tw-my-5 tw-leading-snug",
    size: textSize,
    fontFamily: textFontFamily,
    color: textColor
  }, title), text), !!subText && /*#__PURE__*/React__default$1["default"].createElement(SubTitle$1, _extends$g({
    className: "HERO_DYNAMIC_DESKTOP__CONTAINER__BOX__SUB_TITLE tw-leading-snug",
    color: subTextColor,
    fontFamily: subTextFontFamily,
    size: subTextSize
  }, subTitle), subText, /*#__PURE__*/React__default$1["default"].createElement(LineDivider, {
    className: "HERO_DYNAMIC_DESKTOP__CONTAINER__BOX__LINE_DIVIDER tw-my-8 tw-border-2 tw-w-40"
  }))))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HERO_DYNAMIC_MOBILE tw-x-container md:tw-hidden tw-p-4"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$f, {
    key: "TITLE_MOBIL_1",
    className: "HERO_DYNAMIC_MOBILE__TITLE xxxx bl-font-secondary tw-font-bold bl-text-primary bl-text-2xl sm:bl-text-3xl  tw-my-4 tw-leading-snug",
    size: textSize,
    fontFamily: textFontFamily,
    color: textColor,
    mobileSize: mobileTextSize,
    mobileFontFamily: mobileTextFontFamily,
    mobileColor: mobileTextColor
  }, text), subText && /*#__PURE__*/React__default$1["default"].createElement(Title$f, {
    key: "TITLE_MOBIL_2",
    className: "HERO_DYNAMIC_MOBILE__TITLE_SUBTITLE bl-font-secondary tw-font-bold bl-text-primary bl-text-2xl sm:bl-text-3xl  tw-my-4 tw-leading-snug tw-hidden",
    size: textSize,
    fontFamily: textFontFamily,
    color: textColor,
    mobileSize: mobileTextSize,
    mobileFontFamily: mobileTextFontFamily,
    mobileColor: mobileTextColor
  }, subText), /*#__PURE__*/React__default$1["default"].createElement(LineDivider, {
    className: "HERO_DYNAMIC_MOBILE__LINE_DIVIDER tw-my-4 tw-border-2 tw-w-40"
  })));
}

var _templateObject$1V, _templateObject2$L, _templateObject3$C, _templateObject4$s, _templateObject5$n, _templateObject6$h;

var SwiperContainer = styled__default["default"](Swiper)(_templateObject$1V || (_templateObject$1V = _taggedTemplateLiteral(["\n  height: calc(100vh - ", "px);\n\n  @media (max-width: 1024px) {\n    height: calc(100vh - ", "px);\n    .swiper-pagination.swiper-pagination-bullets {\n      bottom: 25px;\n    }\n  }\n\n  .swiper-pagination-bullet-active {\n    background: var(--primary-110-color);\n  }\n"])), function (_ref) {
  var _ref$fullScreen = _ref.fullScreen,
      fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen;
  return fullScreen ? 0 : 77;
}, function (_ref2) {
  var _ref2$fullScreen = _ref2.fullScreen,
      fullScreen = _ref2$fullScreen === void 0 ? false : _ref2$fullScreen;
  return fullScreen ? 0 : 43;
});
var Title$e = styled__default["default"].h3(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 62px;\n  line-height: 70px;\n  margin: 3rem 0 0 0;\n  ", ";\n\n  @media (max-width: ", "px) {\n    padding: 0;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 42px;\n    line-height: 50px;\n    text-align: center;\n  }\n"])), function (_ref3) {
  var _ref3$dark = _ref3.dark,
      dark = _ref3$dark === void 0 ? false : _ref3$dark,
      _ref3$titleColor = _ref3.titleColor,
      titleColor = _ref3$titleColor === void 0 ? null : _ref3$titleColor;
  if (!dark) return "color: ".concat(titleColor);
  return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm;
});
var Description$1 = styled__default["default"].p(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 22px;\n  line-height: 28px;\n  ", "\n"])), function (_ref5) {
  var subTextColor = _ref5.subTextColor;
  return "color: ".concat(subTextColor, ";"); // if (!dark) {
  //   return `
  //     color: ${subTextColor};
  //   `
  // } else {
  //   return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
  // }
});
var Cover = styled__default["default"].div(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  position: relative;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 5;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n  }\n"])), function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsTypes.WHITE : _ref6$color;
  return color;
}, function (_ref7) {
  var _ref7$image = _ref7.image,
      image = _ref7$image === void 0 ? "" : _ref7$image,
      _ref7$gradientType = _ref7.gradientType,
      gradientType = _ref7$gradientType === void 0 ? "" : _ref7$gradientType,
      _ref7$gradient = _ref7.gradient,
      gradient = _ref7$gradient === void 0 ? "" : _ref7$gradient;
  if (gradient) return gradient;
  return BackgroundStyleSelector({
    gradientType: gradientType,
    image: image
  });
});
var Image$1 = styled__default["default"].img(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteral(["\n  min-height: calc(100vh - ", "px);\n  width: 100%;\n  object-fit: cover;\n"])), function (_ref8) {
  var _ref8$fullScreen = _ref8.fullScreen,
      fullScreen = _ref8$fullScreen === void 0 ? false : _ref8$fullScreen;
  return fullScreen ? 0 : 75;
});
SwiperCore.use([EffectFade, Navigation$1, Pagination$1]);

var defaultSettings = function defaultSettings(data) {
  var dataHasItems = Array.isArray(data) && !!data.length;
  return {
    spaceBetween: 5,
    navigation: false,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    pagination: {
      clickable: true,
      dynamicBullets: true
    },
    loop: dataHasItems
  };
};

var Content$2 = styled__default["default"].div(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 0 135px;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100%;\n  display: flex;\n\n  justify-content: ", ";\n\n  align-items: center;\n  z-index: 15;\n\n  @media (max-width: ", "px) {\n    padding: 0 45px;\n  }\n"])), function (_ref9) {
  var _ref9$position = _ref9.position,
      position = _ref9$position === void 0 ? "Left" : _ref9$position;
  if (/left/gi.test(position)) return "flex-start";
  if (/right/gi.test(position)) return "flex-end";
  if (/center/gi.test(position)) return "center";
  return "center";
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.sm;
});

function HeroCarouselCentralFade(_ref11) {
  var _ref11$gradient = _ref11.gradient,
      componentGradient = _ref11$gradient === void 0 ? "" : _ref11$gradient,
      _ref11$data = _ref11.data,
      data = _ref11$data === void 0 ? [] : _ref11$data,
      buttonHoverBackgroundColor = _ref11.buttonHoverBackgroundColor,
      buttonHoverDefaultBorderColor = _ref11.buttonHoverDefaultBorderColor,
      buttonHoverOutlineAndColorBorderColor = _ref11.buttonHoverOutlineAndColorBorderColor,
      grayscaleAndOutlineBorderColor = _ref11.grayscaleAndOutlineBorderColor,
      grayscaleAndOutlineTextColor = _ref11.grayscaleAndOutlineTextColor,
      grayscaleAndFilledBackgroundColor = _ref11.grayscaleAndFilledBackgroundColor,
      hoverGrayscaleFilledTextColor = _ref11.hoverGrayscaleFilledTextColor,
      hoverAndNotOutlineTextColor = _ref11.hoverAndNotOutlineTextColor,
      hoverColor = _ref11.hoverColor,
      hoverGrayscaleFillBackgroundColor = _ref11.hoverGrayscaleFillBackgroundColor,
      hoverGrayscaleBorderColor = _ref11.hoverGrayscaleBorderColor,
      _ref11$buttonWithoutB = _ref11.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref11$buttonWithoutB === void 0 ? false : _ref11$buttonWithoutB,
      _ref11$darkDescriptio = _ref11.darkDescription,
      darkDescription = _ref11$darkDescriptio === void 0 ? false : _ref11$darkDescriptio,
      _ref11$buttonGrayscal = _ref11.buttonGrayscale,
      componentButtonGrayscale = _ref11$buttonGrayscal === void 0 ? false : _ref11$buttonGrayscal,
      _ref11$darkButton = _ref11.darkButton,
      darkButton = _ref11$darkButton === void 0 ? false : _ref11$darkButton,
      _ref11$settings = _ref11.settings,
      settings = _ref11$settings === void 0 ? defaultSettings(data) : _ref11$settings,
      _ref11$buttonFill = _ref11.buttonFill,
      buttonFill = _ref11$buttonFill === void 0 ? buttonFillTypes.NONE : _ref11$buttonFill,
      _ref11$buttonStyleTyp = _ref11.buttonStyleType,
      buttonStyleType = _ref11$buttonStyleTyp === void 0 ? buttonStyleTypes.STANDARD : _ref11$buttonStyleTyp,
      _ref11$transparent = _ref11.transparent,
      transparent = _ref11$transparent === void 0 ? false : _ref11$transparent,
      _ref11$outline = _ref11.outline,
      outline = _ref11$outline === void 0 ? false : _ref11$outline,
      _ref11$darkGrayscaleA = _ref11.darkGrayscaleAndOutlineBorderColor,
      darkGrayscaleAndOutlineBorderColor = _ref11$darkGrayscaleA === void 0 ? false : _ref11$darkGrayscaleA,
      _ref11$titleColor = _ref11.titleColor,
      componentTitleColor = _ref11$titleColor === void 0 ? colorsVariantsTypes.WHITE : _ref11$titleColor,
      _ref11$grayscaleAndOF = _ref11.grayscaleAndOFilledTextColor,
      grayscaleAndOFilledTextColor = _ref11$grayscaleAndOF === void 0 ? colorsTypes.WHITE : _ref11$grayscaleAndOF,
      _ref11$buttonStylesPr = _ref11.buttonStylesProps,
      buttonStylesProps = _ref11$buttonStylesPr === void 0 ? {} : _ref11$buttonStylesPr; // const swiperSettings = {
  //   // ...defaultSettings(data),
  //   // ...settings,
  // };

  return /*#__PURE__*/React__default$1["default"].createElement(SwiperContainer, _extends$g({
    className: "HERO_CAROUSEL_CENTRAL_CONTENT__SWIPER",
    spaceBetween: 30,
    effect: "fade",
    pagination: {
      clickable: true
    },
    slidesPerView: 1,
    loop: true,
    autoplay: true,
    onAutoplayStart: function onAutoplayStart() {},
    onSlideChangeTransitionStart: function onSlideChangeTransitionStart() {}
  }, settings), (data && data.id ? [data] : data || []).map(function (_ref12) {
    var _ref12$image = _ref12.image,
        image = _ref12$image === void 0 ? {} : _ref12$image,
        _ref12$buttonText = _ref12.buttonText,
        buttonText = _ref12$buttonText === void 0 ? "" : _ref12$buttonText,
        _ref12$buttonUrl = _ref12.buttonUrl,
        buttonUrl = _ref12$buttonUrl === void 0 ? "" : _ref12$buttonUrl,
        _ref12$buttonGrayscal = _ref12.buttonGrayscale,
        buttonGrayscale = _ref12$buttonGrayscal === void 0 ? true : _ref12$buttonGrayscal,
        _ref12$buttonTextFont = _ref12.buttonTextFontFamily,
        buttonTextFontFamily = _ref12$buttonTextFont === void 0 ? fontsFamiliesTypes.PRIMARY : _ref12$buttonTextFont,
        _ref12$buttonTextSize = _ref12.buttonTextSize,
        buttonTextSize = _ref12$buttonTextSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref12$buttonTextSize,
        _ref12$buttonFilled = _ref12.buttonFilled,
        buttonFilled = _ref12$buttonFilled === void 0 ? buttonFillTypes.FILLED : _ref12$buttonFilled,
        _ref12$subText = _ref12.subText,
        subText = _ref12$subText === void 0 ? "" : _ref12$subText,
        _ref12$subTextColor = _ref12.subTextColor,
        subTextColor = _ref12$subTextColor === void 0 ? colorsVariantsTypes.WHITE : _ref12$subTextColor,
        _ref12$subTextFontFam = _ref12.subTextFontFamily,
        subTextFontFamily = _ref12$subTextFontFam === void 0 ? fontsFamiliesTypes.PRIMARY : _ref12$subTextFontFam,
        _ref12$subTextSize = _ref12.subTextSize,
        subTextSize = _ref12$subTextSize === void 0 ? textSizesVariantsTypes.VERY_LARGE : _ref12$subTextSize,
        _ref12$text = _ref12.text,
        text = _ref12$text === void 0 ? "" : _ref12$text,
        _ref12$textColor = _ref12.textColor,
        textColor = _ref12$textColor === void 0 ? colorsVariantsTypes.WHITE : _ref12$textColor,
        _ref12$textFontFamily = _ref12.textFontFamily,
        textFontFamily = _ref12$textFontFamily === void 0 ? fontsFamiliesTypes.SECONDARY : _ref12$textFontFamily,
        _ref12$textSize = _ref12.textSize,
        textSize = _ref12$textSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref12$textSize,
        _ref12$cssBackgroundG = _ref12.cssBackgroundGradient,
        gradient = _ref12$cssBackgroundG === void 0 ? "" : _ref12$cssBackgroundG,
        _ref12$gradientType = _ref12.gradientType,
        gradientType = _ref12$gradientType === void 0 ? "Center" : _ref12$gradientType;
    return /*#__PURE__*/React__default$1["default"].createElement(SwiperSlide, {
      key: nanoid(),
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__SWIPER__SLIDE"
    }, /*#__PURE__*/React__default$1["default"].createElement(Cover, {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER",
      image: image,
      gradientType: gradientType,
      gradient: gradient || componentGradient || undefined
    }, /*#__PURE__*/React__default$1["default"].createElement(Image$1, {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__IMAGE",
      fullScreen: true,
      src: image.url,
      alt: (image === null || image === void 0 ? void 0 : image.alternativeText) || ""
    }), /*#__PURE__*/React__default$1["default"].createElement(Content$2, {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT",
      position: gradientType
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__TITLE_BOX tw-w-full tw-text-center sm:tw-container sm:tw-px-12 tw-z-40"
    }, /*#__PURE__*/React__default$1["default"].createElement(Title$e, {
      size: textSize || textSizesVariantsTypes.HEADER_6,
      fontFamily: textFontFamily || fontsFamiliesTypes.SECONDARY,
      color: textColor || componentTitleColor || colorsVariantsTypes.WHITE // {...data[index]}
      ,
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__TITLE Hero__title bl-text-primary bl-font-secondary tw-px-0 tw-font-bold tw-mb-16 sm:tw-mb-10 bl-text-2xl sm:bl-text-3xl"
    }, text), /*#__PURE__*/React__default$1["default"].createElement(Description$1, {
      subTextColor: subTextColor,
      size: subTextSize || textSizesVariantsTypes.VERY_LARGE,
      fontFamily: subTextFontFamily || fontsFamiliesTypes.PRIMARY,
      color: subTextColor || colorsVariantsTypes.WHITE,
      dark: darkDescription // {...data[index]}
      ,
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__DESCRIPTION Hero__subtitle bl-text-lg bl-text-grayscale tw-mb-16 sm:tw-mb-10"
    }, subText), buttonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
      size: buttonTextSize || textSizesVariantsTypes.VERY_SMALL,
      fontFamily: buttonTextFontFamily || fontsFamiliesTypes.PRIMARY,
      fill: buttonFilled || buttonFill,
      grayscale: buttonGrayscale || componentButtonGrayscale,
      grayscaleAndFilledBackgroundColor: grayscaleAndFilledBackgroundColor,
      hoverGrayscaleFillBackgroundColor: hoverGrayscaleFillBackgroundColor,
      hoverGrayscaleBorderColor: hoverGrayscaleBorderColor,
      hoverBorderColor: true,
      withoutBorderRadius: buttonWithoutBorderRadius,
      styleType: buttonStyleType,
      is: "a",
      href: buttonUrl,
      dark: darkButton,
      hoverBackgroundColor: buttonHoverBackgroundColor,
      hoverDefaultBorderColor: buttonHoverDefaultBorderColor,
      hoverOutlineAndColorBorderColor: buttonHoverOutlineAndColorBorderColor,
      transparent: transparent,
      outline: outline,
      darkGrayscaleAndOutlineBorderColor: darkGrayscaleAndOutlineBorderColor,
      grayscaleAndOutlineBorderColor: grayscaleAndOutlineBorderColor,
      grayscaleAndOutlineTextColor: grayscaleAndOutlineTextColor,
      hoverGrayscaleFilledTextColor: hoverGrayscaleFilledTextColor,
      hoverAndNotOutlineTextColor: hoverAndNotOutlineTextColor,
      hoverColor: hoverColor,
      grayscaleAndOFilledTextColor: grayscaleAndOFilledTextColor,
      className: "HERO_CAROUSEL_CENTRAL_CONTENT__COVER__CONTENT__BUTTON"
    }, buttonStylesProps), buttonText)))));
  }));
}

HeroCarouselCentralFade.defaultProps = {
  dark: false
};
HeroCarouselCentralFade.propTypes = {
  data: PropTypes.array.isRequired,
  dark: PropTypes.bool
};
var _excluded$X = ["variant", "customComponentStyles"];

function Hero(_ref) {
  var _customComponentStyle;

  var variant = _ref.variant,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS,
      props = _objectWithoutProperties$1(_ref, _excluded$X);

  if (!props.data) return null;

  switch (variant) {
    case heroVariantsTypes.CENTRAL:
      return /*#__PURE__*/React__default$1["default"].createElement(HeroCentral, _extends$g({}, props, customComponentStyles.hero));

    case heroVariantsTypes.FULL:
      return /*#__PURE__*/React__default$1["default"].createElement(HeroFull, _extends$g({}, props, customComponentStyles.hero));

    case heroVariantsTypes.CAROUSEL:
      return /*#__PURE__*/React__default$1["default"].createElement(HeroCarousel$1, _extends$g({}, props, customComponentStyles.hero));

    case heroVariantsTypes.CAROUSEL_CENTRAL:
      return /*#__PURE__*/React__default$1["default"].createElement(HeroCarousel, _extends$g({}, props, customComponentStyles.hero));

    case heroVariantsTypes.CAROUSEL_CENTRAL_FADE:
      return /*#__PURE__*/React__default$1["default"].createElement(HeroCarouselCentralFade, _extends$g({}, props, customComponentStyles.hero));

    case heroVariantsTypes.DINAMIC:
      return /*#__PURE__*/React__default$1["default"].createElement(HeroDinamic, _extends$g({}, props, (_customComponentStyle = customComponentStyles.hero) === null || _customComponentStyle === void 0 ? void 0 : _customComponentStyle.dinamic));

    default:
      throw new Error("Invalid Hero variant: ".concat(variant));
  }
}

var Hero$1 = withErrorBoundary(Hero);
var _excluded$W = ["data", "customComponentStyles"];

function HeroWithDividers(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$W);

  var heroVariant = data.variant ? data.variant : heroVariantsTypes.FULL;
  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
    variant: dividersVariantsTypes.HERO,
    childrenVariant: heroVariant,
    data: data.Heros || [data],
    customComponentStyles: customComponentStyles
  }, otherProps));
}

function IframeWithDividers(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.IFRAME,
    data: data
  });
}

function IconSelector(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? iconSelectorTypes.NONE : _ref$label,
      customIconsAlt = _ref.customIconsAlt;

  switch (label) {
    case iconSelectorTypes.EMAIL:
      return /*#__PURE__*/React__default$1["default"].createElement(Icon, {
        icon: iconTypes.ENVELOPE,
        className: "ICON tw-mr-3",
        customIconsAlt: customIconsAlt
      });

    case iconSelectorTypes.TELEPHONE_NUMBER:
      return /*#__PURE__*/React__default$1["default"].createElement(Icon, {
        icon: iconTypes.PHONE,
        className: "ICON tw-mr-3",
        customIconsAlt: customIconsAlt
      });

    case iconSelectorTypes.FACEBOOK:
      return /*#__PURE__*/React__default$1["default"].createElement(Icon, {
        icon: iconTypes.FACEBOOK_SIMPLE,
        className: "ICON tw-mr-3",
        customIconsAlt: customIconsAlt
      });

    case iconSelectorTypes.INSTAGRAM:
      return /*#__PURE__*/React__default$1["default"].createElement(Icon, {
        icon: iconTypes.INSTAGRAM,
        className: "ICON tw-mr-3",
        customIconsAlt: customIconsAlt
      });

    case iconSelectorTypes.LINKEDIN:
      return /*#__PURE__*/React__default$1["default"].createElement(Icon, {
        icon: iconTypes.LINKEDIN,
        className: "ICON tw-mr-3",
        customIconsAlt: customIconsAlt
      });

    default:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "ICON tw-w-6 tw-h-6 bl-bg-primary tw-mr-3",
        customIconsAlt: customIconsAlt
      });
  }
}

var _templateObject$1U, _templateObject2$K;

var Rectangle$1 = styled__default["default"].div(_templateObject$1U || (_templateObject$1U = _taggedTemplateLiteral(["\n  width: 110px;\n  height: 4px;\n  background: var(--secondary-color);\n"])));
var Title$d = styled__default["default"].h3(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
});

function MainContact(_ref4) {
  var data = _ref4.data,
      _ref4$customIconsAlt = _ref4.customIconsAlt,
      customIconsAlt = _ref4$customIconsAlt === void 0 ? "" : _ref4$customIconsAlt,
      rectangle = _ref4.rectangle;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_DARK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$socialTextColor = data.socialTextColor,
      socialTextColor = _data$socialTextColor === void 0 ? colorsVariantsTypes.BLACK : _data$socialTextColor,
      _data$socialTextSize = data.socialTextSize,
      socialTextSize = _data$socialTextSize === void 0 ? textSizesVariantsTypes.SMALL : _data$socialTextSize,
      _data$socialTextFontF = data.socialTextFontFamily,
      socialTextFontFamily = _data$socialTextFontF === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$socialTextFontF;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MAIN__CONTACT tw-w-full"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$d, {
    className: "MAIN__CONTACT__TITLE MainContact__title tw-font-bold  tw-mb-5",
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.VERY_BIG,
    color: titleColor || colorsVariantsTypes.PRIMARY_ULTRA_DARK
  }, data.mainContactTitle), rectangle && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-mb-6"
  }, /*#__PURE__*/React__default$1["default"].createElement(Rectangle$1, {
    className: "MAIN__CONTACT__RECTANGLE MainContact_Rectangle"
  })), /*#__PURE__*/React__default$1["default"].createElement("div", null, data.socialMedia.map(function (element, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(MainContactBox, {
      key: "MainContactBox-".concat(index),
      fontFamily: socialTextFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      size: socialTextSize || textSizesVariantsTypes.SMALL,
      color: socialTextColor || colorsVariantsTypes.BLACK,
      label: element.label,
      text: element.value,
      link: element.link,
      customIconsAlt: customIconsAlt
    });
  }), data.Widgets.map(function (element, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(Widget, {
      key: "Widget-".concat(index),
      data: element
    });
  })));
}

var _templateObject$1T;

function MainContactBox(_ref) {
  var label = _ref.label,
      text = _ref.text,
      link = _ref.link,
      color = _ref.color,
      size = _ref.size,
      fontFamily = _ref.fontFamily,
      customIconsAlt = _ref.customIconsAlt;

  var _selectTag = selectTag(link),
      Tag = _selectTag.Tag,
      props = _selectTag.props,
      className = _selectTag.className;

  var Container = styled__default["default"](Tag)(_templateObject$1T || (_templateObject$1T = _taggedTemplateLiteral(["\n    font-family: ", ";\n    color: ", ";\n    font-size: ", ";\n  "])), function (_ref2) {
    var _ref2$ContainerFontFa = _ref2.ContainerFontFamily,
        ContainerFontFamily = _ref2$ContainerFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref2$ContainerFontFa;
    return getFontFamily(fontsFamiliesVariantsTypes[ContainerFontFamily]);
  }, function (_ref3) {
    var _ref3$ContainerColor = _ref3.ContainerColor,
        ContainerColor = _ref3$ContainerColor === void 0 ? colorsVariantsTypes.BLACK : _ref3$ContainerColor;
    return getColors(colorsVariantsTypes[ContainerColor]);
  }, function (_ref4) {
    var _ref4$ContainerSize = _ref4.ContainerSize,
        ContainerSize = _ref4$ContainerSize === void 0 ? textSizesVariantsTypes.SMALL : _ref4$ContainerSize;
    return getTextSize(textSizesVariantsTypes[ContainerSize]);
  });
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MAIN_CONTACT_BOX tw-flex tw-items-center tw-mb-5"
  }, /*#__PURE__*/React__default$1["default"].createElement(IconSelector, {
    label: label,
    customIconsAlt: customIconsAlt
  }), /*#__PURE__*/React__default$1["default"].createElement(Container, _extends$g({}, props, {
    className: classnames("MAIN_CONTACT_BOX__CONTENT bl-text-grayscale", className),
    ContainerColor: color,
    ContainerSize: size,
    ContainerFontFamily: fontFamily
  }), text));
}

var _templateObject$1S;

var Title$c = styled__default["default"].h5(_templateObject$1S || (_templateObject$1S = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref$color,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.SMALL : _ref$size;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[size]), ";\n    margin-bottom: 1rem;\n  ");
});

function MainOffice(_ref2) {
  var data = _ref2.data,
      _ref2$mainOfficeStyle = _ref2.mainOfficeStyles,
      mainOfficeStyles = _ref2$mainOfficeStyle === void 0 ? {} : _ref2$mainOfficeStyle;
  var _data$titleHoursFontF = data.titleHoursFontFamily,
      titleHoursFontFamily = _data$titleHoursFontF === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleHoursFontF,
      _data$titleHoursColor = data.titleHoursColor,
      titleHoursColor = _data$titleHoursColor === void 0 ? colorsVariantsTypes.SECONDARY : _data$titleHoursColor,
      _data$titleHoursSize = data.titleHoursSize,
      titleHoursSize = _data$titleHoursSize === void 0 ? textSizesVariantsTypes.SMALL : _data$titleHoursSize,
      _data$daysSize = data.daysSize,
      daysSize = _data$daysSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$daysSize,
      _data$daysFontFamily = data.daysFontFamily,
      daysFontFamily = _data$daysFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$daysFontFamily,
      _data$daysColor = data.daysColor,
      daysColor = _data$daysColor === void 0 ? colorsVariantsTypes.BLACK : _data$daysColor,
      _data$hoursSize = data.hoursSize,
      hoursSize = _data$hoursSize === void 0 ? textSizesVariantsTypes.SMALL : _data$hoursSize,
      _data$hoursFontFamily = data.hoursFontFamily,
      hoursFontFamily = _data$hoursFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$hoursFontFamily,
      _data$hoursColor = data.hoursColor,
      hoursColor = _data$hoursColor === void 0 ? colorsVariantsTypes.BLACK : _data$hoursColor,
      _data$infoSize = data.infoSize,
      infoSize = _data$infoSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$infoSize,
      _data$infoFontFamily = data.infoFontFamily,
      infoFontFamily = _data$infoFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$infoFontFamily,
      _data$infoColor = data.infoColor,
      infoColor = _data$infoColor === void 0 ? colorsVariantsTypes.LIGHT : _data$infoColor,
      _data$contactSimpleTi = data.contactSimpleTitleSize,
      contactSimpleTitleSize = _data$contactSimpleTi === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$contactSimpleTi,
      _data$contactSimpleTi2 = data.contactSimpleTitleFontFamily,
      contactSimpleTitleFontFamily = _data$contactSimpleTi2 === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$contactSimpleTi2,
      _data$contactSimpleTi3 = data.contactSimpleTitleColor,
      contactSimpleTitleColor = _data$contactSimpleTi3 === void 0 ? colorsVariantsTypes.BLACK : _data$contactSimpleTi3,
      _data$contactSimpleIn = data.contactSimpleInfoSize,
      contactSimpleInfoSize = _data$contactSimpleIn === void 0 ? textSizesVariantsTypes.SMALL : _data$contactSimpleIn,
      _data$contactSimpleIn2 = data.contactSimpleInfoFontFamily,
      contactSimpleInfoFontFamily = _data$contactSimpleIn2 === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$contactSimpleIn2,
      _data$contactSimpleIn3 = data.contactSimpleInfoColor,
      contactSimpleInfoColor = _data$contactSimpleIn3 === void 0 ? colorsVariantsTypes.BLACK : _data$contactSimpleIn3,
      _data$contactSimpleCo = data.contactSimpleContactSize,
      contactSimpleContactSize = _data$contactSimpleCo === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$contactSimpleCo,
      _data$contactSimpleCo2 = data.contactSimpleContactFontFamily,
      contactSimpleContactFontFamily = _data$contactSimpleCo2 === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$contactSimpleCo2,
      _data$contactSimpleCo3 = data.contactSimpleContactColor,
      contactSimpleContactColor = _data$contactSimpleCo3 === void 0 ? colorsVariantsTypes.LIGHT : _data$contactSimpleCo3;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MAIN_OFFICE tw-flex tw-flex-col tw-h-full md:tw-justify-between"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MAIN_OFFICE__TITLE__BOX"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$c, _extends$g({}, mainOfficeStyles.title, {
    className: "MAIN_OFFICE__TITLE tw-font-bold tw-mb-4",
    fontFamily: titleHoursFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: titleHoursSize || textSizesVariantsTypes.SMALL,
    color: titleHoursColor || colorsVariantsTypes.SECONDARY
  }), data.titleHours), data.officeHoursDetails.map(function (item, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(OfficeHourBox, {
      officeHourBoxStyles: mainOfficeStyles.officeHourBoxStyles,
      key: "OfficeHourBox-".concat(index),
      daysSize: daysSize || textSizesVariantsTypes.VERY_SMALL,
      daysFontFamily: daysFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      daysColor: daysColor || colorsVariantsTypes.BLACK,
      hoursSize: hoursSize || textSizesVariantsTypes.SMALL,
      hoursFontFamily: hoursFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      hoursColor: hoursColor || colorsVariantsTypes.BLACK,
      infoSize: infoSize || textSizesVariantsTypes.VERY_SMALL,
      infoFontFamily: infoFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      infoColor: infoColor || colorsVariantsTypes.LIGHT,
      days: item.days,
      hours: item.hours,
      info: item.info
    });
  })), (data === null || data === void 0 ? void 0 : data.contactSimple) && (data === null || data === void 0 ? void 0 : data.contactSimple.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MAIN_OFFICE__CONTACT_SIMPLE__CONTAINER tw-mt-10"
  }, data.contactSimple.map(function (item, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(ContactSimple, {
      contactSimpleStyles: mainOfficeStyles.contactSimpleStyles,
      key: "ContactSimple-".concat(index),
      contactSimpleTitleSize: contactSimpleTitleSize || textSizesVariantsTypes.VERY_SMALL,
      contactSimpleTitleFontFamily: contactSimpleTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      contactSimpleTitleColor: contactSimpleTitleColor || colorsVariantsTypes.BLACK,
      contactSimpleInfoSize: contactSimpleInfoSize || textSizesVariantsTypes.SMALL,
      contactSimpleInfoFontFamily: contactSimpleInfoFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      contactSimpleInfoColor: contactSimpleInfoColor || colorsVariantsTypes.BLACK,
      contactSimpleContactSize: contactSimpleContactSize || textSizesVariantsTypes.VERY_SMALL,
      contactSimpleContactFontFamily: contactSimpleContactFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      contactSimpleContactColor: contactSimpleContactColor || colorsVariantsTypes.LIGHT,
      title: item.title,
      info: item.info,
      contact: item.contact
    });
  })));
}

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
}; // utils is a library of generic helper functions non-specific to axios


var toString$1 = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */

function isArray$3(val) {
  return toString$1.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer$3(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


function isArrayBuffer(val) {
  return toString$1.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */


function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString$2(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject$2(val) {
  return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */


function isPlainObject$1(val) {
  if (toString$1.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


function isDate$1(val) {
  return toString$1.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */


function isFile(val) {
  return toString$1.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */


function isBlob(val) {
  return toString$1.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */


function isFunction$3(val) {
  return toString$1.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject$2(val) && isFunction$3(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */


function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$3(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
merge() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge({}, val);
    } else if (isArray$3(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */


function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
}

var utils$2 = {
  isArray: isArray$3,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$3,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$2,
  isNumber: isNumber,
  isObject: isObject$2,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$3,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$2.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$2.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$2.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$2.forEach(val, function parseValue(v) {
        if (utils$2.isDate(v)) {
          v = v.toISOString();
        } else if (utils$2.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager.prototype.forEach = function forEach(fn) {
  utils$2.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$2.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */


var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };

  return error;
};
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */


var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */


var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies = utils$2.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils$2.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils$2.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils$2.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */


var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */


var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
}; // Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers


var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils$2.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$2.trim(line.substr(0, i)).toLowerCase();
    val = utils$2.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin = utils$2.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils$2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils$2.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response); // Clean up request

      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        } // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        } // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'


        setTimeout(onloadend);
      };
    } // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils$2.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils$2.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils$2.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel); // Clean up request

        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    } // Send the request


    request.send(requestData);
  });
};
/**
 * Helpers.
 */


var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function ms(val, options) {
  options = options || {};
  var type = typeof val;

  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;

    case 'weeks':
    case 'week':
    case 'w':
      return n * w;

    case 'days':
    case 'day':
    case 'd':
      return n * d;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }

  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }

  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }

  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }

  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }

  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }

  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }

  return ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */


function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = ms;
  createDebug.destroy = destroy;
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;
    var enableOverride = null;
    var namespacesCache;
    var enabledCache;

    function debug() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      // Disabled?
      if (!debug.enabled) {
        return;
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return '%';
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.useColors = createDebug.useColors();
    debug.color = createDebug.selectColor(namespace);
    debug.extend = extend;
    debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

    Object.defineProperty(debug, 'enabled', {
      enumerable: true,
      configurable: false,
      get: function get() {
        if (enableOverride !== null) {
          return enableOverride;
        }

        if (namespacesCache !== createDebug.namespaces) {
          namespacesCache = createDebug.namespaces;
          enabledCache = createDebug.enabled(namespace);
        }

        return enabledCache;
      },
      set: function set(v) {
        enableOverride = v;
      }
    }); // Env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    return debug;
  }

  function extend(namespace, delimiter) {
    var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
    newDebug.log = this.log;
    return newDebug;
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.namespaces = namespaces;
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }
  }
  /**
  * Disable debug output.
  *
  * @return {String} namespaces
  * @api public
  */


  function disable() {
    var namespaces = [].concat(_toConsumableArray2(createDebug.names.map(toNamespace)), _toConsumableArray2(createDebug.skips.map(toNamespace).map(function (namespace) {
      return '-' + namespace;
    }))).join(',');
    createDebug.enable('');
    return namespaces;
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Convert regexp to namespace
  *
  * @param {RegExp} regxep
  * @return {String} namespace
  * @api private
  */


  function toNamespace(regexp) {
    return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }
  /**
  * XXX DO NOT USE. This is a temporary stub function.
  * XXX It WILL be removed in the next major release.
  */


  function destroy() {
    console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

var common = setup;
/* eslint-env browser */

var browser$1 = createCommonjsModule(function (module, exports) {
  /**
   * This is the web browser implementation of `debug()`.
   */
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = localstorage();

  exports.destroy = function () {
    var warned = false;
    return function () {
      if (!warned) {
        warned = true;
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
      }
    };
  }();
  /**
   * Colors.
   */


  exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
  /**
   * Currently only WebKit-based Web Inspectors, Firefox >= v31,
   * and the Firebug extension (any Firefox version) are known
   * to support "%c" CSS customizations.
   *
   * TODO: add a `localStorage` variable to explicitly enable/disable colors
   */
  // eslint-disable-next-line complexity

  function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
      return true;
    } // Internet Explorer and Edge do not support colors.


    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    } // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  /**
   * Colorize log arguments if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

    if (!this.useColors) {
      return;
    }

    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into

    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function (match) {
      if (match === '%%') {
        return;
      }

      index++;

      if (match === '%c') {
        // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
      }
    });
    args.splice(lastC, 0, c);
  }
  /**
   * Invokes `console.debug()` when available.
   * No-op when `console.debug` is not a "function".
   * If `console.debug` is not available, falls back
   * to `console.log`.
   *
   * @api public
   */


  exports.log = console.debug || console.log || function () {};
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    try {
      if (namespaces) {
        exports.storage.setItem('debug', namespaces);
      } else {
        exports.storage.removeItem('debug');
      }
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    var r;

    try {
      r = exports.storage.getItem('debug');
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    } // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


    if (!r && typeof process !== 'undefined' && 'env' in process) {
      r = process.env.DEBUG;
    }

    return r;
  }
  /**
   * Localstorage attempts to return the localstorage.
   *
   * This is necessary because safari throws
   * when a user disables cookies/localstorage
   * and you attempt to access it.
   *
   * @return {LocalStorage}
   * @api private
   */


  function localstorage() {
    try {
      // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
      // The Browser also has localStorage in the global context.
      return localStorage;
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
   */

  formatters.j = function (v) {
    try {
      return JSON.stringify(v);
    } catch (error) {
      return '[UnexpectedJSONParseError]: ' + error.message;
    }
  };
});

var hasFlag = function hasFlag(flag, argv) {
  argv = argv || process.argv;
  var prefix = flag.startsWith('-') ? '' : flag.length === 1 ? '-' : '--';
  var pos = argv.indexOf(prefix + flag);
  var terminatorPos = argv.indexOf('--');
  return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

var env = process.env;
var forceColor;

if (hasFlag('no-color') || hasFlag('no-colors') || hasFlag('color=false')) {
  forceColor = false;
} else if (hasFlag('color') || hasFlag('colors') || hasFlag('color=true') || hasFlag('color=always')) {
  forceColor = true;
}

if ('FORCE_COLOR' in env) {
  forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
  if (level === 0) {
    return false;
  }

  return {
    level: level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3
  };
}

function supportsColor(stream) {
  if (forceColor === false) {
    return 0;
  }

  if (hasFlag('color=16m') || hasFlag('color=full') || hasFlag('color=truecolor')) {
    return 3;
  }

  if (hasFlag('color=256')) {
    return 2;
  }

  if (stream && !stream.isTTY && forceColor !== true) {
    return 0;
  }

  var min = forceColor ? 1 : 0;

  if (process.platform === 'win32') {
    // Node.js 7.5.0 is the first version of Node.js to include a patch to
    // libuv that enables 256 color output on Windows. Anything earlier and it
    // won't work. However, here we target Node.js 8 at minimum as it is an LTS
    // release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
    // release that supports 256 colors. Windows 10 build 14931 is the first release
    // that supports 16m/TrueColor.
    var osRelease = os__default["default"].release().split('.');

    if (Number(process.versions.node.split('.')[0]) >= 8 && Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
      return Number(osRelease[2]) >= 14931 ? 3 : 2;
    }

    return 1;
  }

  if ('CI' in env) {
    if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(function (sign) {
      return sign in env;
    }) || env.CI_NAME === 'codeship') {
      return 1;
    }

    return min;
  }

  if ('TEAMCITY_VERSION' in env) {
    return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
  }

  if (env.COLORTERM === 'truecolor') {
    return 3;
  }

  if ('TERM_PROGRAM' in env) {
    var _version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

    switch (env.TERM_PROGRAM) {
      case 'iTerm.app':
        return _version >= 3 ? 3 : 2;

      case 'Apple_Terminal':
        return 2;
      // No default
    }
  }

  if (/-256(color)?$/i.test(env.TERM)) {
    return 2;
  }

  if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
    return 1;
  }

  if ('COLORTERM' in env) {
    return 1;
  }

  if (env.TERM === 'dumb') {
    return min;
  }

  return min;
}

function getSupportLevel(stream) {
  var level = supportsColor(stream);
  return translateLevel(level);
}

var supportsColor_1 = {
  supportsColor: getSupportLevel,
  stdout: getSupportLevel(process.stdout),
  stderr: getSupportLevel(process.stderr)
};
/**
 * Module dependencies.
 */

var node = createCommonjsModule(function (module, exports) {
  /**
   * This is the Node.js implementation of `debug()`.
   */
  exports.init = init;
  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.destroy = util__default["default"].deprecate(function () {}, 'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
  /**
   * Colors.
   */

  exports.colors = [6, 2, 3, 4, 5, 1];

  try {
    // Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
    // eslint-disable-next-line import/no-extraneous-dependencies
    var _supportsColor = supportsColor_1;

    if (_supportsColor && (_supportsColor.stderr || _supportsColor).level >= 2) {
      exports.colors = [20, 21, 26, 27, 32, 33, 38, 39, 40, 41, 42, 43, 44, 45, 56, 57, 62, 63, 68, 69, 74, 75, 76, 77, 78, 79, 80, 81, 92, 93, 98, 99, 112, 113, 128, 129, 134, 135, 148, 149, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 178, 179, 184, 185, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 214, 215, 220, 221];
    }
  } catch (error) {// Swallow - we only care if `supports-color` is available; it doesn't have to be.
  }
  /**
   * Build up the default `inspectOpts` object from the environment variables.
   *
   *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
   */


  exports.inspectOpts = Object.keys(process.env).filter(function (key) {
    return /^debug_/i.test(key);
  }).reduce(function (obj, key) {
    // Camel-case
    var prop = key.substring(6).toLowerCase().replace(/_([a-z])/g, function (_, k) {
      return k.toUpperCase();
    }); // Coerce string value into JS value

    var val = process.env[key];

    if (/^(yes|on|true|enabled)$/i.test(val)) {
      val = true;
    } else if (/^(no|off|false|disabled)$/i.test(val)) {
      val = false;
    } else if (val === 'null') {
      val = null;
    } else {
      val = Number(val);
    }

    obj[prop] = val;
    return obj;
  }, {});
  /**
   * Is stdout a TTY? Colored output is enabled when `true`.
   */

  function useColors() {
    return 'colors' in exports.inspectOpts ? Boolean(exports.inspectOpts.colors) : tty__default["default"].isatty(process.stderr.fd);
  }
  /**
   * Adds ANSI color escape codes if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    var name = this.namespace,
        useColors = this.useColors;

    if (useColors) {
      var _c4 = this.color;
      var colorCode = "\x1B[3" + (_c4 < 8 ? _c4 : '8;5;' + _c4);
      var prefix = "  ".concat(colorCode, ";1m").concat(name, " \x1B[0m");
      args[0] = prefix + args[0].split('\n').join('\n' + prefix);
      args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + "\x1B[0m");
    } else {
      args[0] = getDate() + name + ' ' + args[0];
    }
  }

  function getDate() {
    if (exports.inspectOpts.hideDate) {
      return '';
    }

    return new Date().toISOString() + ' ';
  }
  /**
   * Invokes `util.format()` with the specified arguments and writes to stderr.
   */


  function log() {
    var _util__default$defaul;

    return process.stderr.write((_util__default$defaul = util__default["default"]).format.apply(_util__default$defaul, arguments) + '\n');
  }
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    if (namespaces) {
      process.env.DEBUG = namespaces;
    } else {
      // If you set a process.env field to null or undefined, it gets cast to the
      // string 'null' or 'undefined'. Just delete instead.
      delete process.env.DEBUG;
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    return process.env.DEBUG;
  }
  /**
   * Init logic for `debug` instances.
   *
   * Create a new `inspectOpts` object in case `useColors` is set
   * differently for a particular `debug` instance.
   */


  function init(debug) {
    debug.inspectOpts = {};
    var keys = Object.keys(exports.inspectOpts);

    for (var i = 0; i < keys.length; i++) {
      debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %o to `util.inspect()`, all on a single line.
   */

  formatters.o = function (v) {
    this.inspectOpts.colors = this.useColors;
    return util__default["default"].inspect(v, this.inspectOpts).split('\n').map(function (str) {
      return str.trim();
    }).join(' ');
  };
  /**
   * Map %O to `util.inspect()`, allowing multiple lines if needed.
   */


  formatters.O = function (v) {
    this.inspectOpts.colors = this.useColors;
    return util__default["default"].inspect(v, this.inspectOpts);
  };
});
/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

var src = createCommonjsModule(function (module) {
  if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
    module.exports = browser$1;
  } else {
    module.exports = node;
  }
});
var debug;

var debug_1 = function debug_1() {
  if (!debug) {
    try {
      /* eslint global-require: off */
      debug = src("follow-redirects");
    } catch (error) {
      /* */
    }

    if (typeof debug !== "function") {
      debug = function debug() {
        /* */
      };
    }
  }

  debug.apply(null, arguments);
};

var URL$1 = url__default["default"].URL;
var Writable = require$$0__default["default"].Writable; // Create handlers that pass events from native requests

var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
var eventHandlers = Object.create(null);
events.forEach(function (event) {
  eventHandlers[event] = function (arg1, arg2, arg3) {
    this._redirectable.emit(event, arg1, arg2, arg3);
  };
});
var InvalidUrlError = createErrorType("ERR_INVALID_URL", "Invalid URL", TypeError); // Error types with codes

var RedirectionError = createErrorType("ERR_FR_REDIRECTION_FAILURE", "Redirected request failed");
var TooManyRedirectsError = createErrorType("ERR_FR_TOO_MANY_REDIRECTS", "Maximum number of redirects exceeded");
var MaxBodyLengthExceededError = createErrorType("ERR_FR_MAX_BODY_LENGTH_EXCEEDED", "Request body larger than maxBodyLength limit");
var WriteAfterEndError = createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end"); // An HTTP(S) request that can be redirected

function RedirectableRequest(options, responseCallback) {
  // Initialize the request
  Writable.call(this);

  this._sanitizeOptions(options);

  this._options = options;
  this._ended = false;
  this._ending = false;
  this._redirectCount = 0;
  this._redirects = [];
  this._requestBodyLength = 0;
  this._requestBodyBuffers = []; // Attach a callback if passed

  if (responseCallback) {
    this.on("response", responseCallback);
  } // React to responses of native requests


  var self = this;

  this._onNativeResponse = function (response) {
    self._processResponse(response);
  }; // Perform the first request


  this._performRequest();
}

RedirectableRequest.prototype = Object.create(Writable.prototype);

RedirectableRequest.prototype.abort = function () {
  abortRequest(this._currentRequest);
  this.emit("abort");
}; // Writes buffered data to the current native request


RedirectableRequest.prototype.write = function (data, encoding, callback) {
  // Writing is not allowed if end has been called
  if (this._ending) {
    throw new WriteAfterEndError();
  } // Validate input and shift parameters if necessary


  if (!isString$1(data) && !isBuffer$2(data)) {
    throw new TypeError("data should be a string, Buffer or Uint8Array");
  }

  if (isFunction$2(encoding)) {
    callback = encoding;
    encoding = null;
  } // Ignore empty buffers, since writing them doesn't invoke the callback
  // https://github.com/nodejs/node/issues/22066


  if (data.length === 0) {
    if (callback) {
      callback();
    }

    return;
  } // Only write when we don't exceed the maximum body length


  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
    this._requestBodyLength += data.length;

    this._requestBodyBuffers.push({
      data: data,
      encoding: encoding
    });

    this._currentRequest.write(data, encoding, callback);
  } // Error when we exceed the maximum body length
  else {
    this.emit("error", new MaxBodyLengthExceededError());
    this.abort();
  }
}; // Ends the current native request


RedirectableRequest.prototype.end = function (data, encoding, callback) {
  // Shift parameters if necessary
  if (isFunction$2(data)) {
    callback = data;
    data = encoding = null;
  } else if (isFunction$2(encoding)) {
    callback = encoding;
    encoding = null;
  } // Write data if needed and end


  if (!data) {
    this._ended = this._ending = true;

    this._currentRequest.end(null, null, callback);
  } else {
    var self = this;
    var currentRequest = this._currentRequest;
    this.write(data, encoding, function () {
      self._ended = true;
      currentRequest.end(null, null, callback);
    });
    this._ending = true;
  }
}; // Sets a header value on the current native request


RedirectableRequest.prototype.setHeader = function (name, value) {
  this._options.headers[name] = value;

  this._currentRequest.setHeader(name, value);
}; // Clears a header value on the current native request


RedirectableRequest.prototype.removeHeader = function (name) {
  delete this._options.headers[name];

  this._currentRequest.removeHeader(name);
}; // Global timeout for all underlying requests


RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
  var self = this; // Destroys the socket on timeout

  function destroyOnTimeout(socket) {
    socket.setTimeout(msecs);
    socket.removeListener("timeout", socket.destroy);
    socket.addListener("timeout", socket.destroy);
  } // Sets up a timer to trigger a timeout event


  function startTimer(socket) {
    if (self._timeout) {
      clearTimeout(self._timeout);
    }

    self._timeout = setTimeout(function () {
      self.emit("timeout");
      clearTimer();
    }, msecs);
    destroyOnTimeout(socket);
  } // Stops a timeout from triggering


  function clearTimer() {
    // Clear the timeout
    if (self._timeout) {
      clearTimeout(self._timeout);
      self._timeout = null;
    } // Clean up all attached listeners


    self.removeListener("abort", clearTimer);
    self.removeListener("error", clearTimer);
    self.removeListener("response", clearTimer);

    if (callback) {
      self.removeListener("timeout", callback);
    }

    if (!self.socket) {
      self._currentRequest.removeListener("socket", startTimer);
    }
  } // Attach callback if passed


  if (callback) {
    this.on("timeout", callback);
  } // Start the timer if or when the socket is opened


  if (this.socket) {
    startTimer(this.socket);
  } else {
    this._currentRequest.once("socket", startTimer);
  } // Clean up on events


  this.on("socket", destroyOnTimeout);
  this.on("abort", clearTimer);
  this.on("error", clearTimer);
  this.on("response", clearTimer);
  return this;
}; // Proxy all other public ClientRequest methods


["flushHeaders", "getHeader", "setNoDelay", "setSocketKeepAlive"].forEach(function (method) {
  RedirectableRequest.prototype[method] = function (a, b) {
    return this._currentRequest[method](a, b);
  };
}); // Proxy all public ClientRequest properties

["aborted", "connection", "socket"].forEach(function (property) {
  Object.defineProperty(RedirectableRequest.prototype, property, {
    get: function get() {
      return this._currentRequest[property];
    }
  });
});

RedirectableRequest.prototype._sanitizeOptions = function (options) {
  // Ensure headers are always present
  if (!options.headers) {
    options.headers = {};
  } // Since http.request treats host as an alias of hostname,
  // but the url module interprets host as hostname plus port,
  // eliminate the host property to avoid confusion.


  if (options.host) {
    // Use hostname if set, because it has precedence
    if (!options.hostname) {
      options.hostname = options.host;
    }

    delete options.host;
  } // Complete the URL object when necessary


  if (!options.pathname && options.path) {
    var searchPos = options.path.indexOf("?");

    if (searchPos < 0) {
      options.pathname = options.path;
    } else {
      options.pathname = options.path.substring(0, searchPos);
      options.search = options.path.substring(searchPos);
    }
  }
}; // Executes the next native request (initial or redirect)


RedirectableRequest.prototype._performRequest = function () {
  // Load the native protocol
  var protocol = this._options.protocol;
  var nativeProtocol = this._options.nativeProtocols[protocol];

  if (!nativeProtocol) {
    this.emit("error", new TypeError("Unsupported protocol " + protocol));
    return;
  } // If specified, use the agent corresponding to the protocol
  // (HTTP and HTTPS use different types of agents)


  if (this._options.agents) {
    var scheme = protocol.slice(0, -1);
    this._options.agent = this._options.agents[scheme];
  } // Create the native request and set up its event handlers


  var request = this._currentRequest = nativeProtocol.request(this._options, this._onNativeResponse);
  request._redirectable = this;

  var _iterator9 = _createForOfIteratorHelper2(events),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var event = _step9.value;
      request.on(event, eventHandlers[event]);
    } // RFC7230§5.3.1: When making a request directly to an origin server, […]
    // a client MUST send only the absolute path […] as the request-target.

  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  this._currentUrl = /^\//.test(this._options.path) ? url__default["default"].format(this._options) : // When making a request to a proxy, […]
  // a client MUST send the target URI in absolute-form […].
  this._options.path; // End a redirected request
  // (The first request must be ended explicitly with RedirectableRequest#end)

  if (this._isRedirect) {
    // Write the request entity and end
    var i = 0;
    var self = this;
    var buffers = this._requestBodyBuffers;

    (function writeNext(error) {
      // Only write if this request has not been redirected yet

      /* istanbul ignore else */
      if (request === self._currentRequest) {
        // Report any write errors

        /* istanbul ignore if */
        if (error) {
          self.emit("error", error);
        } // Write the next buffer if there are still left
        else if (i < buffers.length) {
          var buffer = buffers[i++];
          /* istanbul ignore else */

          if (!request.finished) {
            request.write(buffer.data, buffer.encoding, writeNext);
          }
        } // End the request if `end` has been called on us
        else if (self._ended) {
          request.end();
        }
      }
    })();
  }
}; // Processes a response from the current native request


RedirectableRequest.prototype._processResponse = function (response) {
  // Store the redirected response
  var statusCode = response.statusCode;

  if (this._options.trackRedirects) {
    this._redirects.push({
      url: this._currentUrl,
      headers: response.headers,
      statusCode: statusCode
    });
  } // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
  // that further action needs to be taken by the user agent in order to
  // fulfill the request. If a Location header field is provided,
  // the user agent MAY automatically redirect its request to the URI
  // referenced by the Location field value,
  // even if the specific status code is not understood.
  // If the response is not a redirect; return it as-is


  var location = response.headers.location;

  if (!location || this._options.followRedirects === false || statusCode < 300 || statusCode >= 400) {
    response.responseUrl = this._currentUrl;
    response.redirects = this._redirects;
    this.emit("response", response); // Clean up

    this._requestBodyBuffers = [];
    return;
  } // The response is a redirect, so abort the current request


  abortRequest(this._currentRequest); // Discard the remainder of the response to avoid waiting for data

  response.destroy(); // RFC7231§6.4: A client SHOULD detect and intervene
  // in cyclical redirections (i.e., "infinite" redirection loops).

  if (++this._redirectCount > this._options.maxRedirects) {
    this.emit("error", new TooManyRedirectsError());
    return;
  } // Store the request headers if applicable


  var requestHeaders;
  var beforeRedirect = this._options.beforeRedirect;

  if (beforeRedirect) {
    requestHeaders = Object.assign({
      // The Host header was set by nativeProtocol.request
      Host: response.req.getHeader("host")
    }, this._options.headers);
  } // RFC7231§6.4: Automatic redirection needs to done with
  // care for methods not known to be safe, […]
  // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
  // the request method from POST to GET for the subsequent request.


  var method = this._options.method;

  if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" || // RFC7231§6.4.4: The 303 (See Other) status code indicates that
  // the server is redirecting the user agent to a different resource […]
  // A user agent can perform a retrieval request targeting that URI
  // (a GET or HEAD request if using HTTP) […]
  statusCode === 303 && !/^(?:GET|HEAD)$/.test(this._options.method)) {
    this._options.method = "GET"; // Drop a possible entity and headers related to it

    this._requestBodyBuffers = [];
    removeMatchingHeaders(/^content-/i, this._options.headers);
  } // Drop the Host header, as the redirect might lead to a different host


  var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers); // If the redirect is relative, carry over the host of the last request

  var currentUrlParts = url__default["default"].parse(this._currentUrl);
  var currentHost = currentHostHeader || currentUrlParts.host;
  var currentUrl = /^\w+:/.test(location) ? this._currentUrl : url__default["default"].format(Object.assign(currentUrlParts, {
    host: currentHost
  })); // Determine the URL of the redirection

  var redirectUrl;

  try {
    redirectUrl = url__default["default"].resolve(currentUrl, location);
  } catch (cause) {
    this.emit("error", new RedirectionError({
      cause: cause
    }));
    return;
  } // Create the redirected request


  debug_1("redirecting to", redirectUrl);
  this._isRedirect = true;
  var redirectUrlParts = url__default["default"].parse(redirectUrl);
  Object.assign(this._options, redirectUrlParts); // Drop confidential headers when redirecting to a less secure protocol
  // or to a different domain that is not a superdomain

  if (redirectUrlParts.protocol !== currentUrlParts.protocol && redirectUrlParts.protocol !== "https:" || redirectUrlParts.host !== currentHost && !isSubdomain(redirectUrlParts.host, currentHost)) {
    removeMatchingHeaders(/^(?:authorization|cookie)$/i, this._options.headers);
  } // Evaluate the beforeRedirect callback


  if (isFunction$2(beforeRedirect)) {
    var responseDetails = {
      headers: response.headers,
      statusCode: statusCode
    };
    var requestDetails = {
      url: currentUrl,
      method: method,
      headers: requestHeaders
    };

    try {
      beforeRedirect(this._options, responseDetails, requestDetails);
    } catch (err) {
      this.emit("error", err);
      return;
    }

    this._sanitizeOptions(this._options);
  } // Perform the redirected request


  try {
    this._performRequest();
  } catch (cause) {
    this.emit("error", new RedirectionError({
      cause: cause
    }));
  }
}; // Wraps the key/value object of protocols with redirect functionality


function wrap(protocols) {
  // Default settings
  var exports = {
    maxRedirects: 21,
    maxBodyLength: 10 * 1024 * 1024
  }; // Wrap each protocol

  var nativeProtocols = {};
  Object.keys(protocols).forEach(function (scheme) {
    var protocol = scheme + ":";
    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol); // Executes a request, following redirects

    function request(input, options, callback) {
      // Parse parameters
      if (isString$1(input)) {
        var parsed;

        try {
          parsed = urlToOptions(new URL$1(input));
        } catch (err) {
          /* istanbul ignore next */
          parsed = url__default["default"].parse(input);
        }

        if (!isString$1(parsed.protocol)) {
          throw new InvalidUrlError({
            input: input
          });
        }

        input = parsed;
      } else if (URL$1 && input instanceof URL$1) {
        input = urlToOptions(input);
      } else {
        callback = options;
        options = input;
        input = {
          protocol: protocol
        };
      }

      if (isFunction$2(options)) {
        callback = options;
        options = null;
      } // Set defaults


      options = Object.assign({
        maxRedirects: exports.maxRedirects,
        maxBodyLength: exports.maxBodyLength
      }, input, options);
      options.nativeProtocols = nativeProtocols;

      if (!isString$1(options.host) && !isString$1(options.hostname)) {
        options.hostname = "::1";
      }

      assert__default["default"].equal(options.protocol, protocol, "protocol mismatch");
      debug_1("options", options);
      return new RedirectableRequest(options, callback);
    } // Executes a GET request, following redirects


    function get(input, options, callback) {
      var wrappedRequest = wrappedProtocol.request(input, options, callback);
      wrappedRequest.end();
      return wrappedRequest;
    } // Expose the properties on the wrapped protocol


    Object.defineProperties(wrappedProtocol, {
      request: {
        value: request,
        configurable: true,
        enumerable: true,
        writable: true
      },
      get: {
        value: get,
        configurable: true,
        enumerable: true,
        writable: true
      }
    });
  });
  return exports;
}
/* istanbul ignore next */


function noop() {
  /* empty */
} // from https://github.com/nodejs/node/blob/master/lib/internal/url.js


function urlToOptions(urlObject) {
  var options = {
    protocol: urlObject.protocol,
    hostname: urlObject.hostname.startsWith("[") ?
    /* istanbul ignore next */
    urlObject.hostname.slice(1, -1) : urlObject.hostname,
    hash: urlObject.hash,
    search: urlObject.search,
    pathname: urlObject.pathname,
    path: urlObject.pathname + urlObject.search,
    href: urlObject.href
  };

  if (urlObject.port !== "") {
    options.port = Number(urlObject.port);
  }

  return options;
}

function removeMatchingHeaders(regex, headers) {
  var lastValue;

  for (var header in headers) {
    if (regex.test(header)) {
      lastValue = headers[header];
      delete headers[header];
    }
  }

  return lastValue === null || typeof lastValue === "undefined" ? undefined : String(lastValue).trim();
}

function createErrorType(code, message, baseClass) {
  // Create constructor
  function CustomError(properties) {
    Error.captureStackTrace(this, this.constructor);
    Object.assign(this, properties || {});
    this.code = code;
    this.message = this.cause ? message + ": " + this.cause.message : message;
  } // Attach constructor and set default properties


  CustomError.prototype = new (baseClass || Error)();
  CustomError.prototype.constructor = CustomError;
  CustomError.prototype.name = "Error [" + code + "]";
  return CustomError;
}

function abortRequest(request) {
  var _iterator10 = _createForOfIteratorHelper2(events),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var event = _step10.value;
      request.removeListener(event, eventHandlers[event]);
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  request.on("error", noop);
  request.abort();
}

function isSubdomain(subdomain, domain) {
  assert__default["default"](isString$1(subdomain) && isString$1(domain));
  var dot = subdomain.length - domain.length - 1;
  return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
}

function isString$1(value) {
  return typeof value === "string" || value instanceof String;
}

function isFunction$2(value) {
  return typeof value === "function";
}

function isBuffer$2(value) {
  return typeof value === "object" && "length" in value;
} // Exports


var followRedirects = wrap({
  http: http__default["default"],
  https: https__default["default"]
});
var wrap_1 = wrap;
followRedirects.wrap = wrap_1;
var _from = "axios@^0.21.1";
var _id = "axios@0.21.4";
var _inBundle = false;
var _integrity = "sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==";
var _location = "/axios";
var _phantomChildren = {};
var _requested = {
  type: "range",
  registry: true,
  raw: "axios@^0.21.1",
  name: "axios",
  escapedName: "axios",
  rawSpec: "^0.21.1",
  saveSpec: null,
  fetchSpec: "^0.21.1"
};
var _requiredBy = ["/"];
var _resolved = "https://registry.npmjs.org/axios/-/axios-0.21.4.tgz";
var _shasum = "c67b90dc0568e5c1cf2b0b858c43ba28e2eda575";
var _spec = "axios@^0.21.1";
var _where = "/home/runner/work/BlossomWebsitesCorePackage/BlossomWebsitesCorePackage";
var author = {
  name: "Matt Zabriskie"
};
var browser = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
};
var bugs = {
  url: "https://github.com/axios/axios/issues"
};
var bundleDependencies = false;
var bundlesize = [{
  path: "./dist/axios.min.js",
  threshold: "5kB"
}];
var dependencies = {
  "follow-redirects": "^1.14.0"
};
var deprecated = false;
var description = "Promise based HTTP client for the browser and node.js";
var devDependencies = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
};
var homepage = "https://axios-http.com";
var jsdelivr = "dist/axios.min.js";
var keywords = ["xhr", "http", "ajax", "promise", "node"];
var license = "MIT";
var main = "index.js";
var name = "axios";
var repository = {
  type: "git",
  url: "git+https://github.com/axios/axios.git"
};
var scripts = {
  build: "NODE_ENV=production grunt build",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  examples: "node ./examples/server.js",
  fix: "eslint --fix lib/**/*.js",
  postversion: "git push && git push --tags",
  preversion: "npm test",
  start: "node ./sandbox/server.js",
  test: "grunt test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"
};
var typings = "./index.d.ts";
var unpkg = "dist/axios.min.js";
var version = "0.21.4";
var pkg = {
  _from: _from,
  _id: _id,
  _inBundle: _inBundle,
  _integrity: _integrity,
  _location: _location,
  _phantomChildren: _phantomChildren,
  _requested: _requested,
  _requiredBy: _requiredBy,
  _resolved: _resolved,
  _shasum: _shasum,
  _spec: _spec,
  _where: _where,
  author: author,
  browser: browser,
  bugs: bugs,
  bundleDependencies: bundleDependencies,
  bundlesize: bundlesize,
  dependencies: dependencies,
  deprecated: deprecated,
  description: description,
  devDependencies: devDependencies,
  homepage: homepage,
  jsdelivr: jsdelivr,
  keywords: keywords,
  license: license,
  main: main,
  name: name,
  repository: repository,
  scripts: scripts,
  typings: typings,
  unpkg: unpkg,
  version: version
};
var httpFollow = followRedirects.http;
var httpsFollow = followRedirects.https;
var isHttps = /https:?/;
/**
 *
 * @param {http.ClientRequestArgs} options
 * @param {AxiosProxyConfig} proxy
 * @param {string} location
 */

function setProxy(options, proxy, location) {
  options.hostname = proxy.host;
  options.host = proxy.host;
  options.port = proxy.port;
  options.path = location; // Basic proxy authorization

  if (proxy.auth) {
    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
  } // If a proxy is used, any redirects must also pass through the proxy


  options.beforeRedirect = function beforeRedirect(redirection) {
    redirection.headers.host = redirection.host;
    setProxy(redirection, proxy, redirection.href);
  };
}
/*eslint consistent-return:0*/


var http_1 = function httpAdapter(config) {
  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
    var resolve = function resolve(value) {
      resolvePromise(value);
    };

    var reject = function reject(value) {
      rejectPromise(value);
    };

    var data = config.data;
    var headers = config.headers; // Set User-Agent (required by some servers)
    // See https://github.com/axios/axios/issues/69

    if ('User-Agent' in headers || 'user-agent' in headers) {
      // User-Agent is specified; handle case where no UA header is desired
      if (!headers['User-Agent'] && !headers['user-agent']) {
        delete headers['User-Agent'];
        delete headers['user-agent'];
      } // Otherwise, use specified value

    } else {
      // Only set header if it hasn't been set in config
      headers['User-Agent'] = 'axios/' + pkg.version;
    }

    if (data && !utils$2.isStream(data)) {
      if (Buffer.isBuffer(data)) ;else if (utils$2.isArrayBuffer(data)) {
        data = Buffer.from(new Uint8Array(data));
      } else if (utils$2.isString(data)) {
        data = Buffer.from(data, 'utf-8');
      } else {
        return reject(createError('Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream', config));
      } // Add Content-Length header if data exists

      headers['Content-Length'] = data.length;
    } // HTTP basic authentication


    var auth = undefined;

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      auth = username + ':' + password;
    } // Parse url


    var fullPath = buildFullPath(config.baseURL, config.url);
    var parsed = url__default["default"].parse(fullPath);
    var protocol = parsed.protocol || 'http:';

    if (!auth && parsed.auth) {
      var urlAuth = parsed.auth.split(':');
      var urlUsername = urlAuth[0] || '';
      var urlPassword = urlAuth[1] || '';
      auth = urlUsername + ':' + urlPassword;
    }

    if (auth) {
      delete headers.Authorization;
    }

    var isHttpsRequest = isHttps.test(protocol);
    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;
    var options = {
      path: buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
      method: config.method.toUpperCase(),
      headers: headers,
      agent: agent,
      agents: {
        http: config.httpAgent,
        https: config.httpsAgent
      },
      auth: auth
    };

    if (config.socketPath) {
      options.socketPath = config.socketPath;
    } else {
      options.hostname = parsed.hostname;
      options.port = parsed.port;
    }

    var proxy = config.proxy;

    if (!proxy && proxy !== false) {
      var proxyEnv = protocol.slice(0, -1) + '_proxy';
      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];

      if (proxyUrl) {
        var parsedProxyUrl = url__default["default"].parse(proxyUrl);
        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
        var shouldProxy = true;

        if (noProxyEnv) {
          var noProxy = noProxyEnv.split(',').map(function trim(s) {
            return s.trim();
          });
          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
            if (!proxyElement) {
              return false;
            }

            if (proxyElement === '*') {
              return true;
            }

            if (proxyElement[0] === '.' && parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
              return true;
            }

            return parsed.hostname === proxyElement;
          });
        }

        if (shouldProxy) {
          proxy = {
            host: parsedProxyUrl.hostname,
            port: parsedProxyUrl.port,
            protocol: parsedProxyUrl.protocol
          };

          if (parsedProxyUrl.auth) {
            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
            proxy.auth = {
              username: proxyUrlAuth[0],
              password: proxyUrlAuth[1]
            };
          }
        }
      }
    }

    if (proxy) {
      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
    }

    var transport;
    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);

    if (config.transport) {
      transport = config.transport;
    } else if (config.maxRedirects === 0) {
      transport = isHttpsProxy ? https__default["default"] : http__default["default"];
    } else {
      if (config.maxRedirects) {
        options.maxRedirects = config.maxRedirects;
      }

      transport = isHttpsProxy ? httpsFollow : httpFollow;
    }

    if (config.maxBodyLength > -1) {
      options.maxBodyLength = config.maxBodyLength;
    } // Create the request


    var req = transport.request(options, function handleResponse(res) {
      if (req.aborted) return; // uncompress the response body transparently if required

      var stream = res; // return the last request in case of redirects

      var lastRequest = res.req || req; // if no content, is HEAD request or decompress disabled we should not decompress

      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
        switch (res.headers['content-encoding']) {
          /*eslint default-case:0*/
          case 'gzip':
          case 'compress':
          case 'deflate':
            // add the unzipper to the body stream processing pipeline
            stream = stream.pipe(zlib__default["default"].createUnzip()); // remove the content-encoding in order to not confuse downstream operations

            delete res.headers['content-encoding'];
            break;
        }
      }

      var response = {
        status: res.statusCode,
        statusText: res.statusMessage,
        headers: res.headers,
        config: config,
        request: lastRequest
      };

      if (config.responseType === 'stream') {
        response.data = stream;
        settle(resolve, reject, response);
      } else {
        var responseBuffer = [];
        var totalResponseBytes = 0;
        stream.on('data', function handleStreamData(chunk) {
          responseBuffer.push(chunk);
          totalResponseBytes += chunk.length; // make sure the content length is not over the maxContentLength if specified

          if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
            stream.destroy();
            reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded', config, null, lastRequest));
          }
        });
        stream.on('error', function handleStreamError(err) {
          if (req.aborted) return;
          reject(enhanceError(err, config, null, lastRequest));
        });
        stream.on('end', function handleStreamEnd() {
          var responseData = Buffer.concat(responseBuffer);

          if (config.responseType !== 'arraybuffer') {
            responseData = responseData.toString(config.responseEncoding);

            if (!config.responseEncoding || config.responseEncoding === 'utf8') {
              responseData = utils$2.stripBOM(responseData);
            }
          }

          response.data = responseData;
          settle(resolve, reject, response);
        });
      }
    }); // Handle errors

    req.on('error', function handleRequestError(err) {
      if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
      reject(enhanceError(err, config, null, req));
    }); // Handle request timeout

    if (config.timeout) {
      // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
      var timeout = parseInt(config.timeout, 10);

      if (isNaN(timeout)) {
        reject(createError('error trying to parse `config.timeout` to int', config, 'ERR_PARSE_TIMEOUT', req));
        return;
      } // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
      // And then these socket which be hang up will devoring CPU little by little.
      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.


      req.setTimeout(timeout, function handleRequestTimeout() {
        req.abort();
        reject(createError('timeout of ' + timeout + 'ms exceeded', config, config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', req));
      });
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (req.aborted) return;
        req.abort();
        reject(cancel);
      });
    } // Send the request


    if (utils$2.isStream(data)) {
      data.on('error', function handleStreamError(err) {
        reject(enhanceError(err, config, null, req));
      }).pipe(req);
    } else {
      req.end(data);
    }
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$2.isUndefined(headers) && utils$2.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = http_1;
  }

  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$2.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$2.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$2.isFormData(data) || utils$2.isArrayBuffer(data) || utils$2.isBuffer(data) || utils$2.isStream(data) || utils$2.isFile(data) || utils$2.isBlob(data)) {
      return data;
    }

    if (utils$2.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils$2.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    if (utils$2.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || forcedJSONParsing && utils$2.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }

          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils$2.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils$2.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */

var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/

  utils$2.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils$2.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils$2.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */


var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }

    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$2.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils$2.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils$2.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils$2.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils$2.forEach(otherKeys, mergeDeepProperties);
  return config;
};

var validators$1 = {}; // eslint-disable-next-line func-names

['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */

function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');

  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }

  return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */


validators$1.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  } // eslint-disable-next-line func-names


  return function (value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */


function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }

  var keys = Object.keys(options);
  var i = keys.length;

  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];

    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);

      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators$1
};
var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */

function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  } // filter out skipped interceptors


  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;

  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();

    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
}; // Provide aliases for supported request methods


utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */


var isAxiosError = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */


function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context); // Copy axios.prototype to instance

  utils$2.extend(instance, Axios_1.prototype, context); // Copy context to instance

  utils$2.extend(instance, context);
  return instance;
} // Create the default instance to be exported


var axios$1 = createInstance(defaults_1); // Expose Axios class to allow class inheritance

axios$1.Axios = Axios_1; // Factory for creating new instances

axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
}; // Expose Cancel & CancelToken


axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel; // Expose all/spread

axios$1.all = function all(promises) {
  return Promise.all(promises);
};

axios$1.spread = spread; // Expose isAxiosError

axios$1.isAxiosError = isAxiosError;
var axios_1 = axios$1; // Allow use of default import syntax in TypeScript

var _default = axios$1;
axios_1.default = _default;
var axios = axios_1;

function r(e) {
  var t,
      f,
      n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
    e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (t in e) {
    e[t] && (n && (n += " "), n += t);
  }
  return n;
}

function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) {
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  }

  return n;
}

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isStr(v) {
  return typeof v === 'string';
}

function isFn(v) {
  return typeof v === 'function';
}

function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}

function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}

function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}

var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function canBeRendered(content) {
  return React.isValidElement(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  DARK: 'dark'
};
/**
 * Used to collapse toast after exit animation
 */

function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var height = node.scrollHeight;
  var style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = height + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}
/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */


function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        nodeRef = _ref2.nodeRef,
        isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = React.useRef();
    var animationStep = React.useRef(0
    /* Enter */
    );
    React.useLayoutEffect(function () {
      onEnter();
    }, []);
    React.useEffect(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener('animationend', onEntered);
    }

    function onEntered() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onEntered);

      if (animationStep.current === 0
      /* Enter */
      ) {
        node.className = baseClassName.current;
      }
    }

    function onExit() {
      animationStep.current = 1
      /* Exit */
      ;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener('animationend', onExited);
    }

    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }

    return React__default$1["default"].createElement(React__default$1["default"].Fragment, null, children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};
/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */

function useKeeper(arg, refresh) {
  if (refresh === void 0) {
    refresh = false;
  }

  var ref = React.useRef(arg);
  React.useEffect(function () {
    if (refresh) ref.current = arg;
  });
  return ref.current;
}

function reducer(state, action) {
  switch (action.type) {
    case 0
    /* ADD */
    :
      return [].concat(state, [action.toastId]).filter(function (id) {
        return id !== action.staleId;
      });

    case 1
    /* REMOVE */
    :
      return isToastIdValid(action.toastId) ? state.filter(function (id) {
        return id !== action.toastId;
      }) : [];
  }
}

function useToastContainer(props) {
  var _useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useReducer2 = React.useReducer(reducer, []),
      toast = _useReducer2[0],
      dispatch = _useReducer2[1];

  var containerRef = React.useRef(null);
  var toastCount = useKeeper(0);
  var queue = useKeeper([]);
  var collection = useKeeper({});
  var instance = useKeeper({
    toastKey: 1,
    displayedToast: 0,
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return collection[id] || null;
    }
  });
  React.useEffect(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  React.useEffect(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toast.length;
    eventManager.emit(4
    /* Change */
    , toast.length, props.containerId);
  }, [toast]);
  React.useEffect(function () {
    instance.props = props;
  });

  function isToastActive(id) {
    return toast.indexOf(id) !== -1;
  }

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      toastCount -= queue.length;
      queue = [];
    }
  }

  function removeToast(toastId) {
    dispatch({
      type: 1
      /* REMOVE */
      ,
      toastId: toastId
    });
  }

  function dequeueToast() {
    var _queue$shift = queue.shift(),
        toastContent = _queue$shift.toastContent,
        toastProps = _queue$shift.toastProps,
        staleId = _queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(_ref2) {
    var containerId = _ref2.containerId,
        toastId = _ref2.toastId,
        updateId = _ref2.updateId;
    return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || collection[toastId] && updateId == null ? true : false;
  } // this function and all the function called inside needs to rely on ref(`useKeeper`)


  function buildToast(content, _ref3) {
    var delay = _ref3.delay,
        staleId = _ref3.staleId,
        options = _objectWithoutPropertiesLoose$3(_ref3, ["delay", "staleId"]);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId;
    var props = instance.props;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = options.updateId == null;
    if (isNotAnUpdate) toastCount++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: isStr(options.role) ? options.role : props.role,
      deleteToast: function deleteToast() {
        removeFromCollection(toastId);
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose; //  tweak for vertical dragging

    if (toastProps.draggableDirection === "y"
    /* Y */
    && toastProps.draggablePercent === 80
    /* DRAGGABLE_PERCENT */
    ) {
      toastProps.draggablePercent *= 1.5;
    }

    var closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    toastProps.closeButton = closeButton;
    var toastContent = content;

    if (React.isValidElement(content) && !isStr(content.type)) {
      toastContent = React.cloneElement(content, {
        closeToast: closeToast,
        toastProps: toastProps
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) {
      queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) delete collection[staleId];
    collection[toastId] = {
      content: content,
      props: toastProps
    };
    dispatch({
      type: 0
      /* ADD */
      ,
      toastId: toastId,
      staleId: staleId
    });
  }

  function removeFromCollection(toastId) {
    delete collection[toastId];
    var queueLen = queue.length;
    toastCount = isToastIdValid(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
    if (toastCount < 0) toastCount = 0;

    if (queueLen > 0) {
      var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

      if (queueLen === 1 || freeSlot === 1) {
        instance.displayedToast++;
        dequeueToast();
      } else {
        var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
        instance.displayedToast = toDequeue;

        for (var i = 0; i < toDequeue; i++) {
          dequeueToast();
        }
      }
    } else {
      forceUpdate();
    }
  }

  function getToastToRender(cb) {
    var toastToRender = {};
    var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);

    for (var i = 0; i < toastList.length; i++) {
      var _toast = collection[toastList[i]];
      var position = _toast.props.position;
      toastToRender[position] || (toastToRender[position] = []);
      toastToRender[position].push(_toast);
    }

    return Object.keys(toastToRender).map(function (p) {
      return cb(p, toastToRender[p]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    collection: collection,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = React.useState(true),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = React.useState(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = React.useRef(null);
  var drag = useKeeper({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null
  });
  var syncProps = useKeeper(props, true);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  React.useEffect(function () {
    if (isFn(props.onOpen)) props.onOpen(React.isValidElement(props.children) && props.children.props);
    return function () {
      if (isFn(syncProps.onClose)) syncProps.onClose(React.isValidElement(syncProps.children) && syncProps.children.props);
    };
  }, []);
  React.useEffect(function () {
    props.draggable && bindDragEvents();
    return function () {
      props.draggable && unbindDragEvents();
    };
  }, [props.draggable]);
  React.useEffect(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      var toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* X */
      ) {
        drag.start = drag.x;
        drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
      } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    if (drag.canDrag) {
      e.preventDefault();
      var toast = toastRef.current;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* X */
      ) {
        drag.delta = drag.x - drag.start;
      } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    var toast = toastRef.current;

    if (drag.canDrag) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return React.createElement("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, React.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _cx, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn;

  var style = _extends$6({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx("Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return React.createElement("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style
  }, animationEvent));
}

ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var Toast$2 = function Toast(props) {
  var _cx;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn;
  var defaultClassName = clsx("Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx(defaultClassName, className);
  var isProgressControlled = !!progress;

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type
    };
    if (isFn(closeButton)) return closeButton(props);
    if (React.isValidElement(closeButton)) return React.cloneElement(closeButton, props);
  }

  return React.createElement(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, React.createElement("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), React.createElement("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), children), renderCloseButton(closeButton), (autoClose || isProgressControlled) && React.createElement(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});

var ToastContainer$1 = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position) {
    var _cx;

    var defaultClassName = clsx("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : clsx(defaultClassName, parseClassName(className));
  }

  return React.createElement("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var containerStyle = toastList.length === 0 ? _extends$6({}, style, {
      pointerEvents: 'none'
    }) : _extends$6({}, style);
    return React.createElement("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return React.createElement(Toast$2, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};

ToastContainer$1.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* X */
  ,
  role: 'alert'
};
var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */

function isAnyContainerMounted() {
  return containers.size > 0;
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */


function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substr(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (isAnyContainerMounted()) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      ReactDOM.render(React.createElement(ToastContainer$1, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends$6({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

var createToastByType = function createToastByType(type) {
  return function (content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
};

var toast = function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
};

toast.success = /*#__PURE__*/createToastByType(TYPE.SUCCESS);
toast.info = /*#__PURE__*/createToastByType(TYPE.INFO);
toast.error = /*#__PURE__*/createToastByType(TYPE.ERROR);
toast.warning = /*#__PURE__*/createToastByType(TYPE.WARNING);
toast.dark = /*#__PURE__*/createToastByType(TYPE.DARK);
toast.warn = toast.warning;
/**
 * Remove toast programmaticaly
 */

toast.dismiss = function (id) {
  return eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  } // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update


  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends$6({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * Configure the ToastContainer when lazy mounted
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */


function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof$2(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */


function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions = {};

function getDefaultOptions() {
  return defaultOptions;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */


function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$1(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */


function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */


function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */


var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];

function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}

function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}

function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$2 = match$1;
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$2,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale; // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

var isArray$2 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType$2 = typeof Element !== 'undefined';

function equal$2(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$2(a),
        arrB = isArray$2(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal$2(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // start react-fast-compare
    // custom handling for DOM elements


    if (hasElementType$2 && a instanceof Element && b instanceof Element) return a === b; // custom handling for React

    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal$2(a[key], b[key])) return false;
      }
    } // end react-fast-compare
    // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


var reactFastCompare$2 = function exportedEqual(a, b) {
  try {
    return equal$2(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
};

var isMergeableObject$1 = function isMergeableObject(value) {
  return isNonNullObject$1(value) && !isSpecial$1(value);
};

function isNonNullObject$1(value) {
  return !!value && typeof value === 'object';
}

function isSpecial$1(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement$1(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE$1 = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

function isReactElement$1(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE$1;
}

function emptyTarget$1(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified$1(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge$1(emptyTarget$1(value), value, options) : value;
}

function defaultArrayMerge$1(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified$1(element, options);
  });
}

function mergeObject$1(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified$1(target[key], options);
    });
  }

  Object.keys(source).forEach(function (key) {
    if (!options.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified$1(source[key], options);
    } else {
      destination[key] = deepmerge$1(target[key], source[key], options);
    }
  });
  return destination;
}

function deepmerge$1(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge$1;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject$1;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified$1(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject$1(target, source, options);
  }
}

deepmerge$1.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge$1(prev, next, options);
  }, {});
};

var deepmerge_1$1 = deepmerge$1;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;
/** Built-in value references. */

var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
/** Used for built-in method references. */

var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$d.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$d.toString;
/** Built-in value references. */

var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}
/** Used for built-in method references. */


var objectProto$c = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$c.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}
/** `Object#toString` result references. */


var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */


function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
/** Built-in value references. */


var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}
/** `Object#toString` result references. */


var objectTag$3 = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$b = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto = getPrototype$1(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */


function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function stackGet(key) {
  return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function stackHas(key) {
  return this.__data__.has(key);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
/** `Object#toString` result references. */


var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
/** Used to detect overreaching core-js shims. */


var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/** Used for built-in method references. */


var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */


var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$a = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */


function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/* Built-in method references that are verified to be native. */


var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;
/* Built-in method references that are verified to be native. */

var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }

  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}
/** Used for built-in method references. */


var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED : value;
  return this;
}
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var defineProperty$1 = defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
/** Used for built-in method references. */


var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */


function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */


function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}
/** `Object#toString` result references. */


var argsTag$2 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
/** Used for built-in method references. */


var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray$1 = isArray;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}
/** Detect free variable `exports`. */


var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
/** Built-in value references. */

var Buffer$2 = moduleExports$2 ? root$1.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/** Used as references for various `Number` constants. */


var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/** `Object#toString` result references. */


var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */


function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
/** Detect free variable `exports`. */


var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports$1 && freeGlobal$1.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

var nodeUtil$1 = nodeUtil;
/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$5.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}
/** Used for built-in method references. */


var objectProto$4 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */


function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */


function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}
/** Used for built-in method references. */


var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */


function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}
/** Detect free variable `exports`. */


var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer$1 = moduleExports ? root$1.Buffer : undefined,
    allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */


function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */


function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */


function stubArray() {
  return [];
}
/** Used for built-in method references. */


var objectProto$1 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */


function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];

  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }

  return result;
};
var getSymbolsIn$1 = getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */


function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}
/* Built-in method references that are verified to be native. */


var DataView$1 = getNative(root$1, 'DataView');
var DataView$2 = DataView$1;
/* Built-in method references that are verified to be native. */

var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;
/* Built-in method references that are verified to be native. */

var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;
/* Built-in method references that are verified to be native. */

var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;
/** `Object#toString` result references. */

var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView$2),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$2),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$2);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;

        case mapCtorString:
          return mapTag$3;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$3;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var getTag$1 = getTag;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}
/** Built-in value references. */


var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */


function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/** Used to match `RegExp` flags from their coerced string values. */


var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
/** Used to convert symbols to primitives and strings. */


var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */


function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/** `Object#toString` result references. */


var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag$2:
      return cloneSymbol(object);
  }
}
/** Built-in value references. */


var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject$1(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var baseCreate$1 = baseCreate;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}
/** `Object#toString` result references. */


var mapTag$1 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}
/* Node.js helper references. */


var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;
/** `Object#toString` result references. */

var setTag$1 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}
/* Node.js helper references. */


var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject$1(value)) {
    return value;
  }

  var isArr = isArray$1(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }

    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}
/** Used to compose bitmasks for cloning. */


var CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */

function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$1);
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}
/** `Object#toString` result references. */


var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
/** Error message constants. */


var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = MapCache;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}
/** Used to match property names within property paths. */


var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
/** Used as references for various `Number` constants. */


var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */


function toPath(value) {
  if (isArray$1(value)) {
    return arrayMap(value, toKey);
  }

  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString(value)));
}

var isProduction = process.env.NODE_ENV === 'production';

function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}
/** Used to compose bitmasks for cloning. */


var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */

function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function _inheritsLoose$3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/** @private is the value an empty array? */


var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */


var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */


var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */


var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */


var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private Does a React component have exactly 0 children? */


var isEmptyChildren = function isEmptyChildren(children) {
  return React.Children.count(children) === 0;
};
/** @private is the given object/value a promise? */


var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */


function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */


function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */


function setIn(obj, path, value) {
  var res = clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */


function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/React.createContext(undefined);
FormikContext.displayName = 'FormikContext';
FormikContext.Provider;
FormikContext.Consumer;

function useFormikContext() {
  var formik = React.useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends$5({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends$5({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (reactFastCompare$2(state.errors, msg.payload)) {
        return state;
      }

      return _extends$5({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends$5({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends$5({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends$5({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends$5({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends$5({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends$5({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends$5({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends$5({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends$5({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends$5({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};

function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose$2(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends$5({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = React.useRef(props.initialValues);
  var initialErrors = React.useRef(props.initialErrors || emptyErrors);
  var initialTouched = React.useRef(props.initialTouched || emptyTouched);
  var initialStatus = React.useRef(props.initialStatus);
  var isMounted = React.useRef(false);
  var fieldRegistry = React.useRef({});

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  React.useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = React.useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = React.useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = React.useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = React.useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = React.useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = React.useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1$1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  React.useEffect(function () {
    if (validateOnMount && isMounted.current === true && reactFastCompare$2(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = React.useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  React.useEffect(function () {
    if (isMounted.current === true && !reactFastCompare$2(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare$2(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare$2(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare$2(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = React.useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = React.useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = React.useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = React.useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = React.useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = React.useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = React.useCallback(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = React.useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = React.useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (process.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = React.useCallback(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = React.useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = React.useCallback(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = React.useMemo(function () {
    return !reactFastCompare$2(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = React.useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends$5({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */


function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */


function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */


function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1$1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1$1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

function useEventCallback(fn) {
  var ref = React.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

var Form$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose$2(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return React.createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form$1.displayName = 'Form';
/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};

var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};

var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};

var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends$5({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$3(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends$5({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized$1(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !reactFastCompare$2(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose$2(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends$5({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? React.createElement(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? React.Children.only(children) : null : null;
  };

  return FieldArrayInner;
}(React.Component);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var INPUT_GENERATOR_TYPES = {
  SELECT: "SELECT",
  TEXT: "TEXT",
  TEXTAREA: "TEXTAREA",
  DATELINE: "DATELINE",
  RADIO: "RADIO",
  CHECKBOX: "CHECKBOX",
  NUMBER: "NUMBER",
  EMAIL: "EMAIL",
  RE_CAPTCHA: "RE_CAPTCHA"
};

function useFormGenerator(options) {
  var constructorObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var handles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var inputsKeyNames = inputsKeyNamesBuilder(constructorObj);
  /**   Start Local State   */

  var _useState = React.useState([]),
      _useState2 = _slicedToArray$1(_useState, 2),
      inputs = _useState2[0],
      setInputs = _useState2[1];
  /**   End Local State   */

  /**   Start Formik   */


  var _handles$onSubmit = handles.onSubmit,
      onSubmit = _handles$onSubmit === void 0 ? function () {
    return null;
  } : _handles$onSubmit,
      _handles$onValidate = handles.onValidate,
      onValidate = _handles$onValidate === void 0 ? function () {
    return {};
  } : _handles$onValidate;
  var formikValidationModels = inputsValidatorBuilder(constructorObj);
  var formik = useFormik({
    initialValues: inputsKeyNames,
    onSubmit: onSubmit,
    validate: onValidate
  });
  /**   End Formik   */

  var actionsInitialData = {};
  var actions = inputs.reduce(actionsBuilder, actionsInitialData);
  /**   Start Handles   */

  function
  /** { key = "", value = "" } */
  onChangeTextInput() {}

  function
  /** { key = "", value = {}, data = [] } */
  onChangeSelectInput() {}

  function
  /** { key = "", value = {}, data = [] } */
  onChangeRadioInput() {}

  function
  /** { key = "", data = [] } */
  onChangeCheckBoxInput() {}

  function
  /** { key = "", value = {} } */
  onChangeDatelineInput() {}
  /**   End Handles   */

  /**   Start Builders   */


  function actionsBuilder(acc, item) {
    var _item$inputs;

    var itemActionsInitialData = {};

    var concatItemActions = function concatItemActions(acc2, input) {
      var _input$props;

      return _objectSpread2(_objectSpread2({}, acc2), {}, _defineProperty$1({
        formik: formik
      }, lodash.camelCase(input.keyName), (input === null || input === void 0 ? void 0 : (_input$props = input.props) === null || _input$props === void 0 ? void 0 : _input$props.onChange) || undefined));
    };

    var itemActions = item === null || item === void 0 ? void 0 : (_item$inputs = item.inputs) === null || _item$inputs === void 0 ? void 0 : _item$inputs.reduce(concatItemActions, itemActionsInitialData);

    var newActions = _objectSpread2(_objectSpread2({}, acc), itemActions || {});

    return newActions;
  }

  function inputsKeyNamesBuilder() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var inputsUpdated = Object.entries(obj).map(inputsUpdatedFormatter);
    var keyNames = inputsUpdated.reduce(function (acc, item) {
      var _item$inputs2;

      item === null || item === void 0 ? void 0 : (_item$inputs2 = item.inputs) === null || _item$inputs2 === void 0 ? void 0 : _item$inputs2.forEach(function (subItem) {
        acc[subItem.keyName] = "";
      });
      return acc;
    }, {});
    return keyNames;
  }

  function inputsValidatorBuilder() {
    var _Object$entries;

    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var inputsUpdated = Object === null || Object === void 0 ? void 0 : (_Object$entries = Object.entries(obj)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(inputsUpdatedFormatter);
    /** validated models */

    var validationModels = inputsUpdated === null || inputsUpdated === void 0 ? void 0 : inputsUpdated.reduce(function (boxOfValidatedModels, model) {
      model.inputs.forEach(function (modelData) {
        var _modelData$props, _modelData$props2, _modelData$props4, _modelData$props6, _modelData$props8, _modelData$props10, _modelData$props12;

        boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""] = {};

        if (modelData.name) {
          boxOfValidatedModels[modelData.keyName].name = (modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || "";
        }

        if (modelData.type) {
          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].type = lodash.lowerCase(modelData.type);
        }

        boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].isRequired = !!(modelData !== null && modelData !== void 0 && (_modelData$props = modelData.props) !== null && _modelData$props !== void 0 && _modelData$props.isRequired) || false;

        if ((_modelData$props2 = modelData.props) !== null && _modelData$props2 !== void 0 && _modelData$props2.regex) {
          var _modelData$props3;

          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].regex = (modelData === null || modelData === void 0 ? void 0 : (_modelData$props3 = modelData.props) === null || _modelData$props3 === void 0 ? void 0 : _modelData$props3.regex) || "";
        }

        if ((_modelData$props4 = modelData.props) !== null && _modelData$props4 !== void 0 && _modelData$props4.label) {
          var _modelData$props5;

          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].label = (modelData === null || modelData === void 0 ? void 0 : (_modelData$props5 = modelData.props) === null || _modelData$props5 === void 0 ? void 0 : _modelData$props5.label) || "";
        }

        if ((_modelData$props6 = modelData.props) !== null && _modelData$props6 !== void 0 && _modelData$props6.maxLength) {
          var _modelData$props7;

          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].maxLength = (modelData === null || modelData === void 0 ? void 0 : (_modelData$props7 = modelData.props) === null || _modelData$props7 === void 0 ? void 0 : _modelData$props7.maxLength) || "";
        }

        if ((_modelData$props8 = modelData.props) !== null && _modelData$props8 !== void 0 && _modelData$props8.minLength) {
          var _modelData$props9;

          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].minLength = (modelData === null || modelData === void 0 ? void 0 : (_modelData$props9 = modelData.props) === null || _modelData$props9 === void 0 ? void 0 : _modelData$props9.minLength) || "";
        }

        if ((_modelData$props10 = modelData.props) !== null && _modelData$props10 !== void 0 && _modelData$props10.helperText) {
          var _modelData$props11;

          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].helperText = (modelData === null || modelData === void 0 ? void 0 : (_modelData$props11 = modelData.props) === null || _modelData$props11 === void 0 ? void 0 : _modelData$props11.helperText) || "";
        }

        if ((_modelData$props12 = modelData.props) !== null && _modelData$props12 !== void 0 && _modelData$props12.title) {
          var _modelData$props13;

          boxOfValidatedModels[(modelData === null || modelData === void 0 ? void 0 : modelData.keyName) || ""].title = (modelData === null || modelData === void 0 ? void 0 : (_modelData$props13 = modelData.props) === null || _modelData$props13 === void 0 ? void 0 : _modelData$props13.title) || "";
        }
      });
      return boxOfValidatedModels;
    }, {});
    return validationModels;
  }

  function inputsUpdatedFormatter( //  param 1: Object as Array
  _ref, id //  param 2: Index
  ) {
    var _ref2 = _slicedToArray$1(_ref, 2),
        key = _ref2[0],
        //  Object Key
    $values //  Object Value/Data
    = _ref2[1];

    var hasLinks = !lodash.isEmpty($values.links);

    var item = _objectSpread2(_objectSpread2({}, $values), {}, {
      key: key,
      id: id,
      inputs: $values.inputs.map(function (input) {
        return inputsItemFormatter({
          title: ($values === null || $values === void 0 ? void 0 : $values.title) || ($values === null || $values === void 0 ? void 0 : $values.description) || "",
          input: input
        });
      })
    });

    if (hasLinks) {
      var linksUpdated = $values.links.map(function (_ref3) {
        var _ref3$relationName = _ref3.relationName,
            relationName = _ref3$relationName === void 0 ? "" : _ref3$relationName,
            _ref3$acceptedValue = _ref3.acceptedValue,
            acceptedValue = _ref3$acceptedValue === void 0 ? "" : _ref3$acceptedValue,
            _ref3$form = _ref3.form,
            form = _ref3$form === void 0 ? {} : _ref3$form;
        var formUpdated = Object.entries(form).map(inputsUpdatedFormatter);
        return {
          relationName: relationName,
          acceptedValue: acceptedValue,
          form: formUpdated
        };
      });
      item.links = linksUpdated;
    }

    return item;
  }

  function inputsItemFormatter(_ref4) {
    var _inputFormatted, _inputFormatted2, _inputFormatted2$prop;

    var _ref4$title = _ref4.title,
        title = _ref4$title === void 0 ? "" : _ref4$title,
        _ref4$input = _ref4.input,
        input = _ref4$input === void 0 ? {} : _ref4$input;
    var inputType = lodash.snakeCase(input.type).toUpperCase();
    var titleAndNameAreEqual = lodash.camelCase(title) !== lodash.camelCase(input.name);
    var keyName = "".concat(title ? "".concat(lodash.camelCase(titleAndNameAreEqual ? title : ""), "_") : "").concat(lodash.camelCase(input.name) || "");
    var inputFormatted = {};

    if (inputType === INPUT_GENERATOR_TYPES.TEXT || inputType === INPUT_GENERATOR_TYPES.TEXTAREA || inputType === INPUT_GENERATOR_TYPES.NUMBER || inputType === INPUT_GENERATOR_TYPES.EMAIL) {
      var _input$props2, _input$props3;

      inputFormatted = _objectSpread2(_objectSpread2({}, input), {}, {
        type: inputType,
        props: _objectSpread2(_objectSpread2({}, (input === null || input === void 0 ? void 0 : input.props) || {}), {}, {
          styles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props2 = input.props) === null || _input$props2 === void 0 ? void 0 : _input$props2.styles) || {}),
          inputStyles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props3 = input.props) === null || _input$props3 === void 0 ? void 0 : _input$props3.inputStyles) || {}),
          value: undefined,
          label: (input === null || input === void 0 ? void 0 : input.label) || "",
          isRequired: (input === null || input === void 0 ? void 0 : input.required) || false,
          type: input === null || input === void 0 ? void 0 : input.type,
          minLength: Number((input === null || input === void 0 ? void 0 : input.minLength) || 0),
          maxLength: Number((input === null || input === void 0 ? void 0 : input.maxLength) || 0),
          onChange: function onChange(value) {
            return onChangeTextInput();
          }
        })
      });
      if (options && options[keyName]) inputFormatted.props.value = options[keyName];
    } else if (inputType === INPUT_GENERATOR_TYPES.CHECKBOX) {
      var _input$props4, _input$props5;

      var checkboxData = lodash.isString(input.data) ? options[input.data] : input.data;
      inputFormatted = _objectSpread2(_objectSpread2({}, input), {}, {
        type: INPUT_GENERATOR_TYPES.CHECKBOX,
        props: _objectSpread2(_objectSpread2({}, input === null || input === void 0 ? void 0 : input.props), {}, {
          styles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props4 = input.props) === null || _input$props4 === void 0 ? void 0 : _input$props4.styles) || {}),
          inputStyles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props5 = input.props) === null || _input$props5 === void 0 ? void 0 : _input$props5.inputStyles) || {}),
          data: checkboxData,
          isRequired: (input === null || input === void 0 ? void 0 : input.required) || false,
          onChange: function onChange($data) {
            return onChangeCheckBoxInput();
          }
        })
      });
    } else if (inputType === INPUT_GENERATOR_TYPES.SELECT) {
      inputFormatted = _objectSpread2(_objectSpread2({}, input), {}, {
        type: INPUT_GENERATOR_TYPES.SELECT,
        props: _objectSpread2(_objectSpread2({}, (input === null || input === void 0 ? void 0 : input.props) || {}), {}, {
          title: (input === null || input === void 0 ? void 0 : input.label) || "",
          helperText: (input === null || input === void 0 ? void 0 : input.label) || "",
          data: [],
          isRequired: (input === null || input === void 0 ? void 0 : input.required) || false,
          onChange: function onChange(value) {
            return onChangeSelectInput({
              key: keyName,
              value: value,
              data: options[input.data]
            });
          }
        })
      });

      if (options && input && input.data && options[input.data]) {
        inputFormatted.props.data = options[input.data];
      }
    } else if (inputType === INPUT_GENERATOR_TYPES.RADIO) {
      var _input$props6, _input$props7;

      inputFormatted = _objectSpread2(_objectSpread2({}, input), {}, {
        type: INPUT_GENERATOR_TYPES.RADIO,
        props: _objectSpread2(_objectSpread2({}, (input === null || input === void 0 ? void 0 : input.props) || {}), {}, {
          styles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props6 = input.props) === null || _input$props6 === void 0 ? void 0 : _input$props6.styles) || {}),
          inputStyles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props7 = input.props) === null || _input$props7 === void 0 ? void 0 : _input$props7.inputStyles) || {}),
          data: options[input.data],
          isRequired: (input === null || input === void 0 ? void 0 : input.required) || false,
          onChange: function onChange(value) {
            return onChangeRadioInput({
              key: keyName,
              value: value,
              data: options[input.data]
            });
          }
        })
      });

      if (options && input && input.data && options[input.data]) {
        inputFormatted.props.data = options[input.data];
      }
    } else if (inputType === INPUT_GENERATOR_TYPES.DATELINE) {
      var _input$props8, _input$props9;

      inputFormatted = _objectSpread2(_objectSpread2({}, input), {}, {
        type: INPUT_GENERATOR_TYPES.DATELINE,
        props: _objectSpread2(_objectSpread2({}, (input === null || input === void 0 ? void 0 : input.props) || {}), {}, {
          styles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props8 = input.props) === null || _input$props8 === void 0 ? void 0 : _input$props8.styles) || {}),
          inputStyles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props9 = input.props) === null || _input$props9 === void 0 ? void 0 : _input$props9.inputStyles) || {}),
          label: input.label,
          initialDate: options[input.data] ? options[input.data][0] : format(new Date(), "yyyy-MM-dd"),
          onChange: function onChange(value) {
            return onChangeDatelineInput();
          }
        })
      });
    } else if (inputType === INPUT_GENERATOR_TYPES.RE_CAPTCHA) {
      var _input$props10, _input$props11;

      inputFormatted = _objectSpread2(_objectSpread2({}, input), {}, {
        type: INPUT_GENERATOR_TYPES.RE_CAPTCHA,
        props: _objectSpread2(_objectSpread2({}, (input === null || input === void 0 ? void 0 : input.props) || {}), {}, {
          styles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props10 = input.props) === null || _input$props10 === void 0 ? void 0 : _input$props10.styles) || {}),
          inputStyles: _objectSpread2({}, (input === null || input === void 0 ? void 0 : (_input$props11 = input.props) === null || _input$props11 === void 0 ? void 0 : _input$props11.inputStyles) || {}),
          isRequired: (input === null || input === void 0 ? void 0 : input.required) || false,
          label: (input === null || input === void 0 ? void 0 : input.label) || "",
          initialDate: false,
          onChange: function onChange(value) {
            return onChangeDatelineInput();
          }
        })
      });
    }

    inputFormatted = _objectSpread2(_objectSpread2({}, inputFormatted), {}, {
      id: keyName,
      keyName: keyName,
      props: _objectSpread2(_objectSpread2({}, ((_inputFormatted = inputFormatted) === null || _inputFormatted === void 0 ? void 0 : _inputFormatted.props) || {}), {}, {
        keyName: keyName,
        styles: _objectSpread2(_objectSpread2({}, input.theme || undefined), ((_inputFormatted2 = inputFormatted) === null || _inputFormatted2 === void 0 ? void 0 : (_inputFormatted2$prop = _inputFormatted2.props) === null || _inputFormatted2$prop === void 0 ? void 0 : _inputFormatted2$prop.styles) || {}),
        regex: input.regex || undefined
      })
    });
    return inputFormatted;
  }

  function inputsBuilder() {
    var inputsUpdated = Object.entries(constructorObj).map(inputsUpdatedFormatter);
    setInputs(inputsUpdated);
    return inputsUpdated;
  }
  /**   End Builders   */


  React.useEffect(function () {
    inputsBuilder();
  }, [options]);
  return {
    formikKeyNames: inputsKeyNames,
    formikValidationModels: formikValidationModels,
    formik: formik,
    data: options,
    inputs: inputs,
    actions: actions
  };
}

var useInput = function useInput(_ref) {
  var _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$isSuccess = _ref.isSuccess,
      isSuccess = _ref$isSuccess === void 0 ? undefined : _ref$isSuccess,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? undefined : _ref$hasError,
      _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function
    /** value = "" */
  () {
    return undefined;
  } : _ref$onChange,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data;
  var formikValue = formik ? formik.values[keyName] : "";
  var formikError = formik ? formik.errors[keyName] : "";
  var isTouched = formik ? formik.touched[keyName] : false;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = React.useState(data),
      _useState4 = _slicedToArray$1(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];

  var _useState5 = React.useState({}),
      _useState6 = _slicedToArray$1(_useState5, 2),
      currentOption = _useState6[0],
      setCurrentOption = _useState6[1];

  var _useState7 = React.useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      focus = _useState8[0],
      setFocus = _useState8[1];

  var isText = /(text|number|email|textarea)/gi.test(type);
  var isSelect = /select/gi.test(type);
  var isDateline = /dateline/gi.test(type);
  var isRadio = /radio/gi.test(type);
  var isCheckBox = /checkbox/gi.test(type); // Handlers

  var handleChangeValue = function handleChangeValue() {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$isReCaptcha = _ref2.isReCaptcha,
        isReCaptcha = _ref2$isReCaptcha === void 0 ? false : _ref2$isReCaptcha;

    var target = event.target;
    var hasFormik = !lodash.isEmpty(formik);
    var hasExternalCallback = !lodash.isEmpty(onChange);
    if (disable || isReCaptcha) return;
    if (hasFormik) formik.handleChange(event);

    if (isText) {
      if (hasExternalCallback) onChange(formikValue);
      setValue(formikValue);
    }

    if (isCheckBox) {
      var checks = options.map(function (_option_) {
        return _option_.label === target.value ? _objectSpread2(_objectSpread2({}, _option_), {}, {
          isChecked: target.checked
        }) : _option_;
      });
      setOptions(checks);
    }

    if (isSelect) {
      var option = options.find(function (_option_) {
        return _option_.value === target.value;
      });
      onChange(option);
      setCurrentOption(option);
    }

    if (isDateline) {
      onChange(target.value);
      setValue(target.value);
    }

    if (isRadio) {
      var newOption = options.find(function (_option_) {
        var isThis = new RegExp(target.value, "ig").test(_option_.label);
        return isThis;
      });

      if (!lodash.isEmpty(newOption)) {
        onChange(newOption.label);
        setValue(newOption.label);
        setCurrentOption(newOption);
      }
    }
  };

  function
  /** event */
  onClick() {
    if (disable) return;
    setFocus(true);
  }

  function onClear() {
    onChange({
      target: {
        value: ""
      }
    });
    setValue("");
  }

  function onBlur(event) {
    if (disable) return;

    if (!lodash.isEmpty(formik)) {
      formik.handleBlur(event);
    }

    setFocus(false);
  }

  var actions = {
    handleChangeValue: handleChangeValue,
    onClick: onClick,
    onBlur: onBlur,
    setOptions: setOptions,
    onClear: onClear
  };
  var payload = {
    value: value,
    formikValue: formikValue,
    formikError: formikError,
    isTouched: isTouched,
    options: options,
    currentOption: currentOption,
    focus: focus,
    hasError: hasError,
    isSuccess: isSuccess,
    isText: isText,
    isSelect: isSelect,
    isDateline: isDateline,
    isRadio: isRadio
  };
  var inputModel = {
    payload: payload,
    focus: focus,
    hasError: hasError,
    isSuccess: isSuccess,
    actions: actions
  };
  return inputModel;
};

var INPUT = "INPUT";
var INPUT_TEXT = "INPUT_TEXT";

function getColor(_ref) {
  var _ref$like = _ref.like,
      like = _ref$like === void 0 ? INPUT : _ref$like,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? false : _ref$success,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$withBorder = _ref.withBorder,
      withBorder = _ref$withBorder === void 0 ? false : _ref$withBorder;
  if (disable && withBorder) return "var(--grayscale-80-color)";
  if (disable) return "var(--grayscale-50-color)";

  if (like === INPUT) {
    if (withBorder) {
      if (error) return "var(--ui-alert-color)";
      if (success) return "var(--primary-color)";
    }

    if (error) return "var(--ui-alert-faded-color)";
    if (success) return "var(--primary-6-color)";
    return "var(--grayscale-6-color)";
  }

  if (like === INPUT_TEXT) {
    if (withBorder) {
      if (error) return "var(--ui-alert-color)";
      if (success) return "var(--primary-color)";
    }

    if (error) return "var(--ui-alert-color)";
    if (success) return "var(--primary-color)";
    return "var(--grayscale-50-color)";
  }

  if (withBorder) {
    return "var(--grayscale-80-color)";
  }

  return "var(--grayscale-30-color)";
}

var _templateObject$1R, _templateObject2$J, _templateObject3$B;

function CheckBox(_ref, ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "radio" : _ref$type,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange;

  var $id = id || lodash.random(0, 99999999);

  var _useInput = useInput({
    type: type,
    formik: formik,
    keyName: keyName,
    isRequired: isRequired,
    data: data,
    disable: disable,
    label: title,
    onChange: _onChange
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var $direction = "row";

  if (/vertical/gi.test(direction)) {
    $direction = "col";
  }

  return /*#__PURE__*/React__default$1["default"].createElement(InputContainer$1, {
    className: className
  }, /*#__PURE__*/React__default$1["default"].createElement("span", {
    className: "tw-font-medium bl-text-xs"
  }, title), /*#__PURE__*/React__default$1["default"].createElement("label", {
    className: "tw-flex tw-flex-".concat($direction, " tw-mr-6 tw-items-start"),
    htmlFor: $id,
    role: "group"
  }, payload.options.map(function (item) {
    var itemName = "".concat($id, "-").concat(lodash.lowerCase(item.label));
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: itemName,
      className: "tw-mr-6 tw-mb-2"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-flex tw-inline-flex tw-items-center tw-relative tw-pl-8"
    }, /*#__PURE__*/React__default$1["default"].createElement(Svg, {
      className: "tw-fill-current tw-hidden bl-text-primary tw-pointer-events-none",
      viewBox: "0 0 20 20",
      active: item.isChecked
    }, /*#__PURE__*/React__default$1["default"].createElement("path", {
      d: "M0 11l2-2 5 5L18 3l2 2L7 18z"
    })), /*#__PURE__*/React__default$1["default"].createElement(CheckBoxInput, {
      ref: ref,
      name: $id,
      id: itemName,
      className: "tw-form-checkbox",
      type: "checkbox",
      checked: item.isChecked,
      value: item.label,
      onBlur: actions.onBlur,
      onClick: actions.onClick,
      onChange: function onChange(event) {
        if (_onChange !== undefined) _onChange(event);
        actions.handleChangeValue(event);
      }
    }), /*#__PURE__*/React__default$1["default"].createElement("span", {
      className: "tw-ml-2 tw-font-medium bl-text-xs"
    }, item.label)));
  })));
}
/** Components */


var InputContainer$1 = styled__default["default"].div(_templateObject$1R || (_templateObject$1R = _taggedTemplateLiteral(["\n  display: block;\n"])));
var Svg = styled__default["default"].svg(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral(["\n  display: ", ";\n  z-index: 5;\n  position: absolute;\n  left: 4px;\n  bottom: 5px;\n  width: ", "px;\n  height: ", "px;\n  color: ", ";\n"])), function (_ref2) {
  var _ref2$active = _ref2.active,
      active = _ref2$active === void 0 ? false : _ref2$active;
  return active ? "block" : "none";
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 15 : _ref3$size;
  return size;
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 15 : _ref4$size;
  return size;
}, function (_ref5) {
  var _ref5$active = _ref5.active,
      active = _ref5$active === void 0 ? false : _ref5$active;
  return active ? "white" : "transparent";
});
var CheckBoxInput = styled__default["default"].input(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 4;\n  left: 0;\n  top: 50%;\n  bottom: 50%;\n  transform: translateY(-50%);\n\n  &:checked + svg {\n    display: block;\n  }\n\n  &:after {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    top: -2px;\n    left: -1px;\n    position: relative;\n    top: ", "px;\n    background-color: ", ";\n    content: \"\";\n    display: inline-block;\n    visibility: visible;\n    border: 2px solid white;\n  }\n\n  &:checked:after {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    top: -2px;\n    left: -1px;\n    position: relative;\n    top: ", "px;\n    background-color: ", ";\n    content: \"\";\n    display: inline-block;\n    visibility: visible;\n    border: 2px solid white;\n  }\n"])), function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 25 : _ref6$size;
  return size;
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 25 : _ref7$size;
  return size;
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 25 : _ref8$size;
  return size * 0.25;
}, function (_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 25 : _ref9$size;
  return size * -0.25;
}, function (_ref10) {
  var _ref10$disableColor = _ref10.disableColor,
      disableColor = _ref10$disableColor === void 0 ? "#d1d3d1" : _ref10$disableColor;
  return disableColor;
}, function (_ref11) {
  var _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? 25 : _ref11$size;
  return size;
}, function (_ref12) {
  var _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? 25 : _ref12$size;
  return size;
}, function (_ref13) {
  var _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 25 : _ref13$size;
  return size * 0.25;
}, function (_ref14) {
  var _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? 25 : _ref14$size;
  return size * -0.25;
}, getColor({
  success: true,
  withBorder: true
}));
var CheckBox$1 = /*#__PURE__*/React.forwardRef(CheckBox);

var _templateObject$1Q;

var CustomInput$1 = styled__default["default"].input(_templateObject$1Q || (_templateObject$1Q = _taggedTemplateLiteral(["\n  background: transparent;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  box-shadow: none;\n  transition: all linear 95ms;\n\n  &:focus,\n  &:active,\n  &:hover {\n    outline: none;\n    box-shadow: none;\n  }\n"])));

var _templateObject$1P;

var GroupInputRadio = styled__default["default"].label(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteral(["\n  background: transparent;\n  padding: ", "px 0 0 0;\n  transition: all linear 95ms;\n  display: flex;\n  flex-direction: ", ";\n"])), function (_ref) {
  var _ref$hasData = _ref.hasData,
      hasData = _ref$hasData === void 0 ? false : _ref$hasData;
  return hasData ? 15 : 0;
}, function (_ref2) {
  var _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? "column" : _ref2$direction;
  return direction;
});

var _templateObject$1O;

var InputBox = styled__default["default"].div(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteral(["\n  background: transparent;\n  display: grid;\n  z-index: 40;\n  padding: ", "px 0 0 0;\n  transition: all linear 95ms;\n"])), function (_ref) {
  var _ref$hasData = _ref.hasData,
      hasData = _ref$hasData === void 0 ? false : _ref$hasData;
  return hasData ? 15 : 0;
});

var _templateObject$1N;

var background$1 = function background(_ref) {
  var _ref$hiddenBg = _ref.hiddenBg,
      hiddenBg = _ref$hiddenBg === void 0 ? false : _ref$hiddenBg,
      _ref$like = _ref.like,
      like = _ref$like === void 0 ? INPUT : _ref$like,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? false : _ref$success,
      _ref$withBorder = _ref.withBorder,
      withBorder = _ref$withBorder === void 0 ? false : _ref$withBorder,
      backgroundColor = _ref.backgroundColor;
  if (backgroundColor) return backgroundColor;
  if (!hiddenBg) return getColor({
    like: like,
    error: error,
    success: success,
    withBorder: withBorder
  });
  return undefined;
};

var hoverBackground$1 = function hoverBackground(_ref2) {
  var _ref2$hiddenBg = _ref2.hiddenBg,
      hiddenBg = _ref2$hiddenBg === void 0 ? false : _ref2$hiddenBg,
      _ref2$like = _ref2.like,
      like = _ref2$like === void 0 ? INPUT : _ref2$like,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$withBorder = _ref2.withBorder,
      withBorder = _ref2$withBorder === void 0 ? false : _ref2$withBorder;

  if (!hiddenBg) {
    if (error) return getColor({
      like: like,
      error: true,
      success: false,
      withBorder: withBorder
    });
    return getColor({
      like: like,
      error: false,
      success: true,
      withBorder: withBorder
    });
  }

  return undefined;
};

var padding$1 = function padding(_ref3) {
  var _ref3$noPadding = _ref3.noPadding,
      noPadding = _ref3$noPadding === void 0 ? false : _ref3$noPadding;
  return noPadding ? 0 : "0 1.25rem";
};

var height = function height(_ref4) {
  var _ref4$height = _ref4.height,
      $height = _ref4$height === void 0 ? 55 : _ref4$height;
  return $height;
};

var focusWithinBorderWidth$1 = function focusWithinBorderWidth(_ref5) {
  var _ref5$hiddenBg = _ref5.hiddenBg,
      hiddenBg = _ref5$hiddenBg === void 0 ? false : _ref5$hiddenBg;
  return hiddenBg ? 0 : 1;
};

var focusWithinBorderColor$1 = function focusWithinBorderColor(_ref6) {
  var _ref6$like = _ref6.like,
      like = _ref6$like === void 0 ? INPUT : _ref6$like,
      _ref6$hiddenBg = _ref6.hiddenBg,
      hiddenBg = _ref6$hiddenBg === void 0 ? false : _ref6$hiddenBg,
      _ref6$error = _ref6.error,
      error = _ref6$error === void 0 ? false : _ref6$error,
      _ref6$success = _ref6.success,
      success = _ref6$success === void 0 ? false : _ref6$success;
  return hoverBackground$1({
    hiddenBg: hiddenBg,
    like: like,
    error: error,
    success: success,
    withBorder: true
  });
};

var InputContainer = styled__default["default"].div(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", "px;\n  padding: ", ";\n  height: ", "px;\n  position: relative;\n  display: grid;\n  transition: all linear 100ms;\n\n  &:focus-within {\n    background: ", ";\n    border: solid ", "px ", ";\n  }\n"])), background$1, function (_ref7) {
  var _ref7$borderRadius = _ref7.borderRadius,
      borderRadius = _ref7$borderRadius === void 0 ? 10 : _ref7$borderRadius;
  return borderRadius;
}, padding$1, height, hoverBackground$1, focusWithinBorderWidth$1, focusWithinBorderColor$1);

var _templateObject$1M;

var InputLabel = styled__default["default"].div(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteral(["\n  position: ", ";\n  top: ", ";\n  left: ", ";\n  transition: all linear 95ms;\n  font-size: ", ";\n"])), function (_ref) {
  var _ref$noFloat = _ref.noFloat,
      noFloat = _ref$noFloat === void 0 ? false : _ref$noFloat;
  return !noFloat ? "absolute" : "";
}, function (_ref2) {
  var _ref2$noFloat = _ref2.noFloat,
      noFloat = _ref2$noFloat === void 0 ? false : _ref2$noFloat,
      _ref2$top = _ref2.top,
      top = _ref2$top === void 0 ? 15 : _ref2$top;
  return !noFloat && lodash.isNumber(top) ? "".concat(top, "px") : undefined;
}, function (_ref3) {
  var _ref3$noFloat = _ref3.noFloat,
      noFloat = _ref3$noFloat === void 0 ? false : _ref3$noFloat;
  return !noFloat ? "1.25rem" : undefined;
}, function (_ref4) {
  var _ref4$noFloat = _ref4.noFloat,
      noFloat = _ref4$noFloat === void 0 ? false : _ref4$noFloat,
      _ref4$top = _ref4.top,
      top = _ref4$top === void 0 ? 0 : _ref4$top;
  return !noFloat && lodash.isNumber(top) ? "".concat(top, "px") : undefined;
});

var _templateObject$1L;

var InputLabelError = styled__default["default"].div(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteral(["\n  position: ", ";\n  bottom: ", ";\n  left: ", ";\n  transition: all linear 95ms;\n  //  white-space: nowrap;\n  //  overflow: hidden;\n  //  text-overflow: ellipsis;\n\n  @media (max-width: 428px) {\n    bottom: ", ";\n  }\n"])), function (_ref) {
  var _ref$noFloat = _ref.noFloat,
      noFloat = _ref$noFloat === void 0 ? false : _ref$noFloat;
  return !noFloat ? "absolute" : "";
}, function (_ref2) {
  var _ref2$noFloat = _ref2.noFloat,
      noFloat = _ref2$noFloat === void 0 ? false : _ref2$noFloat,
      _ref2$bottom = _ref2.bottom,
      bottom = _ref2$bottom === void 0 ? 5 : _ref2$bottom;
  return !noFloat ? "".concat(bottom, "px") : undefined;
}, function (_ref3) {
  var _ref3$noFloat = _ref3.noFloat,
      noFloat = _ref3$noFloat === void 0 ? false : _ref3$noFloat;
  return !noFloat ? "0.25rem" : undefined;
}, function (_ref4) {
  var _ref4$noFloat = _ref4.noFloat,
      noFloat = _ref4$noFloat === void 0 ? false : _ref4$noFloat,
      _ref4$bottom = _ref4.bottom,
      position = _ref4$bottom === void 0 ? -25 : _ref4$bottom,
      _ref4$length = _ref4.length,
      length = _ref4$length === void 0 ? 0 : _ref4$length,
      _ref4$maxLength = _ref4.maxLength,
      maxLength = _ref4$maxLength === void 0 ? 27 : _ref4$maxLength;
  var isVeryLong = length > maxLength;
  var multiplier = 1.6;
  if (isVeryLong) return "".concat(position * multiplier, "px");
  if (!noFloat) return "".concat(position, "px");
  return undefined;
});

var _templateObject$1K;

var InputLabelText = styled__default["default"].p(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteral(["\n  color: ", ";\n  transition: all linear 95ms;\n  width: 100%;\n"])), getColor);

var _templateObject$1J;

var InputSelect$1 = styled__default["default"].select(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteral(["\n  background: transparent;\n  padding: ", "px 0 0 0;\n  outline: none;\n  box-shadow: none;\n  transition: all linear 125ms;\n\n  &:focus,\n  &:active,\n  &:hover {\n    outline: none;\n    box-shadow: none;\n  }\n"])), function (_ref) {
  var _ref$hasData = _ref.hasData,
      hasData = _ref$hasData === void 0 ? false : _ref$hasData;
  return hasData ? 15 : 0;
});

var _templateObject$1I;

var InputSelectOption = styled__default["default"].option(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteral(["\n  background: transparent;\n"])));

var _templateObject$1H;

var RadioButton = styled__default["default"].input(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteral(["\n  margin: 0 10px 0 0;\n\n  &:after {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    top: -2px;\n    left: -1px;\n    position: relative;\n    background-color: ", ";\n    content: \"\";\n    display: inline-block;\n    visibility: visible;\n    border: 2px solid white;\n  }\n\n  &:checked:after {\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    top: -2px;\n    left: -1px;\n    position: relative;\n    background-color: ", ";\n    content: \"\";\n    display: inline-block;\n    visibility: visible;\n    border: 2px solid white;\n  }\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 17 : _ref$size;
  return size;
}, function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 17 : _ref2$size;
  return size;
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 17 : _ref3$size;
  return size;
}, function (_ref4) {
  var _ref4$disableColor = _ref4.disableColor,
      disableColor = _ref4$disableColor === void 0 ? "#d1d3d1" : _ref4$disableColor;
  return disableColor;
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 17 : _ref5$size;
  return size;
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 17 : _ref6$size;
  return size;
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 17 : _ref7$size;
  return size;
}, getColor({
  success: true,
  withBorder: true
}));

var _templateObject$1G;

var Textarea = styled__default["default"].textarea(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteral(["\n  background: transparent;\n  width: 100%;\n  min-height: ", "px;\n  max-height: ", "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  box-shadow: none;\n  transition: all linear 95ms;\n\n  &:focus,\n  &:active,\n  &:hover {\n    outline: none;\n    box-shadow: none;\n  }\n"])), function (_ref) {
  var _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 100 : _ref$minHeight;
  return minHeight;
}, function (_ref2) {
  var _ref2$maxHeight = _ref2.maxHeight,
      maxHeight = _ref2$maxHeight === void 0 ? 178 : _ref2$maxHeight;
  return maxHeight;
});

var _templateObject$1F;

var background = function background(_ref) {
  var _ref$hiddenBg = _ref.hiddenBg,
      hiddenBg = _ref$hiddenBg === void 0 ? false : _ref$hiddenBg,
      _ref$like = _ref.like,
      like = _ref$like === void 0 ? INPUT : _ref$like,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? false : _ref$success,
      _ref$withBorder = _ref.withBorder,
      withBorder = _ref$withBorder === void 0 ? false : _ref$withBorder,
      backgroundColor = _ref.backgroundColor;
  if (backgroundColor) return backgroundColor;
  if (!hiddenBg) return getColor({
    like: like,
    error: error,
    success: success,
    withBorder: withBorder
  });
  return undefined;
};

var hoverBackground = function hoverBackground(_ref2) {
  var _ref2$hiddenBg = _ref2.hiddenBg,
      hiddenBg = _ref2$hiddenBg === void 0 ? false : _ref2$hiddenBg,
      _ref2$like = _ref2.like,
      like = _ref2$like === void 0 ? INPUT : _ref2$like,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$withBorder = _ref2.withBorder,
      withBorder = _ref2$withBorder === void 0 ? false : _ref2$withBorder;

  if (!hiddenBg) {
    if (error) return getColor({
      like: like,
      error: true,
      success: false,
      withBorder: withBorder
    });
    return getColor({
      like: like,
      error: false,
      success: true,
      withBorder: withBorder
    });
  }

  return undefined;
};

var padding = function padding(_ref3) {
  var _ref3$noPadding = _ref3.noPadding,
      noPadding = _ref3$noPadding === void 0 ? false : _ref3$noPadding;
  return noPadding ? 0 : "0 1.25rem";
};

var focusWithinBorderWidth = function focusWithinBorderWidth(_ref4) {
  var _ref4$hiddenBg = _ref4.hiddenBg,
      hiddenBg = _ref4$hiddenBg === void 0 ? false : _ref4$hiddenBg;
  return hiddenBg ? 0 : 1;
};

var focusWithinBorderColor = function focusWithinBorderColor(_ref5) {
  var _ref5$like = _ref5.like,
      like = _ref5$like === void 0 ? INPUT : _ref5$like,
      _ref5$hiddenBg = _ref5.hiddenBg,
      hiddenBg = _ref5$hiddenBg === void 0 ? false : _ref5$hiddenBg,
      _ref5$error = _ref5.error,
      error = _ref5$error === void 0 ? false : _ref5$error,
      _ref5$success = _ref5.success,
      success = _ref5$success === void 0 ? false : _ref5$success;
  return hoverBackground({
    hiddenBg: hiddenBg,
    like: like,
    error: error,
    success: success,
    withBorder: true
  });
};

var TextareaContainer = styled__default["default"].label(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteral(["\n  padding: 20px 0 0 20px;\n  background: ", ";\n  border-radius: ", "px;\n  padding: ", ";\n  min-height: ", "px;\n  max-height: ", "px;\n  position: relative;\n  display: grid;\n  transition: all linear 100ms;\n\n  &:focus-within {\n    background: ", ";\n    border: solid ", "px ", ";\n  }\n"])), background, function (_ref6) {
  var _ref6$borderRadius = _ref6.borderRadius,
      borderRadius = _ref6$borderRadius === void 0 ? 10 : _ref6$borderRadius;
  return borderRadius;
}, padding, function (_ref7) {
  var _ref7$minHeight = _ref7.minHeight,
      minHeight = _ref7$minHeight === void 0 ? 100 : _ref7$minHeight;
  return minHeight;
}, function (_ref8) {
  var _ref8$maxHeight = _ref8.maxHeight,
      maxHeight = _ref8$maxHeight === void 0 ? 200 : _ref8$maxHeight;
  return maxHeight;
}, hoverBackground, focusWithinBorderWidth, focusWithinBorderColor);

var _templateObject$1E;

var InvisibleBox = styled__default["default"].div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteral(["\n  &,\n  * {\n    visibility: hidden;\n    position: absolute;\n    opacity: 0;\n    top: 0;\n    left: 0;\n    width: 0;\n    min-width: 0;\n    max-width: 0;\n    height: 0;\n    min-width: 0;\n    max-width: 0;\n    z-index: -100;\n  }\n"])));

function Dateline(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 50 : _ref$height,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "dateline" : _ref$type,
      _ref$value = _ref.value,
      $value = _ref$value === void 0 ? undefined : _ref$value,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange;

  var _useInput = useInput({
    type: type,
    formik: formik,
    keyName: keyName,
    isRequired: isRequired,
    disable: disable,
    label: label,
    onChange: _onChange
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var formikValue = payload.formikValue,
      formikError = payload.formikError,
      isTouched = payload.isTouched;
  var $id = keyName || lodash.random(0, 99999999);
  var value = $value || formik ? formikValue || "" : value || "";
  var success = !formikError && !!isTouched && !!value || !!value && isRequired && !!isTouched;
  var error = !!formikError && !!isTouched || !value && isRequired && !!isTouched;
  return /*#__PURE__*/React__default$1["default"].createElement(InputContainer, {
    htmlFor: $id,
    onBlur: actions.onBlur,
    onClick: actions.onClick,
    success: success,
    error: error,
    like: INPUT,
    height: height
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabel, {
    top: true
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    success: success,
    error: error,
    like: INPUT_TEXT,
    className: "bl-text-xxs tw-font-medium"
  }, label, !isRequired && /*#__PURE__*/React__default$1["default"].createElement("span", null, " (Optional)"))), /*#__PURE__*/React__default$1["default"].createElement(CustomInput$1, {
    id: $id,
    name: $id,
    disabled: disable,
    success: success,
    error: error,
    className: "bl-text-sm tw-font-medium bl-text-grayscale-80 tw-pt-4",
    type: "date",
    value: value,
    onChange: function onChange(event) {
      if (_onChange !== undefined) _onChange(event);
      actions.handleChangeValue(event);
    }
  }), !!isTouched || !!error && /*#__PURE__*/React__default$1["default"].createElement(InputLabelError, {
    bottom: error ? -20 : 0
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    error: true,
    like: INPUT_TEXT,
    className: "bl-text-xxs tw-font-medium TEXT__ERROR__FIELD"
  }, formikError)));
}

function FormInput(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? undefined : _ref$name,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? undefined : _ref$autoComplete,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$success = _ref.success,
      $success = _ref$success === void 0 ? undefined : _ref$success,
      _ref$error = _ref.error,
      $error = _ref$error === void 0 ? undefined : _ref$error,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "" : _ref$backgroundColor,
      _ref$hoverBackground = _ref.hoverBackground,
      hoverBackground = _ref$hoverBackground === void 0 ? "" : _ref$hoverBackground,
      _ref$hiddenBg = _ref.hiddenBg,
      hiddenBg = _ref$hiddenBg === void 0 ? false : _ref$hiddenBg,
      _ref$like = _ref.like,
      like = _ref$like === void 0 ? INPUT : _ref$like,
      _ref$withBorder = _ref.withBorder,
      withBorder = _ref$withBorder === void 0 ? false : _ref$withBorder,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 50 : _ref$height,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$value = _ref.value,
      $value = _ref$value === void 0 ? undefined : _ref$value,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? undefined : _ref$minLength,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? undefined : _ref$maxLength,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
      _ref$inputStyles = _ref.inputStyles,
      inputStyles = _ref$inputStyles === void 0 ? {} : _ref$inputStyles,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search;

  var _useInput = useInput({
    type: type,
    keyName: keyName,
    isRequired: isRequired,
    disable: disable,
    label: label,
    onChange: _onChange,
    formik: formik,
    minLength: minLength,
    maxLength: maxLength
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var formikValue = payload.formikValue,
      _payload$formikField = payload.formikField,
      formikField = _payload$formikField === void 0 ? {} : _payload$formikField,
      formikError = payload.formikError,
      isTouched = payload.isTouched;
  var $id = keyName || lodash.random(0, 99999999);
  var value = formik ? formikValue || "" : payload.value || "";
  var success = !formikError && !!isTouched && !!value || !!value && isRequired && !!isTouched;
  var error = !!formikError && !!isTouched || !value && isRequired && !!isTouched;
  if ($value !== undefined) value = $value;
  if ($success !== undefined) success = $success;
  if ($error !== undefined) error = $error;
  return /*#__PURE__*/React__default$1["default"].createElement(InputContainer, _extends$g({
    backgroundColor: backgroundColor,
    hoverBackground: hoverBackground,
    hiddenBg: hiddenBg,
    borderRadius: borderRadius,
    htmlFor: name || $id,
    onBlur: actions.onBlur,
    onClick: actions.onClick,
    success: success,
    error: error,
    withBorder: withBorder,
    like: like,
    height: height,
    className: "FORM__INPUT__CONTAINER FORM_INPUT ".concat(className)
  }, inputStyles, styles), search ? /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "INPUT_SEARCH_ICON"
  }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    fill: "currentColor",
    className: "SEARCH_ICON bi bi-search",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
  }))) : null, search ? /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "INPUT_X_ICON"
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return actions.onClear(true);
    }
  }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "currentColor",
    className: " bi bi-x",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
  })))) : null, /*#__PURE__*/React__default$1["default"].createElement(InputLabel, {
    top: value ? height * 0.08 : height * 0.32
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    success: success,
    error: error,
    like: INPUT_TEXT,
    className: "INPUT_LABEL_TEXT bl-text-xxs tw-font-medium"
  }, search ? /*#__PURE__*/React__default$1["default"].createElement("span", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0") : null, "".concat(label).concat(!isRequired ? " (Optional)" : ""))), /*#__PURE__*/React__default$1["default"].createElement(InputBox, {
    hasData: !!value
  }, /*#__PURE__*/React__default$1["default"].createElement(CustomInput$1, _extends$g({}, formikField, {
    autoComplete: autoComplete,
    id: name || $id,
    name: name || $id,
    disabled: disable,
    type: type,
    success: success,
    error: error,
    className: "bl-text-sm tw-font-medium bl-text-grayscale-80 INPUT_BOX_CUSTOM_INPUT" // placeholder={label}
    ,
    value: value,
    onChange: function onChange(event) {
      if (_onChange !== undefined) _onChange(event);
      actions.handleChangeValue(event);
    }
  }))), !!error && /*#__PURE__*/React__default$1["default"].createElement(InputLabelError, {
    bottom: error ? -20 : 0,
    length: (formikError === null || formikError === void 0 ? void 0 : formikError.length) || 0
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    error: true,
    like: INPUT_TEXT,
    className: "TEXT__ERROR__FIELD bl-text-xxs tw-font-medium"
  }, formikError)));
}

var FormInput$1 = /*#__PURE__*/React.memo(FormInput);

function Radio(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "radio" : _ref$type,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 55 : _ref$height,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange;

  var _useInput = useInput({
    type: type,
    formik: formik,
    keyName: keyName,
    isRequired: isRequired,
    data: data,
    disable: disable,
    label: title,
    onChange: _onChange
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var formikValue = payload.formikValue,
      formikError = payload.formikError,
      isTouched = payload.isTouched;
  var $id = keyName || lodash.random(0, 99999999);
  var value = formik ? formikValue || "" : payload.value || "";
  var success = !formikError && !!isTouched || !!value && isRequired && !!isTouched;
  var error = (!!formikError || !success) && !!isTouched || !value && isRequired && !!isTouched;
  var $direction = "row";

  if (/vertical/gi.test(direction)) {
    $direction = "column";
  }

  return /*#__PURE__*/React__default$1["default"].createElement(InputContainer, {
    hiddenBg: true,
    noPadding: true,
    height: height
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabel, {
    noFloat: true
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    success: success,
    error: error,
    like: INPUT_TEXT,
    className: "bl-text-md tw-font-medium"
  }, title)), /*#__PURE__*/React__default$1["default"].createElement(GroupInputRadio, {
    role: "group",
    htmlFor: $id,
    direction: $direction
  }, payload.options.map(function (item) {
    var itemName = "".concat($id, "-").concat(item.value);
    var isChecked = payload.currentOption.value === item.value;
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: itemName,
      role: "presentation",
      className: "tw-mr-6 tw-flex tw-flex-row tw-justify-start tw-items-center"
    }, /*#__PURE__*/React__default$1["default"].createElement(RadioButton, {
      name: $id,
      id: itemName,
      type: type,
      checked: isChecked,
      value: item.label,
      onBlur: actions.onBlur,
      onClick: actions.onClick,
      onChange: function onChange(event) {
        if (_onChange !== undefined) _onChange(event);
        actions.handleChangeValue(event);
      }
    }), /*#__PURE__*/React__default$1["default"].createElement("span", {
      className: "bl-text-xs tw-font-medium"
    }, item.label));
  })));
}

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$2(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props;
    _this$props.sitekey;
    _this$props.onChange;
    _this$props.theme;
    _this$props.type;
    _this$props.tabindex;
    _this$props.onExpired;
    _this$props.onErrored;
    _this$props.size;
    _this$props.stoken;
    _this$props.grecaptcha;
    _this$props.badge;
    _this$props.hl;

    var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return React__default$1["default"].createElement("div", _extends$4({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(React__default$1["default"].Component);

ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  grecaptcha: PropTypes.object,
  theme: PropTypes.oneOf(["dark", "light"]),
  type: PropTypes.oneOf(["image", "audio"]),
  tabindex: PropTypes.number,
  onExpired: PropTypes.func,
  onErrored: PropTypes.func,
  size: PropTypes.oneOf(["compact", "normal", "invisible"]),
  stoken: PropTypes.string,
  hl: PropTypes.string,
  badge: PropTypes.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;

function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader = /*#__PURE__*/function (_Component) {
      _inheritsLoose$1(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this; // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry


        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props;
        _this$props.asyncScriptOnLoad;

        var forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return React.createElement(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(React.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = React.forwardRef(function (props, ref) {
      return React.createElement(AsyncScriptLoader, _extends$3({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    return hoistNonReactStatics_cjs(ForwardedComponent, WrappedComponent);
  };
}

var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

var RecaptchaWrapper = makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA);

function ReCaptcha(_ref, ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$siteKey = _ref.siteKey,
      siteKey = _ref$siteKey === void 0 ? process.env.GATSBY_RE_CAPTCHA_CLIENT_API_KEY : _ref$siteKey,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$reCaptchaType = _ref.reCaptchaType,
      reCaptchaType = _ref$reCaptchaType === void 0 ? "image" : _ref$reCaptchaType,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
      _ref$onExpired = _ref.onExpired,
      onExpired = _ref$onExpired === void 0 ? undefined : _ref$onExpired,
      _ref$onErrored = _ref.onErrored,
      onErrored = _ref$onErrored === void 0 ? undefined : _ref$onErrored,
      _ref$stoken = _ref.stoken,
      stoken = _ref$stoken === void 0 ? undefined : _ref$stoken,
      _ref$hl = _ref.hl,
      hl = _ref$hl === void 0 ? undefined : _ref$hl,
      _ref$badge = _ref.badge,
      badge = _ref$badge === void 0 ? undefined : _ref$badge,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "normal" : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "light" : _ref$theme,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray$1(_useState, 2),
      showReCaptcha = _useState2[0],
      setShowReCaptcha = _useState2[1];

  var checkboxRef = /*#__PURE__*/React.createRef();
  var data = [{
    id: 0,
    isChecked: false,
    label: label
  }];

  var _useInput = useInput({
    type: "checkbox",
    formik: formik,
    keyName: keyName,
    isRequired: isRequired,
    data: data,
    disable: disable,
    label: label,
    onChange: _onChange
  }),
      actions = _useInput.actions;

  function $onExpired(_x) {
    return _$onExpired.apply(this, arguments);
  }

  function _$onExpired() {
    _$onExpired = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (onExpired !== undefined) onExpired(value);
              _context.next = 3;
              return $setValue(false);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _$onExpired.apply(this, arguments);
  }

  function $onErrored(_x2) {
    return _$onErrored.apply(this, arguments);
  }

  function _$onErrored() {
    _$onErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(error) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (onErrored !== undefined) onErrored(error);
              _context2.next = 3;
              return $setValue(false);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _$onErrored.apply(this, arguments);
  }

  function
  /** value */
  $onChange() {
    return _$onChange.apply(this, arguments);
  }

  function _$onChange() {
    _$onChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return $setValue(true);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _$onChange.apply(this, arguments);
  }

  function $setValue() {
    return _$setValue.apply(this, arguments);
  }

  function _$setValue() {
    _$setValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var isChecked,
          _args4 = arguments;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              isChecked = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : false;

              if (checkboxRef.current) {
                checkboxRef.current.checked = isChecked;

                if (formik) {
                  formik.setFieldValue(keyName, isChecked);
                }
              }

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _$setValue.apply(this, arguments);
  }

  React.useEffect(function () {
    setShowReCaptcha(false);
    setTimeout(function () {
      return setShowReCaptcha(true);
    }, 50);
  }, [formik.dirty]);
  if (!showReCaptcha) return null;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "bl-text-xxs tw-font-medium"
  }, /*#__PURE__*/React__default$1["default"].createElement(InvisibleBox, null, /*#__PURE__*/React__default$1["default"].createElement(CheckBox$1, {
    ref: checkboxRef,
    formik: formik,
    keyName: keyName,
    isRequired: isRequired,
    disable: disable,
    type: type,
    title: label,
    data: data,
    onChange: function onChange(event) {
      if (_onChange !== undefined) _onChange(event);
      actions.handleChangeValue(event, {
        isReCaptcha: true
      });
    }
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-relative tw-z-10"
  }, /*#__PURE__*/React__default$1["default"].createElement(RecaptchaWrapper, {
    ref: ref,
    tabindex: tabIndex,
    badge: badge,
    stoken: stoken,
    hl: hl,
    size: size,
    theme: theme,
    sitekey: siteKey,
    type: reCaptchaType,
    onExpired: $onExpired,
    onErrored: $onErrored,
    onChange: $onChange
  })));
}

var ReCaptcha$1 = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(ReCaptcha));

function Select(_ref) {
  var _payload$currentOptio;

  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "select" : _ref$type,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 50 : _ref$height,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$value = _ref.value,
      $value = _ref$value === void 0 ? undefined : _ref$value,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange;

  var _useInput = useInput({
    type: type,
    formik: formik,
    keyName: keyName,
    isRequired: isRequired,
    data: data,
    disable: disable,
    label: title,
    onChange: _onChange
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var formikValue = payload.formikValue,
      formikError = payload.formikError,
      isTouched = payload.isTouched;
  var $id = keyName || lodash.random(0, 99999999);
  var value = $value || formik ? formikValue || "" : payload.value || "";
  var success = !formikError && !!isTouched && !!value || !!value && isRequired && !!isTouched;
  var error = !!formikError && !!isTouched || !value && isRequired && !!isTouched;
  return /*#__PURE__*/React__default$1["default"].createElement(InputContainer, {
    htmlFor: $id,
    onBlur: actions.onBlur,
    onClick: actions.onClick,
    success: success,
    error: error,
    like: INPUT,
    height: height
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabel, {
    top: true
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    success: success,
    error: error,
    like: INPUT_TEXT,
    className: "bl-text-xxs tw-font-medium"
  }, title, !isRequired && /*#__PURE__*/React__default$1["default"].createElement("span", null, " (Optional)"))), !disable && /*#__PURE__*/React__default$1["default"].createElement(InputSelect$1, {
    hasData: true,
    id: $id,
    name: $id,
    value: (payload === null || payload === void 0 ? void 0 : (_payload$currentOptio = payload.currentOption) === null || _payload$currentOptio === void 0 ? void 0 : _payload$currentOptio.value) || "",
    onChange: function onChange(event) {
      if (_onChange !== undefined) _onChange(event);
      actions.handleChangeValue(event);
    },
    className: "bl-text-sm tw-font-medium bl-text-grayscale-80"
  }, /*#__PURE__*/React__default$1["default"].createElement(InputSelectOption, {
    value: ""
  }, "Select an option"), payload.options.map(function (item, typeIndex) {
    return /*#__PURE__*/React__default$1["default"].createElement(InputSelectOption, {
      key: typeIndex.toString(),
      value: item.value
    }, item.label);
  })), !!isTouched || !!error && /*#__PURE__*/React__default$1["default"].createElement(InputLabelError, {
    bottom: error ? -20 : 0
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    error: true,
    like: INPUT_TEXT,
    className: "TEXT__ERROR__FIELD bl-text-xxs tw-font-medium"
  }, formikError)));
}

function TextareaInput(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? undefined : _ref$name,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? undefined : _ref$autoComplete,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$success = _ref.success,
      $success = _ref$success === void 0 ? undefined : _ref$success,
      _ref$error = _ref.error,
      $error = _ref$error === void 0 ? undefined : _ref$error,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 100 : _ref$minHeight,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 200 : _ref$maxHeight,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$value = _ref.value,
      $value = _ref$value === void 0 ? undefined : _ref$value,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? undefined : _ref$minLength,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? undefined : _ref$maxLength,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
      _ref$inputStyles = _ref.inputStyles,
      inputStyles = _ref$inputStyles === void 0 ? {} : _ref$inputStyles;

  var ref = React.useRef(null);

  var _useInput = useInput({
    type: type,
    keyName: keyName,
    isRequired: isRequired,
    disable: disable,
    label: label,
    onChange: _onChange,
    formik: formik,
    minLength: minLength,
    maxLength: maxLength
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var formikValue = payload.formikValue,
      _payload$formikField = payload.formikField,
      formikField = _payload$formikField === void 0 ? {} : _payload$formikField,
      formikError = payload.formikError,
      isTouched = payload.isTouched;
  var $id = keyName || lodash.random(0, 99999999);
  var value = formik ? formikValue || "" : payload.value || "";
  var success = !formikError && !!isTouched && !!value || !!value && isRequired && !!isTouched;
  var error = !!formikError && !!isTouched || !value && isRequired && !!isTouched;
  if ($value !== undefined) value = $value;
  if ($success !== undefined) success = $success && !!isTouched;
  if ($error !== undefined) error = $error && !!isTouched;
  return /*#__PURE__*/React__default$1["default"].createElement(TextareaContainer, _extends$g({
    htmlFor: name || $id,
    onBlur: actions.onBlur,
    onClick: actions.onClick,
    success: success,
    error: error,
    like: INPUT,
    minHeight: minHeight,
    maxHeight: maxHeight,
    className: className
  }, inputStyles), /*#__PURE__*/React__default$1["default"].createElement(InputLabel, {
    top: value ? 5 : undefined
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    success: success,
    error: error,
    like: INPUT_TEXT,
    className: "bl-text-xxs tw-font-medium LABEL__TEXTAREA"
  }, "".concat(label).concat(!isRequired ? " (Optional)" : ""))), /*#__PURE__*/React__default$1["default"].createElement(InputBox, {
    hasData: false
  }, /*#__PURE__*/React__default$1["default"].createElement(Textarea, _extends$g({
    ref: ref
  }, formikField, {
    autoComplete: autoComplete,
    id: name || $id,
    name: name || $id,
    disabled: disable,
    type: type,
    success: success,
    error: error,
    className: "bl-text-sm tw-font-medium bl-text-grayscale-80" // placeholder={label}
    ,
    value: value,
    onChange: function onChange(event) {
      if (_onChange !== undefined) _onChange(event);
      actions.handleChangeValue(event);
    }
  }))), !!error && /*#__PURE__*/React__default$1["default"].createElement(InputLabelError, {
    bottom: error && ref && ref.current ? -20 : 0
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    error: true,
    like: INPUT_TEXT,
    className: "TEXT__ERROR__FIELD bl-text-xxs tw-font-medium"
  }, formikError)));
}

var TextareaInput$1 = /*#__PURE__*/React.memo(TextareaInput);
var _excluded$V = ["type"];

function InputGenerator(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "" : _ref$type,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$V);

  var id = otherProps.id,
      keyName = otherProps.keyName,
      formik = otherProps.formik,
      data = otherProps.data,
      minLength = otherProps.minLength,
      maxLength = otherProps.maxLength,
      inputStyles = otherProps.inputStyles;
  var typeFormatted = lodash.lowerCase(type);
  var typeSnakeCase = lodash.snakeCase(type).toUpperCase();
  var commonProps = {
    id: id,
    keyName: keyName,
    formik: formik,
    data: data,
    minLength: minLength,
    maxLength: maxLength,
    type: typeFormatted,
    inputStyles: inputStyles
  };

  var componentProps = _objectSpread2(_objectSpread2({}, otherProps.props), commonProps);

  switch (typeSnakeCase) {
    case INPUT_GENERATOR_TYPES.SELECT:
      return /*#__PURE__*/React__default$1["default"].createElement(Select, componentProps);

    case INPUT_GENERATOR_TYPES.TEXTAREA:
      return /*#__PURE__*/React__default$1["default"].createElement(TextareaInput$1, componentProps);

    case INPUT_GENERATOR_TYPES.TEXT:
      return /*#__PURE__*/React__default$1["default"].createElement(FormInput$1, componentProps);

    case INPUT_GENERATOR_TYPES.EMAIL:
      return /*#__PURE__*/React__default$1["default"].createElement(FormInput$1, componentProps);

    case INPUT_GENERATOR_TYPES.NUMBER:
      return /*#__PURE__*/React__default$1["default"].createElement(FormInput$1, componentProps);

    case INPUT_GENERATOR_TYPES.DATELINE:
      return /*#__PURE__*/React__default$1["default"].createElement(Dateline, componentProps);

    case INPUT_GENERATOR_TYPES.RADIO:
      return /*#__PURE__*/React__default$1["default"].createElement(Radio, componentProps);

    case INPUT_GENERATOR_TYPES.CHECKBOX:
      return /*#__PURE__*/React__default$1["default"].createElement(CheckBox$1, componentProps);

    case INPUT_GENERATOR_TYPES.RE_CAPTCHA:
      return /*#__PURE__*/React__default$1["default"].createElement(ReCaptcha$1, componentProps);

    default:
      return null;
  }
}

function FormLinked(_ref) {
  var formik = _ref.formik,
      _ref$relationName = _ref.relationName,
      relationName = _ref$relationName === void 0 ? "" : _ref$relationName,
      _ref$form = _ref.form,
      components = _ref$form === void 0 ? [] : _ref$form,
      _ref$inputs = _ref.inputs,
      inputs = _ref$inputs === void 0 ? [] : _ref$inputs,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 1 : _ref$cols;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  React.useEffect(function () {
    var currentComponent = inputs.find(function (_ref2) {
      var compId = _ref2.id;
      var isThis = lodash.camelCase(compId) === lodash.camelCase(relationName);
      return isThis;
    });
    var formikValue = formik ? formik.values["_".concat(relationName)] : "";
    var hasData = !!formikValue && !lodash.isEmpty(currentComponent);

    if (!!currentComponent && !!currentComponent.type && /radio/i.test(currentComponent.type) && !!formikValue) {
      if (/yes/i.test(formikValue)) setShow(true);else if (/no/i.test(formikValue)) setShow(false);else setShow(hasData);
    }
  }, [inputs, formik.values, relationName]);
  if (!show) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, components.map(function (comp) {
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "".concat(comp.key, "-").concat(comp.id),
      className: "tw-p-0 tw-col-span-1 tw-grid tw-grid-cols-".concat(cols, " tw-gap-4")
    }, comp.inputs.map(function (input) {
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: input.keyName,
        className: "tw-grid tw-grid-cols-1"
      }, /*#__PURE__*/React__default$1["default"].createElement(InputGenerator, _extends$g({}, input, {
        formik: formik
      })));
    }));
  }));
}

var _templateObject$1D;

var FormContainer = styled__default["default"].div(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "3rem 0" : _ref$padding;
  return "\n  padding: ".concat(padding, ";\n");
});

function Form(_ref2) {
  var formik = _ref2.formik,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? "" : _ref2$title,
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? "" : _ref2$description,
      _ref2$inputs = _ref2.inputs,
      components = _ref2$inputs === void 0 ? [] : _ref2$inputs,
      _ref2$links = _ref2.links,
      links = _ref2$links === void 0 ? [] : _ref2$links,
      _ref2$cols = _ref2.cols,
      cols = _ref2$cols === void 0 ? 1 : _ref2$cols,
      _ref2$noGap = _ref2.noGap,
      noGap = _ref2$noGap === void 0 ? false : _ref2$noGap,
      _ref2$noMargin = _ref2.noMargin,
      noMargin = _ref2$noMargin === void 0 ? false : _ref2$noMargin,
      _ref2$inputStyles = _ref2.inputStyles,
      inputStyles = _ref2$inputStyles === void 0 ? {} : _ref2$inputStyles,
      _ref2$formContainerSt = _ref2.formContainerStyles,
      formContainerStyles = _ref2$formContainerSt === void 0 ? {} : _ref2$formContainerSt;
  return /*#__PURE__*/React__default$1["default"].createElement(FormContainer, _extends$g({}, formContainerStyles, {
    className: "FORM_CONTAINER tw-col-span-2 tw-grid tw-grid-cols-1 tw-gap-".concat(noGap ? 0 : 4, " tw-my-").concat(noMargin ? 0 : 4)
  }), /*#__PURE__*/React__default$1["default"].createElement("h4", {
    className: "FORM_CONTAINER__H4 bl-text-md tw-mb-0 tw-font-bold"
  }, title), /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "FORM_CONTAINER__P bl-text-xs tw-mb-0 tw-font-thin"
  }, description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FORM_CONTAINER__CONTAINER_INPUTS tw-p-0 tw-col-span-1 tw-grid tw-grid-cols-".concat(cols, " tw-gap-x-4 tw-gap-y-7")
  }, components.map(function (componentProps) {
    var fullWidthStyle = "";
    var maxColSpan = cols - 1 <= 1 ? cols : cols - 1;

    if (!lodash.isEmpty(componentProps) && !lodash.isEmpty(componentProps.props) && !lodash.isEmpty(componentProps.props.styles) && !!componentProps.props.styles.fullWidth) {
      fullWidthStyle = "tw-col-span-".concat(maxColSpan);
    }

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FORM_CONTAINER__CONTAINER_INPUT tw-grid tw-grid-cols-1 ".concat(fullWidthStyle),
      key: componentProps.keyName
    }, /*#__PURE__*/React__default$1["default"].createElement(InputGenerator, _extends$g({}, componentProps, {
      formik: formik,
      inputStyles: _objectSpread2(_objectSpread2({}, inputStyles), componentProps.inputStyles)
    })));
  })), !lodash.isEmpty(links) && links.map(function (link, linkIndex) {
    return /*#__PURE__*/React__default$1["default"].createElement(FormLinked, _extends$g({
      inputs: components,
      key: "".concat(link.relationName, "-").concat(linkIndex + 1),
      formik: formik,
      cols: cols
    }, link));
  }));
}

function formsService$1() {
  return _formsService$1.apply(this, arguments);
}

function _formsService$1() {
  _formsService$1 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref,
        _ref$financialInstitu,
        financialInstitutionFriendlyName,
        _ref$securedFormFrien,
        securedFormFriendlyName,
        _ref$hostname,
        hostname,
        _ref$formData,
        formData,
        _ref$type,
        type,
        _ref$urlBase,
        urlBase,
        isGet,
        isValidRequestMethod,
        method,
        url,
        options,
        response,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$financialInstitu = _ref.financialInstitutionFriendlyName, financialInstitutionFriendlyName = _ref$financialInstitu === void 0 ? process.env.GATSBY_FINANCIAL_INSTITUTION_FRIENDLY_NAME || "" : _ref$financialInstitu, _ref$securedFormFrien = _ref.securedFormFriendlyName, securedFormFriendlyName = _ref$securedFormFrien === void 0 ? process.env.GATSBY_SECURED_FORM_CONTACT_US || "" : _ref$securedFormFrien, _ref$hostname = _ref.hostname, hostname = _ref$hostname === void 0 ? window.location.hostname : _ref$hostname, _ref$formData = _ref.formData, formData = _ref$formData === void 0 ? {} : _ref$formData, _ref$type = _ref.type, type = _ref$type === void 0 ? "GET" : _ref$type, _ref$urlBase = _ref.urlBase, urlBase = _ref$urlBase === void 0 ? process.env.GATSBY_API_URL : _ref$urlBase;
            _context.prev = 1;
            isGet = /get/gi.test(type);
            isValidRequestMethod = /(get|post)/gi.test(type);

            if (isValidRequestMethod) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Method \"".concat(lodash.upperCase(type), "\" is not supported by this service.")
              }
            });

          case 6:
            if (!(!isGet && lodash.isEmpty(formData))) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              message: "You cannot submit an empty form"
            });

          case 8:
            if (!lodash.isEmpty(securedFormFriendlyName)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form securedFormFriendlyName name is required"
              }
            });

          case 10:
            if (!lodash.isEmpty(hostname)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form hostname name is required"
              }
            });

          case 12:
            if (!lodash.isEmpty(financialInstitutionFriendlyName)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form financialInstitutionFriendlyName name is required"
              }
            });

          case 14:
            method = axios[lodash.lowerCase(type)];
            url = isGet ? "".concat(urlBase, "/secured-form?securedFormFriendlyName=").concat(securedFormFriendlyName, "&hostname=").concat(hostname, "&financialInstitutionFriendlyName=").concat(financialInstitutionFriendlyName) : "".concat(urlBase, "/financial-institution-secured-form-customer");
            options = {
              financialInstitutionFriendlyName: financialInstitutionFriendlyName,
              securedFormFriendlyName: securedFormFriendlyName,
              hostname: hostname,
              securedFormValues: formData
            };
            _context.next = 19;
            return method(url, !isGet ? options : undefined);

          case 19:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](1);

            if (!(!lodash.isEmpty(_context.t0) && _context.t0.response !== undefined && _context.t0.response.status !== undefined && _context.t0.message !== undefined)) {
              _context.next = 27;
              break;
            }

            return _context.abrupt("return", {
              success: false,
              error: {
                metaData: _context.t0,
                fetchMessage: _context.t0.message,
                fetchStatus: _context.t0.response.status,
                message: "An unexpected error occurred. The form was not loaded."
              }
            });

          case 27:
            return _context.abrupt("return", {
              success: false,
              error: {
                metaData: {},
                fetchMessage: "The request has failed, please check the endpoint or other parameters.",
                fetchStatus: 404,
                message: "An unknown error occurred when requesting information, please contact technical support."
              }
            });

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 23]]);
  }));
  return _formsService$1.apply(this, arguments);
}

var _templateObject$1C;

var Legend = styled__default["default"].span(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteral([""])));

function FormApplicationTemplate(_ref) {
  var _ref$submitButtonText = _ref.submitButtonText,
      submitButtonText = _ref$submitButtonText === void 0 ? "SUBMIT APPLICATION" : _ref$submitButtonText,
      _ref$securedFormFrien = _ref.securedFormFriendlyName,
      securedFormFriendlyName = _ref$securedFormFrien === void 0 ? "" : _ref$securedFormFrien,
      _ref$legend = _ref.legend,
      legend = _ref$legend === void 0 ? "" : _ref$legend,
      _ref$buttonStyles = _ref.buttonStyles,
      $buttonStyles = _ref$buttonStyles === void 0 ? undefined : _ref$buttonStyles,
      _ref$buttonCustomStyl = _ref.buttonCustomStyles,
      buttonCustomStyles = _ref$buttonCustomStyl === void 0 ? {} : _ref$buttonCustomStyl,
      _ref$onSubmit = _ref.onSubmit,
      $onSubmit = _ref$onSubmit === void 0 ? undefined : _ref$onSubmit,
      _ref$data = _ref.data,
      demoData = _ref$data === void 0 ? {} : _ref$data,
      _ref$noGap = _ref.noGap,
      noGap = _ref$noGap === void 0 ? false : _ref$noGap,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$noBackground = _ref.noBackground,
      noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
      _ref$centerSubmitBtn = _ref.centerSubmitBtn,
      centerSubmitBtn = _ref$centerSubmitBtn === void 0 ? true : _ref$centerSubmitBtn,
      _ref$inputStyles = _ref.inputStyles,
      inputStyles = _ref$inputStyles === void 0 ? {} : _ref$inputStyles,
      _ref$formContainerSty = _ref.formContainerStyles,
      formContainerStyles = _ref$formContainerSty === void 0 ? {
    submitVisible: true
  } : _ref$formContainerSty;

  var _useState = React.useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      _useState2$ = _useState2[0],
      formData = _useState2$.data,
      options = _useState2$.options,
      setFormData = _useState2[1];

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      showModal = _useModal.showModal,
      closeModal = _useModal.closeModal;

  var _useFormGenerator = useFormGenerator(demoData.options ? demoData.options : options, demoData.data ? demoData.data : formData, {
    onSubmit: onSubmit,
    onValidate: onValidate
  }),
      _useFormGenerator$for = _useFormGenerator.formikValidationModels,
      formikValidationModels = _useFormGenerator$for === void 0 ? {} : _useFormGenerator$for,
      formik = _useFormGenerator.formik,
      _useFormGenerator$inp = _useFormGenerator.inputs,
      inputs = _useFormGenerator$inp === void 0 ? [] : _useFormGenerator$inp;

  var hasInputs = !lodash.isEmpty(inputs);
  var hasErrors = !formik.isValid || !hasInputs;

  function
  /** values, actions */
  onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return showModal();

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              closeModal();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function onAcceptConditions() {
    return _onAcceptConditions.apply(this, arguments);
  }

  function _onAcceptConditions() {
    _onAcceptConditions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var values, setSubmitting, resetForm, resetValues, formDataFormatted, _yield$formsService2, _yield$formsService2$, success;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              values = formik.values, setSubmitting = formik.setSubmitting, resetForm = formik.resetForm;
              resetForm();

              if (!($onSubmit !== undefined)) {
                _context3.next = 8;
                break;
              }

              _context3.next = 6;
              return $onSubmit(values, {
                setSubmitting: setSubmitting
              });

            case 6:
              closeModal();
              return _context3.abrupt("return");

            case 8:
              if (!hasErrors) {
                _context3.next = 11;
                break;
              }

              closeModal();
              return _context3.abrupt("return");

            case 11:
              resetValues = Object.entries(values).reduce(function (acc, _ref10) {
                var _ref11 = _slicedToArray$1(_ref10, 2),
                    key = _ref11[0],
                    value = _ref11[1];

                var $value = /string/gi.test(_typeof$3(value)) ? "" : false;
                return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty$1({}, key, $value));
              }, {});
              formDataFormatted = Object.entries(values).reduce(function (acc, _ref12) {
                var _ref13 = _slicedToArray$1(_ref12, 2),
                    key = _ref13[0],
                    value = _ref13[1];

                var keyName = key.split("_");
                var inputName = keyName[0];
                var inputValueName = keyName[1];

                var item = _objectSpread2({}, acc);

                if (inputName) {
                  item[inputName] = _objectSpread2({}, acc[inputName]);

                  if (!!value && !!inputName && !!inputValueName) {
                    item[inputName] = _objectSpread2(_objectSpread2({}, item[inputName]), {}, _defineProperty$1({}, inputValueName, value));
                  } else item[inputName] = value;
                }

                return item;
              }, {});
              _context3.next = 15;
              return formsService$1({
                securedFormFriendlyName: securedFormFriendlyName,
                type: "POST",
                formData: formDataFormatted
              });

            case 15:
              _yield$formsService2 = _context3.sent;
              _yield$formsService2$ = _yield$formsService2.success;
              success = _yield$formsService2$ === void 0 ? false : _yield$formsService2$;
              closeModal();

              if (success) {
                _context3.next = 24;
                break;
              }

              setFormData(resetValues);
              setSubmitting(false);
              toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                className: "bl-text-sm tw-text-center"
              }, "There was an error submitting the form."), {
                toastId: "fetch-error-ups"
              });
              return _context3.abrupt("return");

            case 24:
              setFormData(resetValues);
              setSubmitting(false);
              toast.success( /*#__PURE__*/React__default$1["default"].createElement("p", {
                className: "bl-text-sm tw-text-center"
              }, "Your form has been successfully submitted."), {
                toastId: "onSubmit"
              });
              _context3.next = 32;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3["catch"](0);
              closeModal();

            case 32:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 29]]);
    }));
    return _onAcceptConditions.apply(this, arguments);
  }

  function
  /** values = {} */
  onValidate() {
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    var errors = {};
    var formikValidationModelsMultiArray = Object.entries(formikValidationModels);
    var formikValuesAsMultiArray = Object.entries(formik.values);
    var requiredValuesAreMissing = formikValuesAsMultiArray.map(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          $itemKey = _ref3[0],
          $itemValue = _ref3[1];

      var $model = formikValidationModelsMultiArray.find(function (_ref4) {
        var _ref5 = _slicedToArray$1(_ref4, 1),
            $key = _ref5[0];

        return $key === $itemKey;
      });
      var $modeRuleIsRequired = !!$model && !!$model[1] && !lodash.isEmpty($model[1]) && $model[1].isRequired;
      return {
        key: $itemKey,
        value: $itemValue,
        isRequired: $modeRuleIsRequired
      };
    }).filter(function ($item) {
      return $item.isRequired;
    });
    requiredValuesAreMissing.forEach(function (missingValue) {
      var formikMissingValue = formik.values[missingValue.key] || "";

      if (missingValue.isRequired && !formikMissingValue) {
        errors[missingValue.key] = "Field \"".concat(missingValue.key, "\" is mandatory ");
      }
    });
    /** Start Validations */

    formikValidationModelsMultiArray.forEach(function (_ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          _ref7$ = _ref7[0],
          inputName = _ref7$ === void 0 ? "" : _ref7$,
          _ref7$2 = _ref7[1],
          inputValidationRules = _ref7$2 === void 0 ? {} : _ref7$2;
      /** Example:
       * console.log(name, inputValidationRules);
       *  Validate Rules
       *    Example:
       *      if (X === Y) {
       *        errors[inputName] = 'Something happened';
       *        showToast(errors[inputName]);
       *      }
       */


      var isNumb = /number/i.test(inputValidationRules.type);
      var isEmail = /email/i.test(inputValidationRules.type);
      /checkbox/i.test(inputValidationRules.type);
      /(date|dateline)/i.test(inputValidationRules.type);
      /reCaptcha/i.test(inputValidationRules.type);
      var formikValue = formik ? formik.values[inputName] : "";
      var formikNumberValue = Number(formikValue);
      var formikValueLength = (formikValue || "").length;
      var maxLengthRule = inputValidationRules.maxLength;
      var minLengthRule = inputValidationRules.minLength;

      if (isEmail && !emailPattern.test(formikValue)) {
        errors[inputName] = "Field is not a valid email address";
      }
      /** Validations with regular expressions */


      if (inputValidationRules.regex && Array.isArray(inputValidationRules.regex) && !lodash.isEmpty(inputValidationRules.regex)) {
        /** traversing regular expressions */
        inputValidationRules.regex.forEach(function (_ref8) {
          var _ref8$labelError = _ref8.labelError,
              message = _ref8$labelError === void 0 ? "" : _ref8$labelError,
              rule = _ref8.rule;
          /** new regular expression */

          var expression = new RegExp(rule);
          var isNotMatched = !expression.test(formikValue);
          /** validating that the value of Formik is valid for the new regular expression */

          if (isNotMatched) {
            errors[inputName] = message;
          }
        });
      }

      if (lodash.isNumber(formikValueLength)) {
        var isValuesNumberGreaterThan = formikValueLength > maxLengthRule;
        var isValuesNumberLessThan = formikValueLength < minLengthRule;

        if (lodash.isNumber(maxLengthRule) && (isValuesNumberGreaterThan || isValuesNumberLessThan)) {
          errors[inputName] = "This field cannot be greater than ".concat(inputValidationRules.maxLength);
        }

        if (lodash.isNumber(minLengthRule) && formikValueLength < minLengthRule) {
          errors[inputName] = "This field cannot be less than ".concat(inputValidationRules.minLength);
        }
      }

      if (isNumb) {
        var _isValuesNumberGreaterThan = formikNumberValue > maxLengthRule;

        var _isValuesNumberLessThan = formikNumberValue < minLengthRule;

        if (!lodash.isNumber(formikNumberValue)) {
          errors[inputName] = "Field is not a number";
        } else {
          if (lodash.isNumber(maxLengthRule) && (_isValuesNumberGreaterThan || _isValuesNumberLessThan)) {
            errors[inputName] = "This field cannot be greater than ".concat(inputValidationRules.maxLength);
          }

          if (lodash.isNumber(minLengthRule) && formikNumberValue < minLengthRule) {
            errors[inputName] = "This field cannot be less than ".concat(inputValidationRules.minLength);
          }
        }
      }

      if (!formikValue && inputValidationRules.isRequired) {
        errors[inputName] = "This field is mandatory";
      }
    });
    /** End Validations */

    return errors;
  }

  React.useEffect(function () {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$formsService, _yield$formsService$s, success, _yield$formsService$d, data, error;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!lodash.isEmpty(demoData)) {
                _context.next = 10;
                break;
              }

              _context.next = 3;
              return formsService$1({
                securedFormFriendlyName: securedFormFriendlyName
              });

            case 3:
              _yield$formsService = _context.sent;
              _yield$formsService$s = _yield$formsService.success;
              success = _yield$formsService$s === void 0 ? false : _yield$formsService$s;
              _yield$formsService$d = _yield$formsService.data;
              data = _yield$formsService$d === void 0 ? {} : _yield$formsService$d;
              error = _yield$formsService.error;

              if (success) {
                setFormData(data.fields);
              } else {
                toast.error("ERROR: ".concat(error.message), {
                  toastId: "fetch-error"
                });
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FORM_APPLICATION tw-grid tw-grid-cols-1 tw-grid-rows-1 ".concat(noBackground ? "" : "tw-bg-gray-50", " tw-p-").concat(noPadding ? 0 : 2, " tw-h-full tw-m-0")
  }, /*#__PURE__*/React__default$1["default"].createElement("form", {
    onSubmit: formik.handleSubmit,
    className: "tw-my-0 ".concat(noMargin ? "" : "tw-mx-auto", " tw-p-").concat(noPadding ? 0 : 2, " tw-max-w-full sm:tw-max-w-3xl tw-flex tw-flex-column tw-justify-start tw-items-center tw-flex-nowrap tw-divide-y FORM_APPLICATION__FORM")
  }, inputs.map(function (inputProps) {
    return /*#__PURE__*/React__default$1["default"].createElement(Form, _extends$g({}, inputProps, {
      noGap: noGap,
      noMargin: noMargin,
      formik: formik,
      key: lodash.camelCase("".concat(inputProps.key || inputProps.title, "-").concat(inputProps.id)),
      inputStyles: inputStyles,
      formContainerStyles: formContainerStyles
    }));
  }), hasInputs && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FORM_APPLICATION__BUTTON__BOX tw-col-span-2 ".concat(centerSubmitBtn ? "tw-text-center" : "")
  }, /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({}, buttonCustomStyles, {
    styleType: buttonStyleTypes.STANDARD,
    fill: buttonFillTypes.FILLED,
    disabled: !!hasErrors,
    className: $buttonStyles || "bl-text-sm",
    type: "submit"
  }), submitButtonText))), !!legend && /*#__PURE__*/React__default$1["default"].createElement(Legend, {
    text: legend
  }), /*#__PURE__*/React__default$1["default"].createElement(ConfirmationModal, {
    message: "Thanks for getting in touch!",
    acceptBtnText: "Send",
    isModalVisible: isModalVisible,
    showModal: showModal,
    closeModal: closeModal,
    onAccept: onAcceptConditions
  }));
}

var _templateObject$1B;

var Title$b = styled__default["default"].h3(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n"])));

function Message(_ref) {
  var data = _ref.data,
      _ref$noGap = _ref.noGap,
      noGap = _ref$noGap === void 0 ? false : _ref$noGap,
      _ref$formTemplateJson = _ref.formTemplateJson,
      formTemplateJson = _ref$formTemplateJson === void 0 ? {} : _ref$formTemplateJson,
      inputStyles = _ref.inputStyles,
      _ref$buttonCustomStyl = _ref.buttonCustomStyles,
      buttonCustomStyles = _ref$buttonCustomStyl === void 0 ? {} : _ref$buttonCustomStyl,
      _ref$formContainerSty = _ref.formContainerStyles,
      formContainerStyles = _ref$formContainerSty === void 0 ? {} : _ref$formContainerSty,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Submit Message" : _ref$buttonText;

  function onSubmitHandler(_x, _x2) {
    return _onSubmitHandler.apply(this, arguments);
  }

  function _onSubmitHandler() {
    _onSubmitHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(formValues, _ref2) {
      var _ref2$setSubmitting, setSubmitting, _ref2$resetForm, resetForm;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$setSubmitting = _ref2.setSubmitting, setSubmitting = _ref2$setSubmitting === void 0 ? function () {
                return null;
              } : _ref2$setSubmitting, _ref2$resetForm = _ref2.resetForm, resetForm = _ref2$resetForm === void 0 ? function () {
                return null;
              } : _ref2$resetForm;
              _context.prev = 1;
              setSubmitting(true);
              _context.next = 5;
              return axios.post("".concat(process.env.GATSBY_API_URL, "/contact-us"), _objectSpread2(_objectSpread2({}, formValues), {}, {
                cu: lodash.kebabCase(process.env.GATSBY_CU_NAME)
              }), {
                headers: {
                  "Content-Type": "application/json"
                }
              });

            case 5:
              toast.success("Your form has been successfully submitted.", {
                toastId: "onSubmit"
              });
              setSubmitting(false);
              resetForm();
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              toast.error("There was an error submitting the form.", {
                toastId: "fetch-error-ups"
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));
    return _onSubmitHandler.apply(this, arguments);
  }

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "MESSAGE_COMPONENT tw-w-full"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$b, {
    className: "MESSAGE_TITLE ContactForm__title tw-font-bold bl-text-primary-180 bl-text-xl"
  }, data.formTitle), /*#__PURE__*/React__default$1["default"].createElement(FormApplicationTemplate, {
    centerSubmitBtn: false,
    noGap: noGap,
    data: formTemplateJson,
    securedFormFriendlyName: process.env.GATSBY_SECURED_FORM_CONTACT_US,
    submitButtonText: buttonText,
    buttonStyles: "bl-text-xxs tw-mb-8",
    buttonCustomStyles: buttonCustomStyles,
    onSubmit: onSubmitHandler,
    noPadding: true,
    noMargin: true,
    noBackground: true,
    inputStyles: inputStyles,
    formContainerStyles: formContainerStyles
  }));
}

var _templateObject$1A, _templateObject2$I, _templateObject3$A, _templateObject4$r, _templateObject5$m, _templateObject6$g;

var Title$a = styled__default["default"].h2(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.BIG : _ref$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref2$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref3$color;
  return getColors(colorsVariantsTypes[color]);
});
var SubTitle = styled__default["default"].p(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref4$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref5) {
  var _ref5$fontFamily = _ref5.fontFamily,
      fontFamily = _ref5$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref5$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsVariantsTypes.WHITE : _ref6$color;
  return getColors(colorsVariantsTypes[color]);
});
var Price = styled__default["default"].p(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref7$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref8) {
  var _ref8$fontFamily = _ref8.fontFamily,
      fontFamily = _ref8$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref8$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref9) {
  var _ref9$color = _ref9.color,
      color = _ref9$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref9$color;
  return getColors(colorsVariantsTypes[color]);
});
var SubPrice = styled__default["default"].p(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral(["\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref10) {
  var _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref10$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref11) {
  var _ref11$fontFamily = _ref11.fontFamily,
      fontFamily = _ref11$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref11$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref12) {
  var _ref12$color = _ref12.color,
      color = _ref12$color === void 0 ? colorsVariantsTypes.LIGHT : _ref12$color;
  return getColors(colorsVariantsTypes[color]);
});
var Container$5 = styled__default["default"].div(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  padding: 0;\n\n  margin-top: ", ";\n\n  margin-bottom: ", ";\n\n  margin-left: ", ";\n\n  margin-right: ", ";\n"])), function (_ref13) {
  var _ref13$marginTop = _ref13.marginTop,
      marginTop = _ref13$marginTop === void 0 ? 0 : _ref13$marginTop;
  return lodash.isNumber(marginTop) ? "".concat(marginTop, "px") : marginTop;
}, function (_ref14) {
  var _ref14$marginBottom = _ref14.marginBottom,
      marginBottom = _ref14$marginBottom === void 0 ? 0 : _ref14$marginBottom;
  return lodash.isNumber(marginBottom) ? "".concat(marginBottom, "px") : marginBottom;
}, function (_ref15) {
  var _ref15$marginLeft = _ref15.marginLeft,
      marginLeft = _ref15$marginLeft === void 0 ? 0 : _ref15$marginLeft;
  return lodash.isNumber(marginLeft) ? "".concat(marginLeft, "px") : marginLeft;
}, function (_ref16) {
  var _ref16$marginRight = _ref16.marginRight,
      marginRight = _ref16$marginRight === void 0 ? 0 : _ref16$marginRight;
  return lodash.isNumber(marginRight) ? "".concat(marginRight, "px") : marginRight;
});
var Content$1 = styled__default["default"].div(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  height: 100%;\n  /*min-width: ", "*/\n  border: 2px solid ", ";\n"])), function (_ref17) {
  var _ref17$width = _ref17.width,
      width = _ref17$width === void 0 ? 250 : _ref17$width;
  return lodash.isNumber(width) ? "".concat(width, "px") : width;
}, getColors(colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT));

function OutlineProduct(_ref18) {
  var _ref18$marginButton = _ref18.marginButton,
      marginButton = _ref18$marginButton === void 0 ? false : _ref18$marginButton,
      _ref18$borderColor = _ref18.borderColor,
      borderColor = _ref18$borderColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref18$borderColor,
      _ref18$buttonFilled = _ref18.buttonFilled,
      buttonFilled = _ref18$buttonFilled === void 0 ? buttonFillTypes.FILLED : _ref18$buttonFilled,
      _ref18$buttonGrayscal = _ref18.buttonGrayscale,
      buttonGrayscale = _ref18$buttonGrayscal === void 0 ? false : _ref18$buttonGrayscal,
      _ref18$buttonHoverCol = _ref18.buttonHoverColor,
      buttonHoverColor = _ref18$buttonHoverCol === void 0 ? false : _ref18$buttonHoverCol,
      _ref18$buttonHoverOut = _ref18.buttonHoverOutline,
      buttonHoverOutline = _ref18$buttonHoverOut === void 0 ? false : _ref18$buttonHoverOut,
      _ref18$buttonStylesPr = _ref18.buttonStylesProps,
      buttonStylesProps = _ref18$buttonStylesPr === void 0 ? {
    withoutBorderRadius: false
  } : _ref18$buttonStylesPr,
      _ref18$buttonText = _ref18.buttonText,
      buttonText = _ref18$buttonText === void 0 ? "" : _ref18$buttonText,
      _ref18$buttonTextFont = _ref18.buttonTextFontFamily,
      buttonTextFontFamily = _ref18$buttonTextFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref18$buttonTextFont,
      _ref18$buttonTextSize = _ref18.buttonTextSize,
      buttonTextSize = _ref18$buttonTextSize === void 0 ? textSizesVariantsTypes.NORMAL : _ref18$buttonTextSize,
      _ref18$buttonUrl = _ref18.buttonUrl,
      buttonUrl = _ref18$buttonUrl === void 0 ? "" : _ref18$buttonUrl,
      _ref18$buttonWithoutB = _ref18.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref18$buttonWithoutB === void 0 ? false : _ref18$buttonWithoutB,
      _ref18$image = _ref18.image,
      image = _ref18$image === void 0 ? {
    alternativeText: "",
    caption: "",
    created_at: "",
    created_by: 1,
    ext: "",
    formats: {
      large: {
        ext: "",
        hash: "",
        height: 563,
        mime: "",
        name: "",
        path: null,
        size: 22.36,
        url: "",
        width: 1000
      },
      medium: {
        ext: "",
        hash: "",
        height: 422,
        mime: "",
        name: "",
        path: null,
        size: 14.5,
        url: "",
        width: 750
      },
      small: {
        ext: "",
        hash: "",
        height: 281,
        mime: "",
        name: "",
        path: null,
        size: 7.96,
        url: "",
        width: 500
      },
      thumbnail: {
        ext: "",
        hash: "",
        height: 138,
        mime: "",
        name: "",
        path: null,
        size: 3.01,
        url: "",
        width: 245
      }
    },
    hash: "",
    height: 844,
    mime: "",
    name: "",
    previewUrl: null,
    provider: "",
    provider_metadata: null,
    size: 32.09,
    updated_at: "",
    updated_by: 1,
    url: "",
    width: 1500
  } : _ref18$image,
      _ref18$marginTop = _ref18.marginTop,
      marginTop = _ref18$marginTop === void 0 ? 0 : _ref18$marginTop,
      _ref18$marginBottom = _ref18.marginBottom,
      marginBottom = _ref18$marginBottom === void 0 ? 0 : _ref18$marginBottom,
      _ref18$marginLeft = _ref18.marginLeft,
      marginLeft = _ref18$marginLeft === void 0 ? 0 : _ref18$marginLeft,
      _ref18$marginRight = _ref18.marginRight,
      marginRight = _ref18$marginRight === void 0 ? 0 : _ref18$marginRight,
      _ref18$price = _ref18.price,
      price = _ref18$price === void 0 ? "" : _ref18$price,
      _ref18$priceColor = _ref18.priceColor,
      priceColor = _ref18$priceColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref18$priceColor,
      _ref18$priceFontFamil = _ref18.priceFontFamily,
      priceFontFamily = _ref18$priceFontFamil === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref18$priceFontFamil,
      _ref18$priceSize = _ref18.priceSize,
      priceSize = _ref18$priceSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref18$priceSize,
      _ref18$priceSubColor = _ref18.priceSubColor,
      priceSubColor = _ref18$priceSubColor === void 0 ? colorsVariantsTypes.LIGHT : _ref18$priceSubColor,
      _ref18$priceSubFontFa = _ref18.priceSubFontFamily,
      priceSubFontFamily = _ref18$priceSubFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref18$priceSubFontFa,
      _ref18$priceSubSize = _ref18.priceSubSize,
      priceSubSize = _ref18$priceSubSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref18$priceSubSize,
      _ref18$priceSubTitle = _ref18.priceSubTitle,
      priceSubTitle = _ref18$priceSubTitle === void 0 ? "" : _ref18$priceSubTitle,
      _ref18$subTitle = _ref18.subTitle,
      subTitle = _ref18$subTitle === void 0 ? "" : _ref18$subTitle,
      _ref18$subTitleColor = _ref18.subTitleColor,
      subTitleColor = _ref18$subTitleColor === void 0 ? colorsVariantsTypes.WHITE : _ref18$subTitleColor,
      _ref18$subTitleFontFa = _ref18.subTitleFontFamily,
      subTitleFontFamily = _ref18$subTitleFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref18$subTitleFontFa,
      _ref18$subTitleSize = _ref18.subTitleSize,
      subTitleSize = _ref18$subTitleSize === void 0 ? textSizesVariantsTypes.SMALL : _ref18$subTitleSize,
      _ref18$title = _ref18.title,
      title = _ref18$title === void 0 ? "" : _ref18$title,
      _ref18$titleColor = _ref18.titleColor,
      titleColor = _ref18$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref18$titleColor,
      _ref18$titleFontFamil = _ref18.titleFontFamily,
      titleFontFamily = _ref18$titleFontFamil === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref18$titleFontFamil,
      _ref18$titleSize = _ref18.titleSize,
      titleSize = _ref18$titleSize === void 0 ? textSizesVariantsTypes.BIG : _ref18$titleSize,
      _ref18$width = _ref18.width,
      width = _ref18$width === void 0 ? 400 : _ref18$width;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$5, {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER tw-mb-6 tw-w-72 md:tw-w-64 md:tw-mb-12 tw-mx-auto",
    marginTop: marginTop,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight
  }, /*#__PURE__*/React__default$1["default"].createElement(Content$1, {
    width: width,
    borderColor: borderColor,
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_content tw-rounded-lg tw-py-6 tw-mb-4"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$a, {
    className: "Product__title PRODUCT__OUTLINE__PRODUCT__CONTAINER_content_title tw-font-bold tw-mb-4",
    color: titleColor || colorsVariantsTypes.PRIMARY,
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.SECONDARY,
    size: titleSize || textSizesVariantsTypes.BIG
  }, title), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_content_img_container tw-mx-auto tw-w-24 tw-h-20 tw-flex tw-items-center tw-mb-5"
  }, image && /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_content_img tw-w-full tw-h-auto tw-object-cover",
    src: image.url,
    alt: (image === null || image === void 0 ? void 0 : image.alternativeText) || ""
  })), /*#__PURE__*/React__default$1["default"].createElement("div", null, /*#__PURE__*/React__default$1["default"].createElement(SubTitle, {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_subtitle tw-mb-2",
    color: subTitleColor,
    fontFamily: subTitleFontFamily,
    size: subTitleSize
  }, subTitle), /*#__PURE__*/React__default$1["default"].createElement(Price, {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_price Product__price tw-font-bold bl-text-3xl tw-leading-none tw-mb-3",
    color: priceColor,
    fontFamily: priceFontFamily,
    size: priceSize
  }, price), /*#__PURE__*/React__default$1["default"].createElement(SubPrice, {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_subprice bl-text-xs tw-m-0 tw-mb-3",
    color: priceSubColor,
    fontFamily: priceSubFontFamily,
    size: priceSubSize
  }, priceSubTitle))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_button_container tw-absolute tw-inset-x-0 tw-bottom-0 tw-flex tw-justify-center tw-z-10"
  }, /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    className: "PRODUCT__OUTLINE__PRODUCT__CONTAINER_button",
    is: "a",
    href: buttonUrl,
    fill: buttonFilled,
    grayscale: buttonGrayscale,
    hoverOutline: buttonHoverOutline,
    withoutBorderRadius: buttonWithoutBorderRadius,
    hoverColor: buttonHoverColor,
    marginButton: marginButton,
    fontFamily: buttonTextFontFamily,
    size: buttonTextSize
  }, buttonStylesProps), buttonText)));
}

OutlineProduct.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  priceSubTitle: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired
};

var _templateObject$1z, _templateObject2$H, _templateObject3$z, _templateObject4$q, _templateObject5$l, _templateObject6$f, _templateObject7$9, _templateObject8$7, _templateObject9$3;

var ProductDividedByGradientContainer = styled__default["default"].div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteral(["\n  & * {\n    box-sizing: border-box;\n  }\n\n  width: ", ";\n  max-width: ", ";\n  height: 100%;\n  min-height: 400px;\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 125px 45px min-content 15px 75px 15px;\n  margin: 0;\n  padding: 0;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    z-index: -1;\n\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n"])), function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width;
  return lodash.isNumber(width) ? "".concat(width, "px") : width;
}, function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return lodash.isNumber(maxWidth) ? "".concat(maxWidth, "px") : maxWidth;
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.WHITE : _ref3$color;
  return getColors(color);
});
var ProductDividedByGradientTitle$1 = styled__default["default"].h5(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  height: 45px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n  margin: 15px 0 0 0;\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref4) {
  var _ref4$columnPosition = _ref4.columnPosition,
      columnPosition = _ref4$columnPosition === void 0 ? 1 : _ref4$columnPosition;
  return columnPosition;
}, function (_ref5) {
  var _ref5$rowPosition = _ref5.rowPosition,
      rowPosition = _ref5$rowPosition === void 0 ? 1 : _ref5$rowPosition;
  return rowPosition;
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref6$size;
  return getTextSize(size);
}, function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref7$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref8$color;
  return getColors(color);
});
var ProductDividedByGradientMetaTex = styled__default["default"].span(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 16px;\n  text-align: center;\n  margin: 0;\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n\n  &:last-child {\n    margin: 0.5rem auto 0 auto;\n  }\n"])), function (_ref9) {
  var _ref9$columnPosition = _ref9.columnPosition,
      columnPosition = _ref9$columnPosition === void 0 ? 1 : _ref9$columnPosition;
  return columnPosition;
}, function (_ref10) {
  var _ref10$rowPosition = _ref10.rowPosition,
      rowPosition = _ref10$rowPosition === void 0 ? 1 : _ref10$rowPosition;
  return rowPosition;
}, function (_ref11) {
  var _ref11$size = _ref11.size,
      size = _ref11$size === void 0 ? textSizesVariantsTypes.NORMAL : _ref11$size;
  return getTextSize(size);
}, function (_ref12) {
  var _ref12$fontFamily = _ref12.fontFamily,
      fontFamily = _ref12$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref12$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref13) {
  var _ref13$color = _ref13.color,
      color = _ref13$color === void 0 ? colorsVariantsTypes.PRIMARY_ULTRA_LIGHT : _ref13$color;
  return getColors(color);
});
var ProductDividedByGradientPercentage = styled__default["default"].span(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  font-style: normal;\n  font-weight: 600;\n  line-height: 70px;\n  text-align: center;\n  margin: 0;\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref14) {
  var _ref14$columnPosition = _ref14.columnPosition,
      columnPosition = _ref14$columnPosition === void 0 ? 1 : _ref14$columnPosition;
  return columnPosition;
}, function (_ref15) {
  var _ref15$rowPosition = _ref15.rowPosition,
      rowPosition = _ref15$rowPosition === void 0 ? 1 : _ref15$rowPosition;
  return rowPosition;
}, function (_ref16) {
  var _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? textSizesVariantsTypes.HEADER_5 : _ref16$size;
  return getTextSize(size);
}, function (_ref17) {
  var _ref17$fontFamily = _ref17.fontFamily,
      fontFamily = _ref17$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref17$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref18) {
  var _ref18$color = _ref18.color,
      color = _ref18$color === void 0 ? colorsVariantsTypes.WHITE : _ref18$color;
  return getColors(color);
});
var ProductDividedByGradientDivider = styled__default["default"].div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  width: 100%;\n  height: ", "px;\n  margin: 15px 0;\n  background: ", ";\n  opacity: ", ";\n"])), function (_ref19) {
  var _ref19$columnPosition = _ref19.columnPosition,
      columnPosition = _ref19$columnPosition === void 0 ? 1 : _ref19$columnPosition;
  return columnPosition;
}, function (_ref20) {
  var _ref20$rowPosition = _ref20.rowPosition,
      rowPosition = _ref20$rowPosition === void 0 ? 1 : _ref20$rowPosition;
  return rowPosition;
}, function (_ref21) {
  var _ref21$height = _ref21.height,
      height = _ref21$height === void 0 ? 4 : _ref21$height;
  return height;
}, function (_ref22) {
  var _ref22$customGradient = _ref22.customGradient,
      customGradient = _ref22$customGradient === void 0 ? colorsTypes.TRANSPARENT : _ref22$customGradient,
      _ref22$color = _ref22.color,
      color = _ref22$color === void 0 ? colorsTypes.PRIMARY : _ref22$color,
      _ref22$gradient = _ref22.gradient,
      gradient = _ref22$gradient === void 0 ? colorsTypes.PRIMARY_DARK : _ref22$gradient,
      _ref22$withoutGradien = _ref22.withoutGradient,
      withoutGradient = _ref22$withoutGradien === void 0 ? false : _ref22$withoutGradien;
  if (withoutGradient) return color;
  if (customGradient) return customGradient;
  return "linear-gradient(264.35deg, ".concat(color, " 2.57%, ").concat(gradient, " 95.51%);");
}, function (_ref23) {
  var _ref23$opacity = _ref23.opacity,
      opacity = _ref23$opacity === void 0 ? 0.5 : _ref23$opacity;
  return opacity;
});
var ProductDividedByGradientImageContainer$1 = styled__default["default"].div(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  width: 100%;\n  height: ", "px;\n  margin: 0;\n"])), function (_ref24) {
  var _ref24$columnPosition = _ref24.columnPosition,
      columnPosition = _ref24$columnPosition === void 0 ? 1 : _ref24$columnPosition;
  return columnPosition;
}, function (_ref25) {
  var _ref25$rowPosition = _ref25.rowPosition,
      rowPosition = _ref25$rowPosition === void 0 ? 1 : _ref25$rowPosition;
  return rowPosition;
}, function (_ref26) {
  var _ref26$height = _ref26.height,
      height = _ref26$height === void 0 ? 125 : _ref26$height;
  return height;
});
var ProductDividedByGradientImage$1 = styled__default["default"].img(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral(["\n  height: ", "px;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 3rem;\n"])), function (_ref27) {
  var _ref27$height = _ref27.height,
      height = _ref27$height === void 0 ? 75 : _ref27$height;
  return height;
});
var ButtonContainer$1 = styled__default["default"].div(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n"])), function (_ref28) {
  var _ref28$columnPosition = _ref28.columnPosition,
      columnPosition = _ref28$columnPosition === void 0 ? 1 : _ref28$columnPosition;
  return columnPosition;
}, function (_ref29) {
  var _ref29$rowPosition = _ref29.rowPosition,
      rowPosition = _ref29$rowPosition === void 0 ? 1 : _ref29$rowPosition;
  return rowPosition;
});
var CustomButton$6 = styled__default["default"](Button$2)(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  width: auto;\n  min-width: 125px;\n  margin: 0;\n"])));

var ProductDividedByGradient$1 = function ProductDividedByGradient(_ref30) {
  var _ref30$buttonHoverOut = _ref30.buttonHoverOutline,
      buttonHoverOutline = _ref30$buttonHoverOut === void 0 ? false : _ref30$buttonHoverOut,
      _ref30$buttonWithoutB = _ref30.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref30$buttonWithoutB === void 0 ? false : _ref30$buttonWithoutB,
      _ref30$buttonGrayscal = _ref30.buttonGrayscale,
      buttonGrayscale = _ref30$buttonGrayscal === void 0 ? false : _ref30$buttonGrayscal,
      _ref30$dividerWithout = _ref30.dividerWithoutGradient,
      dividerWithoutGradient = _ref30$dividerWithout === void 0 ? false : _ref30$dividerWithout,
      _ref30$dividerOpacity = _ref30.dividerOpacity,
      dividerOpacity = _ref30$dividerOpacity === void 0 ? 0.5 : _ref30$dividerOpacity,
      _ref30$productWidth = _ref30.productWidth,
      productWidth = _ref30$productWidth === void 0 ? "100%" : _ref30$productWidth,
      productMaxWidth = _ref30.productMaxWidth,
      _ref30$colorDivider = _ref30.colorDivider,
      colorDivider = _ref30$colorDivider === void 0 ? colorsTypes.PRIMARY_DARK : _ref30$colorDivider,
      _ref30$cssBackgroundG = _ref30.cssBackgroundGradient,
      cssBackgroundGradient = _ref30$cssBackgroundG === void 0 ? "" : _ref30$cssBackgroundG,
      _ref30$gradient = _ref30.gradient,
      gradient = _ref30$gradient === void 0 ? colorsTypes.SECONDARY : _ref30$gradient,
      _ref30$buttonFilled = _ref30.buttonFilled,
      buttonFilled = _ref30$buttonFilled === void 0 ? buttonFillTypes.FILLED : _ref30$buttonFilled,
      _ref30$buttonStylesPr = _ref30.buttonStylesProps,
      buttonStylesProps = _ref30$buttonStylesPr === void 0 ? {
    withoutBorderRadius: false
  } : _ref30$buttonStylesPr,
      _ref30$buttonText = _ref30.buttonText,
      buttonText = _ref30$buttonText === void 0 ? "" : _ref30$buttonText,
      _ref30$buttonTextFont = _ref30.buttonTextFontFamily,
      buttonTextFontFamily = _ref30$buttonTextFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref30$buttonTextFont,
      _ref30$buttonTextSize = _ref30.buttonTextSize,
      buttonTextSize = _ref30$buttonTextSize === void 0 ? textSizesVariantsTypes.NORMAL : _ref30$buttonTextSize,
      _ref30$buttonUrl = _ref30.buttonUrl,
      buttonUrl = _ref30$buttonUrl === void 0 ? "" : _ref30$buttonUrl,
      _ref30$image = _ref30.image,
      image = _ref30$image === void 0 ? {
    alternativeText: "",
    caption: "",
    created_at: "",
    created_by: 1,
    ext: "",
    formats: {
      large: {
        ext: "",
        hash: "",
        height: 563,
        mime: "",
        name: "",
        path: null,
        size: 22.36,
        url: "",
        width: 1000
      },
      medium: {
        ext: "",
        hash: "",
        height: 422,
        mime: "",
        name: "",
        path: null,
        size: 14.5,
        url: "",
        width: 750
      },
      small: {
        ext: "",
        hash: "",
        height: 281,
        mime: "",
        name: "",
        path: null,
        size: 7.96,
        url: "",
        width: 500
      },
      thumbnail: {
        ext: "",
        hash: "",
        height: 138,
        mime: "",
        name: "",
        path: null,
        size: 3.01,
        url: "",
        width: 245
      }
    },
    hash: "",
    height: 844,
    mime: "",
    name: "",
    previewUrl: null,
    provider: "",
    provider_metadata: null,
    size: 32.09,
    updated_at: "",
    updated_by: 1,
    url: "",
    width: 1500
  } : _ref30$image,
      _ref30$marginTop = _ref30.marginTop,
      marginTop = _ref30$marginTop === void 0 ? 0 : _ref30$marginTop,
      _ref30$marginBottom = _ref30.marginBottom,
      marginBottom = _ref30$marginBottom === void 0 ? 0 : _ref30$marginBottom,
      _ref30$marginLeft = _ref30.marginLeft,
      marginLeft = _ref30$marginLeft === void 0 ? 25 : _ref30$marginLeft,
      _ref30$marginRight = _ref30.marginRight,
      marginRight = _ref30$marginRight === void 0 ? 25 : _ref30$marginRight,
      _ref30$price = _ref30.price,
      price = _ref30$price === void 0 ? "" : _ref30$price,
      _ref30$priceColor = _ref30.priceColor,
      priceColor = _ref30$priceColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref30$priceColor,
      _ref30$priceFontFamil = _ref30.priceFontFamily,
      priceFontFamily = _ref30$priceFontFamil === void 0 ? fontsFamiliesTypes.PRIMARY : _ref30$priceFontFamil,
      _ref30$priceSize = _ref30.priceSize,
      priceSize = _ref30$priceSize === void 0 ? textSizesVariantsTypes.HEADER_5 : _ref30$priceSize,
      _ref30$priceSubColor = _ref30.priceSubColor,
      priceSubColor = _ref30$priceSubColor === void 0 ? colorsVariantsTypes.ULTRA_DARK : _ref30$priceSubColor,
      _ref30$priceSubFontFa = _ref30.priceSubFontFamily,
      priceSubFontFamily = _ref30$priceSubFontFa === void 0 ? fontsFamiliesTypes.PRIMARY : _ref30$priceSubFontFa,
      _ref30$priceSubSize = _ref30.priceSubSize,
      priceSubSize = _ref30$priceSubSize === void 0 ? textSizesVariantsTypes.NORMAL : _ref30$priceSubSize,
      _ref30$priceSubTitle = _ref30.priceSubTitle,
      priceSubTitle = _ref30$priceSubTitle === void 0 ? "" : _ref30$priceSubTitle,
      _ref30$subTitle = _ref30.subTitle,
      subTitle = _ref30$subTitle === void 0 ? "" : _ref30$subTitle,
      _ref30$subTitleColor = _ref30.subTitleColor,
      subTitleColor = _ref30$subTitleColor === void 0 ? colorsVariantsTypes.WHITE : _ref30$subTitleColor,
      _ref30$subTitleFontFa = _ref30.subTitleFontFamily,
      subTitleFontFamily = _ref30$subTitleFontFa === void 0 ? fontsFamiliesTypes.PRIMARY : _ref30$subTitleFontFa,
      _ref30$subTitleSize = _ref30.subTitleSize,
      subTitleSize = _ref30$subTitleSize === void 0 ? textSizesVariantsTypes.SMALL : _ref30$subTitleSize,
      _ref30$title = _ref30.title,
      title = _ref30$title === void 0 ? "" : _ref30$title,
      _ref30$titleColor = _ref30.titleColor,
      titleColor = _ref30$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref30$titleColor,
      _ref30$titleFontFamil = _ref30.titleFontFamily,
      titleFontFamily = _ref30$titleFontFamil === void 0 ? fontsFamiliesTypes.SECONDARY : _ref30$titleFontFamil,
      _ref30$titleSize = _ref30.titleSize,
      titleSize = _ref30$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref30$titleSize;
  return /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientContainer, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__CONTAINER",
    width: productWidth,
    maxWidth: productMaxWidth,
    marginTop: marginTop,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight
  }, /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientImageContainer$1, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__IMAGE__CONTAINER",
    rowPosition: 1
  }, !!image && !!image.url && /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientImage$1, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__IMAGE",
    src: process.env.GATSBY_CU_NAME === "bayou" ? "https://d1w2egu22dd0ex.cloudfront.net/".concat(image.url.split("/").pop()) : image.url,
    alt: (image === null || image === void 0 ? void 0 : image.alternativeText) || ""
  })), /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientTitle$1, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__TITLE",
    color: titleColor,
    fontFamily: titleFontFamily,
    size: titleSize,
    rowPosition: 2
  }, title), /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientDivider, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__DIVIDER",
    customGradient: cssBackgroundGradient,
    opacity: dividerOpacity,
    withoutGradient: dividerWithoutGradient,
    color: colorDivider,
    gradient: gradient,
    rowPosition: 3
  }), /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientMetaTex, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__META_TEXT_ROW_4",
    color: subTitleColor,
    fontFamily: subTitleFontFamily,
    size: subTitleSize,
    rowPosition: 4
  }, subTitle), /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientPercentage, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__PERCENTAGE",
    color: priceColor,
    fontFamily: priceFontFamily,
    size: priceSize,
    rowPosition: 5
  }, price), /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientMetaTex, {
    color: priceSubColor,
    fontFamily: priceSubFontFamily,
    size: priceSubSize,
    className: "tw-mt-10 PRODUCT__DIVIDED__BY__GRADIENT__META_TEXT_ROW_6",
    rowPosition: 6
  }, priceSubTitle), /*#__PURE__*/React__default$1["default"].createElement(ButtonContainer$1, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__BUTTON_CONTAINER",
    rowPosition: 7
  }, /*#__PURE__*/React__default$1["default"].createElement(CustomButton$6, _extends$g({
    className: "PRODUCT__DIVIDED__BY__GRADIENT__BUTTON_CONTAINER__CUSTOM_BUTTON",
    is: "a",
    href: buttonUrl,
    grayscale: buttonGrayscale,
    hoverOutline: buttonHoverOutline,
    withoutBorderRadius: buttonWithoutBorderRadius,
    fill: buttonFilled,
    fontFamily: buttonTextFontFamily,
    size: buttonTextSize
  }, buttonStylesProps), !!buttonText && buttonText)));
};

ProductDividedByGradient$1.propTypes = {
  title: PropTypes.string.isRequired,
  // image: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  priceSubTitle: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  color: PropTypes.string,
  gradient: PropTypes.string
};

var _templateObject$1y, _templateObject2$G, _templateObject3$y, _templateObject4$p, _templateObject5$k, _templateObject6$e, _templateObject7$8, _templateObject8$6;

var ProductGradientContainer = styled__default["default"].div(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    max-width: 400px;\n  }\n\n  max-height: 350px;\n  position: relative;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  margin-top: ", ";\n\n  margin-bottom: ", ";\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    z-index: -1;\n    transition: all linear 90ms;\n  }\n\n  &:hover {\n    &::after {\n      background-blend-mode: multiply, normal;\n\n      opacity: ", ";\n\n      background: ", ";\n    }\n  }\n"])), breakpoints.md, function (_ref) {
  var _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === void 0 ? 0 : _ref$marginTop;
  return lodash.isNumber(marginTop) ? "".concat(marginTop, "px") : marginTop;
}, function (_ref2) {
  var _ref2$marginBottom = _ref2.marginBottom,
      marginBottom = _ref2$marginBottom === void 0 ? 0 : _ref2$marginBottom;
  return lodash.isNumber(marginBottom) ? "".concat(marginBottom, "px") : marginBottom;
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsTypes.BLACK : _ref3$color,
      customGradient = _ref3.customGradient,
      _ref3$gradient = _ref3.gradient,
      gradient = _ref3$gradient === void 0 ? colorsTypes.BLACK : _ref3$gradient;
  if (customGradient) return customGradient;
  if (!gradient && !!color) return color;
  return "linear-gradient(".concat(gradient, ", ").concat(color, " 60%)");
}, function (_ref4) {
  var _ref4$hoverOpacity = _ref4.hoverOpacity,
      hoverOpacity = _ref4$hoverOpacity === void 0 ? 0.85 : _ref4$hoverOpacity;
  return hoverOpacity;
}, function (_ref5) {
  var hoverColor = _ref5.hoverColor,
      hoverCustomGradient = _ref5.hoverCustomGradient;
  if (hoverCustomGradient) return hoverCustomGradient;
  if (hoverColor) return hoverColor;
  return undefined;
});
var ProductGradientTitle = styled__default["default"].h5(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral(["\n  margin: 50px 0 0 0;\n  padding: 0 15px;\n  width: 100%;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 39px;\n  text-align: center;\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref6$size;
  return getTextSize(size);
}, function (_ref7) {
  var _ref7$fontFamily = _ref7.fontFamily,
      fontFamily = _ref7$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref7$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.WHITE : _ref8$color;
  return getColors(color);
});
var ProductGradientMetaTex = styled__default["default"].span(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  width: 100%;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 16px;\n  text-align: center;\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? textSizesVariantsTypes.NORMAL : _ref9$size;
  return getTextSize(size);
}, function (_ref10) {
  var _ref10$fontFamily = _ref10.fontFamily,
      fontFamily = _ref10$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref10$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref11) {
  var _ref11$color = _ref11.color,
      color = _ref11$color === void 0 ? colorsVariantsTypes.WHITE : _ref11$color;
  return getColors(color);
});
var ProductGradientPercentage = styled__default["default"].span(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral(["\n  font-weight: bold;\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n  line-height: 1.1;\n  text-align: center;\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref12) {
  var _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? textSizesVariantsTypes.HEADER_2 : _ref12$size;
  return getTextSize(size);
}, function (_ref13) {
  var _ref13$fontFamily = _ref13.fontFamily,
      fontFamily = _ref13$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref13$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref14) {
  var _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? colorsVariantsTypes.WHITE : _ref14$color;
  return getColors(color);
});
var ProductGradientDivider = styled__default["default"].div(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral(["\n  width: 55%;\n  height: ", "px;\n  margin: 30px auto;\n  background: ", ";\n\n  @media (max-width: 640px) {\n    & {\n      margin: 25px auto;\n    }\n  }\n"])), function (_ref15) {
  var _ref15$height = _ref15.height,
      height = _ref15$height === void 0 ? 4 : _ref15$height;
  return height;
}, function (_ref16) {
  var _ref16$color = _ref16.color,
      color = _ref16$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref16$color;
  return color;
});
var MainProdContainer = styled__default["default"].div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral(["\n  margin-left: ", ";\n\n  margin-right: ", ";\n\n  background-color: black;\n"])), function (_ref17) {
  var _ref17$marginLeft = _ref17.marginLeft,
      marginLeft = _ref17$marginLeft === void 0 ? 15 : _ref17$marginLeft;
  return lodash.isNumber(marginLeft) ? "".concat(marginLeft, "px") : marginLeft;
}, function (_ref18) {
  var _ref18$marginRight = _ref18.marginRight,
      marginRight = _ref18$marginRight === void 0 ? 15 : _ref18$marginRight;
  return lodash.isNumber(marginRight) ? "".concat(marginRight, "px") : marginRight;
});
var Spacer$1 = styled__default["default"].div(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var BackgroundImage = styled__default["default"].img(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  bottom: 50%;\n  left: 50%;\n  right: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n  object-fit: cover;\n  z-index: -2;\n"])));

var ProductGradient = function ProductGradient(_ref19) {
  var _ref19$gradient = _ref19.gradient,
      gradient = _ref19$gradient === void 0 ? "" : _ref19$gradient,
      _ref19$customGradient = _ref19.customGradient,
      customGradient = _ref19$customGradient === void 0 ? "linear-gradient(180deg, #4F0017 2.57%, #8E0129 95.51%)" : _ref19$customGradient,
      _ref19$hoverCustomGra = _ref19.hoverCustomGradient,
      hoverCustomGradient = _ref19$hoverCustomGra === void 0 ? "linear-gradient(180deg, #4F0017 2.57%, #8E0129 95.51%)" : _ref19$hoverCustomGra,
      _ref19$buttonGrayscal = _ref19.buttonGrayscale,
      buttonGrayscale = _ref19$buttonGrayscal === void 0 ? true : _ref19$buttonGrayscal,
      _ref19$buttonStylesPr = _ref19.buttonStylesProps,
      buttonStylesProps = _ref19$buttonStylesPr === void 0 ? {
    withoutBorderRadius: false
  } : _ref19$buttonStylesPr,
      _ref19$buttonText = _ref19.buttonText,
      buttonText = _ref19$buttonText === void 0 ? "" : _ref19$buttonText,
      _ref19$buttonTextFont = _ref19.buttonTextFontFamily,
      buttonTextFontFamily = _ref19$buttonTextFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref19$buttonTextFont,
      _ref19$buttonTextSize = _ref19.buttonTextSize,
      buttonTextSize = _ref19$buttonTextSize === void 0 ? textSizesVariantsTypes.SMALL : _ref19$buttonTextSize,
      _ref19$buttonUrl = _ref19.buttonUrl,
      buttonUrl = _ref19$buttonUrl === void 0 ? "" : _ref19$buttonUrl,
      _ref19$image = _ref19.image,
      image = _ref19$image === void 0 ? {
    alternativeText: "",
    caption: "",
    created_at: "",
    created_by: 1,
    ext: "",
    formats: {
      large: {
        ext: "",
        hash: "",
        height: 563,
        mime: "",
        name: "",
        path: null,
        size: 22.36,
        url: "",
        width: 1000
      },
      medium: {
        ext: "",
        hash: "",
        height: 422,
        mime: "",
        name: "",
        path: null,
        size: 14.5,
        url: "",
        width: 750
      },
      small: {
        ext: "",
        hash: "",
        height: 281,
        mime: "",
        name: "",
        path: null,
        size: 7.96,
        url: "",
        width: 500
      },
      thumbnail: {
        ext: "",
        hash: "",
        height: 138,
        mime: "",
        name: "",
        path: null,
        size: 3.01,
        url: "",
        width: 245
      }
    },
    hash: "",
    height: 844,
    mime: "",
    name: "",
    previewUrl: null,
    provider: "",
    provider_metadata: null,
    size: 32.09,
    updated_at: "",
    updated_by: 1,
    url: "",
    width: 1500
  } : _ref19$image,
      _ref19$marginTop = _ref19.marginTop,
      marginTop = _ref19$marginTop === void 0 ? 0 : _ref19$marginTop,
      _ref19$marginBottom = _ref19.marginBottom,
      marginBottom = _ref19$marginBottom === void 0 ? 0 : _ref19$marginBottom,
      _ref19$marginLeft = _ref19.marginLeft,
      marginLeft = _ref19$marginLeft === void 0 ? 25 : _ref19$marginLeft,
      _ref19$marginRight = _ref19.marginRight,
      marginRight = _ref19$marginRight === void 0 ? 25 : _ref19$marginRight,
      _ref19$price = _ref19.price,
      price = _ref19$price === void 0 ? "" : _ref19$price,
      _ref19$priceColor = _ref19.priceColor,
      priceColor = _ref19$priceColor === void 0 ? colorsVariantsTypes.WHITE : _ref19$priceColor,
      _ref19$priceFontFamil = _ref19.priceFontFamily,
      priceFontFamily = _ref19$priceFontFamil === void 0 ? fontsFamiliesTypes.PRIMARY : _ref19$priceFontFamil,
      _ref19$priceSize = _ref19.priceSize,
      priceSize = _ref19$priceSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref19$priceSize,
      _ref19$priceSubColor = _ref19.priceSubColor,
      priceSubColor = _ref19$priceSubColor === void 0 ? colorsVariantsTypes.WHITE : _ref19$priceSubColor,
      _ref19$priceSubFontFa = _ref19.priceSubFontFamily,
      priceSubFontFamily = _ref19$priceSubFontFa === void 0 ? fontsFamiliesTypes.PRIMARY : _ref19$priceSubFontFa,
      _ref19$priceSubSize = _ref19.priceSubSize,
      priceSubSize = _ref19$priceSubSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref19$priceSubSize,
      _ref19$priceSubTitle = _ref19.priceSubTitle,
      priceSubTitle = _ref19$priceSubTitle === void 0 ? "" : _ref19$priceSubTitle,
      _ref19$subTitle = _ref19.subTitle,
      subTitle = _ref19$subTitle === void 0 ? "" : _ref19$subTitle,
      _ref19$subTitleColor = _ref19.subTitleColor,
      subTitleColor = _ref19$subTitleColor === void 0 ? colorsVariantsTypes.WHITE : _ref19$subTitleColor,
      _ref19$subTitleFontFa = _ref19.subTitleFontFamily,
      subTitleFontFamily = _ref19$subTitleFontFa === void 0 ? fontsFamiliesTypes.PRIMARY : _ref19$subTitleFontFa,
      _ref19$subTitleSize = _ref19.subTitleSize,
      subTitleSize = _ref19$subTitleSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref19$subTitleSize,
      _ref19$title = _ref19.title,
      title = _ref19$title === void 0 ? "" : _ref19$title,
      _ref19$titleColor = _ref19.titleColor,
      titleColor = _ref19$titleColor === void 0 ? colorsVariantsTypes.WHITE : _ref19$titleColor,
      _ref19$titleFontFamil = _ref19.titleFontFamily,
      titleFontFamily = _ref19$titleFontFamil === void 0 ? fontsFamiliesTypes.SECONDARY : _ref19$titleFontFamil,
      _ref19$titleSize = _ref19.titleSize,
      titleSize = _ref19$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref19$titleSize;
  return /*#__PURE__*/React__default$1["default"].createElement(MainProdContainer, {
    className: "mainProdContainer"
  }, /*#__PURE__*/React__default$1["default"].createElement(ProductGradientContainer, {
    className: "sm:tw-my-8 PRODUCT__GRADIENT__CONTAINER",
    color: "bule",
    gradient: gradient,
    customGradient: customGradient,
    hoverCustomGradient: hoverCustomGradient // CssBackgroundGradientlinear-gradient(180deg, #4F0017 2.57%, #8E0129 95.51%)
    ,
    marginTop: marginTop || 0,
    marginBottom: marginBottom || 0,
    marginLeft: marginLeft || 25,
    marginRight: marginRight || 25
  }, !!image && !!image.url && /*#__PURE__*/React__default$1["default"].createElement(BackgroundImage, {
    className: "PRODUCT__GRADIENT__CONTAINER__BACKGROUND__IMAGE",
    src: image.url,
    alt: image.alternativeText || ""
  }), /*#__PURE__*/React__default$1["default"].createElement(ProductGradientTitle, {
    className: "PRODUCT__GRADIENT__CONTAINER__PRODUCT__GRADIENT__TITLE",
    color: titleColor || colorsVariantsTypes.WHITE,
    fontFamily: titleFontFamily || fontsFamiliesTypes.SECONDARY,
    size: titleSize || textSizesVariantsTypes.VERY_BIG
  }, title), /*#__PURE__*/React__default$1["default"].createElement(ProductGradientDivider, {
    className: "PRODUCT__GRADIENT__CONTAINER__PRODUCT__GRADIENT__DIVIDER"
  }), /*#__PURE__*/React__default$1["default"].createElement(ProductGradientMetaTex, {
    className: "PRODUCT__GRADIENT__CONTAINER__PRODUCT__GRADIENT__META__TEX_1",
    color: subTitleColor || colorsVariantsTypes.WHITE,
    fontFamily: subTitleFontFamily || fontsFamiliesTypes.PRIMARY,
    size: subTitleSize || textSizesVariantsTypes.VERY_SMALL
  }, subTitle), /*#__PURE__*/React__default$1["default"].createElement(ProductGradientPercentage, {
    className: "PRODUCT__GRADIENT__CONTAINER__PRODUCT__GRADIENT__PERCENTAGE",
    color: priceColor || colorsVariantsTypes.WHITE,
    fontFamily: priceFontFamily || fontsFamiliesTypes.PRIMARY,
    size: priceSize || textSizesVariantsTypes.HEADER_6
  }, price), /*#__PURE__*/React__default$1["default"].createElement(ProductGradientMetaTex, {
    className: "PRODUCT__GRADIENT__CONTAINER__PRODUCT__GRADIENT__META__TEX_2",
    color: priceSubColor || colorsVariantsTypes.WHITE,
    fontFamily: priceSubFontFamily || fontsFamiliesTypes.PRIMARY,
    size: priceSubSize || textSizesVariantsTypes.VERY_SMALL
  }, priceSubTitle), /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    className: "PRODUCT__GRADIENT__CONTAINER__BUTTON",
    is: "a",
    href: buttonUrl,
    fontFamily: buttonTextFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: buttonTextSize || textSizesVariantsTypes.SMALL,
    grayscale: buttonGrayscale
  }, buttonStylesProps), buttonText), /*#__PURE__*/React__default$1["default"].createElement(Spacer$1, {
    className: "PRODUCT__GRADIENT__CONTAINER__SPACER"
  })));
};

ProductGradient.propTypes = {
  title: PropTypes.string.isRequired,
  // image: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  priceSubTitle: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  color: PropTypes.string,
  gradient: PropTypes.string
};

var _templateObject$1x, _templateObject2$F, _templateObject3$x, _templateObject4$o, _templateObject5$j, _templateObject6$d, _templateObject7$7, _templateObject8$5;

var ProductWithoutBorderContainer = styled__default["default"].div(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 50px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    z-index: -1;\n\n    &:hover {\n      opacity: 0.5;\n    }\n  }\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsVariantsTypes.WHITE : _ref$color;
  return getColors(color);
});
var ProductWithoutBorderImage = styled__default["default"].img(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral(["\n  width: 6rem;\n  height: 5rem;\n"])));
var ProductWithoutBorderTitle = styled__default["default"].h5(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  font-size: ", ";\n\n  font-weight: bold;\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n  text-align: center;\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref4$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var ProductWithoutBorderMetaText = styled__default["default"].span(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  font-size: ", ";\n\n  font-weight: 100;\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n  text-align: center;\n  line-height: 1.1;\n"])), function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref5$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref6) {
  var _ref6$fontFamily = _ref6.fontFamily,
      fontFamily = _ref6$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref6$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref7$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var ProductWithoutBorderPercentage = styled__default["default"].span(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-family: ", ";\n\n  font-size: ", ";\n\n  font-weight: bold;\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n  line-height: 1.1;\n  text-align: center;\n"])), function (_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref8$color;
  return getColors(colorsVariantsTypes[color]);
}, function (_ref9) {
  var _ref9$fontFamily = _ref9.fontFamily,
      fontFamily = _ref9$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref9$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref10) {
  var _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? textSizesVariantsTypes.HEADER_4 : _ref10$size;
  return getTextSize(textSizesVariantsTypes[size]);
});
var ProductWithoutBorderDivider = styled__default["default"].div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral(["\n  width: 70%;\n  height: ", "px;\n  margin: 30px auto;\n\n  background: ", ";\n"])), function (_ref11) {
  var _ref11$height = _ref11.height,
      height = _ref11$height === void 0 ? 4 : _ref11$height;
  return height;
}, function (_ref12) {
  var _ref12$color = _ref12.color,
      color = _ref12$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref12$color;
  return getColors(color);
});
var Spacer = styled__default["default"].div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var CustomButton$5 = styled__default["default"](Button$2)(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n  transition: all 0.3s ease-in-out;\n  font-weight: bold;\n  margin: 25px 0 0 0;\n  border-radius: 0;\n\n  background-color: ", ";\n\n  color: ", ";\n\n  &:hover {\n    background-color: transparent;\n\n    color: ", ";\n\n    border: ", ";\n  }\n"])), function (_ref13) {
  var _ref13$background = _ref13.background,
      background = _ref13$background === void 0 ? getColors(colorsVariantsTypes.SECONDARY) : _ref13$background;
  return background;
}, function (_ref14) {
  var _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref14$color;
  return getColors(color);
}, function (_ref15) {
  var _ref15$color = _ref15.color,
      color = _ref15$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref15$color;
  return getColors(color);
}, function (_ref16) {
  var _ref16$background = _ref16.background,
      background = _ref16$background === void 0 ? getColors(colorsVariantsTypes.SECONDARY) : _ref16$background;
  return "".concat(background, " solid 1.5px");
});

var ProductWithoutBorder = function ProductWithoutBorder(_ref17) {
  var title = _ref17.title,
      image = _ref17.image,
      subTitle = _ref17.subTitle,
      price = _ref17.price,
      priceSubTitle = _ref17.priceSubTitle,
      buttonUrl = _ref17.buttonUrl,
      buttonText = _ref17.buttonText,
      _ref17$buttonHoverOut = _ref17.buttonHoverOutline,
      buttonHoverOutline = _ref17$buttonHoverOut === void 0 ? false : _ref17$buttonHoverOut,
      _ref17$buttonWithoutB = _ref17.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref17$buttonWithoutB === void 0 ? false : _ref17$buttonWithoutB,
      _ref17$buttonHoverCol = _ref17.buttonHoverColor,
      buttonHoverColor = _ref17$buttonHoverCol === void 0 ? false : _ref17$buttonHoverCol,
      _ref17$buttonGrayscal = _ref17.buttonGrayscale,
      buttonGrayscale = _ref17$buttonGrayscal === void 0 ? false : _ref17$buttonGrayscal,
      _ref17$bottomColor = _ref17.bottomColor,
      bottomColor = _ref17$bottomColor === void 0 ? "#0C1C4C" : _ref17$bottomColor,
      _ref17$priceColor = _ref17.priceColor,
      priceColor = _ref17$priceColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref17$priceColor,
      _ref17$priceFontFamil = _ref17.priceFontFamily,
      priceFontFamily = _ref17$priceFontFamil === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref17$priceFontFamil,
      _ref17$priceSize = _ref17.priceSize,
      priceSize = _ref17$priceSize === void 0 ? textSizesVariantsTypes.HEADER_6 : _ref17$priceSize,
      _ref17$priceSubColor = _ref17.priceSubColor,
      priceSubColor = _ref17$priceSubColor === void 0 ? colorsVariantsTypes.LIGHT : _ref17$priceSubColor,
      _ref17$priceSubFontFa = _ref17.priceSubFontFamily,
      priceSubFontFamily = _ref17$priceSubFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref17$priceSubFontFa,
      _ref17$priceSubSize = _ref17.priceSubSize,
      priceSubSize = _ref17$priceSubSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref17$priceSubSize,
      _ref17$subTitleColor = _ref17.subTitleColor,
      subTitleColor = _ref17$subTitleColor === void 0 ? colorsVariantsTypes.WHITE : _ref17$subTitleColor,
      _ref17$subTitleFontFa = _ref17.subTitleFontFamily,
      subTitleFontFamily = _ref17$subTitleFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref17$subTitleFontFa,
      _ref17$subTitleSize = _ref17.subTitleSize,
      subTitleSize = _ref17$subTitleSize === void 0 ? textSizesVariantsTypes.SMALL : _ref17$subTitleSize,
      _ref17$titleColor = _ref17.titleColor,
      titleColor = _ref17$titleColor === void 0 ? colorsVariantsTypes.SECONDARY : _ref17$titleColor,
      _ref17$titleFontFamil = _ref17.titleFontFamily,
      titleFontFamily = _ref17$titleFontFamil === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref17$titleFontFamil,
      _ref17$titleSize = _ref17.titleSize,
      titleSize = _ref17$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref17$titleSize,
      _ref17$buttonTextFont = _ref17.buttonTextFontFamily,
      buttonTextFontFamily = _ref17$buttonTextFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref17$buttonTextFont,
      _ref17$buttonTextSize = _ref17.buttonTextSize,
      buttonTextSize = _ref17$buttonTextSize === void 0 ? textSizesVariantsTypes.NORMAL : _ref17$buttonTextSize;
  return /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderContainer, {
    className: "PRODUCT__WITHOUT__BORDER__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderImage, {
    src: image.url,
    alt: (image === null || image === void 0 ? void 0 : image.alternativeText) || "",
    className: "PRODUCT__WITHOUT__BORDER__IMAGE"
  }), /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderTitle, {
    className: "PRODUCT__WITHOUT__BORDER__TITLE",
    color: titleColor || colorsVariantsTypes.SECONDARY,
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: titleSize || textSizesVariantsTypes.VERY_BIG
  }, title), /*#__PURE__*/React__default$1["default"].createElement(Spacer, null), /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderDivider, {
    className: "PRODUCT__WITHOUT__BORDER__DIVIDER"
  }), /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderMetaText, {
    className: "PRODUCT__WITHOUT__BORDER__META__TEXT__1",
    color: subTitleColor || colorsVariantsTypes.SECONDARY,
    fontFamily: subTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: subTitleSize || textSizesVariantsTypes.VERY_SMALL
  }, subTitle), /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderPercentage, {
    className: "PRODUCT__WITHOUT__BORDER__PERCENTAGE",
    color: priceColor || colorsVariantsTypes.SECONDARY,
    fontFamily: priceFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: priceSize || textSizesVariantsTypes.HEADER_4
  }, price), /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorderMetaText, {
    className: "PRODUCT__WITHOUT__BORDER__META__TEXT__2",
    color: priceSubColor || colorsVariantsTypes.SECONDARY,
    fontFamily: priceSubFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
    size: priceSubSize || textSizesVariantsTypes.VERY_SMALL
  }, priceSubTitle), /*#__PURE__*/React__default$1["default"].createElement(Spacer, {
    className: "PRODUCT__WITHOUT__BORDER__SPACER"
  }), /*#__PURE__*/React__default$1["default"].createElement(CustomButton$5, {
    className: "PRODUCT__WITHOUT__BORDER__CUSTOM__BUTTON",
    is: "a",
    href: buttonUrl,
    background: bottomColor,
    hoverOutline: buttonHoverOutline,
    withoutBorderRadius: buttonWithoutBorderRadius,
    hoverColor: buttonHoverColor,
    grayscale: buttonGrayscale,
    fontFamily: buttonTextFontFamily,
    size: buttonTextSize
  }, buttonText));
};

ProductWithoutBorder.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  subTitle: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  priceSubTitle: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired
};

var _templateObject$1w, _templateObject2$E, _templateObject3$w;

var ProductDividedByGradientTitle = styled__default["default"].h5(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  height: 45px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n  margin: 15px 0 0 0;\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref) {
  var _ref$columnPosition = _ref.columnPosition,
      columnPosition = _ref$columnPosition === void 0 ? 1 : _ref$columnPosition;
  return columnPosition;
}, function (_ref2) {
  var _ref2$rowPosition = _ref2.rowPosition,
      rowPosition = _ref2$rowPosition === void 0 ? 1 : _ref2$rowPosition;
  return rowPosition;
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref3$size;
  return getTextSize(size);
}, function (_ref4) {
  var _ref4$fontFamily = _ref4.fontFamily,
      fontFamily = _ref4$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref4$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref5$color;
  return getColors(color);
});
var ProductDividedByGradientImageContainer = styled__default["default"].div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n  grid-column: ", ";\n  grid-row: ", ";\n  width: 100%;\n  height: ", "px;\n  margin: 0;\n"])), function (_ref6) {
  var _ref6$columnPosition = _ref6.columnPosition,
      columnPosition = _ref6$columnPosition === void 0 ? 1 : _ref6$columnPosition;
  return columnPosition;
}, function (_ref7) {
  var _ref7$rowPosition = _ref7.rowPosition,
      rowPosition = _ref7$rowPosition === void 0 ? 1 : _ref7$rowPosition;
  return rowPosition;
}, function (_ref8) {
  var _ref8$height = _ref8.height,
      height = _ref8$height === void 0 ? 125 : _ref8$height;
  return height;
});
var ProductDividedByGradientImage = styled__default["default"].img(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral(["\n  height: ", "px;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 3rem;\n"])), function (_ref9) {
  var _ref9$height = _ref9.height,
      height = _ref9$height === void 0 ? 75 : _ref9$height;
  return height;
});

var ProductDividedByGradient = function ProductDividedByGradient(_ref10) {
  var _ref10$image = _ref10.image,
      image = _ref10$image === void 0 ? {
    alternativeText: "",
    caption: "",
    created_at: "",
    created_by: 1,
    ext: "",
    formats: {
      large: {
        ext: "",
        hash: "",
        height: 563,
        mime: "",
        name: "",
        path: null,
        size: 22.36,
        url: "",
        width: 1000
      },
      medium: {
        ext: "",
        hash: "",
        height: 422,
        mime: "",
        name: "",
        path: null,
        size: 14.5,
        url: "",
        width: 750
      },
      small: {
        ext: "",
        hash: "",
        height: 281,
        mime: "",
        name: "",
        path: null,
        size: 7.96,
        url: "",
        width: 500
      },
      thumbnail: {
        ext: "",
        hash: "",
        height: 138,
        mime: "",
        name: "",
        path: null,
        size: 3.01,
        url: "",
        width: 245
      }
    },
    hash: "",
    height: 844,
    mime: "",
    name: "",
    previewUrl: null,
    provider: "",
    provider_metadata: null,
    size: 32.09,
    updated_at: "",
    updated_by: 1,
    url: "",
    width: 1500
  } : _ref10$image,
      _ref10$title = _ref10.title,
      title = _ref10$title === void 0 ? "" : _ref10$title,
      _ref10$titleColor = _ref10.titleColor,
      titleColor = _ref10$titleColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref10$titleColor,
      _ref10$titleFontFamil = _ref10.titleFontFamily,
      titleFontFamily = _ref10$titleFontFamil === void 0 ? fontsFamiliesTypes.SECONDARY : _ref10$titleFontFamil,
      _ref10$titleSize = _ref10.titleSize,
      titleSize = _ref10$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref10$titleSize,
      _ref10$buttonUrl = _ref10.buttonUrl,
      buttonUrl = _ref10$buttonUrl === void 0 ? "/" : _ref10$buttonUrl;

  var _onClick = function onClick(link) {
    window.location.href = link;
  };

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    role: "button",
    key: title,
    tabIndex: 0,
    className: "PRODUCT__DIVIDED__BY__GRADIENT__CONTAINER",
    onClick: function onClick() {
      return _onClick(buttonUrl);
    },
    onKeyDown: function onKeyDown() {
      return _onClick(buttonUrl);
    }
  }, /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientImageContainer, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__IMAGE__CONTAINER",
    rowPosition: 1
  }, !!image && !!image.url && /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientImage, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__IMAGE",
    src: image.url,
    alt: (image === null || image === void 0 ? void 0 : image.alternativeText) || ""
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__TITLE__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradientTitle, {
    className: "PRODUCT__DIVIDED__BY__GRADIENT__TITLE",
    color: titleColor,
    fontFamily: titleFontFamily,
    size: titleSize,
    rowPosition: 2
  }, title)))));
};

ProductDividedByGradient.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired // // subTitle: PropTypes.string.isRequired,
  // // price: PropTypes.number.isRequired,
  // // priceSubTitle: PropTypes.string.isRequired,

};
var _excluded$U = ["variant", "title", "image", "subTitle", "price", "priceSubTitle", "buttonUrl", "buttonText", "buttonHoverOutline", "buttonWithoutBorderRadius", "buttonHoverColor", "gradientColors", "dividerWithoutGradient", "dividerOpacity", "colorDivider", "borderColor"];

function Product(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? productVariantsTypes.NONE : _ref$variant,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? "" : _ref$image,
      _ref$subTitle = _ref.subTitle,
      subTitle = _ref$subTitle === void 0 ? "" : _ref$subTitle,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? "" : _ref$price,
      _ref$priceSubTitle = _ref.priceSubTitle,
      priceSubTitle = _ref$priceSubTitle === void 0 ? "" : _ref$priceSubTitle,
      _ref$buttonUrl = _ref.buttonUrl,
      buttonUrl = _ref$buttonUrl === void 0 ? "" : _ref$buttonUrl,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "" : _ref$buttonText,
      _ref$buttonHoverOutli = _ref.buttonHoverOutline,
      buttonHoverOutline = _ref$buttonHoverOutli === void 0 ? false : _ref$buttonHoverOutli,
      _ref$buttonWithoutBor = _ref.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref$buttonWithoutBor === void 0 ? false : _ref$buttonWithoutBor,
      _ref$buttonHoverColor = _ref.buttonHoverColor,
      buttonHoverColor = _ref$buttonHoverColor === void 0 ? false : _ref$buttonHoverColor,
      _ref$gradientColors = _ref.gradientColors,
      gradientColors = _ref$gradientColors === void 0 ? [getColors(colorsVariantsTypes.PRIMARY), getColors(colorsVariantsTypes.PRIMARY)] : _ref$gradientColors,
      _ref$dividerWithoutGr = _ref.dividerWithoutGradient,
      dividerWithoutGradient = _ref$dividerWithoutGr === void 0 ? false : _ref$dividerWithoutGr,
      _ref$dividerOpacity = _ref.dividerOpacity,
      dividerOpacity = _ref$dividerOpacity === void 0 ? 0.5 : _ref$dividerOpacity,
      _ref$colorDivider = _ref.colorDivider,
      colorDivider = _ref$colorDivider === void 0 ? getColors(colorsVariantsTypes.PRIMARY_DARK) : _ref$colorDivider,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? "var(--primary-color)" : _ref$borderColor,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$U);

  var _gradientColors = _slicedToArray$1(gradientColors, 2),
      firstGradient = _gradientColors[0],
      secondGradient = _gradientColors[1];

  switch (variant) {
    case productVariantsTypes.OUTLINE:
      return /*#__PURE__*/React__default$1["default"].createElement(OutlineProduct, _extends$g({
        className: "PRODUCT__SWITCH__OUTLINE__PRODUCT",
        title: title,
        image: image,
        subTitle: subTitle,
        price: price,
        priceSubTitle: priceSubTitle,
        buttonUrl: buttonUrl,
        buttonText: buttonText,
        buttonHoverOutline: buttonHoverOutline,
        buttonWithoutBorderRadius: buttonWithoutBorderRadius,
        buttonHoverColor: buttonHoverColor,
        borderColor: borderColor
      }, otherProps));

    case productVariantsTypes.GRADIENT:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "PRODUCT__SWITCH__GRADIENT"
      }, /*#__PURE__*/React__default$1["default"].createElement(ProductGradient, _extends$g({
        className: "PRODUCT__SWITCH__PRODUCT__GRADIENT",
        title: title,
        image: image,
        subTitle: subTitle,
        price: price,
        priceSubTitle: priceSubTitle,
        buttonUrl: buttonUrl,
        buttonText: buttonText,
        buttonHoverOutline: buttonHoverOutline,
        buttonWithoutBorderRadius: buttonWithoutBorderRadius,
        buttonHoverColor: buttonHoverColor
      }, otherProps)));

    case productVariantsTypes.DIVIDED_BY_GRADIENT:
      return /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradient$1, _extends$g({
        className: "PRODUCT__SWITCH__PRODUCT__DIVIDE__BY__GRADIENT",
        title: title,
        image: image,
        subTitle: subTitle,
        price: price,
        priceSubTitle: priceSubTitle,
        buttonUrl: buttonUrl,
        buttonText: buttonText,
        buttonHoverOutline: buttonHoverOutline,
        buttonWithoutBorderRadius: buttonWithoutBorderRadius,
        buttonHoverColor: buttonHoverColor,
        dividerWithoutGradient: dividerWithoutGradient,
        dividerOpacity: dividerOpacity,
        colorDivider: colorDivider,
        gradient: firstGradient,
        grayscale: secondGradient
      }, otherProps));

    case productVariantsTypes.PRODUCT_WITHOUT_BORDER:
      return /*#__PURE__*/React__default$1["default"].createElement(ProductWithoutBorder, _extends$g({
        className: "PRODUCT__SWITCH__PRODUCT__WITHOUT__BORDER",
        title: title,
        image: image,
        subTitle: subTitle,
        price: price,
        priceSubTitle: priceSubTitle,
        buttonUrl: buttonUrl,
        buttonText: buttonText,
        buttonHoverOutline: buttonHoverOutline,
        buttonWithoutBorderRadius: buttonWithoutBorderRadius,
        buttonHoverColor: buttonHoverColor
      }, otherProps));

    case productVariantsTypes.IMAGE_AND_TITLE:
      return /*#__PURE__*/React__default$1["default"].createElement(ProductDividedByGradient, _extends$g({
        className: "PRODUCT__SWITCH__PRODUCT__DIVIDE__BY__GRADIENT",
        title: title,
        image: image,
        subTitle: subTitle,
        price: price,
        priceSubTitle: priceSubTitle,
        buttonUrl: buttonUrl,
        buttonText: buttonText,
        buttonHoverOutline: buttonHoverOutline,
        buttonWithoutBorderRadius: buttonWithoutBorderRadius,
        buttonHoverColor: buttonHoverColor,
        dividerWithoutGradient: dividerWithoutGradient,
        dividerOpacity: dividerOpacity,
        colorDivider: colorDivider,
        gradient: firstGradient,
        grayscale: secondGradient
      }, otherProps));

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

Product.propTypes = {
  variant: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  priceSubTitle: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired
};
var reactSlideshowImage_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e(React__default$1["default"]);
  }(commonjsGlobal$1, function (t) {
    return function () {
      var e = {
        787: function _(e) {
          e.exports = t;
        }
      },
          i = {};

      function n(t) {
        var r = i[t];
        if (void 0 !== r) return r.exports;
        var o = i[t] = {
          exports: {}
        };
        return e[t](o, o.exports, n), o.exports;
      }

      n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return n.d(e, {
          a: e
        }), e;
      }, n.d = function (t, e) {
        for (var i in e) {
          n.o(e, i) && !n.o(t, i) && Object.defineProperty(t, i, {
            enumerable: !0,
            get: e[i]
          });
        }
      }, n.g = function () {
        if ("object" == typeof globalThis) return globalThis;

        try {
          return this || new Function("return this")();
        } catch (t) {
          if ("object" == typeof window) return window;
        }
      }(), n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      };
      var r = {};
      return function () {
        n.r(r), n.d(r, {
          Fade: function Fade() {
            return mt;
          },
          Slide: function Slide() {
            return ht;
          },
          Zoom: function Zoom() {
            return Tt;
          }
        });

        var t,
            e = n(787),
            i = n.n(e),
            o = {
          Linear: {
            None: function None(t) {
              return t;
            }
          },
          Quadratic: {
            In: function In(t) {
              return t * t;
            },
            Out: function Out(t) {
              return t * (2 - t);
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1);
            }
          },
          Cubic: {
            In: function In(t) {
              return t * t * t;
            },
            Out: function Out(t) {
              return --t * t * t + 1;
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2);
            }
          },
          Quartic: {
            In: function In(t) {
              return t * t * t * t;
            },
            Out: function Out(t) {
              return 1 - --t * t * t * t;
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2);
            }
          },
          Quintic: {
            In: function In(t) {
              return t * t * t * t * t;
            },
            Out: function Out(t) {
              return --t * t * t * t * t + 1;
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2);
            }
          },
          Sinusoidal: {
            In: function In(t) {
              return 1 - Math.cos(t * Math.PI / 2);
            },
            Out: function Out(t) {
              return Math.sin(t * Math.PI / 2);
            },
            InOut: function InOut(t) {
              return .5 * (1 - Math.cos(Math.PI * t));
            }
          },
          Exponential: {
            In: function In(t) {
              return 0 === t ? 0 : Math.pow(1024, t - 1);
            },
            Out: function Out(t) {
              return 1 === t ? 1 : 1 - Math.pow(2, -10 * t);
            },
            InOut: function InOut(t) {
              return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? .5 * Math.pow(1024, t - 1) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
            }
          },
          Circular: {
            In: function In(t) {
              return 1 - Math.sqrt(1 - t * t);
            },
            Out: function Out(t) {
              return Math.sqrt(1 - --t * t);
            },
            InOut: function InOut(t) {
              return (t *= 2) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
            }
          },
          Elastic: {
            In: function In(t) {
              return 0 === t ? 0 : 1 === t ? 1 : -Math.pow(2, 10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI);
            },
            Out: function Out(t) {
              return 0 === t ? 0 : 1 === t ? 1 : Math.pow(2, -10 * t) * Math.sin(5 * (t - .1) * Math.PI) + 1;
            },
            InOut: function InOut(t) {
              return 0 === t ? 0 : 1 === t ? 1 : (t *= 2) < 1 ? -.5 * Math.pow(2, 10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI) : .5 * Math.pow(2, -10 * (t - 1)) * Math.sin(5 * (t - 1.1) * Math.PI) + 1;
            }
          },
          Back: {
            In: function In(t) {
              var e = 1.70158;
              return t * t * ((e + 1) * t - e);
            },
            Out: function Out(t) {
              var e = 1.70158;
              return --t * t * ((e + 1) * t + e) + 1;
            },
            InOut: function InOut(t) {
              var e = 2.5949095;
              return (t *= 2) < 1 ? t * t * ((e + 1) * t - e) * .5 : .5 * ((t -= 2) * t * ((e + 1) * t + e) + 2);
            }
          },
          Bounce: {
            In: function In(t) {
              return 1 - o.Bounce.Out(1 - t);
            },
            Out: function Out(t) {
              return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
            },
            InOut: function InOut(t) {
              return t < .5 ? .5 * o.Bounce.In(2 * t) : .5 * o.Bounce.Out(2 * t - 1) + .5;
            }
          }
        },
            s = "undefined" == typeof self && "undefined" != typeof process && process.hrtime ? function () {
          var t = process.hrtime();
          return 1e3 * t[0] + t[1] / 1e6;
        } : "undefined" != typeof self && void 0 !== self.performance && void 0 !== self.performance.now ? self.performance.now.bind(self.performance) : void 0 !== Date.now ? Date.now : function () {
          return new Date().getTime();
        },
            a = function () {
          function t() {
            this._tweens = {}, this._tweensAddedDuringUpdate = {};
          }

          return t.prototype.getAll = function () {
            var t = this;
            return Object.keys(this._tweens).map(function (e) {
              return t._tweens[e];
            });
          }, t.prototype.removeAll = function () {
            this._tweens = {};
          }, t.prototype.add = function (t) {
            this._tweens[t.getId()] = t, this._tweensAddedDuringUpdate[t.getId()] = t;
          }, t.prototype.remove = function (t) {
            delete this._tweens[t.getId()], delete this._tweensAddedDuringUpdate[t.getId()];
          }, t.prototype.update = function (t, e) {
            void 0 === t && (t = s()), void 0 === e && (e = !1);
            var i = Object.keys(this._tweens);
            if (0 === i.length) return !1;

            for (; i.length > 0;) {
              this._tweensAddedDuringUpdate = {};

              for (var n = 0; n < i.length; n++) {
                var r = this._tweens[i[n]],
                    o = !e;
                r && !1 === r.update(t, o) && !e && delete this._tweens[i[n]];
              }

              i = Object.keys(this._tweensAddedDuringUpdate);
            }

            return !0;
          }, t;
        }(),
            u = {
          Linear: function Linear(t, e) {
            var i = t.length - 1,
                n = i * e,
                r = Math.floor(n),
                o = u.Utils.Linear;
            return e < 0 ? o(t[0], t[1], n) : e > 1 ? o(t[i], t[i - 1], i - n) : o(t[r], t[r + 1 > i ? i : r + 1], n - r);
          },
          Bezier: function Bezier(t, e) {
            for (var i = 0, n = t.length - 1, r = Math.pow, o = u.Utils.Bernstein, s = 0; s <= n; s++) {
              i += r(1 - e, n - s) * r(e, s) * t[s] * o(n, s);
            }

            return i;
          },
          CatmullRom: function CatmullRom(t, e) {
            var i = t.length - 1,
                n = i * e,
                r = Math.floor(n),
                o = u.Utils.CatmullRom;
            return t[0] === t[i] ? (e < 0 && (r = Math.floor(n = i * (1 + e))), o(t[(r - 1 + i) % i], t[r], t[(r + 1) % i], t[(r + 2) % i], n - r)) : e < 0 ? t[0] - (o(t[0], t[0], t[1], t[1], -n) - t[0]) : e > 1 ? t[i] - (o(t[i], t[i], t[i - 1], t[i - 1], n - i) - t[i]) : o(t[r ? r - 1 : 0], t[r], t[i < r + 1 ? i : r + 1], t[i < r + 2 ? i : r + 2], n - r);
          },
          Utils: {
            Linear: function Linear(t, e, i) {
              return (e - t) * i + t;
            },
            Bernstein: function Bernstein(t, e) {
              var i = u.Utils.Factorial;
              return i(t) / i(e) / i(t - e);
            },
            Factorial: (t = [1], function (e) {
              var i = 1;
              if (t[e]) return t[e];

              for (var n = e; n > 1; n--) {
                i *= n;
              }

              return t[e] = i, i;
            }),
            CatmullRom: function CatmullRom(t, e, i, n, r) {
              var o = .5 * (i - t),
                  s = .5 * (n - e),
                  a = r * r;
              return (2 * e - 2 * i + o + s) * (r * a) + (-3 * e + 3 * i - 2 * o - s) * a + o * r + e;
            }
          }
        },
            c = function () {
          function t() {}

          return t.nextId = function () {
            return t._nextId++;
          }, t._nextId = 0, t;
        }(),
            h = new a(),
            l = function () {
          function t(t, e) {
            void 0 === e && (e = h), this._object = t, this._group = e, this._isPaused = !1, this._pauseStart = 0, this._valuesStart = {}, this._valuesEnd = {}, this._valuesStartRepeat = {}, this._duration = 1e3, this._initialRepeat = 0, this._repeat = 0, this._yoyo = !1, this._isPlaying = !1, this._reversed = !1, this._delayTime = 0, this._startTime = 0, this._easingFunction = o.Linear.None, this._interpolationFunction = u.Linear, this._chainedTweens = [], this._onStartCallbackFired = !1, this._id = c.nextId(), this._isChainStopped = !1, this._goToEnd = !1;
          }

          return t.prototype.getId = function () {
            return this._id;
          }, t.prototype.isPlaying = function () {
            return this._isPlaying;
          }, t.prototype.isPaused = function () {
            return this._isPaused;
          }, t.prototype.to = function (t, e) {
            return this._valuesEnd = Object.create(t), void 0 !== e && (this._duration = e), this;
          }, t.prototype.duration = function (t) {
            return this._duration = t, this;
          }, t.prototype.start = function (t) {
            if (this._isPlaying) return this;
            if (this._group && this._group.add(this), this._repeat = this._initialRepeat, this._reversed) for (var e in this._reversed = !1, this._valuesStartRepeat) {
              this._swapEndStartRepeatValues(e), this._valuesStart[e] = this._valuesStartRepeat[e];
            }
            return this._isPlaying = !0, this._isPaused = !1, this._onStartCallbackFired = !1, this._isChainStopped = !1, this._startTime = void 0 !== t ? "string" == typeof t ? s() + parseFloat(t) : t : s(), this._startTime += this._delayTime, this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat), this;
          }, t.prototype._setupProperties = function (t, e, i, n) {
            for (var r in i) {
              var o = t[r],
                  s = Array.isArray(o),
                  a = s ? "array" : typeof o,
                  u = !s && Array.isArray(i[r]);

              if ("undefined" !== a && "function" !== a) {
                if (u) {
                  var c = i[r];
                  if (0 === c.length) continue;
                  c = c.map(this._handleRelativeValue.bind(this, o)), i[r] = [o].concat(c);
                }

                if ("object" !== a && !s || !o || u) void 0 === e[r] && (e[r] = o), s || (e[r] *= 1), n[r] = u ? i[r].slice().reverse() : e[r] || 0;else {
                  for (var h in e[r] = s ? [] : {}, o) {
                    e[r][h] = o[h];
                  }

                  n[r] = s ? [] : {}, this._setupProperties(o, e[r], i[r], n[r]);
                }
              }
            }
          }, t.prototype.stop = function () {
            return this._isChainStopped || (this._isChainStopped = !0, this.stopChainedTweens()), this._isPlaying ? (this._group && this._group.remove(this), this._isPlaying = !1, this._isPaused = !1, this._onStopCallback && this._onStopCallback(this._object), this) : this;
          }, t.prototype.end = function () {
            return this._goToEnd = !0, this.update(1 / 0), this;
          }, t.prototype.pause = function (t) {
            return void 0 === t && (t = s()), this._isPaused || !this._isPlaying || (this._isPaused = !0, this._pauseStart = t, this._group && this._group.remove(this)), this;
          }, t.prototype.resume = function (t) {
            return void 0 === t && (t = s()), this._isPaused && this._isPlaying ? (this._isPaused = !1, this._startTime += t - this._pauseStart, this._pauseStart = 0, this._group && this._group.add(this), this) : this;
          }, t.prototype.stopChainedTweens = function () {
            for (var t = 0, e = this._chainedTweens.length; t < e; t++) {
              this._chainedTweens[t].stop();
            }

            return this;
          }, t.prototype.group = function (t) {
            return this._group = t, this;
          }, t.prototype.delay = function (t) {
            return this._delayTime = t, this;
          }, t.prototype.repeat = function (t) {
            return this._initialRepeat = t, this._repeat = t, this;
          }, t.prototype.repeatDelay = function (t) {
            return this._repeatDelayTime = t, this;
          }, t.prototype.yoyo = function (t) {
            return this._yoyo = t, this;
          }, t.prototype.easing = function (t) {
            return this._easingFunction = t, this;
          }, t.prototype.interpolation = function (t) {
            return this._interpolationFunction = t, this;
          }, t.prototype.chain = function () {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            return this._chainedTweens = t, this;
          }, t.prototype.onStart = function (t) {
            return this._onStartCallback = t, this;
          }, t.prototype.onUpdate = function (t) {
            return this._onUpdateCallback = t, this;
          }, t.prototype.onRepeat = function (t) {
            return this._onRepeatCallback = t, this;
          }, t.prototype.onComplete = function (t) {
            return this._onCompleteCallback = t, this;
          }, t.prototype.onStop = function (t) {
            return this._onStopCallback = t, this;
          }, t.prototype.update = function (t, e) {
            if (void 0 === t && (t = s()), void 0 === e && (e = !0), this._isPaused) return !0;
            var i,
                n,
                r = this._startTime + this._duration;

            if (!this._goToEnd && !this._isPlaying) {
              if (t > r) return !1;
              e && this.start(t);
            }

            if (this._goToEnd = !1, t < this._startTime) return !0;
            !1 === this._onStartCallbackFired && (this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), n = (t - this._startTime) / this._duration, n = 0 === this._duration || n > 1 ? 1 : n;

            var o = this._easingFunction(n);

            if (this._updateProperties(this._object, this._valuesStart, this._valuesEnd, o), this._onUpdateCallback && this._onUpdateCallback(this._object, n), 1 === n) {
              if (this._repeat > 0) {
                for (i in isFinite(this._repeat) && this._repeat--, this._valuesStartRepeat) {
                  this._yoyo || "string" != typeof this._valuesEnd[i] || (this._valuesStartRepeat[i] = this._valuesStartRepeat[i] + parseFloat(this._valuesEnd[i])), this._yoyo && this._swapEndStartRepeatValues(i), this._valuesStart[i] = this._valuesStartRepeat[i];
                }

                return this._yoyo && (this._reversed = !this._reversed), void 0 !== this._repeatDelayTime ? this._startTime = t + this._repeatDelayTime : this._startTime = t + this._delayTime, this._onRepeatCallback && this._onRepeatCallback(this._object), !0;
              }

              this._onCompleteCallback && this._onCompleteCallback(this._object);

              for (var a = 0, u = this._chainedTweens.length; a < u; a++) {
                this._chainedTweens[a].start(this._startTime + this._duration);
              }

              return this._isPlaying = !1, !1;
            }

            return !0;
          }, t.prototype._updateProperties = function (t, e, i, n) {
            for (var r in i) {
              if (void 0 !== e[r]) {
                var o = e[r] || 0,
                    s = i[r],
                    a = Array.isArray(t[r]),
                    u = Array.isArray(s);
                !a && u ? t[r] = this._interpolationFunction(s, n) : "object" == typeof s && s ? this._updateProperties(t[r], o, s, n) : "number" == typeof (s = this._handleRelativeValue(o, s)) && (t[r] = o + (s - o) * n);
              }
            }
          }, t.prototype._handleRelativeValue = function (t, e) {
            return "string" != typeof e ? e : "+" === e.charAt(0) || "-" === e.charAt(0) ? t + parseFloat(e) : parseFloat(e);
          }, t.prototype._swapEndStartRepeatValues = function (t) {
            var e = this._valuesStartRepeat[t],
                i = this._valuesEnd[t];
            this._valuesStartRepeat[t] = "string" == typeof i ? this._valuesStartRepeat[t] + parseFloat(i) : this._valuesEnd[t], this._valuesEnd[t] = e;
          }, t;
        }(),
            p = c.nextId,
            d = h,
            f = d.getAll.bind(d),
            v = d.removeAll.bind(d),
            y = d.add.bind(d),
            m = d.remove.bind(d),
            b = d.update.bind(d);

        var g = {
          Easing: o,
          Group: a,
          Interpolation: u,
          now: s,
          Sequence: c,
          nextId: p,
          Tween: l,
          VERSION: "18.6.4",
          getAll: f,
          removeAll: v,
          add: y,
          remove: m,
          update: b
        };

        var w = function () {
          if ("undefined" != typeof Map) return Map;

          function t(t, e) {
            var i = -1;
            return t.some(function (t, n) {
              return t[0] === e && (i = n, !0);
            }), i;
          }

          return function () {
            function e() {
              this.__entries__ = [];
            }

            return Object.defineProperty(e.prototype, "size", {
              get: function get() {
                return this.__entries__.length;
              },
              enumerable: !0,
              configurable: !0
            }), e.prototype.get = function (e) {
              var i = t(this.__entries__, e),
                  n = this.__entries__[i];
              return n && n[1];
            }, e.prototype.set = function (e, i) {
              var n = t(this.__entries__, e);
              ~n ? this.__entries__[n][1] = i : this.__entries__.push([e, i]);
            }, e.prototype.delete = function (e) {
              var i = this.__entries__,
                  n = t(i, e);
              ~n && i.splice(n, 1);
            }, e.prototype.has = function (e) {
              return !!~t(this.__entries__, e);
            }, e.prototype.clear = function () {
              this.__entries__.splice(0);
            }, e.prototype.forEach = function (t, e) {
              void 0 === e && (e = null);

              for (var i = 0, n = this.__entries__; i < n.length; i++) {
                var r = n[i];
                t.call(e, r[1], r[0]);
              }
            }, e;
          }();
        }(),
            _ = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
            S = void 0 !== n.g && n.g.Math === Math ? n.g : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
            O = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(S) : function (t) {
          return setTimeout(function () {
            return t(Date.now());
          }, 1e3 / 60);
        },
            T = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
            k = "undefined" != typeof MutationObserver,
            x = function () {
          function t() {
            this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (t, e) {
              var i = !1,
                  n = !1,
                  r = 0;

              function o() {
                i && (i = !1, t()), n && a();
              }

              function s() {
                O(o);
              }

              function a() {
                var t = Date.now();

                if (i) {
                  if (t - r < 2) return;
                  n = !0;
                } else i = !0, n = !1, setTimeout(s, 20);

                r = t;
              }

              return a;
            }(this.refresh.bind(this));
          }

          return t.prototype.addObserver = function (t) {
            ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
          }, t.prototype.removeObserver = function (t) {
            var e = this.observers_,
                i = e.indexOf(t);
            ~i && e.splice(i, 1), !e.length && this.connected_ && this.disconnect_();
          }, t.prototype.refresh = function () {
            this.updateObservers_() && this.refresh();
          }, t.prototype.updateObservers_ = function () {
            var t = this.observers_.filter(function (t) {
              return t.gatherActive(), t.hasActive();
            });
            return t.forEach(function (t) {
              return t.broadcastActive();
            }), t.length > 0;
          }, t.prototype.connect_ = function () {
            _ && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), k ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
              attributes: !0,
              childList: !0,
              characterData: !0,
              subtree: !0
            })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
          }, t.prototype.disconnect_ = function () {
            _ && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
          }, t.prototype.onTransitionEnd_ = function (t) {
            var e = t.propertyName,
                i = void 0 === e ? "" : e;
            T.some(function (t) {
              return !!~i.indexOf(t);
            }) && this.refresh();
          }, t.getInstance = function () {
            return this.instance_ || (this.instance_ = new t()), this.instance_;
          }, t.instance_ = null, t;
        }(),
            E = function E(t, e) {
          for (var i = 0, n = Object.keys(e); i < n.length; i++) {
            var r = n[i];
            Object.defineProperty(t, r, {
              value: e[r],
              enumerable: !1,
              writable: !1,
              configurable: !0
            });
          }

          return t;
        },
            C = function C(t) {
          return t && t.ownerDocument && t.ownerDocument.defaultView || S;
        },
            M = A(0, 0, 0, 0);

        function j(t) {
          return parseFloat(t) || 0;
        }

        function P(t) {
          for (var e = [], i = 1; i < arguments.length; i++) {
            e[i - 1] = arguments[i];
          }

          return e.reduce(function (e, i) {
            return e + j(t["border-" + i + "-width"]);
          }, 0);
        }

        var I = "undefined" != typeof SVGGraphicsElement ? function (t) {
          return t instanceof C(t).SVGGraphicsElement;
        } : function (t) {
          return t instanceof C(t).SVGElement && "function" == typeof t.getBBox;
        };

        function R(t) {
          return _ ? I(t) ? function (t) {
            var e = t.getBBox();
            return A(0, 0, e.width, e.height);
          }(t) : function (t) {
            var e = t.clientWidth,
                i = t.clientHeight;
            if (!e && !i) return M;

            var n = C(t).getComputedStyle(t),
                r = function (t) {
              for (var e = {}, i = 0, n = ["top", "right", "bottom", "left"]; i < n.length; i++) {
                var r = n[i],
                    o = t["padding-" + r];
                e[r] = j(o);
              }

              return e;
            }(n),
                o = r.left + r.right,
                s = r.top + r.bottom,
                a = j(n.width),
                u = j(n.height);

            if ("border-box" === n.boxSizing && (Math.round(a + o) !== e && (a -= P(n, "left", "right") + o), Math.round(u + s) !== i && (u -= P(n, "top", "bottom") + s)), !function (t) {
              return t === C(t).document.documentElement;
            }(t)) {
              var c = Math.round(a + o) - e,
                  h = Math.round(u + s) - i;
              1 !== Math.abs(c) && (a -= c), 1 !== Math.abs(h) && (u -= h);
            }

            return A(r.left, r.top, a, u);
          }(t) : M;
        }

        function A(t, e, i, n) {
          return {
            x: t,
            y: e,
            width: i,
            height: n
          };
        }

        var z = function () {
          function t(t) {
            this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = A(0, 0, 0, 0), this.target = t;
          }

          return t.prototype.isActive = function () {
            var t = R(this.target);
            return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
          }, t.prototype.broadcastRect = function () {
            var t = this.contentRect_;
            return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
          }, t;
        }(),
            W = function W(t, e) {
          var i,
              n,
              r,
              o,
              s,
              a,
              u,
              c = (n = (i = e).x, r = i.y, o = i.width, s = i.height, a = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, u = Object.create(a.prototype), E(u, {
            x: n,
            y: r,
            width: o,
            height: s,
            top: r,
            right: n + o,
            bottom: s + r,
            left: n
          }), u);
          E(this, {
            target: t,
            contentRect: c
          });
        },
            D = function () {
          function t(t, e, i) {
            if (this.activeObservations_ = [], this.observations_ = new w(), "function" != typeof t) throw new TypeError("The callback provided as parameter 1 is not a function.");
            this.callback_ = t, this.controller_ = e, this.callbackCtx_ = i;
          }

          return t.prototype.observe = function (t) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

            if ("undefined" != typeof Element && Element instanceof Object) {
              if (!(t instanceof C(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
              var e = this.observations_;
              e.has(t) || (e.set(t, new z(t)), this.controller_.addObserver(this), this.controller_.refresh());
            }
          }, t.prototype.unobserve = function (t) {
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");

            if ("undefined" != typeof Element && Element instanceof Object) {
              if (!(t instanceof C(t).Element)) throw new TypeError('parameter 1 is not of type "Element".');
              var e = this.observations_;
              e.has(t) && (e.delete(t), e.size || this.controller_.removeObserver(this));
            }
          }, t.prototype.disconnect = function () {
            this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
          }, t.prototype.gatherActive = function () {
            var t = this;
            this.clearActive(), this.observations_.forEach(function (e) {
              e.isActive() && t.activeObservations_.push(e);
            });
          }, t.prototype.broadcastActive = function () {
            if (this.hasActive()) {
              var t = this.callbackCtx_,
                  e = this.activeObservations_.map(function (t) {
                return new W(t.target, t.broadcastRect());
              });
              this.callback_.call(t, e, t), this.clearActive();
            }
          }, t.prototype.clearActive = function () {
            this.activeObservations_.splice(0);
          }, t.prototype.hasActive = function () {
            return this.activeObservations_.length > 0;
          }, t;
        }(),
            N = "undefined" != typeof WeakMap ? new WeakMap() : new w(),
            F = function t(e) {
          if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function.");
          if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
          var i = x.getInstance(),
              n = new D(e, i, this);
          N.set(this, n);
        };

        ["observe", "unobserve", "disconnect"].forEach(function (t) {
          F.prototype[t] = function () {
            var e;
            return (e = N.get(this))[t].apply(e, arguments);
          };
        });
        var U = void 0 !== S.ResizeObserver ? S.ResizeObserver : F;

        function G(t) {
          return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, G(t);
        }

        function B(t, e) {
          var i = Object.keys(t);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), i.push.apply(i, n);
          }

          return i;
        }

        function X(t, e, i) {
          return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = i, t;
        }

        var L = {
          duration: 5e3,
          transitionDuration: 1e3,
          defaultIndex: 0,
          infinite: !0,
          autoplay: !0,
          indicators: !1,
          arrows: !0,
          pauseOnHover: !0,
          scale: 1,
          easing: "linear",
          canSwipe: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          cssClass: "",
          responsive: []
        },
            q = function q(t) {
          var e,
              n = i().Children.map(t.children, function (t) {
            return t;
          }),
              r = {};

          if ("undefined" != typeof window && Array.isArray(t.responsive)) {
            var o = (e = window.innerWidth, t.responsive.find(function (t) {
              return t.breakpoint <= e;
            }));
            o && (r = o.settings);
          }

          return function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = null != arguments[e] ? arguments[e] : {};
              e % 2 ? B(i, !0).forEach(function (e) {
                X(t, e, i[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : B(i).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
              });
            }

            return t;
          }({}, L, {}, t, {}, r, {
            children: n
          });
        },
            H = {
          duration: "number",
          transitionDuration: "number",
          defaultIndex: "number",
          infinite: "boolean",
          indicators: ["boolean", "function"],
          autoplay: "boolean",
          arrows: "boolean",
          onChange: "function",
          pauseOnHover: "boolean",
          prevArrow: ["object", "function"],
          nextArrow: ["object", "function"],
          scale: "number",
          easing: "string",
          canSwipe: "boolean",
          slidesToShow: "number",
          slidesToScroll: "number",
          cssClass: "string",
          responsive: "array"
        },
            V = function V(t) {
          for (var e in t) {
            var i = G(t[e]);
            H[e] && (Array.isArray(H[e]) && !H[e].includes(i) ? console.warn("".concat(e, " must be of one of type ").concat(H[e].join(", "))) : ("array" !== H[e] || Array.isArray(t[e])) && ("array" === H[e] || Array.isArray(H[e]) || i === H[e]) || console.warn("".concat(e, " must be of type ").concat(H[e])));
          }
        };

        function Q() {
          return Q = Object.assign || function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = arguments[e];

              for (var n in i) {
                Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
              }
            }

            return t;
          }, Q.apply(this, arguments);
        }

        function Z(t, e) {
          var i = Object.keys(t);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), i.push.apply(i, n);
          }

          return i;
        }

        function J(t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = null != arguments[e] ? arguments[e] : {};
            e % 2 ? Z(i, !0).forEach(function (e) {
              K(t, e, i[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : Z(i).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
            });
          }

          return t;
        }

        function K(t, e, i) {
          return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = i, t;
        }

        var Y = {
          linear: g.Easing.Linear.None,
          ease: g.Easing.Quadratic.InOut,
          "ease-in": g.Easing.Quadratic.In,
          "ease-out": g.Easing.Quadratic.Out,
          cubic: g.Easing.Cubic.InOut,
          "cubic-in": g.Easing.Cubic.In,
          "cubic-out": g.Easing.Cubic.Out
        },
            $ = function $(t) {
          return Y[t] || Y.linear;
        },
            tt = function tt(t, e) {
          var i = Object.keys(t);
          return Object.keys(e).reduce(function (t, n) {
            return -1 === i.indexOf(n) && (t[n] = e[n]), t;
          }, {});
        },
            et = function et(t, e, n) {
          var r = t.prevArrow,
              o = t.infinite,
              s = e <= 0 && !o,
              a = {
            "data-type": "prev",
            "aria-label": "Previous Slide",
            disabled: s,
            onClick: n
          };
          if (r) return i().cloneElement(r, J({
            className: "".concat(r.props.className, " nav ").concat(s ? "disabled" : "")
          }, a));
          var u = "nav default-nav ".concat(s ? "disabled" : "");
          return i().createElement("button", Q({
            className: u
          }, a), i().createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, i().createElement("path", {
            d: "M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
          })));
        },
            it = function it(t, e, n) {
          var r = t.nextArrow,
              o = t.infinite,
              s = t.children,
              a = t.slidesToScroll,
              u = e >= s.length - a && !o,
              c = {
            "data-type": "next",
            "aria-label": "Next Slide",
            disabled: u,
            onClick: n
          };
          if (r) return i().cloneElement(r, J({
            className: "".concat(r.props.className, " nav ").concat(u ? "disabled" : "")
          }, c));
          var h = "nav default-nav ".concat(u ? "disabled" : "");
          return i().createElement("button", Q({
            className: h
          }, c), i().createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
          }, i().createElement("path", {
            d: "M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
          })));
        },
            nt = function nt(t, e, n) {
          var r = t.children,
              o = t.indicators,
              s = t.slidesToScroll,
              a = "boolean" != typeof o,
              u = Math.ceil(r.length / s);
          return i().createElement("ul", {
            className: "indicators"
          }, Array.from({
            length: u
          }, function (t, r) {
            var u = {
              "data-key": r,
              "aria-label": "Go to slide ".concat(r + 1),
              onClick: n
            },
                c = Math.floor((e + s - 1) / s) === r;
            return a ? function (t, e, n, r) {
              return i().cloneElement(r, J({
                className: "".concat(r.props.className, " ").concat(t ? "active" : ""),
                key: e
              }, n));
            }(c, r, u, o(r)) : function (t, e, n) {
              return i().createElement("li", {
                key: e
              }, i().createElement("button", Q({
                className: "each-slideshow-indicator ".concat(t ? "active" : "")
              }, n)));
            }(c, r, u);
          }));
        };

        function rt(t) {
          return rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, rt(t);
        }

        function ot() {
          return ot = Object.assign || function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = arguments[e];

              for (var n in i) {
                Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
              }
            }

            return t;
          }, ot.apply(this, arguments);
        }

        function st(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }

        function at(t) {
          return at = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }, at(t);
        }

        function ut(t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }

        function ct(t, e) {
          return ct = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t;
          }, ct(t, e);
        }

        var ht = function (t) {
          function n(t) {
            var i;
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, n), (i = function (t, e) {
              return !e || "object" !== rt(e) && "function" != typeof e ? ut(t) : e;
            }(this, at(n).call(this))).state = {
              slidesToShow: t.slidesToShow || 1,
              index: t.defaultIndex && t.defaultIndex < t.children.length ? t.defaultIndex : 0
            }, i.width = 0, i.dragging = !1, i.imageContainer = null, i.wrapper = null, i.timeout = null, i.moveSlides = i.moveSlides.bind(ut(i)), i.pauseSlides = i.pauseSlides.bind(ut(i)), i.startSlides = i.startSlides.bind(ut(i)), i.handleResize = i.handleResize.bind(ut(i)), i.initResizeObserver = i.initResizeObserver.bind(ut(i)), i.reactSlideshowWrapper = (0, e.createRef)(), i.goToSlide = i.goToSlide.bind(ut(i)), i.tweenGroup = new g.Group(), i.startSwipe = i.startSwipe.bind(ut(i)), i.endSwipe = i.endSwipe.bind(ut(i)), i.swipe = i.swipe.bind(ut(i)), i.distanceSwiped = 0, i;
          }

          var r, o;
          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && ct(t, e);
          }(n, t), r = n, (o = [{
            key: "componentDidMount",
            value: function value() {
              var t = this;
              this.setWidth(), this.initResizeObserver(), V(this.props);
              var e = q(this.props),
                  i = e.autoplay,
                  n = e.duration;
              i && (this.timeout = setTimeout(function () {
                return t.goNext();
              }, n));
            }
          }, {
            key: "initResizeObserver",
            value: function value() {
              var t = this;
              this.resizeObserver = new U(function (e) {
                e && t.handleResize();
              }), this.reactSlideshowWrapper.current && this.resizeObserver.observe(this.reactSlideshowWrapper.current);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.tweenGroup.removeAll(), clearTimeout(this.timeout), this.removeResizeObserver();
            }
          }, {
            key: "startSwipe",
            value: function value(t) {
              q(this.props).canSwipe && (this.startingClientX = t.touches ? t.touches[0].pageX : t.clientX, clearTimeout(this.timeout), this.dragging = !0);
            }
          }, {
            key: "endSwipe",
            value: function value() {
              q(this.props).canSwipe && (this.dragging = !1, Math.abs(this.distanceSwiped) / this.width > .2 ? this.distanceSwiped < 0 ? this.goNext() : this.goBack() : Math.abs(this.distanceSwiped) > 0 && this.slideImages(this.state.index, 300));
            }
          }, {
            key: "swipe",
            value: function value(t) {
              var e = q(this.props),
                  i = e.canSwipe,
                  n = e.slidesToShow,
                  r = e.children,
                  o = e.infinite,
                  s = e.slidesToScroll;

              if (i) {
                var a = t.touches ? t.touches[0].pageX : t.clientX;

                if (this.dragging) {
                  var u = this.width * (this.state.index + this.getOffset(o, n)),
                      c = a - this.startingClientX;
                  if (!o && this.state.index === r.length - s && c < 0) return;
                  if (!o && 0 === this.state.index && c > 0) return;
                  this.distanceSwiped = c, u -= this.distanceSwiped, this.imageContainer.style.transform = "translate(-".concat(u, "px)");
                }
              }
            }
          }, {
            key: "removeResizeObserver",
            value: function value() {
              this.resizeObserver && this.reactSlideshowWrapper && this.reactSlideshowWrapper.current && this.resizeObserver.unobserve(this.reactSlideshowWrapper.current);
            }
          }, {
            key: "setWidth",
            value: function value() {
              this.allImages = this.wrapper && Array.prototype.slice.call(this.wrapper.querySelectorAll(".images-wrap > div"), 0) || [];
              var t = q(this.props),
                  e = t.slidesToShow,
                  n = t.infinite;
              this.state.slidesToShow !== e && this.setState({
                slidesToShow: e,
                index: 0
              }), this.width = (this.wrapper && this.wrapper.clientWidth || 0) / e;
              var r = i().Children.count(this.props.children),
                  o = this.width * (r + 2 * e);
              this.imageContainer && (this.imageContainer.style.width = "".concat(o, "px"), this.imageContainer.style.transform = "translate(-".concat(this.width * (this.state.index + this.getOffset(n, e)), "px)")), this.applySlideStyle();
            }
          }, {
            key: "componentDidUpdate",
            value: function value(t) {
              var e = this,
                  i = q(this.props),
                  n = i.autoplay,
                  r = i.duration,
                  o = i.children,
                  s = q(t);
              n !== s.autoplay && (n ? this.timeout = setTimeout(function () {
                return e.goNext();
              }, r) : clearTimeout(this.timeout)), o.length != s.children.length && (this.setWidth(), clearTimeout(this.timeout), this.timeout = setTimeout(function () {
                return e.goNext();
              }, r));
            }
          }, {
            key: "handleResize",
            value: function value() {
              this.setWidth();
            }
          }, {
            key: "applySlideStyle",
            value: function value() {
              var t = this;
              this.allImages.forEach(function (e, i) {
                e.style.width = "".concat(t.width, "px"), e.style.display = "block";
              });
            }
          }, {
            key: "pauseSlides",
            value: function value() {
              q(this.props).pauseOnHover && clearTimeout(this.timeout);
            }
          }, {
            key: "startSlides",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  i = e.pauseOnHover,
                  n = e.autoplay,
                  r = e.duration;
              this.dragging ? this.endSwipe() : i && n && (this.timeout = setTimeout(function () {
                return t.goNext();
              }, r));
            }
          }, {
            key: "moveSlides",
            value: function value(t) {
              "next" === t.currentTarget.dataset.type ? this.goNext() : this.goBack();
            }
          }, {
            key: "goToSlide",
            value: function value(t) {
              var e = t.currentTarget,
                  i = q(this.props).slidesToScroll;
              this.goTo(parseInt(e.dataset.key * i));
            }
          }, {
            key: "goTo",
            value: function value(t) {
              this.slideImages(this.calculateIndex(t));
            }
          }, {
            key: "calculateIndex",
            value: function value(t) {
              var e = q(this.props),
                  i = e.children,
                  n = e.slidesToScroll;
              return t < i.length && t + n > i.length && (i.length - n) % n ? i.length - n : t;
            }
          }, {
            key: "goNext",
            value: function value() {
              var t = this.state.index,
                  e = q(this.props),
                  i = e.children,
                  n = e.infinite,
                  r = e.slidesToScroll;

              if (n || t !== i.length - r) {
                var o = this.calculateIndex(t + r);
                this.slideImages(o);
              }
            }
          }, {
            key: "goBack",
            value: function value() {
              var t = this.state.index,
                  e = q(this.props),
                  i = e.infinite,
                  n = e.slidesToScroll;

              if (i || 0 !== t) {
                var r = t - n;
                r % n && (r = Math.ceil(r / n) * n), this.slideImages(r);
              }
            }
          }, {
            key: "isSlideActive",
            value: function value(t) {
              var e = q(this.props).slidesToShow;
              return t < this.state.index + e && t >= this.state.index;
            }
          }, {
            key: "renderPreceedingSlides",
            value: function value(t, e) {
              return t.slice(-e).map(function (t, n) {
                return i().createElement("div", {
                  "data-index": n - e,
                  "aria-roledescription": "slide",
                  "aria-hidden": "true",
                  key: n - e
                }, t);
              });
            }
          }, {
            key: "renderTrailingSlides",
            value: function value() {
              var t = q(this.props),
                  e = t.children,
                  n = t.slidesToShow,
                  r = t.slidesToScroll;
              if (t.infinite || n !== r) return e.slice(0, n).map(function (t, n) {
                return i().createElement("div", {
                  "data-index": e.length + n,
                  "aria-roledescription": "slide",
                  "aria-hidden": "true",
                  key: e.length + n
                }, t);
              });
            }
          }, {
            key: "getOffset",
            value: function value(t, e) {
              return t ? e : 0;
            }
          }, {
            key: "render",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  n = e.children,
                  r = e.indicators,
                  o = e.arrows,
                  s = e.cssClass,
                  a = e.slidesToShow,
                  u = e.infinite,
                  c = tt(H, this.props),
                  h = this.state.index,
                  l = {
                transform: "translate(-".concat((h + this.getOffset(u, a)) * this.width, "px)")
              };
              return i().createElement("div", ot({
                dir: "ltr",
                "aria-roledescription": "carousel"
              }, c), i().createElement("div", {
                className: "react-slideshow-container",
                onMouseEnter: this.pauseSlides,
                onMouseOver: this.pauseSlides,
                onMouseLeave: this.startSlides,
                onMouseDown: this.startSwipe,
                onMouseUp: this.endSwipe,
                onMouseMove: this.swipe,
                onTouchStart: this.startSwipe,
                onTouchEnd: this.endSwipe,
                onTouchCancel: this.endSwipe,
                onTouchMove: this.swipe,
                ref: this.reactSlideshowWrapper
              }, o && et(q(this.props), this.state.index, this.moveSlides), i().createElement("div", {
                className: "react-slideshow-wrapper slide ".concat(s),
                ref: function ref(e) {
                  return t.wrapper = e;
                }
              }, i().createElement("div", {
                className: "images-wrap",
                style: l,
                ref: function ref(e) {
                  return t.imageContainer = e;
                }
              }, u ? this.renderPreceedingSlides(n, a) : "", n.map(function (e, n) {
                var r = t.isSlideActive(n);
                return i().createElement("div", {
                  "data-index": n,
                  key: n,
                  className: r ? "active" : "",
                  "aria-roledescription": "slide",
                  "aria-hidden": r ? "false" : "true"
                }, e);
              }), this.renderTrailingSlides())), o && it(q(this.props), this.state.index, this.moveSlides)), r && nt(q(this.props), this.state.index, this.goToSlide));
            }
          }, {
            key: "slideImages",
            value: function value(t, e) {
              var i = this,
                  n = q(this.props),
                  r = n.children,
                  o = n.transitionDuration,
                  s = n.autoplay,
                  a = n.infinite,
                  u = n.duration,
                  c = n.onChange,
                  h = n.easing,
                  l = n.slidesToShow,
                  p = n.slidesToScroll;

              if (o = e || o, !this.tweenGroup.getAll().length) {
                clearTimeout(this.timeout);
                var d = {
                  margin: -this.width * (this.state.index + this.getOffset(a, l)) + this.distanceSwiped
                },
                    f = new g.Tween(d, this.tweenGroup).to({
                  margin: -this.width * (t + this.getOffset(a, l))
                }, o).onUpdate(function (t) {
                  i.imageContainer && (i.imageContainer.style.transform = "translate(".concat(t.margin, "px)"));
                }).start();
                f.easing($(h)), function t() {
                  requestAnimationFrame(t), i.tweenGroup.update();
                }(), f.onComplete(function () {
                  i.distanceSwiped = 0;
                  var e = t;
                  e < 0 ? e = r.length - p : e >= r.length && (e = 0), "function" == typeof c && c(i.state.index, e), i.setState({
                    index: e
                  }, function () {
                    s && (a || i.state.index < r.length) && (clearTimeout(i.timeout), i.timeout = setTimeout(function () {
                      return i.goNext();
                    }, u));
                  });
                });
              }
            }
          }]) && st(r.prototype, o), n;
        }(e.Component);

        function lt(t) {
          return lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, lt(t);
        }

        function pt() {
          return pt = Object.assign || function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = arguments[e];

              for (var n in i) {
                Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
              }
            }

            return t;
          }, pt.apply(this, arguments);
        }

        function dt(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }

        function ft(t) {
          return ft = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }, ft(t);
        }

        function vt(t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }

        function yt(t, e) {
          return yt = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t;
          }, yt(t, e);
        }

        var mt = function (t) {
          function n(t) {
            var i;
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, n), (i = function (t, e) {
              return !e || "object" !== lt(e) && "function" != typeof e ? vt(t) : e;
            }(this, ft(n).call(this))).state = {
              index: t.defaultIndex && t.defaultIndex < t.children.length ? t.defaultIndex : 0
            }, i.width = 0, i.timeout = null, i.divsContainer = null, i.wrapper = null, i.setWidth = i.setWidth.bind(vt(i)), i.handleResize = i.handleResize.bind(vt(i)), i.navigate = i.navigate.bind(vt(i)), i.preFade = i.preFade.bind(vt(i)), i.pauseSlides = i.pauseSlides.bind(vt(i)), i.startSlides = i.startSlides.bind(vt(i)), i.initResizeObserver = i.initResizeObserver.bind(vt(i)), i.tweenGroup = new g.Group(), i.reactSlideshowWrapper = (0, e.createRef)(), i.wrapper = (0, e.createRef)(), i.startSwipe = i.startSwipe.bind(vt(i)), i.endSwipe = i.endSwipe.bind(vt(i)), i;
          }

          var r, o;
          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && yt(t, e);
          }(n, t), r = n, (o = [{
            key: "componentDidMount",
            value: function value() {
              this.setWidth(), this.play(), this.initResizeObserver(), V(this.props);
            }
          }, {
            key: "initResizeObserver",
            value: function value() {
              var t = this;
              this.reactSlideshowWrapper.current && (this.resizeObserver = new U(function (e) {
                e && t.handleResize();
              }), this.resizeObserver.observe(this.reactSlideshowWrapper.current));
            }
          }, {
            key: "play",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  i = e.autoplay,
                  n = e.children,
                  r = e.duration,
                  o = this.state.index;
              i && n.length > 1 && (clearTimeout(this.timeout), this.timeout = setTimeout(function () {
                return t.fadeImages(o + 1);
              }, r));
            }
          }, {
            key: "componentDidUpdate",
            value: function value(t) {
              var e = q(this.props),
                  i = e.autoplay,
                  n = e.children,
                  r = q(t);
              i !== r.autoplay && (i ? this.play() : clearTimeout(this.timeout)), n.length != r.children.length && (this.applyStyle(), clearTimeout(this.timeout), this.play());
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.tweenGroup.removeAll(), clearTimeout(this.timeout), this.removeResizeObserver();
            }
          }, {
            key: "removeResizeObserver",
            value: function value() {
              this.resizeObserver && this.reactSlideshowWrapper && this.reactSlideshowWrapper.current && this.resizeObserver.unobserve(this.reactSlideshowWrapper.current);
            }
          }, {
            key: "setWidth",
            value: function value() {
              this.wrapper.current && (this.width = this.wrapper.current.clientWidth), this.applyStyle();
            }
          }, {
            key: "handleResize",
            value: function value() {
              this.setWidth();
            }
          }, {
            key: "applyStyle",
            value: function value() {
              var t = this.width * i().Children.count(this.props.children);

              if (this.divsContainer) {
                this.divsContainer.style.width = "".concat(t, "px");

                for (var e = 0; e < this.divsContainer.children.length; e++) {
                  var n = this.divsContainer.children[e];
                  n && (n.style.width = "".concat(this.width, "px"), n.style.left = "".concat(e * -this.width, "px"), n.style.display = "block");
                }
              }
            }
          }, {
            key: "pauseSlides",
            value: function value() {
              q(this.props).pauseOnHover && clearTimeout(this.timeout);
            }
          }, {
            key: "startSlides",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  i = e.pauseOnHover,
                  n = e.autoplay,
                  r = e.duration;
              i && n && (this.timeout = setTimeout(function () {
                return t.goNext();
              }, r));
            }
          }, {
            key: "goNext",
            value: function value() {
              var t = this.state.index,
                  e = q(this.props),
                  i = e.children;
              (e.infinite || t !== i.length - 1) && this.fadeImages((t + 1) % i.length);
            }
          }, {
            key: "goBack",
            value: function value() {
              var t = this.state.index,
                  e = q(this.props),
                  i = e.children;
              (e.infinite || 0 !== t) && this.fadeImages(0 === t ? i.length - 1 : t - 1);
            }
          }, {
            key: "navigate",
            value: function value(t) {
              var e = t.currentTarget.dataset;
              e.key != this.state.index && this.goTo(parseInt(e.key));
            }
          }, {
            key: "goTo",
            value: function value(t) {
              this.fadeImages(t);
            }
          }, {
            key: "preFade",
            value: function value(t) {
              "prev" === t.currentTarget.dataset.type ? this.goBack() : this.goNext();
            }
          }, {
            key: "startSwipe",
            value: function value(t) {
              q(this.props).canSwipe && (this.startingClientX = t.touches ? t.touches[0].pageX : t.clientX, clearTimeout(this.timeout), this.dragging = !0);
            }
          }, {
            key: "endSwipe",
            value: function value(t) {
              var e = (t.changedTouches ? t.changedTouches[0].pageX : t.clientX) - this.startingClientX;
              q(this.props).canSwipe && (this.dragging = !1, Math.abs(e) / this.width > .2 && (e < 0 ? this.goNext() : this.goBack()));
            }
          }, {
            key: "render",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  n = e.indicators,
                  r = e.children,
                  o = e.arrows,
                  s = e.cssClass,
                  a = this.state.index,
                  u = tt(H, this.props);
              return i().createElement("div", pt({
                dir: "ltr",
                "aria-roledescription": "carousel"
              }, u), i().createElement("div", {
                className: "react-slideshow-container",
                onMouseEnter: this.pauseSlides,
                onMouseOver: this.pauseSlides,
                onMouseLeave: this.startSlides,
                onMouseDown: this.startSwipe,
                onMouseUp: this.endSwipe,
                onTouchStart: this.startSwipe,
                onTouchEnd: this.endSwipe,
                onTouchCancel: this.endSwipe,
                ref: this.reactSlideshowWrapper
              }, o && et(q(this.props), this.state.index, this.preFade), i().createElement("div", {
                className: "react-slideshow-fade-wrapper ".concat(s),
                ref: this.wrapper
              }, i().createElement("div", {
                className: "react-slideshow-fade-images-wrap",
                ref: function ref(e) {
                  return t.divsContainer = e;
                }
              }, r.map(function (t, e) {
                return i().createElement("div", {
                  style: {
                    opacity: e === a ? "1" : "0",
                    zIndex: e === a ? "1" : "0"
                  },
                  "data-index": e,
                  key: e,
                  "aria-roledescription": "slide",
                  "aria-hidden": e === a ? "false" : "true"
                }, t);
              }))), o && it(q(this.props), this.state.index, this.preFade)), n && nt(q(this.props), this.state.index, this.navigate));
            }
          }, {
            key: "fadeImages",
            value: function value(t) {
              var e = this,
                  i = this.state.index,
                  n = q(this.props),
                  r = n.autoplay,
                  o = n.children,
                  s = n.infinite,
                  a = n.duration,
                  u = n.transitionDuration,
                  c = n.onChange,
                  h = n.easing;

              if (!this.tweenGroup.getAll().length) {
                this.divsContainer.children[t] || (t = 0), clearTimeout(this.timeout), function t() {
                  requestAnimationFrame(t), e.tweenGroup.update();
                }();
                var l = new g.Tween({
                  opacity: 0
                }, this.tweenGroup).to({
                  opacity: 1
                }, u).onUpdate(function (n) {
                  e.divsContainer.children[t].style.opacity = n.opacity, e.divsContainer.children[i].style.opacity = 1 - n.opacity;
                }).start();
                l.easing($(h)), l.onComplete(function () {
                  e.setState({
                    index: t
                  }), "function" == typeof c && c(i, t), r && (s || t < o.length - 1) && (clearTimeout(e.timeout), e.timeout = setTimeout(function () {
                    e.fadeImages((t + 1) % o.length);
                  }, a));
                });
              }
            }
          }]) && dt(r.prototype, o), n;
        }(e.Component);

        function bt(t) {
          return bt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
          } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }, bt(t);
        }

        function gt() {
          return gt = Object.assign || function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var i = arguments[e];

              for (var n in i) {
                Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
              }
            }

            return t;
          }, gt.apply(this, arguments);
        }

        function wt(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
          }
        }

        function _t(t) {
          return _t = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }, _t(t);
        }

        function St(t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }

        function Ot(t, e) {
          return Ot = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t;
          }, Ot(t, e);
        }

        var Tt = function (t) {
          function n(t) {
            var i;
            return function (t, e) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this, n), (i = function (t, e) {
              return !e || "object" !== bt(e) && "function" != typeof e ? St(t) : e;
            }(this, _t(n).call(this))).state = {
              index: t.defaultIndex && t.defaultIndex < t.children.length ? t.defaultIndex : 0
            }, i.width = 0, i.timeout = null, i.divsContainer = null, i.wrapper = null, i.setWidth = i.setWidth.bind(St(i)), i.handleResize = i.handleResize.bind(St(i)), i.navigate = i.navigate.bind(St(i)), i.preZoom = i.preZoom.bind(St(i)), i.pauseSlides = i.pauseSlides.bind(St(i)), i.startSlides = i.startSlides.bind(St(i)), i.tweenGroup = new g.Group(), i.initResizeObserver = i.initResizeObserver.bind(St(i)), i.reactSlideshowWrapper = (0, e.createRef)(), i.startSwipe = i.startSwipe.bind(St(i)), i.endSwipe = i.endSwipe.bind(St(i)), i;
          }

          var r, o;
          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }), e && Ot(t, e);
          }(n, t), r = n, (o = [{
            key: "componentDidMount",
            value: function value() {
              this.setWidth(), this.play(), this.initResizeObserver(), V(this.props);
            }
          }, {
            key: "initResizeObserver",
            value: function value() {
              var t = this;
              this.reactSlideshowWrapper.current && (this.resizeObserver = new U(function (e) {
                e && t.handleResize();
              }), this.resizeObserver.observe(this.reactSlideshowWrapper.current));
            }
          }, {
            key: "play",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  i = e.autoplay,
                  n = e.children,
                  r = e.duration,
                  o = this.state.index;
              i && n.length > 1 && (clearTimeout(this.timeout), this.timeout = setTimeout(function () {
                return t.zoomTo(o + 1);
              }, r));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.tweenGroup.removeAll(), clearTimeout(this.timeout), this.removeResizeObserver();
            }
          }, {
            key: "removeResizeObserver",
            value: function value() {
              this.resizeObserver && this.reactSlideshowWrapper && this.reactSlideshowWrapper.current && this.resizeObserver.unobserve(this.reactSlideshowWrapper.current);
            }
          }, {
            key: "componentDidUpdate",
            value: function value(t) {
              var e = q(this.props),
                  i = e.autoplay,
                  n = e.children,
                  r = q(t);
              i !== r.autoplay && (i ? this.play() : clearTimeout(this.timeout)), n.length != r.children.length && (this.applyStyle(), clearTimeout(this.timeout), this.play());
            }
          }, {
            key: "setWidth",
            value: function value() {
              this.wrapper && (this.width = this.wrapper.clientWidth), this.applyStyle();
            }
          }, {
            key: "handleResize",
            value: function value() {
              this.setWidth();
            }
          }, {
            key: "applyStyle",
            value: function value() {
              var t = this.width * i().Children.count(this.props.children);

              if (this.divsContainer) {
                this.divsContainer.style.width = "".concat(t, "px");

                for (var e = 0; e < this.divsContainer.children.length; e++) {
                  var n = this.divsContainer.children[e];
                  n && (n.style.width = "".concat(this.width, "px"), n.style.left = "".concat(e * -this.width, "px"), n.style.display = "block");
                }
              }
            }
          }, {
            key: "pauseSlides",
            value: function value() {
              q(this.props).pauseOnHover && clearTimeout(this.timeout);
            }
          }, {
            key: "startSlides",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  i = e.pauseOnHover,
                  n = e.autoplay,
                  r = e.duration;
              i && n && (this.timeout = setTimeout(function () {
                return t.goNext();
              }, r));
            }
          }, {
            key: "goNext",
            value: function value() {
              var t = this.state.index,
                  e = q(this.props),
                  i = e.children;
              (e.infinite || t !== i.length - 1) && this.zoomTo((t + 1) % i.length);
            }
          }, {
            key: "goBack",
            value: function value() {
              var t = this.state.index,
                  e = q(this.props),
                  i = e.children;
              (e.infinite || 0 !== t) && this.zoomTo(0 === t ? i.length - 1 : t - 1);
            }
          }, {
            key: "goTo",
            value: function value(t) {
              this.zoomTo(t);
            }
          }, {
            key: "navigate",
            value: function value(t) {
              var e = t.currentTarget.dataset;
              e.key != this.state.index && this.goTo(parseInt(e.key));
            }
          }, {
            key: "preZoom",
            value: function value(t) {
              "prev" === t.currentTarget.dataset.type ? this.goBack() : this.goNext();
            }
          }, {
            key: "startSwipe",
            value: function value(t) {
              q(this.props).canSwipe && (this.startingClientX = t.touches ? t.touches[0].pageX : t.clientX, clearTimeout(this.timeout), this.dragging = !0);
            }
          }, {
            key: "endSwipe",
            value: function value(t) {
              var e = (t.changedTouches ? t.changedTouches[0].pageX : t.clientX) - this.startingClientX;
              q(this.props).canSwipe && (this.dragging = !1, Math.abs(e) / this.width > .2 && (e < 0 ? this.goNext() : this.goBack()));
            }
          }, {
            key: "render",
            value: function value() {
              var t = this,
                  e = q(this.props),
                  n = e.indicators,
                  r = e.arrows,
                  o = e.children,
                  s = e.cssClass,
                  a = this.state.index,
                  u = tt(H, this.props);
              return i().createElement("div", gt({
                dir: "ltr",
                "aria-roledescription": "carousel"
              }, u), i().createElement("div", {
                className: "react-slideshow-container",
                onMouseEnter: this.pauseSlides,
                onMouseOver: this.pauseSlides,
                onMouseLeave: this.startSlides,
                onMouseDown: this.startSwipe,
                onMouseUp: this.endSwipe,
                onTouchStart: this.startSwipe,
                onTouchEnd: this.endSwipe,
                onTouchCancel: this.endSwipe,
                ref: this.reactSlideshowWrapper
              }, r && et(q(this.props), this.state.index, this.preZoom), i().createElement("div", {
                className: "react-slideshow-zoom-wrapper ".concat(s),
                ref: function ref(e) {
                  return t.wrapper = e;
                }
              }, i().createElement("div", {
                className: "zoom-wrapper",
                ref: function ref(e) {
                  return t.divsContainer = e;
                }
              }, o.map(function (t, e) {
                return i().createElement("div", {
                  style: {
                    opacity: e === a ? "1" : "0",
                    zIndex: e === a ? "1" : "0"
                  },
                  "data-index": e,
                  key: e,
                  "aria-roledescription": "slide",
                  "aria-hidden": e === a ? "false" : "true"
                }, t);
              }))), r && it(q(this.props), this.state.index, this.preZoom)), n && nt(q(this.props), this.state.index, this.navigate));
            }
          }, {
            key: "zoomTo",
            value: function value(t) {
              var e = this,
                  i = this.state.index,
                  n = q(this.props),
                  r = n.children,
                  o = n.scale,
                  s = n.autoplay,
                  a = n.infinite,
                  u = n.transitionDuration,
                  c = n.duration,
                  h = n.onChange,
                  l = n.easing;

              if (!this.tweenGroup.getAll().length) {
                this.divsContainer && !this.divsContainer.children[t] && (t = 0), clearTimeout(this.timeout), function t() {
                  requestAnimationFrame(t), e.tweenGroup.update();
                }();
                var p = new g.Tween({
                  opacity: 0,
                  scale: 1
                }, this.tweenGroup).to({
                  opacity: 1,
                  scale: o
                }, u).onUpdate(function (n) {
                  e.divsContainer && (e.divsContainer.children[t].style.opacity = n.opacity, e.divsContainer.children[i].style.opacity = 1 - n.opacity, e.divsContainer.children[i].style.transform = "scale(".concat(n.scale, ")"));
                }).start();
                p.easing($(l)), p.onComplete(function () {
                  "function" == typeof h && h(i, t), e.setState({
                    index: t
                  }, function () {
                    e.divsContainer && (e.divsContainer.children[i].style.transform = "scale(1)");
                  }), s && (a || t < r.length - 1) && (clearTimeout(e.timeout), e.timeout = setTimeout(function () {
                    e.zoomTo((t + 1) % r.length);
                  }, c));
                });
              }
            }
          }]) && wt(r.prototype, o), n;
        }(e.Component);
      }(), r;
    }();
  });
});
var _excluded$T = ["data", "productGradientColors", "typeOfItems", "buttonHoverOutline", "buttonWithoutBorderRadius", "buttonHoverColor", "buttonGrayscale", "wrapProducts", "arrowLeftSrc", "arrowRightSrc", "fontFamilyOfSectionTitles", "sizeOfSectionTitles", "titleFontFamily", "subTitleFontFamily"];

var _templateObject$1v, _templateObject2$D, _templateObject3$v;

var Arrow = styled__default["default"].div(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$right = _ref.right,
      right = _ref$right === void 0 ? false : _ref$right;
  return "\n  //only for mobile\n  @media (max-width: ".concat(breakpoints.sm, "px) {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    width: 400px !important;\n    margin-left: auto !important;\n    mergin-right: auto !important;\n    margin: auto;\n    & > img{\n      width: 20px !important;\n      float: ").concat(right ? "right" : "left", ";\n    }\n  }\n\n  @media (max-width: 440px) {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    width: 90% !important;\n    margin-left: auto !important;\n    mergin-right: auto !important;\n    margin: auto;\n    & > img{\n      width: 20px !important;\n      float: ").concat(right ? "0" : "5%", ";\n      margin-left: ").concat(right ? "5%" : "0", ";\n    }\n  }\n  ");
});
var Title$9 = styled__default["default"].h4(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 600;\n  line-height: 39px;\n  padding: 0 20px;\n  margin: 0 0 0 0;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? textSizesVariantsTypes.BIG : _ref2$size;
  return getTextSize(size);
}, function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref3$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? colorsVariantsTypes.SECONDARY : _ref4$color;
  return getColors(color);
});

function ProductsCollection(_ref5) {
  var _data$;

  var _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? [] : _ref5$data,
      _ref5$productGradient = _ref5.productGradientColors,
      productGradientColors = _ref5$productGradient === void 0 ? [getColors(colorsVariantsTypes.PRIMARY), getColors(colorsVariantsTypes.PRIMARY)] : _ref5$productGradient,
      _ref5$typeOfItems = _ref5.typeOfItems,
      typeOfItems = _ref5$typeOfItems === void 0 ? productVariantsTypes.NONE : _ref5$typeOfItems,
      _ref5$buttonHoverOutl = _ref5.buttonHoverOutline,
      buttonHoverOutline = _ref5$buttonHoverOutl === void 0 ? false : _ref5$buttonHoverOutl,
      _ref5$buttonWithoutBo = _ref5.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref5$buttonWithoutBo === void 0 ? false : _ref5$buttonWithoutBo,
      _ref5$buttonHoverColo = _ref5.buttonHoverColor,
      buttonHoverColor = _ref5$buttonHoverColo === void 0 ? false : _ref5$buttonHoverColo,
      _ref5$buttonGrayscale = _ref5.buttonGrayscale,
      buttonGrayscale = _ref5$buttonGrayscale === void 0 ? false : _ref5$buttonGrayscale,
      _ref5$wrapProducts = _ref5.wrapProducts,
      wrapProducts = _ref5$wrapProducts === void 0 ? false : _ref5$wrapProducts,
      _ref5$arrowLeftSrc = _ref5.arrowLeftSrc,
      arrowLeftSrc = _ref5$arrowLeftSrc === void 0 ? "" : _ref5$arrowLeftSrc,
      _ref5$arrowRightSrc = _ref5.arrowRightSrc,
      arrowRightSrc = _ref5$arrowRightSrc === void 0 ? "" : _ref5$arrowRightSrc,
      _ref5$fontFamilyOfSec = _ref5.fontFamilyOfSectionTitles,
      fontFamilyOfSectionTitles = _ref5$fontFamilyOfSec === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref5$fontFamilyOfSec,
      _ref5$sizeOfSectionTi = _ref5.sizeOfSectionTitles,
      sizeOfSectionTitles = _ref5$sizeOfSectionTi === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref5$sizeOfSectionTi,
      _ref5$titleFontFamily = _ref5.titleFontFamily,
      titleFontFamily = _ref5$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref5$titleFontFamily,
      _ref5$subTitleFontFam = _ref5.subTitleFontFamily,
      subTitleFontFamily = _ref5$subTitleFontFam === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref5$subTitleFontFam,
      otherProps = _objectWithoutProperties$1(_ref5, _excluded$T);

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width; // if on mobile then DO NOT set a mrgin of 15px


  var marginForArrow = width > breakpoints.sm ? {
    marginRight: "15px"
  } : null;
  var itemsSup = [];
  var settingsSlider = {
    dots: true,
    infinite: false,
    speed: 500,
    autoplay: false,
    easing: "ease",
    pauseOnHover: true,
    canSwipe: false,
    defaultIndex: 0,
    transitionDuration: 200,
    slidesToShow: 1,
    indicators: true,
    slidesToScroll: 1,
    prevArrow: /*#__PURE__*/React__default$1["default"].createElement(Arrow, {
      left: true,
      className: "PRODUCTS_LEFT_ARROW",
      style: _objectSpread2({
        width: "30px"
      }, marginForArrow)
    }, arrowLeftSrc ? /*#__PURE__*/React__default$1["default"].createElement("img", {
      src: arrowLeftSrc,
      alt: "Left Arrow",
      className: "PRODUCTS_LEFT_ARROW_IMG"
    }) : /*#__PURE__*/React__default$1["default"].createElement("svg", {
      width: "51",
      height: "52",
      viewBox: "0 0 51 52",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React__default$1["default"].createElement("path", {
      d: "M37.7012 2.59765L15.3699 24.931V24.931C14.7601 25.5399 14.7594 26.5279 15.3684 27.1378C15.3689 27.1383 15.3694 27.1388 15.3699 27.1393L37.7012 49.4727",
      stroke: "url(#paint0_linear)",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__default$1["default"].createElement("defs", null, /*#__PURE__*/React__default$1["default"].createElement("linearGradient", {
      id: "paint0_linear",
      x1: "33.4282",
      y1: "3.05338",
      x2: "24.0679",
      y2: "49.025",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React__default$1["default"].createElement("stop", {
      stopColor: colorsTypes.PRIMARY_ULTRA_DARK
    }), /*#__PURE__*/React__default$1["default"].createElement("stop", {
      offset: "1",
      stopColor: colorsTypes.PRIMARY
    }))))),
    nextArrow: /*#__PURE__*/React__default$1["default"].createElement(Arrow, {
      right: true,
      className: "PRODUCTS_RIGHT_ARROW",
      style: {
        width: "30px",
        marginLeft: "0px"
      }
    }, arrowRightSrc ? /*#__PURE__*/React__default$1["default"].createElement("img", {
      src: arrowRightSrc,
      alt: "Right Arrow",
      className: "PRODUCTS_RIGHT_ARROW_IMG"
    }) : /*#__PURE__*/React__default$1["default"].createElement("svg", {
      width: "51",
      height: "52",
      viewBox: "0 0 51 52",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React__default$1["default"].createElement("path", {
      d: "M13.9961 2.59765L36.3273 24.931V24.931C36.9372 25.5399 36.9379 26.5279 36.3289 27.1378C36.3284 27.1383 36.3279 27.1388 36.3273 27.1393L13.9961 49.4727",
      stroke: "url(#paint0_linear)",
      strokeWidth: "5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__default$1["default"].createElement("defs", null, /*#__PURE__*/React__default$1["default"].createElement("linearGradient", {
      id: "paint0_linear",
      x1: "18.269",
      y1: "3.05338",
      x2: "27.6294",
      y2: "49.025",
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React__default$1["default"].createElement("stop", {
      stopColor: colorsTypes.PRIMARY_ULTRA_DARK
    }), /*#__PURE__*/React__default$1["default"].createElement("stop", {
      offset: "1",
      stopColor: colorsTypes.PRIMARY
    })))))
  };
  var antSection = "";
  var auxCounter = 0;
  var itemsInf = [];

  var items = function items() {
    data.map(function (product) {
      auxCounter += 1;
      itemsInf.push( /*#__PURE__*/React__default$1["default"].createElement(Product, _extends$g({
        className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_PRODUCT PRODUCTS__COLLECTION__controller_container_list_product",
        key: nanoid(),
        variant: typeOfItems,
        buttonHoverOutline: buttonHoverOutline,
        buttonWithoutBorderRadius: buttonWithoutBorderRadius,
        buttonHoverColor: buttonHoverColor,
        buttonGrayscale: buttonGrayscale,
        gradientColors: productGradientColors,
        wrap: wrapProducts
      }, otherProps, product, {
        titleFontFamily: titleFontFamily,
        subTitleFontFamily: subTitleFontFamily
      })));

      if (auxCounter > 1 && (auxCounter % 3 === 0 || antSection !== (product === null || product === void 0 ? void 0 : product.section))) {
        if (auxCounter < 3) {
          for (var i = auxCounter; i < 3; i += 1) {
            itemsInf.push( /*#__PURE__*/React__default$1["default"].createElement("div", {
              className: "md:tw-h-40 PRODUCTS__COLLECTION__PRODUCT_SPACING PRODUCTS__COLLECTION__product_commodin"
            }));
          }
        }

        itemsSup.push( /*#__PURE__*/React__default$1["default"].createElement("div", {
          className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_ITEM each-slide tw-grid  md:tw-grid-cols-3  tw-gap-4"
        }, /*#__PURE__*/React__default$1["default"].createElement("div", {
          className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_ITEM_BOX md:tw-col-span-3"
        }, /*#__PURE__*/React__default$1["default"].createElement(Title$9, {
          className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_ITEM_TITLE PRODUCTS__COLLECTION__controller_container_list_item_title",
          fontFamily: fontFamilyOfSectionTitles,
          size: sizeOfSectionTitles
        }, antSection)), itemsInf));
        itemsInf = [];
        auxCounter = 0;
      } // generalCounter += 1;


      antSection = product === null || product === void 0 ? void 0 : product.section;
      return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null);
    });

    if (itemsInf.length > 0) {
      for (var i = itemsInf.length; i < 3; i += 1) {
        itemsInf.push( /*#__PURE__*/React__default$1["default"].createElement("div", {
          className: "PRODUCTS__COLLECTION__product md:tw-h-40"
        }));
      }

      itemsSup.push( /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_ITEM each-slide tw-grid  md:tw-grid-cols-3 tw-gap-4"
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_ITEM_BOX md:tw-col-span-3"
      }, /*#__PURE__*/React__default$1["default"].createElement(Title$9, {
        className: "PRODUCTS__COLLECTION__CONTROLLER_CONTAINER_LIST_ITEM_TITLE PRODUCTS__COLLECTION__controller_container_list_item_title",
        fontFamily: fontFamilyOfSectionTitles,
        size: sizeOfSectionTitles
      }, antSection)), itemsInf));
    }
  };

  items();
  var PageFooter = styled__default["default"].h3(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    float: right;\n  "])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), getTextSize(textSizesVariantsTypes.VERY_SMALL), getColors(colorsVariantsTypes.SEMI_DARK));
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    id: data[0].productsId,
    className: "PRODUCT__COLLECTION__CONTAINER tw-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(reactSlideshowImage_min.Slide, _extends$g({
    className: "PRODUCT__COLLECTION__SLIDE tw-relative"
  }, settingsSlider), itemsSup), /*#__PURE__*/React__default$1["default"].createElement(PageFooter, {
    className: "DIVIDER_IMAGE_PAGE_FOOTER"
  }, (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.PageFooter));
}

ProductsCollection.defaultProps = {
  data: []
};
ProductsCollection.protoTypes = {
  settings: PropTypes.objectOf(PropTypes.shape({
    slidesPerView: PropTypes.string,
    spaceBetween: PropTypes.number,
    navigation: PropTypes.bool,
    pagination: PropTypes.objectOf(PropTypes.shape({
      clickable: PropTypes.bool
    }))
  })),
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.shape({
      buttonText: PropTypes.string.isRequired,
      buttonUrl: PropTypes.string.isRequired,
      image: PropTypes.object.isRequired,
      price: PropTypes.number.isRequired,
      priceSubTitle: PropTypes.string.isRequired,
      subTitle: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }))).isRequired
  }))).isRequired
};
var _excluded$S = ["data", "centralLink", "applyMaxWidthContainer", "itemsType", "productGradientColors", "buttonHoverOutline", "buttonWithoutBorderRadius", "buttonHoverColor", "buttonGrayscale", "dividerWithoutGradient", "dividerOpacity", "productGrid", "colorDivider", "borderColor"];

var _templateObject$1u, _templateObject2$C, _templateObject3$u, _templateObject4$n, _templateObject5$i, _templateObject6$c, _templateObject7$6, _templateObject8$4;

var Container$4 = styled__default["default"].div(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteral(["\n  &,\n  &.tw-container {\n    max-width: 100%;\n    overflow-x: auto;\n    margin: 0 0 calc(var(--padding-default) * 1.3) 0;\n    padding: 0 0 1rem 0;\n  }\n"])));
var PageFooter = styled__default["default"].h3(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n  float: right;\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), getTextSize(textSizesVariantsTypes.VERY_SMALL), getColors(colorsVariantsTypes.SEMI_DARK));
var ProductsListContainer = styled__default["default"].div(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 var(--padding-default);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  flex-wrap: ", ";\n\n  @media all and (max-width: ", "px) {\n    padding: 0 var(--padding-sm);\n  }\n\n  @media all and (max-width: ", "px) {\n    flex-direction: column;\n  }\n\n  @media all and (max-width: ", "px) {\n    //  padding: 0 var(--padding-lg);\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @media all and (max-width: ", "px) {\n    //  padding: 0 var(--padding-xl);\n  }\n"])), function (_ref) {
  var _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap;
  return wrap ? "wrap" : "nowrap";
}, function (_ref2) {
  var _theme$breakpoints;

  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.sm) || 0;
}, function (_ref3) {
  var _theme$breakpoints2;

  var _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? {} : _ref3$theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.md) || 0;
}, function (_ref4) {
  var _theme$breakpoints3;

  var _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? {} : _ref4$theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints3 = theme.breakpoints) === null || _theme$breakpoints3 === void 0 ? void 0 : _theme$breakpoints3.lg) || 0;
}, function (_ref5) {
  var _theme$breakpoints4;

  var _ref5$theme = _ref5.theme,
      theme = _ref5$theme === void 0 ? {} : _ref5$theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$breakpoints4 = theme.breakpoints) === null || _theme$breakpoints4 === void 0 ? void 0 : _theme$breakpoints4.xl) || 0;
});
var LinksArrayContainer = styled__default["default"].div(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  margin-top: 1rem;\n"])));
var LinkContainer = styled__default["default"].div(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral(["\n  margin: 50px auto;\n  width: max-content;\n"])));
var LinkText = styled__default["default"].a(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1.7rem;\n  font-weight: bold;\n  display: block;\n"])), getColors(colorsVariantsTypes.PRIMARY_DARK));
var LinkHoverText = styled__default["default"].div(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", "px;\n  margin: 10px auto;\n  background: transparent;\n\n  ", ":hover & {\n    background: linear-gradient(\n      264.35deg,\n      ", " 2.57%,\n      ", " 95.51%\n    );\n    opacity: 0.5;\n  }\n"])), function (_ref6) {
  var _ref6$height = _ref6.height,
      height = _ref6$height === void 0 ? 4 : _ref6$height;
  return height;
}, LinkContainer, function (_ref7) {
  var _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? getColors(colorsVariantsTypes.PRIMARY_SEMI_DARK) : _ref7$color;
  return color;
}, function (_ref8) {
  var _ref8$gradient = _ref8.gradient,
      gradient = _ref8$gradient === void 0 ? getColors(colorsVariantsTypes.PRIMARY_DARK) : _ref8$gradient;
  return gradient;
});
var ProductContainer = styled__default["default"].div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n  margin: 0 2rem 0 0;\n\n  &:last-child {\n    margin: 0;\n  }\n\n  @media (max-width: ", "px) {\n    margin: 0 1rem 0 0;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    margin: 1rem;\n\n    &:last-child {\n      margin: 1rem;\n    }\n  }\n\n  @media (max-width: ", "px) {\n    &:last-child {\n      margin: 1rem;\n    }\n  }\n"])), function (_ref9) {
  var _theme$breakpoints5;

  var _ref9$theme = _ref9.theme,
      theme = _ref9$theme === void 0 ? {} : _ref9$theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$breakpoints5 = theme.breakpoints) === null || _theme$breakpoints5 === void 0 ? void 0 : _theme$breakpoints5.xl;
}, function (_ref10) {
  var _theme$breakpoints6;

  var _ref10$theme = _ref10.theme,
      theme = _ref10$theme === void 0 ? {} : _ref10$theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$breakpoints6 = theme.breakpoints) === null || _theme$breakpoints6 === void 0 ? void 0 : _theme$breakpoints6.lg;
}, function (_ref11) {
  var _theme$breakpoints7;

  var _ref11$theme = _ref11.theme,
      theme = _ref11$theme === void 0 ? {} : _ref11$theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$breakpoints7 = theme.breakpoints) === null || _theme$breakpoints7 === void 0 ? void 0 : _theme$breakpoints7.md;
});

function ProductsList(_ref12) {
  var _data$, _data$2, _data$3;

  var data = _ref12.data,
      _ref12$centralLink = _ref12.centralLink,
      centralLink = _ref12$centralLink === void 0 ? [] : _ref12$centralLink,
      _ref12$applyMaxWidthC = _ref12.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref12$applyMaxWidthC === void 0 ? false : _ref12$applyMaxWidthC,
      _ref12$itemsType = _ref12.itemsType,
      itemsType = _ref12$itemsType === void 0 ? productVariantsTypes.None : _ref12$itemsType,
      _ref12$productGradien = _ref12.productGradientColors,
      productGradientColors = _ref12$productGradien === void 0 ? [getColors(colorsVariantsTypes.PRIMARY), getColors(colorsVariantsTypes.PRIMARY)] : _ref12$productGradien,
      _ref12$buttonHoverOut = _ref12.buttonHoverOutline,
      buttonHoverOutline = _ref12$buttonHoverOut === void 0 ? false : _ref12$buttonHoverOut,
      _ref12$buttonWithoutB = _ref12.buttonWithoutBorderRadius,
      buttonWithoutBorderRadius = _ref12$buttonWithoutB === void 0 ? false : _ref12$buttonWithoutB,
      _ref12$buttonHoverCol = _ref12.buttonHoverColor,
      buttonHoverColor = _ref12$buttonHoverCol === void 0 ? false : _ref12$buttonHoverCol,
      _ref12$buttonGrayscal = _ref12.buttonGrayscale,
      buttonGrayscale = _ref12$buttonGrayscal === void 0 ? false : _ref12$buttonGrayscal,
      _ref12$dividerWithout = _ref12.dividerWithoutGradient,
      dividerWithoutGradient = _ref12$dividerWithout === void 0 ? false : _ref12$dividerWithout,
      _ref12$dividerOpacity = _ref12.dividerOpacity,
      dividerOpacity = _ref12$dividerOpacity === void 0 ? 0.5 : _ref12$dividerOpacity,
      _ref12$productGrid = _ref12.productGrid,
      productGrid = _ref12$productGrid === void 0 ? "grid" : _ref12$productGrid,
      _ref12$colorDivider = _ref12.colorDivider,
      colorDivider = _ref12$colorDivider === void 0 ? getColors(colorsVariantsTypes.PRIMARY_DARK) : _ref12$colorDivider,
      _ref12$borderColor = _ref12.borderColor,
      borderColor = _ref12$borderColor === void 0 ? colorsTypes.PRIMARY : _ref12$borderColor,
      otherProps = _objectWithoutProperties$1(_ref12, _excluded$S);

  var listDisplay = {
    display: productGrid
  };
  if (!data) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$4, {
    id: (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.productsId,
    style: listDisplay,
    className: classnames("PRODUCTS_LIST__CONTAINER PRODUCTS__LIST__CONTAINER PRODDUCTS__LIST__products_list_container tw-x-container", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement(ProductsListContainer, {
    className: "PRODUCTS_LIST__CONTAINER_BOX PRODDUCTS__LIST__products_list_container"
  }, ((_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.section) && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "PRODUCTS__LIST__PRODUCT_CONTAINER_TITLE tw-hidden"
  }, (_data$3 = data[0]) === null || _data$3 === void 0 ? void 0 : _data$3.section), data.map(function (card, index) {
    var _data$4, _data$5;

    return /*#__PURE__*/React__default$1["default"].createElement(ProductContainer, {
      key: "Product-card-".concat(index),
      className: "PRODUCTS_CONTAINER PRODUCTS__LIST__PRODUCT_CONTAINER PRODDUCTS__LIST__product_container PRODUCT Product"
    }, /*#__PURE__*/React__default$1["default"].createElement(Product, _extends$g({
      variant: itemsType,
      title: card.title,
      image: card.image,
      subTitle: card.subTitle,
      price: card.price,
      priceSubTitle: card.priceSubTitle,
      buttonUrl: card.buttonUrl,
      buttonText: card.buttonText,
      buttonGrayscale: buttonGrayscale,
      buttonHoverOutline: buttonHoverOutline,
      buttonWithoutBorderRadius: buttonWithoutBorderRadius,
      buttonHoverColor: buttonHoverColor,
      gradientColors: productGradientColors,
      dividerWithoutGradient: dividerWithoutGradient,
      dividerOpacity: dividerOpacity,
      colorDivider: colorDivider,
      borderColor: borderColor
    }, otherProps)), ((_data$4 = data[0]) === null || _data$4 === void 0 ? void 0 : _data$4.PageFooter) && /*#__PURE__*/React__default$1["default"].createElement(PageFooter, {
      className: "DIVIDER_IMAGE_PAGE_FOOTER tw-hidden"
    }, (_data$5 = data[0]) === null || _data$5 === void 0 ? void 0 : _data$5.PageFooter));
  })), Array.isArray(centralLink) && centralLink.length > 0 && /*#__PURE__*/React__default$1["default"].createElement(LinksArrayContainer, {
    className: "PRODUCTS__LIST__ITEM PRODUCTS__LIST__links_array_container"
  }, centralLink.map(function (element, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(LinkContainer, {
      className: "PRODUCTS__LIST__ITEM_CONTAINER PRODUCTS__LIST__link_container",
      key: "central_link_".concat(index)
    }, /*#__PURE__*/React__default$1["default"].createElement(LinkText, {
      href: element.url,
      className: "PRODUCTS__LIST__ITEM_CONTAINER_TEXT"
    }, element.text), /*#__PURE__*/React__default$1["default"].createElement(LinkHoverText, {
      className: "PRODUCTS__LIST__ITEM_CONTAINER_HOVER PRODUCTS__LIST__link_hover_text"
    }));
  })));
}

var ProductsList$1 = withErrorBoundary(ProductsList);
var _excluded$R = ["title", "data", "variant", "typeOfItems", "buttonStylesProps"];

function Products(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? productsVariantsTypes.NONE : _ref$variant,
      _ref$typeOfItems = _ref.typeOfItems,
      typeOfItems = _ref$typeOfItems === void 0 ? productVariantsTypes.NONE : _ref$typeOfItems,
      _ref$buttonStylesProp = _ref.buttonStylesProps,
      buttonStylesProps = _ref$buttonStylesProp === void 0 ? {} : _ref$buttonStylesProp,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$R);

  if (lodash.isEmpty(data) && Array.isArray(data) && !data.length || !Array.isArray(data)) return null;

  switch (variant) {
    case productsVariantsTypes.HORIZONTAL_COLLECTION:
      return /*#__PURE__*/React__default$1["default"].createElement(ProductsCollection, _extends$g({
        className: "PRODUCTS__INDEX___switch_products_collection",
        data: data,
        title: title,
        typeOfItems: typeOfItems,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    case productsVariantsTypes.LIST:
      return /*#__PURE__*/React__default$1["default"].createElement(ProductsList$1, _extends$g({
        className: "PRODUCTS__INDEX___switch_products_list",
        data: data,
        itemsType: typeOfItems,
        buttonStylesProps: buttonStylesProps
      }, otherProps));

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

Products.defaultProps = {
  items: []
};
Products.protoTypes = {
  variant: PropTypes.string.isRequired,
  typeOfItems: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.shape({
    buttonText: PropTypes.string.isRequired,
    buttonUrl: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    priceSubTitle: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }))).isRequired
};
var _excluded$Q = ["data"],
    _excluded2 = ["variant", "itemsVariant", "Products"];

function ProductsWithDividers(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$Q);

  var _data$variant = data.variant,
      variant = _data$variant === void 0 ? productsVariantsTypes.LIST : _data$variant,
      _data$itemsVariant = data.itemsVariant,
      itemsVariant = _data$itemsVariant === void 0 ? productVariantsTypes.OUTLINE : _data$itemsVariant,
      _data$Products = data.Products,
      products = _data$Products === void 0 ? [] : _data$Products,
      otherDataProps = _objectWithoutProperties$1(data, _excluded2);

  return /*#__PURE__*/React__default$1["default"].createElement(Dividers, _extends$g({
    variant: dividersVariantsTypes.PRODUCTS,
    data: products,
    itemVariant: variant,
    subItemVariant: itemsVariant
  }, otherProps, otherDataProps));
}

var _templateObject$1t, _templateObject2$B, _templateObject3$t, _templateObject4$m, _templateObject5$h, _templateObject6$b, _templateObject7$5, _templateObject8$3, _templateObject9$2;

var Container$3 = styled__default["default"].div(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-top: 65px;\n  margin-bottom: 65px;\n"])));
var ButtonContainer = styled__default["default"].div(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n  width: 25%;\n  margin-top: auto;\n  margin-bottom: auto;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1023px) {\n    align-items: center;\n    width: 100%;\n  }\n"])));
var ButtonRates = styled__default["default"](Button$2)(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral(["\n  width: fit-content;\n"])));
var RatesContainer = styled__default["default"].div(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral(["\n  width: 75%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  @media (max-width: 1023px) {\n    width: 100%;\n  }\n"])));
var Rate = styled__default["default"].div(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral(["\n  max-width: 260px;\n  text-align: center;\n  padding-left: 25px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1023px) {\n    margin-top: 30px;\n    margin-bottom: 0px;\n    max-width: none;\n    width: 100%;\n    padding-left: 0px;\n  }\n"])));
var RateTitle = styled__default["default"].h5(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral(["\n  padding: 5px 0px;\n  flex: 1;\n  font-family: var(--secondary-family);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: var(--primary-110-color);\n"])));
var RateSubtitle = styled__default["default"].p(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n  flex: 1;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n"])));
var RateContent = styled__default["default"].h3(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n  flex: 1;\n  font-family: var(--secondary-family);\n  white-space: pre;\n  color: var(--primary-110-color);\n  font-weight: 600;\n  font-size: 62px;\n  line-height: 70px;\n"])));
var RateDescription = styled__default["default"].p(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n  flex: 1;\n  color: var(--primary-color);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n"])));

function ProductsRates(_ref) {
  var data = _ref.data;
  var _data$buttonName = data.buttonName,
      buttonName = _data$buttonName === void 0 ? "" : _data$buttonName,
      _data$link = data.link,
      link = _data$link === void 0 ? "" : _data$link,
      _data$rates = data.rates,
      rates = _data$rates === void 0 ? [] : _data$rates;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$3, {
    className: "PRODUCTS_RATES tw-x-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(ButtonContainer, {
    className: "PRODUCTS_RATES__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(ButtonRates, {
    is: "a",
    href: link,
    className: "PRODUCTS_RATES__BUTTON"
  }, buttonName)), /*#__PURE__*/React__default$1["default"].createElement(RatesContainer, {
    className: "PRODUCTS_RATES__RATES__CONTAINER"
  }, rates.length > 0 && rates.map(function (item) {
    return /*#__PURE__*/React__default$1["default"].createElement(Rate, {
      className: "PRODUCTS_RATES__RATE",
      key: nanoid()
    }, /*#__PURE__*/React__default$1["default"].createElement(RateTitle, {
      className: "PRODUCTS_RATES__TITLE"
    }, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/React__default$1["default"].createElement(RateSubtitle, {
      className: "PRODUCTS_RATES__SUBTITLE"
    }, item === null || item === void 0 ? void 0 : item.subtitle), /*#__PURE__*/React__default$1["default"].createElement(RateContent, {
      className: "PRODUCTS_RATES_CONTENT"
    }, item.content), /*#__PURE__*/React__default$1["default"].createElement(RateDescription, {
      className: "PRODUCTS_RATES_DESCRIPTION"
    }, item === null || item === void 0 ? void 0 : item.description));
  })));
}

function RenderDynamicZoneComponent(_ref) {
  var _ref$componentName = _ref.componentName,
      componentName = _ref$componentName === void 0 ? dynamicPageRendereableComponentsTypes.NONE : _ref$componentName,
      _ref$stylesProps = _ref.stylesProps,
      stylesProps = _ref$stylesProps === void 0 ? {} : _ref$stylesProps,
      data = _ref.data;
  var buttonStylesProps = stylesProps.buttonStylesProps;

  switch (componentName) {
    case dynamicPageRendereableComponentsTypes.VIDEO_LIST:
      return /*#__PURE__*/React__default$1["default"].createElement(VideoList, {
        data: data
      });

    case dynamicPageRendereableComponentsTypes.PAGE_HEADER_GRADIENT:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-pt-28"
      }, /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, {
        variant: pageHeaderVariantsTypes.GRADIENT,
        color: pageHeaderColorVariantsTypes.PRIMARY,
        data: data
      }));

    case dynamicPageRendereableComponentsTypes.PAGE_HEADER_GRADIENTS:
      return /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, {
        variant: pageHeaderVariantsTypes.GRADIENTS,
        color: pageHeaderColorVariantsTypes.PRIMARY,
        data: data
      });

    case dynamicPageRendereableComponentsTypes.FEATURES_V2:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-mb-20 md:tw-mb-48 RENDER_DYNAMIC_ZONE_FEATURE_V2_DIVIDER_1"
      }), /*#__PURE__*/React__default$1["default"].createElement(Feature, {
        variant: featureVariantsTypes.V2,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-mb-20 md:tw-mb-48 RENDER_DYNAMIC_ZONE_FEATURE_V2_DIVIDER_2"
      })));

    case dynamicPageRendereableComponentsTypes.FEATURES_V1:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-mb-20 md:tw-mb-48 RENDER_DYNAMIC_ZONE_FEATURE_V1_DIVIDER_1"
      }), /*#__PURE__*/React__default$1["default"].createElement(Feature, {
        variant: featureVariantsTypes.V1,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-mb-20 md:tw-mb-48 RENDER_DYNAMIC_ZONE_FEATURE_V1_DIVIDER_2"
      })));

    case dynamicPageRendereableComponentsTypes.TABLE:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Table$1, {
        title: data.title,
        description: data.description,
        HeadTitles: data.HeadTitles,
        TableItems: data.TableItems
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-6"
      }));

    case dynamicPageRendereableComponentsTypes.TEXTS_LISTS:
      var isListDotten = data.listDecoration === "none";
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, {
        buttonStylesProps: buttonStylesProps,
        data: data,
        variant: isListDotten ? bodyTextVariantsTypes.DECORATION_NONE : bodyTextVariantsTypes.DECORATION_DOTTEN
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.HERO:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(Hero$1, {
        variant: heroVariantsTypes.FULL,
        data: data.Heros
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.PRODUCTS:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(Products, {
        data: data.Products,
        variant: productsVariantsTypes.LIST,
        typeOfItems: productVariantsTypes.OUTLINE
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.CALLOUT_BUTTON:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, {
        variant: calloutVariantsTypes.BUTTON,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.CALLOUT_DATA:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, {
        variant: calloutVariantsTypes.DATA,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.CALLOUT_MOBILE_APPS:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, {
        variant: data.Type || calloutVariantsTypes.MOBILE_APPS,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.IMAGES_GALERY:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(ImagesGalery$1, {
        variant: data.variant || imagesGaleryVariantsTypes.NONE,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.IMAGES_GALERY_RICHTEXT:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(ImagesGaleryRichText, {
        variant: data.variant || imagesGaleryVariantsTypes.RICHTEXT,
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    case dynamicPageRendereableComponentsTypes.MEMBER_FEEDBACK:
      return /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackForm, {
        data: data
      });

    case dynamicPageRendereableComponentsTypes.POP_UP_GALERY:
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-container"
      }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }), /*#__PURE__*/React__default$1["default"].createElement(PopUpGaleryCommon, {
        data: data
      }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-7"
      }));

    default:
      return null;
  }
}

function Slider(_ref) {
  var children = _ref.children;
  var SLIDE_CONFIG = {
    duration: 6000,
    transitionDuration: 2000,
    pauseOnHover: true,
    infinite: true,
    indicators: true,
    arrows: false
  };
  return /*#__PURE__*/React__default$1["default"].createElement(reactSlideshowImage_min.Fade, SLIDE_CONFIG, children);
}

var _templateObject$1s, _templateObject2$A, _templateObject3$s, _templateObject4$l, _templateObject5$g;

var SearchCustomInput$1 = styled__default["default"](CustomInput$1)(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteral(["\n  padding-left: 25px;\n"])));
var InputSearchContainer = styled__default["default"].div(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 14px;\n  top: 19px;\n"])));
var InputSearchSvg = styled__default["default"].svg(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: 10px;\n"])));
var InputXContainer = styled__default["default"].div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 12px;\n  top: 15px;\n"])));
var CustomInputLabelText = styled__default["default"].p(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n"])));

function SearchInput(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? undefined : _ref$formik,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? "" : _ref$keyName,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? undefined : _ref$name,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? undefined : _ref$autoComplete,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$disable = _ref.disable,
      disable = _ref$disable === void 0 ? false : _ref$disable,
      _ref$success = _ref.success,
      $success = _ref$success === void 0 ? undefined : _ref$success,
      _ref$error = _ref.error,
      $error = _ref$error === void 0 ? undefined : _ref$error,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "" : _ref$backgroundColor,
      _ref$hoverBackground = _ref.hoverBackground,
      hoverBackground = _ref$hoverBackground === void 0 ? "" : _ref$hoverBackground,
      _ref$hiddenBg = _ref.hiddenBg,
      hiddenBg = _ref$hiddenBg === void 0 ? false : _ref$hiddenBg,
      _ref$like = _ref.like,
      like = _ref$like === void 0 ? INPUT : _ref$like,
      _ref$withBorder = _ref.withBorder,
      withBorder = _ref$withBorder === void 0 ? false : _ref$withBorder,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 50 : _ref$height,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$value = _ref.value,
      $value = _ref$value === void 0 ? undefined : _ref$value,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? undefined : _ref$minLength,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? undefined : _ref$maxLength,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
      _ref$inputStyles = _ref.inputStyles,
      inputStyles = _ref$inputStyles === void 0 ? {} : _ref$inputStyles,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? false : _ref$search;

  var _useInput = useInput({
    type: type,
    keyName: keyName,
    isRequired: isRequired,
    disable: disable,
    label: label,
    onChange: _onChange,
    formik: formik,
    minLength: minLength,
    maxLength: maxLength
  }),
      payload = _useInput.payload,
      actions = _useInput.actions;

  var formikValue = payload.formikValue,
      _payload$formikField = payload.formikField,
      formikField = _payload$formikField === void 0 ? {} : _payload$formikField,
      formikError = payload.formikError,
      isTouched = payload.isTouched;
  var $id = keyName || lodash.random(0, 99999999);
  var value = formik ? formikValue || "" : payload.value || "";
  var success = !formikError && !!isTouched && !!value || !!value && isRequired && !!isTouched;
  var error = !!formikError && !!isTouched || !value && isRequired && !!isTouched;
  if ($value !== undefined) value = $value;
  if ($success !== undefined) success = $success;
  if ($error !== undefined) error = $error;
  return /*#__PURE__*/React__default$1["default"].createElement(InputContainer, _extends$g({
    backgroundColor: backgroundColor,
    hoverBackground: hoverBackground,
    hiddenBg: hiddenBg,
    borderRadius: borderRadius,
    htmlFor: name || $id,
    onBlur: actions.onBlur,
    onClick: actions.onClick,
    success: success,
    error: error,
    withBorder: withBorder,
    like: like,
    height: height,
    className: "FORM__INPUT__CONTAINER FORM_INPUT ".concat(className)
  }, inputStyles, styles), search ? /*#__PURE__*/React__default$1["default"].createElement(InputSearchContainer, {
    className: "INPUT_SEARCH_ICON"
  }, /*#__PURE__*/React__default$1["default"].createElement(InputSearchSvg, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    fill: "currentColor",
    className: "SEARCH_ICON bi bi-search",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
  }))) : null, search ? /*#__PURE__*/React__default$1["default"].createElement(InputXContainer, {
    className: "INPUT_X_ICON"
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return actions.onClear(true);
    }
  }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "currentColor",
    className: " bi bi-x",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
  })))) : null, /*#__PURE__*/React__default$1["default"].createElement(InputLabel, {
    top: value ? height * 0.08 : height * 0.32
  }, /*#__PURE__*/React__default$1["default"].createElement(CustomInputLabelText, {
    success: success,
    error: error,
    like: INPUT_TEXT,
    className: "INPUT_LABEL_TEXT bl-text-xxs tw-font-medium"
  }, search ? /*#__PURE__*/React__default$1["default"].createElement("span", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0") : null, "".concat(label).concat(!isRequired ? " (Optional)" : ""))), /*#__PURE__*/React__default$1["default"].createElement(InputBox, {
    hasData: !!value
  }, /*#__PURE__*/React__default$1["default"].createElement(SearchCustomInput$1, _extends$g({}, formikField, {
    autoComplete: autoComplete,
    id: name || $id,
    name: name || $id,
    disabled: disable,
    type: type,
    success: success,
    error: error,
    className: "bl-text-sm tw-font-medium bl-text-grayscale-80 INPUT_BOX_CUSTOM_INPUT" // placeholder={label}
    ,
    value: value,
    onChange: function onChange(event) {
      if (_onChange !== undefined) _onChange(event);
      actions.handleChangeValue(event);
    }
  }))), !!error && /*#__PURE__*/React__default$1["default"].createElement(InputLabelError, {
    bottom: error ? -20 : 0,
    length: (formikError === null || formikError === void 0 ? void 0 : formikError.length) || 0
  }, /*#__PURE__*/React__default$1["default"].createElement(InputLabelText, {
    error: true,
    like: INPUT_TEXT,
    className: "TEXT__ERROR__FIELD bl-text-xxs tw-font-medium"
  }, formikError)));
}

var SearchInput$1 = /*#__PURE__*/React.memo(SearchInput);

var _templateObject$1r, _templateObject2$z, _templateObject3$r, _templateObject4$k, _templateObject5$f;

global.fetch = require("node-fetch");
var Title$8 = styled__default["default"].h1(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteral(["\n  font-family: var(--Secondary-family);\n  color: var(--primary-150-color);\n  font-size: 42px;\n  font-weight: 600;\n\n  @media (max-width: var(--breakpoints-md)) {\n    font-size: 26px;\n  }\n"])));
var Rectangle = styled__default["default"].div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 2px;\n  background-color: var(--primary-50-color);\n"])));
var SearchCustomInput = styled__default["default"](SearchInput$1)(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\n  background: var(--primary-6-color) !important;\n  border: none;\n  border-radius: 0;\n  color: var(--grayscale-100-color);\n"])));
var SearchResultTitle = styled__default["default"].div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\n  font-size: 22px;\n  line-height: 28px;\n  color: var(--grayscale-100-color);\n  padding-top: 50px;\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: 400;\n"])));
var SearchResultDescription = styled__default["default"].div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--grayscale-70-color);\n"])));
var pages = [];
var filteredPages = [];

function Search(_ref) {
  var data = _ref.data,
      _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon;

  function fetchSitemap() {
    return _fetchSitemap.apply(this, arguments);
  }

  function _fetchSitemap() {
    _fetchSitemap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch("".concat(process.env.GATSBY_CMS_URL, "/credit-unions/search/").concat(lodash.snakeCase(process.env.GATSBY_CU_NAME)));

            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();

            case 5:
              pages = _context.sent;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchSitemap.apply(this, arguments);
  }

  fetchSitemap();

  function filterSitemap(_x) {
    return _filterSitemap.apply(this, arguments);
  }

  function _filterSitemap() {
    _filterSitemap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(searchInput) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              filteredPages = pages.filter(function (item) {
                var _item$metadata, _item$metadata$title, _item$metadata2, _item$metadata2$descr;

                if ((_item$metadata = item.metadata) !== null && _item$metadata !== void 0 && (_item$metadata$title = _item$metadata.title) !== null && _item$metadata$title !== void 0 && _item$metadata$title.toLowerCase().includes(searchInput.toLowerCase()) || (_item$metadata2 = item.metadata) !== null && _item$metadata2 !== void 0 && (_item$metadata2$descr = _item$metadata2.description) !== null && _item$metadata2$descr !== void 0 && _item$metadata2$descr.toLowerCase().includes(searchInput.toLowerCase())) {
                  return true;
                }

                return false;
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _filterSitemap.apply(this, arguments);
  }

  var _useState = React.useState({}),
      _useState2 = _slicedToArray$1(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  var _onClick = function onClick(link) {
    window.location.href = link;
  };

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("SEARCH_CONTAINER tw-x-container tw-py-10", applyMaxWidthContainer && "max-width-container")
  }, (data === null || data === void 0 ? void 0 : data.searchTitle) && /*#__PURE__*/React__default$1["default"].createElement(Title$8, {
    className: "SEARCH_PAGE_TITLE tw-mb-10 tw-font-bold bl-text-primary-180 bl-text-xl"
  }, data.searchTitle ? data.searchTitle : ""), /*#__PURE__*/React__default$1["default"].createElement(SearchCustomInput, {
    type: "text",
    name: "search",
    label: data.Placeholder ? data.Placeholder : "Search Value",
    autoComplete: "off",
    value: query.search,
    success: !!query.search,
    error: !query.search,
    className: "Search_Input tw-py-4 tw-px-3 tw-rounded-lg bl-text-grayscale-100 bl-bg-grayscale-6 tw-w-full tw-block focus:tw-outline-none tw-mb-1",
    onChange: function onChange(_ref2) {
      var target = _ref2.target;
      var search = target.value;
      setQuery(_objectSpread2(_objectSpread2({}, query), {}, {
        search: search
      }));
      filterSitemap(search);
    },
    isRequired: true,
    search: true
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SEARCH_FOUND_TEXT_CONTAINER tw-flex tw-justify-end tw-mb-8"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SEARCH_FOUND_TEXT_BOX bl-text-grayscale-70"
  }, filteredPages ? /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SEARCH_FOUND_TEXT_1"
  }, " ", filteredPages.length, " Results Found") : /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SEARCH_FOUND_TEXT_2"
  }, " 0 Results Found"))), /*#__PURE__*/React__default$1["default"].createElement(Rectangle, {
    className: "SEARCH_TITLE__RECTANGLE page-title-rectangle"
  }), filteredPages ? filteredPages.map(function (item, index) {
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      role: "button",
      key: index,
      tabIndex: 0,
      onClick: function onClick() {
        return _onClick(item.link);
      },
      onKeyDown: function onKeyDown() {
        return _onClick(item.link);
      }
    }, /*#__PURE__*/React__default$1["default"].createElement(SearchResultTitle, {
      className: "SEARCH_RESULT_TITLE"
    }, " ", item.link.substring(1), " "), /*#__PURE__*/React__default$1["default"].createElement(SearchResultDescription, {
      className: "SEARCH_RESULT_DESCRIPTION"
    }, " ", item.metadata.title, " "));
  }) : null);
}

function SpeedBump(_ref) {
  var data = _ref.data,
      config = _ref.config,
      _ref$speedBumpStyles = _ref.speedBumpStyles,
      speedBumpStyles = _ref$speedBumpStyles === void 0 ? {} : _ref$speedBumpStyles;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      showModal = _useModal.showModal,
      closeModal = _useModal.closeModal;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      externalURL = _useState2[0],
      setExternalURL = _useState2[1];

  var _data$color = data.color,
      color = _data$color === void 0 ? colorsVariantsTypes.BLACK : _data$color,
      _data$size = data.size,
      size = _data$size === void 0 ? textSizesVariantsTypes.LARGE : _data$size,
      _data$fontFamily = data.fontFamily,
      fontFamily = _data$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$fontFamily;
  React.useEffect(function () {
    function onClickHandler(e) {
      var target = e.target || e.srcElement;
      if (e.target.tagName !== "A") return;

      while (target) {
        if (target instanceof HTMLAnchorElement) {
          var url = target.getAttribute("href");
          var openSpeedBumpAttr = target.getAttribute("popup");

          if (isExternalURL(url) && !insideWhitelist(url) && (openSpeedBumpAttr === "true" || openSpeedBumpAttr == null)) {
            e.preventDefault();
            setExternalURL(url);
            showModal();
          }

          break;
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener("click", onClickHandler, false);
    } else {
      document.attachEvent("onclick", onClickHandler);
    }
  }, [showModal]);

  function insideWhitelist(url) {
    var whitelist = (process.env.GATSBY_SPEEDBUMP_WHITELIST_URL || "").split(",");
    var inside = false;
    whitelist.forEach(function (item) {
      if (url.indexOf(item) !== -1) inside = true;
    });
    return inside;
  }

  return /*#__PURE__*/React__default$1["default"].createElement(ConfirmationModal, {
    color: color,
    size: size,
    fontFamily: fontFamily,
    speedBumpStyles: speedBumpStyles,
    borderWithRadius: config.borderWithRadius,
    message: data.speedBumpDisclaimer,
    isModalVisible: isModalVisible,
    showModal: showModal,
    closeModal: closeModal,
    onAccept: function onAccept() {
      window.open(externalURL);
      closeModal();
    }
  });
}

var _templateObject$1q, _templateObject2$y;

var StandardTabTitle = styled__default["default"].h4(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteral(["\n  transition: all linear 90ms;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  display: block;\n\n  white-space: ", ";\n\n  text-align: ", ";\n\n  color: ", ";\n\n  font-size: ", ";\n\n  font-family: ", ";\n"])), function (_ref) {
  var _ref$oneLine = _ref.oneLine,
      oneLine = _ref$oneLine === void 0 ? true : _ref$oneLine;
  return oneLine ? "nowrap" : "break-spaces";
}, function (_ref2) {
  var _ref2$textCenter = _ref2.textCenter,
      textCenter = _ref2$textCenter === void 0 ? true : _ref2$textCenter;
  return textCenter ? "center" : undefined;
}, function (_ref3) {
  var _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$activeColor = _ref3.activeColor,
      activeColor = _ref3$activeColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref3$activeColor,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$color;
  return getColors(active ? activeColor : color);
}, function (_ref4) {
  var _ref4$fontSize = _ref4.fontSize,
      fontSize = _ref4$fontSize === void 0 ? textSizesVariantsTypes.NORMAL : _ref4$fontSize;
  return getTextSize(fontSize);
}, function (_ref5) {
  var _ref5$fontFamily = _ref5.fontFamily,
      fontFamily = _ref5$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref5$fontFamily;
  return getFontFamily(fontFamily);
});
var StandardTabContainer = styled__default["default"].div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  transition: all linear 90ms;\n  cursor: pointer;\n  position: relative;\n\n  background: ", ";\n\n  width: ", ";\n\n  min-width: ", ";\n\n  height: ", ";\n\n  padding: ", ";\n\n  border: ", ";\n\n  border-right: ", ";\n\n  // Divider\n  &::after {\n    content: \"\";\n    transition: all linear 60ms;\n    position: absolute;\n    bottom: 0px;\n    width: 95%;\n    left: 50%;\n    right: 50%;\n    transform: translateX(-50%);\n\n    display: ", ";\n\n    height: ", "px;\n\n    background: ", ";\n  }\n\n  &::before {\n    content: \"\";\n    transition: all linear 60ms;\n    position: absolute;\n    top: 0;\n    height: 100%;\n    z-index: 10;\n\n    display: ", ";\n\n    right: -", ";\n\n    width: ", ";\n\n    background: ", ";\n  }\n\n  &:hover {\n    &::after {\n      height: ", "px;\n    }\n  }\n"])), function (_ref6) {
  var _ref6$active = _ref6.active,
      active = _ref6$active === void 0 ? false : _ref6$active,
      _ref6$activeBackgroun = _ref6.activeBackgroundColor,
      activeBackgroundColor = _ref6$activeBackgroun === void 0 ? colorsVariantsTypes.TRANSPARENT : _ref6$activeBackgroun,
      _ref6$backgroundColor = _ref6.backgroundColor,
      backgroundColor = _ref6$backgroundColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref6$backgroundColor;
  return getColors(active ? activeBackgroundColor : backgroundColor);
}, function (_ref7) {
  var _ref7$width = _ref7.width,
      width = _ref7$width === void 0 ? "100%" : _ref7$width;
  return lodash.isNumber(width) ? "".concat(width, "px") : width;
}, function (_ref8) {
  var _ref8$minWidth = _ref8.minWidth,
      minWidth = _ref8$minWidth === void 0 ? "auto" : _ref8$minWidth;
  return lodash.isNumber(minWidth) ? "".concat(minWidth, "px") : minWidth;
}, function (_ref9) {
  var _ref9$height = _ref9.height,
      height = _ref9$height === void 0 ? 75 : _ref9$height;
  return lodash.isNumber(height) ? "".concat(height, "px") : height;
}, function (_ref10) {
  var _ref10$padding = _ref10.padding,
      padding = _ref10$padding === void 0 ? 15 : _ref10$padding;
  return lodash.isNumber(padding) ? "".concat(padding, "px") : padding;
}, function (_ref11) {
  var _ref11$showAllBorders = _ref11.showAllBorders,
      showAllBorders = _ref11$showAllBorders === void 0 ? false : _ref11$showAllBorders,
      _ref11$borderColor = _ref11.borderColor,
      borderColor = _ref11$borderColor === void 0 ? colorsVariantsTypes.LIGHT : _ref11$borderColor,
      _ref11$borderWidth = _ref11.borderWidth,
      borderWidth = _ref11$borderWidth === void 0 ? 1 : _ref11$borderWidth;

  if (showAllBorders) {
    var borderSize = lodash.isNumber(borderWidth) ? "".concat(borderWidth, "px") : borderWidth;
    return "".concat(borderSize, " solid ").concat(getColors(borderColor));
  }

  return undefined;
}, function (_ref12) {
  var _ref12$active = _ref12.active,
      active = _ref12$active === void 0 ? false : _ref12$active,
      _ref12$showAllBorders = _ref12.showAllBorders,
      showAllBorders = _ref12$showAllBorders === void 0 ? false : _ref12$showAllBorders,
      _ref12$borderColor = _ref12.borderColor,
      borderColor = _ref12$borderColor === void 0 ? colorsVariantsTypes.LIGHT : _ref12$borderColor,
      _ref12$activeBorderCo = _ref12.activeBorderColor,
      activeBorderColor = _ref12$activeBorderCo === void 0 ? colorsVariantsTypes.WHITE : _ref12$activeBorderCo,
      _ref12$borderWidth = _ref12.borderWidth,
      borderWidth = _ref12$borderWidth === void 0 ? 1 : _ref12$borderWidth;

  if (showAllBorders) {
    var borderSize = active ? 0 : lodash.isNumber(borderWidth) ? "".concat(borderWidth, "px") : borderWidth;
    return "".concat(borderSize, " solid ").concat(getColors(active ? activeBorderColor : borderColor));
  }

  return undefined;
}, function (_ref13) {
  var _ref13$hiddenDivider = _ref13.hiddenDivider,
      hiddenDivider = _ref13$hiddenDivider === void 0 ? false : _ref13$hiddenDivider,
      _ref13$active = _ref13.active,
      active = _ref13$active === void 0 ? false : _ref13$active;
  if (hiddenDivider || !active) return "none";
  return "block";
}, function (_ref14) {
  var _ref14$active = _ref14.active,
      active = _ref14$active === void 0 ? false : _ref14$active;
  return active ? 2 : 0;
}, function (_ref15) {
  var _ref15$dividerColor = _ref15.dividerColor,
      dividerColor = _ref15$dividerColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref15$dividerColor;
  return getColors(dividerColor);
}, function (_ref16) {
  var _ref16$active = _ref16.active,
      active = _ref16$active === void 0 ? false : _ref16$active;
  if (!active) return "none";
  return "block";
}, function (_ref17) {
  var _ref17$borderWidth = _ref17.borderWidth,
      borderWidth = _ref17$borderWidth === void 0 ? 1 : _ref17$borderWidth;
  return lodash.isNumber(borderWidth) ? "".concat(borderWidth, "px") : borderWidth;
}, function (_ref18) {
  var _ref18$borderWidth = _ref18.borderWidth,
      borderWidth = _ref18$borderWidth === void 0 ? 1 : _ref18$borderWidth;
  return lodash.isNumber(borderWidth) ? "".concat(borderWidth, "px") : borderWidth;
}, function (_ref19) {
  var _ref19$activeBorderCo = _ref19.activeBorderColor,
      activeBorderColor = _ref19$activeBorderCo === void 0 ? colorsVariantsTypes.WHITE : _ref19$activeBorderCo;
  return getColors(activeBorderColor);
}, function (_ref20) {
  var _ref20$active = _ref20.active,
      active = _ref20$active === void 0 ? false : _ref20$active;
  return active ? 4 : 2;
});

var TabStandard = function TabStandard(_ref21) {
  var _ref21$active = _ref21.active,
      active = _ref21$active === void 0 ? false : _ref21$active,
      _ref21$title = _ref21.title,
      title = _ref21$title === void 0 ? "" : _ref21$title,
      _ref21$width = _ref21.width,
      width = _ref21$width === void 0 ? "100%" : _ref21$width,
      _ref21$height = _ref21.height,
      height = _ref21$height === void 0 ? 75 : _ref21$height,
      _ref21$padding = _ref21.padding,
      padding = _ref21$padding === void 0 ? 15 : _ref21$padding,
      _ref21$oneLine = _ref21.oneLine,
      oneLine = _ref21$oneLine === void 0 ? true : _ref21$oneLine,
      _ref21$textCenter = _ref21.textCenter,
      textCenter = _ref21$textCenter === void 0 ? false : _ref21$textCenter,
      _ref21$hiddenDivider = _ref21.hiddenDivider,
      hiddenDivider = _ref21$hiddenDivider === void 0 ? false : _ref21$hiddenDivider,
      _ref21$color = _ref21.color,
      color = _ref21$color === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref21$color,
      _ref21$activeColor = _ref21.activeColor,
      activeColor = _ref21$activeColor === void 0 ? colorsVariantsTypes.PRIMARY : _ref21$activeColor,
      _ref21$backgroundColo = _ref21.backgroundColor,
      backgroundColor = _ref21$backgroundColo === void 0 ? colorsVariantsTypes.TRANSPARENT : _ref21$backgroundColo,
      _ref21$activeBackgrou = _ref21.activeBackgroundColor,
      activeBackgroundColor = _ref21$activeBackgrou === void 0 ? colorsVariantsTypes.TRANSPARENT : _ref21$activeBackgrou,
      _ref21$dividerColor = _ref21.dividerColor,
      dividerColor = _ref21$dividerColor === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref21$dividerColor,
      _ref21$fontFamily = _ref21.fontFamily,
      fontFamily = _ref21$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref21$fontFamily,
      _ref21$fontSize = _ref21.fontSize,
      fontSize = _ref21$fontSize === void 0 ? textSizesVariantsTypes.NORMAL : _ref21$fontSize,
      _ref21$onChange = _ref21.onChange,
      onChange = _ref21$onChange === void 0 ? function () {
    return null;
  } : _ref21$onChange,
      _ref21$showAllBorders = _ref21.showAllBorders,
      showAllBorders = _ref21$showAllBorders === void 0 ? false : _ref21$showAllBorders,
      _ref21$borderColor = _ref21.borderColor,
      borderColor = _ref21$borderColor === void 0 ? colorsVariantsTypes.LIGHT : _ref21$borderColor,
      _ref21$activeBorderCo = _ref21.activeBorderColor,
      activeBorderColor = _ref21$activeBorderCo === void 0 ? colorsVariantsTypes.WHITE : _ref21$activeBorderCo,
      _ref21$borderWidth = _ref21.borderWidth,
      borderWidth = _ref21$borderWidth === void 0 ? 1 : _ref21$borderWidth;
  return /*#__PURE__*/React__default$1["default"].createElement(StandardTabContainer, {
    activeBorderColor: activeBorderColor,
    showAllBorders: showAllBorders,
    borderColor: borderColor,
    borderWidth: borderWidth,
    hiddenDivider: hiddenDivider,
    width: width,
    height: height,
    padding: padding,
    activeBackgroundColor: activeBackgroundColor,
    backgroundColor: backgroundColor,
    dividerColor: dividerColor,
    className: "STANDARD_TAB__CONTAINER",
    onClick: onChange,
    active: active
  }, /*#__PURE__*/React__default$1["default"].createElement(StandardTabTitle, {
    active: active,
    textCenter: textCenter,
    oneLine: oneLine,
    fontSize: fontSize,
    color: color,
    activeColor: activeColor,
    fontFamily: fontFamily,
    className: "STANDARD_TAB__TITLE ".concat(active && "STANDARD_TAB__TITLE__ACTIVE")
  }, title));
};

TabStandard.propTypes = {
  title: PropTypes.string.isRequired
};
var _excluded$P = ["active", "title", "variant"];

function Tab(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? tabVariantsTypes.STANDARD : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$P);

  switch (variant) {
    case tabVariantsTypes.STANDARD:
      return /*#__PURE__*/React__default$1["default"].createElement(TabStandard, _extends$g({
        title: title,
        active: active
      }, otherProps));

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

Tab.protoTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  variant: PropTypes.string.isRequired
};

var _templateObject$1p, _templateObject2$x, _templateObject3$q, _templateObject4$j, _templateObject5$e, _templateObject6$a;

var MobileTabsHeaderHeaderContainer = styled__default["default"].div(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteral(["\n  display: none;\n\n  @media all and (max-width: ", "px) {\n    // overflow: ", ";\n    margin: 0 0 17.5px 0;\n    position: relative;\n    padding: 0;\n    display: grid;\n  }\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme;
  return theme.breakpoints.md;
}, function (_ref2) {
  var _ref2$active = _ref2.active,
      active = _ref2$active === void 0 ? false : _ref2$active;
  return active ? "inherit" : "hidden";
});
var MobileTabsHeaderHeader = styled__default["default"].div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n  @media all and (max-width: ", "px) {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 10;\n    background: ", ";\n  }\n"])), function (_ref3) {
  var _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? {} : _ref3$theme;
  return theme.breakpoints.md;
}, function (_ref4) {
  var _ref4$active = _ref4.active,
      active = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$backgroundColor = _ref4.backgroundColor,
      backgroundColor = _ref4$backgroundColor === void 0 ? "linear-gradient(264.35deg, ".concat(colorsTypes.PRIMARY_DARK, " 2.57%, ").concat(colorsTypes.PRIMARY, " 95.51%)") : _ref4$backgroundColor,
      _ref4$activeBackgroun = _ref4.activeBackgroundColor,
      activeBackgroundColor = _ref4$activeBackgroun === void 0 ? colorsVariantsTypes.WHITE : _ref4$activeBackgroun;
  return active ? activeBackgroundColor : backgroundColor;
});
var MobileTabsHeaderList = styled__default["default"].div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\n  display: none;\n  z-index: 10;\n\n  @media all and (max-width: ", "px) {\n    overflow: hidden;\n    position: absolute;\n    top: calc(100% + 50px);\n    left: 0;\n    width: 100%;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: stretch;\n  }\n"])), function (_ref5) {
  var _ref5$theme = _ref5.theme,
      theme = _ref5$theme === void 0 ? {} : _ref5$theme;
  return theme.breakpoints.md;
}, function (_ref6) {
  var _ref6$showMe = _ref6.showMe,
      showMe = _ref6$showMe === void 0 ? false : _ref6$showMe;
  return showMe ? "auto" : 0;
});
var MobileTabsHeaderArrow = styled__default["default"].img(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  display: block;\n  padding: 0;\n  margin: 0 17.5px 0 0;\n"])), function (_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 24 : _ref7$size;
  return size;
}, function (_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? 24 : _ref8$size;
  return size;
});
var MobileTabsHeaderTitle = styled__default["default"].h4(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\n  text-align: left;\n\n  font-style: normal;\n  line-height: 39px;\n\n  padding: ", "px 20px;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  font-weight: ", ";\n\n  background: ", ";\n\n  background-color: ", ";\n\n  color: ", ";\n"])), function (_ref9) {
  var _ref9$active = _ref9.active,
      active = _ref9$active === void 0 ? false : _ref9$active;
  return active ? 0 : 17.5;
}, function (_ref10) {
  var _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref10$size;
  return getTextSize(size);
}, function (_ref11) {
  var _ref11$fontFamily = _ref11.fontFamily,
      fontFamily = _ref11$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref11$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref12) {
  var _ref12$active = _ref12.active,
      active = _ref12$active === void 0 ? false : _ref12$active,
      _ref12$fontWeight = _ref12.fontWeight,
      fontWeight = _ref12$fontWeight === void 0 ? 500 : _ref12$fontWeight,
      _ref12$activeFontWeig = _ref12.activeFontWeight,
      activeFontWeight = _ref12$activeFontWeig === void 0 ? 600 : _ref12$activeFontWeig;
  return active ? activeFontWeight : fontWeight;
}, function (_ref13) {
  var _ref13$active = _ref13.active,
      active = _ref13$active === void 0 ? false : _ref13$active,
      _ref13$backgroundColo = _ref13.backgroundColor,
      backgroundColor = _ref13$backgroundColo === void 0 ? colorsTypes.PRIMARY_DARK : _ref13$backgroundColo,
      _ref13$activeBackgrou = _ref13.activeBackgroundColor,
      activeBackgroundColor = _ref13$activeBackgrou === void 0 ? "initial" : _ref13$activeBackgrou;
  return active ? activeBackgroundColor : backgroundColor;
}, function (_ref14) {
  var _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref14$color;
  return color;
}, function (_ref15) {
  var _ref15$active = _ref15.active,
      active = _ref15$active === void 0 ? false : _ref15$active,
      _ref15$textColor = _ref15.textColor,
      textColor = _ref15$textColor === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref15$textColor,
      _ref15$activeTextColo = _ref15.activeTextColor,
      activeTextColor = _ref15$activeTextColo === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref15$activeTextColo;
  return getColors(active ? activeTextColor : textColor);
});
var MobileTabsHeaderTitleMain = styled__default["default"].h4(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral(["\n  text-align: left;\n\n  font-style: normal;\n  line-height: 39px;\n\n  padding: 17.5px 20px;\n\n  font-size: ", ";\n\n  font-family: ", ";\n\n  font-weight: ", ";\n\n  background: ", ";\n\n  color: ", ";\n"])), function (_ref16) {
  var _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref16$size;
  return getTextSize(size);
}, function (_ref17) {
  var _ref17$fontFamily = _ref17.fontFamily,
      fontFamily = _ref17$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref17$fontFamily;
  return getFontFamily(fontFamily);
}, function (_ref18) {
  var _ref18$active = _ref18.active,
      active = _ref18$active === void 0 ? false : _ref18$active,
      _ref18$fontWeight = _ref18.fontWeight,
      fontWeight = _ref18$fontWeight === void 0 ? 600 : _ref18$fontWeight,
      _ref18$activeFontWeig = _ref18.activeFontWeight,
      activeFontWeight = _ref18$activeFontWeig === void 0 ? 600 : _ref18$activeFontWeig;
  return active ? activeFontWeight : fontWeight;
}, function (_ref19) {
  var _ref19$active = _ref19.active,
      active = _ref19$active === void 0 ? false : _ref19$active,
      _ref19$backgroundColo = _ref19.backgroundColor,
      backgroundColor = _ref19$backgroundColo === void 0 ? "initial" : _ref19$backgroundColo,
      _ref19$activeBackgrou = _ref19.activeBackgroundColor,
      activeBackgroundColor = _ref19$activeBackgrou === void 0 ? colorsVariantsTypes.WHITE : _ref19$activeBackgrou;
  return active ? activeBackgroundColor : backgroundColor;
}, function (_ref20) {
  var _ref20$active = _ref20.active,
      active = _ref20$active === void 0 ? false : _ref20$active,
      _ref20$textColor = _ref20.textColor,
      textColor = _ref20$textColor === void 0 ? colorsVariantsTypes.WHITE : _ref20$textColor,
      _ref20$activeTextColo = _ref20.activeTextColor,
      activeTextColor = _ref20$activeTextColo === void 0 ? colorsVariantsTypes.PRIMARY_DARK : _ref20$activeTextColo;
  return getColors(active ? activeTextColor : textColor);
});

function MobileTabsHeader(_ref21) {
  var _ref21$data = _ref21.data,
      data = _ref21$data === void 0 ? [] : _ref21$data,
      _ref21$currentTab = _ref21.currentTab,
      currentTab = _ref21$currentTab === void 0 ? {} : _ref21$currentTab,
      _ref21$position = _ref21.position,
      position = _ref21$position === void 0 ? 0 : _ref21$position,
      _ref21$onChange = _ref21.onChange,
      onChange = _ref21$onChange === void 0 ? function () {
    return null;
  } : _ref21$onChange,
      _ref21$mobileArrowDow = _ref21.mobileArrowDownSrc,
      mobileArrowDownSrc = _ref21$mobileArrowDow === void 0 ? "/images/icons/arrow-white-down.ico" : _ref21$mobileArrowDow,
      _ref21$mobileArrowRig = _ref21.mobileArrowRightSrc,
      mobileArrowRightSrc = _ref21$mobileArrowRig === void 0 ? "/images/icons/arrow-up-white.svg" : _ref21$mobileArrowRig;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      mobileHeaderMenuIsActive = _useState2[0],
      setMobileHeaderMenuIsActive = _useState2[1];

  var onClickMobileTabActive = function onClickMobileTabActive() {
    setMobileHeaderMenuIsActive(!mobileHeaderMenuIsActive);
  };

  return /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeaderHeaderContainer, {
    className: "MOBILE_TABS_HEADER__HEADER__CONTAINER",
    active: !lodash.isEmpty(currentTab)
  }, /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeaderHeader, {
    className: "MOBILE_TABS_HEADER__HEADER",
    active: mobileHeaderMenuIsActive,
    onClick: onClickMobileTabActive
  }, /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeaderTitleMain, {
    className: "MOBILE_TABS_HEADER__HEADER_TITLE__MAIN",
    active: mobileHeaderMenuIsActive
  }, currentTab.title || ""), /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeaderArrow, {
    className: "MOBILE_TABS_HEADER__ARROW",
    alt: "",
    src: mobileHeaderMenuIsActive ? mobileArrowRightSrc : mobileArrowDownSrc
  })), /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeaderList, {
    className: "MOBILE_TABS_HEADER__LIST",
    showMe: mobileHeaderMenuIsActive
  }, data.map(function (_ref22) {
    var _ref22$title = _ref22.title,
        title = _ref22$title === void 0 ? "" : _ref22$title,
        _ref22$content = _ref22.content,
        content = _ref22$content === void 0 ? {} : _ref22$content;
    var tabKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var active = tabKey === position;
    return /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeaderTitle, {
      className: "MOBILE_TABS_HEADER__LIST__TITLE ".concat(active && "MOBILE_TABS_HEADER__LIST__TITLE__ACTIVE"),
      hidden: active,
      size: textSizesVariantsTypes.LARGE,
      onClick: function onClick() {
        onChange({
          title: title,
          content: content
        }, tabKey);
        onClickMobileTabActive();
      }
    }, title || "");
  })));
}

var _templateObject$1o, _templateObject2$w;

var HorizontalTabsContainer = styled__default["default"].div(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteral(["\n  & * {\n    box-sizing: border-box;\n    transition: all linear 150ms;\n  }\n\n  display: grid;\n  grid-auto-flow: row;\n  grid-auto-columns: auto;\n"])));
var HorizontalTabsHeader = styled__default["default"].div(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: auto;\n  grid-gap: 50px;\n  justify-items: center;\n  overflow: auto;\n  padding: 35px 20px 15px 20px;\n  height: ", ";\n  background: linear-gradient(\n    264.35deg,\n    ", " 2.57%,\n    ", " 95.51%\n  );\n\n  @media all and (max-width: ", "px) {\n    display: none;\n  }\n"])), function (_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 100 : _ref$height;
  return lodash.isNumber(height) ? "".concat(height, "px") : height;
}, getColors(colorsVariantsTypes.PRIMARY_DARK), getColors(colorsVariantsTypes.PRIMARY), function (_ref2) {
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  return theme.breakpoints.md;
});

var HorizontalTabs = function HorizontalTabs(_ref3) {
  var _ref3$data = _ref3.data,
      data = _ref3$data === void 0 ? [] : _ref3$data,
      _ref3$currentTab = _ref3.currentTab,
      currentTab = _ref3$currentTab === void 0 ? {} : _ref3$currentTab,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? tabVariantsTypes.NONE : _ref3$variant,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? 0 : _ref3$position,
      _ref3$onChange = _ref3.onChange,
      _onChange = _ref3$onChange === void 0 ? function () {
    return null;
  } : _ref3$onChange,
      _ref3$mobileArrowDown = _ref3.mobileArrowDownSrc,
      mobileArrowDownSrc = _ref3$mobileArrowDown === void 0 ? "/images/icons/arrow-white-down.ico" : _ref3$mobileArrowDown,
      _ref3$mobileArrowRigh = _ref3.mobileArrowRightSrc,
      mobileArrowRightSrc = _ref3$mobileArrowRigh === void 0 ? "/images/icons/arrow-up-white.svg" : _ref3$mobileArrowRigh;

  return /*#__PURE__*/React__default$1["default"].createElement(HorizontalTabsContainer, {
    className: "HORIZONTAL_TABS__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeader, {
    data: data,
    currentTab: currentTab,
    mobileArrowDownSrc: mobileArrowDownSrc,
    mobileArrowRightSrc: mobileArrowRightSrc,
    onChange: _onChange,
    position: position
  }), /*#__PURE__*/React__default$1["default"].createElement(HorizontalTabsHeader, {
    className: "HORIZONTAL_TABS__HEADER"
  }, Array.isArray(data) && data.map(function (_ref4) {
    var _ref4$title = _ref4.title,
        title = _ref4$title === void 0 ? "" : _ref4$title,
        _ref4$content = _ref4.content,
        content = _ref4$content === void 0 ? {} : _ref4$content;
    var tabKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var active = tabKey === position;
    return /*#__PURE__*/React__default$1["default"].createElement(Tab, {
      className: "HORIZONTAL_TABS_TAB ".concat(active && "HORIZONTAL_TABS_TAB__ACTIVE"),
      active: active,
      variant: variant,
      title: title,
      onChange: function onChange() {
        return _onChange({
          title: title,
          content: content
        }, tabKey);
      }
    });
  })), !!currentTab && !!currentTab.title && !!currentTab.components && /*#__PURE__*/React__default$1["default"].createElement(TabContent, _extends$g({
    className: "HORIZONTAL_TABS__TAB__CONTENT",
    variant: variant
  }, currentTab)));
};

HorizontalTabs.propTypes = {
  data: PropTypes.array.isRequired,
  variant: PropTypes.string.isRequired
};

var _templateObject$1n, _templateObject2$v, _templateObject3$p;

var VerticalTabsContent = styled__default["default"].div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteral(["\n  display: grid;\n\n  * {\n    font-family: ", ";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 22px;\n    line-height: 28px;\n  }\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY));
var VerticalTabsContainer = styled__default["default"].div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n  margin: 5rem auto 0 auto;\n  padding: 0 var(--padding-default);\n  display: grid;\n  grid-template-rows: 1fr;\n  grid-gap: 2.5rem;\n\n  grid-template-columns: ", " 1fr;\n\n  & * {\n    box-sizing: border-box;\n    transition: all linear 150ms;\n  }\n\n  .rich-text-container {\n    .custom-container.rate-list-index-container {\n      width: 100%;\n      height: 100%;\n      padding: 0;\n      margin: 0;\n    }\n  }\n\n  @media all and (min-width: ", "px) {\n    padding: 0 calc(var(--padding-default) * 3);\n  }\n\n  @media all and (max-width: ", "px) {\n    padding: 0;\n    margin: 0;\n    grid-gap: 0;\n    grid-template-columns: 1fr;\n    grid-template-rows: ", " 1fr;\n\n    .rich-text-container > .custom-container.rate-list-index-container {\n      padding: 0 var(--padding-sm);\n    }\n  }\n"])), function (_ref) {
  var _ref$menuWidth = _ref.menuWidth,
      menuWidth = _ref$menuWidth === void 0 ? 270 : _ref$menuWidth;
  return lodash.isNumber(menuWidth) ? "".concat(menuWidth, "px") : menuWidth;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  return theme.breakpoints.xl;
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? {} : _ref3$theme;
  return theme.breakpoints.md;
}, function (_ref4) {
  var _ref4$menuHeight = _ref4.menuHeight,
      menuHeight = _ref4$menuHeight === void 0 ? 50 : _ref4$menuHeight;
  return lodash.isNumber(menuHeight) ? "".concat(menuHeight, "px") : menuHeight;
});
var VerticalTabsHeader = styled__default["default"].div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-flow: row;\n  grid-auto-rows: min-content;\n  grid-gap: 0;\n  padding: 4rem 0;\n  max-height: ", ";\n\n  width: ", ";\n  border-right: ", ";\n\n  @media all and (max-width: ", "px) {\n    display: none;\n  }\n"])), function (_ref5) {
  var _ref5$columnsLenght = _ref5.columnsLenght,
      columnsLenght = _ref5$columnsLenght === void 0 ? 1 : _ref5$columnsLenght,
      _ref5$greaterColumnLe = _ref5.greaterColumnLenght,
      greaterColumnLenght = _ref5$greaterColumnLe === void 0 ? 0 : _ref5$greaterColumnLe;
  return "".concat(columnsLenght * 50 + greaterColumnLenght * 50 + 120, "px");
}, function (_ref6) {
  var _ref6$width = _ref6.width,
      width = _ref6$width === void 0 ? "auto" : _ref6$width;
  return lodash.isNumber(width) ? "".concat(width, "px") : width;
}, function (_ref7) {
  var _ref7$borderRightColo = _ref7.borderRightColor,
      borderRightColor = _ref7$borderRightColo === void 0 ? colorsVariantsTypes.LIGHT : _ref7$borderRightColo,
      _ref7$borderRightWidt = _ref7.borderRightWidth,
      borderRightWidth = _ref7$borderRightWidt === void 0 ? 1 : _ref7$borderRightWidt;
  return "solid ".concat(getColors(borderRightColor), " ").concat(lodash.isNumber(borderRightWidth) ? "".concat(borderRightWidth, "px ") : borderRightWidth);
}, function (_ref8) {
  var _ref8$theme = _ref8.theme,
      theme = _ref8$theme === void 0 ? {} : _ref8$theme;
  return theme.breakpoints.md;
});

var VerticalTabs = function VerticalTabs(_ref9) {
  var _ref9$data = _ref9.data,
      data = _ref9$data === void 0 ? [] : _ref9$data,
      _ref9$currentTab = _ref9.currentTab,
      currentTab = _ref9$currentTab === void 0 ? {} : _ref9$currentTab,
      _ref9$variant = _ref9.variant,
      variant = _ref9$variant === void 0 ? tabVariantsTypes.NONE : _ref9$variant,
      _ref9$position = _ref9.position,
      position = _ref9$position === void 0 ? 0 : _ref9$position,
      _ref9$onChange = _ref9.onChange,
      _onChange = _ref9$onChange === void 0 ? function () {
    return null;
  } : _ref9$onChange,
      _ref9$mobileArrowDown = _ref9.mobileArrowDownSrc,
      mobileArrowDownSrc = _ref9$mobileArrowDown === void 0 ? "/images/icons/arrow-white-down.ico" : _ref9$mobileArrowDown,
      _ref9$mobileArrowRigh = _ref9.mobileArrowRightSrc,
      mobileArrowRightSrc = _ref9$mobileArrowRigh === void 0 ? "/images/icons/arrow-up-white.svg" : _ref9$mobileArrowRigh,
      _ref9$tabOptions = _ref9.tabOptions,
      tabOptions = _ref9$tabOptions === void 0 ? {} : _ref9$tabOptions,
      _ref9$menuWidth = _ref9.menuWidth,
      menuWidth = _ref9$menuWidth === void 0 ? 270 : _ref9$menuWidth,
      _ref9$menuHeight = _ref9.menuHeight,
      menuHeight = _ref9$menuHeight === void 0 ? 50 : _ref9$menuHeight;

  var columnsLenght = data === null || data === void 0 ? void 0 : data.length;
  var greaterColumnLenght = 0; // eslint-disable-next-line array-callback-return

  data === null || data === void 0 ? void 0 : data.map(function (_ref10) {
    var _ref10$title = _ref10.title,
        title = _ref10$title === void 0 ? "" : _ref10$title;

    if (title.length >= 35) {
      // eslint-disable-next-line no-plusplus
      greaterColumnLenght++;
    }
  });
  return /*#__PURE__*/React__default$1["default"].createElement(VerticalTabsContainer, {
    menuWidth: menuWidth,
    menuHeight: menuHeight,
    className: "VERTICAL_TABS__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(MobileTabsHeader, {
    data: data,
    currentTab: currentTab,
    mobileArrowDownSrc: mobileArrowDownSrc,
    mobileArrowRightSrc: mobileArrowRightSrc,
    onChange: _onChange,
    position: position
  }), /*#__PURE__*/React__default$1["default"].createElement(VerticalTabsHeader, {
    className: "VERTICAL_TABS__HEADER",
    columnsLenght: columnsLenght,
    greaterColumnLenght: greaterColumnLenght
  }, Array.isArray(data) && data.map(function (_ref11) {
    var _ref11$title = _ref11.title,
        title = _ref11$title === void 0 ? "" : _ref11$title,
        _ref11$content = _ref11.content,
        content = _ref11$content === void 0 ? {} : _ref11$content;
    var tabKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return /*#__PURE__*/React__default$1["default"].createElement(Tab, _extends$g({
      active: tabKey === position,
      variant: variant,
      title: title,
      onChange: function onChange() {
        return _onChange({
          title: title,
          content: content
        }, tabKey);
      },
      className: "VERTICAL_TABS_TAB",
      hiddenDivider: true,
      showAllBorders: true,
      color: colorsVariantsTypes.LIGHT,
      fontSize: textSizesVariantsTypes.SMALL,
      backgroundColor: colorsVariantsTypes.VERY_ULTRA_LIGHT,
      activeBackgroundColor: colorsVariantsTypes.WHITE,
      oneLine: false,
      width: "100%",
      height: title.length >= 35 ? 100 : 50
    }, tabOptions));
  })), /*#__PURE__*/React__default$1["default"].createElement(VerticalTabsContent, {
    className: "VERTICAL__TABS__TAB__CONTENT"
  }, !!currentTab && !!currentTab.title && !!currentTab.components && /*#__PURE__*/React__default$1["default"].createElement(TabContent, _extends$g({
    variant: variant
  }, currentTab))));
};

VerticalTabs.propTypes = {
  data: PropTypes.array.isRequired,
  variant: PropTypes.string.isRequired
};
var _excluded$O = ["data", "variant", "typeOfItems", "customComponentStyles", "tabsProps"];

function Tabs(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? tabsVariantsTypes.HORIZONTAL : _ref$variant,
      _ref$typeOfItems = _ref.typeOfItems,
      typeOfItems = _ref$typeOfItems === void 0 ? tabVariantsTypes.STANDARD : _ref$typeOfItems,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS,
      _ref$tabsProps = _ref.tabsProps,
      tabsProps = _ref$tabsProps === void 0 ? {} : _ref$tabsProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$O);

  var tabsData = [];

  if (data && data.SingularTabComponent && Array.isArray(data.SingularTabComponent) && data.SingularTabComponent.length) {
    tabsData = data.SingularTabComponent.map(function (_ref2) {
      var _ref2$Components = _ref2.Components,
          components = _ref2$Components === void 0 ? [] : _ref2$Components,
          _ref2$created_at = _ref2.created_at,
          createdAt = _ref2$created_at === void 0 ? "" : _ref2$created_at,
          _ref2$created_by = _ref2.created_by,
          createdBy = _ref2$created_by === void 0 ? {} : _ref2$created_by,
          _ref2$id = _ref2.id,
          id = _ref2$id === void 0 ? 0 : _ref2$id,
          _ref2$published_at = _ref2.published_at,
          publishedAt = _ref2$published_at === void 0 ? "" : _ref2$published_at,
          _ref2$title = _ref2.title,
          title = _ref2$title === void 0 ? "" : _ref2$title,
          _ref2$updated_at = _ref2.updated_at,
          updatedAt = _ref2$updated_at === void 0 ? "" : _ref2$updated_at,
          _ref2$updated_by = _ref2.updated_by,
          updatedBy = _ref2$updated_by === void 0 ? {} : _ref2$updated_by;
      return {
        id: id,
        components: components,
        createdAt: createdAt,
        createdBy: createdBy,
        publishedAt: publishedAt,
        title: title,
        updatedAt: updatedAt,
        updatedBy: updatedBy
      };
    });
  } else if (Array.isArray(data) && data.length) {
    tabsData = data;
  }

  var _useState = React.useState(0),
      _useState2 = _slicedToArray$1(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useState3 = React.useState(tabsData.length ? tabsData[0] : {}),
      _useState4 = _slicedToArray$1(_useState3, 2),
      currentTab = _useState4[0],
      setCurrentTab = _useState4[1];

  var onChangeTab = function onChangeTab(tab, tabKey) {
    setPosition(tabKey);
    setCurrentTab(tabsData[tabKey]);
  };

  switch (variant) {
    case tabsVariantsTypes.VERTICAL:
      return /*#__PURE__*/React__default$1["default"].createElement(HorizontalTabs, _extends$g({
        data: tabsData,
        currentTab: currentTab,
        variant: typeOfItems,
        position: position,
        onChange: onChangeTab
      }, (customComponentStyles === null || customComponentStyles === void 0 ? void 0 : customComponentStyles.tabsProps) || {}, otherProps, tabsProps));

    case tabsVariantsTypes.HORIZONTAL:
      return /*#__PURE__*/React__default$1["default"].createElement(VerticalTabs, _extends$g({
        data: tabsData,
        currentTab: currentTab,
        variant: typeOfItems,
        position: position,
        onChange: onChangeTab
      }, (customComponentStyles === null || customComponentStyles === void 0 ? void 0 : customComponentStyles.tabsProps) || {}, otherProps, tabsProps));

    default:
      throw new Error("Invalid Branch variant: ".concat(variant));
  }
}

Tabs.protoTypes = {
  variant: PropTypes.string.isRequired,
  typeOfItems: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
};

var _templateObject$1m, _templateObject2$u, _templateObject3$o, _templateObject4$i;

var Container$2 = styled__default["default"].div(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 174px;\n  margin: 4.75rem;\n  @media (max-width: ", "px) {\n    margin-bottom: 0;\n  }\n"])), breakpoints.md);
var Name = styled__default["default"].h4(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  margin-top: 0.5rem;\n  font-family: ", ";\n  text-align: center;\n  color: ", ";\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 24px;\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
});
var Role = styled__default["default"].h6(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-align: center;\n  color: ", ";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n"])), function (_ref3) {
  var _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref4$color;
  return getColors(colorsVariantsTypes[color]);
});
var Image = styled__default["default"].img(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n  height: 110px;\n  width: 110px;\n  border-radius: 50%;\n"])));

function TeamMember(_ref5) {
  var _ref5$image = _ref5.image,
      image = _ref5$image === void 0 ? "url.png" : _ref5$image,
      _ref5$name = _ref5.name,
      name = _ref5$name === void 0 ? "Name" : _ref5$name,
      _ref5$role = _ref5.role,
      role = _ref5$role === void 0 ? "Role" : _ref5$role;
  return /*#__PURE__*/React__default$1["default"].createElement(Container$2, {
    className: "TEAM_MEMBER__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(Image, {
    className: "TEAM_MEMBER__IMAGE",
    alt: name,
    src: image
  }), /*#__PURE__*/React__default$1["default"].createElement(Name, {
    className: "TEAM_MEMBER__NAME"
  }, name), /*#__PURE__*/React__default$1["default"].createElement(Role, {
    className: "TEAM_MEMBER__ROLE"
  }, role));
}

var _templateObject$1l, _templateObject2$t, _templateObject3$n;

var Container$1 = styled__default["default"].div(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteral(["\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  padding: 6rem;\n  min-height: 600px;\n  max-width: 1200px;\n  justify-content: space-between;\n  @media (max-width: ", "px) {\n    padding: 4rem 1.5rem 3rem 1.5rem;\n    min-height: calc(100vh - 100px);\n  }\n"])), breakpoints.md);
var Title$7 = styled__default["default"].h2(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-align: center;\n  color: ", ";\n  font-size: 62px;\n  font-weight: 600;\n  line-height: 70px;\n  @media (max-width: ", "px) {\n    font-size: 42px;\n    line-height: 50px;\n    margin-bottom: -10px;\n  }\n"])), function (_ref) {
  var _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.PRIMARY : _ref2$color;
  return getColors(colorsVariantsTypes[color]);
}, breakpoints.md);
var ListContainer = styled__default["default"].div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"])));

function TeamMembers(_ref3) {
  var data = _ref3.data;
  var _data$teamId = data.teamId,
      teamId = _data$teamId === void 0 ? "" : _data$teamId,
      _data$title = data.title,
      title = _data$title === void 0 ? "Title" : _data$title,
      _data$teamMembers = data.teamMembers,
      teamMembers = _data$teamMembers === void 0 ? [] : _data$teamMembers;

  if (data) {
    return /*#__PURE__*/React__default$1["default"].createElement(Container$1, {
      id: teamId,
      className: "TEAM_MEMBERS__CONTAINER"
    }, /*#__PURE__*/React__default$1["default"].createElement(Title$7, {
      className: "TEAM_MEMBERS__TITLE"
    }, title), /*#__PURE__*/React__default$1["default"].createElement(ListContainer, {
      className: "TEAM_MEMBERS_LIST__CONTAINER"
    }, teamMembers.map(function (_ref4) {
      var id = _ref4.id,
          name = _ref4.name,
          image = _ref4.image,
          role = _ref4.role;
      return /*#__PURE__*/React__default$1["default"].createElement(TeamMember, {
        key: id,
        name: name,
        image: image.url,
        role: role
      });
    })));
  }
}

var _excluded$N = ["components"];

var TabContentStandard = function TabContentStandard(_ref) {
  var _ref$components = _ref.components,
      Components = _ref$components === void 0 ? [] : _ref$components,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$N);

  return /*#__PURE__*/React__default$1["default"].createElement(DynamicZonesPage, _extends$g({
    data: {
      Components: Components
    }
  }, otherProps));
};

TabContentStandard.propTypes = {
  components: PropTypes.array.isRequired
};
var _excluded$M = ["title", "components", "variant"];

function TabContent(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? [] : _ref$components,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? tabVariantsTypes.STANDARD : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$M);

  switch (variant) {
    case tabVariantsTypes.STANDARD:
      return /*#__PURE__*/React__default$1["default"].createElement(TabContentStandard, _extends$g({
        title: title,
        components: components
      }, otherProps));

    default:
      throw new Error("Invalid variant of TabContent: ".concat(variant));
  }
}

TabContent.protoTypes = {
  title: PropTypes.string.isRequired,
  components: PropTypes.array.isRequired,
  variant: PropTypes.string.isRequired
};

function TableComponent(_ref) {
  var _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      data = _ref.data;
  var _data$titleColor = data.titleColor,
      titleColor = _data$titleColor === void 0 ? colorsVariantsTypes.BLACK : _data$titleColor,
      _data$titleSize = data.titleSize,
      titleSize = _data$titleSize === void 0 ? textSizesVariantsTypes.VERY_BIG : _data$titleSize,
      _data$titleFontFamily = data.titleFontFamily,
      titleFontFamily = _data$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$titleFontFamily,
      _data$descriptionColo = data.descriptionColor,
      descriptionColor = _data$descriptionColo === void 0 ? colorsVariantsTypes.BLACK : _data$descriptionColo,
      _data$descriptionSize = data.descriptionSize,
      descriptionSize = _data$descriptionSize === void 0 ? textSizesVariantsTypes.SMALL : _data$descriptionSize,
      _data$descriptionFont = data.descriptionFontFamily,
      descriptionFontFamily = _data$descriptionFont === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$descriptionFont,
      _data$headTitleColor = data.headTitleColor,
      headTitleColor = _data$headTitleColor === void 0 ? colorsVariantsTypes.BLACK : _data$headTitleColor,
      _data$headTitleSize = data.headTitleSize,
      headTitleSize = _data$headTitleSize === void 0 ? textSizesVariantsTypes.SMALL : _data$headTitleSize,
      _data$headTitleFontFa = data.headTitleFontFamily,
      headTitleFontFamily = _data$headTitleFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$headTitleFontFa,
      _data$itemColor = data.itemColor,
      itemColor = _data$itemColor === void 0 ? colorsVariantsTypes.BLACK : _data$itemColor,
      _data$itemSize = data.itemSize,
      itemSize = _data$itemSize === void 0 ? textSizesVariantsTypes.SMALL : _data$itemSize,
      _data$itemFontFamily = data.itemFontFamily,
      itemFontFamily = _data$itemFontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$itemFontFamily;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("TABLE tw-x-container", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement(Table$1, {
    title: data.title,
    description: data.description,
    HeadTitles: data.HeadTitles,
    TableItems: data.TableItems,
    titleColor: titleColor,
    titleSize: titleSize,
    titleFontFamily: titleFontFamily,
    descriptionColor: descriptionColor,
    descriptionSize: descriptionSize,
    descriptionFontFamily: descriptionFontFamily,
    headTitleColor: headTitleColor,
    headTitleSize: headTitleSize,
    headTitleFontFamily: headTitleFontFamily,
    itemColor: itemColor,
    itemSize: itemSize,
    itemFontFamily: itemFontFamily
  }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "tw-my-6"
  }));
}

function TableContentItem(_ref) {
  var data = _ref.data,
      className = _ref.className,
      width = _ref.width,
      key = _ref.key,
      color = _ref.color,
      size = _ref.size,
      fontFamily = _ref.fontFamily;
  var keyNames = Object.keys(data);
  return /*#__PURE__*/React__default$1["default"].createElement("tr", {
    key: key
  }, keyNames.map(function (keyName, index) {
    if (!data[keyName] || keyName === "id") return null;
    return /*#__PURE__*/React__default$1["default"].createElement(TableContentItemLine, {
      key: index,
      className: className,
      width: width,
      color: color || colorsVariantsTypes.BLACK,
      size: size || textSizesVariantsTypes.SMALL,
      fontFamily: fontFamily || fontsFamiliesVariantsTypes.PRIMARY
    }, data[keyName]);
  }));
}

var _excluded$L = ["variant"];

function Text(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties$1(_ref, _excluded$L);

  switch (variant) {
    case textVariantsTypes.H2:
      return /*#__PURE__*/React__default$1["default"].createElement(H3$6, props);

    case textVariantsTypes.SIMPLE:
      return /*#__PURE__*/React__default$1["default"].createElement(TextSimple, props);

    case textVariantsTypes.BODY:
      return /*#__PURE__*/React__default$1["default"].createElement(TextBody, props);

    default:
      throw new Error("Invalid Text variant: ".concat(variant));
  }
}

var Text$1 = withErrorBoundary(Text);

function TextsLists(_ref) {
  var _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      data = _ref.data,
      _ref$buttonStylesProp = _ref.buttonStylesProps,
      buttonStylesProps = _ref$buttonStylesProp === void 0 ? {} : _ref$buttonStylesProp;
  var isListDotten = data.listDecoration === "none";
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("TEXT_LISTS tw-x-container", applyMaxWidthContainer && "max-width-container")
  }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "TEXT_LISTS__DIVIDER tw-my-7"
  }), /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, {
    data: data,
    buttonStylesProps: buttonStylesProps,
    variant: isListDotten ? bodyTextVariantsTypes.DECORATION_NONE : bodyTextVariantsTypes.DECORATION_DOTTEN
  }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    className: "TEXT_LISTS__DIVIDER tw-my-7"
  }));
}

function parseLinksToUsefulHTML() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var newData = data;
  var content; // regex to match links formatted from rich text

  var Uregex = new RegExp(/(<a .*?<\/u><\/span><\/a>)+/g);
  var Iregex = new RegExp(/(<a .*?<\/i><\/a>)+/g); // logic to mach the A tags and replace them with their correct form in order for the speedBump to work properly

  var UlinkMatchesSearch = data.match(Uregex) || [];
  var IlinkMatchesSearch = data.match(Iregex) || [];

  var replacedLinks = function replacedLinks(linkMatchesSearch) {
    var tagToReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /(<u>+.*?<\/u>)/g;
    var replaceInTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : /<u>|<\/u>/g;
    return linkMatchesSearch.map(function (el) {
      var href = el.match(/href="([^"]*)"/g);
      content = el.match(tagToReplace)[0].replaceAll(replaceInTag, "");
      var replacedLink = el.replaceAll(tagToReplace, "<a ".concat(href, ">").concat(content, "</a>"));
      return replacedLink;
    });
  }; // replace each element with their correct form


  UlinkMatchesSearch.forEach(function (el, index) {
    newData = newData.replace(el, replacedLinks(UlinkMatchesSearch)[index]);
  });
  IlinkMatchesSearch.forEach(function (el, index) {
    newData = newData.replace(el, replacedLinks(IlinkMatchesSearch, /<i>+.*?<\/i>/g, /<i>|<\/i>/g)[index]);
  });
  return newData;
}

function RichText(_ref) {
  var _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      data = _ref.data;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      parsedContent = _useState2[0],
      setParsedContent = _useState2[1];

  React.useEffect(function () {
    setParsedContent(parseLinksToUsefulHTML(data.content));
  }, [data]);
  var backgroundContainer = data !== null && data !== void 0 && data.withBackground ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : "";
  var content = "<div id=".concat(data.table_id, " class=\"rate-list-index-container\">\n    ").concat(parsedContent, "\n  </div>");
  return /*#__PURE__*/React__default$1["default"].createElement(RichTextContainer, {
    className: classnames("rich-text-container tw-x-container", applyMaxWidthContainer && "max-width-container"),
    backgroundContainer: backgroundContainer,
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
}

var _templateObject$1k, _templateObject2$s, _templateObject3$m;

var Title$6 = styled__default["default"].h4(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? textSizesVariantsTypes.VERY_BIG : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsVariantsTypes.BLACK : _ref$color,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref$fontFamily;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[size]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), "\n  ");
});
var Description = styled__default["default"].p(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? textSizesVariantsTypes.SMALL : _ref2$size,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsVariantsTypes.BLACK : _ref2$color,
      _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref2$fontFamily;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[size]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), "\n  ");
});
var Th = styled__default["default"].th(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.SMALL : _ref3$size,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsVariantsTypes.BLACK : _ref3$color,
      _ref3$fontFamily = _ref3.fontFamily,
      fontFamily = _ref3$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref3$fontFamily;
  return "\n    color: ".concat(getColors(colorsVariantsTypes[color]), ";\n    font-size: ").concat(getTextSize(textSizesVariantsTypes[size]), ";\n    font-family: ").concat(getFontFamily(fontsFamiliesVariantsTypes[fontFamily]), "\n  ");
});

function Table(_ref4) {
  var title = _ref4.title,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? "tw-w-1/4" : _ref4$width,
      description = _ref4.description,
      HeadTitles = _ref4.HeadTitles,
      TableItems = _ref4.TableItems,
      titleColor = _ref4.titleColor,
      titleSize = _ref4.titleSize,
      titleFontFamily = _ref4.titleFontFamily,
      descriptionColor = _ref4.descriptionColor,
      descriptionSize = _ref4.descriptionSize,
      descriptionFontFamily = _ref4.descriptionFontFamily,
      headTitleColor = _ref4.headTitleColor,
      headTitleSize = _ref4.headTitleSize,
      headTitleFontFamily = _ref4.headTitleFontFamily,
      itemColor = _ref4.itemColor,
      itemSize = _ref4.itemSize,
      itemFontFamily = _ref4.itemFontFamily;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-py-2"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$6, {
    className: "tw-font-bold tw-leading-tight tw-mb-10",
    color: titleColor || colorsVariantsTypes.BLACK,
    size: titleSize || textSizesVariantsTypes.VERY_BIG,
    fontFamily: titleFontFamily || fontsFamiliesVariantsTypes.PRIMARY
  }, title), /*#__PURE__*/React__default$1["default"].createElement(Description, {
    className: "tw-mx-1",
    color: descriptionColor || colorsVariantsTypes.BLACK,
    size: descriptionSize || textSizesVariantsTypes.SMALL,
    fontFamily: descriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY
  }, description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "TABLE__CONTAINER tw-overflow-x-auto"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "TABLE__CONTAINER_BOX tw-align-middle tw-inline-block tw-min-w-full tw-overflow-hidden bl-grayscale-0 tw-pt-3 tw-rounded-bl-lg tw-rounded-br-lg tw-w-160 md:tw-w-auto"
  }, /*#__PURE__*/React__default$1["default"].createElement("table", {
    className: "TABLE__TABLE tw-min-w-full bl-bg-primary-6 tw-rounded-t-lg tw-w-full"
  }, /*#__PURE__*/React__default$1["default"].createElement("thead", {
    className: "TABLE__THEAD"
  }, /*#__PURE__*/React__default$1["default"].createElement("tr", {
    className: "TABLE__TR"
  }, HeadTitles.map(function (item, index) {
    if (!item.text) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(Th, {
      key: "th-".concat(index),
      className: "TABLE__TH tw-px-6 tw-font-bold tw-text-left tw-leading-4 tw-tracking-wider tw-py-6",
      color: headTitleColor || colorsVariantsTypes.BLACK,
      size: headTitleSize || textSizesVariantsTypes.SMALL,
      fontFamily: headTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY
    }, item.text);
  }))), /*#__PURE__*/React__default$1["default"].createElement("tbody", {
    className: "TABLE__TBODY bl-bg-grayscale-0"
  }, TableItems.map(function (item, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(TableContentItem, {
      key: "TableContentItem-".concat(index),
      className: "TABLE__TD",
      width: width,
      data: item,
      color: itemColor || colorsVariantsTypes.BLACK,
      size: itemSize || textSizesVariantsTypes.SMALL,
      fontFamily: itemFontFamily || fontsFamiliesVariantsTypes.PRIMARY
    });
  }))))));
}

var Table$1 = withErrorBoundary(Table);

function formsService() {
  return _formsService.apply(this, arguments);
}

function _formsService() {
  _formsService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref,
        _ref$type,
        type,
        _ref$creditUnionName,
        creditUnionName,
        _ref$hostname,
        hostname,
        _ref$formData,
        formData,
        _ref$urlBase,
        urlBase,
        url,
        options,
        response,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$type = _ref.type, type = _ref$type === void 0 ? "" : _ref$type, _ref$creditUnionName = _ref.creditUnionName, creditUnionName = _ref$creditUnionName === void 0 ? process.env.GATSBY_CU_NAME || "" : _ref$creditUnionName, _ref$hostname = _ref.hostname, hostname = _ref$hostname === void 0 ? window.location.hostname || "" : _ref$hostname, _ref$formData = _ref.formData, formData = _ref$formData === void 0 ? {
              fullName: "",
              email: "",
              phoneNumber: "",
              message: ""
            } : _ref$formData, _ref$urlBase = _ref.urlBase, urlBase = _ref$urlBase === void 0 ? process.env.GATSBY_API_URL || "" : _ref$urlBase;
            _context.prev = 1;

            if (!lodash.isEmpty(formData)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              message: "You cannot submit an empty form"
            });

          case 4:
            if (!lodash.isEmpty(hostname)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form hostname name is required"
              }
            });

          case 6:
            if (!lodash.isEmpty(creditUnionName)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form credit union name name is required"
              }
            });

          case 8:
            if (!lodash.isEmpty(formData.email)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form email is required"
              }
            });

          case 10:
            if (!lodash.isEmpty(formData.fullName)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form full name is required"
              }
            });

          case 12:
            if (!lodash.isEmpty(formData.phoneNumber)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form phone number is required"
              }
            });

          case 14:
            url = type === "MEMBERSHIP_FEEDBACK" ? "".concat(urlBase, "/contact-us") : "".concat(urlBase, "/financial-institution-secured-form-customer"); // const url = `${urlBase}/financial-institution-secured-form-customer`;

            options = type === "MEMBERSHIP_FEEDBACK" ? _objectSpread2(_objectSpread2({}, formData), {}, {
              cu: creditUnionName,
              type: type
            }) : _objectSpread2(_objectSpread2({}, formData), {}, {
              cu: creditUnionName
            });
            _context.next = 18;
            return axios.post(url, options);

          case 18:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](1);

            if (!(!lodash.isEmpty(_context.t0) && _context.t0.response !== undefined && _context.t0.response.status !== undefined && _context.t0.message !== undefined)) {
              _context.next = 26;
              break;
            }

            return _context.abrupt("return", {
              success: false,
              error: {
                metaData: _context.t0,
                fetchMessage: _context.t0.message,
                fetchStatus: _context.t0.response.status,
                message: "An unexpected error occurred. The form was not loaded."
              }
            });

          case 26:
            return _context.abrupt("return", {
              success: false,
              error: {
                metaData: {},
                fetchMessage: "The request has failed, please check the endpoint or other parameters.",
                fetchStatus: 404,
                message: "An unknown error occurred when requesting information, please contact technical support."
              }
            });

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 22]]);
  }));
  return _formsService.apply(this, arguments);
}

function customFormsService() {
  return _customFormsService.apply(this, arguments);
}

function _customFormsService() {
  _customFormsService = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _ref,
        _ref$header,
        header,
        _ref$type,
        type,
        _ref$creditUnionName,
        creditUnionName,
        _ref$hostname,
        hostname,
        _ref$formData,
        formData,
        _ref$urlBase,
        urlBase,
        url,
        keys,
        data,
        options,
        response,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$header = _ref.header, header = _ref$header === void 0 ? {
              formName: "",
              recipients: [],
              backgroundColorHeaderEmail: "#767676",
              labelColor: "#000000"
            } : _ref$header, _ref$type = _ref.type, type = _ref$type === void 0 ? "CUSTOM_FORM" : _ref$type, _ref$creditUnionName = _ref.creditUnionName, creditUnionName = _ref$creditUnionName === void 0 ? process.env.GATSBY_CU_NAME || "" : _ref$creditUnionName, _ref$hostname = _ref.hostname, hostname = _ref$hostname === void 0 ? window.location.hostname || "" : _ref$hostname, _ref$formData = _ref.formData, formData = _ref$formData === void 0 ? {} : _ref$formData, _ref$urlBase = _ref.urlBase, urlBase = _ref$urlBase === void 0 ? process.env.GATSBY_API_URL || "" : _ref$urlBase;
            _context.prev = 1;

            if (!lodash.isEmpty(formData)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              message: "You cannot submit an empty form"
            });

          case 4:
            if (!lodash.isEmpty(hostname)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form hostname name is required"
              }
            });

          case 6:
            if (!lodash.isEmpty(creditUnionName)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: "Secured form credit union name name is required"
              }
            });

          case 8:
            url = "".concat(urlBase, "/contact-us");
            keys = Object.keys(formData);
            data = keys.reduce(function (acc, field) {
              if (!formData[field]) return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty$1({}, field, "Not Provided"));
              return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty$1({}, field, formData[field]));
            }, {});
            options = {
              data: data,
              keys: keys,
              header: header,
              cu: creditUnionName,
              type: type
            };
            _context.next = 14;
            return axios.post(url, options);

          case 14:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);

            if (!(!lodash.isEmpty(_context.t0) && _context.t0.response !== undefined && _context.t0.response.status !== undefined && _context.t0.message !== undefined)) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", {
              success: false,
              error: {
                metaData: _context.t0,
                fetchMessage: _context.t0.message,
                fetchStatus: _context.t0.response.status,
                message: "An unexpected error occurred. The form was not loaded."
              }
            });

          case 22:
            return _context.abrupt("return", {
              success: false,
              error: {
                metaData: {},
                fetchMessage: "The request has failed, please check the endpoint or other parameters.",
                fetchStatus: 404,
                message: "An unknown error occurred when requesting information, please contact technical support."
              }
            });

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));
  return _customFormsService.apply(this, arguments);
}

var _templateObject$1j, _templateObject2$r, _templateObject3$l, _templateObject4$h, _templateObject5$d, _templateObject6$9;

var OptInFormTitleContainer = styled__default["default"].div(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteral(["\n  padding: 0 0 30px 0;\n"])));
var OptInFormTitle = styled__default["default"].h3(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n  color: var(--primary-150-color);\n  font-family: var(--secondary-family);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 39px;\n"])));
var OptInFormLegendContainer = styled__default["default"].div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n  padding: 20px 0;\n"])));
var OptInFormLegendText = styled__default["default"].span(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 20px;\n"])));
var OptInFormSubmitContainer = styled__default["default"].div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", " {\n    padding: 10px 30px;\n    font-family: var(primary-family);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    text-align: center;\n    cursor: ", ";\n  }\n"])), Button$2, function (_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active;
  return active ? "pointer" : "not-allowed";
});
var OptInFormContainer = styled__default["default"].form(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: ", ";\n  grid-gap: 20px;\n  justify-items: stretch;\n\n  background: ", ";\n\n  padding: ", ";\n\n  & > *:last-child {\n    grid-column: 1/3;\n  }\n\n  ", ",\n  ", ",\n  ", " {\n    grid-column: 1/3;\n  }\n\n  @media all and (max-width: ", "px) {\n    padding: ", ";\n  }\n"])), function (_ref2) {
  var _ref2$hasTitle = _ref2.hasTitle,
      hasTitle = _ref2$hasTitle === void 0 ? false : _ref2$hasTitle,
      _ref2$hasLegend = _ref2.hasLegend,
      hasLegend = _ref2$hasLegend === void 0 ? false : _ref2$hasLegend,
      _ref2$hasSubmitButton = _ref2.hasSubmitButton,
      hasSubmitButton = _ref2$hasSubmitButton === void 0 ? false : _ref2$hasSubmitButton,
      _ref2$inputs = _ref2.inputs,
      inputs = _ref2$inputs === void 0 ? [] : _ref2$inputs;
  var rows = inputs.map(function () {
    return "auto";
  });
  if (hasTitle) rows.push("auto");
  if (hasLegend) rows.push("auto");
  if (hasSubmitButton) rows.push("auto");
  return rows.join(" ");
}, function (_ref3) {
  var _ref3$background = _ref3.background,
      background = _ref3$background === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$background;
  return getColors(background);
}, function (_ref4) {
  var _ref4$padding = _ref4.padding,
      padding = _ref4$padding === void 0 ? "50px 15%" : _ref4$padding;
  return lodash.isNumber(padding) ? "".concat(padding, "px") : padding;
}, OptInFormTitleContainer, OptInFormSubmitContainer, OptInFormLegendContainer, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md;
}, function (_ref6) {
  var _ref6$mobilePadding = _ref6.mobilePadding,
      mobilePadding = _ref6$mobilePadding === void 0 ? "50px 20px" : _ref6$mobilePadding;
  return lodash.isNumber(mobilePadding) ? "".concat(mobilePadding, "px") : mobilePadding;
});

function OptInForm(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === void 0 ? {
    title: "",
    textSize: textSizesTypes.NORMAL,
    description: "",
    descriptionSize: textSizesTypes.NORMAL,
    submitButtonText: "",
    submitButtonTextSize: textSizesTypes.NORMAL,
    legend: "By submitting this form, I do want Baton Rouge Fire Department Federal Credit Union to authorize and pay overdrafts on my ATM and everyday debit card transactions. I understand that I have the right to revoke this decision at any time by calling 225-274-8383.",
    legendSize: textSizesTypes.NORMAL
  } : _ref7$data,
      _ref7$containerProps = _ref7.containerProps,
      containerProps = _ref7$containerProps === void 0 ? {} : _ref7$containerProps,
      _ref7$titleProps = _ref7.titleProps,
      titleProps = _ref7$titleProps === void 0 ? {} : _ref7$titleProps,
      _ref7$legendProps = _ref7.legendProps,
      legendProps = _ref7$legendProps === void 0 ? {} : _ref7$legendProps,
      _ref7$submitProps = _ref7.submitProps,
      submitProps = _ref7$submitProps === void 0 ? {} : _ref7$submitProps,
      _ref7$submitButtonPro = _ref7.submitButtonProps,
      submitButtonProps = _ref7$submitButtonPro === void 0 ? {} : _ref7$submitButtonPro;
  var optIn = React.useMemo(function () {
    return [{
      id: nanoid(),
      isRequired: true,
      label: "Member name*",
      name: "memberName",
      type: "text",
      // placeholder: "Member name*",
      validations: [{
        regexp: "^(\\w|\\d|\\s){4,}$",
        regExpoConfig: "gi",
        error: {
          message: "El nombre es incorrecto"
        }
      }],
      containerProps: {
        gridColumn: "auto",
        mobileGridColumn: "1/3"
      }
    }, {
      id: nanoid(),
      isRequired: false,
      label: "Account Number",
      name: "accountNumber",
      type: "text",
      // placeholder: "Account Number",
      validations: [{
        regexp: "^\\d{7,}$",
        regExpoConfig: "g",
        error: {
          message: "Número de cuenta incorrecto"
        }
      }],
      containerProps: {
        gridColumn: "auto",
        mobileGridColumn: "1/3"
      }
    }, {
      id: nanoid(),
      isRequired: false,
      label: "Phone Number",
      name: "phoneNumber",
      type: "text",
      // placeholder: "Phone Number",
      validations: [{
        regexp: "^\\d{7,}$",
        regExpoConfig: "g",
        error: {
          message: "Número de teléfono incorrecto"
        }
      }],
      containerProps: {
        gridColumn: "auto",
        mobileGridColumn: "1/3"
      }
    }, {
      id: nanoid(),
      isRequired: true,
      label: "Last 4 of SSN*",
      name: "last4ofSSN",
      type: "text",
      // placeholder: "Last 4 of SSN*",
      validations: [{
        regexp: "^(\\w|\\d|\\s){4,}$",
        regExpoConfig: "g",
        error: {
          message: "Is Required"
        }
      }],
      containerProps: {
        gridColumn: "auto",
        mobileGridColumn: "1/3"
      }
    }, {
      id: nanoid(),
      isRequired: false,
      label: "Email",
      name: "email",
      type: "email",
      // placeholder: "Email",
      validations: [{
        regexp: "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
        regExpoConfig: "g",
        error: {
          message: "invalid email"
        }
      }],
      containerProps: {
        gridColumn: "1/3",
        mobileGridColumn: "1/3"
      }
    }];
  }, []);

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      showModal = _useModal.showModal,
      closeModal = _useModal.closeModal;

  var _useForm = useForm({
    inputs: optIn
  }),
      onInputTextChange = _useForm.onInputTextChange,
      getField = _useForm.getField,
      cleanFields = _useForm.cleanFields,
      _useForm$inputsLikeAr = _useForm.inputsLikeArray,
      inputsLikeArray = _useForm$inputsLikeAr === void 0 ? [] : _useForm$inputsLikeAr,
      setInputs = _useForm.setInputs,
      _useForm$isValidFormD = _useForm.isValidFormData,
      isValidFormData = _useForm$isValidFormD === void 0 ? false : _useForm$isValidFormD;

  function onAcceptConditions() {
    return _onAcceptConditions.apply(this, arguments);
  }

  function _onAcceptConditions() {
    _onAcceptConditions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var bodyFetch, _yield$formsService, _yield$formsService$s, success, _yield$formsService$m, message, _yield$formsService$e, error;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              bodyFetch = inputsLikeArray.reduce(function (acc, input) {
                var name = input.name;
                if (input.name === "memberName") name = "fullName";
                return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty$1({}, name, getField(input.name).value));
              }, {});
              _context2.next = 4;
              return formsService({
                formData: bodyFetch
              });

            case 4:
              _yield$formsService = _context2.sent;
              _yield$formsService$s = _yield$formsService.success;
              success = _yield$formsService$s === void 0 ? false : _yield$formsService$s;
              _yield$formsService$m = _yield$formsService.message;
              message = _yield$formsService$m === void 0 ? "" : _yield$formsService$m;
              _yield$formsService$e = _yield$formsService.error;
              error = _yield$formsService$e === void 0 ? {} : _yield$formsService$e;
              closeModal();

              if (message) {
                toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                  className: "bl-text-sm tw-text-center"
                }, message), {
                  toastId: "member-feedback-form-submit-error-message"
                });
              }

              if (error && error.message) {
                toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                  className: "bl-text-sm tw-text-center"
                }, error.message), {
                  toastId: "member-feedback-form-submit-error-message"
                });
              }

              if (success) cleanFields();
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](0);
              closeModal();

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 17]]);
    }));
    return _onAcceptConditions.apply(this, arguments);
  }

  function
  /* _event */
  onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return showModal();

            case 3:
              _context3.next = 8;
              break;

            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](0);
              closeModal();

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 5]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  React.useEffect(function () {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setInputs({
      optIn: optIn
    });
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(OptInFormContainer, _extends$g({}, containerProps, {
    className: "OPT_IN_FORM",
    hasTitle: !!data.title,
    hasLegend: !!data.legend,
    hasSubmitButton: !!data.submitButtonText,
    inputs: inputsLikeArray
  }), !!data.title && /*#__PURE__*/React__default$1["default"].createElement(OptInFormTitleContainer, _extends$g({}, titleProps, {
    className: "OPT_IN_FORM__TITLE"
  }), /*#__PURE__*/React__default$1["default"].createElement(OptInFormTitle, {
    className: "OPT_IN_FORM__TITLE__TEXT",
    size: data.textSize
  }, data.title)), !!inputsLikeArray && inputsLikeArray.map(function (input) {
    return /*#__PURE__*/React__default$1["default"].createElement(Input, _extends$g({
      className: "OPT_IN_FORM__INPUT OPT_IN_FORM__INPUT__".concat(lodash.upperCase(lodash.snakeCase(input.name))),
      onChange: onInputTextChange,
      value: getField(input.name).value,
      error: getField(input.name).error,
      key: input.id,
      id: input.id
    }, input));
  }), !!data.legend && /*#__PURE__*/React__default$1["default"].createElement(OptInFormLegendContainer, _extends$g({}, legendProps, {
    className: "OPT_IN_FORM__LEGEND"
  }), /*#__PURE__*/React__default$1["default"].createElement(OptInFormLegendText, {
    className: "OPT_IN_FORM__LEGEND__TEXT"
  }, data.legend)), !!data.submitButtonText && /*#__PURE__*/React__default$1["default"].createElement(OptInFormSubmitContainer, _extends$g({}, submitProps, {
    active: isValidFormData,
    className: "OPT_IN_FORM__SUBMIT"
  }), /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    onClick: /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isValidFormData) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return onSubmit(_event);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref8.apply(this, arguments);
      };
    }()
  }, submitButtonProps, {
    className: "OPT_IN_FORM__SUBMIT__BUTTON",
    withoutBorderRadius: true,
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.NONE,
    fontSize: data.submitButtonTextSize,
    filledBackgroundColor: colorsTypes.PRIMARY_DARK,
    filledOutlineBorderColor: colorsTypes.PRIMARY_DARK,
    filledTextColor: colorsTypes.WHITE,
    hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
    hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
    hoverFilledTextColor: colorsTypes.PRIMARY_DARK
  }), data.submitButtonText))), /*#__PURE__*/React__default$1["default"].createElement(ConfirmationModal, {
    message: "Thanks for getting in touch!",
    acceptBtnText: "Send",
    isModalVisible: isModalVisible,
    showModal: showModal,
    closeModal: closeModal,
    onAccept: onAcceptConditions
  }));
}

var _templateObject$1i, _templateObject2$q, _templateObject3$k, _templateObject4$g, _templateObject5$c, _templateObject6$8;

var MemberFeedbackFormTitleContainer = styled__default["default"].div(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteral([""])));
var MemberFeedbackFormTitle = styled__default["default"].h3(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  color: var(--primary-150-color);\n  font-family: var(--secondary-family);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 39px;\n"])));
var MemberFeedbackFormLegendContainer = styled__default["default"].div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  padding: 20px 0;\n"])));
var MemberFeedbackFormLegendText = styled__default["default"].span(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 20px;\n"])));
var MemberFeedbackFormSubmitContainer = styled__default["default"].div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", " {\n    padding: 10px 30px;\n    font-family: var(primary-family);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    text-align: center;\n    cursor: ", ";\n  }\n"])), Button$2, function (_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active;
  return active ? "pointer" : "not-allowed";
});
var MemberFeedbackFormContainer = styled__default["default"].form(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: ", ";\n  grid-gap: 20px;\n  justify-items: stretch;\n\n  background: ", ";\n\n  padding: ", ";\n\n  & > *:last-child {\n    grid-column: 1/3;\n  }\n\n  ", ",\n  ", ",\n  ", " {\n    grid-column: 1/3;\n  }\n\n  @media all and (max-width: ", "px) {\n    padding: ", ";\n  }\n"])), function (_ref2) {
  var _ref2$hasTitle = _ref2.hasTitle,
      hasTitle = _ref2$hasTitle === void 0 ? false : _ref2$hasTitle,
      _ref2$hasLegend = _ref2.hasLegend,
      hasLegend = _ref2$hasLegend === void 0 ? false : _ref2$hasLegend,
      _ref2$hasSubmitButton = _ref2.hasSubmitButton,
      hasSubmitButton = _ref2$hasSubmitButton === void 0 ? false : _ref2$hasSubmitButton,
      _ref2$inputs = _ref2.inputs,
      inputs = _ref2$inputs === void 0 ? [] : _ref2$inputs;
  var rows = inputs.map(function () {
    return "auto";
  });
  if (hasTitle) rows.push("auto");
  if (hasLegend) rows.push("auto");
  if (hasSubmitButton) rows.push("auto");
  return rows.join(" ");
}, function (_ref3) {
  var _ref3$background = _ref3.background,
      background = _ref3$background === void 0 ? colorsVariantsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$background;
  return getColors(background);
}, function (_ref4) {
  var _ref4$padding = _ref4.padding,
      padding = _ref4$padding === void 0 ? "50px 15%" : _ref4$padding;
  return lodash.isNumber(padding) ? "".concat(padding, "px") : padding;
}, MemberFeedbackFormTitleContainer, MemberFeedbackFormSubmitContainer, MemberFeedbackFormLegendContainer, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.md;
}, function (_ref6) {
  var _ref6$mobilePadding = _ref6.mobilePadding,
      mobilePadding = _ref6$mobilePadding === void 0 ? "50px 20px" : _ref6$mobilePadding;
  return lodash.isNumber(mobilePadding) ? "".concat(mobilePadding, "px") : mobilePadding;
});

function MemberFeedbackForm(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === void 0 ? {
    aboutUsTitle: "",
    aboutUsTitleSize: textSizesTypes.NORMAL,
    commentTitle: "",
    commentTitleSize: textSizesTypes.NORMAL,
    tellUsTitle: "",
    tellUsTitleSize: textSizesTypes.NORMAL,
    submitButtonText: "",
    submitButtonTextSize: textSizesTypes.NORMAL,
    legendTitle: "",
    legendTitleSize: textSizesTypes.NORMAL,
    legend: "",
    legendSize: textSizesTypes.NORMAL
  } : _ref7$data,
      _ref7$containerProps = _ref7.containerProps,
      containerProps = _ref7$containerProps === void 0 ? {} : _ref7$containerProps,
      _ref7$titleProps = _ref7.titleProps,
      titleProps = _ref7$titleProps === void 0 ? {} : _ref7$titleProps,
      _ref7$legendProps = _ref7.legendProps,
      legendProps = _ref7$legendProps === void 0 ? {} : _ref7$legendProps,
      _ref7$submitProps = _ref7.submitProps,
      submitProps = _ref7$submitProps === void 0 ? {} : _ref7$submitProps,
      _ref7$submitButtonPro = _ref7.submitButtonProps,
      submitButtonProps = _ref7$submitButtonPro === void 0 ? {} : _ref7$submitButtonPro;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      showModal = _useModal.showModal,
      closeModal = _useModal.closeModal;

  var memberFeedbackForm = React.useMemo(function () {
    return {
      aboutUs: [{
        id: nanoid(),
        variant: inputVariantTypes.SELECT,
        isRequired: true,
        label: "About Us",
        name: "aboutUs",
        type: "select",
        // placeholder: "About Us",
        // validations: [], // Select dont need a validations collection
        options: [{
          id: nanoid(),
          value: "WEB_SITE",
          label: "Web Site"
        }, {
          id: nanoid(),
          value: "FACILITY",
          label: "Facility"
        }, {
          id: nanoid(),
          value: "PRODUCTS",
          label: "Products"
        }, {
          id: nanoid(),
          value: "SERVICES",
          label: "Services"
        }, {
          id: nanoid(),
          value: "EMPLOYEE",
          label: "Employee"
        }, {
          id: nanoid(),
          value: "OTHER",
          label: "Other"
        }],
        containerProps: {
          gridColumn: "1/3",
          mobileGridColumn: "1/3"
        }
      }],
      comment: [{
        id: nanoid(),
        isRequired: false,
        label: "Comment",
        name: "comment",
        type: "textarea",
        variant: inputVariantTypes.TEXTAREA,
        // placeholder: "Comment",
        validations: [],
        containerProps: {
          gridColumn: "1/3",
          mobileGridColumn: "1/3"
        }
      }],
      tellUs: [{
        id: nanoid(),
        isRequired: true,
        label: "Name",
        name: "name",
        type: "text",
        // placeholder: "Member name*",
        validations: [],
        containerProps: {
          gridColumn: "auto",
          mobileGridColumn: "1/3"
        }
      }, {
        id: nanoid(),
        isRequired: true,
        label: "Email",
        name: "email",
        type: "email",
        // placeholder: "Email",
        validations: [{
          regexp: "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
          regExpoConfig: "g",
          error: {
            message: "invalid email"
          }
        }],
        containerProps: {
          gridColumn: "auto",
          mobileGridColumn: "1/3"
        }
      }, {
        id: nanoid(),
        isRequired: false,
        label: "Phone",
        name: "phone",
        type: "text",
        // placeholder: "Phone Number",
        validations: [{
          regexp: "^\\d{7,}$",
          regExpoConfig: "g",
          error: {
            message: "Número de teléfono incorrecto"
          }
        }],
        containerProps: {
          gridColumn: "auto",
          mobileGridColumn: "1/3"
        }
      }, {
        id: nanoid(),
        isRequired: false,
        label: "Fax",
        name: "fax",
        type: "text",
        // placeholder: "Phone Number",
        validations: [{
          regexp: "^\\d{7,}$",
          regExpoConfig: "g",
          error: {
            message: "Número de fax incorrecto"
          }
        }],
        containerProps: {
          gridColumn: "auto",
          mobileGridColumn: "1/3"
        }
      }]
    };
  }, []);

  var _useForm = useForm({
    inputs: memberFeedbackForm
  }),
      _useForm$isValidFormD = _useForm.isValidFormData,
      isValidFormData = _useForm$isValidFormD === void 0 ? false : _useForm$isValidFormD,
      onInputTextChange = _useForm.onInputTextChange,
      getField = _useForm.getField,
      cleanFields = _useForm.cleanFields,
      setInputs = _useForm.setInputs,
      inputs = _useForm.inputs,
      _useForm$inputsLikeAr = _useForm.inputsLikeArray,
      inputsLikeArray = _useForm$inputsLikeAr === void 0 ? [] : _useForm$inputsLikeAr;

  function onAcceptConditions() {
    return _onAcceptConditions.apply(this, arguments);
  }

  function _onAcceptConditions() {
    _onAcceptConditions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var bodyFetch, _yield$formsService, _yield$formsService$m, message, _yield$formsService$e, error;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              bodyFetch = inputsLikeArray.reduce(function (acc, input) {
                var name = input.name;
                if (input.name === "name") name = "fullName";
                if (input.name === "phone") name = "phoneNumber";
                return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty$1({}, name, getField(input.name).value));
              }, {});
              _context2.next = 4;
              return formsService({
                type: "MEMBERSHIP_FEEDBACK",
                formData: bodyFetch
              });

            case 4:
              _yield$formsService = _context2.sent;
              _yield$formsService$m = _yield$formsService.message;
              message = _yield$formsService$m === void 0 ? "" : _yield$formsService$m;
              _yield$formsService$e = _yield$formsService.error;
              error = _yield$formsService$e === void 0 ? false : _yield$formsService$e;
              closeModal();

              if (error && error.message) {
                toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                  className: "bl-text-sm tw-text-center"
                }, error.message), {
                  toastId: "member-feedback-form-submit-error-message"
                });
              }

              if (error) {
                toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                  className: "bl-text-sm tw-text-center"
                }, message), {
                  toastId: "member-feedback-form-submit-error-message"
                });
              }

              if (!error) toast.success("Your form has been successfully submitted.", {
                toastId: "onSubmit"
              });
              cleanFields();
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](0);
              closeModal();

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 16]]);
    }));
    return _onAcceptConditions.apply(this, arguments);
  }

  function
  /* _event */
  onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return showModal();

            case 3:
              _context3.next = 8;
              break;

            case 5:
              _context3.prev = 5;
              _context3.t0 = _context3["catch"](0);
              closeModal();

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 5]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  React.useEffect(function () {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setInputs(memberFeedbackForm);
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormContainer, _extends$g({}, containerProps, {
    className: "MEMBER_FEEDBACK",
    hasTitle: !!data.title,
    hasLegend: !!data.legend,
    hasSubmitButton: !!data.submitButtonText,
    inputs: ["about us", "comment", "tell us"].concat(_toConsumableArray(inputsLikeArray))
  }), !!data.aboutUsTitle && /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormTitleContainer, _extends$g({}, titleProps, {
    className: "MEMBER_FEEDBACK__TITLE"
  }), /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormTitle, {
    className: "MEMBER_FEEDBACK__TITLE__TEXT",
    size: data.aboutUsTitleSize
  }, data.aboutUsTitle)), !!inputs && !!inputs.aboutUs && inputs.aboutUs.map(function (input) {
    return /*#__PURE__*/React__default$1["default"].createElement(Input, _extends$g({
      className: "MEMBER_FEEDBACK__INPUT MEMBER_FEEDBACK__INPUT__".concat(lodash.upperCase(lodash.snakeCase(input.name))),
      onChange: onInputTextChange,
      value: getField(input.name).value,
      error: getField(input.name).error,
      key: input.id,
      id: input.id
    }, input));
  }), !!data.commentTitle && /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormTitleContainer, _extends$g({}, titleProps, {
    className: "MEMBER_FEEDBACK__TITLE tw-mt-10"
  }), /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormTitle, {
    className: "MEMBER_FEEDBACK__TITLE__TEXT",
    size: data.commentTitleSize
  }, data.commentTitle)), !!inputs && !!inputs.comment && inputs.comment.map(function (input) {
    return /*#__PURE__*/React__default$1["default"].createElement(Input, _extends$g({
      className: "MEMBER_FEEDBACK__INPUT MEMBER_FEEDBACK__INPUT__".concat(lodash.upperCase(lodash.snakeCase(input.name))),
      onChange: onInputTextChange,
      value: getField(input.name).value,
      error: getField(input.name).error,
      key: input.id,
      id: input.id
    }, input));
  }), !!data.tellUsTitle && /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormTitleContainer, _extends$g({}, titleProps, {
    className: "MEMBER_FEEDBACK__TITLE tw-mt-10"
  }), /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormTitle, {
    className: "MEMBER_FEEDBACK__TITLE__TEXT",
    size: data.tellUsTitleSize
  }, data.tellUsTitle)), !!inputs && !!inputs.tellUs && inputs.tellUs.map(function (input) {
    return /*#__PURE__*/React__default$1["default"].createElement(Input, _extends$g({
      className: "MEMBER_FEEDBACK__INPUT MEMBER_FEEDBACK__INPUT__".concat(lodash.upperCase(lodash.snakeCase(input.name))),
      variant: inputVariantTypes.TEXT,
      onChange: onInputTextChange,
      value: getField(input.name).value,
      error: getField(input.name).error,
      key: input.id,
      id: input.id
    }, input));
  }), !!data.legend && /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormLegendContainer, _extends$g({}, legendProps, {
    className: "MEMBER_FEEDBACK__LEGEND"
  }), /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormLegendText, {
    className: "MEMBER_FEEDBACK__LEGEND__TEXT"
  }, data.legend)), !!data.submitButtonText && /*#__PURE__*/React__default$1["default"].createElement(MemberFeedbackFormSubmitContainer, _extends$g({}, submitProps, {
    active: isValidFormData,
    className: "MEMBER_FEEDBACK__SUBMIT"
  }), /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    onClick: /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isValidFormData) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return onSubmit(_event);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref8.apply(this, arguments);
      };
    }()
  }, submitButtonProps, {
    className: "MEMBER_FEEDBACK__SUBMIT__BUTTON",
    withoutBorderRadius: true,
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.NONE,
    fontSize: data.submitButtonTextSize,
    filledBackgroundColor: colorsTypes.PRIMARY_DARK,
    filledOutlineBorderColor: colorsTypes.PRIMARY_DARK,
    filledTextColor: colorsTypes.WHITE,
    hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
    hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
    hoverFilledTextColor: colorsTypes.PRIMARY_DARK
  }), data.submitButtonText))), /*#__PURE__*/React__default$1["default"].createElement(ConfirmationModal, {
    message: "Thanks for getting in touch!",
    acceptBtnText: "Send",
    isModalVisible: isModalVisible,
    showModal: showModal,
    closeModal: closeModal,
    onAccept: onAcceptConditions
  }));
}

function dataStructuting() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    titleForm: "",
    field: []
  };
  var newStructuredData = {};
  data.field.map(function (item, index) {
    newStructuredData = _objectSpread2(_objectSpread2({}, newStructuredData), {}, _defineProperty$1({}, "field_".concat(index), [_objectSpread2(_objectSpread2({}, item), {}, {
      name: lodash.startCase(item.name),
      variant: variantTypeSelect(item.inputType),
      id: nanoid(),
      type: item.inputType,
      validations: validatorTypeSelect(item.inputType, item.isRequired, item.errorMessage),
      options: optionsValue(item.inputType, item.optionsOrPageMessage)
    })]));
    return newStructuredData;
  });
  return newStructuredData;
} // Not Export Functions


function validatorTypeSelect() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "text";
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "This field is required.";
  if (!isRequired) return [];
  var regExp = "";
  if (type === "text" || type === "texarea" || type === "check") regExp = "^[a-zA-Z0-9A-Z\xC0-\xFF\xF1\xD1 .,;:_-]{1,}$";
  if (type === "email") regExp = "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
  if (type === "phone") regExp = "^\\d{7,12}$";
  if (type === "number") regExp = "^\\d{1,}$";
  return [{
    regexp: regExp,
    regExpoConfig: "g",
    error: {
      message: errorMessage
    }
  }];
}

function variantTypeSelect() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (type === "textarea") return inputVariantTypes.TEXTAREA;
  if (type === "select") return inputVariantTypes.SELECT;
  if (type === "check") return inputVariantTypes.CHECK;
  return inputVariantTypes.TEXT;
}

function optionsValue(type, options) {
  if (!options || type !== "select" && type !== "check") return [];
  return options.split("\n").reduce(function (acc, select) {
    return [].concat(_toConsumableArray(acc), [{
      id: nanoid(),
      value: lodash.snakeCase(select).toUpperCase(),
      label: select
    }]);
  }, []);
}

var _templateObject$1h, _templateObject2$p, _templateObject3$j, _templateObject4$f, _templateObject5$b, _templateObject6$7, _templateObject7$4;

var FormTemplateContainer = styled__default["default"].section(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding-top: 40px;\n  padding-bottom: 40px;\n"])), function (_ref) {
  var _ref$backgroundColorF = _ref.backgroundColorForm,
      backgroundColorForm = _ref$backgroundColorF === void 0 ? "var(--primary-30-color)" : _ref$backgroundColorF;
  return backgroundColorForm;
});
var FormTemplateTitle = styled__default["default"].h2(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-weight: 600;\n  font-size: 26px;\n  color: ", ";\n  margin-bottom: 20px;\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "var(--grayscale-100-color)" : _ref2$color;
  return color;
});
var FormTemplateForm = styled__default["default"].form(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"])));
var FormTemplateSubtitle = styled__default["default"].h3(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-weight: 600;\n  font-size: 26px;\n  color: ", ";\n  margin: 20px 0px;\n  width: 100%;\n"])), function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "var(--primary-150-color)" : _ref3$color;
  return color;
});
var FormTemplateText = styled__default["default"].p(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-weight: 400;\n  line-height: 20px;\n  font-size: 16px;\n  margin-bottom: 10px;\n  color: ", ";\n  width: 100%;\n"])), function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? "var(--grayscale-100-color)" : _ref4$color;
  return color;
});
var CustomInput = styled__default["default"](Input)(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n  margin-bottom: 25px;\n  width: ", ";\n\n  input {\n    background-color: var(--grayscale-0-color);\n  }\n\n  @media (max-width: 767px) {\n    width: 100%;\n  }\n"])), function () {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "full",
      inputWidth = _ref5.inputWidth;

  if (inputWidth === "half") return "47%";
  if (inputWidth === "third") return "31%";
  return "100%";
});
var FormTemplateSubmitContainer = styled__default["default"].div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", " {\n    padding: 10px 30px;\n    margin-top: 20px;\n    font-family: var(--primary-family);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    text-align: center;\n    cursor: ", ";\n  }\n"])), Button$2, function (_ref6) {
  var _ref6$active = _ref6.active,
      active = _ref6$active === void 0 ? false : _ref6$active;
  return active ? "pointer" : "not-allowed";
});

function FormTemplate(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === void 0 ? {
    formName: "custom form",
    titleForm: "",
    buttonName: "Send",
    field: []
  } : _ref7$data,
      _ref7$formTemplatePro = _ref7.formTemplateProps,
      formTemplateProps = _ref7$formTemplatePro === void 0 ? {
    backgroundColorForm: colorsTypes.HIGHT_LIGHT_PRIMARY,
    titleFormColor: colorsTypes.BLACK,
    subtitleFormColor: colorsTypes.PRIMARY_DARK,
    textColor: colorsTypes.BLACK,
    submitButtonFilledBackgroundColor: colorsTypes.PRIMARY_DARK,
    submitButtonFilledOutlineBorderColor: colorsTypes.PRIMARY_DARK,
    submitButtonFilledTextColor: colorsTypes.WHITE,
    submitButtonHoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
    submitButtonHoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
    submitButtonHoverFilledTextColor: colorsTypes.PRIMARY_DARK
  } : _ref7$formTemplatePro;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      showModal = _useModal.showModal,
      closeModal = _useModal.closeModal;

  var structuredData = dataStructuting(data);
  var snakeFormName = lodash.snakeCase(data === null || data === void 0 ? void 0 : data.formName).toUpperCase();

  var _useForm = useForm({
    inputs: structuredData
  }),
      _useForm$isValidFormD = _useForm.isValidFormData,
      isValidFormData = _useForm$isValidFormD === void 0 ? false : _useForm$isValidFormD,
      onInputTextChange = _useForm.onInputTextChange,
      getField = _useForm.getField,
      cleanFields = _useForm.cleanFields,
      setInputs = _useForm.setInputs,
      inputs = _useForm.inputs,
      _useForm$inputsLikeAr = _useForm.inputsLikeArray,
      inputsLikeArray = _useForm$inputsLikeAr === void 0 ? [] : _useForm$inputsLikeAr;

  function
  /* _event */
  onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return showModal();

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              closeModal();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function onAcceptConditions() {
    return _onAcceptConditions.apply(this, arguments);
  }

  function _onAcceptConditions() {
    _onAcceptConditions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _data$formName, formName, _data$recipients, recipients, _data$backgroundColor, backgroundColorHeaderEmail, _data$labelColor, labelColor, recipientsArray, bodyFetch, _yield$customFormsSer, _yield$customFormsSer2, message, _yield$customFormsSer3, error;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _data$formName = data.formName, formName = _data$formName === void 0 ? "Form Test" : _data$formName, _data$recipients = data.recipients, recipients = _data$recipients === void 0 ? [] : _data$recipients, _data$backgroundColor = data.backgroundColorHeaderEmail, backgroundColorHeaderEmail = _data$backgroundColor === void 0 ? "" : _data$backgroundColor, _data$labelColor = data.labelColor, labelColor = _data$labelColor === void 0 ? "" : _data$labelColor;
              recipientsArray = recipients.replace(/\s+/g, "").split(",");
              bodyFetch = inputsLikeArray.reduce(function (acc, input) {
                var name = input.name;

                if (input.inputType === "pageMessageTitle" || input.inputType === "pageMessageText") {
                  return _objectSpread2({}, acc);
                }

                return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty$1({}, name, getField(input.name).value));
              }, {});
              _context3.next = 6;
              return customFormsService({
                header: {
                  formName: formName,
                  recipients: recipientsArray,
                  iconUrl: "".concat(window.location.host, "/images/logo.png"),
                  backgroundColor: backgroundColorHeaderEmail,
                  labelColor: labelColor
                },
                formData: bodyFetch
              });

            case 6:
              _yield$customFormsSer = _context3.sent;
              _yield$customFormsSer2 = _yield$customFormsSer.message;
              message = _yield$customFormsSer2 === void 0 ? "" : _yield$customFormsSer2;
              _yield$customFormsSer3 = _yield$customFormsSer.error;
              error = _yield$customFormsSer3 === void 0 ? false : _yield$customFormsSer3;
              closeModal();

              if (error && error.message) {
                toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                  className: "bl-text-sm tw-text-center"
                }, error.message), {
                  toastId: "member-feedback-form-submit-error-message"
                });
              }

              if (error) {
                toast.error( /*#__PURE__*/React__default$1["default"].createElement("p", {
                  className: "bl-text-sm tw-text-center"
                }, message), {
                  toastId: "member-feedback-form-submit-error-message"
                });
              }

              if (!error) toast.success("Your form has been successfully submitted.", {
                toastId: "onSubmit"
              });
              cleanFields();
              _context3.next = 21;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);
              closeModal();

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 18]]);
    }));
    return _onAcceptConditions.apply(this, arguments);
  }

  React.useEffect(function () {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setInputs(structuredData);
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement(FormTemplateContainer, {
    className: "tw-x-container CUSTOM_FORM__CONTAINER ".concat(snakeFormName, "__CONTAINER"),
    backgroundColorForm: formTemplateProps.backgroundColorForm
  }, /*#__PURE__*/React__default$1["default"].createElement(FormTemplateTitle, {
    className: "CUSTOM_FORM__TITLE ".concat(snakeFormName, "__FORM__TITLE"),
    color: formTemplateProps.titleFormColor
  }, data === null || data === void 0 ? void 0 : data.titleForm), /*#__PURE__*/React__default$1["default"].createElement(FormTemplateForm, {
    className: "CUSTOM_FORM ".concat(snakeFormName, "__FORM")
  }, Object.keys(inputs).map(function (elements) {
    return inputs[elements].map(function (input) {
      if (input.inputType === "pageMessageTitle") return !!input.optionsOrPageMessage && /*#__PURE__*/React__default$1["default"].createElement(FormTemplateSubtitle, {
        className: "CUSTOM_FORM__SUBTITLE ".concat(snakeFormName, "__FORM__SUBTITLE"),
        color: formTemplateProps.subtitleFormColor
      }, input.optionsOrPageMessage || "Section Title");
      if (input.inputType === "pageMessageText") return !!input.optionsOrPageMessage && /*#__PURE__*/React__default$1["default"].createElement(FormTemplateText, {
        className: "CUSTOM_FORM__TEXT ".concat(snakeFormName, "__FORM__TEXT"),
        color: formTemplateProps.textColor
      }, input.optionsOrPageMessage || "Section Text");
      return /*#__PURE__*/React__default$1["default"].createElement(CustomInput, _extends$g({
        className: "CUSTOM_FORM__INPUT ".concat(snakeFormName, "__INPUT ").concat(snakeFormName, "__INPUT__").concat(lodash.snakeCase(input === null || input === void 0 ? void 0 : input.name).toUpperCase() || "INPUT"),
        onChange: onInputTextChange,
        value: getField(input.name).value,
        error: getField(input.name).error,
        key: input.id,
        id: input.id,
        inputWidth: input.inputWidth
      }, input));
    });
  }), /*#__PURE__*/React__default$1["default"].createElement(FormTemplateSubmitContainer // {...submitProps}
  , {
    active: isValidFormData,
    className: "MEMBER_FEEDBACK__SUBMIT"
  }, /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    onClick: /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isValidFormData) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return onSubmit(_event);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref8.apply(this, arguments);
      };
    }() // {...submitButtonProps}
    ,
    className: "".concat(snakeFormName, "__CONTAINER__SUBMIT__BUTTON CUSTOM_FORM__SUBMIT__BUTTON tw-p-16 tw-bg-red-600"),
    withoutBorderRadius: true,
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.NONE // fontSize={data.submitButtonTextSize}
    ,
    filledBackgroundColor: formTemplateProps.submitButtonFilledBackgroundColor,
    filledOutlineBorderColor: formTemplateProps.submitButtonFilledOutlineBorderColor,
    filledTextColor: formTemplateProps.submitButtonFilledTextColor,
    hoverFilledBackgroundColor: formTemplateProps.submitButtonHoverFilledBackgroundColor,
    hoverFilledBorderColor: formTemplateProps.submitButtonHoverFilledBorderColor,
    hoverFilledTextColor: formTemplateProps.submitButtonHoverFilledTextColor
  }, data === null || data === void 0 ? void 0 : data.buttonName)), /*#__PURE__*/React__default$1["default"].createElement(ConfirmationModal, {
    message: "Thanks for getting in touch!",
    acceptBtnText: "Send",
    isModalVisible: isModalVisible,
    showModal: showModal,
    closeModal: closeModal,
    onAccept: onAcceptConditions
  })));
}

var _templateObject$1g, _templateObject2$o, _templateObject3$i, _templateObject4$e; // components


var CustomDiv = styled__default["default"].div(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteral(["\n  margin: auto;\n"])));
var CustomButton$4 = styled__default["default"](Button$2)(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  margin: 10px auto;\n"])));
var Title$5 = styled__default["default"].h4(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  color: var(--grayscale-100-color);\n  font-weight: bold;\n  font-size: 1.2rem;\n"])));
var Report$1 = styled__default["default"].div(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return "\n  width: 20%;\n  min-width: 100px;\n  margin: auto 0;\n  margin-top: 5px;\n  @media (max-width: ".concat(theme.breakpoints.sm, "px){\n   margin: auto 5px; \n  }\n");
});

function Reports(_ref2) {
  var _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? {
    Pdf: []
  } : _ref2$data;

  var _onClick = function onClick(to) {
    return window.open(to);
  };

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$5, {
    className: "ANT_FEATURE_FULL_MOBILE__CONTAINER__TITLE FeatureFullBg__title tw-pt-12 tw-pb-2 tw-font-semibold text-3xl tw-leading-snug"
  }, data.title), /*#__PURE__*/React__default$1["default"].createElement(CustomDiv, {
    className: "tw-flex tw-flex-wrap tw-space-between"
  }, data.Pdf.map(function (_ref3, idx) {
    var _ref3$label = _ref3.label,
        label = _ref3$label === void 0 ? "report" : _ref3$label,
        _ref3$file = _ref3.file,
        file = _ref3$file === void 0 ? {} : _ref3$file;
    return /*#__PURE__*/React__default$1["default"].createElement(Report$1, null, /*#__PURE__*/React__default$1["default"].createElement(CustomButton$4, {
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
      hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      filledBackgroundColor: colorsTypes.PRIMARY,
      className: "DINAMIC_PAGE_COMPONENT DINAMIC_PAGE_COMPONENT_REPORTS_BUTTON",
      onClick: function onClick() {
        return _onClick(file.url);
      },
      key: "".concat(label, "-").concat(file.url, "-").concat(idx)
    }, !label ? "report" : label));
  }))));
}

var _templateObject$1f, _templateObject2$n, _templateObject3$h, _templateObject4$d, _templateObject5$a, _templateObject6$6;

var InputTextContainer = styled__default["default"].div(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  position: relative;\n  min-height: 50px;\n  background: var(--grayscale-0-color);\n  z-index: 0;\n  grid-column: ", ";\n\n  @media all and (max-width: ", "px) {\n    grid-column: ", ";\n  }\n"])), function (_ref) {
  var gridColumn = _ref.gridColumn;
  return gridColumn;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (_ref3) {
  var mobileGridColumn = _ref3.mobileGridColumn;
  return mobileGridColumn;
});
var InputTextLabelContainer = styled__default["default"].div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  transition: all linear 100ms;\n  z-index: 15;\n  height: min-content;\n  width: auto;\n  bottom: 50%;\n  transform: translateY(-50%);\n  top: ", ";\n\n  left: ", ";\n"])), function (_ref4) {
  var _ref4$hasValue = _ref4.hasValue,
      hasValue = _ref4$hasValue === void 0 ? false : _ref4$hasValue,
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? {
    initial: 10,
    vertical: "50%"
  } : _ref4$position;

  if (!hasValue) {
    if (process.env.GATSBY_CU_NAME === "nas_jrb") {
      return "55%";
    }

    return lodash.isNumber(position.vertical) ? "".concat(position.vertical, "px") : position.vertical;
  }

  if (process.env.GATSBY_CU_NAME === "nas_jrb") {
    return "40%";
  }

  return lodash.isNumber(position.initial) ? "".concat(position.initial, "px") : position.initial;
}, function (_ref5) {
  var _ref5$position = _ref5.position,
      position = _ref5$position === void 0 ? {
    initial: -5,
    horizontal: 5
  } : _ref5$position;
  return lodash.isNumber(position.horizontal) ? "".concat(position.horizontal, "px") : position.horizontal;
});
var InputTextLabelText = styled__default["default"].p(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px !important;\n  line-height: 16px !important;\n  padding-left: 30px !important;\n  padding-right: 10px !important;\n"])));
var InputTextErrorContainer = styled__default["default"].div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 5;\n\n  bottom: ", ";\n\n  left: ", ";\n\n  opacity: ", ";\n"])), function (_ref6) {
  var _ref6$position = _ref6.position,
      position = _ref6$position === void 0 ? {
    vertical: "-35%"
  } : _ref6$position;
  return lodash.isNumber(position.vertical) ? "".concat(position.vertical, "px") : position.vertical;
}, function (_ref7) {
  var _ref7$position = _ref7.position,
      position = _ref7$position === void 0 ? {
    horizontal: 5
  } : _ref7$position;
  return lodash.isNumber(position.horizontal) ? "".concat(position.horizontal, "px") : position.horizontal;
}, function (_ref8) {
  var _ref8$hasError = _ref8.hasError,
      hasError = _ref8$hasError === void 0 ? false : _ref8$hasError;
  return hasError ? 1 : 0;
});
var InputTextErrorText = styled__default["default"].span(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n  color: var(--ui-alert-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n"])));
var InputTextField = styled__default["default"].input(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n  z-index: 10;\n  outline: none;\n  border: none;\n  background: transparent;\n  padding: 2% 0 0 5px;\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 16px;\n  padding: 14px 35px;\n  margin-top: ", ";\n"])), function (_ref9) {
  var _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? "" : _ref9$label;
  return !label ? "0px" : "10px";
});

function InputText(_ref10) {
  var _ref10$id = _ref10.id,
      $id = _ref10$id === void 0 ? "" : _ref10$id,
      _ref10$className = _ref10.className,
      $className = _ref10$className === void 0 ? "" : _ref10$className,
      _ref10$containerStyle = _ref10.containerStyles,
      $containerStyles = _ref10$containerStyle === void 0 ? {} : _ref10$containerStyle,
      _ref10$containerProps = _ref10.containerProps,
      $containerProps = _ref10$containerProps === void 0 ? {} : _ref10$containerProps,
      _ref10$labelStyles = _ref10.labelStyles,
      $labelStyles = _ref10$labelStyles === void 0 ? {} : _ref10$labelStyles,
      _ref10$labelTextStyle = _ref10.labelTextStyles,
      $labelTextStyles = _ref10$labelTextStyle === void 0 ? {} : _ref10$labelTextStyle,
      _ref10$labelProps = _ref10.labelProps,
      $labelProps = _ref10$labelProps === void 0 ? {} : _ref10$labelProps,
      _ref10$labelTextProps = _ref10.labelTextProps,
      $labelTextProps = _ref10$labelTextProps === void 0 ? {} : _ref10$labelTextProps,
      _ref10$labelClassName = _ref10.labelClassName,
      $labelClassName = _ref10$labelClassName === void 0 ? "" : _ref10$labelClassName,
      _ref10$labelTextClass = _ref10.labelTextClassName,
      $labelTextClassName = _ref10$labelTextClass === void 0 ? "" : _ref10$labelTextClass,
      _ref10$label = _ref10.label,
      $label = _ref10$label === void 0 ? "" : _ref10$label,
      _ref10$inputStyles = _ref10.inputStyles,
      $inputStyles = _ref10$inputStyles === void 0 ? {} : _ref10$inputStyles,
      _ref10$type = _ref10.type,
      $type = _ref10$type === void 0 ? "text" : _ref10$type,
      _ref10$inputProps = _ref10.inputProps,
      $inputProps = _ref10$inputProps === void 0 ? {} : _ref10$inputProps,
      _ref10$inputClassName = _ref10.inputClassName,
      $inputClassName = _ref10$inputClassName === void 0 ? "" : _ref10$inputClassName,
      _ref10$errorTextProps = _ref10.errorTextProps,
      $errorTextProps = _ref10$errorTextProps === void 0 ? {} : _ref10$errorTextProps,
      _ref10$errorStyles = _ref10.errorStyles,
      $errorStyles = _ref10$errorStyles === void 0 ? {} : _ref10$errorStyles,
      _ref10$errorTextStyle = _ref10.errorTextStyles,
      $errorTextStyles = _ref10$errorTextStyle === void 0 ? {} : _ref10$errorTextStyle,
      _ref10$errorProps = _ref10.errorProps,
      $errorProps = _ref10$errorProps === void 0 ? {} : _ref10$errorProps,
      _ref10$errorClassName = _ref10.errorClassName,
      $errorClassName = _ref10$errorClassName === void 0 ? "" : _ref10$errorClassName,
      _ref10$errorTextClass = _ref10.errorTextClassName,
      $errorTextClassName = _ref10$errorTextClass === void 0 ? "" : _ref10$errorTextClass,
      _ref10$errorMessage = _ref10.errorMessage,
      $errorMessage = _ref10$errorMessage === void 0 ? "" : _ref10$errorMessage,
      _ref10$error = _ref10.error,
      $error = _ref10$error === void 0 ? {
    message: ""
  } : _ref10$error,
      _ref10$value = _ref10.value,
      $value = _ref10$value === void 0 ? "" : _ref10$value,
      _ref10$role = _ref10.role,
      $role = _ref10$role === void 0 ? "" : _ref10$role,
      _ref10$name = _ref10.name,
      $name = _ref10$name === void 0 ? "" : _ref10$name,
      _ref10$isRequired = _ref10.isRequired,
      $isRequired = _ref10$isRequired === void 0 ? false : _ref10$isRequired,
      _ref10$placeholder = _ref10.placeholder,
      $placeholder = _ref10$placeholder === void 0 ? "" : _ref10$placeholder,
      _ref10$validations = _ref10.validations,
      $validations = _ref10$validations === void 0 ? [] : _ref10$validations,
      _ref10$onChange = _ref10.onChange,
      $onChange = _ref10$onChange === void 0 ? function () {
    return undefined;
  } : _ref10$onChange,
      _ref10$onFocus = _ref10.onFocus,
      $onFocus = _ref10$onFocus === void 0 ? function () {
    return undefined;
  } : _ref10$onFocus,
      _ref10$onBlur = _ref10.onBlur,
      $onBlur = _ref10$onBlur === void 0 ? function () {
    return undefined;
  } : _ref10$onBlur;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isFocus = _useState2[0],
      setIsFocus = _useState2[1];

  var _useState3 = React.useState($error.message),
      _useState4 = _slicedToArray$1(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var inputRef = React.useRef(null);
  var hasValue = !!$value || isFocus;

  var focusInput = function focusInput() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var onChange = function onChange(_event) {
    var isValid = $validations.map(function (_ref11) {
      var _ref11$regexp = _ref11.regexp,
          regexp = _ref11$regexp === void 0 ? "" : _ref11$regexp,
          _ref11$regExpoConfig = _ref11.regExpoConfig,
          regExpoConfig = _ref11$regExpoConfig === void 0 ? "g" : _ref11$regExpoConfig,
          _ref11$error = _ref11.error,
          $$error = _ref11$error === void 0 ? {
        message: ""
      } : _ref11$error;
      var test = new RegExp(regexp, regExpoConfig).test(_event.target.value);

      if ($isRequired && (!_event.target.value || !test)) {
        if ($$error.message) setError($$error.message);else setError($error.message);
      } else setError();

      return test;
    });
    $onChange(_event, {
      isValid: isValid.every(Boolean),
      hasValue: hasValue,
      hasError: !!error,
      error: error
    });
  };

  var onFocus = function onFocus(_event) {
    $onFocus(_event);
    setIsFocus(true);
  };

  var onBlur = function onBlur(_event) {
    $onBlur(_event);
    setIsFocus(false);
    if (!_event.target.value) setError($errorMessage);
  };

  var onClickLabel = function
  /* _event */
  onClickLabel() {
    focusInput();
  };

  var onClickError = function
  /* _event */
  onClickError() {
    focusInput();
  };

  return /*#__PURE__*/React__default$1["default"].createElement(InputTextContainer, _extends$g({
    styles: $containerStyles
  }, $containerProps, {
    className: "".concat($className, " INPUT_TEXT")
  }), !!$label && /*#__PURE__*/React__default$1["default"].createElement(InputTextLabelContainer, _extends$g({
    styles: $labelStyles
  }, $labelProps, {
    className: "".concat($labelClassName, " INPUT_TEXT__LABEL"),
    hasValue: hasValue,
    hasError: !!error,
    onClick: onClickLabel
  }), /*#__PURE__*/React__default$1["default"].createElement(InputTextLabelText, _extends$g({
    styles: $labelTextStyles
  }, $labelTextProps, {
    className: "".concat($labelTextClassName, " INPUT_TEXT__LABEL__TEXT")
  }), $label)), /*#__PURE__*/React__default$1["default"].createElement(InputTextField, _extends$g({
    ref: inputRef,
    styles: $inputStyles,
    id: $id,
    label: $label
  }, $inputProps, {
    className: "".concat($inputClassName, " INPUT_TEXT__FIELD"),
    type: $type,
    value: $value || undefined,
    role: $role || undefined,
    name: $name,
    placeholder: $placeholder,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  })), !!error && /*#__PURE__*/React__default$1["default"].createElement(InputTextErrorContainer, _extends$g({
    className: "".concat($errorClassName, " INPUT_TEXT__ERROR"),
    hasValue: hasValue,
    hasError: !!error,
    onClick: onClickError,
    styles: $errorStyles
  }, $errorProps), /*#__PURE__*/React__default$1["default"].createElement(InputTextErrorText, _extends$g({
    styles: $errorTextStyles
  }, $errorTextProps, {
    className: "".concat($errorTextClassName, " INPUT_TEXT__ERROR__TEXT")
  }), error)));
}

var _templateObject$1e, _templateObject2$m, _templateObject3$g, _templateObject4$c, _templateObject5$9, _templateObject6$5;

var InputTextareaContainer = styled__default["default"].div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  position: relative;\n  min-height: 200px;\n  background: var(--grayscale-0-color);\n  z-index: 0;\n  grid-column: ", ";\n\n  @media all and (max-width: ", "px) {\n    grid-column: ", ";\n  }\n"])), function (_ref) {
  var gridColumn = _ref.gridColumn;
  return gridColumn;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (_ref3) {
  var mobileGridColumn = _ref3.mobileGridColumn;
  return mobileGridColumn;
});
var InputTextareaLabelContainer = styled__default["default"].div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  transition: all linear 100ms;\n  z-index: 15;\n  height: auto;\n  width: auto;\n  //bottom: 50%;\n  transform: translateY(-50%);\n  top: ", ";\n\n  left: ", ";\n"])), function (_ref4) {
  var _ref4$hasValue = _ref4.hasValue,
      hasValue = _ref4$hasValue === void 0 ? false : _ref4$hasValue,
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? {
    initial: 10,
    vertical: "20px"
  } : _ref4$position;

  if (!hasValue) {
    return lodash.isNumber(position.vertical) ? "".concat(position.vertical, "px") : position.vertical;
  }

  return lodash.isNumber(position.initial) ? "".concat(position.initial, "px") : position.initial;
}, function (_ref5) {
  var _ref5$position = _ref5.position,
      position = _ref5$position === void 0 ? {
    initial: -5,
    horizontal: 5
  } : _ref5$position;
  return lodash.isNumber(position.horizontal) ? "".concat(position.horizontal, "px") : position.horizontal;
});
var InputTextareaLabelText = styled__default["default"].p(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n  font-size: 14px !important;\n  line-height: 16px !important;\n  padding-left: 30px !important;\n  padding-right: 10px !important;\n"])));
var InputTextareaErrorContainer = styled__default["default"].div(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 5;\n\n  bottom: ", ";\n\n  left: ", ";\n\n  opacity: ", ";\n"])), function (_ref6) {
  var _ref6$position = _ref6.position,
      position = _ref6$position === void 0 ? {
    vertical: -20
  } : _ref6$position;
  return lodash.isNumber(position.vertical) ? "".concat(position.vertical, "px") : position.vertical;
}, function (_ref7) {
  var _ref7$position = _ref7.position,
      position = _ref7$position === void 0 ? {
    horizontal: 5
  } : _ref7$position;
  return lodash.isNumber(position.horizontal) ? "".concat(position.horizontal, "px") : position.horizontal;
}, function (_ref8) {
  var _ref8$hasError = _ref8.hasError,
      hasError = _ref8$hasError === void 0 ? false : _ref8$hasError;
  return hasError ? 1 : 0;
});
var InputTextareaErrorText = styled__default["default"].span(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n  color: var(--ui-alert-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n"])));
var InputTextareaField = styled__default["default"].textarea(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n  z-index: 10;\n  outline: none;\n  border: none;\n  background: transparent;\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 16px;\n  padding: 14px 35px;\n  margin-top: ", ";\n"])), function (_ref9) {
  var _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? "" : _ref9$label;
  return !label ? "0px" : "10px";
});

function InputTextarea(_ref10) {
  var _ref10$id = _ref10.id,
      $id = _ref10$id === void 0 ? "" : _ref10$id,
      _ref10$className = _ref10.className,
      $className = _ref10$className === void 0 ? "" : _ref10$className,
      _ref10$containerStyle = _ref10.containerStyles,
      $containerStyles = _ref10$containerStyle === void 0 ? {} : _ref10$containerStyle,
      _ref10$containerProps = _ref10.containerProps,
      $containerProps = _ref10$containerProps === void 0 ? {} : _ref10$containerProps,
      _ref10$labelStyles = _ref10.labelStyles,
      $labelStyles = _ref10$labelStyles === void 0 ? {} : _ref10$labelStyles,
      _ref10$labelTextStyle = _ref10.labelTextStyles,
      $labelTextStyles = _ref10$labelTextStyle === void 0 ? {} : _ref10$labelTextStyle,
      _ref10$labelProps = _ref10.labelProps,
      $labelProps = _ref10$labelProps === void 0 ? {} : _ref10$labelProps,
      _ref10$labelTextProps = _ref10.labelTextProps,
      $labelTextProps = _ref10$labelTextProps === void 0 ? {} : _ref10$labelTextProps,
      _ref10$labelClassName = _ref10.labelClassName,
      $labelClassName = _ref10$labelClassName === void 0 ? "" : _ref10$labelClassName,
      _ref10$labelTextClass = _ref10.labelTextClassName,
      $labelTextClassName = _ref10$labelTextClass === void 0 ? "" : _ref10$labelTextClass,
      _ref10$label = _ref10.label,
      $label = _ref10$label === void 0 ? "" : _ref10$label,
      _ref10$inputStyles = _ref10.inputStyles,
      $inputStyles = _ref10$inputStyles === void 0 ? {} : _ref10$inputStyles,
      _ref10$type = _ref10.type,
      $type = _ref10$type === void 0 ? "textarea" : _ref10$type,
      _ref10$inputProps = _ref10.inputProps,
      $inputProps = _ref10$inputProps === void 0 ? {} : _ref10$inputProps,
      _ref10$inputClassName = _ref10.inputClassName,
      $inputClassName = _ref10$inputClassName === void 0 ? "" : _ref10$inputClassName,
      _ref10$errorTextProps = _ref10.errorTextProps,
      $errorTextProps = _ref10$errorTextProps === void 0 ? {} : _ref10$errorTextProps,
      _ref10$errorStyles = _ref10.errorStyles,
      $errorStyles = _ref10$errorStyles === void 0 ? {} : _ref10$errorStyles,
      _ref10$errorTextStyle = _ref10.errorTextStyles,
      $errorTextStyles = _ref10$errorTextStyle === void 0 ? {} : _ref10$errorTextStyle,
      _ref10$errorProps = _ref10.errorProps,
      $errorProps = _ref10$errorProps === void 0 ? {} : _ref10$errorProps,
      _ref10$errorClassName = _ref10.errorClassName,
      $errorClassName = _ref10$errorClassName === void 0 ? "" : _ref10$errorClassName,
      _ref10$errorTextClass = _ref10.errorTextClassName,
      $errorTextClassName = _ref10$errorTextClass === void 0 ? "" : _ref10$errorTextClass,
      _ref10$error = _ref10.error,
      $error = _ref10$error === void 0 ? {
    message: ""
  } : _ref10$error,
      _ref10$errorMessage = _ref10.errorMessage,
      $errorMessage = _ref10$errorMessage === void 0 ? "" : _ref10$errorMessage,
      _ref10$value = _ref10.value,
      $value = _ref10$value === void 0 ? "" : _ref10$value,
      _ref10$role = _ref10.role,
      $role = _ref10$role === void 0 ? "" : _ref10$role,
      _ref10$name = _ref10.name,
      $name = _ref10$name === void 0 ? "" : _ref10$name,
      _ref10$isRequired = _ref10.isRequired,
      $isRequired = _ref10$isRequired === void 0 ? false : _ref10$isRequired,
      _ref10$placeholder = _ref10.placeholder,
      $placeholder = _ref10$placeholder === void 0 ? "" : _ref10$placeholder,
      _ref10$validations = _ref10.validations,
      $validations = _ref10$validations === void 0 ? [] : _ref10$validations,
      _ref10$onChange = _ref10.onChange,
      $onChange = _ref10$onChange === void 0 ? function () {
    return undefined;
  } : _ref10$onChange,
      _ref10$onFocus = _ref10.onFocus,
      $onFocus = _ref10$onFocus === void 0 ? function () {
    return undefined;
  } : _ref10$onFocus,
      _ref10$onBlur = _ref10.onBlur,
      $onBlur = _ref10$onBlur === void 0 ? function () {
    return undefined;
  } : _ref10$onBlur;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isFocus = _useState2[0],
      setIsFocus = _useState2[1];

  var _useState3 = React.useState($error.message),
      _useState4 = _slicedToArray$1(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var inputRef = React.useRef(null);
  var hasValue = !!$value || isFocus;

  var focusInput = function focusInput() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var onChange = function onChange(_event) {
    var isValid = $validations.map(function (_ref11) {
      var _ref11$regexp = _ref11.regexp,
          regexp = _ref11$regexp === void 0 ? "" : _ref11$regexp,
          _ref11$regExpoConfig = _ref11.regExpoConfig,
          regExpoConfig = _ref11$regExpoConfig === void 0 ? "g" : _ref11$regExpoConfig,
          _ref11$error = _ref11.error,
          $$error = _ref11$error === void 0 ? {
        message: ""
      } : _ref11$error;
      var test = new RegExp(regexp, regExpoConfig).test(_event.target.value);

      if ($isRequired && (!_event.target.value || !test)) {
        if ($$error.message) setError($$error.message);else setError($error.message);
      } else setError("");

      return test;
    });
    $onChange(_event, {
      isValid: isValid.every(Boolean),
      hasValue: hasValue,
      hasError: !!error,
      error: error
    });
  };

  var onFocus = function onFocus(_event) {
    $onFocus(_event);
    setIsFocus(true);
  };

  var onBlur = function onBlur(_event) {
    $onBlur(_event);
    setIsFocus(false);
    if (!_event.target.value) setError($errorMessage);
  };

  var onClickLabel = function
  /* _event */
  onClickLabel() {
    focusInput();
  };

  var onClickError = function
  /* _event */
  onClickError() {
    focusInput();
  };

  return /*#__PURE__*/React__default$1["default"].createElement(InputTextareaContainer, _extends$g({
    styles: $containerStyles
  }, $containerProps, {
    className: "".concat($className, " INPUT_TEXTAREA")
  }), !!$label && /*#__PURE__*/React__default$1["default"].createElement(InputTextareaLabelContainer, _extends$g({
    styles: $labelStyles
  }, $labelProps, {
    className: "".concat($labelClassName, " INPUT_TEXTAREA__LABEL"),
    hasValue: hasValue,
    hasError: !!error,
    onClick: onClickLabel
  }), /*#__PURE__*/React__default$1["default"].createElement(InputTextareaLabelText, _extends$g({
    styles: $labelTextStyles
  }, $labelTextProps, {
    className: "".concat($labelTextClassName, " INPUT_TEXTAREA__LABEL__TEXT")
  }), $label)), /*#__PURE__*/React__default$1["default"].createElement(InputTextareaField, _extends$g({
    ref: inputRef,
    id: $id,
    styles: $inputStyles,
    label: $label
  }, $inputProps, {
    className: "".concat($inputClassName, " INPUT_TEXTAREA__FIELD"),
    type: $type,
    value: $value || undefined,
    role: $role || undefined,
    name: $name,
    placeholder: $placeholder,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  })), !!error && /*#__PURE__*/React__default$1["default"].createElement(InputTextareaErrorContainer, _extends$g({
    className: "".concat($errorClassName, " INPUT_TEXTAREA__ERROR"),
    hasValue: hasValue,
    hasError: !!error,
    onClick: onClickError,
    styles: $errorStyles
  }, $errorProps), /*#__PURE__*/React__default$1["default"].createElement(InputTextareaErrorText, _extends$g({
    styles: $errorTextStyles
  }, $errorTextProps, {
    className: "".concat($errorTextClassName, " INPUT_TEXTAREA__ERROR__TEXT")
  }), error)));
}

var _templateObject$1d, _templateObject2$l, _templateObject3$f, _templateObject4$b, _templateObject5$8, _templateObject6$4, _templateObject7$3;

var InputSelectContainer = styled__default["default"].div(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  position: relative;\n  min-height: 50px;\n  background: var(--grayscale-0-color);\n  z-index: 0;\n  grid-column: ", ";\n\n  @media all and (max-width: ", "px) {\n    grid-column: ", ";\n  }\n"])), function (_ref) {
  var gridColumn = _ref.gridColumn;
  return gridColumn;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (_ref3) {
  var mobileGridColumn = _ref3.mobileGridColumn;
  return mobileGridColumn;
});
var InputSelectLabelContainer = styled__default["default"].div(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  transition: all linear 100ms;\n  z-index: 15;\n  height: min-content;\n  width: auto;\n  bottom: 50%;\n  transform: translateY(-50%);\n  top: ", ";\n\n  left: ", ";\n"])), function (_ref4) {
  var _ref4$hasValue = _ref4.hasValue,
      hasValue = _ref4$hasValue === void 0 ? false : _ref4$hasValue,
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? {
    initial: 10,
    vertical: "50%"
  } : _ref4$position;

  if (!hasValue) {
    return lodash.isNumber(position.vertical) ? "".concat(position.vertical, "px") : position.vertical;
  }

  return lodash.isNumber(position.initial) ? "".concat(position.initial, "px") : position.initial;
}, function (_ref5) {
  var _ref5$position = _ref5.position,
      position = _ref5$position === void 0 ? {
    initial: -5,
    horizontal: 5
  } : _ref5$position;
  return lodash.isNumber(position.horizontal) ? "".concat(position.horizontal, "px") : position.horizontal;
});
var InputSelectLabelText = styled__default["default"].span(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 14px;\n  padding: 14px 35px;\n"])));
var InputSelectErrorContainer = styled__default["default"].div(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 5;\n\n  bottom: ", ";\n\n  left: ", ";\n\n  opacity: ", ";\n"])), function (_ref6) {
  var _ref6$position = _ref6.position,
      position = _ref6$position === void 0 ? {
    vertical: "-35%"
  } : _ref6$position;
  return lodash.isNumber(position.vertical) ? "".concat(position.vertical, "px") : position.vertical;
}, function (_ref7) {
  var _ref7$position = _ref7.position,
      position = _ref7$position === void 0 ? {
    horizontal: 5
  } : _ref7$position;
  return lodash.isNumber(position.horizontal) ? "".concat(position.horizontal, "px") : position.horizontal;
}, function (_ref8) {
  var _ref8$hasError = _ref8.hasError,
      hasError = _ref8$hasError === void 0 ? false : _ref8$hasError;
  return hasError ? 1 : 0;
});
var InputSelectErrorText = styled__default["default"].span(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n  color: var(--ui-alert-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 14px;\n"])));
var InputSelectField = styled__default["default"].select(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n  z-index: 10;\n  outline: none;\n  border: none;\n  background: transparent;\n  padding: 2% 0 0 5px;\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 16px;\n  margin-top: ", ";\n  padding: 14px 35px;\n"])), function (_ref9) {
  var _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? "" : _ref9$label;
  return !label ? "0px" : "10px";
});
var InputSelectOptionField = styled__default["default"].option(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n  outline: none;\n  border: none;\n  background: transparent;\n  padding: 2% 0 0 5px;\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 16px;\n"])));

function InputSelect(_ref10) {
  var _ref10$id = _ref10.id,
      $id = _ref10$id === void 0 ? "" : _ref10$id,
      _ref10$className = _ref10.className,
      $className = _ref10$className === void 0 ? "" : _ref10$className,
      _ref10$containerStyle = _ref10.containerStyles,
      $containerStyles = _ref10$containerStyle === void 0 ? {} : _ref10$containerStyle,
      _ref10$containerProps = _ref10.containerProps,
      $containerProps = _ref10$containerProps === void 0 ? {} : _ref10$containerProps,
      _ref10$labelStyles = _ref10.labelStyles,
      $labelStyles = _ref10$labelStyles === void 0 ? {} : _ref10$labelStyles,
      _ref10$labelTextStyle = _ref10.labelTextStyles,
      $labelTextStyles = _ref10$labelTextStyle === void 0 ? {} : _ref10$labelTextStyle,
      _ref10$labelProps = _ref10.labelProps,
      $labelProps = _ref10$labelProps === void 0 ? {} : _ref10$labelProps,
      _ref10$labelTextProps = _ref10.labelTextProps,
      $labelTextProps = _ref10$labelTextProps === void 0 ? {} : _ref10$labelTextProps,
      _ref10$labelClassName = _ref10.labelClassName,
      $labelClassName = _ref10$labelClassName === void 0 ? "" : _ref10$labelClassName,
      _ref10$labelTextClass = _ref10.labelTextClassName,
      $labelTextClassName = _ref10$labelTextClass === void 0 ? "" : _ref10$labelTextClass,
      _ref10$label = _ref10.label,
      $label = _ref10$label === void 0 ? "" : _ref10$label,
      _ref10$inputStyles = _ref10.inputStyles,
      $inputStyles = _ref10$inputStyles === void 0 ? {} : _ref10$inputStyles,
      _ref10$inputProps = _ref10.inputProps,
      $inputProps = _ref10$inputProps === void 0 ? {} : _ref10$inputProps,
      _ref10$inputClassName = _ref10.inputClassName,
      $inputClassName = _ref10$inputClassName === void 0 ? "" : _ref10$inputClassName,
      _ref10$optionStyles = _ref10.optionStyles,
      $optionStyles = _ref10$optionStyles === void 0 ? {} : _ref10$optionStyles,
      _ref10$optionProps = _ref10.optionProps,
      $optionProps = _ref10$optionProps === void 0 ? {} : _ref10$optionProps,
      _ref10$optionClassNam = _ref10.optionClassName,
      $optionClassName = _ref10$optionClassNam === void 0 ? "" : _ref10$optionClassNam,
      _ref10$errorTextProps = _ref10.errorTextProps,
      $errorTextProps = _ref10$errorTextProps === void 0 ? {} : _ref10$errorTextProps,
      _ref10$errorStyles = _ref10.errorStyles,
      $errorStyles = _ref10$errorStyles === void 0 ? {} : _ref10$errorStyles,
      _ref10$errorTextStyle = _ref10.errorTextStyles,
      $errorTextStyles = _ref10$errorTextStyle === void 0 ? {} : _ref10$errorTextStyle,
      _ref10$errorProps = _ref10.errorProps,
      $errorProps = _ref10$errorProps === void 0 ? {} : _ref10$errorProps,
      _ref10$errorClassName = _ref10.errorClassName,
      $errorClassName = _ref10$errorClassName === void 0 ? "" : _ref10$errorClassName,
      _ref10$errorTextClass = _ref10.errorTextClassName,
      $errorTextClassName = _ref10$errorTextClass === void 0 ? "" : _ref10$errorTextClass,
      _ref10$error = _ref10.error,
      $error = _ref10$error === void 0 ? {
    message: ""
  } : _ref10$error,
      _ref10$value = _ref10.value,
      $value = _ref10$value === void 0 ? "" : _ref10$value,
      _ref10$role = _ref10.role,
      $role = _ref10$role === void 0 ? "" : _ref10$role,
      _ref10$name = _ref10.name,
      $name = _ref10$name === void 0 ? "" : _ref10$name,
      _ref10$defaultOptionL = _ref10.defaultOptionLabel,
      $defaultOptionLabel = _ref10$defaultOptionL === void 0 ? "Select an option" : _ref10$defaultOptionL,
      _ref10$isRequired = _ref10.isRequired,
      $isRequired = _ref10$isRequired === void 0 ? false : _ref10$isRequired,
      _ref10$placeholder = _ref10.placeholder,
      $placeholder = _ref10$placeholder === void 0 ? "" : _ref10$placeholder,
      _ref10$errorMessage = _ref10.errorMessage,
      $errorMessage = _ref10$errorMessage === void 0 ? "" : _ref10$errorMessage,
      _ref10$options = _ref10.options,
      $options = _ref10$options === void 0 ? [] : _ref10$options,
      _ref10$onChange = _ref10.onChange,
      $onChange = _ref10$onChange === void 0 ? function () {
    return undefined;
  } : _ref10$onChange,
      _ref10$onFocus = _ref10.onFocus,
      $onFocus = _ref10$onFocus === void 0 ? function () {
    return undefined;
  } : _ref10$onFocus,
      _ref10$onBlur = _ref10.onBlur,
      $onBlur = _ref10$onBlur === void 0 ? function () {
    return undefined;
  } : _ref10$onBlur;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      isFocus = _useState2[0],
      setIsFocus = _useState2[1];

  var _useState3 = React.useState($error.message),
      _useState4 = _slicedToArray$1(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var inputRef = React.useRef(null);
  var hasValue = !!$value || isFocus;

  var focusInput = function focusInput() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var onChange = function onChange(_event) {
    var _value = _event.target.value === $defaultOptionLabel ? "" : _event.target.value;

    $onChange(_event, {
      isValid: !!_value,
      hasValue: !!$value,
      hasError: !!error || !_value,
      error: error
    });
    if (!_value && $isRequired) setError($errorMessage || "Is required");
  };

  var onFocus = function onFocus(_event) {
    $onFocus(_event);
    setIsFocus(true);
  };

  var onBlur = function onBlur(_event) {
    $onBlur(_event);
    setIsFocus(false);
  };

  var onClickLabel = function
  /* _event */
  onClickLabel() {
    focusInput();
  };

  var onClickError = function
  /* _event */
  onClickError() {
    focusInput();
  };

  return /*#__PURE__*/React__default$1["default"].createElement(InputSelectContainer, _extends$g({
    styles: $containerStyles
  }, $containerProps, {
    className: "".concat($className, " INPUT_SELECT")
  }), !!$label && /*#__PURE__*/React__default$1["default"].createElement(InputSelectLabelContainer, _extends$g({
    styles: $labelStyles
  }, $labelProps, {
    className: "".concat($labelClassName, " INPUT_SELECT__LABEL"),
    hasValue: true,
    hasError: !!error,
    onClick: onClickLabel
  }), /*#__PURE__*/React__default$1["default"].createElement(InputSelectLabelText, _extends$g({
    styles: $labelTextStyles
  }, $labelTextProps, {
    className: "".concat($labelTextClassName, " INPUT_SELECT__LABEL__TEXT")
  }), $label)), /*#__PURE__*/React__default$1["default"].createElement(InputSelectField, _extends$g({
    id: $id,
    placeholder: $placeholder,
    styles: $inputStyles,
    name: $name,
    role: $role,
    label: $label
  }, $inputProps, {
    value: $value,
    className: "".concat($inputClassName),
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur
  }), /*#__PURE__*/React__default$1["default"].createElement(InputSelectOptionField, _extends$g({
    value: null,
    styles: $optionStyles
  }, $optionProps, {
    className: "".concat($optionClassName)
  }), $defaultOptionLabel), $options.map(function (option) {
    return /*#__PURE__*/React__default$1["default"].createElement(InputSelectOptionField, _extends$g({
      value: option.value,
      key: option.id,
      styles: $optionStyles
    }, $optionProps, {
      className: "".concat($optionClassName)
    }), option.label);
  })), !!error && /*#__PURE__*/React__default$1["default"].createElement(InputSelectErrorContainer, _extends$g({
    className: "".concat($errorClassName, " INPUT_SELECT__ERROR"),
    hasValue: hasValue,
    hasError: !!error,
    onClick: onClickError,
    styles: $errorStyles
  }, $errorProps), /*#__PURE__*/React__default$1["default"].createElement(InputSelectErrorText, _extends$g({
    styles: $errorTextStyles
  }, $errorTextProps, {
    className: "".concat($errorTextClassName, " INPUT_SELECT__ERROR__TEXT")
  }), error)));
}
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */


function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */


function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
/** Used to compose unicode character classes. */


var rsAstralRange$1 = "\\ud800-\\udfff",
    rsComboMarksRange$1 = "\\u0300-\\u036f",
    reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */

var rsZWJ$1 = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */

var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */

function hasUnicode(string) {
  return reHasUnicode.test(string);
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function asciiToArray(string) {
  return string.split('');
}
/** Used to compose unicode character classes. */


var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f",
    reComboHalfMarksRange = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange = "\\u20d0-\\u20ff",
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */

var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */

var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */

var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */


function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */


function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */


var upperFirst = createCaseFirst('toUpperCase');
var upperFirst$1 = upperFirst;
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */

function capitalize(string) {
  return upperFirst$1(toString(string).toLowerCase());
}

var _templateObject$1c, _templateObject2$k, _templateObject3$e, _templateObject4$a, _templateObject5$7, _templateObject6$3;

var RadioContainer = styled__default["default"].div(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 20px;\n"])));
var RadioTitle = styled__default["default"].h3(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-weight: 400;\n  font-size: 16px;\n  color: var(--grayscale-100-color);\n  width: 100%;\n  margin-bottom: 5px;\n"])));
var RadioMapContainer = styled__default["default"].div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n"])));
var RadioInputContainer = styled__default["default"].div(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  margin-right: 30px;\n  display: flex;\n  align-items: center;\n"])));
var RadioLabel = styled__default["default"].label(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  font-family: var(--primary-family);\n  font-weight: 400;\n  font-size: 16px;\n  color: var(--grayscale-100-color);\n"])));
var RadioInput = styled__default["default"].input(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  border: 2px solid var(--grayscale-0-color);\n  background: var(--grayscale-0-color);\n  padding: 0.5em;\n  cursor: pointer;\n  -webkit-appearance: none;\n\n  &:checked {\n    border-color: var(--grayscale-0-color);\n    background: var(--primary-150-color);\n  }\n"])));

function InputRadiobutton(_ref) {
  var _ref$label = _ref.label,
      $label = _ref$label === void 0 ? "" : _ref$label,
      _ref$inputClassName = _ref.inputClassName,
      $inputClassName = _ref$inputClassName === void 0 ? "" : _ref$inputClassName,
      _ref$name = _ref.name,
      $name = _ref$name === void 0 ? "" : _ref$name,
      _ref$options = _ref.options,
      $options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onChange = _ref.onChange,
      $onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      $onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      $onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(_event) {
    var _value = _event.currentTarget.value;
    setValue(_value);
    $onChange(_event, {});
  };

  var onFocus = function onFocus(_event) {
    $onFocus(_event, {});
  };

  var onBlur = function onBlur(_event) {
    $onBlur(_event, {});
  };

  return /*#__PURE__*/React__default$1["default"].createElement(RadioContainer, {
    className: "CUSTOM_RADIO__CONTAINER"
  }, $label && /*#__PURE__*/React__default$1["default"].createElement(RadioTitle, {
    className: "RADIO__TITLE"
  }, $label), /*#__PURE__*/React__default$1["default"].createElement(RadioMapContainer, null, $options.map(function (input, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(RadioInputContainer, {
      className: "RADIO__MAP__INPUT__BOX",
      key: "radio_form_".concat(index)
    }, (input === null || input === void 0 ? void 0 : input.value) && /*#__PURE__*/React__default$1["default"].createElement(RadioLabel, {
      className: "RADIO__LABEL",
      htmlFor: input.value
    }, capitalize(input.value)), /*#__PURE__*/React__default$1["default"].createElement(RadioInput, {
      type: "radio",
      id: input.value,
      name: $name,
      value: input.value,
      checked: input.value === value,
      className: "".concat($inputClassName, " RADIO__INPUT"),
      onFocus: onFocus,
      onChange: onChange,
      onBlur: onBlur
    }));
  })));
}

var _excluded$K = ["variant"];

function Input(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? inputVariantTypes.TEXT : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$K);

  switch (variant) {
    case inputVariantTypes.TEXT:
      return /*#__PURE__*/React__default$1["default"].createElement(InputText, otherProps);

    case inputVariantTypes.TEXTAREA:
      return /*#__PURE__*/React__default$1["default"].createElement(InputTextarea, otherProps);

    case inputVariantTypes.SELECT:
      return /*#__PURE__*/React__default$1["default"].createElement(InputSelect, otherProps);

    case inputVariantTypes.CHECK:
      return /*#__PURE__*/React__default$1["default"].createElement(InputRadiobutton, otherProps);

    default:
      throw new Error("Invalid Input variant: ".concat(variant));
  }
}

var _templateObject$1b;

var Toast$1 = styled__default["default"](ToastContainer$1)(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteral(["\n  /** Used to define container behavior: width, position: fixed etc... **/\n  & {\n  }\n\n  /** Used to define the position of the ToastContainer **/\n\n  &--top-left {\n  }\n\n  &--top-center {\n  }\n\n  &--top-right {\n  }\n\n  &--bottom-left {\n  }\n\n  &--bottom-center {\n  }\n\n  &--bottom-right {\n  }\n\n  /** Classes for the displayed toast **/\n  .Toastify__toast {\n  }\n\n  .Toastify__toast--rtl {\n  }\n\n  .Toastify__toast--dark {\n  }\n\n  .Toastify__toast--default {\n  }\n\n  .Toastify__toast--info {\n  }\n\n  .Toastify__toast--success {\n    background: #3fc78e;\n  }\n\n  .Toastify__toast--warning {\n  }\n\n  .Toastify__toast--error {\n    background: #de3232;\n  }\n\n  .Toastify__toast-body {\n  }\n\n  /** Classes for the close button. Better use your own closeButton **/\n  .Toastify__close-button {\n  }\n\n  .Toastify__close-button--default {\n  }\n\n  .Toastify__close-button > svg {\n  }\n\n  .Toastify__close-button:hover,\n  .Toastify__close-button:focus {\n  }\n\n  /** Classes for the progress bar **/\n  .Toastify__progress-bar {\n  }\n\n  .Toastify__progress-bar--animated {\n  }\n\n  .Toastify__progress-bar--controlled {\n  }\n\n  .Toastify__progress-bar--rtl {\n  }\n\n  .Toastify__progress-bar--default {\n  }\n\n  .Toastify__progress-bar--dark {\n  }\n"])));

var loadScript = function load(src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');

  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }

  opts = opts || {};

  cb = cb || function () {};

  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;

  if (opts.attrs) {
    setAttributes(script, opts.attrs);
  }

  if (opts.text) {
    script.text = '' + opts.text;
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb); // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload

  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script);
};

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd(script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };

  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}

function ieOnEnd(script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return;
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }

  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}

function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}

function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}

function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
} // Protects from prototype poisoning and unexpected merging up the prototype chain.


function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }

    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.

  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
var parseStartTime_1 = parseStartTime;
var parseEndTime_1 = parseEndTime;
var randomString_1 = randomString;
var queryString_1 = queryString;
var getSDK_1 = getSDK;
var getConfig_1 = getConfig;
var omit_1 = omit;
var callPlayer_1 = callPlayer;
var isMediaStream_1 = isMediaStream;
var isBlobUrl_1 = isBlobUrl;
var supportsWebKitPresentationMode_1 = supportsWebKitPresentationMode;

var _loadScript = _interopRequireDefault(loadScript);

var _deepmerge = _interopRequireDefault(cjs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  if (url instanceof Array) {
    return undefined;
  }

  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
}

function getGlobal(key) {
  if (window[key]) {
    return window[key];
  }

  if (window.exports && window.exports[key]) {
    return window.exports[key];
  }

  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key];
  }

  return null;
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];
  var existingGlobal = getGlobal(sdkGlobal);

  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(getGlobal(sdkGlobal));
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(getGlobal(sdkGlobal));
      }
    });
  });
}

function getConfig(props, defaultProps) {
  return (0, _deepmerge["default"])(defaultProps.config, props.config);
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player; // Util method for calling a method on this.player
  // but guard against errors and console.warn instead


  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

function isBlobUrl(url) {
  return /^blob:/.test(url);
}

function supportsWebKitPresentationMode() {
  var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('video'); // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function

  var notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && notMobile;
}

var utils$1 = /*#__PURE__*/Object.defineProperty({
  parseStartTime: parseStartTime_1,
  parseEndTime: parseEndTime_1,
  randomString: randomString_1,
  queryString: queryString_1,
  getSDK: getSDK_1,
  getConfig: getConfig_1,
  omit: omit_1,
  callPlayer: callPlayer_1,
  isMediaStream: isMediaStream_1,
  isBlobUrl: isBlobUrl_1,
  supportsWebKitPresentationMode: supportsWebKitPresentationMode_1
}, '__esModule', {
  value: true
});
var patterns = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.canPlay = exports.FLV_EXTENSIONS = exports.DASH_EXTENSIONS = exports.HLS_EXTENSIONS = exports.VIDEO_EXTENSIONS = exports.AUDIO_EXTENSIONS = exports.MATCH_URL_KALTURA = exports.MATCH_URL_VIDYARD = exports.MATCH_URL_MIXCLOUD = exports.MATCH_URL_DAILYMOTION = exports.MATCH_URL_TWITCH_CHANNEL = exports.MATCH_URL_TWITCH_VIDEO = exports.MATCH_URL_WISTIA = exports.MATCH_URL_STREAMABLE = exports.MATCH_URL_FACEBOOK_WATCH = exports.MATCH_URL_FACEBOOK = exports.MATCH_URL_VIMEO = exports.MATCH_URL_SOUNDCLOUD = exports.MATCH_URL_YOUTUBE = void 0;

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function F() {};

        return {
          s: F,
          n: function n() {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function e(_e) {
            throw _e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function s() {
        it = o[Symbol.iterator]();
      },
      n: function n() {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(_e2) {
        didErr = true;
        err = _e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it["return"] != null) it["return"]();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  var MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
  exports.MATCH_URL_YOUTUBE = MATCH_URL_YOUTUBE;
  var MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
  exports.MATCH_URL_SOUNDCLOUD = MATCH_URL_SOUNDCLOUD;
  var MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
  exports.MATCH_URL_VIMEO = MATCH_URL_VIMEO;
  var MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
  exports.MATCH_URL_FACEBOOK = MATCH_URL_FACEBOOK;
  var MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
  exports.MATCH_URL_FACEBOOK_WATCH = MATCH_URL_FACEBOOK_WATCH;
  var MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
  exports.MATCH_URL_STREAMABLE = MATCH_URL_STREAMABLE;
  var MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?(.*)$/;
  exports.MATCH_URL_WISTIA = MATCH_URL_WISTIA;
  var MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
  exports.MATCH_URL_TWITCH_VIDEO = MATCH_URL_TWITCH_VIDEO;
  var MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
  exports.MATCH_URL_TWITCH_CHANNEL = MATCH_URL_TWITCH_CHANNEL;
  var MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
  exports.MATCH_URL_DAILYMOTION = MATCH_URL_DAILYMOTION;
  var MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
  exports.MATCH_URL_MIXCLOUD = MATCH_URL_MIXCLOUD;
  var MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
  exports.MATCH_URL_VIDYARD = MATCH_URL_VIDYARD;
  var MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
  exports.MATCH_URL_KALTURA = MATCH_URL_KALTURA;
  var AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
  exports.AUDIO_EXTENSIONS = AUDIO_EXTENSIONS;
  var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
  exports.VIDEO_EXTENSIONS = VIDEO_EXTENSIONS;
  var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
  exports.HLS_EXTENSIONS = HLS_EXTENSIONS;
  var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
  exports.DASH_EXTENSIONS = DASH_EXTENSIONS;
  var FLV_EXTENSIONS = /\.(flv)($|\?)/i;
  exports.FLV_EXTENSIONS = FLV_EXTENSIONS;

  var canPlayFile = function canPlayFile(url) {
    if (url instanceof Array) {
      var _iterator = _createForOfIteratorHelper(url),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (typeof item === 'string' && canPlayFile(item)) {
            return true;
          }

          if (canPlayFile(item.src)) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    }

    if ((0, utils$1.isMediaStream)(url) || (0, utils$1.isBlobUrl)(url)) {
      return true;
    }

    return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url) || FLV_EXTENSIONS.test(url);
  };

  var canPlay = {
    youtube: function youtube(url) {
      if (url instanceof Array) {
        return url.every(function (item) {
          return MATCH_URL_YOUTUBE.test(item);
        });
      }

      return MATCH_URL_YOUTUBE.test(url);
    },
    soundcloud: function soundcloud(url) {
      return MATCH_URL_SOUNDCLOUD.test(url) && !AUDIO_EXTENSIONS.test(url);
    },
    vimeo: function vimeo(url) {
      return MATCH_URL_VIMEO.test(url) && !VIDEO_EXTENSIONS.test(url) && !HLS_EXTENSIONS.test(url);
    },
    facebook: function facebook(url) {
      return MATCH_URL_FACEBOOK.test(url) || MATCH_URL_FACEBOOK_WATCH.test(url);
    },
    streamable: function streamable(url) {
      return MATCH_URL_STREAMABLE.test(url);
    },
    wistia: function wistia(url) {
      return MATCH_URL_WISTIA.test(url);
    },
    twitch: function twitch(url) {
      return MATCH_URL_TWITCH_VIDEO.test(url) || MATCH_URL_TWITCH_CHANNEL.test(url);
    },
    dailymotion: function dailymotion(url) {
      return MATCH_URL_DAILYMOTION.test(url);
    },
    mixcloud: function mixcloud(url) {
      return MATCH_URL_MIXCLOUD.test(url);
    },
    vidyard: function vidyard(url) {
      return MATCH_URL_VIDYARD.test(url);
    },
    kaltura: function kaltura(url) {
      return MATCH_URL_KALTURA.test(url);
    },
    file: canPlayFile
  };
  exports.canPlay = canPlay;
});
var YouTube_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://www.youtube.com/iframe_api';
  var SDK_GLOBAL = 'YT';
  var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
  var MATCH_PLAYLIST = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/;
  var MATCH_USER_UPLOADS = /user\/([a-zA-Z0-9_-]+)\/?/;
  var MATCH_NOCOOKIE = /youtube-nocookie\.com/;
  var NOCOOKIE_HOST = 'https://www.youtube-nocookie.com';

  var YouTube = /*#__PURE__*/function (_Component) {
    _inherits(YouTube, _Component);

    var _super = _createSuper(YouTube);

    function YouTube() {
      var _this;

      _classCallCheck(this, YouTube);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "parsePlaylist", function (url) {
        if (url instanceof Array) {
          return {
            listType: 'playlist',
            playlist: url.map(_this.getID).join(',')
          };
        }

        if (MATCH_PLAYLIST.test(url)) {
          var _url$match = url.match(MATCH_PLAYLIST),
              _url$match2 = _slicedToArray(_url$match, 2),
              playlistId = _url$match2[1];

          return {
            listType: 'playlist',
            list: playlistId.replace(/^UC/, 'UU')
          };
        }

        if (MATCH_USER_UPLOADS.test(url)) {
          var _url$match3 = url.match(MATCH_USER_UPLOADS),
              _url$match4 = _slicedToArray(_url$match3, 2),
              username = _url$match4[1];

          return {
            listType: 'user_uploads',
            list: username
          };
        }

        return {};
      });

      _defineProperty(_assertThisInitialized(_this), "onStateChange", function (event) {
        var data = event.data;
        var _this$props = _this.props,
            onPlay = _this$props.onPlay,
            onPause = _this$props.onPause,
            onBuffer = _this$props.onBuffer,
            onBufferEnd = _this$props.onBufferEnd,
            onEnded = _this$props.onEnded,
            onReady = _this$props.onReady,
            loop = _this$props.loop,
            _this$props$config = _this$props.config,
            playerVars = _this$props$config.playerVars,
            onUnstarted = _this$props$config.onUnstarted;
        var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
            UNSTARTED = _window$SDK_GLOBAL$Pl.UNSTARTED,
            PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
            PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
            BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
            ENDED = _window$SDK_GLOBAL$Pl.ENDED,
            CUED = _window$SDK_GLOBAL$Pl.CUED;
        if (data === UNSTARTED) onUnstarted();

        if (data === PLAYING) {
          onPlay();
          onBufferEnd();
        }

        if (data === PAUSED) onPause();
        if (data === BUFFERING) onBuffer();

        if (data === ENDED) {
          var isPlaylist = !!_this.callPlayer('getPlaylist'); // Only loop manually if not playing a playlist

          if (loop && !isPlaylist) {
            if (playerVars.start) {
              _this.seekTo(playerVars.start);
            } else {
              _this.play();
            }
          }

          onEnded();
        }

        if (data === CUED) onReady();
      });

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('mute');
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('unMute');
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
        _this.container = container;
      });

      return _this;
    }

    _createClass(YouTube, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "getID",
      value: function getID(url) {
        if (!url || url instanceof Array || MATCH_PLAYLIST.test(url)) {
          return null;
        }

        return url.match(patterns.MATCH_URL_YOUTUBE)[1];
      }
    }, {
      key: "load",
      value: function load(url, isReady) {
        var _this2 = this;

        var _this$props2 = this.props,
            playing = _this$props2.playing,
            muted = _this$props2.muted,
            playsinline = _this$props2.playsinline,
            controls = _this$props2.controls,
            loop = _this$props2.loop,
            config = _this$props2.config,
            _onError = _this$props2.onError;
        var playerVars = config.playerVars,
            embedOptions = config.embedOptions;
        var id = this.getID(url);

        if (isReady) {
          if (MATCH_PLAYLIST.test(url) || MATCH_USER_UPLOADS.test(url) || url instanceof Array) {
            this.player.loadPlaylist(this.parsePlaylist(url));
            return;
          }

          this.player.cueVideoById({
            videoId: id,
            startSeconds: (0, utils$1.parseStartTime)(url) || playerVars.start,
            endSeconds: (0, utils$1.parseEndTime)(url) || playerVars.end
          });
          return;
        }

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
          return YT.loaded;
        }).then(function (YT) {
          if (!_this2.container) return;
          _this2.player = new YT.Player(_this2.container, _objectSpread({
            width: '100%',
            height: '100%',
            videoId: id,
            playerVars: _objectSpread(_objectSpread({
              autoplay: playing ? 1 : 0,
              mute: muted ? 1 : 0,
              controls: controls ? 1 : 0,
              start: (0, utils$1.parseStartTime)(url),
              end: (0, utils$1.parseEndTime)(url),
              origin: window.location.origin,
              playsinline: playsinline ? 1 : 0
            }, _this2.parsePlaylist(url)), playerVars),
            events: {
              onReady: function onReady() {
                if (loop) {
                  _this2.player.setLoop(true); // Enable playlist looping

                }

                _this2.props.onReady();
              },
              onPlaybackRateChange: function onPlaybackRateChange(event) {
                return _this2.props.onPlaybackRateChange(event.data);
              },
              onStateChange: _this2.onStateChange,
              onError: function onError(event) {
                return _onError(event.data);
              }
            },
            host: MATCH_NOCOOKIE.test(url) ? NOCOOKIE_HOST : undefined
          }, embedOptions));
        }, _onError);

        if (embedOptions.events) {
          console.warn('Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause');
        }
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('playVideo');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pauseVideo');
      }
    }, {
      key: "stop",
      value: function stop() {
        if (!document.body.contains(this.callPlayer('getIframe'))) return;
        this.callPlayer('stopVideo');
      }
    }, {
      key: "seekTo",
      value: function seekTo(amount) {
        this.callPlayer('seekTo', amount);

        if (!this.props.playing) {
          this.pause();
        }
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction * 100);
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(rate) {
        this.callPlayer('setPlaybackRate', rate);
      }
    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        this.callPlayer('setLoop', loop);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.callPlayer('getDuration');
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.callPlayer('getCurrentTime');
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
      }
    }, {
      key: "render",
      value: function render() {
        var display = this.props.display;
        var style = {
          width: '100%',
          height: '100%',
          display: display
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.ref
        }));
      }
    }]);

    return YouTube;
  }(_react.Component);

  exports["default"] = YouTube;

  _defineProperty(YouTube, "displayName", 'YouTube');

  _defineProperty(YouTube, "canPlay", patterns.canPlay.youtube);
});
var SoundCloud_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://w.soundcloud.com/player/api.js';
  var SDK_GLOBAL = 'SC';

  var SoundCloud = /*#__PURE__*/function (_Component) {
    _inherits(SoundCloud, _Component);

    var _super = _createSuper(SoundCloud);

    function SoundCloud() {
      var _this;

      _classCallCheck(this, SoundCloud);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "duration", null);

      _defineProperty(_assertThisInitialized(_this), "currentTime", null);

      _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.setVolume(0);
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        if (_this.props.volume !== null) {
          _this.setVolume(_this.props.volume);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
        _this.iframe = iframe;
      });

      return _this;
    }

    _createClass(SoundCloud, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url, isReady) {
        var _this2 = this;

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
          if (!_this2.iframe) return;
          var _SC$Widget$Events = SC.Widget.Events,
              PLAY = _SC$Widget$Events.PLAY,
              PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
              PAUSE = _SC$Widget$Events.PAUSE,
              FINISH = _SC$Widget$Events.FINISH,
              ERROR = _SC$Widget$Events.ERROR;

          if (!isReady) {
            _this2.player = SC.Widget(_this2.iframe);

            _this2.player.bind(PLAY, _this2.props.onPlay);

            _this2.player.bind(PAUSE, function () {
              var remaining = _this2.duration - _this2.currentTime;

              if (remaining < 0.05) {
                // Prevent onPause firing right before onEnded
                return;
              }

              _this2.props.onPause();
            });

            _this2.player.bind(PLAY_PROGRESS, function (e) {
              _this2.currentTime = e.currentPosition / 1000;
              _this2.fractionLoaded = e.loadedProgress;
            });

            _this2.player.bind(FINISH, function () {
              return _this2.props.onEnded();
            });

            _this2.player.bind(ERROR, function (e) {
              return _this2.props.onError(e);
            });
          }

          _this2.player.load(url, _objectSpread(_objectSpread({}, _this2.props.config.options), {}, {
            callback: function callback() {
              _this2.player.getDuration(function (duration) {
                _this2.duration = duration / 1000;

                _this2.props.onReady();
              });
            }
          }));
        });
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {// Nothing to do
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('seekTo', seconds * 1000);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction * 100);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return this.fractionLoaded * this.duration;
      }
    }, {
      key: "render",
      value: function render() {
        var display = this.props.display;
        var style = {
          width: '100%',
          height: '100%',
          display: display
        };
        return /*#__PURE__*/_react["default"].createElement("iframe", {
          ref: this.ref,
          src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
          style: style,
          frameBorder: 0,
          allow: "autoplay"
        });
      }
    }]);

    return SoundCloud;
  }(_react.Component);

  exports["default"] = SoundCloud;

  _defineProperty(SoundCloud, "displayName", 'SoundCloud');

  _defineProperty(SoundCloud, "canPlay", patterns.canPlay.soundcloud);

  _defineProperty(SoundCloud, "loopOnEnded", true);
});
var Vimeo_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://player.vimeo.com/api/player.js';
  var SDK_GLOBAL = 'Vimeo';

  var Vimeo = /*#__PURE__*/function (_Component) {
    _inherits(Vimeo, _Component);

    var _super = _createSuper(Vimeo);

    function Vimeo() {
      var _this;

      _classCallCheck(this, Vimeo);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "duration", null);

      _defineProperty(_assertThisInitialized(_this), "currentTime", null);

      _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.setVolume(0);
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        if (_this.props.volume !== null) {
          _this.setVolume(_this.props.volume);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
        _this.container = container;
      });

      return _this;
    }

    _createClass(Vimeo, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        this.duration = null;
        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
          if (!_this2.container) return;
          var _this2$props$config = _this2.props.config,
              playerOptions = _this2$props$config.playerOptions,
              title = _this2$props$config.title;
          _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
            url: url,
            autoplay: _this2.props.playing,
            muted: _this2.props.muted,
            loop: _this2.props.loop,
            playsinline: _this2.props.playsinline,
            controls: _this2.props.controls
          }, playerOptions));

          _this2.player.ready().then(function () {
            var iframe = _this2.container.querySelector('iframe');

            iframe.style.width = '100%';
            iframe.style.height = '100%';

            if (title) {
              iframe.title = title;
            }
          })["catch"](_this2.props.onError);

          _this2.player.on('loaded', function () {
            _this2.props.onReady();

            _this2.refreshDuration();
          });

          _this2.player.on('play', function () {
            _this2.props.onPlay();

            _this2.refreshDuration();
          });

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seeked', function (e) {
            return _this2.props.onSeek(e.seconds);
          });

          _this2.player.on('ended', _this2.props.onEnded);

          _this2.player.on('error', _this2.props.onError);

          _this2.player.on('timeupdate', function (_ref) {
            var seconds = _ref.seconds;
            _this2.currentTime = seconds;
          });

          _this2.player.on('progress', function (_ref2) {
            var seconds = _ref2.seconds;
            _this2.secondsLoaded = seconds;
          });

          _this2.player.on('bufferstart', _this2.props.onBuffer);

          _this2.player.on('bufferend', _this2.props.onBufferEnd);

          _this2.player.on('playbackratechange', function (e) {
            return _this2.props.onPlaybackRateChange(e.playbackRate);
          });
        }, this.props.onError);
      }
    }, {
      key: "refreshDuration",
      value: function refreshDuration() {
        var _this3 = this;

        this.player.getDuration().then(function (duration) {
          _this3.duration = duration;
        });
      }
    }, {
      key: "play",
      value: function play() {
        var promise = this.callPlayer('play');

        if (promise) {
          promise["catch"](this.props.onError);
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {
        this.callPlayer('unload');
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('setCurrentTime', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        this.callPlayer('setLoop', loop);
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(rate) {
        this.callPlayer('setPlaybackRate', rate);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return this.secondsLoaded;
      }
    }, {
      key: "render",
      value: function render() {
        var display = this.props.display;
        var style = {
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          display: display
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: this.props.url,
          ref: this.ref,
          style: style
        });
      }
    }]);

    return Vimeo;
  }(_react.Component);

  exports["default"] = Vimeo;

  _defineProperty(Vimeo, "displayName", 'Vimeo');

  _defineProperty(Vimeo, "canPlay", patterns.canPlay.vimeo);

  _defineProperty(Vimeo, "forceLoad", true);
});
var Facebook_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
  var SDK_GLOBAL = 'FB';
  var SDK_GLOBAL_READY = 'fbAsyncInit';
  var PLAYER_ID_PREFIX = 'facebook-player-';

  var Facebook = /*#__PURE__*/function (_Component) {
    _inherits(Facebook, _Component);

    var _super = _createSuper(Facebook);

    function Facebook() {
      var _this;

      _classCallCheck(this, Facebook);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils$1.randomString)()));

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('mute');
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('unmute');
      });

      return _this;
    }

    _createClass(Facebook, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url, isReady) {
        var _this2 = this;

        if (isReady) {
          (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
            return FB.XFBML.parse();
          });
          return;
        }

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          FB.init({
            appId: _this2.props.config.appId,
            xfbml: true,
            version: _this2.props.config.version
          });
          FB.Event.subscribe('xfbml.render', function (msg) {
            // Here we know the SDK has loaded, even if onReady/onPlay
            // is not called due to a video that cannot be embedded
            _this2.props.onLoaded();
          });
          FB.Event.subscribe('xfbml.ready', function (msg) {
            if (msg.type === 'video' && msg.id === _this2.playerID) {
              _this2.player = msg.instance;

              _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

              _this2.player.subscribe('paused', _this2.props.onPause);

              _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

              _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

              _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

              _this2.player.subscribe('error', _this2.props.onError);

              if (_this2.props.muted) {
                _this2.callPlayer('mute');
              } else {
                _this2.callPlayer('unmute');
              }

              _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
              // to the iframe when autoplay fails, so here we set it back


              document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
            }
          });
        });
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {// Nothing to do
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('seek', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.callPlayer('getDuration');
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.callPlayer('getCurrentPosition');
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var attributes = this.props.config.attributes;
        var style = {
          width: '100%',
          height: '100%'
        };
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          style: style,
          id: this.playerID,
          className: "fb-video",
          "data-href": this.props.url,
          "data-autoplay": this.props.playing ? 'true' : 'false',
          "data-allowfullscreen": "true",
          "data-controls": this.props.controls ? 'true' : 'false'
        }, attributes));
      }
    }]);

    return Facebook;
  }(_react.Component);

  exports["default"] = Facebook;

  _defineProperty(Facebook, "displayName", 'Facebook');

  _defineProperty(Facebook, "canPlay", patterns.canPlay.facebook);

  _defineProperty(Facebook, "loopOnEnded", true);
});
var Streamable_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
  var SDK_GLOBAL = 'playerjs';

  var Streamable = /*#__PURE__*/function (_Component) {
    _inherits(Streamable, _Component);

    var _super = _createSuper(Streamable);

    function Streamable() {
      var _this;

      _classCallCheck(this, Streamable);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "duration", null);

      _defineProperty(_assertThisInitialized(_this), "currentTime", null);

      _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('mute');
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('unmute');
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
        _this.iframe = iframe;
      });

      return _this;
    }

    _createClass(Streamable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
          if (!_this2.iframe) return;
          _this2.player = new playerjs.Player(_this2.iframe);

          _this2.player.setLoop(_this2.props.loop);

          _this2.player.on('ready', _this2.props.onReady);

          _this2.player.on('play', _this2.props.onPlay);

          _this2.player.on('pause', _this2.props.onPause);

          _this2.player.on('seeked', _this2.props.onSeek);

          _this2.player.on('ended', _this2.props.onEnded);

          _this2.player.on('error', _this2.props.onError);

          _this2.player.on('timeupdate', function (_ref) {
            var duration = _ref.duration,
                seconds = _ref.seconds;
            _this2.duration = duration;
            _this2.currentTime = seconds;
          });

          _this2.player.on('buffered', function (_ref2) {
            var percent = _ref2.percent;

            if (_this2.duration) {
              _this2.secondsLoaded = _this2.duration * percent;
            }
          });

          if (_this2.props.muted) {
            _this2.player.mute();
          }
        }, this.props.onError);
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {// Nothing to do
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('setCurrentTime', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction * 100);
      }
    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        this.callPlayer('setLoop', loop);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return this.secondsLoaded;
      }
    }, {
      key: "render",
      value: function render() {
        var id = this.props.url.match(patterns.MATCH_URL_STREAMABLE)[1];
        var style = {
          width: '100%',
          height: '100%'
        };
        return /*#__PURE__*/_react["default"].createElement("iframe", {
          ref: this.ref,
          src: "https://streamable.com/o/".concat(id),
          frameBorder: "0",
          scrolling: "no",
          style: style,
          allow: "encrypted-media; autoplay; fullscreen;"
        });
      }
    }]);

    return Streamable;
  }(_react.Component);

  exports["default"] = Streamable;

  _defineProperty(Streamable, "displayName", 'Streamable');

  _defineProperty(Streamable, "canPlay", patterns.canPlay.streamable);
});
var Wistia_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
  var SDK_GLOBAL = 'Wistia';
  var PLAYER_ID_PREFIX = 'wistia-player-';

  var Wistia = /*#__PURE__*/function (_Component) {
    _inherits(Wistia, _Component);

    var _super = _createSuper(Wistia);

    function Wistia() {
      var _this;

      _classCallCheck(this, Wistia);

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(_args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils$1.randomString)()));

      _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
        var _this$props;

        return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onPause", function () {
        var _this$props2;

        return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
        var _this$props3;

        return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
        var _this$props4;

        return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onPlaybackRateChange", function () {
        var _this$props5;

        return (_this$props5 = _this.props).onPlaybackRateChange.apply(_this$props5, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('mute');
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('unmute');
      });

      return _this;
    }

    _createClass(Wistia, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        var _this$props6 = this.props,
            playing = _this$props6.playing,
            muted = _this$props6.muted,
            controls = _this$props6.controls,
            _onReady = _this$props6.onReady,
            config = _this$props6.config,
            onError = _this$props6.onError;
        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Wistia) {
          if (config.customControls) {
            config.customControls.forEach(function (control) {
              return Wistia.defineControl(control);
            });
          }

          window._wq = window._wq || [];

          window._wq.push({
            id: _this2.playerID,
            options: _objectSpread({
              autoPlay: playing,
              silentAutoPlay: 'allow',
              muted: muted,
              controlsVisibleOnLoad: controls,
              fullscreenButton: controls,
              playbar: controls,
              playbackRateControl: controls,
              qualityControl: controls,
              volumeControl: controls,
              settingsControl: controls,
              smallPlayButton: controls
            }, config.options),
            onReady: function onReady(player) {
              _this2.player = player;

              _this2.unbind();

              _this2.player.bind('play', _this2.onPlay);

              _this2.player.bind('pause', _this2.onPause);

              _this2.player.bind('seek', _this2.onSeek);

              _this2.player.bind('end', _this2.onEnded);

              _this2.player.bind('playbackratechange', _this2.onPlaybackRateChange);

              _onReady();
            }
          });
        }, onError);
      }
    }, {
      key: "unbind",
      value: function unbind() {
        this.player.unbind('play', this.onPlay);
        this.player.unbind('pause', this.onPause);
        this.player.unbind('seek', this.onSeek);
        this.player.unbind('end', this.onEnded);
        this.player.unbind('playbackratechange', this.onPlaybackRateChange);
      } // Proxy methods to prevent listener leaks

    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {
        this.unbind();
        this.callPlayer('remove');
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('time', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('volume', fraction);
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(rate) {
        this.callPlayer('playbackRate', rate);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.callPlayer('duration');
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.callPlayer('time');
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var url = this.props.url;
        var videoID = url && url.match(patterns.MATCH_URL_WISTIA)[1];
        var className = "wistia_embed wistia_async_".concat(videoID);
        var style = {
          width: '100%',
          height: '100%'
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: this.playerID,
          key: videoID,
          className: className,
          style: style
        });
      }
    }]);

    return Wistia;
  }(_react.Component);

  exports["default"] = Wistia;

  _defineProperty(Wistia, "displayName", 'Wistia');

  _defineProperty(Wistia, "canPlay", patterns.canPlay.wistia);

  _defineProperty(Wistia, "loopOnEnded", true);
});
var Twitch_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
  var SDK_GLOBAL = 'Twitch';
  var PLAYER_ID_PREFIX = 'twitch-player-';

  var Twitch = /*#__PURE__*/function (_Component) {
    _inherits(Twitch, _Component);

    var _super = _createSuper(Twitch);

    function Twitch() {
      var _this;

      _classCallCheck(this, Twitch);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, utils$1.randomString)()));

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('setMuted', true);
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('setMuted', false);
      });

      return _this;
    }

    _createClass(Twitch, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url, isReady) {
        var _this2 = this;

        var _this$props = this.props,
            playsinline = _this$props.playsinline,
            onError = _this$props.onError,
            config = _this$props.config,
            controls = _this$props.controls;
        var isChannel = patterns.MATCH_URL_TWITCH_CHANNEL.test(url);
        var id = isChannel ? url.match(patterns.MATCH_URL_TWITCH_CHANNEL)[1] : url.match(patterns.MATCH_URL_TWITCH_VIDEO)[1];

        if (isReady) {
          if (isChannel) {
            this.player.setChannel(id);
          } else {
            this.player.setVideo('v' + id);
          }

          return;
        }

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
          _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
            video: isChannel ? '' : id,
            channel: isChannel ? id : '',
            height: '100%',
            width: '100%',
            playsinline: playsinline,
            autoplay: _this2.props.playing,
            muted: _this2.props.muted,
            // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
            controls: isChannel ? true : controls,
            time: (0, utils$1.parseStartTime)(url)
          }, config.options));
          var _Twitch$Player = Twitch.Player,
              READY = _Twitch$Player.READY,
              PLAYING = _Twitch$Player.PLAYING,
              PAUSE = _Twitch$Player.PAUSE,
              ENDED = _Twitch$Player.ENDED,
              ONLINE = _Twitch$Player.ONLINE,
              OFFLINE = _Twitch$Player.OFFLINE,
              SEEK = _Twitch$Player.SEEK;

          _this2.player.addEventListener(READY, _this2.props.onReady);

          _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

          _this2.player.addEventListener(PAUSE, _this2.props.onPause);

          _this2.player.addEventListener(ENDED, _this2.props.onEnded);

          _this2.player.addEventListener(SEEK, _this2.props.onSeek); // Prevent weird isLoading behaviour when streams are offline


          _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

          _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
        }, onError);
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {
        this.callPlayer('pause');
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('seek', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.callPlayer('getDuration');
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.callPlayer('getCurrentTime');
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var style = {
          width: '100%',
          height: '100%'
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: style,
          id: this.playerID
        });
      }
    }]);

    return Twitch;
  }(_react.Component);

  exports["default"] = Twitch;

  _defineProperty(Twitch, "displayName", 'Twitch');

  _defineProperty(Twitch, "canPlay", patterns.canPlay.twitch);

  _defineProperty(Twitch, "loopOnEnded", true);
});
var DailyMotion_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://api.dmcdn.net/all.js';
  var SDK_GLOBAL = 'DM';
  var SDK_GLOBAL_READY = 'dmAsyncInit';

  var DailyMotion = /*#__PURE__*/function (_Component) {
    _inherits(DailyMotion, _Component);

    var _super = _createSuper(DailyMotion);

    function DailyMotion() {
      var _this;

      _classCallCheck(this, DailyMotion);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
        var duration = _this.getDuration();

        _this.props.onDuration(duration);
      });

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('setMuted', true);
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('setMuted', false);
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
        _this.container = container;
      });

      return _this;
    }

    _createClass(DailyMotion, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        var _this$props = this.props,
            controls = _this$props.controls,
            config = _this$props.config,
            onError = _this$props.onError,
            playing = _this$props.playing;

        var _url$match = url.match(patterns.MATCH_URL_DAILYMOTION),
            _url$match2 = _slicedToArray(_url$match, 2),
            id = _url$match2[1];

        if (this.player) {
          this.player.load(id, {
            start: (0, utils$1.parseStartTime)(url),
            autoplay: playing
          });
          return;
        }

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
          return DM.player;
        }).then(function (DM) {
          if (!_this2.container) return;
          var Player = DM.player;
          _this2.player = new Player(_this2.container, {
            width: '100%',
            height: '100%',
            video: id,
            params: _objectSpread({
              controls: controls,
              autoplay: _this2.props.playing,
              mute: _this2.props.muted,
              start: (0, utils$1.parseStartTime)(url),
              origin: window.location.origin
            }, config.params),
            events: {
              apiready: _this2.props.onReady,
              seeked: function seeked() {
                return _this2.props.onSeek(_this2.player.currentTime);
              },
              video_end: _this2.props.onEnded,
              durationchange: _this2.onDurationChange,
              pause: _this2.props.onPause,
              playing: _this2.props.onPlay,
              waiting: _this2.props.onBuffer,
              error: function error(event) {
                return onError(event);
              }
            }
          });
        }, onError);
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {// Nothing to do
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('seek', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.player.duration || null;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.player.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return this.player.bufferedTime;
      }
    }, {
      key: "render",
      value: function render() {
        var display = this.props.display;
        var style = {
          width: '100%',
          height: '100%',
          display: display
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.ref
        }));
      }
    }]);

    return DailyMotion;
  }(_react.Component);

  exports["default"] = DailyMotion;

  _defineProperty(DailyMotion, "displayName", 'DailyMotion');

  _defineProperty(DailyMotion, "canPlay", patterns.canPlay.dailymotion);

  _defineProperty(DailyMotion, "loopOnEnded", true);
});
var Mixcloud_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
  var SDK_GLOBAL = 'Mixcloud';

  var Mixcloud = /*#__PURE__*/function (_Component) {
    _inherits(Mixcloud, _Component);

    var _super = _createSuper(Mixcloud);

    function Mixcloud() {
      var _this;

      _classCallCheck(this, Mixcloud);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "duration", null);

      _defineProperty(_assertThisInitialized(_this), "currentTime", null);

      _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

      _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
        _this.iframe = iframe;
      });

      return _this;
    }

    _createClass(Mixcloud, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
          _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

          _this2.player.ready.then(function () {
            _this2.player.events.play.on(_this2.props.onPlay);

            _this2.player.events.pause.on(_this2.props.onPause);

            _this2.player.events.ended.on(_this2.props.onEnded);

            _this2.player.events.error.on(_this2.props.error);

            _this2.player.events.progress.on(function (seconds, duration) {
              _this2.currentTime = seconds;
              _this2.duration = duration;
            });

            _this2.props.onReady();
          });
        }, this.props.onError);
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {// Nothing to do
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('seek', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {// No volume support
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            url = _this$props.url,
            config = _this$props.config;
        var id = url.match(patterns.MATCH_URL_MIXCLOUD)[1];
        var style = {
          width: '100%',
          height: '100%'
        };
        var query = (0, utils$1.queryString)(_objectSpread(_objectSpread({}, config.options), {}, {
          feed: "/".concat(id, "/")
        })); // We have to give the iframe a key here to prevent a
        // weird dialog appearing when loading a new track

        return /*#__PURE__*/_react["default"].createElement("iframe", {
          key: id,
          ref: this.ref,
          style: style,
          src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
          frameBorder: "0",
          allow: "autoplay"
        });
      }
    }]);

    return Mixcloud;
  }(_react.Component);

  exports["default"] = Mixcloud;

  _defineProperty(Mixcloud, "displayName", 'Mixcloud');

  _defineProperty(Mixcloud, "canPlay", patterns.canPlay.mixcloud);

  _defineProperty(Mixcloud, "loopOnEnded", true);
});
var Vidyard_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://play.vidyard.com/embed/v4.js';
  var SDK_GLOBAL = 'VidyardV4';
  var SDK_GLOBAL_READY = 'onVidyardAPI';

  var Vidyard = /*#__PURE__*/function (_Component) {
    _inherits(Vidyard, _Component);

    var _super = _createSuper(Vidyard);

    function Vidyard() {
      var _this;

      _classCallCheck(this, Vidyard);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.setVolume(0);
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        if (_this.props.volume !== null) {
          _this.setVolume(_this.props.volume);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
        _this.container = container;
      });

      return _this;
    }

    _createClass(Vidyard, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        var _this$props = this.props,
            playing = _this$props.playing,
            config = _this$props.config,
            onError = _this$props.onError,
            onDuration = _this$props.onDuration;
        var id = url && url.match(patterns.MATCH_URL_VIDYARD)[1];

        if (this.player) {
          this.stop();
        }

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (Vidyard) {
          if (!_this2.container) return;
          Vidyard.api.addReadyListener(function (data, player) {
            if (_this2.player) {
              return;
            }

            _this2.player = player;

            _this2.player.on('ready', _this2.props.onReady);

            _this2.player.on('play', _this2.props.onPlay);

            _this2.player.on('pause', _this2.props.onPause);

            _this2.player.on('seek', _this2.props.onSeek);

            _this2.player.on('playerComplete', _this2.props.onEnded);
          }, id);
          Vidyard.api.renderPlayer(_objectSpread({
            uuid: id,
            container: _this2.container,
            autoplay: playing ? 1 : 0
          }, config.options));
          Vidyard.api.getPlayerMetadata(id).then(function (meta) {
            _this2.duration = meta.length_in_seconds;
            onDuration(meta.length_in_seconds);
          });
        }, onError);
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {
        window.VidyardV4.api.destroyPlayer(this.player);
      }
    }, {
      key: "seekTo",
      value: function seekTo(amount) {
        this.callPlayer('seek', amount);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(rate) {
        this.callPlayer('setPlaybackSpeed', rate);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.callPlayer('currentTime');
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var display = this.props.display;
        var style = {
          width: '100%',
          height: '100%',
          display: display
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: style
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: this.ref
        }));
      }
    }]);

    return Vidyard;
  }(_react.Component);

  exports["default"] = Vidyard;

  _defineProperty(Vidyard, "displayName", 'Vidyard');

  _defineProperty(Vidyard, "canPlay", patterns.canPlay.vidyard);
});
var Kaltura_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
  var SDK_GLOBAL = 'playerjs';

  var Kaltura = /*#__PURE__*/function (_Component) {
    _inherits(Kaltura, _Component);

    var _super = _createSuper(Kaltura);

    function Kaltura() {
      var _this;

      _classCallCheck(this, Kaltura);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "callPlayer", utils$1.callPlayer);

      _defineProperty(_assertThisInitialized(_this), "duration", null);

      _defineProperty(_assertThisInitialized(_this), "currentTime", null);

      _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.callPlayer('mute');
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.callPlayer('unmute');
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
        _this.iframe = iframe;
      });

      return _this;
    }

    _createClass(Kaltura, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        (0, utils$1.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
          if (!_this2.iframe) return;
          _this2.player = new playerjs.Player(_this2.iframe);

          _this2.player.on('ready', function () {
            // An arbitrary timeout is required otherwise
            // the event listeners won’t work
            setTimeout(function () {
              _this2.player.isReady = true;

              _this2.player.setLoop(_this2.props.loop);

              if (_this2.props.muted) {
                _this2.player.mute();
              }

              _this2.addListeners(_this2.player, _this2.props);

              _this2.props.onReady();
            }, 500);
          });
        }, this.props.onError);
      }
    }, {
      key: "addListeners",
      value: function addListeners(player, props) {
        var _this3 = this;

        player.on('play', props.onPlay);
        player.on('pause', props.onPause);
        player.on('ended', props.onEnded);
        player.on('error', props.onError);
        player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this3.duration = duration;
          _this3.currentTime = seconds;
        });
      }
    }, {
      key: "play",
      value: function play() {
        this.callPlayer('play');
      }
    }, {
      key: "pause",
      value: function pause() {
        this.callPlayer('pause');
      }
    }, {
      key: "stop",
      value: function stop() {// Nothing to do
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.callPlayer('setCurrentTime', seconds);
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.callPlayer('setVolume', fraction);
      }
    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        this.callPlayer('setLoop', loop);
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        return this.secondsLoaded;
      }
    }, {
      key: "render",
      value: function render() {
        var style = {
          width: '100%',
          height: '100%'
        };
        return /*#__PURE__*/_react["default"].createElement("iframe", {
          ref: this.ref,
          src: this.props.url,
          frameBorder: "0",
          scrolling: "no",
          style: style,
          allow: "encrypted-media; autoplay; fullscreen;",
          referrerPolicy: "no-referrer-when-downgrade"
        });
      }
    }]);

    return Kaltura;
  }(_react.Component);

  exports["default"] = Kaltura;

  _defineProperty(Kaltura, "displayName", 'Kaltura');

  _defineProperty(Kaltura, "canPlay", patterns.canPlay.kaltura);
});
var FilePlayer_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var HAS_NAVIGATOR = typeof navigator !== 'undefined';
  var IS_IPAD_PRO = HAS_NAVIGATOR && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  var IS_IOS = HAS_NAVIGATOR && (/iPad|iPhone|iPod/.test(navigator.userAgent) || IS_IPAD_PRO) && !window.MSStream;
  var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
  var HLS_GLOBAL = 'Hls';
  var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
  var DASH_GLOBAL = 'dashjs';
  var FLV_SDK_URL = 'https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js';
  var FLV_GLOBAL = 'flvjs';
  var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;
  var MATCH_CLOUDFLARE_STREAM = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/;
  var REPLACE_CLOUDFLARE_STREAM = 'https://videodelivery.net/{id}/manifest/video.m3u8';

  var FilePlayer = /*#__PURE__*/function (_Component) {
    _inherits(FilePlayer, _Component);

    var _super = _createSuper(FilePlayer);

    function FilePlayer() {
      var _this;

      _classCallCheck(this, FilePlayer);

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(_args));

      _defineProperty(_assertThisInitialized(_this), "onReady", function () {
        var _this$props;

        return (_this$props = _this.props).onReady.apply(_this$props, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
        var _this$props2;

        return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
        var _this$props3;

        return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
        var _this$props4;

        return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onPause", function () {
        var _this$props5;

        return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
        var _this$props6;

        return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onError", function () {
        var _this$props7;

        return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onPlayBackRateChange", function (event) {
        return _this.props.onPlaybackRateChange(event.target.playbackRate);
      });

      _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
        var _this$props8;

        return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
        var _this$props9 = _this.props,
            onDisablePIP = _this$props9.onDisablePIP,
            playing = _this$props9.playing;
        onDisablePIP(e);

        if (playing) {
          _this.play();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
        if (_this.player && (0, utils$1.supportsWebKitPresentationMode)(_this.player)) {
          var webkitPresentationMode = _this.player.webkitPresentationMode;

          if (webkitPresentationMode === 'picture-in-picture') {
            _this.onEnablePIP(e);
          } else if (webkitPresentationMode === 'inline') {
            _this.onDisablePIP(e);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
        _this.props.onSeek(e.target.currentTime);
      });

      _defineProperty(_assertThisInitialized(_this), "mute", function () {
        _this.player.muted = true;
      });

      _defineProperty(_assertThisInitialized(_this), "unmute", function () {
        _this.player.muted = false;
      });

      _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
        if (typeof source === 'string') {
          return /*#__PURE__*/_react["default"].createElement("source", {
            key: index,
            src: source
          });
        }

        return /*#__PURE__*/_react["default"].createElement("source", _extends({
          key: index
        }, source));
      });

      _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
        return /*#__PURE__*/_react["default"].createElement("track", _extends({
          key: index
        }, track));
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
        if (_this.player) {
          // Store previous player to be used by removeListeners()
          _this.prevPlayer = _this.player;
        }

        _this.player = player;
      });

      return _this;
    }

    _createClass(FilePlayer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.onMount && this.props.onMount(this);
        this.addListeners(this.player);

        if (IS_IOS) {
          this.player.load();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
          this.removeListeners(this.prevPlayer, prevProps.url);
          this.addListeners(this.player);
        }

        if (this.props.url !== prevProps.url && !(0, utils$1.isMediaStream)(this.props.url)) {
          this.player.srcObject = null;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.player.src = '';
        this.removeListeners(this.player);

        if (this.hls) {
          this.hls.destroy();
        }
      }
    }, {
      key: "addListeners",
      value: function addListeners(player) {
        var _this$props10 = this.props,
            url = _this$props10.url,
            playsinline = _this$props10.playsinline;
        player.addEventListener('play', this.onPlay);
        player.addEventListener('waiting', this.onBuffer);
        player.addEventListener('playing', this.onBufferEnd);
        player.addEventListener('pause', this.onPause);
        player.addEventListener('seeked', this.onSeek);
        player.addEventListener('ended', this.onEnded);
        player.addEventListener('error', this.onError);
        player.addEventListener('ratechange', this.onPlayBackRateChange);
        player.addEventListener('enterpictureinpicture', this.onEnablePIP);
        player.addEventListener('leavepictureinpicture', this.onDisablePIP);
        player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

        if (!this.shouldUseHLS(url)) {
          // onReady is handled by hls.js
          player.addEventListener('canplay', this.onReady);
        }

        if (playsinline) {
          player.setAttribute('playsinline', '');
          player.setAttribute('webkit-playsinline', '');
          player.setAttribute('x5-playsinline', '');
        }
      }
    }, {
      key: "removeListeners",
      value: function removeListeners(player, url) {
        player.removeEventListener('canplay', this.onReady);
        player.removeEventListener('play', this.onPlay);
        player.removeEventListener('waiting', this.onBuffer);
        player.removeEventListener('playing', this.onBufferEnd);
        player.removeEventListener('pause', this.onPause);
        player.removeEventListener('seeked', this.onSeek);
        player.removeEventListener('ended', this.onEnded);
        player.removeEventListener('error', this.onError);
        player.removeEventListener('ratechange', this.onPlayBackRateChange);
        player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
        player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
        player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

        if (!this.shouldUseHLS(url)) {
          // onReady is handled by hls.js
          player.removeEventListener('canplay', this.onReady);
        }
      } // Proxy methods to prevent listener leaks

    }, {
      key: "shouldUseAudio",
      value: function shouldUseAudio(props) {
        if (props.config.forceVideo) {
          return false;
        }

        if (props.config.attributes.poster) {
          return false; // Use <video> so that poster is shown
        }

        return patterns.AUDIO_EXTENSIONS.test(props.url) || props.config.forceAudio;
      }
    }, {
      key: "shouldUseHLS",
      value: function shouldUseHLS(url) {
        if (this.props.config.forceHLS) {
          return true;
        }

        if (IS_IOS) {
          return false;
        }

        return patterns.HLS_EXTENSIONS.test(url) || MATCH_CLOUDFLARE_STREAM.test(url);
      }
    }, {
      key: "shouldUseDASH",
      value: function shouldUseDASH(url) {
        return patterns.DASH_EXTENSIONS.test(url) || this.props.config.forceDASH;
      }
    }, {
      key: "shouldUseFLV",
      value: function shouldUseFLV(url) {
        return patterns.FLV_EXTENSIONS.test(url) || this.props.config.forceFLV;
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this2 = this;

        var _this$props$config = this.props.config,
            hlsVersion = _this$props$config.hlsVersion,
            hlsOptions = _this$props$config.hlsOptions,
            dashVersion = _this$props$config.dashVersion,
            flvVersion = _this$props$config.flvVersion;

        if (this.hls) {
          this.hls.destroy();
        }

        if (this.dash) {
          this.dash.reset();
        }

        if (this.shouldUseHLS(url)) {
          (0, utils$1.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
            _this2.hls = new Hls(hlsOptions);

            _this2.hls.on(Hls.Events.MANIFEST_PARSED, function () {
              _this2.props.onReady();
            });

            _this2.hls.on(Hls.Events.ERROR, function (e, data) {
              _this2.props.onError(e, data, _this2.hls, Hls);
            });

            if (MATCH_CLOUDFLARE_STREAM.test(url)) {
              var id = url.match(MATCH_CLOUDFLARE_STREAM)[1];

              _this2.hls.loadSource(REPLACE_CLOUDFLARE_STREAM.replace('{id}', id));
            } else {
              _this2.hls.loadSource(url);
            }

            _this2.hls.attachMedia(_this2.player);

            _this2.props.onLoaded();
          });
        }

        if (this.shouldUseDASH(url)) {
          (0, utils$1.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
            _this2.dash = dashjs.MediaPlayer().create();

            _this2.dash.initialize(_this2.player, url, _this2.props.playing);

            _this2.dash.on('error', _this2.props.onError);

            if (parseInt(dashVersion) < 3) {
              _this2.dash.getDebug().setLogToBrowserConsole(false);
            } else {
              _this2.dash.updateSettings({
                debug: {
                  logLevel: dashjs.Debug.LOG_LEVEL_NONE
                }
              });
            }

            _this2.props.onLoaded();
          });
        }

        if (this.shouldUseFLV(url)) {
          (0, utils$1.getSDK)(FLV_SDK_URL.replace('VERSION', flvVersion), FLV_GLOBAL).then(function (flvjs) {
            _this2.flv = flvjs.createPlayer({
              type: 'flv',
              url: url
            });

            _this2.flv.attachMediaElement(_this2.player);

            _this2.flv.on(flvjs.Events.ERROR, function (e, data) {
              _this2.props.onError(e, data, _this2.flv, flvjs);
            });

            _this2.flv.load();

            _this2.props.onLoaded();
          });
        }

        if (url instanceof Array) {
          // When setting new urls (<source>) on an already loaded video,
          // HTMLMediaElement.load() is needed to reset the media element
          // and restart the media resource. Just replacing children source
          // dom nodes is not enough
          this.player.load();
        } else if ((0, utils$1.isMediaStream)(url)) {
          try {
            this.player.srcObject = url;
          } catch (e) {
            this.player.src = window.URL.createObjectURL(url);
          }
        }
      }
    }, {
      key: "play",
      value: function play() {
        var promise = this.player.play();

        if (promise) {
          promise["catch"](this.props.onError);
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        this.player.pause();
      }
    }, {
      key: "stop",
      value: function stop() {
        this.player.removeAttribute('src');

        if (this.dash) {
          this.dash.reset();
        }
      }
    }, {
      key: "seekTo",
      value: function seekTo(seconds) {
        this.player.currentTime = seconds;
      }
    }, {
      key: "setVolume",
      value: function setVolume(fraction) {
        this.player.volume = fraction;
      }
    }, {
      key: "enablePIP",
      value: function enablePIP() {
        if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
          this.player.requestPictureInPicture();
        } else if ((0, utils$1.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
          this.player.webkitSetPresentationMode('picture-in-picture');
        }
      }
    }, {
      key: "disablePIP",
      value: function disablePIP() {
        if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
          document.exitPictureInPicture();
        } else if ((0, utils$1.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== 'inline') {
          this.player.webkitSetPresentationMode('inline');
        }
      }
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(rate) {
        try {
          this.player.playbackRate = rate;
        } catch (error) {
          this.props.onError(error);
        }
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        if (!this.player) return null;
        var _this$player = this.player,
            duration = _this$player.duration,
            seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
        // so instead we use the end of the seekable timerange

        if (duration === Infinity && seekable.length > 0) {
          return seekable.end(seekable.length - 1);
        }

        return duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        if (!this.player) return null;
        return this.player.currentTime;
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        if (!this.player) return null;
        var buffered = this.player.buffered;

        if (buffered.length === 0) {
          return 0;
        }

        var end = buffered.end(buffered.length - 1);
        var duration = this.getDuration();

        if (end > duration) {
          return duration;
        }

        return end;
      }
    }, {
      key: "getSource",
      value: function getSource(url) {
        var useHLS = this.shouldUseHLS(url);
        var useDASH = this.shouldUseDASH(url);
        var useFLV = this.shouldUseFLV(url);

        if (url instanceof Array || (0, utils$1.isMediaStream)(url) || useHLS || useDASH || useFLV) {
          return undefined;
        }

        if (MATCH_DROPBOX_URL.test(url)) {
          return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
        }

        return url;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props11 = this.props,
            url = _this$props11.url,
            playing = _this$props11.playing,
            loop = _this$props11.loop,
            controls = _this$props11.controls,
            muted = _this$props11.muted,
            config = _this$props11.config,
            width = _this$props11.width,
            height = _this$props11.height;
        var useAudio = this.shouldUseAudio(this.props);
        var Element = useAudio ? 'audio' : 'video';
        var style = {
          width: width === 'auto' ? width : '100%',
          height: height === 'auto' ? height : '100%'
        };
        return /*#__PURE__*/_react["default"].createElement(Element, _extends({
          ref: this.ref,
          src: this.getSource(url),
          style: style,
          preload: "auto",
          autoPlay: playing || undefined,
          controls: controls,
          muted: muted,
          loop: loop
        }, config.attributes), url instanceof Array && url.map(this.renderSourceElement), config.tracks.map(this.renderTrack));
      }
    }]);

    return FilePlayer;
  }(_react.Component);

  exports["default"] = FilePlayer;

  _defineProperty(FilePlayer, "displayName", 'FilePlayer');

  _defineProperty(FilePlayer, "canPlay", patterns.canPlay.file);
});
var players = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  var _default = [{
    key: 'youtube',
    name: 'YouTube',
    canPlay: patterns.canPlay.youtube,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(YouTube_1);
      });
    })
  }, {
    key: 'soundcloud',
    name: 'SoundCloud',
    canPlay: patterns.canPlay.soundcloud,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(SoundCloud_1);
      });
    })
  }, {
    key: 'vimeo',
    name: 'Vimeo',
    canPlay: patterns.canPlay.vimeo,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Vimeo_1);
      });
    })
  }, {
    key: 'facebook',
    name: 'Facebook',
    canPlay: patterns.canPlay.facebook,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Facebook_1);
      });
    })
  }, {
    key: 'streamable',
    name: 'Streamable',
    canPlay: patterns.canPlay.streamable,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Streamable_1);
      });
    })
  }, {
    key: 'wistia',
    name: 'Wistia',
    canPlay: patterns.canPlay.wistia,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Wistia_1);
      });
    })
  }, {
    key: 'twitch',
    name: 'Twitch',
    canPlay: patterns.canPlay.twitch,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Twitch_1);
      });
    })
  }, {
    key: 'dailymotion',
    name: 'DailyMotion',
    canPlay: patterns.canPlay.dailymotion,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(DailyMotion_1);
      });
    })
  }, {
    key: 'mixcloud',
    name: 'Mixcloud',
    canPlay: patterns.canPlay.mixcloud,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Mixcloud_1);
      });
    })
  }, {
    key: 'vidyard',
    name: 'Vidyard',
    canPlay: patterns.canPlay.vidyard,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Vidyard_1);
      });
    })
  }, {
    key: 'kaltura',
    name: 'Kaltura',
    canPlay: patterns.canPlay.kaltura,
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(Kaltura_1);
      });
    })
  }, {
    key: 'file',
    name: 'FilePlayer',
    canPlay: patterns.canPlay.file,
    canEnablePIP: function canEnablePIP(url) {
      return patterns.canPlay.file(url) && (document.pictureInPictureEnabled || (0, utils$1.supportsWebKitPresentationMode)()) && !patterns.AUDIO_EXTENSIONS.test(url);
    },
    lazyPlayer: /*#__PURE__*/(0, React__default$1["default"].lazy)(function () {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(FilePlayer_1);
      });
    })
  }];
  exports["default"] = _default;
});

var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === 'number' && value !== value;
};

function isEqual(first, second) {
  if (first === second) {
    return true;
  }

  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }

  return false;
}

function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    var newArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

var memoizeOne_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': memoizeOne
});
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType$1 = typeof Element !== 'undefined';
var hasMap$1 = typeof Map === 'function';
var hasSet$1 = typeof Set === 'function';
var hasArrayBuffer$1 = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView; // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal$1(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal$1(a[i], b[i])) return false;
      }

      return true;
    } // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.


    var it;

    if (hasMap$1 && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal$1(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (hasSet$1 && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    } // END: Modifications


    if (hasArrayBuffer$1 && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    } // END: fast-deep-equal
    // START: react-fast-compare
    // custom handling for DOM elements


    if (hasElementType$1 && a instanceof Element) return false; // custom handling for React/Preact

    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements
        continue;
      } // all other properties should be traversed as usual


      if (!equal$1(a[keys[i]], b[keys[i]])) return false;
    } // END: react-fast-compare
    // START: fast-deep-equal


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


var reactFastCompare$1 = function isEqual(a, b) {
  try {
    return equal$1(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
};

var props = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.defaultProps = exports.propTypes = void 0;

  var _propTypes = _interopRequireDefault(propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var string = _propTypes["default"].string,
      bool = _propTypes["default"].bool,
      number = _propTypes["default"].number,
      array = _propTypes["default"].array,
      oneOfType = _propTypes["default"].oneOfType,
      shape = _propTypes["default"].shape,
      object = _propTypes["default"].object,
      func = _propTypes["default"].func,
      node = _propTypes["default"].node;
  var propTypes$1 = {
    url: oneOfType([string, array, object]),
    playing: bool,
    loop: bool,
    controls: bool,
    volume: number,
    muted: bool,
    playbackRate: number,
    width: oneOfType([string, number]),
    height: oneOfType([string, number]),
    style: object,
    progressInterval: number,
    playsinline: bool,
    pip: bool,
    stopOnUnmount: bool,
    light: oneOfType([bool, string, object]),
    playIcon: node,
    previewTabIndex: number,
    fallback: node,
    oEmbedUrl: string,
    wrapper: oneOfType([string, func, shape({
      render: func.isRequired
    })]),
    config: shape({
      soundcloud: shape({
        options: object
      }),
      youtube: shape({
        playerVars: object,
        embedOptions: object,
        onUnstarted: func
      }),
      facebook: shape({
        appId: string,
        version: string,
        playerId: string,
        attributes: object
      }),
      dailymotion: shape({
        params: object
      }),
      vimeo: shape({
        playerOptions: object,
        title: string
      }),
      file: shape({
        attributes: object,
        tracks: array,
        forceVideo: bool,
        forceAudio: bool,
        forceHLS: bool,
        forceDASH: bool,
        forceFLV: bool,
        hlsOptions: object,
        hlsVersion: string,
        dashVersion: string,
        flvVersion: string
      }),
      wistia: shape({
        options: object,
        playerId: string,
        customControls: array
      }),
      mixcloud: shape({
        options: object
      }),
      twitch: shape({
        options: object,
        playerId: string
      }),
      vidyard: shape({
        options: object
      })
    }),
    onReady: func,
    onStart: func,
    onPlay: func,
    onPause: func,
    onBuffer: func,
    onBufferEnd: func,
    onEnded: func,
    onError: func,
    onDuration: func,
    onSeek: func,
    onPlaybackRateChange: func,
    onProgress: func,
    onClickPreview: func,
    onEnablePIP: func,
    onDisablePIP: func
  };
  exports.propTypes = propTypes$1;

  var noop = function noop() {};

  var defaultProps = {
    playing: false,
    loop: false,
    controls: false,
    volume: null,
    muted: false,
    playbackRate: 1,
    width: '640px',
    height: '360px',
    style: {},
    progressInterval: 1000,
    playsinline: false,
    pip: false,
    stopOnUnmount: true,
    light: false,
    fallback: null,
    wrapper: 'div',
    previewTabIndex: 0,
    oEmbedUrl: 'https://noembed.com/embed?url={url}',
    config: {
      soundcloud: {
        options: {
          visual: true,
          // Undocumented, but makes player fill container and look better
          buying: false,
          liking: false,
          download: false,
          sharing: false,
          show_comments: false,
          show_playcount: false
        }
      },
      youtube: {
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1
        },
        embedOptions: {},
        onUnstarted: noop
      },
      facebook: {
        appId: '1309697205772819',
        version: 'v3.3',
        playerId: null,
        attributes: {}
      },
      dailymotion: {
        params: {
          api: 1,
          'endscreen-enable': false
        }
      },
      vimeo: {
        playerOptions: {
          autopause: false,
          byline: false,
          portrait: false,
          title: false
        },
        title: null
      },
      file: {
        attributes: {},
        tracks: [],
        forceVideo: false,
        forceAudio: false,
        forceHLS: false,
        forceDASH: false,
        forceFLV: false,
        hlsOptions: {},
        hlsVersion: '1.1.4',
        dashVersion: '3.1.3',
        flvVersion: '1.5.0'
      },
      wistia: {
        options: {},
        playerId: null,
        customControls: null
      },
      mixcloud: {
        options: {
          hide_cover: 1
        }
      },
      twitch: {
        options: {},
        playerId: null
      },
      vidyard: {
        options: {}
      }
    },
    onReady: noop,
    onStart: noop,
    onPlay: noop,
    onPause: noop,
    onBuffer: noop,
    onBufferEnd: noop,
    onEnded: noop,
    onError: noop,
    onDuration: noop,
    onSeek: noop,
    onPlaybackRateChange: noop,
    onProgress: noop,
    onClickPreview: noop,
    onEnablePIP: noop,
    onDisablePIP: noop
  };
  exports.defaultProps = defaultProps;
});
var Player_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  var _reactFastCompare = _interopRequireDefault(reactFastCompare$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var SEEK_ON_PLAY_EXPIRY = 5000;

  var Player = /*#__PURE__*/function (_Component) {
    _inherits(Player, _Component);

    var _super = _createSuper(Player);

    function Player() {
      var _this;

      _classCallCheck(this, Player);

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(_args));

      _defineProperty(_assertThisInitialized(_this), "mounted", false);

      _defineProperty(_assertThisInitialized(_this), "isReady", false);

      _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

      _defineProperty(_assertThisInitialized(_this), "isLoading", true);

      _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

      _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

      _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

      _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

      _defineProperty(_assertThisInitialized(_this), "handlePlayerMount", function (player) {
        if (_this.player) {
          _this.progress(); // Ensure onProgress is still called in strict mode


          return; // Return here to prevent loading twice in strict mode
        }

        _this.player = player;

        _this.player.load(_this.props.url);

        _this.progress();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
        if (!_this.player) return null;
        return _this.player[key];
      });

      _defineProperty(_assertThisInitialized(_this), "progress", function () {
        if (_this.props.url && _this.player && _this.isReady) {
          var playedSeconds = _this.getCurrentTime() || 0;

          var loadedSeconds = _this.getSecondsLoaded();

          var duration = _this.getDuration();

          if (duration) {
            var progress = {
              playedSeconds: playedSeconds,
              played: playedSeconds / duration
            };

            if (loadedSeconds !== null) {
              progress.loadedSeconds = loadedSeconds;
              progress.loaded = loadedSeconds / duration;
            } // Only call onProgress if values have changed


            if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
              _this.props.onProgress(progress);
            }

            _this.prevPlayed = progress.playedSeconds;
            _this.prevLoaded = progress.loadedSeconds;
          }
        }

        _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
      });

      _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
        if (!_this.mounted) return;
        _this.isReady = true;
        _this.isLoading = false;
        var _this$props = _this.props,
            onReady = _this$props.onReady,
            playing = _this$props.playing,
            volume = _this$props.volume,
            muted = _this$props.muted;
        onReady();

        if (!muted && volume !== null) {
          _this.player.setVolume(volume);
        }

        if (_this.loadOnReady) {
          _this.player.load(_this.loadOnReady, true);

          _this.loadOnReady = null;
        } else if (playing) {
          _this.player.play();
        }

        _this.handleDurationCheck();
      });

      _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
        _this.isPlaying = true;
        _this.isLoading = false;
        var _this$props2 = _this.props,
            onStart = _this$props2.onStart,
            onPlay = _this$props2.onPlay,
            playbackRate = _this$props2.playbackRate;

        if (_this.startOnPlay) {
          if (_this.player.setPlaybackRate && playbackRate !== 1) {
            _this.player.setPlaybackRate(playbackRate);
          }

          onStart();
          _this.startOnPlay = false;
        }

        onPlay();

        if (_this.seekOnPlay) {
          _this.seekTo(_this.seekOnPlay);

          _this.seekOnPlay = null;
        }

        _this.handleDurationCheck();
      });

      _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
        _this.isPlaying = false;

        if (!_this.isLoading) {
          _this.props.onPause(e);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
        var _this$props3 = _this.props,
            activePlayer = _this$props3.activePlayer,
            loop = _this$props3.loop,
            onEnded = _this$props3.onEnded;

        if (activePlayer.loopOnEnded && loop) {
          _this.seekTo(0);
        }

        if (!loop) {
          _this.isPlaying = false;
          onEnded();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleError", function () {
        var _this$props4;

        _this.isLoading = false;

        (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
      });

      _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
        clearTimeout(_this.durationCheckTimeout);

        var duration = _this.getDuration();

        if (duration) {
          if (!_this.onDurationCalled) {
            _this.props.onDuration(duration);

            _this.onDurationCalled = true;
          }
        } else {
          _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
        // Sometimes we know loading has stopped but onReady/onPlay are never called
        // so this provides a way for players to avoid getting stuck
        _this.isLoading = false;
      });

      return _this;
    }

    _createClass(Player, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearTimeout(this.progressTimeout);
        clearTimeout(this.durationCheckTimeout);

        if (this.isReady && this.props.stopOnUnmount) {
          this.player.stop();

          if (this.player.disablePIP) {
            this.player.disablePIP();
          }
        }

        this.mounted = false;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this; // If there isn’t a player available, don’t do anything


        if (!this.player) {
          return;
        } // Invoke player methods based on changed props


        var _this$props5 = this.props,
            url = _this$props5.url,
            playing = _this$props5.playing,
            volume = _this$props5.volume,
            muted = _this$props5.muted,
            playbackRate = _this$props5.playbackRate,
            pip = _this$props5.pip,
            loop = _this$props5.loop,
            activePlayer = _this$props5.activePlayer,
            disableDeferredLoading = _this$props5.disableDeferredLoading;

        if (!(0, _reactFastCompare["default"])(prevProps.url, url)) {
          if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, utils$1.isMediaStream)(url)) {
            console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
            this.loadOnReady = url;
            return;
          }

          this.isLoading = true;
          this.startOnPlay = true;
          this.onDurationCalled = false;
          this.player.load(url, this.isReady);
        }

        if (!prevProps.playing && playing && !this.isPlaying) {
          this.player.play();
        }

        if (prevProps.playing && !playing && this.isPlaying) {
          this.player.pause();
        }

        if (!prevProps.pip && pip && this.player.enablePIP) {
          this.player.enablePIP();
        }

        if (prevProps.pip && !pip && this.player.disablePIP) {
          this.player.disablePIP();
        }

        if (prevProps.volume !== volume && volume !== null) {
          this.player.setVolume(volume);
        }

        if (prevProps.muted !== muted) {
          if (muted) {
            this.player.mute();
          } else {
            this.player.unmute();

            if (volume !== null) {
              // Set volume next tick to fix a bug with DailyMotion
              setTimeout(function () {
                return _this2.player.setVolume(volume);
              });
            }
          }
        }

        if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
          this.player.setPlaybackRate(playbackRate);
        }

        if (prevProps.loop !== loop && this.player.setLoop) {
          this.player.setLoop(loop);
        }
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        if (!this.isReady) return null;
        return this.player.getDuration();
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        if (!this.isReady) return null;
        return this.player.getCurrentTime();
      }
    }, {
      key: "getSecondsLoaded",
      value: function getSecondsLoaded() {
        if (!this.isReady) return null;
        return this.player.getSecondsLoaded();
      }
    }, {
      key: "seekTo",
      value: function seekTo(amount, type) {
        var _this3 = this; // When seeking before player is ready, store value and seek later


        if (!this.isReady) {
          if (amount !== 0) {
            this.seekOnPlay = amount;
            setTimeout(function () {
              _this3.seekOnPlay = null;
            }, SEEK_ON_PLAY_EXPIRY);
          }

          return;
        }

        var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

        if (isFraction) {
          // Convert fraction to seconds based on duration
          var duration = this.player.getDuration();

          if (!duration) {
            console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
            return;
          }

          this.player.seekTo(duration * amount);
          return;
        }

        this.player.seekTo(amount);
      }
    }, {
      key: "render",
      value: function render() {
        var Player = this.props.activePlayer;

        if (!Player) {
          return null;
        }

        return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        }));
      }
    }]);

    return Player;
  }(_react.Component);

  exports["default"] = Player;

  _defineProperty(Player, "displayName", 'Player');

  _defineProperty(Player, "propTypes", props.propTypes);

  _defineProperty(Player, "defaultProps", props.defaultProps);
});
var Preview_1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var ICON_SIZE = '64px';
  var cache = {};

  var Preview = /*#__PURE__*/function (_Component) {
    _inherits(Preview, _Component);

    var _super = _createSuper(Preview);

    function Preview() {
      var _this;

      _classCallCheck(this, Preview);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "mounted", false);

      _defineProperty(_assertThisInitialized(_this), "state", {
        image: null
      });

      _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          _this.props.onClick();
        }
      });

      return _this;
    }

    _createClass(Preview, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
        this.fetchImage(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props = this.props,
            url = _this$props.url,
            light = _this$props.light;

        if (prevProps.url !== url || prevProps.light !== light) {
          this.fetchImage(this.props);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "fetchImage",
      value: function fetchImage(_ref) {
        var _this2 = this;

        var url = _ref.url,
            light = _ref.light,
            oEmbedUrl = _ref.oEmbedUrl;

        if ( /*#__PURE__*/_react["default"].isValidElement(light)) {
          return;
        }

        if (typeof light === 'string') {
          this.setState({
            image: light
          });
          return;
        }

        if (cache[url]) {
          this.setState({
            image: cache[url]
          });
          return;
        }

        this.setState({
          image: null
        });
        return window.fetch(oEmbedUrl.replace('{url}', url)).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data.thumbnail_url && _this2.mounted) {
            var image = data.thumbnail_url.replace('height=100', 'height=480');

            _this2.setState({
              image: image
            });

            cache[url] = image;
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            light = _this$props2.light,
            onClick = _this$props2.onClick,
            playIcon = _this$props2.playIcon,
            previewTabIndex = _this$props2.previewTabIndex;
        var image = this.state.image;

        var isElement = /*#__PURE__*/_react["default"].isValidElement(light);

        var flexCenter = {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        };
        var styles = {
          preview: _objectSpread({
            width: '100%',
            height: '100%',
            backgroundImage: image && !isElement ? "url(".concat(image, ")") : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            cursor: 'pointer'
          }, flexCenter),
          shadow: _objectSpread({
            background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
            borderRadius: ICON_SIZE,
            width: ICON_SIZE,
            height: ICON_SIZE,
            position: isElement ? 'absolute' : undefined
          }, flexCenter),
          playIcon: {
            borderStyle: 'solid',
            borderWidth: '16px 0 16px 26px',
            borderColor: 'transparent transparent transparent white',
            marginLeft: '7px'
          }
        };

        var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.shadow,
          className: "react-player__shadow"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.playIcon,
          className: "react-player__play-icon"
        }));

        return /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.preview,
          className: "react-player__preview",
          onClick: onClick,
          tabIndex: previewTabIndex,
          onKeyPress: this.handleKeyPress
        }, isElement ? light : null, playIcon || defaultPlayIcon);
      }
    }]);

    return Preview;
  }(_react.Component);

  exports["default"] = Preview;
});
var require$$2 = /*@__PURE__*/getAugmentedNamespace(memoizeOne_esm);
var ReactPlayer$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createReactPlayer = void 0;

  var _react = _interopRequireWildcard(React__default$1["default"]);

  var _deepmerge = _interopRequireDefault(cjs);

  var _memoizeOne = _interopRequireDefault(require$$2);

  var _reactFastCompare = _interopRequireDefault(reactFastCompare$1);

  var _Player3 = _interopRequireDefault(Player_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();

    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };

    return cache;
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }

    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }

    var cache = _getRequireWildcardCache();

    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }

    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }

    newObj["default"] = obj;

    if (cache) {
      cache.set(obj, newObj);
    }

    return newObj;
  }

  var Preview = /*#__PURE__*/(0, _react.lazy)(function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(Preview_1);
    });
  });
  var IS_BROWSER = typeof window !== 'undefined' && window.document;
  var IS_GLOBAL = typeof commonjsGlobal$1 !== 'undefined' && commonjsGlobal$1.window && commonjsGlobal$1.window.document;
  var SUPPORTED_PROPS = Object.keys(props.propTypes); // Return null when rendering on the server
  // as Suspense is not supported yet

  var UniversalSuspense = IS_BROWSER || IS_GLOBAL ? _react.Suspense : function () {
    return null;
  };
  var customPlayers = [];

  var createReactPlayer = function createReactPlayer(players, fallback) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      _inherits(ReactPlayer, _Component);

      var _super = _createSuper(ReactPlayer);

      function ReactPlayer() {
        var _this;

        _classCallCheck(this, ReactPlayer);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "state", {
          showPreview: !!_this.props.light
        });

        _defineProperty(_assertThisInitialized(_this), "references", {
          wrapper: function wrapper(_wrapper) {
            _this.wrapper = _wrapper;
          },
          player: function player(_player) {
            _this.player = _player;
          }
        });

        _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function (e) {
          _this.setState({
            showPreview: false
          });

          _this.props.onClickPreview(e);
        });

        _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
          _this.setState({
            showPreview: true
          });
        });

        _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
          if (!_this.player) return null;
          return _this.player.getDuration();
        });

        _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
          if (!_this.player) return null;
          return _this.player.getCurrentTime();
        });

        _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
          if (!_this.player) return null;
          return _this.player.getSecondsLoaded();
        });

        _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
          var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
          if (!_this.player) return null;
          return _this.player.getInternalPlayer(key);
        });

        _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
          if (!_this.player) return null;

          _this.player.seekTo(fraction, type);
        });

        _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
          _this.props.onReady(_assertThisInitialized(_this));
        });

        _defineProperty(_assertThisInitialized(_this), "getActivePlayer", (0, _memoizeOne["default"])(function (url) {
          for (var _i = 0, _arr = [].concat(customPlayers, _toConsumableArray(players)); _i < _arr.length; _i++) {
            var player = _arr[_i];

            if (player.canPlay(url)) {
              return player;
            }
          }

          if (fallback) {
            return fallback;
          }

          return null;
        }));

        _defineProperty(_assertThisInitialized(_this), "getConfig", (0, _memoizeOne["default"])(function (url, key) {
          var config = _this.props.config;
          return _deepmerge["default"].all([props.defaultProps.config, props.defaultProps.config[key] || {}, config, config[key] || {}]);
        }));

        _defineProperty(_assertThisInitialized(_this), "getAttributes", (0, _memoizeOne["default"])(function (url) {
          return (0, utils$1.omit)(_this.props, SUPPORTED_PROPS);
        }));

        _defineProperty(_assertThisInitialized(_this), "renderActivePlayer", function (url) {
          if (!url) return null;

          var player = _this.getActivePlayer(url);

          if (!player) return null;

          var config = _this.getConfig(url, player.key);

          return /*#__PURE__*/_react["default"].createElement(_Player3["default"], _extends({}, _this.props, {
            key: player.key,
            ref: _this.references.player,
            config: config,
            activePlayer: player.lazyPlayer || player,
            onReady: _this.handleReady
          }));
        });

        return _this;
      }

      _createClass(ReactPlayer, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _reactFastCompare["default"])(this.props, nextProps) || !(0, _reactFastCompare["default"])(this.state, nextState);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var light = this.props.light;

          if (!prevProps.light && light) {
            this.setState({
              showPreview: true
            });
          }

          if (prevProps.light && !light) {
            this.setState({
              showPreview: false
            });
          }
        }
      }, {
        key: "renderPreview",
        value: function renderPreview(url) {
          if (!url) return null;
          var _this$props = this.props,
              light = _this$props.light,
              playIcon = _this$props.playIcon,
              previewTabIndex = _this$props.previewTabIndex,
              oEmbedUrl = _this$props.oEmbedUrl;
          return /*#__PURE__*/_react["default"].createElement(Preview, {
            url: url,
            light: light,
            playIcon: playIcon,
            previewTabIndex: previewTabIndex,
            oEmbedUrl: oEmbedUrl,
            onClick: this.handleClickPreview
          });
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
              url = _this$props2.url,
              style = _this$props2.style,
              width = _this$props2.width,
              height = _this$props2.height,
              fallback = _this$props2.fallback,
              Wrapper = _this$props2.wrapper;
          var showPreview = this.state.showPreview;
          var attributes = this.getAttributes(url);
          var wrapperRef = typeof Wrapper === 'string' ? this.references.wrapper : undefined;
          return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
            ref: wrapperRef,
            style: _objectSpread(_objectSpread({}, style), {}, {
              width: width,
              height: height
            })
          }, attributes), /*#__PURE__*/_react["default"].createElement(UniversalSuspense, {
            fallback: fallback
          }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
        }
      }]);

      return ReactPlayer;
    }(_react.Component), _defineProperty(_class, "displayName", 'ReactPlayer'), _defineProperty(_class, "propTypes", props.propTypes), _defineProperty(_class, "defaultProps", props.defaultProps), _defineProperty(_class, "addCustomPlayer", function (player) {
      customPlayers.push(player);
    }), _defineProperty(_class, "removeCustomPlayers", function () {
      customPlayers.length = 0;
    }), _defineProperty(_class, "canPlay", function (url) {
      for (var _i2 = 0, _arr2 = [].concat(customPlayers, _toConsumableArray(players)); _i2 < _arr2.length; _i2++) {
        var _Player = _arr2[_i2];

        if (_Player.canPlay(url)) {
          return true;
        }
      }

      return false;
    }), _defineProperty(_class, "canEnablePIP", function (url) {
      for (var _i3 = 0, _arr3 = [].concat(customPlayers, _toConsumableArray(players)); _i3 < _arr3.length; _i3++) {
        var _Player2 = _arr3[_i3];

        if (_Player2.canEnablePIP && _Player2.canEnablePIP(url)) {
          return true;
        }
      }

      return false;
    }), _temp;
  };

  exports.createReactPlayer = createReactPlayer;
});
var lib$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;

  var _players = _interopRequireDefault(players);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  } // Fall back to FilePlayer if nothing else can play the URL


  var fallback = _players["default"][_players["default"].length - 1];

  var _default = (0, ReactPlayer$1.createReactPlayer)(_players["default"], fallback);

  exports["default"] = _default;
});
var ReactPlayer = /*@__PURE__*/getDefaultExportFromCjs(lib$1);

var _templateObject$1a, _templateObject2$j, _templateObject3$d, _templateObject4$9;

var SimpleVideoContainer$1 = styled__default["default"].div(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr auto;\n"])));
var SimpleVideoMediaContainer = styled__default["default"].div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n"])));
var SimpleVideoTitleContainer$1 = styled__default["default"].div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var SimpleVideoTitle$1 = styled__default["default"].h6(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  color: var(--grayscale-100-color);\n  font-family: var(--primary-family);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n"])));

function SimpleVideo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$videoUrl = _ref.videoUrl,
      videoUrl = _ref$videoUrl === void 0 ? "" : _ref$videoUrl,
      _ref$playerSettings = _ref.playerSettings,
      playerSettings = _ref$playerSettings === void 0 ? {
    controls: false
    /** Set to true or false to display native player controls.
    ◦  For Vimeo videos, hiding controls must be enabled by the video owner.  */
    ,
    loop: false,
    // Set to true or false to loop the media
    playing: false,
    //  Set to true or false to pause or play the media
    light: false
    /** Set to true to show just the video thumbnail, which loads the full player on click
    ◦  Pass in an image URL to override the preview image */
    ,
    volume: null
    /** Set the volume of the player, between 0 and 1
    ◦  null uses default volume on all players [#357](https://github.com/CookPete/react-player/issues/357) */
    ,
    muted: false
    /** Mutes the player
    ◦  Only works if volume is set */
    ,
    playbackRate: 1
    /** Set the playback rate of the player
    ◦  Only supported by YouTube, Wistia, and file paths */
    ,
    width: "auto",
    // Set the width of the player
    height: "600px",
    // Set the height of the player
    style: {},
    // Add [inline styles](https://facebook.github.io/react/tips/inline-styles.html) to the root element
    progressInterval: 1000,
    //  The time between onProgress callbacks, in milliseconds
    playsinline: false,
    //  Applies the playsinline attribute where supported
    pip: false
    /** Set to true or false to enable or disable [picture-in-picture](https://developers.google.com/web/updates/2018/10/watch-video-using-picture-in-picture) mode
    ◦  Only available when playing file URLs in [certain browsers](https://caniuse.com/#feat=picture-in-picture) */
    ,
    stopOnUnmount: true,
    // If you are using pip you may want to use stopOnUnmount={false} to continue playing in picture-in-picture mode even after ReactPlayer unmounts
    fallback: null,
    // Element or component to use as a fallback if you are using lazy loading
    wrapper: "div",
    //  Element or component to use as the container element
    playIcon: undefined,
    //  Element or component to use as the play icon in light mode
    previewTabIndex: 0,
    //  Set the tab index to be used on light mode
    config: undefined,
    //  Override options for the various players, see [config prop](https://www.npmjs.com/package/react-player#config-prop)

    /** Callback props
     *  Callback props take a function that gets fired on various player events:
     */
    onReady: undefined,
    //  Called when media is loaded and ready to play. If playing is set to true, media will play immediately
    onStart: undefined,
    //  Called when media starts playing
    onPlay: undefined,
    //  Called when media starts or resumes playing after pausing or buffering
    onProgress: undefined
    /** Callback containing played and loaded progress as a fraction, and playedSeconds and loadedSeconds in seconds
    ◦  eg { played: 0.12, playedSeconds: 11.3, loaded: 0.34, loadedSeconds: 16.7 } */
    ,
    onDuration: undefined,
    //  Callback containing duration of the media, in seconds
    onPause: undefined,
    //  Called when media is paused
    onBuffer: undefined,
    //  Called when media starts buffering
    onBufferEnd: undefined
    /** Called when media has finished buffering
    ◦  Works for files, YouTube and Facebook */
    ,
    onSeek: undefined,
    //  Called when media seeks with seconds parameter
    onEnded: undefined
    /** Called when media finishes playing
    ◦  Does not fire when loop is set to true */
    ,
    onError: undefined,
    //  Called when an error occurs whilst attempting to play media
    onClickPreview: undefined,
    //  Called when user clicks the light mode preview
    onEnablePIP: undefined,
    //  Called when picture-in-picture mode is enabled
    onDisablePIP: undefined //  Called when picture-in-picture mode is disabled

  } : _ref$playerSettings;
  return /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoContainer$1, null, /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoMediaContainer, null, /*#__PURE__*/React__default$1["default"].createElement(ReactPlayer, _extends$g({
    url: videoUrl
  }, playerSettings))), /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoTitleContainer$1, null, /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoTitle$1, null, title)));
}

var _excluded$J = ["variant"];

function Video(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? videoVariantTypes.SIMPLE : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$J);

  switch (variant) {
    case videoVariantTypes.SIMPLE:
      return /*#__PURE__*/React__default$1["default"].createElement(SimpleVideo, otherProps);

    default:
      throw new Error("Invalid Video variant: ".concat(variant));
  }
}

var _templateObject$19, _templateObject2$i, _templateObject3$c, _templateObject4$8;

var SimpleVideoContainer = styled__default["default"].div(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteral(["\n  max-width: ", "px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.xl;
});
var SimpleVideoTitleContainer = styled__default["default"].div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral([""])));
var SimpleVideoContentContainer = styled__default["default"].div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  display: grid;\n  grid-gap: 40px;\n  grid-auto-rows: auto;\n  grid-template-columns: ", ";\n\n  @media all and (max-width: ", "px) {\n    grid-gap: 20px;\n    grid-template-columns: ", ";\n  }\n"])), function (_ref2) {
  var _ref2$itemsCount = _ref2.itemsCount,
      itemsCount = _ref2$itemsCount === void 0 ? 0 : _ref2$itemsCount,
      _ref2$columns = _ref2.columns,
      columns = _ref2$columns === void 0 ? 1 : _ref2$columns;
  if (!itemsCount) return undefined;

  if (itemsCount < columns) {
    return lodash.range(itemsCount).map(function () {
      return "1fr";
    }).join(" ");
  }

  return lodash.range(columns).map(function () {
    return "1fr";
  }).join(" ");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.md;
}, function (_ref4) {
  var _ref4$itemsCount = _ref4.itemsCount,
      itemsCount = _ref4$itemsCount === void 0 ? 0 : _ref4$itemsCount,
      _ref4$mobileColumns = _ref4.mobileColumns,
      mobileColumns = _ref4$mobileColumns === void 0 ? 1 : _ref4$mobileColumns;
  if (!itemsCount) return undefined;

  if (itemsCount < mobileColumns) {
    return lodash.range(itemsCount).map(function () {
      return "1fr";
    }).join(" ");
  }

  return lodash.range(mobileColumns).map(function () {
    return "1fr";
  }).join(" ");
});
var SimpleVideoTitle = styled__default["default"].h6(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral([""])));

function VerticalVideoList(_ref5) {
  var _ref5$videoListProps = _ref5.videoListProps,
      videoListProps = _ref5$videoListProps === void 0 ? {
    listContainer: {},
    listTitleContainer: {},
    listTitle: {},
    listContentContainer: {},
    listItem: {}
  } : _ref5$videoListProps,
      _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? {
    variant: videoListVariantTypes.VERTICAL,
    videos: [],
    mobileColumns: 1,
    columns: 1,
    id: 1,
    title: ""
  } : _ref5$data;
  return /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoContainer, videoListProps.listContainer, !!data.title && /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoTitleContainer, videoListProps.listTitleContainer, /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoTitle, videoListProps.listTitle, data.title)), /*#__PURE__*/React__default$1["default"].createElement(SimpleVideoContentContainer, _extends$g({
    itemsCount: data.videos.length,
    columns: data.columns,
    mobileColumns: data.mobileColumns
  }, videoListProps.listContentContainer), data.videos.map(function (video) {
    return /*#__PURE__*/React__default$1["default"].createElement(Video, _extends$g({}, videoListProps.listItem, video, {
      key: nanoid()
    }));
  })));
}

var _excluded$I = ["variant"];

function VideoList(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? videoListVariantTypes.VERTICAL : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$I);

  switch (variant) {
    case videoListVariantTypes.VERTICAL:
      return /*#__PURE__*/React__default$1["default"].createElement(VerticalVideoList, otherProps);

    default:
      throw new Error("Invalid Video variant: ".concat(variant));
  }
}

var _templateObject$18, _templateObject2$h, _templateObject3$b, _templateObject4$7, _templateObject5$6; // components


var CustomButton$3 = styled__default["default"](Button$2)(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteral(["\n  margin: 0.5rem auto;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  font-size: 14px;\n  width: 138px;\n"])));
var Title$4 = styled__default["default"].h3(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.2rem" : _ref$fontSize,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "var(--grayscale-100-color)" : _ref$color,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "" : _ref$margin,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? "var(--primary-family)" : _ref$fontFamily;
  return "\n\tfont-family: ".concat(fontFamily, ";\n\tcolor: ").concat(color, ";\n\tfont-weight: bold;\n\tfont-size: ").concat(fontSize, ";\n  margin: ").concat(margin, ";\n");
});
var CustomCol = styled__default["default"].div(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  width: 33%;\n  min-width: 250px;\n"])));
var Report = styled__default["default"].div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme,
      _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? "Roboto" : _ref2$fontFamily;
  return "\n  width: 25%;\n  min-width: 100px;\n  margin: auto 0 0 1.5rem;\n  margin-top: 5px;\n  font-family: ".concat(fontFamily, ";\n  @media (max-width: ").concat(theme.breakpoints.sm, "px){\n   margin: auto 5px; \n  }\n");
});
var P = styled__default["default"].p(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$fontSize = _ref3.fontSize,
      fontSize = _ref3$fontSize === void 0 ? "22px" : _ref3$fontSize;
  return "\n\tfont-size: ".concat(fontSize, ";\n");
});

function DescriptionAndLinks(_ref4) {
  var _ref4$data = _ref4.data,
      data = _ref4$data === void 0 ? {
    ButtonsList: {}
  } : _ref4$data;

  var _onClick = function onClick(to) {
    return window.open(to);
  };

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-container"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$4, {
    fontSize: "62px",
    color: "var(--primary-100-color)",
    className: "DESCRIPTION_AND_LINKS__TITLE FeatureFullBg__title tw-pt-12 tw-pb-2 tw-font-semibold text-3xl tw-leading-snug",
    margin: "2rem 0"
  }, data.title), /*#__PURE__*/React__default$1["default"].createElement(P, {
    className: "tw-pb-6"
  }, data.description), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-flex tw-flex-wrap"
  }, data.ButtonsList.map(function (item, idx) {
    var ButtonListKeys = Object.keys(item);
    return /*#__PURE__*/React__default$1["default"].createElement(CustomCol, {
      key: "button-list-container-".concat(idx)
    }, /*#__PURE__*/React__default$1["default"].createElement(Title$4, {
      fontSize: "26px",
      fontFamily: "Poppins",
      margin: "2rem 0"
    }, item.title), ButtonListKeys.map(function (subItem, sidx) {
      var label = item["label".concat(sidx)];
      var link = item["link".concat(sidx)];

      if (subItem === "title") {
        return null;
      }

      if (label && link) {
        return /*#__PURE__*/React__default$1["default"].createElement(Report, null, /*#__PURE__*/React__default$1["default"].createElement(CustomButton$3, {
          fill: buttonFillTypes.FILLED,
          styleType: buttonStyleTypes.STANDARD,
          hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
          hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
          hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
          filledBackgroundColor: colorsTypes.PRIMARY,
          className: "DINAMIC_PAGE_COMPONENT DINAMIC_PAGE_COMPONENT_REPORTS_BUTTON",
          onClick: function onClick() {
            return _onClick(link);
          },
          key: "".concat(label, "-").concat(link)
        }, label));
      }

      return null;
    }));
  }))));
}

var _templateObject$17, _templateObject2$g, _templateObject3$a, _templateObject4$6, _templateObject5$5;

function ImagesGalerySlider(_ref) {
  var _data, _data2;

  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  if (!data.id) data = data[0];
  SwiperCore.use([Navigation$1, Thumbs$1]);
  var ButtonImgContainer = styled__default["default"].button(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteral(["\n    height: 118px;\n    width: 99px;\n  "])));
  var CloseIcon = styled__default["default"](Icon)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n    filter: invert(1);\n    width: 35px;\n  "])));
  var ImagesGaleryBlurBackground = styled__default["default"].div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    height: calc(100vh * 3);\n    width: 100vw;\n    background: #000;\n    opacity: 0.7;\n    z-index: 50;\n  "])));
  var ImageGalery = styled__default["default"].img(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n    display: block;\n    width: 75vw;\n    height: 90vh;\n    object-fit: contain;\n    @media (max-width: 760px) {\n      height: 75vh;\n    }\n  "])));
  var SlideImageContainer = styled__default["default"].div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 45%;\n    z-index: 52;\n    width: 100%;\n  "]))); // thumbs={{ swiper: thumbsSwiper }}
  // const [thumbsSwiper, setThumbsSwiper] = useState(null);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showSlide = _useState2[0],
      setShowSlide = _useState2[1];

  var setShowSlide2 = function setShowSlide2() {
    setShowSlide(false);
  };

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IMAGES_GALERY_SLIDE_MINI_IMGS_CONTAINER tw-x-container tw-flex tw-gap-2  tw-m-2 tw-flex-wrap tw-content-center"
  }, ((_data = data) === null || _data === void 0 ? void 0 : _data.images) && data.images.map(function (galeryImage) {
    return /*#__PURE__*/React__default$1["default"].createElement(ButtonImgContainer, {
      className: "IMAGES_GALERY_SLIDE_MINI_IMGS_BUTTON_CONTAINER",
      onClick: setShowSlide,
      key: nanoid(),
      type: "button"
    }, /*#__PURE__*/React__default$1["default"].createElement("img", {
      style: {
        "object-fit": "cover",
        height: "100%",
        width: "100%"
      },
      src: galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.url,
      alt: (galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.alternativeText) || (galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.hash)
    }));
  })), /*#__PURE__*/React__default$1["default"].createElement("main", {
    className: "IMAGES_GALERY_SLIDE_MAIN"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("IMAGES_GALERY_SLIDE_CONTAINER_FULL tw-h-auto", showSlide ? "" : "tw-hidden")
  }, /*#__PURE__*/React__default$1["default"].createElement(SlideImageContainer, {
    className: "IMAGES_GALERY_SLIDE_CONTAINER_FULL_DISPLAY"
  }, /*#__PURE__*/React__default$1["default"].createElement(Swiper, {
    style: {
      "--swiper-navigation-color": "#fff",
      "--swiper-pagination-color": "#fff",
      "z-index": "51",
      bottom: "40vh",
      "overflow-y": "visible",
      "overflow-x": "hidden"
    },
    spaceBetween: 15,
    navigation: true,
    className: "mySwiper2"
  }, ((_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.images) && data.images.map(function (galeryImage) {
    return /*#__PURE__*/React__default$1["default"].createElement(SwiperSlide, {
      key: nanoid()
    }, /*#__PURE__*/React__default$1["default"].createElement(ImageGalery, {
      src: galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.url,
      alt: (galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.alternativeText) || (galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.hash)
    }));
  }))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    style: {
      position: "fixed",
      top: "20px",
      right: "30px",
      "z-index": "51"
    }
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    onClick: setShowSlide2
  }, /*#__PURE__*/React__default$1["default"].createElement(CloseIcon, {
    size: "35",
    icon: iconTypes.REMOVE
  }))), /*#__PURE__*/React__default$1["default"].createElement(ImagesGaleryBlurBackground, {
    className: "IMAGES_GALERY_SLIDE_BACKGROUND"
  }))));
}
/*
<Swiper
                onClick={setShowSlide}
                spaceBetween={10}
                slidesPerView={9}
                style={{
                  'z-index': '49',
                }}
                freeMode={true}
                watchSlidesProgress={true}
                className="mySwiper tw-grid-cols-3"
              >
                {data?.images && data.images.map(galeryImage => {
                  return (
                      <SwiperSlide key={nanoid()}>
                        <img src={galeryImage?.url}
                            alt={galeryImage?.alternativeText || galeryImage?.hash}
                        />
                      </SwiperSlide>
                    );
                  })
                }
            </Swiper>

*/


var _templateObject$16, _templateObject2$f;

function ImagesGaleryRichText$1(_ref) {
  var _data, _data$galery, _data$galery$images$, _data2, _data2$galery, _data3, _data3$galery, _data3$galery$images$, _data4, _data4$galery, _data4$galery$images$, _data5, _data5$galery, _data6, _data6$galery, _data7;

  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  if (!data.id) data = data[0];
  var GaleryTitle = styled__default["default"].div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    padding: 5px 15px 7px;\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: 600;\n    margin: 0 0;\n  "])), function (_ref2) {
    var _ref2$titleBacgroundC = _ref2.titleBacgroundColor,
        titleBacgroundColor = _ref2$titleBacgroundC === void 0 ? colorsVariantsTypes.PRIMARY_SEMI_DARK : _ref2$titleBacgroundC;
    return getColors(titleBacgroundColor);
  }, function (_ref3) {
    var _ref3$textTitleColor = _ref3.textTitleColor,
        textTitleColor = _ref3$textTitleColor === void 0 ? colorsVariantsTypes.WHITE : _ref3$textTitleColor;
    return getColors(textTitleColor);
  }, function (_ref4) {
    var _ref4$titleSize = _ref4.titleSize,
        titleSize = _ref4$titleSize === void 0 ? textSizesVariantsTypes.SMALL : _ref4$titleSize;
    return getTextSize(titleSize);
  }, function (_ref5) {
    var _ref5$titleFontFamily = _ref5.titleFontFamily,
        titleFontFamily = _ref5$titleFontFamily === void 0 ? fontsFamiliesVariantsTypes.SECONDARY : _ref5$titleFontFamily;
    return getFontFamily(titleFontFamily);
  });
  var GaleryElements = styled__default["default"].div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n    border: 1px solid\n      ", ";\n    padding: 1.5rem;\n  "])), function (_ref6) {
    var _ref6$titleBacgroundC = _ref6.titleBacgroundColor,
        titleBacgroundColor = _ref6$titleBacgroundC === void 0 ? colorsVariantsTypes.PRIMARY_SEMI_DARK : _ref6$titleBacgroundC;
    return getColors(titleBacgroundColor);
  });

  var _useState = React.useState((_data = data) === null || _data === void 0 ? void 0 : (_data$galery = _data.galery) === null || _data$galery === void 0 ? void 0 : (_data$galery$images$ = _data$galery.images[0]) === null || _data$galery$images$ === void 0 ? void 0 : _data$galery$images$.url),
      _useState2 = _slicedToArray$1(_useState, 2),
      stateImage = _useState2[0],
      setStateImage = _useState2[1];

  var changeImage = function changeImage(e, newUrlImg) {
    setStateImage(newUrlImg);
  };

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IMAGES_GAELERY tw-x-container"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IMAGES_GAELERY__CONTAINER__BOX tw-my-8"
  }, /*#__PURE__*/React__default$1["default"].createElement(GaleryTitle, {
    className: "tw-w-full"
  }, (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$galery = _data2.galery) === null || _data2$galery === void 0 ? void 0 : _data2$galery.title), /*#__PURE__*/React__default$1["default"].createElement(GaleryElements, {
    className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-mr-3 tw-order-last md:tw-order-first"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IMAGES_GALERY_RICH_TEXT_MAIN_IMAGE_CONTAINER  tw-mb-4 "
  }, /*#__PURE__*/React__default$1["default"].createElement("figure", null, /*#__PURE__*/React__default$1["default"].createElement("img", {
    id: "IMAGES_GALERY_RICH_TEXT_MAIN_IMAGE",
    className: "IMAGES_GALERY_RICH_TEXT_MAIN_IMAGE tw-w-full tw-h-auto tw-object-cover",
    src: stateImage,
    alt: ((_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$galery = _data3.galery) === null || _data3$galery === void 0 ? void 0 : (_data3$galery$images$ = _data3$galery.images[0]) === null || _data3$galery$images$ === void 0 ? void 0 : _data3$galery$images$.alternativeText) || ((_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$galery = _data4.galery) === null || _data4$galery === void 0 ? void 0 : (_data4$galery$images$ = _data4$galery.images[0]) === null || _data4$galery$images$ === void 0 ? void 0 : _data4$galery$images$.hash)
  }))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IMAGES_GALERY_RICH_TEXT_MIN_IMAGES_CONTAINER tw-grid tw-gap-4 tw-grid-cols-3 md:tw-grid-cols-5"
  }, ((_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$galery = _data5.galery) === null || _data5$galery === void 0 ? void 0 : _data5$galery.images) && ((_data6 = data) === null || _data6 === void 0 ? void 0 : (_data6$galery = _data6.galery) === null || _data6$galery === void 0 ? void 0 : _data6$galery.images.map(function (galeryImage) {
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "IMAGES_GALERY_RICH_TEXT_MIN_IMAGE_CONTAINER sm:tw-my-2 md:tw-my-4",
      key: nanoid()
    }, /*#__PURE__*/React__default$1["default"].createElement("button", {
      className: "IMAGES_GALERY_RICH_TEXT_MIN_IMAGE_BUTTON",
      type: "button",
      onClick: function onClick(e) {
        return changeImage(e, galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.url);
      }
    }, /*#__PURE__*/React__default$1["default"].createElement("img", {
      className: "IMAGES_GALERY_RICH_TEXT_MIN_IMAGE_IMAGE tw-object-cover",
      src: galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.url,
      alt: (galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.alternativeText) || (galeryImage === null || galeryImage === void 0 ? void 0 : galeryImage.hash)
    })));
  })))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "IMAGES_GALERY_RICH_TEXT_TEXT_CONTAINER tw-ml-3"
  }, /*#__PURE__*/React__default$1["default"].createElement(RichTextContainer, {
    className: "IMAGES_GALERY_RICH_TEXT_MAIN",
    dangerouslySetInnerHTML: {
      __html: (_data7 = data) === null || _data7 === void 0 ? void 0 : _data7.text
    }
  })))));
}

var _excluded$H = ["title", "variant", "images", "customComponentStyles"];

function ImagesGalery(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? imagesGaleryVariantsTypes.NONE : _ref$variant,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? {} : _ref$images,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS,
      props = _objectWithoutProperties$1(_ref, _excluded$H);

  if (!props.data) return null;

  switch (variant) {
    case imagesGaleryVariantsTypes.NONE:
      return /*#__PURE__*/React__default$1["default"].createElement(ImagesGalerySlider, _extends$g({}, props, {
        title: title,
        images: images
      }, customComponentStyles.ImagesGalerySlider));

    case imagesGaleryVariantsTypes.RICHTEXT:
      return /*#__PURE__*/React__default$1["default"].createElement(ImagesGaleryRichText$1, props);

    default:
      throw new Error("Invalid Images Galery variant: ".concat(variant));
  }
}

var ImagesGalery$1 = withErrorBoundary(ImagesGalery);

function ImagesGaleryRichText(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$customComponentS = _ref.customComponentStyles,
      customComponentStyles = _ref$customComponentS === void 0 ? {} : _ref$customComponentS;
  return /*#__PURE__*/React__default$1["default"].createElement(ImagesGalery$1, {
    variant: imagesGaleryVariantsTypes.RICHTEXT,
    data: data,
    customComponentStyles: customComponentStyles
  });
}

function PopUpGaleryCommon(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  return /*#__PURE__*/React__default$1["default"].createElement(PopUpGalery$1, {
    data: data
  });
}

var _templateObject$15, _templateObject2$e, _templateObject3$9, _templateObject4$5, _templateObject5$4, _templateObject6$2, _templateObject7$2, _templateObject8$2;

function PopUpGalery(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  var PopUpContainer = styled__default["default"].div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteral(["\n    height: 100%;\n    width: 100%;\n    background-size: cover !important;\n    @media (min-width: ", "px) {\n      z-index: 51;\n    }\n    @media (max-width: ", "px) {\n      z-index: 101;\n    }\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return theme.breakpoints.sm;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.breakpoints.md;
  });
  var TitleImg = styled__default["default"].h3(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n    font-family: Poppins;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 26px;\n    line-height: 39px;\n    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.6);\n    -webkit-text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.6);\n    -moz--text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.6);\n  "])));
  var Images = styled__default["default"].div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n    position: relative;\n    height: 299px;\n    background-size: cover !important;\n    @media (min-width: ", "px) {\n      min-width: 475px;\n    }\n    @media (max-width: ", "px) {\n      min-width: 335px;\n    }\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.breakpoints.sm;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.breakpoints.md;
  });
  var BoxPopUp = styled__default["default"].div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    border-radius: 5px;\n\n    @media (min-width: ", "px) {\n      width: 700px;\n      min-height: 400px;\n    }\n    @media (max-width: ", "px) {\n      width: 276px;\n      min-height: 467px;\n    }\n  "])), function (_ref6) {
    var theme = _ref6.theme;
    return theme.breakpoints.sm;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.breakpoints.md;
  });
  var ClosePopUp = styled__default["default"].div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n    width: 100%;\n    border-bottom: solid 1px #9ca3af;\n    padding: 0;\n    height: 35px;\n\n    @media (min-width: ", "px) {\n      margin-bottom: 22px;\n    }\n    @media (max-width: ", "px) {\n      margin-bottom: 43px;\n    }\n  "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.breakpoints.sm;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.breakpoints.md;
  });
  var ParagraphfPopUp = styled__default["default"].div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n    font-family: \"Roboto\", sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 16px;\n\n    @media (min-width: ", "px) {\n      padding-left: 40px;\n      padding-right: 40px;\n      padding-bottom: 47px;\n    }\n\n    @media (max-width: ", "px) {\n      padding-left: 22px;\n      padding-right: 22px;\n      padding-bottom: 22px;\n    }\n  "])), function (_ref10) {
    var theme = _ref10.theme;
    return theme.breakpoints.sm;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.breakpoints.md;
  });
  var CloseIcon = styled__default["default"](Icon)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n    width: 15px;\n    height: 13px;\n    color: #000000;\n    position: absolute;\n\n    @media (min-width: ", "px) {\n      right: 3%;\n      top: 3%;\n    }\n\n    @media (max-width: ", "px) {\n      right: 5%;\n      top: 1.5%;\n    }\n  "])), function (_ref12) {
    var theme = _ref12.theme;
    return theme.breakpoints.sm;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.breakpoints.md;
  });
  var TitlePopUp = styled__default["default"].h3(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n    font-family: Poppins;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 26px;\n    height: 38px;\n    margin-bottom: 10px;\n\n    @media (min-width: ", "px) {\n      padding-left: 40px;\n      padding-right: 40px;\n      line-height: 39px;\n    }\n    @media (max-width: ", "px) {\n      padding-left: 22px;\n      padding-right: 22px;\n      margin-bottom: 22px;\n      line-height: 100%;\n    }\n  "])), function (_ref14) {
    var theme = _ref14.theme;
    return theme.breakpoints.sm;
  }, function (_ref15) {
    var theme = _ref15.theme;
    return theme.breakpoints.md;
  });

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      showPopUp = _useState2[0],
      setShowPopUp = _useState2[1];

  var _useState3 = React.useState(""),
      _useState4 = _slicedToArray$1(_useState3, 2),
      popUpTitle = _useState4[0],
      setTitlePopU = _useState4[1];

  var _useState5 = React.useState(""),
      _useState6 = _slicedToArray$1(_useState5, 2),
      popUpText = _useState6[0],
      setTextPopUp = _useState6[1];

  var _useState7 = React.useState(""),
      _useState8 = _slicedToArray$1(_useState7, 2),
      popUpBgImg = _useState8[0],
      setImgPopUp = _useState8[1];

  var _useState9 = React.useState(""),
      _useState10 = _slicedToArray$1(_useState9, 2),
      popUpBgImgMovile = _useState10[0],
      setImgMovilePopUp = _useState10[1];

  var showPopUp2 = function showPopUp2(url, urlMovile, title, text) {
    setShowPopUp(true);
    setImgPopUp(url);
    setImgMovilePopUp(urlMovile);
    setTitlePopU(title);
    setTextPopUp(text);
  };

  var closePopUp = function closePopUp() {
    setShowPopUp(false);
  };

  var styleFeature = {
    background: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(".concat(width < breakpoints.md ? popUpBgImgMovile : popUpBgImg, ")"),
    backgroundPosition: "top center",
    backgroundRepeat: "no-repeat"
  };
  var styleFeature2 = {
    gap: "".concat(width < breakpoints.md ? "20px 20px" : "10px 20px")
  };
  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "POPUP_GALERY_CONTAINER tw-x-container tw-mx-auto tw-my-5"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2",
    style: styleFeature2
  }, (data === null || data === void 0 ? void 0 : data.items) && data.items.map(function (galeryImagePopUp) {
    var _galeryImagePopUp$ima3;

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "POPUP_GALERY_IMAGE tw-relative "
    }, /*#__PURE__*/React__default$1["default"].createElement("button", {
      type: "button",
      className: "tw-relative tw-flex tw-justify-center tw-text-6xl tw-rounded-xl tw-content-center",
      onClick: function onClick() {
        var _galeryImagePopUp$ima, _galeryImagePopUp$ima2;

        return showPopUp2(galeryImagePopUp === null || galeryImagePopUp === void 0 ? void 0 : (_galeryImagePopUp$ima = galeryImagePopUp.image) === null || _galeryImagePopUp$ima === void 0 ? void 0 : _galeryImagePopUp$ima.url, galeryImagePopUp === null || galeryImagePopUp === void 0 ? void 0 : (_galeryImagePopUp$ima2 = galeryImagePopUp.imageMobile) === null || _galeryImagePopUp$ima2 === void 0 ? void 0 : _galeryImagePopUp$ima2.url, galeryImagePopUp === null || galeryImagePopUp === void 0 ? void 0 : galeryImagePopUp.title, galeryImagePopUp === null || galeryImagePopUp === void 0 ? void 0 : galeryImagePopUp.text);
      }
    }, /*#__PURE__*/React__default$1["default"].createElement(Images, {
      className: classnames("POPUP_GALERY_IMAGES w-full"),
      alt: "galery-item",
      style: {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(".concat(galeryImagePopUp === null || galeryImagePopUp === void 0 ? void 0 : (_galeryImagePopUp$ima3 = galeryImagePopUp.imageMobile) === null || _galeryImagePopUp$ima3 === void 0 ? void 0 : _galeryImagePopUp$ima3.url, ")")
      }
    }), /*#__PURE__*/React__default$1["default"].createElement(TitleImg, {
      className: classnames("POPUP_GALERY_TITLE_IMAGE tw-absolute tw-top-1/2 tw-text-white tw-object-center")
    }, galeryImagePopUp === null || galeryImagePopUp === void 0 ? void 0 : galeryImagePopUp.title)));
  }))), /*#__PURE__*/React__default$1["default"].createElement(PopUpContainer, {
    style: styleFeature,
    className: classnames("POPUP_GALERY_POPUP_CONTAINER tw-flex tw-z-75 tw-fixed tw-top-0 tw-left-0 tw-h-full tw-w-full", showPopUp ? "" : "tw-hidden")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0 "
  }, /*#__PURE__*/React__default$1["default"].createElement(BoxPopUp, {
    className: classnames("POPUP_GALERY_POPUP_BOX tw-relative tw-bg-white tw-bg-opacity-80 tw-mx-auto tw-my-28 tw-py-0 tw-px-0")
  }, /*#__PURE__*/React__default$1["default"].createElement(ClosePopUp, {
    className: classnames("POPUP_GALERY_POPUP_CLOSE tw-flex tw-w-full tw-text-right tw-pr-1 tw-border-b-1 tw-border-gray-400")
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: classnames("POPUP_GALERY_POPUP_CLOSE_BTN tw-text-black tw-font-bold bl-text-base"),
    onClick: closePopUp
  }, /*#__PURE__*/React__default$1["default"].createElement(CloseIcon, {
    size: "35",
    icon: iconTypes.REMOVE
  }))), /*#__PURE__*/React__default$1["default"].createElement(TitlePopUp, null, popUpTitle), /*#__PURE__*/React__default$1["default"].createElement(ParagraphfPopUp, null, /*#__PURE__*/React__default$1["default"].createElement(RichTextContainer, {
    className: "POPUP_GALERY_POPUP_PARAGRAPH",
    dangerouslySetInnerHTML: {
      __html: popUpText
    }
  }))))));
}

var PopUpGalery$1 = withErrorBoundary(PopUpGalery);
var interopRequireDefault = createCommonjsModule(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var assertThisInitialized = createCommonjsModule(function (module) {
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
var inheritsLoose = createCommonjsModule(function (module) {
  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
  }

  module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */


var NODE_ENV = process.env.NODE_ENV;

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1 = invariant;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  } // Binding "this" is important for shallow renderer support.


  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
} // React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.


componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  } // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.


  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;

  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }

  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }

  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }

  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  } // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.


  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  } // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.


  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
} ////////////////////////////////////////////////////////////////////////////////
// startsWith(string, search) - Check if `string` starts with `search`


var startsWith = function startsWith(string, search) {
  return string.substr(0, search.length) === search;
}; ////////////////////////////////////////////////////////////////////////////////
// pick(routes, uri)
//
// Ranks and picks the best route to match. Each segment gets the highest
// amount of points, then the type of segment gets an additional amount of
// points where
//
//     static > dynamic > splat > root
//
// This way we don't have to worry about the order of our routes, let the
// computers do it.
//
// A route looks like this
//
//     { path, default, value }
//
// And a returned match looks like:
//
//     { route, params, uri }
//
// I know, I should use TypeScript not comments for these types.


var pick = function pick(routes, uri) {
  var match = void 0;
  var default_ = void 0;

  var _uri$split = uri.split("?"),
      uriPathname = _uri$split[0];

  var uriSegments = segmentize(uriPathname);
  var isRootUri = uriSegments[0] === "";
  var ranked = rankRoutes(routes);

  for (var i = 0, l = ranked.length; i < l; i++) {
    var missed = false;
    var route = ranked[i].route;

    if (route.default) {
      default_ = {
        route: route,
        params: {},
        uri: uri
      };
      continue;
    }

    var routeSegments = segmentize(route.path);
    var params = {};
    var max = Math.max(uriSegments.length, routeSegments.length);
    var index = 0;

    for (; index < max; index++) {
      var routeSegment = routeSegments[index];
      var uriSegment = uriSegments[index];

      if (isSplat(routeSegment)) {
        // Hit a splat, just grab the rest, and return a match
        // uri:   /files/documents/work
        // route: /files/*
        var param = routeSegment.slice(1) || "*";
        params[param] = uriSegments.slice(index).map(decodeURIComponent).join("/");
        break;
      }

      if (uriSegment === undefined) {
        // URI is shorter than the route, no match
        // uri:   /users
        // route: /users/:userId
        missed = true;
        break;
      }

      var dynamicMatch = paramRe.exec(routeSegment);

      if (dynamicMatch && !isRootUri) {
        var matchIsNotReserved = reservedNames.indexOf(dynamicMatch[1]) === -1;
        !matchIsNotReserved ? process.env.NODE_ENV !== "production" ? invariant_1(false, "<Router> dynamic segment \"" + dynamicMatch[1] + "\" is a reserved name. Please use a different name in path \"" + route.path + "\".") : invariant_1(false) : void 0;
        var value = decodeURIComponent(uriSegment);
        params[dynamicMatch[1]] = value;
      } else if (routeSegment !== uriSegment) {
        // Current segments don't match, not dynamic, not splat, so no match
        // uri:   /users/123/settings
        // route: /users/:id/profile
        missed = true;
        break;
      }
    }

    if (!missed) {
      match = {
        route: route,
        params: params,
        uri: "/" + uriSegments.slice(0, index).join("/")
      };
      break;
    }
  }

  return match || default_ || null;
}; ////////////////////////////////////////////////////////////////////////////////
// match(path, uri) - Matches just one path to a uri, also lol


var match = function match(path, uri) {
  return pick([{
    path: path
  }], uri);
}; ////////////////////////////////////////////////////////////////////////////////
// resolve(to, basepath)
//
// Resolves URIs as though every path is a directory, no files.  Relative URIs
// in the browser can feel awkward because not only can you be "in a directory"
// you can be "at a file", too. For example
//
//     browserSpecResolve('foo', '/bar/') => /bar/foo
//     browserSpecResolve('foo', '/bar') => /foo
//
// But on the command line of a file system, it's not as complicated, you can't
// `cd` from a file, only directories.  This way, links have to know less about
// their current path. To go deeper you can do this:
//
//     <Link to="deeper"/>
//     // instead of
//     <Link to=`{${props.uri}/deeper}`/>
//
// Just like `cd`, if you want to go deeper from the command line, you do this:
//
//     cd deeper
//     # not
//     cd $(pwd)/deeper
//
// By treating every path as a directory, linking to relative paths should
// require less contextual information and (fingers crossed) be more intuitive.


var resolve = function resolve(to, base) {
  // /foo/bar, /baz/qux => /foo/bar
  if (startsWith(to, "/")) {
    return to;
  }

  var _to$split = to.split("?"),
      toPathname = _to$split[0],
      toQuery = _to$split[1];

  var _base$split = base.split("?"),
      basePathname = _base$split[0];

  var toSegments = segmentize(toPathname);
  var baseSegments = segmentize(basePathname); // ?a=b, /users?b=c => /users?a=b

  if (toSegments[0] === "") {
    return addQuery(basePathname, toQuery);
  } // profile, /users/789 => /users/789/profile


  if (!startsWith(toSegments[0], ".")) {
    var pathname = baseSegments.concat(toSegments).join("/");
    return addQuery((basePathname === "/" ? "" : "/") + pathname, toQuery);
  } // ./         /users/123  =>  /users/123
  // ../        /users/123  =>  /users
  // ../..      /users/123  =>  /
  // ../../one  /a/b/c/d    =>  /a/b/one
  // .././one   /a/b/c/d    =>  /a/b/c/one


  var allSegments = baseSegments.concat(toSegments);
  var segments = [];

  for (var i = 0, l = allSegments.length; i < l; i++) {
    var segment = allSegments[i];
    if (segment === "..") segments.pop();else if (segment !== ".") segments.push(segment);
  }

  return addQuery("/" + segments.join("/"), toQuery);
}; ////////////////////////////////////////////////////////////////////////////////
// insertParams(path, params)


var insertParams = function insertParams(path, params) {
  var _path$split = path.split("?"),
      pathBase = _path$split[0],
      _path$split$ = _path$split[1],
      query = _path$split$ === undefined ? "" : _path$split$;

  var segments = segmentize(pathBase);
  var constructedPath = "/" + segments.map(function (segment) {
    var match = paramRe.exec(segment);
    return match ? params[match[1]] : segment;
  }).join("/");
  var _params$location = params.location;
  _params$location = _params$location === undefined ? {} : _params$location;
  var _params$location$sear = _params$location.search,
      search = _params$location$sear === undefined ? "" : _params$location$sear;
  var searchSplit = search.split("?")[1] || "";
  constructedPath = addQuery(constructedPath, query, searchSplit);
  return constructedPath;
};

var validateRedirect = function validateRedirect(from, to) {
  var filter = function filter(segment) {
    return isDynamic(segment);
  };

  var fromString = segmentize(from).filter(filter).sort().join("/");
  var toString = segmentize(to).filter(filter).sort().join("/");
  return fromString === toString;
}; ////////////////////////////////////////////////////////////////////////////////
// Junk


var paramRe = /^:(.+)/;
var SEGMENT_POINTS = 4;
var STATIC_POINTS = 3;
var DYNAMIC_POINTS = 2;
var SPLAT_PENALTY = 1;
var ROOT_POINTS = 1;

var isRootSegment = function isRootSegment(segment) {
  return segment === "";
};

var isDynamic = function isDynamic(segment) {
  return paramRe.test(segment);
};

var isSplat = function isSplat(segment) {
  return segment && segment[0] === "*";
};

var rankRoute = function rankRoute(route, index) {
  var score = route.default ? 0 : segmentize(route.path).reduce(function (score, segment) {
    score += SEGMENT_POINTS;
    if (isRootSegment(segment)) score += ROOT_POINTS;else if (isDynamic(segment)) score += DYNAMIC_POINTS;else if (isSplat(segment)) score -= SEGMENT_POINTS + SPLAT_PENALTY;else score += STATIC_POINTS;
    return score;
  }, 0);
  return {
    route: route,
    score: score,
    index: index
  };
};

var rankRoutes = function rankRoutes(routes) {
  return routes.map(rankRoute).sort(function (a, b) {
    return a.score < b.score ? 1 : a.score > b.score ? -1 : a.index - b.index;
  });
};

var segmentize = function segmentize(uri) {
  return uri // strip starting/ending slashes
  .replace(/(^\/+|\/+$)/g, "").split("/");
};

var addQuery = function addQuery(pathname) {
  for (var _len = arguments.length, query = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    query[_key - 1] = arguments[_key];
  }

  query = query.filter(function (q) {
    return q && q.length > 0;
  });
  return pathname + (query && query.length > 0 ? "?" + query.join("&") : "");
};

var reservedNames = ["uri", "path"];
/**
 * Shallow compares two objects.
 * @param {Object} obj1 The first object to compare.
 * @param {Object} obj2 The second object to compare.
 */

var shallowCompare = function shallowCompare(obj1, obj2) {
  var obj1Keys = Object.keys(obj1);
  return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function (key) {
    return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
  });
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var getLocation = function getLocation(source) {
  var _source$location = source.location,
      search = _source$location.search,
      hash = _source$location.hash,
      href = _source$location.href,
      origin = _source$location.origin,
      protocol = _source$location.protocol,
      host = _source$location.host,
      hostname = _source$location.hostname,
      port = _source$location.port;
  var pathname = source.location.pathname;

  if (!pathname && href && canUseDOM$1) {
    var url = new URL(href);
    pathname = url.pathname;
  }

  return {
    pathname: encodeURI(decodeURI(pathname)),
    search: search,
    hash: hash,
    href: href,
    origin: origin,
    protocol: protocol,
    host: host,
    hostname: hostname,
    port: port,
    state: source.history.state,
    key: source.history.state && source.history.state.key || "initial"
  };
};

var createHistory = function createHistory(source, options) {
  var listeners = [];
  var location = getLocation(source);
  var transitioning = false;

  var resolveTransition = function resolveTransition() {};

  return {
    get location() {
      return location;
    },

    get transitioning() {
      return transitioning;
    },

    _onTransitionComplete: function _onTransitionComplete() {
      transitioning = false;
      resolveTransition();
    },
    listen: function listen(listener) {
      listeners.push(listener);

      var popstateListener = function popstateListener() {
        location = getLocation(source);
        listener({
          location: location,
          action: "POP"
        });
      };

      source.addEventListener("popstate", popstateListener);
      return function () {
        source.removeEventListener("popstate", popstateListener);
        listeners = listeners.filter(function (fn) {
          return fn !== listener;
        });
      };
    },
    navigate: function navigate(to) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          state = _ref.state,
          _ref$replace = _ref.replace,
          replace = _ref$replace === undefined ? false : _ref$replace;

      if (typeof to === "number") {
        source.history.go(to);
      } else {
        state = _extends$2({}, state, {
          key: Date.now() + ""
        }); // try...catch iOS Safari limits to 100 pushState calls

        try {
          if (transitioning || replace) {
            source.history.replaceState(state, null, to);
          } else {
            source.history.pushState(state, null, to);
          }
        } catch (e) {
          source.location[replace ? "replace" : "assign"](to);
        }
      }

      location = getLocation(source);
      transitioning = true;
      var transition = new Promise(function (res) {
        return resolveTransition = res;
      });
      listeners.forEach(function (listener) {
        return listener({
          location: location,
          action: "PUSH"
        });
      });
      return transition;
    }
  };
}; ////////////////////////////////////////////////////////////////////////////////
// Stores history entries in memory for testing or other platforms like Native


var createMemorySource = function createMemorySource() {
  var initialPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var searchIndex = initialPath.indexOf("?");
  var initialLocation = {
    pathname: searchIndex > -1 ? initialPath.substr(0, searchIndex) : initialPath,
    search: searchIndex > -1 ? initialPath.substr(searchIndex) : ""
  };
  var index = 0;
  var stack = [initialLocation];
  var states = [null];
  return {
    get location() {
      return stack[index];
    },

    addEventListener: function addEventListener(name, fn) {},
    removeEventListener: function removeEventListener(name, fn) {},
    history: {
      get entries() {
        return stack;
      },

      get index() {
        return index;
      },

      get state() {
        return states[index];
      },

      pushState: function pushState(state, _, uri) {
        var _uri$split = uri.split("?"),
            pathname = _uri$split[0],
            _uri$split$ = _uri$split[1],
            search = _uri$split$ === undefined ? "" : _uri$split$;

        index++;
        stack.push({
          pathname: pathname,
          search: search.length ? "?" + search : search
        });
        states.push(state);
      },
      replaceState: function replaceState(state, _, uri) {
        var _uri$split2 = uri.split("?"),
            pathname = _uri$split2[0],
            _uri$split2$ = _uri$split2[1],
            search = _uri$split2$ === undefined ? "" : _uri$split2$;

        stack[index] = {
          pathname: pathname,
          search: search
        };
        states[index] = state;
      },
      go: function go(to) {
        var newIndex = index + to;

        if (newIndex < 0 || newIndex > states.length - 1) {
          return;
        }

        index = newIndex;
      }
    }
  };
}; ////////////////////////////////////////////////////////////////////////////////
// global history - uses window.history as the source if available, otherwise a
// memory history


var canUseDOM$1 = !!(typeof window !== "undefined" && window.document && window.document.createElement);

var getSource = function getSource() {
  return canUseDOM$1 ? window : createMemorySource();
};

var globalHistory = createHistory(getSource());
var navigate = globalHistory.navigate;

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} ////////////////////////////////////////////////////////////////////////////////


var createNamedContext = function createNamedContext(name, defaultValue) {
  var Ctx = React.createContext(defaultValue);
  Ctx.displayName = name;
  return Ctx;
}; ////////////////////////////////////////////////////////////////////////////////
// Location Context/Provider


var LocationContext = createNamedContext("Location"); // sets up a listener if there isn't one already so apps don't need to be
// wrapped in some top level provider

var Location = function Location(_ref) {
  var children = _ref.children;
  return React__default$1["default"].createElement(LocationContext.Consumer, null, function (context) {
    return context ? children(context) : React__default$1["default"].createElement(LocationProvider, null, children);
  });
};

var LocationProvider = function (_React$Component) {
  _inherits(LocationProvider, _React$Component);

  function LocationProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, LocationProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      context: _this.getContext(),
      refs: {
        unlisten: null
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LocationProvider.prototype.getContext = function getContext() {
    var _props$history = this.props.history,
        navigate = _props$history.navigate,
        location = _props$history.location;
    return {
      navigate: navigate,
      location: location
    };
  };

  LocationProvider.prototype.componentDidCatch = function componentDidCatch(error, info) {
    if (isRedirect(error)) {
      var _navigate = this.props.history.navigate;

      _navigate(error.uri, {
        replace: true
      });
    } else {
      throw error;
    }
  };

  LocationProvider.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevState.context.location !== this.state.context.location) {
      this.props.history._onTransitionComplete();
    }
  };

  LocationProvider.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var refs = this.state.refs,
        history = this.props.history;

    history._onTransitionComplete();

    refs.unlisten = history.listen(function () {
      Promise.resolve().then(function () {
        // TODO: replace rAF with react deferred update API when it's ready https://github.com/facebook/react/issues/13306
        requestAnimationFrame(function () {
          if (!_this2.unmounted) {
            _this2.setState(function () {
              return {
                context: _this2.getContext()
              };
            });
          }
        });
      });
    });
  };

  LocationProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    var refs = this.state.refs;
    this.unmounted = true;
    refs.unlisten();
  };

  LocationProvider.prototype.render = function render() {
    var context = this.state.context,
        children = this.props.children;
    return React__default$1["default"].createElement(LocationContext.Provider, {
      value: context
    }, typeof children === "function" ? children(context) : children || null);
  };

  return LocationProvider;
}(React__default$1["default"].Component); ////////////////////////////////////////////////////////////////////////////////


LocationProvider.defaultProps = {
  history: globalHistory
};
process.env.NODE_ENV !== "production" ? LocationProvider.propTypes = {
  history: PropTypes.object.isRequired
} : void 0;

var ServerLocation = function ServerLocation(_ref2) {
  var url = _ref2.url,
      children = _ref2.children;
  var searchIndex = url.indexOf("?");
  var searchExists = searchIndex > -1;
  var pathname = void 0;
  var search = "";
  var hash = "";

  if (searchExists) {
    pathname = url.substring(0, searchIndex);
    search = url.substring(searchIndex);
  } else {
    pathname = url;
  }

  return React__default$1["default"].createElement(LocationContext.Provider, {
    value: {
      location: {
        pathname: pathname,
        search: search,
        hash: hash
      },
      navigate: function navigate() {
        throw new Error("You can't call navigate on the server.");
      }
    }
  }, children);
}; ////////////////////////////////////////////////////////////////////////////////
// Sets baseuri and basepath for nested routers and links


var BaseContext = createNamedContext("Base", {
  baseuri: "/",
  basepath: "/",
  navigate: globalHistory.navigate
}); ////////////////////////////////////////////////////////////////////////////////
// The main event, welcome to the show everybody.

var Router = function Router(props) {
  return React__default$1["default"].createElement(BaseContext.Consumer, null, function (baseContext) {
    return React__default$1["default"].createElement(Location, null, function (locationContext) {
      return React__default$1["default"].createElement(RouterImpl, _extends$1({}, baseContext, locationContext, props));
    });
  });
};

var RouterImpl = function (_React$PureComponent) {
  _inherits(RouterImpl, _React$PureComponent);

  function RouterImpl() {
    _classCallCheck(this, RouterImpl);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  RouterImpl.prototype.render = function render() {
    var _props = this.props,
        location = _props.location,
        _navigate2 = _props.navigate,
        basepath = _props.basepath,
        primary = _props.primary,
        children = _props.children;
    _props.baseuri;

    var _props$component = _props.component,
        component = _props$component === undefined ? "div" : _props$component,
        domProps = _objectWithoutProperties(_props, ["location", "navigate", "basepath", "primary", "children", "baseuri", "component"]);

    var routes = React__default$1["default"].Children.toArray(children).reduce(function (array, child) {
      var routes = createRoute(basepath)(child);
      return array.concat(routes);
    }, []);
    var pathname = location.pathname;
    var match = pick(routes, pathname);

    if (match) {
      var params = match.params,
          uri = match.uri,
          route = match.route,
          element = match.route.value; // remove the /* from the end for child routes relative paths

      basepath = route.default ? basepath : route.path.replace(/\*$/, "");

      var props = _extends$1({}, params, {
        uri: uri,
        location: location,
        navigate: function navigate(to, options) {
          return _navigate2(resolve(to, uri), options);
        }
      });

      var clone = React__default$1["default"].cloneElement(element, props, element.props.children ? React__default$1["default"].createElement(Router, {
        location: location,
        primary: primary
      }, element.props.children) : undefined); // using 'div' for < 16.3 support

      var FocusWrapper = primary ? FocusHandler : component; // don't pass any props to 'div'

      var wrapperProps = primary ? _extends$1({
        uri: uri,
        location: location,
        component: component
      }, domProps) : domProps;
      return React__default$1["default"].createElement(BaseContext.Provider, {
        value: {
          baseuri: uri,
          basepath: basepath,
          navigate: props.navigate
        }
      }, React__default$1["default"].createElement(FocusWrapper, wrapperProps, clone));
    } else {
      // Not sure if we want this, would require index routes at every level
      // warning(
      //   false,
      //   `<Router basepath="${basepath}">\n\nNothing matched:\n\t${
      //     location.pathname
      //   }\n\nPaths checked: \n\t${routes
      //     .map(route => route.path)
      //     .join(
      //       "\n\t"
      //     )}\n\nTo get rid of this warning, add a default NotFound component as child of Router:
      //   \n\tlet NotFound = () => <div>Not Found!</div>
      //   \n\t<Router>\n\t  <NotFound default/>\n\t  {/* ... */}\n\t</Router>`
      // );
      return null;
    }
  };

  return RouterImpl;
}(React__default$1["default"].PureComponent);

RouterImpl.defaultProps = {
  primary: true
};
var FocusContext = createNamedContext("Focus");

var FocusHandler = function FocusHandler(_ref3) {
  var uri = _ref3.uri,
      location = _ref3.location,
      component = _ref3.component,
      domProps = _objectWithoutProperties(_ref3, ["uri", "location", "component"]);

  return React__default$1["default"].createElement(FocusContext.Consumer, null, function (requestFocus) {
    return React__default$1["default"].createElement(FocusHandlerImpl, _extends$1({}, domProps, {
      component: component,
      requestFocus: requestFocus,
      uri: uri,
      location: location
    }));
  });
}; // don't focus on initial render


var initialRender = true;
var focusHandlerCount = 0;

var FocusHandlerImpl = function (_React$Component2) {
  _inherits(FocusHandlerImpl, _React$Component2);

  function FocusHandlerImpl() {
    var _temp2, _this4, _ret2;

    _classCallCheck(this, FocusHandlerImpl);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this4), _this4.state = {}, _this4.requestFocus = function (node) {
      if (!_this4.state.shouldFocus && node) {
        node.focus();
      }
    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  FocusHandlerImpl.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var initial = prevState.uri == null;

    if (initial) {
      return _extends$1({
        shouldFocus: true
      }, nextProps);
    } else {
      var myURIChanged = nextProps.uri !== prevState.uri;
      var navigatedUpToMe = prevState.location.pathname !== nextProps.location.pathname && nextProps.location.pathname === nextProps.uri;
      return _extends$1({
        shouldFocus: myURIChanged || navigatedUpToMe
      }, nextProps);
    }
  };

  FocusHandlerImpl.prototype.componentDidMount = function componentDidMount() {
    focusHandlerCount++;
    this.focus();
  };

  FocusHandlerImpl.prototype.componentWillUnmount = function componentWillUnmount() {
    focusHandlerCount--;

    if (focusHandlerCount === 0) {
      initialRender = true;
    }
  };

  FocusHandlerImpl.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.location !== this.props.location && this.state.shouldFocus) {
      this.focus();
    }
  };

  FocusHandlerImpl.prototype.focus = function focus() {
    if (process.env.NODE_ENV === "test") {
      // getting cannot read property focus of null in the tests
      // and that bit of global `initialRender` state causes problems
      // should probably figure it out!
      return;
    }

    var requestFocus = this.props.requestFocus;

    if (requestFocus) {
      requestFocus(this.node);
    } else {
      if (initialRender) {
        initialRender = false;
      } else if (this.node) {
        // React polyfills [autofocus] and it fires earlier than cDM,
        // so we were stealing focus away, this line prevents that.
        if (!this.node.contains(document.activeElement)) {
          this.node.focus();
        }
      }
    }
  };

  FocusHandlerImpl.prototype.render = function render() {
    var _this5 = this;

    var _props2 = this.props;
    _props2.children;
    var style = _props2.style;
    _props2.requestFocus;
    var _props2$component = _props2.component,
        Comp = _props2$component === undefined ? "div" : _props2$component;
    _props2.uri;
    _props2.location;

    var domProps = _objectWithoutProperties(_props2, ["children", "style", "requestFocus", "component", "uri", "location"]);

    return React__default$1["default"].createElement(Comp, _extends$1({
      style: _extends$1({
        outline: "none"
      }, style),
      tabIndex: "-1",
      ref: function ref(n) {
        return _this5.node = n;
      }
    }, domProps), React__default$1["default"].createElement(FocusContext.Provider, {
      value: this.requestFocus
    }, this.props.children));
  };

  return FocusHandlerImpl;
}(React__default$1["default"].Component);

polyfill(FocusHandlerImpl);

var k = function k() {}; ////////////////////////////////////////////////////////////////////////////////


var forwardRef = React__default$1["default"].forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = function forwardRef(C) {
    return C;
  };
}

var Link$1 = forwardRef(function (_ref4, ref) {
  var innerRef = _ref4.innerRef,
      props = _objectWithoutProperties(_ref4, ["innerRef"]);

  return React__default$1["default"].createElement(BaseContext.Consumer, null, function (_ref5) {
    _ref5.basepath;
    var baseuri = _ref5.baseuri;
    return React__default$1["default"].createElement(Location, null, function (_ref6) {
      var location = _ref6.location,
          navigate = _ref6.navigate;

      var to = props.to,
          state = props.state,
          replace = props.replace,
          _props$getProps = props.getProps,
          getProps = _props$getProps === undefined ? k : _props$getProps,
          anchorProps = _objectWithoutProperties(props, ["to", "state", "replace", "getProps"]);

      var href = resolve(to, baseuri);
      var encodedHref = encodeURI(href);
      var isCurrent = location.pathname === encodedHref;
      var isPartiallyCurrent = startsWith(location.pathname, encodedHref);
      return React__default$1["default"].createElement("a", _extends$1({
        ref: ref || innerRef,
        "aria-current": isCurrent ? "page" : undefined
      }, anchorProps, getProps({
        isCurrent: isCurrent,
        isPartiallyCurrent: isPartiallyCurrent,
        href: href,
        location: location
      }), {
        href: href,
        onClick: function onClick(event) {
          if (anchorProps.onClick) anchorProps.onClick(event);

          if (shouldNavigate(event)) {
            event.preventDefault();
            var shouldReplace = replace;

            if (typeof replace !== "boolean" && isCurrent) {
              var _location$state = _extends$1({}, location.state);

              _location$state.key;

              var restState = _objectWithoutProperties(_location$state, ["key"]);

              shouldReplace = shallowCompare(_extends$1({}, state), restState);
            }

            navigate(href, {
              state: state,
              replace: shouldReplace
            });
          }
        }
      }));
    });
  });
});
Link$1.displayName = "Link";
process.env.NODE_ENV !== "production" ? Link$1.propTypes = {
  to: PropTypes.string.isRequired
} : void 0; ////////////////////////////////////////////////////////////////////////////////

function RedirectRequest(uri) {
  this.uri = uri;
}

var isRedirect = function isRedirect(o) {
  return o instanceof RedirectRequest;
};

var redirectTo = function redirectTo(to) {
  throw new RedirectRequest(to);
};

var RedirectImpl = function (_React$Component3) {
  _inherits(RedirectImpl, _React$Component3);

  function RedirectImpl() {
    _classCallCheck(this, RedirectImpl);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  } // Support React < 16 with this hook


  RedirectImpl.prototype.componentDidMount = function componentDidMount() {
    var _props3 = this.props,
        navigate = _props3.navigate,
        to = _props3.to;
    _props3.from;
    var _props3$replace = _props3.replace,
        replace = _props3$replace === undefined ? true : _props3$replace,
        state = _props3.state;
    _props3.noThrow;

    var baseuri = _props3.baseuri,
        props = _objectWithoutProperties(_props3, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);

    Promise.resolve().then(function () {
      var resolvedTo = resolve(to, baseuri);
      navigate(insertParams(resolvedTo, props), {
        replace: replace,
        state: state
      });
    });
  };

  RedirectImpl.prototype.render = function render() {
    var _props4 = this.props;
    _props4.navigate;
    var to = _props4.to;
    _props4.from;
    _props4.replace;
    _props4.state;

    var noThrow = _props4.noThrow,
        baseuri = _props4.baseuri,
        props = _objectWithoutProperties(_props4, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);

    var resolvedTo = resolve(to, baseuri);
    if (!noThrow) redirectTo(insertParams(resolvedTo, props));
    return null;
  };

  return RedirectImpl;
}(React__default$1["default"].Component);

var Redirect = function Redirect(props) {
  return React__default$1["default"].createElement(BaseContext.Consumer, null, function (_ref7) {
    var baseuri = _ref7.baseuri;
    return React__default$1["default"].createElement(Location, null, function (locationContext) {
      return React__default$1["default"].createElement(RedirectImpl, _extends$1({}, locationContext, {
        baseuri: baseuri
      }, props));
    });
  });
};

process.env.NODE_ENV !== "production" ? Redirect.propTypes = {
  from: PropTypes.string,
  to: PropTypes.string.isRequired
} : void 0; ////////////////////////////////////////////////////////////////////////////////

var Match = function Match(_ref8) {
  var path = _ref8.path,
      children = _ref8.children;
  return React__default$1["default"].createElement(BaseContext.Consumer, null, function (_ref9) {
    var baseuri = _ref9.baseuri;
    return React__default$1["default"].createElement(Location, null, function (_ref10) {
      var navigate = _ref10.navigate,
          location = _ref10.location;
      var resolvedPath = resolve(path, baseuri);
      var result = match(resolvedPath, location.pathname);
      return children({
        navigate: navigate,
        location: location,
        match: result ? _extends$1({}, result.params, {
          uri: result.uri,
          path: path
        }) : null
      });
    });
  });
}; ////////////////////////////////////////////////////////////////////////////////
// Hooks


var useLocation = function useLocation() {
  var context = React.useContext(LocationContext);

  if (!context) {
    throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
  }

  return context.location;
};

var useNavigate = function useNavigate() {
  var context = React.useContext(BaseContext);

  if (!context) {
    throw new Error("useNavigate hook was used but a BaseContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
  }

  return context.navigate;
};

var useParams = function useParams() {
  var context = React.useContext(BaseContext);

  if (!context) {
    throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
  }

  var location = useLocation();
  var results = match(context.basepath, location.pathname);
  return results ? results.params : null;
};

var useMatch = function useMatch(path) {
  if (!path) {
    throw new Error("useMatch(path: string) requires an argument of a string to match against");
  }

  var context = React.useContext(BaseContext);

  if (!context) {
    throw new Error("useMatch hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
  }

  var location = useLocation();
  var resolvedPath = resolve(path, context.baseuri);
  var result = match(resolvedPath, location.pathname);
  return result ? _extends$1({}, result.params, {
    uri: result.uri,
    path: path
  }) : null;
}; ////////////////////////////////////////////////////////////////////////////////
// Junk


var stripSlashes = function stripSlashes(str) {
  return str.replace(/(^\/+|\/+$)/g, "");
};

var createRoute = function createRoute(basepath) {
  return function (element) {
    if (!element) {
      return null;
    }

    if (element.type === React__default$1["default"].Fragment && element.props.children) {
      return React__default$1["default"].Children.map(element.props.children, createRoute(basepath));
    }

    !(element.props.path || element.props.default || element.type === Redirect) ? process.env.NODE_ENV !== "production" ? invariant_1(false, "<Router>: Children of <Router> must have a `path` or `default` prop, or be a `<Redirect>`. None found on element type `" + element.type + "`") : invariant_1(false) : void 0;
    !!(element.type === Redirect && (!element.props.from || !element.props.to)) ? process.env.NODE_ENV !== "production" ? invariant_1(false, "<Redirect from=\"" + element.props.from + "\" to=\"" + element.props.to + "\"/> requires both \"from\" and \"to\" props when inside a <Router>.") : invariant_1(false) : void 0;
    !!(element.type === Redirect && !validateRedirect(element.props.from, element.props.to)) ? process.env.NODE_ENV !== "production" ? invariant_1(false, "<Redirect from=\"" + element.props.from + " to=\"" + element.props.to + "\"/> has mismatched dynamic segments, ensure both paths have the exact same dynamic segments.") : invariant_1(false) : void 0;

    if (element.props.default) {
      return {
        value: element,
        default: true
      };
    }

    var elementPath = element.type === Redirect ? element.props.from : element.props.path;
    var path = elementPath === "/" ? basepath : stripSlashes(basepath) + "/" + stripSlashes(elementPath);
    return {
      value: element,
      default: element.props.default,
      path: element.props.children ? stripSlashes(path) + "/*" : path
    };
  };
};

var shouldNavigate = function shouldNavigate(event) {
  return !event.defaultPrevented && event.button === 0 && !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

var es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Link: Link$1,
  Location: Location,
  LocationProvider: LocationProvider,
  Match: Match,
  Redirect: Redirect,
  Router: Router,
  ServerLocation: ServerLocation,
  createHistory: createHistory,
  createMemorySource: createMemorySource,
  isRedirect: isRedirect,
  navigate: navigate,
  redirectTo: redirectTo,
  globalHistory: globalHistory,
  matchPath: match,
  useLocation: useLocation,
  useNavigate: useNavigate,
  useParams: useParams,
  useMatch: useMatch,
  resolve: resolve
});
var utils = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.shallowCompare = exports.validateRedirect = exports.insertParams = exports.resolve = exports.match = exports.pick = exports.startsWith = undefined;

  var _invariant2 = _interopRequireDefault(invariant_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } ////////////////////////////////////////////////////////////////////////////////
  // startsWith(string, search) - Check if `string` starts with `search`


  var startsWith = function startsWith(string, search) {
    return string.substr(0, search.length) === search;
  }; ////////////////////////////////////////////////////////////////////////////////
  // pick(routes, uri)
  //
  // Ranks and picks the best route to match. Each segment gets the highest
  // amount of points, then the type of segment gets an additional amount of
  // points where
  //
  //     static > dynamic > splat > root
  //
  // This way we don't have to worry about the order of our routes, let the
  // computers do it.
  //
  // A route looks like this
  //
  //     { path, default, value }
  //
  // And a returned match looks like:
  //
  //     { route, params, uri }
  //
  // I know, I should use TypeScript not comments for these types.


  var pick = function pick(routes, uri) {
    var match = void 0;
    var default_ = void 0;

    var _uri$split = uri.split("?"),
        uriPathname = _uri$split[0];

    var uriSegments = segmentize(uriPathname);
    var isRootUri = uriSegments[0] === "";
    var ranked = rankRoutes(routes);

    for (var i = 0, l = ranked.length; i < l; i++) {
      var missed = false;
      var route = ranked[i].route;

      if (route.default) {
        default_ = {
          route: route,
          params: {},
          uri: uri
        };
        continue;
      }

      var routeSegments = segmentize(route.path);
      var params = {};
      var max = Math.max(uriSegments.length, routeSegments.length);
      var index = 0;

      for (; index < max; index++) {
        var routeSegment = routeSegments[index];
        var uriSegment = uriSegments[index];

        if (isSplat(routeSegment)) {
          // Hit a splat, just grab the rest, and return a match
          // uri:   /files/documents/work
          // route: /files/*
          var param = routeSegment.slice(1) || "*";
          params[param] = uriSegments.slice(index).map(decodeURIComponent).join("/");
          break;
        }

        if (uriSegment === undefined) {
          // URI is shorter than the route, no match
          // uri:   /users
          // route: /users/:userId
          missed = true;
          break;
        }

        var dynamicMatch = paramRe.exec(routeSegment);

        if (dynamicMatch && !isRootUri) {
          var matchIsNotReserved = reservedNames.indexOf(dynamicMatch[1]) === -1;
          !matchIsNotReserved ? process.env.NODE_ENV !== "production" ? (0, _invariant2.default)(false, "<Router> dynamic segment \"" + dynamicMatch[1] + "\" is a reserved name. Please use a different name in path \"" + route.path + "\".") : (0, _invariant2.default)(false) : void 0;
          var value = decodeURIComponent(uriSegment);
          params[dynamicMatch[1]] = value;
        } else if (routeSegment !== uriSegment) {
          // Current segments don't match, not dynamic, not splat, so no match
          // uri:   /users/123/settings
          // route: /users/:id/profile
          missed = true;
          break;
        }
      }

      if (!missed) {
        match = {
          route: route,
          params: params,
          uri: "/" + uriSegments.slice(0, index).join("/")
        };
        break;
      }
    }

    return match || default_ || null;
  }; ////////////////////////////////////////////////////////////////////////////////
  // match(path, uri) - Matches just one path to a uri, also lol


  var match = function match(path, uri) {
    return pick([{
      path: path
    }], uri);
  }; ////////////////////////////////////////////////////////////////////////////////
  // resolve(to, basepath)
  //
  // Resolves URIs as though every path is a directory, no files.  Relative URIs
  // in the browser can feel awkward because not only can you be "in a directory"
  // you can be "at a file", too. For example
  //
  //     browserSpecResolve('foo', '/bar/') => /bar/foo
  //     browserSpecResolve('foo', '/bar') => /foo
  //
  // But on the command line of a file system, it's not as complicated, you can't
  // `cd` from a file, only directories.  This way, links have to know less about
  // their current path. To go deeper you can do this:
  //
  //     <Link to="deeper"/>
  //     // instead of
  //     <Link to=`{${props.uri}/deeper}`/>
  //
  // Just like `cd`, if you want to go deeper from the command line, you do this:
  //
  //     cd deeper
  //     # not
  //     cd $(pwd)/deeper
  //
  // By treating every path as a directory, linking to relative paths should
  // require less contextual information and (fingers crossed) be more intuitive.


  var resolve = function resolve(to, base) {
    // /foo/bar, /baz/qux => /foo/bar
    if (startsWith(to, "/")) {
      return to;
    }

    var _to$split = to.split("?"),
        toPathname = _to$split[0],
        toQuery = _to$split[1];

    var _base$split = base.split("?"),
        basePathname = _base$split[0];

    var toSegments = segmentize(toPathname);
    var baseSegments = segmentize(basePathname); // ?a=b, /users?b=c => /users?a=b

    if (toSegments[0] === "") {
      return addQuery(basePathname, toQuery);
    } // profile, /users/789 => /users/789/profile


    if (!startsWith(toSegments[0], ".")) {
      var pathname = baseSegments.concat(toSegments).join("/");
      return addQuery((basePathname === "/" ? "" : "/") + pathname, toQuery);
    } // ./         /users/123  =>  /users/123
    // ../        /users/123  =>  /users
    // ../..      /users/123  =>  /
    // ../../one  /a/b/c/d    =>  /a/b/one
    // .././one   /a/b/c/d    =>  /a/b/c/one


    var allSegments = baseSegments.concat(toSegments);
    var segments = [];

    for (var i = 0, l = allSegments.length; i < l; i++) {
      var segment = allSegments[i];
      if (segment === "..") segments.pop();else if (segment !== ".") segments.push(segment);
    }

    return addQuery("/" + segments.join("/"), toQuery);
  }; ////////////////////////////////////////////////////////////////////////////////
  // insertParams(path, params)


  var insertParams = function insertParams(path, params) {
    var _path$split = path.split("?"),
        pathBase = _path$split[0],
        _path$split$ = _path$split[1],
        query = _path$split$ === undefined ? "" : _path$split$;

    var segments = segmentize(pathBase);
    var constructedPath = "/" + segments.map(function (segment) {
      var match = paramRe.exec(segment);
      return match ? params[match[1]] : segment;
    }).join("/");
    var _params$location = params.location;
    _params$location = _params$location === undefined ? {} : _params$location;
    var _params$location$sear = _params$location.search,
        search = _params$location$sear === undefined ? "" : _params$location$sear;
    var searchSplit = search.split("?")[1] || "";
    constructedPath = addQuery(constructedPath, query, searchSplit);
    return constructedPath;
  };

  var validateRedirect = function validateRedirect(from, to) {
    var filter = function filter(segment) {
      return isDynamic(segment);
    };

    var fromString = segmentize(from).filter(filter).sort().join("/");
    var toString = segmentize(to).filter(filter).sort().join("/");
    return fromString === toString;
  }; ////////////////////////////////////////////////////////////////////////////////
  // Junk


  var paramRe = /^:(.+)/;
  var SEGMENT_POINTS = 4;
  var STATIC_POINTS = 3;
  var DYNAMIC_POINTS = 2;
  var SPLAT_PENALTY = 1;
  var ROOT_POINTS = 1;

  var isRootSegment = function isRootSegment(segment) {
    return segment === "";
  };

  var isDynamic = function isDynamic(segment) {
    return paramRe.test(segment);
  };

  var isSplat = function isSplat(segment) {
    return segment && segment[0] === "*";
  };

  var rankRoute = function rankRoute(route, index) {
    var score = route.default ? 0 : segmentize(route.path).reduce(function (score, segment) {
      score += SEGMENT_POINTS;
      if (isRootSegment(segment)) score += ROOT_POINTS;else if (isDynamic(segment)) score += DYNAMIC_POINTS;else if (isSplat(segment)) score -= SEGMENT_POINTS + SPLAT_PENALTY;else score += STATIC_POINTS;
      return score;
    }, 0);
    return {
      route: route,
      score: score,
      index: index
    };
  };

  var rankRoutes = function rankRoutes(routes) {
    return routes.map(rankRoute).sort(function (a, b) {
      return a.score < b.score ? 1 : a.score > b.score ? -1 : a.index - b.index;
    });
  };

  var segmentize = function segmentize(uri) {
    return uri // strip starting/ending slashes
    .replace(/(^\/+|\/+$)/g, "").split("/");
  };

  var addQuery = function addQuery(pathname) {
    for (var _len = arguments.length, query = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      query[_key - 1] = arguments[_key];
    }

    query = query.filter(function (q) {
      return q && q.length > 0;
    });
    return pathname + (query && query.length > 0 ? "?" + query.join("&") : "");
  };

  var reservedNames = ["uri", "path"];
  /**
   * Shallow compares two objects.
   * @param {Object} obj1 The first object to compare.
   * @param {Object} obj2 The second object to compare.
   */

  var shallowCompare = function shallowCompare(obj1, obj2) {
    var obj1Keys = Object.keys(obj1);
    return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function (key) {
      return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
    });
  }; ////////////////////////////////////////////////////////////////////////////////


  exports.startsWith = startsWith;
  exports.pick = pick;
  exports.match = match;
  exports.resolve = resolve;
  exports.insertParams = insertParams;
  exports.validateRedirect = validateRedirect;
  exports.shallowCompare = shallowCompare;
});
var parsePath_2 = parsePath;

function parsePath(path) {
  var pathname = path || "/";
  var search = "";
  var hash = "";
  var hashIndex = pathname.indexOf("#");

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf("?");

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === "?" ? "" : search,
    hash: hash === "#" ? "" : hash
  };
}

var parsePath_1 = /*#__PURE__*/Object.defineProperty({
  parsePath: parsePath_2
}, '__esModule', {
  value: true
});

var _reachRouter = /*@__PURE__*/getAugmentedNamespace(es);

var gatsbyLink = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.withPrefix = withPrefix;
  exports.withAssetPrefix = withAssetPrefix;
  exports.navigate = exports.default = void 0;

  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);

  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);

  var _inheritsLoose2 = interopRequireDefault(inheritsLoose);

  var _extends2 = interopRequireDefault(_extends_1);

  var _propTypes = interopRequireDefault(propTypes);

  var _react = interopRequireDefault(React__default$1["default"]);

  exports.parsePath = parsePath_1.parsePath;
  var _excluded = ["to", "getProps", "onClick", "onMouseEnter", "activeClassName", "activeStyle", "innerRef", "partiallyActive", "state", "replace", "_location"];

  var isAbsolutePath = function isAbsolutePath(path) {
    return path === null || path === void 0 ? void 0 : path.startsWith("/");
  };

  function withPrefix(path, prefix) {
    var _ref, _prefix;

    if (prefix === void 0) {
      prefix = getGlobalBasePrefix();
    }

    if (!isLocalLink(path)) {
      return path;
    }

    if (path.startsWith("./") || path.startsWith("../")) {
      return path;
    }

    var base = (_ref = (_prefix = prefix) !== null && _prefix !== void 0 ? _prefix : getGlobalPathPrefix()) !== null && _ref !== void 0 ? _ref : "/";
    return "" + (base !== null && base !== void 0 && base.endsWith("/") ? base.slice(0, -1) : base) + (path.startsWith("/") ? path : "/" + path);
  } // These global values are wrapped in typeof clauses to ensure the values exist.
  // This is especially problematic in unit testing of this component.


  var getGlobalPathPrefix = function getGlobalPathPrefix() {
    return process.env.NODE_ENV !== "production" ? typeof __PATH_PREFIX__ !== "undefined" ? __PATH_PREFIX__ : undefined : __PATH_PREFIX__;
  };

  var getGlobalBasePrefix = function getGlobalBasePrefix() {
    return process.env.NODE_ENV !== "production" ? typeof __BASE_PATH__ !== "undefined" ? __BASE_PATH__ : undefined : __BASE_PATH__;
  };

  var isLocalLink = function isLocalLink(path) {
    return path && !path.startsWith("http://") && !path.startsWith("https://") && !path.startsWith("//");
  };

  function withAssetPrefix(path) {
    return withPrefix(path, getGlobalPathPrefix());
  }

  function absolutify(path, current) {
    // If it's already absolute, return as-is
    if (isAbsolutePath(path)) {
      return path;
    }

    return (0, utils.resolve)(path, current);
  }

  var rewriteLinkPath = function rewriteLinkPath(path, relativeTo) {
    if (typeof path === "number") {
      return path;
    }

    if (!isLocalLink(path)) {
      return path;
    }

    return isAbsolutePath(path) ? withPrefix(path) : absolutify(path, relativeTo);
  };

  var NavLinkPropTypes = {
    activeClassName: _propTypes.default.string,
    activeStyle: _propTypes.default.object,
    partiallyActive: _propTypes.default.bool
  }; // Set up IntersectionObserver

  var createIntersectionObserver = function createIntersectionObserver(el, cb) {
    var io = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (el === entry.target) {
          // Check if element is within viewport, remove listener, destroy observer, and run link callback.
          // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            io.unobserve(el);
            io.disconnect();
            cb();
          }
        }
      });
    }); // Add element to the observer

    io.observe(el);
    return {
      instance: io,
      el: el
    };
  };

  function GatsbyLinkLocationWrapper(props) {
    return /*#__PURE__*/_react.default.createElement(_reachRouter.Location, null, function (_ref2) {
      var location = _ref2.location;
      return /*#__PURE__*/_react.default.createElement(GatsbyLink, (0, _extends2.default)({}, props, {
        _location: location
      }));
    });
  }

  var GatsbyLink = /*#__PURE__*/function (_React$Component) {
    (0, _inheritsLoose2.default)(GatsbyLink, _React$Component);

    function GatsbyLink(props) {
      var _this;

      _this = _React$Component.call(this, props) || this; // Default to no support for IntersectionObserver

      _this.defaultGetProps = function (_ref3) {
        var isPartiallyCurrent = _ref3.isPartiallyCurrent,
            isCurrent = _ref3.isCurrent;

        if (_this.props.partiallyActive ? isPartiallyCurrent : isCurrent) {
          return {
            className: [_this.props.className, _this.props.activeClassName].filter(Boolean).join(" "),
            style: (0, _extends2.default)({}, _this.props.style, _this.props.activeStyle)
          };
        }

        return null;
      };

      var IOSupported = false;

      if (typeof window !== "undefined" && window.IntersectionObserver) {
        IOSupported = true;
      }

      _this.state = {
        IOSupported: IOSupported
      };
      _this.handleRef = _this.handleRef.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    var _proto = GatsbyLink.prototype;

    _proto._prefetch = function _prefetch() {
      var currentPath = window.location.pathname; // reach router should have the correct state

      if (this.props._location && this.props._location.pathname) {
        currentPath = this.props._location.pathname;
      }

      var rewrittenPath = rewriteLinkPath(this.props.to, currentPath);
      var newPathName = (0, parsePath_1.parsePath)(rewrittenPath).pathname; // Prefech is used to speed up next navigations. When you use it on the current navigation,
      // there could be a race-condition where Chrome uses the stale data instead of waiting for the network to complete

      if (currentPath !== newPathName) {
        ___loader.enqueue(newPathName);
      }
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      // Preserve non IO functionality if no support
      if (this.props.to !== prevProps.to && !this.state.IOSupported) {
        this._prefetch();
      }
    };

    _proto.componentDidMount = function componentDidMount() {
      // Preserve non IO functionality if no support
      if (!this.state.IOSupported) {
        this._prefetch();
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (!this.io) {
        return;
      }

      var _this$io = this.io,
          instance = _this$io.instance,
          el = _this$io.el;
      instance.unobserve(el);
      instance.disconnect();
    };

    _proto.handleRef = function handleRef(ref) {
      var _this2 = this;

      if (this.props.innerRef && this.props.innerRef.hasOwnProperty("current")) {
        this.props.innerRef.current = ref;
      } else if (this.props.innerRef) {
        this.props.innerRef(ref);
      }

      if (this.state.IOSupported && ref) {
        // If IO supported and element reference found, setup Observer functionality
        this.io = createIntersectionObserver(ref, function () {
          _this2._prefetch();
        });
      }
    };

    _proto.render = function render() {
      var _this3 = this;

      var _this$props = this.props,
          to = _this$props.to,
          _this$props$getProps = _this$props.getProps,
          getProps = _this$props$getProps === void 0 ? this.defaultGetProps : _this$props$getProps,
          _onClick = _this$props.onClick,
          _onMouseEnter = _this$props.onMouseEnter;
      _this$props.activeClassName;
      _this$props.activeStyle;
      _this$props.innerRef;
      _this$props.partiallyActive;
      var state = _this$props.state,
          replace = _this$props.replace,
          _location = _this$props._location,
          rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);

      if (process.env.NODE_ENV !== "production" && !isLocalLink(to)) {
        console.warn("External link " + to + " was detected in a Link component. Use the Link component only for internal links. See: https://gatsby.dev/internal-links");
      }

      var prefixedTo = rewriteLinkPath(to, _location.pathname);

      if (!isLocalLink(prefixedTo)) {
        return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
          href: prefixedTo
        }, rest));
      }

      return /*#__PURE__*/_react.default.createElement(_reachRouter.Link, (0, _extends2.default)({
        to: prefixedTo,
        state: state,
        getProps: getProps,
        innerRef: this.handleRef,
        onMouseEnter: function onMouseEnter(e) {
          if (_onMouseEnter) {
            _onMouseEnter(e);
          }

          ___loader.hovering((0, parsePath_1.parsePath)(prefixedTo).pathname);
        },
        onClick: function onClick(e) {
          if (_onClick) {
            _onClick(e);
          }

          if (e.button === 0 && // ignore right clicks
          !_this3.props.target && // let browser handle "target=_blank"
          !e.defaultPrevented && // onClick prevented default
          !e.metaKey && // ignore clicks with modifier keys...
          !e.altKey && !e.ctrlKey && !e.shiftKey) {
            e.preventDefault();
            var shouldReplace = replace;

            var isCurrent = encodeURI(prefixedTo) === _location.pathname;

            if (typeof replace !== "boolean" && isCurrent) {
              shouldReplace = true;
            } // Make sure the necessary scripts and data are
            // loaded before continuing.


            window.___navigate(prefixedTo, {
              state: state,
              replace: shouldReplace
            });
          }

          return true;
        }
      }, rest));
    };

    return GatsbyLink;
  }(_react.default.Component);

  GatsbyLink.propTypes = (0, _extends2.default)({}, NavLinkPropTypes, {
    onClick: _propTypes.default.func,
    to: _propTypes.default.string.isRequired,
    replace: _propTypes.default.bool,
    state: _propTypes.default.object
  });

  var _default = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return /*#__PURE__*/_react.default.createElement(GatsbyLinkLocationWrapper, (0, _extends2.default)({
      innerRef: ref
    }, props));
  });

  exports.default = _default;

  var navigate = function navigate(to, options) {
    window.___navigate(rewriteLinkPath(to, window.location.pathname), options);
  };

  exports.navigate = navigate;
});
var Link = /*@__PURE__*/getDefaultExportFromCjs(gatsbyLink);

var _templateObject$14, _templateObject2$d, _templateObject3$8, _templateObject4$4, _templateObject5$3, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1;

var Container = styled__default["default"].footer(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n  background: ", ";\n"])), function (_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.PRIMARY_DARK : _ref$background;
  return background;
});
var NodeDescription = styled__default["default"].p(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref2) {
  var _ref2$fontFamily = _ref2.fontFamily,
      fontFamily = _ref2$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref2$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref3$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? colorsVariantsTypes.WHITE : _ref4$color;
  return getColors(colorsVariantsTypes[color]);
});
var NodeName = styled__default["default"].p(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref5) {
  var _ref5$fontFamily = _ref5.fontFamily,
      fontFamily = _ref5$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref5$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref6$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref7) {
  var _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? colorsVariantsTypes.WHITE : _ref7$color;
  return getColors(colorsVariantsTypes[color]);
});
var NodeDirection = styled__default["default"].pre(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref8) {
  var _ref8$fontFamily = _ref8.fontFamily,
      fontFamily = _ref8$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref8$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref9$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref10) {
  var _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsVariantsTypes.WHITE : _ref10$color;
  return getColors(colorsVariantsTypes[color]);
});
var NodeIconSubText = styled__default["default"].p(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref11) {
  var _ref11$fontFamily = _ref11.fontFamily,
      fontFamily = _ref11$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref11$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref12) {
  var _ref12$size = _ref12.size,
      size = _ref12$size === void 0 ? textSizesVariantsTypes.ULTRA_SMALL : _ref12$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref13) {
  var _ref13$color = _ref13.color,
      color = _ref13$color === void 0 ? colorsVariantsTypes.WHITE : _ref13$color;
  return getColors(colorsVariantsTypes[color]);
});
var LinkTitle = styled__default["default"].h3(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref14) {
  var _ref14$fontFamily = _ref14.fontFamily,
      fontFamily = _ref14$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref14$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref15) {
  var _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref15$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref16) {
  var _ref16$color = _ref16.color,
      color = _ref16$color === void 0 ? colorsVariantsTypes.WHITE : _ref16$color;
  return getColors(colorsVariantsTypes[color]);
});
var LinkItemLabel = styled__default["default"].a(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref17) {
  var _ref17$fontFamily = _ref17.fontFamily,
      fontFamily = _ref17$fontFamily === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _ref17$fontFamily;
  return getFontFamily(fontsFamiliesVariantsTypes[fontFamily]);
}, function (_ref18) {
  var _ref18$size = _ref18.size,
      size = _ref18$size === void 0 ? textSizesVariantsTypes.VERY_SMALL : _ref18$size;
  return getTextSize(textSizesVariantsTypes[size]);
}, function (_ref19) {
  var _ref19$color = _ref19.color,
      color = _ref19$color === void 0 ? colorsVariantsTypes.WHITE : _ref19$color;
  return getColors(colorsVariantsTypes[color]);
});

function Footer(_ref20) {
  var data = _ref20.data,
      _ref20$config = _ref20.config,
      config = _ref20$config === void 0 ? {} : _ref20$config,
      _ref20$background = _ref20.background,
      background = _ref20$background === void 0 ? colorsTypes.PRIMARY_DARK : _ref20$background,
      _ref20$powerByImg = _ref20.powerByImg,
      powerByImg = _ref20$powerByImg === void 0 ? "https://blossomcms.s3.amazonaws.com/blossom_logo_9fb96d3f98.png" : _ref20$powerByImg,
      _ref20$bottomSectionM = _ref20.bottomSectionMargin,
      bottomSectionMargin = _ref20$bottomSectionM === void 0 ? "3rem 0" : _ref20$bottomSectionM,
      _ref20$businessCustom = _ref20.businessCustomLogos,
      businessCustomLogos = _ref20$businessCustom === void 0 ? "" : _ref20$businessCustom,
      _ref20$homeLogoVisibl = _ref20.homeLogoVisible,
      homeLogoVisible = _ref20$homeLogoVisibl === void 0 ? true : _ref20$homeLogoVisibl,
      customIconsAlt = _ref20.customIconsAlt;
  var _data$nodeNameFontFam = data.nodeNameFontFamily,
      nodeNameFontFamily = _data$nodeNameFontFam === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$nodeNameFontFam,
      _data$nodeNameColor = data.nodeNameColor,
      nodeNameColor = _data$nodeNameColor === void 0 ? colorsVariantsTypes.WHITE : _data$nodeNameColor,
      _data$nodeNameSize = data.nodeNameSize,
      nodeNameSize = _data$nodeNameSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$nodeNameSize,
      _data$nodeDescription = data.nodeDescriptionFontFamily,
      nodeDescriptionFontFamily = _data$nodeDescription === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$nodeDescription,
      _data$nodeDescription2 = data.nodeDescriptionColor,
      nodeDescriptionColor = _data$nodeDescription2 === void 0 ? colorsVariantsTypes.WHITE : _data$nodeDescription2,
      _data$nodeDescription3 = data.nodeDescriptionSize,
      nodeDescriptionSize = _data$nodeDescription3 === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$nodeDescription3,
      _data$nodeDirectionFo = data.nodeDirectionFontFamily,
      nodeDirectionFontFamily = _data$nodeDirectionFo === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$nodeDirectionFo,
      _data$nodeDirectionCo = data.nodeDirectionColor,
      nodeDirectionColor = _data$nodeDirectionCo === void 0 ? colorsVariantsTypes.WHITE : _data$nodeDirectionCo,
      _data$nodeDirectionSi = data.nodeDirectionSize,
      nodeDirectionSize = _data$nodeDirectionSi === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$nodeDirectionSi,
      _data$nodeIconSubText = data.nodeIconSubTextFontFamily,
      nodeIconSubTextFontFamily = _data$nodeIconSubText === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$nodeIconSubText,
      _data$nodeIconSubText2 = data.nodeIconSubTextColor,
      nodeIconSubTextColor = _data$nodeIconSubText2 === void 0 ? colorsVariantsTypes.WHITE : _data$nodeIconSubText2,
      _data$nodeIconSubText3 = data.nodeIconSubTextSize,
      nodeIconSubTextSize = _data$nodeIconSubText3 === void 0 ? textSizesVariantsTypes.ULTRA_SMALL : _data$nodeIconSubText3,
      _data$LinkTitleFontFa = data.LinkTitleFontFamily,
      LinkTitleFontFamily = _data$LinkTitleFontFa === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$LinkTitleFontFa,
      _data$LinkTitleColor = data.LinkTitleColor,
      LinkTitleColor = _data$LinkTitleColor === void 0 ? colorsVariantsTypes.WHITE : _data$LinkTitleColor,
      _data$LinkTitleSize = data.LinkTitleSize,
      LinkTitleSize = _data$LinkTitleSize === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$LinkTitleSize,
      _data$LinkItemLabelFo = data.LinkItemLabelFontFamily,
      LinkItemLabelFontFamily = _data$LinkItemLabelFo === void 0 ? fontsFamiliesVariantsTypes.PRIMARY : _data$LinkItemLabelFo,
      _data$LinkItemLabelCo = data.LinkItemLabelColor,
      LinkItemLabelColor = _data$LinkItemLabelCo === void 0 ? colorsVariantsTypes.WHITE : _data$LinkItemLabelCo,
      _data$LinkItemLabelSi = data.LinkItemLabelSize,
      LinkItemLabelSize = _data$LinkItemLabelSi === void 0 ? textSizesVariantsTypes.VERY_SMALL : _data$LinkItemLabelSi;

  if (!config.footer) {
    return /*#__PURE__*/React__default$1["default"].createElement(Container, {
      className: "FOOTER Footer  tw-pt-20",
      background: background
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__CONTAINER tw-x-container tw-px-6 sm:tw-px-8 md:tw-px-0"
    }, homeLogoVisible && /*#__PURE__*/React__default$1["default"].createElement(LogoHome, null), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__INFO_ENTERPRISE_CONTAINER tw-mt-14 tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between"
    }, data && /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(InfoEnterprise, {
      data: data,
      nodeNameFontFamily: nodeNameFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      nodeNameColor: nodeNameColor || colorsVariantsTypes.WHITE,
      nodeNameSize: nodeNameSize,
      nodeDescriptionFontFamily: nodeDescriptionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      nodeDescriptionColor: nodeDescriptionColor || colorsVariantsTypes.WHITE,
      nodeDescriptionSize: nodeDescriptionSize,
      nodeDirectionFontFamily: nodeDirectionFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      nodeDirectionColor: nodeDirectionColor || colorsVariantsTypes.WHITE,
      nodeDirectionSize: nodeDirectionSize,
      nodeIconSubTextFontFamily: nodeIconSubTextFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      nodeIconSubTextColor: nodeIconSubTextColor || colorsVariantsTypes.WHITE,
      nodeIconSubTextSize: nodeIconSubTextSize
    }), /*#__PURE__*/React__default$1["default"].createElement(Links, {
      data: data,
      LinkTitleFontFamily: LinkTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      LinkTitleColor: LinkTitleColor || colorsVariantsTypes.WHITE,
      LinkTitleSize: LinkTitleSize,
      LinkItemLabelFontFamily: LinkItemLabelFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      LinkItemLabelColor: LinkItemLabelColor,
      LinkItemLabelSize: LinkItemLabelSize
    })), data && /*#__PURE__*/React__default$1["default"].createElement(Business, {
      data: data,
      customLogos: businessCustomLogos,
      nodeIconSubTextFontFamily: nodeIconSubTextFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      nodeIconSubTextColor: nodeIconSubTextColor || colorsVariantsTypes.WHITE,
      nodeIconSubTextSize: nodeIconSubTextSize || textSizesVariantsTypes.ULTRA_SMALL
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "FOOTER__DIVIDER bl-bg-grayscale-0 tw-opacity-25 tw-my-8"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__ENTERPRISE_BOX tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between md:tw-items-center tw-py-6"
    }, data && /*#__PURE__*/React__default$1["default"].createElement(Enterprise, {
      data: data
    }), !!powerByImg && /*#__PURE__*/React__default$1["default"].createElement(CorporateImage, {
      powerByImg: powerByImg
    }))), data && /*#__PURE__*/React__default$1["default"].createElement(BottomSection, {
      data: data,
      background: background,
      margin: bottomSectionMargin,
      customIconsAlt: customIconsAlt
    }));
  }

  if (config.footer === "SINGLE_PAGE") {
    return /*#__PURE__*/React__default$1["default"].createElement(Container, {
      className: "FOOTER Footer",
      background: background
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__CONTAINER tw-x-container tw-px-6 sm:tw-px-8 md:tw-px-0"
    }, homeLogoVisible && /*#__PURE__*/React__default$1["default"].createElement(LogoHome, null), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__INFO_ENTERPRISE_CONTAINER tw-mt-14 tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between"
    }, data && /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(LinksSinglePage, {
      data: data,
      LinkTitleFontFamily: LinkTitleFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      LinkTitleColor: LinkTitleColor || colorsVariantsTypes.WHITE,
      LinkTitleSize: LinkTitleSize,
      LinkItemLabelFontFamily: LinkItemLabelFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      LinkItemLabelColor: LinkItemLabelColor,
      LinkItemLabelSize: LinkItemLabelSize
    })), data && /*#__PURE__*/React__default$1["default"].createElement(BusinessSinglePage, {
      data: data,
      customLogos: businessCustomLogos,
      nodeIconSubTextFontFamily: nodeIconSubTextFontFamily || fontsFamiliesVariantsTypes.PRIMARY,
      nodeIconSubTextColor: nodeIconSubTextColor || colorsVariantsTypes.WHITE,
      nodeIconSubTextSize: nodeIconSubTextSize || textSizesVariantsTypes.ULTRA_SMALL
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "FOOTER__DIVIDER bl-bg-grayscale-0 tw-opacity-25 tw-my-8"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__ENTERPRISE_BOX tw-flex tw-flex-col md:tw-flex-row md:tw-justify-between md:tw-items-center tw-py-6"
    }, data && /*#__PURE__*/React__default$1["default"].createElement(Enterprise, {
      data: data
    }), !!powerByImg && /*#__PURE__*/React__default$1["default"].createElement(CorporateImage, {
      powerByImg: powerByImg
    }))), data && /*#__PURE__*/React__default$1["default"].createElement(BottomSection, {
      data: data,
      background: background,
      margin: bottomSectionMargin,
      customIconsAlt: customIconsAlt
    }));
  }
}

var Footer$1 = withErrorBoundary(Footer, {
  FallbackComponent: Footer
}); // --- Components ---

function LogoHome() {
  return /*#__PURE__*/React__default$1["default"].createElement(Link, {
    to: "/",
    className: "FOOTER__LOGO__LINK tw-w-full"
  }, /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: "/images/logo-white.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo"),
    className: "FOOTER__LOGO tw-w-48 tw-h-auto"
  }));
}

function InfoEnterprise(_ref21) {
  var data = _ref21.data,
      nodeNameFontFamily = _ref21.nodeNameFontFamily,
      nodeNameColor = _ref21.nodeNameColor,
      nodeNameSize = _ref21.nodeNameSize,
      nodeDescriptionFontFamily = _ref21.nodeDescriptionFontFamily,
      nodeDescriptionColor = _ref21.nodeDescriptionColor,
      nodeDescriptionSize = _ref21.nodeDescriptionSize,
      nodeDirectionFontFamily = _ref21.nodeDirectionFontFamily,
      nodeDirectionColor = _ref21.nodeDirectionColor,
      nodeDirectionSize = _ref21.nodeDirectionSize;
  return /*#__PURE__*/React__default$1["default"].createElement("div", null, (data.Office || []).map(function (office, index1) {
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
      key: "InfoEnterprise-Office-element-".concat(index1)
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__TEXT_CONTAINER"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__INFO_ENTERPRISE__CONTENT_TEXT tw-w-36 bl-text-grayscale-0 bl-text-xs tw-mb-4"
    }, /*#__PURE__*/React__default$1["default"].createElement(NodeName, {
      className: "FOOTER__OFFICE_NAME tw-font-bold tw-mb-1",
      fontFamily: nodeNameFontFamily,
      color: nodeNameColor,
      size: nodeNameSize
    }, office.name), /*#__PURE__*/React__default$1["default"].createElement(NodeDirection, {
      className: "FOOTER__OFFICE_DIRECTION tw-leading-none bl-text-grayscale-0 bl-font-primary bl-text-xs",
      fontFamily: nodeDirectionFontFamily,
      color: nodeDirectionColor,
      size: nodeDirectionSize
    }, office.direction1)), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__OFFICE_DIRECTION__ITEM__BOX bl-text-grayscale-0 bl-text-xs tw-mb-4"
    }, (office.OfficeItem || []).map(function (element, index2) {
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "InfoEnterprise-OfficeItem-element-".concat(index2),
        className: "FOOTER__OFFICE_DIRECTION__ITEM__BOX__CONTAINER tw-flex"
      }, /*#__PURE__*/React__default$1["default"].createElement(NodeName, {
        className: "FOOTER__OFFICE_DIRECTION__ITEM__BOX__CONTAINER__NAME tw-font-bold tw-mr-2",
        fontFamily: nodeNameFontFamily,
        color: nodeNameColor,
        size: nodeNameSize
      }, element.name), /*#__PURE__*/React__default$1["default"].createElement(NodeDescription, {
        className: "FOOTER__OFFICE_DIRECTION__ITEM__BOX__CONTAINER__DESCRIPTION",
        fontFamily: nodeDescriptionFontFamily,
        color: nodeDescriptionColor,
        size: nodeDescriptionSize
      }, element.description));
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "FOOTER__OFFICE_DIRECTION__ITEM__BOX__2 bl-text-grayscale-0 bl-text-xs tw-mb-8"
    }, (office.OfficeItemTwo || []).map(function (element, index2) {
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "InfoEnterprise-OfficeItemTwo-element-".concat(index2),
        className: "FOOTER__OFFICE_CONTAINER tw-flex tw-flex-wrap"
      }, /*#__PURE__*/React__default$1["default"].createElement(NodeName, {
        className: "FOOTER__OFFICE_CONTAINER__NAME tw-font-bold tw-mr-2",
        fontFamily: nodeNameFontFamily,
        color: nodeNameColor,
        size: nodeNameSize
      }, element.name), /*#__PURE__*/React__default$1["default"].createElement(NodeDescription, {
        className: "FOOTER__OFFICE_CONTAINER__DESCRIPTION",
        fontFamily: nodeDescriptionFontFamily,
        color: nodeDescriptionColor,
        size: nodeDescriptionSize
      }, element.description));
    }))));
  }), (data.Widgets || []).map(function (el, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(Widget, {
      className: "FOOTER_WIDGET",
      data: el,
      key: "widget-key-".concat(index)
    });
  }));
}

function Links(_ref22) {
  var data = _ref22.data,
      LinkTitleFontFamily = _ref22.LinkTitleFontFamily,
      LinkTitleColor = _ref22.LinkTitleColor,
      LinkTitleSize = _ref22.LinkTitleSize,
      LinkItemLabelFontFamily = _ref22.LinkItemLabelFontFamily,
      LinkItemLabelColor = _ref22.LinkItemLabelColor,
      LinkItemLabelSize = _ref22.LinkItemLabelSize;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER_LINKS_CONTAINER lg:tw-flex tw-max-w-48 lg:tw-max-w-96"
  }, (data.Links || []).map(function (element, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(LinkItem, {
      key: "Links-element-".concat(index),
      data: element,
      LinkTitleFontFamily: LinkTitleFontFamily,
      LinkTitleColor: LinkTitleColor,
      LinkTitleSize: LinkTitleSize,
      LinkItemLabelFontFamily: LinkItemLabelFontFamily,
      LinkItemLabelColor: LinkItemLabelColor,
      LinkItemLabelSize: LinkItemLabelSize
    });
  }));
}

function LinkItem(_ref23) {
  var data = _ref23.data,
      LinkTitleFontFamily = _ref23.LinkTitleFontFamily,
      LinkTitleColor = _ref23.LinkTitleColor,
      LinkTitleSize = _ref23.LinkTitleSize,
      LinkItemLabelFontFamily = _ref23.LinkItemLabelFontFamily,
      LinkItemLabelColor = _ref23.LinkItemLabelColor,
      LinkItemLabelSize = _ref23.LinkItemLabelSize;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__INDIVIDUAL_LINKS__SECTION bl-text-grayscale-0 bl-text-xs tw-mb-4 md:tw-pl-4 tw-pr-3 "
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkTitle, {
    className: "FOOTER__INDIVIDUAL_LINKS__SECTION__TITLE tw-font-bold tw-mb-2",
    fontFamily: LinkTitleFontFamily,
    color: LinkTitleColor,
    size: LinkTitleSize
  }, data.title), (data.linkItem || []).map(function (element, index) {
    var _element$url;

    var isPdf = (_element$url = element.url) === null || _element$url === void 0 ? void 0 : _element$url.endsWith(".pdf");
    return /*#__PURE__*/React__default$1["default"].createElement(LinkItemLabel, {
      key: "LinkItem-linkItem-element-".concat(index),
      href: element.url,
      target: isPdf ? "_blank" : "_self",
      className: "FOOTER__LINK__ITEM_LABEL tw-leading-6 md:tw-leading-tight tw-block hover:tw-opacity-50",
      fontFamily: LinkItemLabelFontFamily,
      color: LinkItemLabelColor,
      size: LinkItemLabelSize
    }, element.label);
  }));
}

function LinksSinglePage(_ref24) {
  var data = _ref24.data,
      LinkTitleFontFamily = _ref24.LinkTitleFontFamily,
      LinkTitleColor = _ref24.LinkTitleColor,
      LinkTitleSize = _ref24.LinkTitleSize,
      LinkItemLabelFontFamily = _ref24.LinkItemLabelFontFamily,
      LinkItemLabelColor = _ref24.LinkItemLabelColor,
      LinkItemLabelSize = _ref24.LinkItemLabelSize;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER_LINKS_CONTAINER lg:tw-flex tw-max-w-48 lg:tw-max-w-96"
  }, (data.Links || []).map(function (element, index) {
    return /*#__PURE__*/React__default$1["default"].createElement(LinkItemSinglePage, {
      key: "Links-element-".concat(index),
      data: element,
      LinkTitleFontFamily: LinkTitleFontFamily,
      LinkTitleColor: LinkTitleColor,
      LinkTitleSize: LinkTitleSize,
      LinkItemLabelFontFamily: LinkItemLabelFontFamily,
      LinkItemLabelColor: LinkItemLabelColor,
      LinkItemLabelSize: LinkItemLabelSize
    });
  }));
}

function LinkItemSinglePage(_ref25) {
  var data = _ref25.data,
      LinkTitleFontFamily = _ref25.LinkTitleFontFamily,
      LinkTitleColor = _ref25.LinkTitleColor,
      LinkTitleSize = _ref25.LinkTitleSize,
      LinkItemLabelFontFamily = _ref25.LinkItemLabelFontFamily,
      LinkItemLabelColor = _ref25.LinkItemLabelColor,
      LinkItemLabelSize = _ref25.LinkItemLabelSize;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__INDIVIDUAL_LINKS__SECTION bl-text-grayscale-0 bl-text-xs tw-mb-4 md:tw-pl-4 tw-pr-3 tw-flex tw-flex-row"
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkTitle, {
    className: "FOOTER__INDIVIDUAL_LINKS__SECTION__TITLE tw-font-bold tw-mb-2 ",
    fontFamily: LinkTitleFontFamily,
    color: LinkTitleColor,
    size: LinkTitleSize
  }, data.title), (data.linkItem || []).map(function (element, index) {
    var _element$url2;

    var isPdf = (_element$url2 = element.url) === null || _element$url2 === void 0 ? void 0 : _element$url2.endsWith(".pdf");
    return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(LinkItemLabel, {
      key: "LinkItem-linkItem-element-".concat(index),
      href: element.url,
      target: isPdf ? "_blank" : "_self",
      className: "FOOTER__LINK__ITEM_LABEL tw-leading-6 md:tw-leading-tight tw-block hover:tw-opacity-50",
      fontFamily: LinkItemLabelFontFamily,
      color: LinkItemLabelColor,
      size: LinkItemLabelSize
    }, element.label), /*#__PURE__*/React__default$1["default"].createElement("span", {
      className: "tw-mx-4 tw-mb-4 FOOTER__LINK__ITEM_PIPE-".concat(index)
    }, "|"));
  }));
}

var BusinessItemImage = styled__default["default"].img(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  filter: ", ";\n"])), function (_ref26) {
  var _ref26$invert = _ref26.invert,
      invert = _ref26$invert === void 0 ? false : _ref26$invert,
      _ref26$range = _ref26.range,
      range = _ref26$range === void 0 ? "100%" : _ref26$range;
  if (invert) return "invert(".concat(range, ")");
  return undefined;
});
var BusinessItemImageLink = styled__default["default"].a(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 4rem;\n\n  @media (max-width: 767) {\n    width: 9rem;\n  }\n"])));

var Business = function Business(_ref27) {
  var _data$Brand, _data$Brand$businessL, _data$Brand3;

  var data = _ref27.data,
      nodeIconSubTextFontFamily = _ref27.nodeIconSubTextFontFamily,
      nodeIconSubTextColor = _ref27.nodeIconSubTextColor,
      nodeIconSubTextSize = _ref27.nodeIconSubTextSize,
      _ref27$customLogos = _ref27.customLogos,
      customLogos = _ref27$customLogos === void 0 ? [] : _ref27$customLogos;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BUSINESS tw-flex tw-flex-col tw-max-w-xs tw-mt-8 tw-flex-wrap md:tw-mt-0  lg:tw-flex-row "
  }, (data === null || data === void 0 ? void 0 : (_data$Brand = data.Brand) === null || _data$Brand === void 0 ? void 0 : (_data$Brand$businessL = _data$Brand.businessLogo) === null || _data$Brand$businessL === void 0 ? void 0 : _data$Brand$businessL.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BUSINESS_IMAGES_CONTAINER tw-flex tw-flex-col tw-w-full tw-flex-wrap  lg:tw-items-end"
  }, (data.Brand.businessLogo || []).map(function (item, index) {
    var hasReplaceItem = lodash.find(customLogos, {
      replaceByIndex: index
    });
    var hasReplaceItemHasLink = hasReplaceItem && !!hasReplaceItem.linkTo;
    var image = /*#__PURE__*/React__default$1["default"].createElement(BusinessItemImage, {
      key: "Business-BusinessLogo-".concat(index),
      className: "FOOTER__BUSINESS_LOGO tw-w-36 md:tw-w-auto tw-h-16 tw-mb-6 tw-object-fill",
      src: hasReplaceItem && hasReplaceItem.url ? hasReplaceItem.url : item.url,
      alt: (item === null || item === void 0 ? void 0 : item.alternativeText) || (hasReplaceItem === null || hasReplaceItem === void 0 ? void 0 : hasReplaceItem.alternativeText) || "Bussiness Logo",
      invert: hasReplaceItem && hasReplaceItem.invert || false
    });

    if (hasReplaceItemHasLink) {
      var _data$Brand2;

      return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-relative FOOTER__BUSINESS__ITEM_IMAGE_LINK_CONTAINER"
      }, /*#__PURE__*/React__default$1["default"].createElement(BusinessItemImageLink, {
        className: "FOOTER__BUSINESS__ITEM_IMAGE_LINK",
        target: "_blank",
        href: hasReplaceItem.linkTo
      }), image), (data === null || data === void 0 ? void 0 : (_data$Brand2 = data.Brand) === null || _data$Brand2 === void 0 ? void 0 : _data$Brand2.firstIconSubText) && index === 0 && /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "FOOTER__FIRST_ICON_SUBTEXT__BOX tw-w-full bl-text-grayscale-0 tw-mb-3 bl-text-xxs tw-mt-0 md:tw-text-right tw-opacity-50"
      }, /*#__PURE__*/React__default$1["default"].createElement(NodeIconSubText, {
        className: "FOOTER__FIRST_ICON_SUBTEXT__TEXT tw-leading-4 tw-m-0 bl-text-grayscale-0 bl-font-primary bl-text-xxs",
        fontFamily: nodeIconSubTextFontFamily,
        color: nodeIconSubTextColor,
        size: nodeIconSubTextSize
      }, data.Brand.firstIconSubText)));
    }

    return image;
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__ICON_TEXT__BOX tw-w-full bl-text-grayscale-0 bl-text-xxs tw-mt-0 md:tw-text-right tw-opacity-50 md:tw-ml-5"
  }, (data === null || data === void 0 ? void 0 : (_data$Brand3 = data.Brand) === null || _data$Brand3 === void 0 ? void 0 : _data$Brand3.iconSubText) && /*#__PURE__*/React__default$1["default"].createElement(NodeIconSubText, {
    className: "FOOTER__ICON_TEXT__TEXT tw-leading-4 tw-m-0 bl-text-grayscale-0 bl-font-primary bl-text-xxs",
    fontFamily: nodeIconSubTextFontFamily,
    color: nodeIconSubTextColor,
    size: nodeIconSubTextSize
  }, data.Brand.iconSubText)));
};

function BusinessSinglePage(_ref28) {
  var _data$Brand4, _data$Brand4$business, _data$Brand5;

  var data = _ref28.data,
      nodeIconSubTextFontFamily = _ref28.nodeIconSubTextFontFamily,
      nodeIconSubTextColor = _ref28.nodeIconSubTextColor,
      nodeIconSubTextSize = _ref28.nodeIconSubTextSize,
      _ref28$customLogos = _ref28.customLogos,
      customLogos = _ref28$customLogos === void 0 ? [] : _ref28$customLogos;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BUSINESS tw-flex tw-flex-col tw-mt-8 md:tw-mt-0 lg:tw-flex-row "
  }, (data === null || data === void 0 ? void 0 : (_data$Brand4 = data.Brand) === null || _data$Brand4 === void 0 ? void 0 : (_data$Brand4$business = _data$Brand4.businessLogo) === null || _data$Brand4$business === void 0 ? void 0 : _data$Brand4$business.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BUSINESS_IMAGES_CONTAINER tw-flex tw-flex-row tw-justify-end tw-w-full lg:tw-max-h-48 "
  }, (data.Brand.businessLogo || []).map(function (item, index) {
    var hasReplaceItem = lodash.find(customLogos, {
      replaceByIndex: index
    });
    var hasReplaceItemHasLink = hasReplaceItem && !!hasReplaceItem.linkTo;
    var image = /*#__PURE__*/React__default$1["default"].createElement(BusinessItemImage, {
      key: "Business-BusinessLogo-".concat(index),
      className: "FOOTER__BUSINESS_LOGO tw-w-36 md:tw-w-auto tw-h-16 tw-object-fill tw-mb-6 md:tw-ml-5",
      src: hasReplaceItem && hasReplaceItem.url ? hasReplaceItem.url : item.url,
      alt: (item === null || item === void 0 ? void 0 : item.alternativeText) || (hasReplaceItem === null || hasReplaceItem === void 0 ? void 0 : hasReplaceItem.alternativeText) || "Bussiness Logo",
      invert: hasReplaceItem && hasReplaceItem.invert || false
    });

    if (hasReplaceItemHasLink) {
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "tw-relative FOOTER__BUSINESS__ITEM_IMAGE_LINK_CONTAINER"
      }, /*#__PURE__*/React__default$1["default"].createElement(BusinessItemImageLink, {
        className: "FOOTER__BUSINESS__ITEM_IMAGE_LINK",
        target: "_blank",
        href: hasReplaceItem.linkTo
      }), image);
    }

    return image;
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__ICON_TEXT__BOX tw-96 tw-w-full bl-text-grayscale-0 bl-text-xxs tw-mt-0 md:tw-text-right tw-opacity-50 md:tw-ml-5"
  }, (data === null || data === void 0 ? void 0 : (_data$Brand5 = data.Brand) === null || _data$Brand5 === void 0 ? void 0 : _data$Brand5.iconSubText) && /*#__PURE__*/React__default$1["default"].createElement(NodeIconSubText, {
    className: "FOOTER__ICON_TEXT__TEXT tw-leading-4 tw-m-0 bl-text-grayscale-0 bl-font-primary bl-text-xxs",
    fontFamily: nodeIconSubTextFontFamily,
    color: nodeIconSubTextColor,
    size: nodeIconSubTextSize
  }, data.Brand.iconSubText)));
}

function Enterprise(_ref29) {
  var _data$Brand6;

  var data = _ref29.data;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BRAND_DESCRIPTION_CONTAINER bl-text-grayscale-0 bl-text-xxs tw-opacity-50 tw-w-72 md:tw-w-96 lg:tw-w-160 tw-mb-8 md:tw-mb-0 tw-whitespace-pre-line"
  }, /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "FOOTER__BRAND_DESCRIPTION tw-leading-4"
  }, data === null || data === void 0 ? void 0 : (_data$Brand6 = data.Brand) === null || _data$Brand6 === void 0 ? void 0 : _data$Brand6.description));
}

var CorporateImage = function CorporateImage(_ref30) {
  var powerByImg = _ref30.powerByImg;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER_CORPORATE_CONTAINER tw-flex tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement("p", {
    className: "FOOTER__CORPORATE__TEXT bl-text-grayscale-0 bl-text-xxs tw-text-left md:tw-text-right tw-mb-0.5"
  }, "Powered by:"), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__CORPORATE_IMG tw-relative tw-mr-auto tw-ml-4",
    style: {
      width: "95px"
    }
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: "https://www.homecu.com/",
    className: "tw-w-full tw-h-full tw-absolute tw-z-50"
  }), /*#__PURE__*/React__default$1["default"].createElement("img", {
    className: "tw-w-full tw-h-auto tw-object-cover",
    src: powerByImg,
    alt: "HomeCU Logo"
  })));
};

var ButtonLeftText = styled__default["default"].p(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  color: var(--grayscale-0-color);\n"])));
var ButtonRightText = styled__default["default"].p(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  color: var(--grayscale-0-color);\n"])));
var BttmSection = styled__default["default"].div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: 1rem 0;\n  margin: ", ";\n"])), function (_ref31) {
  var _ref31$background = _ref31.background,
      background = _ref31$background === void 0 ? colorsTypes.PRIMARY_DARK : _ref31$background;
  return background;
}, function (_ref32) {
  var _ref32$margin = _ref32.margin,
      margin = _ref32$margin === void 0 ? "3rem 0" : _ref32$margin;
  return lodash.isNumber(margin) ? "".concat(margin, "px") : margin;
});

function BottomSection(_ref33) {
  var data = _ref33.data,
      _ref33$background = _ref33.background,
      background = _ref33$background === void 0 ? "var(--primary-150-color)" : _ref33$background,
      _ref33$margin = _ref33.margin,
      margin = _ref33$margin === void 0 ? "3rem 0" : _ref33$margin,
      customIconsAlt = _ref33.customIconsAlt;
  if (!(data !== null && data !== void 0 && data.Bottom)) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(BttmSection, {
    className: "FOOTER__BOTTOM_CONTAINER Footer_Bottom_Section",
    background: background,
    margin: margin
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BOTTOM_CONTAINER__BOX tw-x-container tw-px-6 sm:tw-px-8 tw-flex tw-flex-col tw-items-center md:tw-flex-row md:tw-justify-between tw-opacity-50"
  }, /*#__PURE__*/React__default$1["default"].createElement(ButtonLeftText, {
    className: "FOOTER__BOTTOM_CONTAINER__BUTTON_LEFT__TEXT tw-m-0 bl-text-grayscale-0 bl-text-xxs tw-py-2 sm:tw-py-0"
  }, "\xA9 ", new Date().getFullYear(), "\xA0", /*#__PURE__*/React__default$1["default"].createElement("span", {
    className: "FOOTER__BOTTOM_TEXT_LEFT tw-mr-2"
  }, data.Bottom.leftText), /*#__PURE__*/React__default$1["default"].createElement("span", {
    className: "tw-hidden FOOTER__BOTTOM_TEXT_RIGHT"
  }, data.Bottom.leftText)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BOTTOM_CONTAINER__ICONS__CONTAINER md:tw-flex md:tw-h-5 md:tw-h-auto md:tw-mt-0 md:tw-items-center"
  }, (data.Bottom.androidUrl || data.Bottom.appleUrl || data.Bottom.facebookUrl || data.Bottom.twitterUrl || data.Bottom.youtubeUrl || data.Bottom.linkedinUrl || data.Bottom.instagramUrl) && /*#__PURE__*/React__default$1["default"].createElement(ButtonRightText, {
    className: "FOOTER__BOTTOM_CONTAINER__BUTTON_RIGHT__TEXT tw-m-0 bl-text-grayscale-0 bl-text-xxs tw-mr-4 tw-hidden md:tw-block"
  }, data.Bottom.rightText), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-flex tw-items-center FOOTER__BOTTOM_ICON_CARD_1"
  }, /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.androidUrl,
    icon: iconTypes.ANDROID,
    customIconsAlt: customIconsAlt
  }), /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.appleUrl,
    icon: iconTypes.APPLE,
    customIconsAlt: customIconsAlt
  })), (data.Bottom.androidUrl || data.Bottom.appleUrl) && (data.Bottom.facebookUrl || data.Bottom.twitterUrl) && /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
    variant: dividersVariantsTypes.DIVIDER,
    childrenVariant: dividerVariantsTypes.VERTICAL,
    className: "FOOTER__BOTTOM_CONTAINER__DIVIDERS tw-mx-6 bl-bg-grayscale-0 tw-hidden md:tw-block tw-h-5"
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "FOOTER__BOTTOM_ICON_CARD_2 tw-flex tw-justify-center tw-items-center  md:tw-justify-start"
  }, /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.facebookUrl,
    className: "FOOTER__BOTTOM_ICON_FACEBOOK",
    icon: iconTypes.FACEBOOK,
    customIconsAlt: customIconsAlt
  }), /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.twitterUrl,
    className: "FOOTER__BOTTOM_ICON_TWITTER",
    icon: iconTypes.TWITTER,
    customIconsAlt: customIconsAlt
  }), /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.linkedinUrl,
    className: "FOOTER__BOTTOM_ICON_LINKEDIN",
    icon: iconTypes.LINKEDIN,
    customIconsAlt: customIconsAlt
  }), /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.youtubeUrl,
    className: "FOOTER__BOTTOM_ICON_YOUTUBE",
    icon: iconTypes.YOUTUBE,
    customIconsAlt: customIconsAlt
  }), /*#__PURE__*/React__default$1["default"].createElement(IconCard, {
    href: data.Bottom.instagramUrl,
    className: "FOOTER__BOTTOM_ICON_INSTAGRAM",
    icon: iconTypes.INSTAGRAM,
    customIconsAlt: customIconsAlt
  })))));
}

var IconCardLink = styled__default["default"].a(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral([""])));

function IconCard(_ref34) {
  var href = _ref34.href,
      icon = _ref34.icon,
      className = _ref34.className,
      customIconsAlt = _ref34.customIconsAlt;
  if (!href) return null;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("FOOTER__BOTTOM_ICON_CARD tw-relative tw-w-auto tw-flex tw-align-center tw-m-3 md:tw-m-0 md:tw-mx-2", className)
  }, /*#__PURE__*/React__default$1["default"].createElement(IconCardLink, {
    href: href,
    target: "_blank",
    rel: "noreferrer",
    className: "tw-absolute tw-w-full tw-h-full tw-border-none"
  }), /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    icon: icon,
    size: "20",
    stroke: "white",
    fill: "white",
    customIconsAlt: customIconsAlt
  }));
}

var _templateObject$13, _templateObject2$c, _templateObject3$7;

function Toast(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  if (data === null) data = {};

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      active = _useState2[0],
      _setActive = _useState2[1];

  var Component = ToastTypes[data.type];
  React.useEffect(function () {
    if (data.type && data.text && data.active && window.sessionStorage.getItem("toast") !== "false") {
      _setActive(true);
    }
  }, []);
  React.useEffect(function () {
    var mainTag = document.getElementsByTagName("main")[0];

    if (active) {
      var dimensionToast = document.getElementById("toast-component");
      var newPaddingTop = (dimensionToast === null || dimensionToast === void 0 ? void 0 : dimensionToast.clientHeight) || 0;
      if ((mainTag === null || mainTag === void 0 ? void 0 : mainTag.clientWidth) > 768) mainTag.style.paddingTop = "".concat(newPaddingTop, "px");else mainTag.style.paddingTop = "0px";
      return;
    }

    if (!active) mainTag.style.paddingTop = "0px";
  });

  if (active) {
    return /*#__PURE__*/React__default$1["default"].createElement(Component, {
      className: "TOAST_COMPONENT",
      data: data,
      setActive: function setActive() {
        window.sessionStorage.setItem("toast", "false");

        _setActive(false);
      }
    });
  }

  return null;
}

var ToastContainer = styled__default["default"].div(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n  height: min-content;\n  background: ", ";\n  @media (max-width: 768px) {\n    position: absolute;\n    width: 90vw;\n    margin-right: 5vw;\n    margin-left: 5vw;\n    top: calc(50vh - 50%);\n    z-index: 200;\n  }\n"])), function (_ref2) {
  var _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? "#B91C1C" : _ref2$background;
  return background;
});
var CustomButton$2 = styled__default["default"].button(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 0 6px;\n  border-radius: 50%;\n  color: var(--grayscale-0-color);\n  background: transparent;\n  border: 2px solid var(--grayscale-0-color);\n  line-height: 1.4;\n"])));
var ToastBlurBackground = styled__default["default"].div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  @media (max-width: 768px) {\n    position: absolute;\n    height: 100vh;\n    width: 100vw;\n    background: #000;\n    opacity: 0.7;\n    z-index: 199;\n  }\n"])));
var ToastTypes = {
  ALERT: function ALERT(_ref3) {
    var data = _ref3.data,
        setActive = _ref3.setActive;
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      id: "toast-component",
      className: "TOAST_MAIN_CONTAINER tw-w-full"
    }, /*#__PURE__*/React__default$1["default"].createElement(ToastBlurBackground, {
      className: "TOAST_BACKGROUND"
    }), /*#__PURE__*/React__default$1["default"].createElement(ToastContainer, {
      className: "TOAST_ALERT_CONTAINER tw-flex tw-p-4 tw-w-full tw-text-white tw-p-6"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "TOAST_SUB_CONTAINER bl-text-xs tw-flex tw-w-full"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "TOAST_TEXT tw-w-8/12 tw-text-justify tw-self-center",
      dangerouslySetInnerHTML: {
        __html: data.text
      }
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "TOAST_X_CONTAINER tw-w-4/12 tw-justify-center tw-self-center"
    }, /*#__PURE__*/React__default$1["default"].createElement(CustomButton$2, {
      className: "TOAST_X_BUTTON tw-float-right",
      onClick: setActive
    }, "x")))));
  },
  MESSAGE: function MESSAGE(_ref4) {
    var data = _ref4.data,
        setActive = _ref4.setActive;
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      id: "toast-component",
      className: "TOAST_MAIN_CONTAINER tw-w-full"
    }, /*#__PURE__*/React__default$1["default"].createElement(ToastBlurBackground, {
      className: "TOAST_BACKGROUND"
    }), /*#__PURE__*/React__default$1["default"].createElement(ToastContainer, {
      className: "TOAST_MESSAGE_CONTAINER tw-flex tw-p-4 bl-bg-primary-150 tw-w-full tw-text-white tw-p-6",
      background: colorsTypes.PRIMARY_DARK
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "TOAST_SUB_CONTAINER bl-text-xs tw-flex tw-w-full"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "TOAST_TEXT tw-w-8/12 tw-text-justify tw-self-center",
      dangerouslySetInnerHTML: {
        __html: data.text
      }
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "TOAST_X_CONTAINER tw-w-4/12 tw-justify-center tw-self-center"
    }, /*#__PURE__*/React__default$1["default"].createElement(CustomButton$2, {
      className: "TOAST_X_BUTTON tw-float-right",
      onClick: setActive
    }, "x")))));
  }
};

var _templateObject$12, _templateObject2$b, _templateObject3$6, _templateObject4$3;

var HeaderHeightInPx = 75;
var HeaderContainer = styled__default["default"].header(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n  align-self: center;\n  box-shadow: 0 2px 24px 0 var(--bl-opacity-grayscale-6);\n"])));
var DropdownsContainer = styled__default["default"].div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  background: ", ";\n\n  min-height: ", ";\n\n  * {\n    transition: all linear 120ms;\n  }\n"])), function (_ref) {
  var _ref$showBackground = _ref.showBackground,
      showBackground = _ref$showBackground === void 0 ? false : _ref$showBackground,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.WHITE : _ref$background;
  return showBackground ? background : undefined;
}, function (_ref2) {
  var _ref2$minHeight = _ref2.minHeight,
      minHeight = _ref2$minHeight === void 0 ? 0 : _ref2$minHeight;
  return minHeight;
});
var HeaderHeight = {
  minHeight: "".concat(HeaderHeightInPx, "px")
}; // const Logo = styled.img`
//   width: 180px;
//   height: auto;
//   max-height: 50px;
//   @media (max-width: 640px) {
//     width: 120px;
//   }
// `;

var Logo = styled__default["default"].img(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  object-fit: contain;\n  position: relative;\n  display: block;\n  width: auto;\n  height: 80px;\n"])));
var ActiveTopNav = styled__default["default"].div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  border-bottom: solid 3px var(--primary-color);\n"])));

var _templateObject$11;

var Title$3 = styled__default["default"].h3(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n"])));

function Login$1() {
  var _useState = React.useState({
    btnLogin: "login"
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  function onSubmitHandler(e) {
    e.preventDefault();

    if (process.env.GATSBY_CU_NAME === "GNC") {
      // Mejora: props desde el template para escoger el tipo
      var loginCU = "".concat(process.env.GATSBY_LOGIN_URL, " ").concat(query === null || query === void 0 ? void 0 : query.username);
      window.location.href = loginCU.replace(/\s+/g, ""); // Reemplaza cualquier espacio en blanco en la URL (codigo blindaje)
    } else if (process.env.GATSBY_CU_NAME === "peoples_advantage" || process.env.GATSBY_CU_NAME === "peoples-advantage" || process.env.GATSBY_CU_NAME === "lesco") {
      window.location.href = process.env.GATSBY_LOGIN_URL;
    } else {
      window.location.href = "".concat(process.env.GATSBY_LOGIN_URL, "&").concat(formatQueryUrl(query));
    }
  }

  function formatQueryUrl(queryParams) {
    return Object.entries(queryParams).map(function (_ref) {
      var _ref2 = _slicedToArray$1(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join("&");
  }

  var formMethod = "GET";
  var textLoginButton = "Login";
  var forgotText = "Forgot Login ID?";
  var forgotPasswordText = "Forgot Password?";

  if (process.env.GATSBY_CU_NAME === "GNC") {
    // formMethod = "POST";
    textLoginButton = "Account Login";
    forgotText = "Forgot Password";
  }

  if (process.env.GATSBY_CU_NAME === "arlington-municipal") {
    textLoginButton = "Online Banking";
  }

  if (process.env.GATSBY_CU_NAME === "lesco") {
    textLoginButton = "Online Account Login";
  }

  var forgotLink = function forgotLink() {
    if (process.env.GATSBY_CU_NAME === "knox" || process.env.GATSBY_CU_NAME === "eight" || process.env.GATSBY_CU_NAME === "willow_island" || process.env.GATSBY_CU_NAME === "vicksburg-railroad" || process.env.GATSBY_CU_NAME === "Vicksburg railroad" || process.env.GATSBY_CU_NAME === "capital" || process.env.GATSBY_CU_NAME === "grohio" || process.env.GATSBY_CU_NAME === "mcdowell" || process.env.GATSBY_CU_NAME === "east_orange_firemens" || process.env.GATSBY_CU_NAME === "muw_employees" || process.env.GATSBY_CU_NAME === "new_horizon" || process.env.GATSBY_CU_NAME === "new-horizon" || process.env.GATSBY_CU_NAME === "raleigh_county" || process.env.GATSBY_CU_NAME === "raleigh-county" || process.env.GATSBY_CU_NAME === "eqt" || process.env.GATSBY_CU_NAME === "EQT" || process.env.GATSBY_CU_NAME === "greater_centennial" || process.env.GATSBY_CU_NAME === "jackson_area") {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN Header-Login LOGIN__MODAL__CONTAINER tw-max-w-full tw-w-96 tw-px-8 tw-py-10"
  }, /*#__PURE__*/React__default$1["default"].createElement("form", {
    method: formMethod,
    onSubmit: onSubmitHandler,
    id: "loginform",
    name: "loginform",
    className: "HEADER_LOGIN__FORM LOGIN__MODAL__FORM"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$3, {
    className: "HEADER_LOGIN__TITLE tw-mb-10 tw-font-bold bl-text-primary-180 bl-text-xl LOGIN__MODAL__TITLE"
  }, "Secure Login"), /*#__PURE__*/React__default$1["default"].createElement(Input, {
    type: "text",
    name: "username",
    label: "Login ID",
    autoComplete: "off",
    value: query.username,
    success: !!query.username,
    error: !query.username,
    className: "HEADER_LOGIN__INPUT Header-Login_Input tw-py-4 tw-px-3 tw-rounded-lg bl-text-grayscale-100 bl-bg-grayscale-6 tw-w-full tw-block focus:tw-outline-none tw-mb-1",
    onChange: function onChange(_ref3) {
      var target = _ref3.target;
      var username = target.value;
      setQuery(_objectSpread2(_objectSpread2({}, query), {}, {
        username: username
      }));
    },
    isRequired: true
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN__FORGOT_LOGIN_ID Header-Login_ForgotLoginId tw-flex tw-justify-end tw-mb-8"
  }, forgotLink() ? /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_FORGOT_LOGIN_ID,
    className: "LOGIN__MODAL__FORGOT_A bl-text-grayscale-50"
  }, forgotText), /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_FORGOT_PASSWORD_LINK,
    className: "LOGIN__MODAL__FORGOT_A LOGIN__MODAL__FORGOT_PASSWORD bl-text-grayscale-50"
  }, forgotPasswordText)) : /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_FORGOT_LOGIN_ID,
    className: "LOGIN__MODAL__FORGOT_A bl-text-grayscale-50"
  }, forgotText)), /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    fill: buttonFillTypes.FILLED,
    className: "HEADER_LOGIN__BUTTON Header-Login_Button tw-w-full",
    disabled: !query.username,
    type: "submit"
  }, textLoginButton), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN__DESCRIPTION Header-Login_NewDigitalBanking tw-flex tw-justify-center tw-my-4"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_ENROLL_NOW,
    className: "LOGIN__MODAL__ENROLL_A bl-text-grayscale-50"
  }, "NEW TO DIGITAL BANKING? ENROLL NOW"))));
}

var _templateObject$10;

var HeaderDesktopDropdownSubItemText$1 = styled__default["default"].a(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_LIGHT : _ref$color;
  return color;
}, function (_ref2) {
  var _ref2$isHoverLink = _ref2.isHoverLink,
      isHoverLink = _ref2$isHoverLink === void 0 ? false : _ref2$isHoverLink,
      _ref2$hoverColor = _ref2.hoverColor,
      hoverColor = _ref2$hoverColor === void 0 ? "" : _ref2$hoverColor,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.PRIMARY_LIGHT : _ref2$color;
  if (isHoverLink) return hoverColor;
  return color;
});

var _templateObject$$;

var HeaderDesktopLinkDropdownTitle$1 = styled__default["default"].h5(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$color;
  return color;
});

var _templateObject$_;

var HeaderDesktopLinkDropdownContainer$1 = styled__default["default"].div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n  top: calc(\n    100% +\n      ", "px\n  );\n  background: ", ";\n"])), function (_ref) {
  var _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$separationFromTo = _ref.separationFromTop,
      separationFromTop = _ref$separationFromTo === void 0 ? 20 : _ref$separationFromTo,
      _ref$separationFromBo = _ref.separationFromBottom,
      separationFromBottom = _ref$separationFromBo === void 0 ? 50 : _ref$separationFromBo;
  return topIndicator ? separationFromTop : separationFromBottom;
}, function (_ref2) {
  var _ref2$grayscaleBackgr = _ref2.grayscaleBackgroundColor,
      grayscaleBackgroundColor = _ref2$grayscaleBackgr === void 0 ? colorsTypes.WHITE : _ref2$grayscaleBackgr,
      _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref2$backgroundColor,
      _ref2$grayscale = _ref2.grayscale,
      grayscale = _ref2$grayscale === void 0 ? false : _ref2$grayscale;
  return grayscale ? grayscaleBackgroundColor : backgroundColor;
});

function HeaderDesktopLinkDropdown$1(_ref) {
  var menuItem = _ref.menuItem,
      _ref$currentPath = _ref.currentPath,
      currentPath = _ref$currentPath === void 0 ? {} : _ref$currentPath,
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? "/" : _ref$pathname,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$titleColor,
      _ref$itemTextColor = _ref.itemTextColor,
      itemTextColor = _ref$itemTextColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$itemTextColor,
      _ref$itemTextActiveCo = _ref.itemTextActiveColor,
      itemTextActiveColor = _ref$itemTextActiveCo === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$itemTextActiveCo,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$backgroundColor,
      _ref$grayscaleBackgro = _ref.grayscaleBackgroundColor,
      grayscaleBackgroundColor = _ref$grayscaleBackgro === void 0 ? colorsTypes.WHITE : _ref$grayscaleBackgro,
      _ref$separationFromTo = _ref.separationFromTop,
      separationFromTop = _ref$separationFromTo === void 0 ? 20 : _ref$separationFromTo,
      _ref$separationFromBo = _ref.separationFromBottom,
      separationFromBottom = _ref$separationFromBo === void 0 ? 50 : _ref$separationFromBo;
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkDropdownContainer$1, {
    separationFromTop: separationFromTop,
    separationFromBottom: separationFromBottom,
    grayscale: grayscale,
    grayscaleBackgroundColor: grayscaleBackgroundColor,
    backgroundColor: backgroundColor,
    topIndicator: topIndicator,
    className: "HEADER_DESKTOP__LINK__DROPDOWN HeaderDesktopLinkDropdownContainer tw-px-8 tw-rounded-b tw-flex tw-absolute tw-text-gray-700 group-hover:tw-block bl-text-sm"
  }, menuItem.subLinks.map(function (items, i) {
    var keys = Object.keys(items);
    return /*#__PURE__*/React__default$1["default"].createElement("ul", {
      key: "HeaderLinkDropdown-items-".concat(i),
      className: "HEADER_DESKTOP__LINK__DROPDOWN__LINTE HeaderLinkDropdown-items tw-py-10 tw-w-52"
    }, items.title && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkDropdownTitle$1, {
      color: titleColor,
      className: "HEADER_DESKTOP__LINK__DROPDOWN__LIST__TITLE HeaderDesktopLinkDropdownTitle tw-py-2 tw-px-4 tw-font-bold tw-block tw-whitespace-no-wrap"
    }, items.title), keys.map(function (key, index) {
      var url = items["url".concat(index)];
      var text = items["text".concat(index)];
      if (!url || !text) return null;
      var isExternal = url.endsWith(".pdf") || url.endsWith(".html");
      var isItemActive = currentPath && currentPath.isCurrentPath && new RegExp(currentPath.value, "gi").test(text) && currentPath.url && currentPath.url.value === url && active;
      if (pathname === "/") isItemActive = false; // if (url === "/savings-rates") debugger;

      return /*#__PURE__*/React__default$1["default"].createElement("li", {
        className: "HEADER_DESKTOP__LINK__DROPDOWN__LIST__ITEM",
        key: "HeaderDropdownSubContainer-subItem-".concat(key)
      }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDropdownSubItemText$1, {
        isHoverLink: true,
        target: isExternal ? "_blank" : "_self",
        hoverColor: itemTextActiveColor,
        color: isItemActive ? itemTextActiveColor : itemTextColor,
        className: classnames("HEADER_DESKTOP__LINK__DROPDOWN__LIST__ITEM__TEXT HeaderDesktopDropdownSubItemText tw-rounded-b tw-py-2 tw-px-4 tw-block tw-whitespace-no-wrap", isItemActive ? "tw-font-bold HEADER_DESKTOP__LINK__DROPDOWN__LIST__ITEM__TEXT_ACTIVE" : "bl-text-grayscale-50"),
        href: url
      }, text));
    }));
  }));
}

var _templateObject$Z;

var HeaderDesktopLinkWithSubLinksIcon$1 = styled__default["default"](Icon)(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n  filter: ", ";\n"])), function (_ref) {
  var _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$filterEffect = _ref.filterEffect,
      filterEffect = _ref$filterEffect === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$filterEffect,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow;

  if (forceShow) return undefined;

  if (!!_float && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return filterEffect.join(" ");
  }

  return undefined;
});

var _templateObject$Y;

var HeaderDesktopLinkWithSubLinksButton$1 = styled__default["default"].button(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n  padding: 1rem 1.25rem;\n  font-family: ", ";\n\n  font-family: ", ";\n\n  background: ", ";\n\n  span {\n    color: ", ";\n  }\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref2) {
  var _ref2$primaryFamily = _ref2.primaryFamily,
      primaryFamily = _ref2$primaryFamily === void 0 ? false : _ref2$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref3) {
  var _ref3$grayscale = _ref3.grayscale,
      grayscale = _ref3$grayscale === void 0 ? false : _ref3$grayscale,
      _ref3$transparent = _ref3.transparent,
      transparent = _ref3$transparent === void 0 ? false : _ref3$transparent,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible,
      _ref3$grayscaleBackgr = _ref3.grayscaleBackgroundColor,
      grayscaleBackgroundColor = _ref3$grayscaleBackgr === void 0 ? colorsTypes.WHITE : _ref3$grayscaleBackgr,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$backgroundColor,
      _ref3$transparentBack = _ref3.transparentBackgroundColor,
      transparentBackgroundColor = _ref3$transparentBack === void 0 ? colorsTypes.TRANSPARENT : _ref3$transparentBack;
  if (!isVisible) return undefined;
  if (transparent) return transparentBackgroundColor;
  if (grayscale) return grayscaleBackgroundColor; // return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT;

  return backgroundColor;
}, function (_ref4) {
  var _ref4$float = _ref4["float"],
      _float = _ref4$float === void 0 ? false : _ref4$float,
      _ref4$forceShow = _ref4.forceShow,
      forceShow = _ref4$forceShow === void 0 ? false : _ref4$forceShow,
      _ref4$transparent = _ref4.transparent,
      transparent = _ref4$transparent === void 0 ? false : _ref4$transparent,
      _ref4$grayscale = _ref4.grayscale,
      grayscale = _ref4$grayscale === void 0 ? false : _ref4$grayscale,
      _ref4$scrollY = _ref4.scrollY,
      scrollY = _ref4$scrollY === void 0 ? 0 : _ref4$scrollY,
      _ref4$backgroundBreak = _ref4.backgroundBreakpoint,
      backgroundBreakpoint = _ref4$backgroundBreak === void 0 ? 20 : _ref4$backgroundBreak,
      _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref4$color,
      _ref4$transparentColo = _ref4.transparentColor,
      transparentColor = _ref4$transparentColo === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref4$transparentColo,
      _ref4$transparentGray = _ref4.transparentGrayscaleColor,
      transparentGrayscaleColor = _ref4$transparentGray === void 0 ? colorsTypes.WHITE : _ref4$transparentGray,
      _ref4$forceShowColor = _ref4.forceShowColor,
      forceShowColor = _ref4$forceShowColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref4$forceShowColor;

  if (forceShow) return forceShowColor;

  if (!!_float && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    if (transparent) {
      if (grayscale) return transparentGrayscaleColor;
      return transparentColor;
    }

    return color;
  }

  return undefined;
});

var _templateObject$X;

var HeaderDesktopLinkWithSubLinksContainer$1 = styled__default["default"].div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n  display: grid;\n  z-index: ", ";\n  margin: auto 40px auto 0;\n  border-style: solid;\n  height: min-content;\n\n  border-top-width: ", "px;\n\n  border-color: ", ";\n\n  border-bottom-width: ", "px;\n\n  border-top-width: ", "px;\n\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n\n    /*\n    border-top-width: ", "px;\n\n    border-bottom-width: ", "px;\n\n    border-color: ", ";\n    */\n  }\n"])), function (_ref) {
  var _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible;
  return isVisible ? 100 : 50;
}, function (_ref2) {
  var _ref2$disableBorder = _ref2.disableBorder,
      disableBorder = _ref2$disableBorder === void 0 ? false : _ref2$disableBorder,
      _ref2$isVisible = _ref2.isVisible,
      isVisible = _ref2$isVisible === void 0 ? false : _ref2$isVisible,
      _ref2$topIndicator = _ref2.topIndicator,
      topIndicator = _ref2$topIndicator === void 0 ? true : _ref2$topIndicator;
  return topIndicator && isVisible || !disableBorder ? 2 : 0;
}, function (_ref3) {
  var _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$borderColor,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible,
      _ref3$disableBorder = _ref3.disableBorder,
      disableBorder = _ref3$disableBorder === void 0 ? false : _ref3$disableBorder;
  if (disableBorder) return undefined;
  if (isVisible || active) return borderColor;
  return colorsTypes.TRANSPARENT;
}, function (_ref4) {
  var _ref4$disableBorder = _ref4.disableBorder,
      disableBorder = _ref4$disableBorder === void 0 ? false : _ref4$disableBorder,
      _ref4$active = _ref4.active,
      active = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$isVisible = _ref4.isVisible,
      isVisible = _ref4$isVisible === void 0 ? false : _ref4$isVisible,
      _ref4$topIndicator = _ref4.topIndicator,
      topIndicator = _ref4$topIndicator === void 0 ? true : _ref4$topIndicator;
  if (disableBorder) return undefined;
  return !topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref5) {
  var _ref5$disableBorder = _ref5.disableBorder,
      disableBorder = _ref5$disableBorder === void 0 ? false : _ref5$disableBorder,
      _ref5$active = _ref5.active,
      active = _ref5$active === void 0 ? false : _ref5$active,
      _ref5$isVisible = _ref5.isVisible,
      isVisible = _ref5$isVisible === void 0 ? false : _ref5$isVisible,
      _ref5$topIndicator = _ref5.topIndicator,
      topIndicator = _ref5$topIndicator === void 0 ? true : _ref5$topIndicator;
  if (disableBorder) return undefined;
  return topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref6) {
  var _ref6$backgroundColor = _ref6.backgroundColor,
      backgroundColor = _ref6$backgroundColor === void 0 ? colorsTypes.WHITE : _ref6$backgroundColor,
      _ref6$transparentBack = _ref6.transparentBackgroundColor,
      transparentBackgroundColor = _ref6$transparentBack === void 0 ? colorsTypes.TRANSPARENT : _ref6$transparentBack,
      _ref6$activeBackgroun = _ref6.activeBackgroundColor,
      activeBackgroundColor = _ref6$activeBackgroun === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref6$activeBackgroun,
      _ref6$isVisible = _ref6.isVisible,
      isVisible = _ref6$isVisible === void 0 ? false : _ref6$isVisible,
      _ref6$active = _ref6.active,
      active = _ref6$active === void 0 ? false : _ref6$active,
      _ref6$transparent = _ref6.transparent,
      transparent = _ref6$transparent === void 0 ? false : _ref6$transparent;
  if (isVisible || active) return activeBackgroundColor;
  if (transparent) return transparentBackgroundColor;
  return backgroundColor;
}, function (_ref7) {
  var _ref7$hoverBackground = _ref7.hoverBackground,
      hoverBackground = _ref7$hoverBackground === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref7$hoverBackground;
  return getColors(hoverBackground);
}, function (_ref8) {
  var _ref8$isVisible = _ref8.isVisible,
      isVisible = _ref8$isVisible === void 0 ? false : _ref8$isVisible,
      _ref8$active = _ref8.active,
      active = _ref8$active === void 0 ? false : _ref8$active,
      _ref8$transparent = _ref8.transparent,
      transparent = _ref8$transparent === void 0 ? false : _ref8$transparent,
      _ref8$topIndicator = _ref8.topIndicator,
      topIndicator = _ref8$topIndicator === void 0 ? true : _ref8$topIndicator;

  if (active && transparent && isVisible) {
    if (!topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref9) {
  var _ref9$isVisible = _ref9.isVisible,
      isVisible = _ref9$isVisible === void 0 ? false : _ref9$isVisible,
      _ref9$active = _ref9.active,
      active = _ref9$active === void 0 ? false : _ref9$active,
      _ref9$transparent = _ref9.transparent,
      transparent = _ref9$transparent === void 0 ? false : _ref9$transparent,
      _ref9$topIndicator = _ref9.topIndicator,
      topIndicator = _ref9$topIndicator === void 0 ? true : _ref9$topIndicator;

  if (active && transparent && isVisible) {
    if (topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref10) {
  var _ref10$grayscale = _ref10.grayscale,
      grayscale = _ref10$grayscale === void 0 ? false : _ref10$grayscale,
      _ref10$transparent = _ref10.transparent,
      transparent = _ref10$transparent === void 0 ? false : _ref10$transparent,
      _ref10$dark = _ref10.dark,
      dark = _ref10$dark === void 0 ? false : _ref10$dark,
      _ref10$isVisible = _ref10.isVisible,
      isVisible = _ref10$isVisible === void 0 ? false : _ref10$isVisible;

  if (transparent && !isVisible) {
    if (grayscale) {
      if (dark) return colorsTypes.BLACK;
      return colorsTypes.WHITE;
    }

    return colorsTypes.PRIMARY_SEMI_DARK;
  }

  return "none";
});

var _templateObject$W, _templateObject2$a;

var HeaderDesktopLinkWithSubLinksTitle$1 = styled__default["default"].span(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$color,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$activeColor,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible;
  return isVisible ? activeColor : color;
});
var DarkOpacityScreenMenu$1 = styled__default["default"].div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n"])), function (_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColorScreen,
      backgroundColorScreen = _ref2$backgroundColor === void 0 ? "rgba(0,0,0, 0.45)" : _ref2$backgroundColor;
  return backgroundColorScreen;
});

function HeaderDesktopLinkWithSubLinks(_ref3) {
  var activeBorderClass = _ref3.activeBorderClass,
      menuItem = _ref3.menuItem,
      _ref3$currentPath = _ref3.currentPath,
      currentPath = _ref3$currentPath === void 0 ? {} : _ref3$currentPath,
      pathname = _ref3.pathname,
      _ref3$float = _ref3["float"],
      _float = _ref3$float === void 0 ? false : _ref3$float,
      _ref3$scrollY = _ref3.scrollY,
      scrollY = _ref3$scrollY === void 0 ? 0 : _ref3$scrollY,
      _ref3$backgroundBreak = _ref3.backgroundBreakpoint,
      backgroundBreakpoint = _ref3$backgroundBreak === void 0 ? 20 : _ref3$backgroundBreak,
      _ref3$transparent = _ref3.transparent,
      transparent = _ref3$transparent === void 0 ? false : _ref3$transparent,
      _ref3$isTopBorder = _ref3.isTopBorder,
      isTopBorder = _ref3$isTopBorder === void 0 ? false : _ref3$isTopBorder,
      _ref3$forceShow = _ref3.forceShow,
      forceShow = _ref3$forceShow === void 0 ? false : _ref3$forceShow,
      _ref3$grayscale = _ref3.grayscale,
      grayscale = _ref3$grayscale === void 0 ? false : _ref3$grayscale,
      _ref3$dark = _ref3.dark,
      dark = _ref3$dark === void 0 ? false : _ref3$dark,
      _ref3$backgroundScree = _ref3.backgroundScreenActive,
      backgroundScreenActive = _ref3$backgroundScree === void 0 ? false : _ref3$backgroundScree,
      _ref3$forceShowColor = _ref3.forceShowColor,
      forceShowColor = _ref3$forceShowColor === void 0 ? false : _ref3$forceShowColor,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? colorsTypes.TRANSPARENT : _ref3$backgroundColor,
      _ref3$activeTopBorder = _ref3.activeTopBorderColor,
      activeTopBorderColor = _ref3$activeTopBorder === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$activeTopBorder,
      _ref3$activeBackgroun = _ref3.activeBackgroundColor,
      activeBackgroundColor = _ref3$activeBackgroun === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$activeBackgroun,
      _ref3$hoverBackground = _ref3.hoverBackground,
      hoverBackground = _ref3$hoverBackground === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref3$hoverBackground,
      _ref3$hoverBorderColo = _ref3.hoverBorderColor,
      hoverBorderColor = _ref3$hoverBorderColo === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$hoverBorderColo,
      _ref3$titleColor = _ref3.titleColor,
      titleColor = _ref3$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref3$titleColor,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$borderColor,
      _ref3$subItemTitleCol = _ref3.subItemTitleColor,
      subItemTitleColor = _ref3$subItemTitleCol === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref3$subItemTitleCol,
      _ref3$subItemTitleAct = _ref3.subItemTitleActiveColor,
      subItemTitleActiveColor = _ref3$subItemTitleAct === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$subItemTitleAct,
      _ref3$subItemTextColo = _ref3.subItemTextColor,
      subItemTextColor = _ref3$subItemTextColo === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref3$subItemTextColo,
      _ref3$subItemTextActi = _ref3.subItemTextActiveColor,
      subItemTextActiveColor = _ref3$subItemTextActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$subItemTextActi,
      _ref3$menuSubLinksTit = _ref3.menuSubLinksTitleActiveColor,
      menuSubLinksTitleActiveColor = _ref3$menuSubLinksTit === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$menuSubLinksTit,
      _ref3$topIndicator = _ref3.topIndicator,
      topIndicator = _ref3$topIndicator === void 0 ? true : _ref3$topIndicator,
      _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$disableBorder = _ref3.disableBorder,
      disableBorder = _ref3$disableBorder === void 0 ? false : _ref3$disableBorder,
      _ref3$subMenuBackgrou = _ref3.subMenuBackgroundColor,
      subMenuBackgroundColor = _ref3$subMenuBackgrou === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$subMenuBackgrou,
      _ref3$subMenuGrayscal = _ref3.subMenuGrayscaleBackgroundColor,
      subMenuGrayscaleBackgroundColor = _ref3$subMenuGrayscal === void 0 ? colorsTypes.WHITE : _ref3$subMenuGrayscal,
      _ref3$dropdownSeparat = _ref3.dropdownSeparationFromTop,
      dropdownSeparationFromTop = _ref3$dropdownSeparat === void 0 ? 20 : _ref3$dropdownSeparat,
      _ref3$dropdownSeparat2 = _ref3.dropdownSeparationFromBottom,
      dropdownSeparationFromBottom = _ref3$dropdownSeparat2 === void 0 ? 50 : _ref3$dropdownSeparat2;

  var _useClickOut = useClickOut(false),
      ref = _useClickOut.ref,
      isVisible = _useClickOut.isVisible,
      setIsVisible = _useClickOut.setIsVisible;

  function updateWhenClick() {
    setIsVisible(function (current) {
      return !current;
    });
  }

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksContainer$1, {
    transparent: transparent,
    isTopBorder: isTopBorder,
    topIndicator: topIndicator,
    backgroundColor: backgroundColor,
    activeBackgroundColor: activeBackgroundColor,
    grayscale: grayscale,
    dark: dark,
    isVisible: isVisible,
    disableBorder: disableBorder,
    active: active,
    activeTopBorderColor: activeTopBorderColor,
    hoverBackground: hoverBackground,
    borderColor: borderColor,
    hoverBorderColor: hoverBorderColor || activeTopBorderColor,
    className: classnames("HEADER_DESKTOP__LINK__SUB_LINKS HeaderDesktopLinkWithSubLinksContainer tw-z-50 tw-align-text-top ", classnames(activeBorderClass, addClassHeaderOnScroll({
      "float": _float,
      scrollY: scrollY,
      backgroundBreakpoint: backgroundBreakpoint,
      transparent: transparent,
      classTag: "HEADER_DESKTOP__LINK__SUB_LINKS"
    }), isVisible ? "HEADER_DESKTOP__LINK__SUB_LINKS__OPEN" : "HEADER_DESKTOP__LINK__SUB_LINKS__CLOSE"))
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DESKTOP__LINK__SUB_LINKS__CONTAINER tw-inline-block tw-relative tw-w-full tw-flex-1 tw-flex tw-justify-center tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksButton$1, {
    topIndicator: topIndicator,
    ref: ref,
    onClick: updateWhenClick,
    isVisible: active && isVisible,
    grayscale: grayscale,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    backgroundColor: isVisible ? subMenuBackgroundColor : undefined,
    grayscaleBackgroundColor: isVisible ? subMenuGrayscaleBackgroundColor : undefined,
    transparent: transparent,
    forceShow: forceShow,
    forceShowColor: forceShowColor,
    primaryFamily: active && isVisible,
    type: "button",
    className: "HEADER_DESKTOP__LINK__SUB_LINKS__CONTAINER__BOX HeaderDesktopLinkWithSubLinksButton bl-text-xs focus:tw-outline-none active:bl-text-primary tw-flex tw-items-center tw-justify-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksTitle$1, {
    isVisible: active || isVisible,
    className: "HEADER_DESKTOP__LINK_WITH_SUBMIT__LINKS__TITLE HeaderDesktopLinkWithSubLinksTitle tw-mr-2 tw-font-medium",
    color: titleColor
  }, menuItem.text), /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksIcon$1, {
    size: 12,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    forceShow: forceShow,
    icon: isVisible ? iconTypes.ARROW_UP_1 : iconTypes.ARROW_DOWN_1,
    className: "HEADER_DESKTOP__LINK_WITH_SUBMIT__LINKS__ICON HeaderDesktopLinkWithSubLinksIcon"
  })), isVisible && backgroundScreenActive && /*#__PURE__*/React__default$1["default"].createElement(DarkOpacityScreenMenu$1, {
    className: "HEADER_DESKTOP_LINK_WITH_SUB_LINKS__DARK_OPACITY_SCREEN_MENU"
  }), isVisible && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkDropdown$1, {
    separationFromTop: dropdownSeparationFromTop,
    separationFromBottom: dropdownSeparationFromBottom,
    backgroundColor: subMenuBackgroundColor,
    grayscaleBackgroundColor: subMenuGrayscaleBackgroundColor,
    active: active && isVisible,
    itemTextColor: subItemTextColor,
    itemTextActiveColor: subItemTextActiveColor,
    menuSubLinksTitleActiveColor: menuSubLinksTitleActiveColor,
    grayscale: grayscale,
    topIndicator: topIndicator,
    menuItem: menuItem,
    currentPath: currentPath,
    pathname: pathname,
    titleColor: active ? subItemTitleActiveColor : subItemTitleColor,
    className: "HEADER_DESKTOP_DROPDOWN HeaderDesktopLinkDropdown"
  })));
}

var _templateObject$V, _templateObject2$9;

var LinkNormalText$1 = styled__default["default"](Link)(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n  padding: 0.5rem;\n  display: grid;\n  z-index: 50;\n  border-style: solid;\n  height: min-content;\n  background: transparent;\n  margin: auto 20px auto 0;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  border-color: ", ";\n\n  border-bottom-width: ", "px;\n\n  border-top-width: ", "px;\n\n  &:hover {\n    color: ", ";\n\n    background: ", ";\n  }\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref2) {
  var _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$float = _ref2["float"],
      _float = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$backgroundBreak = _ref2.backgroundBreakpoint,
      backgroundBreakpoint = _ref2$backgroundBreak === void 0 ? 20 : _ref2$backgroundBreak,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref2$color;

  if (forceShow) return undefined;

  if (!!_float && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return color;
  }

  return undefined;
}, function (_ref3) {
  var _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$borderColor,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible;
  if (isVisible || active) return borderColor;
  return colorsTypes.TRANSPARENT;
}, function (_ref4) {
  var _ref4$active = _ref4.active,
      active = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$isVisible = _ref4.isVisible,
      isVisible = _ref4$isVisible === void 0 ? false : _ref4$isVisible,
      _ref4$topIndicator = _ref4.topIndicator,
      topIndicator = _ref4$topIndicator === void 0 ? true : _ref4$topIndicator;
  return !topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref5) {
  var _ref5$active = _ref5.active,
      active = _ref5$active === void 0 ? false : _ref5$active,
      _ref5$isVisible = _ref5.isVisible,
      isVisible = _ref5$isVisible === void 0 ? false : _ref5$isVisible,
      _ref5$topIndicator = _ref5.topIndicator,
      topIndicator = _ref5$topIndicator === void 0 ? true : _ref5$topIndicator;
  return topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref6) {
  var _ref6$float = _ref6["float"],
      _float2 = _ref6$float === void 0 ? false : _ref6$float,
      _ref6$transparent = _ref6.transparent,
      transparent = _ref6$transparent === void 0 ? false : _ref6$transparent,
      _ref6$scrollY = _ref6.scrollY,
      scrollY = _ref6$scrollY === void 0 ? 0 : _ref6$scrollY,
      _ref6$backgroundBreak = _ref6.backgroundBreakpoint,
      backgroundBreakpoint = _ref6$backgroundBreak === void 0 ? 20 : _ref6$backgroundBreak,
      _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsTypes.WHITE : _ref6$color;

  if (transparent) return color;
  if (scrollY <= backgroundBreakpoint || scrollY === 0) return color;
  if (!scrollY) return color;
  if (!!_float2 && !!Number(scrollY)) return color;
  return undefined;
}, function (_ref7) {
  var _ref7$grayscale = _ref7.grayscale,
      grayscale = _ref7$grayscale === void 0 ? false : _ref7$grayscale,
      _ref7$transparent = _ref7.transparent,
      transparent = _ref7$transparent === void 0 ? false : _ref7$transparent;
  if (transparent) return "none";
  if (grayscale) return colorsTypes.VERY_ULTRA_LIGHT;
  return colorsTypes.HIGHT_LIGHT_PRIMARY;
});
var LinkNormalAText$1 = styled__default["default"].a(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  height: ", ";\n  margin: auto 20px auto 0;\n  padding: 1rem 0.25rem;\n  font-family: ", ";\n\n  color: ", ";\n\n  border-top-width: ", "px;\n\n  border-bottom-width: ", "px;\n\n  border-color: ", ";\n\n  &:hover {\n    color: ", ";\n\n    background: ", ";\n\n    border-color: ", ";\n  }\n"])), function (_ref8) {
  var _ref8$height = _ref8.height,
      height = _ref8$height === void 0 ? "min-content" : _ref8$height;
  return lodash.isNumber(height) ? "".concat(height, "px") : height;
}, function (_ref9) {
  var _ref9$primaryFamily = _ref9.primaryFamily,
      primaryFamily = _ref9$primaryFamily === void 0 ? false : _ref9$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref10) {
  var _ref10$float = _ref10["float"],
      _float3 = _ref10$float === void 0 ? false : _ref10$float,
      _ref10$forceShow = _ref10.forceShow,
      forceShow = _ref10$forceShow === void 0 ? false : _ref10$forceShow,
      _ref10$scrollY = _ref10.scrollY,
      scrollY = _ref10$scrollY === void 0 ? 0 : _ref10$scrollY,
      _ref10$backgroundBrea = _ref10.backgroundBreakpoint,
      backgroundBreakpoint = _ref10$backgroundBrea === void 0 ? 20 : _ref10$backgroundBrea,
      _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsTypes.WHITE : _ref10$color,
      _ref10$isActive = _ref10.isActive,
      isActive = _ref10$isActive === void 0 ? false : _ref10$isActive,
      _ref10$titleActiveCol = _ref10.titleActiveColor,
      titleActiveColor = _ref10$titleActiveCol === void 0 ? colorsTypes.WHITE : _ref10$titleActiveCol;

  if (forceShow) return undefined;
  if (isActive) return titleActiveColor;

  if (!!_float3 && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return color;
  }

  return undefined;
}, function (_ref11) {
  var _ref11$transparent = _ref11.transparent,
      transparent = _ref11$transparent === void 0 ? false : _ref11$transparent,
      _ref11$topIndicator = _ref11.topIndicator,
      topIndicator = _ref11$topIndicator === void 0 ? true : _ref11$topIndicator;

  if (transparent) {
    if (!topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref12) {
  var _ref12$transparent = _ref12.transparent,
      transparent = _ref12$transparent === void 0 ? false : _ref12$transparent,
      _ref12$topIndicator = _ref12.topIndicator,
      topIndicator = _ref12$topIndicator === void 0 ? true : _ref12$topIndicator;

  if (transparent) {
    if (topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref13) {
  var _ref13$grayscale = _ref13.grayscale,
      grayscale = _ref13$grayscale === void 0 ? false : _ref13$grayscale,
      _ref13$transparent = _ref13.transparent,
      transparent = _ref13$transparent === void 0 ? false : _ref13$transparent,
      _ref13$dark = _ref13.dark,
      dark = _ref13$dark === void 0 ? false : _ref13$dark,
      _ref13$isActive = _ref13.isActive,
      isActive = _ref13$isActive === void 0 ? false : _ref13$isActive,
      _ref13$activeBorderCo = _ref13.activeBorderColor,
      activeBorderColor = _ref13$activeBorderCo === void 0 ? colorsTypes.TRANSPARENT : _ref13$activeBorderCo;

  if (transparent && isActive) {
    if (isActive) return activeBorderColor;
    if (dark) return colorsTypes.BLACK;
    if (grayscale) return colorsTypes.WHITE;
    return colorsTypes.PRIMARY_SEMI_DARK;
  }

  return colorsTypes.TRANSPARENT;
}, function (_ref14) {
  var _ref14$float = _ref14["float"],
      _float4 = _ref14$float === void 0 ? false : _ref14$float,
      _ref14$transparent = _ref14.transparent,
      transparent = _ref14$transparent === void 0 ? false : _ref14$transparent,
      _ref14$scrollY = _ref14.scrollY,
      scrollY = _ref14$scrollY === void 0 ? 0 : _ref14$scrollY,
      _ref14$backgroundBrea = _ref14.backgroundBreakpoint,
      backgroundBreakpoint = _ref14$backgroundBrea === void 0 ? 20 : _ref14$backgroundBrea,
      _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? colorsTypes.BLACK : _ref14$color;

  if (transparent || !scrollY) return undefined;
  if (scrollY <= backgroundBreakpoint || scrollY === 0) return color;
  if (!!_float4 && !!Number(scrollY)) return color;
  return color;
}, function (_ref15) {
  var _ref15$grayscale = _ref15.grayscale,
      grayscale = _ref15$grayscale === void 0 ? false : _ref15$grayscale,
      _ref15$transparent = _ref15.transparent,
      transparent = _ref15$transparent === void 0 ? false : _ref15$transparent;
  if (transparent) return "none";
  if (grayscale) return colorsTypes.VERY_ULTRA_LIGHT;
  return colorsTypes.HIGHT_LIGHT_PRIMARY;
}, function (_ref16) {
  var _ref16$grayscale = _ref16.grayscale,
      grayscale = _ref16$grayscale === void 0 ? false : _ref16$grayscale,
      _ref16$transparent = _ref16.transparent,
      transparent = _ref16$transparent === void 0 ? false : _ref16$transparent,
      _ref16$dark = _ref16.dark,
      dark = _ref16$dark === void 0 ? false : _ref16$dark,
      _ref16$isActive = _ref16.isActive,
      isActive = _ref16$isActive === void 0 ? false : _ref16$isActive;

  if (transparent && !isActive) {
    if (dark) return colorsTypes.BLACK;
    if (grayscale) return colorsTypes.WHITE;
    return colorsTypes.PRIMARY_SEMI_DARK;
  }

  return "none";
});

function HeaderDesktopLinkNormal$1(_ref17) {
  var _ref17$index = _ref17.index,
      index = _ref17$index === void 0 ? "" : _ref17$index,
      menuItem = _ref17.menuItem,
      pathname = _ref17.pathname,
      variant = _ref17.variant,
      _ref17$float = _ref17["float"],
      _float5 = _ref17$float === void 0 ? false : _ref17$float,
      _ref17$forceShow = _ref17.forceShow,
      forceShow = _ref17$forceShow === void 0 ? false : _ref17$forceShow,
      _ref17$grayscale = _ref17.grayscale,
      grayscale = _ref17$grayscale === void 0 ? false : _ref17$grayscale,
      _ref17$dark = _ref17.dark,
      dark = _ref17$dark === void 0 ? false : _ref17$dark,
      _ref17$transparent = _ref17.transparent,
      transparent = _ref17$transparent === void 0 ? false : _ref17$transparent,
      _ref17$topIndicator = _ref17.topIndicator,
      topIndicator = _ref17$topIndicator === void 0 ? true : _ref17$topIndicator,
      _ref17$scrollY = _ref17.scrollY,
      scrollY = _ref17$scrollY === void 0 ? 0 : _ref17$scrollY,
      _ref17$active = _ref17.active,
      active = _ref17$active === void 0 ? false : _ref17$active,
      _ref17$activeBorderCo = _ref17.activeBorderColor,
      activeBorderColor = _ref17$activeBorderCo === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref17$activeBorderCo,
      _ref17$titleActiveCol = _ref17.titleActiveColor,
      titleActiveColor = _ref17$titleActiveCol === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref17$titleActiveCol,
      _ref17$titleColor = _ref17.titleColor,
      titleColor = _ref17$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref17$titleColor,
      _ref17$backgroundBrea = _ref17.backgroundBreakpoint,
      backgroundBreakpoint = _ref17$backgroundBrea === void 0 ? 20 : _ref17$backgroundBrea;

  switch (variant) {
    case linkVariantTypes.PAGE_LINKS:
      var classesValidation = function () {
        if (pathname === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pageLinks) || pathname === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) || pathname === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pdf) || "/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) || "/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pageLinks) || "/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pdf)) {
          return "LINK_NORMAL_TEXT LinkNormalText bl-text-xs tw-px-6 tw-flex tw-items-center tw-justify-center tw-pb-1 tw-border-t-2 tw-font-medium bl-border-primary LINK_NORMAL_TEXT_ACTIVE LINK__NORMAL__A__TEXT_ACTIVE";
        }

        return "LINK_NORMAL_TEXT LinkNormalText bl-text-xs tw-px-6 tw-flex tw-items-center tw-justify-center";
      }();

      return /*#__PURE__*/React__default$1["default"].createElement(LinkNormalText$1, {
        index: index,
        popup: "".concat(menuItem.openThirdPartyPopup),
        grayscale: grayscale,
        dark: dark,
        active: active,
        activeBorderColor: activeBorderColor,
        titleColor: titleColor,
        to: menuItem.pageLinks,
        "float": _float5,
        forceShow: forceShow,
        topIndicator: topIndicator,
        transparent: transparent,
        scrollY: scrollY,
        backgroundBreakpoint: backgroundBreakpoint,
        primaryFamily: "/".concat(pathname) === menuItem.url,
        className: classnames(classesValidation, addClassHeaderOnScroll({
          "float": _float5,
          scrollY: scrollY,
          backgroundBreakpoint: backgroundBreakpoint,
          transparent: transparent,
          classTag: "LINK__NORMAL__A__TEXT"
        }))
      }, menuItem.text);

    case linkVariantTypes.PDF:
      return /*#__PURE__*/React__default$1["default"].createElement(LinkNormalText$1, {
        index: index,
        topIndicator: topIndicator,
        grayscale: grayscale,
        active: active,
        activeBorderColor: activeBorderColor,
        color: titleColor,
        dark: dark,
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pdf.url,
        forceShow: forceShow,
        transparent: transparent,
        "float": _float5,
        scrollY: scrollY,
        backgroundBreakpoint: backgroundBreakpoint,
        primaryFamily: "/".concat(pathname) === menuItem.url || "/".concat(pathname) === menuItem.pageLinks,
        className: classnames("LINK_NORMAL_TEXT LinkNormalText bl-text-xs tw-flex tw-items-center tw-justify-center tw-font-medium", addClassHeaderOnScroll({
          "float": _float5,
          scrollY: scrollY,
          backgroundBreakpoint: backgroundBreakpoint,
          transparent: transparent,
          classTag: "LINK__NORMAL__A__TEXT"
        }) // , pathname === menuItem.url && "tw-pb-1 tw-border-t-2 bl-border-primary",
        )
      }, menuItem.text);

    default:
      var auxActiveClass = "LINK__NORMAL__A__TEXT_INACTIVE path=".concat(pathname, " url=").concat(menuItem === null || menuItem === void 0 ? void 0 : menuItem.url);

      if ("/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) || pathname === "" && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) === "/") {
        auxActiveClass = "LINK__NORMAL__A__TEXT_ACTIVE path=".concat(pathname, " url=").concat(menuItem === null || menuItem === void 0 ? void 0 : menuItem.url);
      }

      return /*#__PURE__*/React__default$1["default"].createElement(LinkNormalAText$1, {
        index: index,
        topIndicator: topIndicator,
        grayscale: grayscale,
        isActive: pathname === menuItem.url || pathname === menuItem.pageLinks || pathname === menuItem.pdf,
        activeBorderColor: activeBorderColor,
        color: titleColor,
        titleActiveColor: titleActiveColor,
        dark: dark,
        popup: "".concat(menuItem.openThirdPartyPopup),
        href: menuItem.url,
        "float": _float5,
        transparent: transparent // forceShow={forceShow}
        ,
        scrollY: scrollY,
        backgroundBreakpoint: backgroundBreakpoint,
        primaryFamily: "/".concat(pathname) === menuItem.url || "/".concat(pathname) === menuItem.pageLinks || "/".concat(pathname) === menuItem.pdf,
        className: classnames("LinkNormalAText bl-text-xs tw-flex tw-items-center tw-justify-center tw-font-medium ".concat(auxActiveClass), addClassHeaderOnScroll({
          "float": _float5,
          scrollY: scrollY,
          backgroundBreakpoint: backgroundBreakpoint,
          transparent: transparent,
          classTag: "LINK__NORMAL__A__TEXT"
        }) // , pathname === menuItem.url && "tw-pb-1 tw-border-t-2 bl-border-primary",
        )
      }, menuItem.text);
  }
}

function HeaderDesktopNavItems$1(_ref) {
  var pathname = _ref.pathname,
      menuItems = _ref.menuItems,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$backgroundScreen = _ref.backgroundScreenActive,
      backgroundScreenActive = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$forceShowColor = _ref.forceShowColor,
      forceShowColor = _ref$forceShowColor === void 0 ? false : _ref$forceShowColor,
      _ref$menuSubItemDisab = _ref.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref$menuSubItemDisab === void 0 ? false : _ref$menuSubItemDisab,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$itemsProps = _ref.itemsProps,
      itemsProps = _ref$itemsProps === void 0 ? {} : _ref$itemsProps,
      _ref$activeBorderColo = _ref.activeBorderColor,
      activeBorderColor = _ref$activeBorderColo === void 0 ? colorsTypes.PRIMARY : _ref$activeBorderColo,
      _ref$hoverBorderColor = _ref.hoverBorderColor,
      hoverBorderColor = _ref$hoverBorderColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$hoverBorderColor,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksTitl,
      _ref$menuSubLinksTitl2 = _ref.menuSubLinksTitleActiveColor,
      menuSubLinksTitleActiveColor = _ref$menuSubLinksTitl2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksTitl2,
      _ref$menuSubItemTitle = _ref.menuSubItemTitleColor,
      menuSubItemTitleColor = _ref$menuSubItemTitle === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubItemTitle,
      _ref$menuSubItemTitle2 = _ref.menuSubItemTitleActiveColor,
      menuSubItemTitleActiveColor = _ref$menuSubItemTitle2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubItemTitle2,
      _ref$subItemTextColor = _ref.subItemTextColor,
      subItemTextColor = _ref$subItemTextColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$subItemTextColor,
      _ref$subItemTextActiv = _ref.subItemTextActiveColor,
      subItemTextActiveColor = _ref$subItemTextActiv === void 0 ? colorsTypes.PRIMARY : _ref$subItemTextActiv,
      _ref$subMenuBackgroun = _ref.subMenuBackgroundColor,
      subMenuBackgroundColor = _ref$subMenuBackgroun === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuBackgroun,
      _ref$subMenuActiveBac = _ref.subMenuActiveBackgroundColor,
      subMenuActiveBackgroundColor = _ref$subMenuActiveBac === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuActiveBac,
      _ref$subMenuGrayscale = _ref.subMenuGrayscaleBackgroundColor,
      subMenuGrayscaleBackgroundColor = _ref$subMenuGrayscale === void 0 ? colorsTypes.WHITE : _ref$subMenuGrayscale,
      _ref$itemBackgroundCo = _ref.itemBackgroundColor,
      itemBackgroundColor = _ref$itemBackgroundCo === void 0 ? colorsTypes.WHITE : _ref$itemBackgroundCo,
      _ref$dropdownHoverBac = _ref.dropdownHoverBackground,
      dropdownHoverBackground = _ref$dropdownHoverBac === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref$dropdownHoverBac,
      _ref$menuSubLinksBord = _ref.menuSubLinksBorderColor,
      menuSubLinksBorderColor = _ref$menuSubLinksBord === void 0 ? colorsVariantsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksBord,
      _ref$dropdownSeparati = _ref.dropdownSeparationFromTop,
      dropdownSeparationFromTop = _ref$dropdownSeparati === void 0 ? 20 : _ref$dropdownSeparati,
      _ref$dropdownSeparati2 = _ref.dropdownSeparationFromBottom,
      dropdownSeparationFromBottom = _ref$dropdownSeparati2 === void 0 ? 50 : _ref$dropdownSeparati2;

  var urlTest = /^(\/|http:\/\/|https:\/\/|www.)/;

  var _useState = React.useState("/".concat(pathname)),
      _useState2 = _slicedToArray$1(_useState, 2),
      localPathname = _useState2[0],
      setLocalPathname = _useState2[1];

  React.useEffect(function () {
    if (window && window.location && window.location.pathname) {
      setLocalPathname(window.location.pathname);
    }
  }, []);
  return (menuItems || []).map(function (menuItem) {
    var variant = menuItem.pdf ? "pdf" : menuItem.pageLinks ? "pageLinks" : "url";
    var index = menuItem.text || nanoid();

    if (menuItem.subLinks && menuItem.subLinks.length > 0) {
      var subLinksCasted = menuItem.subLinks.reduce(function (acc, subLink) {
        var subLinkKeys = Object.entries(subLink).reduce(function () {
          var itemAcc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
              _ref3 = _slicedToArray$1(_ref2, 2),
              _ref3$ = _ref3[0],
              subLinkName = _ref3$ === void 0 ? "" : _ref3$,
              _ref3$2 = _ref3[1],
              subLinkValue = _ref3$2 === void 0 ? "" : _ref3$2;

          if (!subLinkValue) return _toConsumableArray(itemAcc);
          var itemIndex = Number(subLinkName.replace("text", ""));
          var isUrlSubLinkName = /url[0-9]/gi.test(subLinkName);
          var isTextSubLinkName = /text[0-9]/gi.test(subLinkName);
          if (isUrlSubLinkName || !isTextSubLinkName) return itemAcc;
          var subLinks = lodash.uniqBy(Object.entries(subLink).map(function (_ref4) {
            var _ref5 = _slicedToArray$1(_ref4, 2),
                _ref5$ = _ref5[0],
                urlName = _ref5$ === void 0 ? "" : _ref5$,
                _ref5$2 = _ref5[1],
                urlValue = _ref5$2 === void 0 ? "" : _ref5$2;

            var subLinkIndex = Number(urlName.replace("url", ""));
            return {
              name: urlName,
              value: urlValue,
              index: lodash.isNumber(subLinkIndex) && !!subLinkIndex ? subLinkIndex : nanoid()
            };
          }), "name");
          var urls = subLinks.filter(function (_ref6) {
            var _ref6$name = _ref6.name,
                name = _ref6$name === void 0 ? "" : _ref6$name;
            return /url[0-9]/gi.test(name);
          });
          var itemUrl = lodash.find(urls, {
            index: itemIndex
          });
          var isCurrentPath = itemUrl && itemUrl.value && itemUrl.value === localPathname;

          if (isTextSubLinkName) {
            var hasNotTextSubLinkItem = !lodash.find(itemAcc, {
              name: subLinkName
            });

            if (hasNotTextSubLinkItem) {
              var innerTextSubLinkItem = lodash.find(subLinks, {
                name: subLinkName
              });
              return [].concat(_toConsumableArray(itemAcc), [_objectSpread2(_objectSpread2({}, innerTextSubLinkItem), {}, {
                isCurrentPath: isCurrentPath,
                url: itemUrl || undefined,
                isUrl: itemUrl && urlTest.test(itemUrl.value)
              })]);
            }

            return itemAcc.map(function (item) {
              if (item.name === subLinkName) {
                return {
                  isCurrentPath: isCurrentPath,
                  name: subLinkName || "",
                  value: subLinkValue || "",
                  isUrl: urlTest.test(subLinkValue),
                  url: itemUrl || undefined
                };
              }

              return item;
            });
          }

          if (!isUrlSubLinkName) {
            return [].concat(_toConsumableArray(itemAcc), [{
              isCurrentPath: isCurrentPath,
              name: subLinkName || "",
              value: subLinkValue || "",
              isUrl: urlTest.test(subLinkValue),
              url: itemUrl || undefined
            }]);
          }

          return _toConsumableArray(itemAcc);
        }, []);
        return [].concat(_toConsumableArray(acc), [{
          id: subLink.id,
          title: subLink.title,
          titleStyle: subLink.titleStyle,
          data: subLinkKeys
        }]);
      }, []).map(function (item) {
        return _objectSpread2(_objectSpread2({}, item), {}, {
          data: lodash.uniqBy(item.data, "name")
        });
      });
      var subLinksCastedOnlyUrl = subLinksCasted.reduce(function () {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var item = arguments.length > 1 ? arguments[1] : undefined;
        return [].concat(_toConsumableArray(acc), _toConsumableArray(item.data.filter(function (_ref7) {
          var _ref7$isCurrentPath = _ref7.isCurrentPath,
              isCurrentPath = _ref7$isCurrentPath === void 0 ? false : _ref7$isCurrentPath;
          return isCurrentPath;
        })));
      }, []);
      var subLinksCastedOnlyCurrentPaths = subLinksCastedOnlyUrl.filter(function (_ref8) {
        var _ref8$isCurrentPath = _ref8.isCurrentPath,
            isCurrentPath = _ref8$isCurrentPath === void 0 ? false : _ref8$isCurrentPath;
        return isCurrentPath;
      });
      var subLinksCastedCurrentPaths = subLinksCastedOnlyUrl.map(function (_ref9) {
        var _ref9$isCurrentPath = _ref9.isCurrentPath,
            isCurrentPath = _ref9$isCurrentPath === void 0 ? false : _ref9$isCurrentPath;
        return isCurrentPath;
      });
      var currentPath = subLinksCastedOnlyCurrentPaths && subLinksCastedOnlyCurrentPaths.length ? subLinksCastedOnlyCurrentPaths[0] : undefined;
      var hasMatchWithLocalPath = lodash.some(subLinksCastedCurrentPaths);
      return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinks, _extends$g({
        disableBorder: menuSubItemDisableBorder,
        hoverBackground: dropdownHoverBackground,
        dropdownSeparationFromTop: dropdownSeparationFromTop,
        dropdownSeparationFromBottom: dropdownSeparationFromBottom,
        index: index,
        backgroundColor: itemBackgroundColor,
        subMenuBackgroundColor: subMenuBackgroundColor,
        subMenuGrayscaleBackgroundColor: subMenuGrayscaleBackgroundColor,
        subItemTextColor: subItemTextColor,
        activeBackgroundColor: subMenuActiveBackgroundColor,
        subItemTextActiveColor: subItemTextActiveColor,
        subItemTitleColor: menuSubItemTitleColor,
        subItemTitleActiveColor: menuSubItemTitleActiveColor,
        titleColor: hasMatchWithLocalPath && !!currentPath ? menuSubLinksTitleActiveColor : menuSubLinksTitleColor,
        borderColor: menuSubLinksBorderColor,
        activeBorderClass: hasMatchWithLocalPath && !!currentPath ? "HeaderDesktopLinkWithSubLinksContainer-activeMenuItem" : "HeaderDesktopLinkWithSubLinksContainer-inactiveMenuItem",
        active: hasMatchWithLocalPath && !!currentPath,
        topIndicator: topIndicator,
        activeBorderColor: activeBorderColor,
        hoverBorderColor: hoverBorderColor,
        key: "LinkWithSubLinks-".concat(menuItem.id),
        menuItem: menuItem,
        currentPath: currentPath,
        pathname: pathname,
        "float": _float,
        scrollY: scrollY,
        grayscale: grayscale,
        dark: dark,
        backgroundScreenActive: backgroundScreenActive,
        backgroundBreakpoint: backgroundBreakpoint,
        transparent: transparent,
        isTopBorder: isTopBorder,
        forceShow: forceShow,
        forceShowColor: forceShowColor,
        className: "HeaderDesktopLinkWithSubLinks HEADER_DESKTOP__NAVIGATION__ITEMS HEADER_DESKTOP__NAVIGATION__ITEMS__SUB_LINKS HeaderDesktopLinkWithSubLinks"
      }, itemsProps));
    }

    return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkNormal$1, _extends$g({
      index: index,
      key: "LinkNormal-".concat(menuItem.id),
      titleActiveColor: menuSubLinksTitleActiveColor,
      titleColor: menuSubLinksTitleColor,
      activeBorderColor: activeBorderColor,
      menuItem: menuItem,
      pathname: pathname,
      grayscale: grayscale,
      dark: dark,
      topIndicator: topIndicator,
      variant: variant,
      "float": _float,
      scrollY: scrollY,
      backgroundBreakpoint: backgroundBreakpoint,
      transparent: transparent,
      forceShow: forceShow,
      forceShowColor: forceShowColor,
      className: "HEADER_DESKTOP__NAVIGATION__ITEMS HEADER_DESKTOP__NAVIGATION__ITEMS__NORMAL HeaderDesktopLinkNormal"
    }, itemsProps));
  });
}

var _templateObject$U;

var HeaderDesktopContainer = styled__default["default"].nav(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n  flex: 9;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  height: 100%;\n"])));

var _templateObject$T;

var HeaderDesktopContent = styled__default["default"].nav(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  height: 100%;\n"])));

function HeaderDesktopNavMenu(_ref) {
  var creditUnion = _ref.creditUnion,
      pathname = _ref.pathname,
      menuItems = _ref.menuItems,
      loginButtonText = _ref.loginButtonText,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.NONE
  } : _ref$loginButtonStyle,
      _ref$itemsProps = _ref.itemsProps,
      itemsProps = _ref$itemsProps === void 0 ? {} : _ref$itemsProps,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$forceShowColor = _ref.forceShowColor,
      forceShowColor = _ref$forceShowColor === void 0 ? false : _ref$forceShowColor,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$backgroundScreen = _ref.backgroundScreenActive,
      backgroundScreenActive = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$menuSubItemDisab = _ref.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref$menuSubItemDisab === void 0 ? true : _ref$menuSubItemDisab,
      _ref$menuActiveBorder = _ref.menuActiveBorderColor,
      menuActiveBorderColor = _ref$menuActiveBorder === void 0 ? colorsTypes.PRIMARY : _ref$menuActiveBorder,
      _ref$menuHoverBorderC = _ref.menuHoverBorderColor,
      menuHoverBorderColor = _ref$menuHoverBorderC === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuHoverBorderC,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksTitl,
      _ref$menuSubLinksBord = _ref.menuSubLinksBorderColor,
      menuSubLinksBorderColor = _ref$menuSubLinksBord === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksBord,
      _ref$menuSubLinksTitl2 = _ref.menuSubLinksTitleActiveColor,
      menuSubLinksTitleActiveColor = _ref$menuSubLinksTitl2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksTitl2,
      _ref$menuSubItemTitle = _ref.menuSubItemTitleColor,
      menuSubItemTitleColor = _ref$menuSubItemTitle === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubItemTitle,
      _ref$menuSubItemTitle2 = _ref.menuSubItemTitleActiveColor,
      menuSubItemTitleActiveColor = _ref$menuSubItemTitle2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubItemTitle2,
      _ref$menuSubItemTextC = _ref.menuSubItemTextColor,
      menuSubItemTextColor = _ref$menuSubItemTextC === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubItemTextC,
      _ref$menuSubItemTextA = _ref.menuSubItemTextActiveColor,
      menuSubItemTextActiveColor = _ref$menuSubItemTextA === void 0 ? colorsTypes.PRIMARY : _ref$menuSubItemTextA,
      _ref$subMenuBackgroun = _ref.subMenuBackgroundColor,
      subMenuBackgroundColor = _ref$subMenuBackgroun === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuBackgroun,
      _ref$subMenuActiveBac = _ref.subMenuActiveBackgroundColor,
      subMenuActiveBackgroundColor = _ref$subMenuActiveBac === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuActiveBac,
      _ref$subMenuGrayscale = _ref.subMenuGrayscaleBackgroundColor,
      subMenuGrayscaleBackgroundColor = _ref$subMenuGrayscale === void 0 ? colorsTypes.WHITE : _ref$subMenuGrayscale,
      _ref$itemBackgroundCo = _ref.itemBackgroundColor,
      itemBackgroundColor = _ref$itemBackgroundCo === void 0 ? colorsTypes.TRANSPARENT : _ref$itemBackgroundCo,
      _ref$dropdownHoverBac = _ref.dropdownHoverBackground,
      dropdownHoverBackground = _ref$dropdownHoverBac === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref$dropdownHoverBac,
      _ref$dropdownSeparati = _ref.dropdownSeparationFromTop,
      dropdownSeparationFromTop = _ref$dropdownSeparati === void 0 ? 20 : _ref$dropdownSeparati,
      _ref$dropdownSeparati2 = _ref.dropdownSeparationFromBottom,
      dropdownSeparationFromBottom = _ref$dropdownSeparati2 === void 0 ? 50 : _ref$dropdownSeparati2;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _onClick = function onClick(link) {
    window.location.href = link;
  };

  var HeaderDesktopNavContainer = function HeaderDesktopNavContainer(_ref2) {
    var children = _ref2.children;
    return creditUnion === "bayou" ? /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-flex tw-flex-auto"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-m-auto tw-flex"
    }, children)) : /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, children);
  };

  var LoginButton = function LoginButton() {
    return /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
      className: "HEADER_DESKTOP_NAVIGATION_MENU__LOGIN__BUTTON",
      onClick: (loginButtonStyles === null || loginButtonStyles === void 0 ? void 0 : loginButtonStyles.variant) !== "NO_MODAL" && function () {
        return showModal();
      },
      pillTextColor: isModalVisible || forceShow ? undefined : colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, loginButtonStyles), loginButtonText);
  };

  var HeaderDesktopButtonLeft = function HeaderDesktopButtonLeft(_ref3) {
    var children = _ref3.children;
    return creditUnion === "bayou" && loginButtonText && /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HEADER_DESKTOP_NAVIGATION_MENU HeaderDesktopNavMenu-Nav-Container-Container tw-pr-20 tw-flex tw-items-center"
    }, children);
  };

  var HeaderDesktopButtonRight = function HeaderDesktopButtonRight(_ref4) {
    var children = _ref4.children;
    return creditUnion === "bayou" ? /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
      className: "HEADER_DESKTOP_NAVIGATION_MENU__LOGIN__BUTTON",
      onClick: function onClick() {
        return _onClick("https://web.baconpay.com/gate/login?institutionId=33ae4d0c-4b6e-4543-a5af-fa23acf39d97");
      }
    }, "Loan Payments") : children;
  };

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopContainer, {
    className: "HEADER_DESKTOP_NAVIGATION_MENU HeaderDesktopNavMenu-Nav sm:tw-inline-flex tw-items-center tw-justify-between"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopContent, {
    className: "HEADER_DESKTOP_NAVIGATION_MENU__CONTAINER HeaderDesktopNavMenu-Nav-Container"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopButtonLeft, null, /*#__PURE__*/React__default$1["default"].createElement(LoginButton, null)), /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavContainer, null, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavItems$1, _extends$g({
    dropdownHoverBackground: dropdownHoverBackground,
    dropdownSeparationFromTop: dropdownSeparationFromTop,
    dropdownSeparationFromBottom: dropdownSeparationFromBottom,
    itemBackgroundColor: itemBackgroundColor,
    subMenuBackgroundColor: subMenuBackgroundColor,
    subMenuActiveBackgroundColor: subMenuActiveBackgroundColor,
    subMenuGrayscaleBackgroundColor: subMenuGrayscaleBackgroundColor,
    subItemTextColor: menuSubItemTextColor,
    subItemTextActiveColor: menuSubItemTextActiveColor,
    menuSubLinksTitleColor: menuSubLinksTitleColor,
    menuSubLinksBorderColor: menuSubLinksBorderColor,
    menuSubLinksTitleActiveColor: menuSubLinksTitleActiveColor,
    menuSubItemTitleColor: menuSubItemTitleColor,
    menuSubItemTitleActiveColor: menuSubItemTitleActiveColor,
    menuSubItemDisableBorder: menuSubItemDisableBorder,
    activeBorderColor: menuActiveBorderColor,
    hoverBorderColor: menuHoverBorderColor,
    topIndicator: topIndicator,
    pathname: pathname,
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    menuItems: menuItems,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShow,
    forceShowColor: forceShowColor
  }, itemsProps, {
    classNamee: "HEADER_DESKTOP_NAVIGATION_MENU__ITEMS HeaderDesktopNavMenu-Nav-Container-Items"
  })))), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DESKTOP_NAVIGATION_MENU__LOGIN HeaderDesktopNavMenu-Nav-Container-Container tw-flex tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    onClick: function onClick() {
      return _onClick("/search");
    },
    "aria-label": "Search Button",
    className: "HEADER_DESKTOP_NAVIGATION_MENU__SEARCH__BUTTON"
  }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "currentColor",
    className: "bi bi-search HEADER_DESKTOP_NAVIGATION_MENU__SEARCH_ICON",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
  }))), /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopButtonRight, null, /*#__PURE__*/React__default$1["default"].createElement(LoginButton, null)), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    className: "HEADER_DESKTOP_NAVIGATION_MENU__LOGIN__MODAL",
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login$1, null))));
}

var _templateObject$S;

var HeaderDynamicContainer = styled__default["default"](HeaderContainer)(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  position: ", ";\n\n  top: ", ";\n\n  left: ", ";\n\n  width: ", ";\n\n  height: ", ";\n\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n\n  ", " {\n    content: ", ";\n\n    filter: ", ";\n  }\n\n  @media all and (max-width: ", "px) {\n    background: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n\n    ", " {\n      content: ", ";\n\n      filter: ", ";\n    }\n  }\n"])), function (_ref) {
  var _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float;

  if (_float) return "fixed";
  return undefined;
}, function (_ref2) {
  var _ref2$float = _ref2["float"],
      _float2 = _ref2$float === void 0 ? false : _ref2$float;

  if (_float2) return "0";
  return undefined;
}, function (_ref3) {
  var _ref3$float = _ref3["float"],
      _float3 = _ref3$float === void 0 ? false : _ref3$float;

  if (_float3) return "0";
  return undefined;
}, function (_ref4) {
  var _ref4$float = _ref4["float"],
      _float4 = _ref4$float === void 0 ? false : _ref4$float;

  if (_float4) return "100%";
  return undefined;
}, function (_ref5) {
  var _ref5$float = _ref5["float"],
      _float5 = _ref5$float === void 0 ? false : _ref5$float;

  if (_float5) return "auto";
  return undefined;
}, function (_ref6) {
  var _ref6$background = _ref6.background,
      background = _ref6$background === void 0 ? colorsTypes.WHITE : _ref6$background,
      _ref6$menuActive = _ref6.menuActive,
      menuActive = _ref6$menuActive === void 0 ? false : _ref6$menuActive,
      _ref6$float = _ref6["float"],
      _float6 = _ref6$float === void 0 ? false : _ref6$float,
      _ref6$transparent = _ref6.transparent,
      transparent = _ref6$transparent === void 0 ? false : _ref6$transparent,
      _ref6$forceShow = _ref6.forceShow,
      forceShow = _ref6$forceShow === void 0 ? false : _ref6$forceShow,
      _ref6$scrollY = _ref6.scrollY,
      scrollY = _ref6$scrollY === void 0 ? 0 : _ref6$scrollY,
      _ref6$backgroundBreak = _ref6.backgroundBreakpoint,
      backgroundBreakpoint = _ref6$backgroundBreak === void 0 ? 20 : _ref6$backgroundBreak,
      _ref6$backgroundAfter = _ref6.backgroundAfterBreakpoint,
      backgroundAfterBreakpoint = _ref6$backgroundAfter === void 0 ? colorsTypes.WHITE : _ref6$backgroundAfter,
      _ref6$activeBackgroun = _ref6.activeBackground,
      activeBackground = _ref6$activeBackgroun === void 0 ? colorsTypes.WHITE : _ref6$activeBackgroun,
      _ref6$transparentBack = _ref6.transparentBackground,
      transparentBackground = _ref6$transparentBack === void 0 ? colorsTypes.TRANSPARENT : _ref6$transparentBack;

  if (!!_float6 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || forceShow || menuActive) {
    if (menuActive) return activeBackground;
    return backgroundAfterBreakpoint;
  }

  if (menuActive) return activeBackground;
  if (transparent) return transparentBackground;
  return background;
}, function (_ref7) {
  var _ref7$float = _ref7["float"],
      _float7 = _ref7$float === void 0 ? false : _ref7$float,
      _ref7$transparent = _ref7.transparent,
      transparent = _ref7$transparent === void 0 ? false : _ref7$transparent,
      _ref7$menuActive = _ref7.menuActive,
      menuActive = _ref7$menuActive === void 0 ? false : _ref7$menuActive,
      _ref7$hoverBackground = _ref7.hoverBackground,
      hoverBackground = _ref7$hoverBackground === void 0 ? colorsTypes.WHITE : _ref7$hoverBackground,
      _ref7$hoverFloatBackg = _ref7.hoverFloatBackground,
      hoverFloatBackground = _ref7$hoverFloatBackg === void 0 ? colorsTypes.WHITE : _ref7$hoverFloatBackg,
      _ref7$hoverActiveBack = _ref7.hoverActiveBackground,
      hoverActiveBackground = _ref7$hoverActiveBack === void 0 ? colorsTypes.WHITE : _ref7$hoverActiveBack,
      _ref7$backgroundAfter = _ref7.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref7$backgroundAfter === void 0 ? colorsTypes.WHITE : _ref7$backgroundAfter,
      _ref7$hoverTransparen = _ref7.hoverTransparentBackground,
      hoverTransparentBackground = _ref7$hoverTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref7$hoverTransparen,
      _ref7$forceShowHover = _ref7.forceShowHover,
      forceShowHover = _ref7$forceShowHover === void 0 ? false : _ref7$forceShowHover,
      _ref7$scrollY = _ref7.scrollY,
      scrollY = _ref7$scrollY === void 0 ? 0 : _ref7$scrollY,
      _ref7$backgroundBreak = _ref7.backgroundBreakpoint,
      backgroundBreakpoint = _ref7$backgroundBreak === void 0 ? 20 : _ref7$backgroundBreak;

  if (!!_float7 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || forceShowHover || menuActive) {
    if (menuActive) return hoverActiveBackground;
    return backgroundAfterBreakpointHover;
  }

  if (menuActive) return hoverActiveBackground;
  if (transparent) return hoverTransparentBackground;
  if (_float7) return hoverFloatBackground;
  return hoverBackground;
}, Logo, function (_ref8) {
  var logoReplaceImageWith = _ref8.logoReplaceImageWith,
      activeLogoReplaceImageWith = _ref8.activeLogoReplaceImageWith,
      logoReplaceImageWithAfterBreakpoint = _ref8.logoReplaceImageWithAfterBreakpoint,
      activeLogoReplaceImageWithAfterBreakpoint = _ref8.activeLogoReplaceImageWithAfterBreakpoint,
      _ref8$float = _ref8["float"],
      _float8 = _ref8$float === void 0 ? false : _ref8$float,
      _ref8$scrollY = _ref8.scrollY,
      scrollY = _ref8$scrollY === void 0 ? 0 : _ref8$scrollY,
      _ref8$backgroundBreak = _ref8.backgroundBreakpoint,
      backgroundBreakpoint = _ref8$backgroundBreak === void 0 ? 20 : _ref8$backgroundBreak,
      _ref8$menuActive = _ref8.menuActive,
      menuActive = _ref8$menuActive === void 0 ? false : _ref8$menuActive;

  if (!!_float8 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || menuActive) {
    if (menuActive) return activeLogoReplaceImageWithAfterBreakpoint;
    return logoReplaceImageWithAfterBreakpoint;
  }

  if (menuActive) return activeLogoReplaceImageWith;
  return logoReplaceImageWith;
}, function (_ref9) {
  var _ref9$forceShow = _ref9.forceShow,
      forceShow = _ref9$forceShow === void 0 ? false : _ref9$forceShow,
      _ref9$menuActive = _ref9.menuActive,
      menuActive = _ref9$menuActive === void 0 ? false : _ref9$menuActive,
      _ref9$float = _ref9["float"],
      _float9 = _ref9$float === void 0 ? false : _ref9$float,
      _ref9$scrollY = _ref9.scrollY,
      scrollY = _ref9$scrollY === void 0 ? 0 : _ref9$scrollY,
      _ref9$backgroundBreak = _ref9.backgroundBreakpoint,
      backgroundBreakpoint = _ref9$backgroundBreak === void 0 ? 20 : _ref9$backgroundBreak,
      _ref9$logoFilterEffec = _ref9.logoFilterEffect,
      logoFilterEffect = _ref9$logoFilterEffec === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref9$logoFilterEffec,
      _ref9$activeLogoFilte = _ref9.activeLogoFilterEffect,
      activeLogoFilterEffect = _ref9$activeLogoFilte === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref9$activeLogoFilte,
      _ref9$noFilterLogo = _ref9.noFilterLogo,
      noFilterLogo = _ref9$noFilterLogo === void 0 ? false : _ref9$noFilterLogo,
      filter = _ref9.filter;

  if (forceShow || noFilterLogo) return filter;

  if (!!_float9 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || menuActive) {
    if (menuActive) return activeLogoFilterEffect.join(" ");
    return logoFilterEffect.join(" ");
  }

  return filter;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.md;
}, function (_ref11) {
  var _ref11$menuActive = _ref11.menuActive,
      menuActive = _ref11$menuActive === void 0 ? false : _ref11$menuActive,
      _ref11$float = _ref11["float"],
      _float10 = _ref11$float === void 0 ? false : _ref11$float,
      _ref11$transparent = _ref11.transparent,
      transparent = _ref11$transparent === void 0 ? false : _ref11$transparent,
      _ref11$forceShow = _ref11.forceShow,
      forceShow = _ref11$forceShow === void 0 ? false : _ref11$forceShow,
      _ref11$scrollY = _ref11.scrollY,
      scrollY = _ref11$scrollY === void 0 ? 0 : _ref11$scrollY,
      _ref11$backgroundBrea = _ref11.backgroundBreakpoint,
      backgroundBreakpoint = _ref11$backgroundBrea === void 0 ? 20 : _ref11$backgroundBrea,
      _ref11$mobileBackgrou = _ref11.mobileBackground,
      mobileBackground = _ref11$mobileBackgrou === void 0 ? colorsTypes.WHITE : _ref11$mobileBackgrou,
      _ref11$mobileBackgrou2 = _ref11.mobileBackgroundAfterBreakpoint,
      mobileBackgroundAfterBreakpoint = _ref11$mobileBackgrou2 === void 0 ? colorsTypes.WHITE : _ref11$mobileBackgrou2,
      _ref11$mobileActiveBa = _ref11.mobileActiveBackground,
      mobileActiveBackground = _ref11$mobileActiveBa === void 0 ? colorsTypes.WHITE : _ref11$mobileActiveBa,
      _ref11$mobileTranspar = _ref11.mobileTransparentBackground,
      mobileTransparentBackground = _ref11$mobileTranspar === void 0 ? colorsTypes.TRANSPARENT : _ref11$mobileTranspar;

  if (!!_float10 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || forceShow || menuActive) {
    if (menuActive) return mobileActiveBackground;
    return mobileBackgroundAfterBreakpoint;
  }

  if (menuActive) return mobileActiveBackground;
  if (transparent) return mobileTransparentBackground;
  return mobileBackground;
}, function (_ref12) {
  var _ref12$float = _ref12["float"],
      _float11 = _ref12$float === void 0 ? false : _ref12$float,
      _ref12$transparent = _ref12.transparent,
      transparent = _ref12$transparent === void 0 ? false : _ref12$transparent,
      _ref12$menuActive = _ref12.menuActive,
      menuActive = _ref12$menuActive === void 0 ? false : _ref12$menuActive,
      _ref12$forceShowHover = _ref12.forceShowHover,
      forceShowHover = _ref12$forceShowHover === void 0 ? false : _ref12$forceShowHover,
      _ref12$scrollY = _ref12.scrollY,
      scrollY = _ref12$scrollY === void 0 ? 0 : _ref12$scrollY,
      _ref12$backgroundBrea = _ref12.backgroundBreakpoint,
      backgroundBreakpoint = _ref12$backgroundBrea === void 0 ? 20 : _ref12$backgroundBrea,
      _ref12$mobileHoverBac = _ref12.mobileHoverBackground,
      mobileHoverBackground = _ref12$mobileHoverBac === void 0 ? colorsTypes.WHITE : _ref12$mobileHoverBac,
      _ref12$mobileHoverFlo = _ref12.mobileHoverFloatBackground,
      mobileHoverFloatBackground = _ref12$mobileHoverFlo === void 0 ? colorsTypes.WHITE : _ref12$mobileHoverFlo,
      _ref12$mobileHoverAct = _ref12.mobileHoverActiveBackground,
      mobileHoverActiveBackground = _ref12$mobileHoverAct === void 0 ? colorsTypes.WHITE : _ref12$mobileHoverAct,
      _ref12$mobileBackgrou = _ref12.mobileBackgroundAfterBreakpointHover,
      mobileBackgroundAfterBreakpointHover = _ref12$mobileBackgrou === void 0 ? colorsTypes.WHITE : _ref12$mobileBackgrou,
      _ref12$mobileHoverTra = _ref12.mobileHoverTransparentBackground,
      mobileHoverTransparentBackground = _ref12$mobileHoverTra === void 0 ? colorsTypes.TRANSPARENT : _ref12$mobileHoverTra;

  if (!!_float11 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || forceShowHover || menuActive) {
    if (menuActive) return mobileHoverActiveBackground;
    return mobileBackgroundAfterBreakpointHover;
  }

  if (menuActive) return mobileHoverActiveBackground;
  if (transparent) return mobileHoverTransparentBackground;
  if (_float11) return mobileHoverFloatBackground;
  return mobileHoverBackground;
}, Logo, function (_ref13) {
  var mobileLogoReplaceImageWith = _ref13.mobileLogoReplaceImageWith,
      mobileActiveLogoReplaceImageWith = _ref13.mobileActiveLogoReplaceImageWith,
      mobileLogoReplaceImageWithAfterBreakpoint = _ref13.mobileLogoReplaceImageWithAfterBreakpoint,
      mobileActiveLogoReplaceImageWithAfterBreakpoint = _ref13.mobileActiveLogoReplaceImageWithAfterBreakpoint,
      _ref13$float = _ref13["float"],
      _float12 = _ref13$float === void 0 ? false : _ref13$float,
      _ref13$menuActive = _ref13.menuActive,
      menuActive = _ref13$menuActive === void 0 ? false : _ref13$menuActive,
      _ref13$scrollY = _ref13.scrollY,
      scrollY = _ref13$scrollY === void 0 ? 0 : _ref13$scrollY,
      _ref13$backgroundBrea = _ref13.backgroundBreakpoint,
      backgroundBreakpoint = _ref13$backgroundBrea === void 0 ? 20 : _ref13$backgroundBrea;

  if (!!_float12 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || menuActive) {
    if (menuActive) return mobileActiveLogoReplaceImageWithAfterBreakpoint;
    return mobileLogoReplaceImageWithAfterBreakpoint;
  }

  if (menuActive) return mobileActiveLogoReplaceImageWith;
  return mobileLogoReplaceImageWith;
}, function (_ref14) {
  var _ref14$forceShow = _ref14.forceShow,
      forceShow = _ref14$forceShow === void 0 ? false : _ref14$forceShow,
      _ref14$float = _ref14["float"],
      _float13 = _ref14$float === void 0 ? false : _ref14$float,
      _ref14$menuActive = _ref14.menuActive,
      menuActive = _ref14$menuActive === void 0 ? false : _ref14$menuActive,
      _ref14$scrollY = _ref14.scrollY,
      scrollY = _ref14$scrollY === void 0 ? 0 : _ref14$scrollY,
      _ref14$backgroundBrea = _ref14.backgroundBreakpoint,
      backgroundBreakpoint = _ref14$backgroundBrea === void 0 ? 20 : _ref14$backgroundBrea,
      _ref14$mobileLogoFilt = _ref14.mobileLogoFilterEffectAfterScroll,
      mobileLogoFilterEffectAfterScroll = _ref14$mobileLogoFilt === void 0 ? [] : _ref14$mobileLogoFilt,
      _ref14$mobileActiveLo = _ref14.mobileActiveLogoFilterEffectAfterScroll,
      mobileActiveLogoFilterEffectAfterScroll = _ref14$mobileActiveLo === void 0 ? [] : _ref14$mobileActiveLo,
      _ref14$mobileNoFilter = _ref14.mobileNoFilterLogo,
      mobileNoFilterLogo = _ref14$mobileNoFilter === void 0 ? false : _ref14$mobileNoFilter,
      _ref14$mobileLogoFilt2 = _ref14.mobileLogoFilterEffect,
      mobileLogoFilterEffect = _ref14$mobileLogoFilt2 === void 0 ? [] : _ref14$mobileLogoFilt2;

  if (mobileNoFilterLogo) return "none";
  var hasFilter = Array.isArray(mobileLogoFilterEffect) && mobileLogoFilterEffect.length;
  if (forceShow) return hasFilter ? mobileLogoFilterEffect.join(" ") : "none";

  if (!!_float13 && !!Number(scrollY) && scrollY >= backgroundBreakpoint || menuActive) {
    if (menuActive) return mobileActiveLogoFilterEffectAfterScroll.join(" ");
    return mobileLogoFilterEffectAfterScroll.join(" ");
  }

  return "none";
});

var _templateObject$R;

var HeaderDesktopLogoContainer$1 = styled__default["default"](Link)(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 175px;\n\n  @media all and (max-width: ", "px) {\n    width: 175px;\n    height: 75px;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.md;
});

var _templateObject$Q;

var NavigationContainer$2 = styled__default["default"].div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  max-width: ", ";\n  height: 100px;\n"])), function (_ref) {
  var _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "none" : _ref$maxWidth;
  return maxWidth;
});

function HeaderDefault(_ref2) {
  var data = _ref2.data,
      pathname = _ref2.pathname,
      className = _ref2.className,
      _ref2$hoverBackground = _ref2.hoverBackground,
      hoverBackground = _ref2$hoverBackground === void 0 ? colorsTypes.WHITE : _ref2$hoverBackground,
      _ref2$backgroundAfter = _ref2.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref2$backgroundAfter === void 0 ? colorsTypes.WHITE : _ref2$backgroundAfter,
      _ref2$forceShowHover = _ref2.forceShowHover,
      forceShowHover = _ref2$forceShowHover === void 0 ? false : _ref2$forceShowHover,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$isTopBorder = _ref2.isTopBorder,
      isTopBorder = _ref2$isTopBorder === void 0 ? false : _ref2$isTopBorder,
      _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$forceShowItems = _ref2.forceShowItems,
      forceShowItems = _ref2$forceShowItems === void 0 ? true : _ref2$forceShowItems,
      _ref2$forceShowColor = _ref2.forceShowColor,
      forceShowColor = _ref2$forceShowColor === void 0 ? false : _ref2$forceShowColor,
      _ref2$float = _ref2["float"],
      _float = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$grayscale = _ref2.grayscale,
      grayscale = _ref2$grayscale === void 0 ? false : _ref2$grayscale,
      _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark,
      _ref2$backgroundScree = _ref2.backgroundScreenActive,
      backgroundScreenActive = _ref2$backgroundScree === void 0 ? false : _ref2$backgroundScree,
      _ref2$noFilterLogo = _ref2.noFilterLogo,
      noFilterLogo = _ref2$noFilterLogo === void 0 ? false : _ref2$noFilterLogo,
      _ref2$menuSubItemDisa = _ref2.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref2$menuSubItemDisa === void 0 ? false : _ref2$menuSubItemDisa,
      _ref2$topIndicator = _ref2.topIndicator,
      topIndicator = _ref2$topIndicator === void 0 ? true : _ref2$topIndicator,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$backgroundBreak = _ref2.backgroundBreakpoint,
      backgroundBreakpoint = _ref2$backgroundBreak === void 0 ? 20 : _ref2$backgroundBreak,
      _ref2$logoFilterEffec = _ref2.logoFilterEffect,
      logoFilterEffect = _ref2$logoFilterEffec === void 0 ? [] : _ref2$logoFilterEffec,
      _ref2$navigationOptio = _ref2.navigationOptions,
      navigationOptions = _ref2$navigationOptio === void 0 ? {
    maxWidth: "var(--breakpoints-xl)"
  } : _ref2$navigationOptio,
      _ref2$navigationMenuO = _ref2.navigationMenuOptions,
      navigationMenuOptions = _ref2$navigationMenuO === void 0 ? {
    menuActiveBorderColor: colorsTypes.PRIMARY,
    menuHoverBorderColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubLinksTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubItemTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subMenuBackgroundColor: colorsTypes.TRANSPARENT,
    subMenuActiveBackgroundColor: colorsTypes.TRANSPARENT,
    itemBackgroundColor: colorsTypes.WHITE,
    dropdownHoverBackground: colorsVariantsTypes.HIGHT_LIGHT_PRIMARY,
    dropdownSeparationFromTop: 20,
    dropdownSeparationFromBottom: 50
  } : _ref2$navigationMenuO,
      _ref2$loginButtonStyl = _ref2.loginButtonStyles,
      loginButtonStyles = _ref2$loginButtonStyl === void 0 ? {} : _ref2$loginButtonStyl,
      _ref2$isDynamic = _ref2.isDynamic,
      isDynamic = _ref2$isDynamic === void 0 ? false : _ref2$isDynamic;

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    noFilterLogo: noFilterLogo,
    logoFilterEffect: logoFilterEffect,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShow,
    hoverBackground: hoverBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    forceShowHover: forceShowHover,
    className: classnames("HEADER_DESKTOP_DEFAULT HeaderDesktop-HeaderDynamicContainer bl-bg-grayscale-0 tw-z-50 tw-relative tw-font-normal tw-flex tw-flex-wrap", scrollY > backgroundBreakpoint ? "HEADER_DESKTOP_DEFAULT_SCROLLED " : "HEADER_DESKTOP_DEFAULT_NO_SCROLLED", isDynamic ? "HEADER_DESKTOP_DEFAULT_DINAMIC_PAGE" : "HEADER_DESKTOP_DEFAULT_NO_DINAMIC_PAGE", className)
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement(NavigationContainer$2, _extends$g({
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION HeaderDesktop-HeaderDynamicContainer-NavigatorContainer tw-w-full tw-mx-auto tw-px-8 tw-flex tw-justify-between tw-items-center"
  }, navigationOptions), /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLogoContainer$1, {
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION__LOGO tw-flex-1 tw-flex tw-justify-center tw-items-center HeaderDesktop-HeaderDynamicContainer_Link tw-h-full tw-mr-10",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION__LOGO__IMAGE HeaderDesktop-HeaderDynamicContainer_Logo Header__logo",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), data && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavMenu, _extends$g({
    menuSubItemDisableBorder: menuSubItemDisableBorder,
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    topIndicator: topIndicator,
    pathname: pathname,
    menuItems: data.NavBarItems,
    loginButtonText: data.loginButtonText,
    "float": _float,
    scrollY: scrollY,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShowItems,
    forceShowColor: forceShowColor,
    backgroundBreakpoint: backgroundBreakpoint,
    loginButtonStyles: loginButtonStyles
  }, navigationMenuOptions))));
}

var _templateObject$P;

var NavigationContainer$1 = styled__default["default"].div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  max-width: ", ";\n"])), function (_ref) {
  var _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "none" : _ref$maxWidth;
  return maxWidth;
});

function HeaderContained(_ref2) {
  var data = _ref2.data,
      pathname = _ref2.pathname,
      className = _ref2.className,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$forceShowItems = _ref2.forceShowItems,
      forceShowItems = _ref2$forceShowItems === void 0 ? true : _ref2$forceShowItems,
      _ref2$forceShowColor = _ref2.forceShowColor,
      forceShowColor = _ref2$forceShowColor === void 0 ? false : _ref2$forceShowColor,
      _ref2$float = _ref2["float"],
      _float = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$grayscale = _ref2.grayscale,
      grayscale = _ref2$grayscale === void 0 ? false : _ref2$grayscale,
      _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark,
      _ref2$backgroundScree = _ref2.backgroundScreenActive,
      backgroundScreenActive = _ref2$backgroundScree === void 0 ? false : _ref2$backgroundScree,
      _ref2$noFilterLogo = _ref2.noFilterLogo,
      noFilterLogo = _ref2$noFilterLogo === void 0 ? false : _ref2$noFilterLogo,
      _ref2$topIndicator = _ref2.topIndicator,
      topIndicator = _ref2$topIndicator === void 0 ? true : _ref2$topIndicator,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$backgroundBreak = _ref2.backgroundBreakpoint,
      backgroundBreakpoint = _ref2$backgroundBreak === void 0 ? 20 : _ref2$backgroundBreak,
      _ref2$navigationOptio = _ref2.navigationOptions,
      navigationOptions = _ref2$navigationOptio === void 0 ? {
    maxWidth: "var(--breakpoints-xl)"
  } : _ref2$navigationOptio,
      _ref2$navigationMenuO = _ref2.navigationMenuOptions,
      navigationMenuOptions = _ref2$navigationMenuO === void 0 ? {
    menuActiveBorderColor: colorsTypes.PRIMARY,
    menuHoverBorderColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubLinksTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubItemTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    subMenuGrayscaleBackgroundColor: colorsTypes.WHITE
  } : _ref2$navigationMenuO,
      _ref2$loginButtonStyl = _ref2.loginButtonStyles,
      loginButtonStyles = _ref2$loginButtonStyl === void 0 ? {} : _ref2$loginButtonStyl;
  /**
   * TODO:
   * The container doesn't have the correct width
   * Make the Logo smaller
   */


  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    noFilterLogo: noFilterLogo,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    forceShow: forceShow,
    className: classnames("HEADER_CONTAINER HeaderDesktop-HeaderDynamicContainer bl-bg-grayscale-0 tw-z-50 tw-relative tw-font-normal tw-flex tw-flex-wrap", className)
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement(NavigationContainer$1, _extends$g({}, navigationOptions, {
    className: "HEADER_CONTAINER__NAVIGATION NAVIGATION HeaderDesktop-HeaderDynamicContainer-NavigatorContainer tw-w-full tw-mx-auto tw-flex tw-justify-between tw-items-center"
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_CONTAINER__NAVIGATION__CONTAINER NAVIGATION__CONTAINER tw-container tw-flex tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_CONTAINER__NAVIGATION__CONTAINER__LOGO NAVIGATION__CONTAINER__LOGO HeaderDesktop-HeaderDynamicContainer_Link",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_CONTAINER__NAVIGATION__CONTAINER__LOGO__IMAGE NAVIGATION__CONTAINER__LOGO__IMAGE HeaderDesktop-HeaderDynamicContainer_Logo Header__logo tw-w-40 tw-my-5",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), data && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavMenu, _extends$g({
    className: "HEADER_CONTAINER__NAVIGATION__CONTAINER__NAVIGATION",
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    topIndicator: topIndicator,
    pathname: pathname,
    menuItems: data.NavBarItems,
    loginButtonText: data.loginButtonText,
    "float": _float,
    scrollY: scrollY,
    transparent: transparent,
    forceShow: forceShowItems,
    forceShowColor: forceShowColor,
    backgroundBreakpoint: backgroundBreakpoint,
    loginButtonStyles: loginButtonStyles
  }, navigationMenuOptions)))));
}

var _excluded$G = ["variant"];

function HeaderDesktop(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? headerDesktopVariantTypes.STANDARD : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$G);

  switch (variant) {
    case headerDesktopVariantTypes.STANDARD:
      return /*#__PURE__*/React__default$1["default"].createElement(HeaderDefault, otherProps);

    case headerDesktopVariantTypes.CONTAINED:
      return /*#__PURE__*/React__default$1["default"].createElement(HeaderContained, otherProps);

    default:
      throw new Error("Header Desktop: Invalid variant type (".concat(variant, ")"));
  }
}

var _templateObject$O;

var Title$2 = styled__default["default"].h3(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n"])));
var forgotPasswordText = "Forgot Password?";

function LoginForm() {
  var _useState = React.useState({
    btnLogin: "login"
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];

  function onSubmitHandler(e) {
    e.preventDefault();

    if (process.env.GATSBY_CU_NAME === "GNC") {
      // Mejora: props desde el template para escoger el tipo
      var loginCU = "".concat(process.env.GATSBY_LOGIN_URL, " ").concat(query === null || query === void 0 ? void 0 : query.username);
      window.location.href = loginCU.replace(/\s+/g, ""); // Reemplaza cualquier espacio en blanco en la URL (codigo blindaje)
    } else if (process.env.GATSBY_CU_NAME === "peoples_advantage" || process.env.GATSBY_CU_NAME === "peoples-advantage" || process.env.GATSBY_CU_NAME === "lesco") {
      window.location.href = process.env.GATSBY_LOGIN_URL;
    } else {
      window.location.href = "".concat(process.env.GATSBY_LOGIN_URL, "&").concat(formatQueryUrl(query));
    }
  }

  function formatQueryUrl(queryParams) {
    return Object.entries(queryParams).map(function (_ref) {
      var _ref2 = _slicedToArray$1(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join("&");
  }

  var formMethod = "GET";
  var textLoginButton = "Login";

  if (process.env.GATSBY_CU_NAME === "GNC") {
    // formMethod = "POST";
    textLoginButton = "Account Login";
  }

  if (process.env.GATSBY_CU_NAME === "arlington-municipal") {
    textLoginButton = "Online Banking";
  }

  if (process.env.GATSBY_CU_NAME === "lesco") {
    textLoginButton = "Online Account Login";
  }

  var forgotLink = function forgotLink() {
    if (process.env.GATSBY_CU_NAME === "knox" || process.env.GATSBY_CU_NAME === "eight" || process.env.GATSBY_CU_NAME === "willow_island" || process.env.GATSBY_CU_NAME === "vicksburg-railroad" || process.env.GATSBY_CU_NAME === "Vicksburg railroad" || process.env.GATSBY_CU_NAME === "capital" || process.env.GATSBY_CU_NAME === "grohio" || process.env.GATSBY_CU_NAME === "mcdowell" || process.env.GATSBY_CU_NAME === "east_orange_firemens" || process.env.GATSBY_CU_NAME === "muw_employees" || process.env.GATSBY_CU_NAME === "new_horizon" || process.env.GATSBY_CU_NAME === "new-horizon" || process.env.GATSBY_CU_NAME === "raleigh_county" || process.env.GATSBY_CU_NAME === "raleigh-county" || process.env.GATSBY_CU_NAME === "eqt" || process.env.GATSBY_CU_NAME === "EQT" || process.env.GATSBY_CU_NAME === "greater_centennial" || process.env.GATSBY_CU_NAME === "jackson_area") {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN Header-Login LOGIN__MODAL__CONTAINER tw-max-w-full tw-w-96 tw-px-8 tw-py-10"
  }, /*#__PURE__*/React__default$1["default"].createElement("form", {
    method: formMethod,
    onSubmit: onSubmitHandler,
    id: "loginform",
    name: "loginform",
    className: "HEADER_LOGIN__FORM LOGIN__MODAL__FORM"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$2, {
    className: "HEADER_LOGIN__TITLE tw-mb-10 tw-font-bold bl-text-primary-180 bl-text-xl LOGIN__MODAL__TITLE"
  }, "Secure Login"), /*#__PURE__*/React__default$1["default"].createElement(Input, {
    type: "text",
    name: "username",
    label: "Login ID",
    autoComplete: "off",
    value: query.username,
    success: !!query.username,
    error: !query.username,
    className: "HEADER_LOGIN__INPUT Header-Login_Input tw-py-4 tw-px-3 tw-rounded-lg bl-text-grayscale-100 bl-bg-grayscale-6 tw-w-full tw-block focus:tw-outline-none tw-mb-1",
    onChange: function onChange(_ref3) {
      var target = _ref3.target;
      var username = target.value;
      setQuery(_objectSpread2(_objectSpread2({}, query), {}, {
        username: username
      }));
    },
    isRequired: true
  }), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN__FORGOT_LOGIN_ID Header-Login_ForgotLoginId tw-flex tw-justify-end tw-mb-8"
  }, forgotLink() ? /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_FORGOT_LOGIN_ID,
    className: "LOGIN__MODAL__FORGOT_A bl-text-grayscale-50"
  }, "Forgot Login ID?"), /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_FORGOT_PASSWORD_LINK,
    className: "LOGIN__MODAL__FORGOT_A LOGIN__MODAL__FORGOT_PASSWORD bl-text-grayscale-50"
  }, forgotPasswordText)) : /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_FORGOT_LOGIN_ID,
    className: "LOGIN__MODAL__FORGOT_A bl-text-grayscale-50"
  }, "Forgot Login ID?")), /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    fill: buttonFillTypes.FILLED,
    className: "HEADER_LOGIN__BUTTON Header-Login_Button tw-w-full",
    disabled: !query.username,
    type: "submit"
  }, textLoginButton), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN__DESCRIPTION Header-Login_NewDigitalBanking tw-flex tw-justify-center tw-my-4"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_ENROLL_NOW,
    className: "LOGIN__MODAL__ENROLL_A bl-text-grayscale-50"
  }, "NEW TO DIGITAL BANKING? ENROLL NOW"))));
}

var _templateObject$N;

var Title$1 = styled__default["default"].h3(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n"])));

function LoginDirect() {
  var _useState = React.useState({
    btnLogin: "login"
  }),
      _useState2 = _slicedToArray$1(_useState, 1),
      query = _useState2[0];

  function onSubmitHandler(e) {
    e.preventDefault();
    window.location.href = "".concat(process.env.GATSBY_LOGIN_URL, "&").concat(formatQueryUrl(query));
  }

  function formatQueryUrl(queryParams) {
    return Object.entries(queryParams).map(function (_ref) {
      var _ref2 = _slicedToArray$1(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join("&");
  }

  var formMethod = "GET";
  var textLoginButton = "Login";
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN Header-Login LOGIN__MODAL__CONTAINER tw-max-w-full tw-w-96 tw-px-8 tw-py-10"
  }, /*#__PURE__*/React__default$1["default"].createElement("form", {
    method: formMethod,
    onSubmit: onSubmitHandler,
    id: "loginform",
    name: "loginform",
    className: "HEADER_LOGIN__FORM LOGIN__MODAL__FORM"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title$1, {
    className: "HEADER_LOGIN__TITLE tw-mb-10 tw-font-bold bl-text-primary-180 bl-text-xl LOGIN__MODAL__TITLE"
  }, "Secure Login"), /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
    fill: buttonFillTypes.FILLED,
    className: "HEADER_LOGIN__BUTTON Header-Login_Button tw-w-full" // disabled={!query.username}
    ,
    type: "submit"
  }, textLoginButton), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_LOGIN__DESCRIPTION Header-Login_NewDigitalBanking tw-flex tw-justify-center tw-my-4"
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: process.env.GATSBY_LOGIN_ENROLL_NOW,
    className: "LOGIN__MODAL__ENROLL_A bl-text-grayscale-50"
  }, "NEW TO DIGITAL BANKING? ENROLL NOW"))));
}

var _templateObject$M, _templateObject2$8, _templateObject3$5, _templateObject4$2, _templateObject5$2, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

var LoginPostContainer = styled__default["default"].div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  padding: 40px;\n  min-width: 400px;\n\n  @media (max-width: 450px) {\n    min-width: 320px;\n  }\n"])));
var LoginPostForm = styled__default["default"].form(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral([""])));
var LoginPostContianerInput = styled__default["default"].div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  margin: 20px 0px 10px 0px;\n"])));
var LoginPostLabel = styled__default["default"].label(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  height: 45px;\n  background: #efefef;\n  cursor: text;\n\n  &:focus-within {\n    outline: 2px solid black;\n  }\n"])));
var LoginPostLabelText = styled__default["default"].p(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  margin-left: 45px;\n  top: ", ";\n  font-size: ", ";\n"])), function (_ref) {
  var _ref$isEmptyInput = _ref.isEmptyInput,
      isEmptyInput = _ref$isEmptyInput === void 0 ? false : _ref$isEmptyInput;
  return isEmptyInput ? "25%" : "0%";
}, function (_ref2) {
  var _ref2$isEmptyInput = _ref2.isEmptyInput,
      isEmptyInput = _ref2$isEmptyInput === void 0 ? false : _ref2$isEmptyInput;
  return isEmptyInput ? "14px" : "12px";
});
var LoginPostInput = styled__default["default"].input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-left: 40px;\n  padding: 0px 5px;\n  background: transparent;\n  font-size: 16px;\n  margin-top: ", ";\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref3) {
  var _ref3$isEmptyInput = _ref3.isEmptyInput,
      isEmptyInput = _ref3$isEmptyInput === void 0 ? false : _ref3$isEmptyInput;
  return isEmptyInput ? "0px" : "10px";
});
var LoginIconContainer = styled__default["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 25%;\n  margin-left: 10px;\n"])));
var LoginIcon = styled__default["default"].img(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 20px;\n"])));
var TitleContainer = styled__default["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-bottom: 40px;\n"])));
var Title = styled__default["default"].h3(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  color: var(--primary-150-color);\n  font-size: 26px;\n  font-weight: 600;\n"])));
var ForgotPasswordContainer = styled__default["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n"])));
var ForgotPassword = styled__default["default"].a(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-size: 14px;\n  color: var(--grayscale-50-color);\n"])));
var LoginPostContainerButton = styled__default["default"].div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  margin-top: 35px;\n  width: 100%;\n  text-align: center;\n"])));
var LoginPostButton = styled__default["default"].input(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 16px;\n  font-family: var(--primary-family);\n  text-align: center;\n  width: 100%;\n  padding: 14px 5px;\n  border-radius: 0px;\n  margin-bottom: 20px;\n  background: var(--primary-150-color);\n  border: 1px solid var(--primary-150-color);\n  color: var(--grayscale-0-color);\n  cursor: ", ";\n  opacity: ", ";\n\n  &:hover:enabled {\n    background: transparent;\n    border-color: var(--primary-150-color);\n    color: var(--primary-150-color);\n  }\n"])), function (_ref4) {
  var _ref4$disabled = _ref4.disabled,
      disabled = _ref4$disabled === void 0 ? false : _ref4$disabled;
  return disabled ? "not-allowed" : "pointer";
}, function (_ref5) {
  var _ref5$disabled = _ref5.disabled,
      disabled = _ref5$disabled === void 0 ? false : _ref5$disabled;
  return disabled ? "0.8" : "1";
});
var EnrollNowLink = styled__default["default"].a(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-family: var(--primary-family);\n  font-size: 14px;\n  color: var(--grayscale-50-color);\n"])));

function LoginFormInput(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      name = _ref.name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$isEmptyInput = _ref.isEmptyInput,
      isEmptyInput = _ref$isEmptyInput === void 0 ? false : _ref$isEmptyInput,
      _ref$imgSrc = _ref.imgSrc,
      imgSrc = _ref$imgSrc === void 0 ? "https://toledometrobucket.s3.us-east-2.amazonaws.com/icons/User.png" : _ref$imgSrc,
      _ref$imgAlt = _ref.imgAlt,
      imgAlt = _ref$imgAlt === void 0 ? "alt-Image" : _ref$imgAlt,
      OnChange = _ref.OnChange;
  return /*#__PURE__*/React__default$1["default"].createElement(LoginPostContianerInput, {
    className: classnames("LOGIN_POST__MODAL__CONTAINER__INPUT", className)
  }, /*#__PURE__*/React__default$1["default"].createElement(LoginPostLabel, {
    className: "LOGIN_POST__MODAL_LABEL"
  }, /*#__PURE__*/React__default$1["default"].createElement(LoginPostLabelText, {
    className: "LOGIN_POST__MODAL_LABEL_TEXT",
    isEmptyInput: isEmptyInput
  }, label), /*#__PURE__*/React__default$1["default"].createElement(LoginIconContainer, {
    className: "LOGIN_POST__MODAL__ICON_CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(LoginIcon, {
    src: imgSrc,
    alt: imgAlt
  })), /*#__PURE__*/React__default$1["default"].createElement(LoginPostInput, {
    className: "LOGIN_POST__MODAL__INPUT",
    isEmptyInput: isEmptyInput,
    type: type,
    name: name,
    id: name,
    onChange: OnChange
  })));
}

function LoginPost(_ref) {
  var _ref$loginPostUserNam = _ref.loginPostUserName,
      loginPostUserName = _ref$loginPostUserNam === void 0 ? "username" : _ref$loginPostUserNam,
      _ref$loginPostPasswor = _ref.loginPostPassword,
      loginPostPassword = _ref$loginPostPasswor === void 0 ? "password" : _ref$loginPostPasswor;

  var _useState = React.useState({
    name: "",
    password: ""
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      fieldsData = _useState2[0],
      setFieldsData = _useState2[1];

  var actionForm = process.env.GATSBY_LOGIN_URL || "/";
  var forgotPasswordLink = process.env.GATSBY_LOGIN_FORGOT_LOGIN_ID || "/";
  var enrollNowLink = process.env.GATSBY_LOGIN_ENROLL_NOW || "/";
  return /*#__PURE__*/React__default$1["default"].createElement(LoginPostContainer, {
    className: "LOGIN_POST__MODAL__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(LoginPostForm, {
    className: "LOGIN_POST__MODAL__FORM",
    method: "post",
    action: process.env.GATSBY_CU_NAME !== "United Members" ? actionForm : "https://unitedmbrs.cmycu.com/txapi.cgi?c2li"
  }, /*#__PURE__*/React__default$1["default"].createElement(TitleContainer, {
    className: "LOGIN_POST__MODAL__TITLE__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(Title, {
    className: "LOGIN_POST__MODAL__TITLE"
  }, "Secure Login")), /*#__PURE__*/React__default$1["default"].createElement(LoginFormInput, {
    className: "USERNAME_INPUT_LOGIN",
    type: "text",
    name: loginPostUserName,
    label: process.env.GATSBY_CU_NAME !== "United Members" ? loginPostUserName : "Account Number",
    isEmptyInput: !(fieldsData !== null && fieldsData !== void 0 && fieldsData.name),
    imgSrc: "https://toledometrobucket.s3.us-east-2.amazonaws.com/icons/User.png",
    imgAlt: "User Image",
    OnChange: function OnChange(e) {
      return setFieldsData(_objectSpread2(_objectSpread2({}, fieldsData), {}, {
        name: e.target.value
      }));
    }
  }), /*#__PURE__*/React__default$1["default"].createElement(LoginFormInput, {
    className: "PASSWORD_INPUT_LOGIN",
    type: "password",
    name: loginPostPassword,
    label: process.env.GATSBY_CU_NAME !== "United Members" ? loginPostPassword : "Password",
    isEmptyInput: !(fieldsData !== null && fieldsData !== void 0 && fieldsData.password),
    imgSrc: "https://toledometrobucket.s3.us-east-2.amazonaws.com/icons/Lock.png",
    imgAlt: "Password Image",
    OnChange: function OnChange(e) {
      return setFieldsData(_objectSpread2(_objectSpread2({}, fieldsData), {}, {
        password: e.target.value
      }));
    }
  }), /*#__PURE__*/React__default$1["default"].createElement(ForgotPasswordContainer, {
    className: "LOGIN_POST__MODAL__FORGOT__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(ForgotPassword, {
    href: forgotPasswordLink,
    className: "LOGIN_POST__MODAL__FORGOT"
  }, "Forgot Password")), /*#__PURE__*/React__default$1["default"].createElement(LoginPostContainerButton, {
    className: "LOGIN_POST__MODAL__BUTTON__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(LoginPostButton, {
    type: "submit",
    name: "btnLogin\u200B",
    className: "LOGIN_POST__MODAL__BUTTON",
    value: "Login",
    disabled: !fieldsData.name || !fieldsData.password
  }), /*#__PURE__*/React__default$1["default"].createElement(EnrollNowLink, {
    href: enrollNowLink,
    className: "LOGIN_POST__MODAL__ENROLL_NOW"
  }, "Not enrolled yet? Sign up now."))));
}

var _excluded$F = ["variant", "data"];

function Login(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? loginVariantTypes.FORM : _ref$variant,
      data = _ref.data,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$F);

  if (variant === loginVariantTypes.NO_MODAL) {
    window.open("".concat(process.env.GATSBY_LOGIN_URL), "_blank");
    return null;
  }

  if (variant === loginVariantTypes.DIRECT) return /*#__PURE__*/React__default$1["default"].createElement(LoginDirect, _extends$g({
    variant: variant
  }, data, otherProps));

  if (variant === loginVariantTypes.FORM) {
    return /*#__PURE__*/React__default$1["default"].createElement(LoginForm, _extends$g({
      variant: variant
    }, data, otherProps));
  }

  if (variant === loginVariantTypes.POST) {
    return /*#__PURE__*/React__default$1["default"].createElement(LoginPost, _extends$g({
      variant: variant
    }, data, otherProps));
  }

  throw new Error("no login variant found");
}

var _excluded$E = ["isActive", "onClickButton", "isScrollChangeColorButton", "float", "noFilter", "forceFilter", "scrollY", "backgroundBreakpoint", "filterEffect", "filterEffectAfterScroll"];

function ExpandedButton(_ref) {
  var _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      onClickButton = _ref.onClickButton,
      _ref$isScrollChangeCo = _ref.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref$isScrollChangeCo === void 0 ? false : _ref$isScrollChangeCo,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$noFilter = _ref.noFilter,
      noFilter = _ref$noFilter === void 0 ? false : _ref$noFilter,
      _ref$forceFilter = _ref.forceFilter,
      forceFilter = _ref$forceFilter === void 0 ? false : _ref$forceFilter,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$filterEffect = _ref.filterEffect,
      filterEffect = _ref$filterEffect === void 0 ? [] : _ref$filterEffect,
      _ref$filterEffectAfte = _ref.filterEffectAfterScroll,
      filterEffectAfterScroll = _ref$filterEffectAfte === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$filterEffectAfte,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$E);

  return /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "EXPANDED_BUTTON HeaderCompressed_ExpandedButton tw-float-right tw-flex tw-items-center tw-px-3 tw-py-2 hover:bl-border-grayscale-0",
    onClick: function onClick() {
      return onClickButton();
    }
  }, /*#__PURE__*/React__default$1["default"].createElement(Icon, _extends$g({
    className: "EXPANDED_BUTTON__ICON",
    icon: isActive ? iconTypes.REMOVE : iconTypes.NAVIGATION_MENU,
    isScrollChangeColorButton: isScrollChangeColorButton,
    "float": _float,
    noFilter: noFilter,
    forceFilter: forceFilter,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    filterEffect: filterEffect,
    filterEffectAfterScroll: filterEffectAfterScroll
  }, otherProps)));
}

var _templateObject$L;

var LinkWithSubLinksTitle$3 = styled__default["default"].p(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-weight: 500;\n"])));

var _templateObject$K;

var SubLinksTitle = styled__default["default"].p(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-weight: 600;\n"])));

function SubLinks$3(_ref) {
  var pathname = _ref.pathname,
      _ref$subLinks = _ref.subLinks,
      subLinks = _ref$subLinks === void 0 ? [] : _ref$subLinks;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SUB_LINKS"
  }, subLinks.map(function (subLink, i) {
    var keys = Object.keys(subLink) || [];
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "SUB_LINKS__LINK",
      key: "SubLinks-subLink-".concat(i)
    }, subLink.title && /*#__PURE__*/React__default$1["default"].createElement(SubLinksTitle, {
      className: "SUB_LINKS__LINK__TITLE HeaderCompressed_SubLinksTitle tw-pl-4 bl-text-base bl-text-primary tw-mt-4 tw-mb-2"
    }, subLink.title), keys.map(function (key, index) {
      var url = subLink["url".concat(index)];
      var text = subLink["text".concat(index)];
      if (!url || !text) return null;
      var isPdf = url.endsWith(".pdf");

      if (url === "/autolink") {
        return /*#__PURE__*/React__default$1["default"].createElement(AutoLink$1, {
          key: "".concat(url).concat(text, "-i"),
          url: url,
          text: text,
          pathname: pathname
        });
      }

      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "SubLink-key-".concat(key),
        className: classnames("SUB_LINKS__LINK__CONTAINER HeaderCompressed_SubLinksKey tw-w-full tw-py-1 tw-pl-4 bl-text-sm", "/".concat(pathname) === url ? "bl-bg-primary tw-text-white HeaderCompressed_SubLinksKey_active" : "bl-text-grayscale-30")
      }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
        href: url,
        target: isPdf ? "_blank" : "_self",
        className: classnames("SUB_LINKS__LINK__CONTAINER HeaderCompressed_SubLinksKey_Link bl-font-primary", "/".concat(pathname) === url ? "HeaderCompressed_SubLinksKey_Link_active" : "HeaderCompressed_SubLinksKey_Link_inactive")
      }, text));
    }));
  }));
}

function AutoLink$1(_ref2) {
  var url = _ref2.url,
      text = _ref2.text,
      pathname = _ref2.pathname;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("SUB_LINKS__LINK__CONTAINER HeaderCompressed_SubLinksKey tw-w-full tw-py-1 tw-pl-4 bl-text-sm", "/".concat(pathname) === url ? "bl-bg-primary tw-text-white HeaderCompressed_SubLinksKey_active" : "bl-text-grayscale-30")
  }, /*#__PURE__*/React__default$1["default"].createElement("a", {
    href: url,
    className: classnames("SUB_LINKS__LINK__CONTAINER HeaderCompressed_SubLinksKey_Link bl-font-primary", "/".concat(pathname) === url ? "HeaderCompressed_SubLinksKey_Link_active" : "HeaderCompressed_SubLinksKey_Link_inactive")
  }, text));
}

function LinkWithSubLinks$3(_ref) {
  var id = _ref.id,
      pathname = _ref.pathname,
      text = _ref.text,
      subLinks = _ref.subLinks,
      isLinkActive = _ref.isLinkActive,
      onClick = _ref.onClick;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "LINK_WITH_SUB_LINKS HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT HeaderCompressed_LinkWithSubLinks_Container tw-text-left"
  }, /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON BUTTON HeaderCompressed_LinkWithSubLinks_Button focus:tw-outline-none tw-text-left bl-text-sm tw-pl-4 tw-flex tw-items-center ".concat(isLinkActive ? "HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON__ACTIVE" : "HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON__INACTIVE"),
    onClick: onClick(id),
    onKeyPress: onClick(id)
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksTitle$3, {
    className: "LINK_WITH_SUB_TITLE HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON__TEXT HeaderCompressed_LinkWithSubLinksTitle tw-mr-4 bl-font-secondary"
  }, text), /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    className: "HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON__TEXT__ICON ICON ".concat(isLinkActive ? "HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON__TEXT__ICON_UP" : "HEADER_COMPRESSED__DROPDOWN__CONTAINER__CONTENT__ITEM__CONTENT__BUTTON__TEXT__ICON_DOWN"),
    size: 16,
    icon: isLinkActive ? iconTypes.ARROW_UP_1 : iconTypes.ARROW_DOWN_1
  })), isLinkActive && /*#__PURE__*/React__default$1["default"].createElement(SubLinks$3, {
    pathname: pathname,
    subLinks: subLinks
  }));
}

var _templateObject$J;

var CustomLink$3 = styled__default["default"](Link)(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  font-family: var(--secondary-family);\n  font-weight: 500;\n"])));

function LinkNormal$3(_ref) {
  var menuItem = _ref.menuItem,
      pathname = _ref.pathname,
      variant = _ref.variant;

  switch (variant) {
    case linkVariantTypes.PAGE_LINKS:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$3, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pageLinks,
        className: classnames("LINK_NORMAL HeaderCompressed_PAGE_LINKS_CustomLink tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-sm tw-pl-4 bl-font-secondary", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary")
      }, menuItem.text);

    case linkVariantTypes.PDF:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$3, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pdf.url,
        className: classnames("CUSTOM_LINK HeaderCompressed_PDF_CustomLink tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-sm tw-pl-4 bl-font-secondary", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary")
      }, menuItem.text);

    case linkVariantTypes.SEARCH:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$3, {
        to: "/search",
        "aria-label": "Search Button",
        className: classnames("CUSTOM_LINK HeaderDesktop-LinkNormal-search tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/search")
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_CONTAINER tw-flex"
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM"
      }, "Search"), /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM CUSTOM_LINK_SEARCH_ICON"
      }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 16 17",
        fill: "none"
      }, /*#__PURE__*/React__default$1["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2.75C3.79086 2.75 2 4.54086 2 6.75C2 8.95914 3.79086 10.75 6 10.75C8.20914 10.75 10 8.95914 10 6.75C10 4.54086 8.20914 2.75 6 2.75ZM0 6.75C0 3.43629 2.68629 0.75 6 0.75C9.31371 0.75 12 3.43629 12 6.75C12 8.04583 11.5892 9.24572 10.8907 10.2265L15.7071 15.0429C16.0976 15.4334 16.0976 16.0666 15.7071 16.4571C15.3166 16.8476 14.6834 16.8476 14.2929 16.4571L9.47653 11.6407C8.49572 12.3392 7.29583 12.75 6 12.75C2.68629 12.75 0 10.0637 0 6.75Z",
        fill: "#05274C"
      })))));

    default:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$3, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        href: menuItem.url,
        className: classnames("CUSTOM_LINK HeaderCompressed_DEFAULT_CustomLink tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-sm tw-pl-4 bl-font-secondary", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary")
      }, menuItem.text);
  }
}

function Dropdown$3(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      variant = _ref.variant,
      _ref$showBackground = _ref.showBackground,
      showBackground = _ref$showBackground === void 0 ? false : _ref$showBackground,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle,
      _ref$showModal = _ref.showModal,
      showModal = _ref$showModal === void 0 ? {} : _ref$showModal,
      _ref$onPressCloseMenu = _ref.onPressCloseMenuButton,
      onPressCloseMenuButton = _ref$onPressCloseMenu === void 0 ? {} : _ref$onPressCloseMenu;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      openedSubMenu = _useState2[0],
      setOpenedSubMenu = _useState2[1];

  function toggleSubMenu(subMenuId) {
    return function () {
      setOpenedSubMenu(subMenuId === openedSubMenu ? "" : subMenuId);
    };
  }

  loginButtonStyles = _objectSpread2(_objectSpread2({}, loginButtonStyles), {}, {
    variant: variant
  });
  return /*#__PURE__*/React__default$1["default"].createElement(DropdownsContainer, {
    background: "rgba(0, 0, 0, 0.2)",
    showBackground: showBackground,
    className: "DROPDOWN HeaderCompressed_DropdownsContainer  bl-font-secondary bl-text-grayscale-100 tw-mt-50 tw-z-50 tw-flex tw-justify-end",
    minHeight: "".concat(window.innerHeight - HeaderHeightInPx, "px")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "DROPDOWN__CONTAINER HeaderCompressed_DropdownsContainer_Container  tw-w-full lg:tw-w-80 tw-pb-28 bl-bg-grayscale-0 tw-absolute tw-top-0 tw-h-full tw-overflow-y-auto"
  }, /*#__PURE__*/React__default$1["default"].createElement(ActiveTopNav, {
    className: "DROPDOWN__CONTAINER__ACTIVE_TOP_NAV HeaderCompressed_DropdownsContainer_ActiveTopNav tw-flex tw-items-center tw-py-6 tw-justify-between tw-mx-4"
  }, data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.NONE,
    className: classnames("DROPDOWN__CONTAINER__ACTIVE_TOP_NAV__BUTTON BUTTON HeaderCompressed_DropdownsContainer_ActiveTopNav_Button tw-mr-3"),
    variant: true,
    onClick: function onClick() {
      if (variant !== "NO_MODAL") {
        showModal();
      }
    }
  }, loginButtonStyles), data.loginButtonText), /*#__PURE__*/React__default$1["default"].createElement(ExpandedButton, {
    onClickButton: function onClickButton() {
      return onPressCloseMenuButton();
    },
    isActive: isActive
  })), (data.NavBarItems || []).map(function (menuItem, index) {
    var isLinkActive = menuItem.id === openedSubMenu;
    var variantTipe = menuItem.pdf ? "pdf" : menuItem.pageLinks ? "pageLinks" : "url";
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "Dropdown-menuItem-".concat(index),
      className: "DROPDOWN__CONTAINER__CONTENT tw-mt-4"
    }, menuItem.subLinks && menuItem.subLinks.length > 0 ? /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinks$3, {
      isLinkActive: isLinkActive,
      id: menuItem.id,
      pathname: pathname,
      text: menuItem.text,
      subLinks: menuItem.subLinks,
      url: menuItem.url,
      onClick: toggleSubMenu
    }) : /*#__PURE__*/React__default$1["default"].createElement(LinkNormal$3, {
      menuItem: menuItem,
      pathname: pathname,
      variant: variantTipe
    }));
  }), /*#__PURE__*/React__default$1["default"].createElement(LinkNormal$3, {
    className: "DROPDOWN_CONTAINER__MENU__ITEM_DESKTOP_COMPRESSED LINK_NORMAL_SEARCH",
    menuItem: "",
    pathname: "/search",
    variant: linkVariantTypes.SEARCH
  })));
}

var _templateObject$I;

var CustomButton$1 = styled__default["default"](Button$2)(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  background: ", ";\n\n  border-color: ", ";\n\n  color: ", ";\n\n  &:hover {\n    background: ", ";\n\n    border-color: ", ";\n\n    color: ", ";\n  }\n"])), function (_ref) {
  var background = _ref.background,
      _ref$scrollBackground = _ref.scrollBackground,
      scrollBackground = _ref$scrollBackground === void 0 ? colorsTypes.WHITE : _ref$scrollBackground,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$isScrollChangeCo = _ref.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref$isScrollChangeCo === void 0 ? false : _ref$isScrollChangeCo,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp;

  if (forceShow) {
    if (!!_float && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
      return scrollBackground;
    }

    return background;
  }

  if (!!_float && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
    return scrollBackground;
  }

  if (transparent) return transparentBackground;
  return background;
}, function (_ref2) {
  var borderColor = _ref2.borderColor,
      _ref2$scrollBorderCol = _ref2.scrollBorderColor,
      scrollBorderColor = _ref2$scrollBorderCol === void 0 ? colorsTypes.WHITE : _ref2$scrollBorderCol,
      _ref2$float = _ref2["float"],
      _float2 = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$transparentBord = _ref2.transparentBorderColor,
      transparentBorderColor = _ref2$transparentBord === void 0 ? colorsTypes.PRIMARY_DARK : _ref2$transparentBord,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$isScrollChangeC = _ref2.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref2$isScrollChangeC === void 0 ? false : _ref2$isScrollChangeC,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$borderColorBrea = _ref2.borderColorBreakpoint,
      borderColorBreakpoint = _ref2$borderColorBrea === void 0 ? 20 : _ref2$borderColorBrea;

  if (forceShow) return borderColor;

  if (!!_float2 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
    return scrollBorderColor;
  }

  if (transparent) return transparentBorderColor;
  return borderColor;
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsTypes.PRIMARY_DARK : _ref3$color,
      _ref3$scrollColor = _ref3.scrollColor,
      scrollColor = _ref3$scrollColor === void 0 ? colorsTypes.WHITE : _ref3$scrollColor,
      _ref3$float = _ref3["float"],
      _float3 = _ref3$float === void 0 ? false : _ref3$float,
      _ref3$isScrollChangeC = _ref3.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref3$isScrollChangeC === void 0 ? false : _ref3$isScrollChangeC,
      _ref3$scrollY = _ref3.scrollY,
      scrollY = _ref3$scrollY === void 0 ? 0 : _ref3$scrollY,
      _ref3$backgroundBreak = _ref3.backgroundBreakpoint,
      backgroundBreakpoint = _ref3$backgroundBreak === void 0 ? 20 : _ref3$backgroundBreak;

  if (!!_float3 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
    return scrollColor;
  }

  return color;
}, function (_ref4) {
  var _ref4$hoverBackground = _ref4.hoverBackground,
      hoverBackground = _ref4$hoverBackground === void 0 ? colorsTypes.PRIMARY_DARK : _ref4$hoverBackground,
      _ref4$hoverScrollBack = _ref4.hoverScrollBackground,
      hoverScrollBackground = _ref4$hoverScrollBack === void 0 ? colorsTypes.WHITE : _ref4$hoverScrollBack,
      _ref4$float = _ref4["float"],
      _float4 = _ref4$float === void 0 ? false : _ref4$float,
      _ref4$hoverTransparen = _ref4.hoverTransparentBackground,
      hoverTransparentBackground = _ref4$hoverTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref4$hoverTransparen,
      _ref4$transparent = _ref4.transparent,
      transparent = _ref4$transparent === void 0 ? false : _ref4$transparent,
      _ref4$forceShow = _ref4.forceShow,
      forceShow = _ref4$forceShow === void 0 ? false : _ref4$forceShow,
      _ref4$isScrollChangeC = _ref4.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref4$isScrollChangeC === void 0 ? false : _ref4$isScrollChangeC,
      _ref4$scrollY = _ref4.scrollY,
      scrollY = _ref4$scrollY === void 0 ? 0 : _ref4$scrollY,
      _ref4$backgroundBreak = _ref4.backgroundBreakpoint,
      backgroundBreakpoint = _ref4$backgroundBreak === void 0 ? 20 : _ref4$backgroundBreak;

  if (forceShow) {
    if (!!_float4 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
      return hoverScrollBackground;
    }

    return hoverBackground;
  }

  if (!!_float4 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
    return hoverScrollBackground;
  }

  if (transparent) return hoverTransparentBackground;
  return hoverBackground;
}, function (_ref5) {
  var hoverBorderColor = _ref5.hoverBorderColor,
      _ref5$hoverScrollBord = _ref5.hoverScrollBorderColor,
      hoverScrollBorderColor = _ref5$hoverScrollBord === void 0 ? colorsTypes.WHITE : _ref5$hoverScrollBord,
      _ref5$float = _ref5["float"],
      _float5 = _ref5$float === void 0 ? false : _ref5$float,
      _ref5$hoverTransparen = _ref5.hoverTransparentBorderColor,
      hoverTransparentBorderColor = _ref5$hoverTransparen === void 0 ? colorsTypes.PRIMARY_DARK : _ref5$hoverTransparen,
      _ref5$transparent = _ref5.transparent,
      transparent = _ref5$transparent === void 0 ? false : _ref5$transparent,
      _ref5$forceShow = _ref5.forceShow,
      forceShow = _ref5$forceShow === void 0 ? false : _ref5$forceShow,
      _ref5$isScrollChangeC = _ref5.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref5$isScrollChangeC === void 0 ? false : _ref5$isScrollChangeC,
      _ref5$scrollY = _ref5.scrollY,
      scrollY = _ref5$scrollY === void 0 ? 0 : _ref5$scrollY,
      _ref5$borderColorBrea = _ref5.borderColorBreakpoint,
      borderColorBreakpoint = _ref5$borderColorBrea === void 0 ? 20 : _ref5$borderColorBrea;

  if (forceShow) {
    if (!!_float5 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
      return hoverScrollBorderColor;
    }

    return hoverBorderColor;
  }

  if (!!_float5 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
    return hoverScrollBorderColor;
  }

  if (transparent) return hoverTransparentBorderColor;
  return hoverBorderColor;
}, function (_ref6) {
  var _ref6$hoverScrollColo = _ref6.hoverScrollColor,
      hoverScrollColor = _ref6$hoverScrollColo === void 0 ? colorsTypes.PRIMARY_DARK : _ref6$hoverScrollColo,
      _ref6$hoverColor = _ref6.hoverColor,
      hoverColor = _ref6$hoverColor === void 0 ? colorsTypes.WHITE : _ref6$hoverColor,
      _ref6$float = _ref6["float"],
      _float6 = _ref6$float === void 0 ? false : _ref6$float,
      _ref6$borderColorBrea = _ref6.borderColorBreakpoint,
      borderColorBreakpoint = _ref6$borderColorBrea === void 0 ? false : _ref6$borderColorBrea,
      _ref6$scrollY = _ref6.scrollY,
      scrollY = _ref6$scrollY === void 0 ? 0 : _ref6$scrollY,
      _ref6$isScrollChangeC = _ref6.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref6$isScrollChangeC === void 0 ? 20 : _ref6$isScrollChangeC;

  if (!!_float6 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
    return hoverScrollColor;
  }

  return hoverColor;
});

function Default(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      className = _ref.className,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? "" : _ref$background,
      _ref$activeLogoReplac = _ref.activeLogoReplaceImageWith,
      activeLogoReplaceImageWith = _ref$activeLogoReplac === void 0 ? "" : _ref$activeLogoReplac,
      _ref$mobileActiveLogo = _ref.mobileActiveLogoReplaceImageWith,
      mobileActiveLogoReplaceImageWith = _ref$mobileActiveLogo === void 0 ? "" : _ref$mobileActiveLogo,
      _ref$activeLogoReplac2 = _ref.activeLogoReplaceImageWithAfterBreakpoint,
      activeLogoReplaceImageWithAfterBreakpoint = _ref$activeLogoReplac2 === void 0 ? "" : _ref$activeLogoReplac2,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpoint,
      backgroundAfterBreakpoint = _ref$backgroundAfterB === void 0 ? "rgba(32, 0, 9, 0.4)" : _ref$backgroundAfterB,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$noFilterLogo = _ref.noFilterLogo,
      noFilterLogo = _ref$noFilterLogo === void 0 ? false : _ref$noFilterLogo,
      _ref$backgroundMenu = _ref.backgroundMenu,
      backgroundMenu = _ref$backgroundMenu === void 0 ? colorsTypes.TRANSPARENT : _ref$backgroundMenu,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$hoverTransparent = _ref.hoverTransparentBackground,
      hoverTransparentBackground = _ref$hoverTransparent === void 0 ? colorsTypes.TRANSPARENT : _ref$hoverTransparent,
      _ref$backgroundAfterB2 = _ref.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref$backgroundAfterB2 === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB2,
      _ref$loginButtonIsScr = _ref.loginButtonIsScrollChangeColorButton,
      loginButtonIsScrollChangeColorButton = _ref$loginButtonIsScr === void 0 ? false : _ref$loginButtonIsScr,
      _ref$loginButtonScrol = _ref.loginButtonScrollBackground,
      loginButtonScrollBackground = _ref$loginButtonScrol === void 0 ? colorsTypes.WHITE : _ref$loginButtonScrol,
      _ref$loginButtonScrol2 = _ref.loginButtonScrollBackgroundAfterScroll,
      loginButtonScrollBackgroundAfterScroll = _ref$loginButtonScrol2 === void 0 ? colorsTypes.PRIMARY_DARK : _ref$loginButtonScrol2,
      _ref$noFilterMenuIcon = _ref.noFilterMenuIcon,
      noFilterMenuIcon = _ref$noFilterMenuIcon === void 0 ? false : _ref$noFilterMenuIcon,
      _ref$forceFilterMenuI = _ref.forceFilterMenuIcon,
      forceFilterMenuIcon = _ref$forceFilterMenuI === void 0 ? false : _ref$forceFilterMenuI,
      _ref$logoFilterEffect = _ref.logoFilterEffect,
      logoFilterEffect = _ref$logoFilterEffect === void 0 ? [] : _ref$logoFilterEffect,
      _ref$logoFilterEffect2 = _ref.logoFilterEffectAfterScroll,
      logoFilterEffectAfterScroll = _ref$logoFilterEffect2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$logoFilterEffect2,
      _ref$activeLogoFilter = _ref.activeLogoFilterEffect,
      activeLogoFilterEffect = _ref$activeLogoFilter === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$activeLogoFilter,
      _ref$activeLogoFilter2 = _ref.activeLogoFilterEffectAfterScroll,
      activeLogoFilterEffectAfterScroll = _ref$activeLogoFilter2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$activeLogoFilter2,
      _ref$mobileMenuIconFi = _ref.mobileMenuIconFilterEffect,
      mobileMenuIconFilterEffect = _ref$mobileMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi,
      _ref$mobileMenuIconFi2 = _ref.mobileMenuIconFilterEffectAfterScroll,
      mobileMenuIconFilterEffectAfterScroll = _ref$mobileMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi2,
      _ref$mobileMenuIconAc = _ref.mobileMenuIconActiveFilterEffectAfterScroll,
      mobileMenuIconActiveFilterEffectAfterScroll = _ref$mobileMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconAc,
      _ref$menuIconFilterEf = _ref.menuIconFilterEffect,
      menuIconFilterEffect = _ref$menuIconFilterEf === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf,
      _ref$menuIconFilterEf2 = _ref.menuIconFilterEffectAfterScroll,
      menuIconFilterEffectAfterScroll = _ref$menuIconFilterEf2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf2,
      _ref$menuIconActiveFi = _ref.menuIconActiveFilterEffectAfterScroll,
      menuIconActiveFilterEffectAfterScroll = _ref$menuIconActiveFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconActiveFi,
      _ref$mobileBackground = _ref.mobileBackground,
      mobileBackground = _ref$mobileBackground === void 0 ? colorsTypes.WHITE : _ref$mobileBackground,
      _ref$mobileBackground2 = _ref.mobileBackgroundAfterBreakpoint,
      mobileBackgroundAfterBreakpoint = _ref$mobileBackground2 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground2,
      _ref$mobileActiveBack = _ref.mobileActiveBackground,
      mobileActiveBackground = _ref$mobileActiveBack === void 0 ? colorsTypes.WHITE : _ref$mobileActiveBack,
      _ref$mobileTransparen = _ref.mobileTransparentBackground,
      mobileTransparentBackground = _ref$mobileTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileTransparen,
      _ref$mobileHoverBackg = _ref.mobileHoverBackground,
      mobileHoverBackground = _ref$mobileHoverBackg === void 0 ? colorsTypes.WHITE : _ref$mobileHoverBackg,
      _ref$mobileHoverFloat = _ref.mobileHoverFloatBackground,
      mobileHoverFloatBackground = _ref$mobileHoverFloat === void 0 ? colorsTypes.WHITE : _ref$mobileHoverFloat,
      _ref$mobileHoverActiv = _ref.mobileHoverActiveBackground,
      mobileHoverActiveBackground = _ref$mobileHoverActiv === void 0 ? colorsTypes.WHITE : _ref$mobileHoverActiv,
      _ref$mobileBackground3 = _ref.mobileBackgroundAfterBreakpointHover,
      mobileBackgroundAfterBreakpointHover = _ref$mobileBackground3 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground3,
      _ref$mobileHoverTrans = _ref.mobileHoverTransparentBackground,
      mobileHoverTransparentBackground = _ref$mobileHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileHoverTrans,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle,
      _ref$menuIconStyles = _ref.menuIconStyles,
      menuIconStyles = _ref$menuIconStyles === void 0 ? {} : _ref$menuIconStyles,
      variant = _ref.variant,
      _ref$dropdownLoginBut = _ref.dropdownLoginButtonStyles,
      dropdownLoginButtonStyles = _ref$dropdownLoginBut === void 0 ? {} : _ref$dropdownLoginBut,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      menuActive = _useState2[0],
      setMenuActive = _useState2[1];

  React.useEffect(function () {
    screenOverflowHidden(menuActive);
  }, [menuActive]);
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    activeLogoReplaceImageWith: activeLogoReplaceImageWith,
    mobileActiveLogoReplaceImageWith: mobileActiveLogoReplaceImageWith,
    mobileBackground: mobileBackground,
    mobileBackgroundAfterBreakpoint: mobileBackgroundAfterBreakpoint,
    mobileActiveBackground: mobileActiveBackground,
    mobileTransparentBackground: mobileTransparentBackground,
    mobileHoverBackground: mobileHoverBackground,
    mobileHoverFloatBackground: mobileHoverFloatBackground,
    mobileHoverActiveBackground: mobileHoverActiveBackground,
    mobileBackgroundAfterBreakpointHover: mobileBackgroundAfterBreakpointHover,
    mobileHoverTransparentBackground: mobileHoverTransparentBackground,
    mobileLogoFilterEffectAfterScroll: logoFilterEffectAfterScroll,
    mobileActiveLogoFilterEffectAfterScroll: activeLogoFilterEffectAfterScroll,
    mobileActiveLogoReplaceImageWithAfterBreakpoint: activeLogoReplaceImageWithAfterBreakpoint,
    mobileLogoFilterEffect: logoFilterEffect,
    activeLogoReplaceImageWithAfterBreakpoint: activeLogoReplaceImageWithAfterBreakpoint,
    activeLogoFilterEffect: activeLogoFilterEffect,
    noFilterLogo: noFilterLogo,
    background: background,
    backgroundAfterBreakpoint: backgroundAfterBreakpoint,
    transparentBackground: transparentBackground,
    hoverTransparentBackground: hoverTransparentBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent || !menuActive,
    forceShow: forceShow || menuActive,
    variant: variant,
    className: classnames("HEADER_DYNAMIC_CONTAINER Header-Dynamic-Container lg:tw-pb-16 tw-fixed lg:tw-absolute tw-z-50 tw-w-full tw-font-normal tw-h-full", menuActive && "HEADER_DYNAMIC_CONTAINER_ACTIVE tw-min-h-screen tw-overflow-y-scroll lg:tw-overflow-y-auto", className, scrollY > backgroundBreakpoint ? "HEADER_DYNAMIC_CONTAINER_SCROLLED " : "HEADER_DYNAMIC_CONTAINER_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_COMPRESSED_DINAMIC_PAGE" : "HEADER_MOBILE_COMPRESSED_NO_DINAMIC_PAGE"),
    style: HeaderHeight
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement("nav", {
    className: classnames("HEADER_DYNAMIC_CONTAINER__NAV Header-Dynamic-Container_Nav tw-z-50 lg:tw-h-full", !menuActive && "tw-h-full")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER tw-h-full lg:tw-h-auto tw-px-6"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER__CONTENT Header-Dynamic-Container_Nav_Container tw-w-full tw-flex tw-justify-between tw-items-center",
    style: HeaderHeight
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER__CONTENT__LINK Header-Dynamic-Container_Nav_Link tw-mr-6 tw-my-4",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER__CONTENT__LINK__IMAGE Header__logo tw-w-40",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER__CONTENT__MENU Header-Dynamic-Container_Nav_Container_Container tw-float-right tw-flex tw-items-center tw-py-2 tw-rounded", menuActive ? "tw-hidden lg:tw-block" : "tw-block")
  }, process.env.GATSBY_CU_NAME === "leather_stocking" && data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$1, _extends$g({
    isScrollChangeColorButton: loginButtonIsScrollChangeColorButton,
    scrollBackground: loginButtonScrollBackground,
    scrollBackgroundAfterScroll: loginButtonScrollBackgroundAfterScroll,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    fill: buttonFillTypes.FILLED,
    className: classnames("CUSTOM_BUTTON HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER__CONTENT__MENU__BUTTON Header-Dynamic-Container_Nav_Button tw-mr-3", menuActive ? "tw-hidden lg:tw-block HEADER_DESKTOP_COMPRESS_BUTTON_ACTIVE" : "tw-block", scrollY > backgroundBreakpoint ? " HEADER_DESKTOP_BUTTON_SCROLLED " : "HEADER_DESKTOP_BUTTON_NO_SCROLLED"),
    variant: loginButtonStyles.variant
  }, loginButtonStyles, {
    href: "https://www.mobicint.net/lth/loanapp/list",
    isAuxHref: false
  }), "Apply For A Loan"), data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton$1, _extends$g({
    isScrollChangeColorButton: loginButtonIsScrollChangeColorButton,
    scrollBackground: loginButtonScrollBackground,
    scrollBackgroundAfterScroll: loginButtonScrollBackgroundAfterScroll,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    fill: buttonFillTypes.FILLED,
    className: classnames("CUSTOM_BUTTON HEADER_DYNAMIC_CONTAINER__NAV__CONTAINER__CONTENT__MENU__BUTTON Header-Dynamic-Container_Nav_Button tw-mr-3", menuActive ? "tw-hidden lg:tw-block HEADER_DESKTOP_COMPRESS_BUTTON_ACTIVE" : "tw-block", scrollY > backgroundBreakpoint ? " HEADER_DESKTOP_BUTTON_SCROLLED " : "HEADER_DESKTOP_BUTTON_NO_SCROLLED"),
    variant: loginButtonStyles.variant,
    onClick: function onClick() {
      if ((loginButtonStyles === null || loginButtonStyles === void 0 ? void 0 : loginButtonStyles.variant) !== "NO_MODAL") {
        showModal();
        setMenuActive(false);
      }
    }
  }, loginButtonStyles), data.loginButtonText), data && /*#__PURE__*/React__default$1["default"].createElement(ExpandedButton, _extends$g({
    isActive: menuActive,
    isScrollChangeColorButton: loginButtonStyles === null || loginButtonStyles === void 0 ? void 0 : loginButtonStyles.isScrollChangeColorButton,
    forceShow: forceShow || menuActive,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    icon: iconTypes.NAVIGATION_MENU,
    noFilter: noFilterMenuIcon,
    forceFilter: forceFilterMenuIcon,
    filterEffect: menuIconFilterEffect,
    filterEffectAfterScroll: menuIconFilterEffectAfterScroll,
    activeFilterEffectAfterScroll: menuIconActiveFilterEffectAfterScroll,
    mobileFilterEffect: mobileMenuIconFilterEffect,
    variant: loginButtonStyles.variant,
    mobileFilterEffectAfterScroll: mobileMenuIconFilterEffectAfterScroll,
    mobileActiveFilterEffectAfterScroll: mobileMenuIconActiveFilterEffectAfterScroll,
    onClickButton: function onClickButton() {
      setMenuActive(function (current) {
        return !current;
      });
    }
  }, menuIconStyles))))), menuActive && data && /*#__PURE__*/React__default$1["default"].createElement(Dropdown$3, {
    background: backgroundMenu,
    showBackground: _float,
    data: data,
    pathname: pathname,
    isActive: menuActive,
    showModal: showModal,
    variant: loginButtonStyles.variant,
    onPressCloseMenuButton: function onPressCloseMenuButton() {
      return setMenuActive(false);
    },
    loginButtonStyles: dropdownLoginButtonStyles
  }), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login, _extends$g({
    variant: loginButtonStyles.variant
  }, loginButtonStyles)))));
}

var _excluded$D = ["variant"];

function HeaderCompressed(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? headerCompressedVariantTypes.STANDARD : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$D);

  switch (variant) {
    case headerCompressedVariantTypes.STANDARD:
      return /*#__PURE__*/React__default$1["default"].createElement(Default, otherProps);

    default:
      throw new Error("Header Compressed: Invalid variant type (".concat(variant, ")"));
  }
}

var _templateObject$H;

var HeaderDesktopDropdownSubItemText = styled__default["default"].a(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_LIGHT : _ref$color;
  return color;
}, function (_ref2) {
  var _ref2$isHoverLink = _ref2.isHoverLink,
      isHoverLink = _ref2$isHoverLink === void 0 ? false : _ref2$isHoverLink,
      _ref2$hoverColor = _ref2.hoverColor,
      hoverColor = _ref2$hoverColor === void 0 ? "" : _ref2$hoverColor,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.PRIMARY_LIGHT : _ref2$color;
  if (isHoverLink) return hoverColor;
  return color;
});

var _templateObject$G;

var HeaderDesktopLinkDropdownTitle = styled__default["default"].h5(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$color;
  return color;
});

var _templateObject$F;

var HeaderDesktopLinkDropdownContainer = styled__default["default"].div(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n  top: calc(\n    100% +\n      ", "px\n  );\n  background: ", ";\n"])), function (_ref) {
  var _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$separationFromTo = _ref.separationFromTop,
      separationFromTop = _ref$separationFromTo === void 0 ? 20 : _ref$separationFromTo,
      _ref$separationFromBo = _ref.separationFromBottom,
      separationFromBottom = _ref$separationFromBo === void 0 ? 50 : _ref$separationFromBo;
  return topIndicator ? separationFromTop : separationFromBottom;
}, function (_ref2) {
  var _ref2$grayscaleBackgr = _ref2.grayscaleBackgroundColor,
      grayscaleBackgroundColor = _ref2$grayscaleBackgr === void 0 ? colorsTypes.WHITE : _ref2$grayscaleBackgr,
      _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref2$backgroundColor,
      _ref2$grayscale = _ref2.grayscale,
      grayscale = _ref2$grayscale === void 0 ? false : _ref2$grayscale;
  return grayscale ? grayscaleBackgroundColor : backgroundColor;
});

function HeaderDesktopLinkDropdown(_ref) {
  var menuItem = _ref.menuItem,
      _ref$currentPath = _ref.currentPath,
      currentPath = _ref$currentPath === void 0 ? {} : _ref$currentPath,
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? "/" : _ref$pathname,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$titleColor,
      _ref$itemTextColor = _ref.itemTextColor,
      itemTextColor = _ref$itemTextColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$itemTextColor,
      _ref$itemTextActiveCo = _ref.itemTextActiveColor,
      itemTextActiveColor = _ref$itemTextActiveCo === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$itemTextActiveCo,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$backgroundColor,
      _ref$grayscaleBackgro = _ref.grayscaleBackgroundColor,
      grayscaleBackgroundColor = _ref$grayscaleBackgro === void 0 ? colorsTypes.WHITE : _ref$grayscaleBackgro,
      _ref$separationFromTo = _ref.separationFromTop,
      separationFromTop = _ref$separationFromTo === void 0 ? 20 : _ref$separationFromTo,
      _ref$separationFromBo = _ref.separationFromBottom,
      separationFromBottom = _ref$separationFromBo === void 0 ? 50 : _ref$separationFromBo;
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkDropdownContainer, {
    separationFromTop: separationFromTop,
    separationFromBottom: separationFromBottom,
    grayscale: grayscale,
    grayscaleBackgroundColor: grayscaleBackgroundColor,
    backgroundColor: backgroundColor,
    topIndicator: topIndicator,
    className: "HEADER_DESKTOP__LINK__DROPDOWN HeaderDesktopLinkDropdownContainer tw-px-8 tw-rounded-b tw-flex tw-absolute tw-text-gray-700 group-hover:tw-block bl-text-sm"
  }, menuItem.subLinks.map(function (items, i) {
    var keys = Object.keys(items);
    return /*#__PURE__*/React__default$1["default"].createElement("ul", {
      key: "HeaderLinkDropdown-items-".concat(i),
      className: "HEADER_DESKTOP__LINK__DROPDOWN__LINTE HeaderLinkDropdown-items tw-py-10 tw-w-52"
    }, items.title && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkDropdownTitle, {
      color: titleColor,
      className: "HEADER_DESKTOP__LINK__DROPDOWN__LIST__TITLE HeaderDesktopLinkDropdownTitle tw-py-2 tw-px-4 tw-font-bold tw-block tw-whitespace-no-wrap"
    }, items.title), keys.map(function (key, index) {
      var url = items["url".concat(index)];
      var text = items["text".concat(index)];
      if (!url || !text) return null;
      var isExternal = url.endsWith(".pdf") || url.endsWith(".html");
      var isItemActive = currentPath && currentPath.isCurrentPath && new RegExp(currentPath.value, "gi").test(text) && currentPath.url && currentPath.url.value === url && active;
      if (pathname === "/") isItemActive = false; // if (url === "/savings-rates") debugger;

      return /*#__PURE__*/React__default$1["default"].createElement("li", {
        className: "HEADER_DESKTOP__LINK__DROPDOWN__LIST__ITEM",
        key: "HeaderDropdownSubContainer-subItem-".concat(key)
      }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDropdownSubItemText, {
        isHoverLink: true,
        target: isExternal ? "_blank" : "_self",
        hoverColor: itemTextActiveColor,
        color: isItemActive ? itemTextActiveColor : itemTextColor,
        className: classnames("HEADER_DESKTOP__LINK__DROPDOWN__LIST__ITEM__TEXT HeaderDesktopDropdownSubItemText tw-rounded-b tw-py-2 tw-px-4 tw-block tw-whitespace-no-wrap", isItemActive ? "tw-font-bold HEADER_DESKTOP__LINK__DROPDOWN__LIST__ITEM__TEXT_ACTIVE" : "bl-text-grayscale-50"),
        href: url
      }, text));
    }));
  }));
}

var _templateObject$E;

var HeaderDesktopLinkWithSubLinksIcon = styled__default["default"](Icon)(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  filter: ", ";\n"])), function (_ref) {
  var _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$filterEffect = _ref.filterEffect,
      filterEffect = _ref$filterEffect === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$filterEffect,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow;

  if (forceShow) return undefined;

  if (!!_float && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return filterEffect.join(" ");
  }

  return undefined;
});

var _templateObject$D;

var HeaderDesktopLinkWithSubLinksButton = styled__default["default"].button(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  padding: 1rem 1.25rem;\n  font-family: ", ";\n\n  font-family: ", ";\n\n  background: ", ";\n\n  span {\n    color: ", ";\n  }\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref2) {
  var _ref2$primaryFamily = _ref2.primaryFamily,
      primaryFamily = _ref2$primaryFamily === void 0 ? false : _ref2$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref3) {
  var _ref3$grayscale = _ref3.grayscale,
      grayscale = _ref3$grayscale === void 0 ? false : _ref3$grayscale,
      _ref3$transparent = _ref3.transparent,
      transparent = _ref3$transparent === void 0 ? false : _ref3$transparent,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible,
      _ref3$grayscaleBackgr = _ref3.grayscaleBackgroundColor,
      grayscaleBackgroundColor = _ref3$grayscaleBackgr === void 0 ? colorsTypes.WHITE : _ref3$grayscaleBackgr,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$backgroundColor,
      _ref3$transparentBack = _ref3.transparentBackgroundColor,
      transparentBackgroundColor = _ref3$transparentBack === void 0 ? colorsTypes.TRANSPARENT : _ref3$transparentBack;
  if (!isVisible) return undefined;
  if (transparent) return transparentBackgroundColor;
  if (grayscale) return grayscaleBackgroundColor; // return colorsTypes.PRIMARY_VERY_ULTRA_LIGHT;

  return backgroundColor;
}, function (_ref4) {
  var _ref4$float = _ref4["float"],
      _float = _ref4$float === void 0 ? false : _ref4$float,
      _ref4$forceShow = _ref4.forceShow,
      forceShow = _ref4$forceShow === void 0 ? false : _ref4$forceShow,
      _ref4$transparent = _ref4.transparent,
      transparent = _ref4$transparent === void 0 ? false : _ref4$transparent,
      _ref4$grayscale = _ref4.grayscale,
      grayscale = _ref4$grayscale === void 0 ? false : _ref4$grayscale,
      _ref4$scrollY = _ref4.scrollY,
      scrollY = _ref4$scrollY === void 0 ? 0 : _ref4$scrollY,
      _ref4$backgroundBreak = _ref4.backgroundBreakpoint,
      backgroundBreakpoint = _ref4$backgroundBreak === void 0 ? 20 : _ref4$backgroundBreak,
      _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref4$color,
      _ref4$transparentColo = _ref4.transparentColor,
      transparentColor = _ref4$transparentColo === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref4$transparentColo,
      _ref4$transparentGray = _ref4.transparentGrayscaleColor,
      transparentGrayscaleColor = _ref4$transparentGray === void 0 ? colorsTypes.WHITE : _ref4$transparentGray,
      _ref4$forceShowColor = _ref4.forceShowColor,
      forceShowColor = _ref4$forceShowColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref4$forceShowColor;

  if (forceShow) return forceShowColor;

  if (!!_float && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    if (transparent) {
      if (grayscale) return transparentGrayscaleColor;
      return transparentColor;
    }

    return color;
  }

  return undefined;
});

var _templateObject$C;

var HeaderDesktopLinkWithSubLinksContainer = styled__default["default"].div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  display: grid;\n  z-index: ", ";\n  margin: 6px 27px auto 0;\n  border-style: solid;\n  height: min-content;\n\n  border-top-width: ", "px;\n\n  border-color: ", ";\n\n  border-bottom-width: ", "px;\n\n  border-top-width: ", "px;\n\n  background: ", ";\n\n  &:hover {\n    background: ", ";\n\n    /*\n    border-top-width: ", "px;\n\n    border-bottom-width: ", "px;\n\n    border-color: ", ";\n    */\n  }\n"])), function (_ref) {
  var _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible;
  return isVisible ? 100 : 50;
}, function (_ref2) {
  var _ref2$disableBorder = _ref2.disableBorder,
      disableBorder = _ref2$disableBorder === void 0 ? false : _ref2$disableBorder,
      _ref2$isVisible = _ref2.isVisible,
      isVisible = _ref2$isVisible === void 0 ? false : _ref2$isVisible,
      _ref2$topIndicator = _ref2.topIndicator,
      topIndicator = _ref2$topIndicator === void 0 ? true : _ref2$topIndicator;
  return topIndicator && isVisible || !disableBorder ? 2 : 0;
}, function (_ref3) {
  var _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$borderColor,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible,
      _ref3$disableBorder = _ref3.disableBorder,
      disableBorder = _ref3$disableBorder === void 0 ? false : _ref3$disableBorder;
  if (disableBorder) return undefined;
  if (isVisible || active) return borderColor;
  return colorsTypes.TRANSPARENT;
}, function (_ref4) {
  var _ref4$disableBorder = _ref4.disableBorder,
      disableBorder = _ref4$disableBorder === void 0 ? false : _ref4$disableBorder,
      _ref4$active = _ref4.active,
      active = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$isVisible = _ref4.isVisible,
      isVisible = _ref4$isVisible === void 0 ? false : _ref4$isVisible,
      _ref4$topIndicator = _ref4.topIndicator,
      topIndicator = _ref4$topIndicator === void 0 ? true : _ref4$topIndicator;
  if (disableBorder) return undefined;
  return !topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref5) {
  var _ref5$disableBorder = _ref5.disableBorder,
      disableBorder = _ref5$disableBorder === void 0 ? false : _ref5$disableBorder,
      _ref5$active = _ref5.active,
      active = _ref5$active === void 0 ? false : _ref5$active,
      _ref5$isVisible = _ref5.isVisible,
      isVisible = _ref5$isVisible === void 0 ? false : _ref5$isVisible,
      _ref5$topIndicator = _ref5.topIndicator,
      topIndicator = _ref5$topIndicator === void 0 ? true : _ref5$topIndicator;
  if (disableBorder) return undefined;
  return topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref6) {
  var _ref6$backgroundColor = _ref6.backgroundColor,
      backgroundColor = _ref6$backgroundColor === void 0 ? colorsTypes.WHITE : _ref6$backgroundColor,
      _ref6$transparentBack = _ref6.transparentBackgroundColor,
      transparentBackgroundColor = _ref6$transparentBack === void 0 ? colorsTypes.TRANSPARENT : _ref6$transparentBack,
      _ref6$activeBackgroun = _ref6.activeBackgroundColor,
      activeBackgroundColor = _ref6$activeBackgroun === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref6$activeBackgroun,
      _ref6$isVisible = _ref6.isVisible,
      isVisible = _ref6$isVisible === void 0 ? false : _ref6$isVisible,
      _ref6$active = _ref6.active,
      active = _ref6$active === void 0 ? false : _ref6$active,
      _ref6$transparent = _ref6.transparent,
      transparent = _ref6$transparent === void 0 ? false : _ref6$transparent;
  if (isVisible || active) return activeBackgroundColor;
  if (transparent) return transparentBackgroundColor;
  return backgroundColor;
}, function (_ref7) {
  var _ref7$hoverBackground = _ref7.hoverBackground,
      hoverBackground = _ref7$hoverBackground === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref7$hoverBackground;
  return getColors(hoverBackground);
}, function (_ref8) {
  var _ref8$isVisible = _ref8.isVisible,
      isVisible = _ref8$isVisible === void 0 ? false : _ref8$isVisible,
      _ref8$active = _ref8.active,
      active = _ref8$active === void 0 ? false : _ref8$active,
      _ref8$transparent = _ref8.transparent,
      transparent = _ref8$transparent === void 0 ? false : _ref8$transparent,
      _ref8$topIndicator = _ref8.topIndicator,
      topIndicator = _ref8$topIndicator === void 0 ? true : _ref8$topIndicator;

  if (active && transparent && isVisible) {
    if (!topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref9) {
  var _ref9$isVisible = _ref9.isVisible,
      isVisible = _ref9$isVisible === void 0 ? false : _ref9$isVisible,
      _ref9$active = _ref9.active,
      active = _ref9$active === void 0 ? false : _ref9$active,
      _ref9$transparent = _ref9.transparent,
      transparent = _ref9$transparent === void 0 ? false : _ref9$transparent,
      _ref9$topIndicator = _ref9.topIndicator,
      topIndicator = _ref9$topIndicator === void 0 ? true : _ref9$topIndicator;

  if (active && transparent && isVisible) {
    if (topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref10) {
  var _ref10$grayscale = _ref10.grayscale,
      grayscale = _ref10$grayscale === void 0 ? false : _ref10$grayscale,
      _ref10$transparent = _ref10.transparent,
      transparent = _ref10$transparent === void 0 ? false : _ref10$transparent,
      _ref10$dark = _ref10.dark,
      dark = _ref10$dark === void 0 ? false : _ref10$dark,
      _ref10$isVisible = _ref10.isVisible,
      isVisible = _ref10$isVisible === void 0 ? false : _ref10$isVisible;

  if (transparent && !isVisible) {
    if (grayscale) {
      if (dark) return colorsTypes.BLACK;
      return colorsTypes.WHITE;
    }

    return colorsTypes.PRIMARY_SEMI_DARK;
  }

  return "none";
});

var _templateObject$B, _templateObject2$7;

var HeaderDesktopLinkWithSubLinksTitle = styled__default["default"].span(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  color: ", ";\n  width: max-content;\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$color,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$activeColor,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === void 0 ? false : _ref$isVisible;
  return isVisible ? activeColor : color;
});
var DarkOpacityScreenMenu = styled__default["default"].div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n"])), function (_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColorScreen,
      backgroundColorScreen = _ref2$backgroundColor === void 0 ? "rgba(0,0,0, 0.45)" : _ref2$backgroundColor;
  return backgroundColorScreen;
});

function HeaderDesktopDoubleLinkWithSubLinks(_ref3) {
  var activeBorderClass = _ref3.activeBorderClass,
      menuItem = _ref3.menuItem,
      _ref3$currentPath = _ref3.currentPath,
      currentPath = _ref3$currentPath === void 0 ? {} : _ref3$currentPath,
      pathname = _ref3.pathname,
      _ref3$float = _ref3["float"],
      _float = _ref3$float === void 0 ? false : _ref3$float,
      _ref3$scrollY = _ref3.scrollY,
      scrollY = _ref3$scrollY === void 0 ? 0 : _ref3$scrollY,
      _ref3$backgroundBreak = _ref3.backgroundBreakpoint,
      backgroundBreakpoint = _ref3$backgroundBreak === void 0 ? 20 : _ref3$backgroundBreak,
      _ref3$transparent = _ref3.transparent,
      transparent = _ref3$transparent === void 0 ? false : _ref3$transparent,
      _ref3$isTopBorder = _ref3.isTopBorder,
      isTopBorder = _ref3$isTopBorder === void 0 ? false : _ref3$isTopBorder,
      _ref3$forceShow = _ref3.forceShow,
      forceShow = _ref3$forceShow === void 0 ? false : _ref3$forceShow,
      _ref3$grayscale = _ref3.grayscale,
      grayscale = _ref3$grayscale === void 0 ? false : _ref3$grayscale,
      _ref3$dark = _ref3.dark,
      dark = _ref3$dark === void 0 ? false : _ref3$dark,
      _ref3$backgroundScree = _ref3.backgroundScreenActive,
      backgroundScreenActive = _ref3$backgroundScree === void 0 ? false : _ref3$backgroundScree,
      _ref3$forceShowColor = _ref3.forceShowColor,
      forceShowColor = _ref3$forceShowColor === void 0 ? false : _ref3$forceShowColor,
      _ref3$backgroundColor = _ref3.backgroundColor,
      backgroundColor = _ref3$backgroundColor === void 0 ? colorsTypes.TRANSPARENT : _ref3$backgroundColor,
      _ref3$activeTopBorder = _ref3.activeTopBorderColor,
      activeTopBorderColor = _ref3$activeTopBorder === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$activeTopBorder,
      _ref3$activeBackgroun = _ref3.activeBackgroundColor,
      activeBackgroundColor = _ref3$activeBackgroun === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$activeBackgroun,
      _ref3$hoverBackground = _ref3.hoverBackground,
      hoverBackground = _ref3$hoverBackground === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref3$hoverBackground,
      _ref3$hoverBorderColo = _ref3.hoverBorderColor,
      hoverBorderColor = _ref3$hoverBorderColo === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$hoverBorderColo,
      _ref3$titleColor = _ref3.titleColor,
      titleColor = _ref3$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref3$titleColor,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$borderColor,
      _ref3$subItemTitleCol = _ref3.subItemTitleColor,
      subItemTitleColor = _ref3$subItemTitleCol === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref3$subItemTitleCol,
      _ref3$subItemTitleAct = _ref3.subItemTitleActiveColor,
      subItemTitleActiveColor = _ref3$subItemTitleAct === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$subItemTitleAct,
      _ref3$subItemTextColo = _ref3.subItemTextColor,
      subItemTextColor = _ref3$subItemTextColo === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref3$subItemTextColo,
      _ref3$subItemTextActi = _ref3.subItemTextActiveColor,
      subItemTextActiveColor = _ref3$subItemTextActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$subItemTextActi,
      _ref3$menuSubLinksTit = _ref3.menuSubLinksTitleActiveColor,
      menuSubLinksTitleActiveColor = _ref3$menuSubLinksTit === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$menuSubLinksTit,
      _ref3$topIndicator = _ref3.topIndicator,
      topIndicator = _ref3$topIndicator === void 0 ? true : _ref3$topIndicator,
      _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$disableBorder = _ref3.disableBorder,
      disableBorder = _ref3$disableBorder === void 0 ? false : _ref3$disableBorder,
      _ref3$subMenuBackgrou = _ref3.subMenuBackgroundColor,
      subMenuBackgroundColor = _ref3$subMenuBackgrou === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref3$subMenuBackgrou,
      _ref3$subMenuGrayscal = _ref3.subMenuGrayscaleBackgroundColor,
      subMenuGrayscaleBackgroundColor = _ref3$subMenuGrayscal === void 0 ? colorsTypes.WHITE : _ref3$subMenuGrayscal,
      _ref3$dropdownSeparat = _ref3.dropdownSeparationFromTop,
      dropdownSeparationFromTop = _ref3$dropdownSeparat === void 0 ? 20 : _ref3$dropdownSeparat,
      _ref3$dropdownSeparat2 = _ref3.dropdownSeparationFromBottom,
      dropdownSeparationFromBottom = _ref3$dropdownSeparat2 === void 0 ? 50 : _ref3$dropdownSeparat2;

  var _useClickOut = useClickOut(false),
      ref = _useClickOut.ref,
      isVisible = _useClickOut.isVisible,
      setIsVisible = _useClickOut.setIsVisible;

  function updateWhenClick() {
    setIsVisible(function (current) {
      return !current;
    });
  }

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksContainer, {
    transparent: transparent,
    isTopBorder: isTopBorder,
    topIndicator: topIndicator,
    backgroundColor: backgroundColor,
    activeBackgroundColor: activeBackgroundColor,
    grayscale: grayscale,
    dark: dark,
    isVisible: isVisible,
    disableBorder: disableBorder,
    active: active,
    activeTopBorderColor: activeTopBorderColor,
    hoverBackground: hoverBackground,
    borderColor: borderColor,
    hoverBorderColor: hoverBorderColor || activeTopBorderColor,
    className: classnames("HEADER_DESKTOP__LINK__SUB_LINKS HeaderDesktopLinkWithSubLinksContainer tw-z-50 tw-align-text-top ", classnames(activeBorderClass, addClassHeaderOnScroll({
      "float": _float,
      scrollY: scrollY,
      backgroundBreakpoint: backgroundBreakpoint,
      transparent: transparent,
      classTag: "HEADER_DESKTOP__LINK__SUB_LINKS"
    }), isVisible ? "HEADER_DESKTOP__LINK__SUB_LINKS__OPEN" : "HEADER_DESKTOP__LINK__SUB_LINKS__CLOSE"))
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DESKTOP__LINK__SUB_LINKS__CONTAINER tw-inline-block tw-relative tw-w-full tw-flex-1 tw-flex tw-justify-center tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksButton, {
    topIndicator: topIndicator,
    ref: ref,
    onClick: updateWhenClick,
    isVisible: active && isVisible,
    grayscale: grayscale,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    backgroundColor: isVisible ? subMenuBackgroundColor : undefined,
    grayscaleBackgroundColor: isVisible ? subMenuGrayscaleBackgroundColor : undefined,
    transparent: transparent,
    forceShow: forceShow,
    forceShowColor: forceShowColor,
    primaryFamily: active && isVisible,
    type: "button",
    className: "HEADER_DESKTOP__LINK__SUB_LINKS__CONTAINER__BOX HeaderDesktopLinkWithSubLinksButton bl-text-xs focus:tw-outline-none active:bl-text-primary tw-w-max tw-flex tw-items-center tw-justify-center tw-w-full"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksTitle, {
    isVisible: active || isVisible,
    className: "HEADER_DESKTOP__LINK_WITH_SUBMIT__LINKS__TITLE tw-w-full HeaderDesktopLinkWithSubLinksTitle tw-mr-2 tw-font-medium",
    color: titleColor
  }, menuItem.text), /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkWithSubLinksIcon, {
    size: 12,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    forceShow: forceShow,
    icon: isVisible ? iconTypes.ARROW_UP_1 : iconTypes.ARROW_DOWN_1,
    className: "HEADER_DESKTOP__LINK_WITH_SUBMIT__LINKS__ICON HeaderDesktopLinkWithSubLinksIcon"
  })), isVisible && backgroundScreenActive && /*#__PURE__*/React__default$1["default"].createElement(DarkOpacityScreenMenu, {
    className: "HEADER_DESKTOP_LINK_WITH_SUB_LINKS__DARK_OPACITY_SCREEN_MENU"
  }), isVisible && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkDropdown, {
    separationFromTop: dropdownSeparationFromTop,
    separationFromBottom: dropdownSeparationFromBottom,
    backgroundColor: subMenuBackgroundColor,
    grayscaleBackgroundColor: subMenuGrayscaleBackgroundColor,
    active: active && isVisible,
    itemTextColor: subItemTextColor,
    itemTextActiveColor: subItemTextActiveColor,
    menuSubLinksTitleActiveColor: menuSubLinksTitleActiveColor,
    grayscale: grayscale,
    topIndicator: topIndicator,
    menuItem: menuItem,
    currentPath: currentPath,
    pathname: pathname,
    titleColor: active ? subItemTitleActiveColor : subItemTitleColor,
    className: "HEADER_DESKTOP_DROPDOWN HeaderDesktopLinkDropdown"
  })));
}

var _templateObject$A, _templateObject2$6;

var LinkNormalText = styled__default["default"](Link)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  padding: 0.5rem;\n  display: grid;\n  z-index: 50;\n  border-style: solid;\n  height: min-content;\n  background: transparent;\n  margin: auto 20px auto 0;\n\n  font-family: ", ";\n\n  color: ", ";\n\n  border-color: ", ";\n\n  border-bottom-width: ", "px;\n\n  border-top-width: ", "px;\n\n  &:hover {\n    color: ", ";\n\n    background: ", ";\n  }\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref2) {
  var _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$float = _ref2["float"],
      _float = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$backgroundBreak = _ref2.backgroundBreakpoint,
      backgroundBreakpoint = _ref2$backgroundBreak === void 0 ? 20 : _ref2$backgroundBreak,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref2$color;

  if (forceShow) return undefined;

  if (!!_float && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return color;
  }

  return undefined;
}, function (_ref3) {
  var _ref3$active = _ref3.active,
      active = _ref3$active === void 0 ? false : _ref3$active,
      _ref3$borderColor = _ref3.borderColor,
      borderColor = _ref3$borderColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref3$borderColor,
      _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible;
  if (isVisible || active) return borderColor;
  return colorsTypes.TRANSPARENT;
}, function (_ref4) {
  var _ref4$active = _ref4.active,
      active = _ref4$active === void 0 ? false : _ref4$active,
      _ref4$isVisible = _ref4.isVisible,
      isVisible = _ref4$isVisible === void 0 ? false : _ref4$isVisible,
      _ref4$topIndicator = _ref4.topIndicator,
      topIndicator = _ref4$topIndicator === void 0 ? true : _ref4$topIndicator;
  return !topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref5) {
  var _ref5$active = _ref5.active,
      active = _ref5$active === void 0 ? false : _ref5$active,
      _ref5$isVisible = _ref5.isVisible,
      isVisible = _ref5$isVisible === void 0 ? false : _ref5$isVisible,
      _ref5$topIndicator = _ref5.topIndicator,
      topIndicator = _ref5$topIndicator === void 0 ? true : _ref5$topIndicator;
  return topIndicator && (isVisible || active) ? 2 : 0;
}, function (_ref6) {
  var _ref6$float = _ref6["float"],
      _float2 = _ref6$float === void 0 ? false : _ref6$float,
      _ref6$transparent = _ref6.transparent,
      transparent = _ref6$transparent === void 0 ? false : _ref6$transparent,
      _ref6$scrollY = _ref6.scrollY,
      scrollY = _ref6$scrollY === void 0 ? 0 : _ref6$scrollY,
      _ref6$backgroundBreak = _ref6.backgroundBreakpoint,
      backgroundBreakpoint = _ref6$backgroundBreak === void 0 ? 20 : _ref6$backgroundBreak,
      _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? colorsTypes.WHITE : _ref6$color;

  if (transparent) return color;
  if (scrollY <= backgroundBreakpoint || scrollY === 0) return color;
  if (!scrollY) return color;
  if (!!_float2 && !!Number(scrollY)) return color;
  return undefined;
}, function (_ref7) {
  var _ref7$grayscale = _ref7.grayscale,
      grayscale = _ref7$grayscale === void 0 ? false : _ref7$grayscale,
      _ref7$transparent = _ref7.transparent,
      transparent = _ref7$transparent === void 0 ? false : _ref7$transparent;
  if (transparent) return "none";
  if (grayscale) return colorsTypes.VERY_ULTRA_LIGHT;
  return colorsTypes.HIGHT_LIGHT_PRIMARY;
});
var LinkNormalAText = styled__default["default"].a(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  height: ", ";\n  margin: auto 20px auto 0;\n  padding: 1rem 0.25rem;\n  font-family: ", ";\n\n  color: ", ";\n\n  border-top-width: ", "px;\n\n  border-bottom-width: ", "px;\n\n  border-color: ", ";\n\n  &:hover {\n    color: ", ";\n\n    background: ", ";\n\n    border-color: ", ";\n  }\n"])), function (_ref8) {
  var _ref8$height = _ref8.height,
      height = _ref8$height === void 0 ? "min-content" : _ref8$height;
  return lodash.isNumber(height) ? "".concat(height, "px") : height;
}, function (_ref9) {
  var _ref9$primaryFamily = _ref9.primaryFamily,
      primaryFamily = _ref9$primaryFamily === void 0 ? false : _ref9$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref10) {
  var _ref10$float = _ref10["float"],
      _float3 = _ref10$float === void 0 ? false : _ref10$float,
      _ref10$forceShow = _ref10.forceShow,
      forceShow = _ref10$forceShow === void 0 ? false : _ref10$forceShow,
      _ref10$scrollY = _ref10.scrollY,
      scrollY = _ref10$scrollY === void 0 ? 0 : _ref10$scrollY,
      _ref10$backgroundBrea = _ref10.backgroundBreakpoint,
      backgroundBreakpoint = _ref10$backgroundBrea === void 0 ? 20 : _ref10$backgroundBrea,
      _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colorsTypes.WHITE : _ref10$color,
      _ref10$isActive = _ref10.isActive,
      isActive = _ref10$isActive === void 0 ? false : _ref10$isActive,
      _ref10$titleActiveCol = _ref10.titleActiveColor,
      titleActiveColor = _ref10$titleActiveCol === void 0 ? colorsTypes.WHITE : _ref10$titleActiveCol;

  if (forceShow) return undefined;
  if (isActive) return titleActiveColor;

  if (!!_float3 && (!!Number(scrollY) || !scrollY) && (scrollY <= backgroundBreakpoint || scrollY === 0)) {
    return color;
  }

  return undefined;
}, function (_ref11) {
  var _ref11$transparent = _ref11.transparent,
      transparent = _ref11$transparent === void 0 ? false : _ref11$transparent,
      _ref11$topIndicator = _ref11.topIndicator,
      topIndicator = _ref11$topIndicator === void 0 ? true : _ref11$topIndicator;

  if (transparent) {
    if (!topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref12) {
  var _ref12$transparent = _ref12.transparent,
      transparent = _ref12$transparent === void 0 ? false : _ref12$transparent,
      _ref12$topIndicator = _ref12.topIndicator,
      topIndicator = _ref12$topIndicator === void 0 ? true : _ref12$topIndicator;

  if (transparent) {
    if (topIndicator) return 0;
    return 2;
  }

  return 0;
}, function (_ref13) {
  var _ref13$grayscale = _ref13.grayscale,
      grayscale = _ref13$grayscale === void 0 ? false : _ref13$grayscale,
      _ref13$transparent = _ref13.transparent,
      transparent = _ref13$transparent === void 0 ? false : _ref13$transparent,
      _ref13$dark = _ref13.dark,
      dark = _ref13$dark === void 0 ? false : _ref13$dark,
      _ref13$isActive = _ref13.isActive,
      isActive = _ref13$isActive === void 0 ? false : _ref13$isActive,
      _ref13$activeBorderCo = _ref13.activeBorderColor,
      activeBorderColor = _ref13$activeBorderCo === void 0 ? colorsTypes.TRANSPARENT : _ref13$activeBorderCo;

  if (transparent && isActive) {
    if (isActive) return activeBorderColor;
    if (dark) return colorsTypes.BLACK;
    if (grayscale) return colorsTypes.WHITE;
    return colorsTypes.PRIMARY_SEMI_DARK;
  }

  return colorsTypes.TRANSPARENT;
}, function (_ref14) {
  var _ref14$float = _ref14["float"],
      _float4 = _ref14$float === void 0 ? false : _ref14$float,
      _ref14$transparent = _ref14.transparent,
      transparent = _ref14$transparent === void 0 ? false : _ref14$transparent,
      _ref14$scrollY = _ref14.scrollY,
      scrollY = _ref14$scrollY === void 0 ? 0 : _ref14$scrollY,
      _ref14$backgroundBrea = _ref14.backgroundBreakpoint,
      backgroundBreakpoint = _ref14$backgroundBrea === void 0 ? 20 : _ref14$backgroundBrea,
      _ref14$color = _ref14.color,
      color = _ref14$color === void 0 ? colorsTypes.BLACK : _ref14$color;

  if (transparent || !scrollY) return undefined;
  if (scrollY <= backgroundBreakpoint || scrollY === 0) return color;
  if (!!_float4 && !!Number(scrollY)) return color;
  return color;
}, function (_ref15) {
  var _ref15$grayscale = _ref15.grayscale,
      grayscale = _ref15$grayscale === void 0 ? false : _ref15$grayscale,
      _ref15$transparent = _ref15.transparent,
      transparent = _ref15$transparent === void 0 ? false : _ref15$transparent;
  if (transparent) return "none";
  if (grayscale) return colorsTypes.VERY_ULTRA_LIGHT;
  return colorsTypes.HIGHT_LIGHT_PRIMARY;
}, function (_ref16) {
  var _ref16$grayscale = _ref16.grayscale,
      grayscale = _ref16$grayscale === void 0 ? false : _ref16$grayscale,
      _ref16$transparent = _ref16.transparent,
      transparent = _ref16$transparent === void 0 ? false : _ref16$transparent,
      _ref16$dark = _ref16.dark,
      dark = _ref16$dark === void 0 ? false : _ref16$dark,
      _ref16$isActive = _ref16.isActive,
      isActive = _ref16$isActive === void 0 ? false : _ref16$isActive;

  if (transparent && !isActive) {
    if (dark) return colorsTypes.BLACK;
    if (grayscale) return colorsTypes.WHITE;
    return colorsTypes.PRIMARY_SEMI_DARK;
  }

  return "none";
});

function HeaderDesktopLinkNormal(_ref17) {
  var _ref17$index = _ref17.index,
      index = _ref17$index === void 0 ? "" : _ref17$index,
      menuItem = _ref17.menuItem,
      pathname = _ref17.pathname,
      variant = _ref17.variant,
      _ref17$float = _ref17["float"],
      _float5 = _ref17$float === void 0 ? false : _ref17$float,
      _ref17$forceShow = _ref17.forceShow,
      forceShow = _ref17$forceShow === void 0 ? false : _ref17$forceShow,
      _ref17$grayscale = _ref17.grayscale,
      grayscale = _ref17$grayscale === void 0 ? false : _ref17$grayscale,
      _ref17$dark = _ref17.dark,
      dark = _ref17$dark === void 0 ? false : _ref17$dark,
      _ref17$transparent = _ref17.transparent,
      transparent = _ref17$transparent === void 0 ? false : _ref17$transparent,
      _ref17$topIndicator = _ref17.topIndicator,
      topIndicator = _ref17$topIndicator === void 0 ? true : _ref17$topIndicator,
      _ref17$scrollY = _ref17.scrollY,
      scrollY = _ref17$scrollY === void 0 ? 0 : _ref17$scrollY,
      _ref17$active = _ref17.active,
      active = _ref17$active === void 0 ? false : _ref17$active,
      _ref17$activeBorderCo = _ref17.activeBorderColor,
      activeBorderColor = _ref17$activeBorderCo === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref17$activeBorderCo,
      _ref17$titleActiveCol = _ref17.titleActiveColor,
      titleActiveColor = _ref17$titleActiveCol === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref17$titleActiveCol,
      _ref17$titleColor = _ref17.titleColor,
      titleColor = _ref17$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref17$titleColor,
      _ref17$backgroundBrea = _ref17.backgroundBreakpoint,
      backgroundBreakpoint = _ref17$backgroundBrea === void 0 ? 20 : _ref17$backgroundBrea;

  switch (variant) {
    case linkVariantTypes.PAGE_LINKS:
      var classesValidation = function () {
        if (pathname === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pageLinks) || pathname === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) || pathname === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pdf) || "/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) || "/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pageLinks) || "/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.pdf)) {
          return "LINK_NORMAL_TEXT LinkNormalText bl-text-xs tw-px-6 tw-flex tw-items-center tw-justify-center tw-pb-1 tw-border-t-2 tw-font-medium bl-border-primary LINK_NORMAL_TEXT_ACTIVE LINK__NORMAL__A__TEXT_ACTIVE";
        }

        return "LINK_NORMAL_TEXT LinkNormalText bl-text-xs tw-px-6 tw-flex tw-items-center tw-justify-center";
      }();

      return /*#__PURE__*/React__default$1["default"].createElement(LinkNormalText, {
        index: index,
        popup: "".concat(menuItem.openThirdPartyPopup),
        grayscale: grayscale,
        dark: dark,
        active: active,
        activeBorderColor: activeBorderColor,
        titleColor: titleColor,
        to: menuItem.pageLinks,
        "float": _float5,
        forceShow: forceShow,
        topIndicator: topIndicator,
        transparent: transparent,
        scrollY: scrollY,
        backgroundBreakpoint: backgroundBreakpoint,
        primaryFamily: "/".concat(pathname) === menuItem.url,
        className: classnames(classesValidation, addClassHeaderOnScroll({
          "float": _float5,
          scrollY: scrollY,
          backgroundBreakpoint: backgroundBreakpoint,
          transparent: transparent,
          classTag: "LINK__NORMAL__A__TEXT"
        }))
      }, menuItem.text);

    case linkVariantTypes.PDF:
      return /*#__PURE__*/React__default$1["default"].createElement(LinkNormalText, {
        index: index,
        topIndicator: topIndicator,
        grayscale: grayscale,
        active: active,
        activeBorderColor: activeBorderColor,
        color: titleColor,
        dark: dark,
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pdf.url,
        forceShow: forceShow,
        transparent: transparent,
        "float": _float5,
        scrollY: scrollY,
        backgroundBreakpoint: backgroundBreakpoint,
        primaryFamily: "/".concat(pathname) === menuItem.url || "/".concat(pathname) === menuItem.pageLinks,
        className: classnames("LINK_NORMAL_TEXT LinkNormalText bl-text-xs tw-flex tw-items-center tw-justify-center tw-font-medium", addClassHeaderOnScroll({
          "float": _float5,
          scrollY: scrollY,
          backgroundBreakpoint: backgroundBreakpoint,
          transparent: transparent,
          classTag: "LINK__NORMAL__A__TEXT"
        }) // , pathname === menuItem.url && "tw-pb-1 tw-border-t-2 bl-border-primary",
        )
      }, menuItem.text);

    default:
      var auxActiveClass = "LINK__NORMAL__A__TEXT_INACTIVE path=".concat(pathname, " url=").concat(menuItem === null || menuItem === void 0 ? void 0 : menuItem.url);

      if ("/".concat(pathname) === (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) || pathname === "" && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.url) === "/") {
        auxActiveClass = "LINK__NORMAL__A__TEXT_ACTIVE path=".concat(pathname, " url=").concat(menuItem === null || menuItem === void 0 ? void 0 : menuItem.url);
      }

      return /*#__PURE__*/React__default$1["default"].createElement(LinkNormalAText, {
        index: index,
        topIndicator: topIndicator,
        grayscale: grayscale,
        isActive: pathname === menuItem.url || pathname === menuItem.pageLinks || pathname === menuItem.pdf,
        activeBorderColor: activeBorderColor,
        color: titleColor,
        titleActiveColor: titleActiveColor,
        dark: dark,
        popup: "".concat(menuItem.openThirdPartyPopup),
        href: menuItem.url,
        "float": _float5,
        transparent: transparent // forceShow={forceShow}
        ,
        scrollY: scrollY,
        backgroundBreakpoint: backgroundBreakpoint,
        primaryFamily: "/".concat(pathname) === menuItem.url || "/".concat(pathname) === menuItem.pageLinks || "/".concat(pathname) === menuItem.pdf,
        className: classnames("LinkNormalAText bl-text-xs tw-flex tw-items-center tw-justify-center tw-font-medium ".concat(auxActiveClass), addClassHeaderOnScroll({
          "float": _float5,
          scrollY: scrollY,
          backgroundBreakpoint: backgroundBreakpoint,
          transparent: transparent,
          classTag: "LINK__NORMAL__A__TEXT"
        }) // , pathname === menuItem.url && "tw-pb-1 tw-border-t-2 bl-border-primary",
        )
      }, menuItem.text);
  }
}

function HeaderDesktopNavItems(_ref) {
  var pathname = _ref.pathname,
      menuItems = _ref.menuItems,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$backgroundScreen = _ref.backgroundScreenActive,
      backgroundScreenActive = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$forceShowColor = _ref.forceShowColor,
      forceShowColor = _ref$forceShowColor === void 0 ? false : _ref$forceShowColor,
      _ref$menuSubItemDisab = _ref.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref$menuSubItemDisab === void 0 ? false : _ref$menuSubItemDisab,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$itemsProps = _ref.itemsProps,
      itemsProps = _ref$itemsProps === void 0 ? {} : _ref$itemsProps,
      _ref$activeBorderColo = _ref.activeBorderColor,
      activeBorderColor = _ref$activeBorderColo === void 0 ? colorsTypes.PRIMARY : _ref$activeBorderColo,
      _ref$hoverBorderColor = _ref.hoverBorderColor,
      hoverBorderColor = _ref$hoverBorderColor === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$hoverBorderColor,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksTitl,
      _ref$menuSubLinksTitl2 = _ref.menuSubLinksTitleActiveColor,
      menuSubLinksTitleActiveColor = _ref$menuSubLinksTitl2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksTitl2,
      _ref$menuSubItemTitle = _ref.menuSubItemTitleColor,
      menuSubItemTitleColor = _ref$menuSubItemTitle === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubItemTitle,
      _ref$menuSubItemTitle2 = _ref.menuSubItemTitleActiveColor,
      menuSubItemTitleActiveColor = _ref$menuSubItemTitle2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubItemTitle2,
      _ref$subItemTextColor = _ref.subItemTextColor,
      subItemTextColor = _ref$subItemTextColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$subItemTextColor,
      _ref$subItemTextActiv = _ref.subItemTextActiveColor,
      subItemTextActiveColor = _ref$subItemTextActiv === void 0 ? colorsTypes.PRIMARY : _ref$subItemTextActiv,
      _ref$subMenuBackgroun = _ref.subMenuBackgroundColor,
      subMenuBackgroundColor = _ref$subMenuBackgroun === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuBackgroun,
      _ref$subMenuActiveBac = _ref.subMenuActiveBackgroundColor,
      subMenuActiveBackgroundColor = _ref$subMenuActiveBac === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuActiveBac,
      _ref$subMenuGrayscale = _ref.subMenuGrayscaleBackgroundColor,
      subMenuGrayscaleBackgroundColor = _ref$subMenuGrayscale === void 0 ? colorsTypes.WHITE : _ref$subMenuGrayscale,
      _ref$itemBackgroundCo = _ref.itemBackgroundColor,
      itemBackgroundColor = _ref$itemBackgroundCo === void 0 ? colorsTypes.WHITE : _ref$itemBackgroundCo,
      _ref$dropdownHoverBac = _ref.dropdownHoverBackground,
      dropdownHoverBackground = _ref$dropdownHoverBac === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref$dropdownHoverBac,
      _ref$menuSubLinksBord = _ref.menuSubLinksBorderColor,
      menuSubLinksBorderColor = _ref$menuSubLinksBord === void 0 ? colorsVariantsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksBord,
      _ref$dropdownSeparati = _ref.dropdownSeparationFromTop,
      dropdownSeparationFromTop = _ref$dropdownSeparati === void 0 ? 20 : _ref$dropdownSeparati,
      _ref$dropdownSeparati2 = _ref.dropdownSeparationFromBottom,
      dropdownSeparationFromBottom = _ref$dropdownSeparati2 === void 0 ? 50 : _ref$dropdownSeparati2;

  var urlTest = /^(\/|http:\/\/|https:\/\/|www.)/;

  var _useState = React.useState("/".concat(pathname)),
      _useState2 = _slicedToArray$1(_useState, 2),
      localPathname = _useState2[0],
      setLocalPathname = _useState2[1];

  React.useEffect(function () {
    if (window && window.location && window.location.pathname) {
      setLocalPathname(window.location.pathname);
    }
  }, []);
  return (menuItems || []).map(function (menuItem) {
    var variant = menuItem.pdf ? "pdf" : menuItem.pageLinks ? "pageLinks" : "url";
    var index = menuItem.text || nanoid();

    if (menuItem.subLinks && menuItem.subLinks.length > 0) {
      var subLinksCasted = menuItem.subLinks.reduce(function (acc, subLink) {
        var subLinkKeys = Object.entries(subLink).reduce(function () {
          var itemAcc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
              _ref3 = _slicedToArray$1(_ref2, 2),
              _ref3$ = _ref3[0],
              subLinkName = _ref3$ === void 0 ? "" : _ref3$,
              _ref3$2 = _ref3[1],
              subLinkValue = _ref3$2 === void 0 ? "" : _ref3$2;

          if (!subLinkValue) return _toConsumableArray(itemAcc);
          var itemIndex = Number(subLinkName.replace("text", ""));
          var isUrlSubLinkName = /url[0-9]/gi.test(subLinkName);
          var isTextSubLinkName = /text[0-9]/gi.test(subLinkName);
          if (isUrlSubLinkName || !isTextSubLinkName) return itemAcc;
          var subLinks = lodash.uniqBy(Object.entries(subLink).map(function (_ref4) {
            var _ref5 = _slicedToArray$1(_ref4, 2),
                _ref5$ = _ref5[0],
                urlName = _ref5$ === void 0 ? "" : _ref5$,
                _ref5$2 = _ref5[1],
                urlValue = _ref5$2 === void 0 ? "" : _ref5$2;

            var subLinkIndex = Number(urlName.replace("url", ""));
            return {
              name: urlName,
              value: urlValue,
              index: lodash.isNumber(subLinkIndex) && !!subLinkIndex ? subLinkIndex : nanoid()
            };
          }), "name");
          var urls = subLinks.filter(function (_ref6) {
            var _ref6$name = _ref6.name,
                name = _ref6$name === void 0 ? "" : _ref6$name;
            return /url[0-9]/gi.test(name);
          });
          var itemUrl = lodash.find(urls, {
            index: itemIndex
          });
          var isCurrentPath = itemUrl && itemUrl.value && itemUrl.value === localPathname;

          if (isTextSubLinkName) {
            var hasNotTextSubLinkItem = !lodash.find(itemAcc, {
              name: subLinkName
            });

            if (hasNotTextSubLinkItem) {
              var innerTextSubLinkItem = lodash.find(subLinks, {
                name: subLinkName
              });
              return [].concat(_toConsumableArray(itemAcc), [_objectSpread2(_objectSpread2({}, innerTextSubLinkItem), {}, {
                isCurrentPath: isCurrentPath,
                url: itemUrl || undefined,
                isUrl: itemUrl && urlTest.test(itemUrl.value)
              })]);
            }

            return itemAcc.map(function (item) {
              if (item.name === subLinkName) {
                return {
                  isCurrentPath: isCurrentPath,
                  name: subLinkName || "",
                  value: subLinkValue || "",
                  isUrl: urlTest.test(subLinkValue),
                  url: itemUrl || undefined
                };
              }

              return item;
            });
          }

          if (!isUrlSubLinkName) {
            return [].concat(_toConsumableArray(itemAcc), [{
              isCurrentPath: isCurrentPath,
              name: subLinkName || "",
              value: subLinkValue || "",
              isUrl: urlTest.test(subLinkValue),
              url: itemUrl || undefined
            }]);
          }

          return _toConsumableArray(itemAcc);
        }, []);
        return [].concat(_toConsumableArray(acc), [{
          id: subLink.id,
          title: subLink.title,
          titleStyle: subLink.titleStyle,
          data: subLinkKeys
        }]);
      }, []).map(function (item) {
        return _objectSpread2(_objectSpread2({}, item), {}, {
          data: lodash.uniqBy(item.data, "name")
        });
      });
      var subLinksCastedOnlyUrl = subLinksCasted.reduce(function () {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var item = arguments.length > 1 ? arguments[1] : undefined;
        return [].concat(_toConsumableArray(acc), _toConsumableArray(item.data.filter(function (_ref7) {
          var _ref7$isCurrentPath = _ref7.isCurrentPath,
              isCurrentPath = _ref7$isCurrentPath === void 0 ? false : _ref7$isCurrentPath;
          return isCurrentPath;
        })));
      }, []);
      var subLinksCastedOnlyCurrentPaths = subLinksCastedOnlyUrl.filter(function (_ref8) {
        var _ref8$isCurrentPath = _ref8.isCurrentPath,
            isCurrentPath = _ref8$isCurrentPath === void 0 ? false : _ref8$isCurrentPath;
        return isCurrentPath;
      });
      var subLinksCastedCurrentPaths = subLinksCastedOnlyUrl.map(function (_ref9) {
        var _ref9$isCurrentPath = _ref9.isCurrentPath,
            isCurrentPath = _ref9$isCurrentPath === void 0 ? false : _ref9$isCurrentPath;
        return isCurrentPath;
      });
      var currentPath = subLinksCastedOnlyCurrentPaths && subLinksCastedOnlyCurrentPaths.length ? subLinksCastedOnlyCurrentPaths[0] : undefined;
      var hasMatchWithLocalPath = lodash.some(subLinksCastedCurrentPaths);
      return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDoubleLinkWithSubLinks, _extends$g({
        disableBorder: menuSubItemDisableBorder,
        hoverBackground: dropdownHoverBackground,
        dropdownSeparationFromTop: dropdownSeparationFromTop,
        dropdownSeparationFromBottom: dropdownSeparationFromBottom,
        index: index,
        backgroundColor: itemBackgroundColor,
        subMenuBackgroundColor: subMenuBackgroundColor,
        subMenuGrayscaleBackgroundColor: subMenuGrayscaleBackgroundColor,
        subItemTextColor: subItemTextColor,
        activeBackgroundColor: subMenuActiveBackgroundColor,
        subItemTextActiveColor: subItemTextActiveColor,
        subItemTitleColor: menuSubItemTitleColor,
        subItemTitleActiveColor: menuSubItemTitleActiveColor,
        titleColor: hasMatchWithLocalPath && !!currentPath ? menuSubLinksTitleActiveColor : menuSubLinksTitleColor,
        borderColor: menuSubLinksBorderColor,
        activeBorderClass: hasMatchWithLocalPath && !!currentPath ? "HeaderDesktopLinkWithSubLinksContainer-activeMenuItem" : "HeaderDesktopLinkWithSubLinksContainer-inactiveMenuItem",
        active: hasMatchWithLocalPath && !!currentPath,
        topIndicator: topIndicator,
        activeBorderColor: activeBorderColor,
        hoverBorderColor: hoverBorderColor,
        key: "LinkWithSubLinks-".concat(menuItem.id),
        menuItem: menuItem,
        currentPath: currentPath,
        pathname: pathname,
        "float": _float,
        scrollY: scrollY,
        grayscale: grayscale,
        dark: dark,
        backgroundScreenActive: backgroundScreenActive,
        backgroundBreakpoint: backgroundBreakpoint,
        transparent: transparent,
        isTopBorder: isTopBorder,
        forceShow: forceShow,
        forceShowColor: forceShowColor,
        className: "HeaderDesktopLinkWithSubLinks HEADER_DESKTOP__NAVIGATION__ITEMS HEADER_DESKTOP__NAVIGATION__ITEMS__SUB_LINKS HeaderDesktopLinkWithSubLinks"
      }, itemsProps));
    }

    return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLinkNormal, _extends$g({
      index: index,
      key: "LinkNormal-".concat(menuItem.id),
      titleActiveColor: menuSubLinksTitleActiveColor,
      titleColor: menuSubLinksTitleColor,
      activeBorderColor: activeBorderColor,
      menuItem: menuItem,
      pathname: pathname,
      grayscale: grayscale,
      dark: dark,
      topIndicator: topIndicator,
      variant: variant,
      "float": _float,
      scrollY: scrollY,
      backgroundBreakpoint: backgroundBreakpoint,
      transparent: transparent,
      forceShow: forceShow,
      forceShowColor: forceShowColor,
      className: "HEADER_DESKTOP__NAVIGATION__ITEMS HEADER_DESKTOP__NAVIGATION__ITEMS__NORMAL HeaderDesktopLinkNormal"
    }, itemsProps));
  });
}

var _templateObject$z;

var HeaderDesktopDoubleContainer = styled__default["default"].nav(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  flex: 9;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  height: 100%;\n"])));

var _templateObject$y;

var HeaderDesktopDoubleContent = styled__default["default"].nav(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  margin-right:51px;\n"])));

var _templateObject$x;

function HeaderDesktopNavMenuMain(_ref) {
  var pathname = _ref.pathname,
      menuItems = _ref.menuItems,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$itemsProps = _ref.itemsProps,
      itemsProps = _ref$itemsProps === void 0 ? {} : _ref$itemsProps,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$forceShowColor = _ref.forceShowColor,
      forceShowColor = _ref$forceShowColor === void 0 ? false : _ref$forceShowColor,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$backgroundScreen = _ref.backgroundScreenActive,
      backgroundScreenActive = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$menuSubItemDisab = _ref.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref$menuSubItemDisab === void 0 ? true : _ref$menuSubItemDisab,
      _ref$menuActiveBorder = _ref.menuActiveBorderColor,
      menuActiveBorderColor = _ref$menuActiveBorder === void 0 ? colorsTypes.PRIMARY : _ref$menuActiveBorder,
      _ref$menuHoverBorderC = _ref.menuHoverBorderColor,
      menuHoverBorderColor = _ref$menuHoverBorderC === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuHoverBorderC,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksTitl,
      _ref$menuSubLinksBord = _ref.menuSubLinksBorderColor,
      menuSubLinksBorderColor = _ref$menuSubLinksBord === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksBord,
      _ref$menuSubLinksTitl2 = _ref.menuSubLinksTitleActiveColor,
      menuSubLinksTitleActiveColor = _ref$menuSubLinksTitl2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksTitl2,
      _ref$menuSubItemTitle = _ref.menuSubItemTitleColor,
      menuSubItemTitleColor = _ref$menuSubItemTitle === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubItemTitle,
      _ref$menuSubItemTitle2 = _ref.menuSubItemTitleActiveColor,
      menuSubItemTitleActiveColor = _ref$menuSubItemTitle2 === void 0 ? colorsTypes.PRIMARY : _ref$menuSubItemTitle2,
      _ref$menuSubItemTextC = _ref.menuSubItemTextColor,
      menuSubItemTextColor = _ref$menuSubItemTextC === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubItemTextC,
      _ref$menuSubItemTextA = _ref.menuSubItemTextActiveColor,
      menuSubItemTextActiveColor = _ref$menuSubItemTextA === void 0 ? colorsTypes.PRIMARY : _ref$menuSubItemTextA,
      _ref$subMenuBackgroun = _ref.subMenuBackgroundColor,
      subMenuBackgroundColor = _ref$subMenuBackgroun === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuBackgroun,
      _ref$subMenuActiveBac = _ref.subMenuActiveBackgroundColor,
      subMenuActiveBackgroundColor = _ref$subMenuActiveBac === void 0 ? colorsTypes.TRANSPARENT : _ref$subMenuActiveBac,
      _ref$subMenuGrayscale = _ref.subMenuGrayscaleBackgroundColor,
      subMenuGrayscaleBackgroundColor = _ref$subMenuGrayscale === void 0 ? colorsTypes.WHITE : _ref$subMenuGrayscale,
      _ref$itemBackgroundCo = _ref.itemBackgroundColor,
      itemBackgroundColor = _ref$itemBackgroundCo === void 0 ? colorsTypes.TRANSPARENT : _ref$itemBackgroundCo,
      _ref$dropdownHoverBac = _ref.dropdownHoverBackground,
      dropdownHoverBackground = _ref$dropdownHoverBac === void 0 ? colorsVariantsTypes.HIGHT_LIGHT_PRIMARY : _ref$dropdownHoverBac,
      _ref$dropdownSeparati = _ref.dropdownSeparationFromTop,
      dropdownSeparationFromTop = _ref$dropdownSeparati === void 0 ? 20 : _ref$dropdownSeparati,
      _ref$dropdownSeparati2 = _ref.dropdownSeparationFromBottom,
      dropdownSeparationFromBottom = _ref$dropdownSeparati2 === void 0 ? 50 : _ref$dropdownSeparati2,
      _ref$highlightedItem = _ref.highlightedItem,
      highlightedItem = _ref$highlightedItem === void 0 ? null : _ref$highlightedItem;

  var HighlightedLink = styled__default["default"].a(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 50px;\n    color: ", ";\n    min-width: max-content;\n    font-size: 16px;\n    padding: 11px 17px;\n  "])), function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colorsTypes.SECONDARY : _ref2$color;
    return color;
  }, function (_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colorsTypes.WHITE : _ref3$color;
    return color;
  });
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDoubleContainer, {
    className: "HEADER_DESKTOP_DOUBLE_NAVIGATION_MENU HeaderDesktopNavMenu-Nav sm:tw-inline-flex tw-items-center tw-justify-between"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDoubleContent, {
    className: "HEADER_DESKTOP_DOUBLE_NAVIGATION_MENU__CONTAINER HeaderDesktopNavMenu-Nav-Container"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavItems, _extends$g({
    dropdownHoverBackground: dropdownHoverBackground,
    dropdownSeparationFromTop: dropdownSeparationFromTop,
    dropdownSeparationFromBottom: dropdownSeparationFromBottom,
    itemBackgroundColor: itemBackgroundColor,
    subMenuBackgroundColor: subMenuBackgroundColor,
    subMenuActiveBackgroundColor: subMenuActiveBackgroundColor,
    subMenuGrayscaleBackgroundColor: subMenuGrayscaleBackgroundColor,
    subItemTextColor: menuSubItemTextColor,
    subItemTextActiveColor: menuSubItemTextActiveColor,
    menuSubLinksTitleColor: menuSubLinksTitleColor,
    menuSubLinksBorderColor: menuSubLinksBorderColor,
    menuSubLinksTitleActiveColor: menuSubLinksTitleActiveColor,
    menuSubItemTitleColor: menuSubItemTitleColor,
    menuSubItemTitleActiveColor: menuSubItemTitleActiveColor,
    menuSubItemDisableBorder: menuSubItemDisableBorder,
    activeBorderColor: menuActiveBorderColor,
    hoverBorderColor: menuHoverBorderColor,
    topIndicator: topIndicator,
    pathname: pathname,
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    menuItems: menuItems,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShow,
    forceShowColor: forceShowColor
  }, itemsProps, {
    classNamee: "HEADER_DESKTOP_NAVIGATION_MENU__ITEMS HeaderDesktopNavMenu-Nav-Container-Items"
  })), (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.Text) && /*#__PURE__*/React__default$1["default"].createElement(HighlightedLink, {
    href: (highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.Url) || "/",
    className: "HEADER_DESCTOP_DOUBLE_HIGHLIGHTED_LINK"
  }, highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.Text)));
}

var _templateObject$w, _templateObject2$5;

function HeaderDesktopTopNavItems(_ref) {
  var pathname = _ref.pathname,
      menuItems = _ref.menuItems;

  var _useState = React.useState("/".concat(pathname)),
      _useState2 = _slicedToArray$1(_useState, 2);

  _useState2[0];
  var setLocalPathname = _useState2[1];
  React.useEffect(function () {
    if (window && window.location && window.location.pathname) {
      setLocalPathname(window.location.pathname);
    }
  }, []);
  var TopLink = styled__default["default"].a(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n    color: ", ";\n    margin-right: 57px;\n    font-size: 16px;\n    font-weight: 500;\n  "])), function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colorsTypes.WHITE : _ref2$color;
    return color;
  });
  var TopText = styled__default["default"].span(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    color: ", ";\n    margin-right: 57px;\n    font-size: 16px;\n    font-weight: 500;\n  "])), function (_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colorsTypes.WHITE : _ref3$color;
    return color;
  });
  return ((menuItems === null || menuItems === void 0 ? void 0 : menuItems.Items) || []).map(function (menuItem) {
    var index = menuItem.Text || nanoid();

    if (menuItem.Url) {
      return /*#__PURE__*/React__default$1["default"].createElement(TopLink, {
        index: index,
        key: "TopLinkNormal-".concat(index),
        className: "HEADER_DESKTOP_TOP__NAVIGATION__ITEMS HEADER_DESKTOP_TOP__NAVIGATION__ITEMS__NORMAL HeaderDesktopTopLinkNormal tw-flex",
        href: menuItem.Url
      }, menuItem.Text);
    }

    return /*#__PURE__*/React__default$1["default"].createElement(TopText, {
      className: "HEADER_DESKTOP_DOUBLE__LINK_WITH_SUBMIT__LINKS__TITLE HeaderDesktopDoubleLinkWithSubLinksTitle  ",
      key: "TopLinkNormal-".concat(index)
    }, menuItem.Text);
  });
}

var _templateObject$v, _templateObject2$4, _templateObject3$4;

function HeaderDesktopNavTopMenu(_ref) {
  var pathname = _ref.pathname,
      menuItems = _ref.menuItems,
      loginButtonText = _ref.loginButtonText,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {
    transparent: false,
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.NONE,
    filledBackgroundColor: colorsTypes.WHITE,
    withoutBorderRadius: true
  } : _ref$loginButtonStyle,
      _ref$itemsProps = _ref.itemsProps,
      itemsProps = _ref$itemsProps === void 0 ? {} : _ref$itemsProps,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _onClick = function onClick(link) {
    window.location.href = link;
  };

  var HeaderDesktopContainerBackground = styled__default["default"](HeaderDesktopDoubleContainer)(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n    background-color: ", ";\n    margin-right: 46px;\n  "])), function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colorsTypes.PRIMARY : _ref2$color;
    return color;
  });
  var SearchButton = styled__default["default"](Button$2)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    height: inherit;\n  "])));
  var LoginButton = styled__default["default"](Button$2)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    height: inherit;\n    border-radius: 0px;\n    border-color: ", ";\n    :hover {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  "])), function (_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colorsTypes.PRIMARY_LIGHT_SEMI_DARK : _ref3$color;
    return color;
  }, function (_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colorsTypes.WHITE : _ref4$color;
    return color;
  }, function (_ref5) {
    var _ref5$color = _ref5.color,
        color = _ref5$color === void 0 ? colorsTypes.WHITE : _ref5$color;
    return color;
  }, function (_ref6) {
    var _ref6$color = _ref6.color,
        color = _ref6$color === void 0 ? colorsTypes.PRIMARY_LIGHT_SEMI_DARK : _ref6$color;
    return color;
  }, function (_ref7) {
    var _ref7$color = _ref7.color,
        color = _ref7$color === void 0 ? colorsTypes.WHITE : _ref7$color;
    return color;
  }, function (_ref8) {
    var _ref8$color = _ref8.color,
        color = _ref8$color === void 0 ? colorsTypes.WHITE : _ref8$color;
    return color;
  });
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopContainerBackground, {
    className: "HEADER_DESKTOP_DOUBLE_NAVIGATION_TOP_MENU HeaderDesktopNavMenu-Nav sm:tw-inline-flex md:tw-float-right tw-items-center tw-justify-between"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DESKTOP_NAVIGATION_TOP_MENU__LOGIN HeaderDesktopNavMenu-Nav-Container-Container tw-flex tw-items-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopTopNavItems, _extends$g({
    pathname: pathname,
    menuItems: menuItems
  }, itemsProps, {
    classNamee: "HEADER_DESKTOP_NAVIGATION_TOP_MENU__ITEMS HeaderDesktopNavMenu-Nav-Container-Items"
  })), loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(LoginButton, _extends$g({
    className: "HEADER_DESKTOP_NAVIGATION_TOP_MENU__LOGIN__BUTTON",
    onClick: (loginButtonStyles === null || loginButtonStyles === void 0 ? void 0 : loginButtonStyles.variant) !== "NO_MODAL" && function () {
      return showModal();
    },
    pillTextColor: isModalVisible || forceShow ? undefined : colorsTypes.WHITE
  }, loginButtonStyles), loginButtonText)), /*#__PURE__*/React__default$1["default"].createElement(SearchButton, {
    onClick: function onClick() {
      return _onClick("/search");
    },
    "aria-label": "Search Button",
    className: "HEADER_DESKTOP_NAVIGATION_TOP_MENU__SEARCH__BUTTON",
    transparent: "true"
  }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M13.9792 13.9546L18.8395 18.8148",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M11.8944 3.71387C15.1035 5.00879 16.6552 8.66001 15.3603 11.8691C14.0654 15.0781 10.4142 16.6299 7.20509 15.335C3.99601 14.04 2.44428 10.3888 3.73921 7.17975C5.03413 3.97067 8.68535 2.41894 11.8944 3.71387",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    className: "HEADER_DESKTOP_NAVIGATION_TOP_MENU__LOGIN__MODAL",
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login$1, null))));
}

var _templateObject$u;

var HeaderDesktopLogoContainer = styled__default["default"](Link)(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 175px;\n\n  @media all and (max-width: ", "px) {\n    width: 175px;\n    height: 75px;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.md;
});

var _templateObject$t, _templateObject2$3, _templateObject3$3, _templateObject4$1, _templateObject5$1;

function HeaderDesktopDoubleMenu(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic,
      className = _ref.className,
      _ref$menuSubItemDisab = _ref.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref$menuSubItemDisab === void 0 ? false : _ref$menuSubItemDisab,
      _ref$grayscale = _ref.grayscale,
      grayscale = _ref$grayscale === void 0 ? false : _ref$grayscale,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$backgroundScreen = _ref.backgroundScreenActive,
      backgroundScreenActive = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$topIndicator = _ref.topIndicator,
      topIndicator = _ref$topIndicator === void 0 ? true : _ref$topIndicator,
      _ref$forceShowItems = _ref.forceShowItems,
      forceShowItems = _ref$forceShowItems === void 0 ? true : _ref$forceShowItems,
      _ref$forceShowColor = _ref.forceShowColor,
      forceShowColor = _ref$forceShowColor === void 0 ? false : _ref$forceShowColor,
      _ref$navigationMenuOp = _ref.navigationMenuOptions,
      navigationMenuOptions = _ref$navigationMenuOp === void 0 ? {
    menuActiveBorderColor: colorsTypes.PRIMARY,
    menuHoverBorderColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubLinksTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubItemTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subMenuBackgroundColor: colorsTypes.TRANSPARENT,
    subMenuActiveBackgroundColor: colorsTypes.TRANSPARENT,
    itemBackgroundColor: colorsTypes.WHITE,
    dropdownHoverBackground: colorsVariantsTypes.HIGHT_LIGHT_PRIMARY,
    dropdownSeparationFromTop: 20,
    dropdownSeparationFromBottom: 50
  } : _ref$navigationMenuOp,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle;

  var NavigationMainNavbarContainer = styled__default["default"](HeaderDynamicContainer)(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n    max-height: 100px;\n    align-items: center;\n  "])));
  var NavigationNavbarContainer = styled__default["default"].div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    min-height: 100px;\n    margin-left: 50px;\n    width: 100%;\n    align-items: center;\n  "])));
  var NavigationTopNavbarContainer = styled__default["default"].div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n    align-items: center;\n    height: 50px;\n    margin-right: 46px;\n    background-color: ", ";\n    width: 100%;\n  "])), function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colorsTypes.PRIMARY : _ref2$color;
    return color;
  });
  var MainContainer = styled__default["default"].div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    z-index: 50;\n    width: 100%;\n  "])));
  var HeaderDesktopDoubleMainLiksContainer = styled__default["default"].div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n    flex: 1 1 auto !important;\n  "])));
  return /*#__PURE__*/React__default$1["default"].createElement(MainContainer, null, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement(NavigationTopNavbarContainer, null, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavTopMenu, _extends$g({
    className: "HEADER_DESKTOP_DOUBLE_TOP_NAV_BAR",
    menuSubItemDisableBorder: menuSubItemDisableBorder,
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    topIndicator: topIndicator,
    pathname: pathname,
    menuItems: data === null || data === void 0 ? void 0 : data.TopNavbar,
    loginButtonText: data === null || data === void 0 ? void 0 : data.loginButtonText,
    "float": _float,
    scrollY: scrollY,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShowItems,
    forceShowColor: forceShowColor,
    backgroundBreakpoint: backgroundBreakpoint,
    loginButtonStyles: loginButtonStyles
  }, navigationMenuOptions, {
    topNavbar: (data === null || data === void 0 ? void 0 : data.TopNavbar) || ""
  }))), /*#__PURE__*/React__default$1["default"].createElement(NavigationMainNavbarContainer, {
    className: classnames("HEADER_DESKTOP_DOUBLE_NAVIGATION_MAIN HeaderDesktop-HeaderDynamicContainer tw-content-right tw-z-50 tw-relative tw-font-normal tw-flex tw-flex-wrap", scrollY > backgroundBreakpoint ? "HEADER_DESKTOP_DOUBLE_NAVIGATION_MAIN_SCROLLED " : "HEADER_DESKTOP_DOUBLE_NAVIGATION_MAIN_NO_SCROLLED", isDynamic ? "HEADER_DESKTOP_DOUBLE_NAVIGATION_MAIN_DINAMIC_PAGE" : "HEADER_DESKTOP_DOUBLE_NAVIGATION_MAIN_NO_DINAMIC_PAGE", className)
  }, /*#__PURE__*/React__default$1["default"].createElement(NavigationNavbarContainer, {
    className: "HEADER_DESKTOP_DOUBLE_MAIN_NAV_BAR tw-flex"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DESKTOP_DOUBLE_MAIN_NAV_BAR_CONTAINER tw-w-full tw-flex"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-flex-1 HEADER_DESKTOP_DOUBLE_LOGO_CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLogoContainer, {
    className: "HEADER_DESKTOP_DOUBLE__NAVIGATION__LOGO",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION__LOGO__IMAGE HeaderDesktop-HeaderDynamicContainer_Logo Header__logo",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  }))), /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDoubleMainLiksContainer, {
    className: "HEADER_DESKTOP_DOUBLE_MAIN_LINKS_CONTAINER tw-flex-1 tw-float-right"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_DESKTOP_DOUBLE_MAIN_LINKS_CONTAINER_RIGHT tw-flex-1 tw-float-right"
  }, data && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavMenuMain, _extends$g({
    menuSubItemDisableBorder: menuSubItemDisableBorder,
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    topIndicator: topIndicator,
    pathname: pathname,
    menuItems: data.NavBarItems,
    loginButtonText: data.loginButtonText,
    "float": _float,
    scrollY: scrollY,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShowItems,
    forceShowColor: forceShowColor,
    backgroundBreakpoint: backgroundBreakpoint,
    loginButtonStyles: loginButtonStyles
  }, navigationMenuOptions, {
    highlightedItem: (data === null || data === void 0 ? void 0 : data.HighlightedItem) || ""
  }))))))));
}

var _templateObject$s;

var ScrollContainer$2 = styled__default["default"].div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  height: 100vh;\n  overflow-y: auto;\n  padding-bottom: 150px;\n"])));

var _templateObject$r;

var DropdownSubMenu$1 = styled__default["default"].div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  margin: ", "px 0 40px 0;\n  background: ", ";\n  width: 100%;\n  transition: all linear 90ms;\n"])), function (_ref) {
  var _ref$isLinkActive = _ref.isLinkActive,
      isLinkActive = _ref$isLinkActive === void 0 ? false : _ref$isLinkActive;
  return isLinkActive ? 4 : 8;
}, function (_ref2) {
  var _ref2$isLinkActive = _ref2.isLinkActive,
      isLinkActive = _ref2$isLinkActive === void 0 ? false : _ref2$isLinkActive,
      _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref2$background;
  return isLinkActive ? background : undefined;
});

var _templateObject$q;

var LinkWithSubLinksContainer$1 = styled__default["default"].button(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  border-color: ", ";\n"])), function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsTypes.PRIMARY : _ref$borderColor;
  return borderColor;
});

var _templateObject$p;

var LinkWithSubLinksButton$2 = styled__default["default"].button(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  font-family: ", ";\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY));

var _templateObject$o;

var LinkWithSubLinksTitle$2 = styled__default["default"].p(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 1rem;\n  font-family: ", ";\n  font-weight: 500;\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$color;
  return color;
}, getFontFamily(fontsFamiliesVariantsTypes.SECONDARY));

var _templateObject$n;

var SubLinkItemTitle$1 = styled__default["default"].p(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  font-family: ", ";\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.LIGHT : _ref$color;
  return color;
}, getFontFamily(fontsFamiliesVariantsTypes.SECONDARY));

var _templateObject$m;

var SubLinkItem$2 = styled__default["default"](Link)(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.ULTRA_DARK : _ref2$color;
  return color;
});

function SubLinks$2(_ref) {
  var _window;

  var pathname = _ref.pathname,
      _ref$subLinks = _ref.subLinks,
      subLinks = _ref$subLinks === void 0 ? [] : _ref$subLinks,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$titleColor,
      _ref$linkActiveColor = _ref.linkActiveColor,
      linkActiveColor = _ref$linkActiveColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$linkActiveColor,
      _ref$linkColor = _ref.linkColor,
      linkColor = _ref$linkColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$linkColor;

  var _ref2 = ((_window = window) === null || _window === void 0 ? void 0 : _window.location) || {},
      _ref2$pathname = _ref2.pathname,
      localPathname = _ref2$pathname === void 0 ? "" : _ref2$pathname;

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SUB_LINKS HeaderMobile-LinkWithSubLinksContainer-SubLinks tw-pt-6"
  }, subLinks.map(function (subLink, i) {
    var keys = Object.keys(subLink) || []; // const keysValues = Object.values(subLink) || [];
    // const keysBooleans = keysValues.map((key = "") => {
    //   if (key === "/") return false;
    //   return new RegExp(`^${localPathname}`, "gi").test(key);
    // });
    // const subLinksActive = some(keysBooleans, Boolean);

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "SubLinks-subLink-".concat(i),
      className: "SUB_LINKS__ITEM HeaderMobile-LinkWithSubLinksContainer-SubLinks-subLink tw-mb-10 last:tw-mb-0"
    }, subLink.title && /*#__PURE__*/React__default$1["default"].createElement(SubLinkItemTitle$1 // color={subLinksActive ? titleActiveColor : titleColor}
    , {
      color: titleColor,
      className: "SUB_LINKS__ITEM__TITLE HeaderMobile-LinkWithSubLinksContainer-SubLinks-subLink-SubLinkItemTitle tw-pl-4 bl-text-base tw-mb-6"
    }, subLink.title), keys.map(function (key, index) {
      var url = subLink["url".concat(index)];
      var text = subLink["text".concat(index)];
      if (!url || !text) return null;
      var subLinkActive = new RegExp(localPathname, "gi").test(url);
      if (localPathname === "/") subLinkActive = false;
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "SubLink-key-".concat(key),
        className: "SUB_LINKS__ITEM__CONTENT HeaderMobile-LinkWithSubLinksContainer-SubLinks-subLink-SubLink-key tw-w-full tw-pb-6 last:tw-pb-0 tw-pl-4 bl-text-md"
      }, /*#__PURE__*/React__default$1["default"].createElement(SubLinkItem$2, {
        to: url,
        primaryFamily: "/".concat(pathname) === url,
        color: subLinkActive ? linkActiveColor : linkColor,
        className: "SUB_LINKS__ITEM__CONTENT__LINK"
      }, text));
    }));
  }));
}

function LinkWithSubLinks$2(_ref) {
  var id = _ref.id,
      pathname = _ref.pathname,
      text = _ref.text,
      subLinks = _ref.subLinks,
      isLinkActive = _ref.isLinkActive,
      onClick = _ref.onClick,
      borderColor = _ref.borderColor,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$titleColor,
      _ref$titleActiveColor = _ref.titleActiveColor,
      titleActiveColor = _ref$titleActiveColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$titleActiveColor,
      _ref$itemActiveTitleC = _ref.itemActiveTitleColor,
      itemActiveTitleColor = _ref$itemActiveTitleC === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$itemActiveTitleC,
      _ref$itemTitleColor = _ref.itemTitleColor,
      itemTitleColor = _ref$itemTitleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$itemTitleColor;
  return /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksContainer$1, {
    borderColor: borderColor,
    className: classnames("LINK_SUB_LINKS HeaderMobile-LinkWithSubLinksContainer tw-text-left", isLinkActive && "tw-border-l-2 tw-py-4")
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksButton$2, {
    type: "button",
    className: classnames("LINK_SUB_LINKS__HEADER HeaderMobile-LinkWithSubLinksButton focus:tw-outline-none tw-text-left bl-text-md tw-pl-4", isLinkActive && "tw-mb-2"),
    onClick: onClick(id),
    onKeyPress: onClick(id)
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksTitle$2, {
    color: isLinkActive ? titleActiveColor : titleColor,
    className: "LINK_SUB_LINKS__HEADER__TITLE ".concat(isLinkActive && "LINK_SUB_LINKS__HEADER__TITLE_ACTIVE", " HeaderMobile-LinkWithSubLinksButton-LinkWithSubLinksTitle")
  }, text), /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    size: 16,
    icon: isLinkActive ? iconTypes.ARROW_UP_1 : iconTypes.ARROW_DOWN_1,
    className: "LINK_SUB_LINKS__HEADER__ICON HeaderMobile-LinkWithSubLinksButton-Icon"
  })), isLinkActive && /*#__PURE__*/React__default$1["default"].createElement(SubLinks$2, {
    titleActiveColor: itemActiveTitleColor,
    titleColor: itemTitleColor,
    pathname: pathname,
    subLinks: subLinks,
    classname: "LINK_SUB_LINKS__CONTENT HeaderMobile-LinkWithSubLinksContainer-isLinkActive-SubLinks"
  }));
}

var _templateObject$l;

var CustomLink$2 = styled__default["default"](Link)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  border-color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n"])), function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsTypes.PRIMARY : _ref$borderColor;
  return borderColor;
}, fontsFamiliesTypes.SECONDARY);

function LinkNormal$2(_ref) {
  var menuItem = _ref.menuItem,
      pathname = _ref.pathname,
      variant = _ref.variant;

  switch (variant) {
    case linkVariantTypes.PAGE_LINKS:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$2, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pageLinks,
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-PAGE_LINKS tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary", pathname === menuItem.url ? "HEADER_MOBILE__ACTIVE" : "HEADER_MOBILE__INACTIVE")
      }, menuItem.text);

    case linkVariantTypes.PDF:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$2, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pdf.url,
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-PDF tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary", pathname === menuItem.url ? "HEADER_MOBILE__ACTIVE" : "HEADER_MOBILE__INACTIVE")
      }, menuItem.text);

    case linkVariantTypes.SEARCH:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$2, {
        "aria-label": "Search Button",
        to: "/search",
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-PDF tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/search")
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_CONTAINER tw-flex"
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM"
      }, "Search"), /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM CUSTOM_LINK_SEARCH_ICON"
      }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 16 17",
        fill: "none"
      }, /*#__PURE__*/React__default$1["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2.75C3.79086 2.75 2 4.54086 2 6.75C2 8.95914 3.79086 10.75 6 10.75C8.20914 10.75 10 8.95914 10 6.75C10 4.54086 8.20914 2.75 6 2.75ZM0 6.75C0 3.43629 2.68629 0.75 6 0.75C9.31371 0.75 12 3.43629 12 6.75C12 8.04583 11.5892 9.24572 10.8907 10.2265L15.7071 15.0429C16.0976 15.4334 16.0976 16.0666 15.7071 16.4571C15.3166 16.8476 14.6834 16.8476 14.2929 16.4571L9.47653 11.6407C8.49572 12.3392 7.29583 12.75 6 12.75C2.68629 12.75 0 10.0637 0 6.75Z",
        fill: "#05274C"
      })))));

    default:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$2, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.url,
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-DEFAULT tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary", pathname === menuItem.url ? "HEADER_MOBILE__ACTIVE" : "HEADER_MOBILE__INACTIVE")
      }, menuItem.text);
  }
}

function Dropdown$2(_ref) {
  var _window;

  var data = _ref.data,
      pathname = _ref.pathname,
      _ref$showBackground = _ref.showBackground,
      showBackground = _ref$showBackground === void 0 ? false : _ref$showBackground,
      _ref$subLinksTitleCol = _ref.subLinksTitleColor,
      subLinksTitleColor = _ref$subLinksTitleCol === void 0 ? colorsTypes.PRIMARY : _ref$subLinksTitleCol,
      _ref$subLinksListBord = _ref.subLinksListBorderColor,
      subLinksListBorderColor = _ref$subLinksListBord === void 0 ? colorsTypes.PRIMARY : _ref$subLinksListBord,
      _ref$menuSubLinksList = _ref.menuSubLinksListBackground,
      menuSubLinksListBackground = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColor,
      subLinksItemActiveTitleColor = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$subLinksItemTitl = _ref.subLinksItemTitleColor,
      subLinksItemTitleColor = _ref$subLinksItemTitl === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$subLinksItemTitl;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      openedSubMenu = _useState2[0],
      setOpenedSubMenu = _useState2[1];

  function toggleSubMenu(subMenuId) {
    return function () {
      setOpenedSubMenu(subMenuId === openedSubMenu ? "" : subMenuId);
    };
  }

  return /*#__PURE__*/React__default$1["default"].createElement(DropdownsContainer // background={background}
  , {
    showBackground: showBackground,
    className: "DROPDOWN HeaderMobile-DropdownsContainer bl-text-grayscale-100 tw-mt-50 tw-z-50 tw-flex tw-justify-end",
    minHeight: "".concat((((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) || 0) - HeaderHeightInPx, "px")
  }, /*#__PURE__*/React__default$1["default"].createElement(ScrollContainer$2, {
    className: "DROPDOWN_CONTAINER HeaderMobile-DropdownsContainer-ScrollContainer tw-w-full lg:tw-w-80 pb-10 lg:bl-bg-grayscale-6"
  }, (data.NavBarItems || []).map(function (menuItem, index) {
    var isLinkActive = menuItem.id === openedSubMenu;
    var variant = menuItem.pdf ? "pdf" : menuItem.pageLinks ? "pageLinks" : "url";
    return /*#__PURE__*/React__default$1["default"].createElement(DropdownSubMenu$1, {
      key: "Dropdown-menuItem-".concat(index),
      isLinkActive: isLinkActive,
      background: menuSubLinksListBackground,
      className: classnames("DROPDOWN_CONTAINER__MENU HeaderMobile-DropdownsContainer-ScrollContainer-DropdownSubMenu", isLinkActive ? "DROPDOWN_CONTAINER__MENU_ACTIVE" : "DROPDOWN_CONTAINER__MENU_NOT_ACTIVE")
    }, menuItem.subLinks && menuItem.subLinks.length > 0 ? /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinks$2, {
      itemActiveTitleColor: subLinksItemActiveTitleColor,
      itemTitleColor: subLinksItemTitleColor,
      borderColor: subLinksListBorderColor,
      titleColor: subLinksTitleColor,
      isLinkActive: isLinkActive,
      id: menuItem.id,
      pathname: pathname,
      text: menuItem.text,
      subLinks: menuItem.subLinks,
      url: menuItem.url,
      onClick: toggleSubMenu,
      classname: "DROPDOWN_CONTAINER__MENU__ITEM LINK_NORMAL HeaderMobile-DropdownsContainer-ScrollContainer-DropdownSubMenu"
    }) : /*#__PURE__*/React__default$1["default"].createElement(LinkNormal$2, {
      className: "DROPDOWN_CONTAINER__MENU__ITEM LINK_NORMAL",
      menuItem: menuItem,
      pathname: pathname,
      variant: variant
    }));
  }), /*#__PURE__*/React__default$1["default"].createElement(LinkNormal$2, {
    className: "DROPDOWN_CONTAINER__MENU__ITEM LINK_NORMAL_SEARCH",
    menuItem: "",
    pathname: "/search",
    variant: linkVariantTypes.SEARCH
  })));
}

function HeaderMobileDefault(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      className = _ref.className,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$activeLogoReplac = _ref.activeLogoReplaceImageWith,
      activeLogoReplaceImageWith = _ref$activeLogoReplac === void 0 ? "" : _ref$activeLogoReplac,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.WHITE : _ref$background,
      _ref$activeBackground = _ref.activeBackground,
      activeBackground = _ref$activeBackground === void 0 ? colorsTypes.WHITE : _ref$activeBackground,
      _ref$hoverActiveBackg = _ref.hoverActiveBackground,
      hoverActiveBackground = _ref$hoverActiveBackg === void 0 ? colorsTypes.WHITE : _ref$hoverActiveBackg,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpoint,
      backgroundAfterBreakpoint = _ref$backgroundAfterB === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$hoverFloatBackgr = _ref.hoverFloatBackground,
      hoverFloatBackground = _ref$hoverFloatBackgr === void 0 ? colorsTypes.WHITE : _ref$hoverFloatBackgr,
      _ref$backgroundAfterB2 = _ref.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref$backgroundAfterB2 === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB2,
      _ref$hoverTransparent = _ref.hoverTransparentBackground,
      hoverTransparentBackground = _ref$hoverTransparent === void 0 ? colorsTypes.TRANSPARENT : _ref$hoverTransparent,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$backgroundMenu = _ref.backgroundMenu,
      backgroundMenu = _ref$backgroundMenu === void 0 ? colorsTypes.WHITE : _ref$backgroundMenu,
      _ref$menuSubLinksList = _ref.menuSubLinksListBorderColor,
      menuSubLinksListBorderColor = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksList,
      _ref$menuSubLinksList2 = _ref.menuSubLinksListBackground,
      menuSubLinksListBackground = _ref$menuSubLinksList2 === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList2,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksTitl,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColor,
      subLinksItemActiveTitleColor = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$menuSubLinksItem = _ref.menuSubLinksItemTitleColor,
      menuSubLinksItemTitleColor = _ref$menuSubLinksItem === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksItem,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle,
      _ref$mobileActiveLogo = _ref.mobileActiveLogoReplaceImageWith,
      mobileActiveLogoReplaceImageWith = _ref$mobileActiveLogo === void 0 ? "" : _ref$mobileActiveLogo,
      _ref$mobileActiveLogo2 = _ref.mobileActiveLogoReplaceImageWithAfterBreakpoint,
      mobileActiveLogoReplaceImageWithAfterBreakpoint = _ref$mobileActiveLogo2 === void 0 ? "" : _ref$mobileActiveLogo2,
      _ref$mobileNoFilterLo = _ref.mobileNoFilterLogo,
      mobileNoFilterLogo = _ref$mobileNoFilterLo === void 0 ? false : _ref$mobileNoFilterLo,
      _ref$mobileNoFilterMe = _ref.mobileNoFilterMenuIcon,
      mobileNoFilterMenuIcon = _ref$mobileNoFilterMe === void 0 ? false : _ref$mobileNoFilterMe,
      _ref$mobileForceFilte = _ref.mobileForceFilterMenuIcon,
      mobileForceFilterMenuIcon = _ref$mobileForceFilte === void 0 ? false : _ref$mobileForceFilte,
      _ref$mobileLogoReplac = _ref.mobileLogoReplaceImageWith,
      mobileLogoReplaceImageWith = _ref$mobileLogoReplac === void 0 ? undefined : _ref$mobileLogoReplac,
      _ref$mobileLogoReplac2 = _ref.mobileLogoReplaceImageWithAfterBreakpoint,
      mobileLogoReplaceImageWithAfterBreakpoint = _ref$mobileLogoReplac2 === void 0 ? undefined : _ref$mobileLogoReplac2,
      _ref$mobileLogoFilter = _ref.mobileLogoFilter,
      mobileLogoFilter = _ref$mobileLogoFilter === void 0 ? undefined : _ref$mobileLogoFilter,
      _ref$mobileLogoFilter2 = _ref.mobileLogoFilterEffectAfterScroll,
      mobileLogoFilterEffectAfterScroll = _ref$mobileLogoFilter2 === void 0 ? [] : _ref$mobileLogoFilter2,
      _ref$mobileFilterEffe = _ref.mobileFilterEffectAfterScroll,
      mobileFilterEffectAfterScroll = _ref$mobileFilterEffe === void 0 ? [] : _ref$mobileFilterEffe,
      _ref$mobileLogoFilter3 = _ref.mobileLogoFilterEffect,
      mobileLogoFilterEffect = _ref$mobileLogoFilter3 === void 0 ? [] : _ref$mobileLogoFilter3,
      _ref$mobileActiveLogo3 = _ref.mobileActiveLogoFilterEffectAfterScroll,
      mobileActiveLogoFilterEffectAfterScroll = _ref$mobileActiveLogo3 === void 0 ? [] : _ref$mobileActiveLogo3,
      _ref$mobileMenuIconFi = _ref.mobileMenuIconFilterEffect,
      mobileMenuIconFilterEffect = _ref$mobileMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi,
      _ref$mobileMenuIconFi2 = _ref.mobileMenuIconFilterEffectAfterScroll,
      mobileMenuIconFilterEffectAfterScroll = _ref$mobileMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi2,
      _ref$mobileMenuIconAc = _ref.mobileMenuIconActiveFilterEffectAfterScroll,
      mobileMenuIconActiveFilterEffectAfterScroll = _ref$mobileMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconAc,
      _ref$menuIconFilterEf = _ref.menuIconFilterEffect,
      menuIconFilterEffect = _ref$menuIconFilterEf === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf,
      _ref$menuIconFilterEf2 = _ref.menuIconFilterEffectAfterScroll,
      menuIconFilterEffectAfterScroll = _ref$menuIconFilterEf2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf2,
      _ref$menuIconActiveFi = _ref.menuIconActiveFilterEffectAfterScroll,
      menuIconActiveFilterEffectAfterScroll = _ref$menuIconActiveFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconActiveFi,
      _ref$mobileActiveLogo4 = _ref.mobileActiveLogoFilterEffect,
      mobileActiveLogoFilterEffect = _ref$mobileActiveLogo4 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileActiveLogo4,
      _ref$mobileLoginButto = _ref.mobileLoginButtonStyles,
      mobileLoginButtonStyles = _ref$mobileLoginButto === void 0 ? {} : _ref$mobileLoginButto,
      _ref$mobileMenuIconSt = _ref.mobileMenuIconStyles,
      mobileMenuIconStyles = _ref$mobileMenuIconSt === void 0 ? {} : _ref$mobileMenuIconSt,
      _ref$mobileBackground = _ref.mobileBackground,
      mobileBackground = _ref$mobileBackground === void 0 ? colorsTypes.WHITE : _ref$mobileBackground,
      _ref$mobileBackground2 = _ref.mobileBackgroundAfterBreakpoint,
      mobileBackgroundAfterBreakpoint = _ref$mobileBackground2 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground2,
      _ref$mobileActiveBack = _ref.mobileActiveBackground,
      mobileActiveBackground = _ref$mobileActiveBack === void 0 ? colorsTypes.WHITE : _ref$mobileActiveBack,
      _ref$mobileTransparen = _ref.mobileTransparentBackground,
      mobileTransparentBackground = _ref$mobileTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileTransparen,
      _ref$mobileHoverBackg = _ref.mobileHoverBackground,
      mobileHoverBackground = _ref$mobileHoverBackg === void 0 ? colorsTypes.WHITE : _ref$mobileHoverBackg,
      _ref$mobileHoverFloat = _ref.mobileHoverFloatBackground,
      mobileHoverFloatBackground = _ref$mobileHoverFloat === void 0 ? colorsTypes.WHITE : _ref$mobileHoverFloat,
      _ref$mobileHoverActiv = _ref.mobileHoverActiveBackground,
      mobileHoverActiveBackground = _ref$mobileHoverActiv === void 0 ? colorsTypes.WHITE : _ref$mobileHoverActiv,
      _ref$mobileBackground3 = _ref.mobileBackgroundAfterBreakpointHover,
      mobileBackgroundAfterBreakpointHover = _ref$mobileBackground3 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground3,
      _ref$mobileHoverTrans = _ref.mobileHoverTransparentBackground,
      mobileHoverTransparentBackground = _ref$mobileHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileHoverTrans,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      menuActive = _useState2[0],
      setMenuActive = _useState2[1];

  React.useEffect(function () {
    screenOverflowHidden(menuActive);
  }, [menuActive]);

  var checkModalActivation = function checkModalActivation() {
    if (loginButtonStyles.variant !== loginVariantTypes.NO_MODAL) {
      showModal();
    } else {
      window.open("".concat(process.env.GATSBY_LOGIN_URL), "_blank");
    }

    setMenuActive(false);
  };

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    activeLogoReplaceImageWith: activeLogoReplaceImageWith,
    mobileActiveLogoReplaceImageWith: mobileActiveLogoReplaceImageWith,
    mobileLogoFilterEffectAfterScroll: mobileLogoFilterEffectAfterScroll,
    mobileActiveLogoFilterEffectAfterScroll: mobileActiveLogoFilterEffectAfterScroll,
    mobileActiveLogoReplaceImageWithAfterBreakpoint: mobileActiveLogoReplaceImageWithAfterBreakpoint,
    activeLogoFilterEffect: mobileActiveLogoFilterEffect,
    mobileFilterEffectAfterScroll: mobileFilterEffectAfterScroll,
    mobileLogoReplaceImageWith: mobileLogoReplaceImageWith,
    mobileLogoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    mobileNoFilterLogo: mobileNoFilterLogo,
    mobileLogoFilterEffect: mobileLogoFilterEffect,
    logoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    logoReplaceImageWith: mobileLogoReplaceImageWith,
    activeBackground: activeBackground,
    mobileActiveBackground: mobileActiveBackground,
    hoverActiveBackground: hoverActiveBackground,
    mobileHoverActiveBackground: mobileHoverActiveBackground,
    noFilterLogo: mobileNoFilterLogo,
    filter: mobileLogoFilter,
    background: background,
    mobileBackground: mobileBackground,
    mobileHoverBackground: mobileHoverBackground,
    hoverFloatBackground: hoverFloatBackground,
    mobileHoverFloatBackground: mobileHoverFloatBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    mobileBackgroundAfterBreakpointHover: mobileBackgroundAfterBreakpointHover,
    hoverTransparentBackground: hoverTransparentBackground,
    mobileHoverTransparentBackground: mobileHoverTransparentBackground,
    backgroundAfterBreakpoint: backgroundAfterBreakpoint,
    mobileBackgroundAfterBreakpoint: mobileBackgroundAfterBreakpoint,
    transparentBackground: transparentBackground,
    mobileTransparentBackground: mobileTransparentBackground,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent || !menuActive,
    forceShow: forceShow || menuActive,
    className: classnames("HEADER_MOBILE_DEFAULT HeaderDynamicContainer lg:tw-pb-16 tw-fixed lg:tw-absolute tw-z-50 tw-w-full tw-font-normal lg:tw-h-full", menuActive ? "HEADER_MOBILE_DEFAULT__OPEN tw-min-h-screen tw-overflow-y-scroll lg:tw-overflow-y-auto" : "HEADER_MOBILE_DEFAULT__CLOSE", scrollY > backgroundBreakpoint ? "HEADER_MOBILE_DEFAULT_SCROLLED " : "HEADER_MOBILE_DEFAULT_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_DEFAULT_DINAMIC_PAGE" : "HEADER_MOBILE_DEFAULT_NO_DINAMIC_PAGE", className),
    style: HeaderHeight
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement("nav", {
    className: classnames("HEADER_MOBILE_DEFAULT__CONTAINER HeaderDynamicContainer-Nav tw-z-50 lg:tw-h-full", !menuActive && "tw-h-auto")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT HeaderDynamicContainer-Container tw-h-auto tw-px-6"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX HeaderDynamicContainer-Container-Container tw-w-full tw-flex tw-justify-between tw-items-center",
    style: HeaderHeight
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__LOGO HeaderDynamicContainer-Container-Container-Link tw-relative tw-w-40 tw-h-20",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__LOGO__IMAGE HeaderDynamicContainer-Container-Container-Logo Header__logo tw-w-40 tw-my-3",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU HeaderDynamicContainer-Container-Container-Container tw-float-right tw-flex tw-items-center tw-py-2 tw-rounded"
  }, data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.PILL,
    className: classnames("HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU__ITEM HeaderDynamicContainer-Container-Container-Pill-Button tw-mr-3", menuActive ? "tw-hidden lg:tw-block" : "tw-block"),
    onClick: checkModalActivation
  }, loginButtonStyles), data.loginButtonText), data && /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU__ITEM__ICON_BOX HeaderDynamicContainer-Container-Container-Button tw-float-right tw-flex tw-items-center tw-px-3 tw-py-2 hover:bl-border-grayscale-0 ",
    onClick: function onClick() {
      setMenuActive(function (current) {
        return !current;
      });
    }
  }, /*#__PURE__*/React__default$1["default"].createElement(Icon, _extends$g({
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU__ITEM__ICON_BOX__ICON",
    icon: menuActive ? iconTypes.REMOVE : iconTypes.NAVIGATION_MENU,
    menuActive: menuActive,
    isScrollChangeColorButton: mobileLoginButtonStyles === null || mobileLoginButtonStyles === void 0 ? void 0 : mobileLoginButtonStyles.isScrollChangeColorButton,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    noFilter: mobileNoFilterMenuIcon,
    forceFilter: mobileForceFilterMenuIcon,
    filterEffect: menuIconFilterEffect,
    filterEffectAfterScroll: menuIconFilterEffectAfterScroll,
    activeFilterEffectAfterScroll: menuIconActiveFilterEffectAfterScroll,
    mobileFilterEffect: mobileMenuIconFilterEffect,
    mobileFilterEffectAfterScroll: mobileMenuIconFilterEffectAfterScroll,
    mobileActiveFilterEffectAfterScroll: mobileMenuIconActiveFilterEffectAfterScroll
  }, mobileMenuIconStyles)))))), menuActive && data && /*#__PURE__*/React__default$1["default"].createElement(Dropdown$2, {
    subLinksItemTitleColor: menuSubLinksItemTitleColor,
    subLinksListBorderColor: menuSubLinksListBorderColor,
    menuSubLinksListBackground: menuSubLinksListBackground,
    subLinksTitleColor: menuSubLinksTitleColor,
    subLinksItemActiveTitleColor: subLinksItemActiveTitleColor,
    background: backgroundMenu,
    showBackground: _float,
    data: data,
    pathname: pathname,
    classname: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__DROPDOWN HeaderMobile-HeaderDynamicContainer-Dropdown"
  }), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__MODAL",
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login, {
    variant: loginButtonStyles.variant
  }))));
}

var _excluded$C = ["variant"];

function HeaderMobile(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? headerMobileVariantTypes.STANDARD : _ref$variant,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$C);

  switch (variant) {
    case headerMobileVariantTypes.STANDARD:
      return /*#__PURE__*/React__default$1["default"].createElement(HeaderMobileDefault, otherProps);

    default:
      throw new Error("Header Mobile: Invalid variant type (".concat(variant, ")"));
  }
}

var _templateObject$k;

var ScrollContainer$1 = styled__default["default"].div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  height: 100vh;\n  overflow-y: auto;\n  padding-bottom: 150px;\n"])));

var _templateObject$j;

var DropdownSubMenu = styled__default["default"].div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  margin: ", "px 0 40px 0;\n  background: ", ";\n  width: 100%;\n  transition: all linear 90ms;\n"])), function (_ref) {
  var _ref$isLinkActive = _ref.isLinkActive,
      isLinkActive = _ref$isLinkActive === void 0 ? false : _ref$isLinkActive;
  return isLinkActive ? 4 : 8;
}, function (_ref2) {
  var _ref2$isLinkActive = _ref2.isLinkActive,
      isLinkActive = _ref2$isLinkActive === void 0 ? false : _ref2$isLinkActive,
      _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref2$background;
  return isLinkActive ? background : undefined;
});

var _templateObject$i;

var LinkWithSubLinksContainer = styled__default["default"].button(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  border-color: ", ";\n"])), function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsTypes.PRIMARY : _ref$borderColor;
  return borderColor;
});

var _templateObject$h;

var LinkWithSubLinksButton$1 = styled__default["default"].button(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  font-family: ", ";\n"])), getFontFamily(fontsFamiliesVariantsTypes.PRIMARY));

var _templateObject$g;

var LinkWithSubLinksTitle$1 = styled__default["default"].p(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 1rem;\n  font-family: ", ";\n  font-weight: 500;\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$color;
  return color;
}, getFontFamily(fontsFamiliesVariantsTypes.SECONDARY));

var _templateObject$f;

var SubLinkItemTitle = styled__default["default"].p(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  font-family: ", ";\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.LIGHT : _ref$color;
  return color;
}, getFontFamily(fontsFamiliesVariantsTypes.SECONDARY));

var _templateObject$e;

var SubLinkItem$1 = styled__default["default"](Link)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? getFontFamily(fontsFamiliesVariantsTypes.PRIMARY) : undefined;
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.ULTRA_DARK : _ref2$color;
  return color;
});

function SubLinks$1(_ref) {
  var _window;

  var pathname = _ref.pathname,
      _ref$subLinks = _ref.subLinks,
      subLinks = _ref$subLinks === void 0 ? [] : _ref$subLinks,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$titleColor,
      _ref$linkActiveColor = _ref.linkActiveColor,
      linkActiveColor = _ref$linkActiveColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$linkActiveColor,
      _ref$linkColor = _ref.linkColor,
      linkColor = _ref$linkColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$linkColor;

  var _ref2 = ((_window = window) === null || _window === void 0 ? void 0 : _window.location) || {},
      _ref2$pathname = _ref2.pathname,
      localPathname = _ref2$pathname === void 0 ? "" : _ref2$pathname;

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SUB_LINKS HeaderMobile-LinkWithSubLinksContainer-SubLinks tw-pt-6"
  }, subLinks.map(function (subLink, i) {
    var keys = Object.keys(subLink) || []; // const keysValues = Object.values(subLink) || [];
    // const keysBooleans = keysValues.map((key = "") => {
    //   if (key === "/") return false;
    //   return new RegExp(`^${localPathname}`, "gi").test(key);
    // });
    // const subLinksActive = some(keysBooleans, Boolean);

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "SubLinks-subLink-".concat(i),
      className: "SUB_LINKS__ITEM HeaderMobile-LinkWithSubLinksContainer-SubLinks-subLink tw-mb-10 last:tw-mb-0"
    }, subLink.title && /*#__PURE__*/React__default$1["default"].createElement(SubLinkItemTitle // color={subLinksActive ? titleActiveColor : titleColor}
    , {
      color: titleColor,
      className: "SUB_LINKS__ITEM__TITLE HeaderMobile-LinkWithSubLinksContainer-SubLinks-subLink-SubLinkItemTitle tw-pl-4 bl-text-base tw-mb-6"
    }, subLink.title), keys.map(function (key, index) {
      var url = subLink["url".concat(index)];
      var text = subLink["text".concat(index)];
      if (!url || !text) return null;
      var subLinkActive = new RegExp(localPathname, "gi").test(url);
      if (localPathname === "/") subLinkActive = false;
      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "SubLink-key-".concat(key),
        className: "SUB_LINKS__ITEM__CONTENT HeaderMobile-LinkWithSubLinksContainer-SubLinks-subLink-SubLink-key tw-w-full tw-pb-6 last:tw-pb-0 tw-pl-4 bl-text-md"
      }, /*#__PURE__*/React__default$1["default"].createElement(SubLinkItem$1, {
        to: url,
        primaryFamily: "/".concat(pathname) === url,
        color: subLinkActive ? linkActiveColor : linkColor,
        className: "SUB_LINKS__ITEM__CONTENT__LINK"
      }, text));
    }));
  }));
}

function LinkWithSubLinks$1(_ref) {
  var id = _ref.id,
      pathname = _ref.pathname,
      text = _ref.text,
      subLinks = _ref.subLinks,
      isLinkActive = _ref.isLinkActive,
      onClick = _ref.onClick,
      borderColor = _ref.borderColor,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$titleColor,
      _ref$titleActiveColor = _ref.titleActiveColor,
      titleActiveColor = _ref$titleActiveColor === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$titleActiveColor,
      _ref$itemActiveTitleC = _ref.itemActiveTitleColor,
      itemActiveTitleColor = _ref$itemActiveTitleC === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$itemActiveTitleC,
      _ref$itemTitleColor = _ref.itemTitleColor,
      itemTitleColor = _ref$itemTitleColor === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$itemTitleColor;
  return /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksContainer, {
    borderColor: borderColor,
    className: classnames("LINK_SUB_LINKS HeaderMobile-LinkWithSubLinksContainer tw-text-left", isLinkActive && "tw-border-l-2 tw-py-4")
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksButton$1, {
    type: "button",
    className: classnames("LINK_SUB_LINKS__HEADER HeaderMobile-LinkWithSubLinksButton focus:tw-outline-none tw-text-left bl-text-md tw-pl-4", isLinkActive && "tw-mb-2"),
    onClick: onClick(id),
    onKeyPress: onClick(id)
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksTitle$1, {
    color: isLinkActive ? titleActiveColor : titleColor,
    className: "LINK_SUB_LINKS__HEADER__TITLE ".concat(isLinkActive && "LINK_SUB_LINKS__HEADER__TITLE_ACTIVE", " HeaderMobile-LinkWithSubLinksButton-LinkWithSubLinksTitle")
  }, text), /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    size: 16,
    icon: isLinkActive ? iconTypes.ARROW_UP_1 : iconTypes.ARROW_DOWN_1,
    className: "LINK_SUB_LINKS__HEADER__ICON HeaderMobile-LinkWithSubLinksButton-Icon"
  })), isLinkActive && /*#__PURE__*/React__default$1["default"].createElement(SubLinks$1, {
    titleActiveColor: itemActiveTitleColor,
    titleColor: itemTitleColor,
    pathname: pathname,
    subLinks: subLinks,
    classname: "LINK_SUB_LINKS__CONTENT HeaderMobile-LinkWithSubLinksContainer-isLinkActive-SubLinks"
  }));
}

var _templateObject$d;

var CustomLink$1 = styled__default["default"](Link)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  border-color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n"])), function (_ref) {
  var _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? colorsTypes.PRIMARY : _ref$borderColor;
  return borderColor;
}, fontsFamiliesTypes.SECONDARY);

function LinkNormal$1(_ref) {
  var menuItem = _ref.menuItem,
      pathname = _ref.pathname,
      variant = _ref.variant;

  switch (variant) {
    case linkVariantTypes.PAGE_LINKS:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$1, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pageLinks,
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-PAGE_LINKS tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary", pathname === menuItem.url ? "HEADER_MOBILE__ACTIVE" : "HEADER_MOBILE__INACTIVE")
      }, menuItem.text);

    case linkVariantTypes.PDF:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$1, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pdf.url,
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-PDF tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary", pathname === menuItem.url ? "HEADER_MOBILE__ACTIVE" : "HEADER_MOBILE__INACTIVE")
      }, menuItem.text);

    case linkVariantTypes.SEARCH:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$1, {
        "aria-label": "Search Button",
        to: "/search",
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-PDF tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/search")
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_CONTAINER tw-flex"
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM"
      }, "Search"), /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM CUSTOM_LINK_SEARCH_ICON"
      }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 16 17",
        fill: "none"
      }, /*#__PURE__*/React__default$1["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2.75C3.79086 2.75 2 4.54086 2 6.75C2 8.95914 3.79086 10.75 6 10.75C8.20914 10.75 10 8.95914 10 6.75C10 4.54086 8.20914 2.75 6 2.75ZM0 6.75C0 3.43629 2.68629 0.75 6 0.75C9.31371 0.75 12 3.43629 12 6.75C12 8.04583 11.5892 9.24572 10.8907 10.2265L15.7071 15.0429C16.0976 15.4334 16.0976 16.0666 15.7071 16.4571C15.3166 16.8476 14.6834 16.8476 14.2929 16.4571L9.47653 11.6407C8.49572 12.3392 7.29583 12.75 6 12.75C2.68629 12.75 0 10.0637 0 6.75Z",
        fill: "#05274C"
      })))));

    default:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink$1, {
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.url,
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-DEFAULT tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary", pathname === menuItem.url ? "HEADER_MOBILE__ACTIVE" : "HEADER_MOBILE__INACTIVE")
      }, menuItem.text);
  }
}

function Dropdown$1(_ref) {
  var _window;

  var data = _ref.data,
      pathname = _ref.pathname,
      _ref$showBackground = _ref.showBackground,
      showBackground = _ref$showBackground === void 0 ? false : _ref$showBackground,
      _ref$subLinksTitleCol = _ref.subLinksTitleColor,
      subLinksTitleColor = _ref$subLinksTitleCol === void 0 ? colorsTypes.PRIMARY : _ref$subLinksTitleCol,
      _ref$subLinksListBord = _ref.subLinksListBorderColor,
      subLinksListBorderColor = _ref$subLinksListBord === void 0 ? colorsTypes.PRIMARY : _ref$subLinksListBord,
      _ref$menuSubLinksList = _ref.menuSubLinksListBackground,
      menuSubLinksListBackground = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColor,
      subLinksItemActiveTitleColor = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$subLinksItemTitl = _ref.subLinksItemTitleColor,
      subLinksItemTitleColor = _ref$subLinksItemTitl === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$subLinksItemTitl;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      openedSubMenu = _useState2[0],
      setOpenedSubMenu = _useState2[1];

  function toggleSubMenu(subMenuId) {
    return function () {
      setOpenedSubMenu(subMenuId === openedSubMenu ? "" : subMenuId);
    };
  }

  return /*#__PURE__*/React__default$1["default"].createElement(DropdownsContainer // background={background}
  , {
    showBackground: showBackground,
    className: "DROPDOWN HeaderMobile-DropdownsContainer bl-text-grayscale-100 tw-mt-50 tw-z-50 tw-flex tw-justify-end",
    minHeight: "".concat((((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) || 0) - HeaderHeightInPx, "px")
  }, /*#__PURE__*/React__default$1["default"].createElement(ScrollContainer$1, {
    className: "DROPDOWN_CONTAINER HeaderMobile-DropdownsContainer-ScrollContainer tw-w-full lg:tw-w-80 pb-10 lg:bl-bg-grayscale-6"
  }, (data.NavBarItems || []).map(function (menuItem, index) {
    var isLinkActive = menuItem.id === openedSubMenu;
    var variant = menuItem.pdf ? "pdf" : menuItem.pageLinks ? "pageLinks" : "url";
    return /*#__PURE__*/React__default$1["default"].createElement(DropdownSubMenu, {
      key: "Dropdown-menuItem-".concat(index),
      isLinkActive: isLinkActive,
      background: menuSubLinksListBackground,
      className: "DROPDOWN_CONTAINER__MENU HeaderMobile-DropdownsContainer-ScrollContainer-DropdownSubMenu"
    }, menuItem.subLinks && menuItem.subLinks.length > 0 ? /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinks$1, {
      itemActiveTitleColor: subLinksItemActiveTitleColor,
      itemTitleColor: subLinksItemTitleColor,
      borderColor: subLinksListBorderColor,
      titleColor: subLinksTitleColor,
      isLinkActive: isLinkActive,
      id: menuItem.id,
      pathname: pathname,
      text: menuItem.text,
      subLinks: menuItem.subLinks,
      url: menuItem.url,
      onClick: toggleSubMenu,
      classname: "DROPDOWN_CONTAINER__MENU__ITEM LINK_NORMAL HeaderMobile-DropdownsContainer-ScrollContainer-DropdownSubMenu"
    }) : /*#__PURE__*/React__default$1["default"].createElement(LinkNormal$1, {
      className: "DROPDOWN_CONTAINER__MENU__ITEM LINK_NORMAL",
      menuItem: menuItem,
      pathname: pathname,
      variant: variant
    }));
  })));
}

var _templateObject$c, _templateObject2$2, _templateObject3$2, _templateObject4, _templateObject5;

function HeaderMobileDouble(_ref) {
  var _data$TopNavbar, _data$TopNavbar2, _data$TopNavbar3;

  var data = _ref.data,
      pathname = _ref.pathname,
      className = _ref.className,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$activeLogoReplac = _ref.activeLogoReplaceImageWith,
      activeLogoReplaceImageWith = _ref$activeLogoReplac === void 0 ? "" : _ref$activeLogoReplac,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.WHITE : _ref$background,
      _ref$activeBackground = _ref.activeBackground,
      activeBackground = _ref$activeBackground === void 0 ? colorsTypes.WHITE : _ref$activeBackground,
      _ref$hoverActiveBackg = _ref.hoverActiveBackground,
      hoverActiveBackground = _ref$hoverActiveBackg === void 0 ? colorsTypes.WHITE : _ref$hoverActiveBackg,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpoint,
      backgroundAfterBreakpoint = _ref$backgroundAfterB === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$hoverFloatBackgr = _ref.hoverFloatBackground,
      hoverFloatBackground = _ref$hoverFloatBackgr === void 0 ? colorsTypes.WHITE : _ref$hoverFloatBackgr,
      _ref$backgroundAfterB2 = _ref.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref$backgroundAfterB2 === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB2,
      _ref$hoverTransparent = _ref.hoverTransparentBackground,
      hoverTransparentBackground = _ref$hoverTransparent === void 0 ? colorsTypes.TRANSPARENT : _ref$hoverTransparent,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$backgroundMenu = _ref.backgroundMenu,
      backgroundMenu = _ref$backgroundMenu === void 0 ? colorsTypes.WHITE : _ref$backgroundMenu,
      _ref$menuSubLinksList = _ref.menuSubLinksListBorderColor,
      menuSubLinksListBorderColor = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksList,
      _ref$menuSubLinksList2 = _ref.menuSubLinksListBackground,
      menuSubLinksListBackground = _ref$menuSubLinksList2 === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList2,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksTitl,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColor,
      subLinksItemActiveTitleColor = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$menuSubLinksItem = _ref.menuSubLinksItemTitleColor,
      menuSubLinksItemTitleColor = _ref$menuSubLinksItem === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksItem,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle,
      _ref$mobileActiveLogo = _ref.mobileActiveLogoReplaceImageWith,
      mobileActiveLogoReplaceImageWith = _ref$mobileActiveLogo === void 0 ? "" : _ref$mobileActiveLogo,
      _ref$mobileActiveLogo2 = _ref.mobileActiveLogoReplaceImageWithAfterBreakpoint,
      mobileActiveLogoReplaceImageWithAfterBreakpoint = _ref$mobileActiveLogo2 === void 0 ? "" : _ref$mobileActiveLogo2,
      _ref$mobileNoFilterLo = _ref.mobileNoFilterLogo,
      mobileNoFilterLogo = _ref$mobileNoFilterLo === void 0 ? false : _ref$mobileNoFilterLo,
      _ref$mobileNoFilterMe = _ref.mobileNoFilterMenuIcon,
      mobileNoFilterMenuIcon = _ref$mobileNoFilterMe === void 0 ? false : _ref$mobileNoFilterMe,
      _ref$mobileForceFilte = _ref.mobileForceFilterMenuIcon,
      mobileForceFilterMenuIcon = _ref$mobileForceFilte === void 0 ? false : _ref$mobileForceFilte,
      _ref$mobileLogoReplac = _ref.mobileLogoReplaceImageWith,
      mobileLogoReplaceImageWith = _ref$mobileLogoReplac === void 0 ? undefined : _ref$mobileLogoReplac,
      _ref$mobileLogoReplac2 = _ref.mobileLogoReplaceImageWithAfterBreakpoint,
      mobileLogoReplaceImageWithAfterBreakpoint = _ref$mobileLogoReplac2 === void 0 ? undefined : _ref$mobileLogoReplac2,
      _ref$mobileLogoFilter = _ref.mobileLogoFilter,
      mobileLogoFilter = _ref$mobileLogoFilter === void 0 ? undefined : _ref$mobileLogoFilter,
      _ref$mobileLogoFilter2 = _ref.mobileLogoFilterEffectAfterScroll,
      mobileLogoFilterEffectAfterScroll = _ref$mobileLogoFilter2 === void 0 ? [] : _ref$mobileLogoFilter2,
      _ref$mobileFilterEffe = _ref.mobileFilterEffectAfterScroll,
      mobileFilterEffectAfterScroll = _ref$mobileFilterEffe === void 0 ? [] : _ref$mobileFilterEffe,
      _ref$mobileLogoFilter3 = _ref.mobileLogoFilterEffect,
      mobileLogoFilterEffect = _ref$mobileLogoFilter3 === void 0 ? [] : _ref$mobileLogoFilter3,
      _ref$mobileActiveLogo3 = _ref.mobileActiveLogoFilterEffectAfterScroll,
      mobileActiveLogoFilterEffectAfterScroll = _ref$mobileActiveLogo3 === void 0 ? [] : _ref$mobileActiveLogo3,
      _ref$mobileMenuIconFi = _ref.mobileMenuIconFilterEffect,
      mobileMenuIconFilterEffect = _ref$mobileMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi,
      _ref$mobileMenuIconFi2 = _ref.mobileMenuIconFilterEffectAfterScroll,
      mobileMenuIconFilterEffectAfterScroll = _ref$mobileMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi2,
      _ref$mobileMenuIconAc = _ref.mobileMenuIconActiveFilterEffectAfterScroll,
      mobileMenuIconActiveFilterEffectAfterScroll = _ref$mobileMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconAc,
      _ref$menuIconFilterEf = _ref.menuIconFilterEffect,
      menuIconFilterEffect = _ref$menuIconFilterEf === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf,
      _ref$menuIconFilterEf2 = _ref.menuIconFilterEffectAfterScroll,
      menuIconFilterEffectAfterScroll = _ref$menuIconFilterEf2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf2,
      _ref$menuIconActiveFi = _ref.menuIconActiveFilterEffectAfterScroll,
      menuIconActiveFilterEffectAfterScroll = _ref$menuIconActiveFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconActiveFi,
      _ref$mobileActiveLogo4 = _ref.mobileActiveLogoFilterEffect,
      mobileActiveLogoFilterEffect = _ref$mobileActiveLogo4 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileActiveLogo4,
      _ref$mobileLoginButto = _ref.mobileLoginButtonStyles,
      mobileLoginButtonStyles = _ref$mobileLoginButto === void 0 ? {} : _ref$mobileLoginButto,
      _ref$mobileMenuIconSt = _ref.mobileMenuIconStyles,
      mobileMenuIconStyles = _ref$mobileMenuIconSt === void 0 ? {} : _ref$mobileMenuIconSt,
      _ref$mobileBackground = _ref.mobileBackground,
      mobileBackground = _ref$mobileBackground === void 0 ? colorsTypes.WHITE : _ref$mobileBackground,
      _ref$mobileBackground2 = _ref.mobileBackgroundAfterBreakpoint,
      mobileBackgroundAfterBreakpoint = _ref$mobileBackground2 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground2,
      _ref$mobileActiveBack = _ref.mobileActiveBackground,
      mobileActiveBackground = _ref$mobileActiveBack === void 0 ? colorsTypes.WHITE : _ref$mobileActiveBack,
      _ref$mobileTransparen = _ref.mobileTransparentBackground,
      mobileTransparentBackground = _ref$mobileTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileTransparen,
      _ref$mobileHoverBackg = _ref.mobileHoverBackground,
      mobileHoverBackground = _ref$mobileHoverBackg === void 0 ? colorsTypes.WHITE : _ref$mobileHoverBackg,
      _ref$mobileHoverFloat = _ref.mobileHoverFloatBackground,
      mobileHoverFloatBackground = _ref$mobileHoverFloat === void 0 ? colorsTypes.WHITE : _ref$mobileHoverFloat,
      _ref$mobileHoverActiv = _ref.mobileHoverActiveBackground,
      mobileHoverActiveBackground = _ref$mobileHoverActiv === void 0 ? colorsTypes.WHITE : _ref$mobileHoverActiv,
      _ref$mobileBackground3 = _ref.mobileBackgroundAfterBreakpointHover,
      mobileBackgroundAfterBreakpointHover = _ref$mobileBackground3 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground3,
      _ref$mobileHoverTrans = _ref.mobileHoverTransparentBackground,
      mobileHoverTransparentBackground = _ref$mobileHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileHoverTrans,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      menuActive = _useState2[0],
      setMenuActive = _useState2[1];

  var _onClick = function onClick(link) {
    window.location.href = link;
  };

  var LoginButton = styled__default["default"](Button$2)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    height: 50px;\n    width: 100%;\n    border-radius: 0px;\n    border-color: ", ";\n    :hover {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n    position: relative;\n    padding-top: 12px;\n  "])), function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colorsTypes.PRIMARY_LIGHT_SEMI_DARK : _ref2$color;
    return color;
  }, function (_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colorsTypes.WHITE : _ref3$color;
    return color;
  }, function (_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colorsTypes.WHITE : _ref4$color;
    return color;
  }, function (_ref5) {
    var _ref5$color = _ref5.color,
        color = _ref5$color === void 0 ? colorsTypes.PRIMARY_LIGHT_SEMI_DARK : _ref5$color;
    return color;
  }, function (_ref6) {
    var _ref6$color = _ref6.color,
        color = _ref6$color === void 0 ? colorsTypes.WHITE : _ref6$color;
    return color;
  }, function (_ref7) {
    var _ref7$color = _ref7.color,
        color = _ref7$color === void 0 ? colorsTypes.WHITE : _ref7$color;
    return color;
  });
  var TopLink = styled__default["default"].a(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), function (_ref8) {
    var _ref8$color = _ref8.color,
        color = _ref8$color === void 0 ? colorsTypes.WHITE : _ref8$color;
    return color;
  });
  React.useEffect(function () {
    screenOverflowHidden(menuActive);
  }, [menuActive]);

  var checkModalActivation = function checkModalActivation() {
    if (loginButtonStyles.variant !== loginVariantTypes.NO_MODAL) {
      showModal();
    } else {
      window.open("".concat(process.env.GATSBY_LOGIN_URL), "_blank");
    }

    setMenuActive(false);
  };

  var TopNavbarMobile = styled__default["default"].div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n    height: 50px;\n    background-color: #00583F;\n    align-items: right;\n    min-width: 100%;\n  "])));
  var TopNavbarMobileContainer = styled__default["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: inherit;\n    align-items: center;\n  "])));
  var SearchButton = styled__default["default"](Button$2)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: inherit;\n    border-style: none;\n    padding-right: 0px;\n    padding-left: 0px;\n    width: 20px;\n  "])));
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    activeLogoReplaceImageWith: activeLogoReplaceImageWith,
    mobileActiveLogoReplaceImageWith: mobileActiveLogoReplaceImageWith,
    mobileLogoFilterEffectAfterScroll: mobileLogoFilterEffectAfterScroll,
    mobileActiveLogoFilterEffectAfterScroll: mobileActiveLogoFilterEffectAfterScroll,
    mobileActiveLogoReplaceImageWithAfterBreakpoint: mobileActiveLogoReplaceImageWithAfterBreakpoint,
    activeLogoFilterEffect: mobileActiveLogoFilterEffect,
    mobileFilterEffectAfterScroll: mobileFilterEffectAfterScroll,
    mobileLogoReplaceImageWith: mobileLogoReplaceImageWith,
    mobileLogoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    mobileNoFilterLogo: mobileNoFilterLogo,
    mobileLogoFilterEffect: mobileLogoFilterEffect,
    logoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    logoReplaceImageWith: mobileLogoReplaceImageWith,
    activeBackground: activeBackground,
    mobileActiveBackground: mobileActiveBackground,
    hoverActiveBackground: hoverActiveBackground,
    mobileHoverActiveBackground: mobileHoverActiveBackground,
    noFilterLogo: mobileNoFilterLogo,
    filter: mobileLogoFilter,
    background: background,
    mobileBackground: mobileBackground,
    mobileHoverBackground: mobileHoverBackground,
    hoverFloatBackground: hoverFloatBackground,
    mobileHoverFloatBackground: mobileHoverFloatBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    mobileBackgroundAfterBreakpointHover: mobileBackgroundAfterBreakpointHover,
    hoverTransparentBackground: hoverTransparentBackground,
    mobileHoverTransparentBackground: mobileHoverTransparentBackground,
    backgroundAfterBreakpoint: backgroundAfterBreakpoint,
    mobileBackgroundAfterBreakpoint: mobileBackgroundAfterBreakpoint,
    transparentBackground: transparentBackground,
    mobileTransparentBackground: mobileTransparentBackground,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent || !menuActive,
    forceShow: forceShow || menuActive,
    className: classnames("HEADER_MOBILE_DEFAULT HeaderDynamicContainer lg:tw-pb-16 tw-fixed lg:tw-absolute tw-z-50 tw-w-full tw-font-normal lg:tw-h-full", menuActive ? "HEADER_MOBILE_DEFAULT__OPEN tw-min-h-screen tw-overflow-y-scroll lg:tw-overflow-y-auto" : "HEADER_MOBILE_DEFAULT__CLOSE", scrollY > backgroundBreakpoint ? "HEADER_MOBILE_DEFAULT_SCROLLED " : "HEADER_MOBILE_DEFAULT_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_DEFAULT_DINAMIC_PAGE" : "HEADER_MOBILE_DEFAULT_NO_DINAMIC_PAGE", className),
    style: HeaderHeight
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement(TopNavbarMobile, {
    className: "HEADER_MOBILE_DOUBLE_TOP_NAVBAR "
  }, /*#__PURE__*/React__default$1["default"].createElement(TopNavbarMobileContainer, {
    className: "HEADER_MOBILE_DOUBLE_TOP_NAVBAR_CONTAINER tw-flex tw-align-middle"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-flex-auto tw-text-center"
  }, (data === null || data === void 0 ? void 0 : (_data$TopNavbar = data.TopNavbar) === null || _data$TopNavbar === void 0 ? void 0 : _data$TopNavbar.Items[0]) && /*#__PURE__*/React__default$1["default"].createElement(TopLink, {
    href: data === null || data === void 0 ? void 0 : (_data$TopNavbar2 = data.TopNavbar) === null || _data$TopNavbar2 === void 0 ? void 0 : _data$TopNavbar2.Items[0].Url,
    alt: "top-navbar-item"
  }, data === null || data === void 0 ? void 0 : (_data$TopNavbar3 = data.TopNavbar) === null || _data$TopNavbar3 === void 0 ? void 0 : _data$TopNavbar3.Items[0].Text)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-flex-auto tw-text-center"
  }, data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(LoginButton, _extends$g({
    fill: buttonFillTypes.FILLED,
    styleType: buttonStyleTypes.PILL,
    className: classnames("HEADER_MOBILE_DOUBLE_LOGIN_BUTTON"),
    onClick: checkModalActivation
  }, loginButtonStyles), data.loginButtonText)), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-flex-auto tw-text-center"
  }, /*#__PURE__*/React__default$1["default"].createElement(SearchButton, {
    onClick: function onClick() {
      return _onClick("/search");
    },
    "aria-label": "Search Button",
    className: "HEADER_DESKTOP_NAVIGATION_TOP_MENU__SEARCH__BUTTON",
    transparent: "true"
  }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
    width: "20",
    height: "17",
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M13.9792 11.9224L18.8395 15.9379",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/React__default$1["default"].createElement("path", {
    d: "M11.8944 3.46183C15.1035 4.5317 16.6552 7.54834 15.3603 10.1997C14.0654 12.851 10.4142 14.1331 7.20509 13.0632C3.99601 11.9933 2.44428 8.97668 3.73921 6.32535C5.03413 3.674 8.68534 2.39196 11.8944 3.46183",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })))))), /*#__PURE__*/React__default$1["default"].createElement("nav", {
    className: classnames("HEADER_MOBILE_DEFAULT__CONTAINER HeaderDynamicContainer-Nav tw-z-50 lg:tw-h-full", !menuActive && "tw-h-auto")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT HeaderDynamicContainer-Container tw-h-auto tw-px-6"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX HeaderDynamicContainer-Container-Container tw-w-full tw-flex tw-justify-between tw-items-center",
    style: HeaderHeight
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__LOGO HeaderDynamicContainer-Container-Container-Link tw-relative tw-w-40 tw-h-20",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__LOGO__IMAGE HeaderDynamicContainer-Container-Container-Logo Header__logo tw-w-40 tw-my-3",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU HeaderDynamicContainer-Container-Container-Container tw-float-right tw-flex tw-items-center tw-py-2 tw-rounded"
  }, data && /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU__ITEM__ICON_BOX HeaderDynamicContainer-Container-Container-Button tw-float-right tw-flex tw-items-center tw-px-3 tw-py-2 hover:bl-border-grayscale-0 ",
    onClick: function onClick() {
      setMenuActive(function (current) {
        return !current;
      });
    }
  }, /*#__PURE__*/React__default$1["default"].createElement(Icon, _extends$g({
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__BOX__MENU__ITEM__ICON_BOX__ICON",
    icon: menuActive ? iconTypes.REMOVE : iconTypes.NAVIGATION_MENU,
    menuActive: menuActive,
    isScrollChangeColorButton: mobileLoginButtonStyles === null || mobileLoginButtonStyles === void 0 ? void 0 : mobileLoginButtonStyles.isScrollChangeColorButton,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    noFilter: mobileNoFilterMenuIcon,
    forceFilter: mobileForceFilterMenuIcon,
    filterEffect: menuIconFilterEffect,
    filterEffectAfterScroll: menuIconFilterEffectAfterScroll,
    activeFilterEffectAfterScroll: menuIconActiveFilterEffectAfterScroll,
    mobileFilterEffect: mobileMenuIconFilterEffect,
    mobileFilterEffectAfterScroll: mobileMenuIconFilterEffectAfterScroll,
    mobileActiveFilterEffectAfterScroll: mobileMenuIconActiveFilterEffectAfterScroll
  }, mobileMenuIconStyles)))))), menuActive && data && /*#__PURE__*/React__default$1["default"].createElement(Dropdown$1, {
    subLinksItemTitleColor: menuSubLinksItemTitleColor,
    subLinksListBorderColor: menuSubLinksListBorderColor,
    menuSubLinksListBackground: menuSubLinksListBackground,
    subLinksTitleColor: menuSubLinksTitleColor,
    subLinksItemActiveTitleColor: subLinksItemActiveTitleColor,
    background: backgroundMenu,
    showBackground: _float,
    data: data,
    pathname: pathname,
    classname: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__DROPDOWN HeaderMobile-HeaderDynamicContainer-Dropdown"
  }), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    className: "HEADER_MOBILE_DEFAULT__CONTAINER__CONTENT__MODAL",
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login, {
    variant: loginButtonStyles.variant
  }))));
}

var _templateObject$b;

var ScrollContainer = styled__default["default"].div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  height: 100vh;\n  overflow-y: auto;\n  padding-bottom: 150px;\n"])));

var _templateObject$a;

var LinkWithSubLinksButton = styled__default["default"].button(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  font-family: ", ";\n"])), fontsFamiliesTypes.PRIMARY);

var _templateObject$9;

var LinkWithSubLinksTitle = styled__default["default"].p(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 1rem;\n  //font-family: ", ";\n  font-weight: 500;\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$color;
  return color;
}, fontsFamiliesTypes.SECONDARY);

var _templateObject$8;

var SubLinkTitle = styled__default["default"].div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  //font-family: ", ";\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.LIGHT : _ref$color;
  return color;
}, fontsFamiliesTypes.SECONDARY);

var _templateObject$7;

var SubLinkItem = styled__default["default"](Link)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref) {
  var _ref$primaryFamily = _ref.primaryFamily,
      primaryFamily = _ref$primaryFamily === void 0 ? false : _ref$primaryFamily;
  return primaryFamily ? fontsFamiliesTypes.PRIMARY : undefined;
}, function (_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colorsTypes.WHITE : _ref2$color;
  return color;
});

var _templateObject$6;

function SubLinks(_ref) {
  var pathname = _ref.pathname,
      _ref$subLinks = _ref.subLinks,
      subLinks = _ref$subLinks === void 0 ? [] : _ref$subLinks;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SUB_LINKS tw-pt-6"
  }, subLinks.map(function (subLink, i) {
    var keys = Object.keys(subLink) || [];
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "SubLinks-subLink-".concat(i),
      className: "SUB_LINKS__ITEM tw-mb-10 last:tw-mb-0"
    }, subLink.title && /*#__PURE__*/React__default$1["default"].createElement(SubLinkTitle, {
      color: "var(--primary-color)",
      className: "SUB_LINKS__ITEM__TITLE Header-Mobile-Compressed-SubLinks tw-px-7 bl-text-base bl-text-grayscale-50 tw-mb-6 bl-font-secondary"
    }, subLink.title), keys.map(function (key, index) {
      var url = subLink["url".concat(index)];
      var text = subLink["text".concat(index)];

      if (!url || !text) {
        return null;
      }

      if (url === "/autolink") {
        return /*#__PURE__*/React__default$1["default"].createElement(AutoLink, {
          key: "SubLink-key-".concat(key),
          url: url,
          text: text,
          pathname: pathname
        });
      }

      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "SubLink-key-".concat(key),
        className: "SUB_LINKS__ITEM__CONTENT Header-Mobile-Compressed-SubLinks_Sublink-key tw-w-full tw-pb-6 last:tw-pb-0 tw-px-7 bl-text-md"
      }, /*#__PURE__*/React__default$1["default"].createElement(SubLinkItem, {
        to: url,
        color: "var(--grayscale-30-color)",
        primaryFamily: "/".concat(pathname) === url,
        className: classnames("SUB_LINKS__ITEM__CONTENT__TEXT Header-Mobile-Compressed-SubLinks_Sublink-key_SubLinkItem bl-text-grayscale-80")
      }, text));
    }));
  }));
}

var SubLinkAutoLink = styled__default["default"].a(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  color: ", ";\n"])), function (_ref2) {
  var _ref2$primaryFamily = _ref2.primaryFamily,
      primaryFamily = _ref2$primaryFamily === void 0 ? false : _ref2$primaryFamily;
  return primaryFamily ? fontsFamiliesTypes.PRIMARY : undefined;
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsTypes.WHITE : _ref3$color;
  return color;
});

function AutoLink(_ref4) {
  var url = _ref4.url,
      text = _ref4.text,
      pathname = _ref4.pathname;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "SUB_LINKS__ITEM__CONTENT Header-Mobile-Compressed-SubLinks_Sublink-key tw-w-full tw-pb-6 last:tw-pb-0 tw-px-7 bl-text-md"
  }, /*#__PURE__*/React__default$1["default"].createElement(SubLinkAutoLink, {
    href: url,
    color: "var(--grayscale-30-color)",
    primaryFamily: "/".concat(pathname) === url,
    className: classnames("SUB_LINKS__ITEM__CONTENT__TEXT Header-Mobile-Compressed-SubLinks_Sublink-key_SubLinkItem bl-text-grayscale-80")
  }, text));
}

function LinkWithSubLinks(_ref) {
  var id = _ref.id,
      pathname = _ref.pathname,
      text = _ref.text,
      subLinks = _ref.subLinks,
      isLinkActive = _ref.isLinkActive,
      onClick = _ref.onClick;
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: classnames("LINK_SUB_LINKS tw-text-left", isLinkActive && "LINK_SUB_LINKS__ACTIVE bl-bg-primary-6 tw-py-4")
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksButton, {
    type: "button",
    className: classnames("LINK_SUB_LINKS__HEADER Header-Mobile-Compressed-LinkWithSubLinksButton focus:tw-outline-none tw-text-left bl-text-md tw-px-7 tw-flex tw-items-center", isLinkActive && "tw-mb-2"),
    onClick: onClick(id),
    onKeyPress: onClick(id)
  }, /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinksTitle, {
    color: "var(--primary-150-color)",
    className: "LINK_SUB_LINKS__HEADER__TITLE ".concat(isLinkActive && "LINK_SUB_LINKS__HEADER__TITLE_ACTIVE", " Header-Mobile-Compressed-LinkWithSubLinksTitle tw-mr-4 bl-font-secondary")
  }, text), /*#__PURE__*/React__default$1["default"].createElement(Icon, {
    size: 16,
    icon: isLinkActive ? iconTypes.ARROW_UP_1 : iconTypes.ARROW_DOWN_1,
    className: "LINK_SUB_LINKS__HEADER__ICON ".concat(isLinkActive ? "LINK_SUB_LINKS__HEADER__ICON_UP" : "LINK_SUB_LINKS__HEADER__ICON_DOWN")
  })), isLinkActive && /*#__PURE__*/React__default$1["default"].createElement(SubLinks, {
    pathname: pathname,
    subLinks: subLinks
  }));
}

var _templateObject$5;

var CustomLink = styled__default["default"](Link)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  color: ", ";\n  //font-family: ", ";\n  font-weight: 500;\n"])), function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colorsTypes.BLACK : _ref$color;
  return color;
}, fontsFamiliesTypes.SECONDARY);

function LinkNormal(_ref) {
  var menuItem = _ref.menuItem,
      pathname = _ref.pathname,
      variant = _ref.variant;

  switch (variant) {
    case linkVariantTypes.PAGE_LINKS:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink, {
        color: colorsTypes.PRIMARY_DARK,
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pageLinks,
        className: classnames("LINK_NORMAL Header-Mobile-Compressed-Link-Normal tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-px-7 bl-font-secondary", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary")
      }, menuItem.text);

    case linkVariantTypes.PDF:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink, {
        color: colorsTypes.PRIMARY_DARK,
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.pdf.url,
        className: classnames("LINK_NORMAL Header-Mobile-Compressed-Dropdown-Custom-Link-PDF tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-px-7 bl-font-secondary", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary")
      }, menuItem.text);

    case linkVariantTypes.SEARCH:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink, {
        to: "/search",
        "aria-label": "Search Button",
        className: classnames("CUSTOM_LINK HeaderMobile-LinkNormal-SEARCH tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-pl-4", "/search")
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_CONTAINER_MOBILE_SEARCH"
      }, /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM_MOBILE"
      }, "Search"), /*#__PURE__*/React__default$1["default"].createElement("div", {
        className: "CUSTOM_LINK_SEARCH_ITEM_MOBILE CUSTOM_LINK_SEARCH_ICON_MOBILE"
      }, /*#__PURE__*/React__default$1["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 16 17",
        fill: "none"
      }, /*#__PURE__*/React__default$1["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2.75C3.79086 2.75 2 4.54086 2 6.75C2 8.95914 3.79086 10.75 6 10.75C8.20914 10.75 10 8.95914 10 6.75C10 4.54086 8.20914 2.75 6 2.75ZM0 6.75C0 3.43629 2.68629 0.75 6 0.75C9.31371 0.75 12 3.43629 12 6.75C12 8.04583 11.5892 9.24572 10.8907 10.2265L15.7071 15.0429C16.0976 15.4334 16.0976 16.0666 15.7071 16.4571C15.3166 16.8476 14.6834 16.8476 14.2929 16.4571L9.47653 11.6407C8.49572 12.3392 7.29583 12.75 6 12.75C2.68629 12.75 0 10.0637 0 6.75Z",
        fill: "#05274C"
      })))));

    default:
      return /*#__PURE__*/React__default$1["default"].createElement(CustomLink, {
        color: colorsTypes.PRIMARY_DARK,
        "aria-label": "Search Button",
        popup: "".concat(menuItem.openThirdPartyPopup),
        to: menuItem.url,
        className: classnames("LINK_NORMAL Header-Mobile-Compressed-Dropdown-Custom-Link-DEFAULT tw-block lg:tw-inline-block lg:tw-mt-0 bl-text-md tw-px-7 bl-font-secondary", "/".concat(pathname) === menuItem.url && "lg:tw-pt-1 tw-border-l-2 tw-font-bold bl-border-primary")
      }, menuItem.text);
  }
}

function Dropdown(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      _ref$showBackground = _ref.showBackground,
      showBackground = _ref$showBackground === void 0 ? false : _ref$showBackground;

  var _useState = React.useState(""),
      _useState2 = _slicedToArray$1(_useState, 2),
      openedSubMenu = _useState2[0],
      setOpenedSubMenu = _useState2[1];

  function toggleSubMenu(subMenuId) {
    return function () {
      setOpenedSubMenu(subMenuId === openedSubMenu ? "" : subMenuId);
    };
  }

  return /*#__PURE__*/React__default$1["default"].createElement(DropdownsContainer, {
    showBackground: showBackground,
    className: "DROPDOWN Header-Mobile-Compressed-Dropdowns-Container bl-text-grayscale-100 tw-mt-50 tw-z-50 tw-flex tw-justify-end",
    minHeight: "".concat(window.innerHeight - HeaderHeightInPx, "px")
  }, /*#__PURE__*/React__default$1["default"].createElement(ScrollContainer, {
    className: "DROPDOWN__MENU Header-Mobile-Compressed-ScrollContainer tw-w-full lg:tw-w-80 tw-pt-5 tw-pb-10 lg:bl-bg-grayscale-6"
  }, (data.NavBarItems || []).map(function (menuItem, index) {
    var isLinkActive = menuItem.id === openedSubMenu;
    var variant = menuItem.pdf ? "pdf" : menuItem.pageLinks ? "pageLinks" : "url";
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      key: "Dropdown-menuItem-".concat(index),
      className: classnames(isLinkActive ? "DROPDOWN__MENU__ITEM Header-Mobile-Compressed-Dropdown-menuItem tw-mb-4" : "DROPDOWN__MENU__ITEM Header-Mobile-Compressed-Dropdown-menuItem tw-mb-8")
    }, menuItem.subLinks && menuItem.subLinks.length > 0 ? /*#__PURE__*/React__default$1["default"].createElement(LinkWithSubLinks, {
      className: "DROPDOWN__MENU__ITEM__Link",
      isLinkActive: isLinkActive,
      id: menuItem.id,
      pathname: pathname,
      text: menuItem.text,
      subLinks: menuItem.subLinks,
      url: menuItem.url,
      onClick: toggleSubMenu
    }) : /*#__PURE__*/React__default$1["default"].createElement(LinkNormal, {
      className: "DROPDOWN__MENU__ITEM__Link",
      menuItem: menuItem,
      pathname: pathname,
      variant: variant
    }));
  }), /*#__PURE__*/React__default$1["default"].createElement(LinkNormal, {
    className: "DROPDOWN_CONTAINER__MENU__ITEM LINK_NORMAL_SEARCH",
    menuItem: "",
    pathname: "/search",
    variant: linkVariantTypes.SEARCH
  })));
}

var _templateObject$4;

var CustomButton = styled__default["default"](Button$2)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  border-color: ", ";\n\n  color: ", ";\n\n  &:hover {\n    background: ", ";\n\n    border-color: ", ";\n\n    color: ", ";\n  }\n"])), function (_ref) {
  var background = _ref.background,
      _ref$scrollBackground = _ref.scrollBackground,
      scrollBackground = _ref$scrollBackground === void 0 ? colorsTypes.WHITE : _ref$scrollBackground,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$isScrollChangeCo = _ref.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref$isScrollChangeCo === void 0 ? false : _ref$isScrollChangeCo,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp;

  if (forceShow) {
    if (!!_float && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
      return scrollBackground;
    }

    return background;
  }

  if (!!_float && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
    return scrollBackground;
  }

  if (transparent) return transparentBackground;
  return background;
}, function (_ref2) {
  var borderColor = _ref2.borderColor,
      _ref2$scrollBorderCol = _ref2.scrollBorderColor,
      scrollBorderColor = _ref2$scrollBorderCol === void 0 ? colorsTypes.WHITE : _ref2$scrollBorderCol,
      _ref2$float = _ref2["float"],
      _float2 = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$transparentBord = _ref2.transparentBorderColor,
      transparentBorderColor = _ref2$transparentBord === void 0 ? colorsTypes.PRIMARY_DARK : _ref2$transparentBord,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$isScrollChangeC = _ref2.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref2$isScrollChangeC === void 0 ? false : _ref2$isScrollChangeC,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$borderColorBrea = _ref2.borderColorBreakpoint,
      borderColorBreakpoint = _ref2$borderColorBrea === void 0 ? 20 : _ref2$borderColorBrea;

  if (forceShow) return borderColor;

  if (!!_float2 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
    return scrollBorderColor;
  }

  if (transparent) return transparentBorderColor;
  return borderColor;
}, function (_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? colorsTypes.PRIMARY_DARK : _ref3$color,
      _ref3$scrollColor = _ref3.scrollColor,
      scrollColor = _ref3$scrollColor === void 0 ? colorsTypes.WHITE : _ref3$scrollColor,
      _ref3$float = _ref3["float"],
      _float3 = _ref3$float === void 0 ? false : _ref3$float,
      _ref3$isScrollChangeC = _ref3.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref3$isScrollChangeC === void 0 ? false : _ref3$isScrollChangeC,
      _ref3$scrollY = _ref3.scrollY,
      scrollY = _ref3$scrollY === void 0 ? 0 : _ref3$scrollY,
      _ref3$backgroundBreak = _ref3.backgroundBreakpoint,
      backgroundBreakpoint = _ref3$backgroundBreak === void 0 ? 20 : _ref3$backgroundBreak;

  if (!!_float3 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
    return scrollColor;
  }

  return color;
}, function (_ref4) {
  var _ref4$hoverBackground = _ref4.hoverBackground,
      hoverBackground = _ref4$hoverBackground === void 0 ? colorsTypes.PRIMARY_DARK : _ref4$hoverBackground,
      _ref4$hoverScrollBack = _ref4.hoverScrollBackground,
      hoverScrollBackground = _ref4$hoverScrollBack === void 0 ? colorsTypes.WHITE : _ref4$hoverScrollBack,
      _ref4$float = _ref4["float"],
      _float4 = _ref4$float === void 0 ? false : _ref4$float,
      _ref4$hoverTransparen = _ref4.hoverTransparentBackground,
      hoverTransparentBackground = _ref4$hoverTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref4$hoverTransparen,
      _ref4$transparent = _ref4.transparent,
      transparent = _ref4$transparent === void 0 ? false : _ref4$transparent,
      _ref4$forceShow = _ref4.forceShow,
      forceShow = _ref4$forceShow === void 0 ? false : _ref4$forceShow,
      _ref4$isScrollChangeC = _ref4.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref4$isScrollChangeC === void 0 ? false : _ref4$isScrollChangeC,
      _ref4$scrollY = _ref4.scrollY,
      scrollY = _ref4$scrollY === void 0 ? 0 : _ref4$scrollY,
      _ref4$backgroundBreak = _ref4.backgroundBreakpoint,
      backgroundBreakpoint = _ref4$backgroundBreak === void 0 ? 20 : _ref4$backgroundBreak;

  if (forceShow) {
    if (!!_float4 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
      return hoverScrollBackground;
    }

    return hoverBackground;
  }

  if (!!_float4 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton) {
    return hoverScrollBackground;
  }

  if (transparent) return hoverTransparentBackground;
  return hoverBackground;
}, function (_ref5) {
  var hoverBorderColor = _ref5.hoverBorderColor,
      _ref5$hoverScrollBord = _ref5.hoverScrollBorderColor,
      hoverScrollBorderColor = _ref5$hoverScrollBord === void 0 ? colorsTypes.WHITE : _ref5$hoverScrollBord,
      _ref5$float = _ref5["float"],
      _float5 = _ref5$float === void 0 ? false : _ref5$float,
      _ref5$hoverTransparen = _ref5.hoverTransparentBorderColor,
      hoverTransparentBorderColor = _ref5$hoverTransparen === void 0 ? colorsTypes.PRIMARY_DARK : _ref5$hoverTransparen,
      _ref5$transparent = _ref5.transparent,
      transparent = _ref5$transparent === void 0 ? false : _ref5$transparent,
      _ref5$forceShow = _ref5.forceShow,
      forceShow = _ref5$forceShow === void 0 ? false : _ref5$forceShow,
      _ref5$isScrollChangeC = _ref5.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref5$isScrollChangeC === void 0 ? false : _ref5$isScrollChangeC,
      _ref5$scrollY = _ref5.scrollY,
      scrollY = _ref5$scrollY === void 0 ? 0 : _ref5$scrollY,
      _ref5$borderColorBrea = _ref5.borderColorBreakpoint,
      borderColorBreakpoint = _ref5$borderColorBrea === void 0 ? 20 : _ref5$borderColorBrea;

  if (forceShow) {
    if (!!_float5 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
      return hoverScrollBorderColor;
    }

    return hoverBorderColor;
  }

  if (!!_float5 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
    return hoverScrollBorderColor;
  }

  if (transparent) return hoverTransparentBorderColor;
  return hoverBorderColor;
}, function (_ref6) {
  var _ref6$hoverScrollColo = _ref6.hoverScrollColor,
      hoverScrollColor = _ref6$hoverScrollColo === void 0 ? colorsTypes.PRIMARY_DARK : _ref6$hoverScrollColo,
      _ref6$hoverColor = _ref6.hoverColor,
      hoverColor = _ref6$hoverColor === void 0 ? colorsTypes.WHITE : _ref6$hoverColor,
      _ref6$float = _ref6["float"],
      _float6 = _ref6$float === void 0 ? false : _ref6$float,
      _ref6$borderColorBrea = _ref6.borderColorBreakpoint,
      borderColorBreakpoint = _ref6$borderColorBrea === void 0 ? false : _ref6$borderColorBrea,
      _ref6$scrollY = _ref6.scrollY,
      scrollY = _ref6$scrollY === void 0 ? 0 : _ref6$scrollY,
      _ref6$isScrollChangeC = _ref6.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref6$isScrollChangeC === void 0 ? 20 : _ref6$isScrollChangeC;

  if (!!_float6 && scrollY >= borderColorBreakpoint && isScrollChangeColorButton) {
    return hoverScrollColor;
  }

  return hoverColor;
});

var _templateObject$3;

var CustomIcon = styled__default["default"](Icon)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  filter: ", ";\n\n  @media all and (max-width: ", "px) {\n    filter: ", ";\n  }\n"])), function (_ref) {
  var _ref$isScrollChangeCo = _ref.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref$isScrollChangeCo === void 0 ? false : _ref$isScrollChangeCo,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$menuActive = _ref.menuActive,
      menuActive = _ref$menuActive === void 0 ? false : _ref$menuActive,
      _ref$noFilter = _ref.noFilter,
      noFilter = _ref$noFilter === void 0 ? false : _ref$noFilter,
      _ref$forceFilter = _ref.forceFilter,
      forceFilter = _ref$forceFilter === void 0 ? false : _ref$forceFilter,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$filterEffect = _ref.filterEffect,
      filterEffect = _ref$filterEffect === void 0 ? [] : _ref$filterEffect,
      _ref$filterEffectAfte = _ref.filterEffectAfterScroll,
      filterEffectAfterScroll = _ref$filterEffectAfte === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$filterEffectAfte,
      _ref$activeFilterEffe = _ref.activeFilterEffectAfterScroll,
      activeFilterEffectAfterScroll = _ref$activeFilterEffe === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$activeFilterEffe;

  if (noFilter) return "none";

  if (!!_float && scrollY >= backgroundBreakpoint && isScrollChangeColorButton || forceFilter || menuActive) {
    if (menuActive) return activeFilterEffectAfterScroll.join(" ");
    return filterEffectAfterScroll.join(" ");
  }

  return filterEffect.join(" ");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (_ref3) {
  var _ref3$isScrollChangeC = _ref3.isScrollChangeColorButton,
      isScrollChangeColorButton = _ref3$isScrollChangeC === void 0 ? false : _ref3$isScrollChangeC,
      _ref3$float = _ref3["float"],
      _float2 = _ref3$float === void 0 ? false : _ref3$float,
      _ref3$menuActive = _ref3.menuActive,
      menuActive = _ref3$menuActive === void 0 ? false : _ref3$menuActive,
      _ref3$noFilter = _ref3.noFilter,
      noFilter = _ref3$noFilter === void 0 ? false : _ref3$noFilter,
      _ref3$forceFilter = _ref3.forceFilter,
      forceFilter = _ref3$forceFilter === void 0 ? false : _ref3$forceFilter,
      _ref3$scrollY = _ref3.scrollY,
      scrollY = _ref3$scrollY === void 0 ? 0 : _ref3$scrollY,
      _ref3$backgroundBreak = _ref3.backgroundBreakpoint,
      backgroundBreakpoint = _ref3$backgroundBreak === void 0 ? 20 : _ref3$backgroundBreak,
      _ref3$mobileFilterEff = _ref3.mobileFilterEffect,
      mobileFilterEffect = _ref3$mobileFilterEff === void 0 ? [] : _ref3$mobileFilterEff,
      _ref3$mobileFilterEff2 = _ref3.mobileFilterEffectAfterScroll,
      mobileFilterEffectAfterScroll = _ref3$mobileFilterEff2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref3$mobileFilterEff2,
      _ref3$mobileActiveFil = _ref3.mobileActiveFilterEffectAfterScroll,
      mobileActiveFilterEffectAfterScroll = _ref3$mobileActiveFil === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref3$mobileActiveFil;

  if (noFilter) return "none";

  if (!!_float2 && scrollY >= backgroundBreakpoint && isScrollChangeColorButton || forceFilter || menuActive) {
    if (menuActive) return mobileActiveFilterEffectAfterScroll.join(" ");
    return mobileFilterEffectAfterScroll.join(" ");
  }

  return mobileFilterEffect.join(" ");
});

function HeaderMobileCompressed(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      className = _ref.className,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$activeLogoReplac = _ref.activeLogoReplaceImageWith,
      activeLogoReplaceImageWith = _ref$activeLogoReplac === void 0 ? "" : _ref$activeLogoReplac,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.WHITE : _ref$background,
      _ref$activeBackground = _ref.activeBackground,
      activeBackground = _ref$activeBackground === void 0 ? colorsTypes.WHITE : _ref$activeBackground,
      _ref$hoverActiveBackg = _ref.hoverActiveBackground,
      hoverActiveBackground = _ref$hoverActiveBackg === void 0 ? colorsTypes.WHITE : _ref$hoverActiveBackg,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpoint,
      backgroundAfterBreakpoint = _ref$backgroundAfterB === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$hoverFloatBackgr = _ref.hoverFloatBackground,
      hoverFloatBackground = _ref$hoverFloatBackgr === void 0 ? colorsTypes.WHITE : _ref$hoverFloatBackgr,
      _ref$backgroundAfterB2 = _ref.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref$backgroundAfterB2 === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB2,
      _ref$hoverTransparent = _ref.hoverTransparentBackground,
      hoverTransparentBackground = _ref$hoverTransparent === void 0 ? colorsTypes.TRANSPARENT : _ref$hoverTransparent,
      _ref$mobileActiveLogo = _ref.mobileActiveLogoReplaceImageWith,
      mobileActiveLogoReplaceImageWith = _ref$mobileActiveLogo === void 0 ? "" : _ref$mobileActiveLogo,
      _ref$mobileActiveLogo2 = _ref.mobileActiveLogoReplaceImageWithAfterBreakpoint,
      mobileActiveLogoReplaceImageWithAfterBreakpoint = _ref$mobileActiveLogo2 === void 0 ? "" : _ref$mobileActiveLogo2,
      _ref$mobileForceShow = _ref.mobileForceShow,
      mobileForceShow = _ref$mobileForceShow === void 0 ? false : _ref$mobileForceShow,
      _ref$mobileTransparen = _ref.mobileTransparent,
      mobileTransparent = _ref$mobileTransparen === void 0 ? false : _ref$mobileTransparen,
      _ref$mobileNoFilterLo = _ref.mobileNoFilterLogo,
      mobileNoFilterLogo = _ref$mobileNoFilterLo === void 0 ? false : _ref$mobileNoFilterLo,
      _ref$mobileNoFilterMe = _ref.mobileNoFilterMenuIcon,
      mobileNoFilterMenuIcon = _ref$mobileNoFilterMe === void 0 ? false : _ref$mobileNoFilterMe,
      _ref$mobileForceFilte = _ref.mobileForceFilterMenuIcon,
      mobileForceFilterMenuIcon = _ref$mobileForceFilte === void 0 ? false : _ref$mobileForceFilte,
      _ref$mobileLoginButto = _ref.mobileLoginButtonIsScrollChangeColorButton,
      mobileLoginButtonIsScrollChangeColorButton = _ref$mobileLoginButto === void 0 ? false : _ref$mobileLoginButto,
      _ref$mobileLogoReplac = _ref.mobileLogoReplaceImageWith,
      mobileLogoReplaceImageWith = _ref$mobileLogoReplac === void 0 ? undefined : _ref$mobileLogoReplac,
      _ref$mobileLogoReplac2 = _ref.mobileLogoReplaceImageWithAfterBreakpoint,
      mobileLogoReplaceImageWithAfterBreakpoint = _ref$mobileLogoReplac2 === void 0 ? undefined : _ref$mobileLogoReplac2,
      _ref$mobileLogoFilter = _ref.mobileLogoFilter,
      mobileLogoFilter = _ref$mobileLogoFilter === void 0 ? undefined : _ref$mobileLogoFilter,
      _ref$mobileLogoFilter2 = _ref.mobileLogoFilterEffectAfterScroll,
      mobileLogoFilterEffectAfterScroll = _ref$mobileLogoFilter2 === void 0 ? [] : _ref$mobileLogoFilter2,
      _ref$mobileFilterEffe = _ref.mobileFilterEffectAfterScroll,
      mobileFilterEffectAfterScroll = _ref$mobileFilterEffe === void 0 ? [] : _ref$mobileFilterEffe,
      _ref$mobileLogoFilter3 = _ref.mobileLogoFilterEffect,
      mobileLogoFilterEffect = _ref$mobileLogoFilter3 === void 0 ? [] : _ref$mobileLogoFilter3,
      _ref$mobileActiveLogo3 = _ref.mobileActiveLogoFilterEffectAfterScroll,
      mobileActiveLogoFilterEffectAfterScroll = _ref$mobileActiveLogo3 === void 0 ? [] : _ref$mobileActiveLogo3,
      _ref$mobileMenuIconFi = _ref.mobileMenuIconFilterEffect,
      mobileMenuIconFilterEffect = _ref$mobileMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi,
      _ref$mobileMenuIconFi2 = _ref.mobileMenuIconFilterEffectAfterScroll,
      mobileMenuIconFilterEffectAfterScroll = _ref$mobileMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi2,
      _ref$mobileMenuIconAc = _ref.mobileMenuIconActiveFilterEffectAfterScroll,
      mobileMenuIconActiveFilterEffectAfterScroll = _ref$mobileMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconAc,
      _ref$menuIconFilterEf = _ref.menuIconFilterEffect,
      menuIconFilterEffect = _ref$menuIconFilterEf === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf,
      _ref$menuIconFilterEf2 = _ref.menuIconFilterEffectAfterScroll,
      menuIconFilterEffectAfterScroll = _ref$menuIconFilterEf2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf2,
      _ref$menuIconActiveFi = _ref.menuIconActiveFilterEffectAfterScroll,
      menuIconActiveFilterEffectAfterScroll = _ref$menuIconActiveFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconActiveFi,
      _ref$mobileActiveLogo4 = _ref.mobileActiveLogoFilterEffect,
      mobileActiveLogoFilterEffect = _ref$mobileActiveLogo4 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileActiveLogo4,
      _ref$mobileLoginButto2 = _ref.mobileLoginButtonStyles,
      mobileLoginButtonStyles = _ref$mobileLoginButto2 === void 0 ? {} : _ref$mobileLoginButto2,
      _ref$mobileMenuIconSt = _ref.mobileMenuIconStyles,
      mobileMenuIconStyles = _ref$mobileMenuIconSt === void 0 ? {} : _ref$mobileMenuIconSt,
      _ref$mobileBackground = _ref.mobileBackgroundMenu,
      mobileBackgroundMenu = _ref$mobileBackground === void 0 ? colorsTypes.WHITE : _ref$mobileBackground,
      _ref$mobileLoginButto3 = _ref.mobileLoginButtonScrollBackgroundAfterScroll,
      mobileLoginButtonScrollBackgroundAfterScroll = _ref$mobileLoginButto3 === void 0 ? colorsTypes.PRIMARY_DARK : _ref$mobileLoginButto3,
      _ref$mobileLoginButto4 = _ref.mobileLoginButtonScrollBackground,
      mobileLoginButtonScrollBackground = _ref$mobileLoginButto4 === void 0 ? colorsTypes.WHITE : _ref$mobileLoginButto4,
      _ref$mobileBackground2 = _ref.mobileBackground,
      mobileBackground = _ref$mobileBackground2 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground2,
      _ref$mobileBackground3 = _ref.mobileBackgroundAfterBreakpoint,
      mobileBackgroundAfterBreakpoint = _ref$mobileBackground3 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground3,
      _ref$mobileActiveBack = _ref.mobileActiveBackground,
      mobileActiveBackground = _ref$mobileActiveBack === void 0 ? colorsTypes.WHITE : _ref$mobileActiveBack,
      _ref$mobileTransparen2 = _ref.mobileTransparentBackground,
      mobileTransparentBackground = _ref$mobileTransparen2 === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileTransparen2,
      _ref$mobileHoverBackg = _ref.mobileHoverBackground,
      mobileHoverBackground = _ref$mobileHoverBackg === void 0 ? colorsTypes.WHITE : _ref$mobileHoverBackg,
      _ref$mobileHoverFloat = _ref.mobileHoverFloatBackground,
      mobileHoverFloatBackground = _ref$mobileHoverFloat === void 0 ? colorsTypes.WHITE : _ref$mobileHoverFloat,
      _ref$mobileHoverActiv = _ref.mobileHoverActiveBackground,
      mobileHoverActiveBackground = _ref$mobileHoverActiv === void 0 ? colorsTypes.WHITE : _ref$mobileHoverActiv,
      _ref$mobileBackground4 = _ref.mobileBackgroundAfterBreakpointHover,
      mobileBackgroundAfterBreakpointHover = _ref$mobileBackground4 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground4,
      _ref$mobileHoverTrans = _ref.mobileHoverTransparentBackground,
      mobileHoverTransparentBackground = _ref$mobileHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileHoverTrans,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      menuActive = _useState2[0],
      setMenuActive = _useState2[1];

  React.useEffect(function () {
    screenOverflowHidden(menuActive);
  }, [menuActive]);
  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    activeLogoReplaceImageWith: activeLogoReplaceImageWith,
    mobileActiveLogoReplaceImageWith: mobileActiveLogoReplaceImageWith,
    mobileLogoFilterEffectAfterScroll: mobileLogoFilterEffectAfterScroll,
    mobileActiveLogoFilterEffectAfterScroll: mobileActiveLogoFilterEffectAfterScroll,
    mobileActiveLogoReplaceImageWithAfterBreakpoint: mobileActiveLogoReplaceImageWithAfterBreakpoint,
    activeLogoFilterEffect: mobileActiveLogoFilterEffect,
    mobileFilterEffectAfterScroll: mobileFilterEffectAfterScroll,
    mobileLogoReplaceImageWith: mobileLogoReplaceImageWith,
    mobileLogoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    mobileNoFilterLogo: mobileNoFilterLogo,
    mobileLogoFilterEffect: mobileLogoFilterEffect,
    logoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    logoReplaceImageWith: mobileLogoReplaceImageWith,
    activeBackground: activeBackground,
    mobileActiveBackground: mobileActiveBackground,
    hoverActiveBackground: hoverActiveBackground,
    mobileHoverActiveBackground: mobileHoverActiveBackground,
    noFilterLogo: mobileNoFilterLogo,
    filter: mobileLogoFilter,
    background: background,
    mobileBackground: mobileBackground,
    mobileHoverBackground: mobileHoverBackground,
    hoverFloatBackground: hoverFloatBackground,
    mobileHoverFloatBackground: mobileHoverFloatBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    mobileBackgroundAfterBreakpointHover: mobileBackgroundAfterBreakpointHover,
    hoverTransparentBackground: hoverTransparentBackground,
    mobileHoverTransparentBackground: mobileHoverTransparentBackground,
    backgroundAfterBreakpoint: backgroundAfterBreakpoint,
    mobileBackgroundAfterBreakpoint: mobileBackgroundAfterBreakpoint,
    transparentBackground: transparentBackground,
    mobileTransparentBackground: mobileTransparentBackground,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    menuActive: menuActive,
    transparent: mobileTransparent || !menuActive,
    forceShow: mobileForceShow || menuActive,
    isDynamic: isDynamic,
    className: classnames("HEADER_MOBILE_COMPRESSED Header-Dynamic-Container lg:tw-pb-16 tw-fixed lg:tw-absolute tw-z-50 tw-w-full tw-font-normal tw-h-full", menuActive ? "HEADER_MOBILE_COMPRESSED_ACTIVE tw-min-h-screen tw-overflow-y-scroll lg:tw-overflow-y-auto" : "", className, scrollY > backgroundBreakpoint ? "HEADER_MOBILE_SCROLLED " : "HEADER_MOBILE_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_COMPRESSED_DINAMIC_PAGE" : "HEADER_MOBILE_COMPRESSED_NO_DINAMIC_PAGE"),
    style: HeaderHeight
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    className: "HEADER_TOAST",
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement("nav", {
    className: classnames("HEADER_MOBILE_COMPRESSED__CONTAINER Header-Dynamic-Container-Nav tw-z-50 lg:tw-h-full", !menuActive && "tw-h-full")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT Header-Dynamic-Container-Container tw-h-full lg:tw-h-auto tw-px-6"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX Header-Dynamic-Container-Container tw-w-full tw-flex tw-justify-between tw-items-center",
    style: HeaderHeight
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__LOGO Header-Dynamic-Container_Link tw-mr-6 tw-py-4",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: classnames("HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__LOGO__IMAGE Header__logo tw-w-40 tw-my-3", scrollY > backgroundBreakpoint ? "HEADER_MOBILE_COMPRESSED__LOGO_SCROLLED " : "HEADER_MOBILE_COMPRESSED__LOGO_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_COMPRESSED__LOGO_DINAMIC_PAGE" : "HEADER_MOBILE_COMPRESSED__LOGO__NO_DINAMIC_PAGE"),
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__MENU Header-Dynamic-Container-Container-Container tw-float-right tw-flex tw-items-center tw-py-2 tw-rounded"
  }, process.env.GATSBY_CU_NAME === "leather_stocking" && data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton, _extends$g({
    isScrollChangeColorButton: mobileLoginButtonIsScrollChangeColorButton,
    scrollBackground: mobileLoginButtonScrollBackground,
    scrollBackgroundAfterScroll: mobileLoginButtonScrollBackgroundAfterScroll,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    fill: buttonFillTypes.FILLED,
    className: classnames("DEFAULT_HEADER_MOBILE_COMPRESSED HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__MENU__TITLE Header-Dynamic-Container_CustomButton tw-mr-3", menuActive ? "tw-hidden lg:tw-block HEADER_MOBILE_COMPRESS_BUTTON_ACTIVE" : "tw-block", scrollY > backgroundBreakpoint ? " HEADER_MOBILE_BUTTON_SCROLLED " : "NO_SCROLLED", isDynamic ? "HEADER_MOBILE_COMPRESSED_DINAMIC_PAGE_LOGIN_BUTTON SECOND" : "HEADER_MOBILE_COMPRESSED_NO_DINAMIC_PAGE_LOGIN_BUTTON SECOND"),
    href: "https://www.mobicint.net/lth/loanapp/list",
    isAuxHref: false
  }, mobileLoginButtonStyles), "Apply For A Loan"), data && data.loginButtonText && /*#__PURE__*/React__default$1["default"].createElement(CustomButton, _extends$g({
    isScrollChangeColorButton: mobileLoginButtonIsScrollChangeColorButton,
    scrollBackground: mobileLoginButtonScrollBackground,
    scrollBackgroundAfterScroll: mobileLoginButtonScrollBackgroundAfterScroll,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    fill: buttonFillTypes.FILLED,
    className: classnames("DEFAULT_HEADER_MOBILE_COMPRESSED HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__MENU__TITLE Header-Dynamic-Container_CustomButton tw-mr-3", menuActive ? "tw-hidden lg:tw-block HEADER_MOBILE_COMPRESS_BUTTON_ACTIVE" : "tw-block", scrollY > backgroundBreakpoint ? " HEADER_MOBILE_BUTTON_SCROLLED " : "NO_SCROLLED", isDynamic ? "HEADER_MOBILE_COMPRESSED_DINAMIC_PAGE_LOGIN_BUTTON" : "HEADER_MOBILE_COMPRESSED_NO_DINAMIC_PAGE_LOGIN_BUTTON"),
    onClick: function onClick() {
      if ((loginButtonStyles === null || loginButtonStyles === void 0 ? void 0 : loginButtonStyles.variant) !== "NO_MODAL") {
        showModal();
        setMenuActive(false);
      }
    }
  }, mobileLoginButtonStyles), data.loginButtonText), data && /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__MENU__ICON_BOX Header-Dynamic-Container_Button tw-float-right tw-flex tw-items-center tw-px-3 tw-py-2 hover:bl-border-grayscale-0 ",
    onClick: function onClick() {
      setMenuActive(function (current) {
        return !current;
      });
    }
  }, menuActive ? /*#__PURE__*/React__default$1["default"].createElement(Icon, _extends$g({
    className: classnames("HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__MENU__ICON_BOX__ICON ", scrollY > backgroundBreakpoint ? " HEADER_MOBILE_ICON_SCROLLED " : "HEADER_MOBILE_ICON_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_ICON_NO_SCROLLED_DINAMIC_PAGE" : "HEADER_MOBILE_ICON_NO_SCROLLED_NO_DINAMIC_PAGE"),
    menuActive: menuActive,
    icon: iconTypes.REMOVE,
    isScrollChangeColorButton: mobileLoginButtonStyles === null || mobileLoginButtonStyles === void 0 ? void 0 : mobileLoginButtonStyles.isScrollChangeColorButton,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    noFilter: mobileNoFilterMenuIcon,
    forceFilter: mobileForceFilterMenuIcon,
    filterEffect: menuIconFilterEffect,
    filterEffectAfterScroll: menuIconFilterEffectAfterScroll,
    activeFilterEffectAfterScroll: menuIconActiveFilterEffectAfterScroll,
    mobileFilterEffect: mobileMenuIconFilterEffect,
    mobileFilterEffectAfterScroll: mobileMenuIconFilterEffectAfterScroll,
    mobileActiveFilterEffectAfterScroll: mobileMenuIconActiveFilterEffectAfterScroll
  }, mobileMenuIconStyles)) : /*#__PURE__*/React__default$1["default"].createElement(CustomIcon, _extends$g({
    className: classnames("HEADER_MOBILE_COMPRESSED__CONTAINER__CONTENT__BOX__MENU__ICON_BOX__ICON CUSTOM_HEADER_MOBILE_ICON", scrollY > backgroundBreakpoint ? " HEADER_MOBILE_CUSTOMICON_SCROLLED " : "HEADER_MOBILE_CUSTOMICON_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_ICON_DINAMIC_PAGE" : "HEADER_MOBILE_ICON_NO_DINAMIC_PAGE"),
    menuActive: menuActive,
    isScrollChangeColorButton: mobileLoginButtonStyles === null || mobileLoginButtonStyles === void 0 ? void 0 : mobileLoginButtonStyles.isScrollChangeColorButton,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    forceShow: mobileForceShow || menuActive,
    icon: iconTypes.NAVIGATION_MENU,
    noFilter: mobileNoFilterMenuIcon,
    forceFilter: mobileForceFilterMenuIcon,
    filterEffect: menuIconFilterEffect,
    filterEffectAfterScroll: menuIconFilterEffectAfterScroll,
    activeFilterEffectAfterScroll: menuIconActiveFilterEffectAfterScroll,
    mobileFilterEffect: mobileMenuIconFilterEffect,
    mobileFilterEffectAfterScroll: mobileMenuIconFilterEffectAfterScroll,
    mobileActiveFilterEffectAfterScroll: mobileMenuIconActiveFilterEffectAfterScroll
  }, mobileMenuIconStyles)))))), menuActive && data && /*#__PURE__*/React__default$1["default"].createElement(Dropdown, {
    background: mobileBackgroundMenu,
    showBackground: _float,
    data: data,
    pathname: pathname,
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__DROPDOWN"
  }), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    className: "HEADER_MOBILE_COMPRESSED__CONTAINER__MODAL",
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login, _extends$g({
    className: "HEADER_MOBILE_COMPRESS_LOGIN",
    variant: mobileLoginButtonStyles.variant
  }, loginButtonStyles)))));
}

var _templateObject$2, _templateObject2$1, _templateObject3$1;

var BannerContainer$1 = styled__default["default"].div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 250px;\n"])));
var BannerLogoSection$1 = styled__default["default"].div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  background: url(\"/images/banner.svg\"),\n    linear-gradient(90deg, var(--primary-color) 40%, var(--primary-80-color) 100%);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position-y: 20%;\n  min-height: 150px;\n  display: flex;\n  align-items: center;\n  padding: 15px 40px;\n"])));
var NavSection$1 = styled__default["default"].div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  padding: 20px 50px;\n"])));

function HeaderBannerContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default$1["default"].createElement(BannerContainer$1, null, /*#__PURE__*/React__default$1["default"].createElement(BannerLogoSection$1, null, /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopLogoContainer$1, {
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION__LOGO tw-flex-1 tw-flex tw-justify-center tw-items-center HeaderDesktop-HeaderDynamicContainer_Link tw-h-full tw-mr-10",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION__LOGO__IMAGE HeaderDesktop-HeaderDynamicContainer_Logo Header__logo",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  }))), /*#__PURE__*/React__default$1["default"].createElement(NavSection$1, null, children));
}

var _templateObject$1;

var NavigationContainer = styled__default["default"].div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  max-width: ", ";\n"])), function (_ref) {
  var _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "none" : _ref$maxWidth;
  return maxWidth;
});

function Banner(_ref2) {
  var _data$CreditUnion;

  var data = _ref2.data,
      pathname = _ref2.pathname,
      className = _ref2.className,
      _ref2$hoverBackground = _ref2.hoverBackground,
      hoverBackground = _ref2$hoverBackground === void 0 ? colorsTypes.WHITE : _ref2$hoverBackground,
      _ref2$backgroundAfter = _ref2.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref2$backgroundAfter === void 0 ? colorsTypes.WHITE : _ref2$backgroundAfter,
      _ref2$forceShowHover = _ref2.forceShowHover,
      forceShowHover = _ref2$forceShowHover === void 0 ? false : _ref2$forceShowHover,
      _ref2$transparent = _ref2.transparent,
      transparent = _ref2$transparent === void 0 ? false : _ref2$transparent,
      _ref2$isTopBorder = _ref2.isTopBorder,
      isTopBorder = _ref2$isTopBorder === void 0 ? false : _ref2$isTopBorder,
      _ref2$forceShow = _ref2.forceShow,
      forceShow = _ref2$forceShow === void 0 ? false : _ref2$forceShow,
      _ref2$forceShowItems = _ref2.forceShowItems,
      forceShowItems = _ref2$forceShowItems === void 0 ? true : _ref2$forceShowItems,
      _ref2$forceShowColor = _ref2.forceShowColor,
      forceShowColor = _ref2$forceShowColor === void 0 ? false : _ref2$forceShowColor,
      _ref2$float = _ref2["float"],
      _float = _ref2$float === void 0 ? false : _ref2$float,
      _ref2$grayscale = _ref2.grayscale,
      grayscale = _ref2$grayscale === void 0 ? false : _ref2$grayscale,
      _ref2$dark = _ref2.dark,
      dark = _ref2$dark === void 0 ? false : _ref2$dark,
      _ref2$backgroundScree = _ref2.backgroundScreenActive,
      backgroundScreenActive = _ref2$backgroundScree === void 0 ? false : _ref2$backgroundScree,
      _ref2$noFilterLogo = _ref2.noFilterLogo,
      noFilterLogo = _ref2$noFilterLogo === void 0 ? false : _ref2$noFilterLogo,
      _ref2$menuSubItemDisa = _ref2.menuSubItemDisableBorder,
      menuSubItemDisableBorder = _ref2$menuSubItemDisa === void 0 ? false : _ref2$menuSubItemDisa,
      _ref2$topIndicator = _ref2.topIndicator,
      topIndicator = _ref2$topIndicator === void 0 ? true : _ref2$topIndicator,
      _ref2$scrollY = _ref2.scrollY,
      scrollY = _ref2$scrollY === void 0 ? 0 : _ref2$scrollY,
      _ref2$backgroundBreak = _ref2.backgroundBreakpoint,
      backgroundBreakpoint = _ref2$backgroundBreak === void 0 ? 20 : _ref2$backgroundBreak,
      _ref2$logoFilterEffec = _ref2.logoFilterEffect,
      logoFilterEffect = _ref2$logoFilterEffec === void 0 ? [] : _ref2$logoFilterEffec,
      _ref2$navigationOptio = _ref2.navigationOptions,
      navigationOptions = _ref2$navigationOptio === void 0 ? {
    maxWidth: "var(--breakpoints-xl)"
  } : _ref2$navigationOptio,
      _ref2$navigationMenuO = _ref2.navigationMenuOptions,
      navigationMenuOptions = _ref2$navigationMenuO === void 0 ? {
    menuActiveBorderColor: colorsTypes.PRIMARY,
    menuHoverBorderColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubLinksTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubItemTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subMenuBackgroundColor: colorsTypes.TRANSPARENT,
    subMenuActiveBackgroundColor: colorsTypes.TRANSPARENT,
    itemBackgroundColor: colorsTypes.WHITE,
    dropdownHoverBackground: colorsVariantsTypes.HIGHT_LIGHT_PRIMARY,
    dropdownSeparationFromTop: 20,
    dropdownSeparationFromBottom: 50
  } : _ref2$navigationMenuO,
      _ref2$loginButtonStyl = _ref2.loginButtonStyles,
      loginButtonStyles = _ref2$loginButtonStyl === void 0 ? {} : _ref2$loginButtonStyl,
      _ref2$isDynamic = _ref2.isDynamic,
      isDynamic = _ref2$isDynamic === void 0 ? false : _ref2$isDynamic;

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    noFilterLogo: noFilterLogo,
    logoFilterEffect: logoFilterEffect,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShow,
    hoverBackground: hoverBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    forceShowHover: forceShowHover,
    className: classnames("HEADER_DESKTOP_DEFAULT HeaderDesktop-HeaderDynamicContainer bl-bg-grayscale-0 tw-z-50 tw-relative tw-font-normal tw-flex tw-flex-wrap", scrollY > backgroundBreakpoint ? "HEADER_DESKTOP_DEFAULT_SCROLLED " : "HEADER_DESKTOP_DEFAULT_NO_SCROLLED", isDynamic ? "HEADER_DESKTOP_DEFAULT_DINAMIC_PAGE" : "HEADER_DESKTOP_DEFAULT_NO_DINAMIC_PAGE", className)
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement(NavigationContainer, _extends$g({
    className: "HEADER_DESKTOP_DEFAULT__NAVIGATION HeaderDesktop-HeaderDynamicContainer-NavigatorContainer tw-w-full tw-mx-auto tw-flex tw-justify-between tw-items-center"
  }, navigationOptions), /*#__PURE__*/React__default$1["default"].createElement(HeaderBannerContainer, null, data && /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopNavMenu, _extends$g({
    creditUnion: data === null || data === void 0 ? void 0 : (_data$CreditUnion = data.CreditUnion) === null || _data$CreditUnion === void 0 ? void 0 : _data$CreditUnion.CREDIT_UNION,
    menuSubItemDisableBorder: menuSubItemDisableBorder,
    grayscale: grayscale,
    dark: dark,
    backgroundScreenActive: backgroundScreenActive,
    topIndicator: topIndicator,
    pathname: pathname,
    menuItems: data.NavBarItems,
    loginButtonText: data.loginButtonText,
    "float": _float,
    scrollY: scrollY,
    transparent: transparent,
    isTopBorder: isTopBorder,
    forceShow: forceShowItems,
    forceShowColor: forceShowColor,
    backgroundBreakpoint: backgroundBreakpoint,
    loginButtonStyles: loginButtonStyles
  }, navigationMenuOptions)))));
}

var _templateObject, _templateObject2, _templateObject3;

var BannerContainer = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 200px;\n"])));
var BannerLogoSection = styled__default["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: url(\"/images/banner.svg\"),\n    linear-gradient(90deg, var(--primary-color) 40%, var(--primary-80-color) 100%);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position-y: 20%;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  padding: 15px 25px;\n"])));
var NavSection = styled__default["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 15px 25px;\n  background: var(--grayscale-0-color);\n  display: flex;\n  justify-content: space-between;\n"])));

function MobileBannerContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default$1["default"].createElement(BannerContainer, {
    className: "HEADER_MOBILE_BANNER__MAIN"
  }, /*#__PURE__*/React__default$1["default"].createElement(BannerLogoSection, {
    className: "HEADER_MOBILE_BANNER__LOGO_SECTION"
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__LOGO HeaderDynamicContainer-Container-Container-Link tw-relative tw-w-40 tw-h-20",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__LOGO__IMAGE HeaderDynamicContainer-Container-Container-Logo Header__logo tw-w-40 tw-my-3",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  }))), /*#__PURE__*/React__default$1["default"].createElement(NavSection, {
    className: "HEADER_MOBILE_BANNER__NAV_SECTION"
  }, /*#__PURE__*/React__default$1["default"].createElement(Link, {
    className: "HEADER_MOBILE_BANNER_NAV_LINK_SHOW HeaderDynamicContainer-Container-Container-Link tw-relative tw-w-40 tw-h-20",
    to: "/"
  }, /*#__PURE__*/React__default$1["default"].createElement(Logo, {
    className: "HEADER_MOBILE_BANNER_NAV_LINK__IMAGE_SHOW HeaderDynamicContainer-Container-Container-Logo Header__logo tw-w-40 tw-my-3",
    src: "/images/logo.svg",
    alt: "".concat(process.env.GATSBY_CU_NAME, " Logo")
  })), /*#__PURE__*/React__default$1["default"].createElement("div", null, children)));
}

function MobileBanner(_ref) {
  var data = _ref.data,
      pathname = _ref.pathname,
      className = _ref.className,
      _ref$float = _ref["float"],
      _float = _ref$float === void 0 ? false : _ref$float,
      _ref$scrollY = _ref.scrollY,
      scrollY = _ref$scrollY === void 0 ? 0 : _ref$scrollY,
      _ref$backgroundBreakp = _ref.backgroundBreakpoint,
      backgroundBreakpoint = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$activeLogoReplac = _ref.activeLogoReplaceImageWith,
      activeLogoReplaceImageWith = _ref$activeLogoReplac === void 0 ? "" : _ref$activeLogoReplac,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? colorsTypes.WHITE : _ref$background,
      _ref$activeBackground = _ref.activeBackground,
      activeBackground = _ref$activeBackground === void 0 ? colorsTypes.WHITE : _ref$activeBackground,
      _ref$hoverActiveBackg = _ref.hoverActiveBackground,
      hoverActiveBackground = _ref$hoverActiveBackg === void 0 ? colorsTypes.WHITE : _ref$hoverActiveBackg,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpoint,
      backgroundAfterBreakpoint = _ref$backgroundAfterB === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB,
      _ref$transparentBackg = _ref.transparentBackground,
      transparentBackground = _ref$transparentBackg === void 0 ? colorsTypes.TRANSPARENT : _ref$transparentBackg,
      _ref$hoverFloatBackgr = _ref.hoverFloatBackground,
      hoverFloatBackground = _ref$hoverFloatBackgr === void 0 ? colorsTypes.WHITE : _ref$hoverFloatBackgr,
      _ref$backgroundAfterB2 = _ref.backgroundAfterBreakpointHover,
      backgroundAfterBreakpointHover = _ref$backgroundAfterB2 === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB2,
      _ref$hoverTransparent = _ref.hoverTransparentBackground,
      hoverTransparentBackground = _ref$hoverTransparent === void 0 ? colorsTypes.TRANSPARENT : _ref$hoverTransparent,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === void 0 ? false : _ref$transparent,
      _ref$forceShow = _ref.forceShow,
      forceShow = _ref$forceShow === void 0 ? false : _ref$forceShow,
      _ref$backgroundMenu = _ref.backgroundMenu,
      backgroundMenu = _ref$backgroundMenu === void 0 ? colorsTypes.WHITE : _ref$backgroundMenu,
      _ref$menuSubLinksList = _ref.menuSubLinksListBorderColor,
      menuSubLinksListBorderColor = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksList,
      _ref$menuSubLinksList2 = _ref.menuSubLinksListBackground,
      menuSubLinksListBackground = _ref$menuSubLinksList2 === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList2,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColor,
      menuSubLinksTitleColor = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksTitl,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColor,
      subLinksItemActiveTitleColor = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$menuSubLinksItem = _ref.menuSubLinksItemTitleColor,
      menuSubLinksItemTitleColor = _ref$menuSubLinksItem === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksItem,
      _ref$loginButtonStyle = _ref.loginButtonStyles,
      loginButtonStyles = _ref$loginButtonStyle === void 0 ? {} : _ref$loginButtonStyle,
      _ref$mobileActiveLogo = _ref.mobileActiveLogoReplaceImageWith,
      mobileActiveLogoReplaceImageWith = _ref$mobileActiveLogo === void 0 ? "" : _ref$mobileActiveLogo,
      _ref$mobileActiveLogo2 = _ref.mobileActiveLogoReplaceImageWithAfterBreakpoint,
      mobileActiveLogoReplaceImageWithAfterBreakpoint = _ref$mobileActiveLogo2 === void 0 ? "" : _ref$mobileActiveLogo2,
      _ref$mobileNoFilterLo = _ref.mobileNoFilterLogo,
      mobileNoFilterLogo = _ref$mobileNoFilterLo === void 0 ? false : _ref$mobileNoFilterLo,
      _ref$mobileNoFilterMe = _ref.mobileNoFilterMenuIcon,
      mobileNoFilterMenuIcon = _ref$mobileNoFilterMe === void 0 ? false : _ref$mobileNoFilterMe,
      _ref$mobileForceFilte = _ref.mobileForceFilterMenuIcon,
      mobileForceFilterMenuIcon = _ref$mobileForceFilte === void 0 ? false : _ref$mobileForceFilte,
      _ref$mobileLogoReplac = _ref.mobileLogoReplaceImageWith,
      mobileLogoReplaceImageWith = _ref$mobileLogoReplac === void 0 ? undefined : _ref$mobileLogoReplac,
      _ref$mobileLogoReplac2 = _ref.mobileLogoReplaceImageWithAfterBreakpoint,
      mobileLogoReplaceImageWithAfterBreakpoint = _ref$mobileLogoReplac2 === void 0 ? undefined : _ref$mobileLogoReplac2,
      _ref$mobileLogoFilter = _ref.mobileLogoFilter,
      mobileLogoFilter = _ref$mobileLogoFilter === void 0 ? undefined : _ref$mobileLogoFilter,
      _ref$mobileLogoFilter2 = _ref.mobileLogoFilterEffectAfterScroll,
      mobileLogoFilterEffectAfterScroll = _ref$mobileLogoFilter2 === void 0 ? [] : _ref$mobileLogoFilter2,
      _ref$mobileFilterEffe = _ref.mobileFilterEffectAfterScroll,
      mobileFilterEffectAfterScroll = _ref$mobileFilterEffe === void 0 ? [] : _ref$mobileFilterEffe,
      _ref$mobileLogoFilter3 = _ref.mobileLogoFilterEffect,
      mobileLogoFilterEffect = _ref$mobileLogoFilter3 === void 0 ? [] : _ref$mobileLogoFilter3,
      _ref$mobileActiveLogo3 = _ref.mobileActiveLogoFilterEffectAfterScroll,
      mobileActiveLogoFilterEffectAfterScroll = _ref$mobileActiveLogo3 === void 0 ? [] : _ref$mobileActiveLogo3,
      _ref$mobileMenuIconFi = _ref.mobileMenuIconFilterEffect,
      mobileMenuIconFilterEffect = _ref$mobileMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi,
      _ref$mobileMenuIconFi2 = _ref.mobileMenuIconFilterEffectAfterScroll,
      mobileMenuIconFilterEffectAfterScroll = _ref$mobileMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconFi2,
      _ref$mobileMenuIconAc = _ref.mobileMenuIconActiveFilterEffectAfterScroll,
      mobileMenuIconActiveFilterEffectAfterScroll = _ref$mobileMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileMenuIconAc,
      _ref$menuIconFilterEf = _ref.menuIconFilterEffect,
      menuIconFilterEffect = _ref$menuIconFilterEf === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf,
      _ref$menuIconFilterEf2 = _ref.menuIconFilterEffectAfterScroll,
      menuIconFilterEffectAfterScroll = _ref$menuIconFilterEf2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconFilterEf2,
      _ref$menuIconActiveFi = _ref.menuIconActiveFilterEffectAfterScroll,
      menuIconActiveFilterEffectAfterScroll = _ref$menuIconActiveFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$menuIconActiveFi,
      _ref$mobileActiveLogo4 = _ref.mobileActiveLogoFilterEffect,
      mobileActiveLogoFilterEffect = _ref$mobileActiveLogo4 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$mobileActiveLogo4,
      _ref$mobileLoginButto = _ref.mobileLoginButtonStyles,
      mobileLoginButtonStyles = _ref$mobileLoginButto === void 0 ? {} : _ref$mobileLoginButto,
      _ref$mobileMenuIconSt = _ref.mobileMenuIconStyles,
      mobileMenuIconStyles = _ref$mobileMenuIconSt === void 0 ? {} : _ref$mobileMenuIconSt,
      _ref$mobileBackground = _ref.mobileBackground,
      mobileBackground = _ref$mobileBackground === void 0 ? colorsTypes.WHITE : _ref$mobileBackground,
      _ref$mobileBackground2 = _ref.mobileBackgroundAfterBreakpoint,
      mobileBackgroundAfterBreakpoint = _ref$mobileBackground2 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground2,
      _ref$mobileActiveBack = _ref.mobileActiveBackground,
      mobileActiveBackground = _ref$mobileActiveBack === void 0 ? colorsTypes.WHITE : _ref$mobileActiveBack,
      _ref$mobileTransparen = _ref.mobileTransparentBackground,
      mobileTransparentBackground = _ref$mobileTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileTransparen,
      _ref$mobileHoverBackg = _ref.mobileHoverBackground,
      mobileHoverBackground = _ref$mobileHoverBackg === void 0 ? colorsTypes.WHITE : _ref$mobileHoverBackg,
      _ref$mobileHoverFloat = _ref.mobileHoverFloatBackground,
      mobileHoverFloatBackground = _ref$mobileHoverFloat === void 0 ? colorsTypes.WHITE : _ref$mobileHoverFloat,
      _ref$mobileHoverActiv = _ref.mobileHoverActiveBackground,
      mobileHoverActiveBackground = _ref$mobileHoverActiv === void 0 ? colorsTypes.WHITE : _ref$mobileHoverActiv,
      _ref$mobileBackground3 = _ref.mobileBackgroundAfterBreakpointHover,
      mobileBackgroundAfterBreakpointHover = _ref$mobileBackground3 === void 0 ? colorsTypes.WHITE : _ref$mobileBackground3,
      _ref$mobileHoverTrans = _ref.mobileHoverTransparentBackground,
      mobileHoverTransparentBackground = _ref$mobileHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$mobileHoverTrans,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic;

  var _useModal = useModal(),
      isModalVisible = _useModal.isModalVisible,
      closeModal = _useModal.closeModal,
      showModal = _useModal.showModal;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      menuActive = _useState2[0],
      setMenuActive = _useState2[1];

  React.useEffect(function () {
    screenOverflowHidden(menuActive);
  }, [menuActive]);

  var checkModalActivation = function checkModalActivation() {
    if (loginButtonStyles.variant !== loginVariantTypes.NO_MODAL) {
      showModal();
    } else {
      window.open("".concat(process.env.GATSBY_LOGIN_URL), "_blank");
    }

    setMenuActive(false);
  };

  var LoginButtonMobile = function LoginButtonMobile() {
    return data && data.loginButtonText ? /*#__PURE__*/React__default$1["default"].createElement(Button$2, _extends$g({
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.PILL,
      className: classnames("HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__MENU__ITEM SECOND HeaderDynamicContainer-Container-Container-Pill-Button tw-mr-3", menuActive ? "tw-hidden lg:tw-block" : "tw-block"),
      onClick: checkModalActivation
    }, loginButtonStyles), data.loginButtonText) : null;
  };

  var SecondaryButtonMobile = function SecondaryButtonMobile() {
    var _data$CreditUnion;

    var onClickHandler = function onClickHandler(link) {
      window.location.href = link;
    };

    return (data === null || data === void 0 ? void 0 : (_data$CreditUnion = data.CreditUnion) === null || _data$CreditUnion === void 0 ? void 0 : _data$CreditUnion.CREDIT_UNION) === "bayou" && /*#__PURE__*/React__default$1["default"].createElement(Button$2, {
      className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__MENU__ITEM FIRST tw-mr-3",
      onClick: function onClick() {
        return onClickHandler("https://web.baconpay.com/gate/login?institutionId=33ae4d0c-4b6e-4543-a5af-fa23acf39d97");
      }
    }, "Loan Payments");
  };

  return /*#__PURE__*/React__default$1["default"].createElement(HeaderDynamicContainer, {
    activeLogoReplaceImageWith: activeLogoReplaceImageWith,
    mobileActiveLogoReplaceImageWith: mobileActiveLogoReplaceImageWith,
    mobileLogoFilterEffectAfterScroll: mobileLogoFilterEffectAfterScroll,
    mobileActiveLogoFilterEffectAfterScroll: mobileActiveLogoFilterEffectAfterScroll,
    mobileActiveLogoReplaceImageWithAfterBreakpoint: mobileActiveLogoReplaceImageWithAfterBreakpoint,
    activeLogoFilterEffect: mobileActiveLogoFilterEffect,
    mobileFilterEffectAfterScroll: mobileFilterEffectAfterScroll,
    mobileLogoReplaceImageWith: mobileLogoReplaceImageWith,
    mobileLogoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    mobileNoFilterLogo: mobileNoFilterLogo,
    mobileLogoFilterEffect: mobileLogoFilterEffect,
    logoReplaceImageWithAfterBreakpoint: mobileLogoReplaceImageWithAfterBreakpoint,
    logoReplaceImageWith: mobileLogoReplaceImageWith,
    activeBackground: activeBackground,
    mobileActiveBackground: mobileActiveBackground,
    hoverActiveBackground: hoverActiveBackground,
    mobileHoverActiveBackground: mobileHoverActiveBackground,
    noFilterLogo: mobileNoFilterLogo,
    filter: mobileLogoFilter,
    background: background,
    mobileBackground: mobileBackground,
    mobileHoverBackground: mobileHoverBackground,
    hoverFloatBackground: hoverFloatBackground,
    mobileHoverFloatBackground: mobileHoverFloatBackground,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHover,
    mobileBackgroundAfterBreakpointHover: mobileBackgroundAfterBreakpointHover,
    hoverTransparentBackground: hoverTransparentBackground,
    mobileHoverTransparentBackground: mobileHoverTransparentBackground,
    backgroundAfterBreakpoint: backgroundAfterBreakpoint,
    mobileBackgroundAfterBreakpoint: mobileBackgroundAfterBreakpoint,
    transparentBackground: transparentBackground,
    mobileTransparentBackground: mobileTransparentBackground,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    transparent: transparent || !menuActive,
    forceShow: forceShow || menuActive,
    className: classnames("HEADER_MOBILE_BANNER HeaderDynamicContainer lg:tw-pb-16 tw-fixed lg:tw-absolute tw-z-50 tw-w-full tw-font-normal lg:tw-h-full", menuActive ? "HEADER_MOBILE_BANNER__OPEN tw-min-h-screen tw-overflow-y-scroll lg:tw-overflow-y-auto" : "HEADER_MOBILE_BANNER__CLOSE", scrollY > backgroundBreakpoint ? "HEADER_MOBILE_BANNER_SCROLLED " : "HEADER_MOBILE_BANNER_NO_SCROLLED", isDynamic ? "HEADER_MOBILE_BANNER_DINAMIC_PAGE" : "HEADER_MOBILE_BANNER_NO_DINAMIC_PAGE", className),
    style: HeaderHeight
  }, data && /*#__PURE__*/React__default$1["default"].createElement(Toast, {
    data: data.Toast
  }), /*#__PURE__*/React__default$1["default"].createElement("nav", {
    className: classnames("HEADER_MOBILE_BANNER__CONTAINER HeaderDynamicContainer-Nav tw-z-50 lg:tw-h-full", !menuActive && "tw-h-auto")
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT HeaderDynamicContainer-Container tw-h-auto"
  }, /*#__PURE__*/React__default$1["default"].createElement(MobileBannerContainer, {
    className: "HEADER_MOBILE_BANNER__CONTAINER__LAST"
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX HeaderDynamicContainer-Container-Container tw-w-full tw-flex tw-justify-between tw-items-center",
    style: HeaderHeight
  }, /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__MENU HeaderDynamicContainer-Container-Container-Container tw-float-right tw-flex tw-items-center tw-py-2 tw-rounded"
  }, /*#__PURE__*/React__default$1["default"].createElement(LoginButtonMobile, null), /*#__PURE__*/React__default$1["default"].createElement(SecondaryButtonMobile, null), data && /*#__PURE__*/React__default$1["default"].createElement("button", {
    type: "button",
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__MENU__ITEM__ICON_BOX ".concat(menuActive ? "MENU__ITEM__ACTIVE" : "", " HeaderDynamicContainer-Container-Container-Button tw-float-right tw-flex tw-items-center tw-px-3 tw-py-2 hover:bl-border-grayscale-0"),
    onClick: function onClick() {
      setMenuActive(function (current) {
        return !current;
      });
    }
  }, /*#__PURE__*/React__default$1["default"].createElement(Icon, _extends$g({
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__BOX__MENU__ITEM__ICON_BOX__ICON",
    icon: menuActive ? iconTypes.REMOVE : iconTypes.NAVIGATION_MENU,
    menuActive: menuActive,
    isScrollChangeColorButton: mobileLoginButtonStyles === null || mobileLoginButtonStyles === void 0 ? void 0 : mobileLoginButtonStyles.isScrollChangeColorButton,
    "float": _float,
    scrollY: scrollY,
    backgroundBreakpoint: backgroundBreakpoint,
    noFilter: mobileNoFilterMenuIcon,
    forceFilter: mobileForceFilterMenuIcon,
    filterEffect: menuIconFilterEffect,
    filterEffectAfterScroll: menuIconFilterEffectAfterScroll,
    activeFilterEffectAfterScroll: menuIconActiveFilterEffectAfterScroll,
    mobileFilterEffect: mobileMenuIconFilterEffect,
    mobileFilterEffectAfterScroll: mobileMenuIconFilterEffectAfterScroll,
    mobileActiveFilterEffectAfterScroll: mobileMenuIconActiveFilterEffectAfterScroll
  }, mobileMenuIconStyles))))))), menuActive && data && /*#__PURE__*/React__default$1["default"].createElement(Dropdown$2, {
    subLinksItemTitleColor: menuSubLinksItemTitleColor,
    subLinksListBorderColor: menuSubLinksListBorderColor,
    menuSubLinksListBackground: menuSubLinksListBackground,
    subLinksTitleColor: menuSubLinksTitleColor,
    subLinksItemActiveTitleColor: subLinksItemActiveTitleColor,
    background: backgroundMenu,
    showBackground: _float,
    data: data,
    pathname: pathname,
    classname: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__DROPDOWN HeaderMobile-HeaderDynamicContainer-Dropdown"
  }), /*#__PURE__*/React__default$1["default"].createElement(Modal, {
    className: "HEADER_MOBILE_BANNER__CONTAINER__CONTENT__MODAL",
    show: isModalVisible,
    closeModal: closeModal
  }, /*#__PURE__*/React__default$1["default"].createElement(Login, {
    variant: loginButtonStyles.variant
  }))));
}

var _excluded$B = ["config", "forceCompress", "desktopVariant", "compressedVariant", "headerMobileVariant", "mobileVariant", "menuSubLinksListBackground", "isDynamic"];

function Header(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$forceCompress = _ref.forceCompress,
      forceCompress = _ref$forceCompress === void 0 ? false : _ref$forceCompress,
      _ref$desktopVariant = _ref.desktopVariant,
      desktopVariant = _ref$desktopVariant === void 0 ? headerDesktopVariantTypes.STANDARD : _ref$desktopVariant,
      _ref$compressedVarian = _ref.compressedVariant,
      compressedVariant = _ref$compressedVarian === void 0 ? headerCompressedVariantTypes.STANDARD : _ref$compressedVarian,
      _ref$headerMobileVari = _ref.headerMobileVariant,
      headerMobileVariant = _ref$headerMobileVari === void 0 ? headerMobileVariantTypes.STANDARD : _ref$headerMobileVari,
      _ref$mobileVariant = _ref.mobileVariant,
      mobileVariant = _ref$mobileVariant === void 0 ? headerMobileVariantTypes.STANDARD : _ref$mobileVariant,
      _ref$menuSubLinksList = _ref.menuSubLinksListBackground,
      menuSubLinksListBackground = _ref$menuSubLinksList === void 0 ? null : _ref$menuSubLinksList,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$B);

  var _useState = React.useState(0),
      _useState2 = _slicedToArray$1(_useState, 2),
      scrollY = _useState2[0],
      setScrollY = _useState2[1];

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  React.useEffect(function () {
    window.addEventListener("scroll", function (_ref2) {
      var target = _ref2.target;
      var windowScrollY = target.defaultView.scrollY || 0;
      setScrollY(windowScrollY || 0);
    });
    return function () {
      window.removeEventListener("scroll", function () {
        return null;
      });
    };
  }, [width]);

  if (forceCompress && width >= breakpoints.lg || !!config && config.header && config.header === "COMPRESSED" && width >= breakpoints.lg) {
    return /*#__PURE__*/React__default$1["default"].createElement(HeaderCompressed, _extends$g({
      isDynamic: isDynamic,
      scrollY: scrollY,
      backgroundBreakpoint: 400,
      menuSubLinksListBackground: menuSubLinksListBackground,
      className: classnames("Header-Compressed", isDynamic ? "DINAMIC_PAGE_HEADER_COMPRESSED" : ""),
      variant: compressedVariant
    }, otherProps));
  }

  if (forceCompress && width <= breakpoints.lg || !!config && config.header && config.header === "COMPRESSED" && width < breakpoints.lg) {
    return /*#__PURE__*/React__default$1["default"].createElement(HeaderMobileCompressed, _extends$g({
      scrollY: scrollY,
      isDynamic: isDynamic,
      backgroundBreakpoint: 400,
      className: classnames("Header-Mobile-Compressed", isDynamic ? "DINAMIC_PAGE_HEADER_MOBIL_COMPRESSED" : "NO_DINAMIC_PAGE_HEADER_MOBIL_COMPRESSED")
    }, otherProps));
  }

  if ((width >= breakpoints.lg || !width && width > 0) && (config === null || config === void 0 ? void 0 : config.header) === "DESKTOP_DOUBLE") {
    return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktopDoubleMenu, _extends$g({
      scrollY: scrollY,
      isDynamic: isDynamic,
      className: classnames("Header-Desktop-double", isDynamic ? "DINAMIC_PAGE_Header-Desktop-Double" : "NO_DINAMIC_PAGE_Header-Desktop-Double"),
      variant: desktopVariant
    }, otherProps));
  }

  if ((width >= breakpoints.lg || !width && width > 0) && (config === null || config === void 0 ? void 0 : config.header) === "BANNER") {
    return /*#__PURE__*/React__default$1["default"].createElement(Banner, _extends$g({
      scrollY: scrollY,
      isDynamic: isDynamic,
      className: classnames("Header-Desktop", isDynamic ? "DINAMIC_PAGE_Header-Desktop" : "NO_DINAMIC_PAGE_Header-Desktop")
    }, otherProps));
  }

  if (width >= breakpoints.lg || !width && width > 0 && (config === null || config === void 0 ? void 0 : config.header) === "DESKTOP") {
    return /*#__PURE__*/React__default$1["default"].createElement(HeaderDesktop, _extends$g({
      scrollY: scrollY,
      isDynamic: isDynamic,
      className: classnames("Header-Desktop", isDynamic ? "DINAMIC_PAGE_Header-Desktop" : "NO_DINAMIC_PAGE_Header-Desktop"),
      variant: desktopVariant
    }, otherProps));
  }

  if (!!width && width > 0) {
    if (mobileVariant === "DOUBLE") {
      return /*#__PURE__*/React__default$1["default"].createElement(HeaderMobileDouble, _extends$g({
        background: colorsTypes.WHITE,
        backgroundBreakpoint: 250,
        scrollY: scrollY,
        isDynamic: isDynamic,
        className: classnames("Header-Mobile", isDynamic ? "DINAMIC_PAGE_HEADER_MOBIL" : "", isDynamic ? "DINAMIC_PAGE_Header-Desktop" : "NO_DINAMIC_PAGE_Header-Desktop"),
        variant: "DOUBLE",
        mobileVariant: "DOUBLE",
        headerMobileVariant: headerMobileVariant
      }, otherProps));
    }

    if ((config === null || config === void 0 ? void 0 : config.header) === "BANNER" && width < 1024) {
      return /*#__PURE__*/React__default$1["default"].createElement(MobileBanner, _extends$g({
        background: colorsTypes.WHITE,
        backgroundBreakpoint: 250,
        scrollY: scrollY,
        isDynamic: isDynamic,
        className: classnames("Header-Mobile", isDynamic ? "DINAMIC_PAGE_HEADER_MOBIL" : "", isDynamic ? "DINAMIC_PAGE_Header-Desktop" : "NO_DINAMIC_PAGE_Header-Desktop"),
        variant: "DOUBLE",
        mobileVariant: "DOUBLE",
        headerMobileVariant: headerMobileVariant
      }, otherProps));
    }

    return /*#__PURE__*/React__default$1["default"].createElement(HeaderMobile, _extends$g({
      background: colorsTypes.WHITE,
      backgroundBreakpoint: 250,
      scrollY: scrollY,
      isDynamic: isDynamic,
      className: classnames("Header-Mobile", isDynamic ? "DINAMIC_PAGE_HEADER_MOBIL" : "", isDynamic ? "DINAMIC_PAGE_Header-Desktop" : "NO_DINAMIC_PAGE_Header-Desktop"),
      variant: "DOUBLE",
      mobileVariant: "DOUBLE",
      headerMobileVariant: "DOUBLE"
    }, otherProps));
  }

  return null;
}

var Header$1 = withErrorBoundary(Header, {
  FallbackComponent: Header
});
var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Header$1
}); // TYPES
// FUNCTIONS

function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}

function dehydrate(client, options) {
  var _options, _options2;

  options = options || {};
  var mutations = [];
  var queries = [];

  if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
    var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(function (mutation) {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
    var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(function (query) {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations: mutations,
    queries: queries
  };
}

function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  var mutationCache = client.getMutationCache();
  var queryCache = client.getQueryCache();
  var mutations = dehydratedState.mutations || [];
  var queries = dehydratedState.queries || [];
  mutations.forEach(function (dehydratedMutation) {
    var _options$defaultOptio;

    mutationCache.build(client, _extends$9({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
      mutationKey: dehydratedMutation.mutationKey
    }), dehydratedMutation.state);
  });
  queries.forEach(function (dehydratedQuery) {
    var _options$defaultOptio2;

    var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, _extends$9({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }), dehydratedQuery.state);
  });
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _continue(value, then) {
  return value && value.then ? value.then(then) : then(value);
}

function _empty() {}

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var persistQueryClient = _async(function (_ref) {
  var queryClient = _ref.queryClient,
      persistor = _ref.persistor,
      _ref$maxAge = _ref.maxAge,
      maxAge = _ref$maxAge === void 0 ? 1000 * 60 * 60 * 24 : _ref$maxAge,
      _ref$buster = _ref.buster,
      buster = _ref$buster === void 0 ? '' : _ref$buster;
  return _invokeIgnored(function () {
    if (typeof window !== 'undefined') {
      // Subscribe to changes
      var saveClient = function saveClient() {
        var persistClient = {
          buster: buster,
          timestamp: Date.now(),
          clientState: dehydrate(queryClient)
        };
        persistor.persistClient(persistClient);
      }; // Attempt restore


      return _continue(_catch(function () {
        return _await(persistor.restoreClient(), function (persistedClient) {
          if (persistedClient) {
            if (persistedClient.timestamp) {
              var expired = Date.now() - persistedClient.timestamp > maxAge;
              var busted = persistedClient.buster !== buster;

              if (expired || busted) {
                persistor.removeClient();
              } else {
                hydrate(queryClient, persistedClient.clientState);
              }
            } else {
              persistor.removeClient();
            }
          }
        });
      }, function (err) {
        getLogger().error(err);
        getLogger().warn('Encountered an error attempting to restore client cache from persisted location. As a precaution, the persisted cache will be discarded.');
        persistor.removeClient();
      }), function () {
        // Subscribe to changes in the query cache to trigger the save
        queryClient.getQueryCache().subscribe(saveClient);
      });
    }
  });
});

function createLocalStoragePersistor(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$localStorageKey = _ref.localStorageKey,
      localStorageKey = _ref$localStorageKey === void 0 ? "REACT_QUERY_OFFLINE_CACHE" : _ref$localStorageKey,
      _ref$throttleTime = _ref.throttleTime,
      throttleTime = _ref$throttleTime === void 0 ? 1000 : _ref$throttleTime;

  if (typeof localStorage !== 'undefined') {
    return {
      persistClient: throttle(function (persistedClient) {
        localStorage.setItem(localStorageKey, JSON.stringify(persistedClient));
      }, throttleTime),
      restoreClient: function restoreClient() {
        var cacheString = localStorage.getItem(localStorageKey);

        if (!cacheString) {
          return;
        }

        return JSON.parse(cacheString);
      },
      removeClient: function removeClient() {
        localStorage.removeItem(localStorageKey);
      }
    };
  }

  return {
    persistClient: noop$3,
    restoreClient: noop$3,
    removeClient: noop$3
  };
}

function throttle(func, wait) {
  if (wait === void 0) {
    wait = 100;
  }

  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer === null) {
      timer = setTimeout(function () {
        func.apply(void 0, args);
        timer = null;
      }, wait);
    }
  };
}

var queryClient;

function getQueryClient() {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: false,
          cacheTime: 1000 * 60 * 60 * 2 // 2 hours

        }
      }
    });
    persistQueryClient({
      queryClient: queryClient,
      persistor: createLocalStoragePersistor(),
      maxAge: 1000 * 60 * 60 * 2,
      // 2 hours
      buster: "RESET_CACHE|19-02-2020|11:17PM"
    });
  }

  return queryClient;
}

function Layout(_ref) {
  var _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? "" : _ref$pathname,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? {} : _ref$footer,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      _ref$footerOptions = _ref.footerOptions,
      footerOptions = _ref$footerOptions === void 0 ? {
    businessCustomLogos: [],
    // this can be also used outside footer options to make it work globally
    customIconAlts: ""
  } : _ref$footerOptions,
      _ref$headerLoginButto = _ref.headerLoginButtonIsScrollChangeColorButton,
      headerLoginButtonIsScrollChangeColorButton = _ref$headerLoginButto === void 0 ? false : _ref$headerLoginButto,
      _ref$headerLoginButto2 = _ref.headerLoginButtonScrollBackground,
      headerLoginButtonScrollBackground = _ref$headerLoginButto2 === void 0 ? colorsTypes.WHITE : _ref$headerLoginButto2,
      _ref$headerLoginButto3 = _ref.headerLoginButtonScrollBackgroundAfterScroll,
      headerLoginButtonScrollBackgroundAfterScroll = _ref$headerLoginButto3 === void 0 ? colorsTypes.PRIMARY_DARK : _ref$headerLoginButto3,
      _ref$headerDesktopVar = _ref.headerDesktopVariant,
      headerDesktopVariant = _ref$headerDesktopVar === void 0 ? headerDesktopVariantTypes.STANDARD : _ref$headerDesktopVar,
      _ref$headerCompressed = _ref.headerCompressedVariant,
      headerCompressedVariant = _ref$headerCompressed === void 0 ? headerCompressedVariantTypes.STANDARD : _ref$headerCompressed,
      _ref$headerMobileVari = _ref.headerMobileVariant,
      headerMobileVariant = _ref$headerMobileVari === void 0 ? headerMobileVariantTypes.STANDARD : _ref$headerMobileVari,
      _ref$headerDropdownLo = _ref.headerDropdownLoginButtonStyles,
      headerDropdownLoginButtonStyles = _ref$headerDropdownLo === void 0 ? {} : _ref$headerDropdownLo,
      _ref$backgroundHeader = _ref.backgroundHeader,
      backgroundHeader = _ref$backgroundHeader === void 0 ? colorsTypes.WHITE : _ref$backgroundHeader,
      _ref$headerActiveBack = _ref.headerActiveBackground,
      headerActiveBackground = _ref$headerActiveBack === void 0 ? colorsTypes.WHITE : _ref$headerActiveBack,
      _ref$headerHoverActiv = _ref.headerHoverActiveBackground,
      headerHoverActiveBackground = _ref$headerHoverActiv === void 0 ? colorsTypes.WHITE : _ref$headerHoverActiv,
      _ref$backgroundMenuHe = _ref.backgroundMenuHeader,
      backgroundMenuHeader = _ref$backgroundMenuHe === void 0 ? "" : _ref$backgroundMenuHe,
      _ref$headerActiveLogo = _ref.headerActiveLogoReplaceImageWithAfterBreakpoint,
      headerActiveLogoReplaceImageWithAfterBreakpoint = _ref$headerActiveLogo === void 0 ? "" : _ref$headerActiveLogo,
      _ref$backgroundBreakp = _ref.backgroundBreakpointHeader,
      backgroundBreakpointHeader = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$hoverBackgroundH = _ref.hoverBackgroundHeader,
      hoverBackgroundHeader = _ref$hoverBackgroundH === void 0 ? colorsTypes.WHITE : _ref$hoverBackgroundH,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpointHoverHeader,
      backgroundAfterBreakpointHoverHeader = _ref$backgroundAfterB === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB,
      _ref$menuSubLinksList = _ref.menuSubLinksListBorderColorHeader,
      menuSubLinksListBorderColorHeader = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksList,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColorHeader,
      menuSubLinksTitleColorHeader = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksTitl,
      _ref$menuSubLinksList2 = _ref.menuSubLinksListBackgroundHeader,
      menuSubLinksListBackgroundHeader = _ref$menuSubLinksList2 === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList2,
      _ref$menuSubLinksItem = _ref.menuSubLinksItemTitleColorHeader,
      menuSubLinksItemTitleColorHeader = _ref$menuSubLinksItem === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksItem,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColorHeader,
      subLinksItemActiveTitleColorHeader = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$headerBackground = _ref.headerBackgroundAfterBreakpoint,
      headerBackgroundAfterBreakpoint = _ref$headerBackground === void 0 ? colorsTypes.WHITE : _ref$headerBackground,
      _ref$headerTransparen = _ref.headerTransparentBackground,
      headerTransparentBackground = _ref$headerTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref$headerTransparen,
      _ref$headerHoverTrans = _ref.headerHoverTransparentBackground,
      headerHoverTransparentBackground = _ref$headerHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$headerHoverTrans,
      _ref$topIndicatorHead = _ref.topIndicatorHeader,
      topIndicatorHeader = _ref$topIndicatorHead === void 0 ? true : _ref$topIndicatorHead,
      _ref$transparentHeade = _ref.transparentHeader,
      transparentHeader = _ref$transparentHeade === void 0 ? false : _ref$transparentHeade,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$forceShowHeader = _ref.forceShowHeader,
      forceShowHeader = _ref$forceShowHeader === void 0 ? false : _ref$forceShowHeader,
      _ref$forceShowItemsHe = _ref.forceShowItemsHeader,
      forceShowItemsHeader = _ref$forceShowItemsHe === void 0 ? true : _ref$forceShowItemsHe,
      _ref$forceShowColorHe = _ref.forceShowColorHeader,
      forceShowColorHeader = _ref$forceShowColorHe === void 0 ? false : _ref$forceShowColorHe,
      _ref$forceShowHoverHe = _ref.forceShowHoverHeader,
      forceShowHoverHeader = _ref$forceShowHoverHe === void 0 ? false : _ref$forceShowHoverHe,
      _ref$floatHeader = _ref.floatHeader,
      floatHeader = _ref$floatHeader === void 0 ? false : _ref$floatHeader,
      _ref$grayscaleHeader = _ref.grayscaleHeader,
      grayscaleHeader = _ref$grayscaleHeader === void 0 ? false : _ref$grayscaleHeader,
      _ref$darkHeader = _ref.darkHeader,
      darkHeader = _ref$darkHeader === void 0 ? false : _ref$darkHeader,
      _ref$backgroundScreen = _ref.backgroundScreenHeader,
      backgroundScreenHeader = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$forceCompressHea = _ref.forceCompressHeader,
      forceCompressHeader = _ref$forceCompressHea === void 0 ? false : _ref$forceCompressHea,
      _ref$noFilterLogoHead = _ref.noFilterLogoHeader,
      noFilterLogoHeader = _ref$noFilterLogoHead === void 0 ? false : _ref$noFilterLogoHead,
      _ref$headerNoFilterMe = _ref.headerNoFilterMenuIcon,
      headerNoFilterMenuIcon = _ref$headerNoFilterMe === void 0 ? false : _ref$headerNoFilterMe,
      _ref$headerForceFilte = _ref.headerForceFilterMenuIcon,
      headerForceFilterMenuIcon = _ref$headerForceFilte === void 0 ? false : _ref$headerForceFilte,
      _ref$headerLoginButto4 = _ref.headerLoginButtonStyles,
      headerLoginButtonStyles = _ref$headerLoginButto4 === void 0 ? {} : _ref$headerLoginButto4,
      variant = _ref.variant,
      _ref$navigationOption = _ref.navigationOptions,
      navigationOptions = _ref$navigationOption === void 0 ? {} : _ref$navigationOption,
      _ref$navigationMenuOp = _ref.navigationMenuOptions,
      navigationMenuOptions = _ref$navigationMenuOp === void 0 ? {
    menuActiveBorderColor: colorsTypes.PRIMARY,
    menuHoverBorderColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubLinksTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubItemTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subMenuBackgroundColor: colorsTypes.TRANSPARENT,
    subMenuActiveBackgroundColor: colorsTypes.TRANSPARENT,
    itemBackgroundColor: colorsTypes.WHITE,
    dropdownHoverBackground: colorsVariantsTypes.HIGHT_LIGHT_PRIMARY,
    dropdownSeparationFromTop: 20,
    dropdownSeparationFromBottom: 50
  } : _ref$navigationMenuOp,
      _ref$headerLogoFilter = _ref.headerLogoFilter,
      headerLogoFilter = _ref$headerLogoFilter === void 0 ? undefined : _ref$headerLogoFilter,
      _ref$headerLogoReplac = _ref.headerLogoReplaceImageWith,
      headerLogoReplaceImageWith = _ref$headerLogoReplac === void 0 ? undefined : _ref$headerLogoReplac,
      _ref$headerLogoFilter2 = _ref.headerLogoFilterEffect,
      headerLogoFilterEffect = _ref$headerLogoFilter2 === void 0 ? [] : _ref$headerLogoFilter2,
      _ref$headerLogoFilter3 = _ref.headerLogoFilterEffectAfterScroll,
      headerLogoFilterEffectAfterScroll = _ref$headerLogoFilter3 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerLogoFilter3,
      _ref$headerActiveFilt = _ref.headerActiveFilterEffect,
      headerActiveFilterEffect = _ref$headerActiveFilt === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerActiveFilt,
      _ref$headerMenuIconSt = _ref.headerMenuIconStyles,
      headerMenuIconStyles = _ref$headerMenuIconSt === void 0 ? {} : _ref$headerMenuIconSt,
      _ref$headerActiveLogo2 = _ref.headerActiveLogoReplaceImageWith,
      headerActiveLogoReplaceImageWith = _ref$headerActiveLogo2 === void 0 ? "" : _ref$headerActiveLogo2,
      _ref$headerMobileActi = _ref.headerMobileActiveLogoReplaceImageWith,
      headerMobileActiveLogoReplaceImageWith = _ref$headerMobileActi === void 0 ? "" : _ref$headerMobileActi,
      _ref$headerMobileFilt = _ref.headerMobileFilterEffect,
      headerMobileFilterEffect = _ref$headerMobileFilt === void 0 ? [] : _ref$headerMobileFilt,
      _ref$headerMobileActi2 = _ref.headerMobileActiveLogoReplaceImageWithAfterBreakpoint,
      headerMobileActiveLogoReplaceImageWithAfterBreakpoint = _ref$headerMobileActi2 === void 0 ? "" : _ref$headerMobileActi2,
      _ref$headerMobileForc = _ref.headerMobileForceShow,
      headerMobileForceShow = _ref$headerMobileForc === void 0 ? false : _ref$headerMobileForc,
      _ref$headerMobileTran = _ref.headerMobileTransparent,
      headerMobileTransparent = _ref$headerMobileTran === void 0 ? false : _ref$headerMobileTran,
      _ref$headerMobileNoFi = _ref.headerMobileNoFilterLogo,
      headerMobileNoFilterLogo = _ref$headerMobileNoFi === void 0 ? false : _ref$headerMobileNoFi,
      _ref$headerMobileNoFi2 = _ref.headerMobileNoFilterMenuIcon,
      headerMobileNoFilterMenuIcon = _ref$headerMobileNoFi2 === void 0 ? false : _ref$headerMobileNoFi2,
      _ref$headerMobileForc2 = _ref.headerMobileForceFilterMenuIcon,
      headerMobileForceFilterMenuIcon = _ref$headerMobileForc2 === void 0 ? false : _ref$headerMobileForc2,
      _ref$headerMobileLogi = _ref.headerMobileLoginButtonIsScrollChangeColorButton,
      headerMobileLoginButtonIsScrollChangeColorButton = _ref$headerMobileLogi === void 0 ? false : _ref$headerMobileLogi,
      _ref$headerMobileLogo = _ref.headerMobileLogoReplaceImageWith,
      headerMobileLogoReplaceImageWith = _ref$headerMobileLogo === void 0 ? undefined : _ref$headerMobileLogo,
      _ref$headerMobileLogo2 = _ref.headerMobileLogoReplaceImageWithAfterBreakpoint,
      headerMobileLogoReplaceImageWithAfterBreakpoint = _ref$headerMobileLogo2 === void 0 ? undefined : _ref$headerMobileLogo2,
      _ref$headerMobileLogo3 = _ref.headerMobileLogoFilter,
      headerMobileLogoFilter = _ref$headerMobileLogo3 === void 0 ? undefined : _ref$headerMobileLogo3,
      _ref$headerMobileLogo4 = _ref.headerMobileLogoFilterEffectAfterScroll,
      headerMobileLogoFilterEffectAfterScroll = _ref$headerMobileLogo4 === void 0 ? [] : _ref$headerMobileLogo4,
      _ref$headerMobileFilt2 = _ref.headerMobileFilterEffectAfterScroll,
      headerMobileFilterEffectAfterScroll = _ref$headerMobileFilt2 === void 0 ? [] : _ref$headerMobileFilt2,
      _ref$headerMobileLogo5 = _ref.headerMobileLogoFilterEffect,
      headerMobileLogoFilterEffect = _ref$headerMobileLogo5 === void 0 ? [] : _ref$headerMobileLogo5,
      _ref$headerMobileActi3 = _ref.headerMobileActiveLogoFilterEffectAfterScroll,
      headerMobileActiveLogoFilterEffectAfterScroll = _ref$headerMobileActi3 === void 0 ? [] : _ref$headerMobileActi3,
      _ref$headerMobileMenu = _ref.headerMobileMenuIconFilterEffect,
      headerMobileMenuIconFilterEffect = _ref$headerMobileMenu === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileMenu,
      _ref$headerMobileMenu2 = _ref.headerMobileMenuIconFilterEffectAfterScroll,
      headerMobileMenuIconFilterEffectAfterScroll = _ref$headerMobileMenu2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileMenu2,
      _ref$headerMobileMenu3 = _ref.headerMobileMenuIconActiveFilterEffectAfterScroll,
      headerMobileMenuIconActiveFilterEffectAfterScroll = _ref$headerMobileMenu3 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileMenu3,
      _ref$headerMenuIconFi = _ref.headerMenuIconFilterEffect,
      headerMenuIconFilterEffect = _ref$headerMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMenuIconFi,
      _ref$headerMenuIconFi2 = _ref.headerMenuIconFilterEffectAfterScroll,
      headerMenuIconFilterEffectAfterScroll = _ref$headerMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMenuIconFi2,
      _ref$headerMenuIconAc = _ref.headerMenuIconActiveFilterEffectAfterScroll,
      headerMenuIconActiveFilterEffectAfterScroll = _ref$headerMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMenuIconAc,
      _ref$headerMobileActi4 = _ref.headerMobileActiveLogoFilterEffect,
      headerMobileActiveLogoFilterEffect = _ref$headerMobileActi4 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileActi4,
      _ref$headerMobileLogi2 = _ref.headerMobileLoginButtonStyles,
      headerMobileLoginButtonStyles = _ref$headerMobileLogi2 === void 0 ? {} : _ref$headerMobileLogi2,
      _ref$headerMobileMenu4 = _ref.headerMobileMenuIconStyles,
      headerMobileMenuIconStyles = _ref$headerMobileMenu4 === void 0 ? {} : _ref$headerMobileMenu4,
      _ref$headerMobileBack = _ref.headerMobileBackgroundMenu,
      headerMobileBackgroundMenu = _ref$headerMobileBack === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack,
      _ref$headerMobileLogi3 = _ref.headerMobileLoginButtonScrollBackgroundAfterScroll,
      headerMobileLoginButtonScrollBackgroundAfterScroll = _ref$headerMobileLogi3 === void 0 ? colorsTypes.PRIMARY_DARK : _ref$headerMobileLogi3,
      _ref$headerMobileLogi4 = _ref.headerMobileLoginButtonScrollBackground,
      headerMobileLoginButtonScrollBackground = _ref$headerMobileLogi4 === void 0 ? colorsTypes.WHITE : _ref$headerMobileLogi4,
      _ref$headerMobileBack2 = _ref.headerMobileBackground,
      headerMobileBackground = _ref$headerMobileBack2 === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack2,
      _ref$headerMobileBack3 = _ref.headerMobileBackgroundAfterBreakpoint,
      headerMobileBackgroundAfterBreakpoint = _ref$headerMobileBack3 === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack3,
      _ref$headerMobileActi5 = _ref.headerMobileActiveBackground,
      headerMobileActiveBackground = _ref$headerMobileActi5 === void 0 ? colorsTypes.WHITE : _ref$headerMobileActi5,
      _ref$headerMobileTran2 = _ref.headerMobileTransparentBackground,
      headerMobileTransparentBackground = _ref$headerMobileTran2 === void 0 ? colorsTypes.TRANSPARENT : _ref$headerMobileTran2,
      _ref$headerMobileHove = _ref.headerMobileHoverBackground,
      headerMobileHoverBackground = _ref$headerMobileHove === void 0 ? colorsTypes.HIGHT_LIGHT_PRIMARY : _ref$headerMobileHove,
      _ref$headerMobileHove2 = _ref.headerMobileHoverFloatBackground,
      headerMobileHoverFloatBackground = _ref$headerMobileHove2 === void 0 ? colorsTypes.WHITE : _ref$headerMobileHove2,
      _ref$headerMobileHove3 = _ref.headerMobileHoverActiveBackground,
      headerMobileHoverActiveBackground = _ref$headerMobileHove3 === void 0 ? colorsTypes.WHITE : _ref$headerMobileHove3,
      _ref$headerMobileBack4 = _ref.headerMobileBackgroundAfterBreakpointHover,
      headerMobileBackgroundAfterBreakpointHover = _ref$headerMobileBack4 === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack4,
      _ref$headerMobileHove4 = _ref.headerMobileHoverTransparentBackground,
      headerMobileHoverTransparentBackground = _ref$headerMobileHove4 === void 0 ? colorsTypes.TRANSPARENT : _ref$headerMobileHove4,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic; // using actualPath variable for verifying the pathname, pathname prop from props not working properly

  var elements = withProps(children, {
    floatHeader: floatHeader,
    theme: theme
  });

  var _useState = React.useState(),
      _useState2 = _slicedToArray$1(_useState, 2),
      auxPath = _useState2[0],
      setAuxPath = _useState2[1];

  React.useEffect(function () {
    if (pathname !== "") {
      setAuxPath(pathname.toUpperCase().replaceAll("-", "_"));
    } else {
      setAuxPath("HOME");
    }
  }, [pathname]);
  React.useEffect(function () {
    if (window && window.location.href.indexOf("#") !== -1 && document) {
      setTimeout(function () {
        var element = document.getElementById(window.location.href.split("#")[1]);

        if (element) {
          element.scrollIntoView();
        }
      }, 500); // this delay is necessary to allow the scroll when comming from other page
    }
  }, []);
  return /*#__PURE__*/React__default$1["default"].createElement("main", {
    className: "LAYOUT_MAIN LAYOUT_MAIN_".concat(auxPath, " tw-min-h-screen")
  }, /*#__PURE__*/React__default$1["default"].createElement(Header$1, {
    className: "LAYOUT_HEADER" // MOBILE
    ,
    variant: variant,
    mobileActiveLogoReplaceImageWith: headerMobileActiveLogoReplaceImageWith,
    mobileActiveLogoReplaceImageWithAfterBreakpoint: headerMobileActiveLogoReplaceImageWithAfterBreakpoint,
    mobileForceShow: headerMobileForceShow,
    mobileTransparent: headerMobileTransparent,
    mobileNoFilterLogo: headerMobileNoFilterLogo,
    mobileNoFilterMenuIcon: headerMobileNoFilterMenuIcon,
    mobileForceFilterMenuIcon: headerMobileForceFilterMenuIcon,
    mobileLoginButtonIsScrollChangeColorButton: headerMobileLoginButtonIsScrollChangeColorButton,
    mobileLogoReplaceImageWith: headerMobileLogoReplaceImageWith,
    mobileLogoReplaceImageWithAfterBreakpoint: headerMobileLogoReplaceImageWithAfterBreakpoint,
    mobileLogoFilter: headerMobileLogoFilter,
    mobileLogoFilterEffectAfterScroll: headerMobileLogoFilterEffectAfterScroll,
    mobileFilterEffectAfterScroll: headerMobileFilterEffectAfterScroll,
    mobileLogoFilterEffect: headerMobileLogoFilterEffect,
    mobileActiveLogoFilterEffectAfterScroll: headerMobileActiveLogoFilterEffectAfterScroll,
    mobileMenuIconFilterEffect: headerMobileMenuIconFilterEffect,
    mobileMenuIconFilterEffectAfterScroll: headerMobileMenuIconFilterEffectAfterScroll,
    mobileMenuIconActiveFilterEffectAfterScroll: headerMobileMenuIconActiveFilterEffectAfterScroll,
    menuIconFilterEffect: headerMenuIconFilterEffect,
    menuIconFilterEffectAfterScroll: headerMenuIconFilterEffectAfterScroll,
    menuIconActiveFilterEffectAfterScroll: headerMenuIconActiveFilterEffectAfterScroll,
    mobileActiveLogoFilterEffect: headerMobileActiveLogoFilterEffect,
    mobileLoginButtonStyles: headerMobileLoginButtonStyles,
    mobileMenuIconStyles: headerMobileMenuIconStyles,
    mobileBackgroundMenu: headerMobileBackgroundMenu,
    mobileLoginButtonScrollBackgroundAfterScroll: headerMobileLoginButtonScrollBackgroundAfterScroll,
    mobileLoginButtonScrollBackground: headerMobileLoginButtonScrollBackground,
    mobileBackground: headerMobileBackground,
    mobileBackgroundAfterBreakpoint: headerMobileBackgroundAfterBreakpoint,
    mobileActiveBackground: headerMobileActiveBackground,
    mobileTransparentBackground: headerMobileTransparentBackground,
    mobileHoverBackground: headerMobileHoverBackground,
    mobileHoverFloatBackground: headerMobileHoverFloatBackground,
    mobileHoverActiveBackground: headerMobileHoverActiveBackground,
    mobileBackgroundAfterBreakpointHover: headerMobileBackgroundAfterBreakpointHover,
    mobileHoverTransparentBackground: headerMobileHoverTransparentBackground,
    mobileFilterEffect: headerMobileFilterEffect,
    menuIconStyles: headerMenuIconStyles,
    mobileVariant: headerMobileVariant // DESKTOP
    ,
    activeLogoReplaceImageWith: headerActiveLogoReplaceImageWith,
    activeLogoReplaceImageWithAfterBreakpoint: headerActiveLogoReplaceImageWithAfterBreakpoint,
    activeLogoFilterEffect: headerActiveFilterEffect,
    loginButtonIsScrollChangeColorButton: headerLoginButtonIsScrollChangeColorButton,
    loginButtonScrollBackground: headerLoginButtonScrollBackground,
    loginButtonScrollBackgroundAfterScroll: headerLoginButtonScrollBackgroundAfterScroll,
    logoReplaceImageWith: headerLogoReplaceImageWith,
    noFilterMenuIcon: headerNoFilterMenuIcon,
    forceFilterMenuIcon: headerForceFilterMenuIcon,
    activeBackground: headerActiveBackground,
    hoverActiveBackground: headerHoverActiveBackground,
    dropdownLoginButtonStyles: headerDropdownLoginButtonStyles,
    desktopVariant: headerDesktopVariant,
    compressedVariant: headerCompressedVariant,
    subLinksItemActiveTitleColor: subLinksItemActiveTitleColorHeader,
    menuSubLinksItemTitleColor: menuSubLinksItemTitleColorHeader,
    menuSubLinksTitleColor: menuSubLinksTitleColorHeader,
    menuSubLinksListBorderColor: menuSubLinksListBorderColorHeader,
    menuSubLinksListBackground: menuSubLinksListBackgroundHeader,
    noFilterLogo: noFilterLogoHeader,
    background: backgroundHeader,
    backgroundMenu: backgroundMenuHeader,
    hoverBackground: hoverBackgroundHeader,
    backgroundAfterBreakpointHover: backgroundAfterBreakpointHoverHeader,
    backgroundBreakpoint: backgroundBreakpointHeader,
    forceCompress: forceCompressHeader,
    pathname: pathname,
    data: header,
    isDynamic: isDynamic,
    config: config,
    transparent: transparentHeader,
    isTopBorder: isTopBorder,
    forceShow: forceShowHeader,
    forceShowItems: forceShowItemsHeader,
    forceShowColor: forceShowColorHeader,
    forceShowHover: forceShowHoverHeader,
    "float": floatHeader,
    topIndicator: topIndicatorHeader,
    grayscale: grayscaleHeader,
    dark: darkHeader,
    backgroundScreenActive: backgroundScreenHeader,
    loginButtonStyles: headerLoginButtonStyles,
    navigationOptions: _objectSpread2({
      maxWidth: "none"
    }, navigationOptions),
    navigationMenuOptions: navigationMenuOptions,
    backgroundAfterBreakpoint: headerBackgroundAfterBreakpoint,
    transparentBackground: headerTransparentBackground,
    hoverTransparentBackground: headerHoverTransparentBackground,
    logoFilter: headerLogoFilter,
    logoFilterEffect: headerLogoFilterEffect,
    logoFilterEffectAfterScroll: headerLogoFilterEffectAfterScroll
  }), elements, Object.keys(footer).length > 1 && /*#__PURE__*/React__default$1["default"].createElement(Footer$1, _extends$g({
    className: "LAYOUT_FOOTER",
    data: footer,
    config: config
  }, footerOptions)));
}

function Loader() {
  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "bl-text-2xl tw-h-screen tw-flex tw-justify-center tw-items-center LOADER"
  }, /*#__PURE__*/React__default$1["default"].createElement("img", {
    src: "/images/icons/spinner.svg",
    alt: "Loader animation",
    className: "tw-animate-spin"
  }));
}

function _interopDefault$1(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React__default = _interopDefault$1(React__default$1["default"]);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      } // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React__default$1["default"].PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

var lib = withSideEffect;
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView; // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    } // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.


    var it;

    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    } // END: Modifications


    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    } // END: fast-deep-equal
    // START: react-fast-compare
    // custom handling for DOM elements


    if (hasElementType && a instanceof Element) return false; // custom handling for React/Preact

    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements
        continue;
      } // all other properties should be traversed as usual


      if (!equal(a[keys[i]], b[keys[i]])) return false;
    } // END: react-fast-compare
    // START: fast-deep-equal


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
};

var ATTRIBUTE_NAMES = {
  BODY: "bodyAttributes",
  HTML: "htmlAttributes",
  TITLE: "titleAttributes"
};
var TAG_NAMES = {
  BASE: "base",
  BODY: "body",
  HEAD: "head",
  HTML: "html",
  LINK: "link",
  META: "meta",
  NOSCRIPT: "noscript",
  SCRIPT: "script",
  STYLE: "style",
  TITLE: "title"
};
var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
  return TAG_NAMES[name];
});
var TAG_PROPERTIES = {
  CHARSET: "charset",
  CSS_TEXT: "cssText",
  HREF: "href",
  HTTPEQUIV: "http-equiv",
  INNER_HTML: "innerHTML",
  ITEM_PROP: "itemprop",
  NAME: "name",
  PROPERTY: "property",
  REL: "rel",
  SRC: "src",
  TARGET: "target"
};
var REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
};
var HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate"
};
var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
  obj[REACT_TAG_MAP[key]] = key;
  return obj;
}, {});
var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (encode === false) {
    return String(str);
  }

  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
  var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

  if (innermostTemplate && innermostTitle) {
    // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function () {
      return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
  }

  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
  return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
  return propsList.filter(function (props) {
    return typeof props[tagType] !== "undefined";
  }).map(function (props) {
    return props[tagType];
  }).reduce(function (tagAttrs, current) {
    return _extends({}, tagAttrs, current);
  }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
  return propsList.filter(function (props) {
    return typeof props[TAG_NAMES.BASE] !== "undefined";
  }).map(function (props) {
    return props[TAG_NAMES.BASE];
  }).reverse().reduce(function (innermostBaseTag, tag) {
    if (!innermostBaseTag.length) {
      var keys = Object.keys(tag);

      for (var i = 0; i < keys.length; i++) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();

        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag);
        }
      }
    }

    return innermostBaseTag;
  }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
  // Calculate list of tags, giving priority innermost component (end of the propslist)
  var approvedSeenTags = {};
  return propsList.filter(function (props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }

    if (typeof props[tagName] !== "undefined") {
      warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
    }

    return false;
  }).map(function (props) {
    return props[tagName];
  }).reverse().reduce(function (approvedTags, instanceTags) {
    var instanceSeenTags = {};
    instanceTags.filter(function (tag) {
      var primaryAttributeKey = void 0;
      var keys = Object.keys(tag);

      for (var i = 0; i < keys.length; i++) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase(); // Special rule with link tags, since rel and href are both primary tags, rel takes priority

        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
          primaryAttributeKey = lowerCaseAttributeKey;
        } // Special case for innerHTML which doesn't work lowercased


        if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
          primaryAttributeKey = attributeKey;
        }
      }

      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }

      var value = tag[primaryAttributeKey].toLowerCase();

      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }

      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }

      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }

      return false;
    }).reverse().forEach(function (tag) {
      return approvedTags.push(tag);
    }); // Update seen tags with tags from this instance

    var keys = Object.keys(instanceSeenTags);

    for (var i = 0; i < keys.length; i++) {
      var attributeKey = keys[i];
      var tagUnion = objectAssign({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
      approvedSeenTags[attributeKey] = tagUnion;
    }

    return approvedTags;
  }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
  for (var i = propsList.length - 1; i >= 0; i--) {
    var props = propsList[i];

    if (props.hasOwnProperty(property)) {
      return props[property];
    }
  }

  return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
  return {
    baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
    bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
    linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
    metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
    noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
    styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
  };
};

var rafPolyfill = function () {
  var clock = Date.now();
  return function (callback) {
    var currentTime = Date.now();

    if (currentTime - clock > 16) {
      clock = currentTime;
      callback(currentTime);
    } else {
      setTimeout(function () {
        rafPolyfill(callback);
      }, 0);
    }
  };
}();

var cafPolyfill = function cafPolyfill(id) {
  return clearTimeout(id);
};

var requestAnimationFrame$1 = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
  return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }

  if (newState.defer) {
    _helmetCallback = requestAnimationFrame$1(function () {
      commitTagChanges(newState, function () {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
  var baseTag = newState.baseTag,
      bodyAttributes = newState.bodyAttributes,
      htmlAttributes = newState.htmlAttributes,
      linkTags = newState.linkTags,
      metaTags = newState.metaTags,
      noscriptTags = newState.noscriptTags,
      onChangeClientState = newState.onChangeClientState,
      scriptTags = newState.scriptTags,
      styleTags = newState.styleTags,
      title = newState.title,
      titleAttributes = newState.titleAttributes;
  updateAttributes(TAG_NAMES.BODY, bodyAttributes);
  updateAttributes(TAG_NAMES.HTML, htmlAttributes);
  updateTitle(title, titleAttributes);
  var tagUpdates = {
    baseTag: updateTags(TAG_NAMES.BASE, baseTag),
    linkTags: updateTags(TAG_NAMES.LINK, linkTags),
    metaTags: updateTags(TAG_NAMES.META, metaTags),
    noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
    scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
    styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
  };
  var addedTags = {};
  var removedTags = {};
  Object.keys(tagUpdates).forEach(function (tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType],
        newTags = _tagUpdates$tagType.newTags,
        oldTags = _tagUpdates$tagType.oldTags;

    if (newTags.length) {
      addedTags[tagType] = newTags;
    }

    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });
  cb && cb();
  onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
  if (typeof title !== "undefined" && document.title !== title) {
    document.title = flattenArray(title);
  }

  updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];

  if (!elementTag) {
    return;
  }

  var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
  var attributesToRemove = [].concat(helmetAttributes);
  var attributeKeys = Object.keys(attributes);

  for (var i = 0; i < attributeKeys.length; i++) {
    var attribute = attributeKeys[i];
    var value = attributes[attribute] || "";

    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }

    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }

    var indexToSave = attributesToRemove.indexOf(attribute);

    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }

  for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
    elementTag.removeAttribute(attributesToRemove[_i]);
  }

  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
    elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
  }
};

var updateTags = function updateTags(type, tags) {
  var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
  var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
  var oldTags = Array.prototype.slice.call(tagNodes);
  var newTags = [];
  var indexToDelete = void 0;

  if (tags && tags.length) {
    tags.forEach(function (tag) {
      var newElement = document.createElement(type);

      for (var attribute in tag) {
        if (tag.hasOwnProperty(attribute)) {
          if (attribute === TAG_PROPERTIES.INNER_HTML) {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
            newElement.setAttribute(attribute, value);
          }
        }
      }

      newElement.setAttribute(HELMET_ATTRIBUTE, "true"); // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.

      if (oldTags.some(function (existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }

  oldTags.forEach(function (tag) {
    return tag.parentNode.removeChild(tag);
  });
  newTags.forEach(function (tag) {
    return headElement.appendChild(tag);
  });
  return {
    oldTags: oldTags,
    newTags: newTags
  };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
  return Object.keys(attributes).reduce(function (str, key) {
    var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
    return str ? str + " " + attr : attr;
  }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = flattenArray(title);
  return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
  return tags.reduce(function (str, tag) {
    var attributeHtml = Object.keys(tag).filter(function (attribute) {
      return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
    }).reduce(function (string, attribute) {
      var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
      return string ? string + " " + attr : attr;
    }, "");
    var tagContent = tag.innerHTML || tag.cssText || "";
    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
    return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
  }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(attributes).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key] || key] = attributes[key];
    return obj;
  }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
  var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(props).reduce(function (obj, key) {
    obj[HTML_TAG_MAP[key] || key] = props[key];
    return obj;
  }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
  var _initProps; // assigning into an array to define toString function on it


  var initProps = (_initProps = {
    key: title
  }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
  var props = convertElementAttributestoReactProps(attributes, initProps);
  return [React__default$1["default"].createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
  return tags.map(function (tag, i) {
    var _mappedTag;

    var mappedTag = (_mappedTag = {
      key: i
    }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);
    Object.keys(tag).forEach(function (attribute) {
      var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

      if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
        var content = tag.innerHTML || tag.cssText;
        mappedTag.dangerouslySetInnerHTML = {
          __html: content
        };
      } else {
        mappedTag[mappedAttribute] = tag[attribute];
      }
    });
    return React__default$1["default"].createElement(type, mappedTag);
  });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
  switch (type) {
    case TAG_NAMES.TITLE:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
        },
        toString: function toString() {
          return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
        }
      };

    case ATTRIBUTE_NAMES.BODY:
    case ATTRIBUTE_NAMES.HTML:
      return {
        toComponent: function toComponent() {
          return convertElementAttributestoReactProps(tags);
        },
        toString: function toString() {
          return generateElementAttributesAsString(tags);
        }
      };

    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type, tags);
        },
        toString: function toString() {
          return generateTagsAsString(type, tags, encode);
        }
      };
  }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
  var baseTag = _ref.baseTag,
      bodyAttributes = _ref.bodyAttributes,
      encode = _ref.encode,
      htmlAttributes = _ref.htmlAttributes,
      linkTags = _ref.linkTags,
      metaTags = _ref.metaTags,
      noscriptTags = _ref.noscriptTags,
      scriptTags = _ref.scriptTags,
      styleTags = _ref.styleTags,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      titleAttributes = _ref.titleAttributes;
  return {
    base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
    bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
    link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
    meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
    noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
    script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
    style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
    title: getMethodsForTag(TAG_NAMES.TITLE, {
      title: title,
      titleAttributes: titleAttributes
    }, encode)
  };
};

var Helmet = function Helmet(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    inherits(HelmetWrapper, _React$Component);

    function HelmetWrapper() {
      classCallCheck(this, HelmetWrapper);
      return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return !reactFastCompare(this.props, nextProps);
    };

    HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }

      switch (child.type) {
        case TAG_NAMES.SCRIPT:
        case TAG_NAMES.NOSCRIPT:
          return {
            innerHTML: nestedChildren
          };

        case TAG_NAMES.STYLE:
          return {
            cssText: nestedChildren
          };
      }

      throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
    };

    HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
      var _babelHelpers$extends;

      var child = _ref.child,
          arrayTypeChildren = _ref.arrayTypeChildren,
          newChildProps = _ref.newChildProps,
          nestedChildren = _ref.nestedChildren;
      return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
    };

    HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
      var _babelHelpers$extends2, _babelHelpers$extends3;

      var child = _ref2.child,
          newProps = _ref2.newProps,
          newChildProps = _ref2.newChildProps,
          nestedChildren = _ref2.nestedChildren;

      switch (child.type) {
        case TAG_NAMES.TITLE:
          return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

        case TAG_NAMES.BODY:
          return _extends({}, newProps, {
            bodyAttributes: _extends({}, newChildProps)
          });

        case TAG_NAMES.HTML:
          return _extends({}, newProps, {
            htmlAttributes: _extends({}, newChildProps)
          });
      }

      return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
    };

    HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _extends({}, newProps);

      Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
        var _babelHelpers$extends4;

        newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
      });
      return newFlattenedProps;
    };

    HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
      if (process.env.NODE_ENV !== "production") {
        if (!VALID_TAG_NAMES.some(function (name) {
          return child.type === name;
        })) {
          if (typeof child.type === "function") {
            return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
          }

          return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
        }

        if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
          return typeof nestedChild !== "string";
        }))) {
          throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
        }
      }

      return true;
    };

    HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
      var _this2 = this;

      var arrayTypeChildren = {};
      React__default$1["default"].Children.forEach(children, function (child) {
        if (!child || !child.props) {
          return;
        }

        var _child$props = child.props,
            nestedChildren = _child$props.children,
            childProps = objectWithoutProperties(_child$props, ["children"]);
        var newChildProps = convertReactPropstoHtmlAttributes(childProps);

        _this2.warnOnInvalidChildren(child, nestedChildren);

        switch (child.type) {
          case TAG_NAMES.LINK:
          case TAG_NAMES.META:
          case TAG_NAMES.NOSCRIPT:
          case TAG_NAMES.SCRIPT:
          case TAG_NAMES.STYLE:
            arrayTypeChildren = _this2.flattenArrayTypeChildren({
              child: child,
              arrayTypeChildren: arrayTypeChildren,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;

          default:
            newProps = _this2.mapObjectTypeChildren({
              child: child,
              newProps: newProps,
              newChildProps: newChildProps,
              nestedChildren: nestedChildren
            });
            break;
        }
      });
      newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
      return newProps;
    };

    HelmetWrapper.prototype.render = function render() {
      var _props = this.props,
          children = _props.children,
          props = objectWithoutProperties(_props, ["children"]);

      var newProps = _extends({}, props);

      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }

      return React__default$1["default"].createElement(Component, newProps);
    };

    createClass(HelmetWrapper, null, [{
      key: "canUseDOM",
      // Component.peek comes from react-side-effect:
      // For testing, you may use a static peek() method available on the returned component.
      // It lets you get the current state without resetting the mounted instance stack.
      // Don’t use it for anything other than testing.

      /**
       * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
       * @param {Object} bodyAttributes: {"className": "root"}
       * @param {String} defaultTitle: "Default Title"
       * @param {Boolean} defer: true
       * @param {Boolean} encodeSpecialCharacters: true
       * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
       * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
       * @param {Array} meta: [{"name": "description", "content": "Test description"}]
       * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
       * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
       * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
       * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
       * @param {String} title: "Title"
       * @param {Object} titleAttributes: {"itemprop": "name"}
       * @param {String} titleTemplate: "MySite.com - %s"
       */
      set: function set$$1(canUseDOM) {
        Component.canUseDOM = canUseDOM;
      }
    }]);
    return HelmetWrapper;
  }(React__default$1["default"].Component), _class.propTypes = {
    base: PropTypes.object,
    bodyAttributes: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    defaultTitle: PropTypes.string,
    defer: PropTypes.bool,
    encodeSpecialCharacters: PropTypes.bool,
    htmlAttributes: PropTypes.object,
    link: PropTypes.arrayOf(PropTypes.object),
    meta: PropTypes.arrayOf(PropTypes.object),
    noscript: PropTypes.arrayOf(PropTypes.object),
    onChangeClientState: PropTypes.func,
    script: PropTypes.arrayOf(PropTypes.object),
    style: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string,
    titleAttributes: PropTypes.object,
    titleTemplate: PropTypes.string
  }, _class.defaultProps = {
    defer: true,
    encodeSpecialCharacters: true
  }, _class.peek = Component.peek, _class.rewind = function () {
    var mappedState = Component.rewind();

    if (!mappedState) {
      // provide fallback if mappedState is undefined
      mappedState = mapStateOnServer({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: true,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
      });
    }

    return mappedState;
  }, _temp;
};

var NullComponent = function NullComponent() {
  return null;
};

var HelmetSideEffects = lib(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);
var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

function SEO(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description,
      _ref$noRobots = _ref.noRobots,
      noRobots = _ref$noRobots === void 0 ? false : _ref$noRobots,
      pathname = _ref.pathname,
      _ref$websiteName = _ref.websiteName,
      websiteName = _ref$websiteName === void 0 ? process.env.GATSBY_CU_NAME : _ref$websiteName;
  var URL = "".concat(process.env.GATSBY_WEBSITE_URL, "/").concat(pathname);
  var IMAGE = "".concat(process.env.GATSBY_WEBSITE_URL, "/images/logo.svg");
  var TITLE = "";

  if (websiteName === "nas_jrb") {
    TITLE = "INSTEP ";
  } else {
    TITLE = websiteName;
  }

  if (pathname) {
    TITLE = "".concat(TITLE, " - ").concat(pathname);
  } else {
    TITLE = "".concat(websiteName, " - Homepage");
  }

  return /*#__PURE__*/React__default$1["default"].createElement(HelmetExport, {
    htmlAttributes: {
      lang: "en"
    },
    title: TITLE,
    titleTemplate: TITLE
  }, /*#__PURE__*/React__default$1["default"].createElement("meta", {
    httpEquiv: "Content-Type",
    content: "text/html; charset=utf-8"
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "title",
    content: TITLE
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "description",
    content: description
  }), noRobots && /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "robots",
    content: "noindex,nofollow"
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    itemProp: "name",
    content: TITLE
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    itemProp: "description",
    content: description
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    itemProp: "image",
    content: IMAGE
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    property: "og:url",
    content: URL
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    property: "og:type",
    content: "website"
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    property: "og:title",
    content: TITLE
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    property: "og:description",
    content: description
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    property: "og:image",
    content: IMAGE
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "twitter:title",
    content: TITLE
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "twitter:description",
    content: description
  }), /*#__PURE__*/React__default$1["default"].createElement("meta", {
    name: "twitter:image",
    content: IMAGE
  }), /*#__PURE__*/React__default$1["default"].createElement("link", {
    rel: "canonical",
    href: URL
  }));
}

function ErrorView() {
  return /*#__PURE__*/React__default$1["default"].createElement(Error$1, {
    title: "Oops, could not find the page"
  });
}

var Content = withErrorBoundary(function (_ref) {
  var render = _ref.render,
      data = _ref.data;
  return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, render(data.page));
}, {
  FallbackComponent: ErrorView
});

function Page(_ref) {
  var pathname = _ref.pathname,
      _ref$cms = _ref.cms,
      cms = _ref$cms === void 0 ? {} : _ref$cms,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      children = _ref.children,
      doChangeThemes = _ref.doChangeThemes,
      theme = _ref.theme,
      _ref$speedBumpStyles = _ref.speedBumpStyles,
      speedBumpStyles = _ref$speedBumpStyles === void 0 ? {} : _ref$speedBumpStyles,
      _ref$footerOptions = _ref.footerOptions,
      footerOptions = _ref$footerOptions === void 0 ? {
    businessCustomLogos: []
  } : _ref$footerOptions,
      _ref$headerActiveLogo = _ref.headerActiveLogoReplaceImageWithAfterBreakpoint,
      headerActiveLogoReplaceImageWithAfterBreakpoint = _ref$headerActiveLogo === void 0 ? "" : _ref$headerActiveLogo,
      _ref$headerDesktopVar = _ref.headerDesktopVariant,
      headerDesktopVariant = _ref$headerDesktopVar === void 0 ? headerDesktopVariantTypes.STANDARD : _ref$headerDesktopVar,
      _ref$headerCompressed = _ref.headerCompressedVariant,
      headerCompressedVariant = _ref$headerCompressed === void 0 ? headerCompressedVariantTypes.STANDARD : _ref$headerCompressed,
      _ref$headerMobileVari = _ref.headerMobileVariant,
      headerMobileVariant = _ref$headerMobileVari === void 0 ? headerMobileVariantTypes.STANDARD : _ref$headerMobileVari,
      _ref$headerDropdownLo = _ref.headerDropdownLoginButtonStyles,
      headerDropdownLoginButtonStyles = _ref$headerDropdownLo === void 0 ? {} : _ref$headerDropdownLo,
      _ref$backgroundHeader = _ref.backgroundHeader,
      backgroundHeader = _ref$backgroundHeader === void 0 ? colorsTypes.WHITE : _ref$backgroundHeader,
      _ref$headerActiveBack = _ref.headerActiveBackground,
      headerActiveBackground = _ref$headerActiveBack === void 0 ? colorsTypes.WHITE : _ref$headerActiveBack,
      _ref$headerHoverActiv = _ref.headerHoverActiveBackground,
      headerHoverActiveBackground = _ref$headerHoverActiv === void 0 ? colorsTypes.WHITE : _ref$headerHoverActiv,
      _ref$backgroundMenuHe = _ref.backgroundMenuHeader,
      backgroundMenuHeader = _ref$backgroundMenuHe === void 0 ? colorsTypes.WHITE : _ref$backgroundMenuHe,
      _ref$backgroundBreakp = _ref.backgroundBreakpointHeader,
      backgroundBreakpointHeader = _ref$backgroundBreakp === void 0 ? 20 : _ref$backgroundBreakp,
      _ref$hoverBackgroundH = _ref.hoverBackgroundHeader,
      hoverBackgroundHeader = _ref$hoverBackgroundH === void 0 ? colorsTypes.WHITE : _ref$hoverBackgroundH,
      _ref$backgroundAfterB = _ref.backgroundAfterBreakpointHoverHeader,
      backgroundAfterBreakpointHoverHeader = _ref$backgroundAfterB === void 0 ? colorsTypes.WHITE : _ref$backgroundAfterB,
      _ref$menuSubLinksList = _ref.menuSubLinksListBorderColorHeader,
      menuSubLinksListBorderColorHeader = _ref$menuSubLinksList === void 0 ? colorsTypes.PRIMARY : _ref$menuSubLinksList,
      _ref$menuSubLinksList2 = _ref.menuSubLinksListBackgroundHeader,
      menuSubLinksListBackgroundHeader = _ref$menuSubLinksList2 === void 0 ? colorsTypes.PRIMARY_VERY_ULTRA_LIGHT : _ref$menuSubLinksList2,
      _ref$menuSubLinksTitl = _ref.menuSubLinksTitleColorHeader,
      menuSubLinksTitleColorHeader = _ref$menuSubLinksTitl === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$menuSubLinksTitl,
      _ref$subLinksItemActi = _ref.subLinksItemActiveTitleColorHeader,
      subLinksItemActiveTitleColorHeader = _ref$subLinksItemActi === void 0 ? colorsTypes.PRIMARY_SEMI_DARK : _ref$subLinksItemActi,
      _ref$menuSubLinksItem = _ref.menuSubLinksItemTitleColorHeader,
      menuSubLinksItemTitleColorHeader = _ref$menuSubLinksItem === void 0 ? colorsTypes.PRIMARY_ULTRA_DARK : _ref$menuSubLinksItem,
      _ref$headerBackground = _ref.headerBackgroundAfterBreakpoint,
      headerBackgroundAfterBreakpoint = _ref$headerBackground === void 0 ? colorsTypes.WHITE : _ref$headerBackground,
      _ref$headerTransparen = _ref.headerTransparentBackground,
      headerTransparentBackground = _ref$headerTransparen === void 0 ? colorsTypes.TRANSPARENT : _ref$headerTransparen,
      _ref$headerHoverTrans = _ref.headerHoverTransparentBackground,
      headerHoverTransparentBackground = _ref$headerHoverTrans === void 0 ? colorsTypes.TRANSPARENT : _ref$headerHoverTrans,
      _ref$headerLoginButto = _ref.headerLoginButtonIsScrollChangeColorButton,
      headerLoginButtonIsScrollChangeColorButton = _ref$headerLoginButto === void 0 ? false : _ref$headerLoginButto,
      _ref$headerLoginButto2 = _ref.headerLoginButtonScrollBackground,
      headerLoginButtonScrollBackground = _ref$headerLoginButto2 === void 0 ? colorsTypes.WHITE : _ref$headerLoginButto2,
      _ref$headerLoginButto3 = _ref.headerLoginButtonScrollBackgroundAfterScroll,
      headerLoginButtonScrollBackgroundAfterScroll = _ref$headerLoginButto3 === void 0 ? colorsTypes.PRIMARY_DARK : _ref$headerLoginButto3,
      _ref$topIndicatorHead = _ref.topIndicatorHeader,
      topIndicatorHeader = _ref$topIndicatorHead === void 0 ? true : _ref$topIndicatorHead,
      _ref$transparentHeade = _ref.transparentHeader,
      transparentHeader = _ref$transparentHeade === void 0 ? false : _ref$transparentHeade,
      _ref$isTopBorder = _ref.isTopBorder,
      isTopBorder = _ref$isTopBorder === void 0 ? false : _ref$isTopBorder,
      _ref$forceShowHeader = _ref.forceShowHeader,
      forceShowHeader = _ref$forceShowHeader === void 0 ? false : _ref$forceShowHeader,
      _ref$floatHeader = _ref.floatHeader,
      floatHeader = _ref$floatHeader === void 0 ? false : _ref$floatHeader,
      _ref$forceShowColorHe = _ref.forceShowColorHeader,
      forceShowColorHeader = _ref$forceShowColorHe === void 0 ? false : _ref$forceShowColorHe,
      _ref$forceShowHoverHe = _ref.forceShowHoverHeader,
      forceShowHoverHeader = _ref$forceShowHoverHe === void 0 ? false : _ref$forceShowHoverHe,
      _ref$grayscaleHeader = _ref.grayscaleHeader,
      grayscaleHeader = _ref$grayscaleHeader === void 0 ? false : _ref$grayscaleHeader,
      _ref$darkHeader = _ref.darkHeader,
      darkHeader = _ref$darkHeader === void 0 ? false : _ref$darkHeader,
      _ref$backgroundScreen = _ref.backgroundScreenHeader,
      backgroundScreenHeader = _ref$backgroundScreen === void 0 ? false : _ref$backgroundScreen,
      _ref$forceCompressHea = _ref.forceCompressHeader,
      forceCompressHeader = _ref$forceCompressHea === void 0 ? false : _ref$forceCompressHea,
      _ref$forceShowItemsHe = _ref.forceShowItemsHeader,
      forceShowItemsHeader = _ref$forceShowItemsHe === void 0 ? true : _ref$forceShowItemsHe,
      _ref$noFilterLogoHead = _ref.noFilterLogoHeader,
      noFilterLogoHeader = _ref$noFilterLogoHead === void 0 ? false : _ref$noFilterLogoHead,
      _ref$headerNoFilterMe = _ref.headerNoFilterMenuIcon,
      headerNoFilterMenuIcon = _ref$headerNoFilterMe === void 0 ? false : _ref$headerNoFilterMe,
      _ref$headerForceFilte = _ref.headerForceFilterMenuIcon,
      headerForceFilterMenuIcon = _ref$headerForceFilte === void 0 ? false : _ref$headerForceFilte,
      _ref$headerLoginButto4 = _ref.headerLoginButtonStyles,
      headerLoginButtonStyles = _ref$headerLoginButto4 === void 0 ? {} : _ref$headerLoginButto4,
      _ref$navigationOption = _ref.navigationOptions,
      navigationOptions = _ref$navigationOption === void 0 ? {} : _ref$navigationOption,
      _ref$navigationMenuOp = _ref.navigationMenuOptions,
      navigationMenuOptions = _ref$navigationMenuOp === void 0 ? {
    menuActiveBorderColor: colorsTypes.PRIMARY,
    menuHoverBorderColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubLinksTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTitleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    menuSubItemTitleActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextActiveColor: colorsTypes.PRIMARY,
    menuSubItemTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subMenuBackgroundColor: colorsTypes.TRANSPARENT,
    subMenuActiveBackgroundColor: colorsTypes.TRANSPARENT,
    itemBackgroundColor: colorsTypes.WHITE,
    dropdownHoverBackground: colorsVariantsTypes.HIGHT_LIGHT_PRIMARY,
    dropdownSeparationFromTop: 20,
    dropdownSeparationFromBottom: 50
  } : _ref$navigationMenuOp,
      _ref$headerMenuIconSt = _ref.headerMenuIconStyles,
      headerMenuIconStyles = _ref$headerMenuIconSt === void 0 ? {} : _ref$headerMenuIconSt,
      _ref$headerActiveLogo2 = _ref.headerActiveLogoFilterEffect,
      headerActiveLogoFilterEffect = _ref$headerActiveLogo2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerActiveLogo2,
      _ref$headerActiveLogo3 = _ref.headerActiveLogoReplaceImageWith,
      headerActiveLogoReplaceImageWith = _ref$headerActiveLogo3 === void 0 ? "" : _ref$headerActiveLogo3,
      _ref$headerLogoFilter = _ref.headerLogoFilterEffect,
      headerLogoFilterEffect = _ref$headerLogoFilter === void 0 ? [] : _ref$headerLogoFilter,
      _ref$headerMobileActi = _ref.headerMobileActiveLogoReplaceImageWith,
      headerMobileActiveLogoReplaceImageWith = _ref$headerMobileActi === void 0 ? "" : _ref$headerMobileActi,
      _ref$headerMobileFilt = _ref.headerMobileFilterEffect,
      headerMobileFilterEffect = _ref$headerMobileFilt === void 0 ? [] : _ref$headerMobileFilt,
      _ref$headerMobileActi2 = _ref.headerMobileActiveLogoReplaceImageWithAfterBreakpoint,
      headerMobileActiveLogoReplaceImageWithAfterBreakpoint = _ref$headerMobileActi2 === void 0 ? "" : _ref$headerMobileActi2,
      _ref$headerMobileForc = _ref.headerMobileForceShow,
      headerMobileForceShow = _ref$headerMobileForc === void 0 ? false : _ref$headerMobileForc,
      _ref$headerMobileTran = _ref.headerMobileTransparent,
      headerMobileTransparent = _ref$headerMobileTran === void 0 ? false : _ref$headerMobileTran,
      _ref$headerMobileNoFi = _ref.headerMobileNoFilterLogo,
      headerMobileNoFilterLogo = _ref$headerMobileNoFi === void 0 ? false : _ref$headerMobileNoFi,
      _ref$headerMobileNoFi2 = _ref.headerMobileNoFilterMenuIcon,
      headerMobileNoFilterMenuIcon = _ref$headerMobileNoFi2 === void 0 ? false : _ref$headerMobileNoFi2,
      _ref$headerMobileForc2 = _ref.headerMobileForceFilterMenuIcon,
      headerMobileForceFilterMenuIcon = _ref$headerMobileForc2 === void 0 ? false : _ref$headerMobileForc2,
      _ref$headerMobileLogi = _ref.headerMobileLoginButtonIsScrollChangeColorButton,
      headerMobileLoginButtonIsScrollChangeColorButton = _ref$headerMobileLogi === void 0 ? false : _ref$headerMobileLogi,
      _ref$headerMobileLogo = _ref.headerMobileLogoReplaceImageWith,
      headerMobileLogoReplaceImageWith = _ref$headerMobileLogo === void 0 ? undefined : _ref$headerMobileLogo,
      _ref$headerMobileLogo2 = _ref.headerMobileLogoReplaceImageWithAfterBreakpoint,
      headerMobileLogoReplaceImageWithAfterBreakpoint = _ref$headerMobileLogo2 === void 0 ? undefined : _ref$headerMobileLogo2,
      _ref$headerMobileLogo3 = _ref.headerMobileLogoFilter,
      headerMobileLogoFilter = _ref$headerMobileLogo3 === void 0 ? undefined : _ref$headerMobileLogo3,
      _ref$headerMobileLogo4 = _ref.headerMobileLogoFilterEffectAfterScroll,
      headerMobileLogoFilterEffectAfterScroll = _ref$headerMobileLogo4 === void 0 ? [] : _ref$headerMobileLogo4,
      _ref$headerMobileFilt2 = _ref.headerMobileFilterEffectAfterScroll,
      headerMobileFilterEffectAfterScroll = _ref$headerMobileFilt2 === void 0 ? [] : _ref$headerMobileFilt2,
      _ref$headerMobileLogo5 = _ref.headerMobileLogoFilterEffect,
      headerMobileLogoFilterEffect = _ref$headerMobileLogo5 === void 0 ? [] : _ref$headerMobileLogo5,
      _ref$headerMobileActi3 = _ref.headerMobileActiveLogoFilterEffectAfterScroll,
      headerMobileActiveLogoFilterEffectAfterScroll = _ref$headerMobileActi3 === void 0 ? [] : _ref$headerMobileActi3,
      _ref$headerMobileMenu = _ref.headerMobileMenuIconFilterEffect,
      headerMobileMenuIconFilterEffect = _ref$headerMobileMenu === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileMenu,
      _ref$headerMobileMenu2 = _ref.headerMobileMenuIconFilterEffectAfterScroll,
      headerMobileMenuIconFilterEffectAfterScroll = _ref$headerMobileMenu2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileMenu2,
      _ref$headerMobileMenu3 = _ref.headerMobileMenuIconActiveFilterEffectAfterScroll,
      headerMobileMenuIconActiveFilterEffectAfterScroll = _ref$headerMobileMenu3 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileMenu3,
      _ref$headerMenuIconFi = _ref.headerMenuIconFilterEffect,
      headerMenuIconFilterEffect = _ref$headerMenuIconFi === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMenuIconFi,
      _ref$headerMenuIconFi2 = _ref.headerMenuIconFilterEffectAfterScroll,
      headerMenuIconFilterEffectAfterScroll = _ref$headerMenuIconFi2 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMenuIconFi2,
      _ref$headerMenuIconAc = _ref.headerMenuIconActiveFilterEffectAfterScroll,
      headerMenuIconActiveFilterEffectAfterScroll = _ref$headerMenuIconAc === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMenuIconAc,
      _ref$headerMobileActi4 = _ref.headerMobileActiveLogoFilterEffect,
      headerMobileActiveLogoFilterEffect = _ref$headerMobileActi4 === void 0 ? ["invert()", "grayscale(1)", "saturate(0)"] : _ref$headerMobileActi4,
      _ref$headerMobileLogi2 = _ref.headerMobileLoginButtonStyles,
      headerMobileLoginButtonStyles = _ref$headerMobileLogi2 === void 0 ? {} : _ref$headerMobileLogi2,
      _ref$headerMobileMenu4 = _ref.headerMobileMenuIconStyles,
      headerMobileMenuIconStyles = _ref$headerMobileMenu4 === void 0 ? {} : _ref$headerMobileMenu4,
      _ref$headerMobileBack = _ref.headerMobileBackgroundMenu,
      headerMobileBackgroundMenu = _ref$headerMobileBack === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack,
      _ref$headerMobileLogi3 = _ref.headerMobileLoginButtonScrollBackgroundAfterScroll,
      headerMobileLoginButtonScrollBackgroundAfterScroll = _ref$headerMobileLogi3 === void 0 ? colorsTypes.PRIMARY_DARK : _ref$headerMobileLogi3,
      _ref$headerMobileLogi4 = _ref.headerMobileLoginButtonScrollBackground,
      headerMobileLoginButtonScrollBackground = _ref$headerMobileLogi4 === void 0 ? colorsTypes.WHITE : _ref$headerMobileLogi4,
      _ref$headerMobileBack2 = _ref.headerMobileBackground,
      headerMobileBackground = _ref$headerMobileBack2 === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack2,
      _ref$headerMobileBack3 = _ref.headerMobileBackgroundAfterBreakpoint,
      headerMobileBackgroundAfterBreakpoint = _ref$headerMobileBack3 === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack3,
      _ref$headerMobileActi5 = _ref.headerMobileActiveBackground,
      headerMobileActiveBackground = _ref$headerMobileActi5 === void 0 ? colorsTypes.WHITE : _ref$headerMobileActi5,
      _ref$headerMobileTran2 = _ref.headerMobileTransparentBackground,
      headerMobileTransparentBackground = _ref$headerMobileTran2 === void 0 ? colorsTypes.TRANSPARENT : _ref$headerMobileTran2,
      _ref$headerMobileHove = _ref.headerMobileHoverBackground,
      headerMobileHoverBackground = _ref$headerMobileHove === void 0 ? colorsTypes.WHITE : _ref$headerMobileHove,
      _ref$headerMobileHove2 = _ref.headerMobileHoverFloatBackground,
      headerMobileHoverFloatBackground = _ref$headerMobileHove2 === void 0 ? colorsTypes.WHITE : _ref$headerMobileHove2,
      _ref$headerMobileHove3 = _ref.headerMobileHoverActiveBackground,
      headerMobileHoverActiveBackground = _ref$headerMobileHove3 === void 0 ? colorsTypes.WHITE : _ref$headerMobileHove3,
      _ref$headerMobileBack4 = _ref.headerMobileBackgroundAfterBreakpointHover,
      headerMobileBackgroundAfterBreakpointHover = _ref$headerMobileBack4 === void 0 ? colorsTypes.WHITE : _ref$headerMobileBack4,
      _ref$headerMobileHove4 = _ref.headerMobileHoverTransparentBackground,
      headerMobileHoverTransparentBackground = _ref$headerMobileHove4 === void 0 ? colorsTypes.TRANSPARENT : _ref$headerMobileHove4,
      _ref$isDynamic = _ref.isDynamic,
      isDynamic = _ref$isDynamic === void 0 ? false : _ref$isDynamic;

  var onUseFetch = function onUseFetch() {
    var key = cms.pageId || pathname;
    var cachedPage = getQueryClient().getQueryCache().find(key);
    return fetchCMSPage({
      pageId: key,
      isDynamicPage: cms.isDynamicPage,
      pageData: cms.pageData,
      isCachedPage: !!(cachedPage && cachedPage.state.data && !cachedPage.state.data.fallback)
    });
  };

  var _useFetch = useFetch(cms.pageId || pathname, onUseFetch),
      isLoading = _useFetch.isLoading,
      data = _useFetch.data,
      error = _useFetch.error;

  var isErrorAndPageIsNotCached = error && !data;
  var isErrorButFallbackDataWillDisplayed = !error && data && data.fallback;
  var layoutOptions = {
    //  HEADER  –>  DESKTOP
    headerActiveLogoReplaceImageWith: headerActiveLogoReplaceImageWith,
    headerMobileActiveLogoReplaceImageWithAfterBreakpoint: headerMobileActiveLogoReplaceImageWithAfterBreakpoint,
    headerActiveLogoReplaceImageWithAfterBreakpoint: headerActiveLogoReplaceImageWithAfterBreakpoint,
    headerMenuIconStyles: headerMenuIconStyles,
    headerLoginButtonIsScrollChangeColorButton: headerLoginButtonIsScrollChangeColorButton,
    headerLoginButtonScrollBackgroundAfterScroll: headerLoginButtonScrollBackgroundAfterScroll,
    headerHoverActiveBackground: headerHoverActiveBackground,
    headerLoginButtonScrollBackground: headerLoginButtonScrollBackground,
    headerActiveBackground: headerActiveBackground,
    headerNoFilterMenuIcon: headerNoFilterMenuIcon,
    headerForceFilterMenuIcon: headerForceFilterMenuIcon,
    headerTransparentBackground: headerTransparentBackground,
    headerHoverTransparentBackground: headerHoverTransparentBackground,
    headerBackgroundAfterBreakpoint: headerBackgroundAfterBreakpoint,
    headerDropdownLoginButtonStyles: headerDropdownLoginButtonStyles,
    headerDesktopVariant: headerDesktopVariant,
    headerCompressedVariant: headerCompressedVariant,
    headerMobileVariant: headerMobileVariant,
    navigationOptions: navigationOptions,
    pathname: pathname,
    config: config,
    transparentHeader: transparentHeader,
    isTopBorder: isTopBorder,
    hoverBackgroundHeader: hoverBackgroundHeader,
    backgroundAfterBreakpointHoverHeader: backgroundAfterBreakpointHoverHeader,
    backgroundBreakpointHeader: backgroundBreakpointHeader,
    forceShowHoverHeader: forceShowHoverHeader,
    forceShowHeader: forceShowHeader,
    forceShowItemsHeader: forceShowItemsHeader,
    forceShowColorHeader: forceShowColorHeader,
    menuSubLinksTitleColorHeader: menuSubLinksTitleColorHeader,
    menuSubLinksItemTitleColorHeader: menuSubLinksItemTitleColorHeader,
    navigationMenuOptions: navigationMenuOptions,
    subLinksItemActiveTitleColorHeader: subLinksItemActiveTitleColorHeader,
    menuSubLinksListBorderColorHeader: menuSubLinksListBorderColorHeader,
    menuSubLinksListBackgroundHeader: menuSubLinksListBackgroundHeader,
    forceCompressHeader: forceCompressHeader,
    floatHeader: floatHeader,
    backgroundHeader: backgroundHeader,
    grayscaleHeader: grayscaleHeader,
    darkHeader: darkHeader,
    noFilterLogoHeader: noFilterLogoHeader,
    backgroundMenuHeader: backgroundMenuHeader,
    backgroundScreenHeader: backgroundScreenHeader,
    headerLoginButtonStyles: headerLoginButtonStyles,
    headerLogoFilterEffect: headerLogoFilterEffect,
    topIndicatorHeader: topIndicatorHeader,
    footerOptions: footerOptions,
    fallback: false,
    page: {
      MetaData: {
        title: "",
        description: "",
        noRobots: false
      }
    },
    header: {},
    footer: {},
    theme: {},
    //  HEADER  –>  MOBILE
    headerMobileActiveLogoReplaceImageWith: headerMobileActiveLogoReplaceImageWith,
    headerMobileMenuIconFilterEffect: headerMobileMenuIconFilterEffect,
    headerMobileMenuIconFilterEffectAfterScroll: headerMobileMenuIconFilterEffectAfterScroll,
    headerMobileMenuIconActiveFilterEffectAfterScroll: headerMobileMenuIconActiveFilterEffectAfterScroll,
    headerMenuIconFilterEffect: headerMenuIconFilterEffect,
    headerMenuIconFilterEffectAfterScroll: headerMenuIconFilterEffectAfterScroll,
    headerMenuIconActiveFilterEffectAfterScroll: headerMenuIconActiveFilterEffectAfterScroll,
    headerMobileActiveLogoFilterEffectAfterScroll: headerMobileActiveLogoFilterEffectAfterScroll,
    headerMobileActiveLogoFilterEffect: headerMobileActiveLogoFilterEffect,
    headerActiveLogoFilterEffect: headerActiveLogoFilterEffect,
    headerMobileLoginButtonIsScrollChangeColorButton: headerMobileLoginButtonIsScrollChangeColorButton,
    headerMobileLoginButtonScrollBackgroundAfterScroll: headerMobileLoginButtonScrollBackgroundAfterScroll,
    headerMobileForceShow: headerMobileForceShow,
    headerMobileFilterEffectAfterScroll: headerMobileFilterEffectAfterScroll,
    headerMobileFilterEffect: headerMobileFilterEffect,
    headerMobileTransparent: headerMobileTransparent,
    headerMobileNoFilterLogo: headerMobileNoFilterLogo,
    headerMobileNoFilterMenuIcon: headerMobileNoFilterMenuIcon,
    headerMobileForceFilterMenuIcon: headerMobileForceFilterMenuIcon,
    headerMobileBackgroundMenu: headerMobileBackgroundMenu,
    headerMobileBackground: headerMobileBackground,
    headerMobileActiveBackground: headerMobileActiveBackground,
    headerMobileHoverActiveBackground: headerMobileHoverActiveBackground,
    headerMobileBackgroundAfterBreakpoint: headerMobileBackgroundAfterBreakpoint,
    headerMobileTransparentBackground: headerMobileTransparentBackground,
    headerMobileHoverFloatBackground: headerMobileHoverFloatBackground,
    headerMobileHoverBackground: headerMobileHoverBackground,
    headerMobileBackgroundAfterBreakpointHover: headerMobileBackgroundAfterBreakpointHover,
    headerMobileLoginButtonScrollBackground: headerMobileLoginButtonScrollBackground,
    headerMobileHoverTransparentBackground: headerMobileHoverTransparentBackground,
    headerMobileLogoReplaceImageWith: headerMobileLogoReplaceImageWith,
    headerMobileLogoReplaceImageWithAfterBreakpoint: headerMobileLogoReplaceImageWithAfterBreakpoint,
    headerMobileLogoFilter: headerMobileLogoFilter,
    headerMobileLogoFilterEffect: headerMobileLogoFilterEffect,
    headerMobileLogoFilterEffectAfterScroll: headerMobileLogoFilterEffectAfterScroll,
    headerMobileLoginButtonStyles: headerMobileLoginButtonStyles,
    headerMobileMenuIconStyles: headerMobileMenuIconStyles,
    isDynamic: isDynamic
  };

  if (data) {
    var fallback = data.fallback,
        page = data.page,
        layout = data.layout,
        themeData = data.theme;
    if (fallback) layoutOptions.fallback = fallback;
    if (page) layoutOptions.page = page;
    if (layout.Header) layoutOptions.header = layout.Header;
    if (layout.Footer) layoutOptions.footer = layout.Footer;
    if (themeData) layoutOptions.theme = themeData;
  }

  React.useEffect(function () {
    if (!lodash.isEmpty(data) && !lodash.isEmpty(data === null || data === void 0 ? void 0 : data.theme)) {
      var _data$theme, _data$theme2, _data$theme3, _data$theme4, _data$theme4$Theme, _data$theme5, _data$theme5$Theme, _data$theme6, _data$theme6$Theme;

      var themeCasted = {
        name: themeVariantsTypes.Default,
        colors: (data === null || data === void 0 ? void 0 : (_data$theme = data.theme) === null || _data$theme === void 0 ? void 0 : _data$theme.Colors) || {},
        fonts: {
          sizes: (data === null || data === void 0 ? void 0 : (_data$theme2 = data.theme) === null || _data$theme2 === void 0 ? void 0 : _data$theme2.FontSizes) || [],
          families: (data === null || data === void 0 ? void 0 : (_data$theme3 = data.theme) === null || _data$theme3 === void 0 ? void 0 : _data$theme3.Fonts) || []
        },
        spacing: {
          container: (data === null || data === void 0 ? void 0 : (_data$theme4 = data.theme) === null || _data$theme4 === void 0 ? void 0 : (_data$theme4$Theme = _data$theme4.Theme) === null || _data$theme4$Theme === void 0 ? void 0 : _data$theme4$Theme.Container) || {},
          padding: (data === null || data === void 0 ? void 0 : (_data$theme5 = data.theme) === null || _data$theme5 === void 0 ? void 0 : (_data$theme5$Theme = _data$theme5.Theme) === null || _data$theme5$Theme === void 0 ? void 0 : _data$theme5$Theme.Padding) || {},
          screens: (data === null || data === void 0 ? void 0 : (_data$theme6 = data.theme) === null || _data$theme6 === void 0 ? void 0 : (_data$theme6$Theme = _data$theme6.Theme) === null || _data$theme6$Theme === void 0 ? void 0 : _data$theme6$Theme.Screens) || {}
        }
      };
      if (doChangeThemes) doChangeThemes([themeCasted]);
    }
  }, [data === null || data === void 0 ? void 0 : data.theme]);
  var errorComponent = /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(SEO, {
    pathname: pathname
  }), /*#__PURE__*/React__default$1["default"].createElement(ErrorView, null));
  var content = /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(SEO, {
    title: layoutOptions.page.MetaData ? layoutOptions.page.MetaData.title : "",
    description: layoutOptions.page.MetaData ? layoutOptions.page.MetaData.description : "",
    noRobots: layoutOptions.page.MetaData ? layoutOptions.page.MetaData.noRobots : false,
    pathname: pathname,
    websiteName: config === null || config === void 0 ? void 0 : config.websiteName
  }), /*#__PURE__*/React__default$1["default"].createElement(SpeedBump, {
    data: layoutOptions.header,
    config: config.speedBump || {},
    speedBumpStyles: speedBumpStyles
  }), /*#__PURE__*/React__default$1["default"].createElement(Content, {
    render: children,
    data: data,
    doChangeThemes: doChangeThemes,
    currentTheme: theme
  }), /*#__PURE__*/React__default$1["default"].createElement(Toast$1, {
    draggable: true,
    limit: 2,
    position: "bottom-left"
  }));
  if (isLoading) content = /*#__PURE__*/React__default$1["default"].createElement(Loader, null);

  if (!!isErrorAndPageIsNotCached || !!isErrorButFallbackDataWillDisplayed) {
    content = errorComponent;
  }

  return /*#__PURE__*/React__default$1["default"].createElement(Layout, _extends$g({
    currentPageName: data && data.urlRoute
  }, layoutOptions), content);
}

function Root(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default$1["default"].createElement(QueryClientProvider, {
    client: getQueryClient()
  }, /*#__PURE__*/React__default$1["default"].createElement(styled.ThemeProvider, {
    theme: {
      breakpoints: breakpoints
    }
  }, children));
}

var _excluded$A = ["variant"];

function PageHeader(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? pageHeaderVariantsTypes.GRADIENTS : _ref$variant,
      props = _objectWithoutProperties$1(_ref, _excluded$A);

  switch (variant) {
    case pageHeaderVariantsTypes.GRADIENT:
      return /*#__PURE__*/React__default$1["default"].createElement(PageHeaderGradient, props);

    case pageHeaderVariantsTypes.GRADIENTS:
      return /*#__PURE__*/React__default$1["default"].createElement(PageHeaderGradients, props);

    default:
      throw new Error("Invalid PageHeader variant: ".concat(variant));
  }
}

var PageHeader$1 = withErrorBoundary(PageHeader);
var _excluded$z = ["pageData", "config", "heroProps", "productsProps", "featureProps", "calloutProps"];

function HomeTemplateV1(_ref) {
  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$z);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({}, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config
  }), function (data) {
    var _data$CalloutMobileAp, _data$HerosList, _data$HerosList2, _data$FeaturesV;

    var calloutVariant = calloutVariantsTypes[lodash.snakeCase(lodash.upperCase((_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type))] || calloutVariantsTypes.MOBILE_APPS;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      variant: ((_data$HerosList = data.HerosList) === null || _data$HerosList === void 0 ? void 0 : _data$HerosList.variant) || heroVariantsTypes.FULL,
      data: ((_data$HerosList2 = data.HerosList) === null || _data$HerosList2 === void 0 ? void 0 : _data$HerosList2.Heros) || data.Heros,
      buttonFill: buttonFillTypes.FILLED,
      buttonWithoutBorderRadius: false,
      descriptionColor: colorsTypes.BLACK,
      buttonHoverBackgroundColor: colorsTypes.ULTRA_DARK,
      buttonHoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonHoverColor: true
    }, heroProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-20 md:tw-mb-40"
    }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      data: data.Products,
      variant: productsVariantsTypes.LIST,
      typeOfItems: productVariantsTypes.OUTLINE
    }, productsProps)), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-20 md:tw-mb-40"
    }), data.FeaturesV2 && ((_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "FeatureV2-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        variant: featureVariantsTypes.V2,
        data: feature
      }, featureProps, {
        buttonStylesProps: _objectSpread2({
          textColor: colorsTypes.WHITE,
          dark: true,
          buttonFill: buttonFillTypes.FILLED,
          buttonHoverColor: true,
          buttonWithoutBorderRadius: false,
          buttonHoverBackgroundColor: colorsTypes.ULTRA_DARK,
          buttonHoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
          buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.buttonStylesProps) || {})
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-mb-20 md:tw-mb-48"
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
      variant: featureVariantsTypes.V1,
      data: data.FeatureV1,
      descriptionColor: colorsTypes.PRIMARY
    }, featureProps, {
      buttonStylesProps: _objectSpread2({
        textColor: colorsTypes.WHITE,
        dark: true,
        buttonFill: buttonFillTypes.FILLED,
        buttonHoverColor: true,
        buttonWithoutBorderRadius: false,
        buttonHoverBackgroundColor: colorsTypes.ULTRA_DARK,
        buttonHoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK
      }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.buttonStylesProps) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-7 sm:tw-my-12"
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariant,
      data: data.CalloutMobileApps[0]
    }, calloutProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-7 sm:tw-my-12"
    })));
  });
}

HomeTemplateV1.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any // calloutMobileProps: PropTypes.any,
  // calloutCompressedProps: PropTypes.any,

};
var _excluded$y = ["pageData", "config", "heroProps", "productsProps", "featureProps", "calloutProps"];

function HomeTemplateV2(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$y);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _data$FeaturesV, _data$CalloutMobileAp;

    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      variant: heroVariantsTypes.CENTRAL,
      data: data.Heros
    }, heroProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-20 md:tw-mb-40"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      data: data.Products,
      variant: productsVariantsTypes.LIST,
      typeOfItems: productVariantsTypes.OUTLINE,
      buttonHoverOutline: true
    }, productsProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-20 md:tw-mb-40"
    }), (data === null || data === void 0 ? void 0 : data.FeaturesV2) && ((_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "FeatureV2-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        variant: featureVariantsTypes.V2,
        data: feature
      }, featureProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-mb-20 md:tw-mb-48"
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: ((_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type) || calloutVariantsTypes.MOBILE_APPS,
      data: data.CalloutMobileApps[0]
    }, calloutProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-7 sm:tw-my-12"
    })));
  });
}

HomeTemplateV2.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  // featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any // calloutMobileProps: PropTypes.any,
  // calloutCompressedProps: PropTypes.any,

};
var _excluded$x = ["pageData", "config", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function HomeTemplateV3(_ref) {
  var _config$speedBump, _config$speedBump2, _otherProps$footerOpt, _config$speedBump3, _otherProps$speedBump, _config$speedBump4, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$x);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    headerCompressedVariant: headerCompressedVariantTypes.STANDARD,
    headerDesktopVariant: headerDesktopVariantTypes.STANDARD,
    headerMobileVariant: headerMobileVariantTypes.STANDARD,
    backgroundHeader: "rgba(32, 0, 9, 0.4)",
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    forceCompressHeader: true,
    noFilterLogoHeader: true,
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    topIndicatorHeader: false
  }, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config,
    headerLoginButtonStyles: _objectSpread2({
      isScrollChangeColorButton: true,
      grayscale: true,
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverGrayscaleFilledTextColor: colorsTypes.BLACK,
      hoverGrayscaleFillBackgroundColor: colorsTypes.WHITE,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    headerDropdownLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledTextColor: colorsTypes.PRIMARY,
      hoverFilledBorderColor: colorsTypes.PRIMARY,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerDropdownLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      homeLogoVisible: false
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$HerosList, _data$HerosList2, _data$FeatureFullBg, _data$FeaturesV, _config$speedBump5;

    var hasProducts = !!data && !lodash.isEmpty(data.Products) && Array.isArray(data.Products) && !!data.Products.length;
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-custom-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      variant: ((_data$HerosList = data.HerosList) === null || _data$HerosList === void 0 ? void 0 : _data$HerosList.variant) || heroVariantsTypes.CAROUSEL,
      data: ((_data$HerosList2 = data.HerosList) === null || _data$HerosList2 === void 0 ? void 0 : _data$HerosList2.Heros) || data.Heros,
      fullScreen: true,
      gradient: "radial-gradient(\n                94.56% 87.43% at 59.93% 95.59%,\n                rgba(249, 240, 242, 0.3) 0%,\n                rgba(79, 0, 23, 0.3) 100%),\n                linear-gradient(\n                  153.01deg,\n                  rgba(0, 0, 0, 0.5) 30.9%,\n                  rgba(0, 0, 0, 0) 86.82%\n                )"
    }, heroProps, {
      settings: _objectSpread2({
        navigation: false
      }, heroProps === null || heroProps === void 0 ? void 0 : heroProps.settings),
      buttonStylesProps: _objectSpread2({
        grayscale: true,
        hoverColor: true,
        withoutBorderRadius: true,
        fill: buttonFillTypes.FILLED,
        fontFamily: fontsFamiliesVariantsTypes.PRIMARY
      }, (heroProps === null || heroProps === void 0 ? void 0 : heroProps.buttonStylesProps) || {})
    })), hasProducts && /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "DIVIDER_PRODUCTS_1 tw-mb-28"
    }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      data: data.Products,
      customGradient: "linear-gradient(var(--primary-150-color) 2.57%, var(--primary-110-color) 95.51%);",
      variant: productsVariantsTypes.HORIZONTAL_COLLECTION,
      typeOfItems: productVariantsTypes.GRADIENT,
      arrowLeftSrc: "https://olb-assets.s3.us-east-2.amazonaws.com/images/arrow-left-desert-valley.svg",
      arrowRightSrc: "https://olb-assets.s3.us-east-2.amazonaws.com/images/arrow-right-desert-valley.svg"
    }, productsProps, (productsProps === null || productsProps === void 0 ? void 0 : productsProps.getData(data)) || {}, {
      buttonStylesProps: _objectSpread2({
        margin: "25px auto",
        minWidth: "160px",
        fill: buttonFillTypes.FILLED,
        withoutBorderRadius: true,
        grayscale: true
      }, (productsProps === null || productsProps === void 0 ? void 0 : productsProps.buttonStylesProps) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "DIVIDER_PRODUCTS_2 tw-mb-".concat(20)
    })), (data === null || data === void 0 ? void 0 : data.FeatureFullBg) && ((_data$FeatureFullBg = data.FeatureFullBg) === null || _data$FeatureFullBg === void 0 ? void 0 : _data$FeatureFullBg.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureFullBg-".concat(index),
        data: feature,
        variant: featureVariantsTypes.V3,
        lineDivideColor: "white"
      }, featureFullProps, {
        buttonStylesProps: _objectSpread2({
          fill: buttonFillTypes.OUTLINE_DARK,
          padding: "10px 20px",
          minWidth: "none",
          withoutBorderRadius: true,
          grayscale: true,
          grayscaleAndOutlineDarkTextColor: colorsTypes.WHITE,
          hoverGrayscaleOutlineDarkTextColor: colorsTypes.PRIMARY,
          hoverGrayscaleAndOutlineDarkTextColor: colorsTypes.PRIMARY,
          grayscaleAndOutlineDarkBackgroundColor: colorsTypes.TRANSPARENT
        }, (featureFullProps === null || featureFullProps === void 0 ? void 0 : featureFullProps.buttonStylesProps) || {})
      }));
    })), (data === null || data === void 0 ? void 0 : data.FeaturesV2) && ((_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureV2-".concat(index),
        variant: featureVariantsTypes.V4,
        data: feature,
        lineDivideColor: colorsTypes.PRIMARY_SEMI_DARK
      }, featureProps, {
        buttonStylesProps: _objectSpread2({
          fill: buttonFillTypes.OUTLINE_DARK,
          padding: "10px 20px",
          minWidth: "none",
          withoutBorderRadius: true,
          grayscale: true
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.buttonStylesProps) || {})
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      ultraLight: true,
      darkTitle: true,
      darkDescription: true,
      grayscaleDescription: true,
      variant: calloutVariantsTypes.IMAGE_WITH_GRADIENT,
      data: data.FeatureV1
    }, calloutProps, {
      buttonStylesProps: _objectSpread2({
        padding: "10px 20px",
        minWidth: "none",
        withoutBorderRadius: true,
        transparent: true
      }, (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.buttonStylesProps) || {})
    })), (data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && data.CalloutMobileApps.map(function (element, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
        key: "Mobile_Apps_".concat(index),
        variant: element.Type || calloutVariantsTypes.MOBILE_APPS,
        data: element
      }, calloutMobileProps));
    }), (data === null || data === void 0 ? void 0 : data.CompressedContent) && (data === null || data === void 0 ? void 0 : data.CompressedContent.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement(CompressedContent, _extends$g({
      data: data
    }, calloutCompressedProps, {
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump5 = config.speedBump) !== null && _config$speedBump5 !== void 0 && _config$speedBump5.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverBackgroundColor: colorsTypes.WHITE,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (calloutCompressedProps === null || calloutCompressedProps === void 0 ? void 0 : calloutCompressedProps.buttonCustomStyles) || {})
    })));
  });
}

HomeTemplateV3.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$w = ["pageData", "config", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps"];

function HomeTemplateV4(_ref) {
  var _otherProps$footerOpt;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$w);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    backgroundScreenHeader: true,
    headerLogoFilterEffect: [],
    topIndicatorHeader: false
  }, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config,
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: true
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      homeLogoVisible: false
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _data$HerosList, _data$HerosList2, _data$FeatureFullBg, _data$FeaturesV;

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-custom-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      variant: ((_data$HerosList = data.HerosList) === null || _data$HerosList === void 0 ? void 0 : _data$HerosList.variant) || heroVariantsTypes.CAROUSEL,
      data: ((_data$HerosList2 = data.HerosList) === null || _data$HerosList2 === void 0 ? void 0 : _data$HerosList2.Heros) || data.Heros,
      fullScreen: true,
      buttonHoverBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonHoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonFill: buttonFillTypes.FILLED,
      buttonGrayscale: true,
      buttonHoverColor: true,
      buttonWithoutBorderRadius: true,
      gradient: "radial-gradient(\n                80.81% 115.03% at 64.44% 85.88%,\n                rgba(3, 6, 33, 0) 0%,\n                rgba(3, 13, 33, 0.5) 100%)"
    }, heroProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-".concat(28)
    }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      data: data.Products,
      centralLink: data.CentralLink,
      variant: productsVariantsTypes.LIST,
      typeOfItems: productVariantsTypes.DIVIDED_BY_GRADIENT,
      productGradientColors: [colorsTypes.PRIMARY_SEMI_DARK, colorsTypes.PRIMARY_SEMI_DARK],
      buttonHoverOutline: true,
      buttonWithoutBorderRadius: true
    }, productsProps, {
      buttonStylesProps: _objectSpread2({
        hoverColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverOutlineTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultTextColor: colorsTypes.PRIMARY_SEMI_DARK
      }, (productsProps === null || productsProps === void 0 ? void 0 : productsProps.buttonStylesProps) || {})
    })), (data === null || data === void 0 ? void 0 : data.FeatureFullBg) && ((_data$FeatureFullBg = data.FeatureFullBg) === null || _data$FeatureFullBg === void 0 ? void 0 : _data$FeatureFullBg.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureV3-".concat(index),
        data: feature,
        variant: featureVariantsTypes.V3,
        buttonFill: buttonFillTypes.FILLED,
        lineDivideColor: colorsTypes.WHITE
      }, featureFullProps, {
        buttonStylesProps: _objectSpread2({
          padding: "10px 20px",
          minWidth: "none",
          withoutBorderRadius: true,
          filledBackgroundColor: colorsTypes.TRANSPARENT,
          filledBorderColor: colorsTypes.WHITE,
          filledTextColor: colorsTypes.WHITE,
          hoverBackgroundColor: colorsTypes.WHITE,
          hoverFilledTextColor: colorsTypes.WHITE,
          hoverDefaultBorderColor: colorsTypes.WHITE,
          hoverFilledBorderColor: colorsTypes.WHITE
        }, (featureFullProps === null || featureFullProps === void 0 ? void 0 : featureFullProps.buttonStylesProps) || {})
      }));
    })), (data === null || data === void 0 ? void 0 : data.FeaturesV2) && ((_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureV2-".concat(index),
        variant: featureVariantsTypes.V4,
        data: feature // buttonStyleType={buttonStyleTypes.PILL}
        ,
        buttonFill: buttonFillTypes.FILLED,
        lineDivideColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonStylesProps: {
          padding: "10px 20px",
          minWidth: "none",
          withoutBorderRadius: true,
          filledBackgroundColor: colorsTypes.TRANSPARENT,
          filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
          filledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
          hoverBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
          hoverFilledTextColor: colorsTypes.WHITE,
          hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
          hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK
        }
      }, featureProps));
    })), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      ultraLight: true,
      grayscaleDescription: true,
      variant: calloutVariantsTypes.IMAGE_WITH_GRADIENT,
      data: data.FeatureV1
    }, calloutProps, {
      buttonStylesProps: _objectSpread2({
        padding: "10px 20px",
        minWidth: "none",
        withoutBorderRadius: true,
        filledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledTextColor: colorsTypes.WHITE,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: colorsTypes.WHITE,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        transparent: true
      }, (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.buttonStylesProps) || {})
    })), (data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && data.CalloutMobileApps.map(function (element, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
        key: "Mobile_Apps_".concat(index),
        variant: element.Type || calloutVariantsTypes.MOBILE_APPS,
        data: element
      }, calloutMobileProps));
    }));
  });
}

HomeTemplateV4.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any // calloutCompressedProps: PropTypes.any,

};
var _excluded$v = ["pageData", "config", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps"];

function HomeTemplateV5(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$v);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    pageTitleProps: true,
    darkHeader: true,
    backgroundScreenHeader: true,
    noFilterLogoHeader: true,
    forceShowItemsHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK,
      itemBackgroundColor: colorsTypes.BLACK,
      dropdownSeparationFromBottom: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      styleType: buttonStyleTypes.STANDARD,
      filledBackgroundColor: colorsTypes.SECONDARY,
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledBorderColor: colorsTypes.SECONDARY,
      hoverFilledTextColor: colorsTypes.SECONDARY,
      height: 30,
      padding: "2px 17px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$HerosList, _config$speedBump4, _config$speedBump5, _data$FeatureFullBg, _data$FeaturesV, _data$CalloutMobileAp;

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-custom-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      titleColor: colorsTypes.PRIMARY_ULTRA_DARK // variant={data.HerosList?.variant || heroVariantsTypes.CAROUSEL}
      ,
      variant: heroVariantsTypes.CAROUSEL,
      data: ((_data$HerosList = data.HerosList) === null || _data$HerosList === void 0 ? void 0 : _data$HerosList.Heros) || data.Heros,
      fullScreen: true,
      gradient: "linear-gradient(299.89deg, rgba(147, 131, 87, 0.02) -57.56%, rgba(255, 255, 255, 0.08) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.4))"
    }, heroProps, {
      buttonStylesProps: _objectSpread2({
        fill: buttonFillTypes.FILLED,
        withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
        styleType: buttonStyleTypes.STANDARD,
        filledBackgroundColor: colorsTypes.SECONDARY,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        hoverFilledBorderColor: colorsTypes.SECONDARY,
        hoverFilledTextColor: colorsTypes.SECONDARY,
        height: 50
      }, (heroProps === null || heroProps === void 0 ? void 0 : heroProps.buttonStylesProps) || {}),
      settings: _objectSpread2({
        navigation: false
      }, (heroProps === null || heroProps === void 0 ? void 0 : heroProps.settings) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-".concat(28)
    }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      wrapProducts: true,
      data: data.Products,
      centralLink: data.CentralLink,
      variant: productsVariantsTypes.LIST,
      typeOfItems: productVariantsTypes.DIVIDED_BY_GRADIENT,
      productWidth: 200,
      productMaxWidth: 200,
      colorDivider: colorsTypes.SECONDARY,
      titleColor: colorsVariantsTypes.PRIMARY_ULTRA_DARK,
      subTitleColor: colorsVariantsTypes.PRIMARY_ULTRA_DARK,
      priceColor: colorsVariantsTypes.PRIMARY_ULTRA_DARK,
      priceSubColor: colorsVariantsTypes.PRIMARY,
      dividerOpacity: 1,
      dividerWithoutGradient: true
    }, productsProps, {
      buttonStylesProps: _objectSpread2({
        fill: buttonFillTypes.FILLED,
        withoutBorderRadius: !((_config$speedBump5 = config.speedBump) !== null && _config$speedBump5 !== void 0 && _config$speedBump5.borderWithRadious),
        styleType: buttonStyleTypes.STANDARD,
        filledBackgroundColor: colorsTypes.SECONDARY,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        hoverFilledBorderColor: colorsTypes.SECONDARY,
        hoverFilledTextColor: colorsTypes.SECONDARY,
        padding: "7px 17px"
      }, (productsProps === null || productsProps === void 0 ? void 0 : productsProps.buttonStylesProps) || {})
    })), (data === null || data === void 0 ? void 0 : data.FeatureFullBg) && ((_data$FeatureFullBg = data.FeatureFullBg) === null || _data$FeatureFullBg === void 0 ? void 0 : _data$FeatureFullBg.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureV3-".concat(index),
        variant: featureVariantsTypes.V3,
        data: feature,
        lineDivideColor: colorsTypes.WHITE
      }, featureFullProps, {
        buttonStylesProps: _objectSpread2({
          padding: "10px 20px",
          minWidth: "none",
          transparent: true,
          grayscale: true,
          grayscaleBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
          grayscaleTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleBackgroundColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleTextColor: colorsTypes.WHITE,
          hoverDarkOutlineTextColor: colorsTypes.WHITE
        }, (featureFullProps === null || featureFullProps === void 0 ? void 0 : featureFullProps.buttonStylesProps) || {})
      }));
    })), (data === null || data === void 0 ? void 0 : data.FeaturesV2) && ((_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureV2-".concat(index),
        variant: featureVariantsTypes.V4,
        data: feature,
        lineDivideColor: colorsTypes.SECONDARY
      }, featureProps, {
        buttonStylesProps: _objectSpread2({
          padding: "10px 20px",
          minWidth: "none",
          transparent: true,
          grayscale: true,
          grayscaleBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
          grayscaleTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleBackgroundColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleTextColor: colorsTypes.WHITE,
          hoverDarkOutlineTextColor: colorsTypes.WHITE
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.buttonStylesProps) || {})
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      ultraLight: true,
      primaryTitle: true,
      radial: true,
      withoutOpacity: true,
      variant: calloutVariantsTypes.IMAGE_WITH_GRADIENT,
      data: data.FeatureV1,
      config: config
    }, calloutProps, {
      buttonStylesProps: _objectSpread2({
        padding: "10px 20px",
        minWidth: "none",
        fill: buttonFillTypes.OUTLINE_DARK,
        grayscale: true,
        grayscaleOutlineDarkBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
        grayscaleAndOutlineDarkTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
        hoverGrayscaleOutlineBackgroundColor: colorsTypes.PRIMARY_ULTRA_DARK,
        hoverGrayscaleOutlineBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
        hoverGrayscaleOutlineDarkTextColor: colorsTypes.WHITE
      }, (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.buttonStylesProps) || {})
    })), (data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$CalloutMobileAp = data.CalloutMobileApps) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.map(function (element, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
        key: "Mobile_Apps_".concat(index),
        variant: element.Type || calloutVariantsTypes.MOBILE_APPS,
        data: element
      }, calloutMobileProps, {
        buttonStylesProps: _objectSpread2({
          padding: "10px 20px",
          minWidth: "none",
          fill: buttonFillTypes.OUTLINE_DARK,
          grayscale: true,
          grayscaleOutlineDarkBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
          grayscaleAndOutlineDarkTextColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleOutlineBackgroundColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleOutlineBorderColor: colorsTypes.PRIMARY_ULTRA_DARK,
          hoverGrayscaleOutlineDarkTextColor: colorsTypes.WHITE
        }, (calloutMobileProps === null || calloutMobileProps === void 0 ? void 0 : calloutMobileProps.buttonStylesProps) || {})
      }));
    })));
  });
}

HomeTemplateV5.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any // calloutCompressedProps: PropTypes.any,

};
var _excluded$u = ["pageData", "config", "heroProps", "productsProps", "featureProps", "calloutProps"];

function HomeTemplateV6(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$u);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _data$HerosList, _data$HerosList2, _config$speedBump2, _config$speedBump3, _data$FeaturesV, _config$speedBump5;

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-custom-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      variant: ((_data$HerosList = data.HerosList) === null || _data$HerosList === void 0 ? void 0 : _data$HerosList.variant) || heroVariantsTypes.CAROUSEL_CENTRAL,
      data: ((_data$HerosList2 = data.HerosList) === null || _data$HerosList2 === void 0 ? void 0 : _data$HerosList2.Heros) || data.Heros,
      titleColor: colorsTypes.WHITE,
      subTextColor: colorsTypes.WHITE,
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverGrayscaleFillBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
      hoverGrayscaleBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      transparent: true,
      hoverFilledBorderColor: colorsTypes.ULTRA_LIGHT,
      grayscaleAndOutlineBorderColor: colorsTypes.WHITE,
      grayscaleAndOutlineTextColor: colorsTypes.WHITE,
      darkGrayscaleAndOutlineBorderColor: colorsTypes.WHITE,
      hoverAndNotOutlineTextColor: colorsTypes.WHITE,
      hoverColor: true,
      grayscaleTextColor: true,
      outline: true,
      gradient: "radial-gradient(\n                80.81% 115.03% at 64.44% 85.88%,\n                rgba(3, 6, 33, 0) 0%,\n                rgba(3, 13, 33, 0.5) 100%)"
    }, heroProps, {
      buttonStylesProps: _objectSpread2({
        padding: "10px 25px 10px 25px",
        grayscale: true,
        transparent: true,
        hoverTransparent: true,
        hoverGrayscaleOutlineBorderColor: colorsTypes.SEMI_DARK,
        hoverGrayscaleOutlineDarkTextColor: colorsTypes.SEMI_DARK,
        fill: buttonFillTypes.OUTLINE_DARK,
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        styleType: buttonStyleTypes.NONE,
        height: 50
      }, (heroProps === null || heroProps === void 0 ? void 0 : heroProps.buttonStylesProps) || {}),
      settings: _objectSpread2({
        navigation: false
      }, (heroProps === null || heroProps === void 0 ? void 0 : heroProps.settings) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-20 lg:tw-mb-28"
    }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      priceColor: colorsTypes.PRIMARY,
      priceSubColor: colorsTypes.PRIMARY,
      subTitleColor: colorsTypes.PRIMARY,
      titleColor: colorsTypes.PRIMARY,
      productGrid: "flex",
      wrapProducts: true,
      borderColor: colorsVariantsTypes.ULTRA_LIGHT,
      data: data.Products,
      centralLink: data.CentralLink,
      variant: productsVariantsTypes.LIST,
      typeOfItems: productVariantsTypes.OUTLINE,
      productWidth: 200,
      width: 300,
      productMaxWidth: 200,
      colorDivider: colorsTypes.SECONDARY,
      dividerOpacity: 1,
      dividerWithoutGradient: true
    }, productsProps, {
      buttonStylesProps: _objectSpread2({
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.NONE,
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledTextColor: colorsTypes.WHITE,
        radius: 15,
        padding: "7px 17px"
      }, (productsProps === null || productsProps === void 0 ? void 0 : productsProps.buttonStylesProps) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HOME_TEMPLATE_V6__FEATURES_V2__CONTAINER tw-container"
    }, (_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      var _config$speedBump4;

      return /*#__PURE__*/React__default$1["default"].createElement("div", {
        key: "FeatureV2-".concat(index),
        className: "tw-my-24 lg:tw-my-48"
      }, /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        variant: featureVariantsTypes.V5,
        data: feature,
        buttonFill: buttonFillTypes.FILLED,
        lineDivideColor: colorsTypes.PRIMARY
      }, featureProps, {
        imgStyles: _objectSpread2({
          padding: "0 13%",
          borderRadius: "4em / 1em;"
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.imgStyles) || {}),
        contentStyles: _objectSpread2({
          padding: "20px 13% 10px 13%"
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.contentStyles) || {}),
        descriptionStyles: _objectSpread2({
          padding: "10px 0"
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.descriptionStyles) || {}),
        buttonStylesProps: _objectSpread2({
          fill: buttonFillTypes.FILLED,
          styleType: buttonStyleTypes.NONE,
          withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
          hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
          hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
          hoverFilledTextColor: colorsTypes.WHITE,
          radius: 10
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.buttonStylesProps) || {})
      })));
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "HOME_TEMPLATE_V6__CALLOUT_GRADIENT__CONTAINER tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      ultraLight: true,
      darkTitle: true,
      darkDescription: true,
      grayscaleDescription: true,
      containerPadding: true,
      variant: calloutVariantsTypes.IMAGE_WITH_GRADIENT_AND_PADDING,
      data: data.FeatureV1
    }, calloutProps, {
      buttonStylesProps: _objectSpread2({
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.NONE,
        withoutBorderRadius: !((_config$speedBump5 = config.speedBump) !== null && _config$speedBump5 !== void 0 && _config$speedBump5.borderWithRadious),
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledTextColor: colorsTypes.WHITE,
        radius: 10
      }, (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.buttonStylesProps) || {})
    }))));
  });
}

HomeTemplateV6.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any // calloutMobileProps: PropTypes.any,
  // calloutCompressedProps: PropTypes.any,

};
var _excluded$t = ["id", "pageData", "config", "themes", "variant", "header", "about", "contact", "footer"];

function DynamicPage(_ref) {
  var path = _ref.id,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$themes = _ref.themes,
      appThemes = _ref$themes === void 0 ? [] : _ref$themes,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dynamicTemplatesVersionVariantsTypes.DYNAMIC_TEMPLATE_V2 : _ref$variant,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$about = _ref.about,
      about = _ref$about === void 0 ? null : _ref$about,
      _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? null : _ref$contact,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$t);

  var Component = templates[variant];
  /** @TODO: Redirect to 404 */

  if (!Component) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(ThemeProvider, {
    themes: appThemes
  }, /*#__PURE__*/React__default$1["default"].createElement(Component, _extends$g({
    isDynamic: true,
    className: "DINAMIC_PAGE_COMPONENT",
    header: header,
    about: about,
    contact: contact,
    footer: footer
  }, otherProps, {
    pageData: pageData,
    path: path,
    config: config
  })));
}

var _excluded$s = ["pageData", "config", "variant", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "customContainerClass"];

function HomeTemplateV7(_ref) {
  _ref.pageData;

  var config = _ref.config,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dynamicTemplatesVersionVariantsTypes.DYNAMIC_TEMPLATE_V5 : _ref$variant,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$customContainerC = _ref.customContainerClass,
      customContainerClass = _ref$customContainerC === void 0 ? "" : _ref$customContainerC,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$s);

  return /*#__PURE__*/React__default$1["default"].createElement(React__default$1["default"].Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(DynamicPage, _extends$g({
    customContainerClass: customContainerClass,
    heroProps: heroProps,
    productsProps: productsProps,
    featureFullProps: featureFullProps,
    featureProps: featureProps,
    calloutProps: calloutProps
  }, otherProps, {
    path: "/",
    id: "",
    config: config,
    variant: variant
  })));
}

HomeTemplateV7.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any // calloutMobileProps: PropTypes.any,
  // calloutCompressedProps: PropTypes.any,

};
var _excluded$r = ["pageData", "config", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function HomeTemplateV8(_ref) {
  var _config$speedBump, _config$speedBump2, _otherProps$footerOpt, _config$speedBump3, _otherProps$speedBump, _config$speedBump4, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$r);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    headerCompressedVariant: headerCompressedVariantTypes.STANDARD,
    headerDesktopVariant: headerDesktopVariantTypes.STANDARD,
    headerMobileVariant: headerMobileVariantTypes.STANDARD,
    backgroundHeader: "rgba(32, 0, 9, 0.4)",
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    forceCompressHeader: true,
    noFilterLogoHeader: true,
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    topIndicatorHeader: false
  }, otherProps, {
    cms: {
      pageId: "cu-home-pages",
      pageData: pageData
    },
    pathname: "",
    config: config,
    headerLoginButtonStyles: _objectSpread2({
      isScrollChangeColorButton: true,
      grayscale: true,
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverGrayscaleFilledTextColor: colorsTypes.BLACK,
      hoverGrayscaleFillBackgroundColor: colorsTypes.WHITE,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    headerDropdownLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledTextColor: colorsTypes.PRIMARY,
      hoverFilledBorderColor: colorsTypes.PRIMARY,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerDropdownLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      homeLogoVisible: false
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$HerosList, _data$HerosList2, _data$FeatureFullBg, _data$FeaturesV, _config$speedBump5;

    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-custom-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      variant: ((_data$HerosList = data.HerosList) === null || _data$HerosList === void 0 ? void 0 : _data$HerosList.variant) || heroVariantsTypes.CAROUSEL,
      data: ((_data$HerosList2 = data.HerosList) === null || _data$HerosList2 === void 0 ? void 0 : _data$HerosList2.Heros) || data.Heros,
      fullScreen: true,
      gradient: "radial-gradient(\n                94.56% 87.43% at 59.93% 95.59%,\n                rgba(249, 240, 242, 0.3) 0%,\n                rgba(79, 0, 23, 0.3) 100%),\n                linear-gradient(\n                  153.01deg,\n                  rgba(0, 0, 0, 0.5) 30.9%,\n                  rgba(0, 0, 0, 0) 86.82%\n                )"
    }, heroProps, {
      settings: _objectSpread2({
        navigation: false
      }, heroProps === null || heroProps === void 0 ? void 0 : heroProps.settings),
      buttonStylesProps: _objectSpread2({
        grayscale: true,
        hoverColor: true,
        withoutBorderRadius: true,
        fill: buttonFillTypes.FILLED,
        fontFamily: fontsFamiliesVariantsTypes.PRIMARY
      }, (heroProps === null || heroProps === void 0 ? void 0 : heroProps.buttonStylesProps) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-28"
    }), /*#__PURE__*/React__default$1["default"].createElement(Products, _extends$g({
      customGradient: "linear-gradient(135deg, var(--primary-150-color) 2.57%, var(--primary-110-color) 95.51%)",
      data: data.Products,
      variant: productsVariantsTypes.HORIZONTAL_COLLECTION,
      typeOfItems: productVariantsTypes.GRADIENT,
      arrowLeftSrc: "https://olb-assets.s3.us-east-2.amazonaws.com/images/arrow-left-big-hscu.svg",
      arrowRightSrc: "https://olb-assets.s3.us-east-2.amazonaws.com/images/arrow-right-big-hscu.svg"
    }, productsProps, {
      buttonStylesProps: _objectSpread2({
        margin: "25px auto",
        minWidth: "160px",
        fill: buttonFillTypes.FILLED,
        withoutBorderRadius: true,
        grayscale: true
      }, (productsProps === null || productsProps === void 0 ? void 0 : productsProps.buttonStylesProps) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-mb-".concat(20)
    }), (data === null || data === void 0 ? void 0 : data.FeatureFullBg) && ((_data$FeatureFullBg = data.FeatureFullBg) === null || _data$FeatureFullBg === void 0 ? void 0 : _data$FeatureFullBg.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureFullBg-".concat(index),
        data: feature,
        variant: featureVariantsTypes.V3,
        lineDivideColor: colorsTypes.WHITE
      }, featureFullProps, {
        buttonStylesProps: _objectSpread2({
          fill: buttonFillTypes.OUTLINE_DARK,
          padding: "10px 20px",
          minWidth: "none",
          withoutBorderRadius: true,
          grayscale: true,
          grayscaleAndOutlineDarkTextColor: colorsTypes.WHITE,
          hoverGrayscaleOutlineDarkTextColor: colorsTypes.PRIMARY,
          hoverGrayscaleAndOutlineDarkTextColor: colorsTypes.PRIMARY,
          grayscaleAndOutlineDarkBackgroundColor: colorsTypes.TRANSPARENT
        }, (featureFullProps === null || featureFullProps === void 0 ? void 0 : featureFullProps.buttonStylesProps) || {})
      }));
    })), (data === null || data === void 0 ? void 0 : data.FeaturesV2) && ((_data$FeaturesV = data.FeaturesV2) === null || _data$FeaturesV === void 0 ? void 0 : _data$FeaturesV.map(function (feature, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Feature, _extends$g({
        key: "FeatureV2-".concat(index),
        variant: featureVariantsTypes.V4,
        data: feature,
        lineDivideColor: colorsTypes.PRIMARY_SEMI_DARK
      }, featureProps, {
        buttonStylesProps: _objectSpread2({
          fill: buttonFillTypes.OUTLINE_DARK,
          padding: "10px 20px",
          minWidth: "none",
          withoutBorderRadius: true,
          grayscale: true
        }, (featureProps === null || featureProps === void 0 ? void 0 : featureProps.buttonStylesProps) || {})
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      ultraLight: true,
      darkTitle: true,
      darkDescription: true,
      grayscaleDescription: true,
      variant: calloutVariantsTypes.IMAGE_WITH_GRADIENT,
      data: data.FeatureV1
    }, calloutProps, {
      buttonStylesProps: _objectSpread2({
        padding: "10px 20px",
        minWidth: "none",
        withoutBorderRadius: true,
        transparent: true
      }, (calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.buttonStylesProps) || {})
    })), (data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && data.CalloutMobileApps.map(function (element, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
        key: "Mobile_Apps_".concat(index),
        variant: element.Type || calloutVariantsTypes.MOBILE_APPS,
        data: element
      }, calloutMobileProps));
    }), (data === null || data === void 0 ? void 0 : data.CompressedContent) && (data === null || data === void 0 ? void 0 : data.CompressedContent.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement(CompressedContent, _extends$g({
      data: data
    }, calloutCompressedProps, {
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump5 = config.speedBump) !== null && _config$speedBump5 !== void 0 && _config$speedBump5.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverBackgroundColor: colorsTypes.WHITE,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (calloutCompressedProps === null || calloutCompressedProps === void 0 ? void 0 : calloutCompressedProps.buttonCustomStyles) || {})
    })));
  });
}

HomeTemplateV8.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$q = ["pageData", "config", "variant", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps"];

function HomeTemplateV9(_ref) {
  _ref.pageData;

  var config = _ref.config,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dynamicTemplatesVersionVariantsTypes.DYNAMIC_TEMPLATE_V9 : _ref$variant,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$q);

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "tw-custom-container HOME__PAGE"
  }, /*#__PURE__*/React__default$1["default"].createElement(DynamicPage, _extends$g({
    heroProps: heroProps,
    productsProps: productsProps,
    featureFullProps: featureFullProps,
    featureProps: featureProps,
    calloutProps: calloutProps
  }, otherProps, {
    path: "/",
    id: "",
    config: config,
    variant: variant
  })));
}

HomeTemplateV9.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string
};
var _excluded$p = ["pageData", "config", "pageHeaderProps", "contactProps", "branchProps", "calloutPros", "pageTitleProps", "calloutMobilePros", "calloutMobileWithGradientPros"];

function ContactUsTemplateV1(_ref) {
  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutPros = _ref.calloutPros,
      calloutPros = _ref$calloutPros === void 0 ? {} : _ref$calloutPros,
      _ref$pageTitleProps = _ref.pageTitleProps,
      pageTitleProps = _ref$pageTitleProps === void 0 ? {} : _ref$pageTitleProps,
      _ref$calloutMobilePro = _ref.calloutMobilePros,
      calloutMobilePros = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutMobileWit = _ref.calloutMobileWithGradientPros,
      calloutMobileWithGradientPros = _ref$calloutMobileWit === void 0 ? {} : _ref$calloutMobileWit,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$p);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "/contact-us",
    config: config
  }, otherProps), function (data) {
    var _data$Contact, _data$BranchExpanded;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, data.PageHeaderGradients && /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENTS,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: data.PageHeaderGradients
    }, pageHeaderProps)), data.PageTitle && /*#__PURE__*/React__default$1["default"].createElement(PageTitle, _extends$g({
      data: data.PageTitle
    }, pageTitleProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data.Contact,
      variant: ((_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.variant) || contactVariantsTypes.REGULAR
    }, contactProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "bl-bg-grayscale-6 tw-my-8"
    }), data.BranchExpandedTitle && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "bl-font-secondary bl-text-primary bl-text-2xl"
    }, data.BranchExpandedTitle), data === null || data === void 0 ? void 0 : (_data$BranchExpanded = data.BranchExpanded) === null || _data$BranchExpanded === void 0 ? void 0 : _data$BranchExpanded.map(function (branch, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch
      }, branchProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-10"
      }));
    }), Array.isArray(data.CalloutMobileApps) && data.CalloutMobileApps.length > 0 && /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.MOBILE_APPS,
      data: data.CalloutMobileApps[0]
    }, calloutMobilePros)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-10"
    })), Array.isArray(data.CalloutData) && data.CalloutData.length > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.DATA,
      data: data.CalloutData[0]
    }, calloutPros))), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-8 sm:tw-my-12"
    }), data.PageTitle && /*#__PURE__*/React__default$1["default"].createElement(CalloutMobileAppsGradientsDark$1, _extends$g({
      data: data.CalloutMobileAppsGradients
    }, calloutMobileWithGradientPros)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-8 sm:tw-my-12"
    }));
  });
}

ContactUsTemplateV1.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  // heroProps: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any,
  pageTitleProps: PropTypes.any,
  calloutMobilePros: PropTypes.any,
  calloutMobileWithGradientPros: PropTypes.any
};
var _excluded$o = ["pageData", "config", "submitButton", "pageHeaderProps", "contactProps", "branchProps", "calloutPros"];

function ContactUsTemplateV2(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$submitButton = _ref.submitButton,
      submitButton = _ref$submitButton === void 0 ? {} : _ref$submitButton,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutPros = _ref.calloutPros,
      calloutPros = _ref$calloutPros === void 0 ? {} : _ref$calloutPros,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$o);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    transparentHeader: true,
    forceShowHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    backgroundScreenHeader: true,
    darkHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "/contact-us",
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      height: 30,
      padding: "2px 17px",
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverFilledBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$Contact, _data$Contact2, _data$Contact3, _data$Contact4, _data$Contact5, _data$BranchExpanded, _data$CalloutMobileAp;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20 tw-w-full"
    }), (data === null || data === void 0 ? void 0 : data.PageHeaderGradients) && /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENTS,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: data === null || data === void 0 ? void 0 : data.PageHeaderGradients
    }, pageHeaderProps)), (data === null || data === void 0 ? void 0 : data.PageTitle) && /*#__PURE__*/React__default$1["default"].createElement(PageTitle, {
      data: data.PageTitle,
      isTwContainer: true
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6 tw-pt-2.5"
    }), (data === null || data === void 0 ? void 0 : (_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.variant) === contactVariantsTypes.REGULAR ? /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact2 = data.Contact) === null || _data$Contact2 === void 0 ? void 0 : _data$Contact2.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact3 = data.Contact) === null || _data$Contact3 === void 0 ? void 0 : _data$Contact3.borders) !== "CIRCLED",
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.WHITE,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: true,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.WHITE,
        hoverTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonFill: buttonFillTypes.NONE
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    }))) : /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.WHITE,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact4 = data.Contact) === null || _data$Contact4 === void 0 ? void 0 : _data$Contact4.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact5 = data.Contact) === null || _data$Contact5 === void 0 ? void 0 : _data$Contact5.borders) !== "CIRCLED",
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.WHITE,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: true,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.WHITE,
        hoverTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonFill: buttonFillTypes.NONE
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-x-container BRANCH__EXPANDED___SEPARATOR"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: " tw-my-4"
    }), (data === null || data === void 0 ? void 0 : data.BranchExpandedTitle) && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "bl-font-secondary bl-text-primary bl-text-2xl"
    }, data === null || data === void 0 ? void 0 : data.BranchExpandedTitle), data === null || data === void 0 ? void 0 : (_data$BranchExpanded = data.BranchExpanded) === null || _data$BranchExpanded === void 0 ? void 0 : _data$BranchExpanded.map(function (branch, index) {
      var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch,
        design: branchVariantsTypes.VERTICAL_LINE
      }, branchProps, {
        mainOfficeStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
          title: _objectSpread2({
            color: colorsTypes.SECONDARY
          }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
          // for documentation pourposes:
          officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
            first: _objectSpread2({
              color: colorsTypes.BLACK
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.color) || {}) // second: {
            //   color: 'red'
            // },
            // third: {
            //   color: 'green'
            // }

          }),
          contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
            title: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {}), {}, {
              color: colorsTypes.SECONDARY
            }) // for documentation pourposes:
            // text: {
            //   color: 'green'
            // },
            // last: {
            //   color: 'pink'
            // }

          })
        })
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-10"
      }));
    })), Array.isArray(data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: (data === null || data === void 0 ? void 0 : (_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type) || calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT,
      data: data === null || data === void 0 ? void 0 : data.CalloutMobileApps[0]
    }, calloutPros)));
  });
}

ContactUsTemplateV2.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  // heroProps: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any,
  pageTitleProps: PropTypes.any,
  calloutMobilePros: PropTypes.any,
  calloutMobileWithGradientPros: PropTypes.any
};
var _excluded$n = ["pageData", "config", "submitButton", "heroProps", "contactProps", "branchProps", "calloutPros"];

function ContactUsTemplateV3(_ref) {
  var _config$speedBump, _config$speedBump2, _otherProps$footerOpt, _config$speedBump3, _otherProps$speedBump, _config$speedBump4, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$submitButton = _ref.submitButton,
      submitButton = _ref$submitButton === void 0 ? {} : _ref$submitButton,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutPros = _ref.calloutPros,
      calloutPros = _ref$calloutPros === void 0 ? {} : _ref$calloutPros,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$n);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    headerCompressedVariant: headerCompressedVariantTypes.STANDARD,
    headerDesktopVariant: headerDesktopVariantTypes.STANDARD,
    headerMobileVariant: headerMobileVariantTypes.STANDARD,
    backgroundHeader: "rgba(32, 0, 9, 0.4)",
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    forceShowHeader: true,
    forceCompressHeader: true,
    noFilterLogoHeader: true,
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    topIndicatorHeader: false
  }, otherProps, {
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "/contact-us",
    config: config,
    headerLoginButtonStyles: _objectSpread2({
      isScrollChangeColorButton: true,
      grayscale: true,
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverGrayscaleFilledTextColor: colorsTypes.BLACK,
      hoverGrayscaleFillBackgroundColor: colorsTypes.WHITE,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    headerDropdownLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledTextColor: colorsTypes.PRIMARY,
      hoverFilledBorderColor: colorsTypes.PRIMARY,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerDropdownLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      homeLogoVisible: false
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$herosContactUs$, _data$herosContactUs$2, _data$Contact, _config$speedBump5, _data$BranchExpanded, _data$CalloutMobileAp;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "CONTACTA_US_V3_FRAGMENT"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "contact-us-template-v3 tw-my-6 tw-pt-7"
    }), /*#__PURE__*/React__default$1["default"].createElement(Hero$1, _extends$g({
      className: "contact-us-hero tw-mt-8",
      variant: ((_data$herosContactUs$ = data.herosContactUs[0]) === null || _data$herosContactUs$ === void 0 ? void 0 : _data$herosContactUs$.variant) || heroVariantsTypes.DINAMIC,
      data: ((_data$herosContactUs$2 = data.herosContactUs[0]) === null || _data$herosContactUs$2 === void 0 ? void 0 : _data$herosContactUs$2.Heros) || data.Heros,
      fullScreen: true,
      darkTitle: true,
      darkDescription: true,
      buttonHoverBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonHoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
      buttonFill: buttonFillTypes.FILLED,
      buttonGrayscale: true,
      buttonHoverColor: true,
      buttonWithoutBorderRadius: true,
      gradient: "radial-gradient(\n                80.81% 115.03% at 64.44% 85.88%,\n                rgba(3, 6, 33, 0) 0%,\n                rgba(3, 13, 33, 0.5) 100%)"
    }, heroProps)), /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.WHITE,
        borderRadius: ((_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump5 = config.speedBump) !== null && _config$speedBump5 !== void 0 && _config$speedBump5.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverBackgroundColor: colorsTypes.WHITE,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {}),
      customIconsAlt: otherProps.customIconsAlt
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-x-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: " tw-my-4"
    }), data.BranchExpandedTitle && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "bl-font-secondary bl-text-primary bl-text-2xl"
    }, data.BranchExpandedTitle), data === null || data === void 0 ? void 0 : (_data$BranchExpanded = data.BranchExpanded) === null || _data$BranchExpanded === void 0 ? void 0 : _data$BranchExpanded.map(function (branch, index) {
      var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch,
        design: branchVariantsTypes.VERTICAL_LINE
      }, branchProps, {
        mainOfficeStyles: _objectSpread2(_objectSpread2({
          borderColor: colorsTypes.PRIMARY_DARK
        }, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
          title: _objectSpread2({
            color: colorsTypes.SECONDARY
          }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
          officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
            first: _objectSpread2({
              color: colorsTypes.BLACK
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.first) || {})
          }),
          contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
            title: _objectSpread2({
              color: colorsTypes.SECONDARY
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {})
          })
        })
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "MAP__DIVIDER tw-my-10"
      }));
    })), Array.isArray(data.CalloutMobileApps) && data.CalloutMobileApps.length > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: ((_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type) || calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT,
      data: data.CalloutMobileApps[0]
    }, calloutPros)));
  });
}

ContactUsTemplateV3.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  heroProps: PropTypes.any,
  // pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any,
  pageTitleProps: PropTypes.any,
  calloutMobilePros: PropTypes.any,
  calloutMobileWithGradientPros: PropTypes.any
};
var _excluded$m = ["pageData", "config", "submitButton", "pageHeaderProps", "contactProps", "branchProps", "calloutPros", "applyMaxWidthContainer"];

function ContactUsTemplateV5(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$submitButton = _ref.submitButton,
      submitButton = _ref$submitButton === void 0 ? {} : _ref$submitButton,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutPros = _ref.calloutPros,
      calloutPros = _ref$calloutPros === void 0 ? {} : _ref$calloutPros,
      _ref$applyMaxWidthCon = _ref.applyMaxWidthContainer,
      applyMaxWidthContainer = _ref$applyMaxWidthCon === void 0 ? false : _ref$applyMaxWidthCon,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$m);

  var pageTitleProps = {
    titleColor: colorsTypes.PRIMARY_ULTRA_DARK,
    subtitleColor: colorsTypes.PRIMARY_DARK,
    menuActiveBorderColor: colorsTypes.SECONDARY
  };
  return /*#__PURE__*/React__default$1["default"].createElement(Page // transparentHeader
  , _extends$g({
    floatHeader: true,
    grayscaleHeader: true,
    darkHeader: true,
    backgroundScreenHeader: true,
    noFilterLogoHeader: true,
    forceShowItemsHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "contact-us",
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK,
      itemBackgroundColor: colorsTypes.BLACK,
      dropdownSeparationFromBottom: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      styleType: buttonStyleTypes.STANDARD,
      filledBackgroundColor: colorsTypes.SECONDARY,
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledBorderColor: colorsTypes.SECONDARY,
      hoverFilledTextColor: colorsTypes.SECONDARY,
      height: 30,
      padding: "2px 17px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$Contact, _data$Contact2, _data$Contact3, _data$Contact4, _data$Contact5, _data$CalloutMobileAp, _data$CalloutMobileAp2;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "CONTACT_US_V5__FRAGMENT_CONTAINER"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20 tw-w-full"
    }), (data === null || data === void 0 ? void 0 : data.PageHeaderGradients) && /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENTS,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: data === null || data === void 0 ? void 0 : data.PageHeaderGradients
    }, pageHeaderProps, {
      applyMaxWidthContainer: applyMaxWidthContainer
    })), (data === null || data === void 0 ? void 0 : data.PageTitle) && /*#__PURE__*/React__default$1["default"].createElement(PageTitle, {
      data: data === null || data === void 0 ? void 0 : data.PageTitle,
      pageTitleProps: pageTitleProps,
      applyMaxWidthContainer: applyMaxWidthContainer,
      isTwContainer: true
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6 tw-pt-2.5"
    }), (data === null || data === void 0 ? void 0 : (_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.variant) === contactVariantsTypes.REGULAR ? /*#__PURE__*/React__default$1["default"].createElement("div", null, /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text,
      applyMaxWidthContainer: applyMaxWidthContainer
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact2 = data.Contact) === null || _data$Contact2 === void 0 ? void 0 : _data$Contact2.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact3 = data.Contact) === null || _data$Contact3 === void 0 ? void 0 : _data$Contact3.borders) !== "CIRCLED",
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        filledBackgroundColor: colorsTypes.SECONDARY,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        hoverFilledBorderColor: colorsTypes.SECONDARY,
        hoverFilledTextColor: colorsTypes.SECONDARY
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    }))) : /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      applyMaxWidthContainer: applyMaxWidthContainer,
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.WHITE,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact4 = data.Contact) === null || _data$Contact4 === void 0 ? void 0 : _data$Contact4.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact5 = data.Contact) === null || _data$Contact5 === void 0 ? void 0 : _data$Contact5.borders) !== "CIRCLED",
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        filledBackgroundColor: colorsTypes.SECONDARY,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        hoverFilledBorderColor: colorsTypes.SECONDARY,
        hoverFilledTextColor: colorsTypes.SECONDARY
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: classnames("tw-x-container", applyMaxWidthContainer && "max-width-container")
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: " tw-my-4 CONTACT_V5_DIVIDER"
    }), (data === null || data === void 0 ? void 0 : data.BranchExpandedTitle) && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "CONTACT__US__BRANCH_EXPANDED_TITLE"
    }, (data === null || data === void 0 ? void 0 : data.BranchExpandedTitle) || ""), ((data === null || data === void 0 ? void 0 : data.BranchExpanded) || []).map(function (branch, index) {
      var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch,
        design: branchVariantsTypes.VERTICAL_LINE
      }, branchProps, {
        mainOfficeStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
          title: _objectSpread2({
            color: colorsTypes.SECONDARY
          }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
          // for documentation pourposes:
          officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
            first: _objectSpread2({
              color: colorsTypes.BLACK
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.first) || {}) // second: {
            //   color: 'red'
            // },
            // third: {
            //   color: 'green'
            // }

          }),
          contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
            title: _objectSpread2({
              color: colorsTypes.SECONDARY
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {}) // for documentation pourposes:
            // text: {
            //   color: 'green'
            // },
            // last: {
            //   color: 'pink'
            // }

          })
        })
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-10"
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "CONTACT__US_V5__CALLOUT_CONTAINER"
    }, Array.isArray(data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : (_data$CalloutMobileAp = data.CalloutMobileApps) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: (data === null || data === void 0 ? void 0 : (_data$CalloutMobileAp2 = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp2 === void 0 ? void 0 : _data$CalloutMobileAp2.Type) || calloutVariantsTypes.MOBILE_APPS,
      data: data === null || data === void 0 ? void 0 : data.CalloutMobileApps[0],
      applyMaxWidthContainer: applyMaxWidthContainer
    }, calloutPros))));
  });
}

ContactUsTemplateV5.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  // heroProps: PropTypes.any,
  submitButton: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any,
  pageTitleProps: PropTypes.any // calloutMobilePros: PropTypes.any,
  // calloutMobileWithGradientPros: PropTypes.any,

};
var _excluded$l = ["pageData", "config", "submitButton", "pageHeaderProps", "contactProps", "branchProps", "calloutProps"];

function ContactUsTemplateV6(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$submitButton = _ref.submitButton,
      submitButton = _ref$submitButton === void 0 ? {} : _ref$submitButton,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$l);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "/contact-us",
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _data$Contact, _data$Contact2, _config$speedBump2, _data$Contact3, _data$Contact4, _config$speedBump3, _data$BranchExpanded, _data$CalloutMobileAp;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20 tw-w-full"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "CONTACT_V6__PAGE_HEADER__CONTAINER"
    }, data.PageHeaderGradients && /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENTS,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: data.PageHeaderGradients
    }, pageHeaderProps)), data.PageTitle && /*#__PURE__*/React__default$1["default"].createElement(PageTitle, {
      data: data.PageTitle,
      isTwContainer: true
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "lg:tw-my-6 lg:tw-pt-2.5"
    })), data.Contact.variant === contactVariantsTypes.REGULAR ? /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data.Contact,
      noGap: true,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
        borderRadius: ((_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: ((_data$Contact2 = data.Contact) === null || _data$Contact2 === void 0 ? void 0 : _data$Contact2.borders) !== "CIRCLED" || !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.NONE,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledTextColor: colorsTypes.WHITE,
        radius: 10
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    }))) : /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.WHITE,
        borderRadius: ((_data$Contact3 = data.Contact) === null || _data$Contact3 === void 0 ? void 0 : _data$Contact3.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: ((_data$Contact4 = data.Contact) === null || _data$Contact4 === void 0 ? void 0 : _data$Contact4.borders) !== "CIRCLED" || !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.NONE,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
        hoverFilledTextColor: colorsTypes.WHITE,
        radius: 10
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: " tw-my-4"
    }), data.BranchExpandedTitle && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "bl-font-secondary bl-text-primary bl-text-2xl"
    }, data.BranchExpandedTitle), data === null || data === void 0 ? void 0 : (_data$BranchExpanded = data.BranchExpanded) === null || _data$BranchExpanded === void 0 ? void 0 : _data$BranchExpanded.map(function (branch, index) {
      var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch,
        design: branchVariantsTypes.VERTICAL_LINE
      }, branchProps, {
        mainOfficeStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
          title: _objectSpread2({
            color: colorsTypes.SECONDARY
          }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
          // for documentation pourposes:
          officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
            first: _objectSpread2({
              color: colorsTypes.BLACK
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.first) || {}) // second: {
            //   color: 'red'
            // },
            // third: {
            //   color: 'green'
            // }

          }),
          contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
            title: _objectSpread2({
              color: colorsTypes.SECONDARY
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {}) // for documentation pourposes:
            // text: {
            //   color: 'green'
            // },
            // last: {
            //   color: 'pink'
            // }

          })
        })
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-10"
      }));
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container tw-mb-24"
    }, Array.isArray(data.CalloutMobileApps) && data.CalloutMobileApps.length > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: ((_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type) || calloutVariantsTypes.MOBILE_APPS,
      data: data.CalloutMobileApps[0]
    }, calloutProps))));
  });
}

ContactUsTemplateV6.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  // heroProps: PropTypes.any,
  submitButton: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any // pageTitleProps: PropTypes.any,
  // calloutMobilePros: PropTypes.any,
  // calloutMobileWithGradientPros: PropTypes.any,

};
var _excluded$k = ["pageData", "config", "variant", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps"];

function ContactUsTemplateV7(_ref) {
  _ref.pageData;

  var config = _ref.config,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dynamicTemplatesVersionVariantsTypes.DYNAMIC_TEMPLATE_V5 : _ref$variant,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$k);

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_PAGE__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(DynamicPage, _extends$g({
    heroProps: heroProps,
    productsProps: productsProps,
    featureFullProps: featureFullProps,
    featureProps: featureProps,
    calloutProps: calloutProps
  }, otherProps, {
    path: "/contact-us",
    id: "contact-us",
    config: config,
    variant: variant
  })));
}

ContactUsTemplateV7.prototype = {
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  variant: PropTypes.string,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any
};
var _excluded$j = ["pageData", "config", "submitButton", "pageHeaderProps", "contactProps", "branchProps", "calloutPros"];

function ContactUsTemplateV8(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$submitButton = _ref.submitButton,
      submitButton = _ref$submitButton === void 0 ? {} : _ref$submitButton,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutPros = _ref.calloutPros,
      calloutPros = _ref$calloutPros === void 0 ? {} : _ref$calloutPros,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$j);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "/contact-us",
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _data$Contact, _data$Contact2, _data$Contact3, _data$Contact4, _data$Contact5, _data$BranchExpanded, _data$CalloutMobileAp;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20 tw-w-full"
    }), (data === null || data === void 0 ? void 0 : data.PageHeaderGradients) && /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENTS,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: data === null || data === void 0 ? void 0 : data.PageHeaderGradients
    }, pageHeaderProps)), (data === null || data === void 0 ? void 0 : data.PageTitle) && /*#__PURE__*/React__default$1["default"].createElement(PageTitle, {
      data: data.PageTitle,
      isTwContainer: true
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6 tw-pt-2.5"
    }), (data === null || data === void 0 ? void 0 : (_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.variant) === contactVariantsTypes.REGULAR ? /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact2 = data.Contact) === null || _data$Contact2 === void 0 ? void 0 : _data$Contact2.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact3 = data.Contact) === null || _data$Contact3 === void 0 ? void 0 : _data$Contact3.borders) !== "CIRCLED",
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.WHITE,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: true,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.WHITE,
        hoverTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonFill: buttonFillTypes.NONE
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    }))) : /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.WHITE,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact4 = data.Contact) === null || _data$Contact4 === void 0 ? void 0 : _data$Contact4.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact5 = data.Contact) === null || _data$Contact5 === void 0 ? void 0 : _data$Contact5.borders) !== "CIRCLED",
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.WHITE,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: true,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.WHITE,
        hoverTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonFill: buttonFillTypes.NONE
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container BRANCH__EXPANDED___SEPARATOR"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: " tw-my-4"
    }), (data === null || data === void 0 ? void 0 : data.BranchExpandedTitle) && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "bl-font-secondary bl-text-primary bl-text-2xl"
    }, data === null || data === void 0 ? void 0 : data.BranchExpandedTitle), data === null || data === void 0 ? void 0 : (_data$BranchExpanded = data.BranchExpanded) === null || _data$BranchExpanded === void 0 ? void 0 : _data$BranchExpanded.map(function (branch, index) {
      var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch,
        design: branchVariantsTypes.VERTICAL_LINE
      }, branchProps, {
        mainOfficeStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
          title: _objectSpread2({
            color: colorsTypes.SECONDARY
          }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
          // for documentation pourposes:
          officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
            first: _objectSpread2({
              color: colorsTypes.BLACK
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.color) || {}) // second: {
            //   color: 'red'
            // },
            // third: {
            //   color: 'green'
            // }

          }),
          contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
            title: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {}), {}, {
              color: colorsTypes.SECONDARY
            }) // for documentation pourposes:
            // text: {
            //   color: 'green'
            // },
            // last: {
            //   color: 'pink'
            // }

          })
        })
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-10"
      }));
    })), Array.isArray(data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: (data === null || data === void 0 ? void 0 : (_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type) || calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT,
      data: data === null || data === void 0 ? void 0 : data.CalloutMobileApps[0]
    }, calloutPros)));
  });
}

ContactUsTemplateV8.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  // heroProps: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any,
  pageTitleProps: PropTypes.any,
  calloutMobilePros: PropTypes.any,
  calloutMobileWithGradientPros: PropTypes.any
};
var _excluded$i = ["pageData", "config", "submitButton", "pageHeaderProps", "contactProps", "branchProps", "calloutPros"];

function ContactUsTemplateV9(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$submitButton = _ref.submitButton,
      submitButton = _ref$submitButton === void 0 ? {} : _ref$submitButton,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$branchProps = _ref.branchProps,
      branchProps = _ref$branchProps === void 0 ? {} : _ref$branchProps,
      _ref$calloutPros = _ref.calloutPros,
      calloutPros = _ref$calloutPros === void 0 ? {} : _ref$calloutPros,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$i);

  return /*#__PURE__*/React__default$1["default"].createElement(Page // transparentHeader
  , _extends$g({
    isDynamic: true,
    forceShowHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    backgroundScreenHeader: true,
    darkHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      pageId: "cu-contact-uss",
      pageData: pageData
    },
    pathname: "/contact-us",
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      height: 30,
      padding: "2px 17px",
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverFilledBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _data$Contact, _data$Contact2, _data$Contact3, _data$Contact4, _data$Contact5, _data$BranchExpanded, _data$CalloutMobileAp;

    if (!data) return null;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20 tw-w-full"
    }), (data === null || data === void 0 ? void 0 : data.PageHeaderGradients) && /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENTS,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: data === null || data === void 0 ? void 0 : data.PageHeaderGradients
    }, pageHeaderProps)), (data === null || data === void 0 ? void 0 : data.PageTitle) && /*#__PURE__*/React__default$1["default"].createElement(PageTitle, {
      data: data.PageTitle,
      isTwContainer: true
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6 tw-pt-2.5"
    }), (data === null || data === void 0 ? void 0 : (_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.variant) === contactVariantsTypes.REGULAR ? /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact2 = data.Contact) === null || _data$Contact2 === void 0 ? void 0 : _data$Contact2.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact3 = data.Contact) === null || _data$Contact3 === void 0 ? void 0 : _data$Contact3.borders) !== "CIRCLED",
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.WHITE,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: true,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.WHITE,
        hoverTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonFill: buttonFillTypes.NONE
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    }))) : /*#__PURE__*/React__default$1["default"].createElement(Contact$1, _extends$g({
      isDynamic: true,
      data: data === null || data === void 0 ? void 0 : data.Contact,
      variant: contactVariantsTypes.BACKGROUND,
      buttonText: submitButton.text
    }, contactProps, {
      inputStyles: _objectSpread2({
        backgroundColor: colorsTypes.WHITE,
        borderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact4 = data.Contact) === null || _data$Contact4 === void 0 ? void 0 : _data$Contact4.borders) === "CIRCLED" ? 10 : 0
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {}),
      buttonCustomStyles: _objectSpread2({
        withoutBorderRadius: (data === null || data === void 0 ? void 0 : (_data$Contact5 = data.Contact) === null || _data$Contact5 === void 0 ? void 0 : _data$Contact5.borders) !== "CIRCLED",
        filledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        filledTextColor: colorsTypes.WHITE,
        hoverFilledTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverDefaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonWithoutBorderRadius: true,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        hoverFilledBackgroundColor: colorsTypes.PRIMARY_SEMI_DARK,
        hoverColor: true,
        hoverBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultBorderColor: colorsTypes.PRIMARY_SEMI_DARK,
        defaultTextColor: colorsTypes.WHITE,
        hoverTextColor: colorsTypes.PRIMARY_SEMI_DARK,
        buttonFill: buttonFillTypes.NONE
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.buttonCustomStyles) || {}),
      formContainerStyles: _objectSpread2({
        padding: "1.75rem 0px"
      }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.formContainerStyles) || {})
    })), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-x-container BRANCH__EXPANDED___SEPARATOR"
    }, /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: " tw-my-4"
    }), (data === null || data === void 0 ? void 0 : data.BranchExpandedTitle) && /*#__PURE__*/React__default$1["default"].createElement("h3", {
      className: "bl-font-secondary bl-text-primary bl-text-2xl"
    }, data === null || data === void 0 ? void 0 : data.BranchExpandedTitle), data === null || data === void 0 ? void 0 : (_data$BranchExpanded = data.BranchExpanded) === null || _data$BranchExpanded === void 0 ? void 0 : _data$BranchExpanded.map(function (branch, index) {
      var _branchProps$mainOffi, _branchProps$mainOffi2, _branchProps$mainOffi3, _branchProps$mainOffi4, _branchProps$mainOffi5, _branchProps$mainOffi6, _branchProps$mainOffi7;

      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Branch-branch-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(Branch$1, _extends$g({
        data: branch,
        design: branchVariantsTypes.VERTICAL_LINE
      }, branchProps, {
        mainOfficeStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : branchProps.mainOfficeStyles) || {}), {}, {
          title: _objectSpread2({
            color: colorsTypes.SECONDARY
          }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi === void 0 ? void 0 : _branchProps$mainOffi.title) || {}),
          // for documentation pourposes:
          officeHourBoxStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi2 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi2 === void 0 ? void 0 : _branchProps$mainOffi2.officeHourBoxStyles) || {}), {}, {
            first: _objectSpread2({
              color: colorsTypes.BLACK
            }, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi3 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi3 === void 0 ? void 0 : (_branchProps$mainOffi4 = _branchProps$mainOffi3.officeHourBoxStyles) === null || _branchProps$mainOffi4 === void 0 ? void 0 : _branchProps$mainOffi4.color) || {}) // second: {
            //   color: 'red'
            // },
            // third: {
            //   color: 'green'
            // }

          }),
          contactSimpleStyles: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi5 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi5 === void 0 ? void 0 : _branchProps$mainOffi5.contactSimpleStyles) || {}), {}, {
            title: _objectSpread2(_objectSpread2({}, (branchProps === null || branchProps === void 0 ? void 0 : (_branchProps$mainOffi6 = branchProps.mainOfficeStyles) === null || _branchProps$mainOffi6 === void 0 ? void 0 : (_branchProps$mainOffi7 = _branchProps$mainOffi6.contactSimpleStyles) === null || _branchProps$mainOffi7 === void 0 ? void 0 : _branchProps$mainOffi7.title) || {}), {}, {
              color: colorsTypes.SECONDARY
            }) // for documentation pourposes:
            // text: {
            //   color: 'green'
            // },
            // last: {
            //   color: 'pink'
            // }

          })
        })
      })), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-10"
      }));
    })), Array.isArray(data === null || data === void 0 ? void 0 : data.CalloutMobileApps) && (data === null || data === void 0 ? void 0 : data.CalloutMobileApps.length) > 0 && /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: (data === null || data === void 0 ? void 0 : (_data$CalloutMobileAp = data.CalloutMobileApps[0]) === null || _data$CalloutMobileAp === void 0 ? void 0 : _data$CalloutMobileAp.Type) || calloutVariantsTypes.MOBILE_APPS_GRADIENTS_LIGHT,
      data: data === null || data === void 0 ? void 0 : data.CalloutMobileApps[0]
    }, calloutPros)));
  });
}

ContactUsTemplateV9.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  // heroProps: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  contactProps: PropTypes.any,
  branchProps: PropTypes.any,
  calloutPros: PropTypes.any,
  pageTitleProps: PropTypes.any,
  calloutMobilePros: PropTypes.any,
  calloutMobileWithGradientPros: PropTypes.any
};
var _excluded$h = ["pageData", "config", "variant", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps"];

function ContactUsTemplateV10(_ref) {
  _ref.pageData;

  var config = _ref.config,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dynamicTemplatesVersionVariantsTypes.DYNAMIC_TEMPLATE_V9 : _ref$variant,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$h);

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_PAGE__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(DynamicPage, _extends$g({
    heroProps: heroProps,
    productsProps: productsProps,
    featureFullProps: featureFullProps,
    featureProps: featureProps,
    calloutProps: calloutProps
  }, otherProps, {
    path: "/contact-us",
    id: "contact-us",
    config: config,
    variant: variant
  })));
}

ContactUsTemplateV10.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any // heroProps: PropTypes.any,

};
var _excluded$g = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function DynamicTemplateV1(_ref) {
  var _config$speedBump;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$g);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({}, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config,
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious)
    }, otherProps.headerLoginButtonStyles || {})
  }), function (data) {
    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps)));
  });
}

DynamicTemplateV1.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$f = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function DynamicTemplateV2(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$f);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    transparentHeader: true,
    forceShowHeader: true,
    grayscaleHeader: true,
    darkHeader: true,
    floatHeader: true,
    backgroundScreenHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      height: 30,
      padding: "2px 17px",
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverFilledBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _customPageProps$cust, _customPageProps$cust2, _customPageProps$cust3, _customPageProps$cust4, _customPageProps$cust5, _customPageProps$cust6, _customPageProps$cust7, _customPageProps$cust8;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps
    }, otherProps, {
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles) || {}), {}, {
        titleWithGradients: _objectSpread2(_objectSpread2({
          fontFamily: fontsFamiliesTypes.SECONDARY
        }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.titleWithGradients) || {}), {}, {
          gradients: _objectSpread2({
            firstColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            firstLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.titleWithGradients) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.gradients) || {})
        }),
        ratesList: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust4 = customPageProps.customComponentStyles) === null || _customPageProps$cust4 === void 0 ? void 0 : _customPageProps$cust4.ratesList) || {}), {}, {
          title: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust5 = customPageProps.customComponentStyles) === null || _customPageProps$cust5 === void 0 ? void 0 : (_customPageProps$cust6 = _customPageProps$cust5.ratesList) === null || _customPageProps$cust6 === void 0 ? void 0 : _customPageProps$cust6.title) || {}),
          rightSubtitle: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY,
            color: colorsTypes.PRIMARY_SEMI_DARK
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust7 = customPageProps.customComponentStyles) === null || _customPageProps$cust7 === void 0 ? void 0 : (_customPageProps$cust8 = _customPageProps$cust7.ratesList) === null || _customPageProps$cust8 === void 0 ? void 0 : _customPageProps$cust8.rightSubtitle) || {})
        })
      })
    })));
  });
}

DynamicTemplateV2.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$e = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps", "tabsProps"];

function DynamicTemplateV3(_ref) {
  var _config$speedBump, _config$speedBump2, _otherProps$footerOpt, _config$speedBump3, _otherProps$speedBump, _config$speedBump4, _otherProps$speedBump2;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      _ref$tabsProps = _ref.tabsProps,
      tabsProps = _ref$tabsProps === void 0 ? {} : _ref$tabsProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$e);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    className: "DINAMIC_V3_PAGE",
    isDynamic: true,
    headerCompressedVariant: headerCompressedVariantTypes.STANDARD,
    headerDesktopVariant: headerDesktopVariantTypes.STANDARD,
    headerMobileVariant: headerMobileVariantTypes.STANDARD,
    backgroundHeader: "rgba(32, 0, 9, 0.4)",
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    forceShowHeader: true,
    forceCompressHeader: true,
    noFilterLogoHeader: true,
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    topIndicatorHeader: false
  }, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config,
    headerLoginButtonStyles: _objectSpread2({
      isScrollChangeColorButton: false,
      grayscale: false,
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      textColor: "#fff",
      hoverGrayscaleFilledTextColor: colorsTypes.BLACK,
      hoverGrayscaleFillBackgroundColor: colorsTypes.WHITE,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      grayscaleAndOFilledTextColor: colorsTypes.WHITE,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    headerDropdownLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      minWidth: 100,
      height: "auto",
      padding: "3px 15px",
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledTextColor: colorsTypes.PRIMARY,
      hoverFilledBorderColor: colorsTypes.PRIMARY,
      fontFamily: fontsFamiliesVariantsTypes.PRIMARY,
      size: textSizesVariantsTypes.SMALL,
      withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious)
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerDropdownLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      homeLogoVisible: false
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _customPageProps$cust, _customPageProps$cust2, _customPageProps$cust3;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
      className: "DINAMIC_V3_FRAGMENT"
    }, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      className: "DINAMIC_V3_CUSTOM_PAGE",
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps,
      tabsProps: tabsProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles) || {}), {}, {
        calloutWithGradient: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.calloutWithGradient) || {}), {}, {
          buttonStylesProps: _objectSpread2({
            textColor: colorsTypes.PRIMARY_DARK
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.calloutWithGradient) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.buttonStylesProps) || {})
        })
      })
    })));
  });
}

DynamicTemplateV3.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$d = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function DynamicTemplateV4(_ref) {
  var _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$d);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    transparentHeader: true,
    forceShowHeader: true,
    grayscaleHeader: true,
    floatHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config,
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      height: 30,
      padding: "2px 17px",
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverFilledBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps)));
  });
}

DynamicTemplateV4.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$c = ["path", "pageData", "config", "customPageProps", "contactProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps", "customContainerClass"];

function DynamicTemplateV5(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$contactProps = _ref.contactProps,
      contactProps = _ref$contactProps === void 0 ? {} : _ref$contactProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      _ref$customContainerC = _ref.customContainerClass,
      customContainerClass = _ref$customContainerC === void 0 ? "" : _ref$customContainerC,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$c);

  var pageTitleProps = {
    titleColor: colorsTypes.PRIMARY_ULTRA_LIGHT,
    subtitleColor: colorsTypes.PRIMARY_DARK
  };
  return /*#__PURE__*/React__default$1["default"].createElement(Page // transparentHeader
  , _extends$g({
    floatHeader: true,
    grayscaleHeader: true,
    pageTitleProps: true,
    darkHeader: true,
    backgroundScreenHeader: true,
    backgroundBreakpointHeader: 0,
    noFilterLogoHeader: true,
    forceShowItemsHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY,
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config
  }, otherProps, {
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK,
      itemBackgroundColor: colorsTypes.BLACK,
      dropdownSeparationFromBottom: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      fill: buttonFillTypes.FILLED,
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      styleType: buttonStyleTypes.STANDARD,
      filledBackgroundColor: colorsTypes.SECONDARY,
      hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
      hoverFilledBorderColor: colorsTypes.SECONDARY,
      hoverFilledTextColor: colorsTypes.SECONDARY,
      height: 30,
      padding: "2px 17px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _customPageProps$cust, _config$speedBump4, _customPageProps$cust2, _customPageProps$cust3, _customPageProps$cust4, _data$Contact;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      customContainerClass: customContainerClass,
      pathname: "/:id",
      data: data,
      config: config
    }, otherProps, {
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      pageTitleProps: pageTitleProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles) || {}), {}, {
        calloutWithGradient: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.calloutWithGradient) || {}), {}, {
          buttonStylesProps: _objectSpread2({
            fill: buttonFillTypes.FILLED,
            withoutBorderRadius: !((_config$speedBump4 = config.speedBump) !== null && _config$speedBump4 !== void 0 && _config$speedBump4.borderWithRadious),
            styleType: buttonStyleTypes.STANDARD,
            filledBackgroundColor: colorsTypes.SECONDARY,
            hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
            hoverFilledBorderColor: colorsTypes.SECONDARY,
            hoverFilledTextColor: colorsTypes.SECONDARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.calloutWithGradient) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.buttonStylesProps) || {})
        }),
        hero: _objectSpread2({
          variant: heroVariantsTypes.CAROUSEL_CENTRAL,
          // data: data.HerosList?.Heros || data.Heros,
          fullScreen: true,
          buttonFilledBackgroundColor: colorsTypes.PRIMARY,
          buttonHoverBackgroundColor: colorsTypes.PRIMARY,
          buttonHoverDefaultBorderColor: colorsTypes.PRIMARY,
          buttonHoverOutlineAndColorBorderColor: colorsTypes.PRIMARY,
          buttonFill: buttonFillTypes.FILLED,
          buttonGrayscale: true,
          buttonHoverColor: true,
          buttonWithoutBorderRadius: false,
          titleColor: colorsTypes.BLACK,
          subTextColor: colorsTypes.BLACK,
          gradient: "radial-gradient(circle at 50% 61%, ".concat(colorsTypes.WHITE, ", rgba(255, 255, 255, 0) 32%), radial-gradient(circle at 50% 14%, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.93) 53%), linear-gradient(to bottom, rgba(255, 255, 255, 0) 29%, rgba(255, 255, 255, 0.11) 53%, rgba(255, 255, 255, 0.98) 96%, ").concat(colorsTypes.WHITE, " 96%)"),
          grayscaleAndFilledBackgroundColor: colorsTypes.PRIMARY,
          grayscaleAndOFilledTextColor: colorsTypes.WHITE
        }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust4 = customPageProps.customComponentStyles) === null || _customPageProps$cust4 === void 0 ? void 0 : _customPageProps$cust4.hero) || {}),
        contact: {
          inputStyles: _objectSpread2({
            backgroundColor: colorsTypes.WHITE,
            borderRadius: ((_data$Contact = data.Contact) === null || _data$Contact === void 0 ? void 0 : _data$Contact.borders) === "CIRCLED" ? 10 : 0
          }, (contactProps === null || contactProps === void 0 ? void 0 : contactProps.inputStyles) || {})
        }
      })
    })));
  });
}

DynamicTemplateV5.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  pageTitleProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$b = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function DynamicTemplateV6(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$b);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _customPageProps$titl, _customPageProps$cust, _customPageProps$cust2, _customPageProps$cust3, _customPageProps$cust4, _customPageProps$cust5;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({
        titleWithGradients: _objectSpread2(_objectSpread2({
          fontFamily: fontsFamiliesTypes.SECONDARY
        }, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.titleWithGradients) || {}), {}, {
          gradients: _objectSpread2({
            firstColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            firstLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$titl = customPageProps.titleWithGradients) === null || _customPageProps$titl === void 0 ? void 0 : _customPageProps$titl.gradients) || {})
        })
      }, customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles), {}, {
        ratesList: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.ratesList) || {}), {}, {
          title: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.ratesList) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.title) || {}),
          rightSubtitle: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY,
            color: colorsTypes.PRIMARY_SEMI_DARK
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust4 = customPageProps.customComponentStyles) === null || _customPageProps$cust4 === void 0 ? void 0 : (_customPageProps$cust5 = _customPageProps$cust4.ratesList) === null || _customPageProps$cust5 === void 0 ? void 0 : _customPageProps$cust5.rightSubtitle) || {})
        })
      })
    })));
  });
}

DynamicTemplateV6.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$a = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function DynamicTemplateV7(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$a);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: "/".concat(path),
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (data) {
    var _customPageProps$cust, _customPageProps$cust2, _customPageProps$cust3, _customPageProps$cust4, _customPageProps$cust5, _customPageProps$cust6, _customPageProps$cust7, _customPageProps$cust8;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles) || {}), {}, {
        titleWithGradients: _objectSpread2(_objectSpread2({
          fontFamily: fontsFamiliesTypes.SECONDARY
        }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.titleWithGradients) || {}), {}, {
          gradients: _objectSpread2({
            firstColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            firstLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.titleWithGradients) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.gradients) || {})
        }),
        ratesList: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust4 = customPageProps.customComponentStyles) === null || _customPageProps$cust4 === void 0 ? void 0 : _customPageProps$cust4.ratesList) || {}), {}, {
          title: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust5 = customPageProps.customComponentStyles) === null || _customPageProps$cust5 === void 0 ? void 0 : (_customPageProps$cust6 = _customPageProps$cust5.ratesList) === null || _customPageProps$cust6 === void 0 ? void 0 : _customPageProps$cust6.title) || {}),
          rightSubtitle: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY,
            color: colorsTypes.PRIMARY_SEMI_DARK
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust7 = customPageProps.customComponentStyles) === null || _customPageProps$cust7 === void 0 ? void 0 : (_customPageProps$cust8 = _customPageProps$cust7.ratesList) === null || _customPageProps$cust8 === void 0 ? void 0 : _customPageProps$cust8.rightSubtitle) || {})
        })
      })
    })));
  });
}

DynamicTemplateV7.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$9 = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps"];

function DynamicTemplateV8(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$9);

  return /*#__PURE__*/React__default$1["default"].createElement(Page // transparentHeader
  , _extends$g({
    isDynamic: true,
    forceShowHeader: true,
    grayscaleHeader: true,
    darkHeader: true,
    floatHeader: true,
    backgroundScreenHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.BLACK
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      height: 30,
      padding: "2px 17px",
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverFilledBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverFilledTextColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBorderColor: colorsTypes.PRIMARY_DARK,
        hoverFilledBackgroundColor: colorsTypes.TRANSPARENT,
        filledBackgroundColor: colorsTypes.PRIMARY_DARK
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.acceptButton) || {})
    })
  }), function (data) {
    var _customPageProps$cust, _customPageProps$cust2, _customPageProps$cust3, _customPageProps$cust4, _customPageProps$cust5, _customPageProps$cust6, _customPageProps$cust7, _customPageProps$cust8;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-pt-20"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles) || {}), {}, {
        titleWithGradients: _objectSpread2(_objectSpread2({
          fontFamily: fontsFamiliesTypes.SECONDARY
        }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.titleWithGradients) || {}), {}, {
          gradients: _objectSpread2({
            firstColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            firstLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.titleWithGradients) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.gradients) || {})
        }),
        ratesList: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust4 = customPageProps.customComponentStyles) === null || _customPageProps$cust4 === void 0 ? void 0 : _customPageProps$cust4.ratesList) || {}), {}, {
          title: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust5 = customPageProps.customComponentStyles) === null || _customPageProps$cust5 === void 0 ? void 0 : (_customPageProps$cust6 = _customPageProps$cust5.ratesList) === null || _customPageProps$cust6 === void 0 ? void 0 : _customPageProps$cust6.title) || {}),
          rightSubtitle: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY,
            color: colorsTypes.PRIMARY_SEMI_DARK
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust7 = customPageProps.customComponentStyles) === null || _customPageProps$cust7 === void 0 ? void 0 : (_customPageProps$cust8 = _customPageProps$cust7.ratesList) === null || _customPageProps$cust8 === void 0 ? void 0 : _customPageProps$cust8.rightSubtitle) || {})
        })
      })
    })));
  });
}

DynamicTemplateV8.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$8 = ["path", "pageData", "config", "customPageProps", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps", "calloutMobileProps", "calloutCompressedProps", "formTemplateProps"];

function DynamicTemplateV9(_ref) {
  var path = _ref.path,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$customPageProps = _ref.customPageProps,
      customPageProps = _ref$customPageProps === void 0 ? {} : _ref$customPageProps,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      _ref$calloutMobilePro = _ref.calloutMobileProps,
      calloutMobileProps = _ref$calloutMobilePro === void 0 ? {} : _ref$calloutMobilePro,
      _ref$calloutCompresse = _ref.calloutCompressedProps,
      calloutCompressedProps = _ref$calloutCompresse === void 0 ? {} : _ref$calloutCompresse,
      _ref$formTemplateProp = _ref.formTemplateProps,
      formTemplateProps = _ref$formTemplateProp === void 0 ? {} : _ref$formTemplateProp,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$8);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({}, otherProps, {
    cms: {
      isDynamicPage: true,
      pageId: path,
      pageData: pageData
    },
    pathname: path,
    config: config
  }), function (data) {
    var _customPageProps$cust, _customPageProps$cust2, _customPageProps$cust3, _customPageProps$cust4, _customPageProps$cust5, _customPageProps$cust6, _customPageProps$cust7, _customPageProps$cust8;

    var CustomPage = components[dynamicPagesVariantsTypes[data.dynamicPageType]];
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "DYNAMIC__PAGE"
    }), /*#__PURE__*/React__default$1["default"].createElement(CustomPage, _extends$g({
      data: data,
      config: config,
      heroProps: heroProps,
      productsProps: productsProps,
      featureFullProps: featureFullProps,
      featureProps: featureProps,
      formTemplateProps: formTemplateProps,
      calloutProps: calloutProps,
      calloutMobileProps: calloutMobileProps,
      calloutCompressedProps: calloutCompressedProps
    }, customPageProps, {
      customComponentStyles: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : customPageProps.customComponentStyles) || {}), {}, {
        titleWithGradients: _objectSpread2(_objectSpread2({
          fontFamily: fontsFamiliesTypes.SECONDARY
        }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust = customPageProps.customComponentStyles) === null || _customPageProps$cust === void 0 ? void 0 : _customPageProps$cust.titleWithGradients) || {}), {}, {
          gradients: _objectSpread2({
            firstColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            firstLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondColor: colorsTypes.HIGHT_LIGHT_PRIMARY,
            secondLightColor: colorsTypes.HIGHT_LIGHT_PRIMARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust2 = customPageProps.customComponentStyles) === null || _customPageProps$cust2 === void 0 ? void 0 : (_customPageProps$cust3 = _customPageProps$cust2.titleWithGradients) === null || _customPageProps$cust3 === void 0 ? void 0 : _customPageProps$cust3.gradients) || {})
        }),
        ratesList: _objectSpread2(_objectSpread2({}, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust4 = customPageProps.customComponentStyles) === null || _customPageProps$cust4 === void 0 ? void 0 : _customPageProps$cust4.ratesList) || {}), {}, {
          title: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust5 = customPageProps.customComponentStyles) === null || _customPageProps$cust5 === void 0 ? void 0 : (_customPageProps$cust6 = _customPageProps$cust5.ratesList) === null || _customPageProps$cust6 === void 0 ? void 0 : _customPageProps$cust6.title) || {}),
          rightSubtitle: _objectSpread2({
            fontFamily: fontsFamiliesTypes.SECONDARY,
            color: colorsTypes.PRIMARY_SEMI_DARK
          }, (customPageProps === null || customPageProps === void 0 ? void 0 : (_customPageProps$cust7 = customPageProps.customComponentStyles) === null || _customPageProps$cust7 === void 0 ? void 0 : (_customPageProps$cust8 = _customPageProps$cust7.ratesList) === null || _customPageProps$cust8 === void 0 ? void 0 : _customPageProps$cust8.rightSubtitle) || {})
        })
      })
    })));
  });
}

DynamicTemplateV9.prototype = {
  path: PropTypes.string.isRequired,
  pageData: PropTypes.any.isRequired,
  config: PropTypes.any.isRequired,
  customPageProps: PropTypes.any,
  heroProps: PropTypes.any,
  productsProps: PropTypes.any,
  featureFullProps: PropTypes.any,
  featureProps: PropTypes.any,
  calloutProps: PropTypes.any,
  calloutMobileProps: PropTypes.any,
  calloutCompressedProps: PropTypes.any
};
var _excluded$7 = ["pageData", "config", "pageHeaderProps", "bodyTextProps", "calloutTextProps", "calloutButtonProps"];

function AboutUsTemplateV1(_ref) {
  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$bodyTextProps = _ref.bodyTextProps,
      bodyTextProps = _ref$bodyTextProps === void 0 ? {} : _ref$bodyTextProps,
      _ref$calloutTextProps = _ref.calloutTextProps,
      calloutTextProps = _ref$calloutTextProps === void 0 ? {} : _ref$calloutTextProps,
      _ref$calloutButtonPro = _ref.calloutButtonProps,
      calloutButtonProps = _ref$calloutButtonPro === void 0 ? {} : _ref$calloutButtonPro,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$7);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({}, otherProps, {
    cms: {
      pageId: "cu-about-uss",
      pageData: pageData
    },
    pathname: "about-us",
    config: config
  }), function (_ref2) {
    var texts = _ref2.Texts,
        calloutText = _ref2.CalloutText,
        pageHeaderGradient = _ref2.PageHeaderGradient,
        calloutButton = _ref2.CalloutButton,
        textsLists = _ref2.TextsLists;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENT,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: pageHeaderGradient
    }, pageHeaderProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, texts === null || texts === void 0 ? void 0 : texts.map(function (item, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Texts-Fragment-item-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, _extends$g({
        data: item
      }, bodyTextProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-6"
      }));
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.TEXT,
      data: calloutText
    }, calloutTextProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), textsLists === null || textsLists === void 0 ? void 0 : textsLists.map(function (item, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, _extends$g({
        key: "TextsLists-BodyText-item".concat(index),
        data: item
      }, bodyTextProps));
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-10"
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.BUTTON,
      data: calloutButton
    }, calloutButtonProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-16"
    })));
  });
}

AboutUsTemplateV1.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  bodyTextProps: PropTypes.any,
  calloutTextProps: PropTypes.any,
  calloutButtonProps: PropTypes.any
};
var _excluded$6 = ["pageData", "config", "pageHeaderProps", "bodyTextProps", "calloutTextProps", "calloutButtonProps"];

function AboutUsTemplateV2(_ref) {
  var _otherProps$footerOpt, _config$speedBump, _config$speedBump2, _otherProps$speedBump, _config$speedBump3, _otherProps$speedBump2;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$bodyTextProps = _ref.bodyTextProps,
      bodyTextProps = _ref$bodyTextProps === void 0 ? {} : _ref$bodyTextProps,
      _ref$calloutTextProps = _ref.calloutTextProps,
      calloutTextProps = _ref$calloutTextProps === void 0 ? {} : _ref$calloutTextProps,
      _ref$calloutButtonPro = _ref.calloutButtonProps,
      calloutButtonProps = _ref$calloutButtonPro === void 0 ? {} : _ref$calloutButtonPro,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$6);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    transparentHeader: true,
    floatHeader: true,
    grayscaleHeader: true,
    noFilterLogoHeader: true,
    forceShowItemsHeader: true,
    topIndicatorHeader: false,
    backgroundMenuHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY_SEMI_DARK,
    menuSubLinksItemTitleColorHeader: colorsTypes.SECONDARY
  }, otherProps, {
    cms: {
      pageId: "cu-about-uss",
      pageData: pageData
    },
    pathname: "about-us",
    config: config,
    footerOptions: _objectSpread2(_objectSpread2({
      background: colorsTypes.PRIMARY_ULTRA_DARK,
      // powerByImg: "",
      bottomSectionMargin: 0
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    }),
    navigationMenuOptions: _objectSpread2({
      menuSubItemTitleColor: colorsTypes.SECONDARY,
      menuSubItemTitleActiveColor: colorsTypes.SECONDARY,
      menuActiveBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.STANDARD,
      height: 30,
      padding: "2px 17px",
      hoverBackgroundColor: colorsTypes.WHITE,
      hoverFilledBorderColor: colorsTypes.PRIMARY
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    speedBumpStyles: _objectSpread2(_objectSpread2({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.speedBumpStyles), {}, {
      acceptButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump2 = config.speedBump) !== null && _config$speedBump2 !== void 0 && _config$speedBump2.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverBackgroundColor: colorsTypes.PRIMARY,
        filledBackgroundColor: colorsTypes.WHITE,
        filledTextColor: colorsTypes.PRIMARY,
        filledBorderColor: colorsTypes.PRIMARY,
        hoverFilledTextColor: colorsTypes.WHITE
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump = otherProps.speedBumpStyles) === null || _otherProps$speedBump === void 0 ? void 0 : _otherProps$speedBump.acceptButton) || {}),
      cancelButton: _objectSpread2({
        withoutBorderRadius: !((_config$speedBump3 = config.speedBump) !== null && _config$speedBump3 !== void 0 && _config$speedBump3.borderWithRadious),
        fill: buttonFillTypes.FILLED,
        styleType: buttonStyleTypes.STANDARD,
        hoverBackgroundColor: colorsTypes.WHITE,
        filledBackgroundColor: colorsTypes.PRIMARY
      }, (otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$speedBump2 = otherProps.speedBumpStyles) === null || _otherProps$speedBump2 === void 0 ? void 0 : _otherProps$speedBump2.cancelButton) || {})
    })
  }), function (_ref2) {
    var texts = _ref2.Texts,
        calloutText = _ref2.CalloutText,
        pageHeaderGradient = _ref2.PageHeaderGradient,
        calloutButton = _ref2.CalloutButton,
        textsLists = _ref2.TextsLists;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENT,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: pageHeaderGradient
    }, pageHeaderProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, texts === null || texts === void 0 ? void 0 : texts.map(function (item, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Texts-Fragment-item-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, _extends$g({
        data: item
      }, bodyTextProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-6"
      }));
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.TEXT,
      data: calloutText
    }, calloutTextProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), textsLists === null || textsLists === void 0 ? void 0 : textsLists.map(function (item, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, _extends$g({
        key: "TextsLists-BodyText-item".concat(index),
        data: item
      }, bodyTextProps));
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-10"
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.BUTTON,
      data: calloutButton
    }, calloutButtonProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-16"
    })));
  });
}

AboutUsTemplateV2.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  bodyTextProps: PropTypes.any,
  calloutTextProps: PropTypes.any,
  calloutButtonProps: PropTypes.any
};
var _excluded$5 = ["pageData", "config", "pageHeaderProps", "bodyTextProps", "calloutTextProps", "calloutButtonProps"];

function AboutUsTemplateV7(_ref) {
  var _config$speedBump, _otherProps$footerOpt;

  var pageData = _ref.pageData,
      config = _ref.config,
      _ref$pageHeaderProps = _ref.pageHeaderProps,
      pageHeaderProps = _ref$pageHeaderProps === void 0 ? {} : _ref$pageHeaderProps,
      _ref$bodyTextProps = _ref.bodyTextProps,
      bodyTextProps = _ref$bodyTextProps === void 0 ? {} : _ref$bodyTextProps,
      _ref$calloutTextProps = _ref.calloutTextProps,
      calloutTextProps = _ref$calloutTextProps === void 0 ? {} : _ref$calloutTextProps,
      _ref$calloutButtonPro = _ref.calloutButtonProps,
      calloutButtonProps = _ref$calloutButtonPro === void 0 ? {} : _ref$calloutButtonPro,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$5);

  return /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    floatHeader: true,
    forceShowHeader: true,
    topIndicatorHeader: true,
    noFilterLogoHeader: true,
    transparent: true,
    isTopBorder: true,
    backgroundMenuHeader: colorsTypes.TRANSPARENT,
    menuSubLinksListBorderColorHeader: colorsTypes.SECONDARY,
    menuSubLinksListBackgroundHeader: colorsTypes.HIGHT_LIGHT_PRIMARY,
    menuSubLinksTitleColorHeader: colorsTypes.PRIMARY_ULTRA_DARK,
    subLinksItemActiveTitleColorHeader: colorsTypes.PRIMARY,
    menuSubLinksItemTitleColorHeader: colorsTypes.ULTRA_LIGHT
  }, otherProps, {
    cms: {
      pageId: "cu-about-uss",
      pageData: pageData
    },
    pathname: "/about-us",
    config: config,
    navigationOptions: _objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationOptions) || {}),
    navigationMenuOptions: _objectSpread2({
      subMenuGrayscaleBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT,
      subMenuBackgroundColor: colorsTypes.PRIMARY_VERY_ULTRA_LIGHT
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.navigationMenuOptions) || {}),
    headerLoginButtonStyles: _objectSpread2({
      withoutBorderRadius: !((_config$speedBump = config.speedBump) !== null && _config$speedBump !== void 0 && _config$speedBump.borderWithRadious),
      fill: buttonFillTypes.FILLED,
      styleType: buttonStyleTypes.NONE,
      hoverFilledBackgroundColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledBorderColor: colorsTypes.PRIMARY_LIGHT,
      hoverFilledTextColor: colorsTypes.WHITE,
      radius: 10,
      padding: "2px 15px"
    }, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.headerLoginButtonStyles) || {}),
    footerOptions: _objectSpread2(_objectSpread2({}, (otherProps === null || otherProps === void 0 ? void 0 : otherProps.footerOptions) || {}), {}, {
      businessCustomLogos: [{
        replaceByIndex: 0,
        url: "https://olb-assets.s3.us-east-2.amazonaws.com/images/NCUA_Logo.svg",
        alternativeText: "NCUA Logo",
        invert: true,
        linkTo: "https://www.ncua.gov"
      }].concat(_toConsumableArray((otherProps === null || otherProps === void 0 ? void 0 : (_otherProps$footerOpt = otherProps.footerOptions) === null || _otherProps$footerOpt === void 0 ? void 0 : _otherProps$footerOpt.businessCustomLogos) || []))
    })
  }), function (_ref2) {
    var texts = _ref2.Texts,
        calloutText = _ref2.CalloutText,
        pageHeaderGradient = _ref2.PageHeaderGradient,
        calloutButton = _ref2.CalloutButton,
        textsLists = _ref2.TextsLists;
    return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default$1["default"].createElement(PageHeader$1, _extends$g({
      variant: pageHeaderVariantsTypes.GRADIENT,
      color: pageHeaderColorVariantsTypes.PRIMARY,
      data: pageHeaderGradient
    }, pageHeaderProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), /*#__PURE__*/React__default$1["default"].createElement("div", {
      className: "tw-container"
    }, texts === null || texts === void 0 ? void 0 : texts.map(function (item, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(React.Fragment, {
        key: "Texts-Fragment-item-".concat(index)
      }, /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, _extends$g({
        data: item
      }, bodyTextProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
        variant: dividersVariantsTypes.DIVIDER,
        className: "tw-my-6"
      }));
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.TEXT,
      data: calloutText
    }, calloutTextProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-6"
    }), textsLists === null || textsLists === void 0 ? void 0 : textsLists.map(function (item, index) {
      return /*#__PURE__*/React__default$1["default"].createElement(BodyText$1, _extends$g({
        key: "TextsLists-BodyText-item".concat(index),
        data: item
      }, bodyTextProps));
    }), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-10"
    }), /*#__PURE__*/React__default$1["default"].createElement(Callout$2, _extends$g({
      variant: calloutVariantsTypes.BUTTON,
      data: calloutButton
    }, calloutButtonProps)), /*#__PURE__*/React__default$1["default"].createElement(Dividers, {
      variant: dividersVariantsTypes.DIVIDER,
      className: "tw-my-16"
    })));
  });
}

AboutUsTemplateV7.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  pageHeaderProps: PropTypes.any,
  bodyTextProps: PropTypes.any,
  calloutTextProps: PropTypes.any,
  calloutButtonProps: PropTypes.any
};
var _excluded$4 = ["pageData", "config", "variant", "heroProps", "productsProps", "featureFullProps", "featureProps", "calloutProps"];

function AboutUsTemplateV8(_ref) {
  _ref.pageData;

  var config = _ref.config,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? dynamicTemplatesVersionVariantsTypes.DYNAMIC_TEMPLATE_V9 : _ref$variant,
      _ref$heroProps = _ref.heroProps,
      heroProps = _ref$heroProps === void 0 ? {} : _ref$heroProps,
      _ref$productsProps = _ref.productsProps,
      productsProps = _ref$productsProps === void 0 ? {} : _ref$productsProps,
      _ref$featureFullProps = _ref.featureFullProps,
      featureFullProps = _ref$featureFullProps === void 0 ? {} : _ref$featureFullProps,
      _ref$featureProps = _ref.featureProps,
      featureProps = _ref$featureProps === void 0 ? {} : _ref$featureProps,
      _ref$calloutProps = _ref.calloutProps,
      calloutProps = _ref$calloutProps === void 0 ? {} : _ref$calloutProps,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$4);

  return /*#__PURE__*/React__default$1["default"].createElement("div", {
    className: "CONTACT_PAGE__CONTAINER"
  }, /*#__PURE__*/React__default$1["default"].createElement(DynamicPage, _extends$g({
    heroProps: heroProps,
    productsProps: productsProps,
    featureFullProps: featureFullProps,
    featureProps: featureProps,
    calloutProps: calloutProps
  }, otherProps, {
    path: "/about-us",
    id: "About-us",
    config: config,
    variant: variant
  })));
}

AboutUsTemplateV8.prototype = {
  pageData: PropTypes.any,
  config: PropTypes.any,
  variant: PropTypes.string
};
var _excluded$3 = ["variant", "pageData", "config", "themes", "header", "about", "contact", "footer"];

function ContactUs(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? contactUsTemplatesVersionVariantsTypes.CONTACT_US_TEMPLATE_V2 : _ref$variant,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? [] : _ref$themes,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$about = _ref.about,
      about = _ref$about === void 0 ? null : _ref$about,
      _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? null : _ref$contact,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$3);

  var Component = templates[variant];
  /** @TODO: Redirect to 404 */

  if (!Component) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(ThemeProvider, {
    themes: themes
  }, /*#__PURE__*/React__default$1["default"].createElement(Component, _extends$g({
    pageData: pageData,
    config: config,
    header: header,
    about: about,
    contact: contact,
    footer: footer
  }, otherProps)));
}

var _excluded$2 = ["variant", "forceCustomVariant", "header", "about", "contact", "footer", "themes", "config"];

function Home(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? homeTemplatesVersionVariantTypes.HOME_TEMPLATE_V2 : _ref$variant,
      _ref$forceCustomVaria = _ref.forceCustomVariant,
      forceCustomVariant = _ref$forceCustomVaria === void 0 ? false : _ref$forceCustomVaria,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$about = _ref.about,
      about = _ref$about === void 0 ? null : _ref$about,
      _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? null : _ref$contact,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? [] : _ref$themes,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$2);

  var Component = forceCustomVariant ? templates[variant] : templates[(config === null || config === void 0 ? void 0 : config.homePage) || variant];
  /** @TODO: Redirect to 404 */

  if (!Component) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(ThemeProvider, {
    themes: themes
  }, /*#__PURE__*/React__default$1["default"].createElement(Component, _extends$g({
    header: header,
    about: about,
    contact: contact,
    footer: footer,
    config: config
  }, otherProps)));
}

var _excluded$1 = ["variant", "pageData", "config", "themes", "header", "about", "contact", "footer"];

function AboutUsPage(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? aboutUsTemplatesVersionVariantsTypes.ABOUT_US_TEMPLATE_V2 : _ref$variant,
      pageData = _ref.pageData,
      config = _ref.config,
      _ref$themes = _ref.themes,
      themes = _ref$themes === void 0 ? [] : _ref$themes,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$about = _ref.about,
      about = _ref$about === void 0 ? null : _ref$about,
      _ref$contact = _ref.contact,
      contact = _ref$contact === void 0 ? null : _ref$contact,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      otherProps = _objectWithoutProperties$1(_ref, _excluded$1);

  var Component = templates[variant];
  /** @TODO: Redirect to 404 */

  if (!Component) return null;
  return /*#__PURE__*/React__default$1["default"].createElement(ThemeProvider, {
    themes: themes
  }, /*#__PURE__*/React__default$1["default"].createElement(Component, _extends$g({
    pageData: pageData,
    config: config,
    header: header,
    about: about,
    contact: contact,
    footer: footer
  }, otherProps)));
}

var _excluded = ["themes"];

function NotFoundPage(_ref) {
  var _ref$themes = _ref.themes,
      appThemes = _ref$themes === void 0 ? [] : _ref$themes,
      otherProps = _objectWithoutProperties$1(_ref, _excluded);

  return /*#__PURE__*/React__default$1["default"].createElement(ThemeProvider, {
    themes: appThemes
  }, /*#__PURE__*/React__default$1["default"].createElement(Page, _extends$g({
    cms: {
      pageData: {
        MetaData: {
          title: "404: Not Found",
          noRobots: true
        }
      }
    },
    pathname: "404"
  }, otherProps), function () {
    return /*#__PURE__*/React__default$1["default"].createElement(Error$1, {
      title: "404: Not Found"
    });
  }));
}

SwiperCore.use([Autoplay$1, Pagination$1, Navigation$1, Thumbs$1]);
var versionDetails = "Current  \"".concat(pkg$1.name, "\" version: \"").concat(pkg$1.version, "\"");

var consoleController = function () {
  var oldConsoleLog = null;
  var functions = {};

  var enable = function enable() {
    if (oldConsoleLog == null) return;
    console.log = oldConsoleLog;
  };

  var disable = function disable() {
    oldConsoleLog = console.log;

    console.log = function () {};
  };

  var printVersion = function printVersion() {
    enable();
    console.log(versionDetails);
    disable();
  };

  functions.disable = disable;
  functions.printVersion = printVersion;
  return functions;
}();

consoleController.disable(); // Disable all console.log on production ** Enable only for development **

exports.AboutUsPage = AboutUsPage;
exports.AutoLink = AutoLink$2;
exports.BodyText = BodyText$1;
exports.Branch = Branch$1;
exports.BranchExpandedComponent = BranchExpandedComponent;
exports.Button = Button$2;
exports.ButtonVariant = ButtonVariant;
exports.Callout = Callout$2;
exports.CalloutButtonWithDividers = CalloutButtonWithDividers;
exports.CalloutData = CalloutData;
exports.CalloutDataWithDividers = CalloutDataWithDividers;
exports.CalloutMobileApps = CalloutMobileApps;
exports.CalloutMobileAppsGradients = CalloutMobileAppsGradientsDark$1;
exports.CalloutMobileAppsGradientsDark = CalloutMobileAppsGradientsDark;
exports.CalloutMobileAppsGradientsLight = CalloutMobileAppsGradientsLight;
exports.CalloutMobileAppsWithDividers = CalloutMobileAppsWithDividers;
exports.CalloutText = CalloutText;
exports.CalloutTextWithDividers = CalloutTextWithDividers;
exports.CalloutWithGradient = CalloutWithGradient$1;
exports.CalloutWithGradientAndPadding = CalloutWithGradientAndPadding$1;
exports.CheckBox = CheckBox$1;
exports.CompressedContent = CompressedContent;
exports.ConfirmationModal = ConfirmationModal;
exports.Contact = Contact$1;
exports.ContactSimple = ContactSimple;
exports.ContactUsPage = ContactUs;
exports.ContainerGradient = ContainerGradient$1;
exports.ContentBox = ContentBox$1;
exports.CustomButtons = CustomButtons;
exports.CustomInput = CustomInput$1;
exports.CustomPageFeature = CustomPageFeature;
exports.CustomPageGeneric = CustomPageGeneric;
exports.Dateline = Dateline;
exports.DefaultFallbackComponent = DefaultFallbackComponent;
exports.DescriptionAndLinks = DescriptionAndLinks;
exports.DividerDynamicComponent = DividerDynamicComponent;
exports.DividerImage = DividerImage;
exports.Dividers = Dividers;
exports.DynamicPage = DynamicPage;
exports.DynamicZonePage = DynamicZonePage;
exports.DynamicZonesPage = DynamicZonesPage;
exports.Error = Error$1;
exports.Feature = Feature;
exports.FeatureCollapseContent = FeatureCollapseContent;
exports.FeatureFullBackground = FeatureFullBackground;
exports.FeatureFullBg = FeatureFullBg;
exports.FeatureV2Image = FeatureV2Image;
exports.FeatureV4Image = FeatureV4Image;
exports.FeatureWithDiversV1 = FeatureWithDividerV1;
exports.FeatureWithDiversV2 = FeatureWithDividerV2;
exports.FeatureWithDiversV3 = FeatureWithDividerV3;
exports.FeatureWithDividers = FeatureWithDividers;
exports.Footer = Footer$1;
exports.Form = Form;
exports.FormApplicationTemplate = FormApplicationTemplate;
exports.FormInput = FormInput$1;
exports.FormLinked = FormLinked;
exports.FormTemplate = FormTemplate;
exports.GoogleMap = BlossomGoogleMap;
exports.GradientWithoutImageContainer = GradientWithoutImageContainer;
exports.GroupInputRadio = GroupInputRadio;
exports.H3 = H3$6;
exports.Header = index;
exports.HeaderGradient = HeaderGradient;
exports.HeaderGradients = HeaderGradients;
exports.Hero = Hero$1;
exports.HeroCard = HeroCard;
exports.HeroWithDividers = HeroWithDividers;
exports.HomePage = Home;
exports.HorizontalDivider = HorizontalDivider;
exports.Icon = Icon;
exports.IconSelector = IconSelector;
exports.Iframe = Iframe$1;
exports.IframeWithDividers = IframeWithDividers;
exports.ImagesGalery = ImagesGalery$1;
exports.ImagesGaleryRichText = ImagesGaleryRichText;
exports.Input = Input;
exports.InputBox = InputBox;
exports.InputContainer = InputContainer;
exports.InputGenerator = InputGenerator;
exports.InputLabel = InputLabel;
exports.InputLabelError = InputLabelError;
exports.InputLabelText = InputLabelText;
exports.InputSelect = InputSelect$1;
exports.InputSelectOption = InputSelectOption;
exports.InvisibleBox = InvisibleBox;
exports.Legend = Legend;
exports.Links = Links$2;
exports.List = List;
exports.MainContact = MainContact;
exports.MainContactBox = MainContactBox;
exports.MainOffice = MainOffice;
exports.MediaQuery = MediaQuery;
exports.MemberFeedback = MemberFeedbackForm;
exports.Message = Message;
exports.Message404 = Message404;
exports.Modal = Modal;
exports.OfficeHourBox = OfficeHourBox;
exports.OptInForm = OptInForm;
exports.Page = Page;
exports.Page404 = NotFoundPage;
exports.PageHeader = PageHeader$1;
exports.PageHeaderGradient = PageHeaderGradient;
exports.PageHeaderGradientContainer = PageHeaderGradientContainer;
exports.PageHeaderGradients = PageHeaderGradients;
exports.PageHeaderSubTitle = PageHeaderSubTitle;
exports.PageHeaderTitle = Title$v;
exports.PageTitle = PageTitle;
exports.Place = Place;
exports.PopUpGalery = PopUpGalery$1;
exports.PopUpGaleryCommon = PopUpGaleryCommon;
exports.PrimaryText = PrimaryText;
exports.Product = Product;
exports.Products = Products;
exports.ProductsRates = ProductsRates;
exports.ProductsWithDividers = ProductsWithDividers;
exports.Radio = Radio;
exports.RadioButton = RadioButton;
exports.RatesList = RatesList;
exports.RatesTabs = RatesTabs;
exports.ReCaptcha = ReCaptcha$1;
exports.Rectangle = Rectangle$3;
exports.RenderDynamicZoneComponent = RenderDynamicZoneComponent;
exports.Reports = Reports;
exports.RichText = RichText;
exports.RichTextContainer = RichTextContainer;
exports.Root = Root;
exports.ScrollStyle = ScrollStyle;
exports.Search = Search;
exports.SecondaryText = SecondaryText;
exports.Select = Select;
exports.Slider = Slider;
exports.SpeedBump = SpeedBump;
exports.Tab = Tab;
exports.TabContent = TabContent;
exports.Table = Table$1;
exports.TableComponent = TableComponent;
exports.TableContentItem = TableContentItem;
exports.TableContentItemLine = TableContentItemLine;
exports.Tabs = Tabs;
exports.TeamMembers = TeamMembers;
exports.Text = Text$1;
exports.TextBody = TextBody;
exports.TextSimple = TextSimple;
exports.Textarea = Textarea;
exports.TextareaContainer = TextareaContainer;
exports.TextareaInput = TextareaInput$1;
exports.TextsLists = TextsLists;
exports.Title = Title$t;
exports.TitleWithGradients = TitleWithGradient;
exports.Toast = Toast$1;
exports.VerticalDivider = VerticalDivider;
exports.Video = Video;
exports.VideoList = VideoList;
exports.Widget = Widget;
exports.aboutUsTemplatesVersionVariantsTypes = aboutUsTemplatesVersionVariantsTypes;
exports.bodyTextVariantsTypes = bodyTextVariantsTypes;
exports.branchVariantsTypes = branchVariantsTypes;
exports.buttonFillTypes = buttonFillTypes;
exports.buttonStyleTypes = buttonStyleTypes;
exports.buttonVariantsTypes = buttonVariantsTypes;
exports.calloutVariantsTypes = calloutVariantsTypes;
exports.colorsTypes = colorsTypes;
exports.colorsVariantsTypes = colorsVariantsTypes;
exports.consoleController = consoleController;
exports.contactFormTemplate = contactFormTemplate;
exports.contactUsTemplatesVersionVariantsTypes = contactUsTemplatesVersionVariantsTypes;
exports.contactVariantsTypes = contactVariantsTypes;
exports.customPageFeatureVariantsTypes = customPageFeatureVariantsTypes;
exports.customPageGenericVariantsTypes = customPageGenericVariantsTypes;
exports.dividerVariantsTypes = dividerVariantsTypes;
exports.dividersVariantsTypes = dividersVariantsTypes;
exports.dynamicPageRendereableComponentsTypes = dynamicPageRendereableComponentsTypes;
exports.dynamicPagesVariantsTypes = dynamicPagesVariantsTypes;
exports.dynamicTemplatesVersionVariantsTypes = dynamicTemplatesVersionVariantsTypes;
exports.dynamicsComponentsVariantsTypes = dynamicsComponentsVariantsTypes;
exports.featureVariantsTypes = featureVariantsTypes;
exports.fontsFamiliesTypes = fontsFamiliesTypes;
exports.fontsFamiliesVariantsTypes = fontsFamiliesVariantsTypes;
exports.headerCompressedVariantTypes = headerCompressedVariantTypes;
exports.headerDesktopVariantTypes = headerDesktopVariantTypes;
exports.headerMobileCompressedVariantTypes = headerMobileCompressedVariantTypes;
exports.headerMobileVariantTypes = headerMobileVariantTypes;
exports.heroVariantsTypes = heroVariantsTypes;
exports.homeTemplatesVersionVariantTypes = homeTemplatesVersionVariantTypes;
exports.iconSelectorTypes = iconSelectorTypes;
exports.iconTypes = iconTypes;
exports.iconVariantsTypes = iconVariantsTypes;
exports.imagesGaleryVariantsTypes = imagesGaleryVariantsTypes;
exports.inputVariantTypes = inputVariantTypes;
exports.linkVariantTypes = linkVariantTypes;
exports.loginVariantTypes = loginVariantTypes;
exports.memberFeedbackTemplate = memberFeedbackTemplate;
exports.optInFormTemplate = optInFormTemplate;
exports.pageFeatureVariantsTypes = pageFeatureVariantsTypes;
exports.pageGenericVariantsTypes = pageGenericVariantsTypes;
exports.pageHeaderColorVariantsTypes = pageHeaderColorVariantsTypes;
exports.pageHeaderVariantsTypes = pageHeaderVariantsTypes;
exports.pageVariantsTypes = pageVariantsTypes;
exports.productVariantsTypes = productVariantsTypes;
exports.productsVariantsTypes = productsVariantsTypes;
exports.tabVariantsTypes = tabVariantsTypes;
exports.tabsVariantsTypes = tabsVariantsTypes;
exports.textSizesTypes = textSizesTypes;
exports.textSizesVariantsTypes = textSizesVariantsTypes;
exports.textVariantsTypes = textVariantsTypes;
exports.themeVariantsTypes = themeVariantsTypes;
exports.versionDetails = versionDetails;
exports.videoListVariantTypes = videoListVariantTypes;
exports.videoVariantTypes = videoVariantTypes;
exports.withErrorBoundary = withErrorBoundary;